(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode('._context-menu_18ock_1{position:fixed;background-color:#fffffff2;border:1px solid rgba(0,0,0,.1);border-radius:3px;font-size:12px;cursor:default;padding:3px;box-shadow:0 0 3px #0000001a,0 1px 5px #0000000d}._context-menu-dark_18ock_12{color:#ccc;background-color:#444444f7}._context-menu-icon_18ock_17{display:inline-block;margin-right:3px;vertical-align:middle}._context-menu-icon_18ock_17>svg{width:30px;height:20px}._context-menu-item_18ock_27{padding:2px;white-space:nowrap;border-radius:2px;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._context-menu-item_18ock_27:hover{background:#337ab7;color:#fff}._context-menu-hr_18ock_38{margin-top:5px;margin-bottom:5px;border:0;border-top:1px solid rgba(0,0,0,.1)}._play-icon_18ock_45{width:12px;height:12px;position:absolute;right:5px}._context-menu-span_18ock_52{margin-right:20px;vertical-align:middle;display:inline-block;line-height:normal;white-space:nowrap}._context-menu-thumbnail_18ock_60{margin-right:10px;border:1px solid #888888}._context-menu-thumbnail-inline_18ock_65{display:inline-block;margin-right:10px;vertical-align:middle}._multitrack-header_1yz7l_1,._multitrack-header-focus_1yz7l_2,._multitrack-header-squeazed_1yz7l_3{position:relative;display:flex;justify-content:space-between;height:24px;margin-top:4px;margin-bottom:4px;color:#999;font-size:12px;line-height:24px;vertical-align:middle;border:0;border-radius:3px;background:#e5e5e5;transition:height .15s cubic-bezier(.25,.1,.25,1),margin .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-dark_1yz7l_20{background:#222}._multitrack-header-focus_1yz7l_2{height:32px;margin-top:0;margin-bottom:0}._multitrack-header-id_1yz7l_30{padding-left:3px}._multitrack-header-id_1yz7l_30:before{content:"ID:";font-weight:700;padding-right:5px}._multitrack-header-left_1yz7l_39{display:flex;flex-grow:1}._multitrack-header-grabber_1yz7l_44,._multitrack-header-grabber-squeazed_1yz7l_45{display:flex;align-items:center;justify-content:center;width:24px;height:100%;cursor:move;border-radius:3px 0 0 3px;transition:background .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-grabber_1yz7l_44:hover,._multitrack-header-grabber-squeazed_1yz7l_45:hover{background:#999}._multitrack-header-grabber_1yz7l_44:hover div,._multitrack-header-grabber-squeazed_1yz7l_45:hover div{background:#fff}._multitrack-header-grabber_1yz7l_44 div,._multitrack-header-grabber-squeazed_1yz7l_45 div{width:1px;height:50%;margin:1px;background:#999;transition:background .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-dark_1yz7l_20 ._multitrack-header-grabber_1yz7l_44 div{background:#666}._multitrack-header-grabber-squeazed_1yz7l_45{width:19.2px}._multitrack-header-search_1yz7l_80{position:relative;flex-grow:1;height:100%;margin-right:12px}._multitrack-header-search_1yz7l_80:after{position:absolute;top:3px;bottom:3px;right:-12px;display:block;content:"";width:1px;margin:0 6px;background:#cccccc}._multitrack-header-dark_1yz7l_20 ._multitrack-header-search_1yz7l_80:after{background:#666}._multitrack-header-nav-list_1yz7l_102,._multitrack-header_1yz7l_1>nav{display:flex}._multitrack-header-icon_1yz7l_107,._multitrack-header-icon-squeazed_1yz7l_108{width:24px;height:100%;padding:6px;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-icon_1yz7l_107 g,._multitrack-header-icon-squeazed_1yz7l_108 g{stroke:#999}._multitrack-header-icon_1yz7l_107:hover,._multitrack-header-icon_1yz7l_107:active,._multitrack-header-icon_1yz7l_107:focus,._multitrack-header-icon-squeazed_1yz7l_108:hover,._multitrack-header-icon-squeazed_1yz7l_108:active,._multitrack-header-icon-squeazed_1yz7l_108:focus{color:#fff;background:#337ab7}._multitrack-header-icon_1yz7l_107:hover g,._multitrack-header-icon_1yz7l_107:active g,._multitrack-header-icon_1yz7l_107:focus g,._multitrack-header-icon-squeazed_1yz7l_108:hover g,._multitrack-header-icon-squeazed_1yz7l_108:active g,._multitrack-header-icon-squeazed_1yz7l_108:focus g{stroke:#fff}._multitrack-header-icon_1yz7l_107:last-child,._multitrack-header-icon-squeazed_1yz7l_108:last-child{border-radius:0 3px 3px 0}._mouse-tool-selection_1yz7l_136{color:#fff;border-radius:3px 0 0 3px;background:#337ab7}._multitrack-header-icon-squeazed_1yz7l_108{width:20px 5;padding-left:3px;padding-right:3px}._track-control_w7hx2_1,._track-control-vertical_w7hx2_2{position:absolute;z-index:1;display:flex;background:rgba(255,255,255,.75);right:2px;top:2px;border-radius:2.5px;box-shadow:0 0 0 1px #0000000d,0 0 3px #0000001a;opacity:0;transition:opacity .15s cubic-bezier(.25,.1,.25,1),background .15s cubic-bezier(.25,.1,.25,1),box-shadow .15s cubic-bezier(.25,.1,.25,1)}._track-control-dark_w7hx2_15,._track-control-dark_w7hx2_15 ._track-control-active_w7hx2_16{background:rgba(40,40,40,.85)}._track-control-vertical_w7hx2_2{flex-direction:column-reverse}._track-control-left_w7hx2_24{left:2px;right:auto}._track-control-active_w7hx2_16,._track-control-vertical-active_w7hx2_30{opacity:1;z-index:1}._track-control-active_w7hx2_16:hover,._track-control-vertical-active_w7hx2_30:hover{background:rgb(255,255,255);box-shadow:0 0 0 1px #0000001a,0 0 3px #0003}._track-control-dark_w7hx2_15._track-control-active_w7hx2_16:hover{background:rgba(34,34,34,.95)}._track-control-padding-right_w7hx2_48{right:80px}._track-control-button_w7hx2_52{width:20px;height:20px;padding:4px;cursor:pointer;opacity:.66;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1),opacity .15s cubic-bezier(.25,.1,.25,1)}._track-control-button_w7hx2_52:hover{color:#fff;background:#337ab7;opacity:1}._track-control-button_w7hx2_52:first-child{border-radius:2.5px 0 0 2.5px}._track-control-button_w7hx2_52:last-child{border-radius:0 2.5px 2.5px 0}._track-control-dark_w7hx2_15 ._track-control-button_w7hx2_52{color:#ccc}._track-control-dark_w7hx2_15 ._track-control-button_w7hx2_52:hover{color:#fff;background:#337ab7;opacity:1}._track-control-button-vertical_w7hx2_81:first-child{border-radius:0 0 2.5px 2.5px}._track-control-button-vertical_w7hx2_81:last-child{border-radius:2.5px 2.5px 0 0}._center-track_fiu64_1{position:relative;background:transparent}._center-track-container_fiu64_6{position:absolute;z-index:1}._track-range-selection_5bcsr_1{position:absolute;z-index:-1;opacity:0;transition:opacity .15s cubic-bezier(.25,.1,.25,1)}._track-range-selection-active_5bcsr_8{z-index:1;opacity:1}._track-range-selection-group-inactive_5bcsr_22{display:none}._track-range-selection-group-brush-selection_5bcsr_26{outline:2px solid rgba(0,0,0,.33);fill:#000;fill-opacity:.1}._drag-listening-div-active_19gkt_1{z-index:10;box-shadow:inset 0 0 3px red}._gallery-tracks_fbxxi_1{position:relative;top:0;left:0;width:100%;height:100%}._gallery-track_fbxxi_1{position:absolute;box-sizing:border-box;top:0;right:0;bottom:0;left:0}._gallery-sub-track_fbxxi_18,._gallery-invisible-track_fbxxi_19{position:absolute}._tiled-plot_1y7td_1{position:relative;flex:1;overflow:hidden}._horizontalList_1y7td_7{display:flex;width:600px;height:300px;white-space:nowrap}._list_1y7td_14{width:400px;height:600px;overflow:hidden;-webkit-overflow-scrolling:touch}._stylizedList_1y7td_21{position:relative;z-index:0;background-color:#f3f3f3;outline:none}._stylizedItem_1y7td_28{position:relative;display:flex;align-items:center;width:100%;background-color:transparent;-webkit-user-select:none;user-select:none;color:#333;font-weight:400}._stylizedHelper_1y7td_39{box-shadow:0 5px 5px -5px #0003,0 -5px 5px -5px #0003;background-color:#fffc;cursor:row-resize}._stylizedHelper_1y7td_39._horizontalItem_1y7td_44{cursor:col-resize}._horizontalItem_1y7td_44{display:flex;flex-shrink:0;align-items:center;justify-content:center}._resizable-track_1y7td_55{width:100%;height:100%}path._domain_1y7td_60{stroke-width:0px}._top-right-handle_cizw2_1,._bottom-right-handle_cizw2_2{border-right:black solid;border-top:black solid}._top-left-handle_cizw2_7,._bottom-left-handle_cizw2_8{border-left:black solid;border-top:black solid}._top-draggable-handle_cizw2_13,._bottom-draggable-handle_cizw2_14,._left-draggable-handle_cizw2_15,._right-draggable-handle_cizw2_16{position:absolute;opacity:0;transition:transform .15s cubic-bezier(.25,.1,.25,1),opacity .15s cubic-bezier(.25,.1,.25,1)}._draggable-div_cizw2_22{background-color:transparent;box-sizing:border-box}._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle-grabber_cizw2_28{width:10px;height:4px;border-top:1px solid black;border-bottom:1px solid black}._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle-grabber_cizw2_28{margin:4px 7px}._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle-grabber_cizw2_44{width:4px;height:10px;border-left:1px solid black;border-right:1px solid black}._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle-grabber_cizw2_44{margin:7px 4px}._draggable-div_cizw2_22:hover ._top-draggable-handle_cizw2_13,._draggable-div_cizw2_22:hover ._bottom-draggable-handle_cizw2_14,._draggable-div_cizw2_22:hover ._left-draggable-handle_cizw2_15,._draggable-div_cizw2_22:hover ._right-draggable-handle_cizw2_16{opacity:.5;background:rgba(255,255,255,.75);box-shadow:0 0 3px 1px #ffffffbf;border-radius:3px}._top-draggable-handle_cizw2_13:hover,._top-draggable-handle_cizw2_13:active,._bottom-draggable-handle_cizw2_14:hover,._bottom-draggable-handle_cizw2_14:active,._left-draggable-handle_cizw2_15:hover,._left-draggable-handle_cizw2_15:active,._right-draggable-handle_cizw2_16:hover,._right-draggable-handle_cizw2_16:active{opacity:1!important;transform:scale(2)}._top-draggable-handle_cizw2_13:hover ._top-draggable-handle-grabber_cizw2_27,._top-draggable-handle_cizw2_13:hover ._bottom-draggable-handle-grabber_cizw2_28,._top-draggable-handle_cizw2_13:hover ._left-draggable-handle-grabber_cizw2_43,._top-draggable-handle_cizw2_13:hover ._right-draggable-handle-grabber_cizw2_44,._top-draggable-handle_cizw2_13:active ._top-draggable-handle-grabber_cizw2_27,._top-draggable-handle_cizw2_13:active ._bottom-draggable-handle-grabber_cizw2_28,._top-draggable-handle_cizw2_13:active ._left-draggable-handle-grabber_cizw2_43,._top-draggable-handle_cizw2_13:active ._right-draggable-handle-grabber_cizw2_44,._bottom-draggable-handle_cizw2_14:hover ._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle_cizw2_14:hover ._bottom-draggable-handle-grabber_cizw2_28,._bottom-draggable-handle_cizw2_14:hover ._left-draggable-handle-grabber_cizw2_43,._bottom-draggable-handle_cizw2_14:hover ._right-draggable-handle-grabber_cizw2_44,._bottom-draggable-handle_cizw2_14:active ._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle_cizw2_14:active ._bottom-draggable-handle-grabber_cizw2_28,._bottom-draggable-handle_cizw2_14:active ._left-draggable-handle-grabber_cizw2_43,._bottom-draggable-handle_cizw2_14:active ._right-draggable-handle-grabber_cizw2_44,._left-draggable-handle_cizw2_15:hover ._top-draggable-handle-grabber_cizw2_27,._left-draggable-handle_cizw2_15:hover ._bottom-draggable-handle-grabber_cizw2_28,._left-draggable-handle_cizw2_15:hover ._left-draggable-handle-grabber_cizw2_43,._left-draggable-handle_cizw2_15:hover ._right-draggable-handle-grabber_cizw2_44,._left-draggable-handle_cizw2_15:active ._top-draggable-handle-grabber_cizw2_27,._left-draggable-handle_cizw2_15:active ._bottom-draggable-handle-grabber_cizw2_28,._left-draggable-handle_cizw2_15:active ._left-draggable-handle-grabber_cizw2_43,._left-draggable-handle_cizw2_15:active ._right-draggable-handle-grabber_cizw2_44,._right-draggable-handle_cizw2_16:hover ._top-draggable-handle-grabber_cizw2_27,._right-draggable-handle_cizw2_16:hover ._bottom-draggable-handle-grabber_cizw2_28,._right-draggable-handle_cizw2_16:hover ._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle_cizw2_16:hover ._right-draggable-handle-grabber_cizw2_44,._right-draggable-handle_cizw2_16:active ._top-draggable-handle-grabber_cizw2_27,._right-draggable-handle_cizw2_16:active ._bottom-draggable-handle-grabber_cizw2_28,._right-draggable-handle_cizw2_16:active ._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle_cizw2_16:active ._right-draggable-handle-grabber_cizw2_44{box-shadow:0 0 3px 1px #0089ff;background:#0089ff}._top-draggable-handle_cizw2_13,._bottom-draggable-handle_cizw2_14{height:12px;cursor:row-resize}._left-draggable-handle_cizw2_15,._right-draggable-handle_cizw2_16{width:12px;cursor:col-resize}._horizontal-tiled-plot_1bqkg_1{position:relative}._button_1wnjn_1{display:flex;align-items:center;box-sizing:border-box;padding:.5em;color:#000;font-size:1em;line-height:1em;border:0;border-radius:2.5px;background:#fff;box-shadow:0 0 0 1px #ccc;transition:transform .15s cubic-bezier(.25,.1,.25,1),box-shadow .15s cubic-bezier(.25,.1,.25,1),background .15s cubic-bezier(.25,.1,.25,1);-webkit-appearance:none}._button_1wnjn_1:hover{background:#f2f2f2;box-shadow:0 0 0 1px #ccc}._button_1wnjn_1:focus{box-shadow:0 0 0 2px #0089ff}._button_1wnjn_1:active{transform:scale(.9)}._button_1wnjn_1:hover,._button_1wnjn_1:focus,._button_1wnjn_1:active{cursor:pointer;outline:none}._button-shortcut_1wnjn_35{padding:.1em 5px;color:#999;font-size:.8em;transition:color .15s cubic-bezier(.25,.1,.25,1)}._cross_2ke8w_1{position:relative;width:1em;height:1em}._cross_2ke8w_1:before,._cross_2ke8w_1:after{content:"";display:block;position:absolute;top:50%;left:0;width:1em;height:1px;background:black;transform-origin:center}._cross_2ke8w_1:before{-webkit-transform:translate(0,-50%) rotate(45deg);-moz-transform:translate(0,-50%) rotate(45deg);transform:translateY(-50%) rotate(45deg)}._cross_2ke8w_1:after{-webkit-transform:translate(0,-50%) rotate(-45deg);-moz-transform:translate(0,-50%) rotate(-45deg);transform:translateY(-50%) rotate(-45deg)}._modal-background_zzhoe_1{position:absolute;z-index:1000;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.666);animation:_fade-in_zzhoe_1 .2s cubic-bezier(.25,.1,.25,1) 1;transition:opacity .2s cubic-bezier(.25,.1,.25,1)}._modal-hide_zzhoe_13{opacity:0}._modal-wrap_zzhoe_17{position:absolute;top:20px;right:20px;bottom:20px;left:20px}._modal-window_zzhoe_25{position:relative;width:100%;max-width:640px;max-height:100%;margin-left:auto;margin-right:auto;color:#000;border-radius:5px;background:#fff;animation:_fade-scale-in_zzhoe_1 .2s cubic-bezier(.25,.1,.25,1) 1}._modal-window-max-height_zzhoe_38{height:100%}._modal-content_zzhoe_42{padding:10px}@keyframes _fade-in_zzhoe_1{0%{opacity:0}to{opacity:1}}@keyframes _fade-scale-in_zzhoe_1{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}._dialog-header_wp50s_1{position:relative;z-index:2;display:flex;justify-content:space-between;margin:0 -10px 10px;padding:0 10px 10px;border-bottom:1px solid #cccccc}._dialog-header_wp50s_1 h3{margin:0;padding:0;font-size:20px;line-height:1em}._dialog-header_wp50s_1 button{font-size:10px}._dialog-main-max-height_wp50s_20{position:absolute;z-index:1;top:40px;right:0;bottom:50px;left:0;padding:10px;overflow:auto}._dialog-footer_wp50s_31,._dialog-footer-max-height_wp50s_31{display:flex;justify-content:space-between;margin:10px -10px 0;padding:10px 10px 0;border-top:1px solid #cccccc}._dialog-footer_wp50s_31 button,._dialog-footer-max-height_wp50s_31 button{font-size:14px}._dialog-footer-max-height_wp50s_31{position:absolute;z-index:2;left:10px;right:10px;bottom:10px}table.table-track-options{border-collapse:collapse;margin-left:auto;margin-right:auto}td.td-track-options{border:1px solid #fff;outline:none;padding:3px;position:relative;font-family:Roboto,sans-serif;font-size:14px;color:#666}.cell-label{position:absolute;left:0;top:0;margin-left:5px;color:#777}.modal-dialog{position:relative;display:table;overflow-y:auto;overflow-x:auto;width:auto;min-width:300px;margin:auto}._track-renderer_11dwb_1{position:relative}._track-renderer-element_11dwb_5,._track-renderer-events_11dwb_6{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1}._track-renderer-events_11dwb_6{z-index:1}.tileset-finder-label{font-weight:700}.tileset-finder-search-box{margin-left:10px}.tileset-finder-search-bar{display:flex;margin-left:5px;justify-content:space-between;align-items:center}.tileset-finder-checkbox-tree{margin:5px;padding:3px;border:1px solid #aaaaaa;border-radius:5px}.react-checkbox-tree{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;font-size:16px}.react-checkbox-tree>ol{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.react-checkbox-tree ol{margin:0;padding-left:0;list-style-type:none}.react-checkbox-tree ol ol{padding-left:24px}.react-checkbox-tree button{line-height:normal;color:inherit}.react-checkbox-tree button:disabled{cursor:not-allowed}.react-checkbox-tree .rct-bare-label{cursor:default}.react-checkbox-tree label{margin-bottom:0;cursor:pointer}.react-checkbox-tree label:hover{background:rgba(51,51,204,.1)}.react-checkbox-tree label:active,.react-checkbox-tree label:focus{background:rgba(51,51,204,.15)}.react-checkbox-tree:not(.rct-native-display) input{display:none}.react-checkbox-tree.rct-native-display input{margin:0 5px}.react-checkbox-tree .rct-icon{display:inline-block;text-align:center;text-rendering:auto;font-family:"Font Awesome 5 Free",FontAwesome,sans-serif;font-weight:400;font-variant:normal;font-style:normal}.rct-disabled>.rct-text>label{opacity:.75;cursor:not-allowed}.rct-disabled>.rct-text>label:hover{background:transparent}.rct-disabled>.rct-text>label:active{background:transparent}.rct-text{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.rct-options{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-left:.5rem;text-align:right}.rct-option{opacity:.75;border:0;background:none;cursor:pointer;padding:0 4px;font-size:18px}.rct-option:hover{opacity:1}.rct-option+.rct-option{margin-left:2px}.rct-collapse,.rct-checkbox,.rct-node-icon{padding:0 5px}.rct-collapse *,.rct-checkbox *,.rct-node-icon *{display:inline-block;margin:0;width:14px}.rct-collapse{-ms-flex-item-align:stretch;align-self:stretch;border:0;background:none;line-height:normal;color:inherit;font-size:12px}.rct-collapse.rct-collapse-btn{cursor:pointer}.rct-collapse>.rct-icon-expand-close{opacity:.5}.rct-collapse>.rct-icon-expand-close:hover{opacity:1}.rct-native-display .rct-checkbox{display:none}.rct-node-clickable{cursor:pointer}.rct-node-clickable:hover{background:rgba(51,51,204,.1)}.rct-node-clickable:focus{outline:0;background:rgba(51,51,204,.2)}.rct-node-icon{color:#33c}.rct-title{padding:0 5px}.rct-icons-fa4 .rct-icon-expand-close:before{content:""}.rct-icons-fa4 .rct-icon-expand-open:before{content:""}.rct-icons-fa4 .rct-icon-uncheck:before{content:""}.rct-icons-fa4 .rct-icon-check:before{content:""}.rct-icons-fa4 .rct-icon-half-check:before{opacity:.5;content:""}.rct-icons-fa4 .rct-icon-leaf:before{content:""}.rct-icons-fa4 .rct-icon-parent-open:before{content:""}.rct-icons-fa4 .rct-icon-parent-close:before{content:""}.rct-icons-fa4 .rct-icon-expand-all:before{content:""}.rct-icons-fa4 .rct-icon-collapse-all:before{content:""}.rct-icons-fa5 .rct-icon-expand-close:before{font-weight:900;content:""}.rct-icons-fa5 .rct-icon-expand-open:before{font-weight:900;content:""}.rct-icons-fa5 .rct-icon-uncheck:before{content:""}.rct-icons-fa5 .rct-icon-check:before{content:""}.rct-icons-fa5 .rct-icon-half-check:before{opacity:.5;content:""}.rct-icons-fa5 .rct-icon-leaf:before{content:""}.rct-icons-fa5 .rct-icon-parent-open:before{content:""}.rct-icons-fa5 .rct-icon-parent-close:before{content:""}.rct-icons-fa5 .rct-icon-expand-all:before{content:""}.rct-icons-fa5 .rct-icon-collapse-all:before{content:""}.rct-direction-rtl{direction:rtl}.rct-direction-rtl ol ol{padding-right:24px;padding-left:0}.rct-direction-rtl.rct-icons-fa4 .rct-icon-expand-close:before{content:""}.rct-direction-rtl.rct-icons-fa5 .rct-icon-expand-close:before{content:""}.plot-type-selected{background-color:#0000ff4d}.plot-type-container{overflow-y:scroll;margin:5px;padding:3px;border:1px solid #aaaaaa;border-radius:5px;max-height:15vh}.plot-type-container-empty{margin:5px;padding:3px 8px;border:1px solid #aaaaaa;background-color:#e8e8e8;border-radius:5px}.plot-type-item{cursor:pointer}.plot-type-item:not(.plot-type-selected):hover{background-color:#3333cc1a}.track-thumbnail{width:30px;height:20px;display:inline-block;margin-right:10;vertical-align:middle}.track-thumbnail>svg{width:20px;height:20px}._collapse-toggle-icon_ub7s6_1:before{font-family:Glyphicons Halflings;content:"";float:left;padding-right:3px}._collapse-toggle-icon_ub7s6_1._collapsed_ub7s6_9:before{content:""}._modal-title_ub7s6_14{font-family:Roboto;font-weight:700}._modal-container_ub7s6_19{position:relative}._modal-container_ub7s6_19 ._modal_ub7s6_14,._modal-container_ub7s6_19 ._modal-backdrop_ub7s6_23{position:absolute}._modal-dialog_ub7s6_27{position:relative;display:table;overflow-y:auto;overflow-x:auto;width:600px;min-width:300px;margin:auto}._vertical-tiled-plot_f3ho8_1{position:relative}._genome-position-search_1l2sx_1,._genome-position-search-focus_1l2sx_2{position:relative;display:flex;align-items:stretch;height:100%;margin-bottom:0;font-size:13.7142857143px;transition:box-shadow .15s cubic-bezier(.25,.1,.25,1),font-size .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-focus_1l2sx_2{box-shadow:0 0 0 1px #337ab7,0 0 3px 1px #337ab7}._genome-position-search-bar_1l2sx_16{position:relative;box-sizing:border-box;width:100%;height:100%;padding:3px;color:#666;font-size:inherit;line-height:24px;border:0;border-radius:3px 0 0 3px;background:transparent}._genome-position-search-bar_1l2sx_16:focus{outline:none;color:#000}._genome-position-search-dark_1l2sx_34 ._genome-position-search-bar_1l2sx_16:focus{color:#e5e5e5}._genome-position-search-bar-button_1l2sx_38,._genome-position-search-bar-button-focus_1l2sx_39{display:block;height:100%;padding:0 8px!important;color:#999;border:0!important;border-radius:0!important;background:transparent;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-bar-button_1l2sx_38:active,._genome-position-search-bar-button_1l2sx_38:focus,._genome-position-search-bar-button_1l2sx_38:hover,._genome-position-search-bar-button-focus_1l2sx_39:active,._genome-position-search-bar-button-focus_1l2sx_39:focus,._genome-position-search-bar-button-focus_1l2sx_39:hover{color:#fff;background:#337ab7}._genome-position-search-bar-button-focus_1l2sx_39{color:#fff;background:#337ab7}._genome-position-search-bar-icon_1l2sx_62,._genome-position-search-bar-icon-focus_1l2sx_63{display:flex;align-items:center;transition:color .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-bar-icon_1l2sx_62:first-child,._genome-position-search-bar-icon-focus_1l2sx_63:first-child{margin-left:6px;margin-right:2px}._genome-position-search-bar-icon_1l2sx_62 span,._genome-position-search-bar-icon-focus_1l2sx_63 span{display:block;margin-top:-2px}._genome-position-search-bar-icon-focus_1l2sx_63{color:#337ab7}._genome-position-search-bar-suggestions_1l2sx_83{position:fixed;border-radius:3px;box-shadow:0 0 3px #0000001a,0 1px 5px #0000000d;background-color:#fffffff2;border:1px solid rgba(0,0,0,.1);padding:2px 0;font-size:90%;overflow:auto;max-height:50%}._btn_1l2sx_95{display:inline-block;margin-bottom:0;font-size:13.7142857143px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}._btn-sm_1l2sx_116{font-size:12px;line-height:1.5;border-radius:3px}._btn-default_1l2sx_122{color:#666;background-color:#fff;border-color:#ccc}._btn-default_1l2sx_122:hover{color:#000;background:#ccc}._btn-default_1l2sx_122:active,._btn-default_1l2sx_122:focus{color:#fff;border-color:#000;background:#000}._genome-position-search_1l2sx_1 ._btn_1l2sx_95{border-radius:0 3px 3px 0}._export-link-dialog-wrapper_p9gxw_1{display:flex}._export-link-dialog-wrapper_p9gxw_1 input{flex-grow:1}._add-track-position-table_wdy5w_1{border-collapse:collapse;margin:5px;color:#666}._add-track-position-table-dark_wdy5w_7{color:#ccc}._add-track-position-other_wdy5w_11{outline:none}._add-track-position-top-center_wdy5w_15{min-width:80px;min-height:20px;text-align:center;outline:none;border-top:1px solid #999;border-left:1px solid #999;border-right:1px solid #999;border-radius:2px 2px 0 0}._add-track-position-top-center_wdy5w_15:hover{color:#fff;background-color:#337ab7}._add-track-position-middle-left_wdy5w_30{min-width:40px;text-align:center;outline:none;border-top:1px solid #999;border-left:1px solid #999;border-bottom:1px solid #999;border-radius:2px 0 0 2px}._add-track-position-middle-left_wdy5w_30:hover{background-color:#337ab7;color:#fff}._add-track-position-middle-right_wdy5w_45{min-width:40px;text-align:center;outline:none;border-top:1px solid #999;border-right:1px solid #999;border-bottom:1px solid #999;border-radius:0 2px 2px 0}._add-track-position-middle-right_wdy5w_45:hover{background-color:#337ab7;color:#fff}._add-track-position-middle-middle_wdy5w_60{text-align:center;outline:none;border:1px solid #999}._add-track-position-middle-middle_wdy5w_60:hover{background-color:#337ab7;color:#fff}._add-track-position-bottom-middle_wdy5w_71{min-height:20px;text-align:center;outline:none;border-left:1px solid #999;border-right:1px solid #999;border-bottom:1px solid #999;border-radius:0 0 2px 2px}._add-track-position-bottom-middle_wdy5w_71:hover{background-color:#337ab7;color:#fff}._add-track-position-span_wdy5w_86{margin:5px}._view-config-editor-header_1hlm6_1{margin:-10px -10px 0;padding:10px;display:flex;justify-content:space-between;background:#f2f2f2}._view-config-editor-header_1hlm6_1 button{display:flex;align-items:center;font-size:14px;background:#f2f2f2}._view-config-editor-header_1hlm6_1 button:hover{background:#e5e5e5}._view-config-editor-header_1hlm6_1 button:hover span{color:#666}._view-config-editor_1hlm6_1{position:absolute;top:50px;right:0;bottom:0;left:0;margin:1px 0 0;padding:0;overflow:auto;font-size:12.5px;height:calc(100% - 80px)}._view-config-log_1hlm6_34{position:absolute;right:0;bottom:0;left:0;margin:1px 0 0;padding:0;min-height:30px;background:#f2f2f2;transition:height .15s cubic-bezier(.25,.1,.25,1)}._view-config-log-header_1hlm6_46{background:#f2f2f2;border-top:1px solid #cccccc;border-bottom:1px solid #cccccc;padding-left:10px;height:30px;display:flex;align-items:center;cursor:pointer;position:sticky;position:-webkit-sticky;top:0}._view-config-log-msg_1hlm6_60{background:#f2f2f2;overflow:auto;height:calc(100% - 30px)}._view-config-log-msg_1hlm6_60 tr,._view-config-log-msg_1hlm6_60 td{outline:none;vertical-align:top}._view-config-log-msg_1hlm6_60 ._title_1hlm6_70{font-weight:700;padding-left:8px;padding-top:8px;width:100px}._view-config-log-msg_1hlm6_60 ._Warning_1hlm6_76{color:orange}._view-config-log-msg_1hlm6_60 ._Success_1hlm6_79{color:green}._view-config-log-msg_1hlm6_60 ._Error_1hlm6_82{color:red}._view-config-log-msg_1hlm6_60 pre{background:white;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}._higlass_1uoq8_1{position:relative}._higlass-dark-theme_1uoq8_5{background:black}._higlass-container-overflow_1uoq8_9,._higlass-scroll-container-overflow_1uoq8_10,._higlass-scroll-container-scroll_1uoq8_11{position:absolute;top:0;right:0;bottom:0;left:0}._higlass-scroll-container-overflow_1uoq8_10{overflow:hidden}._higlass-scroll-container-scroll_1uoq8_11{overflow-x:hidden;overflow-y:auto}._higlass-canvas_1uoq8_28{position:absolute;width:100%;height:100%}._higlass-drawing-surface_1uoq8_34{position:relative}._higlass-svg_1uoq8_38{position:absolute;width:100%;height:100%;left:0;top:0;pointer-events:none}._tiled-area_1uoq8_47{display:flex;flex-direction:column}._track-mouseover-menu_1uoq8_52{position:fixed;z-index:1;margin:17px 0 0 9px;padding:0 .25rem;max-width:50vw;word-wrap:break-word;font-size:.8em;pointer-events:none;background:white;border-radius:.25rem;box-shadow:0 0 0 1px #0000001a,0 0 3px #00000013,0 0 7px #0000000d}.react-grid-layout{position:relative;transition:height .2s ease}.react-grid-item{transition:all .2s ease;transition-property:left,top}.react-grid-item.cssTransforms{transition-property:transform}.react-grid-item.resizing{z-index:1;will-change:width,height}.react-grid-item.react-draggable-dragging{transition:none;z-index:3;will-change:transform}.react-grid-item.react-grid-placeholder{background:red;opacity:.2;transition-duration:.1s;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.react-grid-item>.react-resizable-handle{position:absolute;width:20px;height:20px;bottom:0;right:0;cursor:se-resize}.react-grid-item>.react-resizable-handle:after{content:"";position:absolute;right:3px;bottom:3px;width:5px;height:5px;border-right:2px solid rgba(0,0,0,.4);border-bottom:2px solid rgba(0,0,0,.4)}.react-resizable{position:relative}.react-resizable-handle{position:absolute;width:20px;height:20px;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+);background-position:bottom right;padding:0 3px 3px 0}.react-resizable-handle-sw{bottom:0;left:0;cursor:sw-resize;transform:rotate(90deg)}.react-resizable-handle-se{bottom:0;right:0;cursor:se-resize}.react-resizable-handle-nw{top:0;left:0;cursor:nw-resize;transform:rotate(180deg)}.react-resizable-handle-ne{top:0;right:0;cursor:ne-resize;transform:rotate(270deg)}.react-resizable-handle-w,.react-resizable-handle-e{top:50%;margin-top:-10px;cursor:ew-resize}.react-resizable-handle-w{left:0;transform:rotate(135deg)}.react-resizable-handle-e{right:0;transform:rotate(315deg)}.react-resizable-handle-n,.react-resizable-handle-s{left:50%;margin-left:-10px;cursor:ns-resize}.react-resizable-handle-n{top:0;transform:rotate(225deg)}.react-resizable-handle-s{bottom:0;transform:rotate(45deg)}code[class*=language-],pre[class*=language-]{color:#393a34;font-family:Consolas,Bitstream Vera Sans Mono,Courier New,Courier,monospace;direction:ltr;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;font-size:.95em;line-height:1.2em;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none}pre[class*=language-]::-moz-selection,pre[class*=language-] ::-moz-selection,code[class*=language-]::-moz-selection,code[class*=language-] ::-moz-selection{background:#b3d4fc}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{background:#b3d4fc}pre[class*=language-]{padding:1em;margin:.5em 0;overflow:auto;border:1px solid #dddddd;background-color:#fff}:not(pre)>code[class*=language-]{padding:1px .2em;background:#f8f8f8;border:1px solid #dddddd}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#998;font-style:italic}.token.namespace{opacity:.7}.token.string,.token.attr-value{color:#e3116c}.token.punctuation,.token.operator{color:#393a34}.token.entity,.token.url,.token.symbol,.token.number,.token.boolean,.token.variable,.token.constant,.token.property,.token.regex,.token.inserted{color:#36acaa}.token.atrule,.token.keyword,.token.attr-name,.language-autohotkey .token.selector{color:#00a4db}.token.function,.token.deleted,.language-autohotkey .token.tag{color:#9a050f}.token.tag,.token.selector,.language-autohotkey .token.keyword{color:#00009f}.token.important,.token.function,.token.bold{font-weight:700}.token.italic{font-style:italic}.higlass *{box-sizing:border-box}.higlass .react-resizable-handle{z-index:1}'));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
import React$3, { createElement, Component, isValidElement, PureComponent } from "react";
import ReactDOM, { findDOMNode as findDOMNode$1 } from "react-dom";
import * as PIXI from "pixi.js";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f2 = n.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", {
    value: true
  });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var propTypes$3 = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim2(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err2 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err2.name = "Invariant Violation";
    throw err2;
  }
  shim2.isRequired = shim2;
  function getShim() {
    return shim2;
  }
  var ReactPropTypes = {
    array: shim2,
    bigint: shim2,
    bool: shim2,
    func: shim2,
    number: shim2,
    object: shim2,
    string: shim2,
    symbol: shim2,
    any: shim2,
    arrayOf: getShim,
    element: shim2,
    elementType: shim2,
    instanceOf: getShim,
    node: shim2,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$3.exports = factoryWithThrowingShims();
}
var propTypesExports = propTypes$3.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var xhtml = "http://www.w3.org/1999/xhtml";
const namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix2 = name += "", i = prefix2.indexOf(":");
  if (i >= 0 && (prefix2 = name.slice(0, i)) !== "xmlns")
    name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix2) ? {
    space: namespaces[prefix2],
    local: name
  } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri2 = this.namespaceURI;
    return uri2 === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri2, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none() {
}
function selector(selector2) {
  return selector2 == null ? none : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2)
          subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection$2(subgroups, this._parents);
}
function array$1(x) {
  return typeof x === "object" && "length" in x ? x : Array.from(x);
}
function empty$3() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty$3 : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    var group2 = select2.apply(this, arguments);
    return group2 == null ? [] : array$1(group2);
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function")
    select2 = arrayAll(select2);
  else
    select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        subgroups.push(select2.call(node2, node2.__data__, i, group2));
        parents.push(node2);
      }
    }
  }
  return new Selection$2(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node2) {
    return node2.matches(selector2);
  };
}
var find$3 = Array.prototype.find;
function childFind(match) {
  return function() {
    return find$3.call(this.children, match);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}
var filter$4 = Array.prototype.filter;
function children() {
  return this.children;
}
function childrenFilter(match) {
  return function() {
    return filter$4.call(this.children, match);
  };
}
function selection_selectChildren(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}
function selection_filter(match) {
  if (typeof match !== "function")
    match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Selection$2(subgroups, this._parents);
}
function sparse(update2) {
  return new Array(update2.length);
}
function selection_enter() {
  return new Selection$2(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$7(x) {
  return function() {
    return x;
  };
}
function bindIndex(parent, group2, enter, update2, exit, data2) {
  var i = 0, node2, groupLength = group2.length, dataLength = data2.length;
  for (; i < dataLength; ++i) {
    if (node2 = group2[i]) {
      node2.__data__ = data2[i];
      update2[i] = node2;
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      exit[i] = node2;
    }
  }
}
function bindKey(parent, group2, enter, update2, exit, data2, key) {
  var i, node2, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group2.length, dataLength = data2.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      keyValues[i] = keyValue = key.call(node2, node2.__data__, i, group2) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node2;
      } else {
        nodeByKeyValue.set(keyValue, node2);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data2[i], i, data2) + "";
    if (node2 = nodeByKeyValue.get(keyValue)) {
      update2[i] = node2;
      node2.__data__ = data2[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node2 = group2[i]) && nodeByKeyValue.get(keyValues[i]) === node2) {
      exit[i] = node2;
    }
  }
}
function datum(node2) {
  return node2.__data__;
}
function selection_data(value2, key) {
  if (!arguments.length)
    return Array.from(this, datum);
  var bind3 = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value2 !== "function")
    value2 = constant$7(value2);
  for (var m = groups2.length, update2 = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j], group2 = groups2[j], groupLength = group2.length, data2 = array$1(value2.call(parent, parent && parent.__data__, j, parents)), dataLength = data2.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update2[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind3(parent, group2, enterGroup, updateGroup, exitGroup, data2, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1)
          i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength)
          ;
        previous._next = next || null;
      }
    }
  }
  update2 = new Selection$2(update2, parents);
  update2._enter = enter;
  update2._exit = exit;
  return update2;
}
function selection_exit() {
  return new Selection$2(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update2 = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null)
    update2 = onupdate(update2);
  if (onexit == null)
    exit.remove();
  else
    onexit(exit);
  return enter && update2 ? enter.merge(update2).order() : update2;
}
function selection_merge(selection2) {
  if (!(selection2 instanceof Selection$2))
    throw new Error("invalid merge");
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection$2(merges, this._parents);
}
function selection_order() {
  for (var groups2 = this._groups, j = -1, m = groups2.length; ++j < m; ) {
    for (var group2 = groups2[j], i = group2.length - 1, next = group2[i], node2; --i >= 0; ) {
      if (node2 = group2[i]) {
        if (next && node2.compareDocumentPosition(next) ^ 4)
          next.parentNode.insertBefore(node2, next);
        next = node2;
      }
    }
  }
  return this;
}
function selection_sort(compare2) {
  if (!compare2)
    compare2 = ascending$1;
  function compareNode(a, b) {
    return a && b ? compare2(a.__data__, b.__data__) : !a - !b;
  }
  for (var groups2 = this._groups, m = groups2.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, sortgroup = sortgroups[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        sortgroup[i] = node2;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection$2(sortgroups, this._parents).order();
}
function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length; i < n; ++i) {
      var node2 = group2[i];
      if (node2)
        return node2;
    }
  }
  return null;
}
function selection_size() {
  let size = 0;
  for (const node2 of this)
    ++size;
  return size;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node2; i < n; ++i) {
      if (node2 = group2[i])
        callback.call(node2, node2.__data__, i, group2);
    }
  }
  return this;
}
function attrRemove$2(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$2(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$2(name, value2) {
  return function() {
    this.setAttribute(name, value2);
  };
}
function attrConstantNS$2(fullname, value2) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value2);
  };
}
function attrFunction$2(name, value2) {
  return function() {
    var v = value2.apply(this, arguments);
    if (v == null)
      this.removeAttribute(name);
    else
      this.setAttribute(name, v);
  };
}
function attrFunctionNS$2(fullname, value2) {
  return function() {
    var v = value2.apply(this, arguments);
    if (v == null)
      this.removeAttributeNS(fullname.space, fullname.local);
    else
      this.setAttributeNS(fullname.space, fullname.local, v);
  };
}
function selection_attr(name, value2) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node2 = this.node();
    return fullname.local ? node2.getAttributeNS(fullname.space, fullname.local) : node2.getAttribute(fullname);
  }
  return this.each((value2 == null ? fullname.local ? attrRemoveNS$2 : attrRemove$2 : typeof value2 === "function" ? fullname.local ? attrFunctionNS$2 : attrFunction$2 : fullname.local ? attrConstantNS$2 : attrConstant$2)(fullname, value2));
}
function defaultView(node2) {
  return node2.ownerDocument && node2.ownerDocument.defaultView || node2.document && node2 || node2.defaultView;
}
function styleRemove$2(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$2(name, value2, priority) {
  return function() {
    this.style.setProperty(name, value2, priority);
  };
}
function styleFunction$2(name, value2, priority) {
  return function() {
    var v = value2.apply(this, arguments);
    if (v == null)
      this.style.removeProperty(name);
    else
      this.style.setProperty(name, v, priority);
  };
}
function selection_style(name, value2, priority) {
  return arguments.length > 1 ? this.each((value2 == null ? styleRemove$2 : typeof value2 === "function" ? styleFunction$2 : styleConstant$2)(name, value2, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node2, name) {
  return node2.style.getPropertyValue(name) || defaultView(node2).getComputedStyle(node2, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value2) {
  return function() {
    this[name] = value2;
  };
}
function propertyFunction(name, value2) {
  return function() {
    var v = value2.apply(this, arguments);
    if (v == null)
      delete this[name];
    else
      this[name] = v;
  };
}
function selection_property(name, value2) {
  return arguments.length > 1 ? this.each((value2 == null ? propertyRemove : typeof value2 === "function" ? propertyFunction : propertyConstant)(name, value2)) : this.node()[name];
}
function classArray(string) {
  return string.trim().split(/^|\s+/);
}
function classList(node2) {
  return node2.classList || new ClassList(node2);
}
function ClassList(node2) {
  this._node = node2;
  this._names = classArray(node2.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node2, names2) {
  var list2 = classList(node2), i = -1, n = names2.length;
  while (++i < n)
    list2.add(names2[i]);
}
function classedRemove(node2, names2) {
  var list2 = classList(node2), i = -1, n = names2.length;
  while (++i < n)
    list2.remove(names2[i]);
}
function classedTrue(names2) {
  return function() {
    classedAdd(this, names2);
  };
}
function classedFalse(names2) {
  return function() {
    classedRemove(this, names2);
  };
}
function classedFunction(names2, value2) {
  return function() {
    (value2.apply(this, arguments) ? classedAdd : classedRemove)(this, names2);
  };
}
function selection_classed(name, value2) {
  var names2 = classArray(name + "");
  if (arguments.length < 2) {
    var list2 = classList(this.node()), i = -1, n = names2.length;
    while (++i < n)
      if (!list2.contains(names2[i]))
        return false;
    return true;
  }
  return this.each((typeof value2 === "function" ? classedFunction : value2 ? classedTrue : classedFalse)(names2, value2));
}
function textRemove() {
  this.textContent = "";
}
function textConstant$2(value2) {
  return function() {
    this.textContent = value2;
  };
}
function textFunction$2(value2) {
  return function() {
    var v = value2.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}
function selection_text(value2) {
  return arguments.length ? this.each(value2 == null ? textRemove : (typeof value2 === "function" ? textFunction$2 : textConstant$2)(value2)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value2) {
  return function() {
    this.innerHTML = value2;
  };
}
function htmlFunction(value2) {
  return function() {
    var v = value2.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}
function selection_html(value2) {
  return arguments.length ? this.each(value2 == null ? htmlRemove : (typeof value2 === "function" ? htmlFunction : htmlConstant)(value2)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling)
    this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling)
    this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create2 = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before2) {
  var create2 = typeof name === "function" ? name : creator(name), select2 = before2 == null ? constantNull : typeof before2 === "function" ? before2 : selector(before2);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove$2() {
  var parent = this.parentNode;
  if (parent)
    parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove$2);
}
function selection_cloneShallow() {
  var clone4 = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone4, this.nextSibling) : clone4;
}
function selection_cloneDeep() {
  var clone4 = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone4, this.nextSibling) : clone4;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value2) {
  return arguments.length ? this.property("__data__", value2) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames$2(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    return {
      type: t,
      name
    };
  });
}
function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on)
      return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i)
      on.length = i;
    else
      delete this.__on;
  };
}
function onAdd(typename, value2, options2) {
  return function() {
    var on = this.__on, o, listener = contextListener(value2);
    if (on)
      for (var j = 0, m = on.length; j < m; ++j) {
        if ((o = on[j]).type === typename.type && o.name === typename.name) {
          this.removeEventListener(o.type, o.listener, o.options);
          this.addEventListener(o.type, o.listener = listener, o.options = options2);
          o.value = value2;
          return;
        }
      }
    this.addEventListener(typename.type, listener, options2);
    o = {
      type: typename.type,
      name: typename.name,
      value: value2,
      listener,
      options: options2
    };
    if (!on)
      this.__on = [o];
    else
      on.push(o);
  };
}
function selection_on(typename, value2, options2) {
  var typenames = parseTypenames$2(typename + ""), i, n = typenames.length, t;
  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on)
      for (var j = 0, m = on.length, o; j < m; ++j) {
        for (i = 0, o = on[j]; i < n; ++i) {
          if ((t = typenames[i]).type === o.type && t.name === o.name) {
            return o.value;
          }
        }
      }
    return;
  }
  on = value2 ? onAdd : onRemove;
  for (i = 0; i < n; ++i)
    this.each(on(typenames[i], value2, options2));
  return this;
}
function dispatchEvent(node2, type3, params) {
  var window2 = defaultView(node2), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type3, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params)
      event.initEvent(type3, params.bubbles, params.cancelable), event.detail = params.detail;
    else
      event.initEvent(type3, false, false);
  }
  node2.dispatchEvent(event);
}
function dispatchConstant(type3, params) {
  return function() {
    return dispatchEvent(this, type3, params);
  };
}
function dispatchFunction(type3, params) {
  return function() {
    return dispatchEvent(this, type3, params.apply(this, arguments));
  };
}
function selection_dispatch(type3, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type3, params));
}
function* selection_iterator() {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node2; i < n; ++i) {
      if (node2 = group2[i])
        yield node2;
    }
  }
}
var root$6 = [null];
function Selection$2(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection() {
  return new Selection$2([[document.documentElement]], root$6);
}
function selection_selection() {
  return this;
}
Selection$2.prototype = selection.prototype = {
  constructor: Selection$2,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select$1(selector2) {
  return typeof selector2 === "string" ? new Selection$2([[document.querySelector(selector2)]], [document.documentElement]) : new Selection$2([[selector2]], root$6);
}
function create$2(name) {
  return select$1(creator(name).call(document.documentElement));
}
var nextId = 0;
function local$1() {
  return new Local();
}
function Local() {
  this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node2) {
    var id2 = this._;
    while (!(id2 in node2))
      if (!(node2 = node2.parentNode))
        return;
    return node2[id2];
  },
  set: function(node2, value2) {
    return node2[this._] = value2;
  },
  remove: function(node2) {
    return this._ in node2 && delete node2[this._];
  },
  toString: function() {
    return this._;
  }
};
function sourceEvent$3(event) {
  let sourceEvent2;
  while (sourceEvent2 = event.sourceEvent)
    event = sourceEvent2;
  return event;
}
function pointer(event, node2) {
  event = sourceEvent$3(event);
  if (node2 === void 0)
    node2 = event.currentTarget;
  if (node2) {
    var svg = node2.ownerSVGElement || node2;
    if (svg.createSVGPoint) {
      var point2 = svg.createSVGPoint();
      point2.x = event.clientX, point2.y = event.clientY;
      point2 = point2.matrixTransform(node2.getScreenCTM().inverse());
      return [point2.x, point2.y];
    }
    if (node2.getBoundingClientRect) {
      var rect = node2.getBoundingClientRect();
      return [event.clientX - rect.left - node2.clientLeft, event.clientY - rect.top - node2.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
function pointers(events2, node2) {
  if (events2.target) {
    events2 = sourceEvent$3(events2);
    if (node2 === void 0)
      node2 = events2.currentTarget;
    events2 = events2.touches || [events2];
  }
  return Array.from(events2, (event) => pointer(event, node2));
}
function selectAll(selector2) {
  return typeof selector2 === "string" ? new Selection$2([document.querySelectorAll(selector2)], [document.documentElement]) : new Selection$2([selector2 == null ? [] : array$1(selector2)], root$6);
}
const d3Selection = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: create$2,
  creator,
  local: local$1,
  matcher,
  namespace,
  namespaces,
  pointer,
  pointers,
  select: select$1,
  selectAll,
  selection,
  selector,
  selectorAll,
  style: styleValue,
  window: defaultView
}, Symbol.toStringTag, { value: "Module" }));
function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function bisector(f2) {
  let delta = f2;
  let compare2 = f2;
  if (f2.length === 1) {
    delta = (d, x) => f2(d) - x;
    compare2 = ascendingComparator(f2);
  }
  function left2(a, x, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (compare2(a[mid], x) < 0)
        lo = mid + 1;
      else
        hi = mid;
    }
    return lo;
  }
  function right2(a, x, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (compare2(a[mid], x) > 0)
        hi = mid;
      else
        lo = mid + 1;
    }
    return lo;
  }
  function center2(a, x, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a.length;
    const i = left2(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }
  return {
    left: left2,
    center: center2,
    right: right2
  };
}
function ascendingComparator(f2) {
  return (d, x) => ascending(f2(d), x);
}
function number$3(x) {
  return x === null ? NaN : +x;
}
function* numbers(values2, valueof) {
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 != null && (value2 = +value2) >= value2) {
        yield value2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (value2 = +value2) >= value2) {
        yield value2;
      }
    }
  }
}
const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = bisector(number$3).center;
const bisect = bisectRight;
function count(values2, valueof) {
  let count2 = 0;
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 != null && (value2 = +value2) >= value2) {
        ++count2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (value2 = +value2) >= value2) {
        ++count2;
      }
    }
  }
  return count2;
}
function length$2(array2) {
  return array2.length | 0;
}
function empty$2(length2) {
  return !(length2 > 0);
}
function arrayify(values2) {
  return typeof values2 !== "object" || "length" in values2 ? values2 : Array.from(values2);
}
function reducer(reduce2) {
  return (values2) => reduce2(...values2);
}
function cross$1(...values2) {
  const reduce2 = typeof values2[values2.length - 1] === "function" && reducer(values2.pop());
  values2 = values2.map(arrayify);
  const lengths = values2.map(length$2);
  const j = values2.length - 1;
  const index2 = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty$2))
    return product;
  while (true) {
    product.push(index2.map((j2, i2) => values2[i2][j2]));
    let i = j;
    while (++index2[i] === lengths[i]) {
      if (i === 0)
        return reduce2 ? product.map(reduce2) : product;
      index2[i--] = 0;
    }
  }
}
function cumsum$1(values2, valueof) {
  var sum2 = 0, index2 = 0;
  return Float64Array.from(values2, valueof === void 0 ? (v) => sum2 += +v || 0 : (v) => sum2 += +valueof(v, index2++, values2) || 0);
}
function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}
function variance(values2, valueof) {
  let count2 = 0;
  let delta;
  let mean2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 != null && (value2 = +value2) >= value2) {
        delta = value2 - mean2;
        mean2 += delta / ++count2;
        sum2 += delta * (value2 - mean2);
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (value2 = +value2) >= value2) {
        delta = value2 - mean2;
        mean2 += delta / ++count2;
        sum2 += delta * (value2 - mean2);
      }
    }
  }
  if (count2 > 1)
    return sum2 / (count2 - 1);
}
function deviation(values2, valueof) {
  const v = variance(values2, valueof);
  return v ? Math.sqrt(v) : v;
}
function extent$1(values2, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value2 of values2) {
      if (value2 != null) {
        if (min2 === void 0) {
          if (value2 >= value2)
            min2 = max2 = value2;
        } else {
          if (min2 > value2)
            min2 = value2;
          if (max2 < value2)
            max2 = value2;
        }
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null) {
        if (min2 === void 0) {
          if (value2 >= value2)
            min2 = max2 = value2;
        } else {
          if (min2 > value2)
            min2 = value2;
          if (max2 < value2)
            max2 = value2;
        }
      }
    }
  }
  return [min2, max2];
}
function _classCallCheck$1U(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1E(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1E(descriptor.key), descriptor);
  }
}
function _createClass$1O(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1E(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1E(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1E(arg) {
  var key = _toPrimitive$1E(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1E(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let Adder = /* @__PURE__ */ function() {
  function Adder2() {
    _classCallCheck$1U(this, Adder2);
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  _createClass$1O(Adder2, [{
    key: "add",
    value: function add3(x) {
      const p = this._partials;
      let i = 0;
      for (let j = 0; j < this._n && j < 32; j++) {
        const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
        if (lo)
          p[i++] = lo;
        x = hi;
      }
      p[i] = x;
      this._n = i + 1;
      return this;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      const p = this._partials;
      let n = this._n, x, y, lo, hi = 0;
      if (n > 0) {
        hi = p[--n];
        while (n > 0) {
          x = hi;
          y = p[--n];
          hi = x + y;
          lo = y - (hi - x);
          if (lo)
            break;
        }
        if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
          y = lo * 2;
          x = hi + y;
          if (y == x - hi)
            hi = x;
        }
      }
      return hi;
    }
  }]);
  return Adder2;
}();
function fsum(values2, valueof) {
  const adder = new Adder();
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 = +value2) {
        adder.add(value2);
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if (value2 = +valueof(value2, ++index2, values2)) {
        adder.add(value2);
      }
    }
  }
  return +adder;
}
function fcumsum(values2, valueof) {
  const adder = new Adder();
  let index2 = -1;
  return Float64Array.from(values2, valueof === void 0 ? (v) => adder.add(+v || 0) : (v) => adder.add(+valueof(v, ++index2, values2) || 0));
}
function _classCallCheck$1T(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1D(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1D(descriptor.key), descriptor);
  }
}
function _createClass$1N(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1D(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1D(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1D(arg) {
  var key = _toPrimitive$1D(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1D(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$E() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$E = Reflect.get.bind();
  } else {
    _get$E = function _get2(target, property2, receiver) {
      var base = _superPropBase$E(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$E.apply(this, arguments);
}
function _superPropBase$E(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$1i(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1x(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1i(subClass, superClass);
}
function _createSuper$1h(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1h();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1i(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1i(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1x(this, result);
  };
}
function _possibleConstructorReturn$1x(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1k(self2);
}
function _assertThisInitialized$1k(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf$1i(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf$1i(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1h()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf$1i(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct$1h() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf$1i(o, p) {
  _setPrototypeOf$1i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1i(o, p);
}
function _getPrototypeOf$1i(o) {
  _getPrototypeOf$1i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1i(o);
}
let InternMap = /* @__PURE__ */ function(_Map) {
  _inherits$1x(InternMap2, _Map);
  var _super = _createSuper$1h(InternMap2);
  function InternMap2(entries2, key = keyof) {
    var _this;
    _classCallCheck$1T(this, InternMap2);
    _this = _super.call(this);
    Object.defineProperties(_assertThisInitialized$1k(_this), {
      _intern: {
        value: /* @__PURE__ */ new Map()
      },
      _key: {
        value: key
      }
    });
    if (entries2 != null)
      for (const [key2, value2] of entries2)
        _this.set(key2, value2);
    return _this;
  }
  _createClass$1N(InternMap2, [{
    key: "get",
    value: function get3(key) {
      return _get$E(_getPrototypeOf$1i(InternMap2.prototype), "get", this).call(this, intern_get(this, key));
    }
  }, {
    key: "has",
    value: function has2(key) {
      return _get$E(_getPrototypeOf$1i(InternMap2.prototype), "has", this).call(this, intern_get(this, key));
    }
  }, {
    key: "set",
    value: function set2(key, value2) {
      return _get$E(_getPrototypeOf$1i(InternMap2.prototype), "set", this).call(this, intern_set(this, key), value2);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return _get$E(_getPrototypeOf$1i(InternMap2.prototype), "delete", this).call(this, intern_delete(this, key));
    }
  }]);
  return InternMap2;
}(/* @__PURE__ */ _wrapNativeSuper(Map));
let InternSet = /* @__PURE__ */ function(_Set) {
  _inherits$1x(InternSet2, _Set);
  var _super2 = _createSuper$1h(InternSet2);
  function InternSet2(values2, key = keyof) {
    var _this2;
    _classCallCheck$1T(this, InternSet2);
    _this2 = _super2.call(this);
    Object.defineProperties(_assertThisInitialized$1k(_this2), {
      _intern: {
        value: /* @__PURE__ */ new Map()
      },
      _key: {
        value: key
      }
    });
    if (values2 != null)
      for (const value2 of values2)
        _this2.add(value2);
    return _this2;
  }
  _createClass$1N(InternSet2, [{
    key: "has",
    value: function has2(value2) {
      return _get$E(_getPrototypeOf$1i(InternSet2.prototype), "has", this).call(this, intern_get(this, value2));
    }
  }, {
    key: "add",
    value: function add3(value2) {
      return _get$E(_getPrototypeOf$1i(InternSet2.prototype), "add", this).call(this, intern_set(this, value2));
    }
  }, {
    key: "delete",
    value: function _delete(value2) {
      return _get$E(_getPrototypeOf$1i(InternSet2.prototype), "delete", this).call(this, intern_delete(this, value2));
    }
  }]);
  return InternSet2;
}(/* @__PURE__ */ _wrapNativeSuper(Set));
function intern_get({
  _intern,
  _key
}, value2) {
  const key = _key(value2);
  return _intern.has(key) ? _intern.get(key) : value2;
}
function intern_set({
  _intern,
  _key
}, value2) {
  const key = _key(value2);
  if (_intern.has(key))
    return _intern.get(key);
  _intern.set(key, value2);
  return value2;
}
function intern_delete({
  _intern,
  _key
}, value2) {
  const key = _key(value2);
  if (_intern.has(key)) {
    value2 = _intern.get(value2);
    _intern.delete(key);
  }
  return value2;
}
function keyof(value2) {
  return value2 !== null && typeof value2 === "object" ? value2.valueOf() : value2;
}
function identity$a(x) {
  return x;
}
function group(values2, ...keys3) {
  return nest(values2, identity$a, identity$a, keys3);
}
function groups(values2, ...keys3) {
  return nest(values2, Array.from, identity$a, keys3);
}
function rollup(values2, reduce2, ...keys3) {
  return nest(values2, identity$a, reduce2, keys3);
}
function rollups(values2, reduce2, ...keys3) {
  return nest(values2, Array.from, reduce2, keys3);
}
function index$2(values2, ...keys3) {
  return nest(values2, identity$a, unique$1, keys3);
}
function indexes(values2, ...keys3) {
  return nest(values2, Array.from, unique$1, keys3);
}
function unique$1(values2) {
  if (values2.length !== 1)
    throw new Error("duplicate key");
  return values2[0];
}
function nest(values2, map2, reduce2, keys3) {
  return function regroup(values3, i) {
    if (i >= keys3.length)
      return reduce2(values3);
    const groups2 = new InternMap();
    const keyof2 = keys3[i++];
    let index2 = -1;
    for (const value2 of values3) {
      const key = keyof2(value2, ++index2, values3);
      const group2 = groups2.get(key);
      if (group2)
        group2.push(value2);
      else
        groups2.set(key, [value2]);
    }
    for (const [key, values4] of groups2) {
      groups2.set(key, regroup(values4, i));
    }
    return map2(groups2);
  }(values2, 0);
}
function permute(source, keys3) {
  return Array.from(keys3, (key) => source[key]);
}
function sort$2(values2, ...F) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  values2 = Array.from(values2);
  let [f2 = ascending] = F;
  if (f2.length === 1 || F.length > 1) {
    const index2 = Uint32Array.from(values2, (d, i) => i);
    if (F.length > 1) {
      F = F.map((f3) => values2.map(f3));
      index2.sort((i, j) => {
        for (const f3 of F) {
          const c2 = ascending(f3[i], f3[j]);
          if (c2)
            return c2;
        }
      });
    } else {
      f2 = values2.map(f2);
      index2.sort((i, j) => ascending(f2[i], f2[j]));
    }
    return permute(values2, index2);
  }
  return values2.sort(f2);
}
function groupSort(values2, reduce2, key) {
  return (reduce2.length === 1 ? sort$2(rollup(values2, reduce2, key), ([ak, av], [bk, bv]) => ascending(av, bv) || ascending(ak, bk)) : sort$2(group(values2, key), ([ak, av], [bk, bv]) => reduce2(av, bv) || ascending(ak, bk))).map(([key2]) => key2);
}
var array = Array.prototype;
var slice$4 = array.slice;
function constant$6(x) {
  return function() {
    return x;
  };
}
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start2, stop, count2) {
  var reverse2, i = -1, n, ticks2, step;
  stop = +stop, start2 = +start2, count2 = +count2;
  if (start2 === stop && count2 > 0)
    return [start2];
  if (reverse2 = stop < start2)
    n = start2, start2 = stop, stop = n;
  if ((step = tickIncrement(start2, stop, count2)) === 0 || !isFinite(step))
    return [];
  if (step > 0) {
    let r0 = Math.round(start2 / step), r1 = Math.round(stop / step);
    if (r0 * step < start2)
      ++r0;
    if (r1 * step > stop)
      --r1;
    ticks2 = new Array(n = r1 - r0 + 1);
    while (++i < n)
      ticks2[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start2 * step), r1 = Math.round(stop * step);
    if (r0 / step < start2)
      ++r0;
    if (r1 / step > stop)
      --r1;
    ticks2 = new Array(n = r1 - r0 + 1);
    while (++i < n)
      ticks2[i] = (r0 + i) / step;
  }
  if (reverse2)
    ticks2.reverse();
  return ticks2;
}
function tickIncrement(start2, stop, count2) {
  var step = (stop - start2) / Math.max(0, count2), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start2, stop, count2) {
  var step0 = Math.abs(stop - start2) / Math.max(0, count2), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
  if (error >= e10)
    step1 *= 10;
  else if (error >= e5)
    step1 *= 5;
  else if (error >= e2)
    step1 *= 2;
  return stop < start2 ? -step1 : step1;
}
function nice$1(start2, stop, count2) {
  let prestep;
  while (true) {
    const step = tickIncrement(start2, stop, count2);
    if (step === prestep || step === 0 || !isFinite(step)) {
      return [start2, stop];
    } else if (step > 0) {
      start2 = Math.floor(start2 / step) * step;
      stop = Math.ceil(stop / step) * step;
    } else if (step < 0) {
      start2 = Math.ceil(start2 * step) / step;
      stop = Math.floor(stop * step) / step;
    }
    prestep = step;
  }
}
function sturges(values2) {
  return Math.ceil(Math.log(count(values2)) / Math.LN2) + 1;
}
function bin() {
  var value2 = identity$a, domain2 = extent$1, threshold2 = sturges;
  function histogram(data2) {
    if (!Array.isArray(data2))
      data2 = Array.from(data2);
    var i, n = data2.length, x, values2 = new Array(n);
    for (i = 0; i < n; ++i) {
      values2[i] = value2(data2[i], i, data2);
    }
    var xz = domain2(values2), x02 = xz[0], x12 = xz[1], tz = threshold2(values2, x02, x12);
    if (!Array.isArray(tz)) {
      const max2 = x12, tn = +tz;
      if (domain2 === extent$1)
        [x02, x12] = nice$1(x02, x12, tn);
      tz = ticks(x02, x12, tn);
      if (tz[tz.length - 1] >= x12) {
        if (max2 >= x12 && domain2 === extent$1) {
          const step = tickIncrement(x02, x12, tn);
          if (isFinite(step)) {
            if (step > 0) {
              x12 = (Math.floor(x12 / step) + 1) * step;
            } else if (step < 0) {
              x12 = (Math.ceil(x12 * -step) + 1) / -step;
            }
          }
        } else {
          tz.pop();
        }
      }
    }
    var m = tz.length;
    while (tz[0] <= x02)
      tz.shift(), --m;
    while (tz[m - 1] > x12)
      tz.pop(), --m;
    var bins = new Array(m + 1), bin2;
    for (i = 0; i <= m; ++i) {
      bin2 = bins[i] = [];
      bin2.x0 = i > 0 ? tz[i - 1] : x02;
      bin2.x1 = i < m ? tz[i] : x12;
    }
    for (i = 0; i < n; ++i) {
      x = values2[i];
      if (x02 <= x && x <= x12) {
        bins[bisect(tz, x, 0, m)].push(data2[i]);
      }
    }
    return bins;
  }
  histogram.value = function(_) {
    return arguments.length ? (value2 = typeof _ === "function" ? _ : constant$6(_), histogram) : value2;
  };
  histogram.domain = function(_) {
    return arguments.length ? (domain2 = typeof _ === "function" ? _ : constant$6([_[0], _[1]]), histogram) : domain2;
  };
  histogram.thresholds = function(_) {
    return arguments.length ? (threshold2 = typeof _ === "function" ? _ : Array.isArray(_) ? constant$6(slice$4.call(_)) : constant$6(_), histogram) : threshold2;
  };
  return histogram;
}
function max$3(values2, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value2 of values2) {
      if (value2 != null && (max2 < value2 || max2 === void 0 && value2 >= value2)) {
        max2 = value2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (max2 < value2 || max2 === void 0 && value2 >= value2)) {
        max2 = value2;
      }
    }
  }
  return max2;
}
function min$2(values2, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value2 of values2) {
      if (value2 != null && (min2 > value2 || min2 === void 0 && value2 >= value2)) {
        min2 = value2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (min2 > value2 || min2 === void 0 && value2 >= value2)) {
        min2 = value2;
      }
    }
  }
  return min2;
}
function quickselect(array2, k, left2 = 0, right2 = array2.length - 1, compare2 = ascending) {
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n = right2 - left2 + 1;
      const m = k - left2 + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right2, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array2, k, newLeft, newRight, compare2);
    }
    const t = array2[k];
    let i = left2;
    let j = right2;
    swap$2(array2, left2, k);
    if (compare2(array2[right2], t) > 0)
      swap$2(array2, left2, right2);
    while (i < j) {
      swap$2(array2, i, j), ++i, --j;
      while (compare2(array2[i], t) < 0)
        ++i;
      while (compare2(array2[j], t) > 0)
        --j;
    }
    if (compare2(array2[left2], t) === 0)
      swap$2(array2, left2, j);
    else
      ++j, swap$2(array2, j, right2);
    if (j <= k)
      left2 = j + 1;
    if (k <= j)
      right2 = j - 1;
  }
  return array2;
}
function swap$2(array2, i, j) {
  const t = array2[i];
  array2[i] = array2[j];
  array2[j] = t;
}
function quantile$1(values2, p, valueof) {
  values2 = Float64Array.from(numbers(values2, valueof));
  if (!(n = values2.length))
    return;
  if ((p = +p) <= 0 || n < 2)
    return min$2(values2);
  if (p >= 1)
    return max$3(values2);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values2, i0).subarray(0, i0 + 1)), value1 = min$2(values2.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values2, p, valueof = number$3) {
  if (!(n = values2.length))
    return;
  if ((p = +p) <= 0 || n < 2)
    return +valueof(values2[0], 0, values2);
  if (p >= 1)
    return +valueof(values2[n - 1], n - 1, values2);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values2[i0], i0, values2), value1 = +valueof(values2[i0 + 1], i0 + 1, values2);
  return value0 + (value1 - value0) * (i - i0);
}
function freedmanDiaconis(values2, min2, max2) {
  return Math.ceil((max2 - min2) / (2 * (quantile$1(values2, 0.75) - quantile$1(values2, 0.25)) * Math.pow(count(values2), -1 / 3)));
}
function scott(values2, min2, max2) {
  return Math.ceil((max2 - min2) / (3.5 * deviation(values2) * Math.pow(count(values2), -1 / 3)));
}
function maxIndex(values2, valueof) {
  let max2;
  let maxIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value2 of values2) {
      ++index2;
      if (value2 != null && (max2 < value2 || max2 === void 0 && value2 >= value2)) {
        max2 = value2, maxIndex2 = index2;
      }
    }
  } else {
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (max2 < value2 || max2 === void 0 && value2 >= value2)) {
        max2 = value2, maxIndex2 = index2;
      }
    }
  }
  return maxIndex2;
}
function mean(values2, valueof) {
  let count2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 != null && (value2 = +value2) >= value2) {
        ++count2, sum2 += value2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (value2 = +value2) >= value2) {
        ++count2, sum2 += value2;
      }
    }
  }
  if (count2)
    return sum2 / count2;
}
function median$1(values2, valueof) {
  return quantile$1(values2, 0.5, valueof);
}
function* flatten$2(arrays) {
  for (const array2 of arrays) {
    yield* array2;
  }
}
function merge$4(arrays) {
  return Array.from(flatten$2(arrays));
}
function minIndex(values2, valueof) {
  let min2;
  let minIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value2 of values2) {
      ++index2;
      if (value2 != null && (min2 > value2 || min2 === void 0 && value2 >= value2)) {
        min2 = value2, minIndex2 = index2;
      }
    }
  } else {
    for (let value2 of values2) {
      if ((value2 = valueof(value2, ++index2, values2)) != null && (min2 > value2 || min2 === void 0 && value2 >= value2)) {
        min2 = value2, minIndex2 = index2;
      }
    }
  }
  return minIndex2;
}
function pairs(values2, pairof = pair) {
  const pairs2 = [];
  let previous;
  let first2 = false;
  for (const value2 of values2) {
    if (first2)
      pairs2.push(pairof(previous, value2));
    previous = value2;
    first2 = true;
  }
  return pairs2;
}
function pair(a, b) {
  return [a, b];
}
function range$2(start2, stop, step) {
  start2 = +start2, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n < 3 ? 1 : +step;
  var i = -1, n = Math.max(0, Math.ceil((stop - start2) / step)) | 0, range2 = new Array(n);
  while (++i < n) {
    range2[i] = start2 + i * step;
  }
  return range2;
}
function least(values2, compare2 = ascending) {
  let min2;
  let defined = false;
  if (compare2.length === 1) {
    let minValue;
    for (const element of values2) {
      const value2 = compare2(element);
      if (defined ? ascending(value2, minValue) < 0 : ascending(value2, value2) === 0) {
        min2 = element;
        minValue = value2;
        defined = true;
      }
    }
  } else {
    for (const value2 of values2) {
      if (defined ? compare2(value2, min2) < 0 : compare2(value2, value2) === 0) {
        min2 = value2;
        defined = true;
      }
    }
  }
  return min2;
}
function leastIndex(values2, compare2 = ascending) {
  if (compare2.length === 1)
    return minIndex(values2, compare2);
  let minValue;
  let min2 = -1;
  let index2 = -1;
  for (const value2 of values2) {
    ++index2;
    if (min2 < 0 ? compare2(value2, value2) === 0 : compare2(value2, minValue) < 0) {
      minValue = value2;
      min2 = index2;
    }
  }
  return min2;
}
function greatest(values2, compare2 = ascending) {
  let max2;
  let defined = false;
  if (compare2.length === 1) {
    let maxValue;
    for (const element of values2) {
      const value2 = compare2(element);
      if (defined ? ascending(value2, maxValue) > 0 : ascending(value2, value2) === 0) {
        max2 = element;
        maxValue = value2;
        defined = true;
      }
    }
  } else {
    for (const value2 of values2) {
      if (defined ? compare2(value2, max2) > 0 : compare2(value2, value2) === 0) {
        max2 = value2;
        defined = true;
      }
    }
  }
  return max2;
}
function greatestIndex(values2, compare2 = ascending) {
  if (compare2.length === 1)
    return maxIndex(values2, compare2);
  let maxValue;
  let max2 = -1;
  let index2 = -1;
  for (const value2 of values2) {
    ++index2;
    if (max2 < 0 ? compare2(value2, value2) === 0 : compare2(value2, maxValue) > 0) {
      maxValue = value2;
      max2 = index2;
    }
  }
  return max2;
}
function scan(values2, compare2) {
  const index2 = leastIndex(values2, compare2);
  return index2 < 0 ? void 0 : index2;
}
const shuffle$1 = shuffler(Math.random);
function shuffler(random) {
  return function shuffle2(array2, i0 = 0, i1 = array2.length) {
    let m = i1 - (i0 = +i0);
    while (m) {
      const i = random() * m-- | 0, t = array2[m + i0];
      array2[m + i0] = array2[i + i0];
      array2[i + i0] = t;
    }
    return array2;
  };
}
function sum$1(values2, valueof) {
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value2 of values2) {
      if (value2 = +value2) {
        sum2 += value2;
      }
    }
  } else {
    let index2 = -1;
    for (let value2 of values2) {
      if (value2 = +valueof(value2, ++index2, values2)) {
        sum2 += value2;
      }
    }
  }
  return sum2;
}
function transpose(matrix) {
  if (!(n = matrix.length))
    return [];
  for (var i = -1, m = min$2(matrix, length$1), transpose2 = new Array(m); ++i < m; ) {
    for (var j = -1, n, row = transpose2[i] = new Array(n); ++j < n; ) {
      row[j] = matrix[j][i];
    }
  }
  return transpose2;
}
function length$1(d) {
  return d.length;
}
function zip() {
  return transpose(arguments);
}
function every(values2, test2) {
  if (typeof test2 !== "function")
    throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value2 of values2) {
    if (!test2(value2, ++index2, values2)) {
      return false;
    }
  }
  return true;
}
function some$1(values2, test2) {
  if (typeof test2 !== "function")
    throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value2 of values2) {
    if (test2(value2, ++index2, values2)) {
      return true;
    }
  }
  return false;
}
function filter$3(values2, test2) {
  if (typeof test2 !== "function")
    throw new TypeError("test is not a function");
  const array2 = [];
  let index2 = -1;
  for (const value2 of values2) {
    if (test2(value2, ++index2, values2)) {
      array2.push(value2);
    }
  }
  return array2;
}
function map$7(values2, mapper) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  if (typeof mapper !== "function")
    throw new TypeError("mapper is not a function");
  return Array.from(values2, (value2, index2) => mapper(value2, index2, values2));
}
function reduce$1(values2, reducer2, value2) {
  if (typeof reducer2 !== "function")
    throw new TypeError("reducer is not a function");
  const iterator = values2[Symbol.iterator]();
  let done, next, index2 = -1;
  if (arguments.length < 3) {
    ({
      done,
      value: value2
    } = iterator.next());
    if (done)
      return;
    ++index2;
  }
  while ({
    done,
    value: next
  } = iterator.next(), !done) {
    value2 = reducer2(value2, next, ++index2, values2);
  }
  return value2;
}
function reverse(values2) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  return Array.from(values2).reverse();
}
function difference(values2, ...others) {
  values2 = new Set(values2);
  for (const other of others) {
    for (const value2 of other) {
      values2.delete(value2);
    }
  }
  return values2;
}
function disjoint(values2, other) {
  const iterator = other[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const v of values2) {
    if (set2.has(v))
      return false;
    let value2, done;
    while ({
      value: value2,
      done
    } = iterator.next()) {
      if (done)
        break;
      if (Object.is(v, value2))
        return false;
      set2.add(value2);
    }
  }
  return true;
}
function set$6(values2) {
  return values2 instanceof Set ? values2 : new Set(values2);
}
function intersection(values2, ...others) {
  values2 = new Set(values2);
  others = others.map(set$6);
  out:
    for (const value2 of values2) {
      for (const other of others) {
        if (!other.has(value2)) {
          values2.delete(value2);
          continue out;
        }
      }
    }
  return values2;
}
function superset(values2, other) {
  const iterator = values2[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const o of other) {
    if (set2.has(o))
      continue;
    let value2, done;
    while ({
      value: value2,
      done
    } = iterator.next()) {
      if (done)
        return false;
      set2.add(value2);
      if (Object.is(o, value2))
        break;
    }
  }
  return true;
}
function subset(values2, other) {
  return superset(other, values2);
}
function union(...others) {
  const set2 = /* @__PURE__ */ new Set();
  for (const other of others) {
    for (const o of other) {
      set2.add(o);
    }
  }
  return set2;
}
const d3Array = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Adder,
  InternMap,
  InternSet,
  ascending,
  bin,
  bisect,
  bisectCenter,
  bisectLeft,
  bisectRight,
  bisector,
  count,
  cross: cross$1,
  cumsum: cumsum$1,
  descending,
  deviation,
  difference,
  disjoint,
  every,
  extent: extent$1,
  fcumsum,
  filter: filter$3,
  fsum,
  greatest,
  greatestIndex,
  group,
  groupSort,
  groups,
  histogram: bin,
  index: index$2,
  indexes,
  intersection,
  least,
  leastIndex,
  map: map$7,
  max: max$3,
  maxIndex,
  mean,
  median: median$1,
  merge: merge$4,
  min: min$2,
  minIndex,
  nice: nice$1,
  pairs,
  permute,
  quantile: quantile$1,
  quantileSorted,
  quickselect,
  range: range$2,
  reduce: reduce$1,
  reverse,
  rollup,
  rollups,
  scan,
  shuffle: shuffle$1,
  shuffler,
  some: some$1,
  sort: sort$2,
  subset,
  sum: sum$1,
  superset,
  thresholdFreedmanDiaconis: freedmanDiaconis,
  thresholdScott: scott,
  thresholdSturges: sturges,
  tickIncrement,
  tickStep,
  ticks,
  transpose,
  union,
  variance,
  zip
}, Symbol.toStringTag, { value: "Module" }));
function initRange(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function")
        this.interpolator(domain2);
      else
        this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function")
        this.interpolator(interpolator);
      else
        this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain2 = [], range2 = [], unknown = implicit;
  function scale(d) {
    let i = index2.get(d);
    if (i === void 0) {
      if (unknown !== implicit)
        return unknown;
      index2.set(d, i = domain2.push(d) - 1);
    }
    return range2[i % range2.length];
  }
  scale.domain = function(_) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [], index2 = new InternMap();
    for (const value2 of _) {
      if (index2.has(value2))
        continue;
      index2.set(value2, domain2.push(value2) - 1);
    }
    return scale;
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), scale) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return ordinal(domain2, range2).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n = domain2().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop = reverse2 ? r0 : r1;
    step = (stop - start2) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round)
      step = Math.floor(step);
    start2 += (stop - start2 - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round)
      start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values2 = range$2(n).map(function(i) {
      return start2 + step * i;
    });
    return ordinalRange(reverse2 ? values2.reverse() : values2);
  }
  scale.domain = function(_) {
    return arguments.length ? (domain2(_), rescale()) : domain2();
  };
  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step;
  };
  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };
  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain2(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish(copy2());
  };
  return scale;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define$d(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$d(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m = reHex.exec(format2)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format2)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format2)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format2)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format2)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r2, g, b, a) {
  if (a <= 0)
    r2 = g = b = NaN;
  return new Rgb(r2, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r2, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r2, g, b, opacity) {
  this.r = +r2;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define$d(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value2) {
  value2 = Math.max(0, Math.min(255, Math.round(value2) || 0));
  return (value2 < 16 ? "0" : "") + value2.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0)
    h = s = l = NaN;
  else if (l <= 0 || l >= 1)
    h = s = NaN;
  else if (s <= 0)
    h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl)
    return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Hsl();
  if (o instanceof Hsl)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g = o.g / 255, b = o.b / 255, min2 = Math.min(r2, g, b), max2 = Math.max(r2, g, b), h = NaN, s = max2 - min2, l = (max2 + min2) / 2;
  if (s) {
    if (r2 === max2)
      h = (g - b) / s + (g < b) * 6;
    else if (g === max2)
      h = (b - r2) / s + 2;
    else
      h = (r2 - g) / s + 4;
    s /= l < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$d(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
const radians$1 = Math.PI / 180;
const degrees$2 = 180 / Math.PI;
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
function labConvert(o) {
  if (o instanceof Lab)
    return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl)
    return hcl2lab(o);
  if (!(o instanceof Rgb))
    o = rgbConvert(o);
  var r2 = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r2 + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r2 === g && g === b)
    x = z = y;
  else {
    x = xyz2lab((0.4360747 * r2 + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r2 + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}
define$d(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.033454 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
}
function lab2xyz(t) {
  return t > t1$1 ? t * t * t : t2 * (t - t0$1);
}
function lrgb2rgb(x) {
  return 255 * (x <= 31308e-7 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl)
    return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab))
    o = labConvert(o);
  if (o.a === 0 && o.b === 0)
    return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * degrees$2;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c2, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c2, l, opacity == null ? 1 : opacity);
}
function hcl(h, c2, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c2, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c2, l, opacity) {
  this.h = +h;
  this.c = +c2;
  this.l = +l;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h))
    return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * radians$1;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
define$d(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
  if (o instanceof Cubehelix)
    return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb))
    o = rgbConvert(o);
  var r2 = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r2 - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define$d(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh2 = Math.cos(h), sinh2 = Math.sin(h);
    return new Rgb(255 * (l + a * (A * cosh2 + B * sinh2)), 255 * (l + a * (C * cosh2 + D * sinh2)), 255 * (l + a * (E * cosh2)), this.opacity);
  }
}));
const d3Color = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color,
  cubehelix,
  gray,
  hcl,
  hsl,
  lab,
  lch,
  rgb
}, Symbol.toStringTag, { value: "Module" }));
const constant$5 = (x) => () => x;
function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$5(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$5(isNaN(a) ? b : a);
}
const interpolateRgb = function rgbGamma(y) {
  var color2 = gamma(y);
  function rgb$1(start2, end2) {
    var r2 = color2((start2 = rgb(start2)).r, (end2 = rgb(end2)).r), g = color2(start2.g, end2.g), b = color2(start2.b, end2.b), opacity = nogamma(start2.opacity, end2.opacity);
    return function(t) {
      start2.r = r2(t);
      start2.g = g(t);
      start2.b = b(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  }
  rgb$1.gamma = rgbGamma;
  return rgb$1;
}(1);
function numberArray(a, b) {
  if (!b)
    b = [];
  var n = a ? Math.min(b.length, a.length) : 0, c2 = b.slice(), i;
  return function(t) {
    for (i = 0; i < n; ++i)
      c2[i] = a[i] * (1 - t) + b[i] * t;
    return c2;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
function genericArray(a, b) {
  var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i)
    x[i] = interpolate$3(a[i], b[i]);
  for (; i < nb; ++i)
    c2[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i)
      c2[i] = x[i](t);
    return c2;
  };
}
function date$2(a, b) {
  var d = /* @__PURE__ */ new Date();
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}
function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}
function object$1(a, b) {
  var i = {}, c2 = {}, k;
  if (a === null || typeof a !== "object")
    a = {};
  if (b === null || typeof b !== "object")
    b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate$3(a[k], b[k]);
    } else {
      c2[k] = b[k];
    }
  }
  return function(t) {
    for (k in i)
      c2[k] = i[k](t);
    return c2;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero$2(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
  a = a + "", b = b + "";
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i])
        s[i] += bs;
      else
        s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i])
        s[i] += bm;
      else
        s[++i] = bm;
    } else {
      s[++i] = null;
      q.push({
        i,
        x: interpolateNumber(am, bm)
      });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i])
      s[i] += bs;
    else
      s[++i] = bs;
  }
  return s.length < 2 ? q[0] ? one(q[0].x) : zero$2(b) : (b = q.length, function(t) {
    for (var i2 = 0, o; i2 < b; ++i2)
      s[(o = q[i2]).i] = o.x(t);
    return s.join("");
  });
}
function interpolate$3(a, b) {
  var t = typeof b, c2;
  return b == null || t === "boolean" ? constant$5(b) : (t === "number" ? interpolateNumber : t === "string" ? (c2 = color(b)) ? (b = c2, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$2 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
}
function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}
var degrees$1 = 180 / Math.PI;
var identity$9 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(a, b, c2, d, e, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b))
    a /= scaleX, b /= scaleX;
  if (skewX = a * c2 + b * d)
    c2 -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c2 * c2 + d * d))
    c2 /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c2)
    a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f2,
    rotate: Math.atan2(b, a) * degrees$1,
    skewX: Math.atan(skewX) * degrees$1,
    scaleX,
    scaleY
  };
}
var svgNode;
function parseCss(value2) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value2 + "");
  return m.isIdentity ? identity$9 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value2) {
  if (value2 == null)
    return identity$9;
  if (!svgNode)
    svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value2);
  if (!(value2 = svgNode.transform.baseVal.consolidate()))
    return identity$9;
  value2 = value2.matrix;
  return decompose(value2.a, value2.b, value2.c, value2.d, value2.e, value2.f);
}
function interpolateTransform(parse2, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate2(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180)
        b += 360;
      else if (b - a > 180)
        a += 360;
      q.push({
        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }
  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({
        i: s.push(pop(s) + "skewX(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a, b) {
    var s = [], q = [];
    a = parse2(a), b = parse2(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate2(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n)
        s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
var epsilon2$1 = 1e-12;
function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
const interpolateZoom = function zoomRho(rho, rho2, rho4) {
  function zoom2(p02, p1) {
    var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < epsilon2$1) {
      S = Math.log(w1 / w0) / rho;
      i = function(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function(t) {
        var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }
    i.duration = S * 1e3 * rho / Math.SQRT2;
    return i;
  }
  zoom2.rho = function(_) {
    var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
    return zoomRho(_1, _2, _4);
  };
  return zoom2;
}(Math.SQRT2, 2, 4);
function piecewise(interpolate2, values2) {
  if (values2 === void 0)
    values2 = interpolate2, interpolate2 = interpolate$3;
  var i = 0, n = values2.length - 1, v = values2[0], I = new Array(n < 0 ? 0 : n);
  while (i < n)
    I[i] = interpolate2(v, v = values2[++i]);
  return function(t) {
    var i2 = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i2](t - i2);
  };
}
function constants$2(x) {
  return function() {
    return x;
  };
}
function number$2(x) {
  return +x;
}
var unit = [0, 1];
function identity$8(x) {
  return x;
}
function normalize(a, b) {
  return (b -= a = +a) ? function(x) {
    return (x - a) / b;
  } : constants$2(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b)
    t = a, a = b, b = t;
  return function(x) {
    return Math.max(a, Math.min(b, x));
  };
}
function bimap(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0)
    d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x) {
    return r0(d0(x));
  };
}
function polymap(domain2, range2, interpolate2) {
  var j = Math.min(domain2.length, range2.length) - 1, d = new Array(j), r2 = new Array(j), i = -1;
  if (domain2[j] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain2[i], domain2[i + 1]);
    r2[i] = interpolate2(range2[i], range2[i + 1]);
  }
  return function(x) {
    var i2 = bisect(domain2, x, 1, j) - 1;
    return r2[i2](d[i2](x));
  };
}
function copy$2(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$3() {
  var domain2 = unit, range2 = unit, interpolate2 = interpolate$3, transform3, untransform, unknown, clamp = identity$8, piecewise2, output, input;
  function rescale() {
    var n = Math.min(domain2.length, range2.length);
    if (clamp !== identity$8)
      clamp = clamper(domain2[0], domain2[n - 1]);
    piecewise2 = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise2(domain2.map(transform3), range2, interpolate2)))(transform3(clamp(x)));
  }
  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise2(range2, domain2.map(transform3), interpolateNumber)))(y)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain2 = Array.from(_, number$2), rescale()) : domain2.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return range2 = Array.from(_), interpolate2 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$8, rescale()) : clamp !== identity$8;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate2 = _, rescale()) : interpolate2;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t, u) {
    transform3 = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer$3()(identity$8, identity$8);
}
function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0)
    return null;
  var i, coefficient = x.slice(0, i);
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}
function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value2, width) {
    var i = value2.length, t = [], j = 0, g = grouping[0], length2 = 0;
    while (i > 0 && g > 0) {
      if (length2 + g + 1 > width)
        g = Math.max(1, width - length2);
      t.push(value2.substring(i -= g, i + g));
      if ((length2 += g + 1) > width)
        break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value2) {
    return value2.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s) {
  out:
    for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
      switch (s[i]) {
        case ".":
          i0 = i1 = i;
          break;
        case "0":
          if (i0 === 0)
            i0 = i;
          i1 = i;
          break;
        default:
          if (!+s[i])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
var prefixExponent;
function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d)
    return x + "";
  var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
}
function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d)
    return x + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};
function identity$7(x) {
  return x;
}
var map$6 = Array.prototype.map, prefixes$1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group2 = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$7 : formatGroup(map$6.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$7 : formatNumerals(map$6.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim3 = specifier.trim, type3 = specifier.type;
    if (type3 === "n")
      comma = true, type3 = "g";
    else if (!formatTypes[type3])
      precision === void 0 && (precision = 12), trim3 = true, type3 = "g";
    if (zero2 || fill === "0" && align === "=")
      zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type3) ? "0" + type3.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type3) ? percent : "";
    var formatType = formatTypes[type3], maybeSuffix = /[defgprs%]/.test(type3);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type3) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value2) {
      var valuePrefix = prefix2, valueSuffix = suffix, i, n, c2;
      if (type3 === "c") {
        valueSuffix = formatType(value2) + valueSuffix;
        value2 = "";
      } else {
        value2 = +value2;
        var valueNegative = value2 < 0 || 1 / value2 < 0;
        value2 = isNaN(value2) ? nan : formatType(Math.abs(value2), precision);
        if (trim3)
          value2 = formatTrim(value2);
        if (valueNegative && +value2 === 0 && sign2 !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type3 === "s" ? prefixes$1[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value2.length;
          while (++i < n) {
            if (c2 = value2.charCodeAt(i), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value2.slice(i + 1) : value2.slice(i)) + valueSuffix;
              value2 = value2.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value2 = group2(value2, Infinity);
      var length2 = valuePrefix.length + value2.length + valueSuffix.length, padding = length2 < width ? new Array(width - length2 + 1).join(fill) : "";
      if (comma && zero2)
        value2 = group2(padding + value2, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value2 = valuePrefix + value2 + valueSuffix + padding;
          break;
        case "=":
          value2 = valuePrefix + padding + value2 + valueSuffix;
          break;
        case "^":
          value2 = padding.slice(0, length2 = padding.length >> 1) + valuePrefix + value2 + valueSuffix + padding.slice(length2);
          break;
        default:
          value2 = padding + valuePrefix + value2 + valueSuffix;
          break;
      }
      return numerals(value2);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value2) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value2) / 3))) * 3, k = Math.pow(10, -e), prefix2 = prefixes$1[8 + e / 3];
    return function(value3) {
      return f2(k * value3) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$1;
var format$1;
var formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format$1 = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value2) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value2) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
const d3Format = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FormatSpecifier,
  get format() {
    return format$1;
  },
  formatDefaultLocale: defaultLocale$1,
  formatLocale: formatLocale$1,
  get formatPrefix() {
    return formatPrefix;
  },
  formatSpecifier,
  precisionFixed,
  precisionPrefix,
  precisionRound
}, Symbol.toStringTag, { value: "Module" }));
function tickFormat(start2, stop, count2, specifier) {
  var step = tickStep(start2, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value2 = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value2)))
        specifier.precision = precision;
      return formatPrefix(specifier, value2);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start2), Math.abs(stop)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}
function linearish(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d = domain2();
    return ticks(d[0], d[d.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d = domain2();
    return tickFormat(d[0], d[d.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null)
      count2 = 10;
    var d = domain2();
    var i0 = 0;
    var i1 = d.length - 1;
    var start2 = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start2) {
      step = start2, start2 = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start2, stop, count2);
      if (step === prestep) {
        d[i0] = start2;
        d[i1] = stop;
        return domain2(d);
      } else if (step > 0) {
        start2 = Math.floor(start2 / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start2 = Math.ceil(start2 * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$2(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function identity$6(domain2) {
  var unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : x;
  }
  scale.invert = scale;
  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain2 = Array.from(_, number$2), scale) : domain2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return identity$6(domain2).unknown(unknown);
  };
  domain2 = arguments.length ? Array.from(domain2, number$2) : [0, 1];
  return linearish(scale);
}
function nice(domain2, interval2) {
  domain2 = domain2.slice();
  var i0 = 0, i1 = domain2.length - 1, x02 = domain2[i0], x12 = domain2[i1], t;
  if (x12 < x02) {
    t = i0, i0 = i1, i1 = t;
    t = x02, x02 = x12, x12 = t;
  }
  domain2[i0] = interval2.floor(x02);
  domain2[i1] = interval2.ceil(x12);
  return domain2;
}
function transformLog(x) {
  return Math.log(x);
}
function transformExp(x) {
  return Math.exp(x);
}
function transformLogn(x) {
  return -Math.log(-x);
}
function transformExpn(x) {
  return -Math.exp(-x);
}
function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x) => Math.pow(base, x);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x) => Math.log(x) / base);
}
function reflect(f2) {
  return (x, k) => -f2(-x, k);
}
function loggish(transform3) {
  const scale = transform3(transformLog, transformExp);
  const domain2 = scale.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain2()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform3(transformLogn, transformExpn);
    } else {
      transform3(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale.domain = function(_) {
    return arguments.length ? (domain2(_), rescale()) : domain2();
  };
  scale.ticks = (count2) => {
    const d = domain2();
    let u = d[0];
    let v = d[d.length - 1];
    const r2 = v < u;
    if (r2)
      [u, v] = [v, u];
    let i = logs(u);
    let j = logs(v);
    let k;
    let t;
    const n = count2 == null ? 10 : +count2;
    let z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0)
        for (; i <= j; ++i) {
          for (k = 1; k < base; ++k) {
            t = i < 0 ? k / pows(-i) : k * pows(i);
            if (t < u)
              continue;
            if (t > v)
              break;
            z.push(t);
          }
        }
      else
        for (; i <= j; ++i) {
          for (k = base - 1; k >= 1; --k) {
            t = i > 0 ? k / pows(-i) : k * pows(i);
            if (t < u)
              continue;
            if (t > v)
              break;
            z.push(t);
          }
        }
      if (z.length * 2 < n)
        z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r2 ? z.reverse() : z;
  };
  scale.tickFormat = (count2, specifier) => {
    if (count2 == null)
      count2 = 10;
    if (specifier == null)
      specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null)
        specifier.trim = true;
      specifier = format$1(specifier);
    }
    if (count2 === Infinity)
      return specifier;
    const k = Math.max(1, base * count2 / scale.ticks().length);
    return (d) => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5)
        i *= base;
      return i <= k ? specifier(d) : "";
    };
  };
  scale.nice = () => {
    return domain2(nice(domain2(), {
      floor: (x) => pows(Math.floor(logs(x))),
      ceil: (x) => pows(Math.ceil(logs(x)))
    }));
  };
  return scale;
}
function log$4() {
  const scale = loggish(transformer$3()).domain([1, 10]);
  scale.copy = () => copy$2(scale, log$4()).base(scale.base());
  initRange.apply(scale, arguments);
  return scale;
}
function transformSymlog(c2) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c2));
  };
}
function transformSymexp(c2) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c2;
  };
}
function symlogish(transform3) {
  var c2 = 1, scale = transform3(transformSymlog(c2), transformSymexp(c2));
  scale.constant = function(_) {
    return arguments.length ? transform3(transformSymlog(c2 = +_), transformSymexp(c2)) : c2;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer$3());
  scale.copy = function() {
    return copy$2(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}
function transformPow(exponent2) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent2) : Math.pow(x, exponent2);
  };
}
function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}
function powish(transform3) {
  var scale = transform3(identity$8, identity$8), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform3(identity$8, identity$8) : exponent2 === 0.5 ? transform3(transformSqrt, transformSquare) : transform3(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  };
  return linearish(scale);
}
function pow$1() {
  var scale = powish(transformer$3());
  scale.copy = function() {
    return copy$2(scale, pow$1()).exponent(scale.exponent());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function sqrt$1() {
  return pow$1.apply(null, arguments).exponent(0.5);
}
function square(x) {
  return Math.sign(x) * x * x;
}
function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
  var squared = continuous(), range2 = [0, 1], round = false, unknown;
  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round ? Math.round(y) : y;
  }
  scale.invert = function(y) {
    return squared.invert(square(y));
  };
  scale.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };
  scale.range = function(_) {
    return arguments.length ? (squared.range((range2 = Array.from(_, number$2)).map(square)), scale) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return scale.range(_).round(true);
  };
  scale.round = function(_) {
    return arguments.length ? (round = !!_, scale) : round;
  };
  scale.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return radial(squared.domain(), range2).round(round).clamp(squared.clamp()).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function quantile() {
  var domain2 = [], range2 = [], thresholds = [], unknown;
  function rescale() {
    var i = 0, n = Math.max(1, range2.length);
    thresholds = new Array(n - 1);
    while (++i < n)
      thresholds[i - 1] = quantileSorted(domain2, i / n);
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range2[bisect(thresholds, x)];
  }
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain2[0], i < thresholds.length ? thresholds[i] : domain2[domain2.length - 1]];
  };
  scale.domain = function(_) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d of _)
      if (d != null && !isNaN(d = +d))
        domain2.push(d);
    domain2.sort(ascending);
    return rescale();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.quantiles = function() {
    return thresholds.slice();
  };
  scale.copy = function() {
    return quantile().domain(domain2).range(range2).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}
function quantize() {
  var x02 = 0, x12 = 1, n = 1, domain2 = [0.5], range2 = [0, 1], unknown;
  function scale(x) {
    return x != null && x <= x ? range2[bisect(domain2, x, 0, n)] : unknown;
  }
  function rescale() {
    var i = -1;
    domain2 = new Array(n);
    while (++i < n)
      domain2[i] = ((i + 1) * x12 - (i - n) * x02) / (n + 1);
    return scale;
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12] = _, x02 = +x02, x12 = +x12, rescale()) : [x02, x12];
  };
  scale.range = function(_) {
    return arguments.length ? (n = (range2 = Array.from(_)).length - 1, rescale()) : range2.slice();
  };
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x02, domain2[0]] : i >= n ? [domain2[n - 1], x12] : [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };
  scale.thresholds = function() {
    return domain2.slice();
  };
  scale.copy = function() {
    return quantize().domain([x02, x12]).range(range2).unknown(unknown);
  };
  return initRange.apply(linearish(scale), arguments);
}
function threshold() {
  var domain2 = [0.5], range2 = [0, 1], unknown, n = 1;
  function scale(x) {
    return x != null && x <= x ? range2[bisect(domain2, x, 0, n)] : unknown;
  }
  scale.domain = function(_) {
    return arguments.length ? (domain2 = Array.from(_), n = Math.min(domain2.length, range2.length - 1), scale) : domain2.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), n = Math.min(domain2.length, range2.length - 1), scale) : range2.slice();
  };
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return threshold().domain(domain2).range(range2).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count2, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval2.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval2.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = (date2) => {
    const d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = (date2, step) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2;
  };
  interval2.range = (start2, stop, step) => {
    const range2 = [];
    start2 = interval2.ceil(start2);
    step = step == null ? 1 : Math.floor(step);
    if (!(start2 < stop) || !(step > 0))
      return range2;
    let previous;
    do
      range2.push(previous = /* @__PURE__ */ new Date(+start2)), offseti(start2, step), floori(start2);
    while (previous < start2 && start2 < stop);
    return range2;
  };
  interval2.filter = (test2) => {
    return timeInterval((date2) => {
      if (date2 >= date2)
        while (floori(date2), !test2(date2))
          date2.setTime(date2 - 1);
    }, (date2, step) => {
      if (date2 >= date2) {
        if (step < 0)
          while (++step <= 0) {
            while (offseti(date2, -1), !test2(date2)) {
            }
          }
        else
          while (--step >= 0) {
            while (offseti(date2, 1), !test2(date2)) {
            }
          }
      }
    });
  };
  if (count2) {
    interval2.count = (start2, end2) => {
      t0.setTime(+start2), t1.setTime(+end2);
      floori(t0), floori(t1);
      return Math.floor(count2(t0, t1));
    };
    interval2.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval2 : interval2.filter(field ? (d) => field(d) % step === 0 : (d) => interval2.count(0, d) % step === 0);
    };
  }
  return interval2;
}
const millisecond = timeInterval(() => {
}, (date2, step) => {
  date2.setTime(+date2 + step);
}, (start2, end2) => {
  return end2 - start2;
});
millisecond.every = (k) => {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0))
    return null;
  if (!(k > 1))
    return millisecond;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k) * k);
  }, (date2, step) => {
    date2.setTime(+date2 + step * k);
  }, (start2, end2) => {
    return (end2 - start2) / k;
  });
};
millisecond.range;
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
const second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step) => {
  date2.setTime(+date2 + step * durationSecond);
}, (start2, end2) => {
  return (end2 - start2) / durationSecond;
}, (date2) => {
  return date2.getUTCSeconds();
});
second.range;
const timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getMinutes();
});
timeMinute.range;
const utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getUTCMinutes();
});
utcMinute.range;
const timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getHours();
});
timeHour.range;
const utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getUTCHours();
});
utcHour.range;
const timeDay = timeInterval((date2) => date2.setHours(0, 0, 0, 0), (date2, step) => date2.setDate(date2.getDate() + step), (start2, end2) => (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationDay, (date2) => date2.getDate() - 1);
timeDay.range;
const utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
utcDay.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return Math.floor(date2 / durationDay);
});
unixDay.range;
function timeWeekday(i) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start2, end2) => {
    return (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start2, end2) => {
    return (end2 - start2) / durationWeek;
  });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setMonth(date2.getMonth() + step);
}, (start2, end2) => {
  return end2.getMonth() - start2.getMonth() + (end2.getFullYear() - start2.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
timeMonth.range;
const utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCMonth(date2.getUTCMonth() + step);
}, (start2, end2) => {
  return end2.getUTCMonth() - start2.getUTCMonth() + (end2.getUTCFullYear() - start2.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
utcMonth.range;
const timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step);
}, (start2, end2) => {
  return end2.getFullYear() - start2.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k) * k);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setFullYear(date2.getFullYear() + step * k);
  });
};
timeYear.range;
const utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step);
}, (start2, end2) => {
  return end2.getUTCFullYear() - start2.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k) * k);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step * k);
  });
};
utcYear.range;
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];
  function ticks2(start2, stop, count2) {
    const reverse2 = stop < start2;
    if (reverse2)
      [start2, stop] = [stop, start2];
    const interval2 = count2 && typeof count2.range === "function" ? count2 : tickInterval(start2, stop, count2);
    const ticks3 = interval2 ? interval2.range(start2, +stop + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop, count2) {
    const target = Math.abs(stop - start2) / count2;
    const i = bisector(([, , step2]) => step2).right(tickIntervals, target);
    if (i === tickIntervals.length)
      return year.every(tickStep(start2 / durationYear, stop / durationYear, count2));
    if (i === 0)
      return millisecond.every(Math.max(tickStep(start2, stop, count2), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }
  return [ticks2, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date2.setFullYear(d.y);
    return date2;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date2.setUTCFullYear(d.y);
    return date2;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
  return {
    y,
    m,
    d,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats2 = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear$2,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats2.x = newFormat(locale_date, formats2);
  formats2.X = newFormat(locale_time, formats2);
  formats2.c = newFormat(locale_dateTime, formats2);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats3) {
    return function(date2) {
      var string = [], i = -1, j = 0, n = specifier.length, c2, pad3, format2;
      if (!(date2 instanceof Date))
        date2 = /* @__PURE__ */ new Date(+date2);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad3 = pads[c2 = specifier.charAt(++i)]) != null)
            c2 = specifier.charAt(++i);
          else
            pad3 = c2 === "e" ? " " : "0";
          if (format2 = formats3[c2])
            c2 = format2(date2, pad3);
          string.push(c2);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
      if (i != string.length)
        return null;
      if ("Q" in d)
        return new Date(d.Q);
      if ("s" in d)
        return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
      if (Z && !("Z" in d))
        d.Z = 0;
      if ("p" in d)
        d.H = d.H % 12 + d.p * 12;
      if (d.m === void 0)
        d.m = "q" in d ? d.q : 0;
      if ("V" in d) {
        if (d.V < 1 || d.V > 53)
          return null;
        if (!("w" in d))
          d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d))
          d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0, n = specifier.length, m = string.length, c2, parse2;
    while (i < n) {
      if (j >= m)
        return -1;
      c2 = specifier.charCodeAt(i++);
      if (c2 === 37) {
        c2 = specifier.charAt(i++);
        parse2 = parses[c2 in pads ? specifier.charAt(i++) : c2];
        if (!parse2 || (j = parse2(d, string, j)) < 0)
          return -1;
      } else if (c2 != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats2);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() {
        return specifier;
      };
      return p;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() {
        return specifier;
      };
      return p;
    }
  };
}
var pads = {
  "-": "",
  "_": " ",
  "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad$2(value2, fill, width) {
  var sign2 = value2 < 0 ? "-" : "", string = (sign2 ? -value2 : value2) + "", length2 = string.length;
  return sign2 + (length2 < width ? new Array(width - length2 + 1).join(fill) + string : string);
}
function requote(s) {
  return s.replace(requoteRe, "\\$&");
}
function formatRe(names2) {
  return new RegExp("^(?:" + names2.map(requote).join("|") + ")", "i");
}
function formatLookup(names2) {
  return new Map(names2.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad$2(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad$2(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad$2(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad$2(1 + timeDay.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad$2(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad$2(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad$2(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad$2(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad$2(timeSunday.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad$2(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad$2(timeMonday.count(timeYear(d) - 1, d), p, 2);
}
function formatYear$2(d, p) {
  return pad$2(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad$2(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad$2(d.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad$2(d.getFullYear() % 1e4, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad$2(z / 60 | 0, "0", 2) + pad$2(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad$2(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad$2(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad$2(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad$2(1 + utcDay.count(utcYear(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad$2(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad$2(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad$2(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad$2(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad$2(utcSunday.count(utcYear(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad$2(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad$2(utcMonday.count(utcYear(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad$2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad$2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1e3);
}
var locale;
var timeFormat;
var utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  locale.parse;
  utcFormat = locale.utcFormat;
  locale.utcParse;
  return locale;
}
function date$1(t) {
  return new Date(t);
}
function number$1(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale = continuous(), invert = scale.invert, domain2 = scale.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale.invert = function(y) {
    return new Date(invert(y));
  };
  scale.domain = function(_) {
    return arguments.length ? domain2(Array.from(_, number$1)) : domain2().map(date$1);
  };
  scale.ticks = function(interval2) {
    var d = domain2();
    return ticks2(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
  };
  scale.tickFormat = function(count2, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale.nice = function(interval2) {
    var d = domain2();
    if (!interval2 || typeof interval2.range !== "function")
      interval2 = tickInterval(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain2(nice(d, interval2)) : scale;
  };
  scale.copy = function() {
    return copy$2(scale, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale;
}
function time$1() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$2() {
  var x02 = 0, x12 = 1, t02, t12, k10, transform3, interpolator = identity$8, clamp = false, unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform3(x) - t02) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12] = _, t02 = transform3(x02 = +x02), t12 = transform3(x12 = +x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x02, x12];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$3);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t) {
    transform3 = t, t02 = t(x02), t12 = t(x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer$2()(identity$8));
  scale.copy = function() {
    return copy$1(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
  var scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = function() {
    return copy$1(scale, sequentialLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
  var scale = symlogish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
  var scale = powish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var domain2 = [], interpolator = identity$8;
  function scale(x) {
    if (x != null && !isNaN(x = +x))
      return interpolator((bisect(domain2, x, 1) - 1) / (domain2.length - 1));
  }
  scale.domain = function(_) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d of _)
      if (d != null && !isNaN(d = +d))
        domain2.push(d);
    domain2.sort(ascending);
    return scale;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  scale.range = function() {
    return domain2.map((d, i) => interpolator(i / (domain2.length - 1)));
  };
  scale.quantiles = function(n) {
    return Array.from({
      length: n + 1
    }, (_, i) => quantile$1(domain2, i / n));
  };
  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain2);
  };
  return initInterpolator.apply(scale, arguments);
}
function transformer$1() {
  var x02 = 0, x12 = 0.5, x2 = 1, s = 1, t02, t12, t22, k10, k21, interpolator = identity$8, transform3, clamp = false, unknown;
  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform3(x)) - t12) * (s * x < s * t12 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12, x2] = _, t02 = transform3(x02 = +x02), t12 = transform3(x12 = +x12), t22 = transform3(x2 = +x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s = t12 < t02 ? -1 : 1, scale) : [x02, x12, x2];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$3);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t) {
    transform3 = t, t02 = t(x02), t12 = t(x12), t22 = t(x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s = t12 < t02 ? -1 : 1;
    return scale;
  };
}
function diverging() {
  var scale = linearish(transformer$1()(identity$8));
  scale.copy = function() {
    return copy$1(scale, diverging());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingLog() {
  var scale = loggish(transformer$1()).domain([0.1, 1, 10]);
  scale.copy = function() {
    return copy$1(scale, divergingLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
  var scale = symlogish(transformer$1());
  scale.copy = function() {
    return copy$1(scale, divergingSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingPow() {
  var scale = powish(transformer$1());
  scale.copy = function() {
    return copy$1(scale, divergingPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$6,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log$4,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow$1,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt$1,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time$1,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
var slugid$2 = {};
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$2(uuid2) {
  return typeof uuid2 === "string" && REGEX.test(uuid2);
}
var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1) {
  byteToHex.push((i$1 + 256).toString(16).substr(1));
}
function stringify$3(arr) {
  var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid2 = (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
  if (!validate$2(uuid2)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid2;
}
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1(options2, buf, offset2) {
  var i = buf && offset2 || 0;
  var b = buf || new Array(16);
  options2 = options2 || {};
  var node2 = options2.node || _nodeId;
  var clockseq = options2.clockseq !== void 0 ? options2.clockseq : _clockseq;
  if (node2 == null || clockseq == null) {
    var seedBytes = options2.random || (options2.rng || rng)();
    if (node2 == null) {
      node2 = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options2.msecs !== void 0 ? options2.msecs : Date.now();
  var nsecs = options2.nsecs !== void 0 ? options2.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options2.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options2.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b[i++] = tl >>> 24 & 255;
  b[i++] = tl >>> 16 & 255;
  b[i++] = tl >>> 8 & 255;
  b[i++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b[i++] = tmh >>> 8 & 255;
  b[i++] = tmh & 255;
  b[i++] = tmh >>> 24 & 15 | 16;
  b[i++] = tmh >>> 16 & 255;
  b[i++] = clockseq >>> 8 | 128;
  b[i++] = clockseq & 255;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node2[n];
  }
  return buf || stringify$3(b);
}
function parse$6(uuid2) {
  if (!validate$2(uuid2)) {
    throw TypeError("Invalid UUID");
  }
  var v;
  var arr = new Uint8Array(16);
  arr[0] = (v = parseInt(uuid2.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 255;
  arr[2] = v >>> 8 & 255;
  arr[3] = v & 255;
  arr[4] = (v = parseInt(uuid2.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 255;
  arr[6] = (v = parseInt(uuid2.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 255;
  arr[8] = (v = parseInt(uuid2.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 255;
  arr[10] = (v = parseInt(uuid2.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v / 4294967296 & 255;
  arr[12] = v >>> 24 & 255;
  arr[13] = v >>> 16 & 255;
  arr[14] = v >>> 8 & 255;
  arr[15] = v & 255;
  return arr;
}
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL$2 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(name, version2, hashfunc) {
  function generateUUID(value2, namespace2, buf, offset2) {
    if (typeof value2 === "string") {
      value2 = stringToBytes(value2);
    }
    if (typeof namespace2 === "string") {
      namespace2 = parse$6(namespace2);
    }
    if (namespace2.length !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    var bytes = new Uint8Array(16 + value2.length);
    bytes.set(namespace2);
    bytes.set(value2, namespace2.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset2 = offset2 || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset2 + i] = bytes[i];
      }
      return buf;
    }
    return stringify$3(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err2) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL$2;
  return generateUUID;
}
function md5(bytes) {
  if (typeof bytes === "string") {
    var msg2 = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg2.length);
    for (var i = 0; i < msg2.length; ++i) {
      bytes[i] = msg2.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = "0123456789abcdef";
  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 255;
    var hex2 = parseInt(hexTab.charAt(x >>> 4 & 15) + hexTab.charAt(x & 15), 16);
    output.push(hex2);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x, len) {
  x[len >> 5] |= 128 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c2 = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c2;
    var oldd = d;
    a = md5ff(a, b, c2, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c2, x[i + 1], 12, -389564586);
    c2 = md5ff(c2, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c2, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c2, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c2, x[i + 5], 12, 1200080426);
    c2 = md5ff(c2, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c2, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c2, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c2, x[i + 9], 12, -1958414417);
    c2 = md5ff(c2, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c2, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c2, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c2, x[i + 13], 12, -40341101);
    c2 = md5ff(c2, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c2, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c2, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c2, x[i + 6], 9, -1069501632);
    c2 = md5gg(c2, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c2, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c2, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c2, x[i + 10], 9, 38016083);
    c2 = md5gg(c2, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c2, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c2, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c2, x[i + 14], 9, -1019803690);
    c2 = md5gg(c2, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c2, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c2, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c2, x[i + 2], 9, -51403784);
    c2 = md5gg(c2, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c2, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c2, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c2, x[i + 8], 11, -2022574463);
    c2 = md5hh(c2, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c2, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c2, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c2, x[i + 4], 11, 1272893353);
    c2 = md5hh(c2, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c2, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c2, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c2, x[i], 11, -358537222);
    c2 = md5hh(c2, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c2, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c2, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c2, x[i + 12], 11, -421815835);
    c2 = md5hh(c2, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c2, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c2, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c2, x[i + 7], 10, 1126891415);
    c2 = md5ii(c2, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c2, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c2, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c2, x[i + 3], 10, -1894986606);
    c2 = md5ii(c2, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c2, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c2, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c2, x[i + 15], 10, -30611744);
    c2 = md5ii(c2, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c2, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c2, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c2, x[i + 11], 10, -1120210379);
    c2 = md5ii(c2, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c2, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c2 = safeAdd(c2, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c2, d];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 255) << i % 32;
  }
  return output;
}
function safeAdd(x, y) {
  var lsw = (x & 65535) + (y & 65535);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c2, d, x, s, t) {
  return md5cmn(b & c2 | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c2, d, x, s, t) {
  return md5cmn(b & d | c2 & ~d, a, b, x, s, t);
}
function md5hh(a, b, c2, d, x, s, t) {
  return md5cmn(b ^ c2 ^ d, a, b, x, s, t);
}
function md5ii(a, b, c2, d, x, s, t) {
  return md5cmn(c2 ^ (b | ~d), a, b, x, s, t);
}
var v3 = v35("v3", 48, md5);
const v3$1 = v3;
function v4(options2, buf, offset2) {
  options2 = options2 || {};
  var rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset2 = offset2 || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset2 + i] = rnds[i];
    }
    return buf;
  }
  return stringify$3(rnds);
}
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  var K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  var H = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    var msg2 = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (var i = 0; i < msg2.length; ++i) {
      bytes.push(msg2.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M2 = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M2[_i] = arr;
  }
  M2[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M2[N - 1][14] = Math.floor(M2[N - 1][14]);
  M2[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M2[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a = H[0];
    var b = H[1];
    var c2 = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c2, d) + e + K2[s] + W[_t2] >>> 0;
      e = d;
      d = c2;
      c2 = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c2 >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 255, H[0] >> 16 & 255, H[0] >> 8 & 255, H[0] & 255, H[1] >> 24 & 255, H[1] >> 16 & 255, H[1] >> 8 & 255, H[1] & 255, H[2] >> 24 & 255, H[2] >> 16 & 255, H[2] >> 8 & 255, H[2] & 255, H[3] >> 24 & 255, H[3] >> 16 & 255, H[3] >> 8 & 255, H[3] & 255, H[4] >> 24 & 255, H[4] >> 16 & 255, H[4] >> 8 & 255, H[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const v5$1 = v5;
const nil = "00000000-0000-0000-0000-000000000000";
function version$1(uuid2) {
  if (!validate$2(uuid2)) {
    throw TypeError("Invalid UUID");
  }
  return parseInt(uuid2.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$6,
  stringify: stringify$3,
  v1,
  v3: v3$1,
  v4,
  v5: v5$1,
  validate: validate$2,
  version: version$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var uuid = require$$0$4;
var toBase64 = (() => {
  if (typeof Buffer !== "undefined") {
    return (bytes) => Buffer.from(bytes).toString("base64");
  }
  return (bytes) => btoa(String.fromCharCode(...bytes));
})();
var fromBase64 = (() => {
  if (typeof Buffer !== "undefined") {
    return (base64) => Buffer.from(base64, "base64");
  }
  return (base64) => Uint8Array.from(atob(base64), (c2) => c2.charCodeAt(0));
})();
slugid$2.encode = function(uuid_) {
  var bytes = uuid.parse(uuid_);
  var base64 = toBase64(bytes);
  var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
  return slug;
};
slugid$2.decode = function(slug) {
  var base64 = slug.replace(/-/g, "+").replace(/_/g, "/") + "==";
  return uuid.stringify(fromBase64(base64));
};
slugid$2.v4 = function() {
  var bytes = uuid.v4(null, new Uint8Array(16));
  var base64 = toBase64(bytes);
  var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
  return slug;
};
slugid$2.nice = function() {
  var bytes = uuid.v4(null, new Uint8Array(16));
  bytes[0] = bytes[0] & 127;
  var base64 = toBase64(bytes);
  var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
  return slug;
};
var slugid = slugid$2;
const slugid$1 = /* @__PURE__ */ getDefaultExportFromCjs(slugid);
var reactGridLayout = { exports: {} };
var ReactGridLayout$2 = {};
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(module2, exports2) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]";
  var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags2 = {};
  typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
  typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
  var freeGlobal2 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess2 = moduleExports2 && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
  function arrayFilter2(array2, predicate) {
    var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
    while (++index2 < length2) {
      var value2 = array2[index2];
      if (predicate(value2, index2, array2)) {
        result[resIndex++] = value2;
      }
    }
    return result;
  }
  function arrayPush2(array2, values2) {
    var index2 = -1, length2 = values2.length, offset2 = array2.length;
    while (++index2 < length2) {
      array2[offset2 + index2] = values2[index2];
    }
    return array2;
  }
  function arraySome2(array2, predicate) {
    var index2 = -1, length2 = array2 == null ? 0 : array2.length;
    while (++index2 < length2) {
      if (predicate(array2[index2], index2, array2)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes2(n, iteratee) {
    var index2 = -1, result = Array(n);
    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value2) {
      return func(value2);
    };
  }
  function cacheHas2(cache2, key) {
    return cache2.has(key);
  }
  function getValue2(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  function mapToArray2(map2) {
    var index2 = -1, result = Array(map2.size);
    map2.forEach(function(value2, key) {
      result[++index2] = [key, value2];
    });
    return result;
  }
  function overArg2(func, transform3) {
    return function(arg) {
      return func(transform3(arg));
    };
  }
  function setToArray2(set2) {
    var index2 = -1, result = Array(set2.size);
    set2.forEach(function(value2) {
      result[++index2] = value2;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer2 = moduleExports2 ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys2 = overArg2(Object.keys, Object);
  var DataView2 = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : void 0;
  function Hash2(entries2) {
    var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data2 = this.__data__;
    if (nativeCreate2) {
      var result = data2[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data2, key) ? data2[key] : void 0;
  }
  function hashHas2(key) {
    var data2 = this.__data__;
    return nativeCreate2 ? data2[key] !== void 0 : hasOwnProperty2.call(data2, key);
  }
  function hashSet2(key, value2) {
    var data2 = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data2[key] = nativeCreate2 && value2 === void 0 ? HASH_UNDEFINED2 : value2;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries2) {
    var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data2.length - 1;
    if (index2 == lastIndex) {
      data2.pop();
    } else {
      splice2.call(data2, index2, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    return index2 < 0 ? void 0 : data2[index2][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value2) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      ++this.size;
      data2.push([key, value2]);
    } else {
      data2[index2][1] = value2;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries2) {
    var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value2) {
    var data2 = getMapData2(this, key), size = data2.size;
    data2.set(key, value2);
    this.size += data2.size == size ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values2) {
    var index2 = -1, length2 = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache2();
    while (++index2 < length2) {
      this.add(values2[index2]);
    }
  }
  function setCacheAdd2(value2) {
    this.__data__.set(value2, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value2) {
    return this.__data__.has(value2);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack2(entries2) {
    var data2 = this.__data__ = new ListCache2(entries2);
    this.size = data2.size;
  }
  function stackClear2() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete2(key) {
    var data2 = this.__data__, result = data2["delete"](key);
    this.size = data2.size;
    return result;
  }
  function stackGet2(key) {
    return this.__data__.get(key);
  }
  function stackHas2(key) {
    return this.__data__.has(key);
  }
  function stackSet2(key, value2) {
    var data2 = this.__data__;
    if (data2 instanceof ListCache2) {
      var pairs2 = data2.__data__;
      if (!Map2 || pairs2.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs2.push([key, value2]);
        this.size = ++data2.size;
        return this;
      }
      data2 = this.__data__ = new MapCache2(pairs2);
    }
    data2.set(key, value2);
    this.size = data2.size;
    return this;
  }
  Stack2.prototype.clear = stackClear2;
  Stack2.prototype["delete"] = stackDelete2;
  Stack2.prototype.get = stackGet2;
  Stack2.prototype.has = stackHas2;
  Stack2.prototype.set = stackSet2;
  function arrayLikeKeys2(value2, inherited) {
    var isArr = isArray2(value2), isArg = !isArr && isArguments3(value2), isBuff = !isArr && !isArg && isBuffer2(value2), isType = !isArr && !isArg && !isBuff && isTypedArray2(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value2.length, String) : [], length2 = result.length;
    for (var key in value2) {
      if ((inherited || hasOwnProperty2.call(value2, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array2, key) {
    var length2 = array2.length;
    while (length2--) {
      if (eq2(array2[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
    var result = keysFunc(object2);
    return isArray2(object2) ? result : arrayPush2(result, symbolsFunc(object2));
  }
  function baseGetTag2(value2) {
    if (value2 == null) {
      return value2 === void 0 ? undefinedTag2 : nullTag2;
    }
    return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag2(value2) : objectToString2(value2);
  }
  function baseIsArguments2(value2) {
    return isObjectLike2(value2) && baseGetTag2(value2) == argsTag2;
  }
  function baseIsEqual2(value2, other, bitmask, customizer, stack) {
    if (value2 === other) {
      return true;
    }
    if (value2 == null || other == null || !isObjectLike2(value2) && !isObjectLike2(other)) {
      return value2 !== value2 && other !== other;
    }
    return baseIsEqualDeep2(value2, other, bitmask, customizer, baseIsEqual2, stack);
  }
  function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
    objTag = objTag == argsTag2 ? objectTag2 : objTag;
    othTag = othTag == argsTag2 ? objectTag2 : othTag;
    var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object2)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack2());
      return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack2());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack2());
    return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative2(value2) {
    if (!isObject2(value2) || isMasked2(value2)) {
      return false;
    }
    var pattern2 = isFunction2(value2) ? reIsNative2 : reIsHostCtor2;
    return pattern2.test(toSource2(value2));
  }
  function baseIsTypedArray2(value2) {
    return isObjectLike2(value2) && isLength2(value2.length) && !!typedArrayTags2[baseGetTag2(value2)];
  }
  function baseKeys2(object2) {
    if (!isPrototype2(object2)) {
      return nativeKeys2(object2);
    }
    var result = [];
    for (var key in Object(object2)) {
      if (hasOwnProperty2.call(object2, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array2);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : void 0;
    stack.set(array2, other);
    stack.set(other, array2);
    while (++index2 < arrLength) {
      var arrValue = array2[index2], othValue = other[index2];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome2(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array2);
    stack["delete"](other);
    return result;
  }
  function equalByTag2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag2:
        if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
          return false;
        }
        object2 = object2.buffer;
        other = other.buffer;
      case arrayBufferTag2:
        if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag2:
      case dateTag2:
      case numberTag2:
        return eq2(+object2, +other);
      case errorTag2:
        return object2.name == other.name && object2.message == other.message;
      case regexpTag2:
      case stringTag2:
        return object2 == other + "";
      case mapTag2:
        var convert = mapToArray2;
      case setTag2:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray2);
        if (object2.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object2);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object2, other);
        var result = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object2);
        return result;
      case symbolTag2:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object2);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object2, other);
    stack.set(other, object2);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object2[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object2.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object2);
    stack["delete"](other);
    return result;
  }
  function getAllKeys2(object2) {
    return baseGetAllKeys2(object2, keys3, getSymbols2);
  }
  function getMapData2(map2, key) {
    var data2 = map2.__data__;
    return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
  }
  function getNative2(object2, key) {
    var value2 = getValue2(object2, key);
    return baseIsNative2(value2) ? value2 : void 0;
  }
  function getRawTag2(value2) {
    var isOwn = hasOwnProperty2.call(value2, symToStringTag2), tag = value2[symToStringTag2];
    try {
      value2[symToStringTag2] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString2.call(value2);
    if (unmasked) {
      if (isOwn) {
        value2[symToStringTag2] = tag;
      } else {
        delete value2[symToStringTag2];
      }
    }
    return result;
  }
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
    if (object2 == null) {
      return [];
    }
    object2 = Object(object2);
    return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
      return propertyIsEnumerable2.call(object2, symbol);
    });
  };
  var getTag2 = baseGetTag2;
  if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
    getTag2 = function(value2) {
      var result = baseGetTag2(value2), Ctor = result == objectTag2 ? value2.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString2:
            return dataViewTag2;
          case mapCtorString2:
            return mapTag2;
          case promiseCtorString2:
            return promiseTag2;
          case setCtorString2:
            return setTag2;
          case weakMapCtorString2:
            return weakMapTag2;
        }
      }
      return result;
    };
  }
  function isIndex2(value2, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
    return !!length2 && (typeof value2 == "number" || reIsUint2.test(value2)) && value2 > -1 && value2 % 1 == 0 && value2 < length2;
  }
  function isKeyable2(value2) {
    var type3 = typeof value2;
    return type3 == "string" || type3 == "number" || type3 == "symbol" || type3 == "boolean" ? value2 !== "__proto__" : value2 === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value2) {
    var Ctor = value2 && value2.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value2 === proto2;
  }
  function objectToString2(value2) {
    return nativeObjectToString2.call(value2);
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq2(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
  }
  var isArguments3 = baseIsArguments2(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments2 : function(value2) {
    return isObjectLike2(value2) && hasOwnProperty2.call(value2, "callee") && !propertyIsEnumerable2.call(value2, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value2) {
    return value2 != null && isLength2(value2.length) && !isFunction2(value2);
  }
  var isBuffer2 = nativeIsBuffer2 || stubFalse2;
  function isEqual(value2, other) {
    return baseIsEqual2(value2, other);
  }
  function isFunction2(value2) {
    if (!isObject2(value2)) {
      return false;
    }
    var tag = baseGetTag2(value2);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
  }
  function isLength2(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value2) {
    var type3 = typeof value2;
    return value2 != null && (type3 == "object" || type3 == "function");
  }
  function isObjectLike2(value2) {
    return value2 != null && typeof value2 == "object";
  }
  var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
  function keys3(object2) {
    return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse2() {
    return false;
  }
  module2.exports = isEqual;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports;
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames() {
      var classes2 = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes2.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes2.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes2.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn2.call(arg, key) && arg[key]) {
              classes2.push(key);
            }
          }
        }
      }
      return classes2.join(" ");
    }
    if (module2.exports) {
      classNames.default = classNames;
      module2.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var utils$a = {};
utils$a.__esModule = true;
utils$a.noop = void 0;
var _extends$u = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
utils$a.bottom = bottom$1;
utils$a.cloneLayout = cloneLayout;
utils$a.cloneLayoutItem = cloneLayoutItem;
utils$a.childrenEqual = childrenEqual;
utils$a.collides = collides;
utils$a.compact = compact;
utils$a.compactItem = compactItem;
utils$a.correctBounds = correctBounds;
utils$a.getLayoutItem = getLayoutItem;
utils$a.getFirstCollision = getFirstCollision;
utils$a.getAllCollisions = getAllCollisions;
utils$a.getStatics = getStatics;
utils$a.moveElement = moveElement;
utils$a.moveElementAwayFromCollision = moveElementAwayFromCollision;
utils$a.perc = perc;
utils$a.setTransform = setTransform;
utils$a.setTopLeft = setTopLeft;
utils$a.sortLayoutItems = sortLayoutItems;
utils$a.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol;
utils$a.sortLayoutItemsByColRow = sortLayoutItemsByColRow;
utils$a.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
utils$a.validateLayout = validateLayout;
utils$a.autoBindHandlers = autoBindHandlers;
var _lodash$3 = lodash_isequalExports;
var _lodash2$3 = _interopRequireDefault$o(_lodash$3);
var _react$b = React$3;
var _react2$8 = _interopRequireDefault$o(_react$b);
function _interopRequireDefault$o(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function bottom$1(layout2) {
  var max2 = 0, bottomY = void 0;
  for (var _i = 0, len = layout2.length; _i < len; _i++) {
    bottomY = layout2[_i].y + layout2[_i].h;
    if (bottomY > max2)
      max2 = bottomY;
  }
  return max2;
}
function cloneLayout(layout2) {
  var newLayout = Array(layout2.length);
  for (var _i2 = 0, len = layout2.length; _i2 < len; _i2++) {
    newLayout[_i2] = cloneLayoutItem(layout2[_i2]);
  }
  return newLayout;
}
function cloneLayoutItem(layoutItem) {
  return {
    w: layoutItem.w,
    h: layoutItem.h,
    x: layoutItem.x,
    y: layoutItem.y,
    i: layoutItem.i,
    minW: layoutItem.minW,
    maxW: layoutItem.maxW,
    minH: layoutItem.minH,
    maxH: layoutItem.maxH,
    moved: Boolean(layoutItem.moved),
    static: Boolean(layoutItem.static),
    // These can be null
    isDraggable: layoutItem.isDraggable,
    isResizable: layoutItem.isResizable
  };
}
function childrenEqual(a, b) {
  return (0, _lodash2$3.default)(_react2$8.default.Children.map(a, function(c2) {
    return c2.key;
  }), _react2$8.default.Children.map(b, function(c2) {
    return c2.key;
  }));
}
function collides(l1, l2) {
  if (l1 === l2)
    return false;
  if (l1.x + l1.w <= l2.x)
    return false;
  if (l1.x >= l2.x + l2.w)
    return false;
  if (l1.y + l1.h <= l2.y)
    return false;
  if (l1.y >= l2.y + l2.h)
    return false;
  return true;
}
function compact(layout2, compactType, cols) {
  var compareWith = getStatics(layout2);
  var sorted = sortLayoutItems(layout2, compactType);
  var out = Array(layout2.length);
  for (var _i3 = 0, len = sorted.length; _i3 < len; _i3++) {
    var l = cloneLayoutItem(sorted[_i3]);
    if (!l.static) {
      l = compactItem(compareWith, l, compactType, cols, sorted);
      compareWith.push(l);
    }
    out[layout2.indexOf(sorted[_i3])] = l;
    l.moved = false;
  }
  return out;
}
var heightWidth = {
  x: "w",
  y: "h"
};
function resolveCompactionCollision(layout2, item, moveToCoord, axis2) {
  var sizeProp = heightWidth[axis2];
  item[axis2] += 1;
  var itemIndex = layout2.indexOf(item);
  for (var _i4 = itemIndex + 1; _i4 < layout2.length; _i4++) {
    var otherItem = layout2[_i4];
    if (otherItem.static)
      continue;
    if (otherItem.y > item.y + item.h)
      break;
    if (collides(item, otherItem)) {
      resolveCompactionCollision(layout2, otherItem, moveToCoord + item[sizeProp], axis2);
    }
  }
  item[axis2] = moveToCoord;
}
function compactItem(compareWith, l, compactType, cols, fullLayout) {
  var compactV = compactType === "vertical";
  var compactH = compactType === "horizontal";
  if (compactV) {
    l.y = Math.min(bottom$1(compareWith), l.y);
    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
      l.y--;
    }
  } else if (compactH) {
    l.y = Math.min(bottom$1(compareWith), l.y);
    while (l.x > 0 && !getFirstCollision(compareWith, l)) {
      l.x--;
    }
  }
  var collides2 = void 0;
  while (collides2 = getFirstCollision(compareWith, l)) {
    if (compactH) {
      resolveCompactionCollision(fullLayout, l, collides2.x + collides2.w, "x");
    } else {
      resolveCompactionCollision(fullLayout, l, collides2.y + collides2.h, "y");
    }
    if (compactH && l.x + l.w > cols) {
      l.x = cols - l.w;
      l.y++;
    }
  }
  return l;
}
function correctBounds(layout2, bounds2) {
  var collidesWith = getStatics(layout2);
  for (var _i5 = 0, len = layout2.length; _i5 < len; _i5++) {
    var l = layout2[_i5];
    if (l.x + l.w > bounds2.cols)
      l.x = bounds2.cols - l.w;
    if (l.x < 0) {
      l.x = 0;
      l.w = bounds2.cols;
    }
    if (!l.static)
      collidesWith.push(l);
    else {
      while (getFirstCollision(collidesWith, l)) {
        l.y++;
      }
    }
  }
  return layout2;
}
function getLayoutItem(layout2, id2) {
  for (var _i6 = 0, len = layout2.length; _i6 < len; _i6++) {
    if (layout2[_i6].i === id2)
      return layout2[_i6];
  }
}
function getFirstCollision(layout2, layoutItem) {
  for (var _i7 = 0, len = layout2.length; _i7 < len; _i7++) {
    if (collides(layout2[_i7], layoutItem))
      return layout2[_i7];
  }
}
function getAllCollisions(layout2, layoutItem) {
  return layout2.filter(function(l) {
    return collides(l, layoutItem);
  });
}
function getStatics(layout2) {
  return layout2.filter(function(l) {
    return l.static;
  });
}
function moveElement(layout2, l, x, y, isUserAction, preventCollision, compactType, cols) {
  if (l.static)
    return layout2;
  if (l.y === y && l.x === x)
    return layout2;
  log$3("Moving element " + l.i + " to [" + String(x) + "," + String(y) + "] from [" + l.x + "," + l.y + "]");
  var oldX = l.x;
  var oldY = l.y;
  if (typeof x === "number")
    l.x = x;
  if (typeof y === "number")
    l.y = y;
  l.moved = true;
  var sorted = sortLayoutItems(layout2, compactType);
  var movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
  if (movingUp)
    sorted = sorted.reverse();
  var collisions = getAllCollisions(sorted, l);
  if (preventCollision && collisions.length) {
    log$3("Collision prevented on " + l.i + ", reverting.");
    l.x = oldX;
    l.y = oldY;
    l.moved = false;
    return layout2;
  }
  for (var _i8 = 0, len = collisions.length; _i8 < len; _i8++) {
    var collision = collisions[_i8];
    log$3("Resolving collision between " + l.i + " at [" + l.x + "," + l.y + "] and " + collision.i + " at [" + collision.x + "," + collision.y + "]");
    if (collision.moved)
      continue;
    if (collision.static) {
      layout2 = moveElementAwayFromCollision(layout2, collision, l, isUserAction, compactType);
    } else {
      layout2 = moveElementAwayFromCollision(layout2, l, collision, isUserAction, compactType);
    }
  }
  return layout2;
}
function moveElementAwayFromCollision(layout2, collidesWith, itemToMove, isUserAction, compactType, cols) {
  var compactH = compactType === "horizontal";
  var compactV = compactType === "vertical";
  var preventCollision = false;
  if (isUserAction) {
    isUserAction = false;
    var fakeItem = {
      x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
      y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: "-1"
    };
    if (!getFirstCollision(layout2, fakeItem)) {
      log$3("Doing reverse collision on " + itemToMove.i + " up to [" + fakeItem.x + "," + fakeItem.y + "].");
      return moveElement(layout2, itemToMove, compactH ? fakeItem.x : void 0, compactV ? fakeItem.y : void 0, isUserAction, preventCollision, compactType);
    }
  }
  return moveElement(layout2, itemToMove, compactH ? itemToMove.x + 1 : void 0, compactV ? itemToMove.y + 1 : void 0, isUserAction, preventCollision, compactType);
}
function perc(num) {
  return num * 100 + "%";
}
function setTransform(_ref) {
  var top2 = _ref.top, left2 = _ref.left, width = _ref.width, height2 = _ref.height;
  var translate = "translate(" + left2 + "px," + top2 + "px)";
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + "px",
    height: height2 + "px",
    position: "absolute"
  };
}
function setTopLeft(_ref2) {
  var top2 = _ref2.top, left2 = _ref2.left, width = _ref2.width, height2 = _ref2.height;
  return {
    top: top2 + "px",
    left: left2 + "px",
    width: width + "px",
    height: height2 + "px",
    position: "absolute"
  };
}
function sortLayoutItems(layout2, compactType) {
  if (compactType === "horizontal")
    return sortLayoutItemsByColRow(layout2);
  else
    return sortLayoutItemsByRowCol(layout2);
}
function sortLayoutItemsByRowCol(layout2) {
  return [].concat(layout2).sort(function(a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    } else if (a.y === b.y && a.x === b.x) {
      return 0;
    }
    return -1;
  });
}
function sortLayoutItemsByColRow(layout2) {
  return [].concat(layout2).sort(function(a, b) {
    if (a.x > b.x || a.x === b.x && a.y > b.y) {
      return 1;
    }
    return -1;
  });
}
function synchronizeLayoutWithChildren(initialLayout, children3, cols, compactType) {
  initialLayout = initialLayout || [];
  var layout2 = [];
  _react2$8.default.Children.forEach(children3, function(child, i) {
    var exists = getLayoutItem(initialLayout, String(child.key));
    if (exists) {
      layout2[i] = cloneLayoutItem(exists);
    } else {
      var g = child.props["data-grid"] || child.props._grid;
      if (g) {
        layout2[i] = cloneLayoutItem(_extends$u({}, g, {
          i: child.key
        }));
      } else {
        layout2[i] = cloneLayoutItem({
          w: 1,
          h: 1,
          x: 0,
          y: bottom$1(layout2),
          i: String(child.key)
        });
      }
    }
  });
  layout2 = correctBounds(layout2, {
    cols
  });
  layout2 = compact(layout2, compactType, cols);
  return layout2;
}
function validateLayout(layout2) {
  var contextName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Layout";
  var subProps = ["x", "y", "w", "h"];
  if (!Array.isArray(layout2))
    throw new Error(contextName + " must be an array!");
  for (var _i9 = 0, len = layout2.length; _i9 < len; _i9++) {
    var item = layout2[_i9];
    for (var j = 0; j < subProps.length; j++) {
      if (typeof item[subProps[j]] !== "number") {
        throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "]." + subProps[j] + " must be a number!");
      }
    }
    if (item.i && typeof item.i !== "string") {
      throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "].i must be a string!");
    }
    if (item.static !== void 0 && typeof item.static !== "boolean") {
      throw new Error("ReactGridLayout: " + contextName + "[" + _i9 + "].static must be a boolean!");
    }
  }
}
function autoBindHandlers(el, fns) {
  fns.forEach(function(key) {
    return el[key] = el[key].bind(el);
  });
}
function log$3() {
  return;
}
utils$a.noop = function noop2() {
};
var GridItem$1 = {};
var reactDraggable = { exports: {} };
(function(module2, exports2) {
  (function(global, factory) {
    module2.exports = factory(ReactDOM, React$3);
  })(commonjsGlobal, function(ReactDOM2, React2) {
    ReactDOM2 = ReactDOM2 && ReactDOM2.hasOwnProperty("default") ? ReactDOM2["default"] : ReactDOM2;
    React2 = React2 && React2.hasOwnProperty("default") ? React2["default"] : React2;
    function createCommonjsModule(fn, module22) {
      return module22 = {
        exports: {}
      }, fn(module22, module22.exports), module22.exports;
    }
    function makeEmptyFunction(arg) {
      return function() {
        return arg;
      };
    }
    var emptyFunction2 = function emptyFunction22() {
    };
    emptyFunction2.thatReturns = makeEmptyFunction;
    emptyFunction2.thatReturnsFalse = makeEmptyFunction(false);
    emptyFunction2.thatReturnsTrue = makeEmptyFunction(true);
    emptyFunction2.thatReturnsNull = makeEmptyFunction(null);
    emptyFunction2.thatReturnsThis = function() {
      return this;
    };
    emptyFunction2.thatReturnsArgument = function(arg) {
      return arg;
    };
    var emptyFunction_1 = emptyFunction2;
    var validateFormat = function validateFormat2(format2) {
    };
    {
      validateFormat = function validateFormat2(format2) {
        if (format2 === void 0) {
          throw new Error("invariant requires an error message argument");
        }
      };
    }
    function invariant2(condition, format2, a, b, c2, d, e, f2) {
      validateFormat(format2);
      if (!condition) {
        var error;
        if (format2 === void 0) {
          error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        } else {
          var args = [a, b, c2, d, e, f2];
          var argIndex = 0;
          error = new Error(format2.replace(/%s/g, function() {
            return args[argIndex++];
          }));
          error.name = "Invariant Violation";
        }
        error.framesToPop = 1;
        throw error;
      }
    }
    var invariant_1 = invariant2;
    var warning = emptyFunction_1;
    {
      var printWarning = function printWarning2(format2) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        var argIndex = 0;
        var message = "Warning: " + format2.replace(/%s/g, function() {
          return args[argIndex++];
        });
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
      warning = function warning2(condition, format2) {
        if (format2 === void 0) {
          throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        }
        if (format2.indexOf("Failed Composite propType: ") === 0) {
          return;
        }
        if (!condition) {
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }
          printWarning.apply(void 0, [format2].concat(args));
        }
      };
    }
    var warning_1 = warning;
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject2(val2) {
      if (val2 === null || val2 === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val2);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err2) {
        return false;
      }
    }
    var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject2(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty2.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
    var ReactPropTypesSecret2 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_12 = ReactPropTypesSecret2;
    {
      var invariant$12 = invariant_1;
      var warning$1 = warning_1;
      var ReactPropTypesSecret$12 = ReactPropTypesSecret_12;
      var loggedTypeFailures = {};
    }
    function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
      {
        for (var typeSpecName in typeSpecs) {
          if (typeSpecs.hasOwnProperty(typeSpecName)) {
            var error;
            try {
              invariant$12(typeof typeSpecs[typeSpecName] === "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]);
              error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret$12);
            } catch (ex) {
              error = ex;
            }
            warning$1(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error);
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              warning$1(false, "Failed %s type: %s%s", location, error.message, stack != null ? stack : "");
            }
          }
        }
      }
    }
    var checkPropTypes_1 = checkPropTypes;
    var factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is3(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message) {
        this.message = message;
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate2) {
        {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret_12) {
            if (throwOnDirectAccess) {
              invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                warning_1(false, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName);
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate2(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate2(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate2(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret_12);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createElementTypeChecker() {
        function validate2(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate2(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName2(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          warning_1(false, "Invalid argument supplied to oneOf, expected an instance of array.");
          return emptyFunction_1.thatReturnsNull;
        }
        function validate2(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is3(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate2);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate2(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (propValue.hasOwnProperty(key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_12);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          warning_1(false, "Invalid argument supplied to oneOfType, expected an instance of array.");
          return emptyFunction_1.thatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            warning_1(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
            return emptyFunction_1.thatReturnsNull;
          }
        }
        function validate2(props, propName, componentName, location, propFullName) {
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            if (checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret_12) == null) {
              return null;
            }
          }
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
        }
        return createChainableTypeChecker(validate2);
      }
      function createNodeChecker() {
        function validate2(props, propName, componentName, location, propFullName) {
          if (!isNode2(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate2(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (!checker) {
              continue;
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_12);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate2(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = objectAssign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (!checker) {
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_12);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate2);
      }
      function isNode2(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode2);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode2(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode2(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol2(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol2(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value2) {
        var type3 = getPreciseType(value2);
        switch (type3) {
          case "array":
          case "object":
            return "an " + type3;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type3;
          default:
            return type3;
        }
      }
      function getClassName2(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes_1;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    var propTypes2 = createCommonjsModule(function(module22) {
      {
        var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 60103;
        var isValidElement2 = function(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        };
        var throwOnDirectAccess = true;
        module22.exports = factoryWithTypeCheckers(isValidElement2, throwOnDirectAccess);
      }
    });
    var classnames2 = createCommonjsModule(function(module22) {
      /*!
        Copyright (c) 2016 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
      */
      (function() {
        var hasOwn2 = {}.hasOwnProperty;
        function classNames() {
          var classes2 = [];
          for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg)
              continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") {
              classes2.push(arg);
            } else if (Array.isArray(arg)) {
              classes2.push(classNames.apply(null, arg));
            } else if (argType === "object") {
              for (var key in arg) {
                if (hasOwn2.call(arg, key) && arg[key]) {
                  classes2.push(key);
                }
              }
            }
          }
          return classes2.join(" ");
        }
        if (module22.exports) {
          module22.exports = classNames;
        } else {
          window.classNames = classNames;
        }
      })();
    });
    function findInArray2(array2, callback) {
      for (var i = 0, length2 = array2.length; i < length2; i++) {
        if (callback.apply(callback, [array2[i], i, array2]))
          return array2[i];
      }
    }
    function isFunction2(func) {
      return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
    }
    function isNum2(num) {
      return typeof num === "number" && !isNaN(num);
    }
    function int2(a) {
      return parseInt(a, 10);
    }
    function dontSetMe2(props, propName, componentName) {
      if (props[propName]) {
        return new Error("Invalid prop " + propName + " passed to " + componentName + " - do not set this, set it on the child.");
      }
    }
    var prefixes2 = ["Moz", "Webkit", "O", "ms"];
    function getPrefix2() {
      var prop2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      if (typeof window === "undefined" || typeof window.document === "undefined")
        return "";
      var style = window.document.documentElement.style;
      if (prop2 in style)
        return "";
      for (var i = 0; i < prefixes2.length; i++) {
        if (browserPrefixToKey2(prop2, prefixes2[i]) in style)
          return prefixes2[i];
      }
      return "";
    }
    function browserPrefixToKey2(prop2, prefix2) {
      return prefix2 ? "" + prefix2 + kebabToTitleCase2(prop2) : prop2;
    }
    function kebabToTitleCase2(str) {
      var out = "";
      var shouldCapitalize = true;
      for (var i = 0; i < str.length; i++) {
        if (shouldCapitalize) {
          out += str[i].toUpperCase();
          shouldCapitalize = false;
        } else if (str[i] === "-") {
          shouldCapitalize = true;
        } else {
          out += str[i];
        }
      }
      return out;
    }
    var browserPrefix = getPrefix2();
    var classCallCheck = function(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
    var createClass = /* @__PURE__ */ function() {
      function defineProperties2(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor)
            descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps)
          defineProperties2(Constructor.prototype, protoProps);
        if (staticProps)
          defineProperties2(Constructor, staticProps);
        return Constructor;
      };
    }();
    var defineProperty2 = function(obj, key, value2) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value2,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value2;
      }
      return obj;
    };
    var _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var inherits = function(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    var possibleConstructorReturn = function(self2, call2) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
    };
    var slicedToArray = /* @__PURE__ */ function() {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = void 0;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
              break;
          }
        } catch (err2) {
          _d = true;
          _e = err2;
        } finally {
          try {
            if (!_n && _i["return"])
              _i["return"]();
          } finally {
            if (_d)
              throw _e;
          }
        }
        return _arr;
      }
      return function(arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var matchesSelectorFunc2 = "";
    function matchesSelector2(el, selector2) {
      if (!matchesSelectorFunc2) {
        matchesSelectorFunc2 = findInArray2(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
          return isFunction2(el[method]);
        });
      }
      if (!isFunction2(el[matchesSelectorFunc2]))
        return false;
      return el[matchesSelectorFunc2](selector2);
    }
    function matchesSelectorAndParentsTo2(el, selector2, baseNode) {
      var node2 = el;
      do {
        if (matchesSelector2(node2, selector2))
          return true;
        if (node2 === baseNode)
          return false;
        node2 = node2.parentNode;
      } while (node2);
      return false;
    }
    function addEvent2(el, event, handler) {
      if (!el) {
        return;
      }
      if (el.attachEvent) {
        el.attachEvent("on" + event, handler);
      } else if (el.addEventListener) {
        el.addEventListener(event, handler, true);
      } else {
        el["on" + event] = handler;
      }
    }
    function removeEvent2(el, event, handler) {
      if (!el) {
        return;
      }
      if (el.detachEvent) {
        el.detachEvent("on" + event, handler);
      } else if (el.removeEventListener) {
        el.removeEventListener(event, handler, true);
      } else {
        el["on" + event] = null;
      }
    }
    function outerHeight2(node2) {
      var height2 = node2.clientHeight;
      var computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
      height2 += int2(computedStyle.borderTopWidth);
      height2 += int2(computedStyle.borderBottomWidth);
      return height2;
    }
    function outerWidth2(node2) {
      var width = node2.clientWidth;
      var computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
      width += int2(computedStyle.borderLeftWidth);
      width += int2(computedStyle.borderRightWidth);
      return width;
    }
    function innerHeight2(node2) {
      var height2 = node2.clientHeight;
      var computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
      height2 -= int2(computedStyle.paddingTop);
      height2 -= int2(computedStyle.paddingBottom);
      return height2;
    }
    function innerWidth2(node2) {
      var width = node2.clientWidth;
      var computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
      width -= int2(computedStyle.paddingLeft);
      width -= int2(computedStyle.paddingRight);
      return width;
    }
    function offsetXYFromParent2(evt, offsetParent) {
      var isBody = offsetParent === offsetParent.ownerDocument.body;
      var offsetParentRect = isBody ? {
        left: 0,
        top: 0
      } : offsetParent.getBoundingClientRect();
      var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
      var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
      return {
        x,
        y
      };
    }
    function createCSSTransform2(controlPos, positionOffset) {
      var translation = getTranslation2(controlPos, positionOffset, "px");
      return defineProperty2({}, browserPrefixToKey2("transform", browserPrefix), translation);
    }
    function createSVGTransform2(controlPos, positionOffset) {
      var translation = getTranslation2(controlPos, positionOffset, "");
      return translation;
    }
    function getTranslation2(_ref2, positionOffset, unitSuffix) {
      var x = _ref2.x, y = _ref2.y;
      var translation = "translate(" + x + unitSuffix + "," + y + unitSuffix + ")";
      if (positionOffset) {
        var defaultX = "" + (typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        var defaultY = "" + (typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(" + defaultX + ", " + defaultY + ")" + translation;
      }
      return translation;
    }
    function getTouch2(e, identifier) {
      return e.targetTouches && findInArray2(e.targetTouches, function(t) {
        return identifier === t.identifier;
      }) || e.changedTouches && findInArray2(e.changedTouches, function(t) {
        return identifier === t.identifier;
      });
    }
    function getTouchIdentifier2(e) {
      if (e.targetTouches && e.targetTouches[0])
        return e.targetTouches[0].identifier;
      if (e.changedTouches && e.changedTouches[0])
        return e.changedTouches[0].identifier;
    }
    function addUserSelectStyles2(doc) {
      if (!doc)
        return;
      var styleEl = doc.getElementById("react-draggable-style-el");
      if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
      }
      if (doc.body)
        addClassName2(doc.body, "react-draggable-transparent-selection");
    }
    function removeUserSelectStyles2(doc) {
      try {
        if (doc && doc.body)
          removeClassName2(doc.body, "react-draggable-transparent-selection");
        if (doc.selection) {
          doc.selection.empty();
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (e) {
      }
    }
    function styleHacks() {
      var childStyle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return _extends2({
        touchAction: "none"
      }, childStyle);
    }
    function addClassName2(el, className2) {
      if (el.classList) {
        el.classList.add(className2);
      } else {
        if (!el.className.match(new RegExp("(?:^|\\s)" + className2 + "(?!\\S)"))) {
          el.className += " " + className2;
        }
      }
    }
    function removeClassName2(el, className2) {
      if (el.classList) {
        el.classList.remove(className2);
      } else {
        el.className = el.className.replace(new RegExp("(?:^|\\s)" + className2 + "(?!\\S)", "g"), "");
      }
    }
    function getBoundPosition2(draggable, x, y) {
      if (!draggable.props.bounds)
        return [x, y];
      var bounds2 = draggable.props.bounds;
      bounds2 = typeof bounds2 === "string" ? bounds2 : cloneBounds2(bounds2);
      var node2 = findDOMNode2(draggable);
      if (typeof bounds2 === "string") {
        var ownerDocument = node2.ownerDocument;
        var ownerWindow = ownerDocument.defaultView;
        var boundNode = void 0;
        if (bounds2 === "parent") {
          boundNode = node2.parentNode;
        } else {
          boundNode = ownerDocument.querySelector(bounds2);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) {
          throw new Error('Bounds selector "' + bounds2 + '" could not find an element.');
        }
        var nodeStyle = ownerWindow.getComputedStyle(node2);
        var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
        bounds2 = {
          left: -node2.offsetLeft + int2(boundNodeStyle.paddingLeft) + int2(nodeStyle.marginLeft),
          top: -node2.offsetTop + int2(boundNodeStyle.paddingTop) + int2(nodeStyle.marginTop),
          right: innerWidth2(boundNode) - outerWidth2(node2) - node2.offsetLeft + int2(boundNodeStyle.paddingRight) - int2(nodeStyle.marginRight),
          bottom: innerHeight2(boundNode) - outerHeight2(node2) - node2.offsetTop + int2(boundNodeStyle.paddingBottom) - int2(nodeStyle.marginBottom)
        };
      }
      if (isNum2(bounds2.right))
        x = Math.min(x, bounds2.right);
      if (isNum2(bounds2.bottom))
        y = Math.min(y, bounds2.bottom);
      if (isNum2(bounds2.left))
        x = Math.max(x, bounds2.left);
      if (isNum2(bounds2.top))
        y = Math.max(y, bounds2.top);
      return [x, y];
    }
    function snapToGrid2(grid, pendingX, pendingY) {
      var x = Math.round(pendingX / grid[0]) * grid[0];
      var y = Math.round(pendingY / grid[1]) * grid[1];
      return [x, y];
    }
    function canDragX2(draggable) {
      return draggable.props.axis === "both" || draggable.props.axis === "x";
    }
    function canDragY2(draggable) {
      return draggable.props.axis === "both" || draggable.props.axis === "y";
    }
    function getControlPosition2(e, touchIdentifier, draggableCore) {
      var touchObj = typeof touchIdentifier === "number" ? getTouch2(e, touchIdentifier) : null;
      if (typeof touchIdentifier === "number" && !touchObj)
        return null;
      var node2 = findDOMNode2(draggableCore);
      var offsetParent = draggableCore.props.offsetParent || node2.offsetParent || node2.ownerDocument.body;
      return offsetXYFromParent2(touchObj || e, offsetParent);
    }
    function createCoreData2(draggable, x, y) {
      var state = draggable.state;
      var isStart = !isNum2(state.lastX);
      var node2 = findDOMNode2(draggable);
      if (isStart) {
        return {
          node: node2,
          deltaX: 0,
          deltaY: 0,
          lastX: x,
          lastY: y,
          x,
          y
        };
      } else {
        return {
          node: node2,
          deltaX: x - state.lastX,
          deltaY: y - state.lastY,
          lastX: state.lastX,
          lastY: state.lastY,
          x,
          y
        };
      }
    }
    function createDraggableData2(draggable, coreData) {
      var scale = draggable.props.scale;
      return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
      };
    }
    function cloneBounds2(bounds2) {
      return {
        left: bounds2.left,
        top: bounds2.top,
        right: bounds2.right,
        bottom: bounds2.bottom
      };
    }
    function findDOMNode2(draggable) {
      var node2 = ReactDOM2.findDOMNode(draggable);
      if (!node2) {
        throw new Error("<DraggableCore>: Unmounted during event!");
      }
      return node2;
    }
    function log2() {
    }
    var eventsFor2 = {
      touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
      },
      mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
      }
    };
    var dragEventFor2 = eventsFor2.mouse;
    var DraggableCore2 = function(_React$Component) {
      inherits(DraggableCore22, _React$Component);
      function DraggableCore22() {
        var _ref;
        var _temp, _this, _ret;
        classCallCheck(this, DraggableCore22);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore22.__proto__ || Object.getPrototypeOf(DraggableCore22)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          dragging: false,
          // Used while dragging to determine deltas.
          lastX: NaN,
          lastY: NaN,
          touchIdentifier: null
        }, _this.handleDragStart = function(e) {
          _this.props.onMouseDown(e);
          if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0)
            return false;
          var thisNode = ReactDOM2.findDOMNode(_this);
          if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
            throw new Error("<DraggableCore> not mounted on DragStart!");
          }
          var ownerDocument = thisNode.ownerDocument;
          if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo2(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo2(e.target, _this.props.cancel, thisNode)) {
            return;
          }
          var touchIdentifier = getTouchIdentifier2(e);
          _this.setState({
            touchIdentifier
          });
          var position = getControlPosition2(e, touchIdentifier, _this);
          if (position == null)
            return;
          var x = position.x, y = position.y;
          var coreEvent = createCoreData2(_this, x, y);
          log2("calling", _this.props.onStart);
          var shouldUpdate = _this.props.onStart(e, coreEvent);
          if (shouldUpdate === false)
            return;
          if (_this.props.enableUserSelectHack)
            addUserSelectStyles2(ownerDocument);
          _this.setState({
            dragging: true,
            lastX: x,
            lastY: y
          });
          addEvent2(ownerDocument, dragEventFor2.move, _this.handleDrag);
          addEvent2(ownerDocument, dragEventFor2.stop, _this.handleDragStop);
        }, _this.handleDrag = function(e) {
          if (e.type === "touchmove")
            e.preventDefault();
          var position = getControlPosition2(e, _this.state.touchIdentifier, _this);
          if (position == null)
            return;
          var x = position.x, y = position.y;
          if (Array.isArray(_this.props.grid)) {
            var _deltaX = x - _this.state.lastX, _deltaY = y - _this.state.lastY;
            var _snapToGrid = snapToGrid2(_this.props.grid, _deltaX, _deltaY);
            var _snapToGrid2 = slicedToArray(_snapToGrid, 2);
            _deltaX = _snapToGrid2[0];
            _deltaY = _snapToGrid2[1];
            if (!_deltaX && !_deltaY)
              return;
            x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
          }
          var coreEvent = createCoreData2(_this, x, y);
          var shouldUpdate = _this.props.onDrag(e, coreEvent);
          if (shouldUpdate === false) {
            try {
              _this.handleDragStop(new MouseEvent("mouseup"));
            } catch (err2) {
              var event = document.createEvent("MouseEvents");
              event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
              _this.handleDragStop(event);
            }
            return;
          }
          _this.setState({
            lastX: x,
            lastY: y
          });
        }, _this.handleDragStop = function(e) {
          if (!_this.state.dragging)
            return;
          var position = getControlPosition2(e, _this.state.touchIdentifier, _this);
          if (position == null)
            return;
          var x = position.x, y = position.y;
          var coreEvent = createCoreData2(_this, x, y);
          var thisNode = ReactDOM2.findDOMNode(_this);
          if (thisNode) {
            if (_this.props.enableUserSelectHack)
              removeUserSelectStyles2(thisNode.ownerDocument);
          }
          _this.setState({
            dragging: false,
            lastX: NaN,
            lastY: NaN
          });
          _this.props.onStop(e, coreEvent);
          if (thisNode) {
            removeEvent2(thisNode.ownerDocument, dragEventFor2.move, _this.handleDrag);
            removeEvent2(thisNode.ownerDocument, dragEventFor2.stop, _this.handleDragStop);
          }
        }, _this.onMouseDown = function(e) {
          dragEventFor2 = eventsFor2.mouse;
          return _this.handleDragStart(e);
        }, _this.onMouseUp = function(e) {
          dragEventFor2 = eventsFor2.mouse;
          return _this.handleDragStop(e);
        }, _this.onTouchStart = function(e) {
          dragEventFor2 = eventsFor2.touch;
          return _this.handleDragStart(e);
        }, _this.onTouchEnd = function(e) {
          dragEventFor2 = eventsFor2.touch;
          return _this.handleDragStop(e);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }
      createClass(DraggableCore22, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var thisNode = ReactDOM2.findDOMNode(this);
          if (thisNode) {
            var ownerDocument = thisNode.ownerDocument;
            removeEvent2(ownerDocument, eventsFor2.mouse.move, this.handleDrag);
            removeEvent2(ownerDocument, eventsFor2.touch.move, this.handleDrag);
            removeEvent2(ownerDocument, eventsFor2.mouse.stop, this.handleDragStop);
            removeEvent2(ownerDocument, eventsFor2.touch.stop, this.handleDragStop);
            if (this.props.enableUserSelectHack)
              removeUserSelectStyles2(ownerDocument);
          }
        }
        // Same as onMouseDown (start drag), but now consider this a touch device.
      }, {
        key: "render",
        value: function render3() {
          return React2.cloneElement(React2.Children.only(this.props.children), {
            style: styleHacks(this.props.children.props.style),
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart,
            onMouseUp: this.onMouseUp,
            onTouchEnd: this.onTouchEnd
          });
        }
      }]);
      return DraggableCore22;
    }(React2.Component);
    DraggableCore2.displayName = "DraggableCore";
    DraggableCore2.propTypes = {
      /**
       * `allowAnyClick` allows dragging using any mouse button.
       * By default, we only accept the left button.
       *
       * Defaults to `false`.
       */
      allowAnyClick: propTypes2.bool,
      /**
       * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
       * with the exception of `onMouseDown`, will not fire.
       */
      disabled: propTypes2.bool,
      /**
       * By default, we add 'user-select:none' attributes to the document body
       * to prevent ugly text selection during drag. If this is causing problems
       * for your app, set this to `false`.
       */
      enableUserSelectHack: propTypes2.bool,
      /**
       * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
       * instead of using the parent node.
       */
      offsetParent: function offsetParent(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) {
          throw new Error("Draggable's offsetParent must be a DOM Node.");
        }
      },
      /**
       * `grid` specifies the x and y that dragging should snap to.
       */
      grid: propTypes2.arrayOf(propTypes2.number),
      /**
       * `scale` specifies the scale of the area you are dragging inside of. It allows
       * the drag deltas to scale correctly with how far zoomed in/out you are.
       */
      scale: propTypes2.number,
      /**
       * `handle` specifies a selector to be used as the handle that initiates drag.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable handle=".handle">
       *              <div>
       *                  <div className="handle">Click me to drag</div>
       *                  <div>This is some other content</div>
       *              </div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      handle: propTypes2.string,
      /**
       * `cancel` specifies a selector to be used to prevent drag initialization.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *           return(
       *               <Draggable cancel=".cancel">
       *                   <div>
       *                     <div className="cancel">You can't drag from here</div>
       *                     <div>Dragging here works fine</div>
       *                   </div>
       *               </Draggable>
       *           );
       *       }
       *   });
       * ```
       */
      cancel: propTypes2.string,
      /**
       * Called when dragging starts.
       * If this function returns the boolean false, dragging will be canceled.
       */
      onStart: propTypes2.func,
      /**
       * Called while dragging.
       * If this function returns the boolean false, dragging will be canceled.
       */
      onDrag: propTypes2.func,
      /**
       * Called when dragging stops.
       * If this function returns the boolean false, the drag will remain active.
       */
      onStop: propTypes2.func,
      /**
       * A workaround option which can be passed if onMouseDown needs to be accessed,
       * since it'll always be blocked (as there is internal use of onMouseDown)
       */
      onMouseDown: propTypes2.func,
      /**
       * These properties should be defined on the child, not here.
       */
      className: dontSetMe2,
      style: dontSetMe2,
      transform: dontSetMe2
    };
    DraggableCore2.defaultProps = {
      allowAnyClick: false,
      // by default only accept left click
      cancel: null,
      disabled: false,
      enableUserSelectHack: true,
      offsetParent: null,
      handle: null,
      grid: null,
      transform: null,
      onStart: function onStart() {
      },
      onDrag: function onDrag() {
      },
      onStop: function onStop() {
      },
      onMouseDown: function onMouseDown() {
      }
    };
    var Draggable2 = function(_React$Component) {
      inherits(Draggable22, _React$Component);
      function Draggable22(props) {
        classCallCheck(this, Draggable22);
        var _this = possibleConstructorReturn(this, (Draggable22.__proto__ || Object.getPrototypeOf(Draggable22)).call(this, props));
        _this.onDragStart = function(e, coreData) {
          var shouldStart = _this.props.onStart(e, createDraggableData2(_this, coreData));
          if (shouldStart === false)
            return false;
          _this.setState({
            dragging: true,
            dragged: true
          });
        };
        _this.onDrag = function(e, coreData) {
          if (!_this.state.dragging)
            return false;
          var uiData = createDraggableData2(_this, coreData);
          var newState = {
            x: uiData.x,
            y: uiData.y
          };
          if (_this.props.bounds) {
            var _x = newState.x, _y = newState.y;
            newState.x += _this.state.slackX;
            newState.y += _this.state.slackY;
            var _getBoundPosition = getBoundPosition2(_this, newState.x, newState.y), _getBoundPosition2 = slicedToArray(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
            newState.x = newStateX;
            newState.y = newStateY;
            newState.slackX = _this.state.slackX + (_x - newState.x);
            newState.slackY = _this.state.slackY + (_y - newState.y);
            uiData.x = newState.x;
            uiData.y = newState.y;
            uiData.deltaX = newState.x - _this.state.x;
            uiData.deltaY = newState.y - _this.state.y;
          }
          var shouldUpdate = _this.props.onDrag(e, uiData);
          if (shouldUpdate === false)
            return false;
          _this.setState(newState);
        };
        _this.onDragStop = function(e, coreData) {
          if (!_this.state.dragging)
            return false;
          var shouldStop = _this.props.onStop(e, createDraggableData2(_this, coreData));
          if (shouldStop === false)
            return false;
          var newState = {
            dragging: false,
            slackX: 0,
            slackY: 0
          };
          var controlled = Boolean(_this.props.position);
          if (controlled) {
            var _this$props$position = _this.props.position, _x2 = _this$props$position.x, _y2 = _this$props$position.y;
            newState.x = _x2;
            newState.y = _y2;
          }
          _this.setState(newState);
        };
        _this.state = {
          // Whether or not we are currently dragging.
          dragging: false,
          // Whether or not we have been dragged before.
          dragged: false,
          // Current transform x and y.
          x: props.position ? props.position.x : props.defaultPosition.x,
          y: props.position ? props.position.y : props.defaultPosition.y,
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) {
          console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        }
        return _this;
      }
      createClass(Draggable22, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (typeof window.SVGElement !== "undefined" && ReactDOM2.findDOMNode(this) instanceof window.SVGElement) {
            this.setState({
              isElementSVG: true
            });
          }
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
            this.setState({
              x: nextProps.position.x,
              y: nextProps.position.y
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.setState({
            dragging: false
          });
        }
      }, {
        key: "render",
        value: function render3() {
          var _classNames;
          var style = {}, svgTransform = null;
          var controlled = Boolean(this.props.position);
          var draggable = !controlled || this.state.dragging;
          var position = this.props.position || this.props.defaultPosition;
          var transformOpts = {
            // Set left if horizontal drag is enabled
            x: canDragX2(this) && draggable ? this.state.x : position.x,
            // Set top if vertical drag is enabled
            y: canDragY2(this) && draggable ? this.state.y : position.y
          };
          if (this.state.isElementSVG) {
            svgTransform = createSVGTransform2(transformOpts, this.props.positionOffset);
          } else {
            style = createCSSTransform2(transformOpts, this.props.positionOffset);
          }
          var _props = this.props, defaultClassName = _props.defaultClassName, defaultClassNameDragging = _props.defaultClassNameDragging, defaultClassNameDragged = _props.defaultClassNameDragged;
          var children3 = React2.Children.only(this.props.children);
          var className2 = classnames2(children3.props.className || "", defaultClassName, (_classNames = {}, defineProperty2(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty2(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
          return React2.createElement(DraggableCore2, _extends2({}, this.props, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
          }), React2.cloneElement(children3, {
            className: className2,
            style: _extends2({}, children3.props.style, style),
            transform: svgTransform
          }));
        }
      }]);
      return Draggable22;
    }(React2.Component);
    Draggable2.displayName = "Draggable";
    Draggable2.propTypes = _extends2({}, DraggableCore2.propTypes, {
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: propTypes2.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: propTypes2.oneOfType([propTypes2.shape({
        left: propTypes2.number,
        right: propTypes2.number,
        top: propTypes2.number,
        bottom: propTypes2.number
      }), propTypes2.string, propTypes2.oneOf([false])]),
      defaultClassName: propTypes2.string,
      defaultClassNameDragging: propTypes2.string,
      defaultClassNameDragged: propTypes2.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: propTypes2.shape({
        x: propTypes2.number,
        y: propTypes2.number
      }),
      positionOffset: propTypes2.shape({
        x: propTypes2.oneOfType([propTypes2.number, propTypes2.string]),
        y: propTypes2.oneOfType([propTypes2.number, propTypes2.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: propTypes2.shape({
        x: propTypes2.number,
        y: propTypes2.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: dontSetMe2,
      style: dontSetMe2,
      transform: dontSetMe2
    });
    Draggable2.defaultProps = _extends2({}, DraggableCore2.defaultProps, {
      axis: "both",
      bounds: false,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      position: null,
      scale: 1
    });
    Draggable2.default = Draggable2;
    Draggable2.DraggableCore = DraggableCore2;
    return Draggable2;
  });
})(reactDraggable);
var reactDraggableExports = reactDraggable.exports;
var reactResizable = { exports: {} };
var Resizable$1 = {};
var cjs$3 = { exports: {} };
var Draggable$1 = {};
function r(e) {
  var t, f2, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f2 = r(e[t])) && (n && (n += " "), n += f2);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f2 = 0, n = ""; f2 < arguments.length; )
    (e = arguments[f2++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const clsx_m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx,
  default: clsx
}, Symbol.toStringTag, { value: "Module" }));
const require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(clsx_m);
var domFns = {};
var shims = {};
Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction$3;
shims.isNum = isNum;
function findInArray(array2, callback) {
  for (let i = 0, length2 = array2.length; i < length2; i++) {
    if (callback.apply(callback, [array2[i], i, array2]))
      return array2[i];
  }
}
function isFunction$3(func) {
  return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function isNum(num) {
  return typeof num === "number" && !isNaN(num);
}
function int(a) {
  return parseInt(a, 10);
}
function dontSetMe(props, propName, componentName) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
var getPrefix$1 = {};
Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
const prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix() {
  var _window$document;
  let prop2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window === "undefined")
    return "";
  const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
  if (!style)
    return "";
  if (prop2 in style)
    return "";
  for (let i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop2, prefixes[i]) in style)
      return prefixes[i];
  }
  return "";
}
function browserPrefixToKey(prop2, prefix2) {
  return prefix2 ? "".concat(prefix2).concat(kebabToTitleCase(prop2)) : prop2;
}
function browserPrefixToStyle(prop2, prefix2) {
  return prefix2 ? "-".concat(prefix2.toLowerCase(), "-").concat(prop2) : prop2;
}
function kebabToTitleCase(str) {
  let out = "";
  let shouldCapitalize = true;
  for (let i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === "-") {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}
getPrefix$1.default = getPrefix();
Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$3(getPrefix$1);
function _getRequireWildcardCache$2(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$2 = function(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$3(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache2 = _getRequireWildcardCache$2(nodeInterop);
  if (cache2 && cache2.has(obj)) {
    return cache2.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache2) {
    cache2.set(obj, newObj);
  }
  return newObj;
}
let matchesSelectorFunc = "";
function matchesSelector(el, selector2) {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
      return (0, _shims$2.isFunction)(el[method]);
    });
  }
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc]))
    return false;
  return el[matchesSelectorFunc](selector2);
}
function matchesSelectorAndParentsTo(el, selector2, baseNode) {
  let node2 = el;
  do {
    if (matchesSelector(node2, selector2))
      return true;
    if (node2 === baseNode)
      return false;
    node2 = node2.parentNode;
  } while (node2);
  return false;
}
function addEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  const options2 = {
    capture: true,
    ...inputOptions
  };
  if (el.addEventListener) {
    el.addEventListener(event, handler, options2);
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, handler);
  } else {
    el["on" + event] = handler;
  }
}
function removeEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  const options2 = {
    capture: true,
    ...inputOptions
  };
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options2);
  } else if (el.detachEvent) {
    el.detachEvent("on" + event, handler);
  } else {
    el["on" + event] = null;
  }
}
function outerHeight(node2) {
  let height2 = node2.clientHeight;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  height2 += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height2 += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height2;
}
function outerWidth(node2) {
  let width = node2.clientWidth;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node2) {
  let height2 = node2.clientHeight;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  height2 -= (0, _shims$2.int)(computedStyle.paddingTop);
  height2 -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height2;
}
function innerWidth(node2) {
  let width = node2.clientWidth;
  const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
function offsetXYFromParent(evt, offsetParent, scale) {
  const isBody = offsetParent === offsetParent.ownerDocument.body;
  const offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x,
    y
  };
}
function createCSSTransform(controlPos, positionOffset) {
  const translation = getTranslation(controlPos, positionOffset, "px");
  return {
    [(0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default)]: translation
  };
}
function createSVGTransform(controlPos, positionOffset) {
  const translation = getTranslation(controlPos, positionOffset, "");
  return translation;
}
function getTranslation(_ref, positionOffset, unitSuffix) {
  let {
    x,
    y
  } = _ref;
  let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
  if (positionOffset) {
    const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
    const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e, identifier) {
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, (t) => identifier === t.identifier) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, (t) => identifier === t.identifier);
}
function getTouchIdentifier(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function addUserSelectStyles(doc) {
  if (!doc)
    return;
  let styleEl = doc.getElementById("react-draggable-style-el");
  if (!styleEl) {
    styleEl = doc.createElement("style");
    styleEl.type = "text/css";
    styleEl.id = "react-draggable-style-el";
    styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
    styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
    doc.getElementsByTagName("head")[0].appendChild(styleEl);
  }
  if (doc.body)
    addClassName(doc.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(doc) {
  if (!doc)
    return;
  try {
    if (doc.body)
      removeClassName(doc.body, "react-draggable-transparent-selection");
    if (doc.selection) {
      doc.selection.empty();
    } else {
      const selection2 = (doc.defaultView || window).getSelection();
      if (selection2 && selection2.type !== "Caret") {
        selection2.removeAllRanges();
      }
    }
  } catch (e) {
  }
}
function addClassName(el, className2) {
  if (el.classList) {
    el.classList.add(className2);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className2, "(?!\\S)")))) {
      el.className += " ".concat(className2);
    }
  }
}
function removeClassName(el, className2) {
  if (el.classList) {
    el.classList.remove(className2);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className2, "(?!\\S)"), "g"), "");
  }
}
var positionFns = {};
Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
function getBoundPosition(draggable, x, y) {
  if (!draggable.props.bounds)
    return [x, y];
  let {
    bounds: bounds2
  } = draggable.props;
  bounds2 = typeof bounds2 === "string" ? bounds2 : cloneBounds(bounds2);
  const node2 = findDOMNode(draggable);
  if (typeof bounds2 === "string") {
    const {
      ownerDocument
    } = node2;
    const ownerWindow = ownerDocument.defaultView;
    let boundNode;
    if (bounds2 === "parent") {
      boundNode = node2.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds2);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds2 + '" could not find an element.');
    }
    const boundNodeEl = boundNode;
    const nodeStyle = ownerWindow.getComputedStyle(node2);
    const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    bounds2 = {
      left: -node2.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node2.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node2) - node2.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node2) - node2.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }
  if ((0, _shims$1.isNum)(bounds2.right))
    x = Math.min(x, bounds2.right);
  if ((0, _shims$1.isNum)(bounds2.bottom))
    y = Math.min(y, bounds2.bottom);
  if ((0, _shims$1.isNum)(bounds2.left))
    x = Math.max(x, bounds2.left);
  if ((0, _shims$1.isNum)(bounds2.top))
    y = Math.max(y, bounds2.top);
  return [x, y];
}
function snapToGrid(grid, pendingX, pendingY) {
  const x = Math.round(pendingX / grid[0]) * grid[0];
  const y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}
function canDragX(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function canDragY(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function getControlPosition(e, touchIdentifier, draggableCore) {
  const touchObj = typeof touchIdentifier === "number" ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === "number" && !touchObj)
    return null;
  const node2 = findDOMNode(draggableCore);
  const offsetParent = draggableCore.props.offsetParent || node2.offsetParent || node2.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
function createCoreData(draggable, x, y) {
  const isStart = !(0, _shims$1.isNum)(draggable.lastX);
  const node2 = findDOMNode(draggable);
  if (isStart) {
    return {
      node: node2,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x,
      y
    };
  } else {
    return {
      node: node2,
      deltaX: x - draggable.lastX,
      deltaY: y - draggable.lastY,
      lastX: draggable.lastX,
      lastY: draggable.lastY,
      x,
      y
    };
  }
}
function createDraggableData(draggable, coreData) {
  const scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}
function cloneBounds(bounds2) {
  return {
    left: bounds2.left,
    top: bounds2.top,
    right: bounds2.right,
    bottom: bounds2.bottom
  };
}
function findDOMNode(draggable) {
  const node2 = draggable.findDOMNode();
  if (!node2) {
    throw new Error("<DraggableCore>: Unmounted during event!");
  }
  return node2;
}
var DraggableCore$2 = {};
var log$2 = {};
Object.defineProperty(log$2, "__esModule", {
  value: true
});
log$2.default = log$1;
function log$1() {
}
function _classCallCheck$1S(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1C(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey2(descriptor.key), descriptor);
  }
}
function _createClass$1M(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1C(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1C(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey2(arg) {
  var key = _toPrimitive2(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive2(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1w(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1h(subClass, superClass);
}
function _setPrototypeOf$1h(o, p) {
  _setPrototypeOf$1h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1h(o, p);
}
function _createSuper$1g(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1g();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1h(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1h(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1w(this, result);
  };
}
function _possibleConstructorReturn$1w(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1j(self2);
}
function _assertThisInitialized$1j(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1g() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1h(o) {
  _getPrototypeOf$1h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1h(o);
}
Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React$2 = _interopRequireWildcard$2(React$3);
var _propTypes$7 = _interopRequireDefault$n(propTypesExports);
var _reactDom$1 = _interopRequireDefault$n(ReactDOM);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault$n(log$2);
function _interopRequireDefault$n(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache$1(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$2(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache2 = _getRequireWildcardCache$1(nodeInterop);
  if (cache2 && cache2.has(obj)) {
    return cache2.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache2) {
    cache2.set(obj, newObj);
  }
  return newObj;
}
function _defineProperty$6(obj, key, value2) {
  key = _toPropertyKey$1C(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _toPropertyKey$1C(arg) {
  var key = _toPrimitive$1C(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1C(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let dragEventFor = eventsFor.mouse;
let DraggableCore$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$1w(DraggableCore2, _React$Component);
  var _super = _createSuper$1g(DraggableCore2);
  function DraggableCore2() {
    var _this;
    _classCallCheck$1S(this, DraggableCore2);
    _this = _super.apply(this, arguments);
    _defineProperty$6(_assertThisInitialized$1j(_this), "dragging", false);
    _defineProperty$6(_assertThisInitialized$1j(_this), "lastX", NaN);
    _defineProperty$6(_assertThisInitialized$1j(_this), "lastY", NaN);
    _defineProperty$6(_assertThisInitialized$1j(_this), "touchIdentifier", null);
    _defineProperty$6(_assertThisInitialized$1j(_this), "mounted", false);
    _defineProperty$6(_assertThisInitialized$1j(_this), "handleDragStart", (e) => {
      _this.props.onMouseDown(e);
      if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0)
        return false;
      const thisNode = _this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error("<DraggableCore> not mounted on DragStart!");
      }
      const {
        ownerDocument
      } = thisNode;
      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }
      if (e.type === "touchstart")
        e.preventDefault();
      const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.touchIdentifier = touchIdentifier;
      const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized$1j(_this));
      if (position == null)
        return;
      const {
        x,
        y
      } = position;
      const coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$1j(_this), x, y);
      (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
      (0, _log.default)("calling", _this.props.onStart);
      const shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false)
        return;
      if (_this.props.enableUserSelectHack)
        (0, _domFns.addUserSelectStyles)(ownerDocument);
      _this.dragging = true;
      _this.lastX = x;
      _this.lastY = y;
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "handleDrag", (e) => {
      const position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _assertThisInitialized$1j(_this));
      if (position == null)
        return;
      let {
        x,
        y
      } = position;
      if (Array.isArray(_this.props.grid)) {
        let deltaX = x - _this.lastX, deltaY = y - _this.lastY;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        if (!deltaX && !deltaY)
          return;
        x = _this.lastX + deltaX, y = _this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$1j(_this), x, y);
      (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
      const shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false) {
        try {
          _this.handleDragStop(new MouseEvent("mouseup"));
        } catch (err2) {
          const event = document.createEvent("MouseEvents");
          event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }
      _this.lastX = x;
      _this.lastY = y;
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "handleDragStop", (e) => {
      if (!_this.dragging)
        return;
      const position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _assertThisInitialized$1j(_this));
      if (position == null)
        return;
      let {
        x,
        y
      } = position;
      if (Array.isArray(_this.props.grid)) {
        let deltaX = x - _this.lastX || 0;
        let deltaY = y - _this.lastY || 0;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        x = _this.lastX + deltaX, y = _this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$1j(_this), x, y);
      const shouldContinue = _this.props.onStop(e, coreEvent);
      if (shouldContinue === false || _this.mounted === false)
        return false;
      const thisNode = _this.findDOMNode();
      if (thisNode) {
        if (_this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
      _this.dragging = false;
      _this.lastX = NaN;
      _this.lastY = NaN;
      if (thisNode) {
        (0, _log.default)("DraggableCore: Removing handlers");
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "onMouseDown", (e) => {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStart(e);
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "onMouseUp", (e) => {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "onTouchStart", (e) => {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });
    _defineProperty$6(_assertThisInitialized$1j(_this), "onTouchEnd", (e) => {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });
    return _this;
  }
  _createClass$1M(DraggableCore2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      const thisNode = this.findDOMNode();
      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      const thisNode = this.findDOMNode();
      if (thisNode) {
        const {
          ownerDocument
        } = thisNode;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
  }, {
    key: "findDOMNode",
    value: function findDOMNode2() {
      var _this$props, _this$props2;
      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom$1.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$2.cloneElement(React$2.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);
  return DraggableCore2;
}(
  React$2.Component
  /*:: <DraggableCoreProps>*/
);
DraggableCore$2.default = DraggableCore$1;
_defineProperty$6(DraggableCore$1, "displayName", "DraggableCore");
_defineProperty$6(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes$7.default.bool,
  children: _propTypes$7.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes$7.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes$7.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(props, propName) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error("Draggable's offsetParent must be a DOM Node.");
    }
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes$7.default.arrayOf(_propTypes$7.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes$7.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes$7.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes$7.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes$7.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes$7.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes$7.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes$7.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes$7.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty$6(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(exports2) {
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey22(descriptor.key), descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _toPropertyKey22(arg) {
    var key = _toPrimitive22(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive22(input, hint) {
    if (typeof input !== "object" || input === null)
      return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object")
        return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass)
      _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
      return call2;
    } else if (call2 !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  Object.defineProperty(exports2, "DraggableCore", {
    enumerable: true,
    get: function() {
      return _DraggableCore.default;
    }
  });
  exports2.default = void 0;
  var React2 = _interopRequireWildcard2(React$3);
  var _propTypes3 = _interopRequireDefault2(propTypesExports);
  var _reactDom3 = _interopRequireDefault2(ReactDOM);
  var _clsx = _interopRequireDefault2(require$$3$1);
  var _domFns2 = domFns;
  var _positionFns2 = positionFns;
  var _shims2 = shims;
  var _DraggableCore = _interopRequireDefault2(DraggableCore$2);
  var _log2 = _interopRequireDefault2(log$2);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _getRequireWildcardCache2(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache2 = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard2(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache2 = _getRequireWildcardCache2(nodeInterop);
    if (cache2 && cache2.has(obj)) {
      return cache2.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache2) {
      cache2.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _defineProperty2(obj, key, value2) {
    key = _toPropertyKey3(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value2,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value2;
    }
    return obj;
  }
  function _toPropertyKey3(arg) {
    var key = _toPrimitive3(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive3(input, hint) {
    if (typeof input !== "object" || input === null)
      return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object")
        return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  let Draggable2 = /* @__PURE__ */ function(_React$Component) {
    _inherits2(Draggable3, _React$Component);
    var _super = _createSuper2(Draggable3);
    function Draggable3(props) {
      var _this;
      _classCallCheck2(this, Draggable3);
      _this = _super.call(this, props);
      _defineProperty2(_assertThisInitialized2(_this), "onDragStart", (e, coreData) => {
        (0, _log2.default)("Draggable: onDragStart: %j", coreData);
        const shouldStart = _this.props.onStart(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldStart === false)
          return false;
        _this.setState({
          dragging: true,
          dragged: true
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDrag", (e, coreData) => {
        if (!_this.state.dragging)
          return false;
        (0, _log2.default)("Draggable: onDrag: %j", coreData);
        const uiData = (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData);
        const newState = {
          x: uiData.x,
          y: uiData.y,
          slackX: 0,
          slackY: 0
        };
        if (_this.props.bounds) {
          const {
            x,
            y
          } = newState;
          newState.x += _this.state.slackX;
          newState.y += _this.state.slackY;
          const [newStateX, newStateY] = (0, _positionFns2.getBoundPosition)(_assertThisInitialized2(_this), newState.x, newState.y);
          newState.x = newStateX;
          newState.y = newStateY;
          newState.slackX = _this.state.slackX + (x - newState.x);
          newState.slackY = _this.state.slackY + (y - newState.y);
          uiData.x = newState.x;
          uiData.y = newState.y;
          uiData.deltaX = newState.x - _this.state.x;
          uiData.deltaY = newState.y - _this.state.y;
        }
        const shouldUpdate = _this.props.onDrag(e, uiData);
        if (shouldUpdate === false)
          return false;
        _this.setState(newState);
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDragStop", (e, coreData) => {
        if (!_this.state.dragging)
          return false;
        const shouldContinue = _this.props.onStop(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldContinue === false)
          return false;
        (0, _log2.default)("Draggable: onDragStop: %j", coreData);
        const newState = {
          dragging: false,
          slackX: 0,
          slackY: 0
        };
        const controlled = Boolean(_this.props.position);
        if (controlled) {
          const {
            x,
            y
          } = _this.props.position;
          newState.x = x;
          newState.y = y;
        }
        _this.setState(newState);
      });
      _this.state = {
        // Whether or not we are currently dragging.
        dragging: false,
        // Whether or not we have been dragged before.
        dragged: false,
        // Current transform x and y.
        x: props.position ? props.position.x : props.defaultPosition.x,
        y: props.position ? props.position.y : props.defaultPosition.y,
        prevPropsPosition: {
          ...props.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: false
      };
      if (props.position && !(props.onDrag || props.onStop)) {
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      return _this;
    }
    _createClass2(Draggable3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) {
          this.setState({
            isElementSVG: true
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.setState({
          dragging: false
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function findDOMNode2() {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom3.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function render3() {
        const {
          axis: axis2,
          bounds: bounds2,
          children: children3,
          defaultPosition,
          defaultClassName,
          defaultClassNameDragging,
          defaultClassNameDragged,
          position,
          positionOffset,
          scale,
          ...draggableCoreProps
        } = this.props;
        let style = {};
        let svgTransform = null;
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
          // Set left if horizontal drag is enabled
          x: (0, _positionFns2.canDragX)(this) && draggable ? this.state.x : validPosition.x,
          // Set top if vertical drag is enabled
          y: (0, _positionFns2.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) {
          svgTransform = (0, _domFns2.createSVGTransform)(transformOpts, positionOffset);
        } else {
          style = (0, _domFns2.createCSSTransform)(transformOpts, positionOffset);
        }
        const className2 = (0, _clsx.default)(children3.props.className || "", defaultClassName, {
          [defaultClassNameDragging]: this.state.dragging,
          [defaultClassNameDragged]: this.state.dragged
        });
        return /* @__PURE__ */ React2.createElement(_DraggableCore.default, _extends2({}, draggableCoreProps, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ React2.cloneElement(React2.Children.only(children3), {
          className: className2,
          style: {
            ...children3.props.style,
            ...style
          },
          transform: svgTransform
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: (
        // React 16.3+
        // Arity (props, state)
        function getDerivedStateFromProps(_ref, _ref2) {
          let {
            position
          } = _ref;
          let {
            prevPropsPosition
          } = _ref2;
          if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, _log2.default)("Draggable: getDerivedStateFromProps %j", {
              position,
              prevPropsPosition
            });
            return {
              x: position.x,
              y: position.y,
              prevPropsPosition: {
                ...position
              }
            };
          }
          return null;
        }
      )
    }]);
    return Draggable3;
  }(
    React2.Component
    /*:: <DraggableProps, DraggableState>*/
  );
  exports2.default = Draggable2;
  _defineProperty2(Draggable2, "displayName", "Draggable");
  _defineProperty2(Draggable2, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ..._DraggableCore.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: _propTypes3.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: _propTypes3.default.oneOfType([_propTypes3.default.shape({
      left: _propTypes3.default.number,
      right: _propTypes3.default.number,
      top: _propTypes3.default.number,
      bottom: _propTypes3.default.number
    }), _propTypes3.default.string, _propTypes3.default.oneOf([false])]),
    defaultClassName: _propTypes3.default.string,
    defaultClassNameDragging: _propTypes3.default.string,
    defaultClassNameDragged: _propTypes3.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    positionOffset: _propTypes3.default.shape({
      x: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string]),
      y: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: _shims2.dontSetMe,
    style: _shims2.dontSetMe,
    transform: _shims2.dontSetMe
  });
  _defineProperty2(Draggable2, "defaultProps", {
    ..._DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(Draggable$1);
const {
  default: Draggable,
  DraggableCore
} = Draggable$1;
cjs$3.exports = Draggable;
cjs$3.exports.default = Draggable;
cjs$3.exports.DraggableCore = DraggableCore;
var cjsExports = cjs$3.exports;
var utils$9 = {};
utils$9.__esModule = true;
utils$9.cloneElement = cloneElement;
var _react$a = _interopRequireDefault$m(React$3);
function _interopRequireDefault$m(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys$2(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$5(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = _objectSpread$3(_objectSpread$3({}, element.props.style), props.style);
  }
  if (props.className && element.props.className) {
    props.className = element.props.className + " " + props.className;
  }
  return /* @__PURE__ */ _react$a.default.cloneElement(element, props);
}
var propTypes$2 = {};
propTypes$2.__esModule = true;
propTypes$2.resizableProps = void 0;
var _propTypes$6 = _interopRequireDefault$l(propTypesExports);
function _interopRequireDefault$l(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var resizableProps = {
  /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */
  axis: _propTypes$6.default.oneOf(["both", "x", "y", "none"]),
  className: _propTypes$6.default.string,
  /*
  * Require that one and only one child be present.
  * */
  children: _propTypes$6.default.element.isRequired,
  /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */
  draggableOpts: _propTypes$6.default.shape({
    allowAnyClick: _propTypes$6.default.bool,
    cancel: _propTypes$6.default.string,
    children: _propTypes$6.default.node,
    disabled: _propTypes$6.default.bool,
    enableUserSelectHack: _propTypes$6.default.bool,
    offsetParent: _propTypes$6.default.node,
    grid: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
    handle: _propTypes$6.default.string,
    nodeRef: _propTypes$6.default.object,
    onStart: _propTypes$6.default.func,
    onDrag: _propTypes$6.default.func,
    onStop: _propTypes$6.default.func,
    onMouseDown: _propTypes$6.default.func,
    scale: _propTypes$6.default.number
  }),
  /*
  * Initial height
  * */
  height: _propTypes$6.default.number.isRequired,
  /*
  * Customize cursor resize handle
  * */
  handle: _propTypes$6.default.oneOfType([_propTypes$6.default.node, _propTypes$6.default.func]),
  /*
  * If you change this, be sure to update your css
  * */
  handleSize: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  lockAspectRatio: _propTypes$6.default.bool,
  /*
  * Max X & Y measure
  * */
  maxConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  /*
  * Min X & Y measure
  * */
  minConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  /*
  * Called on stop resize event
  * */
  onResizeStop: _propTypes$6.default.func,
  /*
  * Called on start resize event
  * */
  onResizeStart: _propTypes$6.default.func,
  /*
  * Called on resize event
  * */
  onResize: _propTypes$6.default.func,
  /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */
  resizeHandles: _propTypes$6.default.arrayOf(_propTypes$6.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */
  transformScale: _propTypes$6.default.number,
  /*
   * Initial width
   */
  width: _propTypes$6.default.number.isRequired
};
propTypes$2.resizableProps = resizableProps;
Resizable$1.__esModule = true;
Resizable$1.default = void 0;
var _react$9 = _interopRequireDefault$k(React$3);
var _reactDraggable$1 = cjsExports;
var _utils$4 = utils$9;
var _propTypes$5 = propTypes$2;
function _interopRequireDefault$k(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends$t() {
  _extends$t = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$t.apply(this, arguments);
}
function ownKeys$1(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized$1i(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$4(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var Resizable = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$1(Resizable2, _React$Component);
  function Resizable2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty$4(_assertThisInitialized$1i(_this), "state", void 0);
    _defineProperty$4(_assertThisInitialized$1i(_this), "lastHandleRect", null);
    _defineProperty$4(_assertThisInitialized$1i(_this), "slack", null);
    return _this;
  }
  var _proto = Resizable2.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.resetData();
  };
  _proto.lockAspectRatio = function lockAspectRatio(width, height2, aspectRatio) {
    height2 = width / aspectRatio;
    width = height2 * aspectRatio;
    return [width, height2];
  };
  _proto.resetData = function resetData() {
    this.lastHandleRect = this.slack = null;
  };
  _proto.runConstraints = function runConstraints(width, height2) {
    var _ref = [this.props.minConstraints, this.props.maxConstraints], min2 = _ref[0], max2 = _ref[1];
    if (!min2 && !max2)
      return [width, height2];
    if (this.props.lockAspectRatio) {
      var resizingHorizontally = height2 === this.props.height;
      if (resizingHorizontally) {
        var ratio = this.props.width / this.props.height;
        height2 = width / ratio;
        width = height2 * ratio;
      } else {
        var _ratio = this.props.height / this.props.width;
        width = height2 / _ratio;
        height2 = width * _ratio;
      }
    }
    var oldW = width, oldH = height2;
    var _ref2 = this.slack || [0, 0], slackW = _ref2[0], slackH = _ref2[1];
    width += slackW;
    height2 += slackH;
    if (min2) {
      width = Math.max(min2[0], width);
      height2 = Math.max(min2[1], height2);
    }
    if (max2) {
      width = Math.min(max2[0], width);
      height2 = Math.min(max2[1], height2);
    }
    this.slack = [slackW + (oldW - width), slackH + (oldH - height2)];
    return [width, height2];
  };
  _proto.resizeHandler = function resizeHandler(handlerName, axis2) {
    var _this2 = this;
    return function(e, _ref3) {
      var node2 = _ref3.node, deltaX = _ref3.deltaX, deltaY = _ref3.deltaY;
      if (handlerName === "onResizeStart")
        _this2.resetData();
      var canDragX2 = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis2 !== "n" && axis2 !== "s";
      var canDragY2 = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis2 !== "e" && axis2 !== "w";
      if (!canDragX2 && !canDragY2)
        return;
      var axisV = axis2[0];
      var axisH = axis2[axis2.length - 1];
      var handleRect = node2.getBoundingClientRect();
      if (_this2.lastHandleRect != null) {
        if (axisH === "w") {
          var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
          deltaX += deltaLeftSinceLast;
        }
        if (axisV === "n") {
          var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
          deltaY += deltaTopSinceLast;
        }
      }
      _this2.lastHandleRect = handleRect;
      if (axisH === "w")
        deltaX = -deltaX;
      if (axisV === "n")
        deltaY = -deltaY;
      var width = _this2.props.width + (canDragX2 ? deltaX / _this2.props.transformScale : 0);
      var height2 = _this2.props.height + (canDragY2 ? deltaY / _this2.props.transformScale : 0);
      var _this2$runConstraints = _this2.runConstraints(width, height2);
      width = _this2$runConstraints[0];
      height2 = _this2$runConstraints[1];
      var dimensionsChanged = width !== _this2.props.width || height2 !== _this2.props.height;
      var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
      var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
      if (cb && !shouldSkipCb) {
        if (typeof e.persist === "function")
          e.persist();
        cb(e, {
          node: node2,
          size: {
            width,
            height: height2
          },
          handle: axis2
        });
      }
      if (handlerName === "onResizeStop")
        _this2.resetData();
    };
  };
  _proto.renderResizeHandle = function renderResizeHandle(resizeHandleAxis) {
    var handle = this.props.handle;
    if (handle) {
      if (typeof handle === "function") {
        return handle(resizeHandleAxis);
      }
      return handle;
    }
    return /* @__PURE__ */ _react$9.default.createElement("span", {
      className: "react-resizable-handle react-resizable-handle-" + resizeHandleAxis
    });
  };
  _proto.render = function render3() {
    var _this3 = this;
    var _this$props = this.props, children3 = _this$props.children, className2 = _this$props.className, draggableOpts = _this$props.draggableOpts;
    _this$props.width;
    _this$props.height;
    _this$props.handle;
    _this$props.handleSize;
    _this$props.lockAspectRatio;
    _this$props.axis;
    _this$props.minConstraints;
    _this$props.maxConstraints;
    _this$props.onResize;
    _this$props.onResizeStop;
    _this$props.onResizeStart;
    var resizeHandles = _this$props.resizeHandles;
    _this$props.transformScale;
    var p = _objectWithoutPropertiesLoose$1(_this$props, ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"]);
    return (0, _utils$4.cloneElement)(children3, _objectSpread$2(_objectSpread$2({}, p), {}, {
      className: (className2 ? className2 + " " : "") + "react-resizable",
      children: [].concat(children3.props.children, resizeHandles.map(function(handleAxis) {
        return /* @__PURE__ */ _react$9.default.createElement(_reactDraggable$1.DraggableCore, _extends$t({}, draggableOpts, {
          key: "resizableHandle-" + handleAxis,
          onStop: _this3.resizeHandler("onResizeStop", handleAxis),
          onStart: _this3.resizeHandler("onResizeStart", handleAxis),
          onDrag: _this3.resizeHandler("onResize", handleAxis)
        }), _this3.renderResizeHandle(handleAxis));
      }))
    }));
  };
  return Resizable2;
}(_react$9.default.Component);
Resizable$1.default = Resizable;
_defineProperty$4(Resizable, "propTypes", _propTypes$5.resizableProps);
_defineProperty$4(Resizable, "defaultProps", {
  handleSize: [20, 20],
  lockAspectRatio: false,
  axis: "both",
  minConstraints: [20, 20],
  maxConstraints: [Infinity, Infinity],
  resizeHandles: ["se"],
  transformScale: 1
});
var ResizableBox$1 = {};
ResizableBox$1.__esModule = true;
ResizableBox$1.default = void 0;
var React$1 = _interopRequireWildcard$1(React$3);
var _propTypes$4 = _interopRequireDefault$j(propTypesExports);
var _Resizable = _interopRequireDefault$j(Resizable$1);
var _propTypes2$4 = propTypes$2;
function _interopRequireDefault$j(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function")
    return null;
  var cache2 = /* @__PURE__ */ new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache2() {
    return cache2;
  };
  return cache2;
}
function _interopRequireWildcard$1(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache2 = _getRequireWildcardCache();
  if (cache2 && cache2.has(obj)) {
    return cache2.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache2) {
    cache2.set(obj, newObj);
  }
  return newObj;
}
function _extends$s() {
  _extends$s = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$s.apply(this, arguments);
}
function ownKeys(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized$1h(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$3(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var ResizableBox = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(ResizableBox2, _React$Component);
  function ResizableBox2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty$3(_assertThisInitialized$1h(_this), "state", {
      width: _this.props.width,
      height: _this.props.height,
      propsWidth: _this.props.width,
      propsHeight: _this.props.height
    });
    _defineProperty$3(_assertThisInitialized$1h(_this), "onResize", function(e, data2) {
      var size = data2.size;
      if (_this.props.onResize) {
        e.persist && e.persist();
        _this.setState(size, function() {
          return _this.props.onResize && _this.props.onResize(e, data2);
        });
      } else {
        _this.setState(size);
      }
    });
    return _this;
  }
  ResizableBox2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
      return {
        width: props.width,
        height: props.height,
        propsWidth: props.width,
        propsHeight: props.height
      };
    }
    return null;
  };
  var _proto = ResizableBox2.prototype;
  _proto.render = function render3() {
    var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize;
    _this$props.onResize;
    var onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis2 = _this$props.axis;
    _this$props.width;
    _this$props.height;
    var resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose(_this$props, ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"]);
    return /* @__PURE__ */ React$1.createElement(_Resizable.default, {
      axis: axis2,
      draggableOpts,
      handle,
      handleSize,
      height: this.state.height,
      lockAspectRatio,
      maxConstraints,
      minConstraints,
      onResizeStart,
      onResize: this.onResize,
      onResizeStop,
      resizeHandles,
      transformScale,
      width: this.state.width
    }, /* @__PURE__ */ React$1.createElement("div", _extends$s({}, props, {
      style: _objectSpread$1(_objectSpread$1({}, style), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  };
  return ResizableBox2;
}(React$1.Component);
ResizableBox$1.default = ResizableBox;
_defineProperty$3(ResizableBox, "propTypes", _objectSpread$1(_objectSpread$1({}, _propTypes2$4.resizableProps), {}, {
  children: _propTypes$4.default.element
}));
reactResizable.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
reactResizable.exports.Resizable = Resizable$1.default;
reactResizable.exports.ResizableBox = ResizableBox$1.default;
var reactResizableExports = reactResizable.exports;
GridItem$1.__esModule = true;
var _extends$r = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$8 = React$3;
var _react2$7 = _interopRequireDefault$i(_react$8);
var _propTypes$3 = propTypesExports;
var _propTypes2$3 = _interopRequireDefault$i(_propTypes$3);
var _reactDraggable = reactDraggableExports;
var _reactResizable = reactResizableExports;
var _utils$3 = utils$a;
var _classnames$1 = classnamesExports;
var _classnames2$1 = _interopRequireDefault$i(_classnames$1);
function _interopRequireDefault$i(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$1R(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1v(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1v(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var GridItem = function(_React$Component) {
  _inherits$1v(GridItem2, _React$Component);
  function GridItem2() {
    var _temp, _this, _ret;
    _classCallCheck$1R(this, GridItem2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$1v(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      resizing: null,
      dragging: null,
      className: ""
    }, _temp), _possibleConstructorReturn$1v(_this, _ret);
  }
  GridItem2.prototype.calcColWidth = function calcColWidth() {
    var _props = this.props, margin = _props.margin, containerPadding = _props.containerPadding, containerWidth = _props.containerWidth, cols = _props.cols;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
  };
  GridItem2.prototype.calcPosition = function calcPosition(x, y, w, h, state) {
    var _props2 = this.props, margin = _props2.margin, containerPadding = _props2.containerPadding, rowHeight = _props2.rowHeight;
    var colWidth = this.calcColWidth();
    var out = {
      left: Math.round((colWidth + margin[0]) * x + containerPadding[0]),
      top: Math.round((rowHeight + margin[1]) * y + containerPadding[1]),
      // 0 * Infinity === NaN, which causes problems with resize constraints;
      // Fix this if it occurs.
      // Note we do it here rather than later because Math.round(Infinity) causes deopt
      width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * margin[0]),
      height: h === Infinity ? h : Math.round(rowHeight * h + Math.max(0, h - 1) * margin[1])
    };
    if (state && state.resizing) {
      out.width = Math.round(state.resizing.width);
      out.height = Math.round(state.resizing.height);
    }
    if (state && state.dragging) {
      out.top = Math.round(state.dragging.top);
      out.left = Math.round(state.dragging.left);
    }
    return out;
  };
  GridItem2.prototype.calcXY = function calcXY(top2, left2) {
    var _props3 = this.props, margin = _props3.margin, cols = _props3.cols, rowHeight = _props3.rowHeight, w = _props3.w, h = _props3.h, maxRows = _props3.maxRows;
    var colWidth = this.calcColWidth();
    var x = Math.round((left2 - margin[0]) / (colWidth + margin[0]));
    var y = Math.round((top2 - margin[1]) / (rowHeight + margin[1]));
    x = Math.max(Math.min(x, cols - w), 0);
    y = Math.max(Math.min(y, maxRows - h), 0);
    return {
      x,
      y
    };
  };
  GridItem2.prototype.calcWH = function calcWH(_ref) {
    var height2 = _ref.height, width = _ref.width;
    var _props4 = this.props, margin = _props4.margin, maxRows = _props4.maxRows, cols = _props4.cols, rowHeight = _props4.rowHeight, x = _props4.x, y = _props4.y;
    var colWidth = this.calcColWidth();
    var w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    var h = Math.round((height2 + margin[1]) / (rowHeight + margin[1]));
    w = Math.max(Math.min(w, cols - x), 0);
    h = Math.max(Math.min(h, maxRows - y), 0);
    return {
      w,
      h
    };
  };
  GridItem2.prototype.createStyle = function createStyle(pos) {
    var _props5 = this.props, usePercentages = _props5.usePercentages, containerWidth = _props5.containerWidth, useCSSTransforms = _props5.useCSSTransforms;
    var style = void 0;
    if (useCSSTransforms) {
      style = (0, _utils$3.setTransform)(pos);
    } else {
      style = (0, _utils$3.setTopLeft)(pos);
      if (usePercentages) {
        style.left = (0, _utils$3.perc)(pos.left / containerWidth);
        style.width = (0, _utils$3.perc)(pos.width / containerWidth);
      }
    }
    return style;
  };
  GridItem2.prototype.mixinDraggable = function mixinDraggable(child) {
    return _react2$7.default.createElement(_reactDraggable.DraggableCore, {
      onStart: this.onDragHandler("onDragStart"),
      onDrag: this.onDragHandler("onDrag"),
      onStop: this.onDragHandler("onDragStop"),
      handle: this.props.handle,
      cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : "")
    }, child);
  };
  GridItem2.prototype.mixinResizable = function mixinResizable(child, position) {
    var _props6 = this.props, cols = _props6.cols, x = _props6.x, minW2 = _props6.minW, minH2 = _props6.minH, maxW2 = _props6.maxW, maxH2 = _props6.maxH;
    var maxWidth = this.calcPosition(0, 0, cols - x, 0).width;
    var mins = this.calcPosition(0, 0, minW2, minH2);
    var maxes = this.calcPosition(0, 0, maxW2, maxH2);
    var minConstraints = [mins.width, mins.height];
    var maxConstraints = [Math.min(maxes.width, maxWidth), Math.min(maxes.height, Infinity)];
    return _react2$7.default.createElement(_reactResizable.Resizable, {
      width: position.width,
      height: position.height,
      minConstraints,
      maxConstraints,
      onResizeStop: this.onResizeHandler("onResizeStop"),
      onResizeStart: this.onResizeHandler("onResizeStart"),
      onResize: this.onResizeHandler("onResize")
    }, child);
  };
  GridItem2.prototype.onDragHandler = function onDragHandler(handlerName) {
    var _this2 = this;
    return function(e, _ref2) {
      var node2 = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
      var handler = _this2.props[handlerName];
      if (!handler)
        return;
      var newPosition = {
        top: 0,
        left: 0
      };
      switch (handlerName) {
        case "onDragStart": {
          var offsetParent = node2.offsetParent;
          if (!offsetParent)
            return;
          var parentRect = offsetParent.getBoundingClientRect();
          var clientRect = node2.getBoundingClientRect();
          newPosition.left = clientRect.left - parentRect.left + offsetParent.scrollLeft;
          newPosition.top = clientRect.top - parentRect.top + offsetParent.scrollTop;
          _this2.setState({
            dragging: newPosition
          });
          break;
        }
        case "onDrag":
          if (!_this2.state.dragging)
            throw new Error("onDrag called before onDragStart.");
          newPosition.left = _this2.state.dragging.left + deltaX;
          newPosition.top = _this2.state.dragging.top + deltaY;
          _this2.setState({
            dragging: newPosition
          });
          break;
        case "onDragStop":
          if (!_this2.state.dragging)
            throw new Error("onDragEnd called before onDragStart.");
          newPosition.left = _this2.state.dragging.left;
          newPosition.top = _this2.state.dragging.top;
          _this2.setState({
            dragging: null
          });
          break;
        default:
          throw new Error("onDragHandler called with unrecognized handlerName: " + handlerName);
      }
      var _calcXY = _this2.calcXY(newPosition.top, newPosition.left), x = _calcXY.x, y = _calcXY.y;
      return handler.call(_this2, _this2.props.i, x, y, {
        e,
        node: node2,
        newPosition
      });
    };
  };
  GridItem2.prototype.onResizeHandler = function onResizeHandler(handlerName) {
    var _this3 = this;
    return function(e, _ref3) {
      var node2 = _ref3.node, size = _ref3.size;
      var handler = _this3.props[handlerName];
      if (!handler)
        return;
      var _props7 = _this3.props, cols = _props7.cols, x = _props7.x, i = _props7.i, maxW2 = _props7.maxW, minW2 = _props7.minW, maxH2 = _props7.maxH, minH2 = _props7.minH;
      var _calcWH = _this3.calcWH(size), w = _calcWH.w, h = _calcWH.h;
      w = Math.min(w, cols - x);
      w = Math.max(w, 1);
      w = Math.max(Math.min(w, maxW2), minW2);
      h = Math.max(Math.min(h, maxH2), minH2);
      _this3.setState({
        resizing: handlerName === "onResizeStop" ? null : size
      });
      handler.call(_this3, i, w, h, {
        e,
        node: node2,
        size
      });
    };
  };
  GridItem2.prototype.render = function render3() {
    var _props8 = this.props, x = _props8.x, y = _props8.y, w = _props8.w, h = _props8.h, isDraggable = _props8.isDraggable, isResizable = _props8.isResizable, useCSSTransforms = _props8.useCSSTransforms;
    var pos = this.calcPosition(x, y, w, h, this.state);
    var child = _react2$7.default.Children.only(this.props.children);
    var newChild = _react2$7.default.cloneElement(child, {
      className: (0, _classnames2$1.default)("react-grid-item", child.props.className, this.props.className, {
        static: this.props.static,
        resizing: Boolean(this.state.resizing),
        "react-draggable": isDraggable,
        "react-draggable-dragging": Boolean(this.state.dragging),
        cssTransforms: useCSSTransforms
      }),
      // We can set the width and height on the child, but unfortunately we can't set the position.
      style: _extends$r({}, this.props.style, child.props.style, this.createStyle(pos))
    });
    if (isResizable)
      newChild = this.mixinResizable(newChild, pos);
    if (isDraggable)
      newChild = this.mixinDraggable(newChild);
    return newChild;
  };
  return GridItem2;
}(_react2$7.default.Component);
GridItem.propTypes = {
  // Children must be only a single element
  children: _propTypes2$3.default.element,
  // General grid attributes
  cols: _propTypes2$3.default.number.isRequired,
  containerWidth: _propTypes2$3.default.number.isRequired,
  rowHeight: _propTypes2$3.default.number.isRequired,
  margin: _propTypes2$3.default.array.isRequired,
  maxRows: _propTypes2$3.default.number.isRequired,
  containerPadding: _propTypes2$3.default.array.isRequired,
  // These are all in grid units
  x: _propTypes2$3.default.number.isRequired,
  y: _propTypes2$3.default.number.isRequired,
  w: _propTypes2$3.default.number.isRequired,
  h: _propTypes2$3.default.number.isRequired,
  // All optional
  minW: function minW(props, propName) {
    var value2 = props[propName];
    if (typeof value2 !== "number")
      return new Error("minWidth not Number");
    if (value2 > props.w || value2 > props.maxW)
      return new Error("minWidth larger than item width/maxWidth");
  },
  maxW: function maxW(props, propName) {
    var value2 = props[propName];
    if (typeof value2 !== "number")
      return new Error("maxWidth not Number");
    if (value2 < props.w || value2 < props.minW)
      return new Error("maxWidth smaller than item width/minWidth");
  },
  minH: function minH(props, propName) {
    var value2 = props[propName];
    if (typeof value2 !== "number")
      return new Error("minHeight not Number");
    if (value2 > props.h || value2 > props.maxH)
      return new Error("minHeight larger than item height/maxHeight");
  },
  maxH: function maxH(props, propName) {
    var value2 = props[propName];
    if (typeof value2 !== "number")
      return new Error("maxHeight not Number");
    if (value2 < props.h || value2 < props.minH)
      return new Error("maxHeight smaller than item height/minHeight");
  },
  // ID is nice to have for callbacks
  i: _propTypes2$3.default.string.isRequired,
  // Functions
  onDragStop: _propTypes2$3.default.func,
  onDragStart: _propTypes2$3.default.func,
  onDrag: _propTypes2$3.default.func,
  onResizeStop: _propTypes2$3.default.func,
  onResizeStart: _propTypes2$3.default.func,
  onResize: _propTypes2$3.default.func,
  // Flags
  isDraggable: _propTypes2$3.default.bool.isRequired,
  isResizable: _propTypes2$3.default.bool.isRequired,
  static: _propTypes2$3.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: _propTypes2$3.default.bool.isRequired,
  // Others
  className: _propTypes2$3.default.string,
  // Selector for draggable handle
  handle: _propTypes2$3.default.string,
  // Selector for draggable cancel (see react-draggable)
  cancel: _propTypes2$3.default.string
};
GridItem.defaultProps = {
  className: "",
  cancel: "",
  handle: "",
  minH: 1,
  minW: 1,
  maxH: Infinity,
  maxW: Infinity
};
GridItem$1.default = GridItem;
ReactGridLayout$2.__esModule = true;
var _extends$q = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$7 = React$3;
var _react2$6 = _interopRequireDefault$h(_react$7);
var _propTypes$2 = propTypesExports;
var _propTypes2$2 = _interopRequireDefault$h(_propTypes$2);
var _lodash$2 = lodash_isequalExports;
var _lodash2$2 = _interopRequireDefault$h(_lodash$2);
var _classnames = classnamesExports;
var _classnames2 = _interopRequireDefault$h(_classnames);
var _utils$2 = utils$a;
var _GridItem = GridItem$1;
var _GridItem2 = _interopRequireDefault$h(_GridItem);
function _interopRequireDefault$h(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$1Q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1u(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1u(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ReactGridLayout$1 = function(_React$Component) {
  _inherits$1u(ReactGridLayout2, _React$Component);
  function ReactGridLayout2(props, context) {
    _classCallCheck$1Q(this, ReactGridLayout2);
    var _this = _possibleConstructorReturn$1u(this, _React$Component.call(this, props, context));
    _initialiseProps.call(_this);
    (0, _utils$2.autoBindHandlers)(_this, ["onDragStart", "onDrag", "onDragStop", "onResizeStart", "onResize", "onResizeStop"]);
    return _this;
  }
  ReactGridLayout2.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true
    });
    this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
  };
  ReactGridLayout2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newLayoutBase = void 0;
    if (!(0, _lodash2$2.default)(nextProps.layout, this.props.layout) || nextProps.compactType !== this.props.compactType) {
      newLayoutBase = nextProps.layout;
    } else if (!(0, _utils$2.childrenEqual)(this.props.children, nextProps.children)) {
      newLayoutBase = this.state.layout;
    }
    if (newLayoutBase) {
      var newLayout = (0, _utils$2.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, this.compactType(nextProps));
      var _oldLayout = this.state.layout;
      this.setState({
        layout: newLayout
      });
      this.onLayoutMaybeChanged(newLayout, _oldLayout);
    }
  };
  ReactGridLayout2.prototype.containerHeight = function containerHeight() {
    if (!this.props.autoSize)
      return;
    var nbRow = (0, _utils$2.bottom)(this.state.layout);
    var containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
    return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
  };
  ReactGridLayout2.prototype.compactType = function compactType(props) {
    if (!props)
      props = this.props;
    return props.verticalCompact === false ? null : props.compactType;
  };
  ReactGridLayout2.prototype.onDragStart = function onDragStart(i, x, y, _ref) {
    var e = _ref.e, node2 = _ref.node;
    var layout2 = this.state.layout;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    if (!l)
      return;
    this.setState({
      oldDragItem: (0, _utils$2.cloneLayoutItem)(l),
      oldLayout: this.state.layout
    });
    return this.props.onDragStart(layout2, l, l, null, e, node2);
  };
  ReactGridLayout2.prototype.onDrag = function onDrag(i, x, y, _ref2) {
    var e = _ref2.e, node2 = _ref2.node;
    var oldDragItem = this.state.oldDragItem;
    var layout2 = this.state.layout;
    var cols = this.props.cols;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    if (!l)
      return;
    var placeholder = {
      w: l.w,
      h: l.h,
      x: l.x,
      y: l.y,
      placeholder: true,
      i
    };
    var isUserAction = true;
    layout2 = (0, _utils$2.moveElement)(layout2, l, x, y, isUserAction, this.props.preventCollision, this.compactType(), cols);
    this.props.onDrag(layout2, oldDragItem, l, placeholder, e, node2);
    this.setState({
      layout: (0, _utils$2.compact)(layout2, this.compactType(), cols),
      activeDrag: placeholder
    });
  };
  ReactGridLayout2.prototype.onDragStop = function onDragStop(i, x, y, _ref3) {
    var e = _ref3.e, node2 = _ref3.node;
    var oldDragItem = this.state.oldDragItem;
    var layout2 = this.state.layout;
    var _props = this.props, cols = _props.cols, preventCollision = _props.preventCollision;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    if (!l)
      return;
    var isUserAction = true;
    layout2 = (0, _utils$2.moveElement)(layout2, l, x, y, isUserAction, preventCollision, this.compactType(), cols);
    this.props.onDragStop(layout2, oldDragItem, l, null, e, node2);
    var newLayout = (0, _utils$2.compact)(layout2, this.compactType(), cols);
    var oldLayout = this.state.oldLayout;
    this.setState({
      activeDrag: null,
      layout: newLayout,
      oldDragItem: null,
      oldLayout: null
    });
    this.onLayoutMaybeChanged(newLayout, oldLayout);
  };
  ReactGridLayout2.prototype.onLayoutMaybeChanged = function onLayoutMaybeChanged(newLayout, oldLayout) {
    if (!oldLayout)
      oldLayout = this.state.layout;
    if (!(0, _lodash2$2.default)(oldLayout, newLayout)) {
      this.props.onLayoutChange(newLayout);
    }
  };
  ReactGridLayout2.prototype.onResizeStart = function onResizeStart(i, w, h, _ref4) {
    var e = _ref4.e, node2 = _ref4.node;
    var layout2 = this.state.layout;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    if (!l)
      return;
    this.setState({
      oldResizeItem: (0, _utils$2.cloneLayoutItem)(l),
      oldLayout: this.state.layout
    });
    this.props.onResizeStart(layout2, l, l, null, e, node2);
  };
  ReactGridLayout2.prototype.onResize = function onResize(i, w, h, _ref5) {
    var e = _ref5.e, node2 = _ref5.node;
    var _state = this.state, layout2 = _state.layout, oldResizeItem = _state.oldResizeItem;
    var _props2 = this.props, cols = _props2.cols, preventCollision = _props2.preventCollision;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    if (!l)
      return;
    var hasCollisions = void 0;
    if (preventCollision) {
      var collisions = (0, _utils$2.getAllCollisions)(layout2, _extends$q({}, l, {
        w,
        h
      })).filter(function(layoutItem) {
        return layoutItem.i !== l.i;
      });
      hasCollisions = collisions.length > 0;
      if (hasCollisions) {
        var leastX = Infinity, leastY = Infinity;
        collisions.forEach(function(layoutItem) {
          if (layoutItem.x > l.x)
            leastX = Math.min(leastX, layoutItem.x);
          if (layoutItem.y > l.y)
            leastY = Math.min(leastY, layoutItem.y);
        });
        if (Number.isFinite(leastX))
          l.w = leastX - l.x;
        if (Number.isFinite(leastY))
          l.h = leastY - l.y;
      }
    }
    if (!hasCollisions) {
      l.w = w;
      l.h = h;
    }
    var placeholder = {
      w: l.w,
      h: l.h,
      x: l.x,
      y: l.y,
      static: true,
      i
    };
    this.props.onResize(layout2, oldResizeItem, l, placeholder, e, node2);
    this.setState({
      layout: (0, _utils$2.compact)(layout2, this.compactType(), cols),
      activeDrag: placeholder
    });
  };
  ReactGridLayout2.prototype.onResizeStop = function onResizeStop(i, w, h, _ref6) {
    var e = _ref6.e, node2 = _ref6.node;
    var _state2 = this.state, layout2 = _state2.layout, oldResizeItem = _state2.oldResizeItem;
    var cols = this.props.cols;
    var l = (0, _utils$2.getLayoutItem)(layout2, i);
    this.props.onResizeStop(layout2, oldResizeItem, l, null, e, node2);
    var newLayout = (0, _utils$2.compact)(layout2, this.compactType(), cols);
    var oldLayout = this.state.oldLayout;
    this.setState({
      activeDrag: null,
      layout: newLayout,
      oldResizeItem: null,
      oldLayout: null
    });
    this.onLayoutMaybeChanged(newLayout, oldLayout);
  };
  ReactGridLayout2.prototype.placeholder = function placeholder() {
    var activeDrag = this.state.activeDrag;
    if (!activeDrag)
      return null;
    var _props3 = this.props, width = _props3.width, cols = _props3.cols, margin = _props3.margin, containerPadding = _props3.containerPadding, rowHeight = _props3.rowHeight, maxRows = _props3.maxRows, useCSSTransforms = _props3.useCSSTransforms;
    return _react2$6.default.createElement(_GridItem2.default, {
      w: activeDrag.w,
      h: activeDrag.h,
      x: activeDrag.x,
      y: activeDrag.y,
      i: activeDrag.i,
      className: "react-grid-placeholder",
      containerWidth: width,
      cols,
      margin,
      containerPadding: containerPadding || margin,
      maxRows,
      rowHeight,
      isDraggable: false,
      isResizable: false,
      useCSSTransforms
    }, _react2$6.default.createElement("div", null));
  };
  ReactGridLayout2.prototype.processGridItem = function processGridItem(child) {
    if (!child || !child.key)
      return;
    var l = (0, _utils$2.getLayoutItem)(this.state.layout, String(child.key));
    if (!l)
      return null;
    var _props4 = this.props, width = _props4.width, cols = _props4.cols, margin = _props4.margin, containerPadding = _props4.containerPadding, rowHeight = _props4.rowHeight, maxRows = _props4.maxRows, isDraggable = _props4.isDraggable, isResizable = _props4.isResizable, useCSSTransforms = _props4.useCSSTransforms, draggableCancel = _props4.draggableCancel, draggableHandle = _props4.draggableHandle;
    var mounted = this.state.mounted;
    var draggable = Boolean(!l.static && isDraggable && (l.isDraggable || l.isDraggable == null));
    var resizable = Boolean(!l.static && isResizable && (l.isResizable || l.isResizable == null));
    return _react2$6.default.createElement(_GridItem2.default, {
      containerWidth: width,
      cols,
      margin,
      containerPadding: containerPadding || margin,
      maxRows,
      rowHeight,
      cancel: draggableCancel,
      handle: draggableHandle,
      onDragStop: this.onDragStop,
      onDragStart: this.onDragStart,
      onDrag: this.onDrag,
      onResizeStart: this.onResizeStart,
      onResize: this.onResize,
      onResizeStop: this.onResizeStop,
      isDraggable: draggable,
      isResizable: resizable,
      useCSSTransforms: useCSSTransforms && mounted,
      usePercentages: !mounted,
      w: l.w,
      h: l.h,
      x: l.x,
      y: l.y,
      i: l.i,
      minH: l.minH,
      minW: l.minW,
      maxH: l.maxH,
      maxW: l.maxW,
      "static": l.static
    }, child);
  };
  ReactGridLayout2.prototype.render = function render3() {
    var _this2 = this;
    var _props5 = this.props, className2 = _props5.className, style = _props5.style;
    var mergedClassName = (0, _classnames2.default)("react-grid-layout", className2);
    var mergedStyle = _extends$q({
      height: this.containerHeight()
    }, style);
    return _react2$6.default.createElement("div", {
      className: mergedClassName,
      style: mergedStyle
    }, _react2$6.default.Children.map(this.props.children, function(child) {
      return _this2.processGridItem(child);
    }), this.placeholder());
  };
  return ReactGridLayout2;
}(_react2$6.default.Component);
ReactGridLayout$1.displayName = "ReactGridLayout";
ReactGridLayout$1.propTypes = {
  //
  // Basic props
  //
  className: _propTypes2$2.default.string,
  style: _propTypes2$2.default.object,
  // This can be set explicitly. If it is not set, it will automatically
  // be set to the container width. Note that resizes will *not* cause this to adjust.
  // If you need that behavior, use WidthProvider.
  width: _propTypes2$2.default.number,
  // If true, the container height swells and contracts to fit contents
  autoSize: _propTypes2$2.default.bool,
  // # of cols.
  cols: _propTypes2$2.default.number,
  // A selector that will not be draggable.
  draggableCancel: _propTypes2$2.default.string,
  // A selector for the draggable handler
  draggableHandle: _propTypes2$2.default.string,
  // Deprecated
  verticalCompact: function verticalCompact(props) {
    if (props.verticalCompact === false && false) {
      console.warn(
        // eslint-disable-line no-console
        '`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. Use `compactType`: "horizontal" | "vertical" | null.'
      );
    }
  },
  // Choose vertical or hotizontal compaction
  compactType: _propTypes2$2.default.oneOf(["vertical", "horizontal"]),
  // layout is an array of object with the format:
  // {x: Number, y: Number, w: Number, h: Number, i: String}
  layout: function layout(props) {
    var layout2 = props.layout;
    if (layout2 === void 0)
      return;
    (0, _utils$2.validateLayout)(layout2, "layout");
  },
  //
  // Grid Dimensions
  //
  // Margin between items [x, y] in px
  margin: _propTypes2$2.default.arrayOf(_propTypes2$2.default.number),
  // Padding inside the container [x, y] in px
  containerPadding: _propTypes2$2.default.arrayOf(_propTypes2$2.default.number),
  // Rows have a static height, but you can change this based on breakpoints if you like
  rowHeight: _propTypes2$2.default.number,
  // Default Infinity, but you can specify a max here if you like.
  // Note that this isn't fully fleshed out and won't error if you specify a layout that
  // extends beyond the row capacity. It will, however, not allow users to drag/resize
  // an item past the barrier. They can push items beyond the barrier, though.
  // Intentionally not documented for this reason.
  maxRows: _propTypes2$2.default.number,
  //
  // Flags
  //
  isDraggable: _propTypes2$2.default.bool,
  isResizable: _propTypes2$2.default.bool,
  // If true, grid items won't change position when being dragged over.
  preventCollision: _propTypes2$2.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: _propTypes2$2.default.bool,
  //
  // Callbacks
  //
  // Callback so you can save the layout. Calls after each drag & resize stops.
  onLayoutChange: _propTypes2$2.default.func,
  // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
  // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
  onDragStart: _propTypes2$2.default.func,
  // Calls on each drag movement.
  onDrag: _propTypes2$2.default.func,
  // Calls when drag is complete.
  onDragStop: _propTypes2$2.default.func,
  //Calls when resize starts.
  onResizeStart: _propTypes2$2.default.func,
  // Calls when resize movement happens.
  onResize: _propTypes2$2.default.func,
  // Calls when resize is complete.
  onResizeStop: _propTypes2$2.default.func,
  //
  // Other validations
  //
  // Children must not have duplicate keys.
  children: function children2(props, propName) {
    var children22 = props[propName];
    var keys3 = {};
    _react2$6.default.Children.forEach(children22, function(child) {
      if (keys3[child.key]) {
        throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
      }
      keys3[child.key] = true;
    });
  }
};
ReactGridLayout$1.defaultProps = {
  autoSize: true,
  cols: 12,
  className: "",
  style: {},
  draggableHandle: "",
  draggableCancel: "",
  containerPadding: null,
  rowHeight: 150,
  maxRows: Infinity,
  // infinite vertical growth
  layout: [],
  margin: [10, 10],
  isDraggable: true,
  isResizable: true,
  useCSSTransforms: true,
  verticalCompact: true,
  compactType: "vertical",
  preventCollision: false,
  onLayoutChange: _utils$2.noop,
  onDragStart: _utils$2.noop,
  onDrag: _utils$2.noop,
  onDragStop: _utils$2.noop,
  onResizeStart: _utils$2.noop,
  onResize: _utils$2.noop,
  onResizeStop: _utils$2.noop
};
var _initialiseProps = function _initialiseProps2() {
  this.state = {
    activeDrag: null,
    layout: (0, _utils$2.synchronizeLayoutWithChildren)(
      this.props.layout,
      this.props.children,
      this.props.cols,
      // Legacy support for verticalCompact: false
      this.compactType()
    ),
    mounted: false,
    oldDragItem: null,
    oldLayout: null,
    oldResizeItem: null
  };
};
ReactGridLayout$2.default = ReactGridLayout$1;
var ResponsiveReactGridLayout$1 = {};
var responsiveUtils = {};
responsiveUtils.__esModule = true;
responsiveUtils.getBreakpointFromWidth = getBreakpointFromWidth;
responsiveUtils.getColsFromBreakpoint = getColsFromBreakpoint;
responsiveUtils.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
responsiveUtils.sortBreakpoints = sortBreakpoints;
var _utils$1 = utils$a;
function getBreakpointFromWidth(breakpoints, width) {
  var sorted = sortBreakpoints(breakpoints);
  var matching = sorted[0];
  for (var i = 1, len = sorted.length; i < len; i++) {
    var breakpointName = sorted[i];
    if (width > breakpoints[breakpointName])
      matching = breakpointName;
  }
  return matching;
}
function getColsFromBreakpoint(breakpoint, cols) {
  if (!cols[breakpoint]) {
    throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
  }
  return cols[breakpoint];
}
function findOrGenerateResponsiveLayout(layouts2, breakpoints, breakpoint, lastBreakpoint, cols, compactType) {
  if (layouts2[breakpoint])
    return (0, _utils$1.cloneLayout)(layouts2[breakpoint]);
  var layout2 = layouts2[lastBreakpoint];
  var breakpointsSorted = sortBreakpoints(breakpoints);
  var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
  for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
    var b = breakpointsAbove[i];
    if (layouts2[b]) {
      layout2 = layouts2[b];
      break;
    }
  }
  layout2 = (0, _utils$1.cloneLayout)(layout2 || []);
  return (0, _utils$1.compact)((0, _utils$1.correctBounds)(layout2, {
    cols
  }), compactType, cols);
}
function sortBreakpoints(breakpoints) {
  var keys3 = Object.keys(breakpoints);
  return keys3.sort(function(a, b) {
    return breakpoints[a] - breakpoints[b];
  });
}
ResponsiveReactGridLayout$1.__esModule = true;
var _extends$p = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$6 = React$3;
var _react2$5 = _interopRequireDefault$g(_react$6);
var _propTypes$1 = propTypesExports;
var _propTypes2$1 = _interopRequireDefault$g(_propTypes$1);
var _lodash$1 = lodash_isequalExports;
var _lodash2$1 = _interopRequireDefault$g(_lodash$1);
var _utils = utils$a;
var _responsiveUtils = responsiveUtils;
var _ReactGridLayout = ReactGridLayout$2;
var _ReactGridLayout2 = _interopRequireDefault$g(_ReactGridLayout);
function _interopRequireDefault$g(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties$4(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$1P(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1t(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1t(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var type$5 = function type(obj) {
  return Object.prototype.toString.call(obj);
};
var ResponsiveReactGridLayout = function(_React$Component) {
  _inherits$1t(ResponsiveReactGridLayout2, _React$Component);
  function ResponsiveReactGridLayout2() {
    var _temp, _this, _ret;
    _classCallCheck$1P(this, ResponsiveReactGridLayout2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$1t(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = _this.generateInitialState(), _this.onLayoutChange = function(layout2) {
      var _extends2;
      _this.props.onLayoutChange(layout2, _extends$p({}, _this.props.layouts, (_extends2 = {}, _extends2[_this.state.breakpoint] = layout2, _extends2)));
    }, _temp), _possibleConstructorReturn$1t(_this, _ret);
  }
  ResponsiveReactGridLayout2.prototype.generateInitialState = function generateInitialState() {
    var _props = this.props, width = _props.width, breakpoints = _props.breakpoints, layouts2 = _props.layouts, cols = _props.cols;
    var breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width);
    var colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols);
    var compactType = this.props.verticalCompact === false ? null : this.props.compactType;
    var initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts2, breakpoints, breakpoint, breakpoint, colNo, compactType);
    return {
      layout: initialLayout,
      breakpoint,
      cols: colNo
    };
  };
  ResponsiveReactGridLayout2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.width != this.props.width || nextProps.breakpoint !== this.props.breakpoint || !(0, _lodash2$1.default)(nextProps.breakpoints, this.props.breakpoints) || !(0, _lodash2$1.default)(nextProps.cols, this.props.cols)) {
      this.onWidthChange(nextProps);
    } else if (!(0, _lodash2$1.default)(nextProps.layouts, this.props.layouts)) {
      var _state = this.state, _breakpoint = _state.breakpoint, _cols = _state.cols;
      var newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, _breakpoint, _breakpoint, _cols, nextProps.compactType);
      this.setState({
        layout: newLayout
      });
    }
  };
  ResponsiveReactGridLayout2.prototype.onWidthChange = function onWidthChange(nextProps) {
    var breakpoints = nextProps.breakpoints, cols = nextProps.cols, layouts2 = nextProps.layouts, compactType = nextProps.compactType;
    var newBreakpoint = nextProps.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(nextProps.breakpoints, nextProps.width);
    var lastBreakpoint = this.state.breakpoint;
    if (lastBreakpoint !== newBreakpoint || this.props.breakpoints !== breakpoints || this.props.cols !== cols) {
      if (!(lastBreakpoint in layouts2))
        layouts2[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout);
      var newCols = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
      var _layout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts2, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
      _layout = (0, _utils.synchronizeLayoutWithChildren)(_layout, nextProps.children, newCols, compactType);
      layouts2[newBreakpoint] = _layout;
      this.props.onLayoutChange(_layout, layouts2);
      this.props.onBreakpointChange(newBreakpoint, newCols);
      this.props.onWidthChange(nextProps.width, nextProps.margin, newCols, nextProps.containerPadding);
      this.setState({
        breakpoint: newBreakpoint,
        layout: _layout,
        cols: newCols
      });
    }
  };
  ResponsiveReactGridLayout2.prototype.render = function render3() {
    var _props2 = this.props;
    _props2.breakpoint;
    _props2.breakpoints;
    _props2.cols;
    _props2.layouts;
    _props2.onBreakpointChange;
    _props2.onLayoutChange;
    _props2.onWidthChange;
    var other = _objectWithoutProperties$4(_props2, ["breakpoint", "breakpoints", "cols", "layouts", "onBreakpointChange", "onLayoutChange", "onWidthChange"]);
    return _react2$5.default.createElement(_ReactGridLayout2.default, _extends$p({}, other, {
      onLayoutChange: this.onLayoutChange,
      layout: this.state.layout,
      cols: this.state.cols
    }));
  };
  return ResponsiveReactGridLayout2;
}(_react2$5.default.Component);
ResponsiveReactGridLayout.propTypes = {
  //
  // Basic props
  //
  // Optional, but if you are managing width yourself you may want to set the breakpoint
  // yourself as well.
  breakpoint: _propTypes2$1.default.string,
  // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
  breakpoints: _propTypes2$1.default.object,
  // # of cols. This is a breakpoint -> cols map
  cols: _propTypes2$1.default.object,
  // layouts is an object mapping breakpoints to layouts.
  // e.g. {lg: Layout, md: Layout, ...}
  layouts: function layouts(props, propName) {
    if (type$5(props[propName]) !== "[object Object]") {
      throw new Error("Layout property must be an object. Received: " + type$5(props[propName]));
    }
    Object.keys(props[propName]).forEach(function(key) {
      if (!(key in props.breakpoints)) {
        throw new Error("Each key in layouts must align with a key in breakpoints.");
      }
      (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
    });
  },
  // The width of this component.
  // Required in this propTypes stanza because generateInitialState() will fail without it.
  width: _propTypes2$1.default.number.isRequired,
  //
  // Callbacks
  //
  // Calls back with breakpoint and new # cols
  onBreakpointChange: _propTypes2$1.default.func,
  // Callback so you can save the layout.
  // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
  onLayoutChange: _propTypes2$1.default.func,
  // Calls back with (containerWidth, margin, cols, containerPadding)
  onWidthChange: _propTypes2$1.default.func
};
ResponsiveReactGridLayout.defaultProps = {
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  cols: {
    lg: 12,
    md: 10,
    sm: 6,
    xs: 4,
    xxs: 2
  },
  layouts: {},
  onBreakpointChange: _utils.noop,
  onLayoutChange: _utils.noop,
  onWidthChange: _utils.noop
};
ResponsiveReactGridLayout$1.default = ResponsiveReactGridLayout;
var WidthProvider$1 = {};
WidthProvider$1.__esModule = true;
var _extends$o = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
WidthProvider$1.default = WidthProvider;
var _react$5 = React$3;
var _react2$4 = _interopRequireDefault$f(_react$5);
var _propTypes = propTypesExports;
var _propTypes2 = _interopRequireDefault$f(_propTypes);
var _reactDom = ReactDOM;
var _reactDom2 = _interopRequireDefault$f(_reactDom);
function _interopRequireDefault$f(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties$3(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$1O(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1s(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1s(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function WidthProvider(ComposedComponent) {
  var _class, _temp2;
  return _temp2 = _class = function(_React$Component) {
    _inherits$1s(WidthProvider2, _React$Component);
    function WidthProvider2() {
      var _temp, _this, _ret;
      _classCallCheck$1O(this, WidthProvider2);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$1s(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        width: 1280
      }, _this.mounted = false, _this.onWindowResize = function() {
        if (!_this.mounted)
          return;
        var node2 = _reactDom2.default.findDOMNode(_this);
        if (node2 instanceof HTMLElement)
          _this.setState({
            width: node2.offsetWidth
          });
      }, _temp), _possibleConstructorReturn$1s(_this, _ret);
    }
    WidthProvider2.prototype.componentDidMount = function componentDidMount() {
      this.mounted = true;
      window.addEventListener("resize", this.onWindowResize);
      this.onWindowResize();
    };
    WidthProvider2.prototype.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;
      window.removeEventListener("resize", this.onWindowResize);
    };
    WidthProvider2.prototype.render = function render3() {
      var _props = this.props, measureBeforeMount = _props.measureBeforeMount, rest = _objectWithoutProperties$3(_props, ["measureBeforeMount"]);
      if (measureBeforeMount && !this.mounted) {
        return _react2$4.default.createElement("div", {
          className: this.props.className,
          style: this.props.style
        });
      }
      return _react2$4.default.createElement(ComposedComponent, _extends$o({}, rest, this.state));
    };
    return WidthProvider2;
  }(_react2$4.default.Component), _class.defaultProps = {
    measureBeforeMount: false
  }, _class.propTypes = {
    // If true, will not render children until mounted. Useful for getting the exact width before
    // rendering, to prevent any unsightly resizing.
    measureBeforeMount: _propTypes2.default.bool
  }, _temp2;
}
(function(module2) {
  module2.exports = ReactGridLayout$2.default;
  module2.exports.utils = utils$a;
  module2.exports.Responsive = ResponsiveReactGridLayout$1.default;
  module2.exports.Responsive.utils = responsiveUtils;
  module2.exports.WidthProvider = WidthProvider$1.default;
})(reactGridLayout);
var reactGridLayoutExports = reactGridLayout.exports;
const ReactGridLayout = /* @__PURE__ */ getDefaultExportFromCjs(reactGridLayoutExports);
var ResizeSensor = { exports: {} };
(function(module2, exports2) {
  (function(root2, factory) {
    {
      module2.exports = factory();
    }
  })(typeof window !== "undefined" ? window : commonjsGlobal, function() {
    if (typeof window === "undefined") {
      return null;
    }
    var globalWindow = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
    var requestAnimationFrame2 = globalWindow.requestAnimationFrame || globalWindow.mozRequestAnimationFrame || globalWindow.webkitRequestAnimationFrame || function(fn) {
      return globalWindow.setTimeout(fn, 20);
    };
    var cancelAnimationFrame = globalWindow.cancelAnimationFrame || globalWindow.mozCancelAnimationFrame || globalWindow.webkitCancelAnimationFrame || function(timer2) {
      globalWindow.clearTimeout(timer2);
    };
    function forEachElement(elements, callback) {
      var elementsType = Object.prototype.toString.call(elements);
      var isCollectionTyped = "[object Array]" === elementsType || "[object NodeList]" === elementsType || "[object HTMLCollection]" === elementsType || "[object Object]" === elementsType || "undefined" !== typeof jQuery && elements instanceof jQuery || "undefined" !== typeof Elements && elements instanceof Elements;
      var i = 0, j = elements.length;
      if (isCollectionTyped) {
        for (; i < j; i++) {
          callback(elements[i]);
        }
      } else {
        callback(elements);
      }
    }
    function getElementSize(element) {
      if (!element.getBoundingClientRect) {
        return {
          width: element.offsetWidth,
          height: element.offsetHeight
        };
      }
      var rect = element.getBoundingClientRect();
      return {
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      };
    }
    function setStyle(element, style) {
      Object.keys(style).forEach(function(key) {
        element.style[key] = style[key];
      });
    }
    var ResizeSensor2 = function(element, callback) {
      var lastAnimationFrameForInvisibleCheck = 0;
      function EventQueue() {
        var q = [];
        this.add = function(ev) {
          q.push(ev);
        };
        var i, j;
        this.call = function(sizeInfo) {
          for (i = 0, j = q.length; i < j; i++) {
            q[i].call(this, sizeInfo);
          }
        };
        this.remove = function(ev) {
          var newQueue = [];
          for (i = 0, j = q.length; i < j; i++) {
            if (q[i] !== ev)
              newQueue.push(q[i]);
          }
          q = newQueue;
        };
        this.length = function() {
          return q.length;
        };
      }
      function attachResizeEvent(element2, resized) {
        if (!element2)
          return;
        if (element2.resizedAttached) {
          element2.resizedAttached.add(resized);
          return;
        }
        element2.resizedAttached = new EventQueue();
        element2.resizedAttached.add(resized);
        element2.resizeSensor = document.createElement("div");
        element2.resizeSensor.dir = "ltr";
        element2.resizeSensor.className = "resize-sensor";
        var style = {
          pointerEvents: "none",
          position: "absolute",
          left: "0px",
          top: "0px",
          right: "0px",
          bottom: "0px",
          overflow: "hidden",
          zIndex: "-1",
          visibility: "hidden",
          maxWidth: "100%"
        };
        var styleChild = {
          position: "absolute",
          left: "0px",
          top: "0px",
          transition: "0s"
        };
        setStyle(element2.resizeSensor, style);
        var expand = document.createElement("div");
        expand.className = "resize-sensor-expand";
        setStyle(expand, style);
        var expandChild = document.createElement("div");
        setStyle(expandChild, styleChild);
        expand.appendChild(expandChild);
        var shrink = document.createElement("div");
        shrink.className = "resize-sensor-shrink";
        setStyle(shrink, style);
        var shrinkChild = document.createElement("div");
        setStyle(shrinkChild, styleChild);
        setStyle(shrinkChild, {
          width: "200%",
          height: "200%"
        });
        shrink.appendChild(shrinkChild);
        element2.resizeSensor.appendChild(expand);
        element2.resizeSensor.appendChild(shrink);
        element2.appendChild(element2.resizeSensor);
        var computedStyle = window.getComputedStyle(element2);
        var position = computedStyle ? computedStyle.getPropertyValue("position") : null;
        if ("absolute" !== position && "relative" !== position && "fixed" !== position && "sticky" !== position) {
          element2.style.position = "relative";
        }
        var dirty = false;
        var rafId = 0;
        var size = getElementSize(element2);
        var lastWidth = 0;
        var lastHeight = 0;
        var initialHiddenCheck = true;
        lastAnimationFrameForInvisibleCheck = 0;
        var resetExpandShrink = function() {
          var width = element2.offsetWidth;
          var height2 = element2.offsetHeight;
          expandChild.style.width = width + 10 + "px";
          expandChild.style.height = height2 + 10 + "px";
          expand.scrollLeft = width + 10;
          expand.scrollTop = height2 + 10;
          shrink.scrollLeft = width + 10;
          shrink.scrollTop = height2 + 10;
        };
        var reset2 = function() {
          if (initialHiddenCheck) {
            var invisible = element2.offsetWidth === 0 && element2.offsetHeight === 0;
            if (invisible) {
              if (!lastAnimationFrameForInvisibleCheck) {
                lastAnimationFrameForInvisibleCheck = requestAnimationFrame2(function() {
                  lastAnimationFrameForInvisibleCheck = 0;
                  reset2();
                });
              }
              return;
            } else {
              initialHiddenCheck = false;
            }
          }
          resetExpandShrink();
        };
        element2.resizeSensor.resetSensor = reset2;
        var onResized = function() {
          rafId = 0;
          if (!dirty)
            return;
          lastWidth = size.width;
          lastHeight = size.height;
          if (element2.resizedAttached) {
            element2.resizedAttached.call(size);
          }
        };
        var onScroll = function() {
          size = getElementSize(element2);
          dirty = size.width !== lastWidth || size.height !== lastHeight;
          if (dirty && !rafId) {
            rafId = requestAnimationFrame2(onResized);
          }
          reset2();
        };
        var addEvent2 = function(el, name, cb) {
          if (el.attachEvent) {
            el.attachEvent("on" + name, cb);
          } else {
            el.addEventListener(name, cb);
          }
        };
        addEvent2(expand, "scroll", onScroll);
        addEvent2(shrink, "scroll", onScroll);
        lastAnimationFrameForInvisibleCheck = requestAnimationFrame2(function() {
          lastAnimationFrameForInvisibleCheck = 0;
          reset2();
        });
      }
      forEachElement(element, function(elem) {
        attachResizeEvent(elem, callback);
      });
      this.detach = function(ev) {
        if (!lastAnimationFrameForInvisibleCheck) {
          cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
          lastAnimationFrameForInvisibleCheck = 0;
        }
        ResizeSensor2.detach(element, ev);
      };
      this.reset = function() {
        element.resizeSensor.resetSensor();
      };
    };
    ResizeSensor2.reset = function(element) {
      forEachElement(element, function(elem) {
        elem.resizeSensor.resetSensor();
      });
    };
    ResizeSensor2.detach = function(element, ev) {
      forEachElement(element, function(elem) {
        if (!elem)
          return;
        if (elem.resizedAttached && typeof ev === "function") {
          elem.resizedAttached.remove(ev);
          if (elem.resizedAttached.length())
            return;
        }
        if (elem.resizeSensor) {
          if (elem.contains(elem.resizeSensor)) {
            elem.removeChild(elem.resizeSensor);
          }
          delete elem.resizeSensor;
          delete elem.resizedAttached;
        }
      });
    };
    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function(mutations) {
        for (var i in mutations) {
          if (mutations.hasOwnProperty(i)) {
            var items2 = mutations[i].addedNodes;
            for (var j = 0; j < items2.length; j++) {
              if (items2[j].resizeSensor) {
                ResizeSensor2.reset(items2[j]);
              }
            }
          }
        }
      });
      document.addEventListener("DOMContentLoaded", function(event) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
    return ResizeSensor2;
  });
})(ResizeSensor);
var ResizeSensorExports = ResizeSensor.exports;
var ElementQueries = { exports: {} };
(function(module2, exports2) {
  (function(root2, factory) {
    {
      module2.exports = factory(ResizeSensorExports);
    }
  })(typeof window !== "undefined" ? window : commonjsGlobal, function(ResizeSensor2) {
    var ElementQueries2 = function() {
      var cssStyleElement;
      var allQueries = {};
      var idToSelectorMapping = [];
      function getEmSize(element) {
        if (!element) {
          element = document.documentElement;
        }
        var fontSize = window.getComputedStyle(element, null).fontSize;
        return parseFloat(fontSize) || 16;
      }
      function getElementSize(element) {
        if (!element.getBoundingClientRect) {
          return {
            width: element.offsetWidth,
            height: element.offsetHeight
          };
        }
        var rect = element.getBoundingClientRect();
        return {
          width: Math.round(rect.width),
          height: Math.round(rect.height)
        };
      }
      function convertToPx(element, value2) {
        var numbers2 = value2.split(/\d/);
        var units = numbers2[numbers2.length - 1];
        value2 = parseFloat(value2);
        switch (units) {
          case "px":
            return value2;
          case "em":
            return value2 * getEmSize(element);
          case "rem":
            return value2 * getEmSize();
          case "vw":
            return value2 * document.documentElement.clientWidth / 100;
          case "vh":
            return value2 * document.documentElement.clientHeight / 100;
          case "vmin":
          case "vmax":
            var vw = document.documentElement.clientWidth / 100;
            var vh = document.documentElement.clientHeight / 100;
            var chooser = Math[units === "vmin" ? "min" : "max"];
            return value2 * chooser(vw, vh);
          default:
            return value2;
        }
      }
      function SetupInformation(element, id2) {
        this.element = element;
        var key, option, elementSize, value2, actualValue, attrValues, attrValue, attrName;
        var attributes2 = ["min-width", "min-height", "max-width", "max-height"];
        this.call = function() {
          elementSize = getElementSize(this.element);
          attrValues = {};
          for (key in allQueries[id2]) {
            if (!allQueries[id2].hasOwnProperty(key)) {
              continue;
            }
            option = allQueries[id2][key];
            value2 = convertToPx(this.element, option.value);
            actualValue = option.property === "width" ? elementSize.width : elementSize.height;
            attrName = option.mode + "-" + option.property;
            attrValue = "";
            if (option.mode === "min" && actualValue >= value2) {
              attrValue += option.value;
            }
            if (option.mode === "max" && actualValue <= value2) {
              attrValue += option.value;
            }
            if (!attrValues[attrName])
              attrValues[attrName] = "";
            if (attrValue && -1 === (" " + attrValues[attrName] + " ").indexOf(" " + attrValue + " ")) {
              attrValues[attrName] += " " + attrValue;
            }
          }
          for (var k in attributes2) {
            if (!attributes2.hasOwnProperty(k))
              continue;
            if (attrValues[attributes2[k]]) {
              this.element.setAttribute(attributes2[k], attrValues[attributes2[k]].substr(1));
            } else {
              this.element.removeAttribute(attributes2[k]);
            }
          }
        };
      }
      function setupElement(element, id2) {
        if (!element.elementQueriesSetupInformation) {
          element.elementQueriesSetupInformation = new SetupInformation(element, id2);
        }
        if (!element.elementQueriesSensor) {
          element.elementQueriesSensor = new ResizeSensor2(element, function() {
            element.elementQueriesSetupInformation.call();
          });
        }
      }
      function queueQuery(selector2, mode, property2, value2) {
        if (typeof allQueries[selector2] === "undefined") {
          allQueries[selector2] = [];
          var id2 = idToSelectorMapping.length;
          cssStyleElement.innerHTML += "\n" + selector2 + " {animation: 0.1s element-queries;}";
          cssStyleElement.innerHTML += "\n" + selector2 + " > .resize-sensor {min-width: " + id2 + "px;}";
          idToSelectorMapping.push(selector2);
        }
        allQueries[selector2].push({
          mode,
          property: property2,
          value: value2
        });
      }
      function getQuery(container) {
        var query;
        if (document.querySelectorAll)
          query = container ? container.querySelectorAll.bind(container) : document.querySelectorAll.bind(document);
        if (!query && "undefined" !== typeof $$)
          query = $$;
        if (!query && "undefined" !== typeof jQuery)
          query = jQuery;
        if (!query) {
          throw "No document.querySelectorAll, jQuery or Mootools's $$ found.";
        }
        return query;
      }
      function findElementQueriesElements(container) {
        var query = getQuery(container);
        for (var selector2 in allQueries)
          if (allQueries.hasOwnProperty(selector2)) {
            var elements = query(selector2, container);
            for (var i = 0, j = elements.length; i < j; i++) {
              setupElement(elements[i], selector2);
            }
          }
      }
      function attachResponsiveImage(element) {
        var children3 = [];
        var rules3 = [];
        var sources = [];
        var defaultImageId = 0;
        var lastActiveImage = -1;
        var loadedImages = [];
        for (var i in element.children) {
          if (!element.children.hasOwnProperty(i))
            continue;
          if (element.children[i].tagName && element.children[i].tagName.toLowerCase() === "img") {
            children3.push(element.children[i]);
            var minWidth = element.children[i].getAttribute("min-width") || element.children[i].getAttribute("data-min-width");
            var src2 = element.children[i].getAttribute("data-src") || element.children[i].getAttribute("url");
            sources.push(src2);
            var rule = {
              minWidth
            };
            rules3.push(rule);
            if (!minWidth) {
              defaultImageId = children3.length - 1;
              element.children[i].style.display = "block";
            } else {
              element.children[i].style.display = "none";
            }
          }
        }
        lastActiveImage = defaultImageId;
        function check() {
          var imageToDisplay = false, i2;
          for (i2 in children3) {
            if (!children3.hasOwnProperty(i2))
              continue;
            if (rules3[i2].minWidth) {
              if (element.offsetWidth > rules3[i2].minWidth) {
                imageToDisplay = i2;
              }
            }
          }
          if (!imageToDisplay) {
            imageToDisplay = defaultImageId;
          }
          if (lastActiveImage !== imageToDisplay) {
            if (!loadedImages[imageToDisplay]) {
              var image = new Image();
              image.onload = function() {
                children3[imageToDisplay].src = sources[imageToDisplay];
                children3[lastActiveImage].style.display = "none";
                children3[imageToDisplay].style.display = "block";
                loadedImages[imageToDisplay] = true;
                lastActiveImage = imageToDisplay;
              };
              image.src = sources[imageToDisplay];
            } else {
              children3[lastActiveImage].style.display = "none";
              children3[imageToDisplay].style.display = "block";
              lastActiveImage = imageToDisplay;
            }
          } else {
            children3[imageToDisplay].src = sources[imageToDisplay];
          }
        }
        element.resizeSensorInstance = new ResizeSensor2(element, check);
        check();
      }
      function findResponsiveImages() {
        var query = getQuery();
        var elements = query("[data-responsive-image],[responsive-image]");
        for (var i = 0, j = elements.length; i < j; i++) {
          attachResponsiveImage(elements[i]);
        }
      }
      var regex2 = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:min|max)-(?:width|height)[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/mgi;
      var attrRegex = /\[[\s\t]*?(min|max)-(width|height)[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/mgi;
      function extractQuery(css2) {
        var match, smatch, attrs, attrMatch;
        css2 = css2.replace(/'/g, '"');
        while (null !== (match = regex2.exec(css2))) {
          smatch = match[1] + match[3];
          attrs = match[2];
          while (null !== (attrMatch = attrRegex.exec(attrs))) {
            queueQuery(smatch, attrMatch[1], attrMatch[2], attrMatch[3]);
          }
        }
      }
      function readRules(rules3) {
        var selector2 = "";
        if (!rules3) {
          return;
        }
        if ("string" === typeof rules3) {
          rules3 = rules3.toLowerCase();
          if (-1 !== rules3.indexOf("min-width") || -1 !== rules3.indexOf("max-width")) {
            extractQuery(rules3);
          }
        } else {
          for (var i = 0, j = rules3.length; i < j; i++) {
            if (1 === rules3[i].type) {
              selector2 = rules3[i].selectorText || rules3[i].cssText;
              if (-1 !== selector2.indexOf("min-height") || -1 !== selector2.indexOf("max-height")) {
                extractQuery(selector2);
              } else if (-1 !== selector2.indexOf("min-width") || -1 !== selector2.indexOf("max-width")) {
                extractQuery(selector2);
              }
            } else if (4 === rules3[i].type) {
              readRules(rules3[i].cssRules || rules3[i].rules);
            } else if (3 === rules3[i].type) {
              if (rules3[i].styleSheet.hasOwnProperty("cssRules")) {
                readRules(rules3[i].styleSheet.cssRules);
              }
            }
          }
        }
      }
      var defaultCssInjected = false;
      this.init = function() {
        var animationStart = "animationstart";
        if (typeof document.documentElement.style["webkitAnimationName"] !== "undefined") {
          animationStart = "webkitAnimationStart";
        } else if (typeof document.documentElement.style["MozAnimationName"] !== "undefined") {
          animationStart = "mozanimationstart";
        } else if (typeof document.documentElement.style["OAnimationName"] !== "undefined") {
          animationStart = "oanimationstart";
        }
        document.body.addEventListener(animationStart, function(e) {
          var element = e.target;
          var styles2 = element && window.getComputedStyle(element, null);
          var animationName = styles2 && styles2.getPropertyValue("animation-name");
          var requiresSetup = animationName && -1 !== animationName.indexOf("element-queries");
          if (requiresSetup) {
            element.elementQueriesSensor = new ResizeSensor2(element, function() {
              if (element.elementQueriesSetupInformation) {
                element.elementQueriesSetupInformation.call();
              }
            });
            var sensorStyles = window.getComputedStyle(element.resizeSensor, null);
            var id2 = sensorStyles.getPropertyValue("min-width");
            id2 = parseInt(id2.replace("px", ""));
            setupElement(e.target, idToSelectorMapping[id2]);
          }
        });
        if (!defaultCssInjected) {
          cssStyleElement = document.createElement("style");
          cssStyleElement.type = "text/css";
          cssStyleElement.innerHTML = "[responsive-image] > img, [data-responsive-image] {overflow: hidden; padding: 0; } [responsive-image] > img, [data-responsive-image] > img {width: 100%;}";
          cssStyleElement.innerHTML += "\n@keyframes element-queries { 0% { visibility: inherit; } }";
          document.getElementsByTagName("head")[0].appendChild(cssStyleElement);
          defaultCssInjected = true;
        }
        for (var i = 0, j = document.styleSheets.length; i < j; i++) {
          try {
            if (document.styleSheets[i].href && 0 === document.styleSheets[i].href.indexOf("file://")) {
              console.warn("CssElementQueries: unable to parse local css files, " + document.styleSheets[i].href);
            }
            readRules(document.styleSheets[i].cssRules || document.styleSheets[i].rules || document.styleSheets[i].cssText);
          } catch (e) {
          }
        }
        findResponsiveImages();
      };
      this.findElementQueriesElements = function(container) {
        findElementQueriesElements(container);
      };
      this.update = function() {
        this.init();
      };
    };
    ElementQueries2.update = function() {
      ElementQueries2.instance.update();
    };
    ElementQueries2.detach = function(element) {
      if (element.elementQueriesSetupInformation) {
        element.elementQueriesSensor.detach();
        delete element.elementQueriesSetupInformation;
        delete element.elementQueriesSensor;
      } else if (element.resizeSensorInstance) {
        element.resizeSensorInstance.detach();
        delete element.resizeSensorInstance;
      }
    };
    ElementQueries2.init = function() {
      if (!ElementQueries2.instance) {
        ElementQueries2.instance = new ElementQueries2();
      }
      ElementQueries2.instance.init();
    };
    var domLoaded = function(callback) {
      if (document.addEventListener) {
        document.addEventListener("DOMContentLoaded", callback, false);
      } else if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) {
        var DOMLoadTimer = setInterval(function() {
          if (/loaded|complete/i.test(document.readyState)) {
            callback();
            clearInterval(DOMLoadTimer);
          }
        }, 10);
      } else
        window.onload = callback;
    };
    ElementQueries2.findElementQueriesElements = function(container) {
      ElementQueries2.instance.findElementQueriesElements(container);
    };
    ElementQueries2.listen = function() {
      domLoaded(ElementQueries2.init);
    };
    return ElementQueries2;
  });
})(ElementQueries);
var ElementQueriesExports = ElementQueries.exports;
var cssElementQueries = {
  ResizeSensor: ResizeSensorExports,
  ElementQueries: ElementQueriesExports
};
function createShiftArr(step) {
  var space = "    ";
  if (isNaN(parseInt(step))) {
    space = step;
  } else {
    switch (step) {
      case 1:
        space = " ";
        break;
      case 2:
        space = "  ";
        break;
      case 3:
        space = "   ";
        break;
      case 4:
        space = "    ";
        break;
      case 5:
        space = "     ";
        break;
      case 6:
        space = "      ";
        break;
      case 7:
        space = "       ";
        break;
      case 8:
        space = "        ";
        break;
      case 9:
        space = "         ";
        break;
      case 10:
        space = "          ";
        break;
      case 11:
        space = "           ";
        break;
      case 12:
        space = "            ";
        break;
    }
  }
  var shift2 = ["\n"];
  for (var ix = 0; ix < 100; ix++) {
    shift2.push(shift2[ix] + space);
  }
  return shift2;
}
function vkbeautify() {
  this.step = "    ";
  this.shift = createShiftArr(this.step);
}
vkbeautify.prototype.xml = function(text2, step) {
  var ar = text2.replace(/>\s{0,}</g, "><").replace(/</g, "~::~<").replace(/\s*xmlns\:/g, "~::~xmlns:").replace(/\s*xmlns\=/g, "~::~xmlns=").split("~::~"), len = ar.length, inComment = false, deep = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
  for (ix = 0; ix < len; ix++) {
    if (ar[ix].search(/<!/) > -1) {
      str += shift2[deep] + ar[ix];
      inComment = true;
      if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1 || ar[ix].search(/!DOCTYPE/) > -1) {
        inComment = false;
      }
    } else if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1) {
      str += ar[ix];
      inComment = false;
    } else if (/^<\w/.exec(ar[ix - 1]) && /^<\/\w/.exec(ar[ix]) && /^<[\w:\-\.\,]+/.exec(ar[ix - 1]) == /^<\/[\w:\-\.\,]+/.exec(ar[ix])[0].replace("/", "")) {
      str += ar[ix];
      if (!inComment)
        deep--;
    } else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) == -1 && ar[ix].search(/\/>/) == -1) {
      str = !inComment ? str += shift2[deep++] + ar[ix] : str += ar[ix];
    } else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) > -1) {
      str = !inComment ? str += shift2[deep] + ar[ix] : str += ar[ix];
    } else if (ar[ix].search(/<\//) > -1) {
      str = !inComment ? str += shift2[--deep] + ar[ix] : str += ar[ix];
    } else if (ar[ix].search(/\/>/) > -1) {
      str = !inComment ? str += shift2[deep] + ar[ix] : str += ar[ix];
    } else if (ar[ix].search(/<\?/) > -1) {
      str += shift2[deep] + ar[ix];
    } else if (ar[ix].search(/xmlns\:/) > -1 || ar[ix].search(/xmlns\=/) > -1) {
      str += shift2[deep] + ar[ix];
    } else {
      str += ar[ix];
    }
  }
  return str[0] == "\n" ? str.slice(1) : str;
};
vkbeautify.prototype.json = function(text2, step) {
  var step = step ? step : this.step;
  if (typeof JSON === "undefined")
    return text2;
  if (typeof text2 === "string")
    return JSON.stringify(JSON.parse(text2), null, step);
  if (typeof text2 === "object")
    return JSON.stringify(text2, null, step);
  return text2;
};
vkbeautify.prototype.css = function(text2, step) {
  var ar = text2.replace(/\s{1,}/g, " ").replace(/\{/g, "{~::~").replace(/\}/g, "~::~}~::~").replace(/\;/g, ";~::~").replace(/\/\*/g, "~::~/*").replace(/\*\//g, "*/~::~").replace(/~::~\s{0,}~::~/g, "~::~").split("~::~"), len = ar.length, deep = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
  for (ix = 0; ix < len; ix++) {
    if (/\{/.exec(ar[ix])) {
      str += shift2[deep++] + ar[ix];
    } else if (/\}/.exec(ar[ix])) {
      str += shift2[--deep] + ar[ix];
    } else if (/\*\\/.exec(ar[ix])) {
      str += shift2[deep] + ar[ix];
    } else {
      str += shift2[deep] + ar[ix];
    }
  }
  return str.replace(/^\n{1,}/, "");
};
function isSubquery(str, parenthesisLevel) {
  return parenthesisLevel - (str.replace(/\(/g, "").length - str.replace(/\)/g, "").length);
}
function split_sql(str, tab) {
  return str.replace(/\s{1,}/g, " ").replace(/ AND /ig, "~::~" + tab + tab + "AND ").replace(/ BETWEEN /ig, "~::~" + tab + "BETWEEN ").replace(/ CASE /ig, "~::~" + tab + "CASE ").replace(/ ELSE /ig, "~::~" + tab + "ELSE ").replace(/ END /ig, "~::~" + tab + "END ").replace(/ FROM /ig, "~::~FROM ").replace(/ GROUP\s{1,}BY/ig, "~::~GROUP BY ").replace(/ HAVING /ig, "~::~HAVING ").replace(/ IN /ig, " IN ").replace(/ JOIN /ig, "~::~JOIN ").replace(/ CROSS~::~{1,}JOIN /ig, "~::~CROSS JOIN ").replace(/ INNER~::~{1,}JOIN /ig, "~::~INNER JOIN ").replace(/ LEFT~::~{1,}JOIN /ig, "~::~LEFT JOIN ").replace(/ RIGHT~::~{1,}JOIN /ig, "~::~RIGHT JOIN ").replace(/ ON /ig, "~::~" + tab + "ON ").replace(/ OR /ig, "~::~" + tab + tab + "OR ").replace(/ ORDER\s{1,}BY/ig, "~::~ORDER BY ").replace(/ OVER /ig, "~::~" + tab + "OVER ").replace(/\(\s{0,}SELECT /ig, "~::~(SELECT ").replace(/\)\s{0,}SELECT /ig, ")~::~SELECT ").replace(/ THEN /ig, " THEN~::~" + tab).replace(/ UNION /ig, "~::~UNION~::~").replace(/ USING /ig, "~::~USING ").replace(/ WHEN /ig, "~::~" + tab + "WHEN ").replace(/ WHERE /ig, "~::~WHERE ").replace(/ WITH /ig, "~::~WITH ").replace(/ ALL /ig, " ALL ").replace(/ AS /ig, " AS ").replace(/ ASC /ig, " ASC ").replace(/ DESC /ig, " DESC ").replace(/ DISTINCT /ig, " DISTINCT ").replace(/ EXISTS /ig, " EXISTS ").replace(/ NOT /ig, " NOT ").replace(/ NULL /ig, " NULL ").replace(/ LIKE /ig, " LIKE ").replace(/\s{0,}SELECT /ig, "SELECT ").replace(/\s{0,}UPDATE /ig, "UPDATE ").replace(/ SET /ig, " SET ").replace(/~::~{1,}/g, "~::~").split("~::~");
}
vkbeautify.prototype.sql = function(text2, step) {
  var ar_by_quote = text2.replace(/\s{1,}/g, " ").replace(/\'/ig, "~::~'").split("~::~"), len = ar_by_quote.length, ar = [], deep = 0, tab = this.step, parenthesisLevel = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
  for (ix = 0; ix < len; ix++) {
    if (ix % 2) {
      ar = ar.concat(ar_by_quote[ix]);
    } else {
      ar = ar.concat(split_sql(ar_by_quote[ix], tab));
    }
  }
  len = ar.length;
  for (ix = 0; ix < len; ix++) {
    parenthesisLevel = isSubquery(ar[ix], parenthesisLevel);
    if (/\s{0,}\s{0,}SELECT\s{0,}/.exec(ar[ix])) {
      ar[ix] = ar[ix].replace(/\,/g, ",\n" + tab + tab);
    }
    if (/\s{0,}\s{0,}SET\s{0,}/.exec(ar[ix])) {
      ar[ix] = ar[ix].replace(/\,/g, ",\n" + tab + tab);
    }
    if (/\s{0,}\(\s{0,}SELECT\s{0,}/.exec(ar[ix])) {
      deep++;
      str += shift2[deep] + ar[ix];
    } else if (/\'/.exec(ar[ix])) {
      if (parenthesisLevel < 1 && deep) {
        deep--;
      }
      str += ar[ix];
    } else {
      str += shift2[deep] + ar[ix];
      if (parenthesisLevel < 1 && deep) {
        deep--;
      }
    }
  }
  str = str.replace(/^\n{1,}/, "").replace(/\n{1,}/g, "\n");
  return str;
};
vkbeautify.prototype.xmlmin = function(text2, preserveComments) {
  var str = preserveComments ? text2 : text2.replace(/\<![ \r\n\t]*(--([^\-]|[\r\n]|-[^\-])*--[ \r\n\t]*)\>/g, "").replace(/[ \r\n\t]{1,}xmlns/g, " xmlns");
  return str.replace(/>\s{0,}</g, "><");
};
vkbeautify.prototype.jsonmin = function(text2) {
  if (typeof JSON === "undefined")
    return text2;
  return JSON.stringify(JSON.parse(text2), null, 0);
};
vkbeautify.prototype.cssmin = function(text2, preserveComments) {
  var str = preserveComments ? text2 : text2.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\//g, "");
  return str.replace(/\s{1,}/g, " ").replace(/\{\s{1,}/g, "{").replace(/\}\s{1,}/g, "}").replace(/\;\s{1,}/g, ";").replace(/\/\*\s{1,}/g, "/*").replace(/\*\/\s{1,}/g, "*/");
};
vkbeautify.prototype.sqlmin = function(text2) {
  return text2.replace(/\s{1,}/g, " ").replace(/\s{1,}\(/, "(").replace(/\s{1,}\)/, ")");
};
var vkbeautify_1 = new vkbeautify();
const vkbeautify$1 = /* @__PURE__ */ getDefaultExportFromCjs(vkbeautify_1);
var requiresPort = function required(port2, protocol) {
  protocol = protocol.split(":")[0];
  port2 = +port2;
  if (!port2)
    return false;
  switch (protocol) {
    case "http":
    case "ws":
      return port2 !== 80;
    case "https":
    case "wss":
      return port2 !== 443;
    case "ftp":
      return port2 !== 21;
    case "gopher":
      return port2 !== 70;
    case "file":
      return false;
  }
  return port2 !== 0;
};
var querystringify$1 = {};
var has$3 = Object.prototype.hasOwnProperty, undef;
function decode$1(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, " "));
  } catch (e) {
    return null;
  }
}
function encode$1(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}
function querystring(query) {
  var parser2 = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
  while (part = parser2.exec(query)) {
    var key = decode$1(part[1]), value2 = decode$1(part[2]);
    if (key === null || value2 === null || key in result)
      continue;
    result[key] = value2;
  }
  return result;
}
function querystringify(obj, prefix2) {
  prefix2 = prefix2 || "";
  var pairs2 = [], value2, key;
  if ("string" !== typeof prefix2)
    prefix2 = "?";
  for (key in obj) {
    if (has$3.call(obj, key)) {
      value2 = obj[key];
      if (!value2 && (value2 === null || value2 === undef || isNaN(value2))) {
        value2 = "";
      }
      key = encode$1(key);
      value2 = encode$1(value2);
      if (key === null || value2 === null)
        continue;
      pairs2.push(key + "=" + value2);
    }
  }
  return pairs2.length ? prefix2 + pairs2.join("&") : "";
}
querystringify$1.stringify = querystringify;
querystringify$1.parse = querystring;
var required$3 = requiresPort, qs = querystringify$1, controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, CRHTLF = /[\n\r\t]/g, slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, port = /:\d+$/, protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, windowsDriveLetter = /^[a-zA-Z]:/;
function trimLeft$1(str) {
  return (str ? str : "").toString().replace(controlOrWhitespace, "");
}
var rules$2 = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  function sanitize(address, url) {
    return isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
  },
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
];
var ignore = {
  hash: 1,
  query: 1
};
function lolcation(loc) {
  var globalVar;
  if (typeof window !== "undefined")
    globalVar = window;
  else if (typeof globalThis !== "undefined")
    globalVar = globalThis;
  else if (typeof self !== "undefined")
    globalVar = self;
  else
    globalVar = {};
  var location = globalVar.location || {};
  loc = loc || location;
  var finaldestination = {}, type3 = typeof loc, key;
  if ("blob:" === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ("string" === type3) {
    finaldestination = new Url(loc, {});
    for (key in ignore)
      delete finaldestination[key];
  } else if ("object" === type3) {
    for (key in loc) {
      if (key in ignore)
        continue;
      finaldestination[key] = loc[key];
    }
    if (finaldestination.slashes === void 0) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }
  return finaldestination;
}
function isSpecial(scheme) {
  return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
function extractProtocol(address, location) {
  address = trimLeft$1(address);
  address = address.replace(CRHTLF, "");
  location = location || {};
  var match = protocolre.exec(address);
  var protocol = match[1] ? match[1].toLowerCase() : "";
  var forwardSlashes = !!match[2];
  var otherSlashes = !!match[3];
  var slashesCount = 0;
  var rest;
  if (forwardSlashes) {
    if (otherSlashes) {
      rest = match[2] + match[3] + match[4];
      slashesCount = match[2].length + match[3].length;
    } else {
      rest = match[2] + match[4];
      slashesCount = match[2].length;
    }
  } else {
    if (otherSlashes) {
      rest = match[3] + match[4];
      slashesCount = match[3].length;
    } else {
      rest = match[4];
    }
  }
  if (protocol === "file:") {
    if (slashesCount >= 2) {
      rest = rest.slice(2);
    }
  } else if (isSpecial(protocol)) {
    rest = match[4];
  } else if (protocol) {
    if (forwardSlashes) {
      rest = rest.slice(2);
    }
  } else if (slashesCount >= 2 && isSpecial(location.protocol)) {
    rest = match[4];
  }
  return {
    protocol,
    slashes: forwardSlashes || isSpecial(protocol),
    slashesCount,
    rest
  };
}
function resolve$4(relative, base) {
  if (relative === "")
    return base;
  var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last2 = path[i - 1], unshift = false, up = 0;
  while (i--) {
    if (path[i] === ".") {
      path.splice(i, 1);
    } else if (path[i] === "..") {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0)
        unshift = true;
      path.splice(i, 1);
      up--;
    }
  }
  if (unshift)
    path.unshift("");
  if (last2 === "." || last2 === "..")
    path.push("");
  return path.join("/");
}
function Url(address, location, parser2) {
  address = trimLeft$1(address);
  address = address.replace(CRHTLF, "");
  if (!(this instanceof Url)) {
    return new Url(address, location, parser2);
  }
  var relative, extracted, parse2, instruction, index2, key, instructions = rules$2.slice(), type3 = typeof location, url = this, i = 0;
  if ("object" !== type3 && "string" !== type3) {
    parser2 = location;
    location = null;
  }
  if (parser2 && "function" !== typeof parser2)
    parser2 = qs.parse;
  location = lolcation(location);
  extracted = extractProtocol(address || "", location);
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || "";
  address = extracted.rest;
  if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) {
    instructions[3] = [/(.*)/, "pathname"];
  }
  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    if (typeof instruction === "function") {
      address = instruction(address, url);
      continue;
    }
    parse2 = instruction[0];
    key = instruction[1];
    if (parse2 !== parse2) {
      url[key] = address;
    } else if ("string" === typeof parse2) {
      index2 = parse2 === "@" ? address.lastIndexOf(parse2) : address.indexOf(parse2);
      if (~index2) {
        if ("number" === typeof instruction[2]) {
          url[key] = address.slice(0, index2);
          address = address.slice(index2 + instruction[2]);
        } else {
          url[key] = address.slice(index2);
          address = address.slice(0, index2);
        }
      }
    } else if (index2 = parse2.exec(address)) {
      url[key] = index2[1];
      address = address.slice(0, index2.index);
    }
    url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
    if (instruction[4])
      url[key] = url[key].toLowerCase();
  }
  if (parser2)
    url.query = parser2(url.query);
  if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) {
    url.pathname = resolve$4(url.pathname, location.pathname);
  }
  if (url.pathname.charAt(0) !== "/" && isSpecial(url.protocol)) {
    url.pathname = "/" + url.pathname;
  }
  if (!required$3(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = "";
  }
  url.username = url.password = "";
  if (url.auth) {
    index2 = url.auth.indexOf(":");
    if (~index2) {
      url.username = url.auth.slice(0, index2);
      url.username = encodeURIComponent(decodeURIComponent(url.username));
      url.password = url.auth.slice(index2 + 1);
      url.password = encodeURIComponent(decodeURIComponent(url.password));
    } else {
      url.username = encodeURIComponent(decodeURIComponent(url.auth));
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
  }
  url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
  url.href = url.toString();
}
function set$5(part, value2, fn) {
  var url = this;
  switch (part) {
    case "query":
      if ("string" === typeof value2 && value2.length) {
        value2 = (fn || qs.parse)(value2);
      }
      url[part] = value2;
      break;
    case "port":
      url[part] = value2;
      if (!required$3(value2, url.protocol)) {
        url.host = url.hostname;
        url[part] = "";
      } else if (value2) {
        url.host = url.hostname + ":" + value2;
      }
      break;
    case "hostname":
      url[part] = value2;
      if (url.port)
        value2 += ":" + url.port;
      url.host = value2;
      break;
    case "host":
      url[part] = value2;
      if (port.test(value2)) {
        value2 = value2.split(":");
        url.port = value2.pop();
        url.hostname = value2.join(":");
      } else {
        url.hostname = value2;
        url.port = "";
      }
      break;
    case "protocol":
      url.protocol = value2.toLowerCase();
      url.slashes = !fn;
      break;
    case "pathname":
    case "hash":
      if (value2) {
        var char = part === "pathname" ? "/" : "#";
        url[part] = value2.charAt(0) !== char ? char + value2 : value2;
      } else {
        url[part] = value2;
      }
      break;
    case "username":
    case "password":
      url[part] = encodeURIComponent(value2);
      break;
    case "auth":
      var index2 = value2.indexOf(":");
      if (~index2) {
        url.username = value2.slice(0, index2);
        url.username = encodeURIComponent(decodeURIComponent(url.username));
        url.password = value2.slice(index2 + 1);
        url.password = encodeURIComponent(decodeURIComponent(url.password));
      } else {
        url.username = encodeURIComponent(decodeURIComponent(value2));
      }
  }
  for (var i = 0; i < rules$2.length; i++) {
    var ins = rules$2[i];
    if (ins[4])
      url[ins[1]] = url[ins[1]].toLowerCase();
  }
  url.auth = url.password ? url.username + ":" + url.password : url.username;
  url.origin = url.protocol !== "file:" && isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
  url.href = url.toString();
  return url;
}
function toString$6(stringify2) {
  if (!stringify2 || "function" !== typeof stringify2)
    stringify2 = qs.stringify;
  var query, url = this, host = url.host, protocol = url.protocol;
  if (protocol && protocol.charAt(protocol.length - 1) !== ":")
    protocol += ":";
  var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? "//" : "");
  if (url.username) {
    result += url.username;
    if (url.password)
      result += ":" + url.password;
    result += "@";
  } else if (url.password) {
    result += ":" + url.password;
    result += "@";
  } else if (url.protocol !== "file:" && isSpecial(url.protocol) && !host && url.pathname !== "/") {
    result += "@";
  }
  if (host[host.length - 1] === ":" || port.test(url.hostname) && !url.port) {
    host += ":";
  }
  result += host + url.pathname;
  query = "object" === typeof url.query ? stringify2(url.query) : url.query;
  if (query)
    result += "?" !== query.charAt(0) ? "?" + query : query;
  if (url.hash)
    result += url.hash;
  return result;
}
Url.prototype = {
  set: set$5,
  toString: toString$6
};
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft$1;
Url.qs = qs;
var urlParse = Url;
const parse$5 = /* @__PURE__ */ getDefaultExportFromCjs(urlParse);
const bc = (() => {
  try {
    return new window.BroadcastChannel("pub-sub-es");
  } catch (e) {
    return {
      postMessage: () => {
      }
    };
  }
})();
const getEventName = (eventName, caseInsensitive) => caseInsensitive ? eventName.toLowerCase() : eventName;
const subscribe = (stack, {
  caseInsensitive
} = {}) => (event, handler, times = Infinity) => {
  const e = getEventName(event, caseInsensitive);
  if (!stack[e]) {
    stack[e] = [];
    stack.__times__[e] = [];
  }
  stack[e].push(handler);
  stack.__times__[e].push(+times || Infinity);
  return {
    event: e,
    handler
  };
};
const unsubscribe = (stack, {
  caseInsensitive
} = {}) => (event, handler) => {
  if (typeof event === "object") {
    handler = event.handler;
    event = event.event;
  }
  const e = getEventName(event, caseInsensitive);
  if (!stack[e])
    return;
  const id2 = stack[e].indexOf(handler);
  if (id2 === -1 || id2 >= stack[e].length)
    return;
  stack[e].splice(id2, 1);
  stack.__times__[e].splice(id2, 1);
};
const inform = (listeners, news) => () => {
  listeners.forEach((listener) => listener(news));
};
const publish = (stack, {
  isGlobal,
  caseInsensitive,
  async: async2
} = {}) => {
  const unsubscriber = unsubscribe(stack);
  return (event, news, options2 = {}) => {
    const e = getEventName(event, caseInsensitive);
    if (!stack[e])
      return;
    const listeners = [...stack[e]];
    listeners.forEach((listener, i) => {
      if (--stack.__times__[e][i] < 1)
        unsubscriber(e, listener);
    });
    if (async2 || options2.async) {
      setTimeout(inform(listeners, news), 0);
    } else {
      inform(listeners, news)();
    }
    if (isGlobal && !options2.isNoGlobalBroadcast) {
      try {
        bc.postMessage({
          event: e,
          news
        });
      } catch (error) {
        if (error instanceof DOMException) {
          console.warn(`Could not broadcast '${e}' globally. Payload is not clonable.`);
        } else {
          throw error;
        }
      }
    }
  };
};
const clear = (stack) => () => {
  Object.keys(stack).filter((eventName) => eventName[0] !== "_").forEach((eventName) => {
    stack[eventName] = void 0;
    stack.__times__[eventName] = void 0;
    delete stack[eventName];
    delete stack.__times__[eventName];
  });
};
const createEmptyStack = () => ({
  __times__: {}
});
const createPubSub = (options2 = {}) => {
  const async2 = options2.async || false;
  const caseInsensitive = options2.caseInsensitive || false;
  const stack = options2.stack || createEmptyStack();
  if (!stack.__times__)
    stack.__times__ = {};
  return {
    publish: publish(stack, {
      async: async2,
      caseInsensitive
    }),
    subscribe: subscribe(stack, {
      caseInsensitive
    }),
    unsubscribe: unsubscribe(stack, {
      caseInsensitive
    }),
    clear: clear(stack),
    stack
  };
};
const globalPubSubStack = createEmptyStack();
const globalPubSub = {
  publish: publish(globalPubSubStack, {
    isGlobal: true
  }),
  subscribe: subscribe(globalPubSubStack),
  unsubscribe: unsubscribe(globalPubSubStack),
  clear: clear(globalPubSubStack),
  stack: globalPubSubStack
};
bc.onmessage = ({
  data: {
    event,
    news
  }
}) => globalPubSub.publish(event, news, {
  isNoGlobalBroadcast: true
});
const classes$b = {
  "context-menu": "_context-menu_18ock_1",
  "context-menu-dark": "_context-menu-dark_18ock_12",
  "context-menu-icon": "_context-menu-icon_18ock_17",
  "context-menu-item": "_context-menu-item_18ock_27",
  "context-menu-hr": "_context-menu-hr_18ock_38",
  "play-icon": "_play-icon_18ock_45",
  "context-menu-span": "_context-menu-span_18ock_52",
  "context-menu-thumbnail": "_context-menu-thumbnail_18ock_60",
  "context-menu-thumbnail-inline": "_context-menu-thumbnail-inline_18ock_65"
};
function ContextMenuItem(props) {
  return /* @__PURE__ */ React$3.createElement("div", {
    "data-menu-item-for": typeof props.children === "string" ? props.children : null,
    className: classes$b["context-menu-item"],
    onClick: (e) => props.onClick(e),
    onMouseEnter: (e) => props.onMouseEnter(e),
    onMouseLeave: (e) => props.onMouseLeave(e),
    role: "button",
    tabIndex: 0
  }, /* @__PURE__ */ React$3.createElement("span", {
    className: classes$b["context-menu-span"]
  }, props.children));
}
ContextMenuItem.defaultProps = {
  onMouseEnter: () => void 0,
  onMouseLeave: () => void 0
};
ContextMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
var noop$3 = {
  value: () => {
  }
};
function dispatch$1() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t))
      throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch$1(_);
}
function Dispatch$1(_) {
  this._ = _;
}
function parseTypenames$1(typenames, types2) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types2.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    return {
      type: t,
      name
    };
  });
}
Dispatch$1.prototype = dispatch$1.prototype = {
  constructor: Dispatch$1,
  on: function(typename, callback) {
    var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
    if (arguments.length < 2) {
      while (++i < n)
        if ((t = (typename = T[i]).type) && (t = get$9(_[t], typename.name)))
          return t;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type)
        _[t] = set$4(_[t], typename.name, callback);
      else if (callback == null)
        for (t in _)
          _[t] = set$4(_[t], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _ = this._;
    for (var t in _)
      copy2[t] = _[t].slice();
    return new Dispatch$1(copy2);
  },
  call: function(type3, that) {
    if ((n = arguments.length - 2) > 0)
      for (var args = new Array(n), i = 0, n, t; i < n; ++i)
        args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type3))
      throw new Error("unknown type: " + type3);
    for (t = this._[type3], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  },
  apply: function(type3, that, args) {
    if (!this._.hasOwnProperty(type3))
      throw new Error("unknown type: " + type3);
    for (var t = this._[type3], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  }
};
function get$9(type3, name) {
  for (var i = 0, n = type3.length, c2; i < n; ++i) {
    if ((c2 = type3[i]).name === name) {
      return c2.value;
    }
  }
}
function set$4(type3, name, callback) {
  for (var i = 0, n = type3.length; i < n; ++i) {
    if (type3[i].name === name) {
      type3[i] = noop$3, type3 = type3.slice(0, i).concat(type3.slice(i + 1));
      break;
    }
  }
  if (callback != null)
    type3.push({
      name,
      value: callback
    });
  return type3;
}
function nopropagation$2(event) {
  event.stopImmediatePropagation();
}
function noevent$2(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function dragDisable(view) {
  var root2 = view.document.documentElement, selection2 = select$1(view).on("dragstart.drag", noevent$2, true);
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", noevent$2, true);
  } else {
    root2.__noselect = root2.style.MozUserSelect;
    root2.style.MozUserSelect = "none";
  }
}
function yesdrag(view, noclick) {
  var root2 = view.document.documentElement, selection2 = select$1(view).on("dragstart.drag", null);
  if (noclick) {
    selection2.on("click.drag", noevent$2, true);
    setTimeout(function() {
      selection2.on("click.drag", null);
    }, 0);
  }
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", null);
  } else {
    root2.style.MozUserSelect = root2.__noselect;
    delete root2.__noselect;
  }
}
const constant$4 = (x) => () => x;
function DragEvent(type3, {
  sourceEvent: sourceEvent2,
  subject,
  target,
  identifier,
  active: active3,
  x,
  y,
  dx,
  dy,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type3,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    subject: {
      value: subject,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target,
      enumerable: true,
      configurable: true
    },
    identifier: {
      value: identifier,
      enumerable: true,
      configurable: true
    },
    active: {
      value: active3,
      enumerable: true,
      configurable: true
    },
    x: {
      value: x,
      enumerable: true,
      configurable: true
    },
    y: {
      value: y,
      enumerable: true,
      configurable: true
    },
    dx: {
      value: dx,
      enumerable: true,
      configurable: true
    },
    dy: {
      value: dy,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
DragEvent.prototype.on = function() {
  var value2 = this._.on.apply(this._, arguments);
  return value2 === this._ ? this : value2;
};
function defaultFilter$2(event) {
  return !event.ctrlKey && !event.button;
}
function defaultContainer() {
  return this.parentNode;
}
function defaultSubject(event, d) {
  return d == null ? {
    x: event.x,
    y: event.y
  } : d;
}
function defaultTouchable$2() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function drag() {
  var filter4 = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch$1("start", "drag", "end"), active3 = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
  function drag2(selection2) {
    selection2.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function mousedowned(event, d) {
    if (touchending || !filter4.call(this, event, d))
      return;
    var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
    if (!gesture)
      return;
    select$1(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(event.view);
    nopropagation$2(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }
  function mousemoved(event) {
    noevent$2(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }
  function mouseupped(event) {
    select$1(event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(event.view, mousemoving);
    noevent$2(event);
    gestures.mouse("end", event);
  }
  function touchstarted(event, d) {
    if (!filter4.call(this, event, d))
      return;
    var touches = event.changedTouches, c2 = container.call(this, event, d), n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(this, c2, event, d, touches[i].identifier, touches[i])) {
        nopropagation$2(event);
        gesture("start", event, touches[i]);
      }
    }
  }
  function touchmoved(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent$2(event);
        gesture("drag", event, touches[i]);
      }
    }
  }
  function touchended(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    if (touchending)
      clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, 500);
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation$2(event);
        gesture("end", event, touches[i]);
      }
    }
  }
  function beforestart(that, container2, event, d, identifier, touch) {
    var dispatch2 = listeners.copy(), p = pointer(touch || event, container2), dx, dy, s;
    if ((s = subject.call(that, new DragEvent("beforestart", {
      sourceEvent: event,
      target: drag2,
      identifier,
      active: active3,
      x: p[0],
      y: p[1],
      dx: 0,
      dy: 0,
      dispatch: dispatch2
    }), d)) == null)
      return;
    dx = s.x - p[0] || 0;
    dy = s.y - p[1] || 0;
    return function gesture(type3, event2, touch2) {
      var p02 = p, n;
      switch (type3) {
        case "start":
          gestures[identifier] = gesture, n = active3++;
          break;
        case "end":
          delete gestures[identifier], --active3;
        case "drag":
          p = pointer(touch2 || event2, container2), n = active3;
          break;
      }
      dispatch2.call(type3, that, new DragEvent(type3, {
        sourceEvent: event2,
        subject: s,
        target: drag2,
        identifier,
        active: n,
        x: p[0] + dx,
        y: p[1] + dy,
        dx: p[0] - p02[0],
        dy: p[1] - p02[1],
        dispatch: dispatch2
      }), d);
    };
  }
  drag2.filter = function(_) {
    return arguments.length ? (filter4 = typeof _ === "function" ? _ : constant$4(!!_), drag2) : filter4;
  };
  drag2.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$4(_), drag2) : container;
  };
  drag2.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$4(_), drag2) : subject;
  };
  drag2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$4(!!_), drag2) : touchable;
  };
  drag2.on = function() {
    var value2 = listeners.on.apply(listeners, arguments);
    return value2 === listeners ? drag2 : value2;
  };
  drag2.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag2) : Math.sqrt(clickDistance2);
  };
  return drag2;
}
const d3Drag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  drag,
  dragDisable,
  dragEnable: yesdrag
}, Symbol.toStringTag, { value: "Module" }));
var frame$1 = 0, timeout$4 = 0, interval$1 = 0, pokeDelay$1 = 1e3, taskHead$1, taskTail$1, clockLast$1 = 0, clockNow$1 = 0, clockSkew$1 = 0, clock$1 = typeof performance === "object" && performance.now ? performance : Date, setFrame$1 = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now$3() {
  return clockNow$1 || (setFrame$1(clearNow$1), clockNow$1 = clock$1.now() + clockSkew$1);
}
function clearNow$1() {
  clockNow$1 = 0;
}
function Timer$1() {
  this._call = this._time = this._next = null;
}
Timer$1.prototype = timer$1.prototype = {
  constructor: Timer$1,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now$3() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail$1 !== this) {
      if (taskTail$1)
        taskTail$1._next = this;
      else
        taskHead$1 = this;
      taskTail$1 = this;
    }
    this._call = callback;
    this._time = time2;
    sleep$1();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep$1();
    }
  }
};
function timer$1(callback, delay, time2) {
  var t = new Timer$1();
  t.restart(callback, delay, time2);
  return t;
}
function timerFlush$1() {
  now$3();
  ++frame$1;
  var t = taskHead$1, e;
  while (t) {
    if ((e = clockNow$1 - t._time) >= 0)
      t._call.call(null, e);
    t = t._next;
  }
  --frame$1;
}
function wake$1() {
  clockNow$1 = (clockLast$1 = clock$1.now()) + clockSkew$1;
  frame$1 = timeout$4 = 0;
  try {
    timerFlush$1();
  } finally {
    frame$1 = 0;
    nap$1();
    clockNow$1 = 0;
  }
}
function poke$2() {
  var now2 = clock$1.now(), delay = now2 - clockLast$1;
  if (delay > pokeDelay$1)
    clockSkew$1 -= delay, clockLast$1 = now2;
}
function nap$1() {
  var t02, t12 = taskHead$1, t22, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time)
        time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t22 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t22 : taskHead$1 = t22;
    }
  }
  taskTail$1 = t02;
  sleep$1(time2);
}
function sleep$1(time2) {
  if (frame$1)
    return;
  if (timeout$4)
    timeout$4 = clearTimeout(timeout$4);
  var delay = time2 - clockNow$1;
  if (delay > 24) {
    if (time2 < Infinity)
      timeout$4 = setTimeout(wake$1, time2 - clock$1.now() - clockSkew$1);
    if (interval$1)
      interval$1 = clearInterval(interval$1);
  } else {
    if (!interval$1)
      clockLast$1 = clock$1.now(), interval$1 = setInterval(poke$2, pokeDelay$1);
    frame$1 = 1, setFrame$1(wake$1);
  }
}
function timeout$3(callback, delay, time2) {
  var t = new Timer$1();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t;
}
var emptyOn$1 = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween$1 = [];
var CREATED$1 = 0;
var SCHEDULED$1 = 1;
var STARTING$1 = 2;
var STARTED$1 = 3;
var RUNNING$1 = 4;
var ENDING$1 = 5;
var ENDED$1 = 6;
function schedule$1(node2, name, id2, index2, group2, timing) {
  var schedules = node2.__transition;
  if (!schedules)
    node2.__transition = {};
  else if (id2 in schedules)
    return;
  create$1(node2, id2, {
    name,
    index: index2,
    // For context during callback.
    group: group2,
    // For context during callback.
    on: emptyOn$1,
    tween: emptyTween$1,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED$1
  });
}
function init$1(node2, id2) {
  var schedule2 = get$8(node2, id2);
  if (schedule2.state > CREATED$1)
    throw new Error("too late; already scheduled");
  return schedule2;
}
function set$3(node2, id2) {
  var schedule2 = get$8(node2, id2);
  if (schedule2.state > STARTED$1)
    throw new Error("too late; already running");
  return schedule2;
}
function get$8(node2, id2) {
  var schedule2 = node2.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2]))
    throw new Error("transition not found");
  return schedule2;
}
function create$1(node2, id2, self2) {
  var schedules = node2.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer$1(schedule2, 0, self2.time);
  function schedule2(elapsed) {
    self2.state = SCHEDULED$1;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed)
      start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self2.state !== SCHEDULED$1)
      return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name)
        continue;
      if (o.state === STARTED$1)
        return timeout$3(start2);
      if (o.state === RUNNING$1) {
        o.state = ENDED$1;
        o.timer.stop();
        o.on.call("interrupt", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED$1;
        o.timer.stop();
        o.on.call("cancel", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout$3(function() {
      if (self2.state === STARTED$1) {
        self2.state = RUNNING$1;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING$1;
    self2.on.call("start", node2, node2.__data__, self2.index, self2.group);
    if (self2.state !== STARTING$1)
      return;
    self2.state = STARTED$1;
    tween = new Array(n = self2.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self2.tween[i].value.call(node2, node2.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING$1, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node2, t);
    }
    if (self2.state === ENDING$1) {
      self2.on.call("end", node2, node2.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED$1;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules)
      return;
    delete node2.__transition;
  }
}
function interrupt$1(node2, name) {
  var schedules = node2.__transition, schedule2, active3, empty2 = true, i;
  if (!schedules)
    return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active3 = schedule2.state > STARTING$1 && schedule2.state < ENDING$1;
    schedule2.state = ENDED$1;
    schedule2.timer.stop();
    schedule2.on.call(active3 ? "interrupt" : "cancel", node2, node2.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2)
    delete node2.__transition;
}
function selection_interrupt$1(name) {
  return this.each(function() {
    interrupt$1(this, name);
  });
}
function tweenRemove$1(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set$3(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction$1(id2, name, value2) {
  var tween0, tween1;
  if (typeof value2 !== "function")
    throw new Error();
  return function() {
    var schedule2 = set$3(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {
        name,
        value: value2
      }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n)
        tween1.push(t);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween$1(name, value2) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get$8(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value2 == null ? tweenRemove$1 : tweenFunction$1)(id2, name, value2));
}
function tweenValue$1(transition3, name, value2) {
  var id2 = transition3._id;
  transition3.each(function() {
    var schedule2 = set$3(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value2.apply(this, arguments);
  });
  return function(node2) {
    return get$8(node2, id2).value[name];
  };
}
function interpolate$2(a, b) {
  var c2;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c2 = color(b)) ? (b = c2, interpolateRgb) : interpolateString)(a, b);
}
function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$1(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS$1(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction$1(name, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value2(this), string1;
    if (value1 == null)
      return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS$1(fullname, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value2(this), string1;
    if (value1 == null)
      return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr$1(name, value2) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$2;
  return this.attrTween(name, typeof value2 === "function" ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue$1(this, "attr." + name, value2)) : value2 == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname) : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value2));
}
function attrInterpolate$1(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS$1(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS$1(fullname, value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolateNS$1(fullname, i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function attrTween$1(name, value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolate$1(name, i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function transition_attrTween$1(name, value2) {
  var key = "attr." + name;
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS$1 : attrTween$1)(fullname, value2));
}
function delayFunction$1(id2, value2) {
  return function() {
    init$1(this, id2).delay = +value2.apply(this, arguments);
  };
}
function delayConstant$1(id2, value2) {
  return value2 = +value2, function() {
    init$1(this, id2).delay = value2;
  };
}
function transition_delay$1(value2) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value2 === "function" ? delayFunction$1 : delayConstant$1)(id2, value2)) : get$8(this.node(), id2).delay;
}
function durationFunction$1(id2, value2) {
  return function() {
    set$3(this, id2).duration = +value2.apply(this, arguments);
  };
}
function durationConstant$1(id2, value2) {
  return value2 = +value2, function() {
    set$3(this, id2).duration = value2;
  };
}
function transition_duration$1(value2) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value2 === "function" ? durationFunction$1 : durationConstant$1)(id2, value2)) : get$8(this.node(), id2).duration;
}
function easeConstant$1(id2, value2) {
  if (typeof value2 !== "function")
    throw new Error();
  return function() {
    set$3(this, id2).ease = value2;
  };
}
function transition_ease$1(value2) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant$1(id2, value2)) : get$8(this.node(), id2).ease;
}
function easeVarying$1(id2, value2) {
  return function() {
    var v = value2.apply(this, arguments);
    if (typeof v !== "function")
      throw new Error();
    set$3(this, id2).ease = v;
  };
}
function transition_easeVarying$1(value2) {
  if (typeof value2 !== "function")
    throw new Error();
  return this.each(easeVarying$1(this._id, value2));
}
function transition_filter$1(match) {
  if (typeof match !== "function")
    match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Transition$1(subgroups, this._parents, this._name, this._id);
}
function transition_merge$1(transition3) {
  if (transition3._id !== this._id)
    throw new Error();
  for (var groups0 = this._groups, groups1 = transition3._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition$1(merges, this._parents, this._name, this._id);
}
function start$2(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0)
      t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction$1(id2, name, listener) {
  var on0, on1, sit = start$2(name) ? init$1 : set$3;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0)
      (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on$1(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get$8(this.node(), id2).on.on(name) : this.each(onFunction$1(id2, name, listener));
}
function removeFunction$1(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition)
      if (+i !== id2)
        return;
    if (parent)
      parent.removeChild(this);
  };
}
function transition_remove$1() {
  return this.on("end.remove", removeFunction$1(this._id));
}
function transition_select$1(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2)
          subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
        schedule$1(subgroup[i], name, id2, i, subgroup, get$8(node2, id2));
      }
    }
  }
  return new Transition$1(subgroups, this._parents, name, id2);
}
function transition_selectAll$1(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        for (var children3 = select2.call(node2, node2.__data__, i, group2), child, inherit2 = get$8(node2, id2), k = 0, l = children3.length; k < l; ++k) {
          if (child = children3[k]) {
            schedule$1(child, name, id2, k, children3, inherit2);
          }
        }
        subgroups.push(children3);
        parents.push(node2);
      }
    }
  }
  return new Transition$1(subgroups, parents, name, id2);
}
var Selection$1 = selection.prototype.constructor;
function transition_selection$1() {
  return new Selection$1(this._groups, this._parents);
}
function styleNull$1(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$1(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction$1(name, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value2(this), string1 = value1 + "";
    if (value1 == null)
      string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove$1(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove3;
  return function() {
    var schedule2 = set$3(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove3 || (remove3 = styleRemove$1(name)) : void 0;
    if (on !== on0 || listener0 !== listener)
      (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style$1(name, value2, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$2;
  return value2 == null ? this.styleTween(name, styleNull$1(name, i)).on("end.style." + name, styleRemove$1(name)) : typeof value2 === "function" ? this.styleTween(name, styleFunction$1(name, i, tweenValue$1(this, "style." + name, value2))).each(styleMaybeRemove$1(this._id, name)) : this.styleTween(name, styleConstant$1(name, i, value2), priority).on("end.style." + name, null);
}
function styleInterpolate$1(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween$1(name, value2, priority) {
  var t, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t = (i0 = i) && styleInterpolate$1(name, i, priority);
    return t;
  }
  tween._value = value2;
  return tween;
}
function transition_styleTween$1(name, value2, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  return this.tween(key, styleTween$1(name, value2, priority == null ? "" : priority));
}
function textConstant$1(value2) {
  return function() {
    this.textContent = value2;
  };
}
function textFunction$1(value2) {
  return function() {
    var value1 = value2(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text$1(value2) {
  return this.tween("text", typeof value2 === "function" ? textFunction$1(tweenValue$1(this, "text", value2)) : textConstant$1(value2 == null ? "" : value2 + ""));
}
function textInterpolate$1(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween$1(value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && textInterpolate$1(i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function transition_textTween$1(value2) {
  var key = "text";
  if (arguments.length < 1)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  return this.tween(key, textTween$1(value2));
}
function transition_transition$1() {
  var name = this._name, id0 = this._id, id1 = newId$1();
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        var inherit2 = get$8(node2, id0);
        schedule$1(node2, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition$1(groups2, this._parents, name, id1);
}
function transition_end$1() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve2, reject) {
    var cancel = {
      value: reject
    }, end2 = {
      value: function() {
        if (--size === 0)
          resolve2();
      }
    };
    that.each(function() {
      var schedule2 = set$3(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end2);
      }
      schedule2.on = on1;
    });
    if (size === 0)
      resolve2();
  });
}
var id$1 = 0;
function Transition$1(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function newId$1() {
  return ++id$1;
}
var selection_prototype$1 = selection.prototype;
Transition$1.prototype = {
  constructor: Transition$1,
  select: transition_select$1,
  selectAll: transition_selectAll$1,
  filter: transition_filter$1,
  merge: transition_merge$1,
  selection: transition_selection$1,
  transition: transition_transition$1,
  call: selection_prototype$1.call,
  nodes: selection_prototype$1.nodes,
  node: selection_prototype$1.node,
  size: selection_prototype$1.size,
  empty: selection_prototype$1.empty,
  each: selection_prototype$1.each,
  on: transition_on$1,
  attr: transition_attr$1,
  attrTween: transition_attrTween$1,
  style: transition_style$1,
  styleTween: transition_styleTween$1,
  text: transition_text$1,
  textTween: transition_textTween$1,
  remove: transition_remove$1,
  tween: transition_tween$1,
  delay: transition_delay$1,
  duration: transition_duration$1,
  ease: transition_ease$1,
  easeVarying: transition_easeVarying$1,
  end: transition_end$1,
  [Symbol.iterator]: selection_prototype$1[Symbol.iterator]
};
function cubicInOut$1(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var defaultTiming$1 = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut$1
};
function inherit$1(node2, id2) {
  var timing;
  while (!(timing = node2.__transition) || !(timing = timing[id2])) {
    if (!(node2 = node2.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition$1(name) {
  var id2, timing;
  if (name instanceof Transition$1) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId$1(), (timing = defaultTiming$1).time = now$3(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        schedule$1(node2, name, id2, i, group2, timing || inherit$1(node2, id2));
      }
    }
  }
  return new Transition$1(groups2, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt$1;
selection.prototype.transition = selection_transition$1;
const constant$3 = (x) => () => x;
function BrushEvent(type3, {
  sourceEvent: sourceEvent2,
  target,
  selection: selection2,
  mode,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type3,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target,
      enumerable: true,
      configurable: true
    },
    selection: {
      value: selection2,
      enumerable: true,
      configurable: true
    },
    mode: {
      value: mode,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
function nopropagation$1(event) {
  event.stopImmediatePropagation();
}
function noevent$1(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var MODE_DRAG = {
  name: "drag"
}, MODE_SPACE = {
  name: "space"
}, MODE_HANDLE = {
  name: "handle"
}, MODE_CENTER = {
  name: "center"
};
const {
  abs: abs$1,
  max: max$2,
  min: min$1
} = Math;
function number1(e) {
  return [+e[0], +e[1]];
}
function number2(e) {
  return [number1(e[0]), number1(e[1])];
}
var X = {
  name: "x",
  handles: ["w", "e"].map(type$4),
  input: function(x, e) {
    return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]];
  },
  output: function(xy) {
    return xy && [xy[0][0], xy[1][0]];
  }
};
var Y = {
  name: "y",
  handles: ["n", "s"].map(type$4),
  input: function(y, e) {
    return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]];
  },
  output: function(xy) {
    return xy && [xy[0][1], xy[1][1]];
  }
};
var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type$4),
  input: function(xy) {
    return xy == null ? null : number2(xy);
  },
  output: function(xy) {
    return xy;
  }
};
var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};
var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};
var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};
var signsX = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
};
var signsY = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function type$4(t) {
  return {
    type: t
  };
}
function defaultFilter$1(event) {
  return !event.ctrlKey && !event.button;
}
function defaultExtent$1() {
  var svg = this.ownerSVGElement || this;
  if (svg.hasAttribute("viewBox")) {
    svg = svg.viewBox.baseVal;
    return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
  }
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}
function defaultTouchable$1() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function local(node2) {
  while (!node2.__brush)
    if (!(node2 = node2.parentNode))
      return;
  return node2.__brush;
}
function empty$1(extent2) {
  return extent2[0][0] === extent2[1][0] || extent2[0][1] === extent2[1][1];
}
function brushSelection(node2) {
  var state = node2.__brush;
  return state ? state.dim.output(state.selection) : null;
}
function brushX() {
  return brush$1(X);
}
function brushY() {
  return brush$1(Y);
}
function brush() {
  return brush$1(XY);
}
function brush$1(dim) {
  var extent2 = defaultExtent$1, filter4 = defaultFilter$1, touchable = defaultTouchable$1, keys3 = true, listeners = dispatch$1("start", "brush", "end"), handleSize = 6, touchending;
  function brush2(group2) {
    var overlay = group2.property("__brush", initialize).selectAll(".overlay").data([type$4("overlay")]);
    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
      var extent3 = local(this).extent;
      select$1(this).attr("x", extent3[0][0]).attr("y", extent3[0][1]).attr("width", extent3[1][0] - extent3[0][0]).attr("height", extent3[1][1] - extent3[0][1]);
    });
    group2.selectAll(".selection").data([type$4("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var handle = group2.selectAll(".handle").data(dim.handles, function(d) {
      return d.type;
    });
    handle.exit().remove();
    handle.enter().append("rect").attr("class", function(d) {
      return "handle handle--" + d.type;
    }).attr("cursor", function(d) {
      return cursors[d.type];
    });
    group2.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  brush2.move = function(group2, selection2) {
    if (group2.tween) {
      group2.on("start.brush", function(event) {
        emitter(this, arguments).beforestart().start(event);
      }).on("interrupt.brush end.brush", function(event) {
        emitter(this, arguments).end(event);
      }).tween("brush", function() {
        var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(this, arguments) : selection2, state.extent), i = interpolate$3(selection0, selection1);
        function tween(t) {
          state.selection = t === 1 && selection1 === null ? null : i(t);
          redraw.call(that);
          emit.brush();
        }
        return selection0 !== null && selection1 !== null ? tween : tween(1);
      });
    } else {
      group2.each(function() {
        var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(that, args) : selection2, state.extent), emit = emitter(that, args).beforestart();
        interrupt$1(that);
        state.selection = selection1 === null ? null : selection1;
        redraw.call(that);
        emit.start().brush().end();
      });
    }
  };
  brush2.clear = function(group2) {
    brush2.move(group2, null);
  };
  function redraw() {
    var group2 = select$1(this), selection2 = local(this).selection;
    if (selection2) {
      group2.selectAll(".selection").style("display", null).attr("x", selection2[0][0]).attr("y", selection2[0][1]).attr("width", selection2[1][0] - selection2[0][0]).attr("height", selection2[1][1] - selection2[0][1]);
      group2.selectAll(".handle").style("display", null).attr("x", function(d) {
        return d.type[d.type.length - 1] === "e" ? selection2[1][0] - handleSize / 2 : selection2[0][0] - handleSize / 2;
      }).attr("y", function(d) {
        return d.type[0] === "s" ? selection2[1][1] - handleSize / 2 : selection2[0][1] - handleSize / 2;
      }).attr("width", function(d) {
        return d.type === "n" || d.type === "s" ? selection2[1][0] - selection2[0][0] + handleSize : handleSize;
      }).attr("height", function(d) {
        return d.type === "e" || d.type === "w" ? selection2[1][1] - selection2[0][1] + handleSize : handleSize;
      });
    } else {
      group2.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
  }
  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }
  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }
  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1)
        this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode) {
      if (this.starting)
        this.starting = false, this.emit("start", event, mode);
      else
        this.emit("brush", event);
      return this;
    },
    brush: function(event, mode) {
      this.emit("brush", event, mode);
      return this;
    },
    end: function(event, mode) {
      if (--this.active === 0)
        delete this.state.emitter, this.emit("end", event, mode);
      return this;
    },
    emit: function(type3, event, mode) {
      var d = select$1(this.that).datum();
      listeners.call(type3, this.that, new BrushEvent(type3, {
        sourceEvent: event,
        target: brush2,
        selection: dim.output(this.state.selection),
        mode,
        dispatch: listeners
      }), d);
    }
  };
  function started(event) {
    if (touchending && !event.touches)
      return;
    if (!filter4.apply(this, arguments))
      return;
    var that = this, type3 = event.target.__data__.type, mode = (keys3 && event.metaKey ? type3 = "overlay" : type3) === "selection" ? MODE_DRAG : keys3 && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type3], signY = dim === X ? null : signsY[type3], state = local(that), extent3 = state.extent, selection2 = state.selection, W = extent3[0][0], w0, w1, N = extent3[0][1], n0, n1, E2 = extent3[1][0], e0, e1, S = extent3[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys3 && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [event], (t) => {
      const i = t.identifier;
      t = pointer(t, that);
      t.point0 = t.slice();
      t.identifier = i;
      return t;
    });
    if (type3 === "overlay") {
      if (selection2)
        moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection2 = [[w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]), n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])], [e0 = dim === Y ? E2 : max$2(pts[0][0], pts[1][0]), s0 = dim === X ? S : max$2(pts[0][1], pts[1][1])]];
      if (points.length > 1)
        move2();
    } else {
      w0 = selection2[0][0];
      n0 = selection2[0][1];
      e0 = selection2[1][0];
      s0 = selection2[1][1];
    }
    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;
    var group2 = select$1(that).attr("pointer-events", "none");
    var overlay = group2.selectAll(".overlay").attr("cursor", cursors[type3]);
    interrupt$1(that);
    var emit = emitter(that, arguments, true).beforestart();
    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select$1(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
      if (keys3)
        view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
      dragDisable(event.view);
    }
    redraw.call(that);
    emit.start(event, mode.name);
    function moved(event2) {
      for (const p of event2.changedTouches || [event2]) {
        for (const d of points)
          if (d.identifier === p.identifier)
            d.cur = pointer(p, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point2 = points[0];
        if (abs$1(point2.cur[0] - point2[0]) > abs$1(point2.cur[1] - point2[1]))
          lockY = true;
        else
          lockX = true;
      }
      for (const point2 of points)
        if (point2.cur)
          point2[0] = point2.cur[0], point2[1] = point2.cur[1];
      moving = true;
      noevent$1(event2);
      move2(event2);
    }
    function move2(event2) {
      const point2 = points[0], point0 = point2.point0;
      var t;
      dx = point2[0] - point0[0];
      dy = point2[1] - point0[1];
      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX)
            dx = max$2(W - w0, min$1(E2 - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY)
            dy = max$2(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX)
              w1 = max$2(W, min$1(E2, points[0][0])), e1 = max$2(W, min$1(E2, points[1][0])), signX = 1;
            if (signY)
              n1 = max$2(N, min$1(S, points[0][1])), s1 = max$2(N, min$1(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0)
              dx = max$2(W - w0, min$1(E2 - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0)
              dx = max$2(W - e0, min$1(E2 - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0)
              dy = max$2(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0)
              dy = max$2(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX)
            w1 = max$2(W, min$1(E2, w0 - dx * signX)), e1 = max$2(W, min$1(E2, e0 + dx * signX));
          if (signY)
            n1 = max$2(N, min$1(S, n0 - dy * signY)), s1 = max$2(N, min$1(S, s0 + dy * signY));
          break;
        }
      }
      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type3 in flipX)
          overlay.attr("cursor", cursors[type3 = flipX[type3]]);
      }
      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type3 in flipY)
          overlay.attr("cursor", cursors[type3 = flipY[type3]]);
      }
      if (state.selection)
        selection2 = state.selection;
      if (lockX)
        w1 = selection2[0][0], e1 = selection2[1][0];
      if (lockY)
        n1 = selection2[0][1], s1 = selection2[1][1];
      if (selection2[0][0] !== w1 || selection2[0][1] !== n1 || selection2[1][0] !== e1 || selection2[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event2, mode.name);
      }
    }
    function ended(event2) {
      nopropagation$1(event2);
      if (event2.touches) {
        if (event2.touches.length)
          return;
        if (touchending)
          clearTimeout(touchending);
        touchending = setTimeout(function() {
          touchending = null;
        }, 500);
      } else {
        yesdrag(event2.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group2.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection)
        selection2 = state.selection;
      if (empty$1(selection2))
        state.selection = null, redraw.call(that);
      emit.end(event2, mode.name);
    }
    function keydowned(event2) {
      switch (event2.keyCode) {
        case 16: {
          shifting = signX && signY;
          break;
        }
        case 18: {
          if (mode === MODE_HANDLE) {
            if (signX)
              e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY)
              s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move2();
          }
          break;
        }
        case 32: {
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0)
              e0 = e1 - dx;
            else if (signX > 0)
              w0 = w1 - dx;
            if (signY < 0)
              s0 = s1 - dy;
            else if (signY > 0)
              n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move2();
          }
          break;
        }
        default:
          return;
      }
      noevent$1(event2);
    }
    function keyupped(event2) {
      switch (event2.keyCode) {
        case 16: {
          if (shifting) {
            lockX = lockY = shifting = false;
            move2();
          }
          break;
        }
        case 18: {
          if (mode === MODE_CENTER) {
            if (signX < 0)
              e0 = e1;
            else if (signX > 0)
              w0 = w1;
            if (signY < 0)
              s0 = s1;
            else if (signY > 0)
              n0 = n1;
            mode = MODE_HANDLE;
            move2();
          }
          break;
        }
        case 32: {
          if (mode === MODE_SPACE) {
            if (event2.altKey) {
              if (signX)
                e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY)
                s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0)
                e0 = e1;
              else if (signX > 0)
                w0 = w1;
              if (signY < 0)
                s0 = s1;
              else if (signY > 0)
                n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type3]);
            move2();
          }
          break;
        }
        default:
          return;
      }
      noevent$1(event2);
    }
  }
  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }
  function touchended(event) {
    emitter(this, arguments).ended(event);
  }
  function initialize() {
    var state = this.__brush || {
      selection: null
    };
    state.extent = number2(extent2.apply(this, arguments));
    state.dim = dim;
    return state;
  }
  brush2.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant$3(number2(_)), brush2) : extent2;
  };
  brush2.filter = function(_) {
    return arguments.length ? (filter4 = typeof _ === "function" ? _ : constant$3(!!_), brush2) : filter4;
  };
  brush2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$3(!!_), brush2) : touchable;
  };
  brush2.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush2) : handleSize;
  };
  brush2.keyModifiers = function(_) {
    return arguments.length ? (keys3 = !!_, brush2) : keys3;
  };
  brush2.on = function() {
    var value2 = listeners.on.apply(listeners, arguments);
    return value2 === listeners ? brush2 : value2;
  };
  return brush2;
}
const d3Brush = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  brush,
  brushSelection,
  brushX,
  brushY
}, Symbol.toStringTag, { value: "Module" }));
function _extends$n() {
  _extends$n = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$n.apply(this, arguments);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(r2, l) {
  var t = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f2 = true, o = false;
    try {
      if (i = (t = t.call(r2)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f2 = false;
      } else
        for (; !(f2 = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f2 = true)
          ;
    } catch (r3) {
      o = true, n = r3;
    } finally {
      try {
        if (!f2 && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _typeof$4(o) {
  "@babel/helpers - typeof";
  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$4(o);
}
function _toPrimitive$1B(input, hint) {
  if (_typeof$4(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$4(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1B(arg) {
  var key = _toPrimitive$1B(arg, "string");
  return _typeof$4(key) === "symbol" ? key : String(key);
}
function _defineProperty$2(obj, key, value2) {
  key = _toPropertyKey$1B(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2.push.apply(ownKeys2, Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    });
  }
  return target;
}
function _classCallCheck$1N(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1B(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1B(descriptor.key), descriptor);
  }
}
function _createClass$1L(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1B(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1B(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _assertThisInitialized$1g(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1r(self2, call2) {
  if (call2 && (_typeof$4(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1g(self2);
}
function _getPrototypeOf$1g(o) {
  _getPrototypeOf$1g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1g(o);
}
function _setPrototypeOf$1g(o, p) {
  _setPrototypeOf$1g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1g(o, p);
}
function _inherits$1r(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf$1g(subClass, superClass);
}
var invariant = function(condition, format2, a, b, c2, d, e, f2) {
  if (!condition) {
    var error;
    if (format2 === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b, c2, d, e, f2];
      var argIndex = 0;
      error = new Error(format2.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
};
var browser = invariant;
const invariant$1 = /* @__PURE__ */ getDefaultExportFromCjs(browser);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var Manager = function() {
  function Manager2() {
    _classCallCheck$1N(this, Manager2);
    _defineProperty$2(this, "refs", {});
  }
  _createClass$1L(Manager2, [{
    key: "add",
    value: function add3(collection, ref2) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }
      this.refs[collection].push(ref2);
    }
  }, {
    key: "remove",
    value: function remove3(collection, ref2) {
      var index2 = this.getIndex(collection, ref2);
      if (index2 !== -1) {
        this.refs[collection].splice(index2, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;
      return this.refs[this.active.collection].find(function(_ref) {
        var node2 = _ref.node;
        return node2.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref2) {
      return this.refs[collection].indexOf(ref2);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.active.collection;
      return this.refs[collection].sort(sortByIndex);
    }
  }]);
  return Manager2;
}();
function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;
  return index1 - index2;
}
function arrayMove(array2, from, to) {
  array2 = array2.slice();
  array2.splice(to < 0 ? array2.length + to : to, 0, array2.splice(from, 1)[0]);
  return array2;
}
function omit(obj, keysToOmit) {
  return Object.keys(obj).reduce(function(acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
var events = {
  end: ["touchend", "touchcancel", "mouseup"],
  move: ["touchmove", "mousemove"],
  start: ["touchstart", "mousedown"]
};
var vendorPrefix = function() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return "";
  }
  var styles2 = window.getComputedStyle(document.documentElement, "") || ["-moz-hidden-iframe"];
  var pre = (Array.prototype.slice.call(styles2).join("").match(/-(moz|webkit|ms)-/) || styles2.OLink === "" && ["", "o"])[1];
  switch (pre) {
    case "ms":
      return "ms";
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : "";
  }
}();
function setInlineStyles(node2, styles2) {
  Object.keys(styles2).forEach(function(key) {
    node2.style[key] = styles2[key];
  });
}
function setTranslate3d(node2, translate) {
  node2.style["".concat(vendorPrefix, "Transform")] = translate == null ? "" : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function setTransitionDuration(node2, duration) {
  node2.style["".concat(vendorPrefix, "TransitionDuration")] = duration == null ? "" : "".concat(duration, "ms");
}
function closest$1(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }
    el = el.parentNode;
  }
  return null;
}
function limit(min2, max2, value2) {
  return Math.max(min2, Math.min(value2, max2));
}
function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === "px") {
    return parseFloat(stringValue);
  }
  return 0;
}
function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft),
    right: getPixelValue(style.marginRight),
    top: getPixelValue(style.marginTop)
  };
}
function provideDisplayName(prefix2, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? "".concat(prefix2, "(").concat(componentName, ")") : prefix2;
}
function getScrollAdjustedBoundingClientRect(node2, scrollDelta) {
  var boundingClientRect = node2.getBoundingClientRect();
  return {
    top: boundingClientRect.top + scrollDelta.top,
    left: boundingClientRect.left + scrollDelta.left
  };
}
function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}
function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function getEdgeOffset(node2, parent) {
  var offset2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    left: 0,
    top: 0
  };
  if (!node2) {
    return void 0;
  }
  var nodeOffset = {
    left: offset2.left + node2.offsetLeft,
    top: offset2.top + node2.offsetTop
  };
  if (node2.parentNode === parent) {
    return nodeOffset;
  }
  return getEdgeOffset(node2.parentNode, parent, nodeOffset);
}
function getTargetIndex(newIndex, prevIndex, oldIndex) {
  if (newIndex < oldIndex && newIndex > prevIndex) {
    return newIndex - 1;
  } else if (newIndex > oldIndex && newIndex < prevIndex) {
    return newIndex + 1;
  } else {
    return newIndex;
  }
}
function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset, width = _ref.width, height2 = _ref.height;
  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit2 = "px";
  if (typeof lockOffset === "string") {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    invariant$1(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit2 = match[1];
  }
  invariant$1(isFinite(offsetX) && isFinite(offsetY), "lockOffset value should be a finite. Given %s", lockOffset);
  if (unit2 === "%") {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height2 / 100;
  }
  return {
    x: offsetX,
    y: offsetY
  };
}
function getLockPixelOffsets(_ref2) {
  var height2 = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
  var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
  invariant$1(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
  var _offsets = _slicedToArray$2(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
  return [getLockPixelOffset({
    height: height2,
    lockOffset: minLockOffset,
    width
  }), getLockPixelOffset({
    height: height2,
    lockOffset: maxLockOffset,
    width
  })];
}
function isScrollable(el) {
  var computedStyle = window.getComputedStyle(el);
  var overflowRegex = /(auto|scroll)/;
  var properties2 = ["overflow", "overflowX", "overflowY"];
  return properties2.find(function(property2) {
    return overflowRegex.test(computedStyle[property2]);
  });
}
function getScrollingParent(el) {
  if (!(el instanceof HTMLElement)) {
    return null;
  } else if (isScrollable(el)) {
    return el;
  } else {
    return getScrollingParent(el.parentNode);
  }
}
function getContainerGridGap(element) {
  var style = window.getComputedStyle(element);
  if (style.display === "grid") {
    return {
      x: getPixelValue(style.gridColumnGap),
      y: getPixelValue(style.gridRowGap)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var KEYCODE = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var NodeType = {
  Anchor: "A",
  Button: "BUTTON",
  Canvas: "CANVAS",
  Input: "INPUT",
  Option: "OPTION",
  Textarea: "TEXTAREA",
  Select: "SELECT"
};
function cloneNode$1(node2) {
  var selector2 = "input, textarea, select, canvas, [contenteditable]";
  var fields = node2.querySelectorAll(selector2);
  var clonedNode = node2.cloneNode(true);
  var clonedFields = _toConsumableArray$2(clonedNode.querySelectorAll(selector2));
  clonedFields.forEach(function(field, i) {
    if (field.type !== "file") {
      field.value = fields[i].value;
    }
    if (field.type === "radio" && field.name) {
      field.name = "__sortableClone__".concat(field.name);
    }
    if (field.tagName === NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
      var destCtx = field.getContext("2d");
      destCtx.drawImage(fields[i], 0, 0);
    }
  });
  return clonedNode;
}
function sortableHandle(WrappedComponent) {
  var _class, _temp;
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function(_React$Component) {
    _inherits$1r(WithSortableHandle, _React$Component);
    function WithSortableHandle() {
      _classCallCheck$1N(this, WithSortableHandle);
      return _possibleConstructorReturn$1r(this, _getPrototypeOf$1g(WithSortableHandle).apply(this, arguments));
    }
    _createClass$1L(WithSortableHandle, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var node2 = findDOMNode$1(this);
        node2.sortableHandle = true;
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant$1(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call");
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render3() {
        var ref2 = config.withRef ? "wrappedInstance" : null;
        return /* @__PURE__ */ createElement(WrappedComponent, _extends$n({
          ref: ref2
        }, this.props));
      }
    }]);
    return WithSortableHandle;
  }(Component), _defineProperty$2(_class, "displayName", provideDisplayName("sortableHandle", WrappedComponent)), _temp;
}
function isSortableHandle(node2) {
  return node2.sortableHandle != null;
}
var AutoScroller = function() {
  function AutoScroller2(container, onScrollCallback) {
    _classCallCheck$1N(this, AutoScroller2);
    this.container = container;
    this.onScrollCallback = onScrollCallback;
  }
  _createClass$1L(AutoScroller2, [{
    key: "clear",
    value: function clear2() {
      if (this.interval == null) {
        return;
      }
      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "update",
    value: function update2(_ref) {
      var _this = this;
      var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height2 = _ref.height;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };
      var _this$container = this.container, scrollTop2 = _this$container.scrollTop, scrollLeft2 = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
      var isTop = scrollTop2 === 0;
      var isBottom = scrollHeight - scrollTop2 - clientHeight === 0;
      var isLeft = scrollLeft2 === 0;
      var isRight = scrollWidth - scrollLeft2 - clientWidth === 0;
      if (translate.y >= maxTranslate.y - height2 / 2 && !isBottom) {
        direction.y = 1;
        speed.y = acceleration.y * Math.abs((maxTranslate.y - height2 / 2 - translate.y) / height2);
      } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
        direction.x = 1;
        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
      } else if (translate.y <= minTranslate.y + height2 / 2 && !isTop) {
        direction.y = -1;
        speed.y = acceleration.y * Math.abs((translate.y - height2 / 2 - minTranslate.y) / height2);
      } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
        direction.x = -1;
        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
      }
      if (this.interval) {
        this.clear();
        this.isAutoScrolling = false;
      }
      if (direction.x !== 0 || direction.y !== 0) {
        this.interval = setInterval(function() {
          _this.isAutoScrolling = true;
          var offset2 = {
            left: speed.x * direction.x,
            top: speed.y * direction.y
          };
          _this.container.scrollTop += offset2.top;
          _this.container.scrollLeft += offset2.left;
          _this.onScrollCallback(offset2);
        }, 5);
      }
    }
  }]);
  return AutoScroller2;
}();
function defaultGetHelperDimensions(_ref) {
  var node2 = _ref.node;
  return {
    height: node2.offsetHeight,
    width: node2.offsetWidth
  };
}
function defaultShouldCancelStart(event) {
  var interactiveElements = [NodeType.Input, NodeType.Textarea, NodeType.Select, NodeType.Option, NodeType.Button];
  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    return true;
  }
  if (closest$1(event.target, function(el) {
    return el.contentEditable === "true";
  })) {
    return true;
  }
  return false;
}
var propTypes = {
  axis: PropTypes.oneOf(["x", "y", "xy"]),
  contentWindow: PropTypes.any,
  disableAutoscroll: PropTypes.bool,
  distance: PropTypes.number,
  getContainer: PropTypes.func,
  getHelperDimensions: PropTypes.func,
  helperClass: PropTypes.string,
  helperContainer: PropTypes.oneOfType([PropTypes.func, typeof HTMLElement === "undefined" ? PropTypes.any : PropTypes.instanceOf(HTMLElement)]),
  hideSortableGhost: PropTypes.bool,
  keyboardSortingTransitionDuration: PropTypes.number,
  lockAxis: PropTypes.string,
  lockOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),
  lockToContainerEdges: PropTypes.bool,
  onSortEnd: PropTypes.func,
  onSortMove: PropTypes.func,
  onSortOver: PropTypes.func,
  onSortStart: PropTypes.func,
  pressDelay: PropTypes.number,
  pressThreshold: PropTypes.number,
  keyCodes: PropTypes.shape({
    lift: PropTypes.arrayOf(PropTypes.number),
    drop: PropTypes.arrayOf(PropTypes.number),
    cancel: PropTypes.arrayOf(PropTypes.number),
    up: PropTypes.arrayOf(PropTypes.number),
    down: PropTypes.arrayOf(PropTypes.number)
  }),
  shouldCancelStart: PropTypes.func,
  transitionDuration: PropTypes.number,
  updateBeforeSortStart: PropTypes.func,
  useDragHandle: PropTypes.bool,
  useWindowAsScrollContainer: PropTypes.bool
};
var defaultKeyCodes = {
  lift: [KEYCODE.SPACE],
  drop: [KEYCODE.SPACE],
  cancel: [KEYCODE.ESC],
  up: [KEYCODE.UP, KEYCODE.LEFT],
  down: [KEYCODE.DOWN, KEYCODE.RIGHT]
};
var defaultProps = {
  axis: "y",
  disableAutoscroll: false,
  distance: 0,
  getHelperDimensions: defaultGetHelperDimensions,
  hideSortableGhost: true,
  lockOffset: "50%",
  lockToContainerEdges: false,
  pressDelay: 0,
  pressThreshold: 5,
  keyCodes: defaultKeyCodes,
  shouldCancelStart: defaultShouldCancelStart,
  transitionDuration: 300,
  useWindowAsScrollContainer: false
};
var omittedProps = Object.keys(propTypes);
function validateProps(props) {
  invariant$1(!(props.distance && props.pressDelay), "Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.");
}
function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }
  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }
  return finalizer(false, value);
}
function sortableContainer(WrappedComponent) {
  var _class, _temp;
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function(_React$Component) {
    _inherits$1r(WithSortableContainer, _React$Component);
    function WithSortableContainer(props) {
      var _this;
      _classCallCheck$1N(this, WithSortableContainer);
      _this = _possibleConstructorReturn$1r(this, _getPrototypeOf$1g(WithSortableContainer).call(this, props));
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "state", {});
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleStart", function(event) {
        var _this$props = _this.props, distance2 = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }
        _this.touched = true;
        _this.position = getPosition(event);
        var node2 = closest$1(event.target, function(el) {
          return el.sortableInfo != null;
        });
        if (node2 && node2.sortableInfo && _this.nodeIsChild(node2) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node2.sortableInfo, index2 = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
          if (disabled) {
            return;
          }
          if (useDragHandle && !closest$1(event.target, isSortableHandle)) {
            return;
          }
          _this.manager.active = {
            collection,
            index: index2
          };
          if (!isTouchEvent(event) && event.target.tagName === NodeType.Anchor) {
            event.preventDefault();
          }
          if (!distance2) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function() {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "nodeIsChild", function(node2) {
        return node2.sortableInfo.manager === _this.manager;
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleMove", function(event) {
        var _this$props2 = _this.props, distance2 = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
        if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: _this.position.x - position.x,
            y: _this.position.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          _this.delta = delta;
          if (!distance2 && (!pressThreshold || combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance2 && combinedDelta >= distance2 && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleEnd", function() {
        _this.touched = false;
        _this.cancel();
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "cancel", function() {
        var distance2 = _this.props.distance;
        var sorting = _this.state.sorting;
        if (!sorting) {
          if (!distance2) {
            clearTimeout(_this.pressTimer);
          }
          _this.manager.active = null;
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handlePress", function(event) {
        try {
          var active3 = _this.manager.getActive();
          var _temp6 = function() {
            if (active3) {
              var _temp7 = function _temp72() {
                var index2 = _node.sortableInfo.index;
                var margin = getElementMargin(_node);
                var gridGap = getContainerGridGap(_this.container);
                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                var dimensions = _getHelperDimensions({
                  index: index2,
                  node: _node,
                  collection: _collection
                });
                _this.node = _node;
                _this.margin = margin;
                _this.gridGap = gridGap;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                  y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                };
                _this.boundingClientRect = _node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index2;
                _this.newIndex = index2;
                _this.axis = {
                  x: _axis.indexOf("x") >= 0,
                  y: _axis.indexOf("y") >= 0
                };
                _this.offsetEdge = getEdgeOffset(_node, _this.container);
                if (_isKeySorting) {
                  _this.initialOffset = getPosition(_objectSpread({}, event, {
                    pageX: _this.boundingClientRect.left,
                    pageY: _this.boundingClientRect.top
                  }));
                } else {
                  _this.initialOffset = getPosition(event);
                }
                _this.initialScroll = {
                  left: _this.scrollContainer.scrollLeft,
                  top: _this.scrollContainer.scrollTop
                };
                _this.initialWindowScroll = {
                  left: window.pageXOffset,
                  top: window.pageYOffset
                };
                _this.helper = _this.helperContainer.appendChild(cloneNode$1(_node));
                setInlineStyles(_this.helper, {
                  boxSizing: "border-box",
                  height: "".concat(_this.height, "px"),
                  left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                  pointerEvents: "none",
                  position: "fixed",
                  top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                  width: "".concat(_this.width, "px")
                });
                if (_isKeySorting) {
                  _this.helper.focus();
                }
                if (_hideSortableGhost) {
                  _this.sortableGhost = _node;
                  setInlineStyles(_node, {
                    opacity: 0,
                    visibility: "hidden"
                  });
                }
                _this.minTranslate = {};
                _this.maxTranslate = {};
                if (_isKeySorting) {
                  var _ref = _useWindowAsScrollContainer ? {
                    top: 0,
                    left: 0,
                    width: _this.contentWindow.innerWidth,
                    height: _this.contentWindow.innerHeight
                  } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                  var containerBottom = containerTop + containerHeight;
                  var containerRight = containerLeft + containerWidth;
                  if (_this.axis.x) {
                    _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                    _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                  }
                  if (_this.axis.y) {
                    _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                    _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                  }
                } else {
                  if (_this.axis.x) {
                    _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                    _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                  }
                  if (_this.axis.y) {
                    _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                    _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                  }
                }
                if (_helperClass) {
                  _helperClass.split(" ").forEach(function(className2) {
                    return _this.helper.classList.add(className2);
                  });
                }
                _this.listenerNode = event.touches ? _node : _this.contentWindow;
                if (_isKeySorting) {
                  _this.listenerNode.addEventListener("wheel", _this.handleKeyEnd, true);
                  _this.listenerNode.addEventListener("mousedown", _this.handleKeyEnd, true);
                  _this.listenerNode.addEventListener("keydown", _this.handleKeyDown);
                } else {
                  events.move.forEach(function(eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                  });
                  events.end.forEach(function(eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                  });
                }
                _this.setState({
                  sorting: true,
                  sortingIndex: index2
                });
                if (_onSortStart) {
                  _onSortStart({
                    node: _node,
                    index: index2,
                    collection: _collection,
                    isKeySorting: _isKeySorting,
                    nodes: _this.manager.getOrderedRefs(),
                    helper: _this.helper
                  }, event);
                }
                if (_isKeySorting) {
                  _this.keyMove(0);
                }
              };
              var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
              var _node = active3.node, _collection = active3.collection;
              var _isKeySorting = _this.manager.isKeySorting;
              var _temp8 = function() {
                if (typeof updateBeforeSortStart === "function") {
                  _this._awaitingUpdateBeforeSortStart = true;
                  var _temp9 = _finallyRethrows(function() {
                    var index2 = _node.sortableInfo.index;
                    return Promise.resolve(updateBeforeSortStart({
                      collection: _collection,
                      index: index2,
                      node: _node,
                      isKeySorting: _isKeySorting
                    }, event)).then(function() {
                    });
                  }, function(_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown)
                      throw _result;
                    return _result;
                  });
                  if (_temp9 && _temp9.then)
                    return _temp9.then(function() {
                    });
                }
              }();
              return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
            }
          }();
          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {
          }) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleSortMove", function(event) {
        var onSortMove = _this.props.onSortMove;
        if (typeof event.preventDefault === "function") {
          event.preventDefault();
        }
        _this.updateHelperPosition(event);
        _this.animateNodes();
        _this.autoscroll();
        if (onSortMove) {
          onSortMove(event);
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleSortEnd", function(event) {
        var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
        var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
        var nodes = _this.manager.getOrderedRefs();
        if (_this.listenerNode) {
          if (isKeySorting) {
            _this.listenerNode.removeEventListener("wheel", _this.handleKeyEnd, true);
            _this.listenerNode.removeEventListener("mousedown", _this.handleKeyEnd, true);
            _this.listenerNode.removeEventListener("keydown", _this.handleKeyDown);
          } else {
            events.move.forEach(function(eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });
            events.end.forEach(function(eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          }
        }
        _this.helper.parentNode.removeChild(_this.helper);
        if (hideSortableGhost && _this.sortableGhost) {
          setInlineStyles(_this.sortableGhost, {
            opacity: "",
            visibility: ""
          });
        }
        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node2 = nodes[i];
          var el = _node2.node;
          _node2.edgeOffset = null;
          _node2.boundingClientRect = null;
          setTranslate3d(el, null);
          setTransitionDuration(el, null);
          _node2.translate = null;
        }
        _this.autoScroller.clear();
        _this.manager.active = null;
        _this.manager.isKeySorting = false;
        _this.setState({
          sorting: false,
          sortingIndex: null
        });
        if (typeof onSortEnd === "function") {
          onSortEnd({
            collection,
            newIndex: _this.newIndex,
            oldIndex: _this.index,
            isKeySorting,
            nodes
          }, event);
        }
        _this.touched = false;
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "autoscroll", function() {
        var disableAutoscroll = _this.props.disableAutoscroll;
        var isKeySorting = _this.manager.isKeySorting;
        if (disableAutoscroll) {
          _this.autoScroller.clear();
          return;
        }
        if (isKeySorting) {
          var translate = _objectSpread({}, _this.translate);
          var scrollX = 0;
          var scrollY = 0;
          if (_this.axis.x) {
            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
            scrollX = _this.translate.x - translate.x;
          }
          if (_this.axis.y) {
            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
            scrollY = _this.translate.y - translate.y;
          }
          _this.translate = translate;
          setTranslate3d(_this.helper, _this.translate);
          _this.scrollContainer.scrollLeft += scrollX;
          _this.scrollContainer.scrollTop += scrollY;
          return;
        }
        _this.autoScroller.update({
          height: _this.height,
          maxTranslate: _this.maxTranslate,
          minTranslate: _this.minTranslate,
          translate: _this.translate,
          width: _this.width
        });
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "onAutoScroll", function(offset2) {
        _this.translate.x += offset2.left;
        _this.translate.y += offset2.top;
        _this.animateNodes();
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleKeyDown", function(event) {
        var keyCode = event.keyCode;
        var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
        var keyCodes = _objectSpread({}, defaultKeyCodes, customKeyCodes);
        if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        if (keyCodes.lift.includes(keyCode) && !_this.manager.active) {
          _this.keyLift(event);
        } else if (keyCodes.drop.includes(keyCode) && _this.manager.active) {
          _this.keyDrop(event);
        } else if (keyCodes.cancel.includes(keyCode)) {
          _this.newIndex = _this.manager.active.index;
          _this.keyDrop(event);
        } else if (keyCodes.up.includes(keyCode)) {
          _this.keyMove(-1);
        } else if (keyCodes.down.includes(keyCode)) {
          _this.keyMove(1);
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "keyLift", function(event) {
        var target = event.target;
        var node2 = closest$1(target, function(el) {
          return el.sortableInfo != null;
        });
        var _node$sortableInfo2 = node2.sortableInfo, index2 = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
        _this.initialFocusedNode = target;
        _this.manager.isKeySorting = true;
        _this.manager.active = {
          index: index2,
          collection
        };
        _this.handlePress(event);
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "keyMove", function(shift2) {
        var nodes = _this.manager.getOrderedRefs();
        var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
        var newIndex = _this.newIndex + shift2;
        var prevIndex = _this.newIndex;
        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }
        _this.prevIndex = prevIndex;
        _this.newIndex = newIndex;
        var targetIndex = getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
        var target = nodes.find(function(_ref2) {
          var node2 = _ref2.node;
          return node2.sortableInfo.index === targetIndex;
        });
        var targetNode = target.node;
        var scrollDelta = _this.containerScrollDelta;
        var targetBoundingClientRect = target.boundingClientRect || getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
        var targetTranslate = target.translate || {
          x: 0,
          y: 0
        };
        var targetPosition = {
          top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
          left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
        };
        var shouldAdjustForSize = prevIndex < newIndex;
        var sizeAdjustment = {
          x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
          y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
        };
        _this.handleSortMove({
          pageX: targetPosition.left + sizeAdjustment.x,
          pageY: targetPosition.top + sizeAdjustment.y,
          ignoreTransition: shift2 === 0
        });
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "keyDrop", function(event) {
        _this.handleSortEnd(event);
        if (_this.initialFocusedNode) {
          _this.initialFocusedNode.focus();
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "handleKeyEnd", function(event) {
        if (_this.manager.active) {
          _this.keyDrop(event);
        }
      });
      _defineProperty$2(_assertThisInitialized$1g(_assertThisInitialized$1g(_this)), "isValidSortingTarget", function(event) {
        var useDragHandle = _this.props.useDragHandle;
        var target = event.target;
        var node2 = closest$1(target, function(el) {
          return el.sortableInfo != null;
        });
        return node2 && node2.sortableInfo && !node2.sortableInfo.disabled && (useDragHandle ? isSortableHandle(target) : target.sortableInfo);
      });
      validateProps(props);
      _this.manager = new Manager();
      _this.events = {
        end: _this.handleEnd,
        move: _this.handleMove,
        start: _this.handleStart
      };
      return _this;
    }
    _createClass$1L(WithSortableContainer, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        var container = this.getContainer();
        Promise.resolve(container).then(function(containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;
          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
          _this2.contentWindow = typeof contentWindow === "function" ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : getScrollingParent(_this2.container) || _this2.container;
          _this2.autoScroller = new AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
          Object.keys(_this2.events).forEach(function(key) {
            return events[key].forEach(function(eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          });
          _this2.container.addEventListener("keydown", _this2.handleKeyDown);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;
        if (this.helper && this.helper.parentNode) {
          this.helper.parentNode.removeChild(this.helper);
        }
        if (!this.container) {
          return;
        }
        Object.keys(this.events).forEach(function(key) {
          return events[key].forEach(function(eventName) {
            return _this3.container.removeEventListener(eventName, _this3.events[key]);
          });
        });
        this.container.removeEventListener("keydown", this.handleKeyDown);
      }
    }, {
      key: "updateHelperPosition",
      value: function updateHelperPosition(event) {
        var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
        var isKeySorting = this.manager.isKeySorting;
        var ignoreTransition = event.ignoreTransition;
        var offset2 = getPosition(event);
        var translate = {
          x: offset2.x - this.initialOffset.x,
          y: offset2.y - this.initialOffset.y
        };
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
        this.translate = translate;
        if (lockToContainerEdges) {
          var _getLockPixelOffsets = getLockPixelOffsets({
            height: this.height,
            lockOffset,
            width: this.width
          }), _getLockPixelOffsets2 = _slicedToArray$2(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };
          translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }
        if (lockAxis === "x") {
          translate.y = 0;
        } else if (lockAxis === "y") {
          translate.x = 0;
        }
        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) {
          setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
        }
        setTranslate3d(this.helper, translate);
      }
    }, {
      key: "animateNodes",
      value: function animateNodes() {
        var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
        var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
        var nodes = this.manager.getOrderedRefs();
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var isKeySorting = this.manager.isKeySorting;
        var prevIndex = this.newIndex;
        this.newIndex = null;
        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node3 = nodes[i].node;
          var index2 = _node3.sortableInfo.index;
          var width = _node3.offsetWidth;
          var height2 = _node3.offsetHeight;
          var offset2 = {
            height: this.height > height2 ? height2 / 2 : this.height / 2,
            width: this.width > width ? width / 2 : this.width / 2
          };
          var mustShiftBackward = isKeySorting && index2 > this.index && index2 <= prevIndex;
          var mustShiftForward = isKeySorting && index2 < this.index && index2 >= prevIndex;
          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;
          if (!edgeOffset) {
            edgeOffset = getEdgeOffset(_node3, this.container);
            nodes[i].edgeOffset = edgeOffset;
            if (isKeySorting) {
              nodes[i].boundingClientRect = getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
            }
          }
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);
            if (isKeySorting) {
              nextNode.boundingClientRect = getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
            }
          }
          if (index2 === this.index) {
            if (hideSortableGhost) {
              this.sortableGhost = _node3;
              setInlineStyles(_node3, {
                opacity: 0,
                visibility: "hidden"
              });
            }
            continue;
          }
          if (transitionDuration) {
            setTransitionDuration(_node3, transitionDuration);
          }
          if (this.axis.x) {
            if (this.axis.y) {
              if (mustShiftForward || index2 < this.index && (sortingOffset.left + windowScrollDelta.left - offset2.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset2.height || sortingOffset.top + windowScrollDelta.top + offset2.height <= edgeOffset.top)) {
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset2.width) {
                  if (nextNode) {
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }
                }
                if (this.newIndex === null) {
                  this.newIndex = index2;
                }
              } else if (mustShiftBackward || index2 > this.index && (sortingOffset.left + windowScrollDelta.left + offset2.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset2.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset2.height >= edgeOffset.top + height2)) {
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset2.width) {
                  if (prevNode) {
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }
                }
                this.newIndex = index2;
              }
            } else {
              if (mustShiftBackward || index2 > this.index && sortingOffset.left + windowScrollDelta.left + offset2.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index2;
              } else if (mustShiftForward || index2 < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset2.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index2;
                }
              }
            }
          } else if (this.axis.y) {
            if (mustShiftBackward || index2 > this.index && sortingOffset.top + windowScrollDelta.top + offset2.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index2;
            } else if (mustShiftForward || index2 < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset2.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index2;
              }
            }
          }
          setTranslate3d(_node3, translate);
          nodes[i].translate = translate;
        }
        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
        if (isKeySorting) {
          this.newIndex = prevIndex;
        }
        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
        if (onSortOver && this.newIndex !== oldIndex) {
          onSortOver({
            collection: this.manager.active.collection,
            index: this.index,
            newIndex: this.newIndex,
            oldIndex,
            isKeySorting,
            nodes,
            helper: this.helper
          });
        }
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant$1(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call");
        return this.refs.wrappedInstance;
      }
    }, {
      key: "getContainer",
      value: function getContainer() {
        var getContainer2 = this.props.getContainer;
        if (typeof getContainer2 !== "function") {
          return findDOMNode$1(this);
        }
        return getContainer2(config.withRef ? this.getWrappedInstance() : void 0);
      }
    }, {
      key: "render",
      value: function render3() {
        var ref2 = config.withRef ? "wrappedInstance" : null;
        return /* @__PURE__ */ createElement(WrappedComponent, _extends$n({
          ref: ref2
        }, omit(this.props, omittedProps)));
      }
    }, {
      key: "helperContainer",
      get: function get3() {
        var helperContainer = this.props.helperContainer;
        if (typeof helperContainer === "function") {
          return helperContainer();
        }
        return this.props.helperContainer || this.document.body;
      }
    }, {
      key: "containerScrollDelta",
      get: function get3() {
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        if (useWindowAsScrollContainer) {
          return {
            left: 0,
            top: 0
          };
        }
        return {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
      }
    }, {
      key: "windowScrollDelta",
      get: function get3() {
        return {
          left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
          top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
        };
      }
    }]);
    return WithSortableContainer;
  }(Component), _defineProperty$2(_class, "displayName", provideDisplayName("sortableList", WrappedComponent)), _defineProperty$2(_class, "defaultProps", defaultProps), _defineProperty$2(_class, "propTypes", propTypes), _defineProperty$2(_class, "childContextTypes", {
    manager: PropTypes.object.isRequired
  }), _temp;
}
var propTypes$1 = {
  index: PropTypes.number.isRequired,
  collection: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool
};
var omittedProps$1 = Object.keys(propTypes$1);
function sortableElement(WrappedComponent) {
  var _class, _temp;
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function(_React$Component) {
    _inherits$1r(WithSortableElement, _React$Component);
    function WithSortableElement() {
      _classCallCheck$1N(this, WithSortableElement);
      return _possibleConstructorReturn$1r(this, _getPrototypeOf$1g(WithSortableElement).apply(this, arguments));
    }
    _createClass$1L(WithSortableElement, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.register();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.node) {
          if (prevProps.index !== this.props.index) {
            this.node.sortableInfo.index = this.props.index;
          }
          if (prevProps.disabled !== this.props.disabled) {
            this.node.sortableInfo.disabled = this.props.disabled;
          }
        }
        if (prevProps.collection !== this.props.collection) {
          this.unregister(prevProps.collection);
          this.register();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unregister();
      }
    }, {
      key: "register",
      value: function register() {
        var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index2 = _this$props.index;
        var node2 = findDOMNode$1(this);
        node2.sortableInfo = {
          collection,
          disabled,
          index: index2,
          manager: this.context.manager
        };
        this.node = node2;
        this.ref = {
          node: node2
        };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: "unregister",
      value: function unregister() {
        var collection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.collection;
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant$1(config.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call");
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render3() {
        var ref2 = config.withRef ? "wrappedInstance" : null;
        return /* @__PURE__ */ createElement(WrappedComponent, _extends$n({
          ref: ref2
        }, omit(this.props, omittedProps$1)));
      }
    }]);
    return WithSortableElement;
  }(Component), _defineProperty$2(_class, "displayName", provideDisplayName("sortableElement", WrappedComponent)), _defineProperty$2(_class, "contextTypes", {
    manager: PropTypes.object.isRequired
  }), _defineProperty$2(_class, "propTypes", propTypes$1), _defineProperty$2(_class, "defaultProps", {
    collection: 0
  }), _temp;
}
const chromInfoBisector = bisector((d) => d.pos).left;
const absToChr = (absPosition, chromInfo) => {
  if (!chromInfo || !chromInfo.cumPositions || !chromInfo.cumPositions.length) {
    return null;
  }
  let insertPoint = chromInfoBisector(chromInfo.cumPositions, absPosition);
  const lastChr = chromInfo.cumPositions[chromInfo.cumPositions.length - 1].chr;
  const lastLength = chromInfo.chromLengths[lastChr];
  if (insertPoint > 0) {
    insertPoint -= 1;
  }
  let chrPosition = Math.floor(absPosition - chromInfo.cumPositions[insertPoint].pos);
  let offset2 = 0;
  if (chrPosition < 0) {
    offset2 = chrPosition - 1;
    chrPosition = 1;
  }
  if (insertPoint === chromInfo.cumPositions.length - 1 && chrPosition > lastLength) {
    offset2 = chrPosition - lastLength;
    chrPosition = lastLength;
  }
  return [chromInfo.cumPositions[insertPoint].chr, chrPosition, offset2, insertPoint];
};
const accessorTransposition = (x, y) => (i) => i % x * y + Math.floor(i / x);
const identity$5 = (i) => i;
const addArrays = (a1, a2, accessor = identity$5) => a1.map((val2, i) => val2 + a2[accessor(i)]);
const XMLNS$2 = "http://www.w3.org/2000/svg";
const hasClass$1 = (el, className2) => {
  if (el.namespaceURI === XMLNS$2) {
    const _class = el.getAttribute("class");
    return !!_class && !!_class.match(new RegExp(`(\\s|^)${className2}(\\s|$)`));
  }
  if (el.classList)
    return el.classList.contains(className2);
  return !!el.className.match(new RegExp(`(\\s|^)${className2}(\\s|$)`));
};
const XMLNS$1 = "http://www.w3.org/2000/svg";
const addClass$1 = (el, className2) => {
  if (el.namespaceURI === XMLNS$1) {
    if (!hasClass$1(el, className2)) {
      const _class = el.getAttribute("class") || "";
      el.setAttribute("class", `${_class} ${className2}`);
    }
  } else if (el.classList) {
    el.classList.add(className2);
  } else if (!hasClass$1(el, className2)) {
    el.className += ` ${className2}`;
  }
};
const base64ToCanvas = (base64, width, height2) => {
  const canvas = document.createElement("canvas");
  return new Promise((resolve2, reject) => {
    const img = new window.Image();
    img.onload = () => {
      canvas.width = width || img.width;
      canvas.height = height2 || img.height;
      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("Could not get canvas context"));
        return;
      }
      context.drawImage(img, 0, 0);
      resolve2(canvas);
    };
    img.onerror = () => {
      reject(new Error("Could not convert base64 to canvas"));
    };
    img.src = `data:image/png;base64,${base64}`;
  });
};
const chrToAbs = (chrom, chromPos, chromInfo) => chromInfo.chrPositions[chrom].pos + chromPos;
const cloneEvent = (event) => {
  if (!(event instanceof Event)) {
    throw new Error("Event must be an instance of Event");
  }
  const newEvent = new event.constructor(event.type, event);
  newEvent.sourceUid = event.sourceUid;
  newEvent.forwarded = event.forwarded;
  return newEvent;
};
const colorDomainToRgbaArray = (colorRange, noTansparent = false) => {
  const domain2 = colorRange.map((x, i) => i * (255 / (colorRange.length - 1)));
  const d3Scale2 = linear().domain(domain2).range(colorRange);
  const fromX = noTansparent ? 255 : 254;
  const rgbaArray = range$2(fromX, -1, -1).map(d3Scale2).map((x) => {
    const r2 = rgb(x);
    return [r2.r, r2.g, r2.b, r2.opacity * 255];
  });
  if (rgbaArray.length < 256)
    rgbaArray.push([255, 255, 255, 0]);
  return rgbaArray;
};
const GLOBALS = {
  PIXI
};
const colorToHex = (colorValue) => {
  const c2 = color(colorValue);
  const hex2 = GLOBALS.PIXI.utils.rgb2hex([c2.r / 255, c2.g / 255, c2.b / 255]);
  return hex2;
};
const colorToRgba = (colorValue) => {
  if (colorValue === "transparent") {
    return [255, 255, 255, 0];
  }
  const c2 = color(colorValue);
  return [c2.r, c2.g, c2.b, 255];
};
const dataToGenomicLoci = (x02, x12, chromInfo) => {
  const gX0 = absToChr(x02, chromInfo);
  const gX1 = absToChr(x12, chromInfo);
  if (!gX0 || !gX1) {
    throw new Error("Couldn't convert data to genomic coordinates");
  }
  return [gX0[0], Math.round(gX0[1]), gX1[0], Math.round(gX1[1])];
};
const debounce$1 = (func, wait, immediate) => {
  let timeout2;
  const debounced = (...args) => {
    const later = () => {
      timeout2 = void 0;
      if (!immediate) {
        func(...args);
      }
    };
    const callNow = immediate && !timeout2;
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, wait);
    if (callNow) {
      func(...args);
    }
  };
  debounced.cancel = () => {
    clearTimeout(timeout2);
    timeout2 = void 0;
  };
  return debounced;
};
const decToHexStr = (dec) => (dec + 16 ** 6).toString(16).substr(-6);
const dictFromTuples = (tuples) => {
  const dict = {};
  tuples.forEach((x) => {
    dict[x[0]] = x[1];
  });
  return dict;
};
const dictItems = (dictionary) => {
  const keyValues = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      keyValues.push([key, dictionary[key]]);
    }
  }
  return keyValues;
};
function dictKeys(dictionary) {
  const keys3 = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      keys3.push(key);
    }
  }
  return keys3;
}
function dictValues(dictionary) {
  const values2 = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      values2.push(dictionary[key]);
    }
  }
  return values2;
}
function download(filename, stringOrBlob) {
  const blob = typeof stringOrBlob === "string" ? new Blob([stringOrBlob], {
    type: "application/octet-stream"
  }) : stringOrBlob;
  const elem = window.document.createElement("a");
  elem.href = window.URL.createObjectURL(blob);
  elem.download = filename;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
  URL.revokeObjectURL(elem.href);
}
const DEFAULT_VIEW_MARGIN = 0;
const DEFAULT_VIEW_PADDING = 5;
const DEFAULT_CONTAINER_PADDING_X = 10;
const DEFAULT_CONTAINER_PADDING_Y = 10;
const MAX_CLICK_DELAY$1 = 300;
const MOUSE_TOOL_MOVE = "move";
const MOUSE_TOOL_SELECT = "select";
const TILE_FETCH_DEBOUNCE = 100;
const ZOOM_DEBOUNCE = 10;
const SHORT_DRAG_TIMEOUT = 110;
const LONG_DRAG_TIMEOUT = 3e3;
const LOCATION_LISTENER_PREFIX = "locationListenerPrefix";
const ZOOM_TRANSITION_DURATION = 1e3;
const DEFAULT_SERVER = "http://higlass.io/api/v1";
const VIEW_HEADER_MED_WIDTH_SEARCH_BAR = 400;
const VIEW_HEADER_MIN_WIDTH_SEARCH_BAR = 300;
const TRACK_LOCATIONS = (
  /** @type {const} */
  ["top", "left", "right", "bottom", "center", "whole", "gallery"]
);
const MIN_HORIZONTAL_HEIGHT = 20;
const MIN_VERTICAL_WIDTH = 20;
const THEME_LIGHT = Symbol("Light theme");
const THEME_DARK = Symbol("Dark theme");
const THEME_DEFAULT = THEME_LIGHT;
const stylesMTHeader = {
  "multitrack-header": "_multitrack-header_1yz7l_1",
  "multitrack-header-focus": "_multitrack-header-focus_1yz7l_2",
  "multitrack-header-squeazed": "_multitrack-header-squeazed_1yz7l_3",
  "multitrack-header-dark": "_multitrack-header-dark_1yz7l_20",
  "multitrack-header-id": "_multitrack-header-id_1yz7l_30",
  "multitrack-header-left": "_multitrack-header-left_1yz7l_39",
  "multitrack-header-grabber": "_multitrack-header-grabber_1yz7l_44",
  "multitrack-header-grabber-squeazed": "_multitrack-header-grabber-squeazed_1yz7l_45",
  "multitrack-header-search": "_multitrack-header-search_1yz7l_80",
  "multitrack-header-nav-list": "_multitrack-header-nav-list_1yz7l_102",
  "multitrack-header-icon": "_multitrack-header-icon_1yz7l_107",
  "multitrack-header-icon-squeazed": "_multitrack-header-icon-squeazed_1yz7l_108",
  "mouse-tool-selection": "_mouse-tool-selection_1yz7l_136"
};
const COG = {
  id: "cog",
  paths: ["M466.895 305.125c-26.863-46.527-10.708-106.152 36.076-133.244l-50.313-87.146c-14.375 8.427-31.088 13.259-48.923 13.259-53.768 0-97.354-43.873-97.354-97.995h-100.629c0.133 16.705-4.037 33.641-12.979 49.126-26.862 46.528-86.578 62.351-133.431 35.379l-50.312 87.146c14.485 8.236 27.025 20.294 35.943 35.739 26.819 46.454 10.756 105.96-35.854 133.112l50.313 87.146c14.325-8.348 30.958-13.127 48.7-13.127 53.598 0 97.072 43.596 97.35 97.479h100.627c-0.043-16.537 4.136-33.285 12.983-48.609 26.818-46.453 86.388-62.297 133.207-35.506l50.313-87.145c-14.39-8.233-26.846-20.249-35.717-35.614zM256 359.666c-57.254 0-103.668-46.412-103.668-103.667 0-57.254 46.413-103.667 103.668-103.667s103.666 46.413 103.666 103.667c-0.001 57.255-46.412 103.667-103.666 103.667z"],
  viewBox: "0 0 512 512"
};
const CROSS = {
  id: "cross",
  paths: ["M507.331 411.33c-0.002-0.002-0.004-0.004-0.006-0.005l-155.322-155.325 155.322-155.325c0.002-0.002 0.004-0.003 0.006-0.005 1.672-1.673 2.881-3.627 3.656-5.708 2.123-5.688 0.912-12.341-3.662-16.915l-73.373-73.373c-4.574-4.573-11.225-5.783-16.914-3.66-2.080 0.775-4.035 1.984-5.709 3.655 0 0.002-0.002 0.003-0.004 0.005l-155.324 155.326-155.324-155.325c-0.002-0.002-0.003-0.003-0.005-0.005-1.673-1.671-3.627-2.88-5.707-3.655-5.69-2.124-12.341-0.913-16.915 3.66l-73.374 73.374c-4.574 4.574-5.784 11.226-3.661 16.914 0.776 2.080 1.985 4.036 3.656 5.708 0.002 0.001 0.003 0.003 0.005 0.005l155.325 155.324-155.325 155.326c-0.001 0.002-0.003 0.003-0.004 0.005-1.671 1.673-2.88 3.627-3.657 5.707-2.124 5.688-0.913 12.341 3.661 16.915l73.374 73.373c4.575 4.574 11.226 5.784 16.915 3.661 2.080-0.776 4.035-1.985 5.708-3.656 0.001-0.002 0.003-0.003 0.005-0.005l155.324-155.325 155.324 155.325c0.002 0.001 0.004 0.003 0.006 0.004 1.674 1.672 3.627 2.881 5.707 3.657 5.689 2.123 12.342 0.913 16.914-3.661l73.373-73.374c4.574-4.574 5.785-11.227 3.662-16.915-0.776-2.080-1.985-4.034-3.657-5.707z"],
  viewBox: "0 0 512 512"
};
const ENLARGE = {
  id: "enlarge",
  paths: ["M512 0h-208l80 80-96 96 48 48 96-96 80 80z", "M512 512v-208l-80 80-96-96-48 48 96 96-80 80z", "M0 512h208l-80-80 96-96-48-48-96 96-80-80z", "M0 0v208l80-80 96 96 48-48-96-96 80-80z"],
  viewBox: "0 0 512 512"
};
const MINUS = {
  id: "minus",
  paths: ["M0 208v96c0 8.836 7.164 16 16 16h480c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16h-480c-8.836 0-16 7.164-16 16z"],
  viewBox: "0 0 512 512"
};
const MOVE = {
  id: "move",
  paths: ["M512,260.096L405.5,161.79v49.155H301.061v-104.45h49.149L251.904,0L160.77,106.495h49.15v104.45H106.495V161.79L0,260.096l106.495,91.135v-49.149h104.45v104.45H161.79L251.904,512l98.306-106.5h-49.149V301.061H405.5v49.149L512,260.096z"],
  viewBox: "0 0 512 512"
};
const PLAY = {
  id: "play",
  paths: ["M96 64l320 192-320 192z"],
  viewBox: "0 0 512 512"
};
const PLUS = {
  id: "plus",
  paths: ["M496 192h-176v-176c0-8.836-7.164-16-16-16h-96c-8.836 0-16 7.164-16 16v176h-176c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h176v176c0 8.836 7.164 16 16 16h96c8.836 0 16-7.164 16-16v-176h176c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16z"],
  viewBox: "0 0 512 512"
};
const CONTENT_COPY = {
  id: "copy",
  paths: ["M607.5 672v-448.5h-351v448.5h351zM607.5 160.5c34.5 0 64.5 28.5 64.5 63v448.5c0 34.5-30 64.5-64.5 64.5h-351c-34.5 0-64.5-30-64.5-64.5v-448.5c0-34.5 30-63 64.5-63h351zM511.5 31.5v64.5h-384v448.5h-63v-448.5c0-34.5 28.5-64.5 63-64.5h384z"],
  viewBox: "0 0 712 712"
};
const SELECT = {
  id: "select",
  viewBox: "0 0 16 16",
  paths: ["M2 14h2v1H1v-3h1v2zm8 1H6v-1h4v1zm5 0h-3v-1h2v-2h1v3zm0-5h-1V6h1v4zM2 10H1V6h1v4zm13-6h-1V2h-2V1h3v3zM4 2H2v2H1V1h3v1zm6 0H6V1h4.03L10 2z"]
};
const CHECK_SQUARE_O = {
  id: "check_square_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"]
};
const SQUARE_O = {
  id: "square_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1312 256h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-832q0-66-47-113t-113-47zm288 160v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"]
};
const FILE_O = {
  id: "file_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z"]
};
const CHEVRON_RIGHT = {
  id: "chevron_right",
  viewBox: "0 0 1792 1792",
  paths: ["M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"]
};
const CHEVRON_DOWN = {
  id: "chevron_down",
  viewBox: "0 0 1792 1792",
  paths: ["M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"]
};
const FOLDER_O = {
  id: "folder_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1600 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zm128-704v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"]
};
const FOLDER_OPEN_O = {
  id: "folder_open_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1845 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zm-1141-163h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zm1269 163q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z"]
};
const all$2 = [COG, CROSS, ENLARGE, MINUS, MOVE, PLAY, PLUS, CONTENT_COPY, SELECT, CHECK_SQUARE_O, SQUARE_O, FILE_O, FOLDER_O, FOLDER_OPEN_O, CHEVRON_RIGHT, CHEVRON_DOWN];
const parser$3 = new DOMParser();
const svgGeoMapStr = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5"><path d="M4 2.1L.5 3.5v12l5-2 5 2 5-2v-12l-5 2-3.17-1.268M10.5 3.5v12" fill="none" stroke="currentColor"/><path d="M5.5 13.5v-7" fill="none" stroke="currentColor" stroke-width=".9969299999999999"/><path d="M5.494 0c-1.803 0-3.26 1.496-3.26 3.35 0 .427.124.97.264 1.343L5.5 11l3.003-6.306c.142-.375.263-.916.263-1.342C8.766 1.496 7.3 0 5.494 0zM5.5 4.64c-.76 0-1.375-.616-1.375-1.374 0-.76.616-1.376 1.375-1.376.76 0 1.374.616 1.374 1.376 0 .758-.614 1.375-1.374 1.375z" fill="currentColor"/></svg>';
const svgGeoMapIcon = parser$3.parseFromString(svgGeoMapStr, "text/xml").documentElement;
const horizontal1dHeatmap = `
<svg width="20px" height="20px" viewBox="0 0 20 20">
  <rect x="0" y="3" width="4" height="14" fill="#637993"/>
  <rect x="4" y="3" width="2" height="14" fill="#c7d1de"/>
  <rect x="6" y="3" width="5" height="14" fill="#3c5068"/>
  <rect x="11" y="3" width="3" height="14" fill="#92a3ba"/>
  <rect x="14" y="3" width="2" height="14" fill="#000000"/>
  <rect x="16" y="3" width="4" height="14" fill="#637993"/>
</svg>
`;
const svgHorizontal1dHeatmap = parser$3.parseFromString(horizontal1dHeatmap, "text/xml").documentElement;
const horizontalLineStr = `
<svg width="20px" height="20px" viewBox="0 0 135 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>line</title>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polyline id="Path" stroke="#4990E2" stroke-width="8" points="2 45.5625 20.7460938 6.3359375 36.828125 86.6484375 59.8945312 17.5742188 79.0390625 70.703125 99.9335938 27 112.769531 81.1601562 132.078125 3"></polyline>
    </g>
</svg>
`;
const svgHorizontalLineIcon = parser$3.parseFromString(horizontalLineStr, "text/xml").documentElement;
const tiles2DIconStr = `
<svg width="20px" height="20px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>2d-tiles-icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="tiles2DIconStr-path-1" x="0" y="0" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-1"></use>
        </mask>
        <rect id="tiles2DIconStr-path-3" x="0" y="30" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-3"></use>
        </mask>
        <rect id="tiles2DIconStr-path-5" x="30" y="0" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-5"></use>
        </mask>
        <rect id="tiles2DIconStr-path-7" x="30" y="30" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-8" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-7"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-2)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-4)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-3"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-6)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-5"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-8)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-7"></use>
    </g>
</svg>
`;
const svg2DTilesIcon = parser$3.parseFromString(tiles2DIconStr, "text/xml").documentElement;
const heatmap2DStr = `
<svg width="20px" height="20px" viewBox="0 0 90 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>2d-heatmap</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="heatmap2DStr-path-1" x="0" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-2" x="30" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-3" x="60" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-4" x="0" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-5" x="30" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-6" x="60" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-7" x="0" y="60" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-8" x="30" y="60" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-9" x="60" y="60" width="30" height="30"></rect>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" fill="#858372" xlink:href="#heatmap2DStr-path-1"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-2"></use>
        <use id="Rectangle" fill="#ECECD5" xlink:href="#heatmap2DStr-path-3"></use>
        <use id="Rectangle" fill="#BCBD9E" xlink:href="#heatmap2DStr-path-4"></use>
        <use id="Rectangle" fill="#817C7C" xlink:href="#heatmap2DStr-path-5"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-6"></use>
        <use id="Rectangle" fill="#ECECD5" xlink:href="#heatmap2DStr-path-7"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-8"></use>
        <use id="Rectangle" fill="#7B7777" xlink:href="#heatmap2DStr-path-9"></use>
    </g>
</svg>
`;
const svg2DHeatmapIcon = parser$3.parseFromString(heatmap2DStr, "text/xml").documentElement;
const axis1D = `
<svg width="20px" height="20px" viewBox="0 0 77 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>axis-1d</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polyline id="Path" stroke="#979797" stroke-width="8" transform="translate(38.258485, 27.557860) scale(1, -1) translate(-38.258485, -27.557860) " points="4 27.05786 36.7512307 27.05786 72.5169695 27.05786"></polyline>
        <path d="M38,24.484375 L38,3" id="Path-2" stroke="#979797" stroke-width="4"></path>
    </g>
</svg>
`;
const svg1DAxisIcon = parser$3.parseFromString(axis1D, "text/xml").documentElement;
const svgVertical1DAxisIcon = select$1(parser$3.parseFromString(axis1D, "text/xml").documentElement).style("transform", "rotate(90deg)").node();
const geneAnnotations = `
<svg width="20px" height="20px" viewBox="0 0 171 116" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>gene-annotations</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="geneAnnotations-path-1" x="34" y="0" width="24" height="116"></rect>
        <mask id="geneAnnotations-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="24" height="116" fill="white">
            <use xlink:href="#geneAnnotations-path-1"></use>
        </mask>
        <rect id="geneAnnotations-path-3" x="80" y="0" width="56" height="116"></rect>
        <mask id="geneAnnotations-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="56" height="116" fill="white">
            <use xlink:href="#geneAnnotations-path-3"></use>
        </mask>
        <rect id="geneAnnotations-path-5" x="147" y="40" width="24" height="35"></rect>
        <mask id="geneAnnotations-mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="24" height="35" fill="white">
            <use xlink:href="#geneAnnotations-path-5"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.71875,58 L147.10172,58" id="Path" stroke="#979797" stroke-width="8"></path>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-2)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-4)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-3"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-6)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-5"></use>
        <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" points="25 57.5 1 75 1 40"></polygon>
    </g>
</svg>
`;
const svgGeneAnnotationsIcon = parser$3.parseFromString(geneAnnotations, "text/xml").documentElement;
const tiles1DIconStr = `
<svg width="20px" height="20px" viewBox="0 0 180 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
    <title>1d-tiles-icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="tiles1DIconStr-path-1" x="0" y="0" width="90" height="90"></rect>
        <mask id="tiles1DIconStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#tiles1DIconStr-path-1"></use>
        </mask>
        <rect id="tiles1DIconStr-path-3" x="90" y="0" width="90" height="90"></rect>
        <mask id="tiles1DIconStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#tiles1DIconStr-path-3"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" stroke="#979797" mask="url(#tiles1DIconStr-mask-2)" stroke-width="12" fill="#E6D5D5" xlink:href="#tiles1DIconStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles1DIconStr-mask-4)" stroke-width="12" fill="#E6D5D5" xlink:href="#tiles1DIconStr-path-3"></use>
    </g>
</svg>
`;
const svg1DTilesIcon = parser$3.parseFromString(tiles1DIconStr, "text/xml").documentElement;
const svgVertical1DTilesIcon = select$1(parser$3.parseFromString(tiles1DIconStr, "text/xml").documentElement).style("transform", "rotate(90deg)").node();
const arrowHeadDomainsStr = `
<svg width="20px" height="20px" viewBox="0 0 111 111" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
    <title>arrowhead-domains</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="arrowHeadDomainsStr-path-1" x="0" y="0" width="90" height="90"></rect>
        <mask id="arrowHeadDomainsStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#arrowHeadDomainsStr-path-1"></use>
        </mask>
        <rect id="arrowHeadDomainsStr-path-3" x="52" y="52" width="59" height="59"></rect>
        <mask id="arrowHeadDomainsStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="59" height="59" fill="white">
            <use xlink:href="#arrowHeadDomainsStr-path-3"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0">
        <use id="Rectangle" stroke="#979797" mask="url(#arrowHeadDomainsStr-mask-2)" stroke-width="22" fill="#D8D8D8" xlink:href="#arrowHeadDomainsStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#arrowHeadDomainsStr-mask-4)" stroke-width="22" fill="#D8D8D8" xlink:href="#arrowHeadDomainsStr-path-3"></use>
    </g>
</svg>
`;
const svgArrowheadDomainsIcon = parser$3.parseFromString(arrowHeadDomainsStr, "text/xml").documentElement;
function SearchIcon({
  theStyle,
  onClick
}) {
  return /* @__PURE__ */ React$3.createElement("svg", {
    className: stylesMTHeader[theStyle],
    viewBox: "0 0 12 13",
    onClick,
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React$3.createElement("g", {
    fill: "none",
    stroke: "#6c6c6c",
    strokeWidth: "2"
  }, /* @__PURE__ */ React$3.createElement("path", {
    d: "M11.29 11.71l-4-4"
  }), /* @__PURE__ */ React$3.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4"
  })));
}
SearchIcon.propTypes = {
  theStyle: PropTypes.string,
  onClick: PropTypes.func
};
const osm = {
  type: "osm-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "OSM Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["minPos", "maxPos", "maxZoom", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    minPos: -180,
    maxPos: 180,
    maxZoom: 19,
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
};
const mapbox = {
  type: "mapbox-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Mapbox Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["style", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    style: "mapbox.streets",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
};
const TRACKS_INFO = [osm, {
  ...osm,
  type: "osm"
}, mapbox, {
  ...mapbox,
  type: "mapbox"
}, {
  type: "left-axis",
  datatype: ["axis"],
  local: true,
  orientation: "1d-vertical",
  name: "Left Axis",
  thumbnail: svgVertical1DAxisIcon,
  availableOptions: ["minWidth"],
  defaultOptions: {
    minWidth: 100
  }
}, {
  type: "top-axis",
  datatype: ["axis"],
  local: true,
  orientation: "1d-horizontal",
  name: "Top Axis",
  thumbnail: svg1DAxisIcon,
  defaultOptions: {}
}, {
  type: "horizontal-rule",
  datatype: ["x-coord"],
  local: true,
  orientation: "whole",
  name: "Horizontal Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "vertical-rule",
  datatype: ["y-coord"],
  local: true,
  orientation: "whole",
  name: "Vertical Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "cross-rule",
  datatype: ["xy-coord"],
  local: true,
  orientation: "whole",
  name: "Cross Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "simple-svg",
  datatype: [],
  local: false,
  orientation: "2d",
  exportable: true,
  availableOptions: ["minWidth", "minHeight"],
  defaultOptions: {
    minWidth: 100,
    minHeight: 100
  }
}, {
  type: "heatmap",
  datatype: ["matrix"],
  local: false,
  orientation: "2d",
  thumbnail: svg2DHeatmapIcon,
  exportable: true,
  availableOptions: ["backgroundColor", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "colorbarBackgroundColor", "maxZoom", "minWidth", "minHeight", "dataTransform", "colorbarPosition", "trackBorderWidth", "trackBorderColor", "heatmapValueScaling", "showMousePosition", "mousePositionColor", "showTooltip", "extent", "zeroValueColor"],
  defaultOptions: {
    backgroundColor: "#eeeeee",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    colorbarBackgroundColor: "#ffffff",
    maxZoom: null,
    minWidth: 100,
    minHeight: 100,
    colorbarPosition: "topRight",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log",
    showMousePosition: false,
    mousePositionColor: "#000000",
    showTooltip: true,
    extent: "full",
    zeroValueColor: null
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      backgroundColor: "#000000",
      colorRange: [
        // corresponding to the inverted fall colormap
        "black",
        "rgba(208,2,27,1.0)",
        "rgba(245,166,35,1.0)",
        "white"
      ],
      colorbarBackgroundColor: "#000000",
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "linear-heatmap",
  aliases: ["horizontal-heatmap", "vertical-heatmap"],
  datatype: ["matrix"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svg2DHeatmapIcon,
  defaultOptions: {
    backgroundColor: "#eeeeee",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    labelColor: "black",
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    maxZoom: null,
    minWidth: 100,
    minHeight: 40,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  },
  availableOptions: ["backgroundColor", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "maxZoom", "minWidth", "minHeight", "dataTransform", "oneDHeatmapFlipped", "colorbarPosition", "trackBorderWidth", "trackBorderColor", "heatmapValueScaling"]
}, {
  type: "line",
  aliases: ["horizontal-line", "vertical-line"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svgHorizontalLineIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundColor", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "lineStrokeWidth", "lineStrokeColor", "valueScaling", "valueScaleMin", "valueScaleMax", "trackBorderWidth", "trackBorderColor", "trackType", "showMousePosition", "showTooltip", "mousePositionColor", "aggregationMode", "minHeight"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelBackgroundColor: "white",
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    lineStrokeColor: "blue",
    lineStrokeWidth: 1,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    showMousePosition: false,
    minHeight: 20,
    mousePositionColor: "#000000",
    showTooltip: true
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "1d-heatmap",
  aliases: ["horizontal-1d-heatmap", "vertical-1d-heatmap"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svgHorizontal1dHeatmap,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisPositionHorizontal", "axisMargin", "colorRange", "valueScaling", "trackBorderWidth", "trackBorderColor", "trackType", "showMousePosition", "showTooltip", "mousePositionColor", "aggregationMode"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisPositionHorizontal: "right",
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    showMousePosition: false,
    mousePositionColor: "#000000",
    showTooltip: true
  }
}, {
  type: "vector-heatmap",
  aliases: ["horizontal-vector-heatmap", "vertical-vector-heatmap"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  minHeight: 1,
  thumbnail: null,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "valueScaling", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "trackBorderWidth", "trackBorderColor", "trackType", "heatmapValueScaling"],
  defaultOptions: {
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    labelColor: "black",
    labelTextOpacity: 0.4,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log"
  }
}, {
  type: "multivec",
  aliases: ["horizontal-multivec", "vertical-multivec"],
  datatype: ["multivec"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: null,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "minHeight", "valueScaling", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "trackBorderWidth", "trackBorderColor", "trackType", "heatmapValueScaling", "selectRows", "selectRowsAggregationMode", "selectRowsAggregationWithRelativeHeight", "selectRowsAggregationMethod", "colorbarBackgroundColor", "colorbarPosition", "zeroValueColor"],
  defaultOptions: {
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    labelColor: "black",
    labelTextOpacity: 0.4,
    minHeight: 100,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log",
    selectRows: null,
    selectRowsAggregationMode: "mean",
    selectRowsAggregationWithRelativeHeight: true,
    selectRowsAggregationMethod: "client",
    colorbarBackgroundColor: "#ffffff",
    colorbarPosition: "topRight",
    zeroValueColor: null
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      colorbarBackgroundColor: "#000000"
    }
  }
}, {
  type: "point",
  aliases: ["horizontal-point", "vertical-point"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "pointColor", "pointSize", "valueScaling", "trackBorderWidth", "trackBorderColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    pointColor: "red",
    pointSize: 3,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4
  }
}, {
  type: "divergent-bar",
  aliases: ["horizontal-divergent-bar", "vertical-divergent-bar"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "barFillColorTop", "barFillColorBottom", "valueScaling", "trackBorderWidth", "trackBorderColor", "barOpacity"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisPositionHorizontal: "right",
    axisLabelFormatting: "scientific",
    barFillColorBottom: "red",
    barFillColorTop: "green",
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    barOpacity: 1
  }
}, {
  type: "bar",
  aliases: ["horizontal-bar", "vertical-bar"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["align", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "barFillColor", "colorRange", "colorRangeGradient", "valueScaling", "valueScaleMin", "valueScaleMax", "trackBorderWidth", "trackBorderColor", "barOpacity", "showMousePosition", "showTooltip", "aggregationMode", "zeroLineVisible", "zeroLineColor", "zeroLineOpacity"],
  defaultOptions: {
    align: "bottom",
    labelColor: "[glyph-color]",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    barFillColor: "darkgreen",
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    barOpacity: 1
  }
}, {
  type: "2d-tiles",
  datatype: ["matrix"],
  local: false,
  orientation: "2d",
  name: "2D Tile Outlines",
  thumbnail: svg2DTilesIcon
}, {
  type: "1d-value-interval",
  aliases: ["horizontal-1d-value-interval", "vertical-1d-value-interval"],
  datatype: ["bed-value"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "1D Rectangles",
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisPositionHorizontal", "axisMargin"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "bottomLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    axisPositionHorizontal: "left",
    lineStrokeColor: "blue",
    valueScaling: "linear"
  }
}, {
  type: "stacked-interval",
  aliases: ["top-stacked-interval", "left-stacked-interval"],
  datatype: ["stacked-interval"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: "horizontal-stacked-interval.png",
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity"]
}, {
  type: "viewport-projection-vertical",
  datatype: ["1d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "1d-vertical",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "viewport-projection-horizontal",
  datatype: ["1d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "1d-horizontal",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "viewport-projection-center",
  datatype: ["2d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "2d",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "gene-annotations",
  aliases: ["horizontal-gene-annotations", "vertical-gene-annotations"],
  datatype: ["gene-annotation"],
  local: false,
  defaultHeight: 90,
  defaultWidth: 90,
  rotatable: true,
  orientation: "1d-horizontal",
  name: "Gene Annotations",
  thumbnail: svgGeneAnnotationsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundColor", "labelBackgroundOpacity", "minHeight", "plusStrandColor", "minusStrandColor", "trackBorderWidth", "trackBorderColor", "showMousePosition", "mousePositionColor", "fontSize", "geneAnnotationHeight", "geneLabelPosition", "geneStrandSpacing", "showTooltip"],
  defaultOptions: {
    fontSize: 10,
    labelColor: "black",
    labelBackgroundColor: "#ffffff",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    minHeight: 24,
    plusStrandColor: "blue",
    minusStrandColor: "red",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    showMousePosition: false,
    mousePositionColor: "#000000",
    geneAnnotationHeight: 16,
    geneLabelPosition: "outside",
    geneStrandSpacing: 4,
    showTooltip: true
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff",
      plusStrandColor: "#40a0ff"
    }
  }
}, {
  type: "arrowhead-domains",
  datatype: ["arrowhead-domains"],
  local: false,
  orientation: "2d",
  name: "Arrowhead Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  }
}, {
  type: "linear-2d-rectangle-domains",
  aliases: ["horizontal-2d-rectangle-domains", "vertical-2d-rectangle-domains"],
  datatype: ["2d-rectangle-domains"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "Horizontal 2D Rectangle Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "bottomLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none"
  }
}, {
  type: "2d-rectangle-domains",
  datatype: ["2d-rectangle-domains"],
  local: false,
  orientation: "2d",
  name: "2D Rectangle Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["flipDiagonal", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainFillOpacity", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize"],
  defaultOptions: {
    flipDiagonal: "none",
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainFillOpacity: 0.4,
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none"
  }
}, {
  type: "horizontal-1d-annotations",
  datatype: ["nothing"],
  // Unfortunately one has to specify something here
  local: false,
  orientation: "1d-horizontal",
  name: "Horizontal 1D Annotations",
  thumbnail: null,
  availableOptions: ["fill", "fillOpacity", "stroke", "strokeOpacity", "strokeWidth", "strokePos", "regions"],
  defaultOptions: {
    fill: "red",
    fillOpacity: 0.2,
    stroke: "red",
    strokeOpacity: 0,
    strokeWidth: 1,
    regions: [],
    strokePos: []
  }
}, {
  type: "vertical-1d-annotations",
  datatype: ["nothing"],
  // Unfortunately one has to specify something here
  local: false,
  orientation: "1d-vertical",
  name: "Vertical 1D Annotations",
  thumbnail: null,
  availableOptions: ["fill", "fillOpacity", "stroke", "strokeOpacity", "regions"],
  defaultOptions: {
    fill: "red",
    fillOpacity: "0.2",
    stroke: "red",
    strokeOpacity: "0",
    regions: []
  }
}, {
  type: "2d-annotations",
  datatype: ["2d-annotations"],
  local: false,
  orientation: "2d",
  name: "2D Annotations",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize", "isClickable", "hoverColor", "selectColor", "exclude", "trackBorderBgWidth", "trackBorderBgColor", "trackBorderBgAlpha"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none",
    isClickable: false,
    hoverColor: "orange",
    selectColor: "fuchsia",
    exclude: [],
    trackBorderBgWidth: 0,
    trackBorderBgColor: "black",
    trackBorderBgAlpha: 0.33
  }
}, {
  type: "square-markers",
  datatype: ["bedpe"],
  local: false,
  orientation: "2d",
  name: "Square Markers",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  }
}, {
  type: "combined",
  datatype: "any",
  local: true,
  orientation: "any"
}, {
  type: "horizontal-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "1d-horizontal",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor", "showMousePosition"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey",
    showMousePosition: false
  }
}, {
  type: "vertical-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "1d-vertical",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor", "showMousePosition"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey",
    showMousePosition: false
  }
}, {
  type: "2d-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "2d",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey"
  }
}, {
  type: "2d-chromosome-annotations",
  datatype: ["chromsizes"],
  local: true,
  orientation: "2d",
  name: "2D Chromosome Annotations",
  thumbnail: null,
  hidden: true
}, {
  type: "2d-chromosome-labels",
  datatype: ["chromsizes"],
  local: true,
  orientation: "2d",
  name: "Pairwise Chromosome Labels",
  thumbnail: null
}, {
  type: "chromosome-labels",
  aliases: ["horizontal-chromosome-labels", "vertical-chromosome-labels"],
  datatype: ["chromsizes"],
  orientation: "1d-horizontal",
  rotatable: true,
  minHeight: 35,
  defaultHeight: 30,
  name: "Chromosome Axis",
  thumbnail: null,
  availableOptions: ["color", "stroke", "fontSize", "fontIsLeftAligned", "showMousePosition", "mousePositionColor", "tickPositions", "tickFormat", "reverseOrientation"],
  defaultOptions: {
    color: "#808080",
    stroke: "#ffffff",
    fontSize: 12,
    fontIsLeftAligned: false,
    showMousePosition: false,
    mousePositionColor: "#000000",
    reverseOrientation: false
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      color: "#808080",
      stroke: "#000000",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "vertical-1d-tiles",
  datatype: ["1d-tiles"],
  local: false,
  orientation: "1d-vertical",
  name: "Vertical 1D Tile Outlines",
  thumbnail: svgVertical1DTilesIcon
}, {
  type: "horizontal-1d-tiles",
  datatype: ["vector", "stacked-interval", "gene-annotation"],
  local: false,
  orientation: "1d-horizontal",
  name: "Horizontal 1D Tile Outlines",
  thumbnail: svg1DTilesIcon
}, {
  type: "osm-2d-tile-ids",
  datatype: ["map-tiles"],
  local: false,
  orientation: "2d",
  name: "OSM Tile Outlines",
  thumbnail: svg2DTilesIcon,
  availableOptions: ["minPos", "maxPos", "maxZoom", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    minPos: -180,
    maxPos: 180,
    maxZoom: 19,
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
}, {
  type: "raster-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Raster Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
}, {
  type: "image-tiles",
  datatype: ["image-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Image Tiles",
  thumbnail: null
}, {
  type: "bedlike",
  datatype: ["bedlike"],
  aliases: ["vertical-bedlike"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "BED-like track",
  thumbnail: null,
  availableOptions: ["alternating", "annotationHeight", "annotationStyle", "fillColor", "fillOpacity", "fontColor", "fontSize", "minusStrandColor", "plusStrandColor", "labelBottomMargin", "labelColor", "labelLeftMargin", "labelPosition", "labelRightMargin", "labelTopMargin", "labelTextOpacity", "labelBackgroundOpacity", "maxAnnotationHeight", "minHeight", "trackBorderWidth", "trackBorderColor", "valueColumn", "colorEncoding", "colorRange", "colorEncodingRange", "separatePlusMinusStrands", "showTexts", "axisPositionHorizontal", "axisMargin"],
  defaultOptions: {
    alternating: false,
    annotationStyle: "box",
    fillColor: "blue",
    fillOpacity: 0.3,
    fontSize: "10",
    axisPositionHorizontal: "right",
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    minHeight: 20,
    maxAnnotationHeight: null,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    valueColumn: null,
    colorEncoding: "itemRgb",
    showTexts: false,
    colorRange: ["#000000", "#652537", "#bf5458", "#fba273", "#ffffe0"],
    colorEncodingRange: false,
    separatePlusMinusStrands: true,
    annotationHeight: 16
  }
}, {
  type: "empty",
  datatype: [],
  orientation: "1d-horizontal",
  name: "Empty track",
  thumbnail: null,
  availableOptions: [],
  defaultOptions: {}
}];
const DATATYPE_TO_TRACK_TYPE = (orientation2) => {
  const localDatatypeToTrackType = {};
  const orientationMatches = (trackInfo2) => {
    if (trackInfo2.orientation === orientation2) {
      return true;
    }
    if (orientation2 === "1d-vertical" && trackInfo2.orientation === "1d-horizontal" && trackInfo2.rotatable) {
      return true;
    }
    return false;
  };
  TRACKS_INFO.filter(orientationMatches).forEach((ti) => {
    let datatypes = ti.datatype;
    if (!Array.isArray(ti.datatype)) {
      datatypes = [datatypes];
    }
    datatypes.forEach((datatype) => {
      if (!(datatype in localDatatypeToTrackType)) {
        localDatatypeToTrackType[datatype] = [];
      }
      localDatatypeToTrackType[datatype].push(ti);
    });
  });
  localDatatypeToTrackType.none = [];
  return localDatatypeToTrackType;
};
const HEATED_OBJECT_MAP = [[0, 0, 0, 255], [35, 0, 0, 255], [52, 0, 0, 255], [60, 0, 0, 255], [63, 1, 0, 255], [64, 2, 0, 255], [68, 5, 0, 255], [69, 6, 0, 255], [72, 8, 0, 255], [74, 10, 0, 255], [77, 12, 0, 255], [78, 14, 0, 255], [81, 16, 0, 255], [83, 17, 0, 255], [85, 19, 0, 255], [86, 20, 0, 255], [89, 22, 0, 255], [91, 24, 0, 255], [92, 25, 0, 255], [94, 26, 0, 255], [95, 28, 0, 255], [98, 30, 0, 255], [100, 31, 0, 255], [102, 33, 0, 255], [103, 34, 0, 255], [105, 35, 0, 255], [106, 36, 0, 255], [108, 38, 0, 255], [109, 39, 0, 255], [111, 40, 0, 255], [112, 42, 0, 255], [114, 43, 0, 255], [115, 44, 0, 255], [117, 45, 0, 255], [119, 47, 0, 255], [119, 47, 0, 255], [120, 48, 0, 255], [122, 49, 0, 255], [123, 51, 0, 255], [125, 52, 0, 255], [125, 52, 0, 255], [126, 53, 0, 255], [128, 54, 0, 255], [129, 56, 0, 255], [129, 56, 0, 255], [131, 57, 0, 255], [132, 58, 0, 255], [134, 59, 0, 255], [134, 59, 0, 255], [136, 61, 0, 255], [137, 62, 0, 255], [137, 62, 0, 255], [139, 63, 0, 255], [139, 63, 0, 255], [140, 65, 0, 255], [142, 66, 0, 255], [142, 66, 0, 255], [143, 67, 0, 255], [143, 67, 0, 255], [145, 68, 0, 255], [145, 68, 0, 255], [146, 70, 0, 255], [146, 70, 0, 255], [148, 71, 0, 255], [148, 71, 0, 255], [149, 72, 0, 255], [149, 72, 0, 255], [151, 73, 0, 255], [151, 73, 0, 255], [153, 75, 0, 255], [153, 75, 0, 255], [154, 76, 0, 255], [154, 76, 0, 255], [154, 76, 0, 255], [156, 77, 0, 255], [156, 77, 0, 255], [157, 79, 0, 255], [157, 79, 0, 255], [159, 80, 0, 255], [159, 80, 0, 255], [159, 80, 0, 255], [160, 81, 0, 255], [160, 81, 0, 255], [162, 82, 0, 255], [162, 82, 0, 255], [163, 84, 0, 255], [163, 84, 0, 255], [165, 85, 0, 255], [165, 85, 0, 255], [166, 86, 0, 255], [166, 86, 0, 255], [166, 86, 0, 255], [168, 87, 0, 255], [168, 87, 0, 255], [170, 89, 0, 255], [170, 89, 0, 255], [171, 90, 0, 255], [171, 90, 0, 255], [173, 91, 0, 255], [173, 91, 0, 255], [174, 93, 0, 255], [174, 93, 0, 255], [176, 94, 0, 255], [176, 94, 0, 255], [177, 95, 0, 255], [177, 95, 0, 255], [179, 96, 0, 255], [179, 96, 0, 255], [180, 98, 0, 255], [182, 99, 0, 255], [182, 99, 0, 255], [183, 100, 0, 255], [183, 100, 0, 255], [185, 102, 0, 255], [185, 102, 0, 255], [187, 103, 0, 255], [187, 103, 0, 255], [188, 104, 0, 255], [188, 104, 0, 255], [190, 105, 0, 255], [191, 107, 0, 255], [191, 107, 0, 255], [193, 108, 0, 255], [193, 108, 0, 255], [194, 109, 0, 255], [196, 110, 0, 255], [196, 110, 0, 255], [197, 112, 0, 255], [197, 112, 0, 255], [199, 113, 0, 255], [200, 114, 0, 255], [200, 114, 0, 255], [202, 116, 0, 255], [202, 116, 0, 255], [204, 117, 0, 255], [205, 118, 0, 255], [205, 118, 0, 255], [207, 119, 0, 255], [208, 121, 0, 255], [208, 121, 0, 255], [210, 122, 0, 255], [211, 123, 0, 255], [211, 123, 0, 255], [213, 124, 0, 255], [214, 126, 0, 255], [214, 126, 0, 255], [216, 127, 0, 255], [217, 128, 0, 255], [217, 128, 0, 255], [219, 130, 0, 255], [221, 131, 0, 255], [221, 131, 0, 255], [222, 132, 0, 255], [224, 133, 0, 255], [224, 133, 0, 255], [225, 135, 0, 255], [227, 136, 0, 255], [227, 136, 0, 255], [228, 137, 0, 255], [230, 138, 0, 255], [230, 138, 0, 255], [231, 140, 0, 255], [233, 141, 0, 255], [233, 141, 0, 255], [234, 142, 0, 255], [236, 144, 0, 255], [236, 144, 0, 255], [238, 145, 0, 255], [239, 146, 0, 255], [241, 147, 0, 255], [241, 147, 0, 255], [242, 149, 0, 255], [244, 150, 0, 255], [244, 150, 0, 255], [245, 151, 0, 255], [247, 153, 0, 255], [247, 153, 0, 255], [248, 154, 0, 255], [250, 155, 0, 255], [251, 156, 0, 255], [251, 156, 0, 255], [253, 158, 0, 255], [255, 159, 0, 255], [255, 159, 0, 255], [255, 160, 0, 255], [255, 161, 0, 255], [255, 163, 0, 255], [255, 163, 0, 255], [255, 164, 0, 255], [255, 165, 0, 255], [255, 167, 0, 255], [255, 167, 0, 255], [255, 168, 0, 255], [255, 169, 0, 255], [255, 169, 0, 255], [255, 170, 0, 255], [255, 172, 0, 255], [255, 173, 0, 255], [255, 173, 0, 255], [255, 174, 0, 255], [255, 175, 0, 255], [255, 177, 0, 255], [255, 178, 0, 255], [255, 179, 0, 255], [255, 181, 0, 255], [255, 181, 0, 255], [255, 182, 0, 255], [255, 183, 0, 255], [255, 184, 0, 255], [255, 187, 7, 255], [255, 188, 10, 255], [255, 189, 14, 255], [255, 191, 18, 255], [255, 192, 21, 255], [255, 193, 25, 255], [255, 195, 29, 255], [255, 197, 36, 255], [255, 198, 40, 255], [255, 200, 43, 255], [255, 202, 51, 255], [255, 204, 54, 255], [255, 206, 61, 255], [255, 207, 65, 255], [255, 210, 72, 255], [255, 211, 76, 255], [255, 214, 83, 255], [255, 216, 91, 255], [255, 219, 98, 255], [255, 221, 105, 255], [255, 223, 109, 255], [255, 225, 116, 255], [255, 228, 123, 255], [255, 232, 134, 255], [255, 234, 142, 255], [255, 237, 149, 255], [255, 239, 156, 255], [255, 240, 160, 255], [255, 243, 167, 255], [255, 246, 174, 255], [255, 248, 182, 255], [255, 249, 185, 255], [255, 252, 193, 255], [255, 253, 196, 255], [255, 255, 204, 255], [255, 255, 207, 255], [255, 255, 211, 255], [255, 255, 218, 255], [255, 255, 222, 255], [255, 255, 225, 255], [255, 255, 229, 255], [255, 255, 233, 255], [255, 255, 236, 255], [255, 255, 240, 255], [255, 255, 244, 255], [255, 255, 247, 255], [255, 255, 255, 0]];
const TRACKS_INFO_BY_TYPE = TRACKS_INFO.reduce(
  (tracksByType, track) => {
    tracksByType[track.type] = track;
    if (track.aliases) {
      for (const alias of track.aliases) {
        tracksByType[alias] = track;
      }
    }
    return tracksByType;
  },
  /** @type {TracksInfoByType} */
  {}
);
const POSITIONS_BY_DATATYPE = TRACKS_INFO.reduce((positionsByDatatype, track) => {
  for (let i = 0; i < track.datatype.length; i++) {
    const datatype = track.datatype[i];
    if (positionsByDatatype[datatype]) {
      positionsByDatatype[datatype].add(track.orientation);
    } else {
      positionsByDatatype[datatype] = /* @__PURE__ */ new Set();
    }
    return positionsByDatatype;
  }
  return {};
}, {});
const DEFAULT_TRACKS_FOR_DATATYPE = (
  /** @type {const} */
  {
    chromsizes: {
      center: "2d-chromosome-grid",
      top: "chromosome-labels",
      left: "chromosome-labels",
      bottom: "chromosome-labels",
      right: "chromosome-labels"
    },
    matrix: {
      center: "heatmap",
      top: "linear-heatmap",
      left: "linear-heatmap",
      right: "linear-heatmap",
      bottom: "linear-heatmap"
    },
    vector: {
      top: "bar",
      bottom: "bar",
      left: "bar",
      right: "bar"
    },
    "geo-json": {
      center: "geo-json"
    },
    "gene-annotation": {
      top: "gene-annotations",
      bottom: "gene-annotations",
      left: "gene-annotations",
      right: "gene-annotations"
    },
    bedlike: {
      top: "bedlike",
      bottom: "bedlike",
      left: "vertical-bedlike",
      right: "vertical-bedlike"
    }
  }
);
const AVAILABLE_TRACK_TYPES = (datatypes, orientation2) => {
  const datatypesToTrackTypes = DATATYPE_TO_TRACK_TYPE(orientation2);
  let availableTrackTypes = new Set(Object.values(datatypesToTrackTypes).flatMap((x) => x));
  for (const datatype of datatypes) {
    const dataTypeSet = new Set(datatype);
    availableTrackTypes = new Set([...availableTrackTypes].filter((x) => x.datatype.filter((y) => dataTypeSet.has(y)).length > 0));
  }
  return [...availableTrackTypes];
};
const NUM_PRECOMP_SUBSETS_PER_1D_TTILE = 8;
const NUM_PRECOMP_SUBSETS_PER_2D_TTILE = 8;
const _configs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AVAILABLE_TRACK_TYPES,
  DATATYPE_TO_TRACK_TYPE,
  DEFAULT_CONTAINER_PADDING_X,
  DEFAULT_CONTAINER_PADDING_Y,
  DEFAULT_SERVER,
  DEFAULT_TRACKS_FOR_DATATYPE,
  DEFAULT_VIEW_MARGIN,
  DEFAULT_VIEW_PADDING,
  GLOBALS,
  HEATED_OBJECT_MAP,
  LOCATION_LISTENER_PREFIX,
  LONG_DRAG_TIMEOUT,
  MAX_CLICK_DELAY: MAX_CLICK_DELAY$1,
  MIN_HORIZONTAL_HEIGHT,
  MIN_VERTICAL_WIDTH,
  MOUSE_TOOL_MOVE,
  MOUSE_TOOL_SELECT,
  NUM_PRECOMP_SUBSETS_PER_1D_TTILE,
  NUM_PRECOMP_SUBSETS_PER_2D_TTILE,
  POSITIONS_BY_DATATYPE,
  SHORT_DRAG_TIMEOUT,
  THEME_DARK,
  THEME_DEFAULT,
  THEME_LIGHT,
  TILE_FETCH_DEBOUNCE,
  TRACKS_INFO,
  TRACKS_INFO_BY_TYPE,
  TRACK_LOCATIONS,
  VIEW_HEADER_MED_WIDTH_SEARCH_BAR,
  VIEW_HEADER_MIN_WIDTH_SEARCH_BAR,
  ZOOM_DEBOUNCE,
  ZOOM_TRANSITION_DURATION
}, Symbol.toStringTag, { value: "Module" }));
const fillInMinWidths = (tracks2) => {
  const horizontalLocations = ["top", "bottom", "gallery"];
  const verticalLocations = ["left", "right", "gallery"];
  tracks2.center = tracks2.center || [];
  tracks2.left = tracks2.left || [];
  tracks2.right = tracks2.right || [];
  tracks2.top = tracks2.top || [];
  tracks2.bottom = tracks2.bottom || [];
  tracks2.whole = tracks2.whole || [];
  tracks2.gallery = tracks2.gallery || [];
  horizontalLocations.map((horizontalLocation) => tracks2[horizontalLocation]).forEach((horizontalTracks) => horizontalTracks.forEach((track) => {
    const trackInfo2 = TRACKS_INFO_BY_TYPE[track.type];
    const defaultOptions = trackInfo2 && trackInfo2.defaultOptions || {};
    const options2 = track.options ? {
      ...defaultOptions,
      ...track.options
    } : defaultOptions;
    if (options2.minHeight !== void 0 && track.height === void 0) {
      track.height = options2.minHeight;
    }
    if (track.height === void 0) {
      track.height = trackInfo2 && trackInfo2.defaultHeight || MIN_HORIZONTAL_HEIGHT;
    }
  }));
  verticalLocations.map((verticalLocation) => tracks2[verticalLocation]).forEach((verticalTracks) => verticalTracks.forEach((track) => {
    const trackInfo2 = TRACKS_INFO_BY_TYPE[track.type];
    const defaultOptions = trackInfo2 && trackInfo2.defaultOptions || {};
    const options2 = track.options ? {
      ...defaultOptions,
      ...track.options
    } : defaultOptions;
    if (options2.minWidth !== void 0 && track.width === void 0) {
      track.width = options2.minWidth;
    }
    if (track.width === void 0) {
      track.width = trackInfo2 && trackInfo2.defaultWidth || MIN_VERTICAL_WIDTH;
    }
  }));
  return tracks2;
};
const reduce = (f2) => (x) => Array.prototype.reduce.call(x, f2);
const flatten$1 = reduce((a, b) => a.concat(b));
const forEach$2 = (f2) => (x) => Array.prototype.forEach.call(x, f2);
const forwardEvent = (event, target) => {
  target.dispatchEvent(cloneEvent(event));
};
const genomeLociToPixels = (genomeLoci, chromInfo) => [chrToAbs(genomeLoci[0], genomeLoci[1], chromInfo), chrToAbs(genomeLoci[2], genomeLoci[3], chromInfo)];
function genomicRangeToChromosomeChunks(chromSizes, genomicStart, genomicEnd, binSize, tileSize) {
  const {
    chr: chrStart,
    pos: chrStartPos
  } = genomicStart;
  const {
    chr: chrEnd,
    pos: chrEndPos
  } = genomicEnd;
  const chrChunks = [];
  if (chrStart === chrEnd) {
    const chrName = chrStart;
    const zStart = Math.floor(chrStartPos / binSize);
    const zEnd = Math.min(zStart + tileSize, Math.ceil(chrEndPos / binSize));
    chrChunks.push([chrName, zStart, zEnd]);
  } else {
    let zRemaining = tileSize;
    const chrStartIndex = chromSizes.findIndex(([chrName]) => chrName === chrStart);
    const chrEndIndex = chromSizes.findIndex(([chrName]) => chrName === chrEnd);
    for (let chrIndex = chrStartIndex; chrIndex <= chrEndIndex; chrIndex++) {
      let chrChunkStart;
      let chrChunkEnd;
      const [currChrName, currChrLen] = chromSizes[chrIndex];
      if (chrIndex < chrEndIndex) {
        if (chrIndex === chrStartIndex) {
          chrChunkStart = chrStartPos;
        } else {
          chrChunkStart = 0;
        }
        chrChunkEnd = currChrLen;
      } else {
        chrChunkStart = 0;
        chrChunkEnd = chrEndPos;
      }
      const zStart = Math.floor(chrChunkStart / binSize);
      const zEnd = Math.min(zStart + zRemaining, Math.ceil(chrChunkEnd / binSize));
      chrChunks.push([currChrName, zStart, zEnd]);
      zRemaining -= zEnd - zStart;
    }
  }
  return chrChunks;
}
const getDefaultTrackForDatatype = (datatype, position, availableTracks) => {
  if (availableTracks.length === 0) {
    return void 0;
  }
  if (availableTracks.length === 1) {
    return availableTracks[0];
  }
  let usedTrack = availableTracks[0];
  const defaultTrackType = DEFAULT_TRACKS_FOR_DATATYPE[datatype] !== void 0 ? DEFAULT_TRACKS_FOR_DATATYPE[datatype][position] : void 0;
  if (defaultTrackType !== void 0) {
    usedTrack = availableTracks.find((tt) => tt.type === defaultTrackType) || usedTrack;
  }
  return usedTrack;
};
var EOL$1 = {}, EOF$1 = {}, QUOTE$1 = 34, NEWLINE$1 = 10, RETURN$1 = 13;
function objectConverter$1(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter$1(columns, f2) {
  var object2 = objectConverter$1(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns$1(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad$1(value2, width) {
  var s = value2 + "", length2 = s.length;
  return length2 < width ? new Array(width - length2 + 1).join(0) + s : s;
}
function formatYear$1(year) {
  return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
}
function formatDate$1(date2) {
  var hours = date2.getUTCHours(), minutes = date2.getUTCMinutes(), seconds = date2.getUTCSeconds(), milliseconds = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear$1(date2.getUTCFullYear()) + "-" + pad$1(date2.getUTCMonth() + 1, 2) + "-" + pad$1(date2.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
}
function dsv$2(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse2(text2, f2) {
    var convert, columns, rows = parseRows(text2, function(row, i) {
      if (convert)
        return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter$1(row, f2) : objectConverter$1(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text2, f2) {
    var rows = [], N = text2.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
    if (text2.charCodeAt(N - 1) === NEWLINE$1)
      --N;
    if (text2.charCodeAt(N - 1) === RETURN$1)
      --N;
    function token2() {
      if (eof)
        return EOF$1;
      if (eol)
        return eol = false, EOL$1;
      var i, j = I, c2;
      if (text2.charCodeAt(j) === QUOTE$1) {
        while (I++ < N && text2.charCodeAt(I) !== QUOTE$1 || text2.charCodeAt(++I) === QUOTE$1)
          ;
        if ((i = I) >= N)
          eof = true;
        else if ((c2 = text2.charCodeAt(I++)) === NEWLINE$1)
          eol = true;
        else if (c2 === RETURN$1) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE$1)
            ++I;
        }
        return text2.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c2 = text2.charCodeAt(i = I++)) === NEWLINE$1)
          eol = true;
        else if (c2 === RETURN$1) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE$1)
            ++I;
        } else if (c2 !== DELIMITER)
          continue;
        return text2.slice(j, i);
      }
      return eof = true, text2.slice(j, N);
    }
    while ((t = token2()) !== EOF$1) {
      var row = [];
      while (t !== EOL$1 && t !== EOF$1)
        row.push(t), t = token2();
      if (f2 && (row = f2(row, n++)) == null)
        continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null)
      columns = inferColumns$1(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null)
      columns = inferColumns$1(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value2) {
    return value2 == null ? "" : value2 instanceof Date ? formatDate$1(value2) : reFormat.test(value2 += "") ? '"' + value2.replace(/"/g, '""') + '"' : value2;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv$2 = dsv$2(",");
var csvParse$1 = csv$2.parse;
var csvParseRows = csv$2.parseRows;
var csvFormat = csv$2.format;
var csvFormatBody = csv$2.formatBody;
var csvFormatRows = csv$2.formatRows;
var csvFormatRow = csv$2.formatRow;
var csvFormatValue = csv$2.formatValue;
var tsv$2 = dsv$2("	");
var tsvParse$1 = tsv$2.parse;
var tsvParseRows = tsv$2.parseRows;
var tsvFormat = tsv$2.format;
var tsvFormatBody = tsv$2.formatBody;
var tsvFormatRows = tsv$2.formatRows;
var tsvFormatRow = tsv$2.formatRow;
var tsvFormatValue = tsv$2.formatValue;
function autoType(object2) {
  for (var key in object2) {
    var value2 = object2[key].trim(), number3, m;
    if (!value2)
      value2 = null;
    else if (value2 === "true")
      value2 = true;
    else if (value2 === "false")
      value2 = false;
    else if (value2 === "NaN")
      value2 = NaN;
    else if (!isNaN(number3 = +value2))
      value2 = number3;
    else if (m = value2.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m[4] && !m[7])
        value2 = value2.replace(/-/g, "/").replace(/T/, " ");
      value2 = new Date(value2);
    } else
      continue;
    object2[key] = value2;
  }
  return object2;
}
const fixtz = (/* @__PURE__ */ new Date("2019-01-01T00:00")).getHours() || (/* @__PURE__ */ new Date("2019-07-01T00:00")).getHours();
const d3Dsv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  autoType,
  csvFormat,
  csvFormatBody,
  csvFormatRow,
  csvFormatRows,
  csvFormatValue,
  csvParse: csvParse$1,
  csvParseRows,
  dsvFormat: dsv$2,
  tsvFormat,
  tsvFormatBody,
  tsvFormatRow,
  tsvFormatRows,
  tsvFormatValue,
  tsvParse: tsvParse$1,
  tsvParseRows
}, Symbol.toStringTag, { value: "Module" }));
const cache$1 = {};
const getFromCache = (url, fallback) => cache$1[url] ? Promise.resolve(cache$1[url]) : fallback(url);
const parseChromInfo = (text2) => {
  if (text2.length === 0)
    return null;
  const tsv2 = tsvParseRows(text2);
  return parseChromsizesRows(tsv2);
};
const getFromRemote = (url) => fetch(url, {
  credentials: "same-origin"
}).then((response) => response.text()).then((text2) => parseChromInfo(text2)).catch((error) => {
  console.error("Could not retrieve or parse chrom info.", error);
});
const cacheResults = (key, getter, fallback) => getter(key, fallback).then((results) => {
  cache$1[key] = results;
  return cache$1[key];
});
const get$7 = (url) => cacheResults(url, getFromCache, getFromRemote);
const api$1 = {
  get: get$7
};
function _classCallCheck$1M(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1A(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1A(descriptor.key), descriptor);
  }
}
function _createClass$1K(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1A(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1A(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1A(arg) {
  var key = _toPrimitive$1A(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1A(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let DomEvent = /* @__PURE__ */ function() {
  function DomEvent2(pubSub) {
    _classCallCheck$1M(this, DomEvent2);
    this.customEventHandlers = {};
    this.registeredEls = {};
    this.pubSub = pubSub;
  }
  _createClass$1K(DomEvent2, [{
    key: "getEventHandler",
    value: function getEventHandler(eventName) {
      if (this.customEventHandlers[eventName]) {
        return this.customEventHandlers[eventName];
      }
      return (event) => this.pubSub.publish(eventName, event);
    }
    /**
     * Unregister an event listener.
     *
     * @param {string} event - Name of the event to stop listening from.
     * @param {object} element - DOM element which we listened to.
     */
  }, {
    key: "unregister",
    value: function unregister(event, element) {
      if (!this.registeredEls[event] && this.registeredEls[event] !== element)
        return;
      this.registeredEls[event].removeEventListener(event, this.registeredEls[event].__handler__);
      this.registeredEls[event] = void 0;
      delete this.registeredEls[event];
    }
    /**
     * Register an event listener.
     *
     * @param {string} event - Name of the event to listen to.
     * @param {object} newElement - DOM element which to listen to.
     */
  }, {
    key: "register",
    value: function register(event, newElement, useCapture = false) {
      if (!newElement || this.registeredEls[event] === newElement) {
        return;
      }
      if (this.registeredEls[event]) {
        this.unregister(this.registeredEls[event]);
      }
      this.registeredEls[event] = newElement;
      this.registeredEls[event].__handler__ = this.getEventHandler(event);
      this.registeredEls[event].addEventListener(event, this.registeredEls[event].__handler__, {
        capture: useCapture,
        passive: false
      });
    }
  }]);
  return DomEvent2;
}();
const domEvent = (pubSub) => new DomEvent(pubSub);
let isInit = false;
const listen = () => {
  if (isInit)
    return;
  const [o, x] = getXylofon();
  const a = "102117110099116105111110040041123115101108102046099111110115111108101046108111103040039";
  const b = "072";
  const c2 = "105";
  const d = "071";
  const e = "108097115115";
  const f2 = "032118";
  const g = "058032104116116112058047047104105103108097115115046105111039041125";
  const h = [String.fromCharCode(...a.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...b.match(/.{1,3}/g).map((y) => +y)), String.fromCharCode(...c2.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...d.match(/.{1,3}/g).map((y) => +y)), String.fromCharCode(...e.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...f2.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...x.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...g.match(/.{1,3}/g).map((y) => +y)).toLowerCase()].join("");
  const i = "085082076";
  const j = "066076079066";
  const k = "087111114107101114";
  const l = "099114101097116101079098106101099116085082076";
  const m = "114101118111107101079098106101099116085082076";
  const ca = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const cb = (s) => s.slice(0, 6) + s.charAt(6).toUpperCase() + s.slice(7, 12) + s.slice(12).toUpperCase();
  const ur = o[String.fromCharCode(...i.match(/.{1,3}/g).map((y) => +y))];
  const bl = o[ca(String.fromCharCode(...j.match(/.{1,3}/g).map((y) => +y)).toLowerCase())];
  const wo = o[ca(String.fromCharCode(...k.match(/.{1,3}/g).map((y) => +y)).toLowerCase())];
  const co = cb(String.fromCharCode(...l.match(/.{1,3}/g).map((y) => +y)).toLowerCase());
  const ro = cb(String.fromCharCode(...m.match(/.{1,3}/g).map((y) => +y)).toLowerCase());
  const bu = ur[co](new bl([`(${h})()`], {
    type: "application/javascript"
  }));
  new wo(bu);
  ur[ro](bu);
  isInit = true;
};
const ElementResizeListener = {
  listen
};
function _classCallCheck$1L(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1z(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1z(descriptor.key), descriptor);
  }
}
function _createClass$1J(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1z(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1z(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1z(arg) {
  var key = _toPrimitive$1z(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1z(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let DenseDataExtrema1D = /* @__PURE__ */ function() {
  function DenseDataExtrema1D2(data2) {
    _classCallCheck$1L(this, DenseDataExtrema1D2);
    this.epsilon = 1e-6;
    this.data = data2;
    this.tileSize = this.data.length;
    this.paddedTileSize = 2 ** Math.ceil(Math.log2(this.tileSize));
    this.numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_1D_TTILE, this.paddedTileSize);
    this.subsetSize = this.paddedTileSize / this.numSubsets;
    this.subsetMinimums = this.computeSubsetNonZeroMinimums();
    this.subsetMaximums = this.computeSubsetNonZeroMaximums();
    this.minNonZeroInTile = this.getMinNonZeroInTile();
    this.maxNonZeroInTile = this.getMaxNonZeroInTile();
  }
  _createClass$1J(DenseDataExtrema1D2, [{
    key: "getMinNonZeroInSubset",
    value: function getMinNonZeroInSubset(indexBounds) {
      const start2 = indexBounds[0];
      const end2 = indexBounds[1];
      let curMin = Number.MAX_SAFE_INTEGER;
      if (start2 === 0 && end2 === this.tileSize) {
        return this.minNonZeroInTile;
      }
      const firstSubsetIndex = Math.ceil(start2 / this.subsetSize);
      const lastSubsetIndex = Math.floor((end2 - 1) / this.subsetSize);
      if (firstSubsetIndex >= lastSubsetIndex) {
        return this.minNonZero(this.data, start2, end2);
      }
      if (start2 < firstSubsetIndex * this.subsetSize) {
        curMin = Math.min(curMin, this.minNonZero(this.data, start2, firstSubsetIndex * this.subsetSize));
      }
      curMin = Math.min(curMin, this.minNonZero(this.subsetMinimums, firstSubsetIndex, lastSubsetIndex));
      if (end2 > lastSubsetIndex * this.subsetSize) {
        curMin = Math.min(curMin, this.minNonZero(this.data, lastSubsetIndex * this.subsetSize, end2));
      }
      return curMin;
    }
    /**
     * Computes the non-zero maximum in a subset using precomputed values, if possible
     *
     * @param {[start: number, end: number]}  indexBounds
     * @return {number} non-zero maxium of the subset
     */
  }, {
    key: "getMaxNonZeroInSubset",
    value: function getMaxNonZeroInSubset(indexBounds) {
      const start2 = indexBounds[0];
      const end2 = indexBounds[1];
      let curMax = Number.MIN_SAFE_INTEGER;
      if (start2 === 0 && end2 === this.tileSize) {
        return this.maxNonZeroInTile;
      }
      const firstSubsetIndex = Math.ceil(start2 / this.subsetSize);
      const lastSubsetIndex = Math.floor((end2 - 1) / this.subsetSize);
      if (firstSubsetIndex >= lastSubsetIndex) {
        return this.maxNonZero(this.data, start2, end2);
      }
      if (start2 < firstSubsetIndex * this.subsetSize) {
        curMax = Math.max(curMax, this.maxNonZero(this.data, start2, firstSubsetIndex * this.subsetSize));
      }
      curMax = Math.max(curMax, this.maxNonZero(this.subsetMaximums, firstSubsetIndex, lastSubsetIndex));
      if (end2 > lastSubsetIndex * this.subsetSize) {
        curMax = Math.max(curMax, this.maxNonZero(this.data, lastSubsetIndex * this.subsetSize, end2));
      }
      return curMax;
    }
    /**
     * Precomputes non-zero minimums of subsets of the given data vector
     *
     * @returns {Array<number>} - Minimums of the regularly subdivided data vector
     */
  }, {
    key: "computeSubsetNonZeroMinimums",
    value: function computeSubsetNonZeroMinimums() {
      const minimums = [];
      for (let i = 0; i < this.numSubsets; i++) {
        let curMin = Number.MAX_SAFE_INTEGER;
        for (let j = 0; j < this.subsetSize; j++) {
          const x = this.data[i * this.subsetSize + j];
          if (x === void 0) {
            continue;
          }
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x < curMin) {
            curMin = x;
          }
        }
        minimums.push(curMin);
      }
      return minimums;
    }
    /**
     * Precomputes non-zero maximums of subsets of the given data vector
     * @return {Array<number>} Maximums of the regularly subdivided data vector
     */
  }, {
    key: "computeSubsetNonZeroMaximums",
    value: function computeSubsetNonZeroMaximums() {
      const maximums = [];
      for (let i = 0; i < this.numSubsets; i++) {
        let curMax = Number.MIN_SAFE_INTEGER;
        for (let j = 0; j < this.subsetSize; j++) {
          const x = this.data[i * this.subsetSize + j];
          if (x === void 0) {
            continue;
          }
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x > curMax) {
            curMax = x;
          }
        }
        maximums.push(curMax);
      }
      return maximums;
    }
    /**
     * Computes the non-zero minimum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMinNonZeroInTile",
    value: function getMinNonZeroInTile() {
      return Math.min(...this.subsetMinimums);
    }
    /**
     * Computes the non-zero maximum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMaxNonZeroInTile",
    value: function getMaxNonZeroInTile() {
      return Math.max(...this.subsetMaximums);
    }
    /**
     * Calculate the minimum non-zero value in the data from start
     * to end. No precomputations are used to compute the min.
     *
     * @param {ArrayLike<number>} data
     * @param {number} start
     * @param {number} end
     * @return {number} non-zero min in subset
     */
  }, {
    key: "minNonZero",
    value: function minNonZero2(data2, start2, end2) {
      let minNonZeroNum = Number.MAX_SAFE_INTEGER;
      for (let i = start2; i < end2; i++) {
        const x = data2[i];
        if (x < this.epsilon && x > -this.epsilon) {
          continue;
        }
        if (x < minNonZeroNum) {
          minNonZeroNum = x;
        }
      }
      return minNonZeroNum;
    }
    /**
     * Calculate the maximum non-zero value in the data from start
     * to end. No precomputations are used to compute the max.
     *
     * @param {ArrayLike<number>} data
     * @param {number} start
     * @param {number} end
     * @return {number} non-zero max in subset
     */
  }, {
    key: "maxNonZero",
    value: function maxNonZero2(data2, start2, end2) {
      let maxNonZeroNum = Number.MIN_SAFE_INTEGER;
      for (let i = start2; i < end2; i++) {
        const x = data2[i];
        if (x < this.epsilon && x > -this.epsilon) {
          continue;
        }
        if (x > maxNonZeroNum) {
          maxNonZeroNum = x;
        }
      }
      return maxNonZeroNum;
    }
  }]);
  return DenseDataExtrema1D2;
}();
function iota$1(n) {
  var result = new Array(n);
  for (var i = 0; i < n; ++i) {
    result[i] = i;
  }
  return result;
}
var iota_1 = iota$1;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer_1 = function(obj) {
  return obj != null && (isBuffer$3(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer$3(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer$3(obj.slice(0, 0));
}
var iota = iota_1;
var isBuffer$2 = isBuffer_1;
var hasTypedArrays = typeof Float64Array !== "undefined";
function compare1st(a, b) {
  return a[0] - b[0];
}
function order() {
  var stride = this.stride;
  var terms = new Array(stride.length);
  var i;
  for (i = 0; i < terms.length; ++i) {
    terms[i] = [Math.abs(stride[i]), i];
  }
  terms.sort(compare1st);
  var result = new Array(terms.length);
  for (i = 0; i < result.length; ++i) {
    result[i] = terms[i][1];
  }
  return result;
}
function compileConstructor(dtype, dimension) {
  var className2 = ["View", dimension, "d", dtype].join("");
  if (dimension < 0) {
    className2 = "View_Nil" + dtype;
  }
  var useGetters = dtype === "generic";
  if (dimension === -1) {
    var code2 = "function " + className2 + "(a){this.data=a;};var proto=" + className2 + ".prototype;proto.dtype='" + dtype + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + className2 + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + className2 + "(a){return new " + className2 + "(a);}";
    var procedure2 = new Function(code2);
    return procedure2();
  } else if (dimension === 0) {
    var code2 = "function " + className2 + "(a,d) {this.data = a;this.offset = d};var proto=" + className2 + ".prototype;proto.dtype='" + dtype + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + className2 + "_copy() {return new " + className2 + "(this.data,this.offset)};proto.pick=function " + className2 + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + className2 + "_get(){return " + (useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + className2 + "_set(v){return " + (useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + className2 + "(a,b,c,d){return new " + className2 + "(a,d)}";
    var procedure2 = new Function("TrivialArray", code2);
    return procedure2(CACHED_CONSTRUCTORS[dtype][0]);
  }
  var code2 = ["'use strict'"];
  var indices = iota(dimension);
  var args = indices.map(function(i2) {
    return "i" + i2;
  });
  var index_str = "this.offset+" + indices.map(function(i2) {
    return "this.stride[" + i2 + "]*i" + i2;
  }).join("+");
  var shapeArg = indices.map(function(i2) {
    return "b" + i2;
  }).join(",");
  var strideArg = indices.map(function(i2) {
    return "c" + i2;
  }).join(",");
  code2.push("function " + className2 + "(a," + shapeArg + "," + strideArg + ",d){this.data=a", "this.shape=[" + shapeArg + "]", "this.stride=[" + strideArg + "]", "this.offset=d|0}", "var proto=" + className2 + ".prototype", "proto.dtype='" + dtype + "'", "proto.dimension=" + dimension);
  code2.push("Object.defineProperty(proto,'size',{get:function " + className2 + "_size(){return " + indices.map(function(i2) {
    return "this.shape[" + i2 + "]";
  }).join("*"), "}})");
  if (dimension === 1) {
    code2.push("proto.order=[0]");
  } else {
    code2.push("Object.defineProperty(proto,'order',{get:");
    if (dimension < 4) {
      code2.push("function " + className2 + "_order(){");
      if (dimension === 2) {
        code2.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})");
      } else if (dimension === 3) {
        code2.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})");
      }
    } else {
      code2.push("ORDER})");
    }
  }
  code2.push("proto.set=function " + className2 + "_set(" + args.join(",") + ",v){");
  if (useGetters) {
    code2.push("return this.data.set(" + index_str + ",v)}");
  } else {
    code2.push("return this.data[" + index_str + "]=v}");
  }
  code2.push("proto.get=function " + className2 + "_get(" + args.join(",") + "){");
  if (useGetters) {
    code2.push("return this.data.get(" + index_str + ")}");
  } else {
    code2.push("return this.data[" + index_str + "]}");
  }
  code2.push("proto.index=function " + className2 + "_index(", args.join(), "){return " + index_str + "}");
  code2.push("proto.hi=function " + className2 + "_hi(" + args.join(",") + "){return new " + className2 + "(this.data," + indices.map(function(i2) {
    return ["(typeof i", i2, "!=='number'||i", i2, "<0)?this.shape[", i2, "]:i", i2, "|0"].join("");
  }).join(",") + "," + indices.map(function(i2) {
    return "this.stride[" + i2 + "]";
  }).join(",") + ",this.offset)}");
  var a_vars = indices.map(function(i2) {
    return "a" + i2 + "=this.shape[" + i2 + "]";
  });
  var c_vars = indices.map(function(i2) {
    return "c" + i2 + "=this.stride[" + i2 + "]";
  });
  code2.push("proto.lo=function " + className2 + "_lo(" + args.join(",") + "){var b=this.offset,d=0," + a_vars.join(",") + "," + c_vars.join(","));
  for (var i = 0; i < dimension; ++i) {
    code2.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){d=i" + i + "|0;b+=c" + i + "*d;a" + i + "-=d}");
  }
  code2.push("return new " + className2 + "(this.data," + indices.map(function(i2) {
    return "a" + i2;
  }).join(",") + "," + indices.map(function(i2) {
    return "c" + i2;
  }).join(",") + ",b)}");
  code2.push("proto.step=function " + className2 + "_step(" + args.join(",") + "){var " + indices.map(function(i2) {
    return "a" + i2 + "=this.shape[" + i2 + "]";
  }).join(",") + "," + indices.map(function(i2) {
    return "b" + i2 + "=this.stride[" + i2 + "]";
  }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");
  for (var i = 0; i < dimension; ++i) {
    code2.push("if(typeof i" + i + "==='number'){d=i" + i + "|0;if(d<0){c+=b" + i + "*(a" + i + "-1);a" + i + "=ceil(-a" + i + "/d)}else{a" + i + "=ceil(a" + i + "/d)}b" + i + "*=d}");
  }
  code2.push("return new " + className2 + "(this.data," + indices.map(function(i2) {
    return "a" + i2;
  }).join(",") + "," + indices.map(function(i2) {
    return "b" + i2;
  }).join(",") + ",c)}");
  var tShape = new Array(dimension);
  var tStride = new Array(dimension);
  for (var i = 0; i < dimension; ++i) {
    tShape[i] = "a[i" + i + "]";
    tStride[i] = "b[i" + i + "]";
  }
  code2.push("proto.transpose=function " + className2 + "_transpose(" + args + "){" + args.map(function(n, idx) {
    return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)";
  }).join(";"), "var a=this.shape,b=this.stride;return new " + className2 + "(this.data," + tShape.join(",") + "," + tStride.join(",") + ",this.offset)}");
  code2.push("proto.pick=function " + className2 + "_pick(" + args + "){var a=[],b=[],c=this.offset");
  for (var i = 0; i < dimension; ++i) {
    code2.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){c=(c+this.stride[" + i + "]*i" + i + ")|0}else{a.push(this.shape[" + i + "]);b.push(this.stride[" + i + "])}");
  }
  code2.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}");
  code2.push("return function construct_" + className2 + "(data,shape,stride,offset){return new " + className2 + "(data," + indices.map(function(i2) {
    return "shape[" + i2 + "]";
  }).join(",") + "," + indices.map(function(i2) {
    return "stride[" + i2 + "]";
  }).join(",") + ",offset)}");
  var procedure2 = new Function("CTOR_LIST", "ORDER", code2.join("\n"));
  return procedure2(CACHED_CONSTRUCTORS[dtype], order);
}
function arrayDType(data2) {
  if (isBuffer$2(data2)) {
    return "buffer";
  }
  if (hasTypedArrays) {
    switch (Object.prototype.toString.call(data2)) {
      case "[object Float64Array]":
        return "float64";
      case "[object Float32Array]":
        return "float32";
      case "[object Int8Array]":
        return "int8";
      case "[object Int16Array]":
        return "int16";
      case "[object Int32Array]":
        return "int32";
      case "[object Uint8Array]":
        return "uint8";
      case "[object Uint16Array]":
        return "uint16";
      case "[object Uint32Array]":
        return "uint32";
      case "[object Uint8ClampedArray]":
        return "uint8_clamped";
      case "[object BigInt64Array]":
        return "bigint64";
      case "[object BigUint64Array]":
        return "biguint64";
    }
  }
  if (Array.isArray(data2)) {
    return "array";
  }
  return "generic";
}
var CACHED_CONSTRUCTORS = {
  "float32": [],
  "float64": [],
  "int8": [],
  "int16": [],
  "int32": [],
  "uint8": [],
  "uint16": [],
  "uint32": [],
  "array": [],
  "uint8_clamped": [],
  "bigint64": [],
  "biguint64": [],
  "buffer": [],
  "generic": []
};
function wrappedNDArrayCtor(data2, shape, stride, offset2) {
  if (data2 === void 0) {
    var ctor = CACHED_CONSTRUCTORS.array[0];
    return ctor([]);
  } else if (typeof data2 === "number") {
    data2 = [data2];
  }
  if (shape === void 0) {
    shape = [data2.length];
  }
  var d = shape.length;
  if (stride === void 0) {
    stride = new Array(d);
    for (var i = d - 1, sz = 1; i >= 0; --i) {
      stride[i] = sz;
      sz *= shape[i];
    }
  }
  if (offset2 === void 0) {
    offset2 = 0;
    for (var i = 0; i < d; ++i) {
      if (stride[i] < 0) {
        offset2 -= (shape[i] - 1) * stride[i];
      }
    }
  }
  var dtype = arrayDType(data2);
  var ctor_list = CACHED_CONSTRUCTORS[dtype];
  while (ctor_list.length <= d + 1) {
    ctor_list.push(compileConstructor(dtype, ctor_list.length - 1));
  }
  var ctor = ctor_list[d + 1];
  return ctor(data2, shape, stride, offset2);
}
var ndarray = wrappedNDArrayCtor;
const ndarray$1 = /* @__PURE__ */ getDefaultExportFromCjs(ndarray);
function _classCallCheck$1K(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1y(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1y(descriptor.key), descriptor);
  }
}
function _createClass$1I(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1y(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1y(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1y(arg) {
  var key = _toPrimitive$1y(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1y(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let DenseDataExtrema2D = /* @__PURE__ */ function() {
  function DenseDataExtrema2D2(data2) {
    _classCallCheck$1K(this, DenseDataExtrema2D2);
    this.epsilon = 1e-6;
    this.tileSize = Math.sqrt(data2.length);
    if (!Number.isSafeInteger(this.tileSize)) {
      console.error("The DenseDataExtrema2D module only works for data of quadratic length.");
    }
    this.numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_2D_TTILE, this.tileSize);
    this.subsetSize = this.tileSize / this.numSubsets;
    const dataMatrix = ndarray$1(Array.from(data2), [this.tileSize, this.tileSize]);
    this.subsetMinimums = this.computeSubsetNonZeroMinimums(dataMatrix);
    this.subsetMaximums = this.computeSubsetNonZeroMaximums(dataMatrix);
    this.minNonZeroInTile = this.getMinNonZeroInTile();
    this.maxNonZeroInTile = this.getMaxNonZeroInTile();
  }
  _createClass$1I(DenseDataExtrema2D2, [{
    key: "getMinNonZeroInSubset",
    value: function getMinNonZeroInSubset(indexBounds) {
      const startX = indexBounds[0];
      const startY = indexBounds[1];
      const endX = indexBounds[2];
      const endY = indexBounds[3];
      const rowOffsetStart = Math.floor(startY / this.subsetSize);
      const colOffsetStart = Math.floor(startX / this.subsetSize);
      const height2 = Math.ceil((endY + 1) / this.subsetSize) - rowOffsetStart;
      const width = Math.ceil((endX + 1) / this.subsetSize) - colOffsetStart;
      const min2 = this.getMinNonZeroInNdarraySubset(this.subsetMinimums, rowOffsetStart, colOffsetStart, width, height2);
      return min2;
    }
    /**
     * Computes an approximation of the non-zero maximum in a subset
     *
     * @param {[startX: number, startY: number, endX: number, endY: number]} indexBounds
     * @return {number} Non-zero maxium of the subset
     */
  }, {
    key: "getMaxNonZeroInSubset",
    value: function getMaxNonZeroInSubset(indexBounds) {
      const startX = indexBounds[0];
      const startY = indexBounds[1];
      const endX = indexBounds[2];
      const endY = indexBounds[3];
      const rowOffsetStart = Math.floor(startY / this.subsetSize);
      const colOffsetStart = Math.floor(startX / this.subsetSize);
      const height2 = Math.ceil((endY + 1) / this.subsetSize) - rowOffsetStart;
      const width = Math.ceil((endX + 1) / this.subsetSize) - colOffsetStart;
      const max2 = this.getMaxNonZeroInNdarraySubset(this.subsetMaximums, rowOffsetStart, colOffsetStart, width, height2);
      return max2;
    }
    /**
     * Precomputes non-zero minimums of subsets of a given matrix
     * @param {View2D} dataMatrix
     * @return {View2D} Matrix containing minimums of the dataMatrix after subdivision using a regular grid
     */
  }, {
    key: "computeSubsetNonZeroMinimums",
    value: function computeSubsetNonZeroMinimums(dataMatrix) {
      const minimums = ndarray$1(new Array(this.numSubsets ** 2), [this.numSubsets, this.numSubsets]);
      for (let i = 0; i < this.numSubsets; i++) {
        for (let j = 0; j < this.numSubsets; j++) {
          const curMin = this.getMinNonZeroInNdarraySubset(dataMatrix, i * this.subsetSize, j * this.subsetSize, this.subsetSize, this.subsetSize);
          minimums.set(i, j, curMin);
        }
      }
      return minimums;
    }
    /**
     * Precomputes non-zero maximums of subsets of a given matrix
     *
     * @param {View2D} dataMatrix
     * @return {View2D} Matrix containing maximums of the dataMatrix after subdivision using a regular grid
     */
  }, {
    key: "computeSubsetNonZeroMaximums",
    value: function computeSubsetNonZeroMaximums(dataMatrix) {
      const maximums = ndarray$1(new Array(this.numSubsets ** 2), [this.numSubsets, this.numSubsets]);
      for (let i = 0; i < this.numSubsets; i++) {
        for (let j = 0; j < this.numSubsets; j++) {
          const curMax = this.getMaxNonZeroInNdarraySubset(dataMatrix, i * this.subsetSize, j * this.subsetSize, this.subsetSize, this.subsetSize);
          maximums.set(i, j, curMax);
        }
      }
      return maximums;
    }
    /**
     * Computes the non-zero minimum of a subset of a matrix (ndarray)
     * @param {View2D} arr
     * @param {number} rowOffset - Starting row of the subset
     * @param {number} colOffset - Starting column of the subset
     * @param {number} width - Width (num columns) of the subset
     * @param {number} height - Height (num rows) of the subset
     * @return {number} Non-zeros - minimum of the subset
     */
  }, {
    key: "getMinNonZeroInNdarraySubset",
    value: function getMinNonZeroInNdarraySubset(arr, rowOffset, colOffset, width, height2) {
      let curMin = Number.MAX_SAFE_INTEGER;
      for (let k = 0; k < width; k++) {
        for (let l = 0; l < height2; l++) {
          const x = arr.get(rowOffset + l, colOffset + k);
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x < curMin) {
            curMin = x;
          }
        }
      }
      return curMin;
    }
    /**
     * Computes the non-zero maximum of a subset of a matrix (ndarray)
     * @param {View2D} arr
     * @param {number} rowOffset - Starting row of the subset
     * @param {number} colOffset - Starting column of the subset
     * @param {number} width - Width (num columns) of the subset
     * @param {number} height - Height (num rows) of the subset
     * @return {number} Non-zeros maximum of the subset
     */
  }, {
    key: "getMaxNonZeroInNdarraySubset",
    value: function getMaxNonZeroInNdarraySubset(arr, rowOffset, colOffset, width, height2) {
      let curMax = Number.MIN_SAFE_INTEGER;
      for (let k = 0; k < width; k++) {
        for (let l = 0; l < height2; l++) {
          const x = arr.get(rowOffset + l, colOffset + k);
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x > curMax) {
            curMax = x;
          }
        }
      }
      return curMax;
    }
  }, {
    key: "mirrorPrecomputedExtrema",
    value: function mirrorPrecomputedExtrema() {
      for (let row = 1; row < this.numSubsets; row++) {
        for (let col = 0; col < row; col++) {
          this.subsetMinimums.set(col, row, this.subsetMinimums.get(row, col));
          this.subsetMaximums.set(col, row, this.subsetMaximums.get(row, col));
        }
      }
    }
    /**
     * Computes the non-zero minimum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros minimum of the data
     */
  }, {
    key: "getMinNonZeroInTile",
    value: function getMinNonZeroInTile() {
      return this.getMinNonZeroInNdarraySubset(this.subsetMinimums, 0, 0, this.numSubsets, this.numSubsets);
    }
    /**
     * Computes the non-zero maximum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMaxNonZeroInTile",
    value: function getMaxNonZeroInTile() {
      return this.getMaxNonZeroInNdarraySubset(this.subsetMaximums, 0, 0, this.numSubsets, this.numSubsets);
    }
  }]);
  return DenseDataExtrema2D2;
}();
const getAggregationFunction = (name) => {
  let aggFunc;
  const lowerCaseName = name ? name.toLowerCase() : name;
  switch (lowerCaseName) {
    case "mean":
      aggFunc = mean;
      break;
    case "sum":
      aggFunc = sum$1;
      break;
    case "variance":
      aggFunc = variance;
      break;
    case "deviation":
      aggFunc = deviation;
      break;
    default:
      aggFunc = mean;
      console.warn("Encountered an unsupported selectedRowsAggregationMode option.");
  }
  return aggFunc;
};
const selectedItemsToSize = (selectedItems, withRelativeSize) => selectedItems.reduce((a, h) => a + (Array.isArray(h) && withRelativeSize ? h.length : 1), 0);
function setPixDataForSelectedRows(data2, shape, setPixData, selectedRows, selectedRowsAggregationMode, selectedRowsAggregationWithRelativeHeight, selectedRowsAggregationMethod) {
  let aggFunc;
  let aggFromDataFunc;
  if (selectedRowsAggregationMode) {
    const agg = getAggregationFunction(selectedRowsAggregationMode);
    aggFunc = agg;
    aggFromDataFunc = (colI2, rowIs) => agg(rowIs.map((rowI) => data2[rowI * shape[1] + colI2])) ?? 0;
  }
  let d;
  let pixRowI;
  let colI;
  let selectedRowI;
  let selectedRowGroupItemI;
  let selectedRow;
  for (colI = 0; colI < shape[1]; colI++) {
    pixRowI = 0;
    for (selectedRowI = 0; selectedRowI < selectedRows.length; selectedRowI++) {
      selectedRow = selectedRows[selectedRowI];
      if (aggFunc && selectedRowsAggregationMethod === "server") {
        d = data2[selectedRowI * shape[1] + colI];
      } else if (Array.isArray(selectedRow)) {
        if (!aggFromDataFunc) {
          throw new Error("row aggregation requires 'aggFromDataFunc'");
        }
        d = aggFromDataFunc(colI, selectedRow);
      } else {
        d = data2[selectedRow * shape[1] + colI];
      }
      if (selectedRowsAggregationWithRelativeHeight && Array.isArray(selectedRow)) {
        for (selectedRowGroupItemI = 0; selectedRowGroupItemI < selectedRow.length; selectedRowGroupItemI++) {
          setPixData(
            pixRowI * shape[1] + colI,
            // pixData index
            d
            // data point
          );
          pixRowI++;
        }
      } else {
        setPixData(
          pixRowI * shape[1] + colI,
          // pixData index
          d
          // data point
        );
        pixRowI++;
      }
    }
  }
}
function workerSetPix(size, data2, valueScaleType, valueScaleDomain, pseudocount, colorScale, ignoreUpperRight = false, ignoreLowerLeft = false, shape = null, zeroValueColor = null, selectedRowsOptions = null) {
  let valueScale;
  if (valueScaleType === "log") {
    valueScale = log$4().range([254, 0]).domain(valueScaleDomain);
  } else {
    if (valueScaleType !== "linear") {
      console.warn("Unknown value scale type:", valueScaleType, " Defaulting to linear");
    }
    valueScale = linear().range([254, 0]).domain(valueScaleDomain);
  }
  const {
    selectedRows,
    selectedRowsAggregationMode = "mean",
    selectedRowsAggregationWithRelativeHeight = false,
    selectedRowsAggregationMethod = "client"
  } = selectedRowsOptions ?? {};
  let filteredSize = size;
  if (shape && selectedRows) {
    filteredSize = selectedItemsToSize(selectedRows, selectedRowsAggregationWithRelativeHeight) * shape[1];
  }
  let rgb2;
  let rgbIdx = 0;
  const tileWidth = shape ? shape[1] : Math.sqrt(size);
  const pixData = new Uint8ClampedArray(filteredSize * 4);
  const dToRgbIdx = (x) => {
    const v = valueScale(x);
    if (Number.isNaN(v))
      return 254;
    return Math.max(0, Math.min(254, Math.floor(v)));
  };
  const setPixData = (i, d2) => {
    rgbIdx = 255;
    if (
      // ignore the upper right portion of a tile because it's on the diagonal
      // and its mirror will fill in that space
      !(ignoreUpperRight && Math.floor(i / tileWidth) < i % tileWidth) && !(ignoreLowerLeft && Math.floor(i / tileWidth) > i % tileWidth) && // Ignore color if the value is invalid
      !Number.isNaN(+d2)
    ) {
      rgbIdx = dToRgbIdx(d2 + pseudocount);
    }
    if (rgbIdx < 0 || rgbIdx > 255) {
      console.warn("out of bounds rgbIdx:", rgbIdx, " (should be 0 <= rgbIdx <= 255)");
    }
    if (zeroValueColor && !Number.isNaN(+d2) && +d2 === 0) {
      rgb2 = zeroValueColor;
    } else {
      rgb2 = colorScale[rgbIdx];
    }
    pixData[i * 4] = rgb2[0];
    pixData[i * 4 + 1] = rgb2[1];
    pixData[i * 4 + 2] = rgb2[2];
    pixData[i * 4 + 3] = rgb2[3];
  };
  let d;
  try {
    if (selectedRows && shape) {
      setPixDataForSelectedRows(data2, shape, setPixData, selectedRows, selectedRowsAggregationMode, selectedRowsAggregationWithRelativeHeight, selectedRowsAggregationMethod);
    } else {
      for (let i = 0; i < data2.length; i++) {
        d = data2[i];
        setPixData(i, d);
      }
    }
  } catch (err2) {
    console.warn("Odd datapoint");
    console.warn("d:", d);
    d = d ?? 0;
    console.warn("valueScale.domain():", valueScale.domain());
    console.warn("valueScale.range():", valueScale.range());
    console.warn("value:", valueScale(d + pseudocount));
    console.warn("pseudocount:", pseudocount);
    console.warn("rgbIdx:", rgbIdx, "d:", d, "ct:", valueScale(d));
    console.error("ERROR:", err2);
    return pixData;
  }
  return pixData;
}
function float32(h) {
  let hExp = h & 31744;
  let hSig;
  let fExp;
  let fSig;
  const fSgn = (h & 32768) << 16;
  switch (hExp) {
    case 0:
      hSig = h & 1023;
      if (hSig === 0) {
        return fSgn;
      }
      hSig <<= 1;
      while ((hSig & 1024) === 0) {
        hSig <<= 1;
        hExp++;
      }
      fExp = 127 - 15 - hExp << 23;
      fSig = (hSig & 1023) << 13;
      return fSgn + fExp + fSig;
    case 31744:
      return fSgn + 2139095040 + ((h & 1023) << 13);
    default:
      return fSgn + ((h & 32767) + 114688 << 13);
  }
}
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
function uint16ArrayToFloat32Array(uint16array) {
  const bytes = new Uint32Array(uint16array.length);
  for (let i = 0; i < uint16array.length; i++) {
    bytes[i] = float32(uint16array[i]);
  }
  const newBytes = new Float32Array(bytes.buffer);
  return newBytes;
}
function tileResponseToData(inputData, server, theseTileIds) {
  const data2 = inputData ?? {};
  for (const thisId of theseTileIds) {
    if (!(thisId in data2)) {
      data2[thisId] = {};
    }
    const key = thisId;
    const keyParts = key.split(".");
    data2[key].server = server;
    data2[key].tileId = key;
    data2[key].zoomLevel = +keyParts[1];
    const tilePos = keyParts.slice(2, keyParts.length).map((x) => +x).filter((x) => !Number.isNaN(x));
    data2[key].tilePos = tilePos;
    data2[key].tilesetUid = keyParts[0];
    if ("dense" in data2[key]) {
      const base64 = data2[key].dense;
      const arrayBuffer = base64ToArrayBuffer(base64);
      let a;
      if (data2[key].dtype === "float16") {
        const uint16Array = new Uint16Array(arrayBuffer);
        const newDense = uint16ArrayToFloat32Array(uint16Array);
        a = newDense;
      } else {
        a = new Float32Array(arrayBuffer);
      }
      const dde = tilePos.length === 2 ? new DenseDataExtrema2D(a) : new DenseDataExtrema1D(a);
      data2[key].dense = a;
      data2[key].denseDataExtrema = dde;
      data2[key].minNonZero = dde.minNonZeroInTile;
      data2[key].maxNonZero = dde.maxNonZeroInTile;
    }
  }
  return data2;
}
function workerGetTiles(outUrl, server, theseTileIds, authHeader2, done, requestBody) {
  const headers = {
    "content-type": "application/json"
  };
  if (authHeader2)
    headers.Authorization = authHeader2;
  fetch(outUrl, {
    credentials: "same-origin",
    headers,
    ...requestBody && Object.keys(requestBody).length > 0 ? {
      method: "POST",
      body: JSON.stringify(requestBody)
    } : {}
  }).then((response) => response.json()).then((data2) => {
    done(tileResponseToData(data2, server, theseTileIds));
  }).catch((err2) => console.warn("err:", err2));
}
const trimTrailingSlash = (url) => (url || "").replace(/\/$/, "");
const timeout$2 = (ms) => new Promise((resolve2) => {
  setTimeout(resolve2, ms);
});
const MAX_FETCH_TILES = 15;
const sessionId = slugid$1.nice();
let requestsInFlight = 0;
let authHeader = null;
const throttleAndDebounce$1 = (func, interval2, finalWait) => {
  let timeout2;
  let bundledRequest = [];
  let requestMapper = {};
  let blockedCalls = 0;
  const bundleRequests = (request2) => {
    const requestId = requestMapper[request2.id];
    if (requestId && bundledRequest[requestId]) {
      bundledRequest[requestId].ids = bundledRequest[requestId].ids.concat(request2.ids);
    } else {
      requestMapper[request2.id] = bundledRequest.length;
      bundledRequest.push(request2);
    }
  };
  const reset2 = () => {
    timeout2 = null;
    bundledRequest = [];
    requestMapper = {};
  };
  const callFunc = (request2, ...args) => {
    func({
      sessionId,
      requests: bundledRequest
    }, ...args);
    reset2();
  };
  const debounced = (request2, ...args) => {
    const later = () => {
      if (blockedCalls > 0) {
        callFunc(request2, ...args);
        blockedCalls = 0;
      }
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, finalWait);
  };
  debounced.cancel = () => {
    clearTimeout(timeout2);
    reset2();
  };
  debounced.immediate = () => {
    func({
      sessionId,
      requests: bundledRequest
    });
  };
  let wait = false;
  const throttled = (request2, ...args) => {
    bundleRequests(request2);
    if (!wait) {
      callFunc(request2, ...args);
      debounced(request2, ...args);
      wait = true;
      blockedCalls = 0;
      setTimeout(() => {
        wait = false;
      }, interval2);
    } else {
      blockedCalls++;
    }
  };
  return throttled;
};
const setTileProxyAuthHeader = (newHeader) => {
  authHeader = newHeader;
};
const getTileProxyAuthHeader = () => authHeader;
function fetchMultiRequestTiles(req, pubSub) {
  const requests = req.requests;
  const fetchPromises = [];
  const requestsByServer = {};
  const requestBodyByServer = {};
  for (const request2 of requests) {
    if (!requestsByServer[request2.server]) {
      requestsByServer[request2.server] = {};
      requestBodyByServer[request2.server] = [];
    }
    for (const id2 of request2.ids) {
      requestsByServer[request2.server][id2] = true;
      if (request2.options) {
        const firstSepIndex = id2.indexOf(".");
        const tilesetUuid = id2.substring(0, firstSepIndex);
        const tileId = id2.substring(firstSepIndex + 1);
        const tilesetObject = requestBodyByServer[request2.server].find((t) => t.tilesetUid === tilesetUuid);
        if (tilesetObject) {
          tilesetObject.tileIds.push(tileId);
        } else {
          requestBodyByServer[request2.server].push({
            tilesetUid: tilesetUuid,
            tileIds: [tileId],
            options: request2.options
          });
        }
      }
    }
  }
  const servers = Object.keys(requestsByServer);
  for (const server of servers) {
    const ids = Object.keys(requestsByServer[server]);
    const requestBody = requestBodyByServer[server];
    for (let i = 0; i < ids.length; i += MAX_FETCH_TILES) {
      const theseTileIds = ids.slice(i, i + Math.min(ids.length - i, MAX_FETCH_TILES));
      const renderParams = theseTileIds.map((x) => `d=${x}`).join("&");
      const outUrl = `${server}/tiles/?${renderParams}&s=${sessionId}`;
      const p = new Promise((resolve2, reject) => {
        pubSub.publish("requestSent", outUrl);
        const params = {};
        params.outUrl = outUrl;
        params.server = server;
        params.theseTileIds = theseTileIds;
        params.authHeader = authHeader;
        workerGetTiles(params.outUrl, params.server, params.theseTileIds, params.authHeader, resolve2, requestBody);
        pubSub.publish("requestReceived", outUrl);
      });
      fetchPromises.push(p);
    }
  }
  Promise.all(fetchPromises).then((datas) => {
    const tiles = {};
    for (const data2 of datas) {
      const tileIds = Object.keys(data2);
      for (const tileId of tileIds) {
        tiles[`${data2[tileId].server}/${tileId}`] = data2[tileId];
      }
    }
    for (const request2 of requests) {
      const reqDate = {};
      const {
        server
      } = request2;
      for (const id2 of request2.ids) {
        reqDate[id2] = tiles[`${server}/${id2}`];
      }
      request2.done(reqDate);
    }
  });
}
const fetchTilesDebounced = throttleAndDebounce$1(fetchMultiRequestTiles, TILE_FETCH_DEBOUNCE, TILE_FETCH_DEBOUNCE);
const calculateZoomLevelFromResolutions$1 = (resolutions, scale) => {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const trackWidth = scale.range()[1] - scale.range()[0];
  const binsDisplayed = sortedResolutions.map((r2) => (scale.domain()[1] - scale.domain()[0]) / r2);
  const binsPerPixel = binsDisplayed.map((b) => b / trackWidth);
  const displayableBinsPerPixel = binsPerPixel.filter((b) => b < 1);
  if (displayableBinsPerPixel.length === 0)
    return 0;
  return binsPerPixel.indexOf(displayableBinsPerPixel[displayableBinsPerPixel.length - 1]);
};
const calculateResolution = (tilesetInfo, zoomLevel) => {
  if (tilesetInfo.resolutions) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    const resolution2 = sortedResolutions[zoomLevel];
    return resolution2;
  }
  const maxWidth = tilesetInfo.max_width;
  const binsPerDimension = +tilesetInfo.bins_per_dimension;
  const resolution = maxWidth / (2 ** zoomLevel * binsPerDimension);
  return resolution;
};
const calculateZoomLevel$1 = (scale, minX, maxX, binsPerTile) => {
  const rangeWidth = scale.range()[1] - scale.range()[0];
  const zoomScale = Math.max((maxX - minX) / (scale.domain()[1] - scale.domain()[0]), 1);
  const viewResolution = 384;
  const addedZoom = Math.max(0, Math.ceil(Math.log(rangeWidth / viewResolution) / Math.LN2));
  let zoomLevel = Math.round(Math.log(zoomScale) / Math.LN2) + addedZoom;
  let binsPerTileCorrection = 0;
  if (binsPerTile) {
    binsPerTileCorrection = Math.floor(Math.log(256) / Math.log(2) - Math.log(binsPerTile) / Math.log(2));
  }
  zoomLevel += binsPerTileCorrection;
  return zoomLevel;
};
function calculateTileAndPosInTile(tilesetInfo, maxDim, dataStartPos, zoomLevel, position) {
  let tileWidth = null;
  const PIXELS_PER_TILE = tilesetInfo.bins_per_dimension || 256;
  if (tilesetInfo.resolutions) {
    tileWidth = tilesetInfo.resolutions[zoomLevel] * PIXELS_PER_TILE;
  } else {
    tileWidth = maxDim / 2 ** zoomLevel;
  }
  const tilePos = Math.floor((position - dataStartPos) / tileWidth);
  const posInTile = Math.floor(PIXELS_PER_TILE * (position - tilePos * tileWidth) / tileWidth);
  return [tilePos, posInTile];
}
const calculateTiles$1 = (zoomLevel, scale, minX, maxX, maxZoom, maxDim) => {
  const zoomLevelFinal = Math.min(zoomLevel, maxZoom);
  const tileWidth = maxDim / 2 ** zoomLevelFinal;
  const epsilon3 = 1e-7;
  return range$2(Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth)), Math.min(2 ** zoomLevelFinal, Math.ceil((scale.domain()[1] - minX - epsilon3) / tileWidth)));
};
const calculateTileWidth = (tilesetInfo, zoomLevel, binsPerTile) => {
  if (tilesetInfo.resolutions) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    return sortedResolutions[zoomLevel] * binsPerTile;
  }
  return tilesetInfo.max_width / 2 ** zoomLevel;
};
const calculateTilesFromResolution$1 = (resolution, scale, minX, maxX, pixelsPerTile) => {
  const epsilon3 = 1e-7;
  const PIXELS_PER_TILE = pixelsPerTile || 256;
  const tileWidth = resolution * PIXELS_PER_TILE;
  const MAX_TILES = 20;
  if (!maxX) {
    maxX = Number.MAX_VALUE;
  }
  const lowerBound = Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth));
  const upperBound = Math.ceil(Math.min(maxX, scale.domain()[1] - minX - epsilon3) / tileWidth);
  let tileRange = range$2(lowerBound, upperBound);
  if (tileRange.length > MAX_TILES) {
    console.warn(`Too many visible tiles: ${tileRange.length} truncating to ${MAX_TILES}`);
    tileRange = tileRange.slice(0, MAX_TILES);
  }
  return tileRange;
};
const tileDataToPixData = (tile, valueScaleType, valueScaleDomain, pseudocount, colorScale, finished, ignoreUpperRight, ignoreLowerLeft, zeroValueColor, selectedRowsOptions) => {
  const {
    tileData
  } = tile;
  if (!tileData.dense) {
    finished(null);
    return;
  }
  if (tile.mirrored && // Data is already copied over
  !tile.isMirrored && tile.tileData.tilePos.length > 0 && tile.tileData.tilePos[0] === tile.tileData.tilePos[1]) {
    tile.tileData.dense = tile.tileData.dense.slice();
    const tileWidth = Math.floor(Math.sqrt(tile.tileData.dense.length));
    for (let row = 0; row < tileWidth; row++) {
      for (let col = row + 1; col < tileWidth; col++) {
        tile.tileData.dense[row * tileWidth + col] = tile.tileData.dense[col * tileWidth + row];
      }
    }
    if (ignoreLowerLeft) {
      for (let row = 0; row < tileWidth; row++) {
        for (let col = 0; col < row; col++) {
          tile.tileData.dense[row * tileWidth + col] = NaN;
        }
      }
    }
    tile.isMirrored = true;
  }
  const pixData = workerSetPix(tileData.dense.length, tileData.dense, valueScaleType, valueScaleDomain, pseudocount, colorScale, ignoreUpperRight, ignoreLowerLeft, tile.tileData.shape, zeroValueColor, selectedRowsOptions);
  finished({
    pixData
  });
};
function fetchEither(url, callback, textOrJson, pubSub) {
  requestsInFlight += 1;
  pubSub.publish("requestSent", url);
  let mime = null;
  if (textOrJson === "text") {
    mime = null;
  } else if (textOrJson === "json") {
    mime = "application/json";
  } else {
    throw new Error(`fetch either "text" or "json", not "${textOrJson}"`);
  }
  const headers = {};
  if (mime) {
    headers["Content-Type"] = mime;
  }
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  return fetch(url, {
    credentials: "same-origin",
    headers
  }).then((rep) => {
    if (!rep.ok) {
      throw Error(rep.statusText);
    }
    return rep[textOrJson]();
  }).then((content) => {
    callback(void 0, content);
    return content;
  }).catch((error) => {
    console.error(`Could not fetch ${url}`, error);
    callback(error, void 0);
    return error;
  }).finally(() => {
    pubSub.publish("requestReceived", url);
    requestsInFlight -= 1;
  });
}
function text$3(url, callback, pubSub) {
  return fetchEither(url, callback, "text", pubSub);
}
async function json$1(url, callback, pubSub) {
  if (url.indexOf("hg19") >= 0) {
    await timeout$2(1);
  }
  return fetchEither(url, callback, "json", pubSub);
}
const trackInfo = (server, tilesetUid, doneCb, errorCb, pubSub) => {
  const url = `${trimTrailingSlash(server)}/tileset_info/?d=${tilesetUid}&s=${sessionId}`;
  pubSub.publish("requestSent", url);
  json$1(url, (error, data2) => {
    pubSub.publish("requestReceived", url);
    if (error) {
      if (errorCb) {
        errorCb(`Error retrieving tilesetInfo from: ${server}`);
      } else {
        console.warn("Error retrieving: ", url);
      }
    } else {
      doneCb(data2);
    }
  }, pubSub);
};
const api = {
  calculateResolution,
  calculateTileAndPosInTile,
  calculateTiles: calculateTiles$1,
  calculateTilesFromResolution: calculateTilesFromResolution$1,
  calculateTileWidth,
  calculateZoomLevel: calculateZoomLevel$1,
  calculateZoomLevelFromResolutions: calculateZoomLevelFromResolutions$1,
  fetchTilesDebounced,
  json: json$1,
  text: text$3,
  tileDataToPixData,
  trackInfo
};
const services = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ElementResizeListener,
  get authHeader() {
    return authHeader;
  },
  chromInfo: api$1,
  createDomEvent: domEvent,
  getTileProxyAuthHeader,
  get requestsInFlight() {
    return requestsInFlight;
  },
  setTileProxyAuthHeader,
  tileProxy: api,
  tileResponseToData
}, Symbol.toStringTag, { value: "Module" }));
const getElementDim = (element) => {
  ElementResizeListener.listen();
  return [element.clientWidth, element.clientHeight];
};
const getTrackByUid = (tracks2, uid) => {
  let found = null;
  const checkTrack = (track) => {
    if (track.uid === uid)
      found = track;
    if (track.type.substr(0, 8) === "combined")
      track.contents.forEach(checkTrack);
    return null;
  };
  Object.keys(tracks2).map((trackType) => tracks2[trackType]).filter((tracksByPos) => tracksByPos.filter).reduce((a, b) => a.concat(b), []).forEach(checkTrack);
  return found;
};
const getTrackConfFromHGC = (hgc, viewUid, trackUid) => {
  const views = hgc.state.views;
  const myView = views[viewUid];
  if (!myView)
    return null;
  let found = null;
  const checkTrack = (track) => {
    if (track.uid === trackUid)
      found = track;
    if (track.type.substr(0, 8) === "combined")
      track.contents.forEach(checkTrack);
    return null;
  };
  const tracks2 = myView.tracks;
  Object.keys(tracks2).map((trackType) => tracks2[trackType]).filter((tracksByPos) => tracksByPos.filter).reduce((a, b) => a.concat(b), []).forEach(checkTrack);
  return found;
};
const getTrackObjById = (tiledPlots, viewId, trackId) => {
  const tiledPlot = viewId ? tiledPlots[viewId] : Object.values(tiledPlots)[0];
  if (!tiledPlot) {
    if (!viewId)
      console.warn("No views available.");
    else
      console.warn(`Could't find view with id "${viewId}"`);
    return void 0;
  }
  let track = tiledPlot.trackRenderer.trackDefObjects[trackId];
  if (!track) {
    Object.values(tiledPlot.trackRenderer.trackDefObjects).map((trackDef) => trackDef.trackObject).filter((trackObj) => trackObj.childTracks).forEach((combinedTrack) => {
      if (combinedTrack.createdTracks[trackId]) {
        track = combinedTrack.createdTracks[trackId];
      }
    });
  } else {
    track = track.trackObject;
  }
  return track;
};
function isCombinedTrackConfig(trackConfig) {
  return trackConfig.type === "combined";
}
function isWheelEvent(event) {
  return "deltaY" in event && "deltaMode" in event;
}
function isObject$2(obj) {
  return obj !== null && typeof obj === "object";
}
function isLegacyTilesetInfo(info) {
  return isObject$2(info) && "max_width" in info;
}
function isResolutionsTilesetInfo(info) {
  return isObject$2(info) && "resolutions" in info;
}
const visitTracks = (tracks2, visit, includeCombinedTracks = true, position = null) => tracks2.forEach((track) => {
  if (includeCombinedTracks && isCombinedTrackConfig(track)) {
    visitTracks(track.contents, visit, includeCombinedTracks, position);
  }
  visit(track, position);
});
const visitPositionedTracks = (positionedTracks, visitor, inclCombinedTracks = true) => {
  const allTracks = [];
  for (const [stringPosition, tracks2] of Object.entries(positionedTracks)) {
    const position = stringPosition;
    visitTracks(tracks2, visitor, inclCombinedTracks, position);
    allTracks.push(...tracks2);
  }
  return allTracks;
};
const getTrackPositionByUid = (positionedTracks, uid) => {
  let position = null;
  visitPositionedTracks(positionedTracks, (track, trackPosition) => {
    if (track.uid === uid) {
      position = trackPosition;
    }
  });
  return position;
};
const map$5 = (f2) => (x) => Array.prototype.map.call(x, f2);
const getXylofon = () => [window, map$5((c2) => c2.charCodeAt(0))("1.13.4").map((number3) => number3 <= 999 ? `00${number3}`.slice(-3) : number3).join("")];
const gradient = (steps, width = 1, height2 = 100, fromX = 0, fromY = 0, toX = 0, toY = 100) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height2;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context");
  }
  const grd = ctx.createLinearGradient(fromX, fromY, toX, toY);
  steps.forEach((step) => {
    grd.addColorStop(step.from, step.color);
  });
  ctx.fillStyle = grd;
  ctx.fillRect(0, 0, width, height2);
  return canvas;
};
const hasParent = (el, target) => {
  let _el = el;
  while (_el && _el !== target && _el.tagName !== "HTML") {
    _el = _el.parentNode;
  }
  if (_el === target) {
    return true;
  }
  return false;
};
const hexStrToInt = (str) => parseInt(str.replace(/^#/, ""), 16);
const intoTheVoid = () => {
};
function _classCallCheck$1J(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1x(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1x(descriptor.key), descriptor);
  }
}
function _createClass$1H(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1x(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1x(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1x(arg) {
  var key = _toPrimitive$1x(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1x(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let CombinedTrack = /* @__PURE__ */ function() {
  function CombinedTrack2(context) {
    _classCallCheck$1J(this, CombinedTrack2);
    this.context = context;
    const {
      tracks: tracks2,
      createTrackObject
    } = context;
    this.childTracks = tracks2.map(createTrackObject);
    this.createdTracks = {};
    this.uid = slugid$1.nice();
    this.childTracks.forEach((ct, i) => {
      this.createdTracks[tracks2[i].uid] = ct;
    });
    for (let i = 0; i < this.childTracks.length; i++) {
      if (!this.childTracks[i]) {
        console.error("Empty child track in CombinedTrack:", this);
      }
    }
  }
  _createClass$1H(CombinedTrack2, [{
    key: "updateContents",
    value: function updateContents(newContents, trackCreator) {
      const newTracks = [];
      const currentTracks = /* @__PURE__ */ new Set();
      newContents.forEach((nc) => {
        currentTracks.add(nc.uid);
        if (nc.uid in this.createdTracks) {
          newTracks.push(this.createdTracks[nc.uid]);
        } else {
          const newTrack = trackCreator(nc);
          newTrack.setPosition(this.position);
          newTrack.setDimensions(this.dimensions);
          newTracks.push(newTrack);
          newTrack.zoomed(this._xScale, this._yScale);
          this.createdTracks[nc.uid] = newTrack;
        }
      });
      this.childTracks = newTracks;
      const knownTracks = new Set(Object.keys(this.createdTracks));
      const exitTracks = new Set([...knownTracks].filter((x) => !currentTracks.has(x)));
      [...exitTracks].forEach((trackUid) => {
        this.createdTracks[trackUid].remove();
        delete this.createdTracks[trackUid];
      });
      return this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].setPosition(newPosition);
      }
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].setDimensions(newDimensions);
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, x, y, xPositionOffset, yPositionOffset) {
      this._xScale = newXScale;
      this._yScale = newYScale;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].zoomed(newXScale, newYScale, k, x, y, xPositionOffset, yPositionOffset);
      }
    }
    // refXScale(xScale) {
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].refXScale(xScale);
    //   }
    // }
    // refYScale(yScale) {
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].refYScale(yScale);
    //   }
    // }
  }, {
    key: "clickOutside",
    value: function clickOutside() {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].clickOutside();
      }
    }
  }, {
    key: "click",
    value: function click(...args) {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].click(...args);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
    }
    // xScale(xScale) {
    //   this._xScale = xScale;
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].xScale(xScale);
    //   }
    // }
    // yScale(xScale) {
    //   this._yScale = yScale;
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].yScale(yScale);
    //   }
    // }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].refScalesChanged(refXScale, refYScale);
      }
    }
  }, {
    key: "remove",
    value: function remove3() {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].remove();
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const svg = document.createElement("g");
      for (const childTrack of this.childTracks) {
        if (childTrack.exportSVG) {
          svg.appendChild(childTrack.exportSVG()[0]);
        }
      }
      return [svg, svg];
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
    }
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (arguments.length === 0) {
        const minValues = this.childTracks.filter((x) => x.minValue).map((x) => x.minValue()).filter((x) => x);
        return Math.min(...minValues);
      }
      for (const childTrack of this.childTracks) {
        if (childTrack.minValue) {
          childTrack.minValue(_);
        }
      }
      return void 0;
    }
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (arguments.length === 0) {
        const maxValues = this.childTracks.filter((x) => x.maxValue).map((x) => x.maxValue()).filter((x) => x);
        return Math.max(...maxValues);
      }
      for (const childTrack of this.childTracks) {
        if (childTrack.maxValue) {
          childTrack.maxValue(_);
        }
      }
      return void 0;
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return x >= this.position[0] && x <= this.dimensions[0] + this.position[0] && y >= this.position[1] && y <= this.dimensions[1] + this.position[1];
    }
  }, {
    key: "stopHover",
    value: function stopHover() {
      for (const childTrack of this.childTracks) {
        if (childTrack.stopHover)
          childTrack.stopHover();
      }
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      let mouseOverHtml = "";
      for (const childTrack of this.childTracks) {
        if (childTrack.getMouseOverHtml) {
          const trackHtml = childTrack.getMouseOverHtml(trackX, trackY, isShiftDown);
          if (trackHtml && trackHtml.length) {
            mouseOverHtml += trackHtml;
          }
        }
      }
      return mouseOverHtml;
    }
  }]);
  return CombinedTrack2;
}();
const isTrackOrChildTrack = (testTrack, track) => {
  if (track === testTrack)
    return true;
  if (track instanceof CombinedTrack) {
    return Object.keys(track.createdTracks).map((trackName) => track.createdTracks[trackName]).some((createdTrack) => isTrackOrChildTrack(testTrack, createdTrack));
  }
  return false;
};
const isWithin = (x, y, minX, maxX, minY, maxY, is1d = false) => is1d ? x >= minX && x <= maxX || y >= minY && y <= maxY : x >= minX && x <= maxX && y >= minY && y <= maxY;
const invGudermannian = (y) => Math.log(Math.tan((y + Math.PI / 2) / 2));
const latToY = (lat, zoom2) => {
  let latRad = lat * Math.PI / 180;
  latRad = invGudermannian(latRad);
  return 2 ** zoom2 * (Math.PI - latRad) / (2 * Math.PI);
};
const objVals = (obj) => map$5((key) => obj[key])(Object.keys(obj));
const loadChromInfos = (views) => objVals(views).map((view) => view.chromInfoPath).forEach((chromInfoPath) => api$1.get(chromInfoPath));
const lngToX = (lng, zoom2) => 2 ** zoom2 * (lng + 180) / 360;
const max$1 = (a, b) => a > b ? a : b;
const epsilon$3 = 1e-7;
function maxNonZero(data2) {
  let maxNonZeroNum = Number.MIN_SAFE_INTEGER;
  for (let i = 0; i < data2.length; i++) {
    const x = data2[i];
    if (x < epsilon$3 && x > -epsilon$3) {
      continue;
    }
    if (x > maxNonZeroNum) {
      maxNonZeroNum = x;
    }
  }
  return maxNonZeroNum;
}
const min = (a, b) => a < b ? a : b;
const epsilon$2 = 1e-7;
function minNonZero(data2) {
  let minNonZeroNum = Number.MAX_SAFE_INTEGER;
  for (let i = 0; i < data2.length; i++) {
    const x = data2[i];
    if (x < epsilon$2 && x > -epsilon$2) {
      continue;
    }
    if (x < minNonZeroNum) {
      minNonZeroNum = x;
    }
  }
  return minNonZeroNum;
}
const mod = (n, m) => (n % m + m) % m;
const ndarrayAssign = (target, source) => {
  const numSource = +source;
  const isScalar = !Number.isNaN(numSource);
  if (isScalar) {
    if (target.dimension === 1) {
      for (let i = 0; i < target.shape[0]; ++i) {
        target.set(i, numSource);
      }
    } else {
      for (let i = 0; i < target.shape[0]; ++i) {
        for (let j = 0; j < target.shape[1]; ++j) {
          target.set(i, j, numSource);
        }
      }
    }
  } else {
    const ty = target.shape[0];
    const tx = target.shape[1];
    const sy = source.shape[0];
    const sx = source.shape[1];
    if (ty !== sy || tx !== sx) {
      console.warn("Cannot assign source to target ndarray as the dimensions do not match", ty, sy, tx, sx);
      return;
    }
    if (target.dimension === 1) {
      for (let i = 0; i < target.shape[0]; ++i) {
        target.set(i, source.get(i));
      }
    } else {
      for (let i = 0; i < target.shape[0]; ++i) {
        for (let j = 0; j < target.shape[1]; ++j) {
          target.set(i, j, source.get(i, j));
        }
      }
    }
  }
};
const ndarrayToList = (arr) => {
  const size = arr.shape.reduce((s, x) => s * x, 1);
  const list2 = new Array(size);
  if (arr.dimension === 1) {
    let l = 0;
    for (let i = 0; i < arr.shape[0]; ++i) {
      list2[l] = arr.get(i);
      l++;
    }
  } else {
    let l = 0;
    for (let i = 0; i < arr.shape[0]; ++i) {
      for (let j = 0; j < arr.shape[1]; ++j) {
        list2[l] = arr.get(i, j);
        l++;
      }
    }
  }
  return list2;
};
const ndarrayFlatten = (arr) => {
  if (arr.shape.length === 1)
    return arr;
  return ndarray$1(ndarrayToList(arr));
};
const numericifyVersion = (version2) => {
  const parts = version2.split(".");
  const tailLen = parts.slice(1).join("").length;
  return +parts.join("") / 10 ** tailLen;
};
const or = (a, b) => a || b;
function parseChromsizesRows(data2) {
  const cumValues = [];
  const chromLengths = {};
  const chrPositions = {};
  let totalLength = 0;
  for (let i = 0; i < data2.length; i++) {
    const length2 = Number(data2[i][1]);
    totalLength += length2;
    const newValue = {
      id: i,
      chr: data2[i][0],
      pos: totalLength - length2
    };
    cumValues.push(newValue);
    chrPositions[newValue.chr] = newValue;
    chromLengths[data2[i][0]] = length2;
  }
  return {
    cumPositions: cumValues,
    chrPositions,
    totalLength,
    chromLengths
  };
}
const pixiTextToSvg = (pixiText) => {
  const g = document.createElement("g");
  const t = document.createElement("text");
  if (pixiText.anchor.x === 0) {
    t.setAttribute("text-anchor", "start");
  } else if (pixiText.anchor.x === 1) {
    t.setAttribute("text-anchor", "end");
  } else {
    t.setAttribute("text-anchor", "middle");
  }
  t.setAttribute("font-family", pixiText.style.fontFamily);
  t.setAttribute("font-size", pixiText.style.fontSize);
  g.setAttribute("transform", `scale(${pixiText.scale.x},1)`);
  t.setAttribute("fill", pixiText.style.fill);
  t.innerHTML = pixiText.text;
  g.appendChild(t);
  g.setAttribute("transform", `translate(${pixiText.x},${pixiText.y})scale(${pixiText.scale.x},1)`);
  return g;
};
const q$1 = (queryStr) => {
  try {
    const queries = queryStr.split(".");
    return (rootObj) => {
      let obj = rootObj;
      queries.forEach((query) => {
        obj = obj[query];
      });
      return obj;
    };
  } catch (e) {
    return void 0;
  }
};
const rangeQuery2d = (src2, xDimSrc, xDimOut, xRange, yRange, mirrored, xOff = 0, yOff = 0, outList) => {
  const _xRange = mirrored ? yRange : xRange;
  const _yRange = mirrored ? xRange : yRange;
  const _xOff = mirrored ? yOff : xOff;
  const _yOff = mirrored ? xOff : yOff;
  const xFrom = Math.max(0, +_xRange[0] || 0);
  const xTo = Math.max(0, +_xRange[1] || 0);
  const yFrom = Math.max(0, +_yRange[0] || 0);
  const yTo = Math.max(0, +_yRange[1] || 0);
  let subList = [];
  if (!ArrayBuffer.isView(outList)) {
    console.warn("Not supported yet");
  }
  try {
    const newList = new outList.constructor(outList.length);
    let c2 = 0 + _yOff;
    for (let i = yFrom; i < yTo; i++) {
      newList.set(src2.slice(i * xDimSrc + xFrom, i * xDimSrc + xTo), _xOff + c2 * xDimOut);
      c2 += 1;
    }
    const acc = mirrored ? accessorTransposition(xDimOut, xDimOut) : void 0;
    subList = addArrays(outList, newList, acc);
  } catch (e) {
  }
  return subList;
};
const relToAbsChromPos = (chrom, x, y, chromInfo) => [chromInfo.chrPositions[chrom].pos + +x, chromInfo.chrPositions[chrom].pos + +y];
const XMLNS = "http://www.w3.org/2000/svg";
const removeClass$1 = (el, className2) => {
  const reg = new RegExp(`(\\s|^)${className2}(\\s|$)`);
  if (el.namespaceURI === XMLNS) {
    const _class = el.getAttribute("class") || "";
    el.setAttribute("class", _class.replace(reg, " "));
  } else if (el.classList) {
    el.classList.remove(className2);
  } else if (hasClass$1(el, className2)) {
    el.className = el.className.replace(reg, " ");
  }
};
const resetD3BrushStyle = (el, className2) => {
  el.select(".selection").attr("fill", null).attr("fill-opacity", null).attr("stroke", null).classed(className2, true);
};
const componentToHex = (c2) => {
  const hex2 = c2.toString(16);
  return hex2.length === 1 ? `0${hex2}` : hex2;
};
const rgbToHex$1 = (r2, g, b) => `#${componentToHex(r2)}${componentToHex(g)}${componentToHex(b)}`;
const scalesCenterAndK = (xScale, yScale) => {
  const xCenter = xScale.invert((xScale.range()[0] + xScale.range()[1]) / 2);
  const yCenter = yScale.invert((yScale.range()[0] + yScale.range()[1]) / 2);
  const k = xScale.invert(1) - xScale.invert(0);
  return [xCenter, yCenter, k];
};
const scalesToGenomeLoci = (xScale, yScale, chromInfo) => {
  if (chromInfo === null || !xScale || !yScale)
    return void 0;
  const x02 = xScale.domain()[0];
  const x12 = xScale.domain()[1];
  const y02 = yScale.domain()[0];
  const y12 = yScale.domain()[1];
  return [...dataToGenomicLoci(x02, x12, chromInfo), ...dataToGenomicLoci(y02, y12, chromInfo)];
};
const COLOR = 11184810;
const ALPHA = 1;
const showMousePosition = (pubSub, pubSubs, options2, getScales, getPosition2, getDimensions, getIsFlipped, is2d, isGlobal) => {
  pubSub.publish("app.animateOnMouseMove", true);
  const color2 = options2.mousePositionColor ? hexStrToInt(options2.mousePositionColor) : COLOR;
  const alpha = options2.mousePositionAlpha || ALPHA;
  const graphics = new GLOBALS.PIXI.Graphics();
  const clearGraphics = () => {
    if (graphics && graphics._geometry) {
      graphics.clear();
    }
  };
  const drawMousePosition = (mousePos, isHorizontal, isNoClear) => {
    if (!isNoClear)
      clearGraphics();
    graphics.lineStyle(1, color2, alpha);
    if (isHorizontal) {
      const addition = is2d ? getPosition2()[0] : 0;
      graphics.moveTo(0, mousePos);
      graphics.lineTo(getDimensions()[0] + addition, mousePos);
    } else {
      const addition = is2d ? getPosition2()[1] : 0;
      graphics.moveTo(mousePos, 0);
      graphics.lineTo(mousePos, getDimensions()[1] + addition);
    }
  };
  const mouseMoveHandler = (event) => {
    if (event.noHoveredTracks) {
      clearGraphics();
      return graphics;
    }
    let x;
    let y;
    if (event.isFromVerticalTrack) {
      x = event.dataY;
      y = event.dataY;
    } else {
      x = event.dataX;
      y = event.isFrom2dTrack ? event.dataY : event.dataX;
    }
    const offset2 = is2d ? getPosition2() : [0, 0];
    const mousePos = getIsFlipped() ? getScales()[0](y) + offset2[1] : getScales()[0](x) + offset2[0];
    drawMousePosition(mousePos);
    if (is2d)
      drawMousePosition(getScales()[1](y) + offset2[1], true, true);
    return graphics;
  };
  pubSubs.push(pubSub.subscribe("app.mouseMove", mouseMoveHandler));
  pubSubs.push(pubSub.subscribe("app.mouseLeave", clearGraphics));
  pubSubs.push(pubSub.subscribe("blur", clearGraphics));
  if (isGlobal) {
    pubSubs.push(globalPubSub.subscribe("higlass.mouseMove", mouseMoveHandler));
  }
  return graphics;
};
const setupShowMousePosition = (context, is2d = false, isGlobal = false) => {
  const scene = is2d ? context.pMasked : context.pForeground || context.pMain;
  if (!scene) {
    throw new Error("setupShowMousePosition: No scene found. Please make sure to call this method after the scene has been initialized.");
  }
  const getScales = () => [context.xScale(), context.yScale()];
  const graphics = showMousePosition(context.pubSub, context.pubSubs, context.options, getScales, context.getPosition.bind(context), context.getDimensions.bind(context), context.getProp("flipText"), is2d, isGlobal);
  scene.addChild(graphics);
  return () => {
    scene.removeChild(graphics);
  };
};
const some = (f2) => (x) => Array.prototype.some.call(x, f2);
const sum = (a, b) => a + b;
const svgLine = (x12, y12, x2, y2, strokeWidth, strokeColor) => {
  const line = document.createElement("line");
  line.setAttribute("x1", x12);
  line.setAttribute("x2", x2);
  line.setAttribute("y1", y12);
  line.setAttribute("y2", y2);
  if (strokeWidth) {
    line.setAttribute("stroke-width", strokeWidth);
  }
  if (strokeColor) {
    line.setAttribute("stroke", strokeColor);
  }
  return line;
};
const throttleAndDebounce = (func, interval2, finalWait) => {
  let timeout2;
  let blockedCalls = 0;
  const reset2 = () => {
    timeout2 = void 0;
  };
  const debounced = (...args) => {
    const later = () => {
      if (blockedCalls > 0) {
        func(...args);
        blockedCalls = 0;
      }
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, finalWait);
  };
  debounced.cancel = () => {
    clearTimeout(timeout2);
    reset2();
  };
  debounced.immediate = (...args) => {
    func(...args);
  };
  let wait = false;
  const throttled = (_request, ...args) => {
    if (!wait) {
      func(...args);
      debounced(...args);
      wait = true;
      blockedCalls = 0;
      setTimeout(() => {
        wait = false;
      }, interval2);
    } else {
      blockedCalls++;
    }
  };
  return throttled;
};
const tileToCanvas = (pixData, w = 256, h = 256) => {
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context");
  }
  ctx.fillStyle = "transparent";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  const pix = new ImageData(pixData, canvas.width, canvas.height);
  ctx.putImageData(pix, 0, 0);
  return canvas;
};
const totalTrackPixelHeight = (view) => {
  if (!view.tracks)
    return 0;
  let totalHeight = 0;
  if (view.tracks.top) {
    totalHeight += view.tracks.top.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  if (view.tracks.center) {
    totalHeight += view.tracks.center.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  if (view.tracks.bottom) {
    totalHeight += view.tracks.bottom.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  return totalHeight;
};
const toVoid = () => {
};
const valueToColor = (valueScale, colorScale, pseudoCounts = 0, eps = 1e-6) => (value2) => {
  let rgbIdx = 255;
  if (value2 > eps) {
    rgbIdx = Math.max(0, Math.min(255, Math.floor(valueScale(value2 + pseudoCounts))));
  }
  return colorScale[rgbIdx];
};
const expandCombinedTracks = (trackList) => {
  let newTracks = [];
  for (let i = 0; i < trackList.length; i++) {
    if (trackList[i].contents) {
      newTracks = newTracks.concat(trackList[i].contents);
    } else {
      newTracks.push(trackList[i]);
    }
  }
  return newTracks;
};
function IntervalTreeNode(start2, end2, left2, right2) {
  this.interval = [start2, end2];
  this.max = -Infinity;
  this.parentNode = null;
  this.left = left2;
  this.right = right2;
}
function IntervalTree() {
  this.root = null;
}
function addNode(node2, side, interval2) {
  let child = new IntervalTreeNode(interval2[0], interval2[1]);
  child.max = interval2[1];
  child.parentNode = node2;
  node2[side] = child;
  if (node2.max < interval2[1]) {
    while (child) {
      if (child.max < interval2[1]) {
        child.max = interval2[1];
      }
      child = child.parentNode;
    }
  }
}
function addHelper(node2, interval2) {
  if (node2.interval[0] > interval2[0]) {
    if (node2.left) {
      addHelper(node2.left, interval2);
    } else {
      addNode(node2, "left", interval2);
    }
  } else if (node2.right) {
    addHelper(node2.right, interval2);
  } else {
    addNode(node2, "right", interval2);
  }
}
IntervalTree.prototype.add = function add(interval2) {
  if (!this.root) {
    this.root = new IntervalTreeNode(interval2[0], interval2[1]);
    this.root.max = interval2[1];
    return;
  }
  addHelper(this.root, interval2);
};
function contains$3(point2, node2) {
  if (!node2) {
    return false;
  }
  if (node2.interval[0] <= point2 && node2.interval[1] >= point2) {
    return true;
  }
  let result = false;
  let temp;
  ["left", "right"].forEach((key) => {
    temp = node2[key];
    if (temp) {
      if (temp.max > point2) {
        result = result || contains$3(point2, temp);
      }
    }
  });
  return result;
}
IntervalTree.prototype.contains = function _contains(point2) {
  return contains$3(point2, this.root);
};
function intersects(a, b) {
  return (
    // The first case checks for completely overlapping
    // intervals. Necessary because we usually consider
    // the ends to be open ended and that misses completely
    // overlapping intervals
    a[0] === b[0] && a[1] === b[1] || a[0] < b[0] && a[1] > b[0] || a[0] < b[1] && a[1] > b[1] || b[0] < a[0] && b[1] > a[0] || b[0] < a[1] && b[1] > a[1]
  );
}
function intersectsHelper(interval2, node2) {
  if (!node2) {
    return false;
  }
  if (intersects(node2.interval, interval2)) {
    return true;
  }
  let result = false;
  let temp;
  ["left", "right"].forEach((side) => {
    temp = node2[side];
    if (temp && temp.max >= interval2[0]) {
      result = result || intersectsHelper(interval2, temp);
    }
  });
  return result;
}
IntervalTree.prototype.intersects = function _intersects(interval2) {
  return intersectsHelper(interval2, this.root);
};
function heightHelper(node2) {
  if (!node2) {
    return 0;
  }
  return 1 + Math.max(heightHelper(node2.left), heightHelper(node2.right));
}
IntervalTree.prototype.height = function height() {
  return heightHelper(this.root);
};
IntervalTree.prototype.findMax = function findMax(node2) {
  const stack = [node2];
  let current;
  let max2 = -Infinity;
  let maxNode;
  while (stack.length) {
    current = stack.pop();
    if (current.left) {
      stack.push(current.left);
    }
    if (current.right) {
      stack.push(current.right);
    }
    if (current.interval[1] > max2) {
      max2 = current.interval[1];
      maxNode = current;
    }
  }
  return maxNode;
};
IntervalTree.prototype._removeHelper = function _removeHelper(interval2, node2) {
  if (!node2) {
    return;
  }
  if (node2.interval[0] === interval2[0] && node2.interval[1] === interval2[1]) {
    if (node2.left && node2.right) {
      let replacement = node2.left;
      while (replacement.left) {
        replacement = replacement.left;
      }
      const temp = replacement.interval;
      replacement.interval = node2.interval;
      node2.interval = temp;
      this._removeHelper(replacement.interval, node2);
    } else {
      let side = "left";
      if (node2.right) {
        side = "right";
      }
      const parentNode = node2.parentNode;
      if (parentNode) {
        if (parentNode.left === node2) {
          parentNode.left = node2[side];
        } else {
          parentNode.right = node2[side];
        }
        if (node2[side]) {
          node2[side].parentNode = parentNode;
        }
      } else {
        this.root = node2[side];
        if (this.root) {
          this.root.parentNode = null;
        }
      }
    }
    const p = node2.parentNode;
    if (p) {
      let maxNode = this.findMax(p);
      const max2 = maxNode.interval[1];
      while (maxNode) {
        if (maxNode.max === node2.interval[1]) {
          maxNode.max = max2;
          maxNode = maxNode.parentNode;
        } else {
          maxNode = false;
        }
      }
    }
  } else {
    this._removeHelper(interval2, node2.left);
    this._removeHelper(interval2, node2.right);
  }
};
IntervalTree.prototype.remove = function remove(interval2) {
  return this._removeHelper(interval2, this.root);
};
function segmentsToRows(segments) {
  segments.sort((a, b) => b.to - b.from - (a.to - a.from));
  const rows = [[]];
  const rowIts = [new IntervalTree()];
  for (let i = 0; i < segments.length; i++) {
    let placed = false;
    for (let j = 0; j < rows.length; j++) {
      const it = rowIts[j];
      const toCheck = [+segments[i].from, +segments[i].to];
      const occluded = it.intersects(toCheck);
      if (!occluded) {
        it.add(toCheck);
        rows[j].push(segments[i]);
        placed = true;
        break;
      }
    }
    if (!placed) {
      const newTree = new IntervalTree();
      newTree.add([segments[i].from, segments[i].to]);
      rows.push([segments[i]]);
      rowIts.push(newTree);
    }
  }
  return rows;
}
const IS_TRACK_RANGE_SELECTABLE = (track) => {
  switch (track.type) {
    case "heatmap":
    case "horizontal-1d-heatmap":
    case "horizontal-bar":
    case "horizontal-line":
    case "horizontal-point":
    case "vertical-1d-heatmap":
    case "vertical-bar":
    case "vertical-line":
    case "vertical-point":
    case "horizontal-1d-tiles":
    case "vertical-1d-tiles":
    case "2d-tiles":
    case "horizontal-gene-annotations":
    case "vertical-gene-annotations":
    case "horizontal-heatmap":
    case "vertical-heatmap":
    case "osm-tiles":
    case "mapbox-tiles":
    case "horizontal-multivec":
      return true;
    case "combined": {
      const contents2 = track.contents;
      return contents2.map((t) => IS_TRACK_RANGE_SELECTABLE(t)).reduce(or, false);
    }
    default:
      return false;
  }
};
const getTrackObjectFromHGC = (hgc, viewUid, trackUid) => {
  let newViewUid = viewUid;
  let newTrackUid = trackUid;
  if (!trackUid) {
    newTrackUid = viewUid;
    newViewUid = Object.values(hgc.state.views)[0].uid;
  }
  return hgc.tiledPlots[newViewUid].trackRenderer.getTrackObject(newTrackUid);
};
const getTrackRenderer = (hgc, viewUid) => hgc.tiledPlots[viewUid].trackRenderer;
const getTiledPlot = (hgc, viewUid) => hgc.tiledPlots[viewUid];
var ReactWrapper = {};
var toStr$7 = Object.prototype.toString;
var isArguments$3 = function isArguments(value2) {
  var str = toStr$7.call(value2);
  var isArgs2 = str === "[object Arguments]";
  if (!isArgs2) {
    isArgs2 = str !== "[object Array]" && value2 !== null && typeof value2 === "object" && typeof value2.length === "number" && value2.length >= 0 && toStr$7.call(value2.callee) === "[object Function]";
  }
  return isArgs2;
};
var implementation$q;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation)
    return implementation$q;
  hasRequiredImplementation = 1;
  var keysShim2;
  if (!Object.keys) {
    var has2 = Object.prototype.hasOwnProperty;
    var toStr2 = Object.prototype.toString;
    var isArgs2 = isArguments$3;
    var isEnumerable2 = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable2.call({
      toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable2.call(function() {
    }, "prototype");
    var dontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"];
    var equalsConstructorPrototype = function(o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k in window) {
        try {
          if (!excludedKeys["$" + k] && has2.call(window, k) && window[k] !== null && typeof window[k] === "object") {
            try {
              equalsConstructorPrototype(window[k]);
            } catch (e) {
              return true;
            }
          }
        } catch (e) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e) {
        return false;
      }
    };
    keysShim2 = function keys3(object2) {
      var isObject2 = object2 !== null && typeof object2 === "object";
      var isFunction2 = toStr2.call(object2) === "[object Function]";
      var isArguments3 = isArgs2(object2);
      var isString3 = isObject2 && toStr2.call(object2) === "[object String]";
      var theKeys = [];
      if (!isObject2 && !isFunction2 && !isArguments3) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction2;
      if (isString3 && object2.length > 0 && !has2.call(object2, 0)) {
        for (var i = 0; i < object2.length; ++i) {
          theKeys.push(String(i));
        }
      }
      if (isArguments3 && object2.length > 0) {
        for (var j = 0; j < object2.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object2) {
          if (!(skipProto && name === "prototype") && has2.call(object2, name)) {
            theKeys.push(String(name));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
        for (var k = 0; k < dontEnums.length; ++k) {
          if (!(skipConstructor && dontEnums[k] === "constructor") && has2.call(object2, dontEnums[k])) {
            theKeys.push(dontEnums[k]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$q = keysShim2;
  return implementation$q;
}
var slice$3 = Array.prototype.slice;
var isArgs = isArguments$3;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
  return origKeys(o);
} : requireImplementation();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function() {
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys3(object2) {
        if (isArgs(object2)) {
          return originalKeys(slice$3.call(object2));
        }
        return originalKeys(object2);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
var objectKeys$1 = keysShim;
var shams$1 = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$4 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var test = {
  foo: {}
};
var $Object$1 = Object;
var hasProto$1 = function hasProto() {
  return {
    __proto__: test
  }.foo === test.foo && !({
    __proto__: null
  } instanceof $Object$1);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$6 = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a, b) {
  var arr = [];
  for (var i = 0; i < a.length; i += 1) {
    arr[i] = a[i];
  }
  for (var j = 0; j < b.length; j += 1) {
    arr[j + a.length] = b[j];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i = offset2 || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
    arr[j] = arrLike[i];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i = 0; i < arr.length; i += 1) {
    str += arr[i];
    if (i + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$p = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$6.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound2;
  var binder = function() {
    if (this instanceof bound2) {
      var result = target.apply(this, concatty(args, arguments));
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(that, concatty(args, arguments));
  };
  var boundLength = max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs[i] = "$" + i;
  }
  bound2 = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound2.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound2;
};
var implementation$o = implementation$p;
var functionBind = Function.prototype.bind || implementation$o;
var call$1 = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;
var hasown = bind$1.call(call$1, $hasOwn);
var undefined$1;
var $SyntaxError$1 = SyntaxError;
var $Function = Function;
var $TypeError$9 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e) {
  }
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, "");
  } catch (e) {
    $gOPD$1 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$9();
};
var ThrowTypeError = $gOPD$1 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$3 = hasSymbols$4();
var hasProto2 = hasProto$1();
var getProto = Object.getPrototypeOf || (hasProto2 ? function(x) {
  return x.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$3 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$3 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$3 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$3 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$3 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$3 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$9,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto) {
  try {
    null.error;
  } catch (e) {
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name) {
  var value2;
  if (name === "%AsyncFunction%") {
    value2 = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value2 = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value2 = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn = doEval2("%AsyncGeneratorFunction%");
    if (fn) {
      value2 = fn.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto) {
      value2 = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value2;
  return value2;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn$3 = hasown;
var $concat$1 = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace$2 = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec$1 = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = function stringToPath(string) {
  var first2 = $strSlice(string, 0, 1);
  var last2 = $strSlice(string, -1);
  if (first2 === "%" && last2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$2(string, rePropName$1, function(match, number3, quote2, subString) {
    result[result.length] = quote2 ? $replace$2(subString, reEscapeChar$1, "$1") : number3 || match;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$3(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$3(INTRINSICS, intrinsicName)) {
    var value2 = INTRINSICS[intrinsicName];
    if (value2 === needsEval) {
      value2 = doEval(intrinsicName);
    }
    if (typeof value2 === "undefined" && !allowMissing) {
      throw new $TypeError$9("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value: value2
    };
  }
  throw new $SyntaxError$1("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$9("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$9('"allowMissing" argument must be a boolean');
  }
  if ($exec$1(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath$2(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value2 = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first2 = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first2 === '"' || first2 === "'" || first2 === "`" || last2 === '"' || last2 === "'" || last2 === "`") && first2 !== last2) {
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$3(INTRINSICS, intrinsicRealName)) {
      value2 = INTRINSICS[intrinsicRealName];
    } else if (value2 != null) {
      if (!(part in value2)) {
        if (!allowMissing) {
          throw new $TypeError$9("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$1 && i + 1 >= parts.length) {
        var desc = $gOPD$1(value2, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value2 = desc.get;
        } else {
          value2 = value2[part];
        }
      } else {
        isOwn = hasOwn$3(value2, part);
        value2 = value2[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value2;
      }
    }
  }
  return value2;
};
var GetIntrinsic$d = getIntrinsic;
var $defineProperty$1 = GetIntrinsic$d("%Object.defineProperty%", true);
var hasPropertyDescriptors$1 = function hasPropertyDescriptors() {
  if ($defineProperty$1) {
    try {
      $defineProperty$1({}, "a", {
        value: 1
      });
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
};
hasPropertyDescriptors$1.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!hasPropertyDescriptors$1()) {
    return null;
  }
  try {
    return $defineProperty$1([], "length", {
      value: 1
    }).length !== 1;
  } catch (e) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors$1;
var GetIntrinsic$c = getIntrinsic;
var $gOPD = GetIntrinsic$c("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) {
  try {
    $gOPD([], "length");
  } catch (e) {
    $gOPD = null;
  }
}
var gopd$1 = $gOPD;
var hasPropertyDescriptors2 = hasPropertyDescriptors_1();
var GetIntrinsic$b = getIntrinsic;
var $defineProperty = hasPropertyDescriptors2 && GetIntrinsic$b("%Object.defineProperty%", true);
if ($defineProperty) {
  try {
    $defineProperty({}, "a", {
      value: 1
    });
  } catch (e) {
    $defineProperty = false;
  }
}
var $SyntaxError = GetIntrinsic$b("%SyntaxError%");
var $TypeError$8 = GetIntrinsic$b("%TypeError%");
var gopd = gopd$1;
var defineDataProperty$1 = function defineDataProperty(obj, property2, value2) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$8("`obj` must be an object or a function`");
  }
  if (typeof property2 !== "string" && typeof property2 !== "symbol") {
    throw new $TypeError$8("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$8("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$8("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$8("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$8("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property2);
  if ($defineProperty) {
    $defineProperty(obj, property2, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value: value2,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property2] = value2;
  } else {
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var keys$2 = objectKeys$1;
var hasSymbols$2 = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr$5 = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty2 = defineDataProperty$1;
var isFunction$2 = function(fn) {
  return typeof fn === "function" && toStr$5.call(fn) === "[object Function]";
};
var supportsDescriptors$1 = hasPropertyDescriptors_1();
var defineProperty$3 = function(object2, name, value2, predicate) {
  if (name in object2) {
    if (predicate === true) {
      if (object2[name] === value2) {
        return;
      }
    } else if (!isFunction$2(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors$1) {
    defineDataProperty2(object2, name, value2, true);
  } else {
    defineDataProperty2(object2, name, value2);
  }
};
var defineProperties$1 = function(object2, map2) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = keys$2(map2);
  if (hasSymbols$2) {
    props = concat.call(props, Object.getOwnPropertySymbols(map2));
  }
  for (var i = 0; i < props.length; i += 1) {
    defineProperty$3(object2, props[i], map2[props[i]], predicates[props[i]]);
  }
};
defineProperties$1.supportsDescriptors = !!supportsDescriptors$1;
var defineProperties_1 = defineProperties$1;
var callBind$9 = { exports: {} };
var GetIntrinsic$a = getIntrinsic;
var define$c = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var gOPD$2 = gopd$1;
var $TypeError$7 = GetIntrinsic$a("%TypeError%");
var $floor$2 = GetIntrinsic$a("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn, length2) {
  if (typeof fn !== "function") {
    throw new $TypeError$7("`fn` is not a function");
  }
  if (typeof length2 !== "number" || length2 < 0 || length2 > 4294967295 || $floor$2(length2) !== length2) {
    throw new $TypeError$7("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn && gOPD$2) {
    var desc = gOPD$2(fn, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define$c(fn, "length", length2, true, true);
    } else {
      define$c(fn, "length", length2);
    }
  }
  return fn;
};
(function(module2) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var setFunctionLength$1 = setFunctionLength;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $defineProperty2 = GetIntrinsic3("%Object.defineProperty%", true);
  var $max = GetIntrinsic3("%Math.max%");
  if ($defineProperty2) {
    try {
      $defineProperty2({}, "a", {
        value: 1
      });
    } catch (e) {
      $defineProperty2 = null;
    }
  }
  module2.exports = function callBind2(originalFunction) {
    if (typeof originalFunction !== "function") {
      throw new $TypeError2("a function is required");
    }
    var func = $reflectApply(bind3, $call, arguments);
    return setFunctionLength$1(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module2.exports, "apply", {
      value: applyBind
    });
  } else {
    module2.exports.apply = applyBind;
  }
})(callBind$9);
var callBindExports = callBind$9.exports;
var GetIntrinsic$9 = getIntrinsic;
var callBind$8 = callBindExports;
var $indexOf = callBind$8(GetIntrinsic$9("String.prototype.indexOf"));
var callBound$a = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$9(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBind$8(intrinsic);
  }
  return intrinsic;
};
var objectKeys = objectKeys$1;
var hasSymbols$1 = shams$1();
var callBound$9 = callBound$a;
var toObject = Object;
var $push$3 = callBound$9("Array.prototype.push");
var $propIsEnumerable = callBound$9("Object.prototype.propertyIsEnumerable");
var originalGetSymbols = hasSymbols$1 ? Object.getOwnPropertySymbols : null;
var implementation$n = function assign(target, source1) {
  if (target == null) {
    throw new TypeError("target must be an object");
  }
  var to = toObject(target);
  if (arguments.length === 1) {
    return to;
  }
  for (var s = 1; s < arguments.length; ++s) {
    var from = toObject(arguments[s]);
    var keys3 = objectKeys(from);
    var getSymbols2 = hasSymbols$1 && (Object.getOwnPropertySymbols || originalGetSymbols);
    if (getSymbols2) {
      var syms = getSymbols2(from);
      for (var j = 0; j < syms.length; ++j) {
        var key = syms[j];
        if ($propIsEnumerable(from, key)) {
          $push$3(keys3, key);
        }
      }
    }
    for (var i = 0; i < keys3.length; ++i) {
      var nextKey = keys3[i];
      if ($propIsEnumerable(from, nextKey)) {
        var propValue = from[nextKey];
        to[nextKey] = propValue;
      }
    }
  }
  return to;
};
var implementation$m = implementation$n;
var lacksProperEnumerationOrder = function() {
  if (!Object.assign) {
    return false;
  }
  var str = "abcdefghijklmnopqrst";
  var letters = str.split("");
  var map2 = {};
  for (var i = 0; i < letters.length; ++i) {
    map2[letters[i]] = letters[i];
  }
  var obj = Object.assign({}, map2);
  var actual = "";
  for (var k in obj) {
    actual += k;
  }
  return str !== actual;
};
var assignHasPendingExceptions = function() {
  if (!Object.assign || !Object.preventExtensions) {
    return false;
  }
  var thrower = Object.preventExtensions({
    1: 2
  });
  try {
    Object.assign(thrower, "xy");
  } catch (e) {
    return thrower[1] === "y";
  }
  return false;
};
var polyfill$d = function getPolyfill() {
  if (!Object.assign) {
    return implementation$m;
  }
  if (lacksProperEnumerationOrder()) {
    return implementation$m;
  }
  if (assignHasPendingExceptions()) {
    return implementation$m;
  }
  return Object.assign;
};
var define$b = defineProperties_1;
var getPolyfill$d = polyfill$d;
var shim$f = function shimAssign() {
  var polyfill2 = getPolyfill$d();
  define$b(Object, {
    assign: polyfill2
  }, {
    assign: function() {
      return Object.assign !== polyfill2;
    }
  });
  return polyfill2;
};
var defineProperties = defineProperties_1;
var callBind$7 = callBindExports;
var implementation$l = implementation$n;
var getPolyfill$c = polyfill$d;
var shim$e = shim$f;
var polyfill$c = callBind$7.apply(getPolyfill$c());
var bound$3 = function assign2(target, source1) {
  return polyfill$c(Object, arguments);
};
defineProperties(bound$3, {
  getPolyfill: getPolyfill$c,
  implementation: implementation$l,
  shim: shim$e
});
var object_assign = bound$3;
var _isNaN = Number.isNaN || function isNaN2(a) {
  return a !== a;
};
var $isNaN$1 = _isNaN;
var _isFinite = function(x) {
  return (typeof x === "number" || typeof x === "bigint") && !$isNaN$1(x) && x !== Infinity && x !== -Infinity;
};
var isInteger$1;
var hasRequiredIsInteger;
function requireIsInteger() {
  if (hasRequiredIsInteger)
    return isInteger$1;
  hasRequiredIsInteger = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $abs = GetIntrinsic3("%Math.abs%");
  var $floor2 = GetIntrinsic3("%Math.floor%");
  var $isNaN2 = _isNaN;
  var $isFinite2 = _isFinite;
  isInteger$1 = function isInteger2(argument) {
    if (typeof argument !== "number" || $isNaN2(argument) || !$isFinite2(argument)) {
      return false;
    }
    var absValue = $abs(argument);
    return $floor2(absValue) === absValue;
  };
  return isInteger$1;
}
var ArrayCreate$1;
var hasRequiredArrayCreate;
function requireArrayCreate() {
  if (hasRequiredArrayCreate)
    return ArrayCreate$1;
  hasRequiredArrayCreate = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $ArrayPrototype = GetIntrinsic3("%Array.prototype%");
  var $RangeError = GetIntrinsic3("%RangeError%");
  var $SyntaxError2 = GetIntrinsic3("%SyntaxError%");
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var isInteger2 = requireIsInteger();
  var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;
  var hasProto3 = hasProto$1();
  var $setProto = GetIntrinsic3("%Object.setPrototypeOf%", true) || (hasProto3 ? function(O, proto2) {
    O.__proto__ = proto2;
    return O;
  } : null);
  ArrayCreate$1 = function ArrayCreate2(length2) {
    if (!isInteger2(length2) || length2 < 0) {
      throw new $TypeError2("Assertion failed: `length` must be an integer Number >= 0");
    }
    if (length2 > MAX_ARRAY_LENGTH) {
      throw new $RangeError("length is greater than (2**32 - 1)");
    }
    var proto2 = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
    var A5 = [];
    if (proto2 !== $ArrayPrototype) {
      if (!$setProto) {
        throw new $SyntaxError2("ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]");
      }
      $setProto(A5, proto2);
    }
    if (length2 !== 0) {
      A5.length = length2;
    }
    return A5;
  };
  return ArrayCreate$1;
}
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$3 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice$1 = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor$1 = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int2 = num < 0 ? -$floor$1(-num) : $floor$1(num);
    if (int2 !== num) {
      var intStr = String(int2);
      var dec = $slice$1.call(str, intStr.length + 1);
      return $replace$1.call(intStr, sepRegex, "$&_") + "." + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace$1.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0$3;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$3(inspectCustom) ? inspectCustom : null;
var objectInspect = function inspect_(obj, options2, depth, seen) {
  var opts = options2 || {};
  if (has$2(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$2(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$2(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$2(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$2(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth2 = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth2 && maxDepth2 > 0 && typeof obj === "object") {
    return isArray$3(obj) ? "[Array]" : "[Object]";
  }
  var indent2 = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value2, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$2(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value2, newOpts, depth + 1, seen);
    }
    return inspect_(value2, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp(obj)) {
    var name = nameOf(obj);
    var keys3 = arrObjKeys(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys3.length > 0 ? " { " + $join.call(keys3, ", ") + " }" : "");
  }
  if (isSymbol$3(obj)) {
    var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
    }
    s += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s += "...";
    }
    s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s;
  }
  if (isArray$3(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent2 && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent2) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, {
        depth: maxDepth2 - depth
      });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap$2(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function(value2, key) {
        mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value2, obj));
      });
    }
    return collectionOf("Map", mapSize.call(obj), mapParts, indent2);
  }
  if (isSet$2(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function(value2) {
        setParts.push(inspect2(value2, obj));
      });
    }
    return collectionOf("Set", setSize.call(obj), setParts, indent2);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString$4(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (typeof window !== "undefined" && obj === window) {
    return "{ [object Window] }";
  }
  if (obj === globalThis) {
    return "{ [object globalThis] }";
  }
  if (!isDate(obj) && !isRegExp(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag2 = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice$1.call(toStr$4(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag2 || protoTag ? "[" + $join.call($concat.call([], stringTag2 || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent2) {
      return tag + "{" + indentedJoin(ys, indent2) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace$1.call(String(s), /"/g, "&quot;");
}
function isArray$3(obj) {
  return toStr$4(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr$4(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
  return toStr$4(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr$4(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString$4(obj) {
  return toStr$4(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr$4(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr$4(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol$3(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
var hasOwn$2 = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$2(obj, key) {
  return hasOwn$2.call(obj, key);
}
function toStr$4(obj) {
  return objectToString$3.call(obj);
}
function nameOf(f2) {
  if (f2.name) {
    return f2.name;
  }
  var m = $match.call(functionToString.call(f2), /^function\s*([\w$]+)/);
  if (m) {
    return m[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap$2(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map;
  } catch (e) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {
  }
  return false;
}
function isSet$2(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }
    return x instanceof Set;
  } catch (e) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e) {
  }
  return false;
}
function isElement(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice$1.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s = $replace$1.call($replace$1.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, "single", opts);
}
function lowbyte(c2) {
  var n = c2.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type3) {
  return type3 + " { ? }";
}
function collectionOf(type3, size, entries2, indent2) {
  var joinedEntries = indent2 ? indentedJoin(entries2, indent2) : $join.call(entries2, ", ");
  return type3 + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent2) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent2.prev + indent2.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent2.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$3(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has$2(obj, i) ? inspect2(obj[i], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$2(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var IsPropertyKey$2;
var hasRequiredIsPropertyKey;
function requireIsPropertyKey() {
  if (hasRequiredIsPropertyKey)
    return IsPropertyKey$2;
  hasRequiredIsPropertyKey = 1;
  IsPropertyKey$2 = function IsPropertyKey2(argument) {
    return typeof argument === "string" || typeof argument === "symbol";
  };
  return IsPropertyKey$2;
}
var Type$5;
var hasRequiredType$1;
function requireType$1() {
  if (hasRequiredType$1)
    return Type$5;
  hasRequiredType$1 = 1;
  Type$5 = function Type2(x) {
    if (x === null) {
      return "Null";
    }
    if (typeof x === "undefined") {
      return "Undefined";
    }
    if (typeof x === "function" || typeof x === "object") {
      return "Object";
    }
    if (typeof x === "number") {
      return "Number";
    }
    if (typeof x === "boolean") {
      return "Boolean";
    }
    if (typeof x === "string") {
      return "String";
    }
  };
  return Type$5;
}
var Type$4;
var hasRequiredType;
function requireType() {
  if (hasRequiredType)
    return Type$4;
  hasRequiredType = 1;
  var ES5Type = requireType$1();
  Type$4 = function Type2(x) {
    if (typeof x === "symbol") {
      return "Symbol";
    }
    if (typeof x === "bigint") {
      return "BigInt";
    }
    return ES5Type(x);
  };
  return Type$4;
}
var GetIntrinsic$8 = getIntrinsic;
var $TypeError$6 = GetIntrinsic$8("%TypeError%");
var inspect = objectInspect;
var IsPropertyKey$1 = requireIsPropertyKey();
var Type$3 = requireType();
var Get$4 = function Get(O, P) {
  if (Type$3(O) !== "Object") {
    throw new $TypeError$6("Assertion failed: Type(O) is not Object");
  }
  if (!IsPropertyKey$1(P)) {
    throw new $TypeError$6("Assertion failed: IsPropertyKey(P) is not true, got " + inspect(P));
  }
  return O[P];
};
var IsArray$3;
var hasRequiredIsArray$1;
function requireIsArray$1() {
  if (hasRequiredIsArray$1)
    return IsArray$3;
  hasRequiredIsArray$1 = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $Array = GetIntrinsic3("%Array%");
  var toStr2 = !$Array.isArray && callBound$a("Object.prototype.toString");
  IsArray$3 = $Array.isArray || function IsArray2(argument) {
    return toStr2(argument) === "[object Array]";
  };
  return IsArray$3;
}
var IsArray$2;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray)
    return IsArray$2;
  hasRequiredIsArray = 1;
  IsArray$2 = requireIsArray$1();
  return IsArray$2;
}
var IsConstructor$1 = { exports: {} };
var GetIntrinsic$7;
var hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic)
    return GetIntrinsic$7;
  hasRequiredGetIntrinsic = 1;
  GetIntrinsic$7 = getIntrinsic;
  return GetIntrinsic$7;
}
var isPropertyDescriptor;
var hasRequiredIsPropertyDescriptor;
function requireIsPropertyDescriptor() {
  if (hasRequiredIsPropertyDescriptor)
    return isPropertyDescriptor;
  hasRequiredIsPropertyDescriptor = 1;
  var GetIntrinsic3 = getIntrinsic;
  var hasOwn2 = hasown;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  isPropertyDescriptor = function IsPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== "Object") {
      return false;
    }
    var allowed = {
      "[[Configurable]]": true,
      "[[Enumerable]]": true,
      "[[Get]]": true,
      "[[Set]]": true,
      "[[Value]]": true,
      "[[Writable]]": true
    };
    for (var key in Desc) {
      if (hasOwn2(Desc, key) && !allowed[key]) {
        return false;
      }
    }
    if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
      throw new $TypeError2("Property Descriptors may not be both accessor and data descriptors");
    }
    return true;
  };
  return isPropertyDescriptor;
}
var DefineOwnProperty;
var hasRequiredDefineOwnProperty;
function requireDefineOwnProperty() {
  if (hasRequiredDefineOwnProperty)
    return DefineOwnProperty;
  hasRequiredDefineOwnProperty = 1;
  var hasPropertyDescriptors3 = hasPropertyDescriptors_1;
  var GetIntrinsic3 = getIntrinsic;
  var $defineProperty2 = hasPropertyDescriptors3() && GetIntrinsic3("%Object.defineProperty%", true);
  var hasArrayLengthDefineBug2 = hasPropertyDescriptors3.hasArrayLengthDefineBug();
  var isArray2 = hasArrayLengthDefineBug2 && requireIsArray$1();
  var callBound2 = callBound$a;
  var $isEnumerable2 = callBound2("Object.prototype.propertyIsEnumerable");
  DefineOwnProperty = function DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, desc) {
    if (!$defineProperty2) {
      if (!IsDataDescriptor2(desc)) {
        return false;
      }
      if (!desc["[[Configurable]]"] || !desc["[[Writable]]"]) {
        return false;
      }
      if (P in O && $isEnumerable2(O, P) !== !!desc["[[Enumerable]]"]) {
        return false;
      }
      var V = desc["[[Value]]"];
      O[P] = V;
      return SameValue2(O[P], V);
    }
    if (hasArrayLengthDefineBug2 && P === "length" && "[[Value]]" in desc && isArray2(O) && O.length !== desc["[[Value]]"]) {
      O.length = desc["[[Value]]"];
      return O.length === desc["[[Value]]"];
    }
    $defineProperty2(O, P, FromPropertyDescriptor2(desc));
    return true;
  };
  return DefineOwnProperty;
}
var isMatchRecord;
var hasRequiredIsMatchRecord;
function requireIsMatchRecord() {
  if (hasRequiredIsMatchRecord)
    return isMatchRecord;
  hasRequiredIsMatchRecord = 1;
  var hasOwn2 = hasown;
  isMatchRecord = function isMatchRecord2(record) {
    return hasOwn2(record, "[[StartIndex]]") && hasOwn2(record, "[[EndIndex]]") && record["[[StartIndex]]"] >= 0 && record["[[EndIndex]]"] >= record["[[StartIndex]]"] && String(parseInt(record["[[StartIndex]]"], 10)) === String(record["[[StartIndex]]"]) && String(parseInt(record["[[EndIndex]]"], 10)) === String(record["[[EndIndex]]"]);
  };
  return isMatchRecord;
}
var assertRecord;
var hasRequiredAssertRecord;
function requireAssertRecord() {
  if (hasRequiredAssertRecord)
    return assertRecord;
  hasRequiredAssertRecord = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var $SyntaxError2 = GetIntrinsic3("%SyntaxError%");
  var hasOwn2 = hasown;
  var isInteger2 = requireIsInteger();
  var isMatchRecord2 = requireIsMatchRecord();
  var predicates = {
    // https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
    "Property Descriptor": function isPropertyDescriptor2(Desc) {
      var allowed = {
        "[[Configurable]]": true,
        "[[Enumerable]]": true,
        "[[Get]]": true,
        "[[Set]]": true,
        "[[Value]]": true,
        "[[Writable]]": true
      };
      if (!Desc) {
        return false;
      }
      for (var key in Desc) {
        if (hasOwn2(Desc, key) && !allowed[key]) {
          return false;
        }
      }
      var isData = hasOwn2(Desc, "[[Value]]");
      var IsAccessor = hasOwn2(Desc, "[[Get]]") || hasOwn2(Desc, "[[Set]]");
      if (isData && IsAccessor) {
        throw new $TypeError2("Property Descriptors may not be both accessor and data descriptors");
      }
      return true;
    },
    // https://262.ecma-international.org/13.0/#sec-match-records
    "Match Record": isMatchRecord2,
    "Iterator Record": function isIteratorRecord(value2) {
      return hasOwn2(value2, "[[Iterator]]") && hasOwn2(value2, "[[NextMethod]]") && hasOwn2(value2, "[[Done]]");
    },
    "PromiseCapability Record": function isPromiseCapabilityRecord(value2) {
      return !!value2 && hasOwn2(value2, "[[Resolve]]") && typeof value2["[[Resolve]]"] === "function" && hasOwn2(value2, "[[Reject]]") && typeof value2["[[Reject]]"] === "function" && hasOwn2(value2, "[[Promise]]") && value2["[[Promise]]"] && typeof value2["[[Promise]]"].then === "function";
    },
    "AsyncGeneratorRequest Record": function isAsyncGeneratorRequestRecord(value2) {
      return !!value2 && hasOwn2(value2, "[[Completion]]") && hasOwn2(value2, "[[Capability]]") && predicates["PromiseCapability Record"](value2["[[Capability]]"]);
    },
    "RegExp Record": function isRegExpRecord(value2) {
      return value2 && hasOwn2(value2, "[[IgnoreCase]]") && typeof value2["[[IgnoreCase]]"] === "boolean" && hasOwn2(value2, "[[Multiline]]") && typeof value2["[[Multiline]]"] === "boolean" && hasOwn2(value2, "[[DotAll]]") && typeof value2["[[DotAll]]"] === "boolean" && hasOwn2(value2, "[[Unicode]]") && typeof value2["[[Unicode]]"] === "boolean" && hasOwn2(value2, "[[CapturingGroupsCount]]") && typeof value2["[[CapturingGroupsCount]]"] === "number" && isInteger2(value2["[[CapturingGroupsCount]]"]) && value2["[[CapturingGroupsCount]]"] >= 0;
    }
  };
  assertRecord = function assertRecord2(Type2, recordType, argumentName, value2) {
    var predicate = predicates[recordType];
    if (typeof predicate !== "function") {
      throw new $SyntaxError2("unknown record type: " + recordType);
    }
    if (Type2(value2) !== "Object" || !predicate(value2)) {
      throw new $TypeError2(argumentName + " must be a " + recordType);
    }
  };
  return assertRecord;
}
var fromPropertyDescriptor;
var hasRequiredFromPropertyDescriptor$1;
function requireFromPropertyDescriptor$1() {
  if (hasRequiredFromPropertyDescriptor$1)
    return fromPropertyDescriptor;
  hasRequiredFromPropertyDescriptor$1 = 1;
  fromPropertyDescriptor = function fromPropertyDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return Desc;
    }
    var obj = {};
    if ("[[Value]]" in Desc) {
      obj.value = Desc["[[Value]]"];
    }
    if ("[[Writable]]" in Desc) {
      obj.writable = !!Desc["[[Writable]]"];
    }
    if ("[[Get]]" in Desc) {
      obj.get = Desc["[[Get]]"];
    }
    if ("[[Set]]" in Desc) {
      obj.set = Desc["[[Set]]"];
    }
    if ("[[Enumerable]]" in Desc) {
      obj.enumerable = !!Desc["[[Enumerable]]"];
    }
    if ("[[Configurable]]" in Desc) {
      obj.configurable = !!Desc["[[Configurable]]"];
    }
    return obj;
  };
  return fromPropertyDescriptor;
}
var FromPropertyDescriptor;
var hasRequiredFromPropertyDescriptor;
function requireFromPropertyDescriptor() {
  if (hasRequiredFromPropertyDescriptor)
    return FromPropertyDescriptor;
  hasRequiredFromPropertyDescriptor = 1;
  var assertRecord2 = requireAssertRecord();
  var fromPropertyDescriptor2 = requireFromPropertyDescriptor$1();
  var Type2 = requireType();
  FromPropertyDescriptor = function FromPropertyDescriptor2(Desc) {
    if (typeof Desc !== "undefined") {
      assertRecord2(Type2, "Property Descriptor", "Desc", Desc);
    }
    return fromPropertyDescriptor2(Desc);
  };
  return FromPropertyDescriptor;
}
var IsAccessorDescriptor;
var hasRequiredIsAccessorDescriptor;
function requireIsAccessorDescriptor() {
  if (hasRequiredIsAccessorDescriptor)
    return IsAccessorDescriptor;
  hasRequiredIsAccessorDescriptor = 1;
  var hasOwn2 = hasown;
  var Type2 = requireType();
  var assertRecord2 = requireAssertRecord();
  IsAccessorDescriptor = function IsAccessorDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    assertRecord2(Type2, "Property Descriptor", "Desc", Desc);
    if (!hasOwn2(Desc, "[[Get]]") && !hasOwn2(Desc, "[[Set]]")) {
      return false;
    }
    return true;
  };
  return IsAccessorDescriptor;
}
var IsDataDescriptor;
var hasRequiredIsDataDescriptor;
function requireIsDataDescriptor() {
  if (hasRequiredIsDataDescriptor)
    return IsDataDescriptor;
  hasRequiredIsDataDescriptor = 1;
  var hasOwn2 = hasown;
  var Type2 = requireType();
  var assertRecord2 = requireAssertRecord();
  IsDataDescriptor = function IsDataDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    assertRecord2(Type2, "Property Descriptor", "Desc", Desc);
    if (!hasOwn2(Desc, "[[Value]]") && !hasOwn2(Desc, "[[Writable]]")) {
      return false;
    }
    return true;
  };
  return IsDataDescriptor;
}
var SameValue;
var hasRequiredSameValue;
function requireSameValue() {
  if (hasRequiredSameValue)
    return SameValue;
  hasRequiredSameValue = 1;
  var $isNaN2 = _isNaN;
  SameValue = function SameValue2(x, y) {
    if (x === y) {
      if (x === 0) {
        return 1 / x === 1 / y;
      }
      return true;
    }
    return $isNaN2(x) && $isNaN2(y);
  };
  return SameValue;
}
var ToBoolean$1 = function ToBoolean(value2) {
  return !!value2;
};
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    });
    isCallableMarker = {};
    reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (_) {
    if (_ !== isCallableMarker) {
      reflectApply = null;
    }
  }
} else {
  reflectApply = null;
}
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value2) {
  try {
    var fnStr = fnToStr.call(value2);
    return constructorRegex.test(fnStr);
  } catch (e) {
    return false;
  }
};
var tryFunctionObject = function tryFunctionToStr(value2) {
  try {
    if (isES6ClassFn(value2)) {
      return false;
    }
    fnToStr.call(value2);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr$3 = Object.prototype.toString;
var objectClass$1 = "[object Object]";
var fnClass = "[object Function]";
var genClass = "[object GeneratorFunction]";
var ddaClass$1 = "[object HTMLAllCollection]";
var ddaClass2 = "[object HTML document.all class]";
var ddaClass3 = "[object HTMLCollection]";
var hasToStringTag$4 = typeof Symbol === "function" && !!Symbol.toStringTag;
var isIE68$1 = !(0 in [,]);
var isDDA$1 = function isDocumentDotAll() {
  return false;
};
if (typeof document === "object") {
  var all$1 = document.all;
  if (toStr$3.call(all$1) === toStr$3.call(document.all)) {
    isDDA$1 = function isDocumentDotAll22(value2) {
      if ((isIE68$1 || !value2) && (typeof value2 === "undefined" || typeof value2 === "object")) {
        try {
          var str = toStr$3.call(value2);
          return (str === ddaClass$1 || str === ddaClass2 || str === ddaClass3 || str === objectClass$1) && value2("") == null;
        } catch (e) {
        }
      }
      return false;
    };
  }
}
var isCallable = reflectApply ? function isCallable2(value2) {
  if (isDDA$1(value2)) {
    return true;
  }
  if (!value2) {
    return false;
  }
  if (typeof value2 !== "function" && typeof value2 !== "object") {
    return false;
  }
  try {
    reflectApply(value2, null, badArrayLike);
  } catch (e) {
    if (e !== isCallableMarker) {
      return false;
    }
  }
  return !isES6ClassFn(value2) && tryFunctionObject(value2);
} : function isCallable22(value2) {
  if (isDDA$1(value2)) {
    return true;
  }
  if (!value2) {
    return false;
  }
  if (typeof value2 !== "function" && typeof value2 !== "object") {
    return false;
  }
  if (hasToStringTag$4) {
    return tryFunctionObject(value2);
  }
  if (isES6ClassFn(value2)) {
    return false;
  }
  var strClass2 = toStr$3.call(value2);
  if (strClass2 !== fnClass && strClass2 !== genClass && !/^\[object HTML/.test(strClass2)) {
    return false;
  }
  return tryFunctionObject(value2);
};
var IsCallable$2 = isCallable;
var ToPropertyDescriptor;
var hasRequiredToPropertyDescriptor;
function requireToPropertyDescriptor() {
  if (hasRequiredToPropertyDescriptor)
    return ToPropertyDescriptor;
  hasRequiredToPropertyDescriptor = 1;
  var hasOwn2 = hasown;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var Type2 = requireType();
  var ToBoolean3 = ToBoolean$1;
  var IsCallable2 = IsCallable$2;
  ToPropertyDescriptor = function ToPropertyDescriptor2(Obj) {
    if (Type2(Obj) !== "Object") {
      throw new $TypeError2("ToPropertyDescriptor requires an object");
    }
    var desc = {};
    if (hasOwn2(Obj, "enumerable")) {
      desc["[[Enumerable]]"] = ToBoolean3(Obj.enumerable);
    }
    if (hasOwn2(Obj, "configurable")) {
      desc["[[Configurable]]"] = ToBoolean3(Obj.configurable);
    }
    if (hasOwn2(Obj, "value")) {
      desc["[[Value]]"] = Obj.value;
    }
    if (hasOwn2(Obj, "writable")) {
      desc["[[Writable]]"] = ToBoolean3(Obj.writable);
    }
    if (hasOwn2(Obj, "get")) {
      var getter = Obj.get;
      if (typeof getter !== "undefined" && !IsCallable2(getter)) {
        throw new $TypeError2("getter must be a function");
      }
      desc["[[Get]]"] = getter;
    }
    if (hasOwn2(Obj, "set")) {
      var setter = Obj.set;
      if (typeof setter !== "undefined" && !IsCallable2(setter)) {
        throw new $TypeError2("setter must be a function");
      }
      desc["[[Set]]"] = setter;
    }
    if ((hasOwn2(desc, "[[Get]]") || hasOwn2(desc, "[[Set]]")) && (hasOwn2(desc, "[[Value]]") || hasOwn2(desc, "[[Writable]]"))) {
      throw new $TypeError2("Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
    }
    return desc;
  };
  return ToPropertyDescriptor;
}
var DefinePropertyOrThrow;
var hasRequiredDefinePropertyOrThrow;
function requireDefinePropertyOrThrow() {
  if (hasRequiredDefinePropertyOrThrow)
    return DefinePropertyOrThrow;
  hasRequiredDefinePropertyOrThrow = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var isPropertyDescriptor2 = requireIsPropertyDescriptor();
  var DefineOwnProperty2 = requireDefineOwnProperty();
  var FromPropertyDescriptor2 = requireFromPropertyDescriptor();
  var IsAccessorDescriptor2 = requireIsAccessorDescriptor();
  var IsDataDescriptor2 = requireIsDataDescriptor();
  var IsPropertyKey2 = requireIsPropertyKey();
  var SameValue2 = requireSameValue();
  var ToPropertyDescriptor2 = requireToPropertyDescriptor();
  var Type2 = requireType();
  DefinePropertyOrThrow = function DefinePropertyOrThrow2(O, P, desc) {
    if (Type2(O) !== "Object") {
      throw new $TypeError2("Assertion failed: Type(O) is not Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: IsPropertyKey(P) is not true");
    }
    var Desc = isPropertyDescriptor2({
      Type: Type2,
      IsDataDescriptor: IsDataDescriptor2,
      IsAccessorDescriptor: IsAccessorDescriptor2
    }, desc) ? desc : ToPropertyDescriptor2(desc);
    if (!isPropertyDescriptor2({
      Type: Type2,
      IsDataDescriptor: IsDataDescriptor2,
      IsAccessorDescriptor: IsAccessorDescriptor2
    }, Desc)) {
      throw new $TypeError2("Assertion failed: Desc is not a valid Property Descriptor");
    }
    return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
  };
  return DefinePropertyOrThrow;
}
var hasRequiredIsConstructor;
function requireIsConstructor() {
  if (hasRequiredIsConstructor)
    return IsConstructor$1.exports;
  hasRequiredIsConstructor = 1;
  var GetIntrinsic3 = requireGetIntrinsic();
  var $construct = GetIntrinsic3("%Reflect.construct%", true);
  var DefinePropertyOrThrow2 = requireDefinePropertyOrThrow();
  try {
    DefinePropertyOrThrow2({}, "", {
      "[[Get]]": function() {
      }
    });
  } catch (e) {
    DefinePropertyOrThrow2 = null;
  }
  if (DefinePropertyOrThrow2 && $construct) {
    var isConstructorMarker = {};
    var badArrayLike2 = {};
    DefinePropertyOrThrow2(badArrayLike2, "length", {
      "[[Get]]": function() {
        throw isConstructorMarker;
      },
      "[[Enumerable]]": true
    });
    IsConstructor$1.exports = function IsConstructor2(argument) {
      try {
        $construct(argument, badArrayLike2);
      } catch (err2) {
        return err2 === isConstructorMarker;
      }
    };
  } else {
    IsConstructor$1.exports = function IsConstructor2(argument) {
      return typeof argument === "function" && !!argument.prototype;
    };
  }
  return IsConstructor$1.exports;
}
var GetIntrinsic$6 = getIntrinsic;
var $species = GetIntrinsic$6("%Symbol.species%", true);
var $TypeError$5 = GetIntrinsic$6("%TypeError%");
var ArrayCreate = requireArrayCreate();
var Get$3 = Get$4;
var IsArray$1 = requireIsArray();
var IsConstructor = requireIsConstructor();
var Type$2 = requireType();
var isInteger = requireIsInteger();
var ArraySpeciesCreate$2 = function ArraySpeciesCreate(originalArray, length2) {
  if (!isInteger(length2) || length2 < 0) {
    throw new $TypeError$5("Assertion failed: length must be an integer >= 0");
  }
  var isArray2 = IsArray$1(originalArray);
  if (!isArray2) {
    return ArrayCreate(length2);
  }
  var C2 = Get$3(originalArray, "constructor");
  if ($species && Type$2(C2) === "Object") {
    C2 = Get$3(C2, $species);
    if (C2 === null) {
      C2 = void 0;
    }
  }
  if (typeof C2 === "undefined") {
    return ArrayCreate(length2);
  }
  if (!IsConstructor(C2)) {
    throw new $TypeError$5("C must be a constructor");
  }
  return new C2(length2);
};
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
var Call$2;
var hasRequiredCall;
function requireCall() {
  if (hasRequiredCall)
    return Call$2;
  hasRequiredCall = 1;
  var GetIntrinsic3 = getIntrinsic;
  var callBound2 = callBound$a;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var IsArray2 = requireIsArray();
  var $apply = GetIntrinsic3("%Reflect.apply%", true) || callBound2("Function.prototype.apply");
  Call$2 = function Call2(F, V) {
    var argumentsList = arguments.length > 2 ? arguments[2] : [];
    if (!IsArray2(argumentsList)) {
      throw new $TypeError2("Assertion failed: optional `argumentsList`, if provided, must be a List");
    }
    return $apply(F, V, argumentsList);
  };
  return Call$2;
}
var isPrimitive$2;
var hasRequiredIsPrimitive$1;
function requireIsPrimitive$1() {
  if (hasRequiredIsPrimitive$1)
    return isPrimitive$2;
  hasRequiredIsPrimitive$1 = 1;
  isPrimitive$2 = function isPrimitive2(value2) {
    return value2 === null || typeof value2 !== "function" && typeof value2 !== "object";
  };
  return isPrimitive$2;
}
var IsExtensible;
var hasRequiredIsExtensible;
function requireIsExtensible() {
  if (hasRequiredIsExtensible)
    return IsExtensible;
  hasRequiredIsExtensible = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $preventExtensions = GetIntrinsic3("%Object.preventExtensions%", true);
  var $isExtensible = GetIntrinsic3("%Object.isExtensible%", true);
  var isPrimitive2 = requireIsPrimitive$1();
  IsExtensible = $preventExtensions ? function IsExtensible2(obj) {
    return !isPrimitive2(obj) && $isExtensible(obj);
  } : function IsExtensible2(obj) {
    return !isPrimitive2(obj);
  };
  return IsExtensible;
}
var isFullyPopulatedPropertyDescriptor;
var hasRequiredIsFullyPopulatedPropertyDescriptor;
function requireIsFullyPopulatedPropertyDescriptor() {
  if (hasRequiredIsFullyPopulatedPropertyDescriptor)
    return isFullyPopulatedPropertyDescriptor;
  hasRequiredIsFullyPopulatedPropertyDescriptor = 1;
  isFullyPopulatedPropertyDescriptor = function isFullyPopulatedPropertyDescriptor2(ES, Desc) {
    return !!Desc && typeof Desc === "object" && "[[Enumerable]]" in Desc && "[[Configurable]]" in Desc && (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
  };
  return isFullyPopulatedPropertyDescriptor;
}
var IsGenericDescriptor;
var hasRequiredIsGenericDescriptor;
function requireIsGenericDescriptor() {
  if (hasRequiredIsGenericDescriptor)
    return IsGenericDescriptor;
  hasRequiredIsGenericDescriptor = 1;
  var assertRecord2 = requireAssertRecord();
  var IsAccessorDescriptor2 = requireIsAccessorDescriptor();
  var IsDataDescriptor2 = requireIsDataDescriptor();
  var Type2 = requireType();
  IsGenericDescriptor = function IsGenericDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    assertRecord2(Type2, "Property Descriptor", "Desc", Desc);
    if (!IsAccessorDescriptor2(Desc) && !IsDataDescriptor2(Desc)) {
      return true;
    }
    return false;
  };
  return IsGenericDescriptor;
}
var ValidateAndApplyPropertyDescriptor;
var hasRequiredValidateAndApplyPropertyDescriptor;
function requireValidateAndApplyPropertyDescriptor() {
  if (hasRequiredValidateAndApplyPropertyDescriptor)
    return ValidateAndApplyPropertyDescriptor;
  hasRequiredValidateAndApplyPropertyDescriptor = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var DefineOwnProperty2 = requireDefineOwnProperty();
  var isFullyPopulatedPropertyDescriptor2 = requireIsFullyPopulatedPropertyDescriptor();
  var isPropertyDescriptor2 = requireIsPropertyDescriptor();
  var FromPropertyDescriptor2 = requireFromPropertyDescriptor();
  var IsAccessorDescriptor2 = requireIsAccessorDescriptor();
  var IsDataDescriptor2 = requireIsDataDescriptor();
  var IsGenericDescriptor2 = requireIsGenericDescriptor();
  var IsPropertyKey2 = requireIsPropertyKey();
  var SameValue2 = requireSameValue();
  var Type2 = requireType();
  ValidateAndApplyPropertyDescriptor = function ValidateAndApplyPropertyDescriptor2(O, P, extensible, Desc, current) {
    var oType = Type2(O);
    if (oType !== "Undefined" && oType !== "Object") {
      throw new $TypeError2("Assertion failed: O must be undefined or an Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: P must be a Property Key");
    }
    if (Type2(extensible) !== "Boolean") {
      throw new $TypeError2("Assertion failed: extensible must be a Boolean");
    }
    if (!isPropertyDescriptor2({
      Type: Type2,
      IsDataDescriptor: IsDataDescriptor2,
      IsAccessorDescriptor: IsAccessorDescriptor2
    }, Desc)) {
      throw new $TypeError2("Assertion failed: Desc must be a Property Descriptor");
    }
    if (Type2(current) !== "Undefined" && !isPropertyDescriptor2({
      Type: Type2,
      IsDataDescriptor: IsDataDescriptor2,
      IsAccessorDescriptor: IsAccessorDescriptor2
    }, current)) {
      throw new $TypeError2("Assertion failed: current must be a Property Descriptor, or undefined");
    }
    if (Type2(current) === "Undefined") {
      if (!extensible) {
        return false;
      }
      if (oType === "Undefined") {
        return true;
      }
      if (IsAccessorDescriptor2(Desc)) {
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
      }
      return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
        "[[Configurable]]": !!Desc["[[Configurable]]"],
        "[[Enumerable]]": !!Desc["[[Enumerable]]"],
        "[[Value]]": Desc["[[Value]]"],
        "[[Writable]]": !!Desc["[[Writable]]"]
      });
    }
    if (!isFullyPopulatedPropertyDescriptor2({
      IsAccessorDescriptor: IsAccessorDescriptor2,
      IsDataDescriptor: IsDataDescriptor2
    }, current)) {
      throw new $TypeError2("`current`, when present, must be a fully populated and valid Property Descriptor");
    }
    if (!current["[[Configurable]]"]) {
      if ("[[Configurable]]" in Desc && Desc["[[Configurable]]"]) {
        return false;
      }
      if ("[[Enumerable]]" in Desc && !SameValue2(Desc["[[Enumerable]]"], current["[[Enumerable]]"])) {
        return false;
      }
      if (!IsGenericDescriptor2(Desc) && !SameValue2(IsAccessorDescriptor2(Desc), IsAccessorDescriptor2(current))) {
        return false;
      }
      if (IsAccessorDescriptor2(current)) {
        if ("[[Get]]" in Desc && !SameValue2(Desc["[[Get]]"], current["[[Get]]"])) {
          return false;
        }
        if ("[[Set]]" in Desc && !SameValue2(Desc["[[Set]]"], current["[[Set]]"])) {
          return false;
        }
      } else if (!current["[[Writable]]"]) {
        if ("[[Writable]]" in Desc && Desc["[[Writable]]"]) {
          return false;
        }
        if ("[[Value]]" in Desc && !SameValue2(Desc["[[Value]]"], current["[[Value]]"])) {
          return false;
        }
      }
    }
    if (oType !== "Undefined") {
      var configurable;
      var enumerable;
      if (IsDataDescriptor2(current) && IsAccessorDescriptor2(Desc)) {
        configurable = ("[[Configurable]]" in Desc ? Desc : current)["[[Configurable]]"];
        enumerable = ("[[Enumerable]]" in Desc ? Desc : current)["[[Enumerable]]"];
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
          "[[Configurable]]": !!configurable,
          "[[Enumerable]]": !!enumerable,
          "[[Get]]": ("[[Get]]" in Desc ? Desc : current)["[[Get]]"],
          "[[Set]]": ("[[Set]]" in Desc ? Desc : current)["[[Set]]"]
        });
      } else if (IsAccessorDescriptor2(current) && IsDataDescriptor2(Desc)) {
        configurable = ("[[Configurable]]" in Desc ? Desc : current)["[[Configurable]]"];
        enumerable = ("[[Enumerable]]" in Desc ? Desc : current)["[[Enumerable]]"];
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
          "[[Configurable]]": !!configurable,
          "[[Enumerable]]": !!enumerable,
          "[[Value]]": ("[[Value]]" in Desc ? Desc : current)["[[Value]]"],
          "[[Writable]]": !!("[[Writable]]" in Desc ? Desc : current)["[[Writable]]"]
        });
      }
      return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
    }
    return true;
  };
  return ValidateAndApplyPropertyDescriptor;
}
var OrdinaryDefineOwnProperty;
var hasRequiredOrdinaryDefineOwnProperty;
function requireOrdinaryDefineOwnProperty() {
  if (hasRequiredOrdinaryDefineOwnProperty)
    return OrdinaryDefineOwnProperty;
  hasRequiredOrdinaryDefineOwnProperty = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $gOPD2 = gopd$1;
  var $SyntaxError2 = GetIntrinsic3("%SyntaxError%");
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var isPropertyDescriptor2 = requireIsPropertyDescriptor();
  var IsAccessorDescriptor2 = requireIsAccessorDescriptor();
  var IsDataDescriptor2 = requireIsDataDescriptor();
  var IsExtensible2 = requireIsExtensible();
  var IsPropertyKey2 = requireIsPropertyKey();
  var ToPropertyDescriptor2 = requireToPropertyDescriptor();
  var SameValue2 = requireSameValue();
  var Type2 = requireType();
  var ValidateAndApplyPropertyDescriptor2 = requireValidateAndApplyPropertyDescriptor();
  OrdinaryDefineOwnProperty = function OrdinaryDefineOwnProperty2(O, P, Desc) {
    if (Type2(O) !== "Object") {
      throw new $TypeError2("Assertion failed: O must be an Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: P must be a Property Key");
    }
    if (!isPropertyDescriptor2({
      Type: Type2,
      IsDataDescriptor: IsDataDescriptor2,
      IsAccessorDescriptor: IsAccessorDescriptor2
    }, Desc)) {
      throw new $TypeError2("Assertion failed: Desc must be a Property Descriptor");
    }
    if (!$gOPD2) {
      if (IsAccessorDescriptor2(Desc)) {
        throw new $SyntaxError2("This environment does not support accessor property descriptors.");
      }
      var creatingNormalDataProperty = !(P in O) && Desc["[[Writable]]"] && Desc["[[Enumerable]]"] && Desc["[[Configurable]]"] && "[[Value]]" in Desc;
      var settingExistingDataProperty = P in O && (!("[[Configurable]]" in Desc) || Desc["[[Configurable]]"]) && (!("[[Enumerable]]" in Desc) || Desc["[[Enumerable]]"]) && (!("[[Writable]]" in Desc) || Desc["[[Writable]]"]) && "[[Value]]" in Desc;
      if (creatingNormalDataProperty || settingExistingDataProperty) {
        O[P] = Desc["[[Value]]"];
        return SameValue2(O[P], Desc["[[Value]]"]);
      }
      throw new $SyntaxError2("This environment does not support defining non-writable, non-enumerable, or non-configurable properties");
    }
    var desc = $gOPD2(O, P);
    var current = desc && ToPropertyDescriptor2(desc);
    var extensible = IsExtensible2(O);
    return ValidateAndApplyPropertyDescriptor2(O, P, extensible, Desc, current);
  };
  return OrdinaryDefineOwnProperty;
}
var CreateDataProperty;
var hasRequiredCreateDataProperty;
function requireCreateDataProperty() {
  if (hasRequiredCreateDataProperty)
    return CreateDataProperty;
  hasRequiredCreateDataProperty = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var IsPropertyKey2 = requireIsPropertyKey();
  var OrdinaryDefineOwnProperty2 = requireOrdinaryDefineOwnProperty();
  var Type2 = requireType();
  CreateDataProperty = function CreateDataProperty2(O, P, V) {
    if (Type2(O) !== "Object") {
      throw new $TypeError2("Assertion failed: Type(O) is not Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: IsPropertyKey(P) is not true");
    }
    var newDesc = {
      "[[Configurable]]": true,
      "[[Enumerable]]": true,
      "[[Value]]": V,
      "[[Writable]]": true
    };
    return OrdinaryDefineOwnProperty2(O, P, newDesc);
  };
  return CreateDataProperty;
}
var CreateDataPropertyOrThrow$2;
var hasRequiredCreateDataPropertyOrThrow;
function requireCreateDataPropertyOrThrow() {
  if (hasRequiredCreateDataPropertyOrThrow)
    return CreateDataPropertyOrThrow$2;
  hasRequiredCreateDataPropertyOrThrow = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var CreateDataProperty2 = requireCreateDataProperty();
  var IsPropertyKey2 = requireIsPropertyKey();
  var Type2 = requireType();
  CreateDataPropertyOrThrow$2 = function CreateDataPropertyOrThrow2(O, P, V) {
    if (Type2(O) !== "Object") {
      throw new $TypeError2("Assertion failed: Type(O) is not Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: IsPropertyKey(P) is not true");
    }
    var success = CreateDataProperty2(O, P, V);
    if (!success) {
      throw new $TypeError2("unable to create data property");
    }
  };
  return CreateDataPropertyOrThrow$2;
}
var HasProperty$2;
var hasRequiredHasProperty;
function requireHasProperty() {
  if (hasRequiredHasProperty)
    return HasProperty$2;
  hasRequiredHasProperty = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var IsPropertyKey2 = requireIsPropertyKey();
  var Type2 = requireType();
  HasProperty$2 = function HasProperty2(O, P) {
    if (Type2(O) !== "Object") {
      throw new $TypeError2("Assertion failed: `O` must be an Object");
    }
    if (!IsPropertyKey2(P)) {
      throw new $TypeError2("Assertion failed: `P` must be a Property Key");
    }
    return P in O;
  };
  return HasProperty$2;
}
var isPrimitive$1;
var hasRequiredIsPrimitive;
function requireIsPrimitive() {
  if (hasRequiredIsPrimitive)
    return isPrimitive$1;
  hasRequiredIsPrimitive = 1;
  isPrimitive$1 = function isPrimitive2(value2) {
    return value2 === null || typeof value2 !== "function" && typeof value2 !== "object";
  };
  return isPrimitive$1;
}
var hasSymbols2 = shams$1;
var shams = function hasToStringTagShams() {
  return hasSymbols2() && !!Symbol.toStringTag;
};
var isDateObject;
var hasRequiredIsDateObject;
function requireIsDateObject() {
  if (hasRequiredIsDateObject)
    return isDateObject;
  hasRequiredIsDateObject = 1;
  var getDay = Date.prototype.getDay;
  var tryDateObject = function tryDateGetDayCall(value2) {
    try {
      getDay.call(value2);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr2 = Object.prototype.toString;
  var dateClass = "[object Date]";
  var hasToStringTag2 = shams();
  isDateObject = function isDateObject2(value2) {
    if (typeof value2 !== "object" || value2 === null) {
      return false;
    }
    return hasToStringTag2 ? tryDateObject(value2) : toStr2.call(value2) === dateClass;
  };
  return isDateObject;
}
var isSymbol$2 = { exports: {} };
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol)
    return isSymbol$2.exports;
  hasRequiredIsSymbol = 1;
  var toStr2 = Object.prototype.toString;
  var hasSymbols3 = hasSymbols$4();
  if (hasSymbols3) {
    var symToStr = Symbol.prototype.toString;
    var symStringRegex = /^Symbol\(.*\)$/;
    var isSymbolObject = function isRealSymbolObject(value2) {
      if (typeof value2.valueOf() !== "symbol") {
        return false;
      }
      return symStringRegex.test(symToStr.call(value2));
    };
    isSymbol$2.exports = function isSymbol2(value2) {
      if (typeof value2 === "symbol") {
        return true;
      }
      if (toStr2.call(value2) !== "[object Symbol]") {
        return false;
      }
      try {
        return isSymbolObject(value2);
      } catch (e) {
        return false;
      }
    };
  } else {
    isSymbol$2.exports = function isSymbol2(value2) {
      return false;
    };
  }
  return isSymbol$2.exports;
}
var es2015;
var hasRequiredEs2015;
function requireEs2015() {
  if (hasRequiredEs2015)
    return es2015;
  hasRequiredEs2015 = 1;
  var hasSymbols3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol";
  var isPrimitive2 = requireIsPrimitive();
  var isCallable$1 = isCallable;
  var isDate2 = requireIsDateObject();
  var isSymbol2 = requireIsSymbol();
  var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
    if (typeof O === "undefined" || O === null) {
      throw new TypeError("Cannot call method on " + O);
    }
    if (typeof hint !== "string" || hint !== "number" && hint !== "string") {
      throw new TypeError('hint must be "string" or "number"');
    }
    var methodNames = hint === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"];
    var method, result, i;
    for (i = 0; i < methodNames.length; ++i) {
      method = O[methodNames[i]];
      if (isCallable$1(method)) {
        result = method.call(O);
        if (isPrimitive2(result)) {
          return result;
        }
      }
    }
    throw new TypeError("No default value");
  };
  var GetMethod = function GetMethod2(O, P) {
    var func = O[P];
    if (func !== null && typeof func !== "undefined") {
      if (!isCallable$1(func)) {
        throw new TypeError(func + " returned for property " + P + " of object " + O + " is not a function");
      }
      return func;
    }
    return void 0;
  };
  es2015 = function ToPrimitive2(input) {
    if (isPrimitive2(input)) {
      return input;
    }
    var hint = "default";
    if (arguments.length > 1) {
      if (arguments[1] === String) {
        hint = "string";
      } else if (arguments[1] === Number) {
        hint = "number";
      }
    }
    var exoticToPrim;
    if (hasSymbols3) {
      if (Symbol.toPrimitive) {
        exoticToPrim = GetMethod(input, Symbol.toPrimitive);
      } else if (isSymbol2(input)) {
        exoticToPrim = Symbol.prototype.valueOf;
      }
    }
    if (typeof exoticToPrim !== "undefined") {
      var result = exoticToPrim.call(input, hint);
      if (isPrimitive2(result)) {
        return result;
      }
      throw new TypeError("unable to convert exotic object to primitive");
    }
    if (hint === "default" && (isDate2(input) || isSymbol2(input))) {
      hint = "string";
    }
    return ordinaryToPrimitive(input, hint === "default" ? "number" : hint);
  };
  return es2015;
}
var ToPrimitive$1;
var hasRequiredToPrimitive;
function requireToPrimitive() {
  if (hasRequiredToPrimitive)
    return ToPrimitive$1;
  hasRequiredToPrimitive = 1;
  var toPrimitive = requireEs2015();
  ToPrimitive$1 = function ToPrimitive2(input) {
    if (arguments.length > 1) {
      return toPrimitive(input, arguments[1]);
    }
    return toPrimitive(input);
  };
  return ToPrimitive$1;
}
var callBound$8 = callBound$a;
var hasToStringTag$3 = shams();
var has$1;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag$3) {
  has$1 = callBound$8("Object.prototype.hasOwnProperty");
  $exec = callBound$8("RegExp.prototype.exec");
  isRegexMarker = {};
  var throwRegexMarker = function() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === "symbol") {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var $toString$1 = callBound$8("Object.prototype.toString");
var gOPD$1 = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
var isRegex = hasToStringTag$3 ? function isRegex2(value2) {
  if (!value2 || typeof value2 !== "object") {
    return false;
  }
  var descriptor = gOPD$1(value2, "lastIndex");
  var hasLastIndexDataProperty = descriptor && has$1(descriptor, "value");
  if (!hasLastIndexDataProperty) {
    return false;
  }
  try {
    $exec(value2, badStringifier);
  } catch (e) {
    return e === isRegexMarker;
  }
} : function isRegex3(value2) {
  if (!value2 || typeof value2 !== "object" && typeof value2 !== "function") {
    return false;
  }
  return $toString$1(value2) === regexClass;
};
var safeRegexTest;
var hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest)
    return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var callBound2 = callBound$a;
  var GetIntrinsic3 = getIntrinsic;
  var isRegex$1 = isRegex;
  var $exec2 = callBound2("RegExp.prototype.exec");
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  safeRegexTest = function regexTester(regex2) {
    if (!isRegex$1(regex2)) {
      throw new $TypeError2("`regex` must be a RegExp");
    }
    return function test2(s) {
      return $exec2(regex2, s) !== null;
    };
  };
  return safeRegexTest;
}
var GetIntrinsic$5 = getIntrinsic;
var $TypeError$4 = GetIntrinsic$5("%TypeError%");
var CheckObjectCoercible = function CheckObjectCoercible2(value2, optMessage) {
  if (value2 == null) {
    throw new $TypeError$4(optMessage || "Cannot call method on " + value2);
  }
  return value2;
};
var RequireObjectCoercible$6 = CheckObjectCoercible;
var ToString$3;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString)
    return ToString$3;
  hasRequiredToString = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $String = GetIntrinsic3("%String%");
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  ToString$3 = function ToString2(argument) {
    if (typeof argument === "symbol") {
      throw new $TypeError2("Cannot convert a Symbol value to a string");
    }
    return $String(argument);
  };
  return ToString$3;
}
var RequireObjectCoercible$5 = RequireObjectCoercible$6;
var ToString$2 = requireToString();
var callBound$7 = callBound$a;
var $replace = callBound$7("String.prototype.replace");
var mvsIsWS = /^\s$/.test("᠎");
var leftWhitespace = mvsIsWS ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = mvsIsWS ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
var implementation$k = function trim() {
  var S = ToString$2(RequireObjectCoercible$5(this));
  return $replace($replace(S, leftWhitespace, ""), rightWhitespace, "");
};
var implementation$j = implementation$k;
var zeroWidthSpace = "​";
var mongolianVowelSeparator = "᠎";
var polyfill$b = function getPolyfill2() {
  if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace && mongolianVowelSeparator.trim() === mongolianVowelSeparator && ("_" + mongolianVowelSeparator).trim() === "_" + mongolianVowelSeparator && (mongolianVowelSeparator + "_").trim() === mongolianVowelSeparator + "_") {
    return String.prototype.trim;
  }
  return implementation$j;
};
var define$a = defineProperties_1;
var getPolyfill$b = polyfill$b;
var shim$d = function shimStringTrim() {
  var polyfill2 = getPolyfill$b();
  define$a(String.prototype, {
    trim: polyfill2
  }, {
    trim: function testTrim() {
      return String.prototype.trim !== polyfill2;
    }
  });
  return polyfill2;
};
var callBind$6 = callBindExports;
var define$9 = defineProperties_1;
var RequireObjectCoercible$4 = RequireObjectCoercible$6;
var implementation$i = implementation$k;
var getPolyfill$a = polyfill$b;
var shim$c = shim$d;
var bound$2 = callBind$6(getPolyfill$a());
var boundMethod = function trim2(receiver) {
  RequireObjectCoercible$4(receiver);
  return bound$2(receiver);
};
define$9(boundMethod, {
  getPolyfill: getPolyfill$a,
  implementation: implementation$i,
  shim: shim$c
});
var string_prototype_trim = boundMethod;
var StringToNumber$1;
var hasRequiredStringToNumber;
function requireStringToNumber() {
  if (hasRequiredStringToNumber)
    return StringToNumber$1;
  hasRequiredStringToNumber = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $Number2 = GetIntrinsic3("%Number%");
  var $RegExp = GetIntrinsic3("%RegExp%");
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var $parseInteger = GetIntrinsic3("%parseInt%");
  var callBound2 = callBound$a;
  var regexTester = requireSafeRegexTest();
  var $strSlice2 = callBound2("String.prototype.slice");
  var isBinary = regexTester(/^0b[01]+$/i);
  var isOctal = regexTester(/^0o[0-7]+$/i);
  var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
  var nonWS = ["", "​", "￾"].join("");
  var nonWSregex = new $RegExp("[" + nonWS + "]", "g");
  var hasNonWS = regexTester(nonWSregex);
  var $trim = string_prototype_trim;
  var Type2 = requireType();
  StringToNumber$1 = function StringToNumber2(argument) {
    if (Type2(argument) !== "String") {
      throw new $TypeError2("Assertion failed: `argument` is not a String");
    }
    if (isBinary(argument)) {
      return $Number2($parseInteger($strSlice2(argument, 2), 2));
    }
    if (isOctal(argument)) {
      return $Number2($parseInteger($strSlice2(argument, 2), 8));
    }
    if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
      return NaN;
    }
    var trimmed = $trim(argument);
    if (trimmed !== argument) {
      return StringToNumber2(trimmed);
    }
    return $Number2(argument);
  };
  return StringToNumber$1;
}
var GetIntrinsic$4 = getIntrinsic;
var $TypeError$3 = GetIntrinsic$4("%TypeError%");
var $Number = GetIntrinsic$4("%Number%");
var isPrimitive = requireIsPrimitive$1();
var ToPrimitive = requireToPrimitive();
var StringToNumber = requireStringToNumber();
var ToNumber$1 = function ToNumber(argument) {
  var value2 = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
  if (typeof value2 === "symbol") {
    throw new $TypeError$3("Cannot convert a Symbol value to a number");
  }
  if (typeof value2 === "bigint") {
    throw new $TypeError$3("Conversion from 'BigInt' to 'number' is not allowed.");
  }
  if (typeof value2 === "string") {
    return StringToNumber(value2);
  }
  return $Number(value2);
};
var Type$1 = requireType();
var $floor = Math.floor;
var floor$1 = function floor(x) {
  if (Type$1(x) === "BigInt") {
    return x;
  }
  return $floor(x);
};
var GetIntrinsic$3 = getIntrinsic;
var floor2 = floor$1;
var $TypeError$2 = GetIntrinsic$3("%TypeError%");
var truncate$1 = function truncate(x) {
  if (typeof x !== "number" && typeof x !== "bigint") {
    throw new $TypeError$2("argument must be a Number or a BigInt");
  }
  var result = x < 0 ? -floor2(-x) : floor2(x);
  return result === 0 ? 0 : result;
};
var ToNumber2 = ToNumber$1;
var truncate2 = truncate$1;
var $isNaN = _isNaN;
var $isFinite = _isFinite;
var ToIntegerOrInfinity$2 = function ToIntegerOrInfinity(value2) {
  var number3 = ToNumber2(value2);
  if ($isNaN(number3) || number3 === 0) {
    return 0;
  }
  if (!$isFinite(number3)) {
    return number3;
  }
  return truncate2(number3);
};
var MAX_SAFE_INTEGER$4 = maxSafeInteger;
var ToIntegerOrInfinity$1 = ToIntegerOrInfinity$2;
var ToLength$1 = function ToLength(argument) {
  var len = ToIntegerOrInfinity$1(argument);
  if (len <= 0) {
    return 0;
  }
  if (len > MAX_SAFE_INTEGER$4) {
    return MAX_SAFE_INTEGER$4;
  }
  return len;
};
var LengthOfArrayLike$2;
var hasRequiredLengthOfArrayLike;
function requireLengthOfArrayLike() {
  if (hasRequiredLengthOfArrayLike)
    return LengthOfArrayLike$2;
  hasRequiredLengthOfArrayLike = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = GetIntrinsic3("%TypeError%");
  var Get3 = Get$4;
  var ToLength3 = ToLength$1;
  var Type2 = requireType();
  LengthOfArrayLike$2 = function LengthOfArrayLike2(obj) {
    if (Type2(obj) !== "Object") {
      throw new $TypeError2("Assertion failed: `obj` must be an Object");
    }
    return ToLength3(Get3(obj, "length"));
  };
  return LengthOfArrayLike$2;
}
var GetIntrinsic$2 = getIntrinsic;
var $TypeError$1 = GetIntrinsic$2("%TypeError%");
var MAX_SAFE_INTEGER$3 = maxSafeInteger;
var Call$1 = requireCall();
var CreateDataPropertyOrThrow$1 = requireCreateDataPropertyOrThrow();
var Get$2 = Get$4;
var HasProperty$1 = requireHasProperty();
var IsArray = requireIsArray();
var LengthOfArrayLike$1 = requireLengthOfArrayLike();
var ToString$1 = requireToString();
var FlattenIntoArray$1 = function FlattenIntoArray(target, source, sourceLen, start2, depth) {
  var mapperFunction;
  if (arguments.length > 5) {
    mapperFunction = arguments[5];
  }
  var targetIndex = start2;
  var sourceIndex = 0;
  while (sourceIndex < sourceLen) {
    var P = ToString$1(sourceIndex);
    var exists = HasProperty$1(source, P);
    if (exists === true) {
      var element = Get$2(source, P);
      if (typeof mapperFunction !== "undefined") {
        if (arguments.length <= 6) {
          throw new $TypeError$1("Assertion failed: thisArg is required when mapperFunction is provided");
        }
        element = Call$1(mapperFunction, arguments[6], [element, sourceIndex, source]);
      }
      var shouldFlatten = false;
      if (depth > 0) {
        shouldFlatten = IsArray(element);
      }
      if (shouldFlatten) {
        var elementLen = LengthOfArrayLike$1(element);
        targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
      } else {
        if (targetIndex >= MAX_SAFE_INTEGER$3) {
          throw new $TypeError$1("index too large");
        }
        CreateDataPropertyOrThrow$1(target, ToString$1(targetIndex), element);
        targetIndex += 1;
      }
    }
    sourceIndex += 1;
  }
  return targetIndex;
};
var GetIntrinsic$1 = getIntrinsic;
var $Object = GetIntrinsic$1("%Object%");
var RequireObjectCoercible$3 = RequireObjectCoercible$6;
var ToObject$2 = function ToObject(value2) {
  RequireObjectCoercible$3(value2);
  return $Object(value2);
};
var ArraySpeciesCreate$1 = ArraySpeciesCreate$2;
var FlattenIntoArray2 = FlattenIntoArray$1;
var Get$1 = Get$4;
var ToIntegerOrInfinity2 = ToIntegerOrInfinity$2;
var ToLength2 = ToLength$1;
var ToObject$1 = ToObject$2;
var implementation$h = function flat() {
  var O = ToObject$1(this);
  var sourceLen = ToLength2(Get$1(O, "length"));
  var depthNum = 1;
  if (arguments.length > 0 && typeof arguments[0] !== "undefined") {
    depthNum = ToIntegerOrInfinity2(arguments[0]);
  }
  var A5 = ArraySpeciesCreate$1(O, 0);
  FlattenIntoArray2(A5, O, sourceLen, 0, depthNum);
  return A5;
};
var implementation$g = implementation$h;
var polyfill$a = function getPolyfill3() {
  return Array.prototype.flat || implementation$g;
};
var esShimUnscopables;
var hasRequiredEsShimUnscopables;
function requireEsShimUnscopables() {
  if (hasRequiredEsShimUnscopables)
    return esShimUnscopables;
  hasRequiredEsShimUnscopables = 1;
  var hasOwn2 = hasown;
  var hasUnscopables = typeof Symbol === "function" && typeof Symbol.unscopables === "symbol";
  var map2 = hasUnscopables && Array.prototype[Symbol.unscopables];
  var $TypeError2 = TypeError;
  esShimUnscopables = function shimUnscopables(method) {
    if (typeof method !== "string" || !method) {
      throw new $TypeError2("method must be a non-empty string");
    }
    if (!hasOwn2(Array.prototype, method)) {
      throw new $TypeError2("method must be on Array.prototype");
    }
    if (hasUnscopables) {
      map2[method] = true;
    }
  };
  return esShimUnscopables;
}
var shim$b;
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1)
    return shim$b;
  hasRequiredShim$1 = 1;
  var define2 = defineProperties_1;
  var shimUnscopables = requireEsShimUnscopables();
  var getPolyfill10 = polyfill$a;
  shim$b = function shimFlat() {
    var polyfill2 = getPolyfill10();
    define2(Array.prototype, {
      flat: polyfill2
    }, {
      flat: function() {
        return Array.prototype.flat !== polyfill2;
      }
    });
    shimUnscopables("flat");
    return polyfill2;
  };
  return shim$b;
}
var define$8 = defineProperties_1;
var callBind$5 = callBindExports;
var implementation$f = implementation$h;
var getPolyfill$9 = polyfill$a;
var polyfill$9 = getPolyfill$9();
var shim$a = requireShim$1();
var boundFlat = callBind$5(polyfill$9);
define$8(boundFlat, {
  getPolyfill: getPolyfill$9,
  implementation: implementation$f,
  shim: shim$a
});
var array_prototype_flat = boundFlat;
var hasOwnProperty$e = {}.hasOwnProperty;
var call = Function.prototype.call;
var src$1 = call.bind ? call.bind(hasOwnProperty$e) : function(O, P) {
  return call.call(hasOwnProperty$e, O, P);
};
var Utils = {};
var build$1 = { exports: {} };
var numberIsNaN = function(value2) {
  return value2 !== value2;
};
var implementation$e = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }
  if (a === b) {
    return true;
  }
  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }
  return false;
};
var implementation$d = implementation$e;
var polyfill$8 = function getPolyfill4() {
  return typeof Object.is === "function" ? Object.is : implementation$d;
};
var getPolyfill$8 = polyfill$8;
var define$7 = defineProperties_1;
var shim$9 = function shimObjectIs() {
  var polyfill2 = getPolyfill$8();
  define$7(Object, {
    is: polyfill2
  }, {
    is: function testObjectIs() {
      return Object.is !== polyfill2;
    }
  });
  return polyfill2;
};
var define$6 = defineProperties_1;
var callBind$4 = callBindExports;
var implementation$c = implementation$e;
var getPolyfill$7 = polyfill$8;
var shim$8 = shim$9;
var polyfill$7 = callBind$4(getPolyfill$7(), Object);
define$6(polyfill$7, {
  getPolyfill: getPolyfill$7,
  implementation: implementation$c,
  shim: shim$8
});
var objectIs = polyfill$7;
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = shallowEqual;
  var _objectIs3 = _interopRequireDefault2(objectIs);
  var _has3 = _interopRequireDefault2(src$1);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof2(obj);
  }
  function shallowEqual(objA, objB) {
    if ((0, _objectIs3["default"])(objA, objB)) {
      return true;
    }
    if (!objA || !objB || _typeof2(objA) !== "object" || _typeof2(objB) !== "object") {
      return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
      return false;
    }
    keysA.sort();
    keysB.sort();
    for (var i = 0; i < keysA.length; i += 1) {
      if (!(0, _has3["default"])(objB, keysA[i]) || !(0, _objectIs3["default"])(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    }
    return true;
  }
  module2.exports = exports2.default;
})(build$1, build$1.exports);
var buildExports = build$1.exports;
var RequireObjectCoercible$2 = RequireObjectCoercible$6;
var callBound$6 = callBound$a;
var $isEnumerable$1 = callBound$6("Object.prototype.propertyIsEnumerable");
var $push$2 = callBound$6("Array.prototype.push");
var implementation$b = function entries(O) {
  var obj = RequireObjectCoercible$2(O);
  var entrys = [];
  for (var key in obj) {
    if ($isEnumerable$1(obj, key)) {
      $push$2(entrys, [key, obj[key]]);
    }
  }
  return entrys;
};
var implementation$a = implementation$b;
var polyfill$6 = function getPolyfill5() {
  return typeof Object.entries === "function" ? Object.entries : implementation$a;
};
var getPolyfill$6 = polyfill$6;
var define$5 = defineProperties_1;
var shim$7 = function shimEntries() {
  var polyfill2 = getPolyfill$6();
  define$5(Object, {
    entries: polyfill2
  }, {
    entries: function testEntries() {
      return Object.entries !== polyfill2;
    }
  });
  return polyfill2;
};
var define$4 = defineProperties_1;
var callBind$3 = callBindExports;
var implementation$9 = implementation$b;
var getPolyfill$5 = polyfill$6;
var shim$6 = shim$7;
var polyfill$5 = callBind$3(getPolyfill$5(), Object);
define$4(polyfill$5, {
  getPolyfill: getPolyfill$5,
  implementation: implementation$9,
  shim: shim$6
});
var object_entries = polyfill$5;
var GetIntrinsic2 = getIntrinsic;
var $TypeError = GetIntrinsic2("%TypeError%");
var hasOwn$1 = hasown;
var IsPropertyKey = requireIsPropertyKey();
var Type = requireType();
var HasOwnProperty$1 = function HasOwnProperty(O, P) {
  if (Type(O) !== "Object") {
    throw new $TypeError("Assertion failed: `O` must be an Object");
  }
  if (!IsPropertyKey(P)) {
    throw new $TypeError("Assertion failed: `P` must be a Property Key");
  }
  return hasOwn$1(O, P);
};
var functionsHaveNames$2 = function functionsHaveNames() {
  return typeof (function f2() {
  }).name === "string";
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
  try {
    gOPD([], "length");
  } catch (e) {
    gOPD = null;
  }
}
functionsHaveNames$2.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames$2() || !gOPD) {
    return false;
  }
  var desc = gOPD(function() {
  }, "name");
  return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames$2.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames$2() && typeof $bind === "function" && (function f2() {
  }).bind().name !== "";
};
var functionsHaveNames_1 = functionsHaveNames$2;
var IsCallable$1 = IsCallable$2;
var HasOwnProperty2 = HasOwnProperty$1;
var functionsHaveNames$1 = functionsHaveNames_1();
var callBound$5 = callBound$a;
var $functionToString = callBound$5("Function.prototype.toString");
var $stringMatch = callBound$5("String.prototype.match");
var toStr$2 = callBound$5("Object.prototype.toString");
var classRegex = /^class /;
var isClass = function isClassConstructor(fn) {
  if (IsCallable$1(fn)) {
    return false;
  }
  if (typeof fn !== "function") {
    return false;
  }
  try {
    var match = $stringMatch($functionToString(fn), classRegex);
    return !!match;
  } catch (e) {
  }
  return false;
};
var regex$1 = /\s*function\s+([^(\s]*)\s*/;
var isIE68 = !(0 in [,]);
var objectClass = "[object Object]";
var ddaClass = "[object HTMLAllCollection]";
var functionProto = Function.prototype;
var isDDA = function isDocumentDotAll2() {
  return false;
};
if (typeof document === "object") {
  var all = document.all;
  if (toStr$2(all) === toStr$2(document.all)) {
    isDDA = function isDocumentDotAll22(value2) {
      if ((isIE68 || !value2) && (typeof value2 === "undefined" || typeof value2 === "object")) {
        try {
          var str = toStr$2(value2);
          return (str === ddaClass || str === objectClass) && value2("") == null;
        } catch (e) {
        }
      }
      return false;
    };
  }
}
var implementation$8 = function getName() {
  if (isDDA(this) || !isClass(this) && !IsCallable$1(this)) {
    throw new TypeError("Function.prototype.name sham getter called on non-function");
  }
  if (functionsHaveNames$1 && HasOwnProperty2(this, "name")) {
    return this.name;
  }
  if (this === functionProto) {
    return "";
  }
  var str = $functionToString(this);
  var match = $stringMatch(str, regex$1);
  var name = match && match[1];
  return name;
};
var implementation$7 = implementation$8;
var polyfill$4 = function getPolyfill6() {
  return implementation$7;
};
var supportsDescriptors = defineProperties_1.supportsDescriptors;
var functionsHaveNames2 = functionsHaveNames_1();
var getPolyfill$4 = polyfill$4;
var defineProperty$2 = Object.defineProperty;
var TypeErr = TypeError;
var shim$5 = function shimName() {
  var polyfill2 = getPolyfill$4();
  if (functionsHaveNames2) {
    return polyfill2;
  }
  if (!supportsDescriptors) {
    throw new TypeErr("Shimming Function.prototype.name support requires ES5 property descriptor support.");
  }
  var functionProto2 = Function.prototype;
  defineProperty$2(functionProto2, "name", {
    configurable: true,
    enumerable: false,
    get: function() {
      var name = polyfill2.call(this);
      if (this !== functionProto2) {
        defineProperty$2(this, "name", {
          configurable: true,
          enumerable: false,
          value: name,
          writable: false
        });
      }
      return name;
    }
  });
  return polyfill2;
};
var define$3 = defineProperties_1;
var callBind$2 = callBindExports;
var implementation$6 = implementation$8;
var getPolyfill$3 = polyfill$4;
var shim$4 = shim$5;
var bound$1 = callBind$2(implementation$6);
define$3(bound$1, {
  getPolyfill: getPolyfill$3,
  implementation: implementation$6,
  shim: shim$4
});
var function_prototype_name = bound$1;
var lib$c = {};
var types = {};
Object.defineProperty(types, "__esModule", {
  value: true
});
var load = {};
var options = {};
var __assign$4 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$4 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$4.apply(this, arguments);
};
Object.defineProperty(options, "__esModule", {
  value: true
});
options.flatten = void 0;
var defaultOpts$2 = {
  xml: false,
  decodeEntities: true
};
options.default = defaultOpts$2;
var xmlModeDefault = {
  _useHtmlParser2: true,
  xmlMode: true
};
function flatten(options2) {
  return (options2 === null || options2 === void 0 ? void 0 : options2.xml) ? typeof options2.xml === "boolean" ? xmlModeDefault : __assign$4(__assign$4({}, xmlModeDefault), options2.xml) : options2 !== null && options2 !== void 0 ? options2 : void 0;
}
options.flatten = flatten;
var _static = {};
var lib$b = {};
var stringify$2 = {};
var lib$a = {};
var lib$9 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.Doctype = exports2.CDATA = exports2.Tag = exports2.Style = exports2.Script = exports2.Comment = exports2.Directive = exports2.Text = exports2.Root = exports2.isTag = exports2.ElementType = void 0;
  var ElementType2;
  (function(ElementType3) {
    ElementType3["Root"] = "root";
    ElementType3["Text"] = "text";
    ElementType3["Directive"] = "directive";
    ElementType3["Comment"] = "comment";
    ElementType3["Script"] = "script";
    ElementType3["Style"] = "style";
    ElementType3["Tag"] = "tag";
    ElementType3["CDATA"] = "cdata";
    ElementType3["Doctype"] = "doctype";
  })(ElementType2 = exports2.ElementType || (exports2.ElementType = {}));
  function isTag2(elem) {
    return elem.type === ElementType2.Tag || elem.type === ElementType2.Script || elem.type === ElementType2.Style;
  }
  exports2.isTag = isTag2;
  exports2.Root = ElementType2.Root;
  exports2.Text = ElementType2.Text;
  exports2.Directive = ElementType2.Directive;
  exports2.Comment = ElementType2.Comment;
  exports2.Script = ElementType2.Script;
  exports2.Style = ElementType2.Style;
  exports2.Tag = ElementType2.Tag;
  exports2.CDATA = ElementType2.CDATA;
  exports2.Doctype = ElementType2.Doctype;
})(lib$9);
var node = {};
var __extends$1 = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$3 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$3 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$3.apply(this, arguments);
};
Object.defineProperty(node, "__esModule", {
  value: true
});
node.cloneNode = node.hasChildren = node.isDocument = node.isDirective = node.isComment = node.isText = node.isCDATA = node.isTag = node.Element = node.Document = node.CDATA = node.NodeWithChildren = node.ProcessingInstruction = node.Comment = node.Text = node.DataNode = node.Node = void 0;
var domelementtype_1$1 = lib$9;
var Node = (
  /** @class */
  function() {
    function Node2() {
      this.parent = null;
      this.prev = null;
      this.next = null;
      this.startIndex = null;
      this.endIndex = null;
    }
    Object.defineProperty(Node2.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(parent) {
        this.parent = parent;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node2.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(prev) {
        this.prev = prev;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node2.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(next) {
        this.next = next;
      },
      enumerable: false,
      configurable: true
    });
    Node2.prototype.cloneNode = function(recursive) {
      if (recursive === void 0) {
        recursive = false;
      }
      return cloneNode(this, recursive);
    };
    return Node2;
  }()
);
node.Node = Node;
var DataNode = (
  /** @class */
  function(_super) {
    __extends$1(DataNode2, _super);
    function DataNode2(data2) {
      var _this = _super.call(this) || this;
      _this.data = data2;
      return _this;
    }
    Object.defineProperty(DataNode2.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(data2) {
        this.data = data2;
      },
      enumerable: false,
      configurable: true
    });
    return DataNode2;
  }(Node)
);
node.DataNode = DataNode;
var Text = (
  /** @class */
  function(_super) {
    __extends$1(Text2, _super);
    function Text2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1$1.ElementType.Text;
      return _this;
    }
    Object.defineProperty(Text2.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: false,
      configurable: true
    });
    return Text2;
  }(DataNode)
);
node.Text = Text;
var Comment = (
  /** @class */
  function(_super) {
    __extends$1(Comment2, _super);
    function Comment2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1$1.ElementType.Comment;
      return _this;
    }
    Object.defineProperty(Comment2.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: false,
      configurable: true
    });
    return Comment2;
  }(DataNode)
);
node.Comment = Comment;
var ProcessingInstruction = (
  /** @class */
  function(_super) {
    __extends$1(ProcessingInstruction2, _super);
    function ProcessingInstruction2(name, data2) {
      var _this = _super.call(this, data2) || this;
      _this.name = name;
      _this.type = domelementtype_1$1.ElementType.Directive;
      return _this;
    }
    Object.defineProperty(ProcessingInstruction2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    return ProcessingInstruction2;
  }(DataNode)
);
node.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = (
  /** @class */
  function(_super) {
    __extends$1(NodeWithChildren2, _super);
    function NodeWithChildren2(children3) {
      var _this = _super.call(this) || this;
      _this.children = children3;
      return _this;
    }
    Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(children3) {
        this.children = children3;
      },
      enumerable: false,
      configurable: true
    });
    return NodeWithChildren2;
  }(Node)
);
node.NodeWithChildren = NodeWithChildren;
var CDATA = (
  /** @class */
  function(_super) {
    __extends$1(CDATA2, _super);
    function CDATA2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1$1.ElementType.CDATA;
      return _this;
    }
    Object.defineProperty(CDATA2.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: false,
      configurable: true
    });
    return CDATA2;
  }(NodeWithChildren)
);
node.CDATA = CDATA;
var Document = (
  /** @class */
  function(_super) {
    __extends$1(Document2, _super);
    function Document2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.type = domelementtype_1$1.ElementType.Root;
      return _this;
    }
    Object.defineProperty(Document2.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: false,
      configurable: true
    });
    return Document2;
  }(NodeWithChildren)
);
node.Document = Document;
var Element = (
  /** @class */
  function(_super) {
    __extends$1(Element2, _super);
    function Element2(name, attribs, children3, type3) {
      if (children3 === void 0) {
        children3 = [];
      }
      if (type3 === void 0) {
        type3 = name === "script" ? domelementtype_1$1.ElementType.Script : name === "style" ? domelementtype_1$1.ElementType.Style : domelementtype_1$1.ElementType.Tag;
      }
      var _this = _super.call(this, children3) || this;
      _this.name = name;
      _this.attribs = attribs;
      _this.type = type3;
      return _this;
    }
    Object.defineProperty(Element2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(name) {
        this.name = name;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "attributes", {
      get: function() {
        var _this = this;
        return Object.keys(this.attribs).map(function(name) {
          var _a, _b;
          return {
            name,
            value: _this.attribs[name],
            namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
            prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
          };
        });
      },
      enumerable: false,
      configurable: true
    });
    return Element2;
  }(NodeWithChildren)
);
node.Element = Element;
function isTag(node2) {
  return (0, domelementtype_1$1.isTag)(node2);
}
node.isTag = isTag;
function isCDATA(node2) {
  return node2.type === domelementtype_1$1.ElementType.CDATA;
}
node.isCDATA = isCDATA;
function isText(node2) {
  return node2.type === domelementtype_1$1.ElementType.Text;
}
node.isText = isText;
function isComment(node2) {
  return node2.type === domelementtype_1$1.ElementType.Comment;
}
node.isComment = isComment;
function isDirective(node2) {
  return node2.type === domelementtype_1$1.ElementType.Directive;
}
node.isDirective = isDirective;
function isDocument(node2) {
  return node2.type === domelementtype_1$1.ElementType.Root;
}
node.isDocument = isDocument;
function hasChildren(node2) {
  return Object.prototype.hasOwnProperty.call(node2, "children");
}
node.hasChildren = hasChildren;
function cloneNode(node2, recursive) {
  if (recursive === void 0) {
    recursive = false;
  }
  var result;
  if (isText(node2)) {
    result = new Text(node2.data);
  } else if (isComment(node2)) {
    result = new Comment(node2.data);
  } else if (isTag(node2)) {
    var children3 = recursive ? cloneChildren(node2.children) : [];
    var clone_1 = new Element(node2.name, __assign$3({}, node2.attribs), children3);
    children3.forEach(function(child) {
      return child.parent = clone_1;
    });
    if (node2.namespace != null) {
      clone_1.namespace = node2.namespace;
    }
    if (node2["x-attribsNamespace"]) {
      clone_1["x-attribsNamespace"] = __assign$3({}, node2["x-attribsNamespace"]);
    }
    if (node2["x-attribsPrefix"]) {
      clone_1["x-attribsPrefix"] = __assign$3({}, node2["x-attribsPrefix"]);
    }
    result = clone_1;
  } else if (isCDATA(node2)) {
    var children3 = recursive ? cloneChildren(node2.children) : [];
    var clone_2 = new CDATA(children3);
    children3.forEach(function(child) {
      return child.parent = clone_2;
    });
    result = clone_2;
  } else if (isDocument(node2)) {
    var children3 = recursive ? cloneChildren(node2.children) : [];
    var clone_3 = new Document(children3);
    children3.forEach(function(child) {
      return child.parent = clone_3;
    });
    if (node2["x-mode"]) {
      clone_3["x-mode"] = node2["x-mode"];
    }
    result = clone_3;
  } else if (isDirective(node2)) {
    var instruction = new ProcessingInstruction(node2.name, node2.data);
    if (node2["x-name"] != null) {
      instruction["x-name"] = node2["x-name"];
      instruction["x-publicId"] = node2["x-publicId"];
      instruction["x-systemId"] = node2["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node2.type));
  }
  result.startIndex = node2.startIndex;
  result.endIndex = node2.endIndex;
  if (node2.sourceCodeLocation != null) {
    result.sourceCodeLocation = node2.sourceCodeLocation;
  }
  return result;
}
node.cloneNode = cloneNode;
function cloneChildren(childs) {
  var children3 = childs.map(function(child) {
    return cloneNode(child, true);
  });
  for (var i = 1; i < children3.length; i++) {
    children3[i].prev = children3[i - 1];
    children3[i - 1].next = children3[i];
  }
  return children3;
}
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports3) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
        __createBinding2(exports3, m, p);
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.DomHandler = void 0;
  var domelementtype_12 = lib$9;
  var node_js_1 = node;
  __exportStar(node, exports2);
  var defaultOpts2 = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
  };
  var DomHandler = (
    /** @class */
    function() {
      function DomHandler2(callback, options2, elementCB) {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
        if (typeof options2 === "function") {
          elementCB = options2;
          options2 = defaultOpts2;
        }
        if (typeof callback === "object") {
          options2 = callback;
          callback = void 0;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options2 !== null && options2 !== void 0 ? options2 : defaultOpts2;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
      }
      DomHandler2.prototype.onparserinit = function(parser2) {
        this.parser = parser2;
      };
      DomHandler2.prototype.onreset = function() {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
      };
      DomHandler2.prototype.onend = function() {
        if (this.done)
          return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
      };
      DomHandler2.prototype.onerror = function(error) {
        this.handleCallback(error);
      };
      DomHandler2.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
          elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
          this.elementCB(elem);
      };
      DomHandler2.prototype.onopentag = function(name, attribs) {
        var type3 = this.options.xmlMode ? domelementtype_12.ElementType.Tag : void 0;
        var element = new node_js_1.Element(name, attribs, void 0, type3);
        this.addNode(element);
        this.tagStack.push(element);
      };
      DomHandler2.prototype.ontext = function(data2) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_12.ElementType.Text) {
          lastNode.data += data2;
          if (this.options.withEndIndices) {
            lastNode.endIndex = this.parser.endIndex;
          }
        } else {
          var node2 = new node_js_1.Text(data2);
          this.addNode(node2);
          this.lastNode = node2;
        }
      };
      DomHandler2.prototype.oncomment = function(data2) {
        if (this.lastNode && this.lastNode.type === domelementtype_12.ElementType.Comment) {
          this.lastNode.data += data2;
          return;
        }
        var node2 = new node_js_1.Comment(data2);
        this.addNode(node2);
        this.lastNode = node2;
      };
      DomHandler2.prototype.oncommentend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.oncdatastart = function() {
        var text2 = new node_js_1.Text("");
        var node2 = new node_js_1.CDATA([text2]);
        this.addNode(node2);
        text2.parent = node2;
        this.lastNode = text2;
      };
      DomHandler2.prototype.oncdataend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.onprocessinginstruction = function(name, data2) {
        var node2 = new node_js_1.ProcessingInstruction(name, data2);
        this.addNode(node2);
      };
      DomHandler2.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") {
          this.callback(error, this.dom);
        } else if (error) {
          throw error;
        }
      };
      DomHandler2.prototype.addNode = function(node2) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
          node2.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
          node2.endIndex = this.parser.endIndex;
        }
        parent.children.push(node2);
        if (previousSibling) {
          node2.prev = previousSibling;
          previousSibling.next = node2;
        }
        node2.parent = parent;
        this.lastNode = null;
      };
      return DomHandler2;
    }()
  );
  exports2.DomHandler = DomHandler;
  exports2.default = DomHandler;
})(lib$a);
var lib$8 = {};
var lib$7 = {};
var decode = {};
var decodeDataHtml = {};
Object.defineProperty(decodeDataHtml, "__esModule", {
  value: true
});
decodeDataHtml.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(c2) {
    return c2.charCodeAt(0);
  })
);
var decodeDataXml = {};
Object.defineProperty(decodeDataXml, "__esModule", {
  value: true
});
decodeDataXml.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(c2) {
    return c2.charCodeAt(0);
  })
);
var decode_codepoint = {};
(function(exports2) {
  var _a;
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.replaceCodePoint = exports2.fromCodePoint = void 0;
  var decodeMap = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  exports2.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
    var output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  };
  function replaceCodePoint(codePoint) {
    var _a2;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
      return 65533;
    }
    return (_a2 = decodeMap.get(codePoint)) !== null && _a2 !== void 0 ? _a2 : codePoint;
  }
  exports2.replaceCodePoint = replaceCodePoint;
  function decodeCodePoint(codePoint) {
    return (0, exports2.fromCodePoint)(replaceCodePoint(codePoint));
  }
  exports2.default = decodeCodePoint;
})(decode_codepoint);
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.decodeXML = exports2.decodeHTMLStrict = exports2.decodeHTMLAttribute = exports2.decodeHTML = exports2.determineBranch = exports2.EntityDecoder = exports2.DecodingMode = exports2.BinTrieFlags = exports2.fromCodePoint = exports2.replaceCodePoint = exports2.decodeCodePoint = exports2.xmlDecodeTree = exports2.htmlDecodeTree = void 0;
  var decode_data_html_js_1 = __importDefault2(decodeDataHtml);
  exports2.htmlDecodeTree = decode_data_html_js_1.default;
  var decode_data_xml_js_1 = __importDefault2(decodeDataXml);
  exports2.xmlDecodeTree = decode_data_xml_js_1.default;
  var decode_codepoint_js_1 = __importStar2(decode_codepoint);
  exports2.decodeCodePoint = decode_codepoint_js_1.default;
  var decode_codepoint_js_2 = decode_codepoint;
  Object.defineProperty(exports2, "replaceCodePoint", {
    enumerable: true,
    get: function() {
      return decode_codepoint_js_2.replaceCodePoint;
    }
  });
  Object.defineProperty(exports2, "fromCodePoint", {
    enumerable: true,
    get: function() {
      return decode_codepoint_js_2.fromCodePoint;
    }
  });
  var CharCodes;
  (function(CharCodes2) {
    CharCodes2[CharCodes2["NUM"] = 35] = "NUM";
    CharCodes2[CharCodes2["SEMI"] = 59] = "SEMI";
    CharCodes2[CharCodes2["EQUALS"] = 61] = "EQUALS";
    CharCodes2[CharCodes2["ZERO"] = 48] = "ZERO";
    CharCodes2[CharCodes2["NINE"] = 57] = "NINE";
    CharCodes2[CharCodes2["LOWER_A"] = 97] = "LOWER_A";
    CharCodes2[CharCodes2["LOWER_F"] = 102] = "LOWER_F";
    CharCodes2[CharCodes2["LOWER_X"] = 120] = "LOWER_X";
    CharCodes2[CharCodes2["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes2[CharCodes2["UPPER_A"] = 65] = "UPPER_A";
    CharCodes2[CharCodes2["UPPER_F"] = 70] = "UPPER_F";
    CharCodes2[CharCodes2["UPPER_Z"] = 90] = "UPPER_Z";
  })(CharCodes || (CharCodes = {}));
  var TO_LOWER_BIT = 32;
  var BinTrieFlags;
  (function(BinTrieFlags2) {
    BinTrieFlags2[BinTrieFlags2["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags2[BinTrieFlags2["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags2[BinTrieFlags2["JUMP_TABLE"] = 127] = "JUMP_TABLE";
  })(BinTrieFlags = exports2.BinTrieFlags || (exports2.BinTrieFlags = {}));
  function isNumber2(code2) {
    return code2 >= CharCodes.ZERO && code2 <= CharCodes.NINE;
  }
  function isHexadecimalCharacter(code2) {
    return code2 >= CharCodes.UPPER_A && code2 <= CharCodes.UPPER_F || code2 >= CharCodes.LOWER_A && code2 <= CharCodes.LOWER_F;
  }
  function isAsciiAlphaNumeric2(code2) {
    return code2 >= CharCodes.UPPER_A && code2 <= CharCodes.UPPER_Z || code2 >= CharCodes.LOWER_A && code2 <= CharCodes.LOWER_Z || isNumber2(code2);
  }
  function isEntityInAttributeInvalidEnd2(code2) {
    return code2 === CharCodes.EQUALS || isAsciiAlphaNumeric2(code2);
  }
  var EntityDecoderState;
  (function(EntityDecoderState2) {
    EntityDecoderState2[EntityDecoderState2["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState2[EntityDecoderState2["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState2[EntityDecoderState2["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState2[EntityDecoderState2["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState2[EntityDecoderState2["NamedEntity"] = 4] = "NamedEntity";
  })(EntityDecoderState || (EntityDecoderState = {}));
  var DecodingMode;
  (function(DecodingMode2) {
    DecodingMode2[DecodingMode2["Legacy"] = 0] = "Legacy";
    DecodingMode2[DecodingMode2["Strict"] = 1] = "Strict";
    DecodingMode2[DecodingMode2["Attribute"] = 2] = "Attribute";
  })(DecodingMode = exports2.DecodingMode || (exports2.DecodingMode = {}));
  var EntityDecoder = (
    /** @class */
    function() {
      function EntityDecoder2(decodeTree, emitCodePoint, errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        this.state = EntityDecoderState.EntityStart;
        this.consumed = 1;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.decodeMode = DecodingMode.Strict;
      }
      EntityDecoder2.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
      };
      EntityDecoder2.prototype.write = function(str, offset2) {
        switch (this.state) {
          case EntityDecoderState.EntityStart: {
            if (str.charCodeAt(offset2) === CharCodes.NUM) {
              this.state = EntityDecoderState.NumericStart;
              this.consumed += 1;
              return this.stateNumericStart(str, offset2 + 1);
            }
            this.state = EntityDecoderState.NamedEntity;
            return this.stateNamedEntity(str, offset2);
          }
          case EntityDecoderState.NumericStart: {
            return this.stateNumericStart(str, offset2);
          }
          case EntityDecoderState.NumericDecimal: {
            return this.stateNumericDecimal(str, offset2);
          }
          case EntityDecoderState.NumericHex: {
            return this.stateNumericHex(str, offset2);
          }
          case EntityDecoderState.NamedEntity: {
            return this.stateNamedEntity(str, offset2);
          }
        }
      };
      EntityDecoder2.prototype.stateNumericStart = function(str, offset2) {
        if (offset2 >= str.length) {
          return -1;
        }
        if ((str.charCodeAt(offset2) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
          this.state = EntityDecoderState.NumericHex;
          this.consumed += 1;
          return this.stateNumericHex(str, offset2 + 1);
        }
        this.state = EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset2);
      };
      EntityDecoder2.prototype.addToNumericResult = function(str, start2, end2, base) {
        if (start2 !== end2) {
          var digitCount = end2 - start2;
          this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start2, digitCount), base);
          this.consumed += digitCount;
        }
      };
      EntityDecoder2.prototype.stateNumericHex = function(str, offset2) {
        var startIdx = offset2;
        while (offset2 < str.length) {
          var char = str.charCodeAt(offset2);
          if (isNumber2(char) || isHexadecimalCharacter(char)) {
            offset2 += 1;
          } else {
            this.addToNumericResult(str, startIdx, offset2, 16);
            return this.emitNumericEntity(char, 3);
          }
        }
        this.addToNumericResult(str, startIdx, offset2, 16);
        return -1;
      };
      EntityDecoder2.prototype.stateNumericDecimal = function(str, offset2) {
        var startIdx = offset2;
        while (offset2 < str.length) {
          var char = str.charCodeAt(offset2);
          if (isNumber2(char)) {
            offset2 += 1;
          } else {
            this.addToNumericResult(str, startIdx, offset2, 10);
            return this.emitNumericEntity(char, 2);
          }
        }
        this.addToNumericResult(str, startIdx, offset2, 10);
        return -1;
      };
      EntityDecoder2.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        if (this.consumed <= expectedLength) {
          (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
          return 0;
        }
        if (lastCp === CharCodes.SEMI) {
          this.consumed += 1;
        } else if (this.decodeMode === DecodingMode.Strict) {
          return 0;
        }
        this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
          if (lastCp !== CharCodes.SEMI) {
            this.errors.missingSemicolonAfterCharacterReference();
          }
          this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
      };
      EntityDecoder2.prototype.stateNamedEntity = function(str, offset2) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        for (; offset2 < str.length; offset2++, this.excess++) {
          var char = str.charCodeAt(offset2);
          this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
          if (this.treeIndex < 0) {
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            isEntityInAttributeInvalidEnd2(char)) ? 0 : this.emitNotTerminatedNamedEntity();
          }
          current = decodeTree[this.treeIndex];
          valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
          if (valueLength !== 0) {
            if (char === CharCodes.SEMI) {
              return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
            }
            if (this.decodeMode !== DecodingMode.Strict) {
              this.result = this.treeIndex;
              this.consumed += this.excess;
              this.excess = 0;
            }
          }
        }
        return -1;
      };
      EntityDecoder2.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
      };
      EntityDecoder2.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) {
          this.emitCodePoint(decodeTree[result + 2], consumed);
        }
        return consumed;
      };
      EntityDecoder2.prototype.end = function() {
        var _a;
        switch (this.state) {
          case EntityDecoderState.NamedEntity: {
            return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          }
          case EntityDecoderState.NumericDecimal: {
            return this.emitNumericEntity(0, 2);
          }
          case EntityDecoderState.NumericHex: {
            return this.emitNumericEntity(0, 3);
          }
          case EntityDecoderState.NumericStart: {
            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
          }
          case EntityDecoderState.EntityStart: {
            return 0;
          }
        }
      };
      return EntityDecoder2;
    }()
  );
  exports2.EntityDecoder = EntityDecoder;
  function getDecoder(decodeTree) {
    var ret = "";
    var decoder = new EntityDecoder(decodeTree, function(str) {
      return ret += (0, decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
      var lastIndex = 0;
      var offset2 = 0;
      while ((offset2 = str.indexOf("&", offset2)) >= 0) {
        ret += str.slice(lastIndex, offset2);
        decoder.startEntity(decodeMode);
        var len = decoder.write(
          str,
          // Skip the "&"
          offset2 + 1
        );
        if (len < 0) {
          lastIndex = offset2 + decoder.end();
          break;
        }
        lastIndex = offset2 + len;
        offset2 = len === 0 ? lastIndex + 1 : lastIndex;
      }
      var result = ret + str.slice(lastIndex);
      ret = "";
      return result;
    };
  }
  function determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    if (branchCount === 0) {
      return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    }
    if (jumpOffset) {
      var value2 = char - jumpOffset;
      return value2 < 0 || value2 >= branchCount ? -1 : decodeTree[nodeIdx + value2] - 1;
    }
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while (lo <= hi) {
      var mid = lo + hi >>> 1;
      var midVal = decodeTree[mid];
      if (midVal < char) {
        lo = mid + 1;
      } else if (midVal > char) {
        hi = mid - 1;
      } else {
        return decodeTree[mid + branchCount];
      }
    }
    return -1;
  }
  exports2.determineBranch = determineBranch;
  var htmlDecoder = getDecoder(decode_data_html_js_1.default);
  var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
  function decodeHTML(str, mode) {
    if (mode === void 0) {
      mode = DecodingMode.Legacy;
    }
    return htmlDecoder(str, mode);
  }
  exports2.decodeHTML = decodeHTML;
  function decodeHTMLAttribute(str) {
    return htmlDecoder(str, DecodingMode.Attribute);
  }
  exports2.decodeHTMLAttribute = decodeHTMLAttribute;
  function decodeHTMLStrict(str) {
    return htmlDecoder(str, DecodingMode.Strict);
  }
  exports2.decodeHTMLStrict = decodeHTMLStrict;
  function decodeXML(str) {
    return xmlDecoder(str, DecodingMode.Strict);
  }
  exports2.decodeXML = decodeXML;
})(decode);
var encode = {};
var encodeHtml = {};
Object.defineProperty(encodeHtml, "__esModule", {
  value: true
});
function restoreDiff(arr) {
  for (var i = 1; i < arr.length; i++) {
    arr[i][0] += arr[i - 1][0] + 1;
  }
  return arr;
}
encodeHtml.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, {
  v: "&lt;",
  n: 8402,
  o: "&nvlt;"
}], [0, {
  v: "&equals;",
  n: 8421,
  o: "&bne;"
}], [0, {
  v: "&gt;",
  n: 8402,
  o: "&nvgt;"
}], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, {
  n: 106,
  o: "&fjlig;"
}], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, {
  v: "&MediumSpace;",
  n: 8202,
  o: "&ThickSpace;"
}], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, {
  v: "&rarrw;",
  n: 824,
  o: "&nrarrw;"
}], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, {
  v: "&part;",
  n: 824,
  o: "&npart;"
}], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, {
  v: "&ang;",
  n: 8402,
  o: "&nang;"
}], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, {
  v: "&cap;",
  n: 65024,
  o: "&caps;"
}], [0, {
  v: "&cup;",
  n: 65024,
  o: "&cups;"
}], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, {
  v: "&sim;",
  n: 8402,
  o: "&nvsim;"
}], [0, {
  v: "&backsim;",
  n: 817,
  o: "&race;"
}], [0, {
  v: "&ac;",
  n: 819,
  o: "&acE;"
}], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, {
  v: "&eqsim;",
  n: 824,
  o: "&nesim;"
}], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, {
  v: "&apid;",
  n: 824,
  o: "&napid;"
}], [0, "&backcong;"], [0, {
  v: "&asympeq;",
  n: 8402,
  o: "&nvap;"
}], [0, {
  v: "&bump;",
  n: 824,
  o: "&nbump;"
}], [0, {
  v: "&bumpe;",
  n: 824,
  o: "&nbumpe;"
}], [0, {
  v: "&doteq;",
  n: 824,
  o: "&nedot;"
}], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, {
  v: "&Congruent;",
  n: 8421,
  o: "&bnequiv;"
}], [0, "&nequiv;"], [1, {
  v: "&le;",
  n: 8402,
  o: "&nvle;"
}], [0, {
  v: "&ge;",
  n: 8402,
  o: "&nvge;"
}], [0, {
  v: "&lE;",
  n: 824,
  o: "&nlE;"
}], [0, {
  v: "&gE;",
  n: 824,
  o: "&ngE;"
}], [0, {
  v: "&lnE;",
  n: 65024,
  o: "&lvertneqq;"
}], [0, {
  v: "&gnE;",
  n: 65024,
  o: "&gvertneqq;"
}], [0, {
  v: "&ll;",
  n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]]))
}], [0, {
  v: "&gg;",
  n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]]))
}], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, {
  v: "&scsim;",
  n: 824,
  o: "&NotSucceedsTilde;"
}], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, {
  v: "&sub;",
  n: 8402,
  o: "&NotSubset;"
}], [0, {
  v: "&sup;",
  n: 8402,
  o: "&NotSuperset;"
}], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, {
  v: "&subne;",
  n: 65024,
  o: "&varsubsetneq;"
}], [0, {
  v: "&supne;",
  n: 65024,
  o: "&varsupsetneq;"
}], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, {
  v: "&sqsub;",
  n: 824,
  o: "&NotSquareSubset;"
}], [0, {
  v: "&sqsup;",
  n: 824,
  o: "&NotSquareSuperset;"
}], [0, "&sqsube;"], [0, "&sqsupe;"], [0, {
  v: "&sqcap;",
  n: 65024,
  o: "&sqcaps;"
}], [0, {
  v: "&sqcup;",
  n: 65024,
  o: "&sqcups;"
}], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, {
  v: "&LeftTriangleEqual;",
  n: 8402,
  o: "&nvltrie;"
}], [0, {
  v: "&RightTriangleEqual;",
  n: 8402,
  o: "&nvrtrie;"
}], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, {
  v: "&Ll;",
  n: 824,
  o: "&nLl;"
}], [0, {
  v: "&Gg;",
  n: 824,
  o: "&nGg;"
}], [0, {
  v: "&leg;",
  n: 65024,
  o: "&lesg;"
}], [0, {
  v: "&gel;",
  n: 65024,
  o: "&gesl;"
}], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, {
  v: "&isindot;",
  n: 824,
  o: "&notindot;"
}], [0, "&notinvc;"], [0, "&notinvb;"], [1, {
  v: "&isinE;",
  n: 824,
  o: "&notinE;"
}], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, {
  v: "&rarrc;",
  n: 824,
  o: "&nrarrc;"
}], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, {
  v: "&LeftTriangleBar;",
  n: 824,
  o: "&NotLeftTriangleBar;"
}], [0, {
  v: "&RightTriangleBar;",
  n: 824,
  o: "&NotRightTriangleBar;"
}], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, {
  v: "&congdot;",
  n: 824,
  o: "&ncongdot;"
}], [0, "&easter;"], [0, "&apacir;"], [0, {
  v: "&apE;",
  n: 824,
  o: "&napE;"
}], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, {
  v: "&leqslant;",
  n: 824,
  o: "&nleqslant;"
}], [0, {
  v: "&geqslant;",
  n: 824,
  o: "&ngeqslant;"
}], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, {
  v: "&LessLess;",
  n: 824,
  o: "&NotNestedLessLess;"
}], [0, {
  v: "&GreaterGreater;",
  n: 824,
  o: "&NotNestedGreaterGreater;"
}], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, {
  v: "&smte;",
  n: 65024,
  o: "&smtes;"
}], [0, {
  v: "&late;",
  n: 65024,
  o: "&lates;"
}], [0, "&bumpE;"], [0, {
  v: "&PrecedesEqual;",
  n: 824,
  o: "&NotPrecedesEqual;"
}], [0, {
  v: "&sce;",
  n: 824,
  o: "&NotSucceedsEqual;"
}], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, {
  v: "&subE;",
  n: 824,
  o: "&nsubE;"
}], [0, {
  v: "&supE;",
  n: 824,
  o: "&nsupE;"
}], [0, "&subsim;"], [0, "&supsim;"], [2, {
  v: "&subnE;",
  n: 65024,
  o: "&varsubsetneqq;"
}], [0, {
  v: "&supnE;",
  n: 65024,
  o: "&varsupsetneqq;"
}], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, {
  v: "&parsl;",
  n: 8421,
  o: "&nparsl;"
}], [44343, {
  n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]]))
}], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var _escape = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.escapeText = exports2.escapeAttribute = exports2.escapeUTF8 = exports2.escape = exports2.encodeXML = exports2.getCodePoint = exports2.xmlReplacer = void 0;
  exports2.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var xmlCodeMap = /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
  exports2.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(str, index2) {
    return str.codePointAt(index2);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(c2, index2) {
      return (c2.charCodeAt(index2) & 64512) === 55296 ? (c2.charCodeAt(index2) - 55296) * 1024 + c2.charCodeAt(index2 + 1) - 56320 + 65536 : c2.charCodeAt(index2);
    }
  );
  function encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while ((match = exports2.xmlReplacer.exec(str)) !== null) {
      var i = match.index;
      var char = str.charCodeAt(i);
      var next = xmlCodeMap.get(char);
      if (next !== void 0) {
        ret += str.substring(lastIdx, i) + next;
        lastIdx = i + 1;
      } else {
        ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, exports2.getCodePoint)(str, i).toString(16), ";");
        lastIdx = exports2.xmlReplacer.lastIndex += Number((char & 64512) === 55296);
      }
    }
    return ret + str.substr(lastIdx);
  }
  exports2.encodeXML = encodeXML;
  exports2.escape = encodeXML;
  function getEscaper(regex2, map2) {
    return function escape2(data2) {
      var match;
      var lastIdx = 0;
      var result = "";
      while (match = regex2.exec(data2)) {
        if (lastIdx !== match.index) {
          result += data2.substring(lastIdx, match.index);
        }
        result += map2.get(match[0].charCodeAt(0));
        lastIdx = match.index + 1;
      }
      return result + data2.substring(lastIdx);
    };
  }
  exports2.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
  exports2.escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]]));
  exports2.escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
})(_escape);
var __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : {
    "default": mod2
  };
};
Object.defineProperty(encode, "__esModule", {
  value: true
});
encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
var encode_html_js_1 = __importDefault$4(encodeHtml);
var escape_js_1$2 = _escape;
var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function encodeHTML(data2) {
  return encodeHTMLTrieRe(htmlReplacer, data2);
}
encode.encodeHTML = encodeHTML;
function encodeNonAsciiHTML(data2) {
  return encodeHTMLTrieRe(escape_js_1$2.xmlReplacer, data2);
}
encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(regExp, str) {
  var ret = "";
  var lastIdx = 0;
  var match;
  while ((match = regExp.exec(str)) !== null) {
    var i = match.index;
    ret += str.substring(lastIdx, i);
    var char = str.charCodeAt(i);
    var next = encode_html_js_1.default.get(char);
    if (typeof next === "object") {
      if (i + 1 < str.length) {
        var nextChar = str.charCodeAt(i + 1);
        var value2 = typeof next.n === "number" ? next.n === nextChar ? next.o : void 0 : next.n.get(nextChar);
        if (value2 !== void 0) {
          ret += value2;
          lastIdx = regExp.lastIndex += 1;
          continue;
        }
      }
      next = next.v;
    }
    if (next !== void 0) {
      ret += next;
      lastIdx = i + 1;
    } else {
      var cp = (0, escape_js_1$2.getCodePoint)(str, i);
      ret += "&#x".concat(cp.toString(16), ";");
      lastIdx = regExp.lastIndex += Number(cp !== char);
    }
  }
  return ret + str.substr(lastIdx);
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.decodeXMLStrict = exports2.decodeHTML5Strict = exports2.decodeHTML4Strict = exports2.decodeHTML5 = exports2.decodeHTML4 = exports2.decodeHTMLAttribute = exports2.decodeHTMLStrict = exports2.decodeHTML = exports2.decodeXML = exports2.DecodingMode = exports2.EntityDecoder = exports2.encodeHTML5 = exports2.encodeHTML4 = exports2.encodeNonAsciiHTML = exports2.encodeHTML = exports2.escapeText = exports2.escapeAttribute = exports2.escapeUTF8 = exports2.escape = exports2.encodeXML = exports2.encode = exports2.decodeStrict = exports2.decode = exports2.EncodingMode = exports2.EntityLevel = void 0;
  var decode_js_12 = decode;
  var encode_js_1 = encode;
  var escape_js_12 = _escape;
  var EntityLevel;
  (function(EntityLevel2) {
    EntityLevel2[EntityLevel2["XML"] = 0] = "XML";
    EntityLevel2[EntityLevel2["HTML"] = 1] = "HTML";
  })(EntityLevel = exports2.EntityLevel || (exports2.EntityLevel = {}));
  var EncodingMode;
  (function(EncodingMode2) {
    EncodingMode2[EncodingMode2["UTF8"] = 0] = "UTF8";
    EncodingMode2[EncodingMode2["ASCII"] = 1] = "ASCII";
    EncodingMode2[EncodingMode2["Extensive"] = 2] = "Extensive";
    EncodingMode2[EncodingMode2["Attribute"] = 3] = "Attribute";
    EncodingMode2[EncodingMode2["Text"] = 4] = "Text";
  })(EncodingMode = exports2.EncodingMode || (exports2.EncodingMode = {}));
  function decode$12(data2, options2) {
    if (options2 === void 0) {
      options2 = EntityLevel.XML;
    }
    var level = typeof options2 === "number" ? options2 : options2.level;
    if (level === EntityLevel.HTML) {
      var mode = typeof options2 === "object" ? options2.mode : void 0;
      return (0, decode_js_12.decodeHTML)(data2, mode);
    }
    return (0, decode_js_12.decodeXML)(data2);
  }
  exports2.decode = decode$12;
  function decodeStrict(data2, options2) {
    var _a;
    if (options2 === void 0) {
      options2 = EntityLevel.XML;
    }
    var opts = typeof options2 === "number" ? {
      level: options2
    } : options2;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = decode_js_12.DecodingMode.Strict;
    return decode$12(data2, opts);
  }
  exports2.decodeStrict = decodeStrict;
  function encode$12(data2, options2) {
    if (options2 === void 0) {
      options2 = EntityLevel.XML;
    }
    var opts = typeof options2 === "number" ? {
      level: options2
    } : options2;
    if (opts.mode === EncodingMode.UTF8)
      return (0, escape_js_12.escapeUTF8)(data2);
    if (opts.mode === EncodingMode.Attribute)
      return (0, escape_js_12.escapeAttribute)(data2);
    if (opts.mode === EncodingMode.Text)
      return (0, escape_js_12.escapeText)(data2);
    if (opts.level === EntityLevel.HTML) {
      if (opts.mode === EncodingMode.ASCII) {
        return (0, encode_js_1.encodeNonAsciiHTML)(data2);
      }
      return (0, encode_js_1.encodeHTML)(data2);
    }
    return (0, escape_js_12.encodeXML)(data2);
  }
  exports2.encode = encode$12;
  var escape_js_2 = _escape;
  Object.defineProperty(exports2, "encodeXML", {
    enumerable: true,
    get: function() {
      return escape_js_2.encodeXML;
    }
  });
  Object.defineProperty(exports2, "escape", {
    enumerable: true,
    get: function() {
      return escape_js_2.escape;
    }
  });
  Object.defineProperty(exports2, "escapeUTF8", {
    enumerable: true,
    get: function() {
      return escape_js_2.escapeUTF8;
    }
  });
  Object.defineProperty(exports2, "escapeAttribute", {
    enumerable: true,
    get: function() {
      return escape_js_2.escapeAttribute;
    }
  });
  Object.defineProperty(exports2, "escapeText", {
    enumerable: true,
    get: function() {
      return escape_js_2.escapeText;
    }
  });
  var encode_js_2 = encode;
  Object.defineProperty(exports2, "encodeHTML", {
    enumerable: true,
    get: function() {
      return encode_js_2.encodeHTML;
    }
  });
  Object.defineProperty(exports2, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
      return encode_js_2.encodeNonAsciiHTML;
    }
  });
  Object.defineProperty(exports2, "encodeHTML4", {
    enumerable: true,
    get: function() {
      return encode_js_2.encodeHTML;
    }
  });
  Object.defineProperty(exports2, "encodeHTML5", {
    enumerable: true,
    get: function() {
      return encode_js_2.encodeHTML;
    }
  });
  var decode_js_2 = decode;
  Object.defineProperty(exports2, "EntityDecoder", {
    enumerable: true,
    get: function() {
      return decode_js_2.EntityDecoder;
    }
  });
  Object.defineProperty(exports2, "DecodingMode", {
    enumerable: true,
    get: function() {
      return decode_js_2.DecodingMode;
    }
  });
  Object.defineProperty(exports2, "decodeXML", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeXML;
    }
  });
  Object.defineProperty(exports2, "decodeHTML", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTML;
    }
  });
  Object.defineProperty(exports2, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTMLStrict;
    }
  });
  Object.defineProperty(exports2, "decodeHTMLAttribute", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTMLAttribute;
    }
  });
  Object.defineProperty(exports2, "decodeHTML4", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTML;
    }
  });
  Object.defineProperty(exports2, "decodeHTML5", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTML;
    }
  });
  Object.defineProperty(exports2, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTMLStrict;
    }
  });
  Object.defineProperty(exports2, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeHTMLStrict;
    }
  });
  Object.defineProperty(exports2, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
      return decode_js_2.decodeXML;
    }
  });
})(lib$7);
var foreignNames = {};
Object.defineProperty(foreignNames, "__esModule", {
  value: true
});
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function(val2) {
  return [val2.toLowerCase(), val2];
}));
foreignNames.attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function(val2) {
  return [val2.toLowerCase(), val2];
}));
var __assign$2 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$2 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$6(result, mod2, k);
  }
  __setModuleDefault$6(result, mod2);
  return result;
};
Object.defineProperty(lib$8, "__esModule", {
  value: true
});
lib$8.render = void 0;
var ElementType = __importStar$6(lib$9);
var entities_1 = lib$7;
var foreignNames_js_1 = foreignNames;
var unencodedElements = /* @__PURE__ */ new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
function replaceQuotes(value2) {
  return value2.replace(/"/g, "&quot;");
}
function formatAttributes(attributes2, opts) {
  var _a;
  if (!attributes2)
    return;
  var encode2 = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
  return Object.keys(attributes2).map(function(key) {
    var _a2, _b;
    var value2 = (_a2 = attributes2[key]) !== null && _a2 !== void 0 ? _a2 : "";
    if (opts.xmlMode === "foreign") {
      key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
    }
    if (!opts.emptyAttrs && !opts.xmlMode && value2 === "") {
      return key;
    }
    return "".concat(key, '="').concat(encode2(value2), '"');
  }).join(" ");
}
var singleTag = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
function render$3(node2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var nodes = "length" in node2 ? node2 : [node2];
  var output = "";
  for (var i = 0; i < nodes.length; i++) {
    output += renderNode(nodes[i], options2);
  }
  return output;
}
lib$8.render = render$3;
lib$8.default = render$3;
function renderNode(node2, options2) {
  switch (node2.type) {
    case ElementType.Root:
      return render$3(node2.children, options2);
    case ElementType.Doctype:
    case ElementType.Directive:
      return renderDirective(node2);
    case ElementType.Comment:
      return renderComment(node2);
    case ElementType.CDATA:
      return renderCdata(node2);
    case ElementType.Script:
    case ElementType.Style:
    case ElementType.Tag:
      return renderTag(node2, options2);
    case ElementType.Text:
      return renderText(node2, options2);
  }
}
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
function renderTag(elem, opts) {
  var _a;
  if (opts.xmlMode === "foreign") {
    elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = __assign$2(__assign$2({}, opts), {
        xmlMode: false
      });
    }
  }
  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = __assign$2(__assign$2({}, opts), {
      xmlMode: "foreign"
    });
  }
  var tag = "<".concat(elem.name);
  var attribs = formatAttributes(elem.attribs, opts);
  if (attribs) {
    tag += " ".concat(attribs);
  }
  if (elem.children.length === 0 && (opts.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    opts.selfClosingTags !== false
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    opts.selfClosingTags && singleTag.has(elem.name)
  ))) {
    if (!opts.xmlMode)
      tag += " ";
    tag += "/>";
  } else {
    tag += ">";
    if (elem.children.length > 0) {
      tag += render$3(elem.children, opts);
    }
    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += "</".concat(elem.name, ">");
    }
  }
  return tag;
}
function renderDirective(elem) {
  return "<".concat(elem.data, ">");
}
function renderText(elem, opts) {
  var _a;
  var data2 = elem.data || "";
  if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data2 = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(data2) : (0, entities_1.escapeText)(data2);
  }
  return data2;
}
function renderCdata(elem) {
  return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function renderComment(elem) {
  return "<!--".concat(elem.data, "-->");
}
var __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : {
    "default": mod2
  };
};
Object.defineProperty(stringify$2, "__esModule", {
  value: true
});
stringify$2.innerText = stringify$2.textContent = stringify$2.getText = stringify$2.getInnerHTML = stringify$2.getOuterHTML = void 0;
var domhandler_1$7 = lib$a;
var dom_serializer_1 = __importDefault$3(lib$8);
var domelementtype_1 = lib$9;
function getOuterHTML(node2, options2) {
  return (0, dom_serializer_1.default)(node2, options2);
}
stringify$2.getOuterHTML = getOuterHTML;
function getInnerHTML(node2, options2) {
  return (0, domhandler_1$7.hasChildren)(node2) ? node2.children.map(function(node3) {
    return getOuterHTML(node3, options2);
  }).join("") : "";
}
stringify$2.getInnerHTML = getInnerHTML;
function getText(node2) {
  if (Array.isArray(node2))
    return node2.map(getText).join("");
  if ((0, domhandler_1$7.isTag)(node2))
    return node2.name === "br" ? "\n" : getText(node2.children);
  if ((0, domhandler_1$7.isCDATA)(node2))
    return getText(node2.children);
  if ((0, domhandler_1$7.isText)(node2))
    return node2.data;
  return "";
}
stringify$2.getText = getText;
function textContent(node2) {
  if (Array.isArray(node2))
    return node2.map(textContent).join("");
  if ((0, domhandler_1$7.hasChildren)(node2) && !(0, domhandler_1$7.isComment)(node2)) {
    return textContent(node2.children);
  }
  if ((0, domhandler_1$7.isText)(node2))
    return node2.data;
  return "";
}
stringify$2.textContent = textContent;
function innerText(node2) {
  if (Array.isArray(node2))
    return node2.map(innerText).join("");
  if ((0, domhandler_1$7.hasChildren)(node2) && (node2.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$7.isCDATA)(node2))) {
    return innerText(node2.children);
  }
  if ((0, domhandler_1$7.isText)(node2))
    return node2.data;
  return "";
}
stringify$2.innerText = innerText;
var traversal = {};
Object.defineProperty(traversal, "__esModule", {
  value: true
});
traversal.prevElementSibling = traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
var domhandler_1$6 = lib$a;
function getChildren(elem) {
  return (0, domhandler_1$6.hasChildren)(elem) ? elem.children : [];
}
traversal.getChildren = getChildren;
function getParent(elem) {
  return elem.parent || null;
}
traversal.getParent = getParent;
function getSiblings(elem) {
  var _a, _b;
  var parent = getParent(elem);
  if (parent != null)
    return getChildren(parent);
  var siblings = [elem];
  var prev = elem.prev, next = elem.next;
  while (prev != null) {
    siblings.unshift(prev);
    _a = prev, prev = _a.prev;
  }
  while (next != null) {
    siblings.push(next);
    _b = next, next = _b.next;
  }
  return siblings;
}
traversal.getSiblings = getSiblings;
function getAttributeValue(elem, name) {
  var _a;
  return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
traversal.getAttributeValue = getAttributeValue;
function hasAttrib(elem, name) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
traversal.hasAttrib = hasAttrib;
function getName2(elem) {
  return elem.name;
}
traversal.getName = getName2;
function nextElementSibling(elem) {
  var _a;
  var next = elem.next;
  while (next !== null && !(0, domhandler_1$6.isTag)(next))
    _a = next, next = _a.next;
  return next;
}
traversal.nextElementSibling = nextElementSibling;
function prevElementSibling(elem) {
  var _a;
  var prev = elem.prev;
  while (prev !== null && !(0, domhandler_1$6.isTag)(prev))
    _a = prev, prev = _a.prev;
  return prev;
}
traversal.prevElementSibling = prevElementSibling;
var manipulation$1 = {};
Object.defineProperty(manipulation$1, "__esModule", {
  value: true
});
manipulation$1.prepend = manipulation$1.prependChild = manipulation$1.append = manipulation$1.appendChild = manipulation$1.replaceElement = manipulation$1.removeElement = void 0;
function removeElement(elem) {
  if (elem.prev)
    elem.prev.next = elem.next;
  if (elem.next)
    elem.next.prev = elem.prev;
  if (elem.parent) {
    var childs = elem.parent.children;
    var childsIndex = childs.lastIndexOf(elem);
    if (childsIndex >= 0) {
      childs.splice(childsIndex, 1);
    }
  }
  elem.next = null;
  elem.prev = null;
  elem.parent = null;
}
manipulation$1.removeElement = removeElement;
function replaceElement(elem, replacement) {
  var prev = replacement.prev = elem.prev;
  if (prev) {
    prev.next = replacement;
  }
  var next = replacement.next = elem.next;
  if (next) {
    next.prev = replacement;
  }
  var parent = replacement.parent = elem.parent;
  if (parent) {
    var childs = parent.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
manipulation$1.replaceElement = replaceElement;
function appendChild(parent, child) {
  removeElement(child);
  child.next = null;
  child.parent = parent;
  if (parent.children.push(child) > 1) {
    var sibling = parent.children[parent.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
manipulation$1.appendChild = appendChild;
function append(elem, next) {
  removeElement(next);
  var parent = elem.parent;
  var currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent;
  if (currNext) {
    currNext.prev = next;
    if (parent) {
      var childs = parent.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent) {
    parent.children.push(next);
  }
}
manipulation$1.append = append;
function prependChild(parent, child) {
  removeElement(child);
  child.parent = parent;
  child.prev = null;
  if (parent.children.unshift(child) !== 1) {
    var sibling = parent.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
manipulation$1.prependChild = prependChild;
function prepend(elem, prev) {
  removeElement(prev);
  var parent = elem.parent;
  if (parent) {
    var childs = parent.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }
  if (elem.prev) {
    elem.prev.next = prev;
  }
  prev.parent = parent;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
manipulation$1.prepend = prepend;
var querying = {};
Object.defineProperty(querying, "__esModule", {
  value: true
});
querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
var domhandler_1$5 = lib$a;
function filter$2(test2, node2, recurse, limit2) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit2 === void 0) {
    limit2 = Infinity;
  }
  return find$2(test2, Array.isArray(node2) ? node2 : [node2], recurse, limit2);
}
querying.filter = filter$2;
function find$2(test2, nodes, recurse, limit2) {
  var result = [];
  var nodeStack = [nodes];
  var indexStack = [0];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (indexStack.length === 1) {
        return result;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if (test2(elem)) {
      result.push(elem);
      if (--limit2 <= 0)
        return result;
    }
    if (recurse && (0, domhandler_1$5.hasChildren)(elem) && elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
querying.find = find$2;
function findOneChild(test2, nodes) {
  return nodes.find(test2);
}
querying.findOneChild = findOneChild;
function findOne(test2, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  var elem = null;
  for (var i = 0; i < nodes.length && !elem; i++) {
    var node2 = nodes[i];
    if (!(0, domhandler_1$5.isTag)(node2)) {
      continue;
    } else if (test2(node2)) {
      elem = node2;
    } else if (recurse && node2.children.length > 0) {
      elem = findOne(test2, node2.children, true);
    }
  }
  return elem;
}
querying.findOne = findOne;
function existsOne(test2, nodes) {
  return nodes.some(function(checked) {
    return (0, domhandler_1$5.isTag)(checked) && (test2(checked) || existsOne(test2, checked.children));
  });
}
querying.existsOne = existsOne;
function findAll(test2, nodes) {
  var result = [];
  var nodeStack = [nodes];
  var indexStack = [0];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (nodeStack.length === 1) {
        return result;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if (!(0, domhandler_1$5.isTag)(elem))
      continue;
    if (test2(elem))
      result.push(elem);
    if (elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
querying.findAll = findAll;
var legacy = {};
Object.defineProperty(legacy, "__esModule", {
  value: true
});
legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
var domhandler_1$4 = lib$a;
var querying_js_1 = querying;
var Checks = {
  tag_name: function(name) {
    if (typeof name === "function") {
      return function(elem) {
        return (0, domhandler_1$4.isTag)(elem) && name(elem.name);
      };
    } else if (name === "*") {
      return domhandler_1$4.isTag;
    }
    return function(elem) {
      return (0, domhandler_1$4.isTag)(elem) && elem.name === name;
    };
  },
  tag_type: function(type3) {
    if (typeof type3 === "function") {
      return function(elem) {
        return type3(elem.type);
      };
    }
    return function(elem) {
      return elem.type === type3;
    };
  },
  tag_contains: function(data2) {
    if (typeof data2 === "function") {
      return function(elem) {
        return (0, domhandler_1$4.isText)(elem) && data2(elem.data);
      };
    }
    return function(elem) {
      return (0, domhandler_1$4.isText)(elem) && elem.data === data2;
    };
  }
};
function getAttribCheck(attrib, value2) {
  if (typeof value2 === "function") {
    return function(elem) {
      return (0, domhandler_1$4.isTag)(elem) && value2(elem.attribs[attrib]);
    };
  }
  return function(elem) {
    return (0, domhandler_1$4.isTag)(elem) && elem.attribs[attrib] === value2;
  };
}
function combineFuncs(a, b) {
  return function(elem) {
    return a(elem) || b(elem);
  };
}
function compileTest(options2) {
  var funcs = Object.keys(options2).map(function(key) {
    var value2 = options2[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value2) : getAttribCheck(key, value2);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
function testElement(options2, node2) {
  var test2 = compileTest(options2);
  return test2 ? test2(node2) : true;
}
legacy.testElement = testElement;
function getElements(options2, nodes, recurse, limit2) {
  if (limit2 === void 0) {
    limit2 = Infinity;
  }
  var test2 = compileTest(options2);
  return test2 ? (0, querying_js_1.filter)(test2, nodes, recurse, limit2) : [];
}
legacy.getElements = getElements;
function getElementById(id2, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (!Array.isArray(nodes))
    nodes = [nodes];
  return (0, querying_js_1.findOne)(getAttribCheck("id", id2), nodes, recurse);
}
legacy.getElementById = getElementById;
function getElementsByTagName(tagName, nodes, recurse, limit2) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit2 === void 0) {
    limit2 = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit2);
}
legacy.getElementsByTagName = getElementsByTagName;
function getElementsByTagType(type3, nodes, recurse, limit2) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit2 === void 0) {
    limit2 = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_type"](type3), nodes, recurse, limit2);
}
legacy.getElementsByTagType = getElementsByTagType;
var helpers$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.uniqueSort = exports2.compareDocumentPosition = exports2.DocumentPosition = exports2.removeSubsets = void 0;
  var domhandler_12 = lib$a;
  function removeSubsets(nodes) {
    var idx = nodes.length;
    while (--idx >= 0) {
      var node2 = nodes[idx];
      if (idx > 0 && nodes.lastIndexOf(node2, idx - 1) >= 0) {
        nodes.splice(idx, 1);
        continue;
      }
      for (var ancestor = node2.parent; ancestor; ancestor = ancestor.parent) {
        if (nodes.includes(ancestor)) {
          nodes.splice(idx, 1);
          break;
        }
      }
    }
    return nodes;
  }
  exports2.removeSubsets = removeSubsets;
  var DocumentPosition;
  (function(DocumentPosition2) {
    DocumentPosition2[DocumentPosition2["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition2[DocumentPosition2["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition2[DocumentPosition2["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition2[DocumentPosition2["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition2[DocumentPosition2["CONTAINED_BY"] = 16] = "CONTAINED_BY";
  })(DocumentPosition = exports2.DocumentPosition || (exports2.DocumentPosition = {}));
  function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
      return 0;
    }
    var current = (0, domhandler_12.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
      aParents.unshift(current);
      current = current.parent;
    }
    current = (0, domhandler_12.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
      bParents.unshift(current);
      current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
      idx++;
    }
    if (idx === 0) {
      return DocumentPosition.DISCONNECTED;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
      if (sharedParent === nodeB) {
        return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
      }
      return DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) {
      return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
    }
    return DocumentPosition.PRECEDING;
  }
  exports2.compareDocumentPosition = compareDocumentPosition;
  function uniqueSort(nodes) {
    nodes = nodes.filter(function(node2, i, arr) {
      return !arr.includes(node2, i + 1);
    });
    nodes.sort(function(a, b) {
      var relative = compareDocumentPosition(a, b);
      if (relative & DocumentPosition.PRECEDING) {
        return -1;
      } else if (relative & DocumentPosition.FOLLOWING) {
        return 1;
      }
      return 0;
    });
    return nodes;
  }
  exports2.uniqueSort = uniqueSort;
})(helpers$1);
var feeds = {};
Object.defineProperty(feeds, "__esModule", {
  value: true
});
feeds.getFeed = void 0;
var stringify_js_1 = stringify$2;
var legacy_js_1 = legacy;
function getFeed(doc) {
  var feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
feeds.getFeed = getFeed;
function getAtomFeed(feedRoot) {
  var _a;
  var childs = feedRoot.children;
  var feed = {
    type: "atom",
    items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function(item) {
      var _a2;
      var children3 = item.children;
      var entry = {
        media: getMediaElements(children3)
      };
      addConditionally(entry, "id", "id", children3);
      addConditionally(entry, "title", "title", children3);
      var href2 = (_a2 = getOneElement("link", children3)) === null || _a2 === void 0 ? void 0 : _a2.attribs["href"];
      if (href2) {
        entry.link = href2;
      }
      var description2 = fetch$1("summary", children3) || fetch$1("content", children3);
      if (description2) {
        entry.description = description2;
      }
      var pubDate = fetch$1("updated", children3);
      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }
      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
  if (href) {
    feed.link = href;
  }
  addConditionally(feed, "description", "subtitle", childs);
  var updated = fetch$1("updated", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
function getRssFeed(feedRoot) {
  var _a, _b;
  var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
  var feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function(item) {
      var children3 = item.children;
      var entry = {
        media: getMediaElements(children3)
      };
      addConditionally(entry, "id", "guid", children3);
      addConditionally(entry, "title", "title", children3);
      addConditionally(entry, "link", "link", children3);
      addConditionally(entry, "description", "description", children3);
      var pubDate = fetch$1("pubDate", children3) || fetch$1("dc:date", children3);
      if (pubDate)
        entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  var updated = fetch$1("lastBuildDate", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
function getMediaElements(where) {
  return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function(elem) {
    var attribs = elem.attribs;
    var media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };
    for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
      var attrib = MEDIA_KEYS_STRING_1[_i];
      if (attribs[attrib]) {
        media[attrib] = attribs[attrib];
      }
    }
    for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
      var attrib = MEDIA_KEYS_INT_1[_a];
      if (attribs[attrib]) {
        media[attrib] = parseInt(attribs[attrib], 10);
      }
    }
    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }
    return media;
  });
}
function getOneElement(tagName, node2) {
  return (0, legacy_js_1.getElementsByTagName)(tagName, node2, true, 1)[0];
}
function fetch$1(tagName, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
function addConditionally(obj, prop2, tagName, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  var val2 = fetch$1(tagName, where, recurse);
  if (val2)
    obj[prop2] = val2;
}
function isValidFeed(value2) {
  return value2 === "rss" || value2 === "feed" || value2 === "rdf:RDF";
}
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports3) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
        __createBinding2(exports3, m, p);
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.hasChildren = exports2.isDocument = exports2.isComment = exports2.isText = exports2.isCDATA = exports2.isTag = void 0;
  __exportStar(stringify$2, exports2);
  __exportStar(traversal, exports2);
  __exportStar(manipulation$1, exports2);
  __exportStar(querying, exports2);
  __exportStar(legacy, exports2);
  __exportStar(helpers$1, exports2);
  __exportStar(feeds, exports2);
  var domhandler_12 = lib$a;
  Object.defineProperty(exports2, "isTag", {
    enumerable: true,
    get: function() {
      return domhandler_12.isTag;
    }
  });
  Object.defineProperty(exports2, "isCDATA", {
    enumerable: true,
    get: function() {
      return domhandler_12.isCDATA;
    }
  });
  Object.defineProperty(exports2, "isText", {
    enumerable: true,
    get: function() {
      return domhandler_12.isText;
    }
  });
  Object.defineProperty(exports2, "isComment", {
    enumerable: true,
    get: function() {
      return domhandler_12.isComment;
    }
  });
  Object.defineProperty(exports2, "isDocument", {
    enumerable: true,
    get: function() {
      return domhandler_12.isDocument;
    }
  });
  Object.defineProperty(exports2, "hasChildren", {
    enumerable: true,
    get: function() {
      return domhandler_12.hasChildren;
    }
  });
})(lib$b);
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$1 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$5(result, mod2, k);
  }
  __setModuleDefault$5(result, mod2);
  return result;
};
Object.defineProperty(_static, "__esModule", {
  value: true
});
_static.merge = _static.contains = _static.root = _static.parseHTML = _static.text = _static.xml = _static.html = void 0;
var domutils_1$4 = lib$b;
var options_js_1$1 = __importStar$5(options);
function render$2(that, dom, options2) {
  if (!that)
    return "";
  return that(dom !== null && dom !== void 0 ? dom : that._root.children, null, void 0, options2).toString();
}
function isOptions(dom, options2) {
  return !options2 && typeof dom === "object" && dom != null && !("length" in dom) && !("type" in dom);
}
function html$4(dom, options2) {
  var toRender = isOptions(dom) ? (options2 = dom, void 0) : dom;
  var opts = __assign$1(__assign$1(__assign$1({}, options_js_1$1.default), this === null || this === void 0 ? void 0 : this._options), (0, options_js_1$1.flatten)(options2 !== null && options2 !== void 0 ? options2 : {}));
  return render$2(this, toRender, opts);
}
_static.html = html$4;
function xml$1(dom) {
  var options2 = __assign$1(__assign$1({}, this._options), {
    xmlMode: true
  });
  return render$2(this, dom, options2);
}
_static.xml = xml$1;
function text$2(elements) {
  var elems = elements ? elements : this ? this.root() : [];
  var ret = "";
  for (var i = 0; i < elems.length; i++) {
    ret += (0, domutils_1$4.textContent)(elems[i]);
  }
  return ret;
}
_static.text = text$2;
function parseHTML(data2, context, keepScripts) {
  if (keepScripts === void 0) {
    keepScripts = typeof context === "boolean" ? context : false;
  }
  if (!data2 || typeof data2 !== "string") {
    return null;
  }
  if (typeof context === "boolean") {
    keepScripts = context;
  }
  var parsed = this.load(data2, options_js_1$1.default, false);
  if (!keepScripts) {
    parsed("script").remove();
  }
  return parsed.root()[0].children.slice();
}
_static.parseHTML = parseHTML;
function root$5() {
  return this(this._root);
}
_static.root = root$5;
function contains$2(container, contained) {
  if (contained === container) {
    return false;
  }
  var next = contained;
  while (next && next !== next.parent) {
    next = next.parent;
    if (next === container) {
      return true;
    }
  }
  return false;
}
_static.contains = contains$2;
function merge$3(arr1, arr2) {
  if (!isArrayLike$2(arr1) || !isArrayLike$2(arr2)) {
    return;
  }
  var newLength = arr1.length;
  var len = +arr2.length;
  for (var i = 0; i < len; i++) {
    arr1[newLength++] = arr2[i];
  }
  arr1.length = newLength;
  return arr1;
}
_static.merge = merge$3;
function isArrayLike$2(item) {
  if (Array.isArray(item)) {
    return true;
  }
  if (typeof item !== "object" || !Object.prototype.hasOwnProperty.call(item, "length") || typeof item.length !== "number" || item.length < 0) {
    return false;
  }
  for (var i = 0; i < item.length; i++) {
    if (!(i in item)) {
      return false;
    }
  }
  return true;
}
var cheerio = {};
var attributes$2 = {};
var utils$8 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.isHtml = exports2.cloneDom = exports2.domEach = exports2.cssCase = exports2.camelCase = exports2.isCheerio = exports2.isTag = void 0;
  var domhandler_12 = lib$a;
  var domhandler_2 = lib$a;
  Object.defineProperty(exports2, "isTag", {
    enumerable: true,
    get: function() {
      return domhandler_2.isTag;
    }
  });
  function isCheerio(maybeCheerio) {
    return maybeCheerio.cheerio != null;
  }
  exports2.isCheerio = isCheerio;
  function camelCase(str) {
    return str.replace(/[_.-](\w|$)/g, function(_, x) {
      return x.toUpperCase();
    });
  }
  exports2.camelCase = camelCase;
  function cssCase(str) {
    return str.replace(/[A-Z]/g, "-$&").toLowerCase();
  }
  exports2.cssCase = cssCase;
  function domEach(array2, fn) {
    var len = array2.length;
    for (var i = 0; i < len; i++)
      fn(array2[i], i);
    return array2;
  }
  exports2.domEach = domEach;
  function cloneDom(dom) {
    var clone4 = "length" in dom ? Array.prototype.map.call(dom, function(el) {
      return (0, domhandler_12.cloneNode)(el, true);
    }) : [(0, domhandler_12.cloneNode)(dom, true)];
    var root2 = new domhandler_12.Document(clone4);
    clone4.forEach(function(node2) {
      node2.parent = root2;
    });
    return clone4;
  }
  exports2.cloneDom = cloneDom;
  var CharacterCodes;
  (function(CharacterCodes2) {
    CharacterCodes2[CharacterCodes2["LowerA"] = 97] = "LowerA";
    CharacterCodes2[CharacterCodes2["LowerZ"] = 122] = "LowerZ";
    CharacterCodes2[CharacterCodes2["UpperA"] = 65] = "UpperA";
    CharacterCodes2[CharacterCodes2["UpperZ"] = 90] = "UpperZ";
    CharacterCodes2[CharacterCodes2["Exclamation"] = 33] = "Exclamation";
  })(CharacterCodes || (CharacterCodes = {}));
  function isHtml(str) {
    var tagStart = str.indexOf("<");
    if (tagStart < 0 || tagStart > str.length - 3)
      return false;
    var tagChar = str.charCodeAt(tagStart + 1);
    return (tagChar >= CharacterCodes.LowerA && tagChar <= CharacterCodes.LowerZ || tagChar >= CharacterCodes.UpperA && tagChar <= CharacterCodes.UpperZ || tagChar === CharacterCodes.Exclamation) && str.includes(">", tagStart + 2);
  }
  exports2.isHtml = isHtml;
})(utils$8);
Object.defineProperty(attributes$2, "__esModule", {
  value: true
});
attributes$2.toggleClass = attributes$2.removeClass = attributes$2.addClass = attributes$2.hasClass = attributes$2.removeAttr = attributes$2.val = attributes$2.data = attributes$2.prop = attributes$2.attr = void 0;
var static_js_1$2 = _static;
var utils_js_1$5 = utils$8;
var domutils_1$3 = lib$b;
var hasOwn = Object.prototype.hasOwnProperty;
var rspace = /\s+/;
var dataAttrPrefix = "data-";
var primitives = {
  null: null,
  true: true,
  false: false
};
var rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i;
var rbrace = /^{[^]*}$|^\[[^]*]$/;
function getAttr(elem, name, xmlMode) {
  var _a;
  if (!elem || !(0, utils_js_1$5.isTag)(elem))
    return void 0;
  (_a = elem.attribs) !== null && _a !== void 0 ? _a : elem.attribs = {};
  if (!name) {
    return elem.attribs;
  }
  if (hasOwn.call(elem.attribs, name)) {
    return !xmlMode && rboolean.test(name) ? name : elem.attribs[name];
  }
  if (elem.name === "option" && name === "value") {
    return (0, static_js_1$2.text)(elem.children);
  }
  if (elem.name === "input" && (elem.attribs["type"] === "radio" || elem.attribs["type"] === "checkbox") && name === "value") {
    return "on";
  }
  return void 0;
}
function setAttr(el, name, value2) {
  if (value2 === null) {
    removeAttribute(el, name);
  } else {
    el.attribs[name] = "".concat(value2);
  }
}
function attr(name, value2) {
  if (typeof name === "object" || value2 !== void 0) {
    if (typeof value2 === "function") {
      if (typeof name !== "string") {
        {
          throw new Error("Bad combination of arguments.");
        }
      }
      return (0, utils_js_1$5.domEach)(this, function(el, i) {
        if ((0, utils_js_1$5.isTag)(el))
          setAttr(el, name, value2.call(el, i, el.attribs[name]));
      });
    }
    return (0, utils_js_1$5.domEach)(this, function(el) {
      if (!(0, utils_js_1$5.isTag)(el))
        return;
      if (typeof name === "object") {
        Object.keys(name).forEach(function(objName) {
          var objValue = name[objName];
          setAttr(el, objName, objValue);
        });
      } else {
        setAttr(el, name, value2);
      }
    });
  }
  return arguments.length > 1 ? this : getAttr(this[0], name, this.options.xmlMode);
}
attributes$2.attr = attr;
function getProp(el, name, xmlMode) {
  return name in el ? (
    // @ts-expect-error TS doesn't like us accessing the value directly here.
    el[name]
  ) : !xmlMode && rboolean.test(name) ? getAttr(el, name, false) !== void 0 : getAttr(el, name, xmlMode);
}
function setProp(el, name, value2, xmlMode) {
  if (name in el) {
    el[name] = value2;
  } else {
    setAttr(el, name, !xmlMode && rboolean.test(name) ? value2 ? "" : null : "".concat(value2));
  }
}
function prop(name, value2) {
  var _this = this;
  var _a;
  if (typeof name === "string" && value2 === void 0) {
    var el = this[0];
    if (!el || !(0, utils_js_1$5.isTag)(el))
      return void 0;
    switch (name) {
      case "style": {
        var property_1 = this.css();
        var keys3 = Object.keys(property_1);
        keys3.forEach(function(p, i) {
          property_1[i] = p;
        });
        property_1.length = keys3.length;
        return property_1;
      }
      case "tagName":
      case "nodeName": {
        return el.name.toUpperCase();
      }
      case "href":
      case "src": {
        var prop_1 = (_a = el.attribs) === null || _a === void 0 ? void 0 : _a[name];
        if (typeof URL !== "undefined" && (name === "href" && (el.tagName === "a" || el.name === "link") || name === "src" && (el.tagName === "img" || el.tagName === "iframe" || el.tagName === "audio" || el.tagName === "video" || el.tagName === "source")) && prop_1 !== void 0 && this.options.baseURI) {
          return new URL(prop_1, this.options.baseURI).href;
        }
        return prop_1;
      }
      case "innerText": {
        return (0, domutils_1$3.innerText)(el);
      }
      case "textContent": {
        return (0, domutils_1$3.textContent)(el);
      }
      case "outerHTML":
        return this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return getProp(el, name, this.options.xmlMode);
    }
  }
  if (typeof name === "object" || value2 !== void 0) {
    if (typeof value2 === "function") {
      if (typeof name === "object") {
        throw new Error("Bad combination of arguments.");
      }
      return (0, utils_js_1$5.domEach)(this, function(el2, i) {
        if ((0, utils_js_1$5.isTag)(el2)) {
          setProp(el2, name, value2.call(el2, i, getProp(el2, name, _this.options.xmlMode)), _this.options.xmlMode);
        }
      });
    }
    return (0, utils_js_1$5.domEach)(this, function(el2) {
      if (!(0, utils_js_1$5.isTag)(el2))
        return;
      if (typeof name === "object") {
        Object.keys(name).forEach(function(key) {
          var val2 = name[key];
          setProp(el2, key, val2, _this.options.xmlMode);
        });
      } else {
        setProp(el2, name, value2, _this.options.xmlMode);
      }
    });
  }
  return void 0;
}
attributes$2.prop = prop;
function setData(el, name, value2) {
  var _a;
  var elem = el;
  (_a = elem.data) !== null && _a !== void 0 ? _a : elem.data = {};
  if (typeof name === "object")
    Object.assign(elem.data, name);
  else if (typeof name === "string" && value2 !== void 0) {
    elem.data[name] = value2;
  }
}
function readData(el, name) {
  var domNames;
  var jsNames;
  var value2;
  if (name == null) {
    domNames = Object.keys(el.attribs).filter(function(attrName) {
      return attrName.startsWith(dataAttrPrefix);
    });
    jsNames = domNames.map(function(domName2) {
      return (0, utils_js_1$5.camelCase)(domName2.slice(dataAttrPrefix.length));
    });
  } else {
    domNames = [dataAttrPrefix + (0, utils_js_1$5.cssCase)(name)];
    jsNames = [name];
  }
  for (var idx = 0; idx < domNames.length; ++idx) {
    var domName = domNames[idx];
    var jsName = jsNames[idx];
    if (hasOwn.call(el.attribs, domName) && !hasOwn.call(el.data, jsName)) {
      value2 = el.attribs[domName];
      if (hasOwn.call(primitives, value2)) {
        value2 = primitives[value2];
      } else if (value2 === String(Number(value2))) {
        value2 = Number(value2);
      } else if (rbrace.test(value2)) {
        try {
          value2 = JSON.parse(value2);
        } catch (e) {
        }
      }
      el.data[jsName] = value2;
    }
  }
  return name == null ? el.data : value2;
}
function data$1(name, value2) {
  var _a;
  var elem = this[0];
  if (!elem || !(0, utils_js_1$5.isTag)(elem))
    return;
  var dataEl = elem;
  (_a = dataEl.data) !== null && _a !== void 0 ? _a : dataEl.data = {};
  if (!name) {
    return readData(dataEl);
  }
  if (typeof name === "object" || value2 !== void 0) {
    (0, utils_js_1$5.domEach)(this, function(el) {
      if ((0, utils_js_1$5.isTag)(el)) {
        if (typeof name === "object")
          setData(el, name);
        else
          setData(el, name, value2);
      }
    });
    return this;
  }
  if (hasOwn.call(dataEl.data, name)) {
    return dataEl.data[name];
  }
  return readData(dataEl, name);
}
attributes$2.data = data$1;
function val(value2) {
  var querying2 = arguments.length === 0;
  var element = this[0];
  if (!element || !(0, utils_js_1$5.isTag)(element))
    return querying2 ? void 0 : this;
  switch (element.name) {
    case "textarea":
      return this.text(value2);
    case "select": {
      var option = this.find("option:selected");
      if (!querying2) {
        if (this.attr("multiple") == null && typeof value2 === "object") {
          return this;
        }
        this.find("option").removeAttr("selected");
        var values2 = typeof value2 !== "object" ? [value2] : value2;
        for (var i = 0; i < values2.length; i++) {
          this.find('option[value="'.concat(values2[i], '"]')).attr("selected", "");
        }
        return this;
      }
      return this.attr("multiple") ? option.toArray().map(function(el) {
        return (0, static_js_1$2.text)(el.children);
      }) : option.attr("value");
    }
    case "input":
    case "option":
      return querying2 ? this.attr("value") : this.attr("value", value2);
  }
  return void 0;
}
attributes$2.val = val;
function removeAttribute(elem, name) {
  if (!elem.attribs || !hasOwn.call(elem.attribs, name))
    return;
  delete elem.attribs[name];
}
function splitNames(names2) {
  return names2 ? names2.trim().split(rspace) : [];
}
function removeAttr(name) {
  var attrNames = splitNames(name);
  var _loop_1 = function(i2) {
    (0, utils_js_1$5.domEach)(this_1, function(elem) {
      if ((0, utils_js_1$5.isTag)(elem))
        removeAttribute(elem, attrNames[i2]);
    });
  };
  var this_1 = this;
  for (var i = 0; i < attrNames.length; i++) {
    _loop_1(i);
  }
  return this;
}
attributes$2.removeAttr = removeAttr;
function hasClass(className2) {
  return this.toArray().some(function(elem) {
    var clazz = (0, utils_js_1$5.isTag)(elem) && elem.attribs["class"];
    var idx = -1;
    if (clazz && className2.length) {
      while ((idx = clazz.indexOf(className2, idx + 1)) > -1) {
        var end2 = idx + className2.length;
        if ((idx === 0 || rspace.test(clazz[idx - 1])) && (end2 === clazz.length || rspace.test(clazz[end2]))) {
          return true;
        }
      }
    }
    return false;
  });
}
attributes$2.hasClass = hasClass;
function addClass(value2) {
  if (typeof value2 === "function") {
    return (0, utils_js_1$5.domEach)(this, function(el2, i2) {
      if ((0, utils_js_1$5.isTag)(el2)) {
        var className3 = el2.attribs["class"] || "";
        addClass.call([el2], value2.call(el2, i2, className3));
      }
    });
  }
  if (!value2 || typeof value2 !== "string")
    return this;
  var classNames = value2.split(rspace);
  var numElements = this.length;
  for (var i = 0; i < numElements; i++) {
    var el = this[i];
    if (!(0, utils_js_1$5.isTag)(el))
      continue;
    var className2 = getAttr(el, "class", false);
    if (!className2) {
      setAttr(el, "class", classNames.join(" ").trim());
    } else {
      var setClass = " ".concat(className2, " ");
      for (var j = 0; j < classNames.length; j++) {
        var appendClass = "".concat(classNames[j], " ");
        if (!setClass.includes(" ".concat(appendClass)))
          setClass += appendClass;
      }
      setAttr(el, "class", setClass.trim());
    }
  }
  return this;
}
attributes$2.addClass = addClass;
function removeClass(name) {
  if (typeof name === "function") {
    return (0, utils_js_1$5.domEach)(this, function(el, i) {
      if ((0, utils_js_1$5.isTag)(el)) {
        removeClass.call([el], name.call(el, i, el.attribs["class"] || ""));
      }
    });
  }
  var classes2 = splitNames(name);
  var numClasses = classes2.length;
  var removeAll2 = arguments.length === 0;
  return (0, utils_js_1$5.domEach)(this, function(el) {
    if (!(0, utils_js_1$5.isTag)(el))
      return;
    if (removeAll2) {
      el.attribs["class"] = "";
    } else {
      var elClasses = splitNames(el.attribs["class"]);
      var changed = false;
      for (var j = 0; j < numClasses; j++) {
        var index2 = elClasses.indexOf(classes2[j]);
        if (index2 >= 0) {
          elClasses.splice(index2, 1);
          changed = true;
          j--;
        }
      }
      if (changed) {
        el.attribs["class"] = elClasses.join(" ");
      }
    }
  });
}
attributes$2.removeClass = removeClass;
function toggleClass(value2, stateVal) {
  if (typeof value2 === "function") {
    return (0, utils_js_1$5.domEach)(this, function(el2, i2) {
      if ((0, utils_js_1$5.isTag)(el2)) {
        toggleClass.call([el2], value2.call(el2, i2, el2.attribs["class"] || "", stateVal), stateVal);
      }
    });
  }
  if (!value2 || typeof value2 !== "string")
    return this;
  var classNames = value2.split(rspace);
  var numClasses = classNames.length;
  var state = typeof stateVal === "boolean" ? stateVal ? 1 : -1 : 0;
  var numElements = this.length;
  for (var i = 0; i < numElements; i++) {
    var el = this[i];
    if (!(0, utils_js_1$5.isTag)(el))
      continue;
    var elementClasses = splitNames(el.attribs["class"]);
    for (var j = 0; j < numClasses; j++) {
      var index2 = elementClasses.indexOf(classNames[j]);
      if (state >= 0 && index2 < 0) {
        elementClasses.push(classNames[j]);
      } else if (state <= 0 && index2 >= 0) {
        elementClasses.splice(index2, 1);
      }
    }
    el.attribs["class"] = elementClasses.join(" ");
  }
  return this;
}
attributes$2.toggleClass = toggleClass;
var traversing = {};
var lib$6 = {};
var SelectorType;
(function(SelectorType2) {
  SelectorType2["Attribute"] = "attribute";
  SelectorType2["Pseudo"] = "pseudo";
  SelectorType2["PseudoElement"] = "pseudo-element";
  SelectorType2["Tag"] = "tag";
  SelectorType2["Universal"] = "universal";
  SelectorType2["Adjacent"] = "adjacent";
  SelectorType2["Child"] = "child";
  SelectorType2["Descendant"] = "descendant";
  SelectorType2["Parent"] = "parent";
  SelectorType2["Sibling"] = "sibling";
  SelectorType2["ColumnCombinator"] = "column-combinator";
})(SelectorType || (SelectorType = {}));
const IgnoreCaseMode = {
  Unknown: null,
  QuirksMode: "quirks",
  IgnoreCase: true,
  CaseSensitive: false
};
var AttributeAction;
(function(AttributeAction2) {
  AttributeAction2["Any"] = "any";
  AttributeAction2["Element"] = "element";
  AttributeAction2["End"] = "end";
  AttributeAction2["Equals"] = "equals";
  AttributeAction2["Exists"] = "exists";
  AttributeAction2["Hyphen"] = "hyphen";
  AttributeAction2["Not"] = "not";
  AttributeAction2["Start"] = "start";
})(AttributeAction || (AttributeAction = {}));
const reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const actionTypes = /* @__PURE__ */ new Map([[126, AttributeAction.Element], [94, AttributeAction.Start], [36, AttributeAction.End], [42, AttributeAction.Any], [33, AttributeAction.Not], [124, AttributeAction.Hyphen]]);
const unpackPseudos = /* @__PURE__ */ new Set(["has", "not", "matches", "is", "where", "host", "host-context"]);
function isTraversal$1(selector2) {
  switch (selector2.type) {
    case SelectorType.Adjacent:
    case SelectorType.Child:
    case SelectorType.Descendant:
    case SelectorType.Parent:
    case SelectorType.Sibling:
    case SelectorType.ColumnCombinator:
      return true;
    default:
      return false;
  }
}
const stripQuotesFromPseudos = /* @__PURE__ */ new Set(["contains", "icontains"]);
function funescape(_, escaped, escapedWhitespace) {
  const high = parseInt(escaped, 16) - 65536;
  return high !== high || escapedWhitespace ? escaped : high < 0 ? (
    // BMP codepoint
    String.fromCharCode(high + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320)
  );
}
function unescapeCSS(str) {
  return str.replace(reEscape, funescape);
}
function isQuote(c2) {
  return c2 === 39 || c2 === 34;
}
function isWhitespace$2(c2) {
  return c2 === 32 || c2 === 9 || c2 === 10 || c2 === 12 || c2 === 13;
}
function parse$4(selector2) {
  const subselects2 = [];
  const endIndex = parseSelector(subselects2, `${selector2}`, 0);
  if (endIndex < selector2.length) {
    throw new Error(`Unmatched selector: ${selector2.slice(endIndex)}`);
  }
  return subselects2;
}
function parseSelector(subselects2, selector2, selectorIndex) {
  let tokens = [];
  function getName3(offset2) {
    const match = selector2.slice(selectorIndex + offset2).match(reName);
    if (!match) {
      throw new Error(`Expected name, found ${selector2.slice(selectorIndex)}`);
    }
    const [name] = match;
    selectorIndex += offset2 + name.length;
    return unescapeCSS(name);
  }
  function stripWhitespace(offset2) {
    selectorIndex += offset2;
    while (selectorIndex < selector2.length && isWhitespace$2(selector2.charCodeAt(selectorIndex))) {
      selectorIndex++;
    }
  }
  function readValueWithParenthesis() {
    selectorIndex += 1;
    const start2 = selectorIndex;
    let counter = 1;
    for (; counter > 0 && selectorIndex < selector2.length; selectorIndex++) {
      if (selector2.charCodeAt(selectorIndex) === 40 && !isEscaped(selectorIndex)) {
        counter++;
      } else if (selector2.charCodeAt(selectorIndex) === 41 && !isEscaped(selectorIndex)) {
        counter--;
      }
    }
    if (counter) {
      throw new Error("Parenthesis not matched");
    }
    return unescapeCSS(selector2.slice(start2, selectorIndex - 1));
  }
  function isEscaped(pos) {
    let slashCount = 0;
    while (selector2.charCodeAt(--pos) === 92)
      slashCount++;
    return (slashCount & 1) === 1;
  }
  function ensureNotTraversal() {
    if (tokens.length > 0 && isTraversal$1(tokens[tokens.length - 1])) {
      throw new Error("Did not expect successive traversals.");
    }
  }
  function addTraversal(type3) {
    if (tokens.length > 0 && tokens[tokens.length - 1].type === SelectorType.Descendant) {
      tokens[tokens.length - 1].type = type3;
      return;
    }
    ensureNotTraversal();
    tokens.push({
      type: type3
    });
  }
  function addSpecialAttribute(name, action) {
    tokens.push({
      type: SelectorType.Attribute,
      name,
      action,
      value: getName3(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function finalizeSubselector() {
    if (tokens.length && tokens[tokens.length - 1].type === SelectorType.Descendant) {
      tokens.pop();
    }
    if (tokens.length === 0) {
      throw new Error("Empty sub-selector");
    }
    subselects2.push(tokens);
  }
  stripWhitespace(0);
  if (selector2.length === selectorIndex) {
    return selectorIndex;
  }
  loop:
    while (selectorIndex < selector2.length) {
      const firstChar = selector2.charCodeAt(selectorIndex);
      switch (firstChar) {
        case 32:
        case 9:
        case 10:
        case 12:
        case 13: {
          if (tokens.length === 0 || tokens[0].type !== SelectorType.Descendant) {
            ensureNotTraversal();
            tokens.push({
              type: SelectorType.Descendant
            });
          }
          stripWhitespace(1);
          break;
        }
        case 62: {
          addTraversal(SelectorType.Child);
          stripWhitespace(1);
          break;
        }
        case 60: {
          addTraversal(SelectorType.Parent);
          stripWhitespace(1);
          break;
        }
        case 126: {
          addTraversal(SelectorType.Sibling);
          stripWhitespace(1);
          break;
        }
        case 43: {
          addTraversal(SelectorType.Adjacent);
          stripWhitespace(1);
          break;
        }
        case 46: {
          addSpecialAttribute("class", AttributeAction.Element);
          break;
        }
        case 35: {
          addSpecialAttribute("id", AttributeAction.Equals);
          break;
        }
        case 91: {
          stripWhitespace(1);
          let name;
          let namespace2 = null;
          if (selector2.charCodeAt(selectorIndex) === 124) {
            name = getName3(1);
          } else if (selector2.startsWith("*|", selectorIndex)) {
            namespace2 = "*";
            name = getName3(2);
          } else {
            name = getName3(0);
            if (selector2.charCodeAt(selectorIndex) === 124 && selector2.charCodeAt(selectorIndex + 1) !== 61) {
              namespace2 = name;
              name = getName3(1);
            }
          }
          stripWhitespace(0);
          let action = AttributeAction.Exists;
          const possibleAction = actionTypes.get(selector2.charCodeAt(selectorIndex));
          if (possibleAction) {
            action = possibleAction;
            if (selector2.charCodeAt(selectorIndex + 1) !== 61) {
              throw new Error("Expected `=`");
            }
            stripWhitespace(2);
          } else if (selector2.charCodeAt(selectorIndex) === 61) {
            action = AttributeAction.Equals;
            stripWhitespace(1);
          }
          let value2 = "";
          let ignoreCase = null;
          if (action !== "exists") {
            if (isQuote(selector2.charCodeAt(selectorIndex))) {
              const quote2 = selector2.charCodeAt(selectorIndex);
              let sectionEnd = selectorIndex + 1;
              while (sectionEnd < selector2.length && (selector2.charCodeAt(sectionEnd) !== quote2 || isEscaped(sectionEnd))) {
                sectionEnd += 1;
              }
              if (selector2.charCodeAt(sectionEnd) !== quote2) {
                throw new Error("Attribute value didn't end");
              }
              value2 = unescapeCSS(selector2.slice(selectorIndex + 1, sectionEnd));
              selectorIndex = sectionEnd + 1;
            } else {
              const valueStart = selectorIndex;
              while (selectorIndex < selector2.length && (!isWhitespace$2(selector2.charCodeAt(selectorIndex)) && selector2.charCodeAt(selectorIndex) !== 93 || isEscaped(selectorIndex))) {
                selectorIndex += 1;
              }
              value2 = unescapeCSS(selector2.slice(valueStart, selectorIndex));
            }
            stripWhitespace(0);
            const forceIgnore = selector2.charCodeAt(selectorIndex) | 32;
            if (forceIgnore === 115) {
              ignoreCase = false;
              stripWhitespace(1);
            } else if (forceIgnore === 105) {
              ignoreCase = true;
              stripWhitespace(1);
            }
          }
          if (selector2.charCodeAt(selectorIndex) !== 93) {
            throw new Error("Attribute selector didn't terminate");
          }
          selectorIndex += 1;
          const attributeSelector = {
            type: SelectorType.Attribute,
            name,
            action,
            value: value2,
            namespace: namespace2,
            ignoreCase
          };
          tokens.push(attributeSelector);
          break;
        }
        case 58: {
          if (selector2.charCodeAt(selectorIndex + 1) === 58) {
            tokens.push({
              type: SelectorType.PseudoElement,
              name: getName3(2).toLowerCase(),
              data: selector2.charCodeAt(selectorIndex) === 40 ? readValueWithParenthesis() : null
            });
            continue;
          }
          const name = getName3(1).toLowerCase();
          let data2 = null;
          if (selector2.charCodeAt(selectorIndex) === 40) {
            if (unpackPseudos.has(name)) {
              if (isQuote(selector2.charCodeAt(selectorIndex + 1))) {
                throw new Error(`Pseudo-selector ${name} cannot be quoted`);
              }
              data2 = [];
              selectorIndex = parseSelector(data2, selector2, selectorIndex + 1);
              if (selector2.charCodeAt(selectorIndex) !== 41) {
                throw new Error(`Missing closing parenthesis in :${name} (${selector2})`);
              }
              selectorIndex += 1;
            } else {
              data2 = readValueWithParenthesis();
              if (stripQuotesFromPseudos.has(name)) {
                const quot = data2.charCodeAt(0);
                if (quot === data2.charCodeAt(data2.length - 1) && isQuote(quot)) {
                  data2 = data2.slice(1, -1);
                }
              }
              data2 = unescapeCSS(data2);
            }
          }
          tokens.push({
            type: SelectorType.Pseudo,
            name,
            data: data2
          });
          break;
        }
        case 44: {
          finalizeSubselector();
          tokens = [];
          stripWhitespace(1);
          break;
        }
        default: {
          if (selector2.startsWith("/*", selectorIndex)) {
            const endIndex = selector2.indexOf("*/", selectorIndex + 2);
            if (endIndex < 0) {
              throw new Error("Comment was not terminated");
            }
            selectorIndex = endIndex + 2;
            if (tokens.length === 0) {
              stripWhitespace(0);
            }
            break;
          }
          let namespace2 = null;
          let name;
          if (firstChar === 42) {
            selectorIndex += 1;
            name = "*";
          } else if (firstChar === 124) {
            name = "";
            if (selector2.charCodeAt(selectorIndex + 1) === 124) {
              addTraversal(SelectorType.ColumnCombinator);
              stripWhitespace(2);
              break;
            }
          } else if (reName.test(selector2.slice(selectorIndex))) {
            name = getName3(0);
          } else {
            break loop;
          }
          if (selector2.charCodeAt(selectorIndex) === 124 && selector2.charCodeAt(selectorIndex + 1) !== 124) {
            namespace2 = name;
            if (selector2.charCodeAt(selectorIndex + 1) === 42) {
              name = "*";
              selectorIndex += 2;
            } else {
              name = getName3(1);
            }
          }
          tokens.push(name === "*" ? {
            type: SelectorType.Universal,
            namespace: namespace2
          } : {
            type: SelectorType.Tag,
            name,
            namespace: namespace2
          });
        }
      }
    }
  finalizeSubselector();
  return selectorIndex;
}
const attribValChars = ["\\", '"'];
const pseudoValChars = [...attribValChars, "(", ")"];
const charsToEscapeInAttributeValue = new Set(attribValChars.map((c2) => c2.charCodeAt(0)));
const charsToEscapeInPseudoValue = new Set(pseudoValChars.map((c2) => c2.charCodeAt(0)));
const charsToEscapeInName = new Set([...pseudoValChars, "~", "^", "$", "*", "+", "!", "|", ":", "[", "]", " ", "."].map((c2) => c2.charCodeAt(0)));
function stringify$1(selector2) {
  return selector2.map((token2) => token2.map(stringifyToken).join("")).join(", ");
}
function stringifyToken(token2, index2, arr) {
  switch (token2.type) {
    case SelectorType.Child:
      return index2 === 0 ? "> " : " > ";
    case SelectorType.Parent:
      return index2 === 0 ? "< " : " < ";
    case SelectorType.Sibling:
      return index2 === 0 ? "~ " : " ~ ";
    case SelectorType.Adjacent:
      return index2 === 0 ? "+ " : " + ";
    case SelectorType.Descendant:
      return " ";
    case SelectorType.ColumnCombinator:
      return index2 === 0 ? "|| " : " || ";
    case SelectorType.Universal:
      return token2.namespace === "*" && index2 + 1 < arr.length && "name" in arr[index2 + 1] ? "" : `${getNamespace(token2.namespace)}*`;
    case SelectorType.Tag:
      return getNamespacedName(token2);
    case SelectorType.PseudoElement:
      return `::${escapeName(token2.name, charsToEscapeInName)}${token2.data === null ? "" : `(${escapeName(token2.data, charsToEscapeInPseudoValue)})`}`;
    case SelectorType.Pseudo:
      return `:${escapeName(token2.name, charsToEscapeInName)}${token2.data === null ? "" : `(${typeof token2.data === "string" ? escapeName(token2.data, charsToEscapeInPseudoValue) : stringify$1(token2.data)})`}`;
    case SelectorType.Attribute: {
      if (token2.name === "id" && token2.action === AttributeAction.Equals && token2.ignoreCase === "quirks" && !token2.namespace) {
        return `#${escapeName(token2.value, charsToEscapeInName)}`;
      }
      if (token2.name === "class" && token2.action === AttributeAction.Element && token2.ignoreCase === "quirks" && !token2.namespace) {
        return `.${escapeName(token2.value, charsToEscapeInName)}`;
      }
      const name = getNamespacedName(token2);
      if (token2.action === AttributeAction.Exists) {
        return `[${name}]`;
      }
      return `[${name}${getActionValue(token2.action)}="${escapeName(token2.value, charsToEscapeInAttributeValue)}"${token2.ignoreCase === null ? "" : token2.ignoreCase ? " i" : " s"}]`;
    }
  }
}
function getActionValue(action) {
  switch (action) {
    case AttributeAction.Equals:
      return "";
    case AttributeAction.Element:
      return "~";
    case AttributeAction.Start:
      return "^";
    case AttributeAction.End:
      return "$";
    case AttributeAction.Any:
      return "*";
    case AttributeAction.Not:
      return "!";
    case AttributeAction.Hyphen:
      return "|";
    case AttributeAction.Exists:
      throw new Error("Shouldn't be here");
  }
}
function getNamespacedName(token2) {
  return `${getNamespace(token2.namespace)}${escapeName(token2.name, charsToEscapeInName)}`;
}
function getNamespace(namespace2) {
  return namespace2 !== null ? `${namespace2 === "*" ? "*" : escapeName(namespace2, charsToEscapeInName)}|` : "";
}
function escapeName(str, charsToEscape) {
  let lastIdx = 0;
  let ret = "";
  for (let i = 0; i < str.length; i++) {
    if (charsToEscape.has(str.charCodeAt(i))) {
      ret += `${str.slice(lastIdx, i)}\\${str.charAt(i)}`;
      lastIdx = i + 1;
    }
  }
  return ret.length > 0 ? ret + str.slice(lastIdx) : str;
}
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AttributeAction() {
    return AttributeAction;
  },
  IgnoreCaseMode,
  get SelectorType() {
    return SelectorType;
  },
  isTraversal: isTraversal$1,
  parse: parse$4,
  stringify: stringify$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(es);
var lib$5 = {};
var boolbase = {
  trueFunc: function trueFunc() {
    return true;
  },
  falseFunc: function falseFunc() {
    return false;
  }
};
var compile$5 = {};
var sort$1 = {};
Object.defineProperty(sort$1, "__esModule", {
  value: true
});
sort$1.isTraversal = void 0;
var css_what_1$2 = require$$0$2;
var procedure = /* @__PURE__ */ new Map([[css_what_1$2.SelectorType.Universal, 50], [css_what_1$2.SelectorType.Tag, 30], [css_what_1$2.SelectorType.Attribute, 1], [css_what_1$2.SelectorType.Pseudo, 0]]);
function isTraversal(token2) {
  return !procedure.has(token2.type);
}
sort$1.isTraversal = isTraversal;
var attributes$1 = /* @__PURE__ */ new Map([[css_what_1$2.AttributeAction.Exists, 10], [css_what_1$2.AttributeAction.Equals, 8], [css_what_1$2.AttributeAction.Not, 7], [css_what_1$2.AttributeAction.Start, 6], [css_what_1$2.AttributeAction.End, 6], [css_what_1$2.AttributeAction.Any, 5]]);
function sortByProcedure(arr) {
  var procs = arr.map(getProcedure);
  for (var i = 1; i < arr.length; i++) {
    var procNew = procs[i];
    if (procNew < 0)
      continue;
    for (var j = i - 1; j >= 0 && procNew < procs[j]; j--) {
      var token2 = arr[j + 1];
      arr[j + 1] = arr[j];
      arr[j] = token2;
      procs[j + 1] = procs[j];
      procs[j] = procNew;
    }
  }
}
sort$1.default = sortByProcedure;
function getProcedure(token2) {
  var _a, _b;
  var proc = (_a = procedure.get(token2.type)) !== null && _a !== void 0 ? _a : -1;
  if (token2.type === css_what_1$2.SelectorType.Attribute) {
    proc = (_b = attributes$1.get(token2.action)) !== null && _b !== void 0 ? _b : 4;
    if (token2.action === css_what_1$2.AttributeAction.Equals && token2.name === "id") {
      proc = 9;
    }
    if (token2.ignoreCase) {
      proc >>= 1;
    }
  } else if (token2.type === css_what_1$2.SelectorType.Pseudo) {
    if (!token2.data) {
      proc = 3;
    } else if (token2.name === "has" || token2.name === "contains") {
      proc = 0;
    } else if (Array.isArray(token2.data)) {
      proc = Math.min.apply(Math, token2.data.map(function(d) {
        return Math.min.apply(Math, d.map(getProcedure));
      }));
      if (proc < 0) {
        proc = 0;
      }
    } else {
      proc = 2;
    }
  }
  return proc;
}
var general = {};
var attributes = {};
var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : {
    "default": mod2
  };
};
Object.defineProperty(attributes, "__esModule", {
  value: true
});
attributes.attributeRules = void 0;
var boolbase_1$2 = __importDefault$2(boolbase);
var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function escapeRegex(value2) {
  return value2.replace(reChars, "\\$&");
}
var caseInsensitiveAttributes = /* @__PURE__ */ new Set(["accept", "accept-charset", "align", "alink", "axis", "bgcolor", "charset", "checked", "clear", "codetype", "color", "compact", "declare", "defer", "dir", "direction", "disabled", "enctype", "face", "frame", "hreflang", "http-equiv", "lang", "language", "link", "media", "method", "multiple", "nohref", "noresize", "noshade", "nowrap", "readonly", "rel", "rev", "rules", "scope", "scrolling", "selected", "shape", "target", "text", "type", "valign", "valuetype", "vlink"]);
function shouldIgnoreCase(selector2, options2) {
  return typeof selector2.ignoreCase === "boolean" ? selector2.ignoreCase : selector2.ignoreCase === "quirks" ? !!options2.quirksMode : !options2.xmlMode && caseInsensitiveAttributes.has(selector2.name);
}
attributes.attributeRules = {
  equals: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name;
    var value2 = data2.value;
    if (shouldIgnoreCase(data2, options2)) {
      value2 = value2.toLowerCase();
      return function(elem) {
        var attr2 = adapter.getAttributeValue(elem, name);
        return attr2 != null && attr2.length === value2.length && attr2.toLowerCase() === value2 && next(elem);
      };
    }
    return function(elem) {
      return adapter.getAttributeValue(elem, name) === value2 && next(elem);
    };
  },
  hyphen: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name;
    var value2 = data2.value;
    var len = value2.length;
    if (shouldIgnoreCase(data2, options2)) {
      value2 = value2.toLowerCase();
      return function hyphenIC(elem) {
        var attr2 = adapter.getAttributeValue(elem, name);
        return attr2 != null && (attr2.length === len || attr2.charAt(len) === "-") && attr2.substr(0, len).toLowerCase() === value2 && next(elem);
      };
    }
    return function hyphen(elem) {
      var attr2 = adapter.getAttributeValue(elem, name);
      return attr2 != null && (attr2.length === len || attr2.charAt(len) === "-") && attr2.substr(0, len) === value2 && next(elem);
    };
  },
  element: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name, value2 = data2.value;
    if (/\s/.test(value2)) {
      return boolbase_1$2.default.falseFunc;
    }
    var regex2 = new RegExp("(?:^|\\s)".concat(escapeRegex(value2), "(?:$|\\s)"), shouldIgnoreCase(data2, options2) ? "i" : "");
    return function element(elem) {
      var attr2 = adapter.getAttributeValue(elem, name);
      return attr2 != null && attr2.length >= value2.length && regex2.test(attr2) && next(elem);
    };
  },
  exists: function(next, _a, _b) {
    var name = _a.name;
    var adapter = _b.adapter;
    return function(elem) {
      return adapter.hasAttrib(elem, name) && next(elem);
    };
  },
  start: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name;
    var value2 = data2.value;
    var len = value2.length;
    if (len === 0) {
      return boolbase_1$2.default.falseFunc;
    }
    if (shouldIgnoreCase(data2, options2)) {
      value2 = value2.toLowerCase();
      return function(elem) {
        var attr2 = adapter.getAttributeValue(elem, name);
        return attr2 != null && attr2.length >= len && attr2.substr(0, len).toLowerCase() === value2 && next(elem);
      };
    }
    return function(elem) {
      var _a;
      return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value2)) && next(elem);
    };
  },
  end: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name;
    var value2 = data2.value;
    var len = -value2.length;
    if (len === 0) {
      return boolbase_1$2.default.falseFunc;
    }
    if (shouldIgnoreCase(data2, options2)) {
      value2 = value2.toLowerCase();
      return function(elem) {
        var _a;
        return ((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value2 && next(elem);
      };
    }
    return function(elem) {
      var _a;
      return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value2)) && next(elem);
    };
  },
  any: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name, value2 = data2.value;
    if (value2 === "") {
      return boolbase_1$2.default.falseFunc;
    }
    if (shouldIgnoreCase(data2, options2)) {
      var regex_1 = new RegExp(escapeRegex(value2), "i");
      return function anyIC(elem) {
        var attr2 = adapter.getAttributeValue(elem, name);
        return attr2 != null && attr2.length >= value2.length && regex_1.test(attr2) && next(elem);
      };
    }
    return function(elem) {
      var _a;
      return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value2)) && next(elem);
    };
  },
  not: function(next, data2, options2) {
    var adapter = options2.adapter;
    var name = data2.name;
    var value2 = data2.value;
    if (value2 === "") {
      return function(elem) {
        return !!adapter.getAttributeValue(elem, name) && next(elem);
      };
    } else if (shouldIgnoreCase(data2, options2)) {
      value2 = value2.toLowerCase();
      return function(elem) {
        var attr2 = adapter.getAttributeValue(elem, name);
        return (attr2 == null || attr2.length !== value2.length || attr2.toLowerCase() !== value2) && next(elem);
      };
    }
    return function(elem) {
      return adapter.getAttributeValue(elem, name) !== value2 && next(elem);
    };
  }
};
var pseudoSelectors = {};
var filters = {};
var lib$4 = {};
var parse$3 = {};
Object.defineProperty(parse$3, "__esModule", {
  value: true
});
parse$3.parse = void 0;
var whitespace = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]);
var ZERO = "0".charCodeAt(0);
var NINE = "9".charCodeAt(0);
function parse$2(formula) {
  formula = formula.trim().toLowerCase();
  if (formula === "even") {
    return [2, 0];
  } else if (formula === "odd") {
    return [2, 1];
  }
  var idx = 0;
  var a = 0;
  var sign2 = readSign();
  var number3 = readNumber();
  if (idx < formula.length && formula.charAt(idx) === "n") {
    idx++;
    a = sign2 * (number3 !== null && number3 !== void 0 ? number3 : 1);
    skipWhitespace();
    if (idx < formula.length) {
      sign2 = readSign();
      skipWhitespace();
      number3 = readNumber();
    } else {
      sign2 = number3 = 0;
    }
  }
  if (number3 === null || idx < formula.length) {
    throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
  }
  return [a, sign2 * number3];
  function readSign() {
    if (formula.charAt(idx) === "-") {
      idx++;
      return -1;
    }
    if (formula.charAt(idx) === "+") {
      idx++;
    }
    return 1;
  }
  function readNumber() {
    var start2 = idx;
    var value2 = 0;
    while (idx < formula.length && formula.charCodeAt(idx) >= ZERO && formula.charCodeAt(idx) <= NINE) {
      value2 = value2 * 10 + (formula.charCodeAt(idx) - ZERO);
      idx++;
    }
    return idx === start2 ? null : value2;
  }
  function skipWhitespace() {
    while (idx < formula.length && whitespace.has(formula.charCodeAt(idx))) {
      idx++;
    }
  }
}
parse$3.parse = parse$2;
var compile$4 = {};
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : {
    "default": mod2
  };
};
Object.defineProperty(compile$4, "__esModule", {
  value: true
});
compile$4.generate = compile$4.compile = void 0;
var boolbase_1$1 = __importDefault$1(boolbase);
function compile$3(parsed) {
  var a = parsed[0];
  var b = parsed[1] - 1;
  if (b < 0 && a <= 0)
    return boolbase_1$1.default.falseFunc;
  if (a === -1)
    return function(index2) {
      return index2 <= b;
    };
  if (a === 0)
    return function(index2) {
      return index2 === b;
    };
  if (a === 1)
    return b < 0 ? boolbase_1$1.default.trueFunc : function(index2) {
      return index2 >= b;
    };
  var absA = Math.abs(a);
  var bMod = (b % absA + absA) % absA;
  return a > 1 ? function(index2) {
    return index2 >= b && index2 % absA === bMod;
  } : function(index2) {
    return index2 <= b && index2 % absA === bMod;
  };
}
compile$4.compile = compile$3;
function generate(parsed) {
  var a = parsed[0];
  var b = parsed[1] - 1;
  var n = 0;
  if (a < 0) {
    var aPos_1 = -a;
    var minValue_1 = (b % aPos_1 + aPos_1) % aPos_1;
    return function() {
      var val2 = minValue_1 + aPos_1 * n++;
      return val2 > b ? null : val2;
    };
  }
  if (a === 0)
    return b < 0 ? (
      // There are no result — always return `null`
      function() {
        return null;
      }
    ) : (
      // Return `b` exactly once
      function() {
        return n++ === 0 ? b : null;
      }
    );
  if (b < 0) {
    b += a * Math.ceil(-b / a);
  }
  return function() {
    return a * n++ + b;
  };
}
compile$4.generate = generate;
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.sequence = exports2.generate = exports2.compile = exports2.parse = void 0;
  var parse_js_12 = parse$3;
  Object.defineProperty(exports2, "parse", {
    enumerable: true,
    get: function() {
      return parse_js_12.parse;
    }
  });
  var compile_js_1 = compile$4;
  Object.defineProperty(exports2, "compile", {
    enumerable: true,
    get: function() {
      return compile_js_1.compile;
    }
  });
  Object.defineProperty(exports2, "generate", {
    enumerable: true,
    get: function() {
      return compile_js_1.generate;
    }
  });
  function nthCheck(formula) {
    return (0, compile_js_1.compile)((0, parse_js_12.parse)(formula));
  }
  exports2.default = nthCheck;
  function sequence(formula) {
    return (0, compile_js_1.generate)((0, parse_js_12.parse)(formula));
  }
  exports2.sequence = sequence;
})(lib$4);
(function(exports2) {
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.filters = void 0;
  var nth_check_1 = __importDefault2(lib$4);
  var boolbase_12 = __importDefault2(boolbase);
  function getChildFunc(next, adapter) {
    return function(elem) {
      var parent = adapter.getParent(elem);
      return parent != null && adapter.isTag(parent) && next(elem);
    };
  }
  exports2.filters = {
    contains: function(next, text2, _a) {
      var adapter = _a.adapter;
      return function contains2(elem) {
        return next(elem) && adapter.getText(elem).includes(text2);
      };
    },
    icontains: function(next, text2, _a) {
      var adapter = _a.adapter;
      var itext = text2.toLowerCase();
      return function icontains(elem) {
        return next(elem) && adapter.getText(elem).toLowerCase().includes(itext);
      };
    },
    // Location specific methods
    "nth-child": function(next, rule, _a) {
      var adapter = _a.adapter, equals = _a.equals;
      var func = (0, nth_check_1.default)(rule);
      if (func === boolbase_12.default.falseFunc)
        return boolbase_12.default.falseFunc;
      if (func === boolbase_12.default.trueFunc)
        return getChildFunc(next, adapter);
      return function nthChild(elem) {
        var siblings = adapter.getSiblings(elem);
        var pos = 0;
        for (var i = 0; i < siblings.length; i++) {
          if (equals(elem, siblings[i]))
            break;
          if (adapter.isTag(siblings[i])) {
            pos++;
          }
        }
        return func(pos) && next(elem);
      };
    },
    "nth-last-child": function(next, rule, _a) {
      var adapter = _a.adapter, equals = _a.equals;
      var func = (0, nth_check_1.default)(rule);
      if (func === boolbase_12.default.falseFunc)
        return boolbase_12.default.falseFunc;
      if (func === boolbase_12.default.trueFunc)
        return getChildFunc(next, adapter);
      return function nthLastChild(elem) {
        var siblings = adapter.getSiblings(elem);
        var pos = 0;
        for (var i = siblings.length - 1; i >= 0; i--) {
          if (equals(elem, siblings[i]))
            break;
          if (adapter.isTag(siblings[i])) {
            pos++;
          }
        }
        return func(pos) && next(elem);
      };
    },
    "nth-of-type": function(next, rule, _a) {
      var adapter = _a.adapter, equals = _a.equals;
      var func = (0, nth_check_1.default)(rule);
      if (func === boolbase_12.default.falseFunc)
        return boolbase_12.default.falseFunc;
      if (func === boolbase_12.default.trueFunc)
        return getChildFunc(next, adapter);
      return function nthOfType(elem) {
        var siblings = adapter.getSiblings(elem);
        var pos = 0;
        for (var i = 0; i < siblings.length; i++) {
          var currentSibling = siblings[i];
          if (equals(elem, currentSibling))
            break;
          if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) {
            pos++;
          }
        }
        return func(pos) && next(elem);
      };
    },
    "nth-last-of-type": function(next, rule, _a) {
      var adapter = _a.adapter, equals = _a.equals;
      var func = (0, nth_check_1.default)(rule);
      if (func === boolbase_12.default.falseFunc)
        return boolbase_12.default.falseFunc;
      if (func === boolbase_12.default.trueFunc)
        return getChildFunc(next, adapter);
      return function nthLastOfType(elem) {
        var siblings = adapter.getSiblings(elem);
        var pos = 0;
        for (var i = siblings.length - 1; i >= 0; i--) {
          var currentSibling = siblings[i];
          if (equals(elem, currentSibling))
            break;
          if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) {
            pos++;
          }
        }
        return func(pos) && next(elem);
      };
    },
    // TODO determine the actual root element
    root: function(next, _rule, _a) {
      var adapter = _a.adapter;
      return function(elem) {
        var parent = adapter.getParent(elem);
        return (parent == null || !adapter.isTag(parent)) && next(elem);
      };
    },
    scope: function(next, rule, options2, context) {
      var equals = options2.equals;
      if (!context || context.length === 0) {
        return exports2.filters["root"](next, rule, options2);
      }
      if (context.length === 1) {
        return function(elem) {
          return equals(context[0], elem) && next(elem);
        };
      }
      return function(elem) {
        return context.includes(elem) && next(elem);
      };
    },
    hover: dynamicStatePseudo("isHovered"),
    visited: dynamicStatePseudo("isVisited"),
    active: dynamicStatePseudo("isActive")
  };
  function dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, _a) {
      var adapter = _a.adapter;
      var func = adapter[name];
      if (typeof func !== "function") {
        return boolbase_12.default.falseFunc;
      }
      return function active3(elem) {
        return func(elem) && next(elem);
      };
    };
  }
})(filters);
var pseudos = {};
Object.defineProperty(pseudos, "__esModule", {
  value: true
});
pseudos.verifyPseudoArgs = pseudos.pseudos = void 0;
pseudos.pseudos = {
  empty: function(elem, _a) {
    var adapter = _a.adapter;
    return !adapter.getChildren(elem).some(function(elem2) {
      return adapter.isTag(elem2) || adapter.getText(elem2) !== "";
    });
  },
  "first-child": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    if (adapter.prevElementSibling) {
      return adapter.prevElementSibling(elem) == null;
    }
    var firstChild = adapter.getSiblings(elem).find(function(elem2) {
      return adapter.isTag(elem2);
    });
    return firstChild != null && equals(elem, firstChild);
  },
  "last-child": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    var siblings = adapter.getSiblings(elem);
    for (var i = siblings.length - 1; i >= 0; i--) {
      if (equals(elem, siblings[i]))
        return true;
      if (adapter.isTag(siblings[i]))
        break;
    }
    return false;
  },
  "first-of-type": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    var siblings = adapter.getSiblings(elem);
    var elemName = adapter.getName(elem);
    for (var i = 0; i < siblings.length; i++) {
      var currentSibling = siblings[i];
      if (equals(elem, currentSibling))
        return true;
      if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
        break;
      }
    }
    return false;
  },
  "last-of-type": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    var siblings = adapter.getSiblings(elem);
    var elemName = adapter.getName(elem);
    for (var i = siblings.length - 1; i >= 0; i--) {
      var currentSibling = siblings[i];
      if (equals(elem, currentSibling))
        return true;
      if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
        break;
      }
    }
    return false;
  },
  "only-of-type": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    var elemName = adapter.getName(elem);
    return adapter.getSiblings(elem).every(function(sibling) {
      return equals(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName;
    });
  },
  "only-child": function(elem, _a) {
    var adapter = _a.adapter, equals = _a.equals;
    return adapter.getSiblings(elem).every(function(sibling) {
      return equals(elem, sibling) || !adapter.isTag(sibling);
    });
  }
};
function verifyPseudoArgs(func, name, subselect, argIndex) {
  if (subselect === null) {
    if (func.length > argIndex) {
      throw new Error("Pseudo-class :".concat(name, " requires an argument"));
    }
  } else if (func.length === argIndex) {
    throw new Error("Pseudo-class :".concat(name, " doesn't have any arguments"));
  }
}
pseudos.verifyPseudoArgs = verifyPseudoArgs;
var aliases = {};
Object.defineProperty(aliases, "__esModule", {
  value: true
});
aliases.aliases = void 0;
aliases.aliases = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
};
var subselects = {};
(function(exports2) {
  var __spreadArray2 = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar)
            ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from));
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.subselects = exports2.getNextSiblings = exports2.ensureIsTag = exports2.PLACEHOLDER_ELEMENT = void 0;
  var boolbase_12 = __importDefault2(boolbase);
  var sort_js_12 = sort$1;
  exports2.PLACEHOLDER_ELEMENT = {};
  function ensureIsTag(next, adapter) {
    if (next === boolbase_12.default.falseFunc)
      return boolbase_12.default.falseFunc;
    return function(elem) {
      return adapter.isTag(elem) && next(elem);
    };
  }
  exports2.ensureIsTag = ensureIsTag;
  function getNextSiblings(elem, adapter) {
    var siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1)
      return [];
    var elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1)
      return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
  }
  exports2.getNextSiblings = getNextSiblings;
  function copyOptions(options2) {
    return {
      xmlMode: !!options2.xmlMode,
      lowerCaseAttributeNames: !!options2.lowerCaseAttributeNames,
      lowerCaseTags: !!options2.lowerCaseTags,
      quirksMode: !!options2.quirksMode,
      cacheResults: !!options2.cacheResults,
      pseudos: options2.pseudos,
      adapter: options2.adapter,
      equals: options2.equals
    };
  }
  var is3 = function(next, token2, options2, context, compileToken2) {
    var func = compileToken2(token2, copyOptions(options2), context);
    return func === boolbase_12.default.trueFunc ? next : func === boolbase_12.default.falseFunc ? boolbase_12.default.falseFunc : function(elem) {
      return func(elem) && next(elem);
    };
  };
  exports2.subselects = {
    is: is3,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */
    matches: is3,
    where: is3,
    not: function(next, token2, options2, context, compileToken2) {
      var func = compileToken2(token2, copyOptions(options2), context);
      return func === boolbase_12.default.falseFunc ? next : func === boolbase_12.default.trueFunc ? boolbase_12.default.falseFunc : function(elem) {
        return !func(elem) && next(elem);
      };
    },
    has: function(next, subselect, options2, _context, compileToken2) {
      var adapter = options2.adapter;
      var opts = copyOptions(options2);
      opts.relativeSelector = true;
      var context = subselect.some(function(s) {
        return s.some(sort_js_12.isTraversal);
      }) ? (
        // Used as a placeholder. Will be replaced with the actual element.
        [exports2.PLACEHOLDER_ELEMENT]
      ) : void 0;
      var compiled = compileToken2(subselect, opts, context);
      if (compiled === boolbase_12.default.falseFunc)
        return boolbase_12.default.falseFunc;
      var hasElement = ensureIsTag(compiled, adapter);
      if (context && compiled !== boolbase_12.default.trueFunc) {
        var _a = compiled.shouldTestNextSiblings, shouldTestNextSiblings_1 = _a === void 0 ? false : _a;
        return function(elem) {
          if (!next(elem))
            return false;
          context[0] = elem;
          var childs = adapter.getChildren(elem);
          var nextElements = shouldTestNextSiblings_1 ? __spreadArray2(__spreadArray2([], childs, true), getNextSiblings(elem, adapter), true) : childs;
          return adapter.existsOne(hasElement, nextElements);
        };
      }
      return function(elem) {
        return next(elem) && adapter.existsOne(hasElement, adapter.getChildren(elem));
      };
    }
  };
})(subselects);
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.compilePseudoSelector = exports2.aliases = exports2.pseudos = exports2.filters = void 0;
  var css_what_12 = require$$0$2;
  var filters_js_1 = filters;
  Object.defineProperty(exports2, "filters", {
    enumerable: true,
    get: function() {
      return filters_js_1.filters;
    }
  });
  var pseudos_js_1 = pseudos;
  Object.defineProperty(exports2, "pseudos", {
    enumerable: true,
    get: function() {
      return pseudos_js_1.pseudos;
    }
  });
  var aliases_js_1 = aliases;
  Object.defineProperty(exports2, "aliases", {
    enumerable: true,
    get: function() {
      return aliases_js_1.aliases;
    }
  });
  var subselects_js_12 = subselects;
  function compilePseudoSelector(next, selector2, options2, context, compileToken2) {
    var _a;
    var name = selector2.name, data2 = selector2.data;
    if (Array.isArray(data2)) {
      if (!(name in subselects_js_12.subselects)) {
        throw new Error("Unknown pseudo-class :".concat(name, "(").concat(data2, ")"));
      }
      return subselects_js_12.subselects[name](next, data2, options2, context, compileToken2);
    }
    var userPseudo = (_a = options2.pseudos) === null || _a === void 0 ? void 0 : _a[name];
    var stringPseudo = typeof userPseudo === "string" ? userPseudo : aliases_js_1.aliases[name];
    if (typeof stringPseudo === "string") {
      if (data2 != null) {
        throw new Error("Pseudo ".concat(name, " doesn't have any arguments"));
      }
      var alias = (0, css_what_12.parse)(stringPseudo);
      return subselects_js_12.subselects["is"](next, alias, options2, context, compileToken2);
    }
    if (typeof userPseudo === "function") {
      (0, pseudos_js_1.verifyPseudoArgs)(userPseudo, name, data2, 1);
      return function(elem) {
        return userPseudo(elem, data2) && next(elem);
      };
    }
    if (name in filters_js_1.filters) {
      return filters_js_1.filters[name](next, data2, options2, context);
    }
    if (name in pseudos_js_1.pseudos) {
      var pseudo_1 = pseudos_js_1.pseudos[name];
      (0, pseudos_js_1.verifyPseudoArgs)(pseudo_1, name, data2, 2);
      return function(elem) {
        return pseudo_1(elem, options2, data2) && next(elem);
      };
    }
    throw new Error("Unknown pseudo-class :".concat(name));
  }
  exports2.compilePseudoSelector = compilePseudoSelector;
})(pseudoSelectors);
Object.defineProperty(general, "__esModule", {
  value: true
});
general.compileGeneralSelector = void 0;
var attributes_js_1 = attributes;
var index_js_1$2 = pseudoSelectors;
var css_what_1$1 = require$$0$2;
function getElementParent(node2, adapter) {
  var parent = adapter.getParent(node2);
  if (parent && adapter.isTag(parent)) {
    return parent;
  }
  return null;
}
function compileGeneralSelector(next, selector2, options2, context, compileToken2) {
  var adapter = options2.adapter, equals = options2.equals;
  switch (selector2.type) {
    case css_what_1$1.SelectorType.PseudoElement: {
      throw new Error("Pseudo-elements are not supported by css-select");
    }
    case css_what_1$1.SelectorType.ColumnCombinator: {
      throw new Error("Column combinators are not yet supported by css-select");
    }
    case css_what_1$1.SelectorType.Attribute: {
      if (selector2.namespace != null) {
        throw new Error("Namespaced attributes are not yet supported by css-select");
      }
      if (!options2.xmlMode || options2.lowerCaseAttributeNames) {
        selector2.name = selector2.name.toLowerCase();
      }
      return attributes_js_1.attributeRules[selector2.action](next, selector2, options2);
    }
    case css_what_1$1.SelectorType.Pseudo: {
      return (0, index_js_1$2.compilePseudoSelector)(next, selector2, options2, context, compileToken2);
    }
    case css_what_1$1.SelectorType.Tag: {
      if (selector2.namespace != null) {
        throw new Error("Namespaced tag names are not yet supported by css-select");
      }
      var name_1 = selector2.name;
      if (!options2.xmlMode || options2.lowerCaseTags) {
        name_1 = name_1.toLowerCase();
      }
      return function tag(elem) {
        return adapter.getName(elem) === name_1 && next(elem);
      };
    }
    case css_what_1$1.SelectorType.Descendant: {
      if (options2.cacheResults === false || typeof WeakSet === "undefined") {
        return function descendant(elem) {
          var current = elem;
          while (current = getElementParent(current, adapter)) {
            if (next(current)) {
              return true;
            }
          }
          return false;
        };
      }
      var isFalseCache_1 = /* @__PURE__ */ new WeakSet();
      return function cachedDescendant(elem) {
        var current = elem;
        while (current = getElementParent(current, adapter)) {
          if (!isFalseCache_1.has(current)) {
            if (adapter.isTag(current) && next(current)) {
              return true;
            }
            isFalseCache_1.add(current);
          }
        }
        return false;
      };
    }
    case "_flexibleDescendant": {
      return function flexibleDescendant(elem) {
        var current = elem;
        do {
          if (next(current))
            return true;
        } while (current = getElementParent(current, adapter));
        return false;
      };
    }
    case css_what_1$1.SelectorType.Parent: {
      return function parent(elem) {
        return adapter.getChildren(elem).some(function(elem2) {
          return adapter.isTag(elem2) && next(elem2);
        });
      };
    }
    case css_what_1$1.SelectorType.Child: {
      return function child(elem) {
        var parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(parent);
      };
    }
    case css_what_1$1.SelectorType.Sibling: {
      return function sibling(elem) {
        var siblings = adapter.getSiblings(elem);
        for (var i = 0; i < siblings.length; i++) {
          var currentSibling = siblings[i];
          if (equals(elem, currentSibling))
            break;
          if (adapter.isTag(currentSibling) && next(currentSibling)) {
            return true;
          }
        }
        return false;
      };
    }
    case css_what_1$1.SelectorType.Adjacent: {
      if (adapter.prevElementSibling) {
        return function adjacent(elem) {
          var previous = adapter.prevElementSibling(elem);
          return previous != null && next(previous);
        };
      }
      return function adjacent(elem) {
        var siblings = adapter.getSiblings(elem);
        var lastElement;
        for (var i = 0; i < siblings.length; i++) {
          var currentSibling = siblings[i];
          if (equals(elem, currentSibling))
            break;
          if (adapter.isTag(currentSibling)) {
            lastElement = currentSibling;
          }
        }
        return !!lastElement && next(lastElement);
      };
    }
    case css_what_1$1.SelectorType.Universal: {
      if (selector2.namespace != null && selector2.namespace !== "*") {
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      }
      return next;
    }
  }
}
general.compileGeneralSelector = compileGeneralSelector;
var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$4(result, mod2, k);
  }
  __setModuleDefault$4(result, mod2);
  return result;
};
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : {
    "default": mod2
  };
};
Object.defineProperty(compile$5, "__esModule", {
  value: true
});
compile$5.compileToken = compile$5.compileUnsafe = compile$5.compile = void 0;
var css_what_1 = require$$0$2;
var boolbase_1 = __importDefault(boolbase);
var sort_js_1 = __importStar$4(sort$1);
var general_js_1 = general;
var subselects_js_1 = subselects;
function compile$2(selector2, options2, context) {
  var next = compileUnsafe(selector2, options2, context);
  return (0, subselects_js_1.ensureIsTag)(next, options2.adapter);
}
compile$5.compile = compile$2;
function compileUnsafe(selector2, options2, context) {
  var token2 = typeof selector2 === "string" ? (0, css_what_1.parse)(selector2) : selector2;
  return compileToken(token2, options2, context);
}
compile$5.compileUnsafe = compileUnsafe;
function includesScopePseudo(t) {
  return t.type === css_what_1.SelectorType.Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some(function(data2) {
    return data2.some(includesScopePseudo);
  }));
}
var DESCENDANT_TOKEN = {
  type: css_what_1.SelectorType.Descendant
};
var FLEXIBLE_DESCENDANT_TOKEN = {
  type: "_flexibleDescendant"
};
var SCOPE_TOKEN = {
  type: css_what_1.SelectorType.Pseudo,
  name: "scope",
  data: null
};
function absolutize(token2, _a, context) {
  var adapter = _a.adapter;
  var hasContext = !!(context === null || context === void 0 ? void 0 : context.every(function(e) {
    var parent = adapter.isTag(e) && adapter.getParent(e);
    return e === subselects_js_1.PLACEHOLDER_ELEMENT || parent && adapter.isTag(parent);
  }));
  for (var _i = 0, token_1 = token2; _i < token_1.length; _i++) {
    var t = token_1[_i];
    if (t.length > 0 && (0, sort_js_1.isTraversal)(t[0]) && t[0].type !== css_what_1.SelectorType.Descendant)
      ;
    else if (hasContext && !t.some(includesScopePseudo)) {
      t.unshift(DESCENDANT_TOKEN);
    } else {
      continue;
    }
    t.unshift(SCOPE_TOKEN);
  }
}
function compileToken(token2, options2, context) {
  var _a;
  token2.forEach(sort_js_1.default);
  context = (_a = options2.context) !== null && _a !== void 0 ? _a : context;
  var isArrayContext = Array.isArray(context);
  var finalContext = context && (Array.isArray(context) ? context : [context]);
  if (options2.relativeSelector !== false) {
    absolutize(token2, options2, finalContext);
  } else if (token2.some(function(t) {
    return t.length > 0 && (0, sort_js_1.isTraversal)(t[0]);
  })) {
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  }
  var shouldTestNextSiblings = false;
  var query = token2.map(function(rules3) {
    if (rules3.length >= 2) {
      var first2 = rules3[0], second2 = rules3[1];
      if (first2.type !== css_what_1.SelectorType.Pseudo || first2.name !== "scope")
        ;
      else if (isArrayContext && second2.type === css_what_1.SelectorType.Descendant) {
        rules3[1] = FLEXIBLE_DESCENDANT_TOKEN;
      } else if (second2.type === css_what_1.SelectorType.Adjacent || second2.type === css_what_1.SelectorType.Sibling) {
        shouldTestNextSiblings = true;
      }
    }
    return compileRules(rules3, options2, finalContext);
  }).reduce(reduceRules, boolbase_1.default.falseFunc);
  query.shouldTestNextSiblings = shouldTestNextSiblings;
  return query;
}
compile$5.compileToken = compileToken;
function compileRules(rules3, options2, context) {
  var _a;
  return rules3.reduce(function(previous, rule) {
    return previous === boolbase_1.default.falseFunc ? boolbase_1.default.falseFunc : (0, general_js_1.compileGeneralSelector)(previous, rule, options2, context, compileToken);
  }, (_a = options2.rootFunc) !== null && _a !== void 0 ? _a : boolbase_1.default.trueFunc);
}
function reduceRules(a, b) {
  if (b === boolbase_1.default.falseFunc || a === boolbase_1.default.trueFunc) {
    return a;
  }
  if (a === boolbase_1.default.falseFunc || b === boolbase_1.default.trueFunc) {
    return b;
  }
  return function combine(elem) {
    return a(elem) || b(elem);
  };
}
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.aliases = exports2.pseudos = exports2.filters = exports2.is = exports2.selectOne = exports2.selectAll = exports2.prepareContext = exports2._compileToken = exports2._compileUnsafe = exports2.compile = void 0;
  var DomUtils = __importStar2(lib$b);
  var boolbase_12 = __importDefault2(boolbase);
  var compile_js_1 = compile$5;
  var subselects_js_12 = subselects;
  var defaultEquals = function(a, b) {
    return a === b;
  };
  var defaultOptions = {
    adapter: DomUtils,
    equals: defaultEquals
  };
  function convertOptionFormats(options2) {
    var _a, _b, _c, _d;
    var opts = options2 !== null && options2 !== void 0 ? options2 : defaultOptions;
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : opts.adapter = DomUtils;
    (_b = opts.equals) !== null && _b !== void 0 ? _b : opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : defaultEquals;
    return opts;
  }
  function wrapCompile(func) {
    return function addAdapter(selector2, options2, context) {
      var opts = convertOptionFormats(options2);
      return func(selector2, opts, context);
    };
  }
  exports2.compile = wrapCompile(compile_js_1.compile);
  exports2._compileUnsafe = wrapCompile(compile_js_1.compileUnsafe);
  exports2._compileToken = wrapCompile(compile_js_1.compileToken);
  function getSelectorFunc(searchFunc) {
    return function select2(query, elements, options2) {
      var opts = convertOptionFormats(options2);
      if (typeof query !== "function") {
        query = (0, compile_js_1.compileUnsafe)(query, opts, elements);
      }
      var filteredElements = prepareContext(elements, opts.adapter, query.shouldTestNextSiblings);
      return searchFunc(query, filteredElements, opts);
    };
  }
  function prepareContext(elems, adapter, shouldTestNextSiblings) {
    if (shouldTestNextSiblings === void 0) {
      shouldTestNextSiblings = false;
    }
    if (shouldTestNextSiblings) {
      elems = appendNextSiblings(elems, adapter);
    }
    return Array.isArray(elems) ? adapter.removeSubsets(elems) : adapter.getChildren(elems);
  }
  exports2.prepareContext = prepareContext;
  function appendNextSiblings(elem, adapter) {
    var elems = Array.isArray(elem) ? elem.slice(0) : [elem];
    var elemsLength = elems.length;
    for (var i = 0; i < elemsLength; i++) {
      var nextSiblings = (0, subselects_js_12.getNextSiblings)(elems[i], adapter);
      elems.push.apply(elems, nextSiblings);
    }
    return elems;
  }
  exports2.selectAll = getSelectorFunc(function(query, elems, options2) {
    return query === boolbase_12.default.falseFunc || !elems || elems.length === 0 ? [] : options2.adapter.findAll(query, elems);
  });
  exports2.selectOne = getSelectorFunc(function(query, elems, options2) {
    return query === boolbase_12.default.falseFunc || !elems || elems.length === 0 ? null : options2.adapter.findOne(query, elems);
  });
  function is3(elem, query, options2) {
    var opts = convertOptionFormats(options2);
    return (typeof query === "function" ? query : (0, compile_js_1.compile)(query, opts))(elem);
  }
  exports2.is = is3;
  exports2.default = exports2.selectAll;
  var index_js_12 = pseudoSelectors;
  Object.defineProperty(exports2, "filters", {
    enumerable: true,
    get: function() {
      return index_js_12.filters;
    }
  });
  Object.defineProperty(exports2, "pseudos", {
    enumerable: true,
    get: function() {
      return index_js_12.pseudos;
    }
  });
  Object.defineProperty(exports2, "aliases", {
    enumerable: true,
    get: function() {
      return index_js_12.aliases;
    }
  });
})(lib$5);
var helpers = {};
var positionals = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.getLimit = exports2.isFilter = exports2.filterNames = void 0;
  exports2.filterNames = /* @__PURE__ */ new Set(["first", "last", "eq", "gt", "nth", "lt", "even", "odd"]);
  function isFilter(s) {
    if (s.type !== "pseudo")
      return false;
    if (exports2.filterNames.has(s.name))
      return true;
    if (s.name === "not" && Array.isArray(s.data)) {
      return s.data.some(function(s2) {
        return s2.some(isFilter);
      });
    }
    return false;
  }
  exports2.isFilter = isFilter;
  function getLimit(filter4, data2, partLimit) {
    var num = data2 != null ? parseInt(data2, 10) : NaN;
    switch (filter4) {
      case "first":
        return 1;
      case "nth":
      case "eq":
        return isFinite(num) ? num >= 0 ? num + 1 : Infinity : 0;
      case "lt":
        return isFinite(num) ? num >= 0 ? Math.min(num, partLimit) : Infinity : 0;
      case "gt":
        return isFinite(num) ? Infinity : 0;
      case "odd":
        return 2 * partLimit;
      case "even":
        return 2 * partLimit - 1;
      case "last":
      case "not":
        return Infinity;
    }
  }
  exports2.getLimit = getLimit;
})(positionals);
Object.defineProperty(helpers, "__esModule", {
  value: true
});
helpers.groupSelectors = helpers.getDocumentRoot = void 0;
var positionals_js_1 = positionals;
function getDocumentRoot(node2) {
  while (node2.parent)
    node2 = node2.parent;
  return node2;
}
helpers.getDocumentRoot = getDocumentRoot;
function groupSelectors(selectors2) {
  var filteredSelectors = [];
  var plainSelectors = [];
  for (var _i = 0, selectors_1 = selectors2; _i < selectors_1.length; _i++) {
    var selector2 = selectors_1[_i];
    if (selector2.some(positionals_js_1.isFilter)) {
      filteredSelectors.push(selector2);
    } else {
      plainSelectors.push(selector2);
    }
  }
  return [plainSelectors, filteredSelectors];
}
helpers.groupSelectors = groupSelectors;
(function(exports2) {
  var __assign2 = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __spreadArray2 = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar)
            ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from));
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.select = exports2.filter = exports2.some = exports2.is = exports2.aliases = exports2.pseudos = exports2.filters = void 0;
  var css_what_12 = require$$0$2;
  var css_select_1 = lib$5;
  var DomUtils = __importStar2(lib$b);
  var boolbase$1 = __importStar2(boolbase);
  var helpers_js_1 = helpers;
  var positionals_js_12 = positionals;
  var css_select_2 = lib$5;
  Object.defineProperty(exports2, "filters", {
    enumerable: true,
    get: function() {
      return css_select_2.filters;
    }
  });
  Object.defineProperty(exports2, "pseudos", {
    enumerable: true,
    get: function() {
      return css_select_2.pseudos;
    }
  });
  Object.defineProperty(exports2, "aliases", {
    enumerable: true,
    get: function() {
      return css_select_2.aliases;
    }
  });
  var UNIVERSAL_SELECTOR2 = {
    type: css_what_12.SelectorType.Universal,
    namespace: null
  };
  var SCOPE_PSEUDO = {
    type: css_what_12.SelectorType.Pseudo,
    name: "scope",
    data: null
  };
  function is3(element, selector2, options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return some2([element], selector2, options2);
  }
  exports2.is = is3;
  function some2(elements, selector2, options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    if (typeof selector2 === "function")
      return elements.some(selector2);
    var _a = (0, helpers_js_1.groupSelectors)((0, css_what_12.parse)(selector2)), plain = _a[0], filtered = _a[1];
    return plain.length > 0 && elements.some((0, css_select_1._compileToken)(plain, options2)) || filtered.some(function(sel) {
      return filterBySelector(sel, elements, options2).length > 0;
    });
  }
  exports2.some = some2;
  function filterByPosition(filter5, elems, data2, options2) {
    var num = typeof data2 === "string" ? parseInt(data2, 10) : NaN;
    switch (filter5) {
      case "first":
      case "lt":
        return elems;
      case "last":
        return elems.length > 0 ? [elems[elems.length - 1]] : elems;
      case "nth":
      case "eq":
        return isFinite(num) && Math.abs(num) < elems.length ? [num < 0 ? elems[elems.length + num] : elems[num]] : [];
      case "gt":
        return isFinite(num) ? elems.slice(num + 1) : [];
      case "even":
        return elems.filter(function(_, i) {
          return i % 2 === 0;
        });
      case "odd":
        return elems.filter(function(_, i) {
          return i % 2 === 1;
        });
      case "not": {
        var filtered_1 = new Set(filterParsed(data2, elems, options2));
        return elems.filter(function(e) {
          return !filtered_1.has(e);
        });
      }
    }
  }
  function filter4(selector2, elements, options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    return filterParsed((0, css_what_12.parse)(selector2), elements, options2);
  }
  exports2.filter = filter4;
  function filterParsed(selector2, elements, options2) {
    if (elements.length === 0)
      return [];
    var _a = (0, helpers_js_1.groupSelectors)(selector2), plainSelectors = _a[0], filteredSelectors = _a[1];
    var found;
    if (plainSelectors.length) {
      var filtered = filterElements(elements, plainSelectors, options2);
      if (filteredSelectors.length === 0) {
        return filtered;
      }
      if (filtered.length) {
        found = new Set(filtered);
      }
    }
    for (var i = 0; i < filteredSelectors.length && (found === null || found === void 0 ? void 0 : found.size) !== elements.length; i++) {
      var filteredSelector = filteredSelectors[i];
      var missing = found ? elements.filter(function(e) {
        return DomUtils.isTag(e) && !found.has(e);
      }) : elements;
      if (missing.length === 0)
        break;
      var filtered = filterBySelector(filteredSelector, elements, options2);
      if (filtered.length) {
        if (!found) {
          if (i === filteredSelectors.length - 1) {
            return filtered;
          }
          found = new Set(filtered);
        } else {
          filtered.forEach(function(el) {
            return found.add(el);
          });
        }
      }
    }
    return typeof found !== "undefined" ? found.size === elements.length ? elements : (
      // Filter elements to preserve order
      elements.filter(function(el) {
        return found.has(el);
      })
    ) : [];
  }
  function filterBySelector(selector2, elements, options2) {
    var _a;
    if (selector2.some(css_what_12.isTraversal)) {
      var root2 = (_a = options2.root) !== null && _a !== void 0 ? _a : (0, helpers_js_1.getDocumentRoot)(elements[0]);
      var opts = __assign2(__assign2({}, options2), {
        context: elements,
        relativeSelector: false
      });
      selector2.push(SCOPE_PSEUDO);
      return findFilterElements(root2, selector2, opts, true, elements.length);
    }
    return findFilterElements(elements, selector2, options2, false, elements.length);
  }
  function select2(selector2, root2, options2, limit2) {
    if (options2 === void 0) {
      options2 = {};
    }
    if (limit2 === void 0) {
      limit2 = Infinity;
    }
    if (typeof selector2 === "function") {
      return find2(root2, selector2);
    }
    var _a = (0, helpers_js_1.groupSelectors)((0, css_what_12.parse)(selector2)), plain = _a[0], filtered = _a[1];
    var results = filtered.map(function(sel) {
      return findFilterElements(root2, sel, options2, true, limit2);
    });
    if (plain.length) {
      results.push(findElements(root2, plain, options2, limit2));
    }
    if (results.length === 0) {
      return [];
    }
    if (results.length === 1) {
      return results[0];
    }
    return DomUtils.uniqueSort(results.reduce(function(a, b) {
      return __spreadArray2(__spreadArray2([], a, true), b, true);
    }));
  }
  exports2.select = select2;
  function findFilterElements(root2, selector2, options2, queryForSelector, totalLimit) {
    var filterIndex = selector2.findIndex(positionals_js_12.isFilter);
    var sub = selector2.slice(0, filterIndex);
    var filter5 = selector2[filterIndex];
    var partLimit = selector2.length - 1 === filterIndex ? totalLimit : Infinity;
    var limit2 = (0, positionals_js_12.getLimit)(filter5.name, filter5.data, partLimit);
    if (limit2 === 0)
      return [];
    var elemsNoLimit = sub.length === 0 && !Array.isArray(root2) ? DomUtils.getChildren(root2).filter(DomUtils.isTag) : sub.length === 0 ? (Array.isArray(root2) ? root2 : [root2]).filter(DomUtils.isTag) : queryForSelector || sub.some(css_what_12.isTraversal) ? findElements(root2, [sub], options2, limit2) : filterElements(root2, [sub], options2);
    var elems = elemsNoLimit.slice(0, limit2);
    var result = filterByPosition(filter5.name, elems, filter5.data, options2);
    if (result.length === 0 || selector2.length === filterIndex + 1) {
      return result;
    }
    var remainingSelector = selector2.slice(filterIndex + 1);
    var remainingHasTraversal = remainingSelector.some(css_what_12.isTraversal);
    if (remainingHasTraversal) {
      if ((0, css_what_12.isTraversal)(remainingSelector[0])) {
        var type3 = remainingSelector[0].type;
        if (type3 === css_what_12.SelectorType.Sibling || type3 === css_what_12.SelectorType.Adjacent) {
          result = (0, css_select_1.prepareContext)(result, DomUtils, true);
        }
        remainingSelector.unshift(UNIVERSAL_SELECTOR2);
      }
      options2 = __assign2(__assign2({}, options2), {
        // Avoid absolutizing the selector
        relativeSelector: false,
        /*
         * Add a custom root func, to make sure traversals don't match elements
         * that aren't a part of the considered tree.
         */
        rootFunc: function(el) {
          return result.includes(el);
        }
      });
    } else if (options2.rootFunc && options2.rootFunc !== boolbase$1.trueFunc) {
      options2 = __assign2(__assign2({}, options2), {
        rootFunc: boolbase$1.trueFunc
      });
    }
    return remainingSelector.some(positionals_js_12.isFilter) ? findFilterElements(result, remainingSelector, options2, false, totalLimit) : remainingHasTraversal ? (
      // Query existing elements to resolve traversal.
      findElements(result, [remainingSelector], options2, totalLimit)
    ) : (
      // If we don't have any more traversals, simply filter elements.
      filterElements(result, [remainingSelector], options2)
    );
  }
  function findElements(root2, sel, options2, limit2) {
    var query = (0, css_select_1._compileToken)(sel, options2, root2);
    return find2(root2, query, limit2);
  }
  function find2(root2, query, limit2) {
    if (limit2 === void 0) {
      limit2 = Infinity;
    }
    var elems = (0, css_select_1.prepareContext)(root2, DomUtils, query.shouldTestNextSiblings);
    return DomUtils.find(function(node2) {
      return DomUtils.isTag(node2) && query(node2);
    }, elems, true, limit2);
  }
  function filterElements(elements, sel, options2) {
    var els = (Array.isArray(elements) ? elements : [elements]).filter(DomUtils.isTag);
    if (els.length === 0)
      return els;
    var query = (0, css_select_1._compileToken)(sel, options2);
    return query === boolbase$1.trueFunc ? els : els.filter(query);
  }
})(lib$6);
var __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$3(result, mod2, k);
  }
  __setModuleDefault$3(result, mod2);
  return result;
};
var __spreadArray$2 = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(traversing, "__esModule", {
  value: true
});
traversing.addBack = traversing.add = traversing.end = traversing.slice = traversing.index = traversing.toArray = traversing.get = traversing.eq = traversing.last = traversing.first = traversing.has = traversing.not = traversing.is = traversing.filterArray = traversing.filter = traversing.map = traversing.each = traversing.contents = traversing.children = traversing.siblings = traversing.prevUntil = traversing.prevAll = traversing.prev = traversing.nextUntil = traversing.nextAll = traversing.next = traversing.closest = traversing.parentsUntil = traversing.parents = traversing.parent = traversing.find = void 0;
var domhandler_1$3 = lib$a;
var select = __importStar$3(lib$6);
var utils_js_1$4 = utils$8;
var static_js_1$1 = _static;
var domutils_1$2 = lib$b;
var reSiblingSelector = /^\s*[~+]/;
function find$1(selectorOrHaystack) {
  var _a;
  if (!selectorOrHaystack) {
    return this._make([]);
  }
  var context = this.toArray();
  if (typeof selectorOrHaystack !== "string") {
    var haystack = (0, utils_js_1$4.isCheerio)(selectorOrHaystack) ? selectorOrHaystack.toArray() : [selectorOrHaystack];
    return this._make(haystack.filter(function(elem) {
      return context.some(function(node2) {
        return (0, static_js_1$1.contains)(node2, elem);
      });
    }));
  }
  var elems = reSiblingSelector.test(selectorOrHaystack) ? context : this.children().toArray();
  var options2 = {
    context,
    root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(select.select(selectorOrHaystack, elems, options2));
}
traversing.find = find$1;
function _getMatcher(matchMap) {
  return function(fn) {
    var postFns = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      postFns[_i - 1] = arguments[_i];
    }
    return function(selector2) {
      var _a;
      var matched = matchMap(fn, this);
      if (selector2) {
        matched = filterArray(matched, selector2, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]);
      }
      return this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && matched.length > 1 ? postFns.reduce(function(elems, fn2) {
          return fn2(elems);
        }, matched) : matched
      );
    };
  };
}
var _matcher = _getMatcher(function(fn, elems) {
  var _a;
  var ret = [];
  for (var i = 0; i < elems.length; i++) {
    var value2 = fn(elems[i]);
    ret.push(value2);
  }
  return (_a = new Array()).concat.apply(_a, ret);
});
var _singleMatcher = _getMatcher(function(fn, elems) {
  var ret = [];
  for (var i = 0; i < elems.length; i++) {
    var value2 = fn(elems[i]);
    if (value2 !== null) {
      ret.push(value2);
    }
  }
  return ret;
});
function _matchUntil(nextElem) {
  var postFns = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    postFns[_i - 1] = arguments[_i];
  }
  var matches = null;
  var innerMatcher = _getMatcher(function(nextElem2, elems) {
    var matched = [];
    (0, utils_js_1$4.domEach)(elems, function(elem) {
      for (var next_1; next_1 = nextElem2(elem); elem = next_1) {
        if (matches === null || matches === void 0 ? void 0 : matches(next_1, matched.length))
          break;
        matched.push(next_1);
      }
    });
    return matched;
  }).apply(void 0, __spreadArray$2([nextElem], postFns, false));
  return function(selector2, filterSelector) {
    var _this = this;
    matches = typeof selector2 === "string" ? function(elem) {
      return select.is(elem, selector2, _this.options);
    } : selector2 ? getFilterFn(selector2) : null;
    var ret = innerMatcher.call(this, filterSelector);
    matches = null;
    return ret;
  };
}
function _removeDuplicates(elems) {
  return Array.from(new Set(elems));
}
traversing.parent = _singleMatcher(function(_a) {
  var parent = _a.parent;
  return parent && !(0, domhandler_1$3.isDocument)(parent) ? parent : null;
}, _removeDuplicates);
traversing.parents = _matcher(function(elem) {
  var matched = [];
  while (elem.parent && !(0, domhandler_1$3.isDocument)(elem.parent)) {
    matched.push(elem.parent);
    elem = elem.parent;
  }
  return matched;
}, domutils_1$2.uniqueSort, function(elems) {
  return elems.reverse();
});
traversing.parentsUntil = _matchUntil(function(_a) {
  var parent = _a.parent;
  return parent && !(0, domhandler_1$3.isDocument)(parent) ? parent : null;
}, domutils_1$2.uniqueSort, function(elems) {
  return elems.reverse();
});
function closest(selector2) {
  var _a;
  var set2 = [];
  if (!selector2) {
    return this._make(set2);
  }
  var selectOpts = {
    xmlMode: this.options.xmlMode,
    root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]
  };
  var selectFn = typeof selector2 === "string" ? function(elem) {
    return select.is(elem, selector2, selectOpts);
  } : getFilterFn(selector2);
  (0, utils_js_1$4.domEach)(this, function(elem) {
    while (elem && (0, utils_js_1$4.isTag)(elem)) {
      if (selectFn(elem, 0)) {
        if (!set2.includes(elem)) {
          set2.push(elem);
        }
        break;
      }
      elem = elem.parent;
    }
  });
  return this._make(set2);
}
traversing.closest = closest;
traversing.next = _singleMatcher(function(elem) {
  return (0, domutils_1$2.nextElementSibling)(elem);
});
traversing.nextAll = _matcher(function(elem) {
  var matched = [];
  while (elem.next) {
    elem = elem.next;
    if ((0, utils_js_1$4.isTag)(elem))
      matched.push(elem);
  }
  return matched;
}, _removeDuplicates);
traversing.nextUntil = _matchUntil(function(el) {
  return (0, domutils_1$2.nextElementSibling)(el);
}, _removeDuplicates);
traversing.prev = _singleMatcher(function(elem) {
  return (0, domutils_1$2.prevElementSibling)(elem);
});
traversing.prevAll = _matcher(function(elem) {
  var matched = [];
  while (elem.prev) {
    elem = elem.prev;
    if ((0, utils_js_1$4.isTag)(elem))
      matched.push(elem);
  }
  return matched;
}, _removeDuplicates);
traversing.prevUntil = _matchUntil(function(el) {
  return (0, domutils_1$2.prevElementSibling)(el);
}, _removeDuplicates);
traversing.siblings = _matcher(function(elem) {
  return (0, domutils_1$2.getSiblings)(elem).filter(function(el) {
    return (0, utils_js_1$4.isTag)(el) && el !== elem;
  });
}, domutils_1$2.uniqueSort);
traversing.children = _matcher(function(elem) {
  return (0, domutils_1$2.getChildren)(elem).filter(utils_js_1$4.isTag);
}, _removeDuplicates);
function contents() {
  var elems = this.toArray().reduce(function(newElems, elem) {
    return (0, domhandler_1$3.hasChildren)(elem) ? newElems.concat(elem.children) : newElems;
  }, []);
  return this._make(elems);
}
traversing.contents = contents;
function each$1(fn) {
  var i = 0;
  var len = this.length;
  while (i < len && fn.call(this[i], i, this[i]) !== false)
    ++i;
  return this;
}
traversing.each = each$1;
function map$4(fn) {
  var elems = [];
  for (var i = 0; i < this.length; i++) {
    var el = this[i];
    var val2 = fn.call(el, i, el);
    if (val2 != null) {
      elems = elems.concat(val2);
    }
  }
  return this._make(elems);
}
traversing.map = map$4;
function getFilterFn(match) {
  if (typeof match === "function") {
    return function(el, i) {
      return match.call(el, i, el);
    };
  }
  if ((0, utils_js_1$4.isCheerio)(match)) {
    return function(el) {
      return Array.prototype.includes.call(match, el);
    };
  }
  return function(el) {
    return match === el;
  };
}
function filter$1(match) {
  var _a;
  return this._make(filterArray(this.toArray(), match, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]));
}
traversing.filter = filter$1;
function filterArray(nodes, match, xmlMode, root2) {
  return typeof match === "string" ? select.filter(match, nodes, {
    xmlMode,
    root: root2
  }) : nodes.filter(getFilterFn(match));
}
traversing.filterArray = filterArray;
function is2(selector2) {
  var nodes = this.toArray();
  return typeof selector2 === "string" ? select.some(nodes.filter(utils_js_1$4.isTag), selector2, this.options) : selector2 ? nodes.some(getFilterFn(selector2)) : false;
}
traversing.is = is2;
function not$1(match) {
  var nodes = this.toArray();
  if (typeof match === "string") {
    var matches_1 = new Set(select.filter(match, nodes, this.options));
    nodes = nodes.filter(function(el) {
      return !matches_1.has(el);
    });
  } else {
    var filterFn_1 = getFilterFn(match);
    nodes = nodes.filter(function(el, i) {
      return !filterFn_1(el, i);
    });
  }
  return this._make(nodes);
}
traversing.not = not$1;
function has(selectorOrHaystack) {
  var _this = this;
  return this.filter(typeof selectorOrHaystack === "string" ? (
    // Using the `:has` selector here short-circuits searches.
    ":has(".concat(selectorOrHaystack, ")")
  ) : function(_, el) {
    return _this._make(el).find(selectorOrHaystack).length > 0;
  });
}
traversing.has = has;
function first() {
  return this.length > 1 ? this._make(this[0]) : this;
}
traversing.first = first;
function last() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
traversing.last = last;
function eq$1(i) {
  var _a;
  i = +i;
  if (i === 0 && this.length <= 1)
    return this;
  if (i < 0)
    i = this.length + i;
  return this._make((_a = this[i]) !== null && _a !== void 0 ? _a : []);
}
traversing.eq = eq$1;
function get$6(i) {
  if (i == null) {
    return this.toArray();
  }
  return this[i < 0 ? this.length + i : i];
}
traversing.get = get$6;
function toArray() {
  return Array.prototype.slice.call(this);
}
traversing.toArray = toArray;
function index$1(selectorOrNeedle) {
  var $haystack;
  var needle;
  if (selectorOrNeedle == null) {
    $haystack = this.parent().children();
    needle = this[0];
  } else if (typeof selectorOrNeedle === "string") {
    $haystack = this._make(selectorOrNeedle);
    needle = this[0];
  } else {
    $haystack = this;
    needle = (0, utils_js_1$4.isCheerio)(selectorOrNeedle) ? selectorOrNeedle[0] : selectorOrNeedle;
  }
  return Array.prototype.indexOf.call($haystack, needle);
}
traversing.index = index$1;
function slice$2(start2, end2) {
  return this._make(Array.prototype.slice.call(this, start2, end2));
}
traversing.slice = slice$2;
function end$1() {
  var _a;
  return (_a = this.prevObject) !== null && _a !== void 0 ? _a : this._make([]);
}
traversing.end = end$1;
function add2(other, context) {
  var selection2 = this._make(other, context);
  var contents2 = (0, domutils_1$2.uniqueSort)(__spreadArray$2(__spreadArray$2([], this.get(), true), selection2.get(), true));
  return this._make(contents2);
}
traversing.add = add2;
function addBack(selector2) {
  return this.prevObject ? this.add(selector2 ? this.prevObject.filter(selector2) : this.prevObject) : this;
}
traversing.addBack = addBack;
var manipulation = {};
var parse$1 = {};
Object.defineProperty(parse$1, "__esModule", {
  value: true
});
parse$1.update = parse$1.getParse = void 0;
var domutils_1$1 = lib$b;
var domhandler_1$2 = lib$a;
function getParse(parser2) {
  return function parse2(content, options2, isDocument2, context) {
    if (typeof Buffer !== "undefined" && Buffer.isBuffer(content)) {
      content = content.toString();
    }
    if (typeof content === "string") {
      return parser2(content, options2, isDocument2, context);
    }
    var doc = content;
    if (!Array.isArray(doc) && (0, domhandler_1$2.isDocument)(doc)) {
      return doc;
    }
    var root2 = new domhandler_1$2.Document([]);
    update(doc, root2);
    return root2;
  };
}
parse$1.getParse = getParse;
function update(newChilds, parent) {
  var arr = Array.isArray(newChilds) ? newChilds : [newChilds];
  if (parent) {
    parent.children = arr;
  } else {
    parent = null;
  }
  for (var i = 0; i < arr.length; i++) {
    var node2 = arr[i];
    if (node2.parent && node2.parent.children !== arr) {
      (0, domutils_1$1.removeElement)(node2);
    }
    if (parent) {
      node2.prev = arr[i - 1] || null;
      node2.next = arr[i + 1] || null;
    } else {
      node2.prev = node2.next = null;
    }
    node2.parent = parent;
  }
  return parent;
}
parse$1.update = update;
var __spreadArray$1 = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(manipulation, "__esModule", {
  value: true
});
manipulation.clone = manipulation.text = manipulation.toString = manipulation.html = manipulation.empty = manipulation.replaceWith = manipulation.remove = manipulation.insertBefore = manipulation.before = manipulation.insertAfter = manipulation.after = manipulation.wrapAll = manipulation.unwrap = manipulation.wrapInner = manipulation.wrap = manipulation.prepend = manipulation.append = manipulation.prependTo = manipulation.appendTo = manipulation._makeDomArray = void 0;
var domhandler_1$1 = lib$a;
var parse_js_1 = parse$1;
var static_js_1 = _static;
var utils_js_1$3 = utils$8;
var domutils_1 = lib$b;
function _makeDomArray(elem, clone4) {
  var _this = this;
  if (elem == null) {
    return [];
  }
  if ((0, utils_js_1$3.isCheerio)(elem)) {
    return clone4 ? (0, utils_js_1$3.cloneDom)(elem.get()) : elem.get();
  }
  if (Array.isArray(elem)) {
    return elem.reduce(function(newElems, el) {
      return newElems.concat(_this._makeDomArray(el, clone4));
    }, []);
  }
  if (typeof elem === "string") {
    return this._parse(elem, this.options, false, null).children;
  }
  return clone4 ? (0, utils_js_1$3.cloneDom)([elem]) : [elem];
}
manipulation._makeDomArray = _makeDomArray;
function _insert(concatenator) {
  return function() {
    var _this = this;
    var elems = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      elems[_i] = arguments[_i];
    }
    var lastIdx = this.length - 1;
    return (0, utils_js_1$3.domEach)(this, function(el, i) {
      if (!(0, domhandler_1$1.hasChildren)(el))
        return;
      var domSrc = typeof elems[0] === "function" ? elems[0].call(el, i, _this._render(el.children)) : elems;
      var dom = _this._makeDomArray(domSrc, i < lastIdx);
      concatenator(dom, el.children, el);
    });
  };
}
function uniqueSplice(array2, spliceIdx, spliceCount, newElems, parent) {
  var _a, _b;
  var spliceArgs = __spreadArray$1([spliceIdx, spliceCount], newElems, true);
  var prev = spliceIdx === 0 ? null : array2[spliceIdx - 1];
  var next = spliceIdx + spliceCount >= array2.length ? null : array2[spliceIdx + spliceCount];
  for (var idx = 0; idx < newElems.length; ++idx) {
    var node2 = newElems[idx];
    var oldParent = node2.parent;
    if (oldParent) {
      var oldSiblings = oldParent.children;
      var prevIdx = oldSiblings.indexOf(node2);
      if (prevIdx > -1) {
        oldParent.children.splice(prevIdx, 1);
        if (parent === oldParent && spliceIdx > prevIdx) {
          spliceArgs[0]--;
        }
      }
    }
    node2.parent = parent;
    if (node2.prev) {
      node2.prev.next = (_a = node2.next) !== null && _a !== void 0 ? _a : null;
    }
    if (node2.next) {
      node2.next.prev = (_b = node2.prev) !== null && _b !== void 0 ? _b : null;
    }
    node2.prev = idx === 0 ? prev : newElems[idx - 1];
    node2.next = idx === newElems.length - 1 ? next : newElems[idx + 1];
  }
  if (prev) {
    prev.next = newElems[0];
  }
  if (next) {
    next.prev = newElems[newElems.length - 1];
  }
  return array2.splice.apply(array2, spliceArgs);
}
function appendTo(target) {
  var appendTarget = (0, utils_js_1$3.isCheerio)(target) ? target : this._make(target);
  appendTarget.append(this);
  return this;
}
manipulation.appendTo = appendTo;
function prependTo(target) {
  var prependTarget = (0, utils_js_1$3.isCheerio)(target) ? target : this._make(target);
  prependTarget.prepend(this);
  return this;
}
manipulation.prependTo = prependTo;
manipulation.append = _insert(function(dom, children3, parent) {
  uniqueSplice(children3, children3.length, 0, dom, parent);
});
manipulation.prepend = _insert(function(dom, children3, parent) {
  uniqueSplice(children3, 0, 0, dom, parent);
});
function _wrap(insert) {
  return function(wrapper2) {
    var lastIdx = this.length - 1;
    var lastParent = this.parents().last();
    for (var i = 0; i < this.length; i++) {
      var el = this[i];
      var wrap_1 = typeof wrapper2 === "function" ? wrapper2.call(el, i, el) : typeof wrapper2 === "string" && !(0, utils_js_1$3.isHtml)(wrapper2) ? lastParent.find(wrapper2).clone() : wrapper2;
      var wrapperDom = this._makeDomArray(wrap_1, i < lastIdx)[0];
      if (!wrapperDom || !(0, domhandler_1$1.hasChildren)(wrapperDom))
        continue;
      var elInsertLocation = wrapperDom;
      var j = 0;
      while (j < elInsertLocation.children.length) {
        var child = elInsertLocation.children[j];
        if ((0, utils_js_1$3.isTag)(child)) {
          elInsertLocation = child;
          j = 0;
        } else {
          j++;
        }
      }
      insert(el, elInsertLocation, [wrapperDom]);
    }
    return this;
  };
}
manipulation.wrap = _wrap(function(el, elInsertLocation, wrapperDom) {
  var parent = el.parent;
  if (!parent)
    return;
  var siblings = parent.children;
  var index2 = siblings.indexOf(el);
  (0, parse_js_1.update)([el], elInsertLocation);
  uniqueSplice(siblings, index2, 0, wrapperDom, parent);
});
manipulation.wrapInner = _wrap(function(el, elInsertLocation, wrapperDom) {
  if (!(0, domhandler_1$1.hasChildren)(el))
    return;
  (0, parse_js_1.update)(el.children, elInsertLocation);
  (0, parse_js_1.update)(wrapperDom, el);
});
function unwrap$1(selector2) {
  var _this = this;
  this.parent(selector2).not("body").each(function(_, el) {
    _this._make(el).replaceWith(el.children);
  });
  return this;
}
manipulation.unwrap = unwrap$1;
function wrapAll(wrapper2) {
  var el = this[0];
  if (el) {
    var wrap_2 = this._make(typeof wrapper2 === "function" ? wrapper2.call(el, 0, el) : wrapper2).insertBefore(el);
    var elInsertLocation = void 0;
    for (var i = 0; i < wrap_2.length; i++) {
      if (wrap_2[i].type === "tag")
        elInsertLocation = wrap_2[i];
    }
    var j = 0;
    while (elInsertLocation && j < elInsertLocation.children.length) {
      var child = elInsertLocation.children[j];
      if (child.type === "tag") {
        elInsertLocation = child;
        j = 0;
      } else {
        j++;
      }
    }
    if (elInsertLocation)
      this._make(elInsertLocation).append(this);
  }
  return this;
}
manipulation.wrapAll = wrapAll;
function after() {
  var _this = this;
  var elems = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    elems[_i] = arguments[_i];
  }
  var lastIdx = this.length - 1;
  return (0, utils_js_1$3.domEach)(this, function(el, i) {
    var parent = el.parent;
    if (!(0, domhandler_1$1.hasChildren)(el) || !parent) {
      return;
    }
    var siblings = parent.children;
    var index2 = siblings.indexOf(el);
    if (index2 < 0)
      return;
    var domSrc = typeof elems[0] === "function" ? elems[0].call(el, i, _this._render(el.children)) : elems;
    var dom = _this._makeDomArray(domSrc, i < lastIdx);
    uniqueSplice(siblings, index2 + 1, 0, dom, parent);
  });
}
manipulation.after = after;
function insertAfter(target) {
  var _this = this;
  if (typeof target === "string") {
    target = this._make(target);
  }
  this.remove();
  var clones = [];
  this._makeDomArray(target).forEach(function(el) {
    var clonedSelf = _this.clone().toArray();
    var parent = el.parent;
    if (!parent) {
      return;
    }
    var siblings = parent.children;
    var index2 = siblings.indexOf(el);
    if (index2 < 0)
      return;
    uniqueSplice(siblings, index2 + 1, 0, clonedSelf, parent);
    clones.push.apply(clones, clonedSelf);
  });
  return this._make(clones);
}
manipulation.insertAfter = insertAfter;
function before() {
  var _this = this;
  var elems = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    elems[_i] = arguments[_i];
  }
  var lastIdx = this.length - 1;
  return (0, utils_js_1$3.domEach)(this, function(el, i) {
    var parent = el.parent;
    if (!(0, domhandler_1$1.hasChildren)(el) || !parent) {
      return;
    }
    var siblings = parent.children;
    var index2 = siblings.indexOf(el);
    if (index2 < 0)
      return;
    var domSrc = typeof elems[0] === "function" ? elems[0].call(el, i, _this._render(el.children)) : elems;
    var dom = _this._makeDomArray(domSrc, i < lastIdx);
    uniqueSplice(siblings, index2, 0, dom, parent);
  });
}
manipulation.before = before;
function insertBefore(target) {
  var _this = this;
  var targetArr = this._make(target);
  this.remove();
  var clones = [];
  (0, utils_js_1$3.domEach)(targetArr, function(el) {
    var clonedSelf = _this.clone().toArray();
    var parent = el.parent;
    if (!parent) {
      return;
    }
    var siblings = parent.children;
    var index2 = siblings.indexOf(el);
    if (index2 < 0)
      return;
    uniqueSplice(siblings, index2, 0, clonedSelf, parent);
    clones.push.apply(clones, clonedSelf);
  });
  return this._make(clones);
}
manipulation.insertBefore = insertBefore;
function remove$1(selector2) {
  var elems = selector2 ? this.filter(selector2) : this;
  (0, utils_js_1$3.domEach)(elems, function(el) {
    (0, domutils_1.removeElement)(el);
    el.prev = el.next = el.parent = null;
  });
  return this;
}
manipulation.remove = remove$1;
function replaceWith(content) {
  var _this = this;
  return (0, utils_js_1$3.domEach)(this, function(el, i) {
    var parent = el.parent;
    if (!parent) {
      return;
    }
    var siblings = parent.children;
    var cont = typeof content === "function" ? content.call(el, i, el) : content;
    var dom = _this._makeDomArray(cont);
    (0, parse_js_1.update)(dom, null);
    var index2 = siblings.indexOf(el);
    uniqueSplice(siblings, index2, 1, dom, parent);
    if (!dom.includes(el)) {
      el.parent = el.prev = el.next = null;
    }
  });
}
manipulation.replaceWith = replaceWith;
function empty() {
  return (0, utils_js_1$3.domEach)(this, function(el) {
    if (!(0, domhandler_1$1.hasChildren)(el))
      return;
    el.children.forEach(function(child) {
      child.next = child.prev = child.parent = null;
    });
    el.children.length = 0;
  });
}
manipulation.empty = empty;
function html$3(str) {
  var _this = this;
  if (str === void 0) {
    var el = this[0];
    if (!el || !(0, domhandler_1$1.hasChildren)(el))
      return null;
    return this._render(el.children);
  }
  return (0, utils_js_1$3.domEach)(this, function(el2) {
    if (!(0, domhandler_1$1.hasChildren)(el2))
      return;
    el2.children.forEach(function(child) {
      child.next = child.prev = child.parent = null;
    });
    var content = (0, utils_js_1$3.isCheerio)(str) ? str.toArray() : _this._parse("".concat(str), _this.options, false, el2).children;
    (0, parse_js_1.update)(content, el2);
  });
}
manipulation.html = html$3;
function toString$5() {
  return this._render(this);
}
manipulation.toString = toString$5;
function text$1(str) {
  var _this = this;
  if (str === void 0) {
    return (0, static_js_1.text)(this);
  }
  if (typeof str === "function") {
    return (0, utils_js_1$3.domEach)(this, function(el, i) {
      return _this._make(el).text(str.call(el, i, (0, static_js_1.text)([el])));
    });
  }
  return (0, utils_js_1$3.domEach)(this, function(el) {
    if (!(0, domhandler_1$1.hasChildren)(el))
      return;
    el.children.forEach(function(child) {
      child.next = child.prev = child.parent = null;
    });
    var textNode = new domhandler_1$1.Text("".concat(str));
    (0, parse_js_1.update)(textNode, el);
  });
}
manipulation.text = text$1;
function clone() {
  return this._make((0, utils_js_1$3.cloneDom)(this.get()));
}
manipulation.clone = clone;
var css$2 = {};
Object.defineProperty(css$2, "__esModule", {
  value: true
});
css$2.css = void 0;
var utils_js_1$2 = utils$8;
function css$1(prop2, val2) {
  if (prop2 != null && val2 != null || // When `prop` is a "plain" object
  typeof prop2 === "object" && !Array.isArray(prop2)) {
    return (0, utils_js_1$2.domEach)(this, function(el, i) {
      if ((0, utils_js_1$2.isTag)(el)) {
        setCss(el, prop2, val2, i);
      }
    });
  }
  if (this.length === 0) {
    return void 0;
  }
  return getCss(this[0], prop2);
}
css$2.css = css$1;
function setCss(el, prop2, value2, idx) {
  if (typeof prop2 === "string") {
    var styles2 = getCss(el);
    var val2 = typeof value2 === "function" ? value2.call(el, idx, styles2[prop2]) : value2;
    if (val2 === "") {
      delete styles2[prop2];
    } else if (val2 != null) {
      styles2[prop2] = val2;
    }
    el.attribs["style"] = stringify(styles2);
  } else if (typeof prop2 === "object") {
    Object.keys(prop2).forEach(function(k, i) {
      setCss(el, k, prop2[k], i);
    });
  }
}
function getCss(el, prop2) {
  if (!el || !(0, utils_js_1$2.isTag)(el))
    return;
  var styles2 = parse(el.attribs["style"]);
  if (typeof prop2 === "string") {
    return styles2[prop2];
  }
  if (Array.isArray(prop2)) {
    var newStyles_1 = {};
    prop2.forEach(function(item) {
      if (styles2[item] != null) {
        newStyles_1[item] = styles2[item];
      }
    });
    return newStyles_1;
  }
  return styles2;
}
function stringify(obj) {
  return Object.keys(obj).reduce(function(str, prop2) {
    return "".concat(str).concat(str ? " " : "").concat(prop2, ": ").concat(obj[prop2], ";");
  }, "");
}
function parse(styles2) {
  styles2 = (styles2 || "").trim();
  if (!styles2)
    return {};
  var obj = {};
  var key;
  for (var _i = 0, _a = styles2.split(";"); _i < _a.length; _i++) {
    var str = _a[_i];
    var n = str.indexOf(":");
    if (n < 1 || n === str.length - 1) {
      var trimmed = str.trimEnd();
      if (trimmed.length > 0 && key !== void 0) {
        obj[key] += ";".concat(trimmed);
      }
    } else {
      key = str.slice(0, n).trim();
      obj[key] = str.slice(n + 1).trim();
    }
  }
  return obj;
}
var forms = {};
Object.defineProperty(forms, "__esModule", {
  value: true
});
forms.serializeArray = forms.serialize = void 0;
var utils_js_1$1 = utils$8;
var submittableSelector = "input,select,textarea,keygen";
var r20 = /%20/g;
var rCRLF = /\r?\n/g;
function serialize$2() {
  var arr = this.serializeArray();
  var retArr = arr.map(function(data2) {
    return "".concat(encodeURIComponent(data2.name), "=").concat(encodeURIComponent(data2.value));
  });
  return retArr.join("&").replace(r20, "+");
}
forms.serialize = serialize$2;
function serializeArray() {
  var _this = this;
  return this.map(function(_, elem) {
    var $elem = _this._make(elem);
    if ((0, utils_js_1$1.isTag)(elem) && elem.name === "form") {
      return $elem.find(submittableSelector).toArray();
    }
    return $elem.filter(submittableSelector).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
    // Convert each of the elements to its value(s)
  ).map(function(_, elem) {
    var _a;
    var $elem = _this._make(elem);
    var name = $elem.attr("name");
    var value2 = (_a = $elem.val()) !== null && _a !== void 0 ? _a : "";
    if (Array.isArray(value2)) {
      return value2.map(function(val2) {
        return {
          name,
          value: val2.replace(rCRLF, "\r\n")
        };
      });
    }
    return {
      name,
      value: value2.replace(rCRLF, "\r\n")
    };
  }).toArray();
}
forms.serializeArray = serializeArray;
var __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$2(result, mod2, k);
  }
  __setModuleDefault$2(result, mod2);
  return result;
};
Object.defineProperty(cheerio, "__esModule", {
  value: true
});
cheerio.Cheerio = void 0;
var Attributes = __importStar$2(attributes$2);
var Traversing = __importStar$2(traversing);
var Manipulation = __importStar$2(manipulation);
var Css = __importStar$2(css$2);
var Forms = __importStar$2(forms);
var Cheerio = (
  /** @class */
  /* @__PURE__ */ function() {
    function Cheerio2(elements, root2, options2) {
      this.length = 0;
      this.options = options2;
      this._root = root2;
      if (elements) {
        for (var idx = 0; idx < elements.length; idx++) {
          this[idx] = elements[idx];
        }
        this.length = elements.length;
      }
    }
    return Cheerio2;
  }()
);
cheerio.Cheerio = Cheerio;
Cheerio.prototype.cheerio = "[cheerio object]";
Cheerio.prototype.splice = Array.prototype.splice;
Cheerio.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(Cheerio.prototype, Attributes, Traversing, Manipulation, Css, Forms);
var __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$1(result, mod2, k);
  }
  __setModuleDefault$1(result, mod2);
  return result;
};
Object.defineProperty(load, "__esModule", {
  value: true
});
load.getLoad = void 0;
var options_js_1 = __importStar$1(options);
var staticMethods = __importStar$1(_static);
var cheerio_js_1 = cheerio;
var utils_js_1 = utils$8;
function getLoad(parse2, render3) {
  return function load2(content, options2, isDocument2) {
    if (isDocument2 === void 0) {
      isDocument2 = true;
    }
    if (content == null) {
      throw new Error("cheerio.load() expects a string");
    }
    var internalOpts = __assign(__assign({}, options_js_1.default), (0, options_js_1.flatten)(options2));
    var initialRoot = parse2(content, internalOpts, isDocument2, null);
    var LoadedCheerio = (
      /** @class */
      function(_super) {
        __extends(LoadedCheerio2, _super);
        function LoadedCheerio2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        LoadedCheerio2.prototype._make = function(selector2, context) {
          var cheerio2 = initialize(selector2, context);
          cheerio2.prevObject = this;
          return cheerio2;
        };
        LoadedCheerio2.prototype._parse = function(content2, options3, isDocument3, context) {
          return parse2(content2, options3, isDocument3, context);
        };
        LoadedCheerio2.prototype._render = function(dom) {
          return render3(dom, this.options);
        };
        return LoadedCheerio2;
      }(cheerio_js_1.Cheerio)
    );
    function initialize(selector2, context, root2, opts) {
      if (root2 === void 0) {
        root2 = initialRoot;
      }
      if (selector2 && (0, utils_js_1.isCheerio)(selector2))
        return selector2;
      var options3 = __assign(__assign({}, internalOpts), (0, options_js_1.flatten)(opts));
      var r2 = typeof root2 === "string" ? [parse2(root2, options3, false, null)] : "length" in root2 ? root2 : [root2];
      var rootInstance = (0, utils_js_1.isCheerio)(r2) ? r2 : new LoadedCheerio(r2, null, options3);
      rootInstance._root = rootInstance;
      if (!selector2) {
        return new LoadedCheerio(void 0, rootInstance, options3);
      }
      var elements = typeof selector2 === "string" && (0, utils_js_1.isHtml)(selector2) ? (
        // $(<html>)
        parse2(selector2, options3, false, null).children
      ) : isNode(selector2) ? (
        // $(dom)
        [selector2]
      ) : Array.isArray(selector2) ? (
        // $([dom])
        selector2
      ) : void 0;
      var instance = new LoadedCheerio(elements, rootInstance, options3);
      if (elements) {
        return instance;
      }
      if (typeof selector2 !== "string") {
        throw new Error("Unexpected type of selector");
      }
      var search = selector2;
      var searchContext = !context ? (
        // If we don't have a context, maybe we have a root, from loading
        rootInstance
      ) : typeof context === "string" ? (0, utils_js_1.isHtml)(context) ? (
        // $('li', '<ul>...</ul>')
        new LoadedCheerio([parse2(context, options3, false, null)], rootInstance, options3)
      ) : (
        // $('li', 'ul')
        (search = "".concat(context, " ").concat(search), rootInstance)
      ) : (0, utils_js_1.isCheerio)(context) ? (
        // $('li', $)
        context
      ) : (
        // $('li', node), $('li', [nodes])
        new LoadedCheerio(Array.isArray(context) ? context : [context], rootInstance, options3)
      );
      if (!searchContext)
        return instance;
      return searchContext.find(search);
    }
    Object.assign(initialize, staticMethods, {
      load: load2,
      // `_root` and `_options` are used in static methods.
      _root: initialRoot,
      _options: internalOpts,
      // Add `fn` for plugins
      fn: LoadedCheerio.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: LoadedCheerio.prototype
    });
    return initialize;
  };
}
load.getLoad = getLoad;
function isNode(obj) {
  return !!obj.name || obj.type === "root" || obj.type === "text" || obj.type === "comment";
}
var parse5Adapter = {};
var cjs$2 = {};
var parser$2 = {};
var tokenizer$1 = {};
var preprocessor$1 = {};
var unicode$3 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.isUndefinedCodePoint = exports2.isControlCodePoint = exports2.getSurrogatePairCodePoint = exports2.isSurrogatePair = exports2.isSurrogate = exports2.SEQUENCES = exports2.CODE_POINTS = exports2.REPLACEMENT_CHARACTER = void 0;
  const UNDEFINED_CODE_POINTS = /* @__PURE__ */ new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]);
  exports2.REPLACEMENT_CHARACTER = "�";
  (function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["NUMBER_SIGN"] = 35] = "NUMBER_SIGN";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_F"] = 70] = "LATIN_CAPITAL_F";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_X"] = 88] = "LATIN_CAPITAL_X";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_F"] = 102] = "LATIN_SMALL_F";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_X"] = 120] = "LATIN_SMALL_X";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
    CODE_POINTS[CODE_POINTS["REPLACEMENT_CHARACTER"] = 65533] = "REPLACEMENT_CHARACTER";
  })(exports2.CODE_POINTS || (exports2.CODE_POINTS = {}));
  exports2.SEQUENCES = {
    DASH_DASH: "--",
    CDATA_START: "[CDATA[",
    DOCTYPE: "doctype",
    SCRIPT: "script",
    PUBLIC: "public",
    SYSTEM: "system"
  };
  function isSurrogate(cp) {
    return cp >= 55296 && cp <= 57343;
  }
  exports2.isSurrogate = isSurrogate;
  function isSurrogatePair(cp) {
    return cp >= 56320 && cp <= 57343;
  }
  exports2.isSurrogatePair = isSurrogatePair;
  function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
  }
  exports2.getSurrogatePairCodePoint = getSurrogatePairCodePoint;
  function isControlCodePoint(cp) {
    return cp !== 32 && cp !== 10 && cp !== 13 && cp !== 9 && cp !== 12 && cp >= 1 && cp <= 31 || cp >= 127 && cp <= 159;
  }
  exports2.isControlCodePoint = isControlCodePoint;
  function isUndefinedCodePoint(cp) {
    return cp >= 64976 && cp <= 65007 || UNDEFINED_CODE_POINTS.has(cp);
  }
  exports2.isUndefinedCodePoint = isUndefinedCodePoint;
})(unicode$3);
var errorCodes$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.ERR = void 0;
  (function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
  })(exports2.ERR || (exports2.ERR = {}));
})(errorCodes$1);
function _classCallCheck$1I(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1w(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1w(descriptor.key), descriptor);
  }
}
function _createClass$1G(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1w(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1w(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1w(arg) {
  var key = _toPrimitive$1w(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1w(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(preprocessor$1, "__esModule", {
  value: true
});
preprocessor$1.Preprocessor = void 0;
const unicode_js_1$3 = unicode$3;
const error_codes_js_1$5 = errorCodes$1;
const DEFAULT_BUFFER_WATERLINE$1 = 1 << 16;
let Preprocessor$1 = /* @__PURE__ */ function() {
  function Preprocessor2(handler) {
    _classCallCheck$1I(this, Preprocessor2);
    this.handler = handler;
    this.html = "";
    this.pos = -1;
    this.lastGapPos = -2;
    this.gapStack = [];
    this.skipNextNewLine = false;
    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE$1;
    this.isEol = false;
    this.lineStartPos = 0;
    this.droppedBufferSize = 0;
    this.line = 1;
    this.lastErrOffset = -1;
  }
  _createClass$1G(Preprocessor2, [{
    key: "col",
    get: function() {
      return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
  }, {
    key: "offset",
    get: function() {
      return this.droppedBufferSize + this.pos;
    }
  }, {
    key: "getError",
    value: function getError(code2) {
      const {
        line,
        col,
        offset: offset2
      } = this;
      return {
        code: code2,
        startLine: line,
        endLine: line,
        startCol: col,
        endCol: col,
        startOffset: offset2,
        endOffset: offset2
      };
    }
  }, {
    key: "_err",
    value: function _err(code2) {
      if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
        this.lastErrOffset = this.offset;
        this.handler.onParseError(this.getError(code2));
      }
    }
  }, {
    key: "_addGap",
    value: function _addGap() {
      this.gapStack.push(this.lastGapPos);
      this.lastGapPos = this.pos;
    }
  }, {
    key: "_processSurrogate",
    value: function _processSurrogate(cp) {
      if (this.pos !== this.html.length - 1) {
        const nextCp = this.html.charCodeAt(this.pos + 1);
        if ((0, unicode_js_1$3.isSurrogatePair)(nextCp)) {
          this.pos++;
          this._addGap();
          return (0, unicode_js_1$3.getSurrogatePairCodePoint)(cp, nextCp);
        }
      } else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return unicode_js_1$3.CODE_POINTS.EOF;
      }
      this._err(error_codes_js_1$5.ERR.surrogateInInputStream);
      return cp;
    }
  }, {
    key: "willDropParsedChunk",
    value: function willDropParsedChunk() {
      return this.pos > this.bufferWaterline;
    }
  }, {
    key: "dropParsedChunk",
    value: function dropParsedChunk() {
      if (this.willDropParsedChunk()) {
        this.html = this.html.substring(this.pos);
        this.lineStartPos -= this.pos;
        this.droppedBufferSize += this.pos;
        this.pos = 0;
        this.lastGapPos = -2;
        this.gapStack.length = 0;
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk) {
      if (this.html.length > 0) {
        this.html += chunk;
      } else {
        this.html = chunk;
      }
      this.endOfChunkHit = false;
      this.lastChunkWritten = isLastChunk;
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
      this.endOfChunkHit = false;
    }
  }, {
    key: "startsWith",
    value: function startsWith(pattern2, caseSensitive) {
      if (this.pos + pattern2.length > this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return false;
      }
      if (caseSensitive) {
        return this.html.startsWith(pattern2, this.pos);
      }
      for (let i = 0; i < pattern2.length; i++) {
        const cp = this.html.charCodeAt(this.pos + i) | 32;
        if (cp !== pattern2.charCodeAt(i)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "peek",
    value: function peek(offset2) {
      const pos = this.pos + offset2;
      if (pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return unicode_js_1$3.CODE_POINTS.EOF;
      }
      const code2 = this.html.charCodeAt(pos);
      return code2 === unicode_js_1$3.CODE_POINTS.CARRIAGE_RETURN ? unicode_js_1$3.CODE_POINTS.LINE_FEED : code2;
    }
  }, {
    key: "advance",
    value: function advance() {
      this.pos++;
      if (this.isEol) {
        this.isEol = false;
        this.line++;
        this.lineStartPos = this.pos;
      }
      if (this.pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return unicode_js_1$3.CODE_POINTS.EOF;
      }
      let cp = this.html.charCodeAt(this.pos);
      if (cp === unicode_js_1$3.CODE_POINTS.CARRIAGE_RETURN) {
        this.isEol = true;
        this.skipNextNewLine = true;
        return unicode_js_1$3.CODE_POINTS.LINE_FEED;
      }
      if (cp === unicode_js_1$3.CODE_POINTS.LINE_FEED) {
        this.isEol = true;
        if (this.skipNextNewLine) {
          this.line--;
          this.skipNextNewLine = false;
          this._addGap();
          return this.advance();
        }
      }
      this.skipNextNewLine = false;
      if ((0, unicode_js_1$3.isSurrogate)(cp)) {
        cp = this._processSurrogate(cp);
      }
      const isCommonValidRange = this.handler.onParseError === null || cp > 31 && cp < 127 || cp === unicode_js_1$3.CODE_POINTS.LINE_FEED || cp === unicode_js_1$3.CODE_POINTS.CARRIAGE_RETURN || cp > 159 && cp < 64976;
      if (!isCommonValidRange) {
        this._checkForProblematicCharacters(cp);
      }
      return cp;
    }
  }, {
    key: "_checkForProblematicCharacters",
    value: function _checkForProblematicCharacters(cp) {
      if ((0, unicode_js_1$3.isControlCodePoint)(cp)) {
        this._err(error_codes_js_1$5.ERR.controlCharacterInInputStream);
      } else if ((0, unicode_js_1$3.isUndefinedCodePoint)(cp)) {
        this._err(error_codes_js_1$5.ERR.noncharacterInInputStream);
      }
    }
  }, {
    key: "retreat",
    value: function retreat(count2) {
      this.pos -= count2;
      while (this.pos < this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
      }
      this.isEol = false;
    }
  }]);
  return Preprocessor2;
}();
preprocessor$1.Preprocessor = Preprocessor$1;
var token$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.getTokenAttr = exports2.TokenType = void 0;
  (function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
  })(exports2.TokenType || (exports2.TokenType = {}));
  function getTokenAttr(token2, attrName) {
    for (let i = token2.attrs.length - 1; i >= 0; i--) {
      if (token2.attrs[i].name === attrName) {
        return token2.attrs[i].value;
      }
    }
    return null;
  }
  exports2.getTokenAttr = getTokenAttr;
})(token$1);
var html$2 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.hasUnescapedText = exports2.isNumberedHeader = exports2.SPECIAL_ELEMENTS = exports2.getTagID = exports2.TAG_ID = exports2.TAG_NAMES = exports2.DOCUMENT_MODE = exports2.ATTRS = exports2.NS = void 0;
  var NS;
  (function(NS2) {
    NS2["HTML"] = "http://www.w3.org/1999/xhtml";
    NS2["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS2["SVG"] = "http://www.w3.org/2000/svg";
    NS2["XLINK"] = "http://www.w3.org/1999/xlink";
    NS2["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS2["XMLNS"] = "http://www.w3.org/2000/xmlns/";
  })(NS = exports2.NS || (exports2.NS = {}));
  (function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
  })(exports2.ATTRS || (exports2.ATTRS = {}));
  (function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
  })(exports2.DOCUMENT_MODE || (exports2.DOCUMENT_MODE = {}));
  var TAG_NAMES;
  (function(TAG_NAMES2) {
    TAG_NAMES2["A"] = "a";
    TAG_NAMES2["ADDRESS"] = "address";
    TAG_NAMES2["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES2["APPLET"] = "applet";
    TAG_NAMES2["AREA"] = "area";
    TAG_NAMES2["ARTICLE"] = "article";
    TAG_NAMES2["ASIDE"] = "aside";
    TAG_NAMES2["B"] = "b";
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BASEFONT"] = "basefont";
    TAG_NAMES2["BGSOUND"] = "bgsound";
    TAG_NAMES2["BIG"] = "big";
    TAG_NAMES2["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["BR"] = "br";
    TAG_NAMES2["BUTTON"] = "button";
    TAG_NAMES2["CAPTION"] = "caption";
    TAG_NAMES2["CENTER"] = "center";
    TAG_NAMES2["CODE"] = "code";
    TAG_NAMES2["COL"] = "col";
    TAG_NAMES2["COLGROUP"] = "colgroup";
    TAG_NAMES2["DD"] = "dd";
    TAG_NAMES2["DESC"] = "desc";
    TAG_NAMES2["DETAILS"] = "details";
    TAG_NAMES2["DIALOG"] = "dialog";
    TAG_NAMES2["DIR"] = "dir";
    TAG_NAMES2["DIV"] = "div";
    TAG_NAMES2["DL"] = "dl";
    TAG_NAMES2["DT"] = "dt";
    TAG_NAMES2["EM"] = "em";
    TAG_NAMES2["EMBED"] = "embed";
    TAG_NAMES2["FIELDSET"] = "fieldset";
    TAG_NAMES2["FIGCAPTION"] = "figcaption";
    TAG_NAMES2["FIGURE"] = "figure";
    TAG_NAMES2["FONT"] = "font";
    TAG_NAMES2["FOOTER"] = "footer";
    TAG_NAMES2["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES2["FORM"] = "form";
    TAG_NAMES2["FRAME"] = "frame";
    TAG_NAMES2["FRAMESET"] = "frameset";
    TAG_NAMES2["H1"] = "h1";
    TAG_NAMES2["H2"] = "h2";
    TAG_NAMES2["H3"] = "h3";
    TAG_NAMES2["H4"] = "h4";
    TAG_NAMES2["H5"] = "h5";
    TAG_NAMES2["H6"] = "h6";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HEADER"] = "header";
    TAG_NAMES2["HGROUP"] = "hgroup";
    TAG_NAMES2["HR"] = "hr";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["I"] = "i";
    TAG_NAMES2["IMG"] = "img";
    TAG_NAMES2["IMAGE"] = "image";
    TAG_NAMES2["INPUT"] = "input";
    TAG_NAMES2["IFRAME"] = "iframe";
    TAG_NAMES2["KEYGEN"] = "keygen";
    TAG_NAMES2["LABEL"] = "label";
    TAG_NAMES2["LI"] = "li";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["LISTING"] = "listing";
    TAG_NAMES2["MAIN"] = "main";
    TAG_NAMES2["MALIGNMARK"] = "malignmark";
    TAG_NAMES2["MARQUEE"] = "marquee";
    TAG_NAMES2["MATH"] = "math";
    TAG_NAMES2["MENU"] = "menu";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["MGLYPH"] = "mglyph";
    TAG_NAMES2["MI"] = "mi";
    TAG_NAMES2["MO"] = "mo";
    TAG_NAMES2["MN"] = "mn";
    TAG_NAMES2["MS"] = "ms";
    TAG_NAMES2["MTEXT"] = "mtext";
    TAG_NAMES2["NAV"] = "nav";
    TAG_NAMES2["NOBR"] = "nobr";
    TAG_NAMES2["NOFRAMES"] = "noframes";
    TAG_NAMES2["NOEMBED"] = "noembed";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["OBJECT"] = "object";
    TAG_NAMES2["OL"] = "ol";
    TAG_NAMES2["OPTGROUP"] = "optgroup";
    TAG_NAMES2["OPTION"] = "option";
    TAG_NAMES2["P"] = "p";
    TAG_NAMES2["PARAM"] = "param";
    TAG_NAMES2["PLAINTEXT"] = "plaintext";
    TAG_NAMES2["PRE"] = "pre";
    TAG_NAMES2["RB"] = "rb";
    TAG_NAMES2["RP"] = "rp";
    TAG_NAMES2["RT"] = "rt";
    TAG_NAMES2["RTC"] = "rtc";
    TAG_NAMES2["RUBY"] = "ruby";
    TAG_NAMES2["S"] = "s";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["SECTION"] = "section";
    TAG_NAMES2["SELECT"] = "select";
    TAG_NAMES2["SOURCE"] = "source";
    TAG_NAMES2["SMALL"] = "small";
    TAG_NAMES2["SPAN"] = "span";
    TAG_NAMES2["STRIKE"] = "strike";
    TAG_NAMES2["STRONG"] = "strong";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["SUB"] = "sub";
    TAG_NAMES2["SUMMARY"] = "summary";
    TAG_NAMES2["SUP"] = "sup";
    TAG_NAMES2["TABLE"] = "table";
    TAG_NAMES2["TBODY"] = "tbody";
    TAG_NAMES2["TEMPLATE"] = "template";
    TAG_NAMES2["TEXTAREA"] = "textarea";
    TAG_NAMES2["TFOOT"] = "tfoot";
    TAG_NAMES2["TD"] = "td";
    TAG_NAMES2["TH"] = "th";
    TAG_NAMES2["THEAD"] = "thead";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["TR"] = "tr";
    TAG_NAMES2["TRACK"] = "track";
    TAG_NAMES2["TT"] = "tt";
    TAG_NAMES2["U"] = "u";
    TAG_NAMES2["UL"] = "ul";
    TAG_NAMES2["SVG"] = "svg";
    TAG_NAMES2["VAR"] = "var";
    TAG_NAMES2["WBR"] = "wbr";
    TAG_NAMES2["XMP"] = "xmp";
  })(TAG_NAMES = exports2.TAG_NAMES || (exports2.TAG_NAMES = {}));
  var TAG_ID;
  (function(TAG_ID2) {
    TAG_ID2[TAG_ID2["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID2[TAG_ID2["A"] = 1] = "A";
    TAG_ID2[TAG_ID2["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID2[TAG_ID2["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID2[TAG_ID2["APPLET"] = 4] = "APPLET";
    TAG_ID2[TAG_ID2["AREA"] = 5] = "AREA";
    TAG_ID2[TAG_ID2["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID2[TAG_ID2["ASIDE"] = 7] = "ASIDE";
    TAG_ID2[TAG_ID2["B"] = 8] = "B";
    TAG_ID2[TAG_ID2["BASE"] = 9] = "BASE";
    TAG_ID2[TAG_ID2["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID2[TAG_ID2["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID2[TAG_ID2["BIG"] = 12] = "BIG";
    TAG_ID2[TAG_ID2["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID2[TAG_ID2["BODY"] = 14] = "BODY";
    TAG_ID2[TAG_ID2["BR"] = 15] = "BR";
    TAG_ID2[TAG_ID2["BUTTON"] = 16] = "BUTTON";
    TAG_ID2[TAG_ID2["CAPTION"] = 17] = "CAPTION";
    TAG_ID2[TAG_ID2["CENTER"] = 18] = "CENTER";
    TAG_ID2[TAG_ID2["CODE"] = 19] = "CODE";
    TAG_ID2[TAG_ID2["COL"] = 20] = "COL";
    TAG_ID2[TAG_ID2["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID2[TAG_ID2["DD"] = 22] = "DD";
    TAG_ID2[TAG_ID2["DESC"] = 23] = "DESC";
    TAG_ID2[TAG_ID2["DETAILS"] = 24] = "DETAILS";
    TAG_ID2[TAG_ID2["DIALOG"] = 25] = "DIALOG";
    TAG_ID2[TAG_ID2["DIR"] = 26] = "DIR";
    TAG_ID2[TAG_ID2["DIV"] = 27] = "DIV";
    TAG_ID2[TAG_ID2["DL"] = 28] = "DL";
    TAG_ID2[TAG_ID2["DT"] = 29] = "DT";
    TAG_ID2[TAG_ID2["EM"] = 30] = "EM";
    TAG_ID2[TAG_ID2["EMBED"] = 31] = "EMBED";
    TAG_ID2[TAG_ID2["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID2[TAG_ID2["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID2[TAG_ID2["FIGURE"] = 34] = "FIGURE";
    TAG_ID2[TAG_ID2["FONT"] = 35] = "FONT";
    TAG_ID2[TAG_ID2["FOOTER"] = 36] = "FOOTER";
    TAG_ID2[TAG_ID2["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID2[TAG_ID2["FORM"] = 38] = "FORM";
    TAG_ID2[TAG_ID2["FRAME"] = 39] = "FRAME";
    TAG_ID2[TAG_ID2["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID2[TAG_ID2["H1"] = 41] = "H1";
    TAG_ID2[TAG_ID2["H2"] = 42] = "H2";
    TAG_ID2[TAG_ID2["H3"] = 43] = "H3";
    TAG_ID2[TAG_ID2["H4"] = 44] = "H4";
    TAG_ID2[TAG_ID2["H5"] = 45] = "H5";
    TAG_ID2[TAG_ID2["H6"] = 46] = "H6";
    TAG_ID2[TAG_ID2["HEAD"] = 47] = "HEAD";
    TAG_ID2[TAG_ID2["HEADER"] = 48] = "HEADER";
    TAG_ID2[TAG_ID2["HGROUP"] = 49] = "HGROUP";
    TAG_ID2[TAG_ID2["HR"] = 50] = "HR";
    TAG_ID2[TAG_ID2["HTML"] = 51] = "HTML";
    TAG_ID2[TAG_ID2["I"] = 52] = "I";
    TAG_ID2[TAG_ID2["IMG"] = 53] = "IMG";
    TAG_ID2[TAG_ID2["IMAGE"] = 54] = "IMAGE";
    TAG_ID2[TAG_ID2["INPUT"] = 55] = "INPUT";
    TAG_ID2[TAG_ID2["IFRAME"] = 56] = "IFRAME";
    TAG_ID2[TAG_ID2["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID2[TAG_ID2["LABEL"] = 58] = "LABEL";
    TAG_ID2[TAG_ID2["LI"] = 59] = "LI";
    TAG_ID2[TAG_ID2["LINK"] = 60] = "LINK";
    TAG_ID2[TAG_ID2["LISTING"] = 61] = "LISTING";
    TAG_ID2[TAG_ID2["MAIN"] = 62] = "MAIN";
    TAG_ID2[TAG_ID2["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID2[TAG_ID2["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID2[TAG_ID2["MATH"] = 65] = "MATH";
    TAG_ID2[TAG_ID2["MENU"] = 66] = "MENU";
    TAG_ID2[TAG_ID2["META"] = 67] = "META";
    TAG_ID2[TAG_ID2["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID2[TAG_ID2["MI"] = 69] = "MI";
    TAG_ID2[TAG_ID2["MO"] = 70] = "MO";
    TAG_ID2[TAG_ID2["MN"] = 71] = "MN";
    TAG_ID2[TAG_ID2["MS"] = 72] = "MS";
    TAG_ID2[TAG_ID2["MTEXT"] = 73] = "MTEXT";
    TAG_ID2[TAG_ID2["NAV"] = 74] = "NAV";
    TAG_ID2[TAG_ID2["NOBR"] = 75] = "NOBR";
    TAG_ID2[TAG_ID2["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID2[TAG_ID2["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID2[TAG_ID2["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID2[TAG_ID2["OBJECT"] = 79] = "OBJECT";
    TAG_ID2[TAG_ID2["OL"] = 80] = "OL";
    TAG_ID2[TAG_ID2["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID2[TAG_ID2["OPTION"] = 82] = "OPTION";
    TAG_ID2[TAG_ID2["P"] = 83] = "P";
    TAG_ID2[TAG_ID2["PARAM"] = 84] = "PARAM";
    TAG_ID2[TAG_ID2["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID2[TAG_ID2["PRE"] = 86] = "PRE";
    TAG_ID2[TAG_ID2["RB"] = 87] = "RB";
    TAG_ID2[TAG_ID2["RP"] = 88] = "RP";
    TAG_ID2[TAG_ID2["RT"] = 89] = "RT";
    TAG_ID2[TAG_ID2["RTC"] = 90] = "RTC";
    TAG_ID2[TAG_ID2["RUBY"] = 91] = "RUBY";
    TAG_ID2[TAG_ID2["S"] = 92] = "S";
    TAG_ID2[TAG_ID2["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID2[TAG_ID2["SECTION"] = 94] = "SECTION";
    TAG_ID2[TAG_ID2["SELECT"] = 95] = "SELECT";
    TAG_ID2[TAG_ID2["SOURCE"] = 96] = "SOURCE";
    TAG_ID2[TAG_ID2["SMALL"] = 97] = "SMALL";
    TAG_ID2[TAG_ID2["SPAN"] = 98] = "SPAN";
    TAG_ID2[TAG_ID2["STRIKE"] = 99] = "STRIKE";
    TAG_ID2[TAG_ID2["STRONG"] = 100] = "STRONG";
    TAG_ID2[TAG_ID2["STYLE"] = 101] = "STYLE";
    TAG_ID2[TAG_ID2["SUB"] = 102] = "SUB";
    TAG_ID2[TAG_ID2["SUMMARY"] = 103] = "SUMMARY";
    TAG_ID2[TAG_ID2["SUP"] = 104] = "SUP";
    TAG_ID2[TAG_ID2["TABLE"] = 105] = "TABLE";
    TAG_ID2[TAG_ID2["TBODY"] = 106] = "TBODY";
    TAG_ID2[TAG_ID2["TEMPLATE"] = 107] = "TEMPLATE";
    TAG_ID2[TAG_ID2["TEXTAREA"] = 108] = "TEXTAREA";
    TAG_ID2[TAG_ID2["TFOOT"] = 109] = "TFOOT";
    TAG_ID2[TAG_ID2["TD"] = 110] = "TD";
    TAG_ID2[TAG_ID2["TH"] = 111] = "TH";
    TAG_ID2[TAG_ID2["THEAD"] = 112] = "THEAD";
    TAG_ID2[TAG_ID2["TITLE"] = 113] = "TITLE";
    TAG_ID2[TAG_ID2["TR"] = 114] = "TR";
    TAG_ID2[TAG_ID2["TRACK"] = 115] = "TRACK";
    TAG_ID2[TAG_ID2["TT"] = 116] = "TT";
    TAG_ID2[TAG_ID2["U"] = 117] = "U";
    TAG_ID2[TAG_ID2["UL"] = 118] = "UL";
    TAG_ID2[TAG_ID2["SVG"] = 119] = "SVG";
    TAG_ID2[TAG_ID2["VAR"] = 120] = "VAR";
    TAG_ID2[TAG_ID2["WBR"] = 121] = "WBR";
    TAG_ID2[TAG_ID2["XMP"] = 122] = "XMP";
  })(TAG_ID = exports2.TAG_ID || (exports2.TAG_ID = {}));
  const TAG_NAME_TO_ID = /* @__PURE__ */ new Map([[TAG_NAMES.A, TAG_ID.A], [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS], [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML], [TAG_NAMES.APPLET, TAG_ID.APPLET], [TAG_NAMES.AREA, TAG_ID.AREA], [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE], [TAG_NAMES.ASIDE, TAG_ID.ASIDE], [TAG_NAMES.B, TAG_ID.B], [TAG_NAMES.BASE, TAG_ID.BASE], [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT], [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND], [TAG_NAMES.BIG, TAG_ID.BIG], [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE], [TAG_NAMES.BODY, TAG_ID.BODY], [TAG_NAMES.BR, TAG_ID.BR], [TAG_NAMES.BUTTON, TAG_ID.BUTTON], [TAG_NAMES.CAPTION, TAG_ID.CAPTION], [TAG_NAMES.CENTER, TAG_ID.CENTER], [TAG_NAMES.CODE, TAG_ID.CODE], [TAG_NAMES.COL, TAG_ID.COL], [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP], [TAG_NAMES.DD, TAG_ID.DD], [TAG_NAMES.DESC, TAG_ID.DESC], [TAG_NAMES.DETAILS, TAG_ID.DETAILS], [TAG_NAMES.DIALOG, TAG_ID.DIALOG], [TAG_NAMES.DIR, TAG_ID.DIR], [TAG_NAMES.DIV, TAG_ID.DIV], [TAG_NAMES.DL, TAG_ID.DL], [TAG_NAMES.DT, TAG_ID.DT], [TAG_NAMES.EM, TAG_ID.EM], [TAG_NAMES.EMBED, TAG_ID.EMBED], [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET], [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION], [TAG_NAMES.FIGURE, TAG_ID.FIGURE], [TAG_NAMES.FONT, TAG_ID.FONT], [TAG_NAMES.FOOTER, TAG_ID.FOOTER], [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT], [TAG_NAMES.FORM, TAG_ID.FORM], [TAG_NAMES.FRAME, TAG_ID.FRAME], [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET], [TAG_NAMES.H1, TAG_ID.H1], [TAG_NAMES.H2, TAG_ID.H2], [TAG_NAMES.H3, TAG_ID.H3], [TAG_NAMES.H4, TAG_ID.H4], [TAG_NAMES.H5, TAG_ID.H5], [TAG_NAMES.H6, TAG_ID.H6], [TAG_NAMES.HEAD, TAG_ID.HEAD], [TAG_NAMES.HEADER, TAG_ID.HEADER], [TAG_NAMES.HGROUP, TAG_ID.HGROUP], [TAG_NAMES.HR, TAG_ID.HR], [TAG_NAMES.HTML, TAG_ID.HTML], [TAG_NAMES.I, TAG_ID.I], [TAG_NAMES.IMG, TAG_ID.IMG], [TAG_NAMES.IMAGE, TAG_ID.IMAGE], [TAG_NAMES.INPUT, TAG_ID.INPUT], [TAG_NAMES.IFRAME, TAG_ID.IFRAME], [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN], [TAG_NAMES.LABEL, TAG_ID.LABEL], [TAG_NAMES.LI, TAG_ID.LI], [TAG_NAMES.LINK, TAG_ID.LINK], [TAG_NAMES.LISTING, TAG_ID.LISTING], [TAG_NAMES.MAIN, TAG_ID.MAIN], [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK], [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE], [TAG_NAMES.MATH, TAG_ID.MATH], [TAG_NAMES.MENU, TAG_ID.MENU], [TAG_NAMES.META, TAG_ID.META], [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH], [TAG_NAMES.MI, TAG_ID.MI], [TAG_NAMES.MO, TAG_ID.MO], [TAG_NAMES.MN, TAG_ID.MN], [TAG_NAMES.MS, TAG_ID.MS], [TAG_NAMES.MTEXT, TAG_ID.MTEXT], [TAG_NAMES.NAV, TAG_ID.NAV], [TAG_NAMES.NOBR, TAG_ID.NOBR], [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES], [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED], [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT], [TAG_NAMES.OBJECT, TAG_ID.OBJECT], [TAG_NAMES.OL, TAG_ID.OL], [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP], [TAG_NAMES.OPTION, TAG_ID.OPTION], [TAG_NAMES.P, TAG_ID.P], [TAG_NAMES.PARAM, TAG_ID.PARAM], [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT], [TAG_NAMES.PRE, TAG_ID.PRE], [TAG_NAMES.RB, TAG_ID.RB], [TAG_NAMES.RP, TAG_ID.RP], [TAG_NAMES.RT, TAG_ID.RT], [TAG_NAMES.RTC, TAG_ID.RTC], [TAG_NAMES.RUBY, TAG_ID.RUBY], [TAG_NAMES.S, TAG_ID.S], [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT], [TAG_NAMES.SECTION, TAG_ID.SECTION], [TAG_NAMES.SELECT, TAG_ID.SELECT], [TAG_NAMES.SOURCE, TAG_ID.SOURCE], [TAG_NAMES.SMALL, TAG_ID.SMALL], [TAG_NAMES.SPAN, TAG_ID.SPAN], [TAG_NAMES.STRIKE, TAG_ID.STRIKE], [TAG_NAMES.STRONG, TAG_ID.STRONG], [TAG_NAMES.STYLE, TAG_ID.STYLE], [TAG_NAMES.SUB, TAG_ID.SUB], [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY], [TAG_NAMES.SUP, TAG_ID.SUP], [TAG_NAMES.TABLE, TAG_ID.TABLE], [TAG_NAMES.TBODY, TAG_ID.TBODY], [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE], [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA], [TAG_NAMES.TFOOT, TAG_ID.TFOOT], [TAG_NAMES.TD, TAG_ID.TD], [TAG_NAMES.TH, TAG_ID.TH], [TAG_NAMES.THEAD, TAG_ID.THEAD], [TAG_NAMES.TITLE, TAG_ID.TITLE], [TAG_NAMES.TR, TAG_ID.TR], [TAG_NAMES.TRACK, TAG_ID.TRACK], [TAG_NAMES.TT, TAG_ID.TT], [TAG_NAMES.U, TAG_ID.U], [TAG_NAMES.UL, TAG_ID.UL], [TAG_NAMES.SVG, TAG_ID.SVG], [TAG_NAMES.VAR, TAG_ID.VAR], [TAG_NAMES.WBR, TAG_ID.WBR], [TAG_NAMES.XMP, TAG_ID.XMP]]);
  function getTagID(tagName) {
    var _a;
    return (_a = TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : TAG_ID.UNKNOWN;
  }
  exports2.getTagID = getTagID;
  const $ = TAG_ID;
  exports2.SPECIAL_ELEMENTS = {
    [NS.HTML]: /* @__PURE__ */ new Set([$.ADDRESS, $.APPLET, $.AREA, $.ARTICLE, $.ASIDE, $.BASE, $.BASEFONT, $.BGSOUND, $.BLOCKQUOTE, $.BODY, $.BR, $.BUTTON, $.CAPTION, $.CENTER, $.COL, $.COLGROUP, $.DD, $.DETAILS, $.DIR, $.DIV, $.DL, $.DT, $.EMBED, $.FIELDSET, $.FIGCAPTION, $.FIGURE, $.FOOTER, $.FORM, $.FRAME, $.FRAMESET, $.H1, $.H2, $.H3, $.H4, $.H5, $.H6, $.HEAD, $.HEADER, $.HGROUP, $.HR, $.HTML, $.IFRAME, $.IMG, $.INPUT, $.LI, $.LINK, $.LISTING, $.MAIN, $.MARQUEE, $.MENU, $.META, $.NAV, $.NOEMBED, $.NOFRAMES, $.NOSCRIPT, $.OBJECT, $.OL, $.P, $.PARAM, $.PLAINTEXT, $.PRE, $.SCRIPT, $.SECTION, $.SELECT, $.SOURCE, $.STYLE, $.SUMMARY, $.TABLE, $.TBODY, $.TD, $.TEMPLATE, $.TEXTAREA, $.TFOOT, $.TH, $.THEAD, $.TITLE, $.TR, $.TRACK, $.UL, $.WBR, $.XMP]),
    [NS.MATHML]: /* @__PURE__ */ new Set([$.MI, $.MO, $.MN, $.MS, $.MTEXT, $.ANNOTATION_XML]),
    [NS.SVG]: /* @__PURE__ */ new Set([$.TITLE, $.FOREIGN_OBJECT, $.DESC]),
    [NS.XLINK]: /* @__PURE__ */ new Set(),
    [NS.XML]: /* @__PURE__ */ new Set(),
    [NS.XMLNS]: /* @__PURE__ */ new Set()
  };
  function isNumberedHeader(tn) {
    return tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6;
  }
  exports2.isNumberedHeader = isNumberedHeader;
  const UNESCAPED_TEXT = /* @__PURE__ */ new Set([TAG_NAMES.STYLE, TAG_NAMES.SCRIPT, TAG_NAMES.XMP, TAG_NAMES.IFRAME, TAG_NAMES.NOEMBED, TAG_NAMES.NOFRAMES, TAG_NAMES.PLAINTEXT]);
  function hasUnescapedText(tn, scriptingEnabled) {
    return UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === TAG_NAMES.NOSCRIPT;
  }
  exports2.hasUnescapedText = hasUnescapedText;
})(html$2);
function _classCallCheck$1H(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1v(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1v(descriptor.key), descriptor);
  }
}
function _createClass$1F(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1v(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1v(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1v(arg) {
  var key = _toPrimitive$1v(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1v(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(tokenizer$1, "__esModule", {
  value: true
});
tokenizer$1.Tokenizer = tokenizer$1.TokenizerMode = void 0;
const preprocessor_js_1$1 = preprocessor$1;
const unicode_js_1$2 = unicode$3;
const token_js_1$3 = token$1;
const decode_js_1$2 = decode;
const error_codes_js_1$4 = errorCodes$1;
const html_js_1$9 = html$2;
const C1_CONTROLS_REFERENCE_REPLACEMENTS$1 = /* @__PURE__ */ new Map([[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
var State$1;
(function(State2) {
  State2[State2["DATA"] = 0] = "DATA";
  State2[State2["RCDATA"] = 1] = "RCDATA";
  State2[State2["RAWTEXT"] = 2] = "RAWTEXT";
  State2[State2["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
  State2[State2["PLAINTEXT"] = 4] = "PLAINTEXT";
  State2[State2["TAG_OPEN"] = 5] = "TAG_OPEN";
  State2[State2["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
  State2[State2["TAG_NAME"] = 7] = "TAG_NAME";
  State2[State2["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
  State2[State2["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
  State2[State2["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
  State2[State2["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
  State2[State2["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
  State2[State2["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
  State2[State2["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
  State2[State2["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
  State2[State2["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
  State2[State2["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
  State2[State2["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
  State2[State2["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
  State2[State2["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
  State2[State2["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
  State2[State2["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
  State2[State2["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
  State2[State2["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
  State2[State2["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
  State2[State2["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
  State2[State2["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
  State2[State2["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
  State2[State2["COMMENT_START"] = 42] = "COMMENT_START";
  State2[State2["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
  State2[State2["COMMENT"] = 44] = "COMMENT";
  State2[State2["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
  State2[State2["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
  State2[State2["COMMENT_END"] = 50] = "COMMENT_END";
  State2[State2["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
  State2[State2["DOCTYPE"] = 52] = "DOCTYPE";
  State2[State2["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
  State2[State2["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
  State2[State2["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
  State2[State2["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
  State2[State2["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
  State2[State2["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
  State2[State2["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
  State2[State2["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
  State2[State2["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
  State2[State2["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
  State2[State2["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
  State2[State2["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
  State2[State2["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
  State2[State2["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
  State2[State2["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
  State2[State2["CDATA_SECTION"] = 68] = "CDATA_SECTION";
  State2[State2["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
  State2[State2["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
  State2[State2["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
  State2[State2["NAMED_CHARACTER_REFERENCE"] = 72] = "NAMED_CHARACTER_REFERENCE";
  State2[State2["AMBIGUOUS_AMPERSAND"] = 73] = "AMBIGUOUS_AMPERSAND";
  State2[State2["NUMERIC_CHARACTER_REFERENCE"] = 74] = "NUMERIC_CHARACTER_REFERENCE";
  State2[State2["HEXADEMICAL_CHARACTER_REFERENCE_START"] = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START";
  State2[State2["HEXADEMICAL_CHARACTER_REFERENCE"] = 76] = "HEXADEMICAL_CHARACTER_REFERENCE";
  State2[State2["DECIMAL_CHARACTER_REFERENCE"] = 77] = "DECIMAL_CHARACTER_REFERENCE";
  State2[State2["NUMERIC_CHARACTER_REFERENCE_END"] = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(State$1 || (State$1 = {}));
tokenizer$1.TokenizerMode = {
  DATA: State$1.DATA,
  RCDATA: State$1.RCDATA,
  RAWTEXT: State$1.RAWTEXT,
  SCRIPT_DATA: State$1.SCRIPT_DATA,
  PLAINTEXT: State$1.PLAINTEXT,
  CDATA_SECTION: State$1.CDATA_SECTION
};
function isAsciiDigit$1(cp) {
  return cp >= unicode_js_1$2.CODE_POINTS.DIGIT_0 && cp <= unicode_js_1$2.CODE_POINTS.DIGIT_9;
}
function isAsciiUpper$1(cp) {
  return cp >= unicode_js_1$2.CODE_POINTS.LATIN_CAPITAL_A && cp <= unicode_js_1$2.CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower$1(cp) {
  return cp >= unicode_js_1$2.CODE_POINTS.LATIN_SMALL_A && cp <= unicode_js_1$2.CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter$1(cp) {
  return isAsciiLower$1(cp) || isAsciiUpper$1(cp);
}
function isAsciiAlphaNumeric$1(cp) {
  return isAsciiLetter$1(cp) || isAsciiDigit$1(cp);
}
function isAsciiUpperHexDigit$1(cp) {
  return cp >= unicode_js_1$2.CODE_POINTS.LATIN_CAPITAL_A && cp <= unicode_js_1$2.CODE_POINTS.LATIN_CAPITAL_F;
}
function isAsciiLowerHexDigit$1(cp) {
  return cp >= unicode_js_1$2.CODE_POINTS.LATIN_SMALL_A && cp <= unicode_js_1$2.CODE_POINTS.LATIN_SMALL_F;
}
function isAsciiHexDigit$1(cp) {
  return isAsciiDigit$1(cp) || isAsciiUpperHexDigit$1(cp) || isAsciiLowerHexDigit$1(cp);
}
function toAsciiLower$1(cp) {
  return cp + 32;
}
function isWhitespace$1(cp) {
  return cp === unicode_js_1$2.CODE_POINTS.SPACE || cp === unicode_js_1$2.CODE_POINTS.LINE_FEED || cp === unicode_js_1$2.CODE_POINTS.TABULATION || cp === unicode_js_1$2.CODE_POINTS.FORM_FEED;
}
function isEntityInAttributeInvalidEnd$1(nextCp) {
  return nextCp === unicode_js_1$2.CODE_POINTS.EQUALS_SIGN || isAsciiAlphaNumeric$1(nextCp);
}
function isScriptDataDoubleEscapeSequenceEnd$1(cp) {
  return isWhitespace$1(cp) || cp === unicode_js_1$2.CODE_POINTS.SOLIDUS || cp === unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN;
}
let Tokenizer$2 = /* @__PURE__ */ function() {
  function Tokenizer2(options2, handler) {
    _classCallCheck$1H(this, Tokenizer2);
    this.options = options2;
    this.handler = handler;
    this.paused = false;
    this.inLoop = false;
    this.inForeignNode = false;
    this.lastStartTagName = "";
    this.active = false;
    this.state = State$1.DATA;
    this.returnState = State$1.DATA;
    this.charRefCode = -1;
    this.consumedAfterSnapshot = -1;
    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = {
      name: "",
      value: ""
    };
    this.preprocessor = new preprocessor_js_1$1.Preprocessor(handler);
    this.currentLocation = this.getCurrentLocation(-1);
  }
  _createClass$1F(Tokenizer2, [{
    key: "_err",
    value: function _err(code2) {
      var _a, _b;
      (_b = (_a = this.handler).onParseError) === null || _b === void 0 ? void 0 : _b.call(_a, this.preprocessor.getError(code2));
    }
    // NOTE: `offset` may never run across line boundaries.
  }, {
    key: "getCurrentLocation",
    value: function getCurrentLocation(offset2) {
      if (!this.options.sourceCodeLocationInfo) {
        return null;
      }
      return {
        startLine: this.preprocessor.line,
        startCol: this.preprocessor.col - offset2,
        startOffset: this.preprocessor.offset - offset2,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
  }, {
    key: "_runParsingLoop",
    value: function _runParsingLoop() {
      if (this.inLoop)
        return;
      this.inLoop = true;
      while (this.active && !this.paused) {
        this.consumedAfterSnapshot = 0;
        const cp = this._consume();
        if (!this._ensureHibernation()) {
          this._callState(cp);
        }
      }
      this.inLoop = false;
    }
    //API
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
  }, {
    key: "resume",
    value: function resume(writeCallback) {
      if (!this.paused) {
        throw new Error("Parser was already resumed");
      }
      this.paused = false;
      if (this.inLoop)
        return;
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk, writeCallback) {
      this.active = true;
      this.preprocessor.write(chunk, isLastChunk);
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.active = true;
      this.preprocessor.insertHtmlAtCurrentPos(chunk);
      this._runParsingLoop();
    }
    //Hibernation
  }, {
    key: "_ensureHibernation",
    value: function _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        this._unconsume(this.consumedAfterSnapshot);
        this.active = false;
        return true;
      }
      return false;
    }
    //Consumption
  }, {
    key: "_consume",
    value: function _consume() {
      this.consumedAfterSnapshot++;
      return this.preprocessor.advance();
    }
  }, {
    key: "_unconsume",
    value: function _unconsume(count2) {
      this.consumedAfterSnapshot -= count2;
      this.preprocessor.retreat(count2);
    }
  }, {
    key: "_reconsumeInState",
    value: function _reconsumeInState(state, cp) {
      this.state = state;
      this._callState(cp);
    }
  }, {
    key: "_advanceBy",
    value: function _advanceBy(count2) {
      this.consumedAfterSnapshot += count2;
      for (let i = 0; i < count2; i++) {
        this.preprocessor.advance();
      }
    }
  }, {
    key: "_consumeSequenceIfMatch",
    value: function _consumeSequenceIfMatch(pattern2, caseSensitive) {
      if (this.preprocessor.startsWith(pattern2, caseSensitive)) {
        this._advanceBy(pattern2.length - 1);
        return true;
      }
      return false;
    }
    //Token creation
  }, {
    key: "_createStartTagToken",
    value: function _createStartTagToken() {
      this.currentToken = {
        type: token_js_1$3.TokenType.START_TAG,
        tagName: "",
        tagID: html_js_1$9.TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(1)
      };
    }
  }, {
    key: "_createEndTagToken",
    value: function _createEndTagToken() {
      this.currentToken = {
        type: token_js_1$3.TokenType.END_TAG,
        tagName: "",
        tagID: html_js_1$9.TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(2)
      };
    }
  }, {
    key: "_createCommentToken",
    value: function _createCommentToken(offset2) {
      this.currentToken = {
        type: token_js_1$3.TokenType.COMMENT,
        data: "",
        location: this.getCurrentLocation(offset2)
      };
    }
  }, {
    key: "_createDoctypeToken",
    value: function _createDoctypeToken(initialName) {
      this.currentToken = {
        type: token_js_1$3.TokenType.DOCTYPE,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null,
        location: this.currentLocation
      };
    }
  }, {
    key: "_createCharacterToken",
    value: function _createCharacterToken(type3, chars) {
      this.currentCharacterToken = {
        type: type3,
        chars,
        location: this.currentLocation
      };
    }
    //Tag attributes
  }, {
    key: "_createAttr",
    value: function _createAttr(attrNameFirstCh) {
      this.currentAttr = {
        name: attrNameFirstCh,
        value: ""
      };
      this.currentLocation = this.getCurrentLocation(0);
    }
  }, {
    key: "_leaveAttrName",
    value: function _leaveAttrName() {
      var _a;
      var _b;
      const token2 = this.currentToken;
      if ((0, token_js_1$3.getTokenAttr)(token2, this.currentAttr.name) === null) {
        token2.attrs.push(this.currentAttr);
        if (token2.location && this.currentLocation) {
          const attrLocations = (_a = (_b = token2.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = /* @__PURE__ */ Object.create(null);
          attrLocations[this.currentAttr.name] = this.currentLocation;
          this._leaveAttrValue();
        }
      } else {
        this._err(error_codes_js_1$4.ERR.duplicateAttribute);
      }
    }
  }, {
    key: "_leaveAttrValue",
    value: function _leaveAttrValue() {
      if (this.currentLocation) {
        this.currentLocation.endLine = this.preprocessor.line;
        this.currentLocation.endCol = this.preprocessor.col;
        this.currentLocation.endOffset = this.preprocessor.offset;
      }
    }
    //Token emission
  }, {
    key: "prepareToken",
    value: function prepareToken(ct) {
      this._emitCurrentCharacterToken(ct.location);
      this.currentToken = null;
      if (ct.location) {
        ct.location.endLine = this.preprocessor.line;
        ct.location.endCol = this.preprocessor.col + 1;
        ct.location.endOffset = this.preprocessor.offset + 1;
      }
      this.currentLocation = this.getCurrentLocation(-1);
    }
  }, {
    key: "emitCurrentTagToken",
    value: function emitCurrentTagToken() {
      const ct = this.currentToken;
      this.prepareToken(ct);
      ct.tagID = (0, html_js_1$9.getTagID)(ct.tagName);
      if (ct.type === token_js_1$3.TokenType.START_TAG) {
        this.lastStartTagName = ct.tagName;
        this.handler.onStartTag(ct);
      } else {
        if (ct.attrs.length > 0) {
          this._err(error_codes_js_1$4.ERR.endTagWithAttributes);
        }
        if (ct.selfClosing) {
          this._err(error_codes_js_1$4.ERR.endTagWithTrailingSolidus);
        }
        this.handler.onEndTag(ct);
      }
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentComment",
    value: function emitCurrentComment(ct) {
      this.prepareToken(ct);
      this.handler.onComment(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentDoctype",
    value: function emitCurrentDoctype(ct) {
      this.prepareToken(ct);
      this.handler.onDoctype(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "_emitCurrentCharacterToken",
    value: function _emitCurrentCharacterToken(nextLocation) {
      if (this.currentCharacterToken) {
        if (nextLocation && this.currentCharacterToken.location) {
          this.currentCharacterToken.location.endLine = nextLocation.startLine;
          this.currentCharacterToken.location.endCol = nextLocation.startCol;
          this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
        }
        switch (this.currentCharacterToken.type) {
          case token_js_1$3.TokenType.CHARACTER: {
            this.handler.onCharacter(this.currentCharacterToken);
            break;
          }
          case token_js_1$3.TokenType.NULL_CHARACTER: {
            this.handler.onNullCharacter(this.currentCharacterToken);
            break;
          }
          case token_js_1$3.TokenType.WHITESPACE_CHARACTER: {
            this.handler.onWhitespaceCharacter(this.currentCharacterToken);
            break;
          }
        }
        this.currentCharacterToken = null;
      }
    }
  }, {
    key: "_emitEOFToken",
    value: function _emitEOFToken() {
      const location = this.getCurrentLocation(0);
      if (location) {
        location.endLine = location.startLine;
        location.endCol = location.startCol;
        location.endOffset = location.startOffset;
      }
      this._emitCurrentCharacterToken(location);
      this.handler.onEof({
        type: token_js_1$3.TokenType.EOF,
        location
      });
      this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  }, {
    key: "_appendCharToCurrentCharacterToken",
    value: function _appendCharToCurrentCharacterToken(type3, ch) {
      if (this.currentCharacterToken) {
        if (this.currentCharacterToken.type !== type3) {
          this.currentLocation = this.getCurrentLocation(0);
          this._emitCurrentCharacterToken(this.currentLocation);
          this.preprocessor.dropParsedChunk();
        } else {
          this.currentCharacterToken.chars += ch;
          return;
        }
      }
      this._createCharacterToken(type3, ch);
    }
  }, {
    key: "_emitCodePoint",
    value: function _emitCodePoint(cp) {
      const type3 = isWhitespace$1(cp) ? token_js_1$3.TokenType.WHITESPACE_CHARACTER : cp === unicode_js_1$2.CODE_POINTS.NULL ? token_js_1$3.TokenType.NULL_CHARACTER : token_js_1$3.TokenType.CHARACTER;
      this._appendCharToCurrentCharacterToken(type3, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  }, {
    key: "_emitChars",
    value: function _emitChars(ch) {
      this._appendCharToCurrentCharacterToken(token_js_1$3.TokenType.CHARACTER, ch);
    }
    // Character reference helpers
  }, {
    key: "_matchNamedCharacterReference",
    value: function _matchNamedCharacterReference(cp) {
      let result = null;
      let excess = 0;
      let withoutSemicolon = false;
      for (let i = 0, current = decode_js_1$2.htmlDecodeTree[0]; i >= 0; cp = this._consume()) {
        i = (0, decode_js_1$2.determineBranch)(decode_js_1$2.htmlDecodeTree, current, i + 1, cp);
        if (i < 0)
          break;
        excess += 1;
        current = decode_js_1$2.htmlDecodeTree[i];
        const masked = current & decode_js_1$2.BinTrieFlags.VALUE_LENGTH;
        if (masked) {
          const valueLength = (masked >> 14) - 1;
          if (cp !== unicode_js_1$2.CODE_POINTS.SEMICOLON && this._isCharacterReferenceInAttribute() && isEntityInAttributeInvalidEnd$1(this.preprocessor.peek(1))) {
            result = [unicode_js_1$2.CODE_POINTS.AMPERSAND];
            i += valueLength;
          } else {
            result = valueLength === 0 ? [decode_js_1$2.htmlDecodeTree[i] & ~decode_js_1$2.BinTrieFlags.VALUE_LENGTH] : valueLength === 1 ? [decode_js_1$2.htmlDecodeTree[++i]] : [decode_js_1$2.htmlDecodeTree[++i], decode_js_1$2.htmlDecodeTree[++i]];
            excess = 0;
            withoutSemicolon = cp !== unicode_js_1$2.CODE_POINTS.SEMICOLON;
          }
          if (valueLength === 0) {
            this._consume();
            break;
          }
        }
      }
      this._unconsume(excess);
      if (withoutSemicolon && !this.preprocessor.endOfChunkHit) {
        this._err(error_codes_js_1$4.ERR.missingSemicolonAfterCharacterReference);
      }
      this._unconsume(1);
      return result;
    }
  }, {
    key: "_isCharacterReferenceInAttribute",
    value: function _isCharacterReferenceInAttribute() {
      return this.returnState === State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === State$1.ATTRIBUTE_VALUE_UNQUOTED;
    }
  }, {
    key: "_flushCodePointConsumedAsCharacterReference",
    value: function _flushCodePointConsumedAsCharacterReference(cp) {
      if (this._isCharacterReferenceInAttribute()) {
        this.currentAttr.value += String.fromCodePoint(cp);
      } else {
        this._emitCodePoint(cp);
      }
    }
    // Calling states this way turns out to be much faster than any other approach.
  }, {
    key: "_callState",
    value: function _callState(cp) {
      switch (this.state) {
        case State$1.DATA: {
          this._stateData(cp);
          break;
        }
        case State$1.RCDATA: {
          this._stateRcdata(cp);
          break;
        }
        case State$1.RAWTEXT: {
          this._stateRawtext(cp);
          break;
        }
        case State$1.SCRIPT_DATA: {
          this._stateScriptData(cp);
          break;
        }
        case State$1.PLAINTEXT: {
          this._statePlaintext(cp);
          break;
        }
        case State$1.TAG_OPEN: {
          this._stateTagOpen(cp);
          break;
        }
        case State$1.END_TAG_OPEN: {
          this._stateEndTagOpen(cp);
          break;
        }
        case State$1.TAG_NAME: {
          this._stateTagName(cp);
          break;
        }
        case State$1.RCDATA_LESS_THAN_SIGN: {
          this._stateRcdataLessThanSign(cp);
          break;
        }
        case State$1.RCDATA_END_TAG_OPEN: {
          this._stateRcdataEndTagOpen(cp);
          break;
        }
        case State$1.RCDATA_END_TAG_NAME: {
          this._stateRcdataEndTagName(cp);
          break;
        }
        case State$1.RAWTEXT_LESS_THAN_SIGN: {
          this._stateRawtextLessThanSign(cp);
          break;
        }
        case State$1.RAWTEXT_END_TAG_OPEN: {
          this._stateRawtextEndTagOpen(cp);
          break;
        }
        case State$1.RAWTEXT_END_TAG_NAME: {
          this._stateRawtextEndTagName(cp);
          break;
        }
        case State$1.SCRIPT_DATA_LESS_THAN_SIGN: {
          this._stateScriptDataLessThanSign(cp);
          break;
        }
        case State$1.SCRIPT_DATA_END_TAG_OPEN: {
          this._stateScriptDataEndTagOpen(cp);
          break;
        }
        case State$1.SCRIPT_DATA_END_TAG_NAME: {
          this._stateScriptDataEndTagName(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPE_START: {
          this._stateScriptDataEscapeStart(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPE_START_DASH: {
          this._stateScriptDataEscapeStartDash(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED: {
          this._stateScriptDataEscaped(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED_DASH: {
          this._stateScriptDataEscapedDash(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED_DASH_DASH: {
          this._stateScriptDataEscapedDashDash(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
          this._stateScriptDataEscapedLessThanSign(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
          this._stateScriptDataEscapedEndTagOpen(cp);
          break;
        }
        case State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
          this._stateScriptDataEscapedEndTagName(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
          this._stateScriptDataDoubleEscapeStart(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED: {
          this._stateScriptDataDoubleEscaped(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
          this._stateScriptDataDoubleEscapedDash(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
          this._stateScriptDataDoubleEscapedDashDash(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
          this._stateScriptDataDoubleEscapedLessThanSign(cp);
          break;
        }
        case State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
          this._stateScriptDataDoubleEscapeEnd(cp);
          break;
        }
        case State$1.BEFORE_ATTRIBUTE_NAME: {
          this._stateBeforeAttributeName(cp);
          break;
        }
        case State$1.ATTRIBUTE_NAME: {
          this._stateAttributeName(cp);
          break;
        }
        case State$1.AFTER_ATTRIBUTE_NAME: {
          this._stateAfterAttributeName(cp);
          break;
        }
        case State$1.BEFORE_ATTRIBUTE_VALUE: {
          this._stateBeforeAttributeValue(cp);
          break;
        }
        case State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
          this._stateAttributeValueDoubleQuoted(cp);
          break;
        }
        case State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
          this._stateAttributeValueSingleQuoted(cp);
          break;
        }
        case State$1.ATTRIBUTE_VALUE_UNQUOTED: {
          this._stateAttributeValueUnquoted(cp);
          break;
        }
        case State$1.AFTER_ATTRIBUTE_VALUE_QUOTED: {
          this._stateAfterAttributeValueQuoted(cp);
          break;
        }
        case State$1.SELF_CLOSING_START_TAG: {
          this._stateSelfClosingStartTag(cp);
          break;
        }
        case State$1.BOGUS_COMMENT: {
          this._stateBogusComment(cp);
          break;
        }
        case State$1.MARKUP_DECLARATION_OPEN: {
          this._stateMarkupDeclarationOpen(cp);
          break;
        }
        case State$1.COMMENT_START: {
          this._stateCommentStart(cp);
          break;
        }
        case State$1.COMMENT_START_DASH: {
          this._stateCommentStartDash(cp);
          break;
        }
        case State$1.COMMENT: {
          this._stateComment(cp);
          break;
        }
        case State$1.COMMENT_LESS_THAN_SIGN: {
          this._stateCommentLessThanSign(cp);
          break;
        }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG: {
          this._stateCommentLessThanSignBang(cp);
          break;
        }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
          this._stateCommentLessThanSignBangDash(cp);
          break;
        }
        case State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
          this._stateCommentLessThanSignBangDashDash(cp);
          break;
        }
        case State$1.COMMENT_END_DASH: {
          this._stateCommentEndDash(cp);
          break;
        }
        case State$1.COMMENT_END: {
          this._stateCommentEnd(cp);
          break;
        }
        case State$1.COMMENT_END_BANG: {
          this._stateCommentEndBang(cp);
          break;
        }
        case State$1.DOCTYPE: {
          this._stateDoctype(cp);
          break;
        }
        case State$1.BEFORE_DOCTYPE_NAME: {
          this._stateBeforeDoctypeName(cp);
          break;
        }
        case State$1.DOCTYPE_NAME: {
          this._stateDoctypeName(cp);
          break;
        }
        case State$1.AFTER_DOCTYPE_NAME: {
          this._stateAfterDoctypeName(cp);
          break;
        }
        case State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
          this._stateAfterDoctypePublicKeyword(cp);
          break;
        }
        case State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
          this._stateBeforeDoctypePublicIdentifier(cp);
          break;
        }
        case State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
          this._stateDoctypePublicIdentifierDoubleQuoted(cp);
          break;
        }
        case State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
          this._stateDoctypePublicIdentifierSingleQuoted(cp);
          break;
        }
        case State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
          this._stateAfterDoctypePublicIdentifier(cp);
          break;
        }
        case State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
          this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
          break;
        }
        case State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
          this._stateAfterDoctypeSystemKeyword(cp);
          break;
        }
        case State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
          this._stateBeforeDoctypeSystemIdentifier(cp);
          break;
        }
        case State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
          this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
          break;
        }
        case State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
          this._stateDoctypeSystemIdentifierSingleQuoted(cp);
          break;
        }
        case State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
          this._stateAfterDoctypeSystemIdentifier(cp);
          break;
        }
        case State$1.BOGUS_DOCTYPE: {
          this._stateBogusDoctype(cp);
          break;
        }
        case State$1.CDATA_SECTION: {
          this._stateCdataSection(cp);
          break;
        }
        case State$1.CDATA_SECTION_BRACKET: {
          this._stateCdataSectionBracket(cp);
          break;
        }
        case State$1.CDATA_SECTION_END: {
          this._stateCdataSectionEnd(cp);
          break;
        }
        case State$1.CHARACTER_REFERENCE: {
          this._stateCharacterReference(cp);
          break;
        }
        case State$1.NAMED_CHARACTER_REFERENCE: {
          this._stateNamedCharacterReference(cp);
          break;
        }
        case State$1.AMBIGUOUS_AMPERSAND: {
          this._stateAmbiguousAmpersand(cp);
          break;
        }
        case State$1.NUMERIC_CHARACTER_REFERENCE: {
          this._stateNumericCharacterReference(cp);
          break;
        }
        case State$1.HEXADEMICAL_CHARACTER_REFERENCE_START: {
          this._stateHexademicalCharacterReferenceStart(cp);
          break;
        }
        case State$1.HEXADEMICAL_CHARACTER_REFERENCE: {
          this._stateHexademicalCharacterReference(cp);
          break;
        }
        case State$1.DECIMAL_CHARACTER_REFERENCE: {
          this._stateDecimalCharacterReference(cp);
          break;
        }
        case State$1.NUMERIC_CHARACTER_REFERENCE_END: {
          this._stateNumericCharacterReferenceEnd(cp);
          break;
        }
        default: {
          throw new Error("Unknown state");
        }
      }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
  }, {
    key: "_stateData",
    value: function _stateData(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.TAG_OPEN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.AMPERSAND: {
          this.returnState = State$1.DATA;
          this.state = State$1.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitCodePoint(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    //  RCDATA state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdata",
    value: function _stateRcdata(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.AMPERSAND: {
          this.returnState = State$1.RCDATA;
          this.state = State$1.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.RCDATA_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtext",
    value: function _stateRawtext(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.RAWTEXT_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptData",
    value: function _stateScriptData(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_statePlaintext",
    value: function _statePlaintext(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagOpen",
    value: function _stateTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this._createStartTagToken();
        this.state = State$1.TAG_NAME;
        this._stateTagName(cp);
      } else
        switch (cp) {
          case unicode_js_1$2.CODE_POINTS.EXCLAMATION_MARK: {
            this.state = State$1.MARKUP_DECLARATION_OPEN;
            break;
          }
          case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
            this.state = State$1.END_TAG_OPEN;
            break;
          }
          case unicode_js_1$2.CODE_POINTS.QUESTION_MARK: {
            this._err(error_codes_js_1$4.ERR.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken(1);
            this.state = State$1.BOGUS_COMMENT;
            this._stateBogusComment(cp);
            break;
          }
          case unicode_js_1$2.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$4.ERR.eofBeforeTagName);
            this._emitChars("<");
            this._emitEOFToken();
            break;
          }
          default: {
            this._err(error_codes_js_1$4.ERR.invalidFirstCharacterOfTagName);
            this._emitChars("<");
            this.state = State$1.DATA;
            this._stateData(cp);
          }
        }
    }
    // End tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateEndTagOpen",
    value: function _stateEndTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this._createEndTagToken();
        this.state = State$1.TAG_NAME;
        this._stateTagName(cp);
      } else
        switch (cp) {
          case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
            this._err(error_codes_js_1$4.ERR.missingEndTagName);
            this.state = State$1.DATA;
            break;
          }
          case unicode_js_1$2.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$4.ERR.eofBeforeTagName);
            this._emitChars("</");
            this._emitEOFToken();
            break;
          }
          default: {
            this._err(error_codes_js_1$4.ERR.invalidFirstCharacterOfTagName);
            this._createCommentToken(2);
            this.state = State$1.BOGUS_COMMENT;
            this._stateBogusComment(cp);
          }
        }
    }
    // Tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagName",
    value: function _stateTagName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
          this.state = State$1.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.tagName += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.tagName += String.fromCodePoint(isAsciiUpper$1(cp) ? toAsciiLower$1(cp) : cp);
        }
      }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataLessThanSign",
    value: function _stateRcdataLessThanSign(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.SOLIDUS) {
        this.state = State$1.RCDATA_END_TAG_OPEN;
      } else {
        this._emitChars("<");
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagOpen",
    value: function _stateRcdataEndTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this.state = State$1.RCDATA_END_TAG_NAME;
        this._stateRcdataEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
  }, {
    key: "handleSpecialEndTag",
    value: function handleSpecialEndTag(_cp) {
      if (!this.preprocessor.startsWith(this.lastStartTagName, false)) {
        return !this._ensureHibernation();
      }
      this._createEndTagToken();
      const token2 = this.currentToken;
      token2.tagName = this.lastStartTagName;
      const cp = this.preprocessor.peek(this.lastStartTagName.length);
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this._advanceBy(this.lastStartTagName.length);
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          return false;
        }
        case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
          this._advanceBy(this.lastStartTagName.length);
          this.state = State$1.SELF_CLOSING_START_TAG;
          return false;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._advanceBy(this.lastStartTagName.length);
          this.emitCurrentTagToken();
          this.state = State$1.DATA;
          return false;
        }
        default: {
          return !this._ensureHibernation();
        }
      }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagName",
    value: function _stateRcdataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State$1.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextLessThanSign",
    value: function _stateRawtextLessThanSign(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.SOLIDUS) {
        this.state = State$1.RAWTEXT_END_TAG_OPEN;
      } else {
        this._emitChars("<");
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagOpen",
    value: function _stateRawtextEndTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this.state = State$1.RAWTEXT_END_TAG_NAME;
        this._stateRawtextEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagName",
    value: function _stateRawtextEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State$1.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataLessThanSign",
    value: function _stateScriptDataLessThanSign(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
          this.state = State$1.SCRIPT_DATA_END_TAG_OPEN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State$1.SCRIPT_DATA_ESCAPE_START;
          this._emitChars("<!");
          break;
        }
        default: {
          this._emitChars("<");
          this.state = State$1.SCRIPT_DATA;
          this._stateScriptData(cp);
        }
      }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagOpen",
    value: function _stateScriptDataEndTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this.state = State$1.SCRIPT_DATA_END_TAG_NAME;
        this._stateScriptDataEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagName",
    value: function _stateScriptDataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStart",
    value: function _stateScriptDataEscapeStart(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPE_START_DASH;
        this._emitChars("-");
      } else {
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStartDash",
    value: function _stateScriptDataEscapeStartDash(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH;
        this._emitChars("-");
      } else {
        this.state = State$1.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscaped",
    value: function _stateScriptDataEscaped(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.SCRIPT_DATA_ESCAPED_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDash",
    value: function _stateScriptDataEscapedDash(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.SCRIPT_DATA_ESCAPED_DASH_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.state = State$1.SCRIPT_DATA_ESCAPED;
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State$1.SCRIPT_DATA_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDashDash",
    value: function _stateScriptDataEscapedDashDash(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA;
          this._emitChars(">");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.state = State$1.SCRIPT_DATA_ESCAPED;
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State$1.SCRIPT_DATA_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedLessThanSign",
    value: function _stateScriptDataEscapedLessThanSign(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.SOLIDUS) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
      } else if (isAsciiLetter$1(cp)) {
        this._emitChars("<");
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_START;
        this._stateScriptDataDoubleEscapeStart(cp);
      } else {
        this._emitChars("<");
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagOpen",
    value: function _stateScriptDataEscapedEndTagOpen(cp) {
      if (isAsciiLetter$1(cp)) {
        this.state = State$1.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
        this._stateScriptDataEscapedEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagName",
    value: function _stateScriptDataEscapedEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeStart",
    value: function _stateScriptDataDoubleEscapeStart(cp) {
      if (this.preprocessor.startsWith(unicode_js_1$2.SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd$1(this.preprocessor.peek(unicode_js_1$2.SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (let i = 0; i < unicode_js_1$2.SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State$1.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscaped",
    value: function _stateScriptDataDoubleEscaped(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDash",
    value: function _stateScriptDataDoubleEscapedDash(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDashDash",
    value: function _stateScriptDataDoubleEscapedDashDash(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this._emitChars("-");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.SCRIPT_DATA;
          this._emitChars(">");
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitChars(unicode_js_1$2.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedLessThanSign",
    value: function _stateScriptDataDoubleEscapedLessThanSign(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.SOLIDUS) {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPE_END;
        this._emitChars("/");
      } else {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeEnd",
    value: function _stateScriptDataDoubleEscapeEnd(cp) {
      if (this.preprocessor.startsWith(unicode_js_1$2.SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd$1(this.preprocessor.peek(unicode_js_1$2.SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (let i = 0; i < unicode_js_1$2.SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State$1.SCRIPT_DATA_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State$1.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Before attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeName",
    value: function _stateBeforeAttributeName(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.SOLIDUS:
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN:
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this.state = State$1.AFTER_ATTRIBUTE_NAME;
          this._stateAfterAttributeName(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EQUALS_SIGN: {
          this._err(error_codes_js_1$4.ERR.unexpectedEqualsSignBeforeAttributeName);
          this._createAttr("=");
          this.state = State$1.ATTRIBUTE_NAME;
          break;
        }
        default: {
          this._createAttr("");
          this.state = State$1.ATTRIBUTE_NAME;
          this._stateAttributeName(cp);
        }
      }
    }
    // Attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeName",
    value: function _stateAttributeName(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED:
        case unicode_js_1$2.CODE_POINTS.SOLIDUS:
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN:
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._leaveAttrName();
          this.state = State$1.AFTER_ATTRIBUTE_NAME;
          this._stateAfterAttributeName(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EQUALS_SIGN: {
          this._leaveAttrName();
          this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK:
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE:
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.unexpectedCharacterInAttributeName);
          this.currentAttr.name += String.fromCodePoint(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.currentAttr.name += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        default: {
          this.currentAttr.name += String.fromCodePoint(isAsciiUpper$1(cp) ? toAsciiLower$1(cp) : cp);
        }
      }
    }
    // After attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeName",
    value: function _stateAfterAttributeName(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
          this.state = State$1.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EQUALS_SIGN: {
          this.state = State$1.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._createAttr("");
          this.state = State$1.ATTRIBUTE_NAME;
          this._stateAttributeName(cp);
        }
      }
    }
    // Before attribute value state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeValue",
    value: function _stateBeforeAttributeValue(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this.state = State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this.state = State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.missingAttributeValue);
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        default: {
          this.state = State$1.ATTRIBUTE_VALUE_UNQUOTED;
          this._stateAttributeValueUnquoted(cp);
        }
      }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueDoubleQuoted",
    value: function _stateAttributeValueDoubleQuoted(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.AMPERSAND: {
          this.returnState = State$1.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          this.state = State$1.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueSingleQuoted",
    value: function _stateAttributeValueSingleQuoted(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this.state = State$1.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.AMPERSAND: {
          this.returnState = State$1.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          this.state = State$1.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueUnquoted",
    value: function _stateAttributeValueUnquoted(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this._leaveAttrValue();
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.AMPERSAND: {
          this.returnState = State$1.ATTRIBUTE_VALUE_UNQUOTED;
          this.state = State$1.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._leaveAttrValue();
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK:
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE:
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN:
        case unicode_js_1$2.CODE_POINTS.EQUALS_SIGN:
        case unicode_js_1$2.CODE_POINTS.GRAVE_ACCENT: {
          this._err(error_codes_js_1$4.ERR.unexpectedCharacterInUnquotedAttributeValue);
          this.currentAttr.value += String.fromCodePoint(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeValueQuoted",
    value: function _stateAfterAttributeValueQuoted(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this._leaveAttrValue();
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.SOLIDUS: {
          this._leaveAttrValue();
          this.state = State$1.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._leaveAttrValue();
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceBetweenAttributes);
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          this._stateBeforeAttributeName(cp);
        }
      }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
  }, {
    key: "_stateSelfClosingStartTag",
    value: function _stateSelfClosingStartTag(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          const token2 = this.currentToken;
          token2.selfClosing = true;
          this.state = State$1.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.unexpectedSolidusInTag);
          this.state = State$1.BEFORE_ATTRIBUTE_NAME;
          this._stateBeforeAttributeName(cp);
        }
      }
    }
    // Bogus comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusComment",
    value: function _stateBogusComment(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.data += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        default: {
          token2.data += String.fromCodePoint(cp);
        }
      }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
  }, {
    key: "_stateMarkupDeclarationOpen",
    value: function _stateMarkupDeclarationOpen(cp) {
      if (this._consumeSequenceIfMatch(unicode_js_1$2.SEQUENCES.DASH_DASH, true)) {
        this._createCommentToken(unicode_js_1$2.SEQUENCES.DASH_DASH.length + 1);
        this.state = State$1.COMMENT_START;
      } else if (this._consumeSequenceIfMatch(unicode_js_1$2.SEQUENCES.DOCTYPE, false)) {
        this.currentLocation = this.getCurrentLocation(unicode_js_1$2.SEQUENCES.DOCTYPE.length + 1);
        this.state = State$1.DOCTYPE;
      } else if (this._consumeSequenceIfMatch(unicode_js_1$2.SEQUENCES.CDATA_START, true)) {
        if (this.inForeignNode) {
          this.state = State$1.CDATA_SECTION;
        } else {
          this._err(error_codes_js_1$4.ERR.cdataInHtmlContent);
          this._createCommentToken(unicode_js_1$2.SEQUENCES.CDATA_START.length + 1);
          this.currentToken.data = "[CDATA[";
          this.state = State$1.BOGUS_COMMENT;
        }
      } else if (!this._ensureHibernation()) {
        this._err(error_codes_js_1$4.ERR.incorrectlyOpenedComment);
        this._createCommentToken(2);
        this.state = State$1.BOGUS_COMMENT;
        this._stateBogusComment(cp);
      }
    }
    // Comment start state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStart",
    value: function _stateCommentStart(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.COMMENT_START_DASH;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptClosingOfEmptyComment);
          this.state = State$1.DATA;
          const token2 = this.currentToken;
          this.emitCurrentComment(token2);
          break;
        }
        default: {
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStartDash",
    value: function _stateCommentStartDash(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.COMMENT_END;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptClosingOfEmptyComment);
          this.state = State$1.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "-";
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateComment",
    value: function _stateComment(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.COMMENT_END_DASH;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          token2.data += "<";
          this.state = State$1.COMMENT_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.data += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += String.fromCodePoint(cp);
        }
      }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSign",
    value: function _stateCommentLessThanSign(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.EXCLAMATION_MARK: {
          token2.data += "!";
          this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.LESS_THAN_SIGN: {
          token2.data += "<";
          break;
        }
        default: {
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBang",
    value: function _stateCommentLessThanSignBang(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH;
      } else {
        this.state = State$1.COMMENT;
        this._stateComment(cp);
      }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDash",
    value: function _stateCommentLessThanSignBangDash(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State$1.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
      } else {
        this.state = State$1.COMMENT_END_DASH;
        this._stateCommentEndDash(cp);
      }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDashDash",
    value: function _stateCommentLessThanSignBangDashDash(cp) {
      if (cp !== unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN && cp !== unicode_js_1$2.CODE_POINTS.EOF) {
        this._err(error_codes_js_1$4.ERR.nestedComment);
      }
      this.state = State$1.COMMENT_END;
      this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndDash",
    value: function _stateCommentEndDash(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State$1.COMMENT_END;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "-";
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEnd",
    value: function _stateCommentEnd(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State$1.COMMENT_END_BANG;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          token2.data += "-";
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "--";
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment end bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndBang",
    value: function _stateCommentEndBang(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.HYPHEN_MINUS: {
          token2.data += "--!";
          this.state = State$1.COMMENT_END_DASH;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.incorrectlyClosedComment);
          this.state = State$1.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "--!";
          this.state = State$1.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctype",
    value: function _stateDoctype(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.BEFORE_DOCTYPE_NAME;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.BEFORE_DOCTYPE_NAME;
          this._stateBeforeDoctypeName(cp);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          this._createDoctypeToken(null);
          const token2 = this.currentToken;
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceBeforeDoctypeName);
          this.state = State$1.BEFORE_DOCTYPE_NAME;
          this._stateBeforeDoctypeName(cp);
        }
      }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeName",
    value: function _stateBeforeDoctypeName(cp) {
      if (isAsciiUpper$1(cp)) {
        this._createDoctypeToken(String.fromCharCode(toAsciiLower$1(cp)));
        this.state = State$1.DOCTYPE_NAME;
      } else
        switch (cp) {
          case unicode_js_1$2.CODE_POINTS.SPACE:
          case unicode_js_1$2.CODE_POINTS.LINE_FEED:
          case unicode_js_1$2.CODE_POINTS.TABULATION:
          case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
            break;
          }
          case unicode_js_1$2.CODE_POINTS.NULL: {
            this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
            this._createDoctypeToken(unicode_js_1$2.REPLACEMENT_CHARACTER);
            this.state = State$1.DOCTYPE_NAME;
            break;
          }
          case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
            this._err(error_codes_js_1$4.ERR.missingDoctypeName);
            this._createDoctypeToken(null);
            const token2 = this.currentToken;
            token2.forceQuirks = true;
            this.emitCurrentDoctype(token2);
            this.state = State$1.DATA;
            break;
          }
          case unicode_js_1$2.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$4.ERR.eofInDoctype);
            this._createDoctypeToken(null);
            const token2 = this.currentToken;
            token2.forceQuirks = true;
            this.emitCurrentDoctype(token2);
            this._emitEOFToken();
            break;
          }
          default: {
            this._createDoctypeToken(String.fromCodePoint(cp));
            this.state = State$1.DOCTYPE_NAME;
          }
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeName",
    value: function _stateDoctypeName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.AFTER_DOCTYPE_NAME;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.name += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.name += String.fromCodePoint(isAsciiUpper$1(cp) ? toAsciiLower$1(cp) : cp);
        }
      }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeName",
    value: function _stateAfterDoctypeName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          if (this._consumeSequenceIfMatch(unicode_js_1$2.SEQUENCES.PUBLIC, false)) {
            this.state = State$1.AFTER_DOCTYPE_PUBLIC_KEYWORD;
          } else if (this._consumeSequenceIfMatch(unicode_js_1$2.SEQUENCES.SYSTEM, false)) {
            this.state = State$1.AFTER_DOCTYPE_SYSTEM_KEYWORD;
          } else if (!this._ensureHibernation()) {
            this._err(error_codes_js_1$4.ERR.invalidCharacterSequenceAfterDoctypeName);
            token2.forceQuirks = true;
            this.state = State$1.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
        }
      }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicKeyword",
    value: function _stateAfterDoctypePublicKeyword(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceAfterDoctypePublicKeyword);
          token2.publicId = "";
          this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceAfterDoctypePublicKeyword);
          token2.publicId = "";
          this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.missingDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypePublicIdentifier",
    value: function _stateBeforeDoctypePublicIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          token2.publicId = "";
          this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          token2.publicId = "";
          this.state = State$1.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.missingDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierDoubleQuoted",
    value: function _stateDoctypePublicIdentifierDoubleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.publicId += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.publicId += String.fromCodePoint(cp);
        }
      }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierSingleQuoted",
    value: function _stateDoctypePublicIdentifierSingleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this.state = State$1.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.publicId += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.publicId += String.fromCodePoint(cp);
        }
      }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicIdentifier",
    value: function _stateAfterDoctypePublicIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
  }, {
    key: "_stateBetweenDoctypePublicAndSystemIdentifiers",
    value: function _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemKeyword",
    value: function _stateAfterDoctypeSystemKeyword(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          this.state = State$1.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$4.ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.missingDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeSystemIdentifier",
    value: function _stateBeforeDoctypeSystemIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          token2.systemId = "";
          this.state = State$1.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.missingDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierDoubleQuoted",
    value: function _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.QUOTATION_MARK: {
          this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.systemId += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.systemId += String.fromCodePoint(cp);
        }
      }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierSingleQuoted",
    value: function _stateDoctypeSystemIdentifierSingleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.APOSTROPHE: {
          this.state = State$1.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          token2.systemId += unicode_js_1$2.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$4.ERR.abruptDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.systemId += String.fromCodePoint(cp);
        }
      }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemIdentifier",
    value: function _stateAfterDoctypeSystemIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.SPACE:
        case unicode_js_1$2.CODE_POINTS.LINE_FEED:
        case unicode_js_1$2.CODE_POINTS.TABULATION:
        case unicode_js_1$2.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$4.ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
          this.state = State$1.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusDoctype",
    value: function _stateBogusDoctype(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$4.ERR.unexpectedNullCharacter);
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
      }
    }
    // CDATA section state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSection",
    value: function _stateCdataSection(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
          this.state = State$1.CDATA_SECTION_BRACKET;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$4.ERR.eofInCdata);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionBracket",
    value: function _stateCdataSectionBracket(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.RIGHT_SQUARE_BRACKET) {
        this.state = State$1.CDATA_SECTION_END;
      } else {
        this._emitChars("]");
        this.state = State$1.CDATA_SECTION;
        this._stateCdataSection(cp);
      }
    }
    // CDATA section end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionEnd",
    value: function _stateCdataSectionEnd(cp) {
      switch (cp) {
        case unicode_js_1$2.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State$1.DATA;
          break;
        }
        case unicode_js_1$2.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
          this._emitChars("]");
          break;
        }
        default: {
          this._emitChars("]]");
          this.state = State$1.CDATA_SECTION;
          this._stateCdataSection(cp);
        }
      }
    }
    // Character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateCharacterReference",
    value: function _stateCharacterReference(cp) {
      if (cp === unicode_js_1$2.CODE_POINTS.NUMBER_SIGN) {
        this.state = State$1.NUMERIC_CHARACTER_REFERENCE;
      } else if (isAsciiAlphaNumeric$1(cp)) {
        this.state = State$1.NAMED_CHARACTER_REFERENCE;
        this._stateNamedCharacterReference(cp);
      } else {
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.AMPERSAND);
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Named character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateNamedCharacterReference",
    value: function _stateNamedCharacterReference(cp) {
      const matchResult = this._matchNamedCharacterReference(cp);
      if (this._ensureHibernation())
        ;
      else if (matchResult) {
        for (let i = 0; i < matchResult.length; i++) {
          this._flushCodePointConsumedAsCharacterReference(matchResult[i]);
        }
        this.state = this.returnState;
      } else {
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.AMPERSAND);
        this.state = State$1.AMBIGUOUS_AMPERSAND;
      }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
  }, {
    key: "_stateAmbiguousAmpersand",
    value: function _stateAmbiguousAmpersand(cp) {
      if (isAsciiAlphaNumeric$1(cp)) {
        this._flushCodePointConsumedAsCharacterReference(cp);
      } else {
        if (cp === unicode_js_1$2.CODE_POINTS.SEMICOLON) {
          this._err(error_codes_js_1$4.ERR.unknownNamedCharacterReference);
        }
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Numeric character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateNumericCharacterReference",
    value: function _stateNumericCharacterReference(cp) {
      this.charRefCode = 0;
      if (cp === unicode_js_1$2.CODE_POINTS.LATIN_SMALL_X || cp === unicode_js_1$2.CODE_POINTS.LATIN_CAPITAL_X) {
        this.state = State$1.HEXADEMICAL_CHARACTER_REFERENCE_START;
      } else if (isAsciiDigit$1(cp)) {
        this.state = State$1.DECIMAL_CHARACTER_REFERENCE;
        this._stateDecimalCharacterReference(cp);
      } else {
        this._err(error_codes_js_1$4.ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.AMPERSAND);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.NUMBER_SIGN);
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
  }, {
    key: "_stateHexademicalCharacterReferenceStart",
    value: function _stateHexademicalCharacterReferenceStart(cp) {
      if (isAsciiHexDigit$1(cp)) {
        this.state = State$1.HEXADEMICAL_CHARACTER_REFERENCE;
        this._stateHexademicalCharacterReference(cp);
      } else {
        this._err(error_codes_js_1$4.ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.AMPERSAND);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1$2.CODE_POINTS.NUMBER_SIGN);
        this._unconsume(2);
        this.state = this.returnState;
      }
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateHexademicalCharacterReference",
    value: function _stateHexademicalCharacterReference(cp) {
      if (isAsciiUpperHexDigit$1(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 55;
      } else if (isAsciiLowerHexDigit$1(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 87;
      } else if (isAsciiDigit$1(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 48;
      } else if (cp === unicode_js_1$2.CODE_POINTS.SEMICOLON) {
        this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END;
      } else {
        this._err(error_codes_js_1$4.ERR.missingSemicolonAfterCharacterReference);
        this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END;
        this._stateNumericCharacterReferenceEnd(cp);
      }
    }
    // Decimal character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateDecimalCharacterReference",
    value: function _stateDecimalCharacterReference(cp) {
      if (isAsciiDigit$1(cp)) {
        this.charRefCode = this.charRefCode * 10 + cp - 48;
      } else if (cp === unicode_js_1$2.CODE_POINTS.SEMICOLON) {
        this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END;
      } else {
        this._err(error_codes_js_1$4.ERR.missingSemicolonAfterCharacterReference);
        this.state = State$1.NUMERIC_CHARACTER_REFERENCE_END;
        this._stateNumericCharacterReferenceEnd(cp);
      }
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
  }, {
    key: "_stateNumericCharacterReferenceEnd",
    value: function _stateNumericCharacterReferenceEnd(cp) {
      if (this.charRefCode === unicode_js_1$2.CODE_POINTS.NULL) {
        this._err(error_codes_js_1$4.ERR.nullCharacterReference);
        this.charRefCode = unicode_js_1$2.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if (this.charRefCode > 1114111) {
        this._err(error_codes_js_1$4.ERR.characterReferenceOutsideUnicodeRange);
        this.charRefCode = unicode_js_1$2.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if ((0, unicode_js_1$2.isSurrogate)(this.charRefCode)) {
        this._err(error_codes_js_1$4.ERR.surrogateCharacterReference);
        this.charRefCode = unicode_js_1$2.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if ((0, unicode_js_1$2.isUndefinedCodePoint)(this.charRefCode)) {
        this._err(error_codes_js_1$4.ERR.noncharacterCharacterReference);
      } else if ((0, unicode_js_1$2.isControlCodePoint)(this.charRefCode) || this.charRefCode === unicode_js_1$2.CODE_POINTS.CARRIAGE_RETURN) {
        this._err(error_codes_js_1$4.ERR.controlCharacterReference);
        const replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS$1.get(this.charRefCode);
        if (replacement !== void 0) {
          this.charRefCode = replacement;
        }
      }
      this._flushCodePointConsumedAsCharacterReference(this.charRefCode);
      this._reconsumeInState(this.returnState, cp);
    }
  }]);
  return Tokenizer2;
}();
tokenizer$1.Tokenizer = Tokenizer$2;
var openElementStack$1 = {};
function _classCallCheck$1G(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1u(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1u(descriptor.key), descriptor);
  }
}
function _createClass$1E(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1u(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1u(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1u(arg) {
  var key = _toPrimitive$1u(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1u(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(openElementStack$1, "__esModule", {
  value: true
});
openElementStack$1.OpenElementStack = void 0;
const html_js_1$8 = html$2;
const IMPLICIT_END_TAG_REQUIRED$1 = /* @__PURE__ */ new Set([html_js_1$8.TAG_ID.DD, html_js_1$8.TAG_ID.DT, html_js_1$8.TAG_ID.LI, html_js_1$8.TAG_ID.OPTGROUP, html_js_1$8.TAG_ID.OPTION, html_js_1$8.TAG_ID.P, html_js_1$8.TAG_ID.RB, html_js_1$8.TAG_ID.RP, html_js_1$8.TAG_ID.RT, html_js_1$8.TAG_ID.RTC]);
const IMPLICIT_END_TAG_REQUIRED_THOROUGHLY$1 = /* @__PURE__ */ new Set([...IMPLICIT_END_TAG_REQUIRED$1, html_js_1$8.TAG_ID.CAPTION, html_js_1$8.TAG_ID.COLGROUP, html_js_1$8.TAG_ID.TBODY, html_js_1$8.TAG_ID.TD, html_js_1$8.TAG_ID.TFOOT, html_js_1$8.TAG_ID.TH, html_js_1$8.TAG_ID.THEAD, html_js_1$8.TAG_ID.TR]);
const SCOPING_ELEMENT_NS$1 = /* @__PURE__ */ new Map([[html_js_1$8.TAG_ID.APPLET, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.CAPTION, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.HTML, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.MARQUEE, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.OBJECT, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.TABLE, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.TD, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.TEMPLATE, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.TH, html_js_1$8.NS.HTML], [html_js_1$8.TAG_ID.ANNOTATION_XML, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.MI, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.MN, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.MO, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.MS, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.MTEXT, html_js_1$8.NS.MATHML], [html_js_1$8.TAG_ID.DESC, html_js_1$8.NS.SVG], [html_js_1$8.TAG_ID.FOREIGN_OBJECT, html_js_1$8.NS.SVG], [html_js_1$8.TAG_ID.TITLE, html_js_1$8.NS.SVG]]);
const NAMED_HEADERS$1 = [html_js_1$8.TAG_ID.H1, html_js_1$8.TAG_ID.H2, html_js_1$8.TAG_ID.H3, html_js_1$8.TAG_ID.H4, html_js_1$8.TAG_ID.H5, html_js_1$8.TAG_ID.H6];
const TABLE_ROW_CONTEXT$1 = [html_js_1$8.TAG_ID.TR, html_js_1$8.TAG_ID.TEMPLATE, html_js_1$8.TAG_ID.HTML];
const TABLE_BODY_CONTEXT$1 = [html_js_1$8.TAG_ID.TBODY, html_js_1$8.TAG_ID.TFOOT, html_js_1$8.TAG_ID.THEAD, html_js_1$8.TAG_ID.TEMPLATE, html_js_1$8.TAG_ID.HTML];
const TABLE_CONTEXT$1 = [html_js_1$8.TAG_ID.TABLE, html_js_1$8.TAG_ID.TEMPLATE, html_js_1$8.TAG_ID.HTML];
const TABLE_CELLS$1 = [html_js_1$8.TAG_ID.TD, html_js_1$8.TAG_ID.TH];
let OpenElementStack$1 = /* @__PURE__ */ function() {
  function OpenElementStack2(document2, treeAdapter, handler) {
    _classCallCheck$1G(this, OpenElementStack2);
    this.treeAdapter = treeAdapter;
    this.handler = handler;
    this.items = [];
    this.tagIDs = [];
    this.stackTop = -1;
    this.tmplCount = 0;
    this.currentTagId = html_js_1$8.TAG_ID.UNKNOWN;
    this.current = document2;
  }
  _createClass$1E(OpenElementStack2, [{
    key: "currentTmplContentOrNode",
    get: function() {
      return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
  }, {
    key: "_indexOf",
    value: function _indexOf(element) {
      return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
  }, {
    key: "_isInTemplate",
    value: function _isInTemplate() {
      return this.currentTagId === html_js_1$8.TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === html_js_1$8.NS.HTML;
    }
  }, {
    key: "_updateCurrentElement",
    value: function _updateCurrentElement() {
      this.current = this.items[this.stackTop];
      this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
  }, {
    key: "push",
    value: function push(element, tagID) {
      this.stackTop++;
      this.items[this.stackTop] = element;
      this.current = element;
      this.tagIDs[this.stackTop] = tagID;
      this.currentTagId = tagID;
      if (this._isInTemplate()) {
        this.tmplCount++;
      }
      this.handler.onItemPush(element, tagID, true);
    }
  }, {
    key: "pop",
    value: function pop() {
      const popped = this.current;
      if (this.tmplCount > 0 && this._isInTemplate()) {
        this.tmplCount--;
      }
      this.stackTop--;
      this._updateCurrentElement();
      this.handler.onItemPop(popped, true);
    }
  }, {
    key: "replace",
    value: function replace(oldElement, newElement) {
      const idx = this._indexOf(oldElement);
      this.items[idx] = newElement;
      if (idx === this.stackTop) {
        this.current = newElement;
      }
    }
  }, {
    key: "insertAfter",
    value: function insertAfter2(referenceElement, newElement, newElementID) {
      const insertionIdx = this._indexOf(referenceElement) + 1;
      this.items.splice(insertionIdx, 0, newElement);
      this.tagIDs.splice(insertionIdx, 0, newElementID);
      this.stackTop++;
      if (insertionIdx === this.stackTop) {
        this._updateCurrentElement();
      }
      this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
  }, {
    key: "popUntilTagNamePopped",
    value: function popUntilTagNamePopped(tagName) {
      let targetIdx = this.stackTop + 1;
      do {
        targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
      } while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== html_js_1$8.NS.HTML);
      this.shortenToLength(targetIdx < 0 ? 0 : targetIdx);
    }
  }, {
    key: "shortenToLength",
    value: function shortenToLength(idx) {
      while (this.stackTop >= idx) {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) {
          this.tmplCount -= 1;
        }
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, this.stackTop < idx);
      }
    }
  }, {
    key: "popUntilElementPopped",
    value: function popUntilElementPopped(element) {
      const idx = this._indexOf(element);
      this.shortenToLength(idx < 0 ? 0 : idx);
    }
  }, {
    key: "popUntilPopped",
    value: function popUntilPopped(tagNames, targetNS) {
      const idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(idx < 0 ? 0 : idx);
    }
  }, {
    key: "popUntilNumberedHeaderPopped",
    value: function popUntilNumberedHeaderPopped() {
      this.popUntilPopped(NAMED_HEADERS$1, html_js_1$8.NS.HTML);
    }
  }, {
    key: "popUntilTableCellPopped",
    value: function popUntilTableCellPopped() {
      this.popUntilPopped(TABLE_CELLS$1, html_js_1$8.NS.HTML);
    }
  }, {
    key: "popAllUpToHtmlElement",
    value: function popAllUpToHtmlElement() {
      this.tmplCount = 0;
      this.shortenToLength(1);
    }
  }, {
    key: "_indexOfTagNames",
    value: function _indexOfTagNames(tagNames, namespace2) {
      for (let i = this.stackTop; i >= 0; i--) {
        if (tagNames.includes(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace2) {
          return i;
        }
      }
      return -1;
    }
  }, {
    key: "clearBackTo",
    value: function clearBackTo(tagNames, targetNS) {
      const idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(idx + 1);
    }
  }, {
    key: "clearBackToTableContext",
    value: function clearBackToTableContext() {
      this.clearBackTo(TABLE_CONTEXT$1, html_js_1$8.NS.HTML);
    }
  }, {
    key: "clearBackToTableBodyContext",
    value: function clearBackToTableBodyContext() {
      this.clearBackTo(TABLE_BODY_CONTEXT$1, html_js_1$8.NS.HTML);
    }
  }, {
    key: "clearBackToTableRowContext",
    value: function clearBackToTableRowContext() {
      this.clearBackTo(TABLE_ROW_CONTEXT$1, html_js_1$8.NS.HTML);
    }
  }, {
    key: "remove",
    value: function remove3(element) {
      const idx = this._indexOf(element);
      if (idx >= 0) {
        if (idx === this.stackTop) {
          this.pop();
        } else {
          this.items.splice(idx, 1);
          this.tagIDs.splice(idx, 1);
          this.stackTop--;
          this._updateCurrentElement();
          this.handler.onItemPop(element, false);
        }
      }
    }
    //Search
  }, {
    key: "tryPeekProperlyNestedBodyElement",
    value: function tryPeekProperlyNestedBodyElement() {
      return this.stackTop >= 1 && this.tagIDs[1] === html_js_1$8.TAG_ID.BODY ? this.items[1] : null;
    }
  }, {
    key: "contains",
    value: function contains2(element) {
      return this._indexOf(element) > -1;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(element) {
      const elementIdx = this._indexOf(element) - 1;
      return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
  }, {
    key: "isRootHtmlElementCurrent",
    value: function isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.tagIDs[0] === html_js_1$8.TAG_ID.HTML;
    }
    //Element in scope
  }, {
    key: "hasInScope",
    value: function hasInScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$8.NS.HTML) {
          return true;
        }
        if (SCOPING_ELEMENT_NS$1.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasNumberedHeaderInScope",
    value: function hasNumberedHeaderInScope() {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if ((0, html_js_1$8.isNumberedHeader)(tn) && ns === html_js_1$8.NS.HTML) {
          return true;
        }
        if (SCOPING_ELEMENT_NS$1.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInListItemScope",
    value: function hasInListItemScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$8.NS.HTML) {
          return true;
        }
        if ((tn === html_js_1$8.TAG_ID.UL || tn === html_js_1$8.TAG_ID.OL) && ns === html_js_1$8.NS.HTML || SCOPING_ELEMENT_NS$1.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInButtonScope",
    value: function hasInButtonScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$8.NS.HTML) {
          return true;
        }
        if (tn === html_js_1$8.TAG_ID.BUTTON && ns === html_js_1$8.NS.HTML || SCOPING_ELEMENT_NS$1.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInTableScope",
    value: function hasInTableScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$8.NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn === html_js_1$8.TAG_ID.TABLE || tn === html_js_1$8.TAG_ID.TEMPLATE || tn === html_js_1$8.TAG_ID.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasTableBodyContextInTableScope",
    value: function hasTableBodyContextInTableScope() {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$8.NS.HTML) {
          continue;
        }
        if (tn === html_js_1$8.TAG_ID.TBODY || tn === html_js_1$8.TAG_ID.THEAD || tn === html_js_1$8.TAG_ID.TFOOT) {
          return true;
        }
        if (tn === html_js_1$8.TAG_ID.TABLE || tn === html_js_1$8.TAG_ID.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInSelectScope",
    value: function hasInSelectScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$8.NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn !== html_js_1$8.TAG_ID.OPTION && tn !== html_js_1$8.TAG_ID.OPTGROUP) {
          return false;
        }
      }
      return true;
    }
    //Implied end tags
  }, {
    key: "generateImpliedEndTags",
    value: function generateImpliedEndTags() {
      while (IMPLICIT_END_TAG_REQUIRED$1.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsThoroughly",
    value: function generateImpliedEndTagsThoroughly() {
      while (IMPLICIT_END_TAG_REQUIRED_THOROUGHLY$1.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsWithExclusion",
    value: function generateImpliedEndTagsWithExclusion(exclusionId) {
      while (this.currentTagId !== exclusionId && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY$1.has(this.currentTagId)) {
        this.pop();
      }
    }
  }]);
  return OpenElementStack2;
}();
openElementStack$1.OpenElementStack = OpenElementStack$1;
var formattingElementList$1 = {};
(function(exports2) {
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey3(descriptor.key), descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _toPropertyKey3(arg) {
    var key = _toPrimitive3(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive3(input, hint) {
    if (typeof input !== "object" || input === null)
      return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object")
        return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.FormattingElementList = exports2.EntryType = void 0;
  const NOAH_ARK_CAPACITY = 3;
  var EntryType;
  (function(EntryType2) {
    EntryType2[EntryType2["Marker"] = 0] = "Marker";
    EntryType2[EntryType2["Element"] = 1] = "Element";
  })(EntryType = exports2.EntryType || (exports2.EntryType = {}));
  const MARKER = {
    type: EntryType.Marker
  };
  let FormattingElementList = /* @__PURE__ */ function() {
    function FormattingElementList2(treeAdapter) {
      _classCallCheck2(this, FormattingElementList2);
      this.treeAdapter = treeAdapter;
      this.entries = [];
      this.bookmark = null;
    }
    _createClass2(FormattingElementList2, [{
      key: "_getNoahArkConditionCandidates",
      value: function _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for (let i = 0; i < this.entries.length; i++) {
          const entry = this.entries[i];
          if (entry.type === EntryType.Marker) {
            break;
          }
          const {
            element
          } = entry;
          if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
            const elementAttrs = this.treeAdapter.getAttrList(element);
            if (elementAttrs.length === neAttrsLength) {
              candidates.push({
                idx: i,
                attrs: elementAttrs
              });
            }
          }
        }
        return candidates;
      }
    }, {
      key: "_ensureNoahArkCondition",
      value: function _ensureNoahArkCondition(newElement) {
        if (this.entries.length < NOAH_ARK_CAPACITY)
          return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < NOAH_ARK_CAPACITY)
          return;
        const neAttrsMap = new Map(neAttrs.map((neAttr) => [neAttr.name, neAttr.value]));
        let validCandidates = 0;
        for (let i = 0; i < candidates.length; i++) {
          const candidate = candidates[i];
          if (candidate.attrs.every((cAttr) => neAttrsMap.get(cAttr.name) === cAttr.value)) {
            validCandidates += 1;
            if (validCandidates >= NOAH_ARK_CAPACITY) {
              this.entries.splice(candidate.idx, 1);
            }
          }
        }
      }
      //Mutations
    }, {
      key: "insertMarker",
      value: function insertMarker() {
        this.entries.unshift(MARKER);
      }
    }, {
      key: "pushElement",
      value: function pushElement(element, token2) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
          type: EntryType.Element,
          element,
          token: token2
        });
      }
    }, {
      key: "insertElementAfterBookmark",
      value: function insertElementAfterBookmark(element, token2) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
          type: EntryType.Element,
          element,
          token: token2
        });
      }
    }, {
      key: "removeEntry",
      value: function removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex >= 0) {
          this.entries.splice(entryIndex, 1);
        }
      }
      /**
       * Clears the list of formatting elements up to the last marker.
       *
       * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
       */
    }, {
      key: "clearToLastMarker",
      value: function clearToLastMarker() {
        const markerIdx = this.entries.indexOf(MARKER);
        if (markerIdx >= 0) {
          this.entries.splice(0, markerIdx + 1);
        } else {
          this.entries.length = 0;
        }
      }
      //Search
    }, {
      key: "getElementEntryInScopeWithTagName",
      value: function getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry2) => entry2.type === EntryType.Marker || this.treeAdapter.getTagName(entry2.element) === tagName);
        return entry && entry.type === EntryType.Element ? entry : null;
      }
    }, {
      key: "getElementEntry",
      value: function getElementEntry(element) {
        return this.entries.find((entry) => entry.type === EntryType.Element && entry.element === element);
      }
    }]);
    return FormattingElementList2;
  }();
  exports2.FormattingElementList = FormattingElementList;
})(formattingElementList$1);
var _default$5 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.defaultTreeAdapter = void 0;
  const html_js_12 = html$2;
  function createTextNode(value2) {
    return {
      nodeName: "#text",
      value: value2,
      parentNode: null
    };
  }
  exports2.defaultTreeAdapter = {
    //Node construction
    createDocument() {
      return {
        nodeName: "#document",
        mode: html_js_12.DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
      };
    },
    createDocumentFragment() {
      return {
        nodeName: "#document-fragment",
        childNodes: []
      };
    },
    createElement(tagName, namespaceURI, attrs) {
      return {
        nodeName: tagName,
        tagName,
        attrs,
        namespaceURI,
        childNodes: [],
        parentNode: null
      };
    },
    createCommentNode(data2) {
      return {
        nodeName: "#comment",
        data: data2,
        parentNode: null
      };
    },
    //Tree mutation
    appendChild(parentNode, newNode) {
      parentNode.childNodes.push(newNode);
      newNode.parentNode = parentNode;
    },
    insertBefore(parentNode, newNode, referenceNode) {
      const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
      parentNode.childNodes.splice(insertionIdx, 0, newNode);
      newNode.parentNode = parentNode;
    },
    setTemplateContent(templateElement, contentElement) {
      templateElement.content = contentElement;
    },
    getTemplateContent(templateElement) {
      return templateElement.content;
    },
    setDocumentType(document2, name, publicId, systemId) {
      const doctypeNode = document2.childNodes.find((node2) => node2.nodeName === "#documentType");
      if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
      } else {
        const node2 = {
          nodeName: "#documentType",
          name,
          publicId,
          systemId,
          parentNode: null
        };
        exports2.defaultTreeAdapter.appendChild(document2, node2);
      }
    },
    setDocumentMode(document2, mode) {
      document2.mode = mode;
    },
    getDocumentMode(document2) {
      return document2.mode;
    },
    detachNode(node2) {
      if (node2.parentNode) {
        const idx = node2.parentNode.childNodes.indexOf(node2);
        node2.parentNode.childNodes.splice(idx, 1);
        node2.parentNode = null;
      }
    },
    insertText(parentNode, text2) {
      if (parentNode.childNodes.length > 0) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
        if (exports2.defaultTreeAdapter.isTextNode(prevNode)) {
          prevNode.value += text2;
          return;
        }
      }
      exports2.defaultTreeAdapter.appendChild(parentNode, createTextNode(text2));
    },
    insertTextBefore(parentNode, text2, referenceNode) {
      const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
      if (prevNode && exports2.defaultTreeAdapter.isTextNode(prevNode)) {
        prevNode.value += text2;
      } else {
        exports2.defaultTreeAdapter.insertBefore(parentNode, createTextNode(text2), referenceNode);
      }
    },
    adoptAttributes(recipient, attrs) {
      const recipientAttrsMap = new Set(recipient.attrs.map((attr2) => attr2.name));
      for (let j = 0; j < attrs.length; j++) {
        if (!recipientAttrsMap.has(attrs[j].name)) {
          recipient.attrs.push(attrs[j]);
        }
      }
    },
    //Tree traversing
    getFirstChild(node2) {
      return node2.childNodes[0];
    },
    getChildNodes(node2) {
      return node2.childNodes;
    },
    getParentNode(node2) {
      return node2.parentNode;
    },
    getAttrList(element) {
      return element.attrs;
    },
    //Node data
    getTagName(element) {
      return element.tagName;
    },
    getNamespaceURI(element) {
      return element.namespaceURI;
    },
    getTextNodeContent(textNode) {
      return textNode.value;
    },
    getCommentNodeContent(commentNode) {
      return commentNode.data;
    },
    getDocumentTypeNodeName(doctypeNode) {
      return doctypeNode.name;
    },
    getDocumentTypeNodePublicId(doctypeNode) {
      return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId(doctypeNode) {
      return doctypeNode.systemId;
    },
    //Node types
    isTextNode(node2) {
      return node2.nodeName === "#text";
    },
    isCommentNode(node2) {
      return node2.nodeName === "#comment";
    },
    isDocumentTypeNode(node2) {
      return node2.nodeName === "#documentType";
    },
    isElementNode(node2) {
      return Object.prototype.hasOwnProperty.call(node2, "tagName");
    },
    // Source code location
    setNodeSourceCodeLocation(node2, location) {
      node2.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation(node2) {
      return node2.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(node2, endLocation) {
      node2.sourceCodeLocation = Object.assign(Object.assign({}, node2.sourceCodeLocation), endLocation);
    }
  };
})(_default$5);
var doctype$3 = {};
Object.defineProperty(doctype$3, "__esModule", {
  value: true
});
doctype$3.getDocumentMode = doctype$3.isConforming = void 0;
const html_js_1$7 = html$2;
const VALID_DOCTYPE_NAME$1 = "html";
const VALID_SYSTEM_ID$1 = "about:legacy-compat";
const QUIRKS_MODE_SYSTEM_ID$1 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd";
const QUIRKS_MODE_PUBLIC_ID_PREFIXES$1 = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", "-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", "-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", "-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", "-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"];
const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES$1 = [...QUIRKS_MODE_PUBLIC_ID_PREFIXES$1, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
const QUIRKS_MODE_PUBLIC_IDS$1 = /* @__PURE__ */ new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]);
const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES$1 = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"];
const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES$1 = [...LIMITED_QUIRKS_PUBLIC_ID_PREFIXES$1, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
function hasPrefix$1(publicId, prefixes2) {
  return prefixes2.some((prefix2) => publicId.startsWith(prefix2));
}
function isConforming$1(token2) {
  return token2.name === VALID_DOCTYPE_NAME$1 && token2.publicId === null && (token2.systemId === null || token2.systemId === VALID_SYSTEM_ID$1);
}
doctype$3.isConforming = isConforming$1;
function getDocumentMode$1(token2) {
  if (token2.name !== VALID_DOCTYPE_NAME$1) {
    return html_js_1$7.DOCUMENT_MODE.QUIRKS;
  }
  const {
    systemId
  } = token2;
  if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID$1) {
    return html_js_1$7.DOCUMENT_MODE.QUIRKS;
  }
  let {
    publicId
  } = token2;
  if (publicId !== null) {
    publicId = publicId.toLowerCase();
    if (QUIRKS_MODE_PUBLIC_IDS$1.has(publicId)) {
      return html_js_1$7.DOCUMENT_MODE.QUIRKS;
    }
    let prefixes2 = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES$1 : QUIRKS_MODE_PUBLIC_ID_PREFIXES$1;
    if (hasPrefix$1(publicId, prefixes2)) {
      return html_js_1$7.DOCUMENT_MODE.QUIRKS;
    }
    prefixes2 = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES$1 : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES$1;
    if (hasPrefix$1(publicId, prefixes2)) {
      return html_js_1$7.DOCUMENT_MODE.LIMITED_QUIRKS;
    }
  }
  return html_js_1$7.DOCUMENT_MODE.NO_QUIRKS;
}
doctype$3.getDocumentMode = getDocumentMode$1;
var foreignContent$3 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.isIntegrationPoint = exports2.adjustTokenSVGTagName = exports2.adjustTokenXMLAttrs = exports2.adjustTokenSVGAttrs = exports2.adjustTokenMathMLAttrs = exports2.causesExit = exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP = void 0;
  const html_js_12 = html$2;
  const MIME_TYPES = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  };
  const DEFINITION_URL_ATTR = "definitionurl";
  const ADJUSTED_DEFINITION_URL_ATTR = "definitionURL";
  const SVG_ATTRS_ADJUSTMENT_MAP = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map((attr2) => [attr2.toLowerCase(), attr2]));
  const XML_ATTRS_ADJUSTMENT_MAP = /* @__PURE__ */ new Map([["xlink:actuate", {
    prefix: "xlink",
    name: "actuate",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:arcrole", {
    prefix: "xlink",
    name: "arcrole",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:href", {
    prefix: "xlink",
    name: "href",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:role", {
    prefix: "xlink",
    name: "role",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:show", {
    prefix: "xlink",
    name: "show",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:title", {
    prefix: "xlink",
    name: "title",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:type", {
    prefix: "xlink",
    name: "type",
    namespace: html_js_12.NS.XLINK
  }], ["xml:base", {
    prefix: "xml",
    name: "base",
    namespace: html_js_12.NS.XML
  }], ["xml:lang", {
    prefix: "xml",
    name: "lang",
    namespace: html_js_12.NS.XML
  }], ["xml:space", {
    prefix: "xml",
    name: "space",
    namespace: html_js_12.NS.XML
  }], ["xmlns", {
    prefix: "",
    name: "xmlns",
    namespace: html_js_12.NS.XMLNS
  }], ["xmlns:xlink", {
    prefix: "xmlns",
    name: "xlink",
    namespace: html_js_12.NS.XMLNS
  }]]);
  exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map((tn) => [tn.toLowerCase(), tn]));
  const EXITS_FOREIGN_CONTENT = /* @__PURE__ */ new Set([html_js_12.TAG_ID.B, html_js_12.TAG_ID.BIG, html_js_12.TAG_ID.BLOCKQUOTE, html_js_12.TAG_ID.BODY, html_js_12.TAG_ID.BR, html_js_12.TAG_ID.CENTER, html_js_12.TAG_ID.CODE, html_js_12.TAG_ID.DD, html_js_12.TAG_ID.DIV, html_js_12.TAG_ID.DL, html_js_12.TAG_ID.DT, html_js_12.TAG_ID.EM, html_js_12.TAG_ID.EMBED, html_js_12.TAG_ID.H1, html_js_12.TAG_ID.H2, html_js_12.TAG_ID.H3, html_js_12.TAG_ID.H4, html_js_12.TAG_ID.H5, html_js_12.TAG_ID.H6, html_js_12.TAG_ID.HEAD, html_js_12.TAG_ID.HR, html_js_12.TAG_ID.I, html_js_12.TAG_ID.IMG, html_js_12.TAG_ID.LI, html_js_12.TAG_ID.LISTING, html_js_12.TAG_ID.MENU, html_js_12.TAG_ID.META, html_js_12.TAG_ID.NOBR, html_js_12.TAG_ID.OL, html_js_12.TAG_ID.P, html_js_12.TAG_ID.PRE, html_js_12.TAG_ID.RUBY, html_js_12.TAG_ID.S, html_js_12.TAG_ID.SMALL, html_js_12.TAG_ID.SPAN, html_js_12.TAG_ID.STRONG, html_js_12.TAG_ID.STRIKE, html_js_12.TAG_ID.SUB, html_js_12.TAG_ID.SUP, html_js_12.TAG_ID.TABLE, html_js_12.TAG_ID.TT, html_js_12.TAG_ID.U, html_js_12.TAG_ID.UL, html_js_12.TAG_ID.VAR]);
  function causesExit(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === html_js_12.TAG_ID.FONT && startTagToken.attrs.some(({
      name
    }) => name === html_js_12.ATTRS.COLOR || name === html_js_12.ATTRS.SIZE || name === html_js_12.ATTRS.FACE);
    return isFontWithAttrs || EXITS_FOREIGN_CONTENT.has(tn);
  }
  exports2.causesExit = causesExit;
  function adjustTokenMathMLAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      if (token2.attrs[i].name === DEFINITION_URL_ATTR) {
        token2.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
        break;
      }
    }
  }
  exports2.adjustTokenMathMLAttrs = adjustTokenMathMLAttrs;
  function adjustTokenSVGAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP.get(token2.attrs[i].name);
      if (adjustedAttrName != null) {
        token2.attrs[i].name = adjustedAttrName;
      }
    }
  }
  exports2.adjustTokenSVGAttrs = adjustTokenSVGAttrs;
  function adjustTokenXMLAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP.get(token2.attrs[i].name);
      if (adjustedAttrEntry) {
        token2.attrs[i].prefix = adjustedAttrEntry.prefix;
        token2.attrs[i].name = adjustedAttrEntry.name;
        token2.attrs[i].namespace = adjustedAttrEntry.namespace;
      }
    }
  }
  exports2.adjustTokenXMLAttrs = adjustTokenXMLAttrs;
  function adjustTokenSVGTagName(token2) {
    const adjustedTagName = exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP.get(token2.tagName);
    if (adjustedTagName != null) {
      token2.tagName = adjustedTagName;
      token2.tagID = (0, html_js_12.getTagID)(token2.tagName);
    }
  }
  exports2.adjustTokenSVGTagName = adjustTokenSVGTagName;
  function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === html_js_12.NS.MATHML && (tn === html_js_12.TAG_ID.MI || tn === html_js_12.TAG_ID.MO || tn === html_js_12.TAG_ID.MN || tn === html_js_12.TAG_ID.MS || tn === html_js_12.TAG_ID.MTEXT);
  }
  function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === html_js_12.NS.MATHML && tn === html_js_12.TAG_ID.ANNOTATION_XML) {
      for (let i = 0; i < attrs.length; i++) {
        if (attrs[i].name === html_js_12.ATTRS.ENCODING) {
          const value2 = attrs[i].value.toLowerCase();
          return value2 === MIME_TYPES.TEXT_HTML || value2 === MIME_TYPES.APPLICATION_XML;
        }
      }
    }
    return ns === html_js_12.NS.SVG && (tn === html_js_12.TAG_ID.FOREIGN_OBJECT || tn === html_js_12.TAG_ID.DESC || tn === html_js_12.TAG_ID.TITLE);
  }
  function isIntegrationPoint(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === html_js_12.NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === html_js_12.NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns);
  }
  exports2.isIntegrationPoint = isIntegrationPoint;
})(foreignContent$3);
function _classCallCheck$1F(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1t(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1t(descriptor.key), descriptor);
  }
}
function _createClass$1D(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1t(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1t(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1t(arg) {
  var key = _toPrimitive$1t(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1t(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(parser$2, "__esModule", {
  value: true
});
parser$2.Parser = void 0;
const index_js_1$1 = tokenizer$1;
const open_element_stack_js_1$1 = openElementStack$1;
const formatting_element_list_js_1$1 = formattingElementList$1;
const default_js_1$3 = _default$5;
const doctype$2 = doctype$3;
const foreignContent$2 = foreignContent$3;
const error_codes_js_1$3 = errorCodes$1;
const unicode$2 = unicode$3;
const html_js_1$6 = html$2;
const token_js_1$2 = token$1;
const HIDDEN_INPUT_TYPE$1 = "hidden";
const AA_OUTER_LOOP_ITER$1 = 8;
const AA_INNER_LOOP_ITER$1 = 3;
var InsertionMode$1;
(function(InsertionMode2) {
  InsertionMode2[InsertionMode2["INITIAL"] = 0] = "INITIAL";
  InsertionMode2[InsertionMode2["BEFORE_HTML"] = 1] = "BEFORE_HTML";
  InsertionMode2[InsertionMode2["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
  InsertionMode2[InsertionMode2["IN_HEAD"] = 3] = "IN_HEAD";
  InsertionMode2[InsertionMode2["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
  InsertionMode2[InsertionMode2["AFTER_HEAD"] = 5] = "AFTER_HEAD";
  InsertionMode2[InsertionMode2["IN_BODY"] = 6] = "IN_BODY";
  InsertionMode2[InsertionMode2["TEXT"] = 7] = "TEXT";
  InsertionMode2[InsertionMode2["IN_TABLE"] = 8] = "IN_TABLE";
  InsertionMode2[InsertionMode2["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
  InsertionMode2[InsertionMode2["IN_CAPTION"] = 10] = "IN_CAPTION";
  InsertionMode2[InsertionMode2["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
  InsertionMode2[InsertionMode2["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
  InsertionMode2[InsertionMode2["IN_ROW"] = 13] = "IN_ROW";
  InsertionMode2[InsertionMode2["IN_CELL"] = 14] = "IN_CELL";
  InsertionMode2[InsertionMode2["IN_SELECT"] = 15] = "IN_SELECT";
  InsertionMode2[InsertionMode2["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
  InsertionMode2[InsertionMode2["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
  InsertionMode2[InsertionMode2["AFTER_BODY"] = 18] = "AFTER_BODY";
  InsertionMode2[InsertionMode2["IN_FRAMESET"] = 19] = "IN_FRAMESET";
  InsertionMode2[InsertionMode2["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
  InsertionMode2[InsertionMode2["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
  InsertionMode2[InsertionMode2["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode$1 || (InsertionMode$1 = {}));
const BASE_LOC$1 = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
};
const TABLE_STRUCTURE_TAGS$1 = /* @__PURE__ */ new Set([html_js_1$6.TAG_ID.TABLE, html_js_1$6.TAG_ID.TBODY, html_js_1$6.TAG_ID.TFOOT, html_js_1$6.TAG_ID.THEAD, html_js_1$6.TAG_ID.TR]);
const defaultParserOptions$1 = {
  scriptingEnabled: true,
  sourceCodeLocationInfo: false,
  treeAdapter: default_js_1$3.defaultTreeAdapter,
  onParseError: null
};
let Parser$3 = /* @__PURE__ */ function() {
  function Parser2(options2, document2, fragmentContext = null, scriptHandler = null) {
    _classCallCheck$1F(this, Parser2);
    this.fragmentContext = fragmentContext;
    this.scriptHandler = scriptHandler;
    this.currentToken = null;
    this.stopped = false;
    this.insertionMode = InsertionMode$1.INITIAL;
    this.originalInsertionMode = InsertionMode$1.INITIAL;
    this.headElement = null;
    this.formElement = null;
    this.currentNotInHTML = false;
    this.tmplInsertionModeStack = [];
    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;
    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
    this.options = Object.assign(Object.assign({}, defaultParserOptions$1), options2);
    this.treeAdapter = this.options.treeAdapter;
    this.onParseError = this.options.onParseError;
    if (this.onParseError) {
      this.options.sourceCodeLocationInfo = true;
    }
    this.document = document2 !== null && document2 !== void 0 ? document2 : this.treeAdapter.createDocument();
    this.tokenizer = new index_js_1$1.Tokenizer(this.options, this);
    this.activeFormattingElements = new formatting_element_list_js_1$1.FormattingElementList(this.treeAdapter);
    this.fragmentContextID = fragmentContext ? (0, html_js_1$6.getTagID)(this.treeAdapter.getTagName(fragmentContext)) : html_js_1$6.TAG_ID.UNKNOWN;
    this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
    this.openElements = new open_element_stack_js_1$1.OpenElementStack(this.document, this.treeAdapter, this);
  }
  _createClass$1D(Parser2, [{
    key: "getFragment",
    value: function getFragment() {
      const rootElement = this.treeAdapter.getFirstChild(this.document);
      const fragment = this.treeAdapter.createDocumentFragment();
      this._adoptNodes(rootElement, fragment);
      return fragment;
    }
    //Errors
  }, {
    key: "_err",
    value: function _err(token2, code2, beforeToken) {
      var _a;
      if (!this.onParseError)
        return;
      const loc = (_a = token2.location) !== null && _a !== void 0 ? _a : BASE_LOC$1;
      const err2 = {
        code: code2,
        startLine: loc.startLine,
        startCol: loc.startCol,
        startOffset: loc.startOffset,
        endLine: beforeToken ? loc.startLine : loc.endLine,
        endCol: beforeToken ? loc.startCol : loc.endCol,
        endOffset: beforeToken ? loc.startOffset : loc.endOffset
      };
      this.onParseError(err2);
    }
    //Stack events
  }, {
    key: "onItemPush",
    value: function onItemPush(node2, tid, isTop) {
      var _a, _b;
      (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 ? void 0 : _b.call(_a, node2);
      if (isTop && this.openElements.stackTop > 0)
        this._setContextModes(node2, tid);
    }
  }, {
    key: "onItemPop",
    value: function onItemPop(node2, isTop) {
      var _a, _b;
      if (this.options.sourceCodeLocationInfo) {
        this._setEndLocation(node2, this.currentToken);
      }
      (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 ? void 0 : _b.call(_a, node2, this.openElements.current);
      if (isTop) {
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
          current = this.fragmentContext;
          currentTagId = this.fragmentContextID;
        } else {
          ({
            current,
            currentTagId
          } = this.openElements);
        }
        this._setContextModes(current, currentTagId);
      }
    }
  }, {
    key: "_setContextModes",
    value: function _setContextModes(current, tid) {
      const isHTML = current === this.document || this.treeAdapter.getNamespaceURI(current) === html_js_1$6.NS.HTML;
      this.currentNotInHTML = !isHTML;
      this.tokenizer.inForeignNode = !isHTML && !this._isIntegrationPoint(tid, current);
    }
  }, {
    key: "_switchToTextParsing",
    value: function _switchToTextParsing(currentToken, nextTokenizerState) {
      this._insertElement(currentToken, html_js_1$6.NS.HTML);
      this.tokenizer.state = nextTokenizerState;
      this.originalInsertionMode = this.insertionMode;
      this.insertionMode = InsertionMode$1.TEXT;
    }
  }, {
    key: "switchToPlaintextParsing",
    value: function switchToPlaintextParsing() {
      this.insertionMode = InsertionMode$1.TEXT;
      this.originalInsertionMode = InsertionMode$1.IN_BODY;
      this.tokenizer.state = index_js_1$1.TokenizerMode.PLAINTEXT;
    }
    //Fragment parsing
  }, {
    key: "_getAdjustedCurrentElement",
    value: function _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
  }, {
    key: "_findFormInFragmentContext",
    value: function _findFormInFragmentContext() {
      let node2 = this.fragmentContext;
      while (node2) {
        if (this.treeAdapter.getTagName(node2) === html_js_1$6.TAG_NAMES.FORM) {
          this.formElement = node2;
          break;
        }
        node2 = this.treeAdapter.getParentNode(node2);
      }
    }
  }, {
    key: "_initTokenizerForFragmentParsing",
    value: function _initTokenizerForFragmentParsing() {
      if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== html_js_1$6.NS.HTML) {
        return;
      }
      switch (this.fragmentContextID) {
        case html_js_1$6.TAG_ID.TITLE:
        case html_js_1$6.TAG_ID.TEXTAREA: {
          this.tokenizer.state = index_js_1$1.TokenizerMode.RCDATA;
          break;
        }
        case html_js_1$6.TAG_ID.STYLE:
        case html_js_1$6.TAG_ID.XMP:
        case html_js_1$6.TAG_ID.IFRAME:
        case html_js_1$6.TAG_ID.NOEMBED:
        case html_js_1$6.TAG_ID.NOFRAMES:
        case html_js_1$6.TAG_ID.NOSCRIPT: {
          this.tokenizer.state = index_js_1$1.TokenizerMode.RAWTEXT;
          break;
        }
        case html_js_1$6.TAG_ID.SCRIPT: {
          this.tokenizer.state = index_js_1$1.TokenizerMode.SCRIPT_DATA;
          break;
        }
        case html_js_1$6.TAG_ID.PLAINTEXT: {
          this.tokenizer.state = index_js_1$1.TokenizerMode.PLAINTEXT;
          break;
        }
      }
    }
    //Tree mutation
  }, {
    key: "_setDocumentType",
    value: function _setDocumentType(token2) {
      const name = token2.name || "";
      const publicId = token2.publicId || "";
      const systemId = token2.systemId || "";
      this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
      if (token2.location) {
        const documentChildren = this.treeAdapter.getChildNodes(this.document);
        const docTypeNode = documentChildren.find((node2) => this.treeAdapter.isDocumentTypeNode(node2));
        if (docTypeNode) {
          this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token2.location);
        }
      }
    }
  }, {
    key: "_attachElementToTree",
    value: function _attachElementToTree(element, location) {
      if (this.options.sourceCodeLocationInfo) {
        const loc = location && Object.assign(Object.assign({}, location), {
          startTag: location
        });
        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
      }
      if (this._shouldFosterParentOnInsertion()) {
        this._fosterParentElement(element);
      } else {
        const parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.appendChild(parent, element);
      }
    }
  }, {
    key: "_appendElement",
    value: function _appendElement(token2, namespaceURI) {
      const element = this.treeAdapter.createElement(token2.tagName, namespaceURI, token2.attrs);
      this._attachElementToTree(element, token2.location);
    }
  }, {
    key: "_insertElement",
    value: function _insertElement(token2, namespaceURI) {
      const element = this.treeAdapter.createElement(token2.tagName, namespaceURI, token2.attrs);
      this._attachElementToTree(element, token2.location);
      this.openElements.push(element, token2.tagID);
    }
  }, {
    key: "_insertFakeElement",
    value: function _insertFakeElement(tagName, tagID) {
      const element = this.treeAdapter.createElement(tagName, html_js_1$6.NS.HTML, []);
      this._attachElementToTree(element, null);
      this.openElements.push(element, tagID);
    }
  }, {
    key: "_insertTemplate",
    value: function _insertTemplate(token2) {
      const tmpl = this.treeAdapter.createElement(token2.tagName, html_js_1$6.NS.HTML, token2.attrs);
      const content = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(tmpl, content);
      this._attachElementToTree(tmpl, token2.location);
      this.openElements.push(tmpl, token2.tagID);
      if (this.options.sourceCodeLocationInfo)
        this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
  }, {
    key: "_insertFakeRootElement",
    value: function _insertFakeRootElement() {
      const element = this.treeAdapter.createElement(html_js_1$6.TAG_NAMES.HTML, html_js_1$6.NS.HTML, []);
      if (this.options.sourceCodeLocationInfo)
        this.treeAdapter.setNodeSourceCodeLocation(element, null);
      this.treeAdapter.appendChild(this.openElements.current, element);
      this.openElements.push(element, html_js_1$6.TAG_ID.HTML);
    }
  }, {
    key: "_appendCommentNode",
    value: function _appendCommentNode(token2, parent) {
      const commentNode = this.treeAdapter.createCommentNode(token2.data);
      this.treeAdapter.appendChild(parent, commentNode);
      if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(commentNode, token2.location);
      }
    }
  }, {
    key: "_insertCharacters",
    value: function _insertCharacters(token2) {
      let parent;
      let beforeElement;
      if (this._shouldFosterParentOnInsertion()) {
        ({
          parent,
          beforeElement
        } = this._findFosterParentingLocation());
        if (beforeElement) {
          this.treeAdapter.insertTextBefore(parent, token2.chars, beforeElement);
        } else {
          this.treeAdapter.insertText(parent, token2.chars);
        }
      } else {
        parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.insertText(parent, token2.chars);
      }
      if (!token2.location)
        return;
      const siblings = this.treeAdapter.getChildNodes(parent);
      const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
      const textNode = siblings[textNodeIdx - 1];
      const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
      if (tnLoc) {
        const {
          endLine,
          endCol,
          endOffset
        } = token2.location;
        this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
          endLine,
          endCol,
          endOffset
        });
      } else if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(textNode, token2.location);
      }
    }
  }, {
    key: "_adoptNodes",
    value: function _adoptNodes(donor, recipient) {
      for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
      }
    }
  }, {
    key: "_setEndLocation",
    value: function _setEndLocation(element, closingToken) {
      if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
        const ctLoc = closingToken.location;
        const tn = this.treeAdapter.getTagName(element);
        const endLoc = (
          // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
          // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
          closingToken.type === token_js_1$2.TokenType.END_TAG && tn === closingToken.tagName ? {
            endTag: Object.assign({}, ctLoc),
            endLine: ctLoc.endLine,
            endCol: ctLoc.endCol,
            endOffset: ctLoc.endOffset
          } : {
            endLine: ctLoc.startLine,
            endCol: ctLoc.startCol,
            endOffset: ctLoc.startOffset
          }
        );
        this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
      }
    }
    //Token processing
  }, {
    key: "shouldProcessStartTagTokenInForeignContent",
    value: function shouldProcessStartTagTokenInForeignContent(token2) {
      if (!this.currentNotInHTML)
        return false;
      let current;
      let currentTagId;
      if (this.openElements.stackTop === 0 && this.fragmentContext) {
        current = this.fragmentContext;
        currentTagId = this.fragmentContextID;
      } else {
        ({
          current,
          currentTagId
        } = this.openElements);
      }
      if (token2.tagID === html_js_1$6.TAG_ID.SVG && this.treeAdapter.getTagName(current) === html_js_1$6.TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === html_js_1$6.NS.MATHML) {
        return false;
      }
      return (
        // Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token2.tagID === html_js_1$6.TAG_ID.MGLYPH || token2.tagID === html_js_1$6.TAG_ID.MALIGNMARK) && !this._isIntegrationPoint(currentTagId, current, html_js_1$6.NS.HTML)
      );
    }
  }, {
    key: "_processToken",
    value: function _processToken(token2) {
      switch (token2.type) {
        case token_js_1$2.TokenType.CHARACTER: {
          this.onCharacter(token2);
          break;
        }
        case token_js_1$2.TokenType.NULL_CHARACTER: {
          this.onNullCharacter(token2);
          break;
        }
        case token_js_1$2.TokenType.COMMENT: {
          this.onComment(token2);
          break;
        }
        case token_js_1$2.TokenType.DOCTYPE: {
          this.onDoctype(token2);
          break;
        }
        case token_js_1$2.TokenType.START_TAG: {
          this._processStartTag(token2);
          break;
        }
        case token_js_1$2.TokenType.END_TAG: {
          this.onEndTag(token2);
          break;
        }
        case token_js_1$2.TokenType.EOF: {
          this.onEof(token2);
          break;
        }
        case token_js_1$2.TokenType.WHITESPACE_CHARACTER: {
          this.onWhitespaceCharacter(token2);
          break;
        }
      }
    }
    //Integration points
  }, {
    key: "_isIntegrationPoint",
    value: function _isIntegrationPoint(tid, element, foreignNS) {
      const ns = this.treeAdapter.getNamespaceURI(element);
      const attrs = this.treeAdapter.getAttrList(element);
      return foreignContent$2.isIntegrationPoint(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
  }, {
    key: "_reconstructActiveFormattingElements",
    value: function _reconstructActiveFormattingElements() {
      const listLength = this.activeFormattingElements.entries.length;
      if (listLength) {
        const endIndex = this.activeFormattingElements.entries.findIndex((entry) => entry.type === formatting_element_list_js_1$1.EntryType.Marker || this.openElements.contains(entry.element));
        const unopenIdx = endIndex < 0 ? listLength - 1 : endIndex - 1;
        for (let i = unopenIdx; i >= 0; i--) {
          const entry = this.activeFormattingElements.entries[i];
          this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
          entry.element = this.openElements.current;
        }
      }
    }
    //Close elements
  }, {
    key: "_closeTableCell",
    value: function _closeTableCell() {
      this.openElements.generateImpliedEndTags();
      this.openElements.popUntilTableCellPopped();
      this.activeFormattingElements.clearToLastMarker();
      this.insertionMode = InsertionMode$1.IN_ROW;
    }
  }, {
    key: "_closePElement",
    value: function _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion(html_js_1$6.TAG_ID.P);
      this.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.P);
    }
    //Insertion modes
  }, {
    key: "_resetInsertionMode",
    value: function _resetInsertionMode() {
      for (let i = this.openElements.stackTop; i >= 0; i--) {
        switch (i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]) {
          case html_js_1$6.TAG_ID.TR: {
            this.insertionMode = InsertionMode$1.IN_ROW;
            return;
          }
          case html_js_1$6.TAG_ID.TBODY:
          case html_js_1$6.TAG_ID.THEAD:
          case html_js_1$6.TAG_ID.TFOOT: {
            this.insertionMode = InsertionMode$1.IN_TABLE_BODY;
            return;
          }
          case html_js_1$6.TAG_ID.CAPTION: {
            this.insertionMode = InsertionMode$1.IN_CAPTION;
            return;
          }
          case html_js_1$6.TAG_ID.COLGROUP: {
            this.insertionMode = InsertionMode$1.IN_COLUMN_GROUP;
            return;
          }
          case html_js_1$6.TAG_ID.TABLE: {
            this.insertionMode = InsertionMode$1.IN_TABLE;
            return;
          }
          case html_js_1$6.TAG_ID.BODY: {
            this.insertionMode = InsertionMode$1.IN_BODY;
            return;
          }
          case html_js_1$6.TAG_ID.FRAMESET: {
            this.insertionMode = InsertionMode$1.IN_FRAMESET;
            return;
          }
          case html_js_1$6.TAG_ID.SELECT: {
            this._resetInsertionModeForSelect(i);
            return;
          }
          case html_js_1$6.TAG_ID.TEMPLATE: {
            this.insertionMode = this.tmplInsertionModeStack[0];
            return;
          }
          case html_js_1$6.TAG_ID.HTML: {
            this.insertionMode = this.headElement ? InsertionMode$1.AFTER_HEAD : InsertionMode$1.BEFORE_HEAD;
            return;
          }
          case html_js_1$6.TAG_ID.TD:
          case html_js_1$6.TAG_ID.TH: {
            if (i > 0) {
              this.insertionMode = InsertionMode$1.IN_CELL;
              return;
            }
            break;
          }
          case html_js_1$6.TAG_ID.HEAD: {
            if (i > 0) {
              this.insertionMode = InsertionMode$1.IN_HEAD;
              return;
            }
            break;
          }
        }
      }
      this.insertionMode = InsertionMode$1.IN_BODY;
    }
  }, {
    key: "_resetInsertionModeForSelect",
    value: function _resetInsertionModeForSelect(selectIdx) {
      if (selectIdx > 0) {
        for (let i = selectIdx - 1; i > 0; i--) {
          const tn = this.openElements.tagIDs[i];
          if (tn === html_js_1$6.TAG_ID.TEMPLATE) {
            break;
          } else if (tn === html_js_1$6.TAG_ID.TABLE) {
            this.insertionMode = InsertionMode$1.IN_SELECT_IN_TABLE;
            return;
          }
        }
      }
      this.insertionMode = InsertionMode$1.IN_SELECT;
    }
    //Foster parenting
  }, {
    key: "_isElementCausesFosterParenting",
    value: function _isElementCausesFosterParenting(tn) {
      return TABLE_STRUCTURE_TAGS$1.has(tn);
    }
  }, {
    key: "_shouldFosterParentOnInsertion",
    value: function _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
  }, {
    key: "_findFosterParentingLocation",
    value: function _findFosterParentingLocation() {
      for (let i = this.openElements.stackTop; i >= 0; i--) {
        const openElement = this.openElements.items[i];
        switch (this.openElements.tagIDs[i]) {
          case html_js_1$6.TAG_ID.TEMPLATE: {
            if (this.treeAdapter.getNamespaceURI(openElement) === html_js_1$6.NS.HTML) {
              return {
                parent: this.treeAdapter.getTemplateContent(openElement),
                beforeElement: null
              };
            }
            break;
          }
          case html_js_1$6.TAG_ID.TABLE: {
            const parent = this.treeAdapter.getParentNode(openElement);
            if (parent) {
              return {
                parent,
                beforeElement: openElement
              };
            }
            return {
              parent: this.openElements.items[i - 1],
              beforeElement: null
            };
          }
        }
      }
      return {
        parent: this.openElements.items[0],
        beforeElement: null
      };
    }
  }, {
    key: "_fosterParentElement",
    value: function _fosterParentElement(element) {
      const location = this._findFosterParentingLocation();
      if (location.beforeElement) {
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
      } else {
        this.treeAdapter.appendChild(location.parent, element);
      }
    }
    //Special elements
  }, {
    key: "_isSpecialElement",
    value: function _isSpecialElement(element, id2) {
      const ns = this.treeAdapter.getNamespaceURI(element);
      return html_js_1$6.SPECIAL_ELEMENTS[ns].has(id2);
    }
  }, {
    key: "onCharacter",
    value: function onCharacter(token2) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        characterInForeignContent$1(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          tokenInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HTML: {
          tokenBeforeHtml$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD: {
          tokenBeforeHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD: {
          tokenInHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_HEAD: {
          tokenAfterHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_BODY:
        case InsertionMode$1.IN_CAPTION:
        case InsertionMode$1.IN_CELL:
        case InsertionMode$1.IN_TEMPLATE: {
          characterInBody$1(this, token2);
          break;
        }
        case InsertionMode$1.TEXT:
        case InsertionMode$1.IN_SELECT:
        case InsertionMode$1.IN_SELECT_IN_TABLE: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode$1.IN_TABLE:
        case InsertionMode$1.IN_TABLE_BODY:
        case InsertionMode$1.IN_ROW: {
          characterInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          characterInTableText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_COLUMN_GROUP: {
          tokenInColumnGroup$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY: {
          tokenAfterBody$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_BODY: {
          tokenAfterAfterBody$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onNullCharacter",
    value: function onNullCharacter(token2) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        nullCharacterInForeignContent$1(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          tokenInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HTML: {
          tokenBeforeHtml$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD: {
          tokenBeforeHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD: {
          tokenInHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_HEAD: {
          tokenAfterHead$1(this, token2);
          break;
        }
        case InsertionMode$1.TEXT: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode$1.IN_TABLE:
        case InsertionMode$1.IN_TABLE_BODY:
        case InsertionMode$1.IN_ROW: {
          characterInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_COLUMN_GROUP: {
          tokenInColumnGroup$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY: {
          tokenAfterBody$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_BODY: {
          tokenAfterAfterBody$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onComment",
    value: function onComment(token2) {
      this.skipNextNewLine = false;
      if (this.currentNotInHTML) {
        appendComment$1(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL:
        case InsertionMode$1.BEFORE_HTML:
        case InsertionMode$1.BEFORE_HEAD:
        case InsertionMode$1.IN_HEAD:
        case InsertionMode$1.IN_HEAD_NO_SCRIPT:
        case InsertionMode$1.AFTER_HEAD:
        case InsertionMode$1.IN_BODY:
        case InsertionMode$1.IN_TABLE:
        case InsertionMode$1.IN_CAPTION:
        case InsertionMode$1.IN_COLUMN_GROUP:
        case InsertionMode$1.IN_TABLE_BODY:
        case InsertionMode$1.IN_ROW:
        case InsertionMode$1.IN_CELL:
        case InsertionMode$1.IN_SELECT:
        case InsertionMode$1.IN_SELECT_IN_TABLE:
        case InsertionMode$1.IN_TEMPLATE:
        case InsertionMode$1.IN_FRAMESET:
        case InsertionMode$1.AFTER_FRAMESET: {
          appendComment$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          tokenInTableText$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY: {
          appendCommentToRootHtmlElement$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_BODY:
        case InsertionMode$1.AFTER_AFTER_FRAMESET: {
          appendCommentToDocument$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onDoctype",
    value: function onDoctype(token2) {
      this.skipNextNewLine = false;
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          doctypeInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD:
        case InsertionMode$1.IN_HEAD:
        case InsertionMode$1.IN_HEAD_NO_SCRIPT:
        case InsertionMode$1.AFTER_HEAD: {
          this._err(token2, error_codes_js_1$3.ERR.misplacedDoctype);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          tokenInTableText$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onStartTag",
    value: function onStartTag(token2) {
      this.skipNextNewLine = false;
      this.currentToken = token2;
      this._processStartTag(token2);
      if (token2.selfClosing && !token2.ackSelfClosing) {
        this._err(token2, error_codes_js_1$3.ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
      }
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     */
  }, {
    key: "_processStartTag",
    value: function _processStartTag(token2) {
      if (this.shouldProcessStartTagTokenInForeignContent(token2)) {
        startTagInForeignContent$1(this, token2);
      } else {
        this._startTagOutsideForeignContent(token2);
      }
    }
  }, {
    key: "_startTagOutsideForeignContent",
    value: function _startTagOutsideForeignContent(token2) {
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          tokenInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HTML: {
          startTagBeforeHtml$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD: {
          startTagBeforeHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD: {
          startTagInHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD_NO_SCRIPT: {
          startTagInHeadNoScript$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_HEAD: {
          startTagAfterHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_BODY: {
          startTagInBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE: {
          startTagInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          tokenInTableText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_CAPTION: {
          startTagInCaption$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_COLUMN_GROUP: {
          startTagInColumnGroup$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_BODY: {
          startTagInTableBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_ROW: {
          startTagInRow$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_CELL: {
          startTagInCell$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_SELECT: {
          startTagInSelect$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_SELECT_IN_TABLE: {
          startTagInSelectInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TEMPLATE: {
          startTagInTemplate$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY: {
          startTagAfterBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_FRAMESET: {
          startTagInFrameset$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_FRAMESET: {
          startTagAfterFrameset$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_BODY: {
          startTagAfterAfterBody$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_FRAMESET: {
          startTagAfterAfterFrameset$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onEndTag",
    value: function onEndTag(token2) {
      this.skipNextNewLine = false;
      this.currentToken = token2;
      if (this.currentNotInHTML) {
        endTagInForeignContent$1(this, token2);
      } else {
        this._endTagOutsideForeignContent(token2);
      }
    }
  }, {
    key: "_endTagOutsideForeignContent",
    value: function _endTagOutsideForeignContent(token2) {
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          tokenInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HTML: {
          endTagBeforeHtml$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD: {
          endTagBeforeHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD: {
          endTagInHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD_NO_SCRIPT: {
          endTagInHeadNoScript$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_HEAD: {
          endTagAfterHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_BODY: {
          endTagInBody$1(this, token2);
          break;
        }
        case InsertionMode$1.TEXT: {
          endTagInText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE: {
          endTagInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          tokenInTableText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_CAPTION: {
          endTagInCaption$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_COLUMN_GROUP: {
          endTagInColumnGroup$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_BODY: {
          endTagInTableBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_ROW: {
          endTagInRow$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_CELL: {
          endTagInCell$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_SELECT: {
          endTagInSelect$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_SELECT_IN_TABLE: {
          endTagInSelectInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TEMPLATE: {
          endTagInTemplate$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY: {
          endTagAfterBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_FRAMESET: {
          endTagInFrameset$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_FRAMESET: {
          endTagAfterFrameset$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_AFTER_BODY: {
          tokenAfterAfterBody$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onEof",
    value: function onEof(token2) {
      switch (this.insertionMode) {
        case InsertionMode$1.INITIAL: {
          tokenInInitialMode$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HTML: {
          tokenBeforeHtml$1(this, token2);
          break;
        }
        case InsertionMode$1.BEFORE_HEAD: {
          tokenBeforeHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD: {
          tokenInHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_HEAD: {
          tokenAfterHead$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_BODY:
        case InsertionMode$1.IN_TABLE:
        case InsertionMode$1.IN_CAPTION:
        case InsertionMode$1.IN_COLUMN_GROUP:
        case InsertionMode$1.IN_TABLE_BODY:
        case InsertionMode$1.IN_ROW:
        case InsertionMode$1.IN_CELL:
        case InsertionMode$1.IN_SELECT:
        case InsertionMode$1.IN_SELECT_IN_TABLE: {
          eofInBody$1(this, token2);
          break;
        }
        case InsertionMode$1.TEXT: {
          eofInText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          tokenInTableText$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TEMPLATE: {
          eofInTemplate$1(this, token2);
          break;
        }
        case InsertionMode$1.AFTER_BODY:
        case InsertionMode$1.IN_FRAMESET:
        case InsertionMode$1.AFTER_FRAMESET:
        case InsertionMode$1.AFTER_AFTER_BODY:
        case InsertionMode$1.AFTER_AFTER_FRAMESET: {
          stopParsing$1(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onWhitespaceCharacter",
    value: function onWhitespaceCharacter(token2) {
      if (this.skipNextNewLine) {
        this.skipNextNewLine = false;
        if (token2.chars.charCodeAt(0) === unicode$2.CODE_POINTS.LINE_FEED) {
          if (token2.chars.length === 1) {
            return;
          }
          token2.chars = token2.chars.substr(1);
        }
      }
      if (this.tokenizer.inForeignNode) {
        this._insertCharacters(token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode$1.IN_HEAD:
        case InsertionMode$1.IN_HEAD_NO_SCRIPT:
        case InsertionMode$1.AFTER_HEAD:
        case InsertionMode$1.TEXT:
        case InsertionMode$1.IN_COLUMN_GROUP:
        case InsertionMode$1.IN_SELECT:
        case InsertionMode$1.IN_SELECT_IN_TABLE:
        case InsertionMode$1.IN_FRAMESET:
        case InsertionMode$1.AFTER_FRAMESET: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode$1.IN_BODY:
        case InsertionMode$1.IN_CAPTION:
        case InsertionMode$1.IN_CELL:
        case InsertionMode$1.IN_TEMPLATE:
        case InsertionMode$1.AFTER_BODY:
        case InsertionMode$1.AFTER_AFTER_BODY:
        case InsertionMode$1.AFTER_AFTER_FRAMESET: {
          whitespaceCharacterInBody$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE:
        case InsertionMode$1.IN_TABLE_BODY:
        case InsertionMode$1.IN_ROW: {
          characterInTable$1(this, token2);
          break;
        }
        case InsertionMode$1.IN_TABLE_TEXT: {
          whitespaceCharacterInTableText$1(this, token2);
          break;
        }
      }
    }
  }], [{
    key: "parse",
    value: function parse2(html2, options2) {
      const parser2 = new this(options2);
      parser2.tokenizer.write(html2, true);
      return parser2.document;
    }
  }, {
    key: "getFragmentParser",
    value: function getFragmentParser(fragmentContext, options2) {
      const opts = Object.assign(Object.assign({}, defaultParserOptions$1), options2);
      fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement(html_js_1$6.TAG_NAMES.TEMPLATE, html_js_1$6.NS.HTML, []);
      const documentMock = opts.treeAdapter.createElement("documentmock", html_js_1$6.NS.HTML, []);
      const parser2 = new this(opts, documentMock, fragmentContext);
      if (parser2.fragmentContextID === html_js_1$6.TAG_ID.TEMPLATE) {
        parser2.tmplInsertionModeStack.unshift(InsertionMode$1.IN_TEMPLATE);
      }
      parser2._initTokenizerForFragmentParsing();
      parser2._insertFakeRootElement();
      parser2._resetInsertionMode();
      parser2._findFormInFragmentContext();
      return parser2;
    }
  }]);
  return Parser2;
}();
parser$2.Parser = Parser$3;
function aaObtainFormattingElementEntry$1(p, token2) {
  let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token2.tagName);
  if (formattingElementEntry) {
    if (!p.openElements.contains(formattingElementEntry.element)) {
      p.activeFormattingElements.removeEntry(formattingElementEntry);
      formattingElementEntry = null;
    } else if (!p.openElements.hasInScope(token2.tagID)) {
      formattingElementEntry = null;
    }
  } else {
    genericEndTagInBody$1(p, token2);
  }
  return formattingElementEntry;
}
function aaObtainFurthestBlock$1(p, formattingElementEntry) {
  let furthestBlock = null;
  let idx = p.openElements.stackTop;
  for (; idx >= 0; idx--) {
    const element = p.openElements.items[idx];
    if (element === formattingElementEntry.element) {
      break;
    }
    if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) {
      furthestBlock = element;
    }
  }
  if (!furthestBlock) {
    p.openElements.shortenToLength(idx < 0 ? 0 : idx);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
  }
  return furthestBlock;
}
function aaInnerLoop$1(p, furthestBlock, formattingElement) {
  let lastElement = furthestBlock;
  let nextElement = p.openElements.getCommonAncestor(furthestBlock);
  for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
    nextElement = p.openElements.getCommonAncestor(element);
    const elementEntry = p.activeFormattingElements.getElementEntry(element);
    const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER$1;
    const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
    if (shouldRemoveFromOpenElements) {
      if (counterOverflow) {
        p.activeFormattingElements.removeEntry(elementEntry);
      }
      p.openElements.remove(element);
    } else {
      element = aaRecreateElementFromEntry$1(p, elementEntry);
      if (lastElement === furthestBlock) {
        p.activeFormattingElements.bookmark = elementEntry;
      }
      p.treeAdapter.detachNode(lastElement);
      p.treeAdapter.appendChild(element, lastElement);
      lastElement = element;
    }
  }
  return lastElement;
}
function aaRecreateElementFromEntry$1(p, elementEntry) {
  const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
  const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
  p.openElements.replace(elementEntry.element, newElement);
  elementEntry.element = newElement;
  return newElement;
}
function aaInsertLastNodeInCommonAncestor$1(p, commonAncestor, lastElement) {
  const tn = p.treeAdapter.getTagName(commonAncestor);
  const tid = (0, html_js_1$6.getTagID)(tn);
  if (p._isElementCausesFosterParenting(tid)) {
    p._fosterParentElement(lastElement);
  } else {
    const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
    if (tid === html_js_1$6.TAG_ID.TEMPLATE && ns === html_js_1$6.NS.HTML) {
      commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
    }
    p.treeAdapter.appendChild(commonAncestor, lastElement);
  }
}
function aaReplaceFormattingElement$1(p, furthestBlock, formattingElementEntry) {
  const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
  const {
    token: token2
  } = formattingElementEntry;
  const newElement = p.treeAdapter.createElement(token2.tagName, ns, token2.attrs);
  p._adoptNodes(furthestBlock, newElement);
  p.treeAdapter.appendChild(furthestBlock, newElement);
  p.activeFormattingElements.insertElementAfterBookmark(newElement, token2);
  p.activeFormattingElements.removeEntry(formattingElementEntry);
  p.openElements.remove(formattingElementEntry.element);
  p.openElements.insertAfter(furthestBlock, newElement, token2.tagID);
}
function callAdoptionAgency$1(p, token2) {
  for (let i = 0; i < AA_OUTER_LOOP_ITER$1; i++) {
    const formattingElementEntry = aaObtainFormattingElementEntry$1(p, token2);
    if (!formattingElementEntry) {
      break;
    }
    const furthestBlock = aaObtainFurthestBlock$1(p, formattingElementEntry);
    if (!furthestBlock) {
      break;
    }
    p.activeFormattingElements.bookmark = formattingElementEntry;
    const lastElement = aaInnerLoop$1(p, furthestBlock, formattingElementEntry.element);
    const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
    p.treeAdapter.detachNode(lastElement);
    if (commonAncestor)
      aaInsertLastNodeInCommonAncestor$1(p, commonAncestor, lastElement);
    aaReplaceFormattingElement$1(p, furthestBlock, formattingElementEntry);
  }
}
function appendComment$1(p, token2) {
  p._appendCommentNode(token2, p.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement$1(p, token2) {
  p._appendCommentNode(token2, p.openElements.items[0]);
}
function appendCommentToDocument$1(p, token2) {
  p._appendCommentNode(token2, p.document);
}
function stopParsing$1(p, token2) {
  p.stopped = true;
  if (token2.location) {
    const target = p.fragmentContext ? 0 : 2;
    for (let i = p.openElements.stackTop; i >= target; i--) {
      p._setEndLocation(p.openElements.items[i], token2);
    }
    if (!p.fragmentContext && p.openElements.stackTop >= 0) {
      const htmlElement = p.openElements.items[0];
      const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
      if (htmlLocation && !htmlLocation.endTag) {
        p._setEndLocation(htmlElement, token2);
        if (p.openElements.stackTop >= 1) {
          const bodyElement = p.openElements.items[1];
          const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
          if (bodyLocation && !bodyLocation.endTag) {
            p._setEndLocation(bodyElement, token2);
          }
        }
      }
    }
  }
}
function doctypeInInitialMode$1(p, token2) {
  p._setDocumentType(token2);
  const mode = token2.forceQuirks ? html_js_1$6.DOCUMENT_MODE.QUIRKS : doctype$2.getDocumentMode(token2);
  if (!doctype$2.isConforming(token2)) {
    p._err(token2, error_codes_js_1$3.ERR.nonConformingDoctype);
  }
  p.treeAdapter.setDocumentMode(p.document, mode);
  p.insertionMode = InsertionMode$1.BEFORE_HTML;
}
function tokenInInitialMode$1(p, token2) {
  p._err(token2, error_codes_js_1$3.ERR.missingDoctype, true);
  p.treeAdapter.setDocumentMode(p.document, html_js_1$6.DOCUMENT_MODE.QUIRKS);
  p.insertionMode = InsertionMode$1.BEFORE_HTML;
  p._processToken(token2);
}
function startTagBeforeHtml$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.HTML) {
    p._insertElement(token2, html_js_1$6.NS.HTML);
    p.insertionMode = InsertionMode$1.BEFORE_HEAD;
  } else {
    tokenBeforeHtml$1(p, token2);
  }
}
function endTagBeforeHtml$1(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$6.TAG_ID.HTML || tn === html_js_1$6.TAG_ID.HEAD || tn === html_js_1$6.TAG_ID.BODY || tn === html_js_1$6.TAG_ID.BR) {
    tokenBeforeHtml$1(p, token2);
  }
}
function tokenBeforeHtml$1(p, token2) {
  p._insertFakeRootElement();
  p.insertionMode = InsertionMode$1.BEFORE_HEAD;
  p._processToken(token2);
}
function startTagBeforeHead$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.HEAD: {
      p._insertElement(token2, html_js_1$6.NS.HTML);
      p.headElement = p.openElements.current;
      p.insertionMode = InsertionMode$1.IN_HEAD;
      break;
    }
    default: {
      tokenBeforeHead$1(p, token2);
    }
  }
}
function endTagBeforeHead$1(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$6.TAG_ID.HEAD || tn === html_js_1$6.TAG_ID.BODY || tn === html_js_1$6.TAG_ID.HTML || tn === html_js_1$6.TAG_ID.BR) {
    tokenBeforeHead$1(p, token2);
  } else {
    p._err(token2, error_codes_js_1$3.ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenBeforeHead$1(p, token2) {
  p._insertFakeElement(html_js_1$6.TAG_NAMES.HEAD, html_js_1$6.TAG_ID.HEAD);
  p.headElement = p.openElements.current;
  p.insertionMode = InsertionMode$1.IN_HEAD;
  p._processToken(token2);
}
function startTagInHead$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BASE:
    case html_js_1$6.TAG_ID.BASEFONT:
    case html_js_1$6.TAG_ID.BGSOUND:
    case html_js_1$6.TAG_ID.LINK:
    case html_js_1$6.TAG_ID.META: {
      p._appendElement(token2, html_js_1$6.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$6.TAG_ID.TITLE: {
      p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RCDATA);
      break;
    }
    case html_js_1$6.TAG_ID.NOSCRIPT: {
      if (p.options.scriptingEnabled) {
        p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RAWTEXT);
      } else {
        p._insertElement(token2, html_js_1$6.NS.HTML);
        p.insertionMode = InsertionMode$1.IN_HEAD_NO_SCRIPT;
      }
      break;
    }
    case html_js_1$6.TAG_ID.NOFRAMES:
    case html_js_1$6.TAG_ID.STYLE: {
      p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RAWTEXT);
      break;
    }
    case html_js_1$6.TAG_ID.SCRIPT: {
      p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.SCRIPT_DATA);
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      p._insertTemplate(token2);
      p.activeFormattingElements.insertMarker();
      p.framesetOk = false;
      p.insertionMode = InsertionMode$1.IN_TEMPLATE;
      p.tmplInsertionModeStack.unshift(InsertionMode$1.IN_TEMPLATE);
      break;
    }
    case html_js_1$6.TAG_ID.HEAD: {
      p._err(token2, error_codes_js_1$3.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default: {
      tokenInHead$1(p, token2);
    }
  }
}
function endTagInHead$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HEAD: {
      p.openElements.pop();
      p.insertionMode = InsertionMode$1.AFTER_HEAD;
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.BR:
    case html_js_1$6.TAG_ID.HTML: {
      tokenInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1$3.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function templateEndTagInHead$1(p, token2) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.generateImpliedEndTagsThoroughly();
    if (p.openElements.currentTagId !== html_js_1$6.TAG_ID.TEMPLATE) {
      p._err(token2, error_codes_js_1$3.ERR.closingOfElementWithOpenChildElements);
    }
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
  } else {
    p._err(token2, error_codes_js_1$3.ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHead$1(p, token2) {
  p.openElements.pop();
  p.insertionMode = InsertionMode$1.AFTER_HEAD;
  p._processToken(token2);
}
function startTagInHeadNoScript$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BASEFONT:
    case html_js_1$6.TAG_ID.BGSOUND:
    case html_js_1$6.TAG_ID.HEAD:
    case html_js_1$6.TAG_ID.LINK:
    case html_js_1$6.TAG_ID.META:
    case html_js_1$6.TAG_ID.NOFRAMES:
    case html_js_1$6.TAG_ID.STYLE: {
      startTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOSCRIPT: {
      p._err(token2, error_codes_js_1$3.ERR.nestedNoscriptInHead);
      break;
    }
    default: {
      tokenInHeadNoScript$1(p, token2);
    }
  }
}
function endTagInHeadNoScript$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.NOSCRIPT: {
      p.openElements.pop();
      p.insertionMode = InsertionMode$1.IN_HEAD;
      break;
    }
    case html_js_1$6.TAG_ID.BR: {
      tokenInHeadNoScript$1(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1$3.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function tokenInHeadNoScript$1(p, token2) {
  const errCode = token2.type === token_js_1$2.TokenType.EOF ? error_codes_js_1$3.ERR.openElementsLeftAfterEof : error_codes_js_1$3.ERR.disallowedContentInNoscriptInHead;
  p._err(token2, errCode);
  p.openElements.pop();
  p.insertionMode = InsertionMode$1.IN_HEAD;
  p._processToken(token2);
}
function startTagAfterHead$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BODY: {
      p._insertElement(token2, html_js_1$6.NS.HTML);
      p.framesetOk = false;
      p.insertionMode = InsertionMode$1.IN_BODY;
      break;
    }
    case html_js_1$6.TAG_ID.FRAMESET: {
      p._insertElement(token2, html_js_1$6.NS.HTML);
      p.insertionMode = InsertionMode$1.IN_FRAMESET;
      break;
    }
    case html_js_1$6.TAG_ID.BASE:
    case html_js_1$6.TAG_ID.BASEFONT:
    case html_js_1$6.TAG_ID.BGSOUND:
    case html_js_1$6.TAG_ID.LINK:
    case html_js_1$6.TAG_ID.META:
    case html_js_1$6.TAG_ID.NOFRAMES:
    case html_js_1$6.TAG_ID.SCRIPT:
    case html_js_1$6.TAG_ID.STYLE:
    case html_js_1$6.TAG_ID.TEMPLATE:
    case html_js_1$6.TAG_ID.TITLE: {
      p._err(token2, error_codes_js_1$3.ERR.abandonedHeadElementChild);
      p.openElements.push(p.headElement, html_js_1$6.TAG_ID.HEAD);
      startTagInHead$1(p, token2);
      p.openElements.remove(p.headElement);
      break;
    }
    case html_js_1$6.TAG_ID.HEAD: {
      p._err(token2, error_codes_js_1$3.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default: {
      tokenAfterHead$1(p, token2);
    }
  }
}
function endTagAfterHead$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.HTML:
    case html_js_1$6.TAG_ID.BR: {
      tokenAfterHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1$3.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function tokenAfterHead$1(p, token2) {
  p._insertFakeElement(html_js_1$6.TAG_NAMES.BODY, html_js_1$6.TAG_ID.BODY);
  p.insertionMode = InsertionMode$1.IN_BODY;
  modeInBody$1(p, token2);
}
function modeInBody$1(p, token2) {
  switch (token2.type) {
    case token_js_1$2.TokenType.CHARACTER: {
      characterInBody$1(p, token2);
      break;
    }
    case token_js_1$2.TokenType.WHITESPACE_CHARACTER: {
      whitespaceCharacterInBody$1(p, token2);
      break;
    }
    case token_js_1$2.TokenType.COMMENT: {
      appendComment$1(p, token2);
      break;
    }
    case token_js_1$2.TokenType.START_TAG: {
      startTagInBody$1(p, token2);
      break;
    }
    case token_js_1$2.TokenType.END_TAG: {
      endTagInBody$1(p, token2);
      break;
    }
    case token_js_1$2.TokenType.EOF: {
      eofInBody$1(p, token2);
      break;
    }
  }
}
function whitespaceCharacterInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token2);
}
function characterInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token2);
  p.framesetOk = false;
}
function htmlStartTagInBody$1(p, token2) {
  if (p.openElements.tmplCount === 0) {
    p.treeAdapter.adoptAttributes(p.openElements.items[0], token2.attrs);
  }
}
function bodyStartTagInBody$1(p, token2) {
  const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (bodyElement && p.openElements.tmplCount === 0) {
    p.framesetOk = false;
    p.treeAdapter.adoptAttributes(bodyElement, token2.attrs);
  }
}
function framesetStartTagInBody$1(p, token2) {
  const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (p.framesetOk && bodyElement) {
    p.treeAdapter.detachNode(bodyElement);
    p.openElements.popAllUpToHtmlElement();
    p._insertElement(token2, html_js_1$6.NS.HTML);
    p.insertionMode = InsertionMode$1.IN_FRAMESET;
  }
}
function addressStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function numberedHeaderStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  if ((0, html_js_1$6.isNumberedHeader)(p.openElements.currentTagId)) {
    p.openElements.pop();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function preStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.skipNextNewLine = true;
  p.framesetOk = false;
}
function formStartTagInBody$1(p, token2) {
  const inTemplate = p.openElements.tmplCount > 0;
  if (!p.formElement || inTemplate) {
    if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
      p._closePElement();
    }
    p._insertElement(token2, html_js_1$6.NS.HTML);
    if (!inTemplate) {
      p.formElement = p.openElements.current;
    }
  }
}
function listItemStartTagInBody$1(p, token2) {
  p.framesetOk = false;
  const tn = token2.tagID;
  for (let i = p.openElements.stackTop; i >= 0; i--) {
    const elementId = p.openElements.tagIDs[i];
    if (tn === html_js_1$6.TAG_ID.LI && elementId === html_js_1$6.TAG_ID.LI || (tn === html_js_1$6.TAG_ID.DD || tn === html_js_1$6.TAG_ID.DT) && (elementId === html_js_1$6.TAG_ID.DD || elementId === html_js_1$6.TAG_ID.DT)) {
      p.openElements.generateImpliedEndTagsWithExclusion(elementId);
      p.openElements.popUntilTagNamePopped(elementId);
      break;
    }
    if (elementId !== html_js_1$6.TAG_ID.ADDRESS && elementId !== html_js_1$6.TAG_ID.DIV && elementId !== html_js_1$6.TAG_ID.P && p._isSpecialElement(p.openElements.items[i], elementId)) {
      break;
    }
  }
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function plaintextStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.tokenizer.state = index_js_1$1.TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody$1(p, token2) {
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.BUTTON)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.BUTTON);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.framesetOk = false;
}
function aStartTagInBody$1(p, token2) {
  const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(html_js_1$6.TAG_NAMES.A);
  if (activeElementEntry) {
    callAdoptionAgency$1(p, token2);
    p.openElements.remove(activeElementEntry.element);
    p.activeFormattingElements.removeEntry(activeElementEntry);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function bStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function nobrStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.NOBR)) {
    callAdoptionAgency$1(p, token2);
    p._reconstructActiveFormattingElements();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function appletStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.activeFormattingElements.insertMarker();
  p.framesetOk = false;
}
function tableStartTagInBody$1(p, token2) {
  if (p.treeAdapter.getDocumentMode(p.document) !== html_js_1$6.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.framesetOk = false;
  p.insertionMode = InsertionMode$1.IN_TABLE;
}
function areaStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token2, html_js_1$6.NS.HTML);
  p.framesetOk = false;
  token2.ackSelfClosing = true;
}
function isHiddenInput$1(token2) {
  const inputType = (0, token_js_1$2.getTokenAttr)(token2, html_js_1$6.ATTRS.TYPE);
  return inputType != null && inputType.toLowerCase() === HIDDEN_INPUT_TYPE$1;
}
function inputStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token2, html_js_1$6.NS.HTML);
  if (!isHiddenInput$1(token2)) {
    p.framesetOk = false;
  }
  token2.ackSelfClosing = true;
}
function paramStartTagInBody$1(p, token2) {
  p._appendElement(token2, html_js_1$6.NS.HTML);
  token2.ackSelfClosing = true;
}
function hrStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._appendElement(token2, html_js_1$6.NS.HTML);
  p.framesetOk = false;
  token2.ackSelfClosing = true;
}
function imageStartTagInBody$1(p, token2) {
  token2.tagName = html_js_1$6.TAG_NAMES.IMG;
  token2.tagID = html_js_1$6.TAG_ID.IMG;
  areaStartTagInBody$1(p, token2);
}
function textareaStartTagInBody$1(p, token2) {
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.skipNextNewLine = true;
  p.tokenizer.state = index_js_1$1.TokenizerMode.RCDATA;
  p.originalInsertionMode = p.insertionMode;
  p.framesetOk = false;
  p.insertionMode = InsertionMode$1.TEXT;
}
function xmpStartTagInBody$1(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._closePElement();
  }
  p._reconstructActiveFormattingElements();
  p.framesetOk = false;
  p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody$1(p, token2) {
  p.framesetOk = false;
  p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RAWTEXT);
}
function noembedStartTagInBody$1(p, token2) {
  p._switchToTextParsing(token2, index_js_1$1.TokenizerMode.RAWTEXT);
}
function selectStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.framesetOk = false;
  p.insertionMode = p.insertionMode === InsertionMode$1.IN_TABLE || p.insertionMode === InsertionMode$1.IN_CAPTION || p.insertionMode === InsertionMode$1.IN_TABLE_BODY || p.insertionMode === InsertionMode$1.IN_ROW || p.insertionMode === InsertionMode$1.IN_CELL ? InsertionMode$1.IN_SELECT_IN_TABLE : InsertionMode$1.IN_SELECT;
}
function optgroupStartTagInBody$1(p, token2) {
  if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTION) {
    p.openElements.pop();
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function rbStartTagInBody$1(p, token2) {
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTags();
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function rtStartTagInBody$1(p, token2) {
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTagsWithExclusion(html_js_1$6.TAG_ID.RTC);
  }
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function mathStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  foreignContent$2.adjustTokenMathMLAttrs(token2);
  foreignContent$2.adjustTokenXMLAttrs(token2);
  if (token2.selfClosing) {
    p._appendElement(token2, html_js_1$6.NS.MATHML);
  } else {
    p._insertElement(token2, html_js_1$6.NS.MATHML);
  }
  token2.ackSelfClosing = true;
}
function svgStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  foreignContent$2.adjustTokenSVGAttrs(token2);
  foreignContent$2.adjustTokenXMLAttrs(token2);
  if (token2.selfClosing) {
    p._appendElement(token2, html_js_1$6.NS.SVG);
  } else {
    p._insertElement(token2, html_js_1$6.NS.SVG);
  }
  token2.ackSelfClosing = true;
}
function genericStartTagInBody$1(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$6.NS.HTML);
}
function startTagInBody$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.I:
    case html_js_1$6.TAG_ID.S:
    case html_js_1$6.TAG_ID.B:
    case html_js_1$6.TAG_ID.U:
    case html_js_1$6.TAG_ID.EM:
    case html_js_1$6.TAG_ID.TT:
    case html_js_1$6.TAG_ID.BIG:
    case html_js_1$6.TAG_ID.CODE:
    case html_js_1$6.TAG_ID.FONT:
    case html_js_1$6.TAG_ID.SMALL:
    case html_js_1$6.TAG_ID.STRIKE:
    case html_js_1$6.TAG_ID.STRONG: {
      bStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.A: {
      aStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.H1:
    case html_js_1$6.TAG_ID.H2:
    case html_js_1$6.TAG_ID.H3:
    case html_js_1$6.TAG_ID.H4:
    case html_js_1$6.TAG_ID.H5:
    case html_js_1$6.TAG_ID.H6: {
      numberedHeaderStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.P:
    case html_js_1$6.TAG_ID.DL:
    case html_js_1$6.TAG_ID.OL:
    case html_js_1$6.TAG_ID.UL:
    case html_js_1$6.TAG_ID.DIV:
    case html_js_1$6.TAG_ID.DIR:
    case html_js_1$6.TAG_ID.NAV:
    case html_js_1$6.TAG_ID.MAIN:
    case html_js_1$6.TAG_ID.MENU:
    case html_js_1$6.TAG_ID.ASIDE:
    case html_js_1$6.TAG_ID.CENTER:
    case html_js_1$6.TAG_ID.FIGURE:
    case html_js_1$6.TAG_ID.FOOTER:
    case html_js_1$6.TAG_ID.HEADER:
    case html_js_1$6.TAG_ID.HGROUP:
    case html_js_1$6.TAG_ID.DIALOG:
    case html_js_1$6.TAG_ID.DETAILS:
    case html_js_1$6.TAG_ID.ADDRESS:
    case html_js_1$6.TAG_ID.ARTICLE:
    case html_js_1$6.TAG_ID.SECTION:
    case html_js_1$6.TAG_ID.SUMMARY:
    case html_js_1$6.TAG_ID.FIELDSET:
    case html_js_1$6.TAG_ID.BLOCKQUOTE:
    case html_js_1$6.TAG_ID.FIGCAPTION: {
      addressStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.LI:
    case html_js_1$6.TAG_ID.DD:
    case html_js_1$6.TAG_ID.DT: {
      listItemStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BR:
    case html_js_1$6.TAG_ID.IMG:
    case html_js_1$6.TAG_ID.WBR:
    case html_js_1$6.TAG_ID.AREA:
    case html_js_1$6.TAG_ID.EMBED:
    case html_js_1$6.TAG_ID.KEYGEN: {
      areaStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.HR: {
      hrStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.RB:
    case html_js_1$6.TAG_ID.RTC: {
      rbStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.RT:
    case html_js_1$6.TAG_ID.RP: {
      rtStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.PRE:
    case html_js_1$6.TAG_ID.LISTING: {
      preStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.XMP: {
      xmpStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.SVG: {
      svgStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.HTML: {
      htmlStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BASE:
    case html_js_1$6.TAG_ID.LINK:
    case html_js_1$6.TAG_ID.META:
    case html_js_1$6.TAG_ID.STYLE:
    case html_js_1$6.TAG_ID.TITLE:
    case html_js_1$6.TAG_ID.SCRIPT:
    case html_js_1$6.TAG_ID.BGSOUND:
    case html_js_1$6.TAG_ID.BASEFONT:
    case html_js_1$6.TAG_ID.TEMPLATE: {
      startTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BODY: {
      bodyStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.FORM: {
      formStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOBR: {
      nobrStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.MATH: {
      mathStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TABLE: {
      tableStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.INPUT: {
      inputStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.PARAM:
    case html_js_1$6.TAG_ID.TRACK:
    case html_js_1$6.TAG_ID.SOURCE: {
      paramStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.IMAGE: {
      imageStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BUTTON: {
      buttonStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.APPLET:
    case html_js_1$6.TAG_ID.OBJECT:
    case html_js_1$6.TAG_ID.MARQUEE: {
      appletStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.IFRAME: {
      iframeStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.SELECT: {
      selectStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.OPTION:
    case html_js_1$6.TAG_ID.OPTGROUP: {
      optgroupStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOEMBED: {
      noembedStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.FRAMESET: {
      framesetStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TEXTAREA: {
      textareaStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOSCRIPT: {
      if (p.options.scriptingEnabled) {
        noembedStartTagInBody$1(p, token2);
      } else {
        genericStartTagInBody$1(p, token2);
      }
      break;
    }
    case html_js_1$6.TAG_ID.PLAINTEXT: {
      plaintextStartTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TR:
    case html_js_1$6.TAG_ID.HEAD:
    case html_js_1$6.TAG_ID.FRAME:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD:
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COLGROUP: {
      break;
    }
    default: {
      genericStartTagInBody$1(p, token2);
    }
  }
}
function bodyEndTagInBody$1(p, token2) {
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.BODY)) {
    p.insertionMode = InsertionMode$1.AFTER_BODY;
    if (p.options.sourceCodeLocationInfo) {
      const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
      if (bodyElement) {
        p._setEndLocation(bodyElement, token2);
      }
    }
  }
}
function htmlEndTagInBody$1(p, token2) {
  if (p.openElements.hasInScope(html_js_1$6.TAG_ID.BODY)) {
    p.insertionMode = InsertionMode$1.AFTER_BODY;
    endTagAfterBody$1(p, token2);
  }
}
function addressEndTagInBody$1(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function formEndTagInBody$1(p) {
  const inTemplate = p.openElements.tmplCount > 0;
  const {
    formElement
  } = p;
  if (!inTemplate) {
    p.formElement = null;
  }
  if ((formElement || inTemplate) && p.openElements.hasInScope(html_js_1$6.TAG_ID.FORM)) {
    p.openElements.generateImpliedEndTags();
    if (inTemplate) {
      p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.FORM);
    } else if (formElement) {
      p.openElements.remove(formElement);
    }
  }
}
function pEndTagInBody$1(p) {
  if (!p.openElements.hasInButtonScope(html_js_1$6.TAG_ID.P)) {
    p._insertFakeElement(html_js_1$6.TAG_NAMES.P, html_js_1$6.TAG_ID.P);
  }
  p._closePElement();
}
function liEndTagInBody$1(p) {
  if (p.openElements.hasInListItemScope(html_js_1$6.TAG_ID.LI)) {
    p.openElements.generateImpliedEndTagsWithExclusion(html_js_1$6.TAG_ID.LI);
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.LI);
  }
}
function ddEndTagInBody$1(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTagsWithExclusion(tn);
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function numberedHeaderEndTagInBody$1(p) {
  if (p.openElements.hasNumberedHeaderInScope()) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilNumberedHeaderPopped();
  }
}
function appletEndTagInBody$1(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
    p.activeFormattingElements.clearToLastMarker();
  }
}
function brEndTagInBody$1(p) {
  p._reconstructActiveFormattingElements();
  p._insertFakeElement(html_js_1$6.TAG_NAMES.BR, html_js_1$6.TAG_ID.BR);
  p.openElements.pop();
  p.framesetOk = false;
}
function genericEndTagInBody$1(p, token2) {
  const tn = token2.tagName;
  const tid = token2.tagID;
  for (let i = p.openElements.stackTop; i > 0; i--) {
    const element = p.openElements.items[i];
    const elementId = p.openElements.tagIDs[i];
    if (tid === elementId && (tid !== html_js_1$6.TAG_ID.UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
      p.openElements.generateImpliedEndTagsWithExclusion(tid);
      if (p.openElements.stackTop >= i)
        p.openElements.shortenToLength(i);
      break;
    }
    if (p._isSpecialElement(element, elementId)) {
      break;
    }
  }
}
function endTagInBody$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.A:
    case html_js_1$6.TAG_ID.B:
    case html_js_1$6.TAG_ID.I:
    case html_js_1$6.TAG_ID.S:
    case html_js_1$6.TAG_ID.U:
    case html_js_1$6.TAG_ID.EM:
    case html_js_1$6.TAG_ID.TT:
    case html_js_1$6.TAG_ID.BIG:
    case html_js_1$6.TAG_ID.CODE:
    case html_js_1$6.TAG_ID.FONT:
    case html_js_1$6.TAG_ID.NOBR:
    case html_js_1$6.TAG_ID.SMALL:
    case html_js_1$6.TAG_ID.STRIKE:
    case html_js_1$6.TAG_ID.STRONG: {
      callAdoptionAgency$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.P: {
      pEndTagInBody$1(p);
      break;
    }
    case html_js_1$6.TAG_ID.DL:
    case html_js_1$6.TAG_ID.UL:
    case html_js_1$6.TAG_ID.OL:
    case html_js_1$6.TAG_ID.DIR:
    case html_js_1$6.TAG_ID.DIV:
    case html_js_1$6.TAG_ID.NAV:
    case html_js_1$6.TAG_ID.PRE:
    case html_js_1$6.TAG_ID.MAIN:
    case html_js_1$6.TAG_ID.MENU:
    case html_js_1$6.TAG_ID.ASIDE:
    case html_js_1$6.TAG_ID.BUTTON:
    case html_js_1$6.TAG_ID.CENTER:
    case html_js_1$6.TAG_ID.FIGURE:
    case html_js_1$6.TAG_ID.FOOTER:
    case html_js_1$6.TAG_ID.HEADER:
    case html_js_1$6.TAG_ID.HGROUP:
    case html_js_1$6.TAG_ID.DIALOG:
    case html_js_1$6.TAG_ID.ADDRESS:
    case html_js_1$6.TAG_ID.ARTICLE:
    case html_js_1$6.TAG_ID.DETAILS:
    case html_js_1$6.TAG_ID.SECTION:
    case html_js_1$6.TAG_ID.SUMMARY:
    case html_js_1$6.TAG_ID.LISTING:
    case html_js_1$6.TAG_ID.FIELDSET:
    case html_js_1$6.TAG_ID.BLOCKQUOTE:
    case html_js_1$6.TAG_ID.FIGCAPTION: {
      addressEndTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.LI: {
      liEndTagInBody$1(p);
      break;
    }
    case html_js_1$6.TAG_ID.DD:
    case html_js_1$6.TAG_ID.DT: {
      ddEndTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.H1:
    case html_js_1$6.TAG_ID.H2:
    case html_js_1$6.TAG_ID.H3:
    case html_js_1$6.TAG_ID.H4:
    case html_js_1$6.TAG_ID.H5:
    case html_js_1$6.TAG_ID.H6: {
      numberedHeaderEndTagInBody$1(p);
      break;
    }
    case html_js_1$6.TAG_ID.BR: {
      brEndTagInBody$1(p);
      break;
    }
    case html_js_1$6.TAG_ID.BODY: {
      bodyEndTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.HTML: {
      htmlEndTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.FORM: {
      formEndTagInBody$1(p);
      break;
    }
    case html_js_1$6.TAG_ID.APPLET:
    case html_js_1$6.TAG_ID.OBJECT:
    case html_js_1$6.TAG_ID.MARQUEE: {
      appletEndTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
    default: {
      genericEndTagInBody$1(p, token2);
    }
  }
}
function eofInBody$1(p, token2) {
  if (p.tmplInsertionModeStack.length > 0) {
    eofInTemplate$1(p, token2);
  } else {
    stopParsing$1(p, token2);
  }
}
function endTagInText$1(p, token2) {
  var _a;
  if (token2.tagID === html_js_1$6.TAG_ID.SCRIPT) {
    (_a = p.scriptHandler) === null || _a === void 0 ? void 0 : _a.call(p, p.openElements.current);
  }
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
}
function eofInText$1(p, token2) {
  p._err(token2, error_codes_js_1$3.ERR.eofInElementThatCanContainOnlyText);
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
  p.onEof(token2);
}
function characterInTable$1(p, token2) {
  if (TABLE_STRUCTURE_TAGS$1.has(p.openElements.currentTagId)) {
    p.pendingCharacterTokens.length = 0;
    p.hasNonWhitespacePendingCharacterToken = false;
    p.originalInsertionMode = p.insertionMode;
    p.insertionMode = InsertionMode$1.IN_TABLE_TEXT;
    switch (token2.type) {
      case token_js_1$2.TokenType.CHARACTER: {
        characterInTableText$1(p, token2);
        break;
      }
      case token_js_1$2.TokenType.WHITESPACE_CHARACTER: {
        whitespaceCharacterInTableText$1(p, token2);
        break;
      }
    }
  } else {
    tokenInTable$1(p, token2);
  }
}
function captionStartTagInTable$1(p, token2) {
  p.openElements.clearBackToTableContext();
  p.activeFormattingElements.insertMarker();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.insertionMode = InsertionMode$1.IN_CAPTION;
}
function colgroupStartTagInTable$1(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.insertionMode = InsertionMode$1.IN_COLUMN_GROUP;
}
function colStartTagInTable$1(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(html_js_1$6.TAG_NAMES.COLGROUP, html_js_1$6.TAG_ID.COLGROUP);
  p.insertionMode = InsertionMode$1.IN_COLUMN_GROUP;
  startTagInColumnGroup$1(p, token2);
}
function tbodyStartTagInTable$1(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token2, html_js_1$6.NS.HTML);
  p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
}
function tdStartTagInTable$1(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(html_js_1$6.TAG_NAMES.TBODY, html_js_1$6.TAG_ID.TBODY);
  p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
  startTagInTableBody$1(p, token2);
}
function tableStartTagInTable$1(p, token2) {
  if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TABLE)) {
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.TABLE);
    p._resetInsertionMode();
    p._processStartTag(token2);
  }
}
function inputStartTagInTable$1(p, token2) {
  if (isHiddenInput$1(token2)) {
    p._appendElement(token2, html_js_1$6.NS.HTML);
  } else {
    tokenInTable$1(p, token2);
  }
  token2.ackSelfClosing = true;
}
function formStartTagInTable$1(p, token2) {
  if (!p.formElement && p.openElements.tmplCount === 0) {
    p._insertElement(token2, html_js_1$6.NS.HTML);
    p.formElement = p.openElements.current;
    p.openElements.pop();
  }
}
function startTagInTable$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.TR: {
      tdStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.STYLE:
    case html_js_1$6.TAG_ID.SCRIPT:
    case html_js_1$6.TAG_ID.TEMPLATE: {
      startTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COL: {
      colStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.FORM: {
      formStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TABLE: {
      tableStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD: {
      tbodyStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.INPUT: {
      inputStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.CAPTION: {
      captionStartTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COLGROUP: {
      colgroupStartTagInTable$1(p, token2);
      break;
    }
    default: {
      tokenInTable$1(p, token2);
    }
  }
}
function endTagInTable$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TABLE)) {
        p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.TABLE);
        p._resetInsertionMode();
      }
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.HTML:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.THEAD:
    case html_js_1$6.TAG_ID.TR: {
      break;
    }
    default: {
      tokenInTable$1(p, token2);
    }
  }
}
function tokenInTable$1(p, token2) {
  const savedFosterParentingState = p.fosterParentingEnabled;
  p.fosterParentingEnabled = true;
  modeInBody$1(p, token2);
  p.fosterParentingEnabled = savedFosterParentingState;
}
function whitespaceCharacterInTableText$1(p, token2) {
  p.pendingCharacterTokens.push(token2);
}
function characterInTableText$1(p, token2) {
  p.pendingCharacterTokens.push(token2);
  p.hasNonWhitespacePendingCharacterToken = true;
}
function tokenInTableText$1(p, token2) {
  let i = 0;
  if (p.hasNonWhitespacePendingCharacterToken) {
    for (; i < p.pendingCharacterTokens.length; i++) {
      tokenInTable$1(p, p.pendingCharacterTokens[i]);
    }
  } else {
    for (; i < p.pendingCharacterTokens.length; i++) {
      p._insertCharacters(p.pendingCharacterTokens[i]);
    }
  }
  p.insertionMode = p.originalInsertionMode;
  p._processToken(token2);
}
const TABLE_VOID_ELEMENTS$1 = /* @__PURE__ */ new Set([html_js_1$6.TAG_ID.CAPTION, html_js_1$6.TAG_ID.COL, html_js_1$6.TAG_ID.COLGROUP, html_js_1$6.TAG_ID.TBODY, html_js_1$6.TAG_ID.TD, html_js_1$6.TAG_ID.TFOOT, html_js_1$6.TAG_ID.TH, html_js_1$6.TAG_ID.THEAD, html_js_1$6.TAG_ID.TR]);
function startTagInCaption$1(p, token2) {
  const tn = token2.tagID;
  if (TABLE_VOID_ELEMENTS$1.has(tn)) {
    if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.CAPTION)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.CAPTION);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = InsertionMode$1.IN_TABLE;
      startTagInTable$1(p, token2);
    }
  } else {
    startTagInBody$1(p, token2);
  }
}
function endTagInCaption$1(p, token2) {
  const tn = token2.tagID;
  switch (tn) {
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.CAPTION)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.CAPTION);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = InsertionMode$1.IN_TABLE;
        if (tn === html_js_1$6.TAG_ID.TABLE) {
          endTagInTable$1(p, token2);
        }
      }
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.HTML:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.THEAD:
    case html_js_1$6.TAG_ID.TR: {
      break;
    }
    default: {
      endTagInBody$1(p, token2);
    }
  }
}
function startTagInColumnGroup$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COL: {
      p._appendElement(token2, html_js_1$6.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      startTagInHead$1(p, token2);
      break;
    }
    default: {
      tokenInColumnGroup$1(p, token2);
    }
  }
}
function endTagInColumnGroup$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.COLGROUP: {
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE;
      }
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COL: {
      break;
    }
    default: {
      tokenInColumnGroup$1(p, token2);
    }
  }
}
function tokenInColumnGroup$1(p, token2) {
  if (p.openElements.currentTagId === html_js_1$6.TAG_ID.COLGROUP) {
    p.openElements.pop();
    p.insertionMode = InsertionMode$1.IN_TABLE;
    p._processToken(token2);
  }
}
function startTagInTableBody$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TR: {
      p.openElements.clearBackToTableBodyContext();
      p._insertElement(token2, html_js_1$6.NS.HTML);
      p.insertionMode = InsertionMode$1.IN_ROW;
      break;
    }
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.TD: {
      p.openElements.clearBackToTableBodyContext();
      p._insertFakeElement(html_js_1$6.TAG_NAMES.TR, html_js_1$6.TAG_ID.TR);
      p.insertionMode = InsertionMode$1.IN_ROW;
      startTagInRow$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD: {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE;
        startTagInTable$1(p, token2);
      }
      break;
    }
    default: {
      startTagInTable$1(p, token2);
    }
  }
}
function endTagInTableBody$1(p, token2) {
  const tn = token2.tagID;
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD: {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE;
      }
      break;
    }
    case html_js_1$6.TAG_ID.TABLE: {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE;
        endTagInTable$1(p, token2);
      }
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.HTML:
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.TR: {
      break;
    }
    default: {
      endTagInTable$1(p, token2);
    }
  }
}
function startTagInRow$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TH:
    case html_js_1$6.TAG_ID.TD: {
      p.openElements.clearBackToTableRowContext();
      p._insertElement(token2, html_js_1$6.NS.HTML);
      p.insertionMode = InsertionMode$1.IN_CELL;
      p.activeFormattingElements.insertMarker();
      break;
    }
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD:
    case html_js_1$6.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
        startTagInTableBody$1(p, token2);
      }
      break;
    }
    default: {
      startTagInTable$1(p, token2);
    }
  }
}
function endTagInRow$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
      }
      break;
    }
    case html_js_1$6.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
        endTagInTableBody$1(p, token2);
      }
      break;
    }
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD: {
      if (p.openElements.hasInTableScope(token2.tagID) || p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
        endTagInTableBody$1(p, token2);
      }
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.HTML:
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TH: {
      break;
    }
    default: {
      endTagInTable$1(p, token2);
    }
  }
}
function startTagInCell$1(p, token2) {
  const tn = token2.tagID;
  if (TABLE_VOID_ELEMENTS$1.has(tn)) {
    if (p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TD) || p.openElements.hasInTableScope(html_js_1$6.TAG_ID.TH)) {
      p._closeTableCell();
      startTagInRow$1(p, token2);
    }
  } else {
    startTagInBody$1(p, token2);
  }
}
function endTagInCell$1(p, token2) {
  const tn = token2.tagID;
  switch (tn) {
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TH: {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = InsertionMode$1.IN_ROW;
      }
      break;
    }
    case html_js_1$6.TAG_ID.TABLE:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD:
    case html_js_1$6.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(tn)) {
        p._closeTableCell();
        endTagInRow$1(p, token2);
      }
      break;
    }
    case html_js_1$6.TAG_ID.BODY:
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COL:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.HTML: {
      break;
    }
    default: {
      endTagInBody$1(p, token2);
    }
  }
}
function startTagInSelect$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.OPTION: {
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      p._insertElement(token2, html_js_1$6.NS.HTML);
      break;
    }
    case html_js_1$6.TAG_ID.OPTGROUP: {
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      p._insertElement(token2, html_js_1$6.NS.HTML);
      break;
    }
    case html_js_1$6.TAG_ID.INPUT:
    case html_js_1$6.TAG_ID.KEYGEN:
    case html_js_1$6.TAG_ID.TEXTAREA:
    case html_js_1$6.TAG_ID.SELECT: {
      if (p.openElements.hasInSelectScope(html_js_1$6.TAG_ID.SELECT)) {
        p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.SELECT);
        p._resetInsertionMode();
        if (token2.tagID !== html_js_1$6.TAG_ID.SELECT) {
          p._processStartTag(token2);
        }
      }
      break;
    }
    case html_js_1$6.TAG_ID.SCRIPT:
    case html_js_1$6.TAG_ID.TEMPLATE: {
      startTagInHead$1(p, token2);
      break;
    }
  }
}
function endTagInSelect$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.OPTGROUP: {
      if (p.openElements.stackTop > 0 && p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === html_js_1$6.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      break;
    }
    case html_js_1$6.TAG_ID.OPTION: {
      if (p.openElements.currentTagId === html_js_1$6.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      break;
    }
    case html_js_1$6.TAG_ID.SELECT: {
      if (p.openElements.hasInSelectScope(html_js_1$6.TAG_ID.SELECT)) {
        p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.SELECT);
        p._resetInsertionMode();
      }
      break;
    }
    case html_js_1$6.TAG_ID.TEMPLATE: {
      templateEndTagInHead$1(p, token2);
      break;
    }
  }
}
function startTagInSelectInTable$1(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$6.TAG_ID.CAPTION || tn === html_js_1$6.TAG_ID.TABLE || tn === html_js_1$6.TAG_ID.TBODY || tn === html_js_1$6.TAG_ID.TFOOT || tn === html_js_1$6.TAG_ID.THEAD || tn === html_js_1$6.TAG_ID.TR || tn === html_js_1$6.TAG_ID.TD || tn === html_js_1$6.TAG_ID.TH) {
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.SELECT);
    p._resetInsertionMode();
    p._processStartTag(token2);
  } else {
    startTagInSelect$1(p, token2);
  }
}
function endTagInSelectInTable$1(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$6.TAG_ID.CAPTION || tn === html_js_1$6.TAG_ID.TABLE || tn === html_js_1$6.TAG_ID.TBODY || tn === html_js_1$6.TAG_ID.TFOOT || tn === html_js_1$6.TAG_ID.THEAD || tn === html_js_1$6.TAG_ID.TR || tn === html_js_1$6.TAG_ID.TD || tn === html_js_1$6.TAG_ID.TH) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.SELECT);
      p._resetInsertionMode();
      p.onEndTag(token2);
    }
  } else {
    endTagInSelect$1(p, token2);
  }
}
function startTagInTemplate$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.BASE:
    case html_js_1$6.TAG_ID.BASEFONT:
    case html_js_1$6.TAG_ID.BGSOUND:
    case html_js_1$6.TAG_ID.LINK:
    case html_js_1$6.TAG_ID.META:
    case html_js_1$6.TAG_ID.NOFRAMES:
    case html_js_1$6.TAG_ID.SCRIPT:
    case html_js_1$6.TAG_ID.STYLE:
    case html_js_1$6.TAG_ID.TEMPLATE:
    case html_js_1$6.TAG_ID.TITLE: {
      startTagInHead$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.CAPTION:
    case html_js_1$6.TAG_ID.COLGROUP:
    case html_js_1$6.TAG_ID.TBODY:
    case html_js_1$6.TAG_ID.TFOOT:
    case html_js_1$6.TAG_ID.THEAD: {
      p.tmplInsertionModeStack[0] = InsertionMode$1.IN_TABLE;
      p.insertionMode = InsertionMode$1.IN_TABLE;
      startTagInTable$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.COL: {
      p.tmplInsertionModeStack[0] = InsertionMode$1.IN_COLUMN_GROUP;
      p.insertionMode = InsertionMode$1.IN_COLUMN_GROUP;
      startTagInColumnGroup$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TR: {
      p.tmplInsertionModeStack[0] = InsertionMode$1.IN_TABLE_BODY;
      p.insertionMode = InsertionMode$1.IN_TABLE_BODY;
      startTagInTableBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.TD:
    case html_js_1$6.TAG_ID.TH: {
      p.tmplInsertionModeStack[0] = InsertionMode$1.IN_ROW;
      p.insertionMode = InsertionMode$1.IN_ROW;
      startTagInRow$1(p, token2);
      break;
    }
    default: {
      p.tmplInsertionModeStack[0] = InsertionMode$1.IN_BODY;
      p.insertionMode = InsertionMode$1.IN_BODY;
      startTagInBody$1(p, token2);
    }
  }
}
function endTagInTemplate$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.TEMPLATE) {
    templateEndTagInHead$1(p, token2);
  }
}
function eofInTemplate$1(p, token2) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.popUntilTagNamePopped(html_js_1$6.TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
    p.onEof(token2);
  } else {
    stopParsing$1(p, token2);
  }
}
function startTagAfterBody$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.HTML) {
    startTagInBody$1(p, token2);
  } else {
    tokenAfterBody$1(p, token2);
  }
}
function endTagAfterBody$1(p, token2) {
  var _a;
  if (token2.tagID === html_js_1$6.TAG_ID.HTML) {
    if (!p.fragmentContext) {
      p.insertionMode = InsertionMode$1.AFTER_AFTER_BODY;
    }
    if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === html_js_1$6.TAG_ID.HTML) {
      p._setEndLocation(p.openElements.items[0], token2);
      const bodyElement = p.openElements.items[1];
      if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) {
        p._setEndLocation(bodyElement, token2);
      }
    }
  } else {
    tokenAfterBody$1(p, token2);
  }
}
function tokenAfterBody$1(p, token2) {
  p.insertionMode = InsertionMode$1.IN_BODY;
  modeInBody$1(p, token2);
}
function startTagInFrameset$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.FRAMESET: {
      p._insertElement(token2, html_js_1$6.NS.HTML);
      break;
    }
    case html_js_1$6.TAG_ID.FRAME: {
      p._appendElement(token2, html_js_1$6.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$6.TAG_ID.NOFRAMES: {
      startTagInHead$1(p, token2);
      break;
    }
  }
}
function endTagInFrameset$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
    p.openElements.pop();
    if (!p.fragmentContext && p.openElements.currentTagId !== html_js_1$6.TAG_ID.FRAMESET) {
      p.insertionMode = InsertionMode$1.AFTER_FRAMESET;
    }
  }
}
function startTagAfterFrameset$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOFRAMES: {
      startTagInHead$1(p, token2);
      break;
    }
  }
}
function endTagAfterFrameset$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.HTML) {
    p.insertionMode = InsertionMode$1.AFTER_AFTER_FRAMESET;
  }
}
function startTagAfterAfterBody$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.HTML) {
    startTagInBody$1(p, token2);
  } else {
    tokenAfterAfterBody$1(p, token2);
  }
}
function tokenAfterAfterBody$1(p, token2) {
  p.insertionMode = InsertionMode$1.IN_BODY;
  modeInBody$1(p, token2);
}
function startTagAfterAfterFrameset$1(p, token2) {
  switch (token2.tagID) {
    case html_js_1$6.TAG_ID.HTML: {
      startTagInBody$1(p, token2);
      break;
    }
    case html_js_1$6.TAG_ID.NOFRAMES: {
      startTagInHead$1(p, token2);
      break;
    }
  }
}
function nullCharacterInForeignContent$1(p, token2) {
  token2.chars = unicode$2.REPLACEMENT_CHARACTER;
  p._insertCharacters(token2);
}
function characterInForeignContent$1(p, token2) {
  p._insertCharacters(token2);
  p.framesetOk = false;
}
function popUntilHtmlOrIntegrationPoint$1(p) {
  while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== html_js_1$6.NS.HTML && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current)) {
    p.openElements.pop();
  }
}
function startTagInForeignContent$1(p, token2) {
  if (foreignContent$2.causesExit(token2)) {
    popUntilHtmlOrIntegrationPoint$1(p);
    p._startTagOutsideForeignContent(token2);
  } else {
    const current = p._getAdjustedCurrentElement();
    const currentNs = p.treeAdapter.getNamespaceURI(current);
    if (currentNs === html_js_1$6.NS.MATHML) {
      foreignContent$2.adjustTokenMathMLAttrs(token2);
    } else if (currentNs === html_js_1$6.NS.SVG) {
      foreignContent$2.adjustTokenSVGTagName(token2);
      foreignContent$2.adjustTokenSVGAttrs(token2);
    }
    foreignContent$2.adjustTokenXMLAttrs(token2);
    if (token2.selfClosing) {
      p._appendElement(token2, currentNs);
    } else {
      p._insertElement(token2, currentNs);
    }
    token2.ackSelfClosing = true;
  }
}
function endTagInForeignContent$1(p, token2) {
  if (token2.tagID === html_js_1$6.TAG_ID.P || token2.tagID === html_js_1$6.TAG_ID.BR) {
    popUntilHtmlOrIntegrationPoint$1(p);
    p._endTagOutsideForeignContent(token2);
    return;
  }
  for (let i = p.openElements.stackTop; i > 0; i--) {
    const element = p.openElements.items[i];
    if (p.treeAdapter.getNamespaceURI(element) === html_js_1$6.NS.HTML) {
      p._endTagOutsideForeignContent(token2);
      break;
    }
    const tagName = p.treeAdapter.getTagName(element);
    if (tagName.toLowerCase() === token2.tagName) {
      token2.tagName = tagName;
      p.openElements.shortenToLength(i);
      break;
    }
  }
}
var serializer$1 = {};
Object.defineProperty(serializer$1, "__esModule", {
  value: true
});
serializer$1.serializeOuter = serializer$1.serialize = void 0;
const html_js_1$5 = html$2;
const escape_js_1$1 = _escape;
const default_js_1$2 = _default$5;
const VOID_ELEMENTS$1 = /* @__PURE__ */ new Set([html_js_1$5.TAG_NAMES.AREA, html_js_1$5.TAG_NAMES.BASE, html_js_1$5.TAG_NAMES.BASEFONT, html_js_1$5.TAG_NAMES.BGSOUND, html_js_1$5.TAG_NAMES.BR, html_js_1$5.TAG_NAMES.COL, html_js_1$5.TAG_NAMES.EMBED, html_js_1$5.TAG_NAMES.FRAME, html_js_1$5.TAG_NAMES.HR, html_js_1$5.TAG_NAMES.IMG, html_js_1$5.TAG_NAMES.INPUT, html_js_1$5.TAG_NAMES.KEYGEN, html_js_1$5.TAG_NAMES.LINK, html_js_1$5.TAG_NAMES.META, html_js_1$5.TAG_NAMES.PARAM, html_js_1$5.TAG_NAMES.SOURCE, html_js_1$5.TAG_NAMES.TRACK, html_js_1$5.TAG_NAMES.WBR]);
function isVoidElement$1(node2, options2) {
  return options2.treeAdapter.isElementNode(node2) && options2.treeAdapter.getNamespaceURI(node2) === html_js_1$5.NS.HTML && VOID_ELEMENTS$1.has(options2.treeAdapter.getTagName(node2));
}
const defaultOpts$1 = {
  treeAdapter: default_js_1$2.defaultTreeAdapter,
  scriptingEnabled: true
};
function serialize$1(node2, options2) {
  const opts = Object.assign(Object.assign({}, defaultOpts$1), options2);
  if (isVoidElement$1(node2, opts)) {
    return "";
  }
  return serializeChildNodes$1(node2, opts);
}
serializer$1.serialize = serialize$1;
function serializeOuter$1(node2, options2) {
  const opts = Object.assign(Object.assign({}, defaultOpts$1), options2);
  return serializeNode$1(node2, opts);
}
serializer$1.serializeOuter = serializeOuter$1;
function serializeChildNodes$1(parentNode, options2) {
  let html2 = "";
  const container = options2.treeAdapter.isElementNode(parentNode) && options2.treeAdapter.getTagName(parentNode) === html_js_1$5.TAG_NAMES.TEMPLATE && options2.treeAdapter.getNamespaceURI(parentNode) === html_js_1$5.NS.HTML ? options2.treeAdapter.getTemplateContent(parentNode) : parentNode;
  const childNodes = options2.treeAdapter.getChildNodes(container);
  if (childNodes) {
    for (const currentNode of childNodes) {
      html2 += serializeNode$1(currentNode, options2);
    }
  }
  return html2;
}
function serializeNode$1(node2, options2) {
  if (options2.treeAdapter.isElementNode(node2)) {
    return serializeElement$1(node2, options2);
  }
  if (options2.treeAdapter.isTextNode(node2)) {
    return serializeTextNode$1(node2, options2);
  }
  if (options2.treeAdapter.isCommentNode(node2)) {
    return serializeCommentNode$1(node2, options2);
  }
  if (options2.treeAdapter.isDocumentTypeNode(node2)) {
    return serializeDocumentTypeNode$1(node2, options2);
  }
  return "";
}
function serializeElement$1(node2, options2) {
  const tn = options2.treeAdapter.getTagName(node2);
  return `<${tn}${serializeAttributes$1(node2, options2)}>${isVoidElement$1(node2, options2) ? "" : `${serializeChildNodes$1(node2, options2)}</${tn}>`}`;
}
function serializeAttributes$1(node2, {
  treeAdapter
}) {
  let html2 = "";
  for (const attr2 of treeAdapter.getAttrList(node2)) {
    html2 += " ";
    if (!attr2.namespace) {
      html2 += attr2.name;
    } else
      switch (attr2.namespace) {
        case html_js_1$5.NS.XML: {
          html2 += `xml:${attr2.name}`;
          break;
        }
        case html_js_1$5.NS.XMLNS: {
          if (attr2.name !== "xmlns") {
            html2 += "xmlns:";
          }
          html2 += attr2.name;
          break;
        }
        case html_js_1$5.NS.XLINK: {
          html2 += `xlink:${attr2.name}`;
          break;
        }
        default: {
          html2 += `${attr2.prefix}:${attr2.name}`;
        }
      }
    html2 += `="${(0, escape_js_1$1.escapeAttribute)(attr2.value)}"`;
  }
  return html2;
}
function serializeTextNode$1(node2, options2) {
  const {
    treeAdapter
  } = options2;
  const content = treeAdapter.getTextNodeContent(node2);
  const parent = treeAdapter.getParentNode(node2);
  const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
  return parentTn && treeAdapter.getNamespaceURI(parent) === html_js_1$5.NS.HTML && (0, html_js_1$5.hasUnescapedText)(parentTn, options2.scriptingEnabled) ? content : (0, escape_js_1$1.escapeText)(content);
}
function serializeCommentNode$1(node2, {
  treeAdapter
}) {
  return `<!--${treeAdapter.getCommentNodeContent(node2)}-->`;
}
function serializeDocumentTypeNode$1(node2, {
  treeAdapter
}) {
  return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node2)}>`;
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.parseFragment = exports2.parse = exports2.TokenizerMode = exports2.Tokenizer = exports2.Token = exports2.html = exports2.foreignContent = exports2.ErrorCodes = exports2.serializeOuter = exports2.serialize = exports2.Parser = exports2.defaultTreeAdapter = void 0;
  const index_js_12 = parser$2;
  var default_js_12 = _default$5;
  Object.defineProperty(exports2, "defaultTreeAdapter", {
    enumerable: true,
    get: function() {
      return default_js_12.defaultTreeAdapter;
    }
  });
  var index_js_2 = parser$2;
  Object.defineProperty(exports2, "Parser", {
    enumerable: true,
    get: function() {
      return index_js_2.Parser;
    }
  });
  var index_js_3 = serializer$1;
  Object.defineProperty(exports2, "serialize", {
    enumerable: true,
    get: function() {
      return index_js_3.serialize;
    }
  });
  Object.defineProperty(exports2, "serializeOuter", {
    enumerable: true,
    get: function() {
      return index_js_3.serializeOuter;
    }
  });
  var error_codes_js_12 = errorCodes$1;
  Object.defineProperty(exports2, "ErrorCodes", {
    enumerable: true,
    get: function() {
      return error_codes_js_12.ERR;
    }
  });
  exports2.foreignContent = foreignContent$3;
  exports2.html = html$2;
  exports2.Token = token$1;
  var index_js_4 = tokenizer$1;
  Object.defineProperty(exports2, "Tokenizer", {
    enumerable: true,
    get: function() {
      return index_js_4.Tokenizer;
    }
  });
  Object.defineProperty(exports2, "TokenizerMode", {
    enumerable: true,
    get: function() {
      return index_js_4.TokenizerMode;
    }
  });
  function parse2(html2, options2) {
    return index_js_12.Parser.parse(html2, options2);
  }
  exports2.parse = parse2;
  function parseFragment(fragmentContext, html2, options2) {
    if (typeof fragmentContext === "string") {
      options2 = html2;
      html2 = fragmentContext;
      fragmentContext = null;
    }
    const parser2 = index_js_12.Parser.getFragmentParser(fragmentContext, options2);
    parser2.tokenizer.write(html2, true);
    return parser2.getFragment();
  }
  exports2.parseFragment = parseFragment;
})(cjs$2);
var cjs$1 = {};
var cjs = {};
var parser$1 = {};
var tokenizer = {};
var preprocessor = {};
var unicode$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.isUndefinedCodePoint = exports2.isControlCodePoint = exports2.getSurrogatePairCodePoint = exports2.isSurrogatePair = exports2.isSurrogate = exports2.SEQUENCES = exports2.CODE_POINTS = exports2.REPLACEMENT_CHARACTER = void 0;
  const UNDEFINED_CODE_POINTS = /* @__PURE__ */ new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]);
  exports2.REPLACEMENT_CHARACTER = "�";
  (function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["NUMBER_SIGN"] = 35] = "NUMBER_SIGN";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_F"] = 70] = "LATIN_CAPITAL_F";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_X"] = 88] = "LATIN_CAPITAL_X";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_F"] = 102] = "LATIN_SMALL_F";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_X"] = 120] = "LATIN_SMALL_X";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
    CODE_POINTS[CODE_POINTS["REPLACEMENT_CHARACTER"] = 65533] = "REPLACEMENT_CHARACTER";
  })(exports2.CODE_POINTS || (exports2.CODE_POINTS = {}));
  exports2.SEQUENCES = {
    DASH_DASH: "--",
    CDATA_START: "[CDATA[",
    DOCTYPE: "doctype",
    SCRIPT: "script",
    PUBLIC: "public",
    SYSTEM: "system"
  };
  function isSurrogate(cp) {
    return cp >= 55296 && cp <= 57343;
  }
  exports2.isSurrogate = isSurrogate;
  function isSurrogatePair(cp) {
    return cp >= 56320 && cp <= 57343;
  }
  exports2.isSurrogatePair = isSurrogatePair;
  function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
  }
  exports2.getSurrogatePairCodePoint = getSurrogatePairCodePoint;
  function isControlCodePoint(cp) {
    return cp !== 32 && cp !== 10 && cp !== 13 && cp !== 9 && cp !== 12 && cp >= 1 && cp <= 31 || cp >= 127 && cp <= 159;
  }
  exports2.isControlCodePoint = isControlCodePoint;
  function isUndefinedCodePoint(cp) {
    return cp >= 64976 && cp <= 65007 || UNDEFINED_CODE_POINTS.has(cp);
  }
  exports2.isUndefinedCodePoint = isUndefinedCodePoint;
})(unicode$1);
var errorCodes = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.ERR = void 0;
  (function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
  })(exports2.ERR || (exports2.ERR = {}));
})(errorCodes);
function _classCallCheck$1E(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1s(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1s(descriptor.key), descriptor);
  }
}
function _createClass$1C(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1s(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1s(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1s(arg) {
  var key = _toPrimitive$1s(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1s(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(preprocessor, "__esModule", {
  value: true
});
preprocessor.Preprocessor = void 0;
const unicode_js_1$1 = unicode$1;
const error_codes_js_1$2 = errorCodes;
const DEFAULT_BUFFER_WATERLINE = 1 << 16;
let Preprocessor = /* @__PURE__ */ function() {
  function Preprocessor2(handler) {
    _classCallCheck$1E(this, Preprocessor2);
    this.handler = handler;
    this.html = "";
    this.pos = -1;
    this.lastGapPos = -2;
    this.gapStack = [];
    this.skipNextNewLine = false;
    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
    this.isEol = false;
    this.lineStartPos = 0;
    this.droppedBufferSize = 0;
    this.line = 1;
    this.lastErrOffset = -1;
  }
  _createClass$1C(Preprocessor2, [{
    key: "col",
    get: function() {
      return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
  }, {
    key: "offset",
    get: function() {
      return this.droppedBufferSize + this.pos;
    }
  }, {
    key: "getError",
    value: function getError(code2) {
      const {
        line,
        col,
        offset: offset2
      } = this;
      return {
        code: code2,
        startLine: line,
        endLine: line,
        startCol: col,
        endCol: col,
        startOffset: offset2,
        endOffset: offset2
      };
    }
  }, {
    key: "_err",
    value: function _err(code2) {
      if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
        this.lastErrOffset = this.offset;
        this.handler.onParseError(this.getError(code2));
      }
    }
  }, {
    key: "_addGap",
    value: function _addGap() {
      this.gapStack.push(this.lastGapPos);
      this.lastGapPos = this.pos;
    }
  }, {
    key: "_processSurrogate",
    value: function _processSurrogate(cp) {
      if (this.pos !== this.html.length - 1) {
        const nextCp = this.html.charCodeAt(this.pos + 1);
        if ((0, unicode_js_1$1.isSurrogatePair)(nextCp)) {
          this.pos++;
          this._addGap();
          return (0, unicode_js_1$1.getSurrogatePairCodePoint)(cp, nextCp);
        }
      } else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return unicode_js_1$1.CODE_POINTS.EOF;
      }
      this._err(error_codes_js_1$2.ERR.surrogateInInputStream);
      return cp;
    }
  }, {
    key: "willDropParsedChunk",
    value: function willDropParsedChunk() {
      return this.pos > this.bufferWaterline;
    }
  }, {
    key: "dropParsedChunk",
    value: function dropParsedChunk() {
      if (this.willDropParsedChunk()) {
        this.html = this.html.substring(this.pos);
        this.lineStartPos -= this.pos;
        this.droppedBufferSize += this.pos;
        this.pos = 0;
        this.lastGapPos = -2;
        this.gapStack.length = 0;
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk) {
      if (this.html.length > 0) {
        this.html += chunk;
      } else {
        this.html = chunk;
      }
      this.endOfChunkHit = false;
      this.lastChunkWritten = isLastChunk;
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
      this.endOfChunkHit = false;
    }
  }, {
    key: "startsWith",
    value: function startsWith(pattern2, caseSensitive) {
      if (this.pos + pattern2.length > this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return false;
      }
      if (caseSensitive) {
        return this.html.startsWith(pattern2, this.pos);
      }
      for (let i = 0; i < pattern2.length; i++) {
        const cp = this.html.charCodeAt(this.pos + i) | 32;
        if (cp !== pattern2.charCodeAt(i)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "peek",
    value: function peek(offset2) {
      const pos = this.pos + offset2;
      if (pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return unicode_js_1$1.CODE_POINTS.EOF;
      }
      const code2 = this.html.charCodeAt(pos);
      return code2 === unicode_js_1$1.CODE_POINTS.CARRIAGE_RETURN ? unicode_js_1$1.CODE_POINTS.LINE_FEED : code2;
    }
  }, {
    key: "advance",
    value: function advance() {
      this.pos++;
      if (this.isEol) {
        this.isEol = false;
        this.line++;
        this.lineStartPos = this.pos;
      }
      if (this.pos >= this.html.length) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return unicode_js_1$1.CODE_POINTS.EOF;
      }
      let cp = this.html.charCodeAt(this.pos);
      if (cp === unicode_js_1$1.CODE_POINTS.CARRIAGE_RETURN) {
        this.isEol = true;
        this.skipNextNewLine = true;
        return unicode_js_1$1.CODE_POINTS.LINE_FEED;
      }
      if (cp === unicode_js_1$1.CODE_POINTS.LINE_FEED) {
        this.isEol = true;
        if (this.skipNextNewLine) {
          this.line--;
          this.skipNextNewLine = false;
          this._addGap();
          return this.advance();
        }
      }
      this.skipNextNewLine = false;
      if ((0, unicode_js_1$1.isSurrogate)(cp)) {
        cp = this._processSurrogate(cp);
      }
      const isCommonValidRange = this.handler.onParseError === null || cp > 31 && cp < 127 || cp === unicode_js_1$1.CODE_POINTS.LINE_FEED || cp === unicode_js_1$1.CODE_POINTS.CARRIAGE_RETURN || cp > 159 && cp < 64976;
      if (!isCommonValidRange) {
        this._checkForProblematicCharacters(cp);
      }
      return cp;
    }
  }, {
    key: "_checkForProblematicCharacters",
    value: function _checkForProblematicCharacters(cp) {
      if ((0, unicode_js_1$1.isControlCodePoint)(cp)) {
        this._err(error_codes_js_1$2.ERR.controlCharacterInInputStream);
      } else if ((0, unicode_js_1$1.isUndefinedCodePoint)(cp)) {
        this._err(error_codes_js_1$2.ERR.noncharacterInInputStream);
      }
    }
  }, {
    key: "retreat",
    value: function retreat(count2) {
      this.pos -= count2;
      while (this.pos < this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
      }
      this.isEol = false;
    }
  }]);
  return Preprocessor2;
}();
preprocessor.Preprocessor = Preprocessor;
var token = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.getTokenAttr = exports2.TokenType = void 0;
  (function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
  })(exports2.TokenType || (exports2.TokenType = {}));
  function getTokenAttr(token2, attrName) {
    for (let i = token2.attrs.length - 1; i >= 0; i--) {
      if (token2.attrs[i].name === attrName) {
        return token2.attrs[i].value;
      }
    }
    return null;
  }
  exports2.getTokenAttr = getTokenAttr;
})(token);
var html$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.hasUnescapedText = exports2.isNumberedHeader = exports2.SPECIAL_ELEMENTS = exports2.getTagID = exports2.TAG_ID = exports2.TAG_NAMES = exports2.DOCUMENT_MODE = exports2.ATTRS = exports2.NS = void 0;
  var NS;
  (function(NS2) {
    NS2["HTML"] = "http://www.w3.org/1999/xhtml";
    NS2["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS2["SVG"] = "http://www.w3.org/2000/svg";
    NS2["XLINK"] = "http://www.w3.org/1999/xlink";
    NS2["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS2["XMLNS"] = "http://www.w3.org/2000/xmlns/";
  })(NS = exports2.NS || (exports2.NS = {}));
  (function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
  })(exports2.ATTRS || (exports2.ATTRS = {}));
  (function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
  })(exports2.DOCUMENT_MODE || (exports2.DOCUMENT_MODE = {}));
  var TAG_NAMES;
  (function(TAG_NAMES2) {
    TAG_NAMES2["A"] = "a";
    TAG_NAMES2["ADDRESS"] = "address";
    TAG_NAMES2["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES2["APPLET"] = "applet";
    TAG_NAMES2["AREA"] = "area";
    TAG_NAMES2["ARTICLE"] = "article";
    TAG_NAMES2["ASIDE"] = "aside";
    TAG_NAMES2["B"] = "b";
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BASEFONT"] = "basefont";
    TAG_NAMES2["BGSOUND"] = "bgsound";
    TAG_NAMES2["BIG"] = "big";
    TAG_NAMES2["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["BR"] = "br";
    TAG_NAMES2["BUTTON"] = "button";
    TAG_NAMES2["CAPTION"] = "caption";
    TAG_NAMES2["CENTER"] = "center";
    TAG_NAMES2["CODE"] = "code";
    TAG_NAMES2["COL"] = "col";
    TAG_NAMES2["COLGROUP"] = "colgroup";
    TAG_NAMES2["DD"] = "dd";
    TAG_NAMES2["DESC"] = "desc";
    TAG_NAMES2["DETAILS"] = "details";
    TAG_NAMES2["DIALOG"] = "dialog";
    TAG_NAMES2["DIR"] = "dir";
    TAG_NAMES2["DIV"] = "div";
    TAG_NAMES2["DL"] = "dl";
    TAG_NAMES2["DT"] = "dt";
    TAG_NAMES2["EM"] = "em";
    TAG_NAMES2["EMBED"] = "embed";
    TAG_NAMES2["FIELDSET"] = "fieldset";
    TAG_NAMES2["FIGCAPTION"] = "figcaption";
    TAG_NAMES2["FIGURE"] = "figure";
    TAG_NAMES2["FONT"] = "font";
    TAG_NAMES2["FOOTER"] = "footer";
    TAG_NAMES2["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES2["FORM"] = "form";
    TAG_NAMES2["FRAME"] = "frame";
    TAG_NAMES2["FRAMESET"] = "frameset";
    TAG_NAMES2["H1"] = "h1";
    TAG_NAMES2["H2"] = "h2";
    TAG_NAMES2["H3"] = "h3";
    TAG_NAMES2["H4"] = "h4";
    TAG_NAMES2["H5"] = "h5";
    TAG_NAMES2["H6"] = "h6";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HEADER"] = "header";
    TAG_NAMES2["HGROUP"] = "hgroup";
    TAG_NAMES2["HR"] = "hr";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["I"] = "i";
    TAG_NAMES2["IMG"] = "img";
    TAG_NAMES2["IMAGE"] = "image";
    TAG_NAMES2["INPUT"] = "input";
    TAG_NAMES2["IFRAME"] = "iframe";
    TAG_NAMES2["KEYGEN"] = "keygen";
    TAG_NAMES2["LABEL"] = "label";
    TAG_NAMES2["LI"] = "li";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["LISTING"] = "listing";
    TAG_NAMES2["MAIN"] = "main";
    TAG_NAMES2["MALIGNMARK"] = "malignmark";
    TAG_NAMES2["MARQUEE"] = "marquee";
    TAG_NAMES2["MATH"] = "math";
    TAG_NAMES2["MENU"] = "menu";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["MGLYPH"] = "mglyph";
    TAG_NAMES2["MI"] = "mi";
    TAG_NAMES2["MO"] = "mo";
    TAG_NAMES2["MN"] = "mn";
    TAG_NAMES2["MS"] = "ms";
    TAG_NAMES2["MTEXT"] = "mtext";
    TAG_NAMES2["NAV"] = "nav";
    TAG_NAMES2["NOBR"] = "nobr";
    TAG_NAMES2["NOFRAMES"] = "noframes";
    TAG_NAMES2["NOEMBED"] = "noembed";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["OBJECT"] = "object";
    TAG_NAMES2["OL"] = "ol";
    TAG_NAMES2["OPTGROUP"] = "optgroup";
    TAG_NAMES2["OPTION"] = "option";
    TAG_NAMES2["P"] = "p";
    TAG_NAMES2["PARAM"] = "param";
    TAG_NAMES2["PLAINTEXT"] = "plaintext";
    TAG_NAMES2["PRE"] = "pre";
    TAG_NAMES2["RB"] = "rb";
    TAG_NAMES2["RP"] = "rp";
    TAG_NAMES2["RT"] = "rt";
    TAG_NAMES2["RTC"] = "rtc";
    TAG_NAMES2["RUBY"] = "ruby";
    TAG_NAMES2["S"] = "s";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["SECTION"] = "section";
    TAG_NAMES2["SELECT"] = "select";
    TAG_NAMES2["SOURCE"] = "source";
    TAG_NAMES2["SMALL"] = "small";
    TAG_NAMES2["SPAN"] = "span";
    TAG_NAMES2["STRIKE"] = "strike";
    TAG_NAMES2["STRONG"] = "strong";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["SUB"] = "sub";
    TAG_NAMES2["SUMMARY"] = "summary";
    TAG_NAMES2["SUP"] = "sup";
    TAG_NAMES2["TABLE"] = "table";
    TAG_NAMES2["TBODY"] = "tbody";
    TAG_NAMES2["TEMPLATE"] = "template";
    TAG_NAMES2["TEXTAREA"] = "textarea";
    TAG_NAMES2["TFOOT"] = "tfoot";
    TAG_NAMES2["TD"] = "td";
    TAG_NAMES2["TH"] = "th";
    TAG_NAMES2["THEAD"] = "thead";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["TR"] = "tr";
    TAG_NAMES2["TRACK"] = "track";
    TAG_NAMES2["TT"] = "tt";
    TAG_NAMES2["U"] = "u";
    TAG_NAMES2["UL"] = "ul";
    TAG_NAMES2["SVG"] = "svg";
    TAG_NAMES2["VAR"] = "var";
    TAG_NAMES2["WBR"] = "wbr";
    TAG_NAMES2["XMP"] = "xmp";
  })(TAG_NAMES = exports2.TAG_NAMES || (exports2.TAG_NAMES = {}));
  var TAG_ID;
  (function(TAG_ID2) {
    TAG_ID2[TAG_ID2["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID2[TAG_ID2["A"] = 1] = "A";
    TAG_ID2[TAG_ID2["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID2[TAG_ID2["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID2[TAG_ID2["APPLET"] = 4] = "APPLET";
    TAG_ID2[TAG_ID2["AREA"] = 5] = "AREA";
    TAG_ID2[TAG_ID2["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID2[TAG_ID2["ASIDE"] = 7] = "ASIDE";
    TAG_ID2[TAG_ID2["B"] = 8] = "B";
    TAG_ID2[TAG_ID2["BASE"] = 9] = "BASE";
    TAG_ID2[TAG_ID2["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID2[TAG_ID2["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID2[TAG_ID2["BIG"] = 12] = "BIG";
    TAG_ID2[TAG_ID2["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID2[TAG_ID2["BODY"] = 14] = "BODY";
    TAG_ID2[TAG_ID2["BR"] = 15] = "BR";
    TAG_ID2[TAG_ID2["BUTTON"] = 16] = "BUTTON";
    TAG_ID2[TAG_ID2["CAPTION"] = 17] = "CAPTION";
    TAG_ID2[TAG_ID2["CENTER"] = 18] = "CENTER";
    TAG_ID2[TAG_ID2["CODE"] = 19] = "CODE";
    TAG_ID2[TAG_ID2["COL"] = 20] = "COL";
    TAG_ID2[TAG_ID2["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID2[TAG_ID2["DD"] = 22] = "DD";
    TAG_ID2[TAG_ID2["DESC"] = 23] = "DESC";
    TAG_ID2[TAG_ID2["DETAILS"] = 24] = "DETAILS";
    TAG_ID2[TAG_ID2["DIALOG"] = 25] = "DIALOG";
    TAG_ID2[TAG_ID2["DIR"] = 26] = "DIR";
    TAG_ID2[TAG_ID2["DIV"] = 27] = "DIV";
    TAG_ID2[TAG_ID2["DL"] = 28] = "DL";
    TAG_ID2[TAG_ID2["DT"] = 29] = "DT";
    TAG_ID2[TAG_ID2["EM"] = 30] = "EM";
    TAG_ID2[TAG_ID2["EMBED"] = 31] = "EMBED";
    TAG_ID2[TAG_ID2["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID2[TAG_ID2["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID2[TAG_ID2["FIGURE"] = 34] = "FIGURE";
    TAG_ID2[TAG_ID2["FONT"] = 35] = "FONT";
    TAG_ID2[TAG_ID2["FOOTER"] = 36] = "FOOTER";
    TAG_ID2[TAG_ID2["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID2[TAG_ID2["FORM"] = 38] = "FORM";
    TAG_ID2[TAG_ID2["FRAME"] = 39] = "FRAME";
    TAG_ID2[TAG_ID2["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID2[TAG_ID2["H1"] = 41] = "H1";
    TAG_ID2[TAG_ID2["H2"] = 42] = "H2";
    TAG_ID2[TAG_ID2["H3"] = 43] = "H3";
    TAG_ID2[TAG_ID2["H4"] = 44] = "H4";
    TAG_ID2[TAG_ID2["H5"] = 45] = "H5";
    TAG_ID2[TAG_ID2["H6"] = 46] = "H6";
    TAG_ID2[TAG_ID2["HEAD"] = 47] = "HEAD";
    TAG_ID2[TAG_ID2["HEADER"] = 48] = "HEADER";
    TAG_ID2[TAG_ID2["HGROUP"] = 49] = "HGROUP";
    TAG_ID2[TAG_ID2["HR"] = 50] = "HR";
    TAG_ID2[TAG_ID2["HTML"] = 51] = "HTML";
    TAG_ID2[TAG_ID2["I"] = 52] = "I";
    TAG_ID2[TAG_ID2["IMG"] = 53] = "IMG";
    TAG_ID2[TAG_ID2["IMAGE"] = 54] = "IMAGE";
    TAG_ID2[TAG_ID2["INPUT"] = 55] = "INPUT";
    TAG_ID2[TAG_ID2["IFRAME"] = 56] = "IFRAME";
    TAG_ID2[TAG_ID2["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID2[TAG_ID2["LABEL"] = 58] = "LABEL";
    TAG_ID2[TAG_ID2["LI"] = 59] = "LI";
    TAG_ID2[TAG_ID2["LINK"] = 60] = "LINK";
    TAG_ID2[TAG_ID2["LISTING"] = 61] = "LISTING";
    TAG_ID2[TAG_ID2["MAIN"] = 62] = "MAIN";
    TAG_ID2[TAG_ID2["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID2[TAG_ID2["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID2[TAG_ID2["MATH"] = 65] = "MATH";
    TAG_ID2[TAG_ID2["MENU"] = 66] = "MENU";
    TAG_ID2[TAG_ID2["META"] = 67] = "META";
    TAG_ID2[TAG_ID2["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID2[TAG_ID2["MI"] = 69] = "MI";
    TAG_ID2[TAG_ID2["MO"] = 70] = "MO";
    TAG_ID2[TAG_ID2["MN"] = 71] = "MN";
    TAG_ID2[TAG_ID2["MS"] = 72] = "MS";
    TAG_ID2[TAG_ID2["MTEXT"] = 73] = "MTEXT";
    TAG_ID2[TAG_ID2["NAV"] = 74] = "NAV";
    TAG_ID2[TAG_ID2["NOBR"] = 75] = "NOBR";
    TAG_ID2[TAG_ID2["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID2[TAG_ID2["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID2[TAG_ID2["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID2[TAG_ID2["OBJECT"] = 79] = "OBJECT";
    TAG_ID2[TAG_ID2["OL"] = 80] = "OL";
    TAG_ID2[TAG_ID2["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID2[TAG_ID2["OPTION"] = 82] = "OPTION";
    TAG_ID2[TAG_ID2["P"] = 83] = "P";
    TAG_ID2[TAG_ID2["PARAM"] = 84] = "PARAM";
    TAG_ID2[TAG_ID2["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID2[TAG_ID2["PRE"] = 86] = "PRE";
    TAG_ID2[TAG_ID2["RB"] = 87] = "RB";
    TAG_ID2[TAG_ID2["RP"] = 88] = "RP";
    TAG_ID2[TAG_ID2["RT"] = 89] = "RT";
    TAG_ID2[TAG_ID2["RTC"] = 90] = "RTC";
    TAG_ID2[TAG_ID2["RUBY"] = 91] = "RUBY";
    TAG_ID2[TAG_ID2["S"] = 92] = "S";
    TAG_ID2[TAG_ID2["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID2[TAG_ID2["SECTION"] = 94] = "SECTION";
    TAG_ID2[TAG_ID2["SELECT"] = 95] = "SELECT";
    TAG_ID2[TAG_ID2["SOURCE"] = 96] = "SOURCE";
    TAG_ID2[TAG_ID2["SMALL"] = 97] = "SMALL";
    TAG_ID2[TAG_ID2["SPAN"] = 98] = "SPAN";
    TAG_ID2[TAG_ID2["STRIKE"] = 99] = "STRIKE";
    TAG_ID2[TAG_ID2["STRONG"] = 100] = "STRONG";
    TAG_ID2[TAG_ID2["STYLE"] = 101] = "STYLE";
    TAG_ID2[TAG_ID2["SUB"] = 102] = "SUB";
    TAG_ID2[TAG_ID2["SUMMARY"] = 103] = "SUMMARY";
    TAG_ID2[TAG_ID2["SUP"] = 104] = "SUP";
    TAG_ID2[TAG_ID2["TABLE"] = 105] = "TABLE";
    TAG_ID2[TAG_ID2["TBODY"] = 106] = "TBODY";
    TAG_ID2[TAG_ID2["TEMPLATE"] = 107] = "TEMPLATE";
    TAG_ID2[TAG_ID2["TEXTAREA"] = 108] = "TEXTAREA";
    TAG_ID2[TAG_ID2["TFOOT"] = 109] = "TFOOT";
    TAG_ID2[TAG_ID2["TD"] = 110] = "TD";
    TAG_ID2[TAG_ID2["TH"] = 111] = "TH";
    TAG_ID2[TAG_ID2["THEAD"] = 112] = "THEAD";
    TAG_ID2[TAG_ID2["TITLE"] = 113] = "TITLE";
    TAG_ID2[TAG_ID2["TR"] = 114] = "TR";
    TAG_ID2[TAG_ID2["TRACK"] = 115] = "TRACK";
    TAG_ID2[TAG_ID2["TT"] = 116] = "TT";
    TAG_ID2[TAG_ID2["U"] = 117] = "U";
    TAG_ID2[TAG_ID2["UL"] = 118] = "UL";
    TAG_ID2[TAG_ID2["SVG"] = 119] = "SVG";
    TAG_ID2[TAG_ID2["VAR"] = 120] = "VAR";
    TAG_ID2[TAG_ID2["WBR"] = 121] = "WBR";
    TAG_ID2[TAG_ID2["XMP"] = 122] = "XMP";
  })(TAG_ID = exports2.TAG_ID || (exports2.TAG_ID = {}));
  const TAG_NAME_TO_ID = /* @__PURE__ */ new Map([[TAG_NAMES.A, TAG_ID.A], [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS], [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML], [TAG_NAMES.APPLET, TAG_ID.APPLET], [TAG_NAMES.AREA, TAG_ID.AREA], [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE], [TAG_NAMES.ASIDE, TAG_ID.ASIDE], [TAG_NAMES.B, TAG_ID.B], [TAG_NAMES.BASE, TAG_ID.BASE], [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT], [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND], [TAG_NAMES.BIG, TAG_ID.BIG], [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE], [TAG_NAMES.BODY, TAG_ID.BODY], [TAG_NAMES.BR, TAG_ID.BR], [TAG_NAMES.BUTTON, TAG_ID.BUTTON], [TAG_NAMES.CAPTION, TAG_ID.CAPTION], [TAG_NAMES.CENTER, TAG_ID.CENTER], [TAG_NAMES.CODE, TAG_ID.CODE], [TAG_NAMES.COL, TAG_ID.COL], [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP], [TAG_NAMES.DD, TAG_ID.DD], [TAG_NAMES.DESC, TAG_ID.DESC], [TAG_NAMES.DETAILS, TAG_ID.DETAILS], [TAG_NAMES.DIALOG, TAG_ID.DIALOG], [TAG_NAMES.DIR, TAG_ID.DIR], [TAG_NAMES.DIV, TAG_ID.DIV], [TAG_NAMES.DL, TAG_ID.DL], [TAG_NAMES.DT, TAG_ID.DT], [TAG_NAMES.EM, TAG_ID.EM], [TAG_NAMES.EMBED, TAG_ID.EMBED], [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET], [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION], [TAG_NAMES.FIGURE, TAG_ID.FIGURE], [TAG_NAMES.FONT, TAG_ID.FONT], [TAG_NAMES.FOOTER, TAG_ID.FOOTER], [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT], [TAG_NAMES.FORM, TAG_ID.FORM], [TAG_NAMES.FRAME, TAG_ID.FRAME], [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET], [TAG_NAMES.H1, TAG_ID.H1], [TAG_NAMES.H2, TAG_ID.H2], [TAG_NAMES.H3, TAG_ID.H3], [TAG_NAMES.H4, TAG_ID.H4], [TAG_NAMES.H5, TAG_ID.H5], [TAG_NAMES.H6, TAG_ID.H6], [TAG_NAMES.HEAD, TAG_ID.HEAD], [TAG_NAMES.HEADER, TAG_ID.HEADER], [TAG_NAMES.HGROUP, TAG_ID.HGROUP], [TAG_NAMES.HR, TAG_ID.HR], [TAG_NAMES.HTML, TAG_ID.HTML], [TAG_NAMES.I, TAG_ID.I], [TAG_NAMES.IMG, TAG_ID.IMG], [TAG_NAMES.IMAGE, TAG_ID.IMAGE], [TAG_NAMES.INPUT, TAG_ID.INPUT], [TAG_NAMES.IFRAME, TAG_ID.IFRAME], [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN], [TAG_NAMES.LABEL, TAG_ID.LABEL], [TAG_NAMES.LI, TAG_ID.LI], [TAG_NAMES.LINK, TAG_ID.LINK], [TAG_NAMES.LISTING, TAG_ID.LISTING], [TAG_NAMES.MAIN, TAG_ID.MAIN], [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK], [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE], [TAG_NAMES.MATH, TAG_ID.MATH], [TAG_NAMES.MENU, TAG_ID.MENU], [TAG_NAMES.META, TAG_ID.META], [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH], [TAG_NAMES.MI, TAG_ID.MI], [TAG_NAMES.MO, TAG_ID.MO], [TAG_NAMES.MN, TAG_ID.MN], [TAG_NAMES.MS, TAG_ID.MS], [TAG_NAMES.MTEXT, TAG_ID.MTEXT], [TAG_NAMES.NAV, TAG_ID.NAV], [TAG_NAMES.NOBR, TAG_ID.NOBR], [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES], [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED], [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT], [TAG_NAMES.OBJECT, TAG_ID.OBJECT], [TAG_NAMES.OL, TAG_ID.OL], [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP], [TAG_NAMES.OPTION, TAG_ID.OPTION], [TAG_NAMES.P, TAG_ID.P], [TAG_NAMES.PARAM, TAG_ID.PARAM], [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT], [TAG_NAMES.PRE, TAG_ID.PRE], [TAG_NAMES.RB, TAG_ID.RB], [TAG_NAMES.RP, TAG_ID.RP], [TAG_NAMES.RT, TAG_ID.RT], [TAG_NAMES.RTC, TAG_ID.RTC], [TAG_NAMES.RUBY, TAG_ID.RUBY], [TAG_NAMES.S, TAG_ID.S], [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT], [TAG_NAMES.SECTION, TAG_ID.SECTION], [TAG_NAMES.SELECT, TAG_ID.SELECT], [TAG_NAMES.SOURCE, TAG_ID.SOURCE], [TAG_NAMES.SMALL, TAG_ID.SMALL], [TAG_NAMES.SPAN, TAG_ID.SPAN], [TAG_NAMES.STRIKE, TAG_ID.STRIKE], [TAG_NAMES.STRONG, TAG_ID.STRONG], [TAG_NAMES.STYLE, TAG_ID.STYLE], [TAG_NAMES.SUB, TAG_ID.SUB], [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY], [TAG_NAMES.SUP, TAG_ID.SUP], [TAG_NAMES.TABLE, TAG_ID.TABLE], [TAG_NAMES.TBODY, TAG_ID.TBODY], [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE], [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA], [TAG_NAMES.TFOOT, TAG_ID.TFOOT], [TAG_NAMES.TD, TAG_ID.TD], [TAG_NAMES.TH, TAG_ID.TH], [TAG_NAMES.THEAD, TAG_ID.THEAD], [TAG_NAMES.TITLE, TAG_ID.TITLE], [TAG_NAMES.TR, TAG_ID.TR], [TAG_NAMES.TRACK, TAG_ID.TRACK], [TAG_NAMES.TT, TAG_ID.TT], [TAG_NAMES.U, TAG_ID.U], [TAG_NAMES.UL, TAG_ID.UL], [TAG_NAMES.SVG, TAG_ID.SVG], [TAG_NAMES.VAR, TAG_ID.VAR], [TAG_NAMES.WBR, TAG_ID.WBR], [TAG_NAMES.XMP, TAG_ID.XMP]]);
  function getTagID(tagName) {
    var _a;
    return (_a = TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : TAG_ID.UNKNOWN;
  }
  exports2.getTagID = getTagID;
  const $ = TAG_ID;
  exports2.SPECIAL_ELEMENTS = {
    [NS.HTML]: /* @__PURE__ */ new Set([$.ADDRESS, $.APPLET, $.AREA, $.ARTICLE, $.ASIDE, $.BASE, $.BASEFONT, $.BGSOUND, $.BLOCKQUOTE, $.BODY, $.BR, $.BUTTON, $.CAPTION, $.CENTER, $.COL, $.COLGROUP, $.DD, $.DETAILS, $.DIR, $.DIV, $.DL, $.DT, $.EMBED, $.FIELDSET, $.FIGCAPTION, $.FIGURE, $.FOOTER, $.FORM, $.FRAME, $.FRAMESET, $.H1, $.H2, $.H3, $.H4, $.H5, $.H6, $.HEAD, $.HEADER, $.HGROUP, $.HR, $.HTML, $.IFRAME, $.IMG, $.INPUT, $.LI, $.LINK, $.LISTING, $.MAIN, $.MARQUEE, $.MENU, $.META, $.NAV, $.NOEMBED, $.NOFRAMES, $.NOSCRIPT, $.OBJECT, $.OL, $.P, $.PARAM, $.PLAINTEXT, $.PRE, $.SCRIPT, $.SECTION, $.SELECT, $.SOURCE, $.STYLE, $.SUMMARY, $.TABLE, $.TBODY, $.TD, $.TEMPLATE, $.TEXTAREA, $.TFOOT, $.TH, $.THEAD, $.TITLE, $.TR, $.TRACK, $.UL, $.WBR, $.XMP]),
    [NS.MATHML]: /* @__PURE__ */ new Set([$.MI, $.MO, $.MN, $.MS, $.MTEXT, $.ANNOTATION_XML]),
    [NS.SVG]: /* @__PURE__ */ new Set([$.TITLE, $.FOREIGN_OBJECT, $.DESC]),
    [NS.XLINK]: /* @__PURE__ */ new Set(),
    [NS.XML]: /* @__PURE__ */ new Set(),
    [NS.XMLNS]: /* @__PURE__ */ new Set()
  };
  function isNumberedHeader(tn) {
    return tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6;
  }
  exports2.isNumberedHeader = isNumberedHeader;
  const UNESCAPED_TEXT = /* @__PURE__ */ new Set([TAG_NAMES.STYLE, TAG_NAMES.SCRIPT, TAG_NAMES.XMP, TAG_NAMES.IFRAME, TAG_NAMES.NOEMBED, TAG_NAMES.NOFRAMES, TAG_NAMES.PLAINTEXT]);
  function hasUnescapedText(tn, scriptingEnabled) {
    return UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === TAG_NAMES.NOSCRIPT;
  }
  exports2.hasUnescapedText = hasUnescapedText;
})(html$1);
function _classCallCheck$1D(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1r(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1r(descriptor.key), descriptor);
  }
}
function _createClass$1B(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1r(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1r(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1r(arg) {
  var key = _toPrimitive$1r(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1r(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(tokenizer, "__esModule", {
  value: true
});
tokenizer.Tokenizer = tokenizer.TokenizerMode = void 0;
const preprocessor_js_1 = preprocessor;
const unicode_js_1 = unicode$1;
const token_js_1$1 = token;
const decode_js_1$1 = decode;
const error_codes_js_1$1 = errorCodes;
const html_js_1$4 = html$1;
const C1_CONTROLS_REFERENCE_REPLACEMENTS = /* @__PURE__ */ new Map([[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
var State;
(function(State2) {
  State2[State2["DATA"] = 0] = "DATA";
  State2[State2["RCDATA"] = 1] = "RCDATA";
  State2[State2["RAWTEXT"] = 2] = "RAWTEXT";
  State2[State2["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
  State2[State2["PLAINTEXT"] = 4] = "PLAINTEXT";
  State2[State2["TAG_OPEN"] = 5] = "TAG_OPEN";
  State2[State2["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
  State2[State2["TAG_NAME"] = 7] = "TAG_NAME";
  State2[State2["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
  State2[State2["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
  State2[State2["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
  State2[State2["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
  State2[State2["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
  State2[State2["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
  State2[State2["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
  State2[State2["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
  State2[State2["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
  State2[State2["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
  State2[State2["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
  State2[State2["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
  State2[State2["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
  State2[State2["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
  State2[State2["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
  State2[State2["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
  State2[State2["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
  State2[State2["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
  State2[State2["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
  State2[State2["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
  State2[State2["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
  State2[State2["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
  State2[State2["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
  State2[State2["COMMENT_START"] = 42] = "COMMENT_START";
  State2[State2["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
  State2[State2["COMMENT"] = 44] = "COMMENT";
  State2[State2["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
  State2[State2["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
  State2[State2["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
  State2[State2["COMMENT_END"] = 50] = "COMMENT_END";
  State2[State2["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
  State2[State2["DOCTYPE"] = 52] = "DOCTYPE";
  State2[State2["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
  State2[State2["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
  State2[State2["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
  State2[State2["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
  State2[State2["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
  State2[State2["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
  State2[State2["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
  State2[State2["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
  State2[State2["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
  State2[State2["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
  State2[State2["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
  State2[State2["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
  State2[State2["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
  State2[State2["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
  State2[State2["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
  State2[State2["CDATA_SECTION"] = 68] = "CDATA_SECTION";
  State2[State2["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
  State2[State2["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
  State2[State2["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
  State2[State2["NAMED_CHARACTER_REFERENCE"] = 72] = "NAMED_CHARACTER_REFERENCE";
  State2[State2["AMBIGUOUS_AMPERSAND"] = 73] = "AMBIGUOUS_AMPERSAND";
  State2[State2["NUMERIC_CHARACTER_REFERENCE"] = 74] = "NUMERIC_CHARACTER_REFERENCE";
  State2[State2["HEXADEMICAL_CHARACTER_REFERENCE_START"] = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START";
  State2[State2["HEXADEMICAL_CHARACTER_REFERENCE"] = 76] = "HEXADEMICAL_CHARACTER_REFERENCE";
  State2[State2["DECIMAL_CHARACTER_REFERENCE"] = 77] = "DECIMAL_CHARACTER_REFERENCE";
  State2[State2["NUMERIC_CHARACTER_REFERENCE_END"] = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(State || (State = {}));
tokenizer.TokenizerMode = {
  DATA: State.DATA,
  RCDATA: State.RCDATA,
  RAWTEXT: State.RAWTEXT,
  SCRIPT_DATA: State.SCRIPT_DATA,
  PLAINTEXT: State.PLAINTEXT,
  CDATA_SECTION: State.CDATA_SECTION
};
function isAsciiDigit(cp) {
  return cp >= unicode_js_1.CODE_POINTS.DIGIT_0 && cp <= unicode_js_1.CODE_POINTS.DIGIT_9;
}
function isAsciiUpper(cp) {
  return cp >= unicode_js_1.CODE_POINTS.LATIN_CAPITAL_A && cp <= unicode_js_1.CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower(cp) {
  return cp >= unicode_js_1.CODE_POINTS.LATIN_SMALL_A && cp <= unicode_js_1.CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter(cp) {
  return isAsciiLower(cp) || isAsciiUpper(cp);
}
function isAsciiAlphaNumeric(cp) {
  return isAsciiLetter(cp) || isAsciiDigit(cp);
}
function isAsciiUpperHexDigit(cp) {
  return cp >= unicode_js_1.CODE_POINTS.LATIN_CAPITAL_A && cp <= unicode_js_1.CODE_POINTS.LATIN_CAPITAL_F;
}
function isAsciiLowerHexDigit(cp) {
  return cp >= unicode_js_1.CODE_POINTS.LATIN_SMALL_A && cp <= unicode_js_1.CODE_POINTS.LATIN_SMALL_F;
}
function isAsciiHexDigit(cp) {
  return isAsciiDigit(cp) || isAsciiUpperHexDigit(cp) || isAsciiLowerHexDigit(cp);
}
function toAsciiLower(cp) {
  return cp + 32;
}
function isWhitespace(cp) {
  return cp === unicode_js_1.CODE_POINTS.SPACE || cp === unicode_js_1.CODE_POINTS.LINE_FEED || cp === unicode_js_1.CODE_POINTS.TABULATION || cp === unicode_js_1.CODE_POINTS.FORM_FEED;
}
function isEntityInAttributeInvalidEnd(nextCp) {
  return nextCp === unicode_js_1.CODE_POINTS.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp);
}
function isScriptDataDoubleEscapeSequenceEnd(cp) {
  return isWhitespace(cp) || cp === unicode_js_1.CODE_POINTS.SOLIDUS || cp === unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN;
}
let Tokenizer$1 = /* @__PURE__ */ function() {
  function Tokenizer2(options2, handler) {
    _classCallCheck$1D(this, Tokenizer2);
    this.options = options2;
    this.handler = handler;
    this.paused = false;
    this.inLoop = false;
    this.inForeignNode = false;
    this.lastStartTagName = "";
    this.active = false;
    this.state = State.DATA;
    this.returnState = State.DATA;
    this.charRefCode = -1;
    this.consumedAfterSnapshot = -1;
    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = {
      name: "",
      value: ""
    };
    this.preprocessor = new preprocessor_js_1.Preprocessor(handler);
    this.currentLocation = this.getCurrentLocation(-1);
  }
  _createClass$1B(Tokenizer2, [{
    key: "_err",
    value: function _err(code2) {
      var _a, _b;
      (_b = (_a = this.handler).onParseError) === null || _b === void 0 ? void 0 : _b.call(_a, this.preprocessor.getError(code2));
    }
    // NOTE: `offset` may never run across line boundaries.
  }, {
    key: "getCurrentLocation",
    value: function getCurrentLocation(offset2) {
      if (!this.options.sourceCodeLocationInfo) {
        return null;
      }
      return {
        startLine: this.preprocessor.line,
        startCol: this.preprocessor.col - offset2,
        startOffset: this.preprocessor.offset - offset2,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
  }, {
    key: "_runParsingLoop",
    value: function _runParsingLoop() {
      if (this.inLoop)
        return;
      this.inLoop = true;
      while (this.active && !this.paused) {
        this.consumedAfterSnapshot = 0;
        const cp = this._consume();
        if (!this._ensureHibernation()) {
          this._callState(cp);
        }
      }
      this.inLoop = false;
    }
    //API
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
  }, {
    key: "resume",
    value: function resume(writeCallback) {
      if (!this.paused) {
        throw new Error("Parser was already resumed");
      }
      this.paused = false;
      if (this.inLoop)
        return;
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk, writeCallback) {
      this.active = true;
      this.preprocessor.write(chunk, isLastChunk);
      this._runParsingLoop();
      if (!this.paused) {
        writeCallback === null || writeCallback === void 0 ? void 0 : writeCallback();
      }
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.active = true;
      this.preprocessor.insertHtmlAtCurrentPos(chunk);
      this._runParsingLoop();
    }
    //Hibernation
  }, {
    key: "_ensureHibernation",
    value: function _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        this._unconsume(this.consumedAfterSnapshot);
        this.active = false;
        return true;
      }
      return false;
    }
    //Consumption
  }, {
    key: "_consume",
    value: function _consume() {
      this.consumedAfterSnapshot++;
      return this.preprocessor.advance();
    }
  }, {
    key: "_unconsume",
    value: function _unconsume(count2) {
      this.consumedAfterSnapshot -= count2;
      this.preprocessor.retreat(count2);
    }
  }, {
    key: "_reconsumeInState",
    value: function _reconsumeInState(state, cp) {
      this.state = state;
      this._callState(cp);
    }
  }, {
    key: "_advanceBy",
    value: function _advanceBy(count2) {
      this.consumedAfterSnapshot += count2;
      for (let i = 0; i < count2; i++) {
        this.preprocessor.advance();
      }
    }
  }, {
    key: "_consumeSequenceIfMatch",
    value: function _consumeSequenceIfMatch(pattern2, caseSensitive) {
      if (this.preprocessor.startsWith(pattern2, caseSensitive)) {
        this._advanceBy(pattern2.length - 1);
        return true;
      }
      return false;
    }
    //Token creation
  }, {
    key: "_createStartTagToken",
    value: function _createStartTagToken() {
      this.currentToken = {
        type: token_js_1$1.TokenType.START_TAG,
        tagName: "",
        tagID: html_js_1$4.TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(1)
      };
    }
  }, {
    key: "_createEndTagToken",
    value: function _createEndTagToken() {
      this.currentToken = {
        type: token_js_1$1.TokenType.END_TAG,
        tagName: "",
        tagID: html_js_1$4.TAG_ID.UNKNOWN,
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: this.getCurrentLocation(2)
      };
    }
  }, {
    key: "_createCommentToken",
    value: function _createCommentToken(offset2) {
      this.currentToken = {
        type: token_js_1$1.TokenType.COMMENT,
        data: "",
        location: this.getCurrentLocation(offset2)
      };
    }
  }, {
    key: "_createDoctypeToken",
    value: function _createDoctypeToken(initialName) {
      this.currentToken = {
        type: token_js_1$1.TokenType.DOCTYPE,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null,
        location: this.currentLocation
      };
    }
  }, {
    key: "_createCharacterToken",
    value: function _createCharacterToken(type3, chars) {
      this.currentCharacterToken = {
        type: type3,
        chars,
        location: this.currentLocation
      };
    }
    //Tag attributes
  }, {
    key: "_createAttr",
    value: function _createAttr(attrNameFirstCh) {
      this.currentAttr = {
        name: attrNameFirstCh,
        value: ""
      };
      this.currentLocation = this.getCurrentLocation(0);
    }
  }, {
    key: "_leaveAttrName",
    value: function _leaveAttrName() {
      var _a;
      var _b;
      const token2 = this.currentToken;
      if ((0, token_js_1$1.getTokenAttr)(token2, this.currentAttr.name) === null) {
        token2.attrs.push(this.currentAttr);
        if (token2.location && this.currentLocation) {
          const attrLocations = (_a = (_b = token2.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = /* @__PURE__ */ Object.create(null);
          attrLocations[this.currentAttr.name] = this.currentLocation;
          this._leaveAttrValue();
        }
      } else {
        this._err(error_codes_js_1$1.ERR.duplicateAttribute);
      }
    }
  }, {
    key: "_leaveAttrValue",
    value: function _leaveAttrValue() {
      if (this.currentLocation) {
        this.currentLocation.endLine = this.preprocessor.line;
        this.currentLocation.endCol = this.preprocessor.col;
        this.currentLocation.endOffset = this.preprocessor.offset;
      }
    }
    //Token emission
  }, {
    key: "prepareToken",
    value: function prepareToken(ct) {
      this._emitCurrentCharacterToken(ct.location);
      this.currentToken = null;
      if (ct.location) {
        ct.location.endLine = this.preprocessor.line;
        ct.location.endCol = this.preprocessor.col + 1;
        ct.location.endOffset = this.preprocessor.offset + 1;
      }
      this.currentLocation = this.getCurrentLocation(-1);
    }
  }, {
    key: "emitCurrentTagToken",
    value: function emitCurrentTagToken() {
      const ct = this.currentToken;
      this.prepareToken(ct);
      ct.tagID = (0, html_js_1$4.getTagID)(ct.tagName);
      if (ct.type === token_js_1$1.TokenType.START_TAG) {
        this.lastStartTagName = ct.tagName;
        this.handler.onStartTag(ct);
      } else {
        if (ct.attrs.length > 0) {
          this._err(error_codes_js_1$1.ERR.endTagWithAttributes);
        }
        if (ct.selfClosing) {
          this._err(error_codes_js_1$1.ERR.endTagWithTrailingSolidus);
        }
        this.handler.onEndTag(ct);
      }
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentComment",
    value: function emitCurrentComment(ct) {
      this.prepareToken(ct);
      this.handler.onComment(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "emitCurrentDoctype",
    value: function emitCurrentDoctype(ct) {
      this.prepareToken(ct);
      this.handler.onDoctype(ct);
      this.preprocessor.dropParsedChunk();
    }
  }, {
    key: "_emitCurrentCharacterToken",
    value: function _emitCurrentCharacterToken(nextLocation) {
      if (this.currentCharacterToken) {
        if (nextLocation && this.currentCharacterToken.location) {
          this.currentCharacterToken.location.endLine = nextLocation.startLine;
          this.currentCharacterToken.location.endCol = nextLocation.startCol;
          this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
        }
        switch (this.currentCharacterToken.type) {
          case token_js_1$1.TokenType.CHARACTER: {
            this.handler.onCharacter(this.currentCharacterToken);
            break;
          }
          case token_js_1$1.TokenType.NULL_CHARACTER: {
            this.handler.onNullCharacter(this.currentCharacterToken);
            break;
          }
          case token_js_1$1.TokenType.WHITESPACE_CHARACTER: {
            this.handler.onWhitespaceCharacter(this.currentCharacterToken);
            break;
          }
        }
        this.currentCharacterToken = null;
      }
    }
  }, {
    key: "_emitEOFToken",
    value: function _emitEOFToken() {
      const location = this.getCurrentLocation(0);
      if (location) {
        location.endLine = location.startLine;
        location.endCol = location.startCol;
        location.endOffset = location.startOffset;
      }
      this._emitCurrentCharacterToken(location);
      this.handler.onEof({
        type: token_js_1$1.TokenType.EOF,
        location
      });
      this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  }, {
    key: "_appendCharToCurrentCharacterToken",
    value: function _appendCharToCurrentCharacterToken(type3, ch) {
      if (this.currentCharacterToken) {
        if (this.currentCharacterToken.type !== type3) {
          this.currentLocation = this.getCurrentLocation(0);
          this._emitCurrentCharacterToken(this.currentLocation);
          this.preprocessor.dropParsedChunk();
        } else {
          this.currentCharacterToken.chars += ch;
          return;
        }
      }
      this._createCharacterToken(type3, ch);
    }
  }, {
    key: "_emitCodePoint",
    value: function _emitCodePoint(cp) {
      const type3 = isWhitespace(cp) ? token_js_1$1.TokenType.WHITESPACE_CHARACTER : cp === unicode_js_1.CODE_POINTS.NULL ? token_js_1$1.TokenType.NULL_CHARACTER : token_js_1$1.TokenType.CHARACTER;
      this._appendCharToCurrentCharacterToken(type3, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  }, {
    key: "_emitChars",
    value: function _emitChars(ch) {
      this._appendCharToCurrentCharacterToken(token_js_1$1.TokenType.CHARACTER, ch);
    }
    // Character reference helpers
  }, {
    key: "_matchNamedCharacterReference",
    value: function _matchNamedCharacterReference(cp) {
      let result = null;
      let excess = 0;
      let withoutSemicolon = false;
      for (let i = 0, current = decode_js_1$1.htmlDecodeTree[0]; i >= 0; cp = this._consume()) {
        i = (0, decode_js_1$1.determineBranch)(decode_js_1$1.htmlDecodeTree, current, i + 1, cp);
        if (i < 0)
          break;
        excess += 1;
        current = decode_js_1$1.htmlDecodeTree[i];
        const masked = current & decode_js_1$1.BinTrieFlags.VALUE_LENGTH;
        if (masked) {
          const valueLength = (masked >> 14) - 1;
          if (cp !== unicode_js_1.CODE_POINTS.SEMICOLON && this._isCharacterReferenceInAttribute() && isEntityInAttributeInvalidEnd(this.preprocessor.peek(1))) {
            result = [unicode_js_1.CODE_POINTS.AMPERSAND];
            i += valueLength;
          } else {
            result = valueLength === 0 ? [decode_js_1$1.htmlDecodeTree[i] & ~decode_js_1$1.BinTrieFlags.VALUE_LENGTH] : valueLength === 1 ? [decode_js_1$1.htmlDecodeTree[++i]] : [decode_js_1$1.htmlDecodeTree[++i], decode_js_1$1.htmlDecodeTree[++i]];
            excess = 0;
            withoutSemicolon = cp !== unicode_js_1.CODE_POINTS.SEMICOLON;
          }
          if (valueLength === 0) {
            this._consume();
            break;
          }
        }
      }
      this._unconsume(excess);
      if (withoutSemicolon && !this.preprocessor.endOfChunkHit) {
        this._err(error_codes_js_1$1.ERR.missingSemicolonAfterCharacterReference);
      }
      this._unconsume(1);
      return result;
    }
  }, {
    key: "_isCharacterReferenceInAttribute",
    value: function _isCharacterReferenceInAttribute() {
      return this.returnState === State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === State.ATTRIBUTE_VALUE_UNQUOTED;
    }
  }, {
    key: "_flushCodePointConsumedAsCharacterReference",
    value: function _flushCodePointConsumedAsCharacterReference(cp) {
      if (this._isCharacterReferenceInAttribute()) {
        this.currentAttr.value += String.fromCodePoint(cp);
      } else {
        this._emitCodePoint(cp);
      }
    }
    // Calling states this way turns out to be much faster than any other approach.
  }, {
    key: "_callState",
    value: function _callState(cp) {
      switch (this.state) {
        case State.DATA: {
          this._stateData(cp);
          break;
        }
        case State.RCDATA: {
          this._stateRcdata(cp);
          break;
        }
        case State.RAWTEXT: {
          this._stateRawtext(cp);
          break;
        }
        case State.SCRIPT_DATA: {
          this._stateScriptData(cp);
          break;
        }
        case State.PLAINTEXT: {
          this._statePlaintext(cp);
          break;
        }
        case State.TAG_OPEN: {
          this._stateTagOpen(cp);
          break;
        }
        case State.END_TAG_OPEN: {
          this._stateEndTagOpen(cp);
          break;
        }
        case State.TAG_NAME: {
          this._stateTagName(cp);
          break;
        }
        case State.RCDATA_LESS_THAN_SIGN: {
          this._stateRcdataLessThanSign(cp);
          break;
        }
        case State.RCDATA_END_TAG_OPEN: {
          this._stateRcdataEndTagOpen(cp);
          break;
        }
        case State.RCDATA_END_TAG_NAME: {
          this._stateRcdataEndTagName(cp);
          break;
        }
        case State.RAWTEXT_LESS_THAN_SIGN: {
          this._stateRawtextLessThanSign(cp);
          break;
        }
        case State.RAWTEXT_END_TAG_OPEN: {
          this._stateRawtextEndTagOpen(cp);
          break;
        }
        case State.RAWTEXT_END_TAG_NAME: {
          this._stateRawtextEndTagName(cp);
          break;
        }
        case State.SCRIPT_DATA_LESS_THAN_SIGN: {
          this._stateScriptDataLessThanSign(cp);
          break;
        }
        case State.SCRIPT_DATA_END_TAG_OPEN: {
          this._stateScriptDataEndTagOpen(cp);
          break;
        }
        case State.SCRIPT_DATA_END_TAG_NAME: {
          this._stateScriptDataEndTagName(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPE_START: {
          this._stateScriptDataEscapeStart(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPE_START_DASH: {
          this._stateScriptDataEscapeStartDash(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED: {
          this._stateScriptDataEscaped(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED_DASH: {
          this._stateScriptDataEscapedDash(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED_DASH_DASH: {
          this._stateScriptDataEscapedDashDash(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
          this._stateScriptDataEscapedLessThanSign(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
          this._stateScriptDataEscapedEndTagOpen(cp);
          break;
        }
        case State.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
          this._stateScriptDataEscapedEndTagName(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
          this._stateScriptDataDoubleEscapeStart(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPED: {
          this._stateScriptDataDoubleEscaped(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
          this._stateScriptDataDoubleEscapedDash(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
          this._stateScriptDataDoubleEscapedDashDash(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
          this._stateScriptDataDoubleEscapedLessThanSign(cp);
          break;
        }
        case State.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
          this._stateScriptDataDoubleEscapeEnd(cp);
          break;
        }
        case State.BEFORE_ATTRIBUTE_NAME: {
          this._stateBeforeAttributeName(cp);
          break;
        }
        case State.ATTRIBUTE_NAME: {
          this._stateAttributeName(cp);
          break;
        }
        case State.AFTER_ATTRIBUTE_NAME: {
          this._stateAfterAttributeName(cp);
          break;
        }
        case State.BEFORE_ATTRIBUTE_VALUE: {
          this._stateBeforeAttributeValue(cp);
          break;
        }
        case State.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
          this._stateAttributeValueDoubleQuoted(cp);
          break;
        }
        case State.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
          this._stateAttributeValueSingleQuoted(cp);
          break;
        }
        case State.ATTRIBUTE_VALUE_UNQUOTED: {
          this._stateAttributeValueUnquoted(cp);
          break;
        }
        case State.AFTER_ATTRIBUTE_VALUE_QUOTED: {
          this._stateAfterAttributeValueQuoted(cp);
          break;
        }
        case State.SELF_CLOSING_START_TAG: {
          this._stateSelfClosingStartTag(cp);
          break;
        }
        case State.BOGUS_COMMENT: {
          this._stateBogusComment(cp);
          break;
        }
        case State.MARKUP_DECLARATION_OPEN: {
          this._stateMarkupDeclarationOpen(cp);
          break;
        }
        case State.COMMENT_START: {
          this._stateCommentStart(cp);
          break;
        }
        case State.COMMENT_START_DASH: {
          this._stateCommentStartDash(cp);
          break;
        }
        case State.COMMENT: {
          this._stateComment(cp);
          break;
        }
        case State.COMMENT_LESS_THAN_SIGN: {
          this._stateCommentLessThanSign(cp);
          break;
        }
        case State.COMMENT_LESS_THAN_SIGN_BANG: {
          this._stateCommentLessThanSignBang(cp);
          break;
        }
        case State.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
          this._stateCommentLessThanSignBangDash(cp);
          break;
        }
        case State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
          this._stateCommentLessThanSignBangDashDash(cp);
          break;
        }
        case State.COMMENT_END_DASH: {
          this._stateCommentEndDash(cp);
          break;
        }
        case State.COMMENT_END: {
          this._stateCommentEnd(cp);
          break;
        }
        case State.COMMENT_END_BANG: {
          this._stateCommentEndBang(cp);
          break;
        }
        case State.DOCTYPE: {
          this._stateDoctype(cp);
          break;
        }
        case State.BEFORE_DOCTYPE_NAME: {
          this._stateBeforeDoctypeName(cp);
          break;
        }
        case State.DOCTYPE_NAME: {
          this._stateDoctypeName(cp);
          break;
        }
        case State.AFTER_DOCTYPE_NAME: {
          this._stateAfterDoctypeName(cp);
          break;
        }
        case State.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
          this._stateAfterDoctypePublicKeyword(cp);
          break;
        }
        case State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
          this._stateBeforeDoctypePublicIdentifier(cp);
          break;
        }
        case State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
          this._stateDoctypePublicIdentifierDoubleQuoted(cp);
          break;
        }
        case State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
          this._stateDoctypePublicIdentifierSingleQuoted(cp);
          break;
        }
        case State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
          this._stateAfterDoctypePublicIdentifier(cp);
          break;
        }
        case State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
          this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
          break;
        }
        case State.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
          this._stateAfterDoctypeSystemKeyword(cp);
          break;
        }
        case State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
          this._stateBeforeDoctypeSystemIdentifier(cp);
          break;
        }
        case State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
          this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
          break;
        }
        case State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
          this._stateDoctypeSystemIdentifierSingleQuoted(cp);
          break;
        }
        case State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
          this._stateAfterDoctypeSystemIdentifier(cp);
          break;
        }
        case State.BOGUS_DOCTYPE: {
          this._stateBogusDoctype(cp);
          break;
        }
        case State.CDATA_SECTION: {
          this._stateCdataSection(cp);
          break;
        }
        case State.CDATA_SECTION_BRACKET: {
          this._stateCdataSectionBracket(cp);
          break;
        }
        case State.CDATA_SECTION_END: {
          this._stateCdataSectionEnd(cp);
          break;
        }
        case State.CHARACTER_REFERENCE: {
          this._stateCharacterReference(cp);
          break;
        }
        case State.NAMED_CHARACTER_REFERENCE: {
          this._stateNamedCharacterReference(cp);
          break;
        }
        case State.AMBIGUOUS_AMPERSAND: {
          this._stateAmbiguousAmpersand(cp);
          break;
        }
        case State.NUMERIC_CHARACTER_REFERENCE: {
          this._stateNumericCharacterReference(cp);
          break;
        }
        case State.HEXADEMICAL_CHARACTER_REFERENCE_START: {
          this._stateHexademicalCharacterReferenceStart(cp);
          break;
        }
        case State.HEXADEMICAL_CHARACTER_REFERENCE: {
          this._stateHexademicalCharacterReference(cp);
          break;
        }
        case State.DECIMAL_CHARACTER_REFERENCE: {
          this._stateDecimalCharacterReference(cp);
          break;
        }
        case State.NUMERIC_CHARACTER_REFERENCE_END: {
          this._stateNumericCharacterReferenceEnd(cp);
          break;
        }
        default: {
          throw new Error("Unknown state");
        }
      }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
  }, {
    key: "_stateData",
    value: function _stateData(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.TAG_OPEN;
          break;
        }
        case unicode_js_1.CODE_POINTS.AMPERSAND: {
          this.returnState = State.DATA;
          this.state = State.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitCodePoint(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    //  RCDATA state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdata",
    value: function _stateRcdata(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.AMPERSAND: {
          this.returnState = State.RCDATA;
          this.state = State.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.RCDATA_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtext",
    value: function _stateRawtext(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.RAWTEXT_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptData",
    value: function _stateScriptData(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
  }, {
    key: "_statePlaintext",
    value: function _statePlaintext(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagOpen",
    value: function _stateTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this.state = State.TAG_NAME;
        this._stateTagName(cp);
      } else
        switch (cp) {
          case unicode_js_1.CODE_POINTS.EXCLAMATION_MARK: {
            this.state = State.MARKUP_DECLARATION_OPEN;
            break;
          }
          case unicode_js_1.CODE_POINTS.SOLIDUS: {
            this.state = State.END_TAG_OPEN;
            break;
          }
          case unicode_js_1.CODE_POINTS.QUESTION_MARK: {
            this._err(error_codes_js_1$1.ERR.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken(1);
            this.state = State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
            break;
          }
          case unicode_js_1.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$1.ERR.eofBeforeTagName);
            this._emitChars("<");
            this._emitEOFToken();
            break;
          }
          default: {
            this._err(error_codes_js_1$1.ERR.invalidFirstCharacterOfTagName);
            this._emitChars("<");
            this.state = State.DATA;
            this._stateData(cp);
          }
        }
    }
    // End tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateEndTagOpen",
    value: function _stateEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this.state = State.TAG_NAME;
        this._stateTagName(cp);
      } else
        switch (cp) {
          case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
            this._err(error_codes_js_1$1.ERR.missingEndTagName);
            this.state = State.DATA;
            break;
          }
          case unicode_js_1.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$1.ERR.eofBeforeTagName);
            this._emitChars("</");
            this._emitEOFToken();
            break;
          }
          default: {
            this._err(error_codes_js_1$1.ERR.invalidFirstCharacterOfTagName);
            this._createCommentToken(2);
            this.state = State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
          }
        }
    }
    // Tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateTagName",
    value: function _stateTagName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1.CODE_POINTS.SOLIDUS: {
          this.state = State.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.tagName += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.tagName += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
        }
      }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataLessThanSign",
    value: function _stateRcdataLessThanSign(cp) {
      if (cp === unicode_js_1.CODE_POINTS.SOLIDUS) {
        this.state = State.RCDATA_END_TAG_OPEN;
      } else {
        this._emitChars("<");
        this.state = State.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagOpen",
    value: function _stateRcdataEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State.RCDATA_END_TAG_NAME;
        this._stateRcdataEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State.RCDATA;
        this._stateRcdata(cp);
      }
    }
  }, {
    key: "handleSpecialEndTag",
    value: function handleSpecialEndTag(_cp) {
      if (!this.preprocessor.startsWith(this.lastStartTagName, false)) {
        return !this._ensureHibernation();
      }
      this._createEndTagToken();
      const token2 = this.currentToken;
      token2.tagName = this.lastStartTagName;
      const cp = this.preprocessor.peek(this.lastStartTagName.length);
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this._advanceBy(this.lastStartTagName.length);
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          return false;
        }
        case unicode_js_1.CODE_POINTS.SOLIDUS: {
          this._advanceBy(this.lastStartTagName.length);
          this.state = State.SELF_CLOSING_START_TAG;
          return false;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._advanceBy(this.lastStartTagName.length);
          this.emitCurrentTagToken();
          this.state = State.DATA;
          return false;
        }
        default: {
          return !this._ensureHibernation();
        }
      }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRcdataEndTagName",
    value: function _stateRcdataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State.RCDATA;
        this._stateRcdata(cp);
      }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextLessThanSign",
    value: function _stateRawtextLessThanSign(cp) {
      if (cp === unicode_js_1.CODE_POINTS.SOLIDUS) {
        this.state = State.RAWTEXT_END_TAG_OPEN;
      } else {
        this._emitChars("<");
        this.state = State.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagOpen",
    value: function _stateRawtextEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State.RAWTEXT_END_TAG_NAME;
        this._stateRawtextEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateRawtextEndTagName",
    value: function _stateRawtextEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State.RAWTEXT;
        this._stateRawtext(cp);
      }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataLessThanSign",
    value: function _stateScriptDataLessThanSign(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SOLIDUS: {
          this.state = State.SCRIPT_DATA_END_TAG_OPEN;
          break;
        }
        case unicode_js_1.CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State.SCRIPT_DATA_ESCAPE_START;
          this._emitChars("<!");
          break;
        }
        default: {
          this._emitChars("<");
          this.state = State.SCRIPT_DATA;
          this._stateScriptData(cp);
        }
      }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagOpen",
    value: function _stateScriptDataEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State.SCRIPT_DATA_END_TAG_NAME;
        this._stateScriptDataEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEndTagName",
    value: function _stateScriptDataEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStart",
    value: function _stateScriptDataEscapeStart(cp) {
      if (cp === unicode_js_1.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State.SCRIPT_DATA_ESCAPE_START_DASH;
        this._emitChars("-");
      } else {
        this.state = State.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapeStartDash",
    value: function _stateScriptDataEscapeStartDash(cp) {
      if (cp === unicode_js_1.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH;
        this._emitChars("-");
      } else {
        this.state = State.SCRIPT_DATA;
        this._stateScriptData(cp);
      }
    }
    // Script data escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscaped",
    value: function _stateScriptDataEscaped(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.SCRIPT_DATA_ESCAPED_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDash",
    value: function _stateScriptDataEscapedDash(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.state = State.SCRIPT_DATA_ESCAPED;
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State.SCRIPT_DATA_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedDashDash",
    value: function _stateScriptDataEscapedDashDash(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.SCRIPT_DATA;
          this._emitChars(">");
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.state = State.SCRIPT_DATA_ESCAPED;
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State.SCRIPT_DATA_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedLessThanSign",
    value: function _stateScriptDataEscapedLessThanSign(cp) {
      if (cp === unicode_js_1.CODE_POINTS.SOLIDUS) {
        this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
      } else if (isAsciiLetter(cp)) {
        this._emitChars("<");
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
        this._stateScriptDataDoubleEscapeStart(cp);
      } else {
        this._emitChars("<");
        this.state = State.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagOpen",
    value: function _stateScriptDataEscapedEndTagOpen(cp) {
      if (isAsciiLetter(cp)) {
        this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
        this._stateScriptDataEscapedEndTagName(cp);
      } else {
        this._emitChars("</");
        this.state = State.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataEscapedEndTagName",
    value: function _stateScriptDataEscapedEndTagName(cp) {
      if (this.handleSpecialEndTag(cp)) {
        this._emitChars("</");
        this.state = State.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeStart",
    value: function _stateScriptDataDoubleEscapeStart(cp) {
      if (this.preprocessor.startsWith(unicode_js_1.SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(unicode_js_1.SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (let i = 0; i < unicode_js_1.SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State.SCRIPT_DATA_ESCAPED;
        this._stateScriptDataEscaped(cp);
      }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscaped",
    value: function _stateScriptDataDoubleEscaped(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDash",
    value: function _stateScriptDataDoubleEscapedDash(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedDashDash",
    value: function _stateScriptDataDoubleEscapedDashDash(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this._emitChars("-");
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
          this._emitChars("<");
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.SCRIPT_DATA;
          this._emitChars(">");
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitChars(unicode_js_1.REPLACEMENT_CHARACTER);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
          break;
        }
        default: {
          this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
          this._emitCodePoint(cp);
        }
      }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapedLessThanSign",
    value: function _stateScriptDataDoubleEscapedLessThanSign(cp) {
      if (cp === unicode_js_1.CODE_POINTS.SOLIDUS) {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
        this._emitChars("/");
      } else {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
  }, {
    key: "_stateScriptDataDoubleEscapeEnd",
    value: function _stateScriptDataDoubleEscapeEnd(cp) {
      if (this.preprocessor.startsWith(unicode_js_1.SEQUENCES.SCRIPT, false) && isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(unicode_js_1.SEQUENCES.SCRIPT.length))) {
        this._emitCodePoint(cp);
        for (let i = 0; i < unicode_js_1.SEQUENCES.SCRIPT.length; i++) {
          this._emitCodePoint(this._consume());
        }
        this.state = State.SCRIPT_DATA_ESCAPED;
      } else if (!this._ensureHibernation()) {
        this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
        this._stateScriptDataDoubleEscaped(cp);
      }
    }
    // Before attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeName",
    value: function _stateBeforeAttributeName(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.SOLIDUS:
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN:
        case unicode_js_1.CODE_POINTS.EOF: {
          this.state = State.AFTER_ATTRIBUTE_NAME;
          this._stateAfterAttributeName(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.EQUALS_SIGN: {
          this._err(error_codes_js_1$1.ERR.unexpectedEqualsSignBeforeAttributeName);
          this._createAttr("=");
          this.state = State.ATTRIBUTE_NAME;
          break;
        }
        default: {
          this._createAttr("");
          this.state = State.ATTRIBUTE_NAME;
          this._stateAttributeName(cp);
        }
      }
    }
    // Attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeName",
    value: function _stateAttributeName(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED:
        case unicode_js_1.CODE_POINTS.SOLIDUS:
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN:
        case unicode_js_1.CODE_POINTS.EOF: {
          this._leaveAttrName();
          this.state = State.AFTER_ATTRIBUTE_NAME;
          this._stateAfterAttributeName(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.EQUALS_SIGN: {
          this._leaveAttrName();
          this.state = State.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK:
        case unicode_js_1.CODE_POINTS.APOSTROPHE:
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.unexpectedCharacterInAttributeName);
          this.currentAttr.name += String.fromCodePoint(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.currentAttr.name += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        default: {
          this.currentAttr.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
        }
      }
    }
    // After attribute name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeName",
    value: function _stateAfterAttributeName(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.SOLIDUS: {
          this.state = State.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1.CODE_POINTS.EQUALS_SIGN: {
          this.state = State.BEFORE_ATTRIBUTE_VALUE;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._createAttr("");
          this.state = State.ATTRIBUTE_NAME;
          this._stateAttributeName(cp);
        }
      }
    }
    // Before attribute value state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeAttributeValue",
    value: function _stateBeforeAttributeValue(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this.state = State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this.state = State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.missingAttributeValue);
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        default: {
          this.state = State.ATTRIBUTE_VALUE_UNQUOTED;
          this._stateAttributeValueUnquoted(cp);
        }
      }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueDoubleQuoted",
    value: function _stateAttributeValueDoubleQuoted(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.AMPERSAND: {
          this.returnState = State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
          this.state = State.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueSingleQuoted",
    value: function _stateAttributeValueSingleQuoted(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.AMPERSAND: {
          this.returnState = State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
          this.state = State.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAttributeValueUnquoted",
    value: function _stateAttributeValueUnquoted(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this._leaveAttrValue();
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1.CODE_POINTS.AMPERSAND: {
          this.returnState = State.ATTRIBUTE_VALUE_UNQUOTED;
          this.state = State.CHARACTER_REFERENCE;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._leaveAttrValue();
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK:
        case unicode_js_1.CODE_POINTS.APOSTROPHE:
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN:
        case unicode_js_1.CODE_POINTS.EQUALS_SIGN:
        case unicode_js_1.CODE_POINTS.GRAVE_ACCENT: {
          this._err(error_codes_js_1$1.ERR.unexpectedCharacterInUnquotedAttributeValue);
          this.currentAttr.value += String.fromCodePoint(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this.currentAttr.value += String.fromCodePoint(cp);
        }
      }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterAttributeValueQuoted",
    value: function _stateAfterAttributeValueQuoted(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this._leaveAttrValue();
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          break;
        }
        case unicode_js_1.CODE_POINTS.SOLIDUS: {
          this._leaveAttrValue();
          this.state = State.SELF_CLOSING_START_TAG;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._leaveAttrValue();
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceBetweenAttributes);
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          this._stateBeforeAttributeName(cp);
        }
      }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
  }, {
    key: "_stateSelfClosingStartTag",
    value: function _stateSelfClosingStartTag(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          const token2 = this.currentToken;
          token2.selfClosing = true;
          this.state = State.DATA;
          this.emitCurrentTagToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInTag);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.unexpectedSolidusInTag);
          this.state = State.BEFORE_ATTRIBUTE_NAME;
          this._stateBeforeAttributeName(cp);
        }
      }
    }
    // Bogus comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusComment",
    value: function _stateBogusComment(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.data += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        default: {
          token2.data += String.fromCodePoint(cp);
        }
      }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
  }, {
    key: "_stateMarkupDeclarationOpen",
    value: function _stateMarkupDeclarationOpen(cp) {
      if (this._consumeSequenceIfMatch(unicode_js_1.SEQUENCES.DASH_DASH, true)) {
        this._createCommentToken(unicode_js_1.SEQUENCES.DASH_DASH.length + 1);
        this.state = State.COMMENT_START;
      } else if (this._consumeSequenceIfMatch(unicode_js_1.SEQUENCES.DOCTYPE, false)) {
        this.currentLocation = this.getCurrentLocation(unicode_js_1.SEQUENCES.DOCTYPE.length + 1);
        this.state = State.DOCTYPE;
      } else if (this._consumeSequenceIfMatch(unicode_js_1.SEQUENCES.CDATA_START, true)) {
        if (this.inForeignNode) {
          this.state = State.CDATA_SECTION;
        } else {
          this._err(error_codes_js_1$1.ERR.cdataInHtmlContent);
          this._createCommentToken(unicode_js_1.SEQUENCES.CDATA_START.length + 1);
          this.currentToken.data = "[CDATA[";
          this.state = State.BOGUS_COMMENT;
        }
      } else if (!this._ensureHibernation()) {
        this._err(error_codes_js_1$1.ERR.incorrectlyOpenedComment);
        this._createCommentToken(2);
        this.state = State.BOGUS_COMMENT;
        this._stateBogusComment(cp);
      }
    }
    // Comment start state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStart",
    value: function _stateCommentStart(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.COMMENT_START_DASH;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptClosingOfEmptyComment);
          this.state = State.DATA;
          const token2 = this.currentToken;
          this.emitCurrentComment(token2);
          break;
        }
        default: {
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment start dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentStartDash",
    value: function _stateCommentStartDash(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.COMMENT_END;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptClosingOfEmptyComment);
          this.state = State.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "-";
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment state
    //------------------------------------------------------------------
  }, {
    key: "_stateComment",
    value: function _stateComment(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.COMMENT_END_DASH;
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          token2.data += "<";
          this.state = State.COMMENT_LESS_THAN_SIGN;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.data += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += String.fromCodePoint(cp);
        }
      }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSign",
    value: function _stateCommentLessThanSign(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.EXCLAMATION_MARK: {
          token2.data += "!";
          this.state = State.COMMENT_LESS_THAN_SIGN_BANG;
          break;
        }
        case unicode_js_1.CODE_POINTS.LESS_THAN_SIGN: {
          token2.data += "<";
          break;
        }
        default: {
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBang",
    value: function _stateCommentLessThanSignBang(cp) {
      if (cp === unicode_js_1.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
      } else {
        this.state = State.COMMENT;
        this._stateComment(cp);
      }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDash",
    value: function _stateCommentLessThanSignBangDash(cp) {
      if (cp === unicode_js_1.CODE_POINTS.HYPHEN_MINUS) {
        this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
      } else {
        this.state = State.COMMENT_END_DASH;
        this._stateCommentEndDash(cp);
      }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentLessThanSignBangDashDash",
    value: function _stateCommentLessThanSignBangDashDash(cp) {
      if (cp !== unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN && cp !== unicode_js_1.CODE_POINTS.EOF) {
        this._err(error_codes_js_1$1.ERR.nestedComment);
      }
      this.state = State.COMMENT_END;
      this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndDash",
    value: function _stateCommentEndDash(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          this.state = State.COMMENT_END;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "-";
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEnd",
    value: function _stateCommentEnd(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EXCLAMATION_MARK: {
          this.state = State.COMMENT_END_BANG;
          break;
        }
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          token2.data += "-";
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "--";
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // Comment end bang state
    //------------------------------------------------------------------
  }, {
    key: "_stateCommentEndBang",
    value: function _stateCommentEndBang(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.HYPHEN_MINUS: {
          token2.data += "--!";
          this.state = State.COMMENT_END_DASH;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.incorrectlyClosedComment);
          this.state = State.DATA;
          this.emitCurrentComment(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInComment);
          this.emitCurrentComment(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.data += "--!";
          this.state = State.COMMENT;
          this._stateComment(cp);
        }
      }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctype",
    value: function _stateDoctype(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.BEFORE_DOCTYPE_NAME;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.BEFORE_DOCTYPE_NAME;
          this._stateBeforeDoctypeName(cp);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          this._createDoctypeToken(null);
          const token2 = this.currentToken;
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceBeforeDoctypeName);
          this.state = State.BEFORE_DOCTYPE_NAME;
          this._stateBeforeDoctypeName(cp);
        }
      }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeName",
    value: function _stateBeforeDoctypeName(cp) {
      if (isAsciiUpper(cp)) {
        this._createDoctypeToken(String.fromCharCode(toAsciiLower(cp)));
        this.state = State.DOCTYPE_NAME;
      } else
        switch (cp) {
          case unicode_js_1.CODE_POINTS.SPACE:
          case unicode_js_1.CODE_POINTS.LINE_FEED:
          case unicode_js_1.CODE_POINTS.TABULATION:
          case unicode_js_1.CODE_POINTS.FORM_FEED: {
            break;
          }
          case unicode_js_1.CODE_POINTS.NULL: {
            this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
            this._createDoctypeToken(unicode_js_1.REPLACEMENT_CHARACTER);
            this.state = State.DOCTYPE_NAME;
            break;
          }
          case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
            this._err(error_codes_js_1$1.ERR.missingDoctypeName);
            this._createDoctypeToken(null);
            const token2 = this.currentToken;
            token2.forceQuirks = true;
            this.emitCurrentDoctype(token2);
            this.state = State.DATA;
            break;
          }
          case unicode_js_1.CODE_POINTS.EOF: {
            this._err(error_codes_js_1$1.ERR.eofInDoctype);
            this._createDoctypeToken(null);
            const token2 = this.currentToken;
            token2.forceQuirks = true;
            this.emitCurrentDoctype(token2);
            this._emitEOFToken();
            break;
          }
          default: {
            this._createDoctypeToken(String.fromCodePoint(cp));
            this.state = State.DOCTYPE_NAME;
          }
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeName",
    value: function _stateDoctypeName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.AFTER_DOCTYPE_NAME;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.name += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
        }
      }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeName",
    value: function _stateAfterDoctypeName(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          if (this._consumeSequenceIfMatch(unicode_js_1.SEQUENCES.PUBLIC, false)) {
            this.state = State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
          } else if (this._consumeSequenceIfMatch(unicode_js_1.SEQUENCES.SYSTEM, false)) {
            this.state = State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
          } else if (!this._ensureHibernation()) {
            this._err(error_codes_js_1$1.ERR.invalidCharacterSequenceAfterDoctypeName);
            token2.forceQuirks = true;
            this.state = State.BOGUS_DOCTYPE;
            this._stateBogusDoctype(cp);
          }
        }
      }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicKeyword",
    value: function _stateAfterDoctypePublicKeyword(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceAfterDoctypePublicKeyword);
          token2.publicId = "";
          this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceAfterDoctypePublicKeyword);
          token2.publicId = "";
          this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.missingDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypePublicIdentifier",
    value: function _stateBeforeDoctypePublicIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          token2.publicId = "";
          this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          token2.publicId = "";
          this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.missingDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierDoubleQuoted",
    value: function _stateDoctypePublicIdentifierDoubleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.publicId += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.publicId += String.fromCodePoint(cp);
        }
      }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypePublicIdentifierSingleQuoted",
    value: function _stateDoctypePublicIdentifierSingleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.publicId += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptDoctypePublicIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.publicId += String.fromCodePoint(cp);
        }
      }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypePublicIdentifier",
    value: function _stateAfterDoctypePublicIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
  }, {
    key: "_stateBetweenDoctypePublicAndSystemIdentifiers",
    value: function _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemKeyword",
    value: function _stateAfterDoctypeSystemKeyword(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          this.state = State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this._err(error_codes_js_1$1.ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.missingDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateBeforeDoctypeSystemIdentifier",
    value: function _stateBeforeDoctypeSystemIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          token2.systemId = "";
          this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.missingDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.DATA;
          this.emitCurrentDoctype(token2);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierDoubleQuoted",
    value: function _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.QUOTATION_MARK: {
          this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.systemId += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.systemId += String.fromCodePoint(cp);
        }
      }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: "_stateDoctypeSystemIdentifierSingleQuoted",
    value: function _stateDoctypeSystemIdentifierSingleQuoted(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.APOSTROPHE: {
          this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          token2.systemId += unicode_js_1.REPLACEMENT_CHARACTER;
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(error_codes_js_1$1.ERR.abruptDoctypeSystemIdentifier);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          token2.systemId += String.fromCodePoint(cp);
        }
      }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: "_stateAfterDoctypeSystemIdentifier",
    value: function _stateAfterDoctypeSystemIdentifier(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.SPACE:
        case unicode_js_1.CODE_POINTS.LINE_FEED:
        case unicode_js_1.CODE_POINTS.TABULATION:
        case unicode_js_1.CODE_POINTS.FORM_FEED: {
          break;
        }
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInDoctype);
          token2.forceQuirks = true;
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
        default: {
          this._err(error_codes_js_1$1.ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
          this.state = State.BOGUS_DOCTYPE;
          this._stateBogusDoctype(cp);
        }
      }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: "_stateBogusDoctype",
    value: function _stateBogusDoctype(cp) {
      const token2 = this.currentToken;
      switch (cp) {
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.emitCurrentDoctype(token2);
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.NULL: {
          this._err(error_codes_js_1$1.ERR.unexpectedNullCharacter);
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this.emitCurrentDoctype(token2);
          this._emitEOFToken();
          break;
        }
      }
    }
    // CDATA section state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSection",
    value: function _stateCdataSection(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
          this.state = State.CDATA_SECTION_BRACKET;
          break;
        }
        case unicode_js_1.CODE_POINTS.EOF: {
          this._err(error_codes_js_1$1.ERR.eofInCdata);
          this._emitEOFToken();
          break;
        }
        default: {
          this._emitCodePoint(cp);
        }
      }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionBracket",
    value: function _stateCdataSectionBracket(cp) {
      if (cp === unicode_js_1.CODE_POINTS.RIGHT_SQUARE_BRACKET) {
        this.state = State.CDATA_SECTION_END;
      } else {
        this._emitChars("]");
        this.state = State.CDATA_SECTION;
        this._stateCdataSection(cp);
      }
    }
    // CDATA section end state
    //------------------------------------------------------------------
  }, {
    key: "_stateCdataSectionEnd",
    value: function _stateCdataSectionEnd(cp) {
      switch (cp) {
        case unicode_js_1.CODE_POINTS.GREATER_THAN_SIGN: {
          this.state = State.DATA;
          break;
        }
        case unicode_js_1.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
          this._emitChars("]");
          break;
        }
        default: {
          this._emitChars("]]");
          this.state = State.CDATA_SECTION;
          this._stateCdataSection(cp);
        }
      }
    }
    // Character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateCharacterReference",
    value: function _stateCharacterReference(cp) {
      if (cp === unicode_js_1.CODE_POINTS.NUMBER_SIGN) {
        this.state = State.NUMERIC_CHARACTER_REFERENCE;
      } else if (isAsciiAlphaNumeric(cp)) {
        this.state = State.NAMED_CHARACTER_REFERENCE;
        this._stateNamedCharacterReference(cp);
      } else {
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.AMPERSAND);
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Named character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateNamedCharacterReference",
    value: function _stateNamedCharacterReference(cp) {
      const matchResult = this._matchNamedCharacterReference(cp);
      if (this._ensureHibernation())
        ;
      else if (matchResult) {
        for (let i = 0; i < matchResult.length; i++) {
          this._flushCodePointConsumedAsCharacterReference(matchResult[i]);
        }
        this.state = this.returnState;
      } else {
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.AMPERSAND);
        this.state = State.AMBIGUOUS_AMPERSAND;
      }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
  }, {
    key: "_stateAmbiguousAmpersand",
    value: function _stateAmbiguousAmpersand(cp) {
      if (isAsciiAlphaNumeric(cp)) {
        this._flushCodePointConsumedAsCharacterReference(cp);
      } else {
        if (cp === unicode_js_1.CODE_POINTS.SEMICOLON) {
          this._err(error_codes_js_1$1.ERR.unknownNamedCharacterReference);
        }
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Numeric character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateNumericCharacterReference",
    value: function _stateNumericCharacterReference(cp) {
      this.charRefCode = 0;
      if (cp === unicode_js_1.CODE_POINTS.LATIN_SMALL_X || cp === unicode_js_1.CODE_POINTS.LATIN_CAPITAL_X) {
        this.state = State.HEXADEMICAL_CHARACTER_REFERENCE_START;
      } else if (isAsciiDigit(cp)) {
        this.state = State.DECIMAL_CHARACTER_REFERENCE;
        this._stateDecimalCharacterReference(cp);
      } else {
        this._err(error_codes_js_1$1.ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.AMPERSAND);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.NUMBER_SIGN);
        this._reconsumeInState(this.returnState, cp);
      }
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
  }, {
    key: "_stateHexademicalCharacterReferenceStart",
    value: function _stateHexademicalCharacterReferenceStart(cp) {
      if (isAsciiHexDigit(cp)) {
        this.state = State.HEXADEMICAL_CHARACTER_REFERENCE;
        this._stateHexademicalCharacterReference(cp);
      } else {
        this._err(error_codes_js_1$1.ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.AMPERSAND);
        this._flushCodePointConsumedAsCharacterReference(unicode_js_1.CODE_POINTS.NUMBER_SIGN);
        this._unconsume(2);
        this.state = this.returnState;
      }
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateHexademicalCharacterReference",
    value: function _stateHexademicalCharacterReference(cp) {
      if (isAsciiUpperHexDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 55;
      } else if (isAsciiLowerHexDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 87;
      } else if (isAsciiDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 48;
      } else if (cp === unicode_js_1.CODE_POINTS.SEMICOLON) {
        this.state = State.NUMERIC_CHARACTER_REFERENCE_END;
      } else {
        this._err(error_codes_js_1$1.ERR.missingSemicolonAfterCharacterReference);
        this.state = State.NUMERIC_CHARACTER_REFERENCE_END;
        this._stateNumericCharacterReferenceEnd(cp);
      }
    }
    // Decimal character reference state
    //------------------------------------------------------------------
  }, {
    key: "_stateDecimalCharacterReference",
    value: function _stateDecimalCharacterReference(cp) {
      if (isAsciiDigit(cp)) {
        this.charRefCode = this.charRefCode * 10 + cp - 48;
      } else if (cp === unicode_js_1.CODE_POINTS.SEMICOLON) {
        this.state = State.NUMERIC_CHARACTER_REFERENCE_END;
      } else {
        this._err(error_codes_js_1$1.ERR.missingSemicolonAfterCharacterReference);
        this.state = State.NUMERIC_CHARACTER_REFERENCE_END;
        this._stateNumericCharacterReferenceEnd(cp);
      }
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
  }, {
    key: "_stateNumericCharacterReferenceEnd",
    value: function _stateNumericCharacterReferenceEnd(cp) {
      if (this.charRefCode === unicode_js_1.CODE_POINTS.NULL) {
        this._err(error_codes_js_1$1.ERR.nullCharacterReference);
        this.charRefCode = unicode_js_1.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if (this.charRefCode > 1114111) {
        this._err(error_codes_js_1$1.ERR.characterReferenceOutsideUnicodeRange);
        this.charRefCode = unicode_js_1.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if ((0, unicode_js_1.isSurrogate)(this.charRefCode)) {
        this._err(error_codes_js_1$1.ERR.surrogateCharacterReference);
        this.charRefCode = unicode_js_1.CODE_POINTS.REPLACEMENT_CHARACTER;
      } else if ((0, unicode_js_1.isUndefinedCodePoint)(this.charRefCode)) {
        this._err(error_codes_js_1$1.ERR.noncharacterCharacterReference);
      } else if ((0, unicode_js_1.isControlCodePoint)(this.charRefCode) || this.charRefCode === unicode_js_1.CODE_POINTS.CARRIAGE_RETURN) {
        this._err(error_codes_js_1$1.ERR.controlCharacterReference);
        const replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS.get(this.charRefCode);
        if (replacement !== void 0) {
          this.charRefCode = replacement;
        }
      }
      this._flushCodePointConsumedAsCharacterReference(this.charRefCode);
      this._reconsumeInState(this.returnState, cp);
    }
  }]);
  return Tokenizer2;
}();
tokenizer.Tokenizer = Tokenizer$1;
var openElementStack = {};
function _classCallCheck$1C(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1q(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1q(descriptor.key), descriptor);
  }
}
function _createClass$1A(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1q(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1q(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1q(arg) {
  var key = _toPrimitive$1q(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1q(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(openElementStack, "__esModule", {
  value: true
});
openElementStack.OpenElementStack = void 0;
const html_js_1$3 = html$1;
const IMPLICIT_END_TAG_REQUIRED = /* @__PURE__ */ new Set([html_js_1$3.TAG_ID.DD, html_js_1$3.TAG_ID.DT, html_js_1$3.TAG_ID.LI, html_js_1$3.TAG_ID.OPTGROUP, html_js_1$3.TAG_ID.OPTION, html_js_1$3.TAG_ID.P, html_js_1$3.TAG_ID.RB, html_js_1$3.TAG_ID.RP, html_js_1$3.TAG_ID.RT, html_js_1$3.TAG_ID.RTC]);
const IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = /* @__PURE__ */ new Set([...IMPLICIT_END_TAG_REQUIRED, html_js_1$3.TAG_ID.CAPTION, html_js_1$3.TAG_ID.COLGROUP, html_js_1$3.TAG_ID.TBODY, html_js_1$3.TAG_ID.TD, html_js_1$3.TAG_ID.TFOOT, html_js_1$3.TAG_ID.TH, html_js_1$3.TAG_ID.THEAD, html_js_1$3.TAG_ID.TR]);
const SCOPING_ELEMENT_NS = /* @__PURE__ */ new Map([[html_js_1$3.TAG_ID.APPLET, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.CAPTION, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.HTML, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.MARQUEE, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.OBJECT, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.TABLE, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.TD, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.TEMPLATE, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.TH, html_js_1$3.NS.HTML], [html_js_1$3.TAG_ID.ANNOTATION_XML, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.MI, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.MN, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.MO, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.MS, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.MTEXT, html_js_1$3.NS.MATHML], [html_js_1$3.TAG_ID.DESC, html_js_1$3.NS.SVG], [html_js_1$3.TAG_ID.FOREIGN_OBJECT, html_js_1$3.NS.SVG], [html_js_1$3.TAG_ID.TITLE, html_js_1$3.NS.SVG]]);
const NAMED_HEADERS = [html_js_1$3.TAG_ID.H1, html_js_1$3.TAG_ID.H2, html_js_1$3.TAG_ID.H3, html_js_1$3.TAG_ID.H4, html_js_1$3.TAG_ID.H5, html_js_1$3.TAG_ID.H6];
const TABLE_ROW_CONTEXT = [html_js_1$3.TAG_ID.TR, html_js_1$3.TAG_ID.TEMPLATE, html_js_1$3.TAG_ID.HTML];
const TABLE_BODY_CONTEXT = [html_js_1$3.TAG_ID.TBODY, html_js_1$3.TAG_ID.TFOOT, html_js_1$3.TAG_ID.THEAD, html_js_1$3.TAG_ID.TEMPLATE, html_js_1$3.TAG_ID.HTML];
const TABLE_CONTEXT = [html_js_1$3.TAG_ID.TABLE, html_js_1$3.TAG_ID.TEMPLATE, html_js_1$3.TAG_ID.HTML];
const TABLE_CELLS = [html_js_1$3.TAG_ID.TD, html_js_1$3.TAG_ID.TH];
let OpenElementStack = /* @__PURE__ */ function() {
  function OpenElementStack2(document2, treeAdapter, handler) {
    _classCallCheck$1C(this, OpenElementStack2);
    this.treeAdapter = treeAdapter;
    this.handler = handler;
    this.items = [];
    this.tagIDs = [];
    this.stackTop = -1;
    this.tmplCount = 0;
    this.currentTagId = html_js_1$3.TAG_ID.UNKNOWN;
    this.current = document2;
  }
  _createClass$1A(OpenElementStack2, [{
    key: "currentTmplContentOrNode",
    get: function() {
      return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
  }, {
    key: "_indexOf",
    value: function _indexOf(element) {
      return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
  }, {
    key: "_isInTemplate",
    value: function _isInTemplate() {
      return this.currentTagId === html_js_1$3.TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === html_js_1$3.NS.HTML;
    }
  }, {
    key: "_updateCurrentElement",
    value: function _updateCurrentElement() {
      this.current = this.items[this.stackTop];
      this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
  }, {
    key: "push",
    value: function push(element, tagID) {
      this.stackTop++;
      this.items[this.stackTop] = element;
      this.current = element;
      this.tagIDs[this.stackTop] = tagID;
      this.currentTagId = tagID;
      if (this._isInTemplate()) {
        this.tmplCount++;
      }
      this.handler.onItemPush(element, tagID, true);
    }
  }, {
    key: "pop",
    value: function pop() {
      const popped = this.current;
      if (this.tmplCount > 0 && this._isInTemplate()) {
        this.tmplCount--;
      }
      this.stackTop--;
      this._updateCurrentElement();
      this.handler.onItemPop(popped, true);
    }
  }, {
    key: "replace",
    value: function replace(oldElement, newElement) {
      const idx = this._indexOf(oldElement);
      this.items[idx] = newElement;
      if (idx === this.stackTop) {
        this.current = newElement;
      }
    }
  }, {
    key: "insertAfter",
    value: function insertAfter2(referenceElement, newElement, newElementID) {
      const insertionIdx = this._indexOf(referenceElement) + 1;
      this.items.splice(insertionIdx, 0, newElement);
      this.tagIDs.splice(insertionIdx, 0, newElementID);
      this.stackTop++;
      if (insertionIdx === this.stackTop) {
        this._updateCurrentElement();
      }
      this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
  }, {
    key: "popUntilTagNamePopped",
    value: function popUntilTagNamePopped(tagName) {
      let targetIdx = this.stackTop + 1;
      do {
        targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
      } while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== html_js_1$3.NS.HTML);
      this.shortenToLength(targetIdx < 0 ? 0 : targetIdx);
    }
  }, {
    key: "shortenToLength",
    value: function shortenToLength(idx) {
      while (this.stackTop >= idx) {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) {
          this.tmplCount -= 1;
        }
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, this.stackTop < idx);
      }
    }
  }, {
    key: "popUntilElementPopped",
    value: function popUntilElementPopped(element) {
      const idx = this._indexOf(element);
      this.shortenToLength(idx < 0 ? 0 : idx);
    }
  }, {
    key: "popUntilPopped",
    value: function popUntilPopped(tagNames, targetNS) {
      const idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(idx < 0 ? 0 : idx);
    }
  }, {
    key: "popUntilNumberedHeaderPopped",
    value: function popUntilNumberedHeaderPopped() {
      this.popUntilPopped(NAMED_HEADERS, html_js_1$3.NS.HTML);
    }
  }, {
    key: "popUntilTableCellPopped",
    value: function popUntilTableCellPopped() {
      this.popUntilPopped(TABLE_CELLS, html_js_1$3.NS.HTML);
    }
  }, {
    key: "popAllUpToHtmlElement",
    value: function popAllUpToHtmlElement() {
      this.tmplCount = 0;
      this.shortenToLength(1);
    }
  }, {
    key: "_indexOfTagNames",
    value: function _indexOfTagNames(tagNames, namespace2) {
      for (let i = this.stackTop; i >= 0; i--) {
        if (tagNames.includes(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace2) {
          return i;
        }
      }
      return -1;
    }
  }, {
    key: "clearBackTo",
    value: function clearBackTo(tagNames, targetNS) {
      const idx = this._indexOfTagNames(tagNames, targetNS);
      this.shortenToLength(idx + 1);
    }
  }, {
    key: "clearBackToTableContext",
    value: function clearBackToTableContext() {
      this.clearBackTo(TABLE_CONTEXT, html_js_1$3.NS.HTML);
    }
  }, {
    key: "clearBackToTableBodyContext",
    value: function clearBackToTableBodyContext() {
      this.clearBackTo(TABLE_BODY_CONTEXT, html_js_1$3.NS.HTML);
    }
  }, {
    key: "clearBackToTableRowContext",
    value: function clearBackToTableRowContext() {
      this.clearBackTo(TABLE_ROW_CONTEXT, html_js_1$3.NS.HTML);
    }
  }, {
    key: "remove",
    value: function remove3(element) {
      const idx = this._indexOf(element);
      if (idx >= 0) {
        if (idx === this.stackTop) {
          this.pop();
        } else {
          this.items.splice(idx, 1);
          this.tagIDs.splice(idx, 1);
          this.stackTop--;
          this._updateCurrentElement();
          this.handler.onItemPop(element, false);
        }
      }
    }
    //Search
  }, {
    key: "tryPeekProperlyNestedBodyElement",
    value: function tryPeekProperlyNestedBodyElement() {
      return this.stackTop >= 1 && this.tagIDs[1] === html_js_1$3.TAG_ID.BODY ? this.items[1] : null;
    }
  }, {
    key: "contains",
    value: function contains2(element) {
      return this._indexOf(element) > -1;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(element) {
      const elementIdx = this._indexOf(element) - 1;
      return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
  }, {
    key: "isRootHtmlElementCurrent",
    value: function isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.tagIDs[0] === html_js_1$3.TAG_ID.HTML;
    }
    //Element in scope
  }, {
    key: "hasInScope",
    value: function hasInScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$3.NS.HTML) {
          return true;
        }
        if (SCOPING_ELEMENT_NS.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasNumberedHeaderInScope",
    value: function hasNumberedHeaderInScope() {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if ((0, html_js_1$3.isNumberedHeader)(tn) && ns === html_js_1$3.NS.HTML) {
          return true;
        }
        if (SCOPING_ELEMENT_NS.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInListItemScope",
    value: function hasInListItemScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$3.NS.HTML) {
          return true;
        }
        if ((tn === html_js_1$3.TAG_ID.UL || tn === html_js_1$3.TAG_ID.OL) && ns === html_js_1$3.NS.HTML || SCOPING_ELEMENT_NS.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInButtonScope",
    value: function hasInButtonScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === html_js_1$3.NS.HTML) {
          return true;
        }
        if (tn === html_js_1$3.TAG_ID.BUTTON && ns === html_js_1$3.NS.HTML || SCOPING_ELEMENT_NS.get(tn) === ns) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInTableScope",
    value: function hasInTableScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$3.NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn === html_js_1$3.TAG_ID.TABLE || tn === html_js_1$3.TAG_ID.TEMPLATE || tn === html_js_1$3.TAG_ID.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasTableBodyContextInTableScope",
    value: function hasTableBodyContextInTableScope() {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$3.NS.HTML) {
          continue;
        }
        if (tn === html_js_1$3.TAG_ID.TBODY || tn === html_js_1$3.TAG_ID.THEAD || tn === html_js_1$3.TAG_ID.TFOOT) {
          return true;
        }
        if (tn === html_js_1$3.TAG_ID.TABLE || tn === html_js_1$3.TAG_ID.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInSelectScope",
    value: function hasInSelectScope(tagName) {
      for (let i = this.stackTop; i >= 0; i--) {
        const tn = this.tagIDs[i];
        const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== html_js_1$3.NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn !== html_js_1$3.TAG_ID.OPTION && tn !== html_js_1$3.TAG_ID.OPTGROUP) {
          return false;
        }
      }
      return true;
    }
    //Implied end tags
  }, {
    key: "generateImpliedEndTags",
    value: function generateImpliedEndTags() {
      while (IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsThoroughly",
    value: function generateImpliedEndTagsThoroughly() {
      while (IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsWithExclusion",
    value: function generateImpliedEndTagsWithExclusion(exclusionId) {
      while (this.currentTagId !== exclusionId && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
        this.pop();
      }
    }
  }]);
  return OpenElementStack2;
}();
openElementStack.OpenElementStack = OpenElementStack;
var formattingElementList = {};
(function(exports2) {
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey3(descriptor.key), descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _toPropertyKey3(arg) {
    var key = _toPrimitive3(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive3(input, hint) {
    if (typeof input !== "object" || input === null)
      return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object")
        return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.FormattingElementList = exports2.EntryType = void 0;
  const NOAH_ARK_CAPACITY = 3;
  var EntryType;
  (function(EntryType2) {
    EntryType2[EntryType2["Marker"] = 0] = "Marker";
    EntryType2[EntryType2["Element"] = 1] = "Element";
  })(EntryType = exports2.EntryType || (exports2.EntryType = {}));
  const MARKER = {
    type: EntryType.Marker
  };
  let FormattingElementList = /* @__PURE__ */ function() {
    function FormattingElementList2(treeAdapter) {
      _classCallCheck2(this, FormattingElementList2);
      this.treeAdapter = treeAdapter;
      this.entries = [];
      this.bookmark = null;
    }
    _createClass2(FormattingElementList2, [{
      key: "_getNoahArkConditionCandidates",
      value: function _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for (let i = 0; i < this.entries.length; i++) {
          const entry = this.entries[i];
          if (entry.type === EntryType.Marker) {
            break;
          }
          const {
            element
          } = entry;
          if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
            const elementAttrs = this.treeAdapter.getAttrList(element);
            if (elementAttrs.length === neAttrsLength) {
              candidates.push({
                idx: i,
                attrs: elementAttrs
              });
            }
          }
        }
        return candidates;
      }
    }, {
      key: "_ensureNoahArkCondition",
      value: function _ensureNoahArkCondition(newElement) {
        if (this.entries.length < NOAH_ARK_CAPACITY)
          return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < NOAH_ARK_CAPACITY)
          return;
        const neAttrsMap = new Map(neAttrs.map((neAttr) => [neAttr.name, neAttr.value]));
        let validCandidates = 0;
        for (let i = 0; i < candidates.length; i++) {
          const candidate = candidates[i];
          if (candidate.attrs.every((cAttr) => neAttrsMap.get(cAttr.name) === cAttr.value)) {
            validCandidates += 1;
            if (validCandidates >= NOAH_ARK_CAPACITY) {
              this.entries.splice(candidate.idx, 1);
            }
          }
        }
      }
      //Mutations
    }, {
      key: "insertMarker",
      value: function insertMarker() {
        this.entries.unshift(MARKER);
      }
    }, {
      key: "pushElement",
      value: function pushElement(element, token2) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
          type: EntryType.Element,
          element,
          token: token2
        });
      }
    }, {
      key: "insertElementAfterBookmark",
      value: function insertElementAfterBookmark(element, token2) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
          type: EntryType.Element,
          element,
          token: token2
        });
      }
    }, {
      key: "removeEntry",
      value: function removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex >= 0) {
          this.entries.splice(entryIndex, 1);
        }
      }
      /**
       * Clears the list of formatting elements up to the last marker.
       *
       * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
       */
    }, {
      key: "clearToLastMarker",
      value: function clearToLastMarker() {
        const markerIdx = this.entries.indexOf(MARKER);
        if (markerIdx >= 0) {
          this.entries.splice(0, markerIdx + 1);
        } else {
          this.entries.length = 0;
        }
      }
      //Search
    }, {
      key: "getElementEntryInScopeWithTagName",
      value: function getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry2) => entry2.type === EntryType.Marker || this.treeAdapter.getTagName(entry2.element) === tagName);
        return entry && entry.type === EntryType.Element ? entry : null;
      }
    }, {
      key: "getElementEntry",
      value: function getElementEntry(element) {
        return this.entries.find((entry) => entry.type === EntryType.Element && entry.element === element);
      }
    }]);
    return FormattingElementList2;
  }();
  exports2.FormattingElementList = FormattingElementList;
})(formattingElementList);
var _default$4 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.defaultTreeAdapter = void 0;
  const html_js_12 = html$1;
  function createTextNode(value2) {
    return {
      nodeName: "#text",
      value: value2,
      parentNode: null
    };
  }
  exports2.defaultTreeAdapter = {
    //Node construction
    createDocument() {
      return {
        nodeName: "#document",
        mode: html_js_12.DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
      };
    },
    createDocumentFragment() {
      return {
        nodeName: "#document-fragment",
        childNodes: []
      };
    },
    createElement(tagName, namespaceURI, attrs) {
      return {
        nodeName: tagName,
        tagName,
        attrs,
        namespaceURI,
        childNodes: [],
        parentNode: null
      };
    },
    createCommentNode(data2) {
      return {
        nodeName: "#comment",
        data: data2,
        parentNode: null
      };
    },
    //Tree mutation
    appendChild(parentNode, newNode) {
      parentNode.childNodes.push(newNode);
      newNode.parentNode = parentNode;
    },
    insertBefore(parentNode, newNode, referenceNode) {
      const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
      parentNode.childNodes.splice(insertionIdx, 0, newNode);
      newNode.parentNode = parentNode;
    },
    setTemplateContent(templateElement, contentElement) {
      templateElement.content = contentElement;
    },
    getTemplateContent(templateElement) {
      return templateElement.content;
    },
    setDocumentType(document2, name, publicId, systemId) {
      const doctypeNode = document2.childNodes.find((node2) => node2.nodeName === "#documentType");
      if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
      } else {
        const node2 = {
          nodeName: "#documentType",
          name,
          publicId,
          systemId,
          parentNode: null
        };
        exports2.defaultTreeAdapter.appendChild(document2, node2);
      }
    },
    setDocumentMode(document2, mode) {
      document2.mode = mode;
    },
    getDocumentMode(document2) {
      return document2.mode;
    },
    detachNode(node2) {
      if (node2.parentNode) {
        const idx = node2.parentNode.childNodes.indexOf(node2);
        node2.parentNode.childNodes.splice(idx, 1);
        node2.parentNode = null;
      }
    },
    insertText(parentNode, text2) {
      if (parentNode.childNodes.length > 0) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
        if (exports2.defaultTreeAdapter.isTextNode(prevNode)) {
          prevNode.value += text2;
          return;
        }
      }
      exports2.defaultTreeAdapter.appendChild(parentNode, createTextNode(text2));
    },
    insertTextBefore(parentNode, text2, referenceNode) {
      const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
      if (prevNode && exports2.defaultTreeAdapter.isTextNode(prevNode)) {
        prevNode.value += text2;
      } else {
        exports2.defaultTreeAdapter.insertBefore(parentNode, createTextNode(text2), referenceNode);
      }
    },
    adoptAttributes(recipient, attrs) {
      const recipientAttrsMap = new Set(recipient.attrs.map((attr2) => attr2.name));
      for (let j = 0; j < attrs.length; j++) {
        if (!recipientAttrsMap.has(attrs[j].name)) {
          recipient.attrs.push(attrs[j]);
        }
      }
    },
    //Tree traversing
    getFirstChild(node2) {
      return node2.childNodes[0];
    },
    getChildNodes(node2) {
      return node2.childNodes;
    },
    getParentNode(node2) {
      return node2.parentNode;
    },
    getAttrList(element) {
      return element.attrs;
    },
    //Node data
    getTagName(element) {
      return element.tagName;
    },
    getNamespaceURI(element) {
      return element.namespaceURI;
    },
    getTextNodeContent(textNode) {
      return textNode.value;
    },
    getCommentNodeContent(commentNode) {
      return commentNode.data;
    },
    getDocumentTypeNodeName(doctypeNode) {
      return doctypeNode.name;
    },
    getDocumentTypeNodePublicId(doctypeNode) {
      return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId(doctypeNode) {
      return doctypeNode.systemId;
    },
    //Node types
    isTextNode(node2) {
      return node2.nodeName === "#text";
    },
    isCommentNode(node2) {
      return node2.nodeName === "#comment";
    },
    isDocumentTypeNode(node2) {
      return node2.nodeName === "#documentType";
    },
    isElementNode(node2) {
      return Object.prototype.hasOwnProperty.call(node2, "tagName");
    },
    // Source code location
    setNodeSourceCodeLocation(node2, location) {
      node2.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation(node2) {
      return node2.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(node2, endLocation) {
      node2.sourceCodeLocation = Object.assign(Object.assign({}, node2.sourceCodeLocation), endLocation);
    }
  };
})(_default$4);
var doctype$1 = {};
Object.defineProperty(doctype$1, "__esModule", {
  value: true
});
doctype$1.getDocumentMode = doctype$1.isConforming = void 0;
const html_js_1$2 = html$1;
const VALID_DOCTYPE_NAME = "html";
const VALID_SYSTEM_ID = "about:legacy-compat";
const QUIRKS_MODE_SYSTEM_ID = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd";
const QUIRKS_MODE_PUBLIC_ID_PREFIXES = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", "-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", "-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", "-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", "-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"];
const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [...QUIRKS_MODE_PUBLIC_ID_PREFIXES, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
const QUIRKS_MODE_PUBLIC_IDS = /* @__PURE__ */ new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]);
const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"];
const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [...LIMITED_QUIRKS_PUBLIC_ID_PREFIXES, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
function hasPrefix(publicId, prefixes2) {
  return prefixes2.some((prefix2) => publicId.startsWith(prefix2));
}
function isConforming(token2) {
  return token2.name === VALID_DOCTYPE_NAME && token2.publicId === null && (token2.systemId === null || token2.systemId === VALID_SYSTEM_ID);
}
doctype$1.isConforming = isConforming;
function getDocumentMode(token2) {
  if (token2.name !== VALID_DOCTYPE_NAME) {
    return html_js_1$2.DOCUMENT_MODE.QUIRKS;
  }
  const {
    systemId
  } = token2;
  if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
    return html_js_1$2.DOCUMENT_MODE.QUIRKS;
  }
  let {
    publicId
  } = token2;
  if (publicId !== null) {
    publicId = publicId.toLowerCase();
    if (QUIRKS_MODE_PUBLIC_IDS.has(publicId)) {
      return html_js_1$2.DOCUMENT_MODE.QUIRKS;
    }
    let prefixes2 = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes2)) {
      return html_js_1$2.DOCUMENT_MODE.QUIRKS;
    }
    prefixes2 = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes2)) {
      return html_js_1$2.DOCUMENT_MODE.LIMITED_QUIRKS;
    }
  }
  return html_js_1$2.DOCUMENT_MODE.NO_QUIRKS;
}
doctype$1.getDocumentMode = getDocumentMode;
var foreignContent$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.isIntegrationPoint = exports2.adjustTokenSVGTagName = exports2.adjustTokenXMLAttrs = exports2.adjustTokenSVGAttrs = exports2.adjustTokenMathMLAttrs = exports2.causesExit = exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP = void 0;
  const html_js_12 = html$1;
  const MIME_TYPES = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  };
  const DEFINITION_URL_ATTR = "definitionurl";
  const ADJUSTED_DEFINITION_URL_ATTR = "definitionURL";
  const SVG_ATTRS_ADJUSTMENT_MAP = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map((attr2) => [attr2.toLowerCase(), attr2]));
  const XML_ATTRS_ADJUSTMENT_MAP = /* @__PURE__ */ new Map([["xlink:actuate", {
    prefix: "xlink",
    name: "actuate",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:arcrole", {
    prefix: "xlink",
    name: "arcrole",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:href", {
    prefix: "xlink",
    name: "href",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:role", {
    prefix: "xlink",
    name: "role",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:show", {
    prefix: "xlink",
    name: "show",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:title", {
    prefix: "xlink",
    name: "title",
    namespace: html_js_12.NS.XLINK
  }], ["xlink:type", {
    prefix: "xlink",
    name: "type",
    namespace: html_js_12.NS.XLINK
  }], ["xml:base", {
    prefix: "xml",
    name: "base",
    namespace: html_js_12.NS.XML
  }], ["xml:lang", {
    prefix: "xml",
    name: "lang",
    namespace: html_js_12.NS.XML
  }], ["xml:space", {
    prefix: "xml",
    name: "space",
    namespace: html_js_12.NS.XML
  }], ["xmlns", {
    prefix: "",
    name: "xmlns",
    namespace: html_js_12.NS.XMLNS
  }], ["xmlns:xlink", {
    prefix: "xmlns",
    name: "xlink",
    namespace: html_js_12.NS.XMLNS
  }]]);
  exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map((tn) => [tn.toLowerCase(), tn]));
  const EXITS_FOREIGN_CONTENT = /* @__PURE__ */ new Set([html_js_12.TAG_ID.B, html_js_12.TAG_ID.BIG, html_js_12.TAG_ID.BLOCKQUOTE, html_js_12.TAG_ID.BODY, html_js_12.TAG_ID.BR, html_js_12.TAG_ID.CENTER, html_js_12.TAG_ID.CODE, html_js_12.TAG_ID.DD, html_js_12.TAG_ID.DIV, html_js_12.TAG_ID.DL, html_js_12.TAG_ID.DT, html_js_12.TAG_ID.EM, html_js_12.TAG_ID.EMBED, html_js_12.TAG_ID.H1, html_js_12.TAG_ID.H2, html_js_12.TAG_ID.H3, html_js_12.TAG_ID.H4, html_js_12.TAG_ID.H5, html_js_12.TAG_ID.H6, html_js_12.TAG_ID.HEAD, html_js_12.TAG_ID.HR, html_js_12.TAG_ID.I, html_js_12.TAG_ID.IMG, html_js_12.TAG_ID.LI, html_js_12.TAG_ID.LISTING, html_js_12.TAG_ID.MENU, html_js_12.TAG_ID.META, html_js_12.TAG_ID.NOBR, html_js_12.TAG_ID.OL, html_js_12.TAG_ID.P, html_js_12.TAG_ID.PRE, html_js_12.TAG_ID.RUBY, html_js_12.TAG_ID.S, html_js_12.TAG_ID.SMALL, html_js_12.TAG_ID.SPAN, html_js_12.TAG_ID.STRONG, html_js_12.TAG_ID.STRIKE, html_js_12.TAG_ID.SUB, html_js_12.TAG_ID.SUP, html_js_12.TAG_ID.TABLE, html_js_12.TAG_ID.TT, html_js_12.TAG_ID.U, html_js_12.TAG_ID.UL, html_js_12.TAG_ID.VAR]);
  function causesExit(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === html_js_12.TAG_ID.FONT && startTagToken.attrs.some(({
      name
    }) => name === html_js_12.ATTRS.COLOR || name === html_js_12.ATTRS.SIZE || name === html_js_12.ATTRS.FACE);
    return isFontWithAttrs || EXITS_FOREIGN_CONTENT.has(tn);
  }
  exports2.causesExit = causesExit;
  function adjustTokenMathMLAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      if (token2.attrs[i].name === DEFINITION_URL_ATTR) {
        token2.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
        break;
      }
    }
  }
  exports2.adjustTokenMathMLAttrs = adjustTokenMathMLAttrs;
  function adjustTokenSVGAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP.get(token2.attrs[i].name);
      if (adjustedAttrName != null) {
        token2.attrs[i].name = adjustedAttrName;
      }
    }
  }
  exports2.adjustTokenSVGAttrs = adjustTokenSVGAttrs;
  function adjustTokenXMLAttrs(token2) {
    for (let i = 0; i < token2.attrs.length; i++) {
      const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP.get(token2.attrs[i].name);
      if (adjustedAttrEntry) {
        token2.attrs[i].prefix = adjustedAttrEntry.prefix;
        token2.attrs[i].name = adjustedAttrEntry.name;
        token2.attrs[i].namespace = adjustedAttrEntry.namespace;
      }
    }
  }
  exports2.adjustTokenXMLAttrs = adjustTokenXMLAttrs;
  function adjustTokenSVGTagName(token2) {
    const adjustedTagName = exports2.SVG_TAG_NAMES_ADJUSTMENT_MAP.get(token2.tagName);
    if (adjustedTagName != null) {
      token2.tagName = adjustedTagName;
      token2.tagID = (0, html_js_12.getTagID)(token2.tagName);
    }
  }
  exports2.adjustTokenSVGTagName = adjustTokenSVGTagName;
  function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === html_js_12.NS.MATHML && (tn === html_js_12.TAG_ID.MI || tn === html_js_12.TAG_ID.MO || tn === html_js_12.TAG_ID.MN || tn === html_js_12.TAG_ID.MS || tn === html_js_12.TAG_ID.MTEXT);
  }
  function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === html_js_12.NS.MATHML && tn === html_js_12.TAG_ID.ANNOTATION_XML) {
      for (let i = 0; i < attrs.length; i++) {
        if (attrs[i].name === html_js_12.ATTRS.ENCODING) {
          const value2 = attrs[i].value.toLowerCase();
          return value2 === MIME_TYPES.TEXT_HTML || value2 === MIME_TYPES.APPLICATION_XML;
        }
      }
    }
    return ns === html_js_12.NS.SVG && (tn === html_js_12.TAG_ID.FOREIGN_OBJECT || tn === html_js_12.TAG_ID.DESC || tn === html_js_12.TAG_ID.TITLE);
  }
  function isIntegrationPoint(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === html_js_12.NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === html_js_12.NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns);
  }
  exports2.isIntegrationPoint = isIntegrationPoint;
})(foreignContent$1);
function _classCallCheck$1B(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1p(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1p(descriptor.key), descriptor);
  }
}
function _createClass$1z(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1p(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1p(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1p(arg) {
  var key = _toPrimitive$1p(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1p(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
Object.defineProperty(parser$1, "__esModule", {
  value: true
});
parser$1.Parser = void 0;
const index_js_1 = tokenizer;
const open_element_stack_js_1 = openElementStack;
const formatting_element_list_js_1 = formattingElementList;
const default_js_1$1 = _default$4;
const doctype = doctype$1;
const foreignContent = foreignContent$1;
const error_codes_js_1 = errorCodes;
const unicode = unicode$1;
const html_js_1$1 = html$1;
const token_js_1 = token;
const HIDDEN_INPUT_TYPE = "hidden";
const AA_OUTER_LOOP_ITER = 8;
const AA_INNER_LOOP_ITER = 3;
var InsertionMode;
(function(InsertionMode2) {
  InsertionMode2[InsertionMode2["INITIAL"] = 0] = "INITIAL";
  InsertionMode2[InsertionMode2["BEFORE_HTML"] = 1] = "BEFORE_HTML";
  InsertionMode2[InsertionMode2["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
  InsertionMode2[InsertionMode2["IN_HEAD"] = 3] = "IN_HEAD";
  InsertionMode2[InsertionMode2["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
  InsertionMode2[InsertionMode2["AFTER_HEAD"] = 5] = "AFTER_HEAD";
  InsertionMode2[InsertionMode2["IN_BODY"] = 6] = "IN_BODY";
  InsertionMode2[InsertionMode2["TEXT"] = 7] = "TEXT";
  InsertionMode2[InsertionMode2["IN_TABLE"] = 8] = "IN_TABLE";
  InsertionMode2[InsertionMode2["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
  InsertionMode2[InsertionMode2["IN_CAPTION"] = 10] = "IN_CAPTION";
  InsertionMode2[InsertionMode2["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
  InsertionMode2[InsertionMode2["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
  InsertionMode2[InsertionMode2["IN_ROW"] = 13] = "IN_ROW";
  InsertionMode2[InsertionMode2["IN_CELL"] = 14] = "IN_CELL";
  InsertionMode2[InsertionMode2["IN_SELECT"] = 15] = "IN_SELECT";
  InsertionMode2[InsertionMode2["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
  InsertionMode2[InsertionMode2["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
  InsertionMode2[InsertionMode2["AFTER_BODY"] = 18] = "AFTER_BODY";
  InsertionMode2[InsertionMode2["IN_FRAMESET"] = 19] = "IN_FRAMESET";
  InsertionMode2[InsertionMode2["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
  InsertionMode2[InsertionMode2["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
  InsertionMode2[InsertionMode2["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode || (InsertionMode = {}));
const BASE_LOC = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
};
const TABLE_STRUCTURE_TAGS = /* @__PURE__ */ new Set([html_js_1$1.TAG_ID.TABLE, html_js_1$1.TAG_ID.TBODY, html_js_1$1.TAG_ID.TFOOT, html_js_1$1.TAG_ID.THEAD, html_js_1$1.TAG_ID.TR]);
const defaultParserOptions = {
  scriptingEnabled: true,
  sourceCodeLocationInfo: false,
  treeAdapter: default_js_1$1.defaultTreeAdapter,
  onParseError: null
};
let Parser$2 = /* @__PURE__ */ function() {
  function Parser2(options2, document2, fragmentContext = null, scriptHandler = null) {
    _classCallCheck$1B(this, Parser2);
    this.fragmentContext = fragmentContext;
    this.scriptHandler = scriptHandler;
    this.currentToken = null;
    this.stopped = false;
    this.insertionMode = InsertionMode.INITIAL;
    this.originalInsertionMode = InsertionMode.INITIAL;
    this.headElement = null;
    this.formElement = null;
    this.currentNotInHTML = false;
    this.tmplInsertionModeStack = [];
    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;
    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
    this.options = Object.assign(Object.assign({}, defaultParserOptions), options2);
    this.treeAdapter = this.options.treeAdapter;
    this.onParseError = this.options.onParseError;
    if (this.onParseError) {
      this.options.sourceCodeLocationInfo = true;
    }
    this.document = document2 !== null && document2 !== void 0 ? document2 : this.treeAdapter.createDocument();
    this.tokenizer = new index_js_1.Tokenizer(this.options, this);
    this.activeFormattingElements = new formatting_element_list_js_1.FormattingElementList(this.treeAdapter);
    this.fragmentContextID = fragmentContext ? (0, html_js_1$1.getTagID)(this.treeAdapter.getTagName(fragmentContext)) : html_js_1$1.TAG_ID.UNKNOWN;
    this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
    this.openElements = new open_element_stack_js_1.OpenElementStack(this.document, this.treeAdapter, this);
  }
  _createClass$1z(Parser2, [{
    key: "getFragment",
    value: function getFragment() {
      const rootElement = this.treeAdapter.getFirstChild(this.document);
      const fragment = this.treeAdapter.createDocumentFragment();
      this._adoptNodes(rootElement, fragment);
      return fragment;
    }
    //Errors
  }, {
    key: "_err",
    value: function _err(token2, code2, beforeToken) {
      var _a;
      if (!this.onParseError)
        return;
      const loc = (_a = token2.location) !== null && _a !== void 0 ? _a : BASE_LOC;
      const err2 = {
        code: code2,
        startLine: loc.startLine,
        startCol: loc.startCol,
        startOffset: loc.startOffset,
        endLine: beforeToken ? loc.startLine : loc.endLine,
        endCol: beforeToken ? loc.startCol : loc.endCol,
        endOffset: beforeToken ? loc.startOffset : loc.endOffset
      };
      this.onParseError(err2);
    }
    //Stack events
  }, {
    key: "onItemPush",
    value: function onItemPush(node2, tid, isTop) {
      var _a, _b;
      (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 ? void 0 : _b.call(_a, node2);
      if (isTop && this.openElements.stackTop > 0)
        this._setContextModes(node2, tid);
    }
  }, {
    key: "onItemPop",
    value: function onItemPop(node2, isTop) {
      var _a, _b;
      if (this.options.sourceCodeLocationInfo) {
        this._setEndLocation(node2, this.currentToken);
      }
      (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 ? void 0 : _b.call(_a, node2, this.openElements.current);
      if (isTop) {
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
          current = this.fragmentContext;
          currentTagId = this.fragmentContextID;
        } else {
          ({
            current,
            currentTagId
          } = this.openElements);
        }
        this._setContextModes(current, currentTagId);
      }
    }
  }, {
    key: "_setContextModes",
    value: function _setContextModes(current, tid) {
      const isHTML = current === this.document || this.treeAdapter.getNamespaceURI(current) === html_js_1$1.NS.HTML;
      this.currentNotInHTML = !isHTML;
      this.tokenizer.inForeignNode = !isHTML && !this._isIntegrationPoint(tid, current);
    }
  }, {
    key: "_switchToTextParsing",
    value: function _switchToTextParsing(currentToken, nextTokenizerState) {
      this._insertElement(currentToken, html_js_1$1.NS.HTML);
      this.tokenizer.state = nextTokenizerState;
      this.originalInsertionMode = this.insertionMode;
      this.insertionMode = InsertionMode.TEXT;
    }
  }, {
    key: "switchToPlaintextParsing",
    value: function switchToPlaintextParsing() {
      this.insertionMode = InsertionMode.TEXT;
      this.originalInsertionMode = InsertionMode.IN_BODY;
      this.tokenizer.state = index_js_1.TokenizerMode.PLAINTEXT;
    }
    //Fragment parsing
  }, {
    key: "_getAdjustedCurrentElement",
    value: function _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
  }, {
    key: "_findFormInFragmentContext",
    value: function _findFormInFragmentContext() {
      let node2 = this.fragmentContext;
      while (node2) {
        if (this.treeAdapter.getTagName(node2) === html_js_1$1.TAG_NAMES.FORM) {
          this.formElement = node2;
          break;
        }
        node2 = this.treeAdapter.getParentNode(node2);
      }
    }
  }, {
    key: "_initTokenizerForFragmentParsing",
    value: function _initTokenizerForFragmentParsing() {
      if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== html_js_1$1.NS.HTML) {
        return;
      }
      switch (this.fragmentContextID) {
        case html_js_1$1.TAG_ID.TITLE:
        case html_js_1$1.TAG_ID.TEXTAREA: {
          this.tokenizer.state = index_js_1.TokenizerMode.RCDATA;
          break;
        }
        case html_js_1$1.TAG_ID.STYLE:
        case html_js_1$1.TAG_ID.XMP:
        case html_js_1$1.TAG_ID.IFRAME:
        case html_js_1$1.TAG_ID.NOEMBED:
        case html_js_1$1.TAG_ID.NOFRAMES:
        case html_js_1$1.TAG_ID.NOSCRIPT: {
          this.tokenizer.state = index_js_1.TokenizerMode.RAWTEXT;
          break;
        }
        case html_js_1$1.TAG_ID.SCRIPT: {
          this.tokenizer.state = index_js_1.TokenizerMode.SCRIPT_DATA;
          break;
        }
        case html_js_1$1.TAG_ID.PLAINTEXT: {
          this.tokenizer.state = index_js_1.TokenizerMode.PLAINTEXT;
          break;
        }
      }
    }
    //Tree mutation
  }, {
    key: "_setDocumentType",
    value: function _setDocumentType(token2) {
      const name = token2.name || "";
      const publicId = token2.publicId || "";
      const systemId = token2.systemId || "";
      this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
      if (token2.location) {
        const documentChildren = this.treeAdapter.getChildNodes(this.document);
        const docTypeNode = documentChildren.find((node2) => this.treeAdapter.isDocumentTypeNode(node2));
        if (docTypeNode) {
          this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token2.location);
        }
      }
    }
  }, {
    key: "_attachElementToTree",
    value: function _attachElementToTree(element, location) {
      if (this.options.sourceCodeLocationInfo) {
        const loc = location && Object.assign(Object.assign({}, location), {
          startTag: location
        });
        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
      }
      if (this._shouldFosterParentOnInsertion()) {
        this._fosterParentElement(element);
      } else {
        const parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.appendChild(parent, element);
      }
    }
  }, {
    key: "_appendElement",
    value: function _appendElement(token2, namespaceURI) {
      const element = this.treeAdapter.createElement(token2.tagName, namespaceURI, token2.attrs);
      this._attachElementToTree(element, token2.location);
    }
  }, {
    key: "_insertElement",
    value: function _insertElement(token2, namespaceURI) {
      const element = this.treeAdapter.createElement(token2.tagName, namespaceURI, token2.attrs);
      this._attachElementToTree(element, token2.location);
      this.openElements.push(element, token2.tagID);
    }
  }, {
    key: "_insertFakeElement",
    value: function _insertFakeElement(tagName, tagID) {
      const element = this.treeAdapter.createElement(tagName, html_js_1$1.NS.HTML, []);
      this._attachElementToTree(element, null);
      this.openElements.push(element, tagID);
    }
  }, {
    key: "_insertTemplate",
    value: function _insertTemplate(token2) {
      const tmpl = this.treeAdapter.createElement(token2.tagName, html_js_1$1.NS.HTML, token2.attrs);
      const content = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(tmpl, content);
      this._attachElementToTree(tmpl, token2.location);
      this.openElements.push(tmpl, token2.tagID);
      if (this.options.sourceCodeLocationInfo)
        this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
  }, {
    key: "_insertFakeRootElement",
    value: function _insertFakeRootElement() {
      const element = this.treeAdapter.createElement(html_js_1$1.TAG_NAMES.HTML, html_js_1$1.NS.HTML, []);
      if (this.options.sourceCodeLocationInfo)
        this.treeAdapter.setNodeSourceCodeLocation(element, null);
      this.treeAdapter.appendChild(this.openElements.current, element);
      this.openElements.push(element, html_js_1$1.TAG_ID.HTML);
    }
  }, {
    key: "_appendCommentNode",
    value: function _appendCommentNode(token2, parent) {
      const commentNode = this.treeAdapter.createCommentNode(token2.data);
      this.treeAdapter.appendChild(parent, commentNode);
      if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(commentNode, token2.location);
      }
    }
  }, {
    key: "_insertCharacters",
    value: function _insertCharacters(token2) {
      let parent;
      let beforeElement;
      if (this._shouldFosterParentOnInsertion()) {
        ({
          parent,
          beforeElement
        } = this._findFosterParentingLocation());
        if (beforeElement) {
          this.treeAdapter.insertTextBefore(parent, token2.chars, beforeElement);
        } else {
          this.treeAdapter.insertText(parent, token2.chars);
        }
      } else {
        parent = this.openElements.currentTmplContentOrNode;
        this.treeAdapter.insertText(parent, token2.chars);
      }
      if (!token2.location)
        return;
      const siblings = this.treeAdapter.getChildNodes(parent);
      const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
      const textNode = siblings[textNodeIdx - 1];
      const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
      if (tnLoc) {
        const {
          endLine,
          endCol,
          endOffset
        } = token2.location;
        this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
          endLine,
          endCol,
          endOffset
        });
      } else if (this.options.sourceCodeLocationInfo) {
        this.treeAdapter.setNodeSourceCodeLocation(textNode, token2.location);
      }
    }
  }, {
    key: "_adoptNodes",
    value: function _adoptNodes(donor, recipient) {
      for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
      }
    }
  }, {
    key: "_setEndLocation",
    value: function _setEndLocation(element, closingToken) {
      if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
        const ctLoc = closingToken.location;
        const tn = this.treeAdapter.getTagName(element);
        const endLoc = (
          // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
          // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
          closingToken.type === token_js_1.TokenType.END_TAG && tn === closingToken.tagName ? {
            endTag: Object.assign({}, ctLoc),
            endLine: ctLoc.endLine,
            endCol: ctLoc.endCol,
            endOffset: ctLoc.endOffset
          } : {
            endLine: ctLoc.startLine,
            endCol: ctLoc.startCol,
            endOffset: ctLoc.startOffset
          }
        );
        this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
      }
    }
    //Token processing
  }, {
    key: "shouldProcessStartTagTokenInForeignContent",
    value: function shouldProcessStartTagTokenInForeignContent(token2) {
      if (!this.currentNotInHTML)
        return false;
      let current;
      let currentTagId;
      if (this.openElements.stackTop === 0 && this.fragmentContext) {
        current = this.fragmentContext;
        currentTagId = this.fragmentContextID;
      } else {
        ({
          current,
          currentTagId
        } = this.openElements);
      }
      if (token2.tagID === html_js_1$1.TAG_ID.SVG && this.treeAdapter.getTagName(current) === html_js_1$1.TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === html_js_1$1.NS.MATHML) {
        return false;
      }
      return (
        // Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token2.tagID === html_js_1$1.TAG_ID.MGLYPH || token2.tagID === html_js_1$1.TAG_ID.MALIGNMARK) && !this._isIntegrationPoint(currentTagId, current, html_js_1$1.NS.HTML)
      );
    }
  }, {
    key: "_processToken",
    value: function _processToken(token2) {
      switch (token2.type) {
        case token_js_1.TokenType.CHARACTER: {
          this.onCharacter(token2);
          break;
        }
        case token_js_1.TokenType.NULL_CHARACTER: {
          this.onNullCharacter(token2);
          break;
        }
        case token_js_1.TokenType.COMMENT: {
          this.onComment(token2);
          break;
        }
        case token_js_1.TokenType.DOCTYPE: {
          this.onDoctype(token2);
          break;
        }
        case token_js_1.TokenType.START_TAG: {
          this._processStartTag(token2);
          break;
        }
        case token_js_1.TokenType.END_TAG: {
          this.onEndTag(token2);
          break;
        }
        case token_js_1.TokenType.EOF: {
          this.onEof(token2);
          break;
        }
        case token_js_1.TokenType.WHITESPACE_CHARACTER: {
          this.onWhitespaceCharacter(token2);
          break;
        }
      }
    }
    //Integration points
  }, {
    key: "_isIntegrationPoint",
    value: function _isIntegrationPoint(tid, element, foreignNS) {
      const ns = this.treeAdapter.getNamespaceURI(element);
      const attrs = this.treeAdapter.getAttrList(element);
      return foreignContent.isIntegrationPoint(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
  }, {
    key: "_reconstructActiveFormattingElements",
    value: function _reconstructActiveFormattingElements() {
      const listLength = this.activeFormattingElements.entries.length;
      if (listLength) {
        const endIndex = this.activeFormattingElements.entries.findIndex((entry) => entry.type === formatting_element_list_js_1.EntryType.Marker || this.openElements.contains(entry.element));
        const unopenIdx = endIndex < 0 ? listLength - 1 : endIndex - 1;
        for (let i = unopenIdx; i >= 0; i--) {
          const entry = this.activeFormattingElements.entries[i];
          this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
          entry.element = this.openElements.current;
        }
      }
    }
    //Close elements
  }, {
    key: "_closeTableCell",
    value: function _closeTableCell() {
      this.openElements.generateImpliedEndTags();
      this.openElements.popUntilTableCellPopped();
      this.activeFormattingElements.clearToLastMarker();
      this.insertionMode = InsertionMode.IN_ROW;
    }
  }, {
    key: "_closePElement",
    value: function _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion(html_js_1$1.TAG_ID.P);
      this.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.P);
    }
    //Insertion modes
  }, {
    key: "_resetInsertionMode",
    value: function _resetInsertionMode() {
      for (let i = this.openElements.stackTop; i >= 0; i--) {
        switch (i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]) {
          case html_js_1$1.TAG_ID.TR: {
            this.insertionMode = InsertionMode.IN_ROW;
            return;
          }
          case html_js_1$1.TAG_ID.TBODY:
          case html_js_1$1.TAG_ID.THEAD:
          case html_js_1$1.TAG_ID.TFOOT: {
            this.insertionMode = InsertionMode.IN_TABLE_BODY;
            return;
          }
          case html_js_1$1.TAG_ID.CAPTION: {
            this.insertionMode = InsertionMode.IN_CAPTION;
            return;
          }
          case html_js_1$1.TAG_ID.COLGROUP: {
            this.insertionMode = InsertionMode.IN_COLUMN_GROUP;
            return;
          }
          case html_js_1$1.TAG_ID.TABLE: {
            this.insertionMode = InsertionMode.IN_TABLE;
            return;
          }
          case html_js_1$1.TAG_ID.BODY: {
            this.insertionMode = InsertionMode.IN_BODY;
            return;
          }
          case html_js_1$1.TAG_ID.FRAMESET: {
            this.insertionMode = InsertionMode.IN_FRAMESET;
            return;
          }
          case html_js_1$1.TAG_ID.SELECT: {
            this._resetInsertionModeForSelect(i);
            return;
          }
          case html_js_1$1.TAG_ID.TEMPLATE: {
            this.insertionMode = this.tmplInsertionModeStack[0];
            return;
          }
          case html_js_1$1.TAG_ID.HTML: {
            this.insertionMode = this.headElement ? InsertionMode.AFTER_HEAD : InsertionMode.BEFORE_HEAD;
            return;
          }
          case html_js_1$1.TAG_ID.TD:
          case html_js_1$1.TAG_ID.TH: {
            if (i > 0) {
              this.insertionMode = InsertionMode.IN_CELL;
              return;
            }
            break;
          }
          case html_js_1$1.TAG_ID.HEAD: {
            if (i > 0) {
              this.insertionMode = InsertionMode.IN_HEAD;
              return;
            }
            break;
          }
        }
      }
      this.insertionMode = InsertionMode.IN_BODY;
    }
  }, {
    key: "_resetInsertionModeForSelect",
    value: function _resetInsertionModeForSelect(selectIdx) {
      if (selectIdx > 0) {
        for (let i = selectIdx - 1; i > 0; i--) {
          const tn = this.openElements.tagIDs[i];
          if (tn === html_js_1$1.TAG_ID.TEMPLATE) {
            break;
          } else if (tn === html_js_1$1.TAG_ID.TABLE) {
            this.insertionMode = InsertionMode.IN_SELECT_IN_TABLE;
            return;
          }
        }
      }
      this.insertionMode = InsertionMode.IN_SELECT;
    }
    //Foster parenting
  }, {
    key: "_isElementCausesFosterParenting",
    value: function _isElementCausesFosterParenting(tn) {
      return TABLE_STRUCTURE_TAGS.has(tn);
    }
  }, {
    key: "_shouldFosterParentOnInsertion",
    value: function _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
  }, {
    key: "_findFosterParentingLocation",
    value: function _findFosterParentingLocation() {
      for (let i = this.openElements.stackTop; i >= 0; i--) {
        const openElement = this.openElements.items[i];
        switch (this.openElements.tagIDs[i]) {
          case html_js_1$1.TAG_ID.TEMPLATE: {
            if (this.treeAdapter.getNamespaceURI(openElement) === html_js_1$1.NS.HTML) {
              return {
                parent: this.treeAdapter.getTemplateContent(openElement),
                beforeElement: null
              };
            }
            break;
          }
          case html_js_1$1.TAG_ID.TABLE: {
            const parent = this.treeAdapter.getParentNode(openElement);
            if (parent) {
              return {
                parent,
                beforeElement: openElement
              };
            }
            return {
              parent: this.openElements.items[i - 1],
              beforeElement: null
            };
          }
        }
      }
      return {
        parent: this.openElements.items[0],
        beforeElement: null
      };
    }
  }, {
    key: "_fosterParentElement",
    value: function _fosterParentElement(element) {
      const location = this._findFosterParentingLocation();
      if (location.beforeElement) {
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
      } else {
        this.treeAdapter.appendChild(location.parent, element);
      }
    }
    //Special elements
  }, {
    key: "_isSpecialElement",
    value: function _isSpecialElement(element, id2) {
      const ns = this.treeAdapter.getNamespaceURI(element);
      return html_js_1$1.SPECIAL_ELEMENTS[ns].has(id2);
    }
  }, {
    key: "onCharacter",
    value: function onCharacter(token2) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        characterInForeignContent(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          tokenInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HTML: {
          tokenBeforeHtml(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD: {
          tokenBeforeHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD: {
          tokenInHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript(this, token2);
          break;
        }
        case InsertionMode.AFTER_HEAD: {
          tokenAfterHead(this, token2);
          break;
        }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_TEMPLATE: {
          characterInBody(this, token2);
          break;
        }
        case InsertionMode.TEXT:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW: {
          characterInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          characterInTableText(this, token2);
          break;
        }
        case InsertionMode.IN_COLUMN_GROUP: {
          tokenInColumnGroup(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY: {
          tokenAfterBody(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_BODY: {
          tokenAfterAfterBody(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onNullCharacter",
    value: function onNullCharacter(token2) {
      this.skipNextNewLine = false;
      if (this.tokenizer.inForeignNode) {
        nullCharacterInForeignContent(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          tokenInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HTML: {
          tokenBeforeHtml(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD: {
          tokenBeforeHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD: {
          tokenInHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript(this, token2);
          break;
        }
        case InsertionMode.AFTER_HEAD: {
          tokenAfterHead(this, token2);
          break;
        }
        case InsertionMode.TEXT: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW: {
          characterInTable(this, token2);
          break;
        }
        case InsertionMode.IN_COLUMN_GROUP: {
          tokenInColumnGroup(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY: {
          tokenAfterBody(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_BODY: {
          tokenAfterAfterBody(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onComment",
    value: function onComment(token2) {
      this.skipNextNewLine = false;
      if (this.currentNotInHTML) {
        appendComment(this, token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.INITIAL:
        case InsertionMode.BEFORE_HTML:
        case InsertionMode.BEFORE_HEAD:
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD:
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
        case InsertionMode.IN_TEMPLATE:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET: {
          appendComment(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          tokenInTableText(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY: {
          appendCommentToRootHtmlElement(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET: {
          appendCommentToDocument(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onDoctype",
    value: function onDoctype(token2) {
      this.skipNextNewLine = false;
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          doctypeInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD:
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD: {
          this._err(token2, error_codes_js_1.ERR.misplacedDoctype);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          tokenInTableText(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onStartTag",
    value: function onStartTag(token2) {
      this.skipNextNewLine = false;
      this.currentToken = token2;
      this._processStartTag(token2);
      if (token2.selfClosing && !token2.ackSelfClosing) {
        this._err(token2, error_codes_js_1.ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
      }
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     */
  }, {
    key: "_processStartTag",
    value: function _processStartTag(token2) {
      if (this.shouldProcessStartTagTokenInForeignContent(token2)) {
        startTagInForeignContent(this, token2);
      } else {
        this._startTagOutsideForeignContent(token2);
      }
    }
  }, {
    key: "_startTagOutsideForeignContent",
    value: function _startTagOutsideForeignContent(token2) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          tokenInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HTML: {
          startTagBeforeHtml(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD: {
          startTagBeforeHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD: {
          startTagInHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD_NO_SCRIPT: {
          startTagInHeadNoScript(this, token2);
          break;
        }
        case InsertionMode.AFTER_HEAD: {
          startTagAfterHead(this, token2);
          break;
        }
        case InsertionMode.IN_BODY: {
          startTagInBody(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE: {
          startTagInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          tokenInTableText(this, token2);
          break;
        }
        case InsertionMode.IN_CAPTION: {
          startTagInCaption(this, token2);
          break;
        }
        case InsertionMode.IN_COLUMN_GROUP: {
          startTagInColumnGroup(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_BODY: {
          startTagInTableBody(this, token2);
          break;
        }
        case InsertionMode.IN_ROW: {
          startTagInRow(this, token2);
          break;
        }
        case InsertionMode.IN_CELL: {
          startTagInCell(this, token2);
          break;
        }
        case InsertionMode.IN_SELECT: {
          startTagInSelect(this, token2);
          break;
        }
        case InsertionMode.IN_SELECT_IN_TABLE: {
          startTagInSelectInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TEMPLATE: {
          startTagInTemplate(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY: {
          startTagAfterBody(this, token2);
          break;
        }
        case InsertionMode.IN_FRAMESET: {
          startTagInFrameset(this, token2);
          break;
        }
        case InsertionMode.AFTER_FRAMESET: {
          startTagAfterFrameset(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_BODY: {
          startTagAfterAfterBody(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_FRAMESET: {
          startTagAfterAfterFrameset(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onEndTag",
    value: function onEndTag(token2) {
      this.skipNextNewLine = false;
      this.currentToken = token2;
      if (this.currentNotInHTML) {
        endTagInForeignContent(this, token2);
      } else {
        this._endTagOutsideForeignContent(token2);
      }
    }
  }, {
    key: "_endTagOutsideForeignContent",
    value: function _endTagOutsideForeignContent(token2) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          tokenInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HTML: {
          endTagBeforeHtml(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD: {
          endTagBeforeHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD: {
          endTagInHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD_NO_SCRIPT: {
          endTagInHeadNoScript(this, token2);
          break;
        }
        case InsertionMode.AFTER_HEAD: {
          endTagAfterHead(this, token2);
          break;
        }
        case InsertionMode.IN_BODY: {
          endTagInBody(this, token2);
          break;
        }
        case InsertionMode.TEXT: {
          endTagInText(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE: {
          endTagInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          tokenInTableText(this, token2);
          break;
        }
        case InsertionMode.IN_CAPTION: {
          endTagInCaption(this, token2);
          break;
        }
        case InsertionMode.IN_COLUMN_GROUP: {
          endTagInColumnGroup(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_BODY: {
          endTagInTableBody(this, token2);
          break;
        }
        case InsertionMode.IN_ROW: {
          endTagInRow(this, token2);
          break;
        }
        case InsertionMode.IN_CELL: {
          endTagInCell(this, token2);
          break;
        }
        case InsertionMode.IN_SELECT: {
          endTagInSelect(this, token2);
          break;
        }
        case InsertionMode.IN_SELECT_IN_TABLE: {
          endTagInSelectInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TEMPLATE: {
          endTagInTemplate(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY: {
          endTagAfterBody(this, token2);
          break;
        }
        case InsertionMode.IN_FRAMESET: {
          endTagInFrameset(this, token2);
          break;
        }
        case InsertionMode.AFTER_FRAMESET: {
          endTagAfterFrameset(this, token2);
          break;
        }
        case InsertionMode.AFTER_AFTER_BODY: {
          tokenAfterAfterBody(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onEof",
    value: function onEof(token2) {
      switch (this.insertionMode) {
        case InsertionMode.INITIAL: {
          tokenInInitialMode(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HTML: {
          tokenBeforeHtml(this, token2);
          break;
        }
        case InsertionMode.BEFORE_HEAD: {
          tokenBeforeHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD: {
          tokenInHead(this, token2);
          break;
        }
        case InsertionMode.IN_HEAD_NO_SCRIPT: {
          tokenInHeadNoScript(this, token2);
          break;
        }
        case InsertionMode.AFTER_HEAD: {
          tokenAfterHead(this, token2);
          break;
        }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE: {
          eofInBody(this, token2);
          break;
        }
        case InsertionMode.TEXT: {
          eofInText(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          tokenInTableText(this, token2);
          break;
        }
        case InsertionMode.IN_TEMPLATE: {
          eofInTemplate(this, token2);
          break;
        }
        case InsertionMode.AFTER_BODY:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET:
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET: {
          stopParsing(this, token2);
          break;
        }
      }
    }
  }, {
    key: "onWhitespaceCharacter",
    value: function onWhitespaceCharacter(token2) {
      if (this.skipNextNewLine) {
        this.skipNextNewLine = false;
        if (token2.chars.charCodeAt(0) === unicode.CODE_POINTS.LINE_FEED) {
          if (token2.chars.length === 1) {
            return;
          }
          token2.chars = token2.chars.substr(1);
        }
      }
      if (this.tokenizer.inForeignNode) {
        this._insertCharacters(token2);
        return;
      }
      switch (this.insertionMode) {
        case InsertionMode.IN_HEAD:
        case InsertionMode.IN_HEAD_NO_SCRIPT:
        case InsertionMode.AFTER_HEAD:
        case InsertionMode.TEXT:
        case InsertionMode.IN_COLUMN_GROUP:
        case InsertionMode.IN_SELECT:
        case InsertionMode.IN_SELECT_IN_TABLE:
        case InsertionMode.IN_FRAMESET:
        case InsertionMode.AFTER_FRAMESET: {
          this._insertCharacters(token2);
          break;
        }
        case InsertionMode.IN_BODY:
        case InsertionMode.IN_CAPTION:
        case InsertionMode.IN_CELL:
        case InsertionMode.IN_TEMPLATE:
        case InsertionMode.AFTER_BODY:
        case InsertionMode.AFTER_AFTER_BODY:
        case InsertionMode.AFTER_AFTER_FRAMESET: {
          whitespaceCharacterInBody(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE:
        case InsertionMode.IN_TABLE_BODY:
        case InsertionMode.IN_ROW: {
          characterInTable(this, token2);
          break;
        }
        case InsertionMode.IN_TABLE_TEXT: {
          whitespaceCharacterInTableText(this, token2);
          break;
        }
      }
    }
  }], [{
    key: "parse",
    value: function parse2(html2, options2) {
      const parser2 = new this(options2);
      parser2.tokenizer.write(html2, true);
      return parser2.document;
    }
  }, {
    key: "getFragmentParser",
    value: function getFragmentParser(fragmentContext, options2) {
      const opts = Object.assign(Object.assign({}, defaultParserOptions), options2);
      fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement(html_js_1$1.TAG_NAMES.TEMPLATE, html_js_1$1.NS.HTML, []);
      const documentMock = opts.treeAdapter.createElement("documentmock", html_js_1$1.NS.HTML, []);
      const parser2 = new this(opts, documentMock, fragmentContext);
      if (parser2.fragmentContextID === html_js_1$1.TAG_ID.TEMPLATE) {
        parser2.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
      }
      parser2._initTokenizerForFragmentParsing();
      parser2._insertFakeRootElement();
      parser2._resetInsertionMode();
      parser2._findFormInFragmentContext();
      return parser2;
    }
  }]);
  return Parser2;
}();
parser$1.Parser = Parser$2;
function aaObtainFormattingElementEntry(p, token2) {
  let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token2.tagName);
  if (formattingElementEntry) {
    if (!p.openElements.contains(formattingElementEntry.element)) {
      p.activeFormattingElements.removeEntry(formattingElementEntry);
      formattingElementEntry = null;
    } else if (!p.openElements.hasInScope(token2.tagID)) {
      formattingElementEntry = null;
    }
  } else {
    genericEndTagInBody(p, token2);
  }
  return formattingElementEntry;
}
function aaObtainFurthestBlock(p, formattingElementEntry) {
  let furthestBlock = null;
  let idx = p.openElements.stackTop;
  for (; idx >= 0; idx--) {
    const element = p.openElements.items[idx];
    if (element === formattingElementEntry.element) {
      break;
    }
    if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) {
      furthestBlock = element;
    }
  }
  if (!furthestBlock) {
    p.openElements.shortenToLength(idx < 0 ? 0 : idx);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
  }
  return furthestBlock;
}
function aaInnerLoop(p, furthestBlock, formattingElement) {
  let lastElement = furthestBlock;
  let nextElement = p.openElements.getCommonAncestor(furthestBlock);
  for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
    nextElement = p.openElements.getCommonAncestor(element);
    const elementEntry = p.activeFormattingElements.getElementEntry(element);
    const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
    const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
    if (shouldRemoveFromOpenElements) {
      if (counterOverflow) {
        p.activeFormattingElements.removeEntry(elementEntry);
      }
      p.openElements.remove(element);
    } else {
      element = aaRecreateElementFromEntry(p, elementEntry);
      if (lastElement === furthestBlock) {
        p.activeFormattingElements.bookmark = elementEntry;
      }
      p.treeAdapter.detachNode(lastElement);
      p.treeAdapter.appendChild(element, lastElement);
      lastElement = element;
    }
  }
  return lastElement;
}
function aaRecreateElementFromEntry(p, elementEntry) {
  const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
  const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
  p.openElements.replace(elementEntry.element, newElement);
  elementEntry.element = newElement;
  return newElement;
}
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
  const tn = p.treeAdapter.getTagName(commonAncestor);
  const tid = (0, html_js_1$1.getTagID)(tn);
  if (p._isElementCausesFosterParenting(tid)) {
    p._fosterParentElement(lastElement);
  } else {
    const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
    if (tid === html_js_1$1.TAG_ID.TEMPLATE && ns === html_js_1$1.NS.HTML) {
      commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
    }
    p.treeAdapter.appendChild(commonAncestor, lastElement);
  }
}
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
  const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
  const {
    token: token2
  } = formattingElementEntry;
  const newElement = p.treeAdapter.createElement(token2.tagName, ns, token2.attrs);
  p._adoptNodes(furthestBlock, newElement);
  p.treeAdapter.appendChild(furthestBlock, newElement);
  p.activeFormattingElements.insertElementAfterBookmark(newElement, token2);
  p.activeFormattingElements.removeEntry(formattingElementEntry);
  p.openElements.remove(formattingElementEntry.element);
  p.openElements.insertAfter(furthestBlock, newElement, token2.tagID);
}
function callAdoptionAgency(p, token2) {
  for (let i = 0; i < AA_OUTER_LOOP_ITER; i++) {
    const formattingElementEntry = aaObtainFormattingElementEntry(p, token2);
    if (!formattingElementEntry) {
      break;
    }
    const furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
    if (!furthestBlock) {
      break;
    }
    p.activeFormattingElements.bookmark = formattingElementEntry;
    const lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
    const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
    p.treeAdapter.detachNode(lastElement);
    if (commonAncestor)
      aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
    aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
  }
}
function appendComment(p, token2) {
  p._appendCommentNode(token2, p.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement(p, token2) {
  p._appendCommentNode(token2, p.openElements.items[0]);
}
function appendCommentToDocument(p, token2) {
  p._appendCommentNode(token2, p.document);
}
function stopParsing(p, token2) {
  p.stopped = true;
  if (token2.location) {
    const target = p.fragmentContext ? 0 : 2;
    for (let i = p.openElements.stackTop; i >= target; i--) {
      p._setEndLocation(p.openElements.items[i], token2);
    }
    if (!p.fragmentContext && p.openElements.stackTop >= 0) {
      const htmlElement = p.openElements.items[0];
      const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
      if (htmlLocation && !htmlLocation.endTag) {
        p._setEndLocation(htmlElement, token2);
        if (p.openElements.stackTop >= 1) {
          const bodyElement = p.openElements.items[1];
          const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
          if (bodyLocation && !bodyLocation.endTag) {
            p._setEndLocation(bodyElement, token2);
          }
        }
      }
    }
  }
}
function doctypeInInitialMode(p, token2) {
  p._setDocumentType(token2);
  const mode = token2.forceQuirks ? html_js_1$1.DOCUMENT_MODE.QUIRKS : doctype.getDocumentMode(token2);
  if (!doctype.isConforming(token2)) {
    p._err(token2, error_codes_js_1.ERR.nonConformingDoctype);
  }
  p.treeAdapter.setDocumentMode(p.document, mode);
  p.insertionMode = InsertionMode.BEFORE_HTML;
}
function tokenInInitialMode(p, token2) {
  p._err(token2, error_codes_js_1.ERR.missingDoctype, true);
  p.treeAdapter.setDocumentMode(p.document, html_js_1$1.DOCUMENT_MODE.QUIRKS);
  p.insertionMode = InsertionMode.BEFORE_HTML;
  p._processToken(token2);
}
function startTagBeforeHtml(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.HTML) {
    p._insertElement(token2, html_js_1$1.NS.HTML);
    p.insertionMode = InsertionMode.BEFORE_HEAD;
  } else {
    tokenBeforeHtml(p, token2);
  }
}
function endTagBeforeHtml(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$1.TAG_ID.HTML || tn === html_js_1$1.TAG_ID.HEAD || tn === html_js_1$1.TAG_ID.BODY || tn === html_js_1$1.TAG_ID.BR) {
    tokenBeforeHtml(p, token2);
  }
}
function tokenBeforeHtml(p, token2) {
  p._insertFakeRootElement();
  p.insertionMode = InsertionMode.BEFORE_HEAD;
  p._processToken(token2);
}
function startTagBeforeHead(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.HEAD: {
      p._insertElement(token2, html_js_1$1.NS.HTML);
      p.headElement = p.openElements.current;
      p.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    default: {
      tokenBeforeHead(p, token2);
    }
  }
}
function endTagBeforeHead(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$1.TAG_ID.HEAD || tn === html_js_1$1.TAG_ID.BODY || tn === html_js_1$1.TAG_ID.HTML || tn === html_js_1$1.TAG_ID.BR) {
    tokenBeforeHead(p, token2);
  } else {
    p._err(token2, error_codes_js_1.ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenBeforeHead(p, token2) {
  p._insertFakeElement(html_js_1$1.TAG_NAMES.HEAD, html_js_1$1.TAG_ID.HEAD);
  p.headElement = p.openElements.current;
  p.insertionMode = InsertionMode.IN_HEAD;
  p._processToken(token2);
}
function startTagInHead(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BASE:
    case html_js_1$1.TAG_ID.BASEFONT:
    case html_js_1$1.TAG_ID.BGSOUND:
    case html_js_1$1.TAG_ID.LINK:
    case html_js_1$1.TAG_ID.META: {
      p._appendElement(token2, html_js_1$1.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$1.TAG_ID.TITLE: {
      p._switchToTextParsing(token2, index_js_1.TokenizerMode.RCDATA);
      break;
    }
    case html_js_1$1.TAG_ID.NOSCRIPT: {
      if (p.options.scriptingEnabled) {
        p._switchToTextParsing(token2, index_js_1.TokenizerMode.RAWTEXT);
      } else {
        p._insertElement(token2, html_js_1$1.NS.HTML);
        p.insertionMode = InsertionMode.IN_HEAD_NO_SCRIPT;
      }
      break;
    }
    case html_js_1$1.TAG_ID.NOFRAMES:
    case html_js_1$1.TAG_ID.STYLE: {
      p._switchToTextParsing(token2, index_js_1.TokenizerMode.RAWTEXT);
      break;
    }
    case html_js_1$1.TAG_ID.SCRIPT: {
      p._switchToTextParsing(token2, index_js_1.TokenizerMode.SCRIPT_DATA);
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      p._insertTemplate(token2);
      p.activeFormattingElements.insertMarker();
      p.framesetOk = false;
      p.insertionMode = InsertionMode.IN_TEMPLATE;
      p.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
      break;
    }
    case html_js_1$1.TAG_ID.HEAD: {
      p._err(token2, error_codes_js_1.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default: {
      tokenInHead(p, token2);
    }
  }
}
function endTagInHead(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HEAD: {
      p.openElements.pop();
      p.insertionMode = InsertionMode.AFTER_HEAD;
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.BR:
    case html_js_1$1.TAG_ID.HTML: {
      tokenInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function templateEndTagInHead(p, token2) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.generateImpliedEndTagsThoroughly();
    if (p.openElements.currentTagId !== html_js_1$1.TAG_ID.TEMPLATE) {
      p._err(token2, error_codes_js_1.ERR.closingOfElementWithOpenChildElements);
    }
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
  } else {
    p._err(token2, error_codes_js_1.ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHead(p, token2) {
  p.openElements.pop();
  p.insertionMode = InsertionMode.AFTER_HEAD;
  p._processToken(token2);
}
function startTagInHeadNoScript(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BASEFONT:
    case html_js_1$1.TAG_ID.BGSOUND:
    case html_js_1$1.TAG_ID.HEAD:
    case html_js_1$1.TAG_ID.LINK:
    case html_js_1$1.TAG_ID.META:
    case html_js_1$1.TAG_ID.NOFRAMES:
    case html_js_1$1.TAG_ID.STYLE: {
      startTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOSCRIPT: {
      p._err(token2, error_codes_js_1.ERR.nestedNoscriptInHead);
      break;
    }
    default: {
      tokenInHeadNoScript(p, token2);
    }
  }
}
function endTagInHeadNoScript(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.NOSCRIPT: {
      p.openElements.pop();
      p.insertionMode = InsertionMode.IN_HEAD;
      break;
    }
    case html_js_1$1.TAG_ID.BR: {
      tokenInHeadNoScript(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function tokenInHeadNoScript(p, token2) {
  const errCode = token2.type === token_js_1.TokenType.EOF ? error_codes_js_1.ERR.openElementsLeftAfterEof : error_codes_js_1.ERR.disallowedContentInNoscriptInHead;
  p._err(token2, errCode);
  p.openElements.pop();
  p.insertionMode = InsertionMode.IN_HEAD;
  p._processToken(token2);
}
function startTagAfterHead(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BODY: {
      p._insertElement(token2, html_js_1$1.NS.HTML);
      p.framesetOk = false;
      p.insertionMode = InsertionMode.IN_BODY;
      break;
    }
    case html_js_1$1.TAG_ID.FRAMESET: {
      p._insertElement(token2, html_js_1$1.NS.HTML);
      p.insertionMode = InsertionMode.IN_FRAMESET;
      break;
    }
    case html_js_1$1.TAG_ID.BASE:
    case html_js_1$1.TAG_ID.BASEFONT:
    case html_js_1$1.TAG_ID.BGSOUND:
    case html_js_1$1.TAG_ID.LINK:
    case html_js_1$1.TAG_ID.META:
    case html_js_1$1.TAG_ID.NOFRAMES:
    case html_js_1$1.TAG_ID.SCRIPT:
    case html_js_1$1.TAG_ID.STYLE:
    case html_js_1$1.TAG_ID.TEMPLATE:
    case html_js_1$1.TAG_ID.TITLE: {
      p._err(token2, error_codes_js_1.ERR.abandonedHeadElementChild);
      p.openElements.push(p.headElement, html_js_1$1.TAG_ID.HEAD);
      startTagInHead(p, token2);
      p.openElements.remove(p.headElement);
      break;
    }
    case html_js_1$1.TAG_ID.HEAD: {
      p._err(token2, error_codes_js_1.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default: {
      tokenAfterHead(p, token2);
    }
  }
}
function endTagAfterHead(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.HTML:
    case html_js_1$1.TAG_ID.BR: {
      tokenAfterHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
    default: {
      p._err(token2, error_codes_js_1.ERR.endTagWithoutMatchingOpenElement);
    }
  }
}
function tokenAfterHead(p, token2) {
  p._insertFakeElement(html_js_1$1.TAG_NAMES.BODY, html_js_1$1.TAG_ID.BODY);
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token2);
}
function modeInBody(p, token2) {
  switch (token2.type) {
    case token_js_1.TokenType.CHARACTER: {
      characterInBody(p, token2);
      break;
    }
    case token_js_1.TokenType.WHITESPACE_CHARACTER: {
      whitespaceCharacterInBody(p, token2);
      break;
    }
    case token_js_1.TokenType.COMMENT: {
      appendComment(p, token2);
      break;
    }
    case token_js_1.TokenType.START_TAG: {
      startTagInBody(p, token2);
      break;
    }
    case token_js_1.TokenType.END_TAG: {
      endTagInBody(p, token2);
      break;
    }
    case token_js_1.TokenType.EOF: {
      eofInBody(p, token2);
      break;
    }
  }
}
function whitespaceCharacterInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token2);
}
function characterInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token2);
  p.framesetOk = false;
}
function htmlStartTagInBody(p, token2) {
  if (p.openElements.tmplCount === 0) {
    p.treeAdapter.adoptAttributes(p.openElements.items[0], token2.attrs);
  }
}
function bodyStartTagInBody(p, token2) {
  const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (bodyElement && p.openElements.tmplCount === 0) {
    p.framesetOk = false;
    p.treeAdapter.adoptAttributes(bodyElement, token2.attrs);
  }
}
function framesetStartTagInBody(p, token2) {
  const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (p.framesetOk && bodyElement) {
    p.treeAdapter.detachNode(bodyElement);
    p.openElements.popAllUpToHtmlElement();
    p._insertElement(token2, html_js_1$1.NS.HTML);
    p.insertionMode = InsertionMode.IN_FRAMESET;
  }
}
function addressStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function numberedHeaderStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  if ((0, html_js_1$1.isNumberedHeader)(p.openElements.currentTagId)) {
    p.openElements.pop();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function preStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.skipNextNewLine = true;
  p.framesetOk = false;
}
function formStartTagInBody(p, token2) {
  const inTemplate = p.openElements.tmplCount > 0;
  if (!p.formElement || inTemplate) {
    if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
      p._closePElement();
    }
    p._insertElement(token2, html_js_1$1.NS.HTML);
    if (!inTemplate) {
      p.formElement = p.openElements.current;
    }
  }
}
function listItemStartTagInBody(p, token2) {
  p.framesetOk = false;
  const tn = token2.tagID;
  for (let i = p.openElements.stackTop; i >= 0; i--) {
    const elementId = p.openElements.tagIDs[i];
    if (tn === html_js_1$1.TAG_ID.LI && elementId === html_js_1$1.TAG_ID.LI || (tn === html_js_1$1.TAG_ID.DD || tn === html_js_1$1.TAG_ID.DT) && (elementId === html_js_1$1.TAG_ID.DD || elementId === html_js_1$1.TAG_ID.DT)) {
      p.openElements.generateImpliedEndTagsWithExclusion(elementId);
      p.openElements.popUntilTagNamePopped(elementId);
      break;
    }
    if (elementId !== html_js_1$1.TAG_ID.ADDRESS && elementId !== html_js_1$1.TAG_ID.DIV && elementId !== html_js_1$1.TAG_ID.P && p._isSpecialElement(p.openElements.items[i], elementId)) {
      break;
    }
  }
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function plaintextStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.tokenizer.state = index_js_1.TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody(p, token2) {
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.BUTTON)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.BUTTON);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.framesetOk = false;
}
function aStartTagInBody(p, token2) {
  const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(html_js_1$1.TAG_NAMES.A);
  if (activeElementEntry) {
    callAdoptionAgency(p, token2);
    p.openElements.remove(activeElementEntry.element);
    p.activeFormattingElements.removeEntry(activeElementEntry);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function bStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function nobrStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.NOBR)) {
    callAdoptionAgency(p, token2);
    p._reconstructActiveFormattingElements();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token2);
}
function appletStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.activeFormattingElements.insertMarker();
  p.framesetOk = false;
}
function tableStartTagInBody(p, token2) {
  if (p.treeAdapter.getDocumentMode(p.document) !== html_js_1$1.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.framesetOk = false;
  p.insertionMode = InsertionMode.IN_TABLE;
}
function areaStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token2, html_js_1$1.NS.HTML);
  p.framesetOk = false;
  token2.ackSelfClosing = true;
}
function isHiddenInput(token2) {
  const inputType = (0, token_js_1.getTokenAttr)(token2, html_js_1$1.ATTRS.TYPE);
  return inputType != null && inputType.toLowerCase() === HIDDEN_INPUT_TYPE;
}
function inputStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token2, html_js_1$1.NS.HTML);
  if (!isHiddenInput(token2)) {
    p.framesetOk = false;
  }
  token2.ackSelfClosing = true;
}
function paramStartTagInBody(p, token2) {
  p._appendElement(token2, html_js_1$1.NS.HTML);
  token2.ackSelfClosing = true;
}
function hrStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._appendElement(token2, html_js_1$1.NS.HTML);
  p.framesetOk = false;
  token2.ackSelfClosing = true;
}
function imageStartTagInBody(p, token2) {
  token2.tagName = html_js_1$1.TAG_NAMES.IMG;
  token2.tagID = html_js_1$1.TAG_ID.IMG;
  areaStartTagInBody(p, token2);
}
function textareaStartTagInBody(p, token2) {
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.skipNextNewLine = true;
  p.tokenizer.state = index_js_1.TokenizerMode.RCDATA;
  p.originalInsertionMode = p.insertionMode;
  p.framesetOk = false;
  p.insertionMode = InsertionMode.TEXT;
}
function xmpStartTagInBody(p, token2) {
  if (p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._closePElement();
  }
  p._reconstructActiveFormattingElements();
  p.framesetOk = false;
  p._switchToTextParsing(token2, index_js_1.TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody(p, token2) {
  p.framesetOk = false;
  p._switchToTextParsing(token2, index_js_1.TokenizerMode.RAWTEXT);
}
function noembedStartTagInBody(p, token2) {
  p._switchToTextParsing(token2, index_js_1.TokenizerMode.RAWTEXT);
}
function selectStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.framesetOk = false;
  p.insertionMode = p.insertionMode === InsertionMode.IN_TABLE || p.insertionMode === InsertionMode.IN_CAPTION || p.insertionMode === InsertionMode.IN_TABLE_BODY || p.insertionMode === InsertionMode.IN_ROW || p.insertionMode === InsertionMode.IN_CELL ? InsertionMode.IN_SELECT_IN_TABLE : InsertionMode.IN_SELECT;
}
function optgroupStartTagInBody(p, token2) {
  if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTION) {
    p.openElements.pop();
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function rbStartTagInBody(p, token2) {
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTags();
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function rtStartTagInBody(p, token2) {
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.RUBY)) {
    p.openElements.generateImpliedEndTagsWithExclusion(html_js_1$1.TAG_ID.RTC);
  }
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function mathStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  foreignContent.adjustTokenMathMLAttrs(token2);
  foreignContent.adjustTokenXMLAttrs(token2);
  if (token2.selfClosing) {
    p._appendElement(token2, html_js_1$1.NS.MATHML);
  } else {
    p._insertElement(token2, html_js_1$1.NS.MATHML);
  }
  token2.ackSelfClosing = true;
}
function svgStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  foreignContent.adjustTokenSVGAttrs(token2);
  foreignContent.adjustTokenXMLAttrs(token2);
  if (token2.selfClosing) {
    p._appendElement(token2, html_js_1$1.NS.SVG);
  } else {
    p._insertElement(token2, html_js_1$1.NS.SVG);
  }
  token2.ackSelfClosing = true;
}
function genericStartTagInBody(p, token2) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token2, html_js_1$1.NS.HTML);
}
function startTagInBody(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.I:
    case html_js_1$1.TAG_ID.S:
    case html_js_1$1.TAG_ID.B:
    case html_js_1$1.TAG_ID.U:
    case html_js_1$1.TAG_ID.EM:
    case html_js_1$1.TAG_ID.TT:
    case html_js_1$1.TAG_ID.BIG:
    case html_js_1$1.TAG_ID.CODE:
    case html_js_1$1.TAG_ID.FONT:
    case html_js_1$1.TAG_ID.SMALL:
    case html_js_1$1.TAG_ID.STRIKE:
    case html_js_1$1.TAG_ID.STRONG: {
      bStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.A: {
      aStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.H1:
    case html_js_1$1.TAG_ID.H2:
    case html_js_1$1.TAG_ID.H3:
    case html_js_1$1.TAG_ID.H4:
    case html_js_1$1.TAG_ID.H5:
    case html_js_1$1.TAG_ID.H6: {
      numberedHeaderStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.P:
    case html_js_1$1.TAG_ID.DL:
    case html_js_1$1.TAG_ID.OL:
    case html_js_1$1.TAG_ID.UL:
    case html_js_1$1.TAG_ID.DIV:
    case html_js_1$1.TAG_ID.DIR:
    case html_js_1$1.TAG_ID.NAV:
    case html_js_1$1.TAG_ID.MAIN:
    case html_js_1$1.TAG_ID.MENU:
    case html_js_1$1.TAG_ID.ASIDE:
    case html_js_1$1.TAG_ID.CENTER:
    case html_js_1$1.TAG_ID.FIGURE:
    case html_js_1$1.TAG_ID.FOOTER:
    case html_js_1$1.TAG_ID.HEADER:
    case html_js_1$1.TAG_ID.HGROUP:
    case html_js_1$1.TAG_ID.DIALOG:
    case html_js_1$1.TAG_ID.DETAILS:
    case html_js_1$1.TAG_ID.ADDRESS:
    case html_js_1$1.TAG_ID.ARTICLE:
    case html_js_1$1.TAG_ID.SECTION:
    case html_js_1$1.TAG_ID.SUMMARY:
    case html_js_1$1.TAG_ID.FIELDSET:
    case html_js_1$1.TAG_ID.BLOCKQUOTE:
    case html_js_1$1.TAG_ID.FIGCAPTION: {
      addressStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.LI:
    case html_js_1$1.TAG_ID.DD:
    case html_js_1$1.TAG_ID.DT: {
      listItemStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BR:
    case html_js_1$1.TAG_ID.IMG:
    case html_js_1$1.TAG_ID.WBR:
    case html_js_1$1.TAG_ID.AREA:
    case html_js_1$1.TAG_ID.EMBED:
    case html_js_1$1.TAG_ID.KEYGEN: {
      areaStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.HR: {
      hrStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.RB:
    case html_js_1$1.TAG_ID.RTC: {
      rbStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.RT:
    case html_js_1$1.TAG_ID.RP: {
      rtStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.PRE:
    case html_js_1$1.TAG_ID.LISTING: {
      preStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.XMP: {
      xmpStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.SVG: {
      svgStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.HTML: {
      htmlStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BASE:
    case html_js_1$1.TAG_ID.LINK:
    case html_js_1$1.TAG_ID.META:
    case html_js_1$1.TAG_ID.STYLE:
    case html_js_1$1.TAG_ID.TITLE:
    case html_js_1$1.TAG_ID.SCRIPT:
    case html_js_1$1.TAG_ID.BGSOUND:
    case html_js_1$1.TAG_ID.BASEFONT:
    case html_js_1$1.TAG_ID.TEMPLATE: {
      startTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BODY: {
      bodyStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.FORM: {
      formStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOBR: {
      nobrStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.MATH: {
      mathStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TABLE: {
      tableStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.INPUT: {
      inputStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.PARAM:
    case html_js_1$1.TAG_ID.TRACK:
    case html_js_1$1.TAG_ID.SOURCE: {
      paramStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.IMAGE: {
      imageStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BUTTON: {
      buttonStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.APPLET:
    case html_js_1$1.TAG_ID.OBJECT:
    case html_js_1$1.TAG_ID.MARQUEE: {
      appletStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.IFRAME: {
      iframeStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.SELECT: {
      selectStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.OPTION:
    case html_js_1$1.TAG_ID.OPTGROUP: {
      optgroupStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOEMBED: {
      noembedStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.FRAMESET: {
      framesetStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TEXTAREA: {
      textareaStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOSCRIPT: {
      if (p.options.scriptingEnabled) {
        noembedStartTagInBody(p, token2);
      } else {
        genericStartTagInBody(p, token2);
      }
      break;
    }
    case html_js_1$1.TAG_ID.PLAINTEXT: {
      plaintextStartTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TR:
    case html_js_1$1.TAG_ID.HEAD:
    case html_js_1$1.TAG_ID.FRAME:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD:
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COLGROUP: {
      break;
    }
    default: {
      genericStartTagInBody(p, token2);
    }
  }
}
function bodyEndTagInBody(p, token2) {
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.BODY)) {
    p.insertionMode = InsertionMode.AFTER_BODY;
    if (p.options.sourceCodeLocationInfo) {
      const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
      if (bodyElement) {
        p._setEndLocation(bodyElement, token2);
      }
    }
  }
}
function htmlEndTagInBody(p, token2) {
  if (p.openElements.hasInScope(html_js_1$1.TAG_ID.BODY)) {
    p.insertionMode = InsertionMode.AFTER_BODY;
    endTagAfterBody(p, token2);
  }
}
function addressEndTagInBody(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function formEndTagInBody(p) {
  const inTemplate = p.openElements.tmplCount > 0;
  const {
    formElement
  } = p;
  if (!inTemplate) {
    p.formElement = null;
  }
  if ((formElement || inTemplate) && p.openElements.hasInScope(html_js_1$1.TAG_ID.FORM)) {
    p.openElements.generateImpliedEndTags();
    if (inTemplate) {
      p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.FORM);
    } else if (formElement) {
      p.openElements.remove(formElement);
    }
  }
}
function pEndTagInBody(p) {
  if (!p.openElements.hasInButtonScope(html_js_1$1.TAG_ID.P)) {
    p._insertFakeElement(html_js_1$1.TAG_NAMES.P, html_js_1$1.TAG_ID.P);
  }
  p._closePElement();
}
function liEndTagInBody(p) {
  if (p.openElements.hasInListItemScope(html_js_1$1.TAG_ID.LI)) {
    p.openElements.generateImpliedEndTagsWithExclusion(html_js_1$1.TAG_ID.LI);
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.LI);
  }
}
function ddEndTagInBody(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTagsWithExclusion(tn);
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function numberedHeaderEndTagInBody(p) {
  if (p.openElements.hasNumberedHeaderInScope()) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilNumberedHeaderPopped();
  }
}
function appletEndTagInBody(p, token2) {
  const tn = token2.tagID;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
    p.activeFormattingElements.clearToLastMarker();
  }
}
function brEndTagInBody(p) {
  p._reconstructActiveFormattingElements();
  p._insertFakeElement(html_js_1$1.TAG_NAMES.BR, html_js_1$1.TAG_ID.BR);
  p.openElements.pop();
  p.framesetOk = false;
}
function genericEndTagInBody(p, token2) {
  const tn = token2.tagName;
  const tid = token2.tagID;
  for (let i = p.openElements.stackTop; i > 0; i--) {
    const element = p.openElements.items[i];
    const elementId = p.openElements.tagIDs[i];
    if (tid === elementId && (tid !== html_js_1$1.TAG_ID.UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
      p.openElements.generateImpliedEndTagsWithExclusion(tid);
      if (p.openElements.stackTop >= i)
        p.openElements.shortenToLength(i);
      break;
    }
    if (p._isSpecialElement(element, elementId)) {
      break;
    }
  }
}
function endTagInBody(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.A:
    case html_js_1$1.TAG_ID.B:
    case html_js_1$1.TAG_ID.I:
    case html_js_1$1.TAG_ID.S:
    case html_js_1$1.TAG_ID.U:
    case html_js_1$1.TAG_ID.EM:
    case html_js_1$1.TAG_ID.TT:
    case html_js_1$1.TAG_ID.BIG:
    case html_js_1$1.TAG_ID.CODE:
    case html_js_1$1.TAG_ID.FONT:
    case html_js_1$1.TAG_ID.NOBR:
    case html_js_1$1.TAG_ID.SMALL:
    case html_js_1$1.TAG_ID.STRIKE:
    case html_js_1$1.TAG_ID.STRONG: {
      callAdoptionAgency(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.P: {
      pEndTagInBody(p);
      break;
    }
    case html_js_1$1.TAG_ID.DL:
    case html_js_1$1.TAG_ID.UL:
    case html_js_1$1.TAG_ID.OL:
    case html_js_1$1.TAG_ID.DIR:
    case html_js_1$1.TAG_ID.DIV:
    case html_js_1$1.TAG_ID.NAV:
    case html_js_1$1.TAG_ID.PRE:
    case html_js_1$1.TAG_ID.MAIN:
    case html_js_1$1.TAG_ID.MENU:
    case html_js_1$1.TAG_ID.ASIDE:
    case html_js_1$1.TAG_ID.BUTTON:
    case html_js_1$1.TAG_ID.CENTER:
    case html_js_1$1.TAG_ID.FIGURE:
    case html_js_1$1.TAG_ID.FOOTER:
    case html_js_1$1.TAG_ID.HEADER:
    case html_js_1$1.TAG_ID.HGROUP:
    case html_js_1$1.TAG_ID.DIALOG:
    case html_js_1$1.TAG_ID.ADDRESS:
    case html_js_1$1.TAG_ID.ARTICLE:
    case html_js_1$1.TAG_ID.DETAILS:
    case html_js_1$1.TAG_ID.SECTION:
    case html_js_1$1.TAG_ID.SUMMARY:
    case html_js_1$1.TAG_ID.LISTING:
    case html_js_1$1.TAG_ID.FIELDSET:
    case html_js_1$1.TAG_ID.BLOCKQUOTE:
    case html_js_1$1.TAG_ID.FIGCAPTION: {
      addressEndTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.LI: {
      liEndTagInBody(p);
      break;
    }
    case html_js_1$1.TAG_ID.DD:
    case html_js_1$1.TAG_ID.DT: {
      ddEndTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.H1:
    case html_js_1$1.TAG_ID.H2:
    case html_js_1$1.TAG_ID.H3:
    case html_js_1$1.TAG_ID.H4:
    case html_js_1$1.TAG_ID.H5:
    case html_js_1$1.TAG_ID.H6: {
      numberedHeaderEndTagInBody(p);
      break;
    }
    case html_js_1$1.TAG_ID.BR: {
      brEndTagInBody(p);
      break;
    }
    case html_js_1$1.TAG_ID.BODY: {
      bodyEndTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.HTML: {
      htmlEndTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.FORM: {
      formEndTagInBody(p);
      break;
    }
    case html_js_1$1.TAG_ID.APPLET:
    case html_js_1$1.TAG_ID.OBJECT:
    case html_js_1$1.TAG_ID.MARQUEE: {
      appletEndTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
    default: {
      genericEndTagInBody(p, token2);
    }
  }
}
function eofInBody(p, token2) {
  if (p.tmplInsertionModeStack.length > 0) {
    eofInTemplate(p, token2);
  } else {
    stopParsing(p, token2);
  }
}
function endTagInText(p, token2) {
  var _a;
  if (token2.tagID === html_js_1$1.TAG_ID.SCRIPT) {
    (_a = p.scriptHandler) === null || _a === void 0 ? void 0 : _a.call(p, p.openElements.current);
  }
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
}
function eofInText(p, token2) {
  p._err(token2, error_codes_js_1.ERR.eofInElementThatCanContainOnlyText);
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
  p.onEof(token2);
}
function characterInTable(p, token2) {
  if (TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
    p.pendingCharacterTokens.length = 0;
    p.hasNonWhitespacePendingCharacterToken = false;
    p.originalInsertionMode = p.insertionMode;
    p.insertionMode = InsertionMode.IN_TABLE_TEXT;
    switch (token2.type) {
      case token_js_1.TokenType.CHARACTER: {
        characterInTableText(p, token2);
        break;
      }
      case token_js_1.TokenType.WHITESPACE_CHARACTER: {
        whitespaceCharacterInTableText(p, token2);
        break;
      }
    }
  } else {
    tokenInTable(p, token2);
  }
}
function captionStartTagInTable(p, token2) {
  p.openElements.clearBackToTableContext();
  p.activeFormattingElements.insertMarker();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.insertionMode = InsertionMode.IN_CAPTION;
}
function colgroupStartTagInTable(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
}
function colStartTagInTable(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(html_js_1$1.TAG_NAMES.COLGROUP, html_js_1$1.TAG_ID.COLGROUP);
  p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
  startTagInColumnGroup(p, token2);
}
function tbodyStartTagInTable(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token2, html_js_1$1.NS.HTML);
  p.insertionMode = InsertionMode.IN_TABLE_BODY;
}
function tdStartTagInTable(p, token2) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement(html_js_1$1.TAG_NAMES.TBODY, html_js_1$1.TAG_ID.TBODY);
  p.insertionMode = InsertionMode.IN_TABLE_BODY;
  startTagInTableBody(p, token2);
}
function tableStartTagInTable(p, token2) {
  if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TABLE)) {
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.TABLE);
    p._resetInsertionMode();
    p._processStartTag(token2);
  }
}
function inputStartTagInTable(p, token2) {
  if (isHiddenInput(token2)) {
    p._appendElement(token2, html_js_1$1.NS.HTML);
  } else {
    tokenInTable(p, token2);
  }
  token2.ackSelfClosing = true;
}
function formStartTagInTable(p, token2) {
  if (!p.formElement && p.openElements.tmplCount === 0) {
    p._insertElement(token2, html_js_1$1.NS.HTML);
    p.formElement = p.openElements.current;
    p.openElements.pop();
  }
}
function startTagInTable(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.TR: {
      tdStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.STYLE:
    case html_js_1$1.TAG_ID.SCRIPT:
    case html_js_1$1.TAG_ID.TEMPLATE: {
      startTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COL: {
      colStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.FORM: {
      formStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TABLE: {
      tableStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD: {
      tbodyStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.INPUT: {
      inputStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.CAPTION: {
      captionStartTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COLGROUP: {
      colgroupStartTagInTable(p, token2);
      break;
    }
    default: {
      tokenInTable(p, token2);
    }
  }
}
function endTagInTable(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TABLE)) {
        p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.TABLE);
        p._resetInsertionMode();
      }
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.HTML:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.THEAD:
    case html_js_1$1.TAG_ID.TR: {
      break;
    }
    default: {
      tokenInTable(p, token2);
    }
  }
}
function tokenInTable(p, token2) {
  const savedFosterParentingState = p.fosterParentingEnabled;
  p.fosterParentingEnabled = true;
  modeInBody(p, token2);
  p.fosterParentingEnabled = savedFosterParentingState;
}
function whitespaceCharacterInTableText(p, token2) {
  p.pendingCharacterTokens.push(token2);
}
function characterInTableText(p, token2) {
  p.pendingCharacterTokens.push(token2);
  p.hasNonWhitespacePendingCharacterToken = true;
}
function tokenInTableText(p, token2) {
  let i = 0;
  if (p.hasNonWhitespacePendingCharacterToken) {
    for (; i < p.pendingCharacterTokens.length; i++) {
      tokenInTable(p, p.pendingCharacterTokens[i]);
    }
  } else {
    for (; i < p.pendingCharacterTokens.length; i++) {
      p._insertCharacters(p.pendingCharacterTokens[i]);
    }
  }
  p.insertionMode = p.originalInsertionMode;
  p._processToken(token2);
}
const TABLE_VOID_ELEMENTS = /* @__PURE__ */ new Set([html_js_1$1.TAG_ID.CAPTION, html_js_1$1.TAG_ID.COL, html_js_1$1.TAG_ID.COLGROUP, html_js_1$1.TAG_ID.TBODY, html_js_1$1.TAG_ID.TD, html_js_1$1.TAG_ID.TFOOT, html_js_1$1.TAG_ID.TH, html_js_1$1.TAG_ID.THEAD, html_js_1$1.TAG_ID.TR]);
function startTagInCaption(p, token2) {
  const tn = token2.tagID;
  if (TABLE_VOID_ELEMENTS.has(tn)) {
    if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.CAPTION)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.CAPTION);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = InsertionMode.IN_TABLE;
      startTagInTable(p, token2);
    }
  } else {
    startTagInBody(p, token2);
  }
}
function endTagInCaption(p, token2) {
  const tn = token2.tagID;
  switch (tn) {
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.CAPTION)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.CAPTION);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = InsertionMode.IN_TABLE;
        if (tn === html_js_1$1.TAG_ID.TABLE) {
          endTagInTable(p, token2);
        }
      }
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.HTML:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.THEAD:
    case html_js_1$1.TAG_ID.TR: {
      break;
    }
    default: {
      endTagInBody(p, token2);
    }
  }
}
function startTagInColumnGroup(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COL: {
      p._appendElement(token2, html_js_1$1.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      startTagInHead(p, token2);
      break;
    }
    default: {
      tokenInColumnGroup(p, token2);
    }
  }
}
function endTagInColumnGroup(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.COLGROUP: {
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE;
      }
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COL: {
      break;
    }
    default: {
      tokenInColumnGroup(p, token2);
    }
  }
}
function tokenInColumnGroup(p, token2) {
  if (p.openElements.currentTagId === html_js_1$1.TAG_ID.COLGROUP) {
    p.openElements.pop();
    p.insertionMode = InsertionMode.IN_TABLE;
    p._processToken(token2);
  }
}
function startTagInTableBody(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TR: {
      p.openElements.clearBackToTableBodyContext();
      p._insertElement(token2, html_js_1$1.NS.HTML);
      p.insertionMode = InsertionMode.IN_ROW;
      break;
    }
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.TD: {
      p.openElements.clearBackToTableBodyContext();
      p._insertFakeElement(html_js_1$1.TAG_NAMES.TR, html_js_1$1.TAG_ID.TR);
      p.insertionMode = InsertionMode.IN_ROW;
      startTagInRow(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD: {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE;
        startTagInTable(p, token2);
      }
      break;
    }
    default: {
      startTagInTable(p, token2);
    }
  }
}
function endTagInTableBody(p, token2) {
  const tn = token2.tagID;
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD: {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE;
      }
      break;
    }
    case html_js_1$1.TAG_ID.TABLE: {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE;
        endTagInTable(p, token2);
      }
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.HTML:
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.TR: {
      break;
    }
    default: {
      endTagInTable(p, token2);
    }
  }
}
function startTagInRow(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TH:
    case html_js_1$1.TAG_ID.TD: {
      p.openElements.clearBackToTableRowContext();
      p._insertElement(token2, html_js_1$1.NS.HTML);
      p.insertionMode = InsertionMode.IN_CELL;
      p.activeFormattingElements.insertMarker();
      break;
    }
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD:
    case html_js_1$1.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE_BODY;
        startTagInTableBody(p, token2);
      }
      break;
    }
    default: {
      startTagInTable(p, token2);
    }
  }
}
function endTagInRow(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE_BODY;
      }
      break;
    }
    case html_js_1$1.TAG_ID.TABLE: {
      if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE_BODY;
        endTagInTableBody(p, token2);
      }
      break;
    }
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD: {
      if (p.openElements.hasInTableScope(token2.tagID) || p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE_BODY;
        endTagInTableBody(p, token2);
      }
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.HTML:
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TH: {
      break;
    }
    default: {
      endTagInTable(p, token2);
    }
  }
}
function startTagInCell(p, token2) {
  const tn = token2.tagID;
  if (TABLE_VOID_ELEMENTS.has(tn)) {
    if (p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TD) || p.openElements.hasInTableScope(html_js_1$1.TAG_ID.TH)) {
      p._closeTableCell();
      startTagInRow(p, token2);
    }
  } else {
    startTagInBody(p, token2);
  }
}
function endTagInCell(p, token2) {
  const tn = token2.tagID;
  switch (tn) {
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TH: {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = InsertionMode.IN_ROW;
      }
      break;
    }
    case html_js_1$1.TAG_ID.TABLE:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD:
    case html_js_1$1.TAG_ID.TR: {
      if (p.openElements.hasInTableScope(tn)) {
        p._closeTableCell();
        endTagInRow(p, token2);
      }
      break;
    }
    case html_js_1$1.TAG_ID.BODY:
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COL:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.HTML: {
      break;
    }
    default: {
      endTagInBody(p, token2);
    }
  }
}
function startTagInSelect(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.OPTION: {
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      p._insertElement(token2, html_js_1$1.NS.HTML);
      break;
    }
    case html_js_1$1.TAG_ID.OPTGROUP: {
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      p._insertElement(token2, html_js_1$1.NS.HTML);
      break;
    }
    case html_js_1$1.TAG_ID.INPUT:
    case html_js_1$1.TAG_ID.KEYGEN:
    case html_js_1$1.TAG_ID.TEXTAREA:
    case html_js_1$1.TAG_ID.SELECT: {
      if (p.openElements.hasInSelectScope(html_js_1$1.TAG_ID.SELECT)) {
        p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.SELECT);
        p._resetInsertionMode();
        if (token2.tagID !== html_js_1$1.TAG_ID.SELECT) {
          p._processStartTag(token2);
        }
      }
      break;
    }
    case html_js_1$1.TAG_ID.SCRIPT:
    case html_js_1$1.TAG_ID.TEMPLATE: {
      startTagInHead(p, token2);
      break;
    }
  }
}
function endTagInSelect(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.OPTGROUP: {
      if (p.openElements.stackTop > 0 && p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === html_js_1$1.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTGROUP) {
        p.openElements.pop();
      }
      break;
    }
    case html_js_1$1.TAG_ID.OPTION: {
      if (p.openElements.currentTagId === html_js_1$1.TAG_ID.OPTION) {
        p.openElements.pop();
      }
      break;
    }
    case html_js_1$1.TAG_ID.SELECT: {
      if (p.openElements.hasInSelectScope(html_js_1$1.TAG_ID.SELECT)) {
        p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.SELECT);
        p._resetInsertionMode();
      }
      break;
    }
    case html_js_1$1.TAG_ID.TEMPLATE: {
      templateEndTagInHead(p, token2);
      break;
    }
  }
}
function startTagInSelectInTable(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$1.TAG_ID.CAPTION || tn === html_js_1$1.TAG_ID.TABLE || tn === html_js_1$1.TAG_ID.TBODY || tn === html_js_1$1.TAG_ID.TFOOT || tn === html_js_1$1.TAG_ID.THEAD || tn === html_js_1$1.TAG_ID.TR || tn === html_js_1$1.TAG_ID.TD || tn === html_js_1$1.TAG_ID.TH) {
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.SELECT);
    p._resetInsertionMode();
    p._processStartTag(token2);
  } else {
    startTagInSelect(p, token2);
  }
}
function endTagInSelectInTable(p, token2) {
  const tn = token2.tagID;
  if (tn === html_js_1$1.TAG_ID.CAPTION || tn === html_js_1$1.TAG_ID.TABLE || tn === html_js_1$1.TAG_ID.TBODY || tn === html_js_1$1.TAG_ID.TFOOT || tn === html_js_1$1.TAG_ID.THEAD || tn === html_js_1$1.TAG_ID.TR || tn === html_js_1$1.TAG_ID.TD || tn === html_js_1$1.TAG_ID.TH) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.SELECT);
      p._resetInsertionMode();
      p.onEndTag(token2);
    }
  } else {
    endTagInSelect(p, token2);
  }
}
function startTagInTemplate(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.BASE:
    case html_js_1$1.TAG_ID.BASEFONT:
    case html_js_1$1.TAG_ID.BGSOUND:
    case html_js_1$1.TAG_ID.LINK:
    case html_js_1$1.TAG_ID.META:
    case html_js_1$1.TAG_ID.NOFRAMES:
    case html_js_1$1.TAG_ID.SCRIPT:
    case html_js_1$1.TAG_ID.STYLE:
    case html_js_1$1.TAG_ID.TEMPLATE:
    case html_js_1$1.TAG_ID.TITLE: {
      startTagInHead(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.CAPTION:
    case html_js_1$1.TAG_ID.COLGROUP:
    case html_js_1$1.TAG_ID.TBODY:
    case html_js_1$1.TAG_ID.TFOOT:
    case html_js_1$1.TAG_ID.THEAD: {
      p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE;
      p.insertionMode = InsertionMode.IN_TABLE;
      startTagInTable(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.COL: {
      p.tmplInsertionModeStack[0] = InsertionMode.IN_COLUMN_GROUP;
      p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
      startTagInColumnGroup(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TR: {
      p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE_BODY;
      p.insertionMode = InsertionMode.IN_TABLE_BODY;
      startTagInTableBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.TD:
    case html_js_1$1.TAG_ID.TH: {
      p.tmplInsertionModeStack[0] = InsertionMode.IN_ROW;
      p.insertionMode = InsertionMode.IN_ROW;
      startTagInRow(p, token2);
      break;
    }
    default: {
      p.tmplInsertionModeStack[0] = InsertionMode.IN_BODY;
      p.insertionMode = InsertionMode.IN_BODY;
      startTagInBody(p, token2);
    }
  }
}
function endTagInTemplate(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.TEMPLATE) {
    templateEndTagInHead(p, token2);
  }
}
function eofInTemplate(p, token2) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.popUntilTagNamePopped(html_js_1$1.TAG_ID.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p.tmplInsertionModeStack.shift();
    p._resetInsertionMode();
    p.onEof(token2);
  } else {
    stopParsing(p, token2);
  }
}
function startTagAfterBody(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.HTML) {
    startTagInBody(p, token2);
  } else {
    tokenAfterBody(p, token2);
  }
}
function endTagAfterBody(p, token2) {
  var _a;
  if (token2.tagID === html_js_1$1.TAG_ID.HTML) {
    if (!p.fragmentContext) {
      p.insertionMode = InsertionMode.AFTER_AFTER_BODY;
    }
    if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === html_js_1$1.TAG_ID.HTML) {
      p._setEndLocation(p.openElements.items[0], token2);
      const bodyElement = p.openElements.items[1];
      if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) {
        p._setEndLocation(bodyElement, token2);
      }
    }
  } else {
    tokenAfterBody(p, token2);
  }
}
function tokenAfterBody(p, token2) {
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token2);
}
function startTagInFrameset(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.FRAMESET: {
      p._insertElement(token2, html_js_1$1.NS.HTML);
      break;
    }
    case html_js_1$1.TAG_ID.FRAME: {
      p._appendElement(token2, html_js_1$1.NS.HTML);
      token2.ackSelfClosing = true;
      break;
    }
    case html_js_1$1.TAG_ID.NOFRAMES: {
      startTagInHead(p, token2);
      break;
    }
  }
}
function endTagInFrameset(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
    p.openElements.pop();
    if (!p.fragmentContext && p.openElements.currentTagId !== html_js_1$1.TAG_ID.FRAMESET) {
      p.insertionMode = InsertionMode.AFTER_FRAMESET;
    }
  }
}
function startTagAfterFrameset(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOFRAMES: {
      startTagInHead(p, token2);
      break;
    }
  }
}
function endTagAfterFrameset(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.HTML) {
    p.insertionMode = InsertionMode.AFTER_AFTER_FRAMESET;
  }
}
function startTagAfterAfterBody(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.HTML) {
    startTagInBody(p, token2);
  } else {
    tokenAfterAfterBody(p, token2);
  }
}
function tokenAfterAfterBody(p, token2) {
  p.insertionMode = InsertionMode.IN_BODY;
  modeInBody(p, token2);
}
function startTagAfterAfterFrameset(p, token2) {
  switch (token2.tagID) {
    case html_js_1$1.TAG_ID.HTML: {
      startTagInBody(p, token2);
      break;
    }
    case html_js_1$1.TAG_ID.NOFRAMES: {
      startTagInHead(p, token2);
      break;
    }
  }
}
function nullCharacterInForeignContent(p, token2) {
  token2.chars = unicode.REPLACEMENT_CHARACTER;
  p._insertCharacters(token2);
}
function characterInForeignContent(p, token2) {
  p._insertCharacters(token2);
  p.framesetOk = false;
}
function popUntilHtmlOrIntegrationPoint(p) {
  while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== html_js_1$1.NS.HTML && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current)) {
    p.openElements.pop();
  }
}
function startTagInForeignContent(p, token2) {
  if (foreignContent.causesExit(token2)) {
    popUntilHtmlOrIntegrationPoint(p);
    p._startTagOutsideForeignContent(token2);
  } else {
    const current = p._getAdjustedCurrentElement();
    const currentNs = p.treeAdapter.getNamespaceURI(current);
    if (currentNs === html_js_1$1.NS.MATHML) {
      foreignContent.adjustTokenMathMLAttrs(token2);
    } else if (currentNs === html_js_1$1.NS.SVG) {
      foreignContent.adjustTokenSVGTagName(token2);
      foreignContent.adjustTokenSVGAttrs(token2);
    }
    foreignContent.adjustTokenXMLAttrs(token2);
    if (token2.selfClosing) {
      p._appendElement(token2, currentNs);
    } else {
      p._insertElement(token2, currentNs);
    }
    token2.ackSelfClosing = true;
  }
}
function endTagInForeignContent(p, token2) {
  if (token2.tagID === html_js_1$1.TAG_ID.P || token2.tagID === html_js_1$1.TAG_ID.BR) {
    popUntilHtmlOrIntegrationPoint(p);
    p._endTagOutsideForeignContent(token2);
    return;
  }
  for (let i = p.openElements.stackTop; i > 0; i--) {
    const element = p.openElements.items[i];
    if (p.treeAdapter.getNamespaceURI(element) === html_js_1$1.NS.HTML) {
      p._endTagOutsideForeignContent(token2);
      break;
    }
    const tagName = p.treeAdapter.getTagName(element);
    if (tagName.toLowerCase() === token2.tagName) {
      token2.tagName = tagName;
      p.openElements.shortenToLength(i);
      break;
    }
  }
}
var serializer = {};
Object.defineProperty(serializer, "__esModule", {
  value: true
});
serializer.serializeOuter = serializer.serialize = void 0;
const html_js_1 = html$1;
const escape_js_1 = _escape;
const default_js_1 = _default$4;
const VOID_ELEMENTS = /* @__PURE__ */ new Set([html_js_1.TAG_NAMES.AREA, html_js_1.TAG_NAMES.BASE, html_js_1.TAG_NAMES.BASEFONT, html_js_1.TAG_NAMES.BGSOUND, html_js_1.TAG_NAMES.BR, html_js_1.TAG_NAMES.COL, html_js_1.TAG_NAMES.EMBED, html_js_1.TAG_NAMES.FRAME, html_js_1.TAG_NAMES.HR, html_js_1.TAG_NAMES.IMG, html_js_1.TAG_NAMES.INPUT, html_js_1.TAG_NAMES.KEYGEN, html_js_1.TAG_NAMES.LINK, html_js_1.TAG_NAMES.META, html_js_1.TAG_NAMES.PARAM, html_js_1.TAG_NAMES.SOURCE, html_js_1.TAG_NAMES.TRACK, html_js_1.TAG_NAMES.WBR]);
function isVoidElement(node2, options2) {
  return options2.treeAdapter.isElementNode(node2) && options2.treeAdapter.getNamespaceURI(node2) === html_js_1.NS.HTML && VOID_ELEMENTS.has(options2.treeAdapter.getTagName(node2));
}
const defaultOpts = {
  treeAdapter: default_js_1.defaultTreeAdapter,
  scriptingEnabled: true
};
function serialize(node2, options2) {
  const opts = Object.assign(Object.assign({}, defaultOpts), options2);
  if (isVoidElement(node2, opts)) {
    return "";
  }
  return serializeChildNodes(node2, opts);
}
serializer.serialize = serialize;
function serializeOuter(node2, options2) {
  const opts = Object.assign(Object.assign({}, defaultOpts), options2);
  return serializeNode(node2, opts);
}
serializer.serializeOuter = serializeOuter;
function serializeChildNodes(parentNode, options2) {
  let html2 = "";
  const container = options2.treeAdapter.isElementNode(parentNode) && options2.treeAdapter.getTagName(parentNode) === html_js_1.TAG_NAMES.TEMPLATE && options2.treeAdapter.getNamespaceURI(parentNode) === html_js_1.NS.HTML ? options2.treeAdapter.getTemplateContent(parentNode) : parentNode;
  const childNodes = options2.treeAdapter.getChildNodes(container);
  if (childNodes) {
    for (const currentNode of childNodes) {
      html2 += serializeNode(currentNode, options2);
    }
  }
  return html2;
}
function serializeNode(node2, options2) {
  if (options2.treeAdapter.isElementNode(node2)) {
    return serializeElement(node2, options2);
  }
  if (options2.treeAdapter.isTextNode(node2)) {
    return serializeTextNode(node2, options2);
  }
  if (options2.treeAdapter.isCommentNode(node2)) {
    return serializeCommentNode(node2, options2);
  }
  if (options2.treeAdapter.isDocumentTypeNode(node2)) {
    return serializeDocumentTypeNode(node2, options2);
  }
  return "";
}
function serializeElement(node2, options2) {
  const tn = options2.treeAdapter.getTagName(node2);
  return `<${tn}${serializeAttributes(node2, options2)}>${isVoidElement(node2, options2) ? "" : `${serializeChildNodes(node2, options2)}</${tn}>`}`;
}
function serializeAttributes(node2, {
  treeAdapter
}) {
  let html2 = "";
  for (const attr2 of treeAdapter.getAttrList(node2)) {
    html2 += " ";
    if (!attr2.namespace) {
      html2 += attr2.name;
    } else
      switch (attr2.namespace) {
        case html_js_1.NS.XML: {
          html2 += `xml:${attr2.name}`;
          break;
        }
        case html_js_1.NS.XMLNS: {
          if (attr2.name !== "xmlns") {
            html2 += "xmlns:";
          }
          html2 += attr2.name;
          break;
        }
        case html_js_1.NS.XLINK: {
          html2 += `xlink:${attr2.name}`;
          break;
        }
        default: {
          html2 += `${attr2.prefix}:${attr2.name}`;
        }
      }
    html2 += `="${(0, escape_js_1.escapeAttribute)(attr2.value)}"`;
  }
  return html2;
}
function serializeTextNode(node2, options2) {
  const {
    treeAdapter
  } = options2;
  const content = treeAdapter.getTextNodeContent(node2);
  const parent = treeAdapter.getParentNode(node2);
  const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
  return parentTn && treeAdapter.getNamespaceURI(parent) === html_js_1.NS.HTML && (0, html_js_1.hasUnescapedText)(parentTn, options2.scriptingEnabled) ? content : (0, escape_js_1.escapeText)(content);
}
function serializeCommentNode(node2, {
  treeAdapter
}) {
  return `<!--${treeAdapter.getCommentNodeContent(node2)}-->`;
}
function serializeDocumentTypeNode(node2, {
  treeAdapter
}) {
  return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node2)}>`;
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.parseFragment = exports2.parse = exports2.TokenizerMode = exports2.Tokenizer = exports2.Token = exports2.html = exports2.foreignContent = exports2.ErrorCodes = exports2.serializeOuter = exports2.serialize = exports2.Parser = exports2.defaultTreeAdapter = void 0;
  const index_js_12 = parser$1;
  var default_js_12 = _default$4;
  Object.defineProperty(exports2, "defaultTreeAdapter", {
    enumerable: true,
    get: function() {
      return default_js_12.defaultTreeAdapter;
    }
  });
  var index_js_2 = parser$1;
  Object.defineProperty(exports2, "Parser", {
    enumerable: true,
    get: function() {
      return index_js_2.Parser;
    }
  });
  var index_js_3 = serializer;
  Object.defineProperty(exports2, "serialize", {
    enumerable: true,
    get: function() {
      return index_js_3.serialize;
    }
  });
  Object.defineProperty(exports2, "serializeOuter", {
    enumerable: true,
    get: function() {
      return index_js_3.serializeOuter;
    }
  });
  var error_codes_js_12 = errorCodes;
  Object.defineProperty(exports2, "ErrorCodes", {
    enumerable: true,
    get: function() {
      return error_codes_js_12.ERR;
    }
  });
  exports2.foreignContent = foreignContent$1;
  exports2.html = html$1;
  exports2.Token = token;
  var index_js_4 = tokenizer;
  Object.defineProperty(exports2, "Tokenizer", {
    enumerable: true,
    get: function() {
      return index_js_4.Tokenizer;
    }
  });
  Object.defineProperty(exports2, "TokenizerMode", {
    enumerable: true,
    get: function() {
      return index_js_4.TokenizerMode;
    }
  });
  function parse2(html2, options2) {
    return index_js_12.Parser.parse(html2, options2);
  }
  exports2.parse = parse2;
  function parseFragment(fragmentContext, html2, options2) {
    if (typeof fragmentContext === "string") {
      options2 = html2;
      html2 = fragmentContext;
      fragmentContext = null;
    }
    const parser2 = index_js_12.Parser.getFragmentParser(fragmentContext, options2);
    parser2.tokenizer.write(html2, true);
    return parser2.getFragment();
  }
  exports2.parseFragment = parseFragment;
})(cjs);
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.adapter = exports2.serializeDoctypeContent = void 0;
  const parse5_12 = cjs;
  const domhandler_12 = lib$a;
  function createTextNode(value2) {
    return new domhandler_12.Text(value2);
  }
  function enquoteDoctypeId(id2) {
    const quote2 = id2.includes('"') ? "'" : '"';
    return quote2 + id2 + quote2;
  }
  function serializeDoctypeContent(name, publicId, systemId) {
    let str = "!DOCTYPE ";
    if (name) {
      str += name;
    }
    if (publicId) {
      str += ` PUBLIC ${enquoteDoctypeId(publicId)}`;
    } else if (systemId) {
      str += " SYSTEM";
    }
    if (systemId) {
      str += ` ${enquoteDoctypeId(systemId)}`;
    }
    return str;
  }
  exports2.serializeDoctypeContent = serializeDoctypeContent;
  exports2.adapter = {
    // Re-exports from domhandler
    isCommentNode: domhandler_12.isComment,
    isElementNode: domhandler_12.isTag,
    isTextNode: domhandler_12.isText,
    //Node construction
    createDocument() {
      const node2 = new domhandler_12.Document([]);
      node2["x-mode"] = parse5_12.html.DOCUMENT_MODE.NO_QUIRKS;
      return node2;
    },
    createDocumentFragment() {
      return new domhandler_12.Document([]);
    },
    createElement(tagName, namespaceURI, attrs) {
      const attribs = /* @__PURE__ */ Object.create(null);
      const attribsNamespace = /* @__PURE__ */ Object.create(null);
      const attribsPrefix = /* @__PURE__ */ Object.create(null);
      for (let i = 0; i < attrs.length; i++) {
        const attrName = attrs[i].name;
        attribs[attrName] = attrs[i].value;
        attribsNamespace[attrName] = attrs[i].namespace;
        attribsPrefix[attrName] = attrs[i].prefix;
      }
      const node2 = new domhandler_12.Element(tagName, attribs, []);
      node2.namespace = namespaceURI;
      node2["x-attribsNamespace"] = attribsNamespace;
      node2["x-attribsPrefix"] = attribsPrefix;
      return node2;
    },
    createCommentNode(data2) {
      return new domhandler_12.Comment(data2);
    },
    //Tree mutation
    appendChild(parentNode, newNode) {
      const prev = parentNode.children[parentNode.children.length - 1];
      if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
      }
      parentNode.children.push(newNode);
      newNode.parent = parentNode;
    },
    insertBefore(parentNode, newNode, referenceNode) {
      const insertionIdx = parentNode.children.indexOf(referenceNode);
      const {
        prev
      } = referenceNode;
      if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
      }
      referenceNode.prev = newNode;
      newNode.next = referenceNode;
      parentNode.children.splice(insertionIdx, 0, newNode);
      newNode.parent = parentNode;
    },
    setTemplateContent(templateElement, contentElement) {
      exports2.adapter.appendChild(templateElement, contentElement);
    },
    getTemplateContent(templateElement) {
      return templateElement.children[0];
    },
    setDocumentType(document2, name, publicId, systemId) {
      const data2 = serializeDoctypeContent(name, publicId, systemId);
      let doctypeNode = document2.children.find((node2) => (0, domhandler_12.isDirective)(node2) && node2.name === "!doctype");
      if (doctypeNode) {
        doctypeNode.data = data2 !== null && data2 !== void 0 ? data2 : null;
      } else {
        doctypeNode = new domhandler_12.ProcessingInstruction("!doctype", data2);
        exports2.adapter.appendChild(document2, doctypeNode);
      }
      doctypeNode["x-name"] = name !== null && name !== void 0 ? name : void 0;
      doctypeNode["x-publicId"] = publicId !== null && publicId !== void 0 ? publicId : void 0;
      doctypeNode["x-systemId"] = systemId !== null && systemId !== void 0 ? systemId : void 0;
    },
    setDocumentMode(document2, mode) {
      document2["x-mode"] = mode;
    },
    getDocumentMode(document2) {
      return document2["x-mode"];
    },
    detachNode(node2) {
      if (node2.parent) {
        const idx = node2.parent.children.indexOf(node2);
        const {
          prev,
          next
        } = node2;
        node2.prev = null;
        node2.next = null;
        if (prev) {
          prev.next = next;
        }
        if (next) {
          next.prev = prev;
        }
        node2.parent.children.splice(idx, 1);
        node2.parent = null;
      }
    },
    insertText(parentNode, text2) {
      const lastChild = parentNode.children[parentNode.children.length - 1];
      if (lastChild && (0, domhandler_12.isText)(lastChild)) {
        lastChild.data += text2;
      } else {
        exports2.adapter.appendChild(parentNode, createTextNode(text2));
      }
    },
    insertTextBefore(parentNode, text2, referenceNode) {
      const prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];
      if (prevNode && (0, domhandler_12.isText)(prevNode)) {
        prevNode.data += text2;
      } else {
        exports2.adapter.insertBefore(parentNode, createTextNode(text2), referenceNode);
      }
    },
    adoptAttributes(recipient, attrs) {
      for (let i = 0; i < attrs.length; i++) {
        const attrName = attrs[i].name;
        if (typeof recipient.attribs[attrName] === "undefined") {
          recipient.attribs[attrName] = attrs[i].value;
          recipient["x-attribsNamespace"][attrName] = attrs[i].namespace;
          recipient["x-attribsPrefix"][attrName] = attrs[i].prefix;
        }
      }
    },
    //Tree traversing
    getFirstChild(node2) {
      return node2.children[0];
    },
    getChildNodes(node2) {
      return node2.children;
    },
    getParentNode(node2) {
      return node2.parent;
    },
    getAttrList(element) {
      return element.attributes;
    },
    //Node data
    getTagName(element) {
      return element.name;
    },
    getNamespaceURI(element) {
      return element.namespace;
    },
    getTextNodeContent(textNode) {
      return textNode.data;
    },
    getCommentNodeContent(commentNode) {
      return commentNode.data;
    },
    getDocumentTypeNodeName(doctypeNode) {
      var _a;
      return (_a = doctypeNode["x-name"]) !== null && _a !== void 0 ? _a : "";
    },
    getDocumentTypeNodePublicId(doctypeNode) {
      var _a;
      return (_a = doctypeNode["x-publicId"]) !== null && _a !== void 0 ? _a : "";
    },
    getDocumentTypeNodeSystemId(doctypeNode) {
      var _a;
      return (_a = doctypeNode["x-systemId"]) !== null && _a !== void 0 ? _a : "";
    },
    //Node types
    isDocumentTypeNode(node2) {
      return (0, domhandler_12.isDirective)(node2) && node2.name === "!doctype";
    },
    // Source code location
    setNodeSourceCodeLocation(node2, location) {
      if (location) {
        node2.startIndex = location.startOffset;
        node2.endIndex = location.endOffset;
      }
      node2.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation(node2) {
      return node2.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(node2, endLocation) {
      if (endLocation.endOffset != null)
        node2.endIndex = endLocation.endOffset;
      node2.sourceCodeLocation = Object.assign(Object.assign({}, node2.sourceCodeLocation), endLocation);
    }
  };
})(cjs$1);
var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(parse5Adapter, "__esModule", {
  value: true
});
parse5Adapter.renderWithParse5 = parse5Adapter.parseWithParse5 = void 0;
var domhandler_1 = lib$a;
var parse5_1 = cjs$2;
var parse5_htmlparser2_tree_adapter_1 = cjs$1;
function parseWithParse5(content, options2, isDocument2, context) {
  var opts = {
    scriptingEnabled: typeof options2.scriptingEnabled === "boolean" ? options2.scriptingEnabled : true,
    treeAdapter: parse5_htmlparser2_tree_adapter_1.adapter,
    sourceCodeLocationInfo: options2.sourceCodeLocationInfo
  };
  return isDocument2 ? (0, parse5_1.parse)(content, opts) : (0, parse5_1.parseFragment)(context, content, opts);
}
parse5Adapter.parseWithParse5 = parseWithParse5;
var renderOpts = {
  treeAdapter: parse5_htmlparser2_tree_adapter_1.adapter
};
function renderWithParse5(dom) {
  var _a;
  var nodes = "length" in dom ? dom : [dom];
  for (var index2 = 0; index2 < nodes.length; index2 += 1) {
    var node2 = nodes[index2];
    if ((0, domhandler_1.isDocument)(node2)) {
      (_a = Array.prototype.splice).call.apply(_a, __spreadArray([nodes, index2, 1], node2.children, false));
    }
  }
  var result = "";
  for (var index2 = 0; index2 < nodes.length; index2 += 1) {
    var node2 = nodes[index2];
    result += (0, parse5_1.serializeOuter)(node2, renderOpts);
  }
  return result;
}
parse5Adapter.renderWithParse5 = renderWithParse5;
var lib$3 = {};
var Parser$1 = {};
var Tokenizer = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.QuoteType = void 0;
  var decode_js_12 = decode;
  var CharCodes;
  (function(CharCodes2) {
    CharCodes2[CharCodes2["Tab"] = 9] = "Tab";
    CharCodes2[CharCodes2["NewLine"] = 10] = "NewLine";
    CharCodes2[CharCodes2["FormFeed"] = 12] = "FormFeed";
    CharCodes2[CharCodes2["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes2[CharCodes2["Space"] = 32] = "Space";
    CharCodes2[CharCodes2["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes2[CharCodes2["Number"] = 35] = "Number";
    CharCodes2[CharCodes2["Amp"] = 38] = "Amp";
    CharCodes2[CharCodes2["SingleQuote"] = 39] = "SingleQuote";
    CharCodes2[CharCodes2["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes2[CharCodes2["Dash"] = 45] = "Dash";
    CharCodes2[CharCodes2["Slash"] = 47] = "Slash";
    CharCodes2[CharCodes2["Zero"] = 48] = "Zero";
    CharCodes2[CharCodes2["Nine"] = 57] = "Nine";
    CharCodes2[CharCodes2["Semi"] = 59] = "Semi";
    CharCodes2[CharCodes2["Lt"] = 60] = "Lt";
    CharCodes2[CharCodes2["Eq"] = 61] = "Eq";
    CharCodes2[CharCodes2["Gt"] = 62] = "Gt";
    CharCodes2[CharCodes2["Questionmark"] = 63] = "Questionmark";
    CharCodes2[CharCodes2["UpperA"] = 65] = "UpperA";
    CharCodes2[CharCodes2["LowerA"] = 97] = "LowerA";
    CharCodes2[CharCodes2["UpperF"] = 70] = "UpperF";
    CharCodes2[CharCodes2["LowerF"] = 102] = "LowerF";
    CharCodes2[CharCodes2["UpperZ"] = 90] = "UpperZ";
    CharCodes2[CharCodes2["LowerZ"] = 122] = "LowerZ";
    CharCodes2[CharCodes2["LowerX"] = 120] = "LowerX";
    CharCodes2[CharCodes2["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
  })(CharCodes || (CharCodes = {}));
  var State2;
  (function(State3) {
    State3[State3["Text"] = 1] = "Text";
    State3[State3["BeforeTagName"] = 2] = "BeforeTagName";
    State3[State3["InTagName"] = 3] = "InTagName";
    State3[State3["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State3[State3["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State3[State3["InClosingTagName"] = 6] = "InClosingTagName";
    State3[State3["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    State3[State3["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State3[State3["InAttributeName"] = 9] = "InAttributeName";
    State3[State3["AfterAttributeName"] = 10] = "AfterAttributeName";
    State3[State3["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State3[State3["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State3[State3["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State3[State3["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    State3[State3["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State3[State3["InDeclaration"] = 16] = "InDeclaration";
    State3[State3["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    State3[State3["BeforeComment"] = 18] = "BeforeComment";
    State3[State3["CDATASequence"] = 19] = "CDATASequence";
    State3[State3["InSpecialComment"] = 20] = "InSpecialComment";
    State3[State3["InCommentLike"] = 21] = "InCommentLike";
    State3[State3["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State3[State3["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State3[State3["InSpecialTag"] = 24] = "InSpecialTag";
    State3[State3["BeforeEntity"] = 25] = "BeforeEntity";
    State3[State3["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State3[State3["InNamedEntity"] = 27] = "InNamedEntity";
    State3[State3["InNumericEntity"] = 28] = "InNumericEntity";
    State3[State3["InHexEntity"] = 29] = "InHexEntity";
  })(State2 || (State2 = {}));
  function isWhitespace2(c2) {
    return c2 === CharCodes.Space || c2 === CharCodes.NewLine || c2 === CharCodes.Tab || c2 === CharCodes.FormFeed || c2 === CharCodes.CarriageReturn;
  }
  function isEndOfTagSection(c2) {
    return c2 === CharCodes.Slash || c2 === CharCodes.Gt || isWhitespace2(c2);
  }
  function isNumber2(c2) {
    return c2 >= CharCodes.Zero && c2 <= CharCodes.Nine;
  }
  function isASCIIAlpha(c2) {
    return c2 >= CharCodes.LowerA && c2 <= CharCodes.LowerZ || c2 >= CharCodes.UpperA && c2 <= CharCodes.UpperZ;
  }
  function isHexDigit(c2) {
    return c2 >= CharCodes.UpperA && c2 <= CharCodes.UpperF || c2 >= CharCodes.LowerA && c2 <= CharCodes.LowerF;
  }
  var QuoteType;
  (function(QuoteType2) {
    QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
    QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
    QuoteType2[QuoteType2["Single"] = 2] = "Single";
    QuoteType2[QuoteType2["Double"] = 3] = "Double";
  })(QuoteType = exports2.QuoteType || (exports2.QuoteType = {}));
  var Sequences = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  };
  var Tokenizer2 = (
    /** @class */
    function() {
      function Tokenizer3(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        this.state = State2.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = State2.Text;
        this.isSpecial = false;
        this.running = true;
        this.offset = 0;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? decode_js_12.xmlDecodeTree : decode_js_12.htmlDecodeTree;
      }
      Tokenizer3.prototype.reset = function() {
        this.state = State2.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = State2.Text;
        this.currentSequence = void 0;
        this.running = true;
        this.offset = 0;
      };
      Tokenizer3.prototype.write = function(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
      };
      Tokenizer3.prototype.end = function() {
        if (this.running)
          this.finish();
      };
      Tokenizer3.prototype.pause = function() {
        this.running = false;
      };
      Tokenizer3.prototype.resume = function() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) {
          this.parse();
        }
      };
      Tokenizer3.prototype.getIndex = function() {
        return this.index;
      };
      Tokenizer3.prototype.getSectionStart = function() {
        return this.sectionStart;
      };
      Tokenizer3.prototype.stateText = function(c2) {
        if (c2 === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
          if (this.index > this.sectionStart) {
            this.cbs.ontext(this.sectionStart, this.index);
          }
          this.state = State2.BeforeTagName;
          this.sectionStart = this.index;
        } else if (this.decodeEntities && c2 === CharCodes.Amp) {
          this.state = State2.BeforeEntity;
        }
      };
      Tokenizer3.prototype.stateSpecialStartSequence = function(c2) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          isEndOfTagSection(c2)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (c2 | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!isMatch) {
          this.isSpecial = false;
        } else if (!isEnd) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0;
        this.state = State2.InTagName;
        this.stateInTagName(c2);
      };
      Tokenizer3.prototype.stateInSpecialTag = function(c2) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (c2 === CharCodes.Gt || isWhitespace2(c2)) {
            var endOfText = this.index - this.currentSequence.length;
            if (this.sectionStart < endOfText) {
              var actualIndex = this.index;
              this.index = endOfText;
              this.cbs.ontext(this.sectionStart, endOfText);
              this.index = actualIndex;
            }
            this.isSpecial = false;
            this.sectionStart = endOfText + 2;
            this.stateInClosingTagName(c2);
            return;
          }
          this.sequenceIndex = 0;
        }
        if ((c2 | 32) === this.currentSequence[this.sequenceIndex]) {
          this.sequenceIndex += 1;
        } else if (this.sequenceIndex === 0) {
          if (this.currentSequence === Sequences.TitleEnd) {
            if (this.decodeEntities && c2 === CharCodes.Amp) {
              this.state = State2.BeforeEntity;
            }
          } else if (this.fastForwardTo(CharCodes.Lt)) {
            this.sequenceIndex = 1;
          }
        } else {
          this.sequenceIndex = Number(c2 === CharCodes.Lt);
        }
      };
      Tokenizer3.prototype.stateCDATASequence = function(c2) {
        if (c2 === Sequences.Cdata[this.sequenceIndex]) {
          if (++this.sequenceIndex === Sequences.Cdata.length) {
            this.state = State2.InCommentLike;
            this.currentSequence = Sequences.CdataEnd;
            this.sequenceIndex = 0;
            this.sectionStart = this.index + 1;
          }
        } else {
          this.sequenceIndex = 0;
          this.state = State2.InDeclaration;
          this.stateInDeclaration(c2);
        }
      };
      Tokenizer3.prototype.fastForwardTo = function(c2) {
        while (++this.index < this.buffer.length + this.offset) {
          if (this.buffer.charCodeAt(this.index - this.offset) === c2) {
            return true;
          }
        }
        this.index = this.buffer.length + this.offset - 1;
        return false;
      };
      Tokenizer3.prototype.stateInCommentLike = function(c2) {
        if (c2 === this.currentSequence[this.sequenceIndex]) {
          if (++this.sequenceIndex === this.currentSequence.length) {
            if (this.currentSequence === Sequences.CdataEnd) {
              this.cbs.oncdata(this.sectionStart, this.index, 2);
            } else {
              this.cbs.oncomment(this.sectionStart, this.index, 2);
            }
            this.sequenceIndex = 0;
            this.sectionStart = this.index + 1;
            this.state = State2.Text;
          }
        } else if (this.sequenceIndex === 0) {
          if (this.fastForwardTo(this.currentSequence[0])) {
            this.sequenceIndex = 1;
          }
        } else if (c2 !== this.currentSequence[this.sequenceIndex - 1]) {
          this.sequenceIndex = 0;
        }
      };
      Tokenizer3.prototype.isTagStartChar = function(c2) {
        return this.xmlMode ? !isEndOfTagSection(c2) : isASCIIAlpha(c2);
      };
      Tokenizer3.prototype.startSpecial = function(sequence, offset2) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset2;
        this.state = State2.SpecialStartSequence;
      };
      Tokenizer3.prototype.stateBeforeTagName = function(c2) {
        if (c2 === CharCodes.ExclamationMark) {
          this.state = State2.BeforeDeclaration;
          this.sectionStart = this.index + 1;
        } else if (c2 === CharCodes.Questionmark) {
          this.state = State2.InProcessingInstruction;
          this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c2)) {
          var lower2 = c2 | 32;
          this.sectionStart = this.index;
          if (!this.xmlMode && lower2 === Sequences.TitleEnd[2]) {
            this.startSpecial(Sequences.TitleEnd, 3);
          } else {
            this.state = !this.xmlMode && lower2 === Sequences.ScriptEnd[2] ? State2.BeforeSpecialS : State2.InTagName;
          }
        } else if (c2 === CharCodes.Slash) {
          this.state = State2.BeforeClosingTagName;
        } else {
          this.state = State2.Text;
          this.stateText(c2);
        }
      };
      Tokenizer3.prototype.stateInTagName = function(c2) {
        if (isEndOfTagSection(c2)) {
          this.cbs.onopentagname(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State2.BeforeAttributeName;
          this.stateBeforeAttributeName(c2);
        }
      };
      Tokenizer3.prototype.stateBeforeClosingTagName = function(c2) {
        if (isWhitespace2(c2))
          ;
        else if (c2 === CharCodes.Gt) {
          this.state = State2.Text;
        } else {
          this.state = this.isTagStartChar(c2) ? State2.InClosingTagName : State2.InSpecialComment;
          this.sectionStart = this.index;
        }
      };
      Tokenizer3.prototype.stateInClosingTagName = function(c2) {
        if (c2 === CharCodes.Gt || isWhitespace2(c2)) {
          this.cbs.onclosetag(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State2.AfterClosingTagName;
          this.stateAfterClosingTagName(c2);
        }
      };
      Tokenizer3.prototype.stateAfterClosingTagName = function(c2) {
        if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.state = State2.Text;
          this.baseState = State2.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer3.prototype.stateBeforeAttributeName = function(c2) {
        if (c2 === CharCodes.Gt) {
          this.cbs.onopentagend(this.index);
          if (this.isSpecial) {
            this.state = State2.InSpecialTag;
            this.sequenceIndex = 0;
          } else {
            this.state = State2.Text;
          }
          this.baseState = this.state;
          this.sectionStart = this.index + 1;
        } else if (c2 === CharCodes.Slash) {
          this.state = State2.InSelfClosingTag;
        } else if (!isWhitespace2(c2)) {
          this.state = State2.InAttributeName;
          this.sectionStart = this.index;
        }
      };
      Tokenizer3.prototype.stateInSelfClosingTag = function(c2) {
        if (c2 === CharCodes.Gt) {
          this.cbs.onselfclosingtag(this.index);
          this.state = State2.Text;
          this.baseState = State2.Text;
          this.sectionStart = this.index + 1;
          this.isSpecial = false;
        } else if (!isWhitespace2(c2)) {
          this.state = State2.BeforeAttributeName;
          this.stateBeforeAttributeName(c2);
        }
      };
      Tokenizer3.prototype.stateInAttributeName = function(c2) {
        if (c2 === CharCodes.Eq || isEndOfTagSection(c2)) {
          this.cbs.onattribname(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State2.AfterAttributeName;
          this.stateAfterAttributeName(c2);
        }
      };
      Tokenizer3.prototype.stateAfterAttributeName = function(c2) {
        if (c2 === CharCodes.Eq) {
          this.state = State2.BeforeAttributeValue;
        } else if (c2 === CharCodes.Slash || c2 === CharCodes.Gt) {
          this.cbs.onattribend(QuoteType.NoValue, this.index);
          this.state = State2.BeforeAttributeName;
          this.stateBeforeAttributeName(c2);
        } else if (!isWhitespace2(c2)) {
          this.cbs.onattribend(QuoteType.NoValue, this.index);
          this.state = State2.InAttributeName;
          this.sectionStart = this.index;
        }
      };
      Tokenizer3.prototype.stateBeforeAttributeValue = function(c2) {
        if (c2 === CharCodes.DoubleQuote) {
          this.state = State2.InAttributeValueDq;
          this.sectionStart = this.index + 1;
        } else if (c2 === CharCodes.SingleQuote) {
          this.state = State2.InAttributeValueSq;
          this.sectionStart = this.index + 1;
        } else if (!isWhitespace2(c2)) {
          this.sectionStart = this.index;
          this.state = State2.InAttributeValueNq;
          this.stateInAttributeValueNoQuotes(c2);
        }
      };
      Tokenizer3.prototype.handleInAttributeValue = function(c2, quote2) {
        if (c2 === quote2 || !this.decodeEntities && this.fastForwardTo(quote2)) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.cbs.onattribend(quote2 === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
          this.state = State2.BeforeAttributeName;
        } else if (this.decodeEntities && c2 === CharCodes.Amp) {
          this.baseState = this.state;
          this.state = State2.BeforeEntity;
        }
      };
      Tokenizer3.prototype.stateInAttributeValueDoubleQuotes = function(c2) {
        this.handleInAttributeValue(c2, CharCodes.DoubleQuote);
      };
      Tokenizer3.prototype.stateInAttributeValueSingleQuotes = function(c2) {
        this.handleInAttributeValue(c2, CharCodes.SingleQuote);
      };
      Tokenizer3.prototype.stateInAttributeValueNoQuotes = function(c2) {
        if (isWhitespace2(c2) || c2 === CharCodes.Gt) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.cbs.onattribend(QuoteType.Unquoted, this.index);
          this.state = State2.BeforeAttributeName;
          this.stateBeforeAttributeName(c2);
        } else if (this.decodeEntities && c2 === CharCodes.Amp) {
          this.baseState = this.state;
          this.state = State2.BeforeEntity;
        }
      };
      Tokenizer3.prototype.stateBeforeDeclaration = function(c2) {
        if (c2 === CharCodes.OpeningSquareBracket) {
          this.state = State2.CDATASequence;
          this.sequenceIndex = 0;
        } else {
          this.state = c2 === CharCodes.Dash ? State2.BeforeComment : State2.InDeclaration;
        }
      };
      Tokenizer3.prototype.stateInDeclaration = function(c2) {
        if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.ondeclaration(this.sectionStart, this.index);
          this.state = State2.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer3.prototype.stateInProcessingInstruction = function(c2) {
        if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.onprocessinginstruction(this.sectionStart, this.index);
          this.state = State2.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer3.prototype.stateBeforeComment = function(c2) {
        if (c2 === CharCodes.Dash) {
          this.state = State2.InCommentLike;
          this.currentSequence = Sequences.CommentEnd;
          this.sequenceIndex = 2;
          this.sectionStart = this.index + 1;
        } else {
          this.state = State2.InDeclaration;
        }
      };
      Tokenizer3.prototype.stateInSpecialComment = function(c2) {
        if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.oncomment(this.sectionStart, this.index, 0);
          this.state = State2.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer3.prototype.stateBeforeSpecialS = function(c2) {
        var lower2 = c2 | 32;
        if (lower2 === Sequences.ScriptEnd[3]) {
          this.startSpecial(Sequences.ScriptEnd, 4);
        } else if (lower2 === Sequences.StyleEnd[3]) {
          this.startSpecial(Sequences.StyleEnd, 4);
        } else {
          this.state = State2.InTagName;
          this.stateInTagName(c2);
        }
      };
      Tokenizer3.prototype.stateBeforeEntity = function(c2) {
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c2 === CharCodes.Number) {
          this.state = State2.BeforeNumericEntity;
        } else if (c2 === CharCodes.Amp)
          ;
        else {
          this.trieIndex = 0;
          this.trieCurrent = this.entityTrie[0];
          this.state = State2.InNamedEntity;
          this.stateInNamedEntity(c2);
        }
      };
      Tokenizer3.prototype.stateInNamedEntity = function(c2) {
        this.entityExcess += 1;
        this.trieIndex = (0, decode_js_12.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c2);
        if (this.trieIndex < 0) {
          this.emitNamedEntity();
          this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var masked = this.trieCurrent & decode_js_12.BinTrieFlags.VALUE_LENGTH;
        if (masked) {
          var valueLength = (masked >> 14) - 1;
          if (!this.allowLegacyEntity() && c2 !== CharCodes.Semi) {
            this.trieIndex += valueLength;
          } else {
            var entityStart = this.index - this.entityExcess + 1;
            if (entityStart > this.sectionStart) {
              this.emitPartial(this.sectionStart, entityStart);
            }
            this.entityResult = this.trieIndex;
            this.trieIndex += valueLength;
            this.entityExcess = 0;
            this.sectionStart = this.index + 1;
            if (valueLength === 0) {
              this.emitNamedEntity();
            }
          }
        }
      };
      Tokenizer3.prototype.emitNamedEntity = function() {
        this.state = this.baseState;
        if (this.entityResult === 0) {
          return;
        }
        var valueLength = (this.entityTrie[this.entityResult] & decode_js_12.BinTrieFlags.VALUE_LENGTH) >> 14;
        switch (valueLength) {
          case 1: {
            this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_js_12.BinTrieFlags.VALUE_LENGTH);
            break;
          }
          case 2: {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            break;
          }
          case 3: {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      };
      Tokenizer3.prototype.stateBeforeNumericEntity = function(c2) {
        if ((c2 | 32) === CharCodes.LowerX) {
          this.entityExcess++;
          this.state = State2.InHexEntity;
        } else {
          this.state = State2.InNumericEntity;
          this.stateInNumericEntity(c2);
        }
      };
      Tokenizer3.prototype.emitNumericEntity = function(strict) {
        var entityStart = this.index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + Number(this.state === State2.InHexEntity);
        if (numberStart !== this.index) {
          if (entityStart > this.sectionStart) {
            this.emitPartial(this.sectionStart, entityStart);
          }
          this.sectionStart = this.index + Number(strict);
          this.emitCodePoint((0, decode_js_12.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
      };
      Tokenizer3.prototype.stateInNumericEntity = function(c2) {
        if (c2 === CharCodes.Semi) {
          this.emitNumericEntity(true);
        } else if (isNumber2(c2)) {
          this.entityResult = this.entityResult * 10 + (c2 - CharCodes.Zero);
          this.entityExcess++;
        } else {
          if (this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else {
            this.state = this.baseState;
          }
          this.index--;
        }
      };
      Tokenizer3.prototype.stateInHexEntity = function(c2) {
        if (c2 === CharCodes.Semi) {
          this.emitNumericEntity(true);
        } else if (isNumber2(c2)) {
          this.entityResult = this.entityResult * 16 + (c2 - CharCodes.Zero);
          this.entityExcess++;
        } else if (isHexDigit(c2)) {
          this.entityResult = this.entityResult * 16 + ((c2 | 32) - CharCodes.LowerA + 10);
          this.entityExcess++;
        } else {
          if (this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else {
            this.state = this.baseState;
          }
          this.index--;
        }
      };
      Tokenizer3.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === State2.Text || this.baseState === State2.InSpecialTag);
      };
      Tokenizer3.prototype.cleanup = function() {
        if (this.running && this.sectionStart !== this.index) {
          if (this.state === State2.Text || this.state === State2.InSpecialTag && this.sequenceIndex === 0) {
            this.cbs.ontext(this.sectionStart, this.index);
            this.sectionStart = this.index;
          } else if (this.state === State2.InAttributeValueDq || this.state === State2.InAttributeValueSq || this.state === State2.InAttributeValueNq) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = this.index;
          }
        }
      };
      Tokenizer3.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      };
      Tokenizer3.prototype.parse = function() {
        while (this.shouldContinue()) {
          var c2 = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case State2.Text: {
              this.stateText(c2);
              break;
            }
            case State2.SpecialStartSequence: {
              this.stateSpecialStartSequence(c2);
              break;
            }
            case State2.InSpecialTag: {
              this.stateInSpecialTag(c2);
              break;
            }
            case State2.CDATASequence: {
              this.stateCDATASequence(c2);
              break;
            }
            case State2.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(c2);
              break;
            }
            case State2.InAttributeName: {
              this.stateInAttributeName(c2);
              break;
            }
            case State2.InCommentLike: {
              this.stateInCommentLike(c2);
              break;
            }
            case State2.InSpecialComment: {
              this.stateInSpecialComment(c2);
              break;
            }
            case State2.BeforeAttributeName: {
              this.stateBeforeAttributeName(c2);
              break;
            }
            case State2.InTagName: {
              this.stateInTagName(c2);
              break;
            }
            case State2.InClosingTagName: {
              this.stateInClosingTagName(c2);
              break;
            }
            case State2.BeforeTagName: {
              this.stateBeforeTagName(c2);
              break;
            }
            case State2.AfterAttributeName: {
              this.stateAfterAttributeName(c2);
              break;
            }
            case State2.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(c2);
              break;
            }
            case State2.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(c2);
              break;
            }
            case State2.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(c2);
              break;
            }
            case State2.AfterClosingTagName: {
              this.stateAfterClosingTagName(c2);
              break;
            }
            case State2.BeforeSpecialS: {
              this.stateBeforeSpecialS(c2);
              break;
            }
            case State2.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(c2);
              break;
            }
            case State2.InSelfClosingTag: {
              this.stateInSelfClosingTag(c2);
              break;
            }
            case State2.InDeclaration: {
              this.stateInDeclaration(c2);
              break;
            }
            case State2.BeforeDeclaration: {
              this.stateBeforeDeclaration(c2);
              break;
            }
            case State2.BeforeComment: {
              this.stateBeforeComment(c2);
              break;
            }
            case State2.InProcessingInstruction: {
              this.stateInProcessingInstruction(c2);
              break;
            }
            case State2.InNamedEntity: {
              this.stateInNamedEntity(c2);
              break;
            }
            case State2.BeforeEntity: {
              this.stateBeforeEntity(c2);
              break;
            }
            case State2.InHexEntity: {
              this.stateInHexEntity(c2);
              break;
            }
            case State2.InNumericEntity: {
              this.stateInNumericEntity(c2);
              break;
            }
            default: {
              this.stateBeforeNumericEntity(c2);
            }
          }
          this.index++;
        }
        this.cleanup();
      };
      Tokenizer3.prototype.finish = function() {
        if (this.state === State2.InNamedEntity) {
          this.emitNamedEntity();
        }
        if (this.sectionStart < this.index) {
          this.handleTrailingData();
        }
        this.cbs.onend();
      };
      Tokenizer3.prototype.handleTrailingData = function() {
        var endIndex = this.buffer.length + this.offset;
        if (this.state === State2.InCommentLike) {
          if (this.currentSequence === Sequences.CdataEnd) {
            this.cbs.oncdata(this.sectionStart, endIndex, 0);
          } else {
            this.cbs.oncomment(this.sectionStart, endIndex, 0);
          }
        } else if (this.state === State2.InNumericEntity && this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else if (this.state === State2.InHexEntity && this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else if (this.state === State2.InTagName || this.state === State2.BeforeAttributeName || this.state === State2.BeforeAttributeValue || this.state === State2.AfterAttributeName || this.state === State2.InAttributeName || this.state === State2.InAttributeValueSq || this.state === State2.InAttributeValueDq || this.state === State2.InAttributeValueNq || this.state === State2.InClosingTagName)
          ;
        else {
          this.cbs.ontext(this.sectionStart, endIndex);
        }
      };
      Tokenizer3.prototype.emitPartial = function(start2, endIndex) {
        if (this.baseState !== State2.Text && this.baseState !== State2.InSpecialTag) {
          this.cbs.onattribdata(start2, endIndex);
        } else {
          this.cbs.ontext(start2, endIndex);
        }
      };
      Tokenizer3.prototype.emitCodePoint = function(cp) {
        if (this.baseState !== State2.Text && this.baseState !== State2.InSpecialTag) {
          this.cbs.onattribentity(cp);
        } else {
          this.cbs.ontextentity(cp);
        }
      };
      return Tokenizer3;
    }()
  );
  exports2.default = Tokenizer2;
})(Tokenizer);
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function(o, v) {
  o["default"] = v;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding(result, mod2, k);
  }
  __setModuleDefault(result, mod2);
  return result;
};
Object.defineProperty(Parser$1, "__esModule", {
  value: true
});
Parser$1.Parser = void 0;
var Tokenizer_js_1 = __importStar(Tokenizer);
var decode_js_1 = decode;
var formTags = /* @__PURE__ */ new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]);
var pTag = /* @__PURE__ */ new Set(["p"]);
var tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]);
var ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]);
var rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]);
var openImpliesClose = /* @__PURE__ */ new Map([["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])], ["th", /* @__PURE__ */ new Set(["th"])], ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])], ["body", /* @__PURE__ */ new Set(["head", "link", "script"])], ["li", /* @__PURE__ */ new Set(["li"])], ["p", pTag], ["h1", pTag], ["h2", pTag], ["h3", pTag], ["h4", pTag], ["h5", pTag], ["h6", pTag], ["select", formTags], ["input", formTags], ["output", formTags], ["button", formTags], ["datalist", formTags], ["textarea", formTags], ["option", /* @__PURE__ */ new Set(["option"])], ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])], ["dd", ddtTags], ["dt", ddtTags], ["address", pTag], ["article", pTag], ["aside", pTag], ["blockquote", pTag], ["details", pTag], ["div", pTag], ["dl", pTag], ["fieldset", pTag], ["figcaption", pTag], ["figure", pTag], ["footer", pTag], ["form", pTag], ["header", pTag], ["hr", pTag], ["main", pTag], ["nav", pTag], ["ol", pTag], ["pre", pTag], ["section", pTag], ["table", pTag], ["ul", pTag], ["rt", rtpTags], ["rp", rtpTags], ["tbody", tableSectionTags], ["tfoot", tableSectionTags]]);
var voidElements = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
var htmlIntegrationElements = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]);
var reNameEnd = /\s|\//;
var Parser = (
  /** @class */
  function() {
    function Parser2(cbs, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      var _a, _b, _c, _d, _e;
      this.options = options2;
      this.startIndex = 0;
      this.endIndex = 0;
      this.openTagStart = 0;
      this.tagname = "";
      this.attribname = "";
      this.attribvalue = "";
      this.attribs = null;
      this.stack = [];
      this.foreignContext = [];
      this.buffers = [];
      this.bufferOffset = 0;
      this.writeIndex = 0;
      this.ended = false;
      this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
      this.lowerCaseTagNames = (_a = options2.lowerCaseTags) !== null && _a !== void 0 ? _a : !options2.xmlMode;
      this.lowerCaseAttributeNames = (_b = options2.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options2.xmlMode;
      this.tokenizer = new ((_c = options2.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
      (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    Parser2.prototype.ontext = function(start2, endIndex) {
      var _a, _b;
      var data2 = this.getSlice(start2, endIndex);
      this.endIndex = endIndex - 1;
      (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data2);
      this.startIndex = endIndex;
    };
    Parser2.prototype.ontextentity = function(cp) {
      var _a, _b;
      var index2 = this.tokenizer.getSectionStart();
      this.endIndex = index2 - 1;
      (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
      this.startIndex = index2;
    };
    Parser2.prototype.isVoidElement = function(name) {
      return !this.options.xmlMode && voidElements.has(name);
    };
    Parser2.prototype.onopentagname = function(start2, endIndex) {
      this.endIndex = endIndex;
      var name = this.getSlice(start2, endIndex);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      this.emitOpenTag(name);
    };
    Parser2.prototype.emitOpenTag = function(name) {
      var _a, _b, _c, _d;
      this.openTagStart = this.startIndex;
      this.tagname = name;
      var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
      if (impliesClose) {
        while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
          var element = this.stack.pop();
          (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
        }
      }
      if (!this.isVoidElement(name)) {
        this.stack.push(name);
        if (foreignContextElements.has(name)) {
          this.foreignContext.push(true);
        } else if (htmlIntegrationElements.has(name)) {
          this.foreignContext.push(false);
        }
      }
      (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
      if (this.cbs.onopentag)
        this.attribs = {};
    };
    Parser2.prototype.endOpenTag = function(isImplied) {
      var _a, _b;
      this.startIndex = this.openTagStart;
      if (this.attribs) {
        (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
        this.attribs = null;
      }
      if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
        this.cbs.onclosetag(this.tagname, true);
      }
      this.tagname = "";
    };
    Parser2.prototype.onopentagend = function(endIndex) {
      this.endIndex = endIndex;
      this.endOpenTag(false);
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.onclosetag = function(start2, endIndex) {
      var _a, _b, _c, _d, _e, _f;
      this.endIndex = endIndex;
      var name = this.getSlice(start2, endIndex);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
        this.foreignContext.pop();
      }
      if (!this.isVoidElement(name)) {
        var pos = this.stack.lastIndexOf(name);
        if (pos !== -1) {
          if (this.cbs.onclosetag) {
            var count2 = this.stack.length - pos;
            while (count2--) {
              this.cbs.onclosetag(this.stack.pop(), count2 !== 0);
            }
          } else
            this.stack.length = pos;
        } else if (!this.options.xmlMode && name === "p") {
          this.emitOpenTag("p");
          this.closeCurrentTag(true);
        }
      } else if (!this.options.xmlMode && name === "br") {
        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
        (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
        (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
      }
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.onselfclosingtag = function(endIndex) {
      this.endIndex = endIndex;
      if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
        this.closeCurrentTag(false);
        this.startIndex = endIndex + 1;
      } else {
        this.onopentagend(endIndex);
      }
    };
    Parser2.prototype.closeCurrentTag = function(isOpenImplied) {
      var _a, _b;
      var name = this.tagname;
      this.endOpenTag(isOpenImplied);
      if (this.stack[this.stack.length - 1] === name) {
        (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
        this.stack.pop();
      }
    };
    Parser2.prototype.onattribname = function(start2, endIndex) {
      this.startIndex = start2;
      var name = this.getSlice(start2, endIndex);
      this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    };
    Parser2.prototype.onattribdata = function(start2, endIndex) {
      this.attribvalue += this.getSlice(start2, endIndex);
    };
    Parser2.prototype.onattribentity = function(cp) {
      this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
    };
    Parser2.prototype.onattribend = function(quote2, endIndex) {
      var _a, _b;
      this.endIndex = endIndex;
      (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote2 === Tokenizer_js_1.QuoteType.Double ? '"' : quote2 === Tokenizer_js_1.QuoteType.Single ? "'" : quote2 === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null);
      if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
        this.attribs[this.attribname] = this.attribvalue;
      }
      this.attribvalue = "";
    };
    Parser2.prototype.getInstructionName = function(value2) {
      var index2 = value2.search(reNameEnd);
      var name = index2 < 0 ? value2 : value2.substr(0, index2);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      return name;
    };
    Parser2.prototype.ondeclaration = function(start2, endIndex) {
      this.endIndex = endIndex;
      var value2 = this.getSlice(start2, endIndex);
      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value2);
        this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value2));
      }
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.onprocessinginstruction = function(start2, endIndex) {
      this.endIndex = endIndex;
      var value2 = this.getSlice(start2, endIndex);
      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value2);
        this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value2));
      }
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.oncomment = function(start2, endIndex, offset2) {
      var _a, _b, _c, _d;
      this.endIndex = endIndex;
      (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start2, endIndex - offset2));
      (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.oncdata = function(start2, endIndex, offset2) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      this.endIndex = endIndex;
      var value2 = this.getSlice(start2, endIndex - offset2);
      if (this.options.xmlMode || this.options.recognizeCDATA) {
        (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value2);
        (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
      } else {
        (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value2, "]]"));
        (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
      }
      this.startIndex = endIndex + 1;
    };
    Parser2.prototype.onend = function() {
      var _a, _b;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var index2 = this.stack.length; index2 > 0; this.cbs.onclosetag(this.stack[--index2], true))
          ;
      }
      (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Parser2.prototype.reset = function() {
      var _a, _b, _c, _d;
      (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
      this.tokenizer.reset();
      this.tagname = "";
      this.attribname = "";
      this.attribs = null;
      this.stack.length = 0;
      this.startIndex = 0;
      this.endIndex = 0;
      (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
      this.buffers.length = 0;
      this.bufferOffset = 0;
      this.writeIndex = 0;
      this.ended = false;
    };
    Parser2.prototype.parseComplete = function(data2) {
      this.reset();
      this.end(data2);
    };
    Parser2.prototype.getSlice = function(start2, end2) {
      while (start2 - this.bufferOffset >= this.buffers[0].length) {
        this.shiftBuffer();
      }
      var slice2 = this.buffers[0].slice(start2 - this.bufferOffset, end2 - this.bufferOffset);
      while (end2 - this.bufferOffset > this.buffers[0].length) {
        this.shiftBuffer();
        slice2 += this.buffers[0].slice(0, end2 - this.bufferOffset);
      }
      return slice2;
    };
    Parser2.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length;
      this.writeIndex--;
      this.buffers.shift();
    };
    Parser2.prototype.write = function(chunk) {
      var _a, _b;
      if (this.ended) {
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(chunk);
      if (this.tokenizer.running) {
        this.tokenizer.write(chunk);
        this.writeIndex++;
      }
    };
    Parser2.prototype.end = function(chunk) {
      var _a, _b;
      if (this.ended) {
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
        return;
      }
      if (chunk)
        this.write(chunk);
      this.ended = true;
      this.tokenizer.end();
    };
    Parser2.prototype.pause = function() {
      this.tokenizer.pause();
    };
    Parser2.prototype.resume = function() {
      this.tokenizer.resume();
      while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      }
      if (this.ended)
        this.tokenizer.end();
    };
    Parser2.prototype.parseChunk = function(chunk) {
      this.write(chunk);
    };
    Parser2.prototype.done = function(chunk) {
      this.end(chunk);
    };
    return Parser2;
  }()
);
Parser$1.Parser = Parser;
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.DomUtils = exports2.parseFeed = exports2.getFeed = exports2.ElementType = exports2.Tokenizer = exports2.createDomStream = exports2.parseDOM = exports2.parseDocument = exports2.DefaultHandler = exports2.DomHandler = exports2.Parser = void 0;
  var Parser_js_1 = Parser$1;
  var Parser_js_2 = Parser$1;
  Object.defineProperty(exports2, "Parser", {
    enumerable: true,
    get: function() {
      return Parser_js_2.Parser;
    }
  });
  var domhandler_12 = lib$a;
  var domhandler_2 = lib$a;
  Object.defineProperty(exports2, "DomHandler", {
    enumerable: true,
    get: function() {
      return domhandler_2.DomHandler;
    }
  });
  Object.defineProperty(exports2, "DefaultHandler", {
    enumerable: true,
    get: function() {
      return domhandler_2.DomHandler;
    }
  });
  function parseDocument(data2, options2) {
    var handler = new domhandler_12.DomHandler(void 0, options2);
    new Parser_js_1.Parser(handler, options2).end(data2);
    return handler.root;
  }
  exports2.parseDocument = parseDocument;
  function parseDOM(data2, options2) {
    return parseDocument(data2, options2).children;
  }
  exports2.parseDOM = parseDOM;
  function createDomStream(callback, options2, elementCallback) {
    var handler = new domhandler_12.DomHandler(callback, options2, elementCallback);
    return new Parser_js_1.Parser(handler, options2);
  }
  exports2.createDomStream = createDomStream;
  var Tokenizer_js_12 = Tokenizer;
  Object.defineProperty(exports2, "Tokenizer", {
    enumerable: true,
    get: function() {
      return __importDefault2(Tokenizer_js_12).default;
    }
  });
  exports2.ElementType = __importStar2(lib$9);
  var domutils_12 = lib$b;
  var domutils_2 = lib$b;
  Object.defineProperty(exports2, "getFeed", {
    enumerable: true,
    get: function() {
      return domutils_2.getFeed;
    }
  });
  var parseFeedDefaultOptions = {
    xmlMode: true
  };
  function parseFeed(feed, options2) {
    if (options2 === void 0) {
      options2 = parseFeedDefaultOptions;
    }
    return (0, domutils_12.getFeed)(parseDOM(feed, options2));
  }
  exports2.parseFeed = parseFeed;
  exports2.DomUtils = __importStar2(lib$b);
})(lib$3);
(function(exports2) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports3) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
        __createBinding2(exports3, m, p);
  };
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.root = exports2.parseHTML = exports2.merge = exports2.contains = exports2.text = exports2.xml = exports2.html = exports2.load = void 0;
  __exportStar(types, exports2);
  var load_js_1 = load;
  var parse_js_12 = parse$1;
  var parse5_adapter_js_1 = parse5Adapter;
  var dom_serializer_12 = __importDefault2(lib$8);
  var htmlparser2_1 = lib$3;
  var parse2 = (0, parse_js_12.getParse)(function(content, options2, isDocument2, context) {
    return options2.xmlMode || options2._useHtmlParser2 ? (0, htmlparser2_1.parseDocument)(content, options2) : (0, parse5_adapter_js_1.parseWithParse5)(content, options2, isDocument2, context);
  });
  exports2.load = (0, load_js_1.getLoad)(parse2, function(dom, options2) {
    return options2.xmlMode || options2._useHtmlParser2 ? (0, dom_serializer_12.default)(dom, options2) : (0, parse5_adapter_js_1.renderWithParse5)(dom);
  });
  exports2.default = (0, exports2.load)([]);
  var static_js_12 = _static;
  Object.defineProperty(exports2, "html", {
    enumerable: true,
    get: function() {
      return static_js_12.html;
    }
  });
  Object.defineProperty(exports2, "xml", {
    enumerable: true,
    get: function() {
      return static_js_12.xml;
    }
  });
  Object.defineProperty(exports2, "text", {
    enumerable: true,
    get: function() {
      return static_js_12.text;
    }
  });
  var staticMethods2 = __importStar2(_static);
  exports2.contains = staticMethods2.contains;
  exports2.merge = staticMethods2.merge;
  exports2.parseHTML = staticMethods2.parseHTML;
  exports2.root = staticMethods2.root;
})(lib$c);
var configuration$1 = {};
var validateAdapter = {};
var _createClass$1y = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$1A(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function unimplementedError(methodName, classname) {
  return new Error(String(methodName) + " is a required method of " + String(classname) + ", but was not implemented.");
}
var EnzymeAdapter = function() {
  function EnzymeAdapter2() {
    _classCallCheck$1A(this, EnzymeAdapter2);
    this.options = {};
  }
  _createClass$1y(EnzymeAdapter2, [{
    key: "createRenderer",
    value: /* @__PURE__ */ function() {
      function createRenderer(options2) {
        throw unimplementedError("createRenderer", "EnzymeAdapter");
      }
      return createRenderer;
    }()
    // converts an RSTNode to the corresponding JSX Pragma Element. This will be needed
    // in order to implement the `Wrapper.mount()` and `Wrapper.shallow()` methods, but should
    // be pretty straightforward for people to implement.
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
  }, {
    key: "nodeToElement",
    value: /* @__PURE__ */ function() {
      function nodeToElement(node2) {
        throw unimplementedError("nodeToElement", "EnzymeAdapter");
      }
      return nodeToElement;
    }()
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "matchesElementType",
    value: /* @__PURE__ */ function() {
      function matchesElementType(node2, matchingType) {
        if (!node2) {
          return node2;
        }
        var type3 = node2.type;
        return type3 === matchingType;
      }
      return matchesElementType;
    }()
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
  }, {
    key: "isValidElement",
    value: /* @__PURE__ */ function() {
      function isValidElement2(element) {
        throw unimplementedError("isValidElement", "EnzymeAdapter");
      }
      return isValidElement2;
    }()
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
  }, {
    key: "createElement",
    value: /* @__PURE__ */ function() {
      function createElement2(type3, props) {
        throw unimplementedError("createElement", "EnzymeAdapter");
      }
      return createElement2;
    }()
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "invokeSetStateCallback",
    value: /* @__PURE__ */ function() {
      function invokeSetStateCallback(instance, callback) {
        callback.call(instance);
      }
      return invokeSetStateCallback;
    }()
  }]);
  return EnzymeAdapter2;
}();
EnzymeAdapter.MODES = {
  STRING: "string",
  MOUNT: "mount",
  SHALLOW: "shallow"
};
var EnzymeAdapter_1 = EnzymeAdapter;
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = validateAdapter2;
  var _EnzymeAdapter3 = EnzymeAdapter_1;
  var _EnzymeAdapter22 = _interopRequireDefault2(_EnzymeAdapter3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function validateAdapter2(adapter) {
    if (!adapter) {
      throw new Error("\n      Enzyme Internal Error: Enzyme expects an adapter to be configured, but found none.\n      To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n      before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n      corresponding to the library currently being tested. For example:\n\n      import Adapter from 'enzyme-adapter-react-15';\n\n      To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n    ");
    }
    if (typeof adapter === "function") {
      if (Object.getPrototypeOf(adapter) === _EnzymeAdapter22["default"]) {
        throw new Error("\n        Enzyme Internal Error: Enzyme expects an adapter instance to be configured -\n        you provided an adapter *constructor*.\n        To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n        before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n        corresponding to the library currently being tested. For example:\n\n        import Adapter from 'enzyme-adapter-react-15';\n\n        To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n      ");
      }
      throw new Error("\n      Enzyme Internal Error: Enzyme expects an adapter to be configured -\n      an enzyme adapter must be an object instance; you provided a function.\n      To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n      before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n      corresponding to the library currently being tested. For example:\n\n      import Adapter from 'enzyme-adapter-react-15';\n\n      To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n    ");
    }
    if (!(adapter instanceof _EnzymeAdapter22["default"])) {
      throw new Error("Enzyme Internal Error: configured enzyme adapter did not inherit from the EnzymeAdapter base class");
    }
  }
})(validateAdapter);
Object.defineProperty(configuration$1, "__esModule", {
  value: true
});
configuration$1.get = get$5;
configuration$1.merge = merge$2;
configuration$1.reset = reset;
var _object$2 = object_assign;
var _object2$2 = _interopRequireDefault$e(_object$2);
var _validateAdapter = validateAdapter;
var _validateAdapter2 = _interopRequireDefault$e(_validateAdapter);
function _interopRequireDefault$e(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var configuration = {};
function get$5() {
  return (0, _object2$2["default"])({}, configuration);
}
function merge$2(extra) {
  if (extra.adapter) {
    (0, _validateAdapter2["default"])(extra.adapter);
  }
  (0, _object2$2["default"])(configuration, extra);
}
function reset() {
  var replacementConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  configuration = {};
  merge$2(replacementConfig);
}
var RSTTraversal = {};
var isSubset = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  var isSubset2 = function(_isSubset3) {
    function isSubset3(_x, _x2) {
      return _isSubset3.apply(this, arguments);
    }
    isSubset3.toString = function() {
      return _isSubset3.toString();
    };
    return isSubset3;
  }(function(superset2, subset2) {
    if (typeof superset2 !== "object" || superset2 === null || typeof subset2 !== "object" || subset2 === null)
      return false;
    return Object.keys(subset2).every(function(key) {
      if (!superset2.propertyIsEnumerable(key))
        return false;
      var subsetItem = subset2[key];
      var supersetItem = superset2[key];
      if (typeof subsetItem === "object" && subsetItem !== null ? !isSubset2(supersetItem, subsetItem) : supersetItem !== subsetItem)
        return false;
      return true;
    });
  });
  exports2["default"] = isSubset2;
  module2.exports = exports2["default"];
})(isSubset, isSubset.exports);
var isSubsetExports = isSubset.exports;
var getAdapter = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = getAdapter2;
  var _validateAdapter3 = validateAdapter;
  var _validateAdapter22 = _interopRequireDefault2(_validateAdapter3);
  var _configuration2 = configuration$1;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function getAdapter2() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options2.adapter) {
      (0, _validateAdapter22["default"])(options2.adapter);
      return options2.adapter;
    }
    var _get2 = (0, _configuration2.get)(), adapter = _get2.adapter;
    (0, _validateAdapter22["default"])(adapter);
    return adapter;
  }
})(getAdapter);
Object.defineProperty(RSTTraversal, "__esModule", {
  value: true
});
var _slicedToArray$1 = /* @__PURE__ */ function() {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i)
          break;
      }
    } catch (err2) {
      _d = true;
      _e = err2;
    } finally {
      try {
        if (!_n && _i["return"])
          _i["return"]();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
RSTTraversal.propsOfNode = propsOfNode;
RSTTraversal.childrenOfNode = childrenOfNode;
RSTTraversal.hasClassName = hasClassName;
RSTTraversal.treeForEach = treeForEach;
RSTTraversal.treeFilter = treeFilter;
RSTTraversal.findParentNode = findParentNode;
RSTTraversal.pathToNode = pathToNode;
RSTTraversal.parentsOfNode = parentsOfNode;
RSTTraversal.nodeHasId = nodeHasId;
RSTTraversal.nodeMatchesObjectProps = nodeMatchesObjectProps;
RSTTraversal.getTextFromNode = getTextFromNode;
RSTTraversal.getTextFromHostNodes = getTextFromHostNodes;
RSTTraversal.getHTMLFromHostNodes = getHTMLFromHostNodes;
var _object$1 = object_assign;
var _object2$1 = _interopRequireDefault$d(_object$1);
var _arrayPrototype$1 = array_prototype_flat;
var _arrayPrototype2$1 = _interopRequireDefault$d(_arrayPrototype$1);
var _object3 = object_entries;
var _object4 = _interopRequireDefault$d(_object3);
var _isSubset = isSubsetExports;
var _isSubset2 = _interopRequireDefault$d(_isSubset);
var _functionPrototype$1 = function_prototype_name;
var _functionPrototype2$1 = _interopRequireDefault$d(_functionPrototype$1);
var _isRegex = isRegex;
var _isRegex2 = _interopRequireDefault$d(_isRegex);
var _getAdapter$2 = getAdapter;
var _getAdapter2$2 = _interopRequireDefault$d(_getAdapter$2);
function _interopRequireDefault$d(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _defineProperty$1(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _toConsumableArray$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function propsOfNode(node2) {
  return node2 && node2.props || {};
}
function childrenOfNode(node2) {
  if (!node2)
    return [];
  var adapter = (0, _getAdapter2$2["default"])();
  var adapterHasIsFragment = adapter.isFragment && typeof adapter.isFragment === "function";
  var renderedArray = Array.isArray(node2.rendered) ? (0, _arrayPrototype2$1["default"])(node2.rendered, 1) : [node2.rendered];
  if (!adapterHasIsFragment) {
    return renderedArray;
  }
  return (0, _arrayPrototype2$1["default"])(renderedArray.map(function(currentChild) {
    if (adapter.isFragment(currentChild)) {
      return childrenOfNode(currentChild);
    }
    return currentChild;
  }), 1);
}
function hasClassName(node2, className2) {
  var classes2 = propsOfNode(node2).className || "";
  classes2 = String(classes2).replace(/\s/g, " ");
  if ((0, _isRegex2["default"])(className2))
    return className2.test(classes2);
  return (" " + String(classes2) + " ").indexOf(" " + String(className2) + " ") > -1;
}
function treeForEach(tree, fn) {
  if (tree) {
    fn(tree);
  }
  childrenOfNode(tree).forEach(function(node2) {
    return treeForEach(node2, fn);
  });
}
function treeFilter(tree, fn) {
  var results = [];
  treeForEach(tree, function(node2) {
    if (fn(node2)) {
      results.push(node2);
    }
  });
  return results;
}
function findParentNode(root2, targetNode) {
  var results = treeFilter(root2, function(node2) {
    if (!node2.rendered) {
      return false;
    }
    return childrenOfNode(node2).indexOf(targetNode) !== -1;
  });
  return results[0] || null;
}
function pathFilter(path, fn) {
  return path.filter(function(tree) {
    return treeFilter(tree, fn).length !== 0;
  });
}
function pathToNode(node2, root2) {
  var queue2 = [root2];
  var path = [];
  var hasNode = function hasNode2(testNode) {
    return node2 === testNode;
  };
  while (queue2.length) {
    var current = queue2.pop();
    var children3 = childrenOfNode(current);
    if (current === node2)
      return pathFilter(path, hasNode);
    path.push(current);
    if (children3.length === 0) {
      path.pop();
    }
    queue2.push.apply(queue2, _toConsumableArray$1(children3));
  }
  return null;
}
function parentsOfNode(node2, root2) {
  return (pathToNode(node2, root2) || []).reverse();
}
function nodeHasId(node2, id2) {
  return propsOfNode(node2).id === id2;
}
var CAN_NEVER_MATCH = {};
function replaceUndefined(v) {
  return typeof v !== "undefined" ? v : CAN_NEVER_MATCH;
}
function replaceUndefinedValues(obj) {
  return (0, _object4["default"])(obj).reduce(function(acc, _ref) {
    var _ref2 = _slicedToArray$1(_ref, 2), k = _ref2[0], v = _ref2[1];
    return (0, _object2$1["default"])({}, acc, _defineProperty$1({}, k, replaceUndefined(v)));
  }, {});
}
function nodeMatchesObjectProps(node2, props) {
  return (0, _isSubset2["default"])(propsOfNode(node2), replaceUndefinedValues(props));
}
function getTextFromHostNode(hostNode) {
  if (typeof hostNode === "string") {
    return String(hostNode || "");
  }
  if (!hostNode) {
    return "";
  }
  return hostNode.textContent || "";
}
function getTextFromRSTNode(node2, _ref3) {
  var getCustom = _ref3.getCustom, handleHostNodes = _ref3.handleHostNodes, recurse = _ref3.recurse, _ref3$nullRenderRetur = _ref3.nullRenderReturnsNull, nullRenderReturnsNull = _ref3$nullRenderRetur === void 0 ? false : _ref3$nullRenderRetur;
  if (node2 == null) {
    return "";
  }
  if (typeof node2 === "string" || typeof node2 === "number") {
    return String(node2);
  }
  if (getCustom && node2.type && typeof node2.type === "function") {
    return getCustom(node2);
  }
  if (handleHostNodes && node2.nodeType === "host") {
    return handleHostNodes(node2);
  }
  if (node2.rendered == null && nullRenderReturnsNull) {
    return null;
  }
  return childrenOfNode(node2).map(recurse).join("");
}
function getTextFromNode(node2) {
  return getTextFromRSTNode(node2, {
    recurse: getTextFromNode,
    getCustom: /* @__PURE__ */ function() {
      function getCustom(_ref4) {
        var type3 = _ref4.type;
        return "<" + String(type3.displayName || (0, _functionPrototype2$1["default"])(type3)) + " />";
      }
      return getCustom;
    }()
  });
}
function getTextFromHostNodes(node2, adapter) {
  return getTextFromRSTNode(node2, {
    recurse: /* @__PURE__ */ function() {
      function recurse(item) {
        return getTextFromHostNodes(item, adapter);
      }
      return recurse;
    }(),
    handleHostNodes: /* @__PURE__ */ function() {
      function handleHostNodes(item) {
        var nodes = [].concat(adapter.nodeToHostNode(item, true));
        return nodes.map(getTextFromHostNode).join("");
      }
      return handleHostNodes;
    }()
  });
}
function getHTMLFromHostNode(hostNode) {
  if (hostNode == null) {
    return null;
  }
  return hostNode.outerHTML.replace(/\sdata-(reactid|reactroot)+="([^"]*)+"/g, "");
}
function getHTMLFromHostNodes(node2, adapter) {
  return getTextFromRSTNode(node2, {
    recurse: /* @__PURE__ */ function() {
      function recurse(item) {
        return getHTMLFromHostNodes(item, adapter);
      }
      return recurse;
    }(),
    handleHostNodes: /* @__PURE__ */ function() {
      function handleHostNodes(item) {
        var nodes = [].concat(adapter.nodeToHostNode(item, true));
        return nodes.map(getHTMLFromHostNode).join("");
      }
      return handleHostNodes;
    }(),
    nullRenderReturnsNull: true
  });
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.shallowEqual = exports2.ITERATOR_SYMBOL = void 0;
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _slicedToArray2 = /* @__PURE__ */ function() {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i)
            break;
        }
      } catch (err2) {
        _d = true;
        _e = err2;
      } finally {
        try {
          if (!_n && _i["return"])
            _i["return"]();
        } finally {
          if (_d)
            throw _e;
        }
      }
      return _arr;
    }
    return function(arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  exports2.getAdapter = getAdapter$1;
  exports2.makeOptions = makeOptions;
  exports2.isCustomComponent = isCustomComponent;
  exports2.isCustomComponentElement = isCustomComponentElement;
  exports2.propsOfNode = propsOfNode2;
  exports2.typeOfNode = typeOfNode;
  exports2.nodeHasType = nodeHasType;
  exports2.nodeMatches = nodeMatches;
  exports2.nodeEqual = nodeEqual;
  exports2.containsChildrenSubArray = containsChildrenSubArray;
  exports2.childrenToSimplifiedArray = childrenToSimplifiedArray;
  exports2.isReactElementAlike = isReactElementAlike;
  exports2.withSetStateAllowed = withSetStateAllowed;
  exports2.AND = AND;
  exports2.displayNameOfNode = displayNameOfNode;
  exports2.sym = sym;
  exports2.privateSet = privateSet;
  exports2.cloneElement = cloneElement2;
  exports2.spyMethod = spyMethod;
  var _enzymeShallowEqual = buildExports;
  Object.defineProperty(exports2, "shallowEqual", {
    enumerable: true,
    get: /* @__PURE__ */ function() {
      function get3() {
        return _interopRequireDefault2(_enzymeShallowEqual)["default"];
      }
      return get3;
    }()
  });
  exports2.isEmptyValue = isEmptyValue;
  exports2.renderedDive = renderedDive;
  exports2.loadCheerioRoot = loadCheerioRoot;
  var _object5 = object_assign;
  var _object22 = _interopRequireDefault2(_object5);
  var _lodash3 = lodash_isequalExports;
  var _lodash22 = _interopRequireDefault2(_lodash3);
  var _objectIs3 = objectIs;
  var _objectIs22 = _interopRequireDefault2(_objectIs3);
  var _object32 = object_entries;
  var _object42 = _interopRequireDefault2(_object32);
  var _functionPrototype3 = function_prototype_name;
  var _functionPrototype22 = _interopRequireDefault2(_functionPrototype3);
  var _has3 = src$1;
  var _has22 = _interopRequireDefault2(_has3);
  var _arrayPrototype3 = array_prototype_flat;
  var _arrayPrototype22 = _interopRequireDefault2(_arrayPrototype3);
  var _stringPrototype = string_prototype_trim;
  var _stringPrototype2 = _interopRequireDefault2(_stringPrototype);
  var _cheerio = lib$c;
  var _cheerio2 = _interopRequireDefault2(_cheerio);
  var _utils2 = utils$8;
  var _configuration2 = configuration$1;
  var _RSTTraversal2 = RSTTraversal;
  var _getAdapter3 = getAdapter;
  var _getAdapter22 = _interopRequireDefault2(_getAdapter3);
  var _validateAdapter3 = validateAdapter;
  var _validateAdapter22 = _interopRequireDefault2(_validateAdapter3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _defineProperty2(obj, key, value2) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value2,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value2;
    }
    return obj;
  }
  function _objectWithoutProperties2(obj, keys3) {
    var target = {};
    for (var i in obj) {
      if (keys3.indexOf(i) >= 0)
        continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i))
        continue;
      target[i] = obj[i];
    }
    return target;
  }
  exports2.ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
  function getAdapter$1() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    console.warn("getAdapter from Utils is deprecated; please use ./getAdapter instead");
    return (0, _getAdapter22["default"])(options2);
  }
  function validateMountOptions(attachTo, hydrateIn) {
    if (attachTo && hydrateIn && attachTo !== hydrateIn) {
      throw new TypeError("If both the `attachTo` and `hydrateIn` options are provided, they must be === (for backwards compatibility)");
    }
  }
  function makeOptions(options2) {
    var _get2 = (0, _configuration2.get)(), configAttachTo = _get2.attachTo, configHydrateIn = _get2.hydrateIn, config = _objectWithoutProperties2(_get2, ["attachTo", "hydrateIn"]);
    validateMountOptions(configAttachTo, configHydrateIn);
    var attachTo = options2.attachTo, hydrateIn = options2.hydrateIn;
    validateMountOptions(attachTo, hydrateIn);
    var finalAttachTo = hydrateIn || configHydrateIn || configAttachTo || attachTo || void 0;
    var finalHydrateIn = hydrateIn || configHydrateIn || void 0;
    var mountTargets = (0, _object22["default"])({}, finalAttachTo && {
      attachTo: finalAttachTo
    }, finalHydrateIn && {
      hydrateIn: finalHydrateIn
    });
    return (0, _object22["default"])({}, config, options2, mountTargets);
  }
  function isCustomComponent(component, adapter) {
    (0, _validateAdapter22["default"])(adapter);
    if (adapter.isCustomComponent) {
      return !!adapter.isCustomComponent(component);
    }
    return typeof component === "function";
  }
  function isCustomComponentElement(inst, adapter) {
    if (adapter.isCustomComponentElement) {
      return !!adapter.isCustomComponentElement(inst);
    }
    return !!inst && adapter.isValidElement(inst) && typeof inst.type === "function";
  }
  function propsOfNode2(node2) {
    return (0, _object42["default"])(node2 && node2.props || {}).filter(function(_ref) {
      var _ref2 = _slicedToArray2(_ref, 2), value2 = _ref2[1];
      return typeof value2 !== "undefined";
    }).reduce(function(acc, _ref3) {
      var _ref4 = _slicedToArray2(_ref3, 2), key = _ref4[0], value2 = _ref4[1];
      return (0, _object22["default"])(acc, _defineProperty2({}, key, value2));
    }, {});
  }
  function typeOfNode(node2) {
    return node2 ? node2.type : null;
  }
  function nodeHasType(node2, type3) {
    if (!type3 || !node2)
      return false;
    var adapter = (0, _getAdapter22["default"])();
    if (adapter.displayNameOfNode) {
      var displayName = adapter.displayNameOfNode(node2);
      return displayName === type3;
    }
    if (!node2.type)
      return false;
    if (typeof node2.type === "string")
      return node2.type === type3;
    return (typeof node2.type === "function" ? (0, _functionPrototype22["default"])(node2.type) === type3 : node2.type.name === type3) || node2.type.displayName === type3;
  }
  function internalChildrenCompare(a, b, lenComp, isLoose) {
    var nodeCompare = isLoose ? nodeMatches : nodeEqual;
    if (a === b)
      return true;
    if (!Array.isArray(a) && !Array.isArray(b)) {
      return nodeCompare(a, b, lenComp);
    }
    var flatA = (0, _arrayPrototype22["default"])(a, Infinity);
    var flatB = (0, _arrayPrototype22["default"])(b, Infinity);
    if (flatA.length !== flatB.length)
      return false;
    if (flatA.length === 0 && flatB.length === 0)
      return true;
    for (var i = 0; i < flatA.length; i += 1) {
      if (!nodeCompare(flatA[i], flatB[i], lenComp))
        return false;
    }
    return true;
  }
  function childrenMatch(a, b, lenComp) {
    return internalChildrenCompare(a, b, lenComp, true);
  }
  function childrenEqual2(a, b, lenComp) {
    return internalChildrenCompare(a, b, lenComp, false);
  }
  function removeNullaryReducer(acc, _ref5) {
    var _ref6 = _slicedToArray2(_ref5, 2), key = _ref6[0], value2 = _ref6[1];
    var addition = value2 == null ? {} : _defineProperty2({}, key, value2);
    return (0, _object22["default"])({}, acc, addition);
  }
  function internalNodeCompare(a, b, lenComp, isLoose) {
    if (a === b)
      return true;
    if (!a || !b)
      return false;
    if (a.type !== b.type)
      return false;
    var left2 = propsOfNode2(a);
    var right2 = propsOfNode2(b);
    if (isLoose) {
      left2 = (0, _object42["default"])(left2).reduce(removeNullaryReducer, {});
      right2 = (0, _object42["default"])(right2).reduce(removeNullaryReducer, {});
    }
    var leftKeys = Object.keys(left2);
    for (var i = 0; i < leftKeys.length; i += 1) {
      var prop2 = leftKeys[i];
      if (prop2 === "children")
        ;
      else if (!(prop2 in right2)) {
        return false;
      } else if (right2[prop2] === left2[prop2])
        ;
      else if (_typeof2(right2[prop2]) === _typeof2(left2[prop2]) && _typeof2(left2[prop2]) === "object") {
        if (!(0, _lodash22["default"])(left2[prop2], right2[prop2]))
          return false;
      } else {
        return false;
      }
    }
    var leftHasChildren = "children" in left2;
    var rightHasChildren = "children" in right2;
    var childCompare = isLoose ? childrenMatch : childrenEqual2;
    if (leftHasChildren || rightHasChildren) {
      if (!childCompare(childrenToSimplifiedArray(left2.children, isLoose), childrenToSimplifiedArray(right2.children, isLoose), lenComp)) {
        return false;
      }
    }
    if (!isTextualNode(a)) {
      var rightKeys = Object.keys(right2);
      return lenComp(leftKeys.length - leftHasChildren, rightKeys.length - rightHasChildren);
    }
    return false;
  }
  function nodeMatches(a, b) {
    var lenComp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _objectIs22["default"];
    return internalNodeCompare(a, b, lenComp, true);
  }
  function nodeEqual(a, b) {
    var lenComp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _objectIs22["default"];
    return internalNodeCompare(a, b, lenComp, false);
  }
  function containsChildrenSubArray(match, node2, subArray) {
    var children3 = (0, _RSTTraversal2.childrenOfNode)(node2);
    var checker = function checker2(_, i) {
      return arraysEqual(match, children3.slice(i, i + subArray.length), subArray);
    };
    return children3.some(checker);
  }
  function arraysEqual(match, left2, right2) {
    return left2.length === right2.length && left2.every(function(el, i) {
      return match(el, right2[i]);
    });
  }
  function childrenToArray(children3) {
    var result = [];
    var push = function push2(el) {
      if (el === null || el === false || typeof el === "undefined")
        return;
      result.push(el);
    };
    if (Array.isArray(children3)) {
      children3.forEach(push);
    } else {
      push(children3);
    }
    return result;
  }
  function childrenToSimplifiedArray(nodeChildren) {
    var isLoose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var childrenArray = childrenToArray(nodeChildren);
    var simplifiedArray = [];
    for (var i = 0; i < childrenArray.length; i += 1) {
      var child = childrenArray[i];
      var previousChild = simplifiedArray.pop();
      if (typeof previousChild === "undefined") {
        simplifiedArray.push(child);
      } else if (isTextualNode(child) && isTextualNode(previousChild)) {
        simplifiedArray.push(previousChild + child);
      } else {
        simplifiedArray.push(previousChild);
        simplifiedArray.push(child);
      }
    }
    if (isLoose) {
      return simplifiedArray.map(function(x) {
        return typeof x === "string" ? (0, _stringPrototype2["default"])(x) : x;
      });
    }
    return simplifiedArray;
  }
  function isTextualNode(node2) {
    return typeof node2 === "string" || typeof node2 === "number";
  }
  function isReactElementAlike(arg, adapter) {
    return adapter.isValidElement(arg) || isTextualNode(arg) || Array.isArray(arg);
  }
  function withSetStateAllowed(fn) {
    var cleanup = false;
    if (typeof globalThis.document === "undefined") {
      cleanup = true;
      globalThis.document = {};
    }
    fn();
    if (cleanup) {
      globalThis.document = void 0;
      delete globalThis.document;
    }
  }
  function AND(fns) {
    var fnsReversed = fns.slice().reverse();
    return function(x) {
      return fnsReversed.every(function(fn) {
        return fn(x);
      });
    };
  }
  function displayNameOfNode(node2) {
    if (!node2)
      return null;
    var type3 = node2.type;
    if (!type3)
      return null;
    return type3.displayName || (typeof type3 === "function" ? (0, _functionPrototype22["default"])(type3) : type3.name || type3);
  }
  function sym(s) {
    return typeof Symbol === "function" ? Symbol["for"]("enzyme." + String(s)) : s;
  }
  function privateSet(obj, prop2, value2) {
    Object.defineProperty(obj, prop2, {
      value: value2,
      enumerable: false,
      writable: true
    });
  }
  function cloneElement2(adapter, el, props) {
    return adapter.createElement(el.type, (0, _object22["default"])({}, el.props, props));
  }
  function spyMethod(instance, methodName) {
    var getStub = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
    };
    var lastReturnValue = void 0;
    var originalMethod = instance[methodName];
    var hasOwn2 = (0, _has22["default"])(instance, methodName);
    var descriptor = void 0;
    if (hasOwn2) {
      descriptor = Object.getOwnPropertyDescriptor(instance, methodName);
    }
    Object.defineProperty(instance, methodName, {
      configurable: true,
      enumerable: !descriptor || !!descriptor.enumerable,
      value: getStub(originalMethod) || /* @__PURE__ */ function() {
        function spied() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var result = originalMethod.apply(this, args);
          lastReturnValue = result;
          return result;
        }
        return spied;
      }()
    });
    return {
      restore: /* @__PURE__ */ function() {
        function restore() {
          if (hasOwn2) {
            if (descriptor) {
              Object.defineProperty(instance, methodName, descriptor);
            } else {
              instance[methodName] = originalMethod;
            }
          } else {
            delete instance[methodName];
          }
        }
        return restore;
      }(),
      getLastReturnValue: /* @__PURE__ */ function() {
        function getLastReturnValue() {
          return lastReturnValue;
        }
        return getLastReturnValue;
      }()
    };
  }
  function isEmptyValue(renderedValue) {
    return renderedValue === null || renderedValue === false;
  }
  function renderedDive(nodes) {
    if (isEmptyValue(nodes)) {
      return true;
    }
    return [].concat(nodes).every(function(n) {
      if (n) {
        var rendered = n.rendered;
        return isEmptyValue(rendered) || renderedDive(rendered);
      }
      return isEmptyValue(n);
    });
  }
  function loadCheerioRoot(html2) {
    if (!html2) {
      return _cheerio2["default"].root();
    }
    if (!(0, _utils2.isHtml)(html2)) {
      return _cheerio2["default"].load(html2, null, false).root();
    }
    return _cheerio2["default"].load("")(html2);
  }
})(Utils);
var Debug = {};
var INFINITY$3 = 1 / 0;
var symbolTag$4 = "[object Symbol]";
var reUnescapedHtml = /[&<>"'`]/g, reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
var htmlEscapes = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "`": "&#96;"
};
var freeGlobal$3 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
var freeSelf$2 = typeof self == "object" && self && self.Object === Object && self;
var root$4 = freeGlobal$3 || freeSelf$2 || Function("return this")();
function basePropertyOf(object2) {
  return function(key) {
    return object2 == null ? void 0 : object2[key];
  };
}
var escapeHtmlChar = basePropertyOf(htmlEscapes);
var objectProto$h = Object.prototype;
var objectToString$2 = objectProto$h.toString;
var Symbol$4 = root$4.Symbol;
var symbolProto$3 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : void 0;
function baseToString$1(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isSymbol$1(value2)) {
    return symbolToString$1 ? symbolToString$1.call(value2) : "";
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -INFINITY$3 ? "-0" : result;
}
function isObjectLike$2(value2) {
  return !!value2 && typeof value2 == "object";
}
function isSymbol$1(value2) {
  return typeof value2 == "symbol" || isObjectLike$2(value2) && objectToString$2.call(value2) == symbolTag$4;
}
function toString$4(value2) {
  return value2 == null ? "" : baseToString$1(value2);
}
function escape(string) {
  string = toString$4(string);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}
var lodash_escape = escape;
var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject2(value2) {
  try {
    strValue.call(value2);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr$1 = Object.prototype.toString;
var strClass = "[object String]";
var hasToStringTag$2 = shams();
var isString$3 = function isString(value2) {
  if (typeof value2 === "string") {
    return true;
  }
  if (typeof value2 !== "object") {
    return false;
  }
  return hasToStringTag$2 ? tryStringObject(value2) : toStr$1.call(value2) === strClass;
};
var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject2(value2) {
  try {
    numToStr.call(value2);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var numClass = "[object Number]";
var hasToStringTag$1 = shams();
var isNumberObject = function isNumberObject2(value2) {
  if (typeof value2 === "number") {
    return true;
  }
  if (typeof value2 !== "object") {
    return false;
  }
  return hasToStringTag$1 ? tryNumberObject(value2) : toStr.call(value2) === numClass;
};
var callBound$4 = callBound$a;
var $boolToStr = callBound$4("Boolean.prototype.toString");
var $toString = callBound$4("Object.prototype.toString");
var tryBooleanObject = function booleanBrandCheck(value2) {
  try {
    $boolToStr(value2);
    return true;
  } catch (e) {
    return false;
  }
};
var boolClass = "[object Boolean]";
var hasToStringTag = shams();
var isBooleanObject = function isBoolean2(value2) {
  if (typeof value2 === "boolean") {
    return true;
  }
  if (value2 === null || typeof value2 !== "object") {
    return false;
  }
  return hasToStringTag && Symbol.toStringTag in value2 ? tryBooleanObject(value2) : $toString(value2) === boolClass;
};
Object.defineProperty(Debug, "__esModule", {
  value: true
});
var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
Debug.typeName = typeName;
Debug.spaces = spaces;
Debug.indent = indent;
Debug.debugNode = debugNode;
Debug.debugNodes = debugNodes;
var _lodash = lodash_escape;
var _lodash2 = _interopRequireDefault$c(_lodash);
var _functionPrototype = function_prototype_name;
var _functionPrototype2 = _interopRequireDefault$c(_functionPrototype);
var _isString = isString$3;
var _isString2$1 = _interopRequireDefault$c(_isString);
var _isNumberObject = isNumberObject;
var _isNumberObject2 = _interopRequireDefault$c(_isNumberObject);
var _isCallable = isCallable;
var _isCallable2 = _interopRequireDefault$c(_isCallable);
var _isBooleanObject = isBooleanObject;
var _isBooleanObject2 = _interopRequireDefault$c(_isBooleanObject);
var _objectInspect = objectInspect;
var _objectInspect2 = _interopRequireDefault$c(_objectInspect);
var _has$1 = src$1;
var _has2$1 = _interopRequireDefault$c(_has$1);
var _RSTTraversal$1 = RSTTraversal;
var _getAdapter$1 = getAdapter;
var _getAdapter2$1 = _interopRequireDefault$c(_getAdapter$1);
function _interopRequireDefault$c(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var booleanValue = Function.bind.call(Function.call, Boolean.prototype.valueOf);
function typeName(node2) {
  var adapter = (0, _getAdapter2$1["default"])();
  if (adapter.displayNameOfNode) {
    return (0, _getAdapter2$1["default"])().displayNameOfNode(node2) || "Component";
  }
  return typeof node2.type === "function" ? node2.type.displayName || (0, _functionPrototype2["default"])(node2.type) || "Component" : node2.type;
}
function spaces(n) {
  return Array(n + 1).join(" ");
}
function indent(depth, string) {
  return string.split("\n").map(function(x) {
    return "" + String(spaces(depth)) + String(x);
  }).join("\n");
}
function propString(prop2, options2) {
  if ((0, _isString2$1["default"])(prop2)) {
    return (0, _objectInspect2["default"])(String(prop2), {
      quoteStyle: "double"
    });
  }
  if ((0, _isNumberObject2["default"])(prop2)) {
    return "{" + String((0, _objectInspect2["default"])(Number(prop2))) + "}";
  }
  if ((0, _isBooleanObject2["default"])(prop2)) {
    return "{" + String((0, _objectInspect2["default"])(booleanValue(prop2))) + "}";
  }
  if ((0, _isCallable2["default"])(prop2)) {
    return "{" + String((0, _objectInspect2["default"])(prop2)) + "}";
  }
  if ((typeof prop2 === "undefined" ? "undefined" : _typeof$3(prop2)) === "object") {
    if (options2.verbose) {
      return "{" + String((0, _objectInspect2["default"])(prop2)) + "}";
    }
    return "{{...}}";
  }
  return "{[" + (typeof prop2 === "undefined" ? "undefined" : _typeof$3(prop2)) + "]}";
}
function propsString(node2, options2) {
  var props = (0, _RSTTraversal$1.propsOfNode)(node2);
  var keys3 = Object.keys(props).filter(function(x) {
    return x !== "children";
  });
  return keys3.map(function(key) {
    return String(key) + "=" + String(propString(props[key], options2));
  }).join(" ");
}
function indentChildren(childrenStrs, indentLength) {
  return childrenStrs.length ? "\n" + String(childrenStrs.map(function(x) {
    return indent(indentLength, x);
  }).join("\n")) + "\n" : "";
}
function isRSTNodeLike(node2) {
  return (0, _has2$1["default"])(node2, "nodeType") && typeof node2.nodeType === "string" && (0, _has2$1["default"])(node2, "type") && (0, _has2$1["default"])(node2, "key") && (0, _has2$1["default"])(node2, "ref") && (0, _has2$1["default"])(node2, "instance") && (0, _has2$1["default"])(node2, "rendered");
}
function debugNode(node2) {
  var indentLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof node2 === "string" || typeof node2 === "number")
    return (0, _lodash2["default"])(node2);
  if (typeof node2 === "function") {
    var name = (0, _functionPrototype2["default"])(node2);
    return "[function" + (name ? " " + String(name) : "") + "]";
  }
  if (!node2)
    return "";
  var adapter = (0, _getAdapter2$1["default"])();
  if (!adapter.isValidElement(node2) && !isRSTNodeLike(node2)) {
    return "{" + String((0, _objectInspect2["default"])(node2)) + "}";
  }
  var childrenStrs = (0, _RSTTraversal$1.childrenOfNode)(node2).map(function(n) {
    return debugNode(n, indentLength, options2);
  }).filter(Boolean);
  var type3 = typeName(node2);
  var props = options2.ignoreProps ? "" : propsString(node2, options2);
  var beforeProps = props ? " " : "";
  var afterProps = childrenStrs.length ? ">" : " ";
  var childrenIndented = indentChildren(childrenStrs, indentLength);
  var nodeClose = childrenStrs.length ? "</" + String(type3) + ">" : "/>";
  return "<" + String(type3) + beforeProps + String(props) + afterProps + String(childrenIndented) + nodeClose;
}
function debugNodes(nodes) {
  var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return nodes.map(function(node2) {
    return debugNode(node2, void 0, options2);
  }).join("\n\n\n");
}
var selectors = {};
var dist = {};
var createGenerator = {};
Object.defineProperty(createGenerator, "__esModule", {
  value: true
});
var escapeValue = function escapeValue2(value2) {
  return JSON.stringify(value2);
};
var renderSelector = function renderSelector2(selectorToken) {
  var tokens = selectorToken.body;
  var parts = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var token2 = _step.value;
      var part = void 0;
      if (token2.type === "universalSelector") {
        part = "*";
      } else if (token2.type === "typeSelector") {
        part = token2.name;
      } else if (token2.type === "idSelector") {
        part = "#" + token2.name;
      } else if (token2.type === "classSelector") {
        part = "." + token2.name;
      } else if (token2.type === "attributePresenceSelector") {
        part = "[" + token2.name + "]";
      } else if (token2.type === "attributeValueSelector") {
        part = "[" + token2.name + token2.operator + escapeValue(token2.value) + "]";
      } else if (token2.type === "pseudoClassSelector") {
        part = ":" + token2.name;
        if (token2.parameters.length) {
          part += "(" + token2.parameters.map(escapeValue).join(", ") + ")";
        }
      } else if (token2.type === "pseudoElementSelector") {
        part = "::" + token2.name;
      } else {
        throw new Error("Unknown token.");
      }
      parts.push(part);
    }
  } catch (err2) {
    _didIteratorError = true;
    _iteratorError = err2;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return parts.join("");
};
createGenerator.default = function() {
  var generate2 = function generate3(tokens) {
    var sequences = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = void 0;
    try {
      for (var _iterator2 = tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var token2 = _step2.value;
        if (token2.type === "selector") {
          sequences.push(renderSelector(token2));
        } else if (token2.type === "descendantCombinator") {
          sequences.push(" ");
        } else if (token2.type === "childCombinator") {
          sequences.push(" > ");
        } else if (token2.type === "adjacentSiblingCombinator") {
          sequences.push(" + ");
        } else if (token2.type === "generalSiblingCombinator") {
          sequences.push(" ~ ");
        } else {
          throw new Error("Unknown token.");
        }
      }
    } catch (err2) {
      _didIteratorError2 = true;
      _iteratorError2 = err2;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
    return sequences.join("");
  };
  return {
    generate: generate2
  };
};
var createParser = {};
var nearley = { exports: {} };
(function(module2) {
  (function(root2, factory) {
    if (module2.exports) {
      module2.exports = factory();
    } else {
      root2.nearley = factory();
    }
  })(commonjsGlobal, function() {
    function Rule(name, symbols, postprocess) {
      this.id = ++Rule.highestId;
      this.name = name;
      this.symbols = symbols;
      this.postprocess = postprocess;
      return this;
    }
    Rule.highestId = 0;
    Rule.prototype.toString = function(withCursorAt) {
      var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(" ") : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(" ") + " ● " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(" ");
      return this.name + " → " + symbolSequence;
    };
    function State2(rule, dot, reference, wantedBy) {
      this.rule = rule;
      this.dot = dot;
      this.reference = reference;
      this.data = [];
      this.wantedBy = wantedBy;
      this.isComplete = this.dot === rule.symbols.length;
    }
    State2.prototype.toString = function() {
      return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };
    State2.prototype.nextState = function(child) {
      var state = new State2(this.rule, this.dot + 1, this.reference, this.wantedBy);
      state.left = this;
      state.right = child;
      if (state.isComplete) {
        state.data = state.build();
        state.right = void 0;
      }
      return state;
    };
    State2.prototype.build = function() {
      var children3 = [];
      var node2 = this;
      do {
        children3.push(node2.right.data);
        node2 = node2.left;
      } while (node2.left);
      children3.reverse();
      return children3;
    };
    State2.prototype.finish = function() {
      if (this.rule.postprocess) {
        this.data = this.rule.postprocess(this.data, this.reference, Parser2.fail);
      }
    };
    function Column(grammar2, index2) {
      this.grammar = grammar2;
      this.index = index2;
      this.states = [];
      this.wants = {};
      this.scannable = [];
      this.completed = {};
    }
    Column.prototype.process = function(nextColumn) {
      var states = this.states;
      var wants = this.wants;
      var completed = this.completed;
      for (var w = 0; w < states.length; w++) {
        var state = states[w];
        if (state.isComplete) {
          state.finish();
          if (state.data !== Parser2.fail) {
            var wantedBy = state.wantedBy;
            for (var i = wantedBy.length; i--; ) {
              var left2 = wantedBy[i];
              this.complete(left2, state);
            }
            if (state.reference === this.index) {
              var exp2 = state.rule.name;
              (this.completed[exp2] = this.completed[exp2] || []).push(state);
            }
          }
        } else {
          var exp2 = state.rule.symbols[state.dot];
          if (typeof exp2 !== "string") {
            this.scannable.push(state);
            continue;
          }
          if (wants[exp2]) {
            wants[exp2].push(state);
            if (completed.hasOwnProperty(exp2)) {
              var nulls = completed[exp2];
              for (var i = 0; i < nulls.length; i++) {
                var right2 = nulls[i];
                this.complete(state, right2);
              }
            }
          } else {
            wants[exp2] = [state];
            this.predict(exp2);
          }
        }
      }
    };
    Column.prototype.predict = function(exp2) {
      var rules3 = this.grammar.byName[exp2] || [];
      for (var i = 0; i < rules3.length; i++) {
        var r2 = rules3[i];
        var wantedBy = this.wants[exp2];
        var s = new State2(r2, 0, this.index, wantedBy);
        this.states.push(s);
      }
    };
    Column.prototype.complete = function(left2, right2) {
      var copy2 = left2.nextState(right2);
      this.states.push(copy2);
    };
    function Grammar(rules3, start2) {
      this.rules = rules3;
      this.start = start2 || this.rules[0].name;
      var byName = this.byName = {};
      this.rules.forEach(function(rule) {
        if (!byName.hasOwnProperty(rule.name)) {
          byName[rule.name] = [];
        }
        byName[rule.name].push(rule);
      });
    }
    Grammar.fromCompiled = function(rules3, start2) {
      var lexer = rules3.Lexer;
      if (rules3.ParserStart) {
        start2 = rules3.ParserStart;
        rules3 = rules3.ParserRules;
      }
      var rules3 = rules3.map(function(r2) {
        return new Rule(r2.name, r2.symbols, r2.postprocess);
      });
      var g = new Grammar(rules3, start2);
      g.lexer = lexer;
      return g;
    };
    function StreamLexer() {
      this.reset("");
    }
    StreamLexer.prototype.reset = function(data2, state) {
      this.buffer = data2;
      this.index = 0;
      this.line = state ? state.line : 1;
      this.lastLineBreak = state ? -state.col : 0;
    };
    StreamLexer.prototype.next = function() {
      if (this.index < this.buffer.length) {
        var ch = this.buffer[this.index++];
        if (ch === "\n") {
          this.line += 1;
          this.lastLineBreak = this.index;
        }
        return {
          value: ch
        };
      }
    };
    StreamLexer.prototype.save = function() {
      return {
        line: this.line,
        col: this.index - this.lastLineBreak
      };
    };
    StreamLexer.prototype.formatError = function(token2, message) {
      var buffer2 = this.buffer;
      if (typeof buffer2 === "string") {
        var lines = buffer2.split("\n").slice(Math.max(0, this.line - 5), this.line);
        var nextLineBreak = buffer2.indexOf("\n", this.index);
        if (nextLineBreak === -1)
          nextLineBreak = buffer2.length;
        var col = this.index - this.lastLineBreak;
        var lastLineDigits = String(this.line).length;
        message += " at line " + this.line + " col " + col + ":\n\n";
        message += lines.map(function(line, i) {
          return pad3(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
        }, this).join("\n");
        message += "\n" + pad3("", lastLineDigits + col) + "^\n";
        return message;
      } else {
        return message + " at index " + (this.index - 1);
      }
      function pad3(n, length2) {
        var s = String(n);
        return Array(length2 - s.length + 1).join(" ") + s;
      }
    };
    function Parser2(rules3, start2, options2) {
      if (rules3 instanceof Grammar) {
        var grammar2 = rules3;
        var options2 = start2;
      } else {
        var grammar2 = Grammar.fromCompiled(rules3, start2);
      }
      this.grammar = grammar2;
      this.options = {
        keepHistory: false,
        lexer: grammar2.lexer || new StreamLexer()
      };
      for (var key in options2 || {}) {
        this.options[key] = options2[key];
      }
      this.lexer = this.options.lexer;
      this.lexerState = void 0;
      var column = new Column(grammar2, 0);
      this.table = [column];
      column.wants[grammar2.start] = [];
      column.predict(grammar2.start);
      column.process();
      this.current = 0;
    }
    Parser2.fail = {};
    Parser2.prototype.feed = function(chunk) {
      var lexer = this.lexer;
      lexer.reset(chunk, this.lexerState);
      var token2;
      while (true) {
        try {
          token2 = lexer.next();
          if (!token2) {
            break;
          }
        } catch (e) {
          var nextColumn = new Column(this.grammar, this.current + 1);
          this.table.push(nextColumn);
          var err2 = new Error(this.reportLexerError(e));
          err2.offset = this.current;
          err2.token = e.token;
          throw err2;
        }
        var column = this.table[this.current];
        if (!this.options.keepHistory) {
          delete this.table[this.current - 1];
        }
        var n = this.current + 1;
        var nextColumn = new Column(this.grammar, n);
        this.table.push(nextColumn);
        var literal = token2.text !== void 0 ? token2.text : token2.value;
        var value2 = lexer.constructor === StreamLexer ? token2.value : token2;
        var scannable = column.scannable;
        for (var w = scannable.length; w--; ) {
          var state = scannable[w];
          var expect = state.rule.symbols[state.dot];
          if (expect.test ? expect.test(value2) : expect.type ? expect.type === token2.type : expect.literal === literal) {
            var next = state.nextState({
              data: value2,
              token: token2,
              isToken: true,
              reference: n - 1
            });
            nextColumn.states.push(next);
          }
        }
        nextColumn.process();
        if (nextColumn.states.length === 0) {
          var err2 = new Error(this.reportError(token2));
          err2.offset = this.current;
          err2.token = token2;
          throw err2;
        }
        if (this.options.keepHistory) {
          column.lexerState = lexer.save();
        }
        this.current++;
      }
      if (column) {
        this.lexerState = lexer.save();
      }
      this.results = this.finish();
      return this;
    };
    Parser2.prototype.reportLexerError = function(lexerError) {
      var tokenDisplay, lexerMessage;
      var token2 = lexerError.token;
      if (token2) {
        tokenDisplay = "input " + JSON.stringify(token2.text[0]) + " (lexer error)";
        lexerMessage = this.lexer.formatError(token2, "Syntax error");
      } else {
        tokenDisplay = "input (lexer error)";
        lexerMessage = lexerError.message;
      }
      return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser2.prototype.reportError = function(token2) {
      var tokenDisplay = (token2.type ? token2.type + " token: " : "") + JSON.stringify(token2.value !== void 0 ? token2.value : token2);
      var lexerMessage = this.lexer.formatError(token2, "Syntax error");
      return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser2.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
      var lines = [];
      lines.push(lexerMessage);
      var lastColumnIndex = this.table.length - 2;
      var lastColumn = this.table[lastColumnIndex];
      var expectantStates = lastColumn.states.filter(function(state) {
        var nextSymbol = state.rule.symbols[state.dot];
        return nextSymbol && typeof nextSymbol !== "string";
      });
      if (expectantStates.length === 0) {
        lines.push("Unexpected " + tokenDisplay + ". I did not expect any more input. Here is the state of my parse table:\n");
        this.displayStateStack(lastColumn.states, lines);
      } else {
        lines.push("Unexpected " + tokenDisplay + ". Instead, I was expecting to see one of the following:\n");
        var stateStacks = expectantStates.map(function(state) {
          return this.buildFirstStateStack(state, []) || [state];
        }, this);
        stateStacks.forEach(function(stateStack) {
          var state = stateStack[0];
          var nextSymbol = state.rule.symbols[state.dot];
          var symbolDisplay = this.getSymbolDisplay(nextSymbol);
          lines.push("A " + symbolDisplay + " based on:");
          this.displayStateStack(stateStack, lines);
        }, this);
      }
      lines.push("");
      return lines.join("\n");
    };
    Parser2.prototype.displayStateStack = function(stateStack, lines) {
      var lastDisplay;
      var sameDisplayCount = 0;
      for (var j = 0; j < stateStack.length; j++) {
        var state = stateStack[j];
        var display = state.rule.toString(state.dot);
        if (display === lastDisplay) {
          sameDisplayCount++;
        } else {
          if (sameDisplayCount > 0) {
            lines.push("    ^ " + sameDisplayCount + " more lines identical to this");
          }
          sameDisplayCount = 0;
          lines.push("    " + display);
        }
        lastDisplay = display;
      }
    };
    Parser2.prototype.getSymbolDisplay = function(symbol) {
      return getSymbolLongDisplay(symbol);
    };
    Parser2.prototype.buildFirstStateStack = function(state, visited) {
      if (visited.indexOf(state) !== -1) {
        return null;
      }
      if (state.wantedBy.length === 0) {
        return [state];
      }
      var prevState = state.wantedBy[0];
      var childVisited = [state].concat(visited);
      var childResult = this.buildFirstStateStack(prevState, childVisited);
      if (childResult === null) {
        return null;
      }
      return [state].concat(childResult);
    };
    Parser2.prototype.save = function() {
      var column = this.table[this.current];
      column.lexerState = this.lexerState;
      return column;
    };
    Parser2.prototype.restore = function(column) {
      var index2 = column.index;
      this.current = index2;
      this.table[index2] = column;
      this.table.splice(index2 + 1);
      this.lexerState = column.lexerState;
      this.results = this.finish();
    };
    Parser2.prototype.rewind = function(index2) {
      if (!this.options.keepHistory) {
        throw new Error("set option `keepHistory` to enable rewinding");
      }
      this.restore(this.table[index2]);
    };
    Parser2.prototype.finish = function() {
      var considerations = [];
      var start2 = this.grammar.start;
      var column = this.table[this.table.length - 1];
      column.states.forEach(function(t) {
        if (t.rule.name === start2 && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser2.fail) {
          considerations.push(t);
        }
      });
      return considerations.map(function(c2) {
        return c2.data;
      });
    };
    function getSymbolLongDisplay(symbol) {
      var type3 = typeof symbol;
      if (type3 === "string") {
        return symbol;
      } else if (type3 === "object") {
        if (symbol.literal) {
          return JSON.stringify(symbol.literal);
        } else if (symbol instanceof RegExp) {
          return "character matching " + symbol;
        } else if (symbol.type) {
          return symbol.type + " token";
        } else if (symbol.test) {
          return "token matching " + String(symbol.test);
        } else {
          throw new Error("Unknown symbol type: " + symbol);
        }
      }
    }
    function getSymbolShortDisplay(symbol) {
      var type3 = typeof symbol;
      if (type3 === "string") {
        return symbol;
      } else if (type3 === "object") {
        if (symbol.literal) {
          return JSON.stringify(symbol.literal);
        } else if (symbol instanceof RegExp) {
          return symbol.toString();
        } else if (symbol.type) {
          return "%" + symbol.type;
        } else if (symbol.test) {
          return "<" + String(symbol.test) + ">";
        } else {
          throw new Error("Unknown symbol type: " + symbol);
        }
      }
    }
    return {
      Parser: Parser2,
      Grammar,
      Rule
    };
  });
})(nearley);
var nearleyExports = nearley.exports;
var grammar = { exports: {} };
var INFINITY$2 = 1 / 0, MAX_SAFE_INTEGER$2 = 9007199254740991;
var argsTag$4 = "[object Arguments]", funcTag$3 = "[object Function]", genTag$2 = "[object GeneratorFunction]";
var freeGlobal$2 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$3 = freeGlobal$2 || freeSelf$1 || Function("return this")();
function arrayPush$1(array2, values2) {
  var index2 = -1, length2 = values2.length, offset2 = array2.length;
  while (++index2 < length2) {
    array2[offset2 + index2] = values2[index2];
  }
  return array2;
}
var objectProto$g = Object.prototype;
var hasOwnProperty$d = objectProto$g.hasOwnProperty;
var objectToString$1 = objectProto$g.toString;
var Symbol$3 = root$3.Symbol, propertyIsEnumerable$2 = objectProto$g.propertyIsEnumerable, spreadableSymbol = Symbol$3 ? Symbol$3.isConcatSpreadable : void 0;
function baseFlatten(array2, depth, predicate, isStrict, result) {
  var index2 = -1, length2 = array2.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length2) {
    var value2 = array2[index2];
    if (depth > 0 && predicate(value2)) {
      if (depth > 1) {
        baseFlatten(value2, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value2);
      }
    } else if (!isStrict) {
      result[result.length] = value2;
    }
  }
  return result;
}
function isFlattenable(value2) {
  return isArray$2(value2) || isArguments$2(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
}
function flattenDeep(array2) {
  var length2 = array2 ? array2.length : 0;
  return length2 ? baseFlatten(array2, INFINITY$2) : [];
}
function isArguments$2(value2) {
  return isArrayLikeObject$1(value2) && hasOwnProperty$d.call(value2, "callee") && (!propertyIsEnumerable$2.call(value2, "callee") || objectToString$1.call(value2) == argsTag$4);
}
var isArray$2 = Array.isArray;
function isArrayLike$1(value2) {
  return value2 != null && isLength$1(value2.length) && !isFunction$1(value2);
}
function isArrayLikeObject$1(value2) {
  return isObjectLike$1(value2) && isArrayLike$1(value2);
}
function isFunction$1(value2) {
  var tag = isObject$1(value2) ? objectToString$1.call(value2) : "";
  return tag == funcTag$3 || tag == genTag$2;
}
function isLength$1(value2) {
  return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER$2;
}
function isObject$1(value2) {
  var type3 = typeof value2;
  return !!value2 && (type3 == "object" || type3 == "function");
}
function isObjectLike$1(value2) {
  return !!value2 && typeof value2 == "object";
}
var lodash_flattendeep = flattenDeep;
(function(module2) {
  (function() {
    function id2(x) {
      return x[0];
    }
    var flattenDeep2 = lodash_flattendeep;
    var appendItem2 = function appendItem3(a, b) {
      return function(d) {
        return d[a].concat([d[b]]);
      };
    };
    var flatten2 = function flatten3(d) {
      d = d.filter(function(r2) {
        return r2 !== null;
      });
      return flattenDeep2(d);
    };
    var combinatorMap = {
      " ": "descendantCombinator",
      "+": "adjacentSiblingCombinator",
      ">": "childCombinator",
      "~": "generalSiblingCombinator"
    };
    var concatUsingCombinator = function concatUsingCombinator2(d) {
      return (Array.isArray(d[0]) ? d[0] : [d[0]]).concat({
        type: combinatorMap[d[2]]
      }).concat(d[4]);
    };
    var parseAsNumber = function parseAsNumber2(d, i, reject) {
      var joined = flattenDeep2(d).join("");
      var parsed = parseFloat(joined);
      if (isNaN(parsed)) {
        return reject;
      }
      return parsed;
    };
    var parseAsBoolean = function parseAsBoolean2(d, i, reject) {
      if (d[0] === "true")
        return true;
      if (d[0] === "false")
        return false;
      return reject;
    };
    var parseFalsyPrimitive = function parseFalsyPrimitive2(d, i, reject) {
      if (d[0] === "NaN")
        return NaN;
      if (d[0] === "undefined")
        return void 0;
      if (d[0] === "null")
        return null;
      return reject;
    };
    var grammar2 = {
      Lexer: void 0,
      ParserRules: [{
        "name": "combinator",
        "symbols": ["selector"]
      }, {
        "name": "combinator",
        "symbols": ["combinator", "_", /[>+~ ]/, "_", "selector"],
        "postprocess": concatUsingCombinator
      }, {
        "name": "selector",
        "symbols": ["selectorBody"],
        "postprocess": function postprocess(d) {
          return {
            type: "selector",
            body: d[0]
          };
        }
      }, {
        "name": "selectorBody$ebnf$1",
        "symbols": ["typeSelector"],
        "postprocess": id2
      }, {
        "name": "selectorBody$ebnf$1",
        "symbols": [],
        "postprocess": function postprocess(d) {
          return null;
        }
      }, {
        "name": "selectorBody$ebnf$2",
        "symbols": []
      }, {
        "name": "selectorBody$ebnf$2",
        "symbols": ["selectorBody$ebnf$2", "simpleSelector"],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "selectorBody",
        "symbols": ["selectorBody$ebnf$1", "selectorBody$ebnf$2"],
        "postprocess": function postprocess(d, i, reject) {
          var selectors2 = flatten2(d);
          if (!selectors2.length)
            return reject;
          return selectors2;
        }
      }, {
        "name": "selectorBody$ebnf$3",
        "symbols": []
      }, {
        "name": "selectorBody$ebnf$3",
        "symbols": ["selectorBody$ebnf$3", "simpleSelector"],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "selectorBody",
        "symbols": ["universalSelector", "selectorBody$ebnf$3"],
        "postprocess": flatten2
      }, {
        "name": "simpleSelector",
        "symbols": ["idSelector"]
      }, {
        "name": "simpleSelector",
        "symbols": ["classSelector"]
      }, {
        "name": "simpleSelector",
        "symbols": ["attributeValueSelector"]
      }, {
        "name": "simpleSelector",
        "symbols": ["attributePresenceSelector"]
      }, {
        "name": "simpleSelector",
        "symbols": ["pseudoClassSelector"]
      }, {
        "name": "simpleSelector",
        "symbols": ["pseudoElementSelector"]
      }, {
        "name": "typeSelector",
        "symbols": ["attributeName"],
        "postprocess": function postprocess(d) {
          return {
            type: "typeSelector",
            name: d[0]
          };
        }
      }, {
        "name": "className$ebnf$1",
        "symbols": [{
          "literal": "-"
        }],
        "postprocess": id2
      }, {
        "name": "className$ebnf$1",
        "symbols": [],
        "postprocess": function postprocess(d) {
          return null;
        }
      }, {
        "name": "className$ebnf$2",
        "symbols": []
      }, {
        "name": "className$ebnf$2",
        "symbols": ["className$ebnf$2", /[_a-zA-Z0-9-]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "className",
        "symbols": ["className$ebnf$1", /[_a-zA-Z]/, "className$ebnf$2"],
        "postprocess": function postprocess(d) {
          return (d[0] || "") + d[1] + d[2].join("");
        }
      }, {
        "name": "attributeName$ebnf$1",
        "symbols": []
      }, {
        "name": "attributeName$ebnf$1",
        "symbols": ["attributeName$ebnf$1", /[_a-zA-Z()0-9-]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "attributeName",
        "symbols": [/[_a-z()A-Z]/, "attributeName$ebnf$1"],
        "postprocess": function postprocess(d) {
          return d[0] + d[1].join("");
        }
      }, {
        "name": "classSelector",
        "symbols": [{
          "literal": "."
        }, "className"],
        "postprocess": function postprocess(d) {
          return {
            type: "classSelector",
            name: d[1]
          };
        }
      }, {
        "name": "idSelector",
        "symbols": [{
          "literal": "#"
        }, "attributeName"],
        "postprocess": function postprocess(d) {
          return {
            type: "idSelector",
            name: d[1]
          };
        }
      }, {
        "name": "universalSelector",
        "symbols": [{
          "literal": "*"
        }],
        "postprocess": function postprocess(d) {
          return {
            type: "universalSelector"
          };
        }
      }, {
        "name": "attributePresenceSelector",
        "symbols": [{
          "literal": "["
        }, "attributeName", {
          "literal": "]"
        }],
        "postprocess": function postprocess(d) {
          return {
            type: "attributePresenceSelector",
            name: d[1]
          };
        }
      }, {
        "name": "attributeOperator",
        "symbols": [{
          "literal": "="
        }]
      }, {
        "name": "attributeOperator$string$1",
        "symbols": [{
          "literal": "~"
        }, {
          "literal": "="
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "attributeOperator",
        "symbols": ["attributeOperator$string$1"]
      }, {
        "name": "attributeOperator$string$2",
        "symbols": [{
          "literal": "|"
        }, {
          "literal": "="
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "attributeOperator",
        "symbols": ["attributeOperator$string$2"]
      }, {
        "name": "attributeOperator$string$3",
        "symbols": [{
          "literal": "^"
        }, {
          "literal": "="
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "attributeOperator",
        "symbols": ["attributeOperator$string$3"]
      }, {
        "name": "attributeOperator$string$4",
        "symbols": [{
          "literal": "$"
        }, {
          "literal": "="
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "attributeOperator",
        "symbols": ["attributeOperator$string$4"]
      }, {
        "name": "attributeOperator$string$5",
        "symbols": [{
          "literal": "*"
        }, {
          "literal": "="
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "attributeOperator",
        "symbols": ["attributeOperator$string$5"]
      }, {
        "name": "attributeValueSelector",
        "symbols": [{
          "literal": "["
        }, "attributeName", "attributeOperator", "attributeValue", {
          "literal": "]"
        }],
        "postprocess": function postprocess(d) {
          return {
            type: "attributeValueSelector",
            name: d[1],
            value: d[3],
            operator: d[2][0]
          };
        }
      }, {
        "name": "attributeValue",
        "symbols": ["falsyPrimitiveStrings"],
        "postprocess": id2
      }, {
        "name": "attributeValue",
        "symbols": ["numericValue"],
        "postprocess": id2
      }, {
        "name": "attributeValue",
        "symbols": ["sqstring"],
        "postprocess": id2
      }, {
        "name": "attributeValue",
        "symbols": ["dqstring"],
        "postprocess": id2
      }, {
        "name": "falsyPrimitiveStrings$string$1",
        "symbols": [{
          "literal": "f"
        }, {
          "literal": "a"
        }, {
          "literal": "l"
        }, {
          "literal": "s"
        }, {
          "literal": "e"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "falsyPrimitiveStrings",
        "symbols": ["falsyPrimitiveStrings$string$1"],
        "postprocess": parseAsBoolean
      }, {
        "name": "falsyPrimitiveStrings$string$2",
        "symbols": [{
          "literal": "t"
        }, {
          "literal": "r"
        }, {
          "literal": "u"
        }, {
          "literal": "e"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "falsyPrimitiveStrings",
        "symbols": ["falsyPrimitiveStrings$string$2"],
        "postprocess": parseAsBoolean
      }, {
        "name": "falsyPrimitiveStrings$string$3",
        "symbols": [{
          "literal": "N"
        }, {
          "literal": "a"
        }, {
          "literal": "N"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "falsyPrimitiveStrings",
        "symbols": ["falsyPrimitiveStrings$string$3"],
        "postprocess": parseFalsyPrimitive
      }, {
        "name": "falsyPrimitiveStrings$string$4",
        "symbols": [{
          "literal": "n"
        }, {
          "literal": "u"
        }, {
          "literal": "l"
        }, {
          "literal": "l"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "falsyPrimitiveStrings",
        "symbols": ["falsyPrimitiveStrings$string$4"],
        "postprocess": parseFalsyPrimitive
      }, {
        "name": "falsyPrimitiveStrings$string$5",
        "symbols": [{
          "literal": "u"
        }, {
          "literal": "n"
        }, {
          "literal": "d"
        }, {
          "literal": "e"
        }, {
          "literal": "f"
        }, {
          "literal": "i"
        }, {
          "literal": "n"
        }, {
          "literal": "e"
        }, {
          "literal": "d"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "falsyPrimitiveStrings",
        "symbols": ["falsyPrimitiveStrings$string$5"],
        "postprocess": parseFalsyPrimitive
      }, {
        "name": "numericValue",
        "symbols": ["int", {
          "literal": "."
        }, "int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue",
        "symbols": [{
          "literal": "+"
        }, "int", {
          "literal": "."
        }, "int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue",
        "symbols": [{
          "literal": "-"
        }, "int", {
          "literal": "."
        }, "int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue",
        "symbols": [{
          "literal": "-"
        }, "int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue",
        "symbols": ["int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue",
        "symbols": [{
          "literal": "+"
        }, "int"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue$string$1",
        "symbols": [{
          "literal": "I"
        }, {
          "literal": "n"
        }, {
          "literal": "f"
        }, {
          "literal": "i"
        }, {
          "literal": "n"
        }, {
          "literal": "i"
        }, {
          "literal": "t"
        }, {
          "literal": "y"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "numericValue",
        "symbols": ["numericValue$string$1"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue$string$2",
        "symbols": [{
          "literal": "+"
        }, {
          "literal": "I"
        }, {
          "literal": "n"
        }, {
          "literal": "f"
        }, {
          "literal": "i"
        }, {
          "literal": "n"
        }, {
          "literal": "i"
        }, {
          "literal": "t"
        }, {
          "literal": "y"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "numericValue",
        "symbols": ["numericValue$string$2"],
        "postprocess": parseAsNumber
      }, {
        "name": "numericValue$string$3",
        "symbols": [{
          "literal": "-"
        }, {
          "literal": "I"
        }, {
          "literal": "n"
        }, {
          "literal": "f"
        }, {
          "literal": "i"
        }, {
          "literal": "n"
        }, {
          "literal": "i"
        }, {
          "literal": "t"
        }, {
          "literal": "y"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "numericValue",
        "symbols": ["numericValue$string$3"],
        "postprocess": parseAsNumber
      }, {
        "name": "int$ebnf$1",
        "symbols": [/[0-9]/]
      }, {
        "name": "int$ebnf$1",
        "symbols": ["int$ebnf$1", /[0-9]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "int",
        "symbols": ["int$ebnf$1"]
      }, {
        "name": "classParameters",
        "symbols": []
      }, {
        "name": "classParameters",
        "symbols": ["classParameter"]
      }, {
        "name": "classParameters",
        "symbols": ["classParameters", {
          "literal": ","
        }, "_", "classParameter"],
        "postprocess": appendItem2(0, 3)
      }, {
        "name": "classParameter$ebnf$1",
        "symbols": [/[^()"', ]/]
      }, {
        "name": "classParameter$ebnf$1",
        "symbols": ["classParameter$ebnf$1", /[^()"', ]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "classParameter",
        "symbols": ["classParameter$ebnf$1"],
        "postprocess": function postprocess(d) {
          return d[0].join("");
        }
      }, {
        "name": "classParameter",
        "symbols": ["sqstring"],
        "postprocess": id2
      }, {
        "name": "classParameter",
        "symbols": ["dqstring"],
        "postprocess": id2
      }, {
        "name": "pseudoElementSelector$string$1",
        "symbols": [{
          "literal": ":"
        }, {
          "literal": ":"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "pseudoElementSelector",
        "symbols": ["pseudoElementSelector$string$1", "pseudoClassSelectorName"],
        "postprocess": function postprocess(d) {
          return {
            type: "pseudoElementSelector",
            name: d[1]
          };
        }
      }, {
        "name": "pseudoClassSelector",
        "symbols": [{
          "literal": ":"
        }, "pseudoClassSelectorName"],
        "postprocess": function postprocess(d) {
          return {
            type: "pseudoClassSelector",
            name: d[1]
          };
        }
      }, {
        "name": "pseudoClassSelector",
        "symbols": [{
          "literal": ":"
        }, "pseudoClassSelectorName", {
          "literal": "("
        }, "classParameters", {
          "literal": ")"
        }],
        "postprocess": function postprocess(d) {
          return {
            type: "pseudoClassSelector",
            name: d[1],
            parameters: d[3]
          };
        }
      }, {
        "name": "pseudoClassSelectorName$ebnf$1",
        "symbols": [/[a-zA-Z0-9-_]/]
      }, {
        "name": "pseudoClassSelectorName$ebnf$1",
        "symbols": ["pseudoClassSelectorName$ebnf$1", /[a-zA-Z0-9-_]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "pseudoClassSelectorName",
        "symbols": [/[a-zA-Z]/, "pseudoClassSelectorName$ebnf$1"],
        "postprocess": function postprocess(d) {
          return d[0] + d[1].join("");
        }
      }, {
        "name": "dqstring$ebnf$1",
        "symbols": []
      }, {
        "name": "dqstring$ebnf$1",
        "symbols": ["dqstring$ebnf$1", "dstrchar"],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "dqstring",
        "symbols": [{
          "literal": '"'
        }, "dqstring$ebnf$1", {
          "literal": '"'
        }],
        "postprocess": function postprocess(d) {
          return d[1].join("");
        }
      }, {
        "name": "dstrchar",
        "symbols": [/[^"]/],
        "postprocess": id2
      }, {
        "name": "dstrchar$string$1",
        "symbols": [{
          "literal": "\\"
        }, {
          "literal": '"'
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "dstrchar",
        "symbols": ["dstrchar$string$1"],
        "postprocess": function postprocess(d) {
          return '"';
        }
      }, {
        "name": "sqstring$ebnf$1",
        "symbols": []
      }, {
        "name": "sqstring$ebnf$1",
        "symbols": ["sqstring$ebnf$1", "sstrchar"],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "sqstring",
        "symbols": [{
          "literal": "'"
        }, "sqstring$ebnf$1", {
          "literal": "'"
        }],
        "postprocess": function postprocess(d) {
          return d[1].join("");
        }
      }, {
        "name": "sstrchar",
        "symbols": [/[^']/],
        "postprocess": id2
      }, {
        "name": "sstrchar$string$1",
        "symbols": [{
          "literal": "\\"
        }, {
          "literal": "'"
        }],
        "postprocess": function joiner(d) {
          return d.join("");
        }
      }, {
        "name": "sstrchar",
        "symbols": ["sstrchar$string$1"],
        "postprocess": function postprocess(d) {
          return "'";
        }
      }, {
        "name": "_$ebnf$1",
        "symbols": []
      }, {
        "name": "_$ebnf$1",
        "symbols": ["_$ebnf$1", /[ ]/],
        "postprocess": function arrpush(d) {
          return d[0].concat([d[1]]);
        }
      }, {
        "name": "_",
        "symbols": ["_$ebnf$1"],
        "postprocess": function postprocess(d) {
          return null;
        }
      }],
      ParserStart: "combinator"
    };
    {
      module2.exports = grammar2;
    }
  })();
})(grammar);
var grammarExports = grammar.exports;
Object.defineProperty(createParser, "__esModule", {
  value: true
});
var _nearley = nearleyExports;
var _grammar = grammarExports;
var _grammar2 = _interopRequireDefault$b(_grammar);
function _interopRequireDefault$b(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
createParser.default = function() {
  var parse2 = function parse3(selector2) {
    var parser2 = new _nearley.Parser(_grammar2.default.ParserRules, _grammar2.default.ParserStart);
    var results = parser2.feed(selector2).results;
    if (results.length === 0) {
      throw new Error("Found no parsings.");
    }
    if (results.length > 1) {
      throw new Error("Ambiguous results.");
    }
    return results[0];
  };
  return {
    parse: parse2
  };
};
Object.defineProperty(dist, "__esModule", {
  value: true
});
dist.createParser = dist.createGenerator = void 0;
var _createGenerator = createGenerator;
var _createGenerator2 = _interopRequireDefault$a(_createGenerator);
var _createParser = createParser;
var _createParser2 = _interopRequireDefault$a(_createParser);
function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
dist.createGenerator = _createGenerator2.default;
dist.createParser = _createParser2.default;
var RequireObjectCoercible$1 = RequireObjectCoercible$6;
var callBound$3 = callBound$a;
var $isEnumerable = callBound$3("Object.prototype.propertyIsEnumerable");
var $push$1 = callBound$3("Array.prototype.push");
var implementation$5 = function values(O) {
  var obj = RequireObjectCoercible$1(O);
  var vals = [];
  for (var key in obj) {
    if ($isEnumerable(obj, key)) {
      $push$1(vals, obj[key]);
    }
  }
  return vals;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill7() {
  return typeof Object.values === "function" ? Object.values : implementation$4;
};
var getPolyfill$2 = polyfill$3;
var define$2 = defineProperties_1;
var shim$3 = function shimValues() {
  var polyfill2 = getPolyfill$2();
  define$2(Object, {
    values: polyfill2
  }, {
    values: function testValues() {
      return Object.values !== polyfill2;
    }
  });
  return polyfill2;
};
var define$1 = defineProperties_1;
var callBind$1 = callBindExports;
var implementation$3 = implementation$5;
var getPolyfill$1 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind$1(getPolyfill$1(), Object);
define$1(polyfill$2, {
  getPolyfill: getPolyfill$1,
  implementation: implementation$3,
  shim: shim$2
});
var object_values = polyfill$2;
var ArraySpeciesCreate2 = ArraySpeciesCreate$2;
var Call = requireCall();
var CreateDataPropertyOrThrow = requireCreateDataPropertyOrThrow();
var Get2 = Get$4;
var HasProperty = requireHasProperty();
var IsCallable = IsCallable$2;
var LengthOfArrayLike = requireLengthOfArrayLike();
var ToBoolean2 = ToBoolean$1;
var ToObject2 = ToObject$2;
var ToString = requireToString();
var callBound$2 = callBound$a;
var isString$2 = isString$3;
var boxedString = Object("a");
var splitString = boxedString[0] !== "a" || !(0 in boxedString);
var strSplit = callBound$2("String.prototype.split");
var implementation$2 = function filter(callbackfn) {
  var O = ToObject2(this);
  var self2 = splitString && isString$2(O) ? strSplit(O, "") : O;
  var len = LengthOfArrayLike(self2);
  if (!IsCallable(callbackfn)) {
    throw new TypeError("Array.prototype.filter callback must be a function");
  }
  var thisArg;
  if (arguments.length > 1) {
    thisArg = arguments[1];
  }
  var A5 = ArraySpeciesCreate2(O, 0);
  var k = 0;
  var to = 0;
  while (k < len) {
    var Pk = ToString(k);
    var kPresent = HasProperty(O, Pk);
    if (kPresent) {
      var kValue = Get2(O, Pk);
      var selected = ToBoolean2(Call(callbackfn, thisArg, [kValue, k, O]));
      if (selected) {
        CreateDataPropertyOrThrow(A5, ToString(to), kValue);
        to += 1;
      }
    }
    k += 1;
  }
  return A5;
};
var esArrayMethodBoxesProperly = function properlyBoxed(method) {
  var properlyBoxesNonStrict = true;
  var properlyBoxesStrict = true;
  var threwException = false;
  if (typeof method === "function") {
    try {
      method.call("f", function(_, __, O) {
        if (typeof O !== "object") {
          properlyBoxesNonStrict = false;
        }
      });
      method.call([null], function() {
        "use strict";
        properlyBoxesStrict = typeof this === "string";
      }, "x");
    } catch (e) {
      threwException = true;
    }
    return !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
  }
  return false;
};
var arrayMethodBoxesProperly = esArrayMethodBoxesProperly;
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill8() {
  var method = Array.prototype.filter;
  return arrayMethodBoxesProperly(method) ? method : implementation$1;
};
var shim$1;
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim)
    return shim$1;
  hasRequiredShim = 1;
  var define2 = defineProperties_1;
  var getPolyfill10 = polyfill$1;
  shim$1 = function shimArrayPrototypeMap() {
    var polyfill2 = getPolyfill10();
    define2(Array.prototype, {
      filter: polyfill2
    }, {
      filter: function() {
        return Array.prototype.filter !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$1;
}
var define = defineProperties_1;
var RequireObjectCoercible = RequireObjectCoercible$6;
var callBind = callBindExports;
var callBound$1 = callBound$a;
var implementation = implementation$2;
var getPolyfill9 = polyfill$1;
var polyfill = callBind.apply(getPolyfill9());
var shim = requireShim();
var $slice = callBound$1("Array.prototype.slice");
var bound = function filter2(array2, callbackfn) {
  RequireObjectCoercible(array2);
  return polyfill(array2, $slice(arguments, 1));
};
define(bound, {
  getPolyfill: getPolyfill9,
  implementation,
  shim
});
var array_prototype_filter = bound;
var callBound = callBound$a;
var $push = callBound("Array.prototype.push");
var map$3 = function(arr, mapper) {
  var mapped = [];
  for (var i = 0; i < arr.length; i += 1) {
    $push(mapped, mapper(arr[i], i));
  }
  return mapped;
};
var expecteds = [
  ["HTMLElement", "article"],
  ["HTMLElement", "section"],
  ["HTMLBaseFontElement", "basefont", "HTMLBaseFontElementConstructor"],
  // Safari 5.1
  ["HTMLPhraseElement", "cite", "HTMLElement"],
  // Safari 5.1
  ["HTMLElement", "noscript"],
  ["HTMLBGSoundElement", "bgsound", "HTMLElement"],
  // Safari 5.1
  ["HTMLPhraseElement", "blink", "HTMLElement"],
  // Safari 5.1
  ["HTMLElement", "multicol"],
  ["HTMLNextIdElement", "nextid", "HTMLElement"],
  // Safari 5.1
  ["HTMLElement", "rb"],
  ["HTMLElement", "spacer"],
  ["HTMLAnchorElement", "a", "HTMLElement"],
  // Safari 5.1
  // ['HTMLAppletElement', 'applet'], // commented out due to IE 11 java update popup
  ["HTMLAreaElement", "area", "HTMLElement"],
  // Safari 5.1
  ["HTMLAudioElement", "audio", "HTMLElement"],
  // Safari 5.1
  ["HTMLBaseElement", "base", "HTMLElement"],
  // Safari 5.1
  ["HTMLBodyElement", "body", "HTMLElement"],
  // Safari 5.1
  ["HTMLBRElement", "br", "HTMLElement"],
  // Safari 5.1
  ["HTMLButtonElement", "button"],
  ["HTMLCanvasElement", "canvas"],
  ["HTMLContentElement", "content", "HTMLElement"],
  // Safari 5.1
  ["HTMLDataElement", "data", "HTMLElement"],
  // Safari 5.1
  ["HTMLDataListElement", "datalist"],
  ["HTMLDialogElement", "dialog", "HTMLElement"],
  // Safari 5.1
  ["HTMLDirectoryElement", "dir"],
  ["HTMLDivElement", "div"],
  ["HTMLDListElement", "dl"],
  ["HTMLEmbedElement", "embed"],
  ["HTMLFieldSetElement", "fieldset"],
  ["HTMLFontElement", "font"],
  ["HTMLFormElement", "form"],
  ["HTMLFrameElement", "frame"],
  ["HTMLFrameSetElement", "frameset"],
  ["HTMLHeadElement", "head"],
  ["HTMLHeadingElement", "h1"],
  ["HTMLHeadingElement", "h2"],
  ["HTMLHeadingElement", "h3"],
  ["HTMLHeadingElement", "h4"],
  ["HTMLHeadingElement", "h5"],
  ["HTMLHeadingElement", "h6"],
  ["HTMLHtmlElement", "html"],
  ["HTMLHRElement", "hr"],
  ["HTMLIFrameElement", "iframe"],
  ["HTMLImageElement", "img"],
  ["HTMLInputElement", "input"],
  ["HTMLIsIndexElement", "index", "HTMLElement"],
  // in HTML5, this is HTMLUnknownElement (Safari 5.1 for HTMLElement)
  ["HTMLKeygenElement", "keygen", "HTMLBlockElement"],
  ["HTMLLabelElement", "label"],
  ["HTMLLegendElement", "legend"],
  ["HTMLLIElement", "li"],
  ["HTMLLinkElement", "link"],
  ["HTMLElement", "main"],
  // in IE 9-11, this is HTMLUnknownElement
  ["HTMLMapElement", "map"],
  ["HTMLMarqueeElement", "marquee"],
  ["HTMLMenuElement", "menu"],
  ["HTMLMetaElement", "meta"],
  ["HTMLMeterElement", "meter", "HTMLElement"],
  // Safari 5.1
  ["HTMLModElement", "del"],
  ["HTMLModElement", "ins"],
  ["HTMLObjectElement", "object"],
  ["HTMLOListElement", "ol"],
  ["HTMLOptGroupElement", "optgroup"],
  ["HTMLOptionElement", "option"],
  ["HTMLOutputElement", "output"],
  ["HTMLParagraphElement", "p"],
  ["HTMLParamElement", "param"],
  ["HTMLPictureElement", "picture", "HTMLElement"],
  // Safari 5.1
  ["HTMLPreElement", "pre"],
  ["HTMLProgressElement", "progress", "HTMLElement"],
  // Safari 5.1
  ["HTMLQuoteElement", "q", "HTMLBlockquoteElement"],
  // Safari 5.1
  ["HTMLQuoteElement", "blockquote", "HTMLBlockElement", "HTMLBlockquoteElement"],
  // Safari 5.1
  ["HTMLScriptElement", "script"],
  ["HTMLSelectElement", "select"],
  ["HTMLShadowElement", "shadow", "HTMLElement"],
  // Safari 5.1
  ["HTMLSourceElement", "source"],
  ["HTMLSpanElement", "span", "HTMLElement"],
  // Safari 5.1
  ["HTMLStyleElement", "style"],
  ["HTMLTableElement", "table"],
  ["HTMLTableCaptionElement", "caption"],
  ["HTMLTableCellElement", "td", "HTMLTableDataCellElement"],
  ["HTMLTableCellElement", "th", "HTMLTableHeaderCellElement"],
  ["HTMLTableRowElement", "tr"],
  ["HTMLTableColElement", "col"],
  ["HTMLTableColElement", "colgroup"],
  ["HTMLTableSectionElement", "tbody"],
  ["HTMLTableSectionElement", "thead"],
  ["HTMLTableSectionElement", "tfoot"],
  ["HTMLTemplateElement", "template", "HTMLElement"],
  // Safari 5.1
  ["HTMLTextAreaElement", "textarea"],
  ["HTMLTimeElement", "time", "HTMLElement"],
  // Safari 5.1
  ["HTMLTitleElement", "title"],
  ["HTMLTrackElement", "track", "HTMLElement"],
  // Safari 5.1
  ["HTMLUListElement", "ul"],
  ["HTMLVideoElement", "video"],
  ["HTMLElement", "abbr"],
  ["HTMLElement", "address"],
  ["HTMLElement", "aside"],
  ["HTMLElement", "b"],
  ["HTMLElement", "bdi"],
  ["HTMLElement", "bdo"],
  ["HTMLElement", "code"],
  ["HTMLElement", "dd"],
  ["HTMLDetailsElement", "details", "HTMLElement"],
  // Safari 5.1
  ["HTMLElement", "dfn"],
  ["HTMLElement", "dt"],
  ["HTMLElement", "em"],
  ["HTMLElement", "figcaption"],
  ["HTMLElement", "figure"],
  ["HTMLElement", "footer"],
  ["HTMLElement", "header"],
  ["HTMLElement", "hgroup"],
  ["HTMLElement", "i"],
  ["HTMLElement", "kbd"],
  ["HTMLElement", "mark"],
  ["HTMLElement", "nav"],
  ["HTMLElement", "rp"],
  ["HTMLElement", "rt"],
  ["HTMLElement", "ruby"],
  ["HTMLElement", "s"],
  ["HTMLElement", "samp"],
  ["HTMLSlotElement", "slot", "HTMLElement"],
  // Safari 5.1
  ["HTMLElement", "small"],
  ["HTMLElement", "strong"],
  ["HTMLElement", "summary"],
  ["HTMLElement", "u"],
  ["HTMLElement", "var"],
  ["HTMLElement", "wbr"]
];
var getConstructor = function getTagConstructor(tag, constructor, unknown) {
  if (typeof document !== "undefined" && typeof document.createElement === "function") {
    var actual = document.createElement(tag).constructor;
    if (actual !== unknown) {
      return actual;
    }
  }
};
var getData$2 = function getData() {
  var unknown = globalThis.HTMLUnknownElement;
  return {
    all: globalThis.HTMLElement,
    elements: map$3(expecteds, function(expected) {
      var constructorName = expected[0];
      var tag = expected[1];
      var alternate;
      var altConstructor;
      for (var i = 2; i < arguments.length && !altConstructor; i += 1) {
        alternate = expected[i];
        altConstructor = alternate && globalThis[alternate];
      }
      var constructor = globalThis[constructorName];
      return {
        constructor: getConstructor(tag, altConstructor || constructor, unknown),
        constructorName: altConstructor ? alternate : constructorName,
        expectedConstructor: altConstructor || constructor,
        tag
      };
    }),
    unknown
  };
};
var filter3 = array_prototype_filter;
var getData$1 = getData$2;
var byConstructor = function byConstructor2(constructor) {
  if (!constructor) {
    return [];
  }
  var data2 = getData$1();
  if (constructor === data2.unknown) {
    return [];
  }
  if (constructor === data2.all) {
    return data2.elements;
  }
  return filter3(data2.elements, function(item) {
    return item.constructor === constructor;
  });
};
Object.defineProperty(selectors, "__esModule", {
  value: true
});
var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _slicedToArray = /* @__PURE__ */ function() {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i)
          break;
      }
    } catch (err2) {
      _d = true;
      _e = err2;
    } finally {
      try {
        if (!_n && _i["return"])
          _i["return"]();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
selectors.buildPredicate = buildPredicate;
selectors.reduceTreeBySelector = reduceTreeBySelector;
selectors.reduceTreesBySelector = reduceTreesBySelector;
var _rstSelectorParser = dist;
var _object = object_values;
var _object2 = _interopRequireDefault$9(_object);
var _arrayPrototype = array_prototype_flat;
var _arrayPrototype2 = _interopRequireDefault$9(_arrayPrototype);
var _objectIs = objectIs;
var _objectIs2 = _interopRequireDefault$9(_objectIs);
var _has = src$1;
var _has2 = _interopRequireDefault$9(_has);
var _byConstructor = byConstructor;
var _byConstructor2 = _interopRequireDefault$9(_byConstructor);
var _RSTTraversal = RSTTraversal;
var _Utils = Utils;
var _getAdapter = getAdapter;
var _getAdapter2 = _interopRequireDefault$9(_getAdapter);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var parser = (0, _rstSelectorParser.createParser)();
var CHILD = "childCombinator";
var ADJACENT_SIBLING = "adjacentSiblingCombinator";
var GENERAL_SIBLING = "generalSiblingCombinator";
var DESCENDANT = "descendantCombinator";
var SELECTOR = "selector";
var TYPE_SELECTOR = "typeSelector";
var CLASS_SELECTOR = "classSelector";
var ID_SELECTOR = "idSelector";
var UNIVERSAL_SELECTOR = "universalSelector";
var ATTRIBUTE_PRESENCE = "attributePresenceSelector";
var ATTRIBUTE_VALUE = "attributeValueSelector";
var PSEUDO_CLASS = "pseudoClassSelector";
var PSEUDO_ELEMENT = "pseudoElementSelector";
var EXACT_ATTRIBUTE_OPERATOR = "=";
var WHITELIST_ATTRIBUTE_OPERATOR = "~=";
var HYPHENATED_ATTRIBUTE_OPERATOR = "|=";
var PREFIX_ATTRIBUTE_OPERATOR = "^=";
var SUFFIX_ATTRIBUTE_OPERATOR = "$=";
var SUBSTRING_ATTRIBUTE_OPERATOR = "*=";
function unique(arr) {
  return [].concat(_toConsumableArray(new Set(arr)));
}
function uniqueReduce(fn, nodes) {
  return unique(nodes.reduce(fn, []));
}
function safelyGenerateTokens(selector2) {
  try {
    return parser.parse(selector2);
  } catch (err2) {
    throw new Error("Failed to parse selector: " + String(selector2));
  }
}
function matchAttributeSelector(node2, token2) {
  var operator = token2.operator, value2 = token2.value, name = token2.name;
  var nodeProps = (0, _Utils.propsOfNode)(node2);
  var descriptor = Object.getOwnPropertyDescriptor(nodeProps, name);
  if (descriptor && descriptor.get) {
    return false;
  }
  var nodePropValue = nodeProps[name];
  if (typeof nodePropValue === "undefined") {
    return false;
  }
  if (token2.type === ATTRIBUTE_PRESENCE) {
    return (0, _has2["default"])(nodeProps, token2.name);
  }
  if (typeof nodePropValue !== "string" || typeof value2 !== "string") {
    if (operator !== EXACT_ATTRIBUTE_OPERATOR) {
      return false;
    }
  }
  switch (operator) {
    case EXACT_ATTRIBUTE_OPERATOR:
      return (0, _objectIs2["default"])(nodePropValue, value2);
    case WHITELIST_ATTRIBUTE_OPERATOR:
      return nodePropValue.split(" ").indexOf(value2) !== -1;
    case HYPHENATED_ATTRIBUTE_OPERATOR:
      return nodePropValue === value2 || nodePropValue.startsWith(String(value2) + "-");
    case PREFIX_ATTRIBUTE_OPERATOR:
      return value2 === "" ? false : nodePropValue.slice(0, value2.length) === value2;
    case SUFFIX_ATTRIBUTE_OPERATOR:
      return value2 === "" ? false : nodePropValue.slice(-value2.length) === value2;
    case SUBSTRING_ATTRIBUTE_OPERATOR:
      return value2 === "" ? false : nodePropValue.indexOf(value2) !== -1;
    default:
      throw new Error('Enzyme::Selector: Unknown attribute selector operator "' + String(operator) + '"');
  }
}
function matchPseudoSelector(node2, token2, root2) {
  var name = token2.name, parameters = token2.parameters;
  if (name === "not") {
    return parameters.every(function(selector2) {
      return reduceTreeBySelector(selector2, node2).length === 0;
    });
  }
  if (name === "empty") {
    return (0, _RSTTraversal.treeFilter)(node2, function(n) {
      return n !== node2;
    }).length === 0;
  }
  if (name === "first-child") {
    var _findParentNode = (0, _RSTTraversal.findParentNode)(root2, node2), rendered = _findParentNode.rendered;
    var _rendered = _slicedToArray(rendered, 1), firstChild = _rendered[0];
    return firstChild === node2;
  }
  if (name === "last-child") {
    var _findParentNode2 = (0, _RSTTraversal.findParentNode)(root2, node2), _rendered2 = _findParentNode2.rendered;
    return _rendered2[_rendered2.length - 1] === node2;
  }
  if (name === "focus") {
    if (typeof document === "undefined") {
      throw new Error('Enzyme::Selector does not support the ":focus" pseudo-element without a global `document`.');
    }
    var adapter = (0, _getAdapter2["default"])();
    return document.activeElement && adapter.nodeToHostNode(node2) === document.activeElement;
  }
  throw new TypeError('Enzyme::Selector does not support the "' + String(token2.name) + '" pseudo-element or pseudo-class selectors.');
}
function nodeMatchesToken(node2, token2, root2) {
  if (node2 === null || typeof node2 === "string") {
    return false;
  }
  switch (token2.type) {
    case UNIVERSAL_SELECTOR:
      return true;
    case CLASS_SELECTOR:
      return (0, _RSTTraversal.hasClassName)(node2, token2.name);
    case TYPE_SELECTOR:
      return (0, _Utils.nodeHasType)(node2, token2.name);
    case ID_SELECTOR:
      return (0, _RSTTraversal.nodeHasId)(node2, token2.name);
    case ATTRIBUTE_PRESENCE:
      return matchAttributeSelector(node2, token2);
    case ATTRIBUTE_VALUE:
      return matchAttributeSelector(node2, token2);
    case PSEUDO_ELEMENT:
    case PSEUDO_CLASS:
      return matchPseudoSelector(node2, token2, root2);
    default:
      throw new Error("Unknown token type: " + String(token2.type));
  }
}
function buildPredicateFromToken(token2, root2) {
  return function(node2) {
    return token2.body.every(function(bodyToken) {
      return nodeMatchesToken(node2, bodyToken, root2);
    });
  };
}
function isComplexSelector(tokens) {
  return tokens.some(function(token2) {
    return token2.type !== SELECTOR;
  });
}
function buildPredicate(selector2) {
  if (typeof selector2 === "string") {
    var tokens = safelyGenerateTokens(selector2);
    if (isComplexSelector(tokens)) {
      throw new TypeError("This method does not support complex CSS selectors");
    }
    return buildPredicateFromToken(tokens[0]);
  }
  var adapter = (0, _getAdapter2["default"])();
  var isElementType = adapter.isValidElementType ? adapter.isValidElementType(selector2) : typeof selector2 === "function";
  if (isElementType) {
    return function(node2) {
      return adapter.matchesElementType(node2, selector2);
    };
  }
  if ((typeof selector2 === "undefined" ? "undefined" : _typeof$2(selector2)) === "object") {
    if (!Array.isArray(selector2) && selector2 !== null && Object.keys(selector2).length > 0) {
      var hasUndefinedValues = (0, _object2["default"])(selector2).some(function(value2) {
        return typeof value2 === "undefined";
      });
      if (hasUndefinedValues) {
        throw new TypeError("Enzyme::Props can’t have `undefined` values. Try using ‘findWhere()’ instead.");
      }
      return function(node2) {
        return (0, _RSTTraversal.nodeMatchesObjectProps)(node2, selector2);
      };
    }
    throw new TypeError("Enzyme::Selector does not support an array, null, or empty object as a selector");
  }
  throw new TypeError("Enzyme::Selector expects a string, object, or valid element type (Component Constructor)");
}
function matchAdjacentSiblings(nodes, predicate, root2) {
  return nodes.reduce(function(matches, node2) {
    var parent = (0, _RSTTraversal.findParentNode)(root2, node2);
    if (!parent) {
      return matches;
    }
    var parentChildren = (0, _RSTTraversal.childrenOfNode)(parent);
    var nodeIndex = parentChildren.indexOf(node2);
    var adjacentSibling = parentChildren[nodeIndex + 1];
    if (!adjacentSibling) {
      return matches;
    }
    if (predicate(adjacentSibling)) {
      matches.push(adjacentSibling);
    }
    return matches;
  }, []);
}
function matchGeneralSibling(nodes, predicate, root2) {
  return uniqueReduce(function(matches, node2) {
    var parent = (0, _RSTTraversal.findParentNode)(root2, node2);
    if (!parent) {
      return matches;
    }
    var parentChildren = (0, _RSTTraversal.childrenOfNode)(parent);
    var nodeIndex = parentChildren.indexOf(node2);
    var youngerSiblings = parentChildren.slice(nodeIndex + 1);
    return matches.concat(youngerSiblings.filter(predicate));
  }, nodes);
}
function matchDirectChild(nodes, predicate) {
  return uniqueReduce(function(matches, node2) {
    return matches.concat((0, _RSTTraversal.childrenOfNode)(node2).filter(predicate));
  }, nodes);
}
function matchDescendant(nodes, predicate) {
  return uniqueReduce(function(matches, node2) {
    return matches.concat((0, _RSTTraversal.treeFilter)(node2, predicate));
  }, (0, _arrayPrototype2["default"])(nodes.map(_RSTTraversal.childrenOfNode)));
}
function reduceTreeBySelector(selector2, root2) {
  if (typeof selector2 !== "string") {
    var elements = (0, _byConstructor2["default"])(selector2);
    if (elements.length > 0) {
      return (0, _arrayPrototype2["default"])(elements.map(function(x) {
        return reduceTreeBySelector(x.tag, root2);
      }));
    }
  }
  if (typeof selector2 === "function" || (typeof selector2 === "undefined" ? "undefined" : _typeof$2(selector2)) === "object") {
    return (0, _RSTTraversal.treeFilter)(root2, buildPredicate(selector2));
  }
  var results = [];
  if (typeof selector2 === "string") {
    var tokens = safelyGenerateTokens(selector2);
    var index2 = 0;
    while (index2 < tokens.length) {
      var token2 = tokens[index2];
      if (token2.type === SELECTOR) {
        var predicate = buildPredicateFromToken(token2, root2);
        results = results.concat((0, _RSTTraversal.treeFilter)(root2, predicate));
      } else {
        var type3 = token2.type;
        index2 += 1;
        var _predicate = buildPredicateFromToken(tokens[index2], root2);
        switch (type3) {
          case ADJACENT_SIBLING:
            results = matchAdjacentSiblings(results, _predicate, root2);
            break;
          case GENERAL_SIBLING:
            results = matchGeneralSibling(results, _predicate, root2);
            break;
          case CHILD:
            results = matchDirectChild(results, _predicate);
            break;
          case DESCENDANT: {
            results = matchDescendant(results, _predicate);
            break;
          }
          default:
            throw new Error("Unknown combinator selector: " + String(type3));
        }
      }
      index2 += 1;
    }
  } else {
    throw new TypeError("Enzyme::Selector expects a string, object, or Component Constructor");
  }
  return results;
}
function reduceTreesBySelector(selector2, roots) {
  var results = roots.map(function(n) {
    return reduceTreeBySelector(selector2, n);
  });
  return unique((0, _arrayPrototype2["default"])(results, 1));
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties2(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties2(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _object5 = object_assign;
  var _object22 = _interopRequireDefault2(_object5);
  var _arrayPrototype3 = array_prototype_flat;
  var _arrayPrototype22 = _interopRequireDefault2(_arrayPrototype3);
  var _has3 = src$1;
  var _has22 = _interopRequireDefault2(_has3);
  var _Utils2 = Utils;
  var _getAdapter3 = getAdapter;
  var _getAdapter22 = _interopRequireDefault2(_getAdapter3);
  var _Debug = Debug;
  var _RSTTraversal2 = RSTTraversal;
  var _selectors = selectors;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _defineProperty2(obj, key, value2) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value2,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value2;
    }
    return obj;
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var NODE = (0, _Utils2.sym)("__node__");
  var NODES = (0, _Utils2.sym)("__nodes__");
  var RENDERER = (0, _Utils2.sym)("__renderer__");
  var UNRENDERED = (0, _Utils2.sym)("__unrendered__");
  var ROOT = (0, _Utils2.sym)("__root__");
  var OPTIONS = (0, _Utils2.sym)("__options__");
  var ROOT_NODES = (0, _Utils2.sym)("__rootNodes__");
  var WRAPPING_COMPONENT = (0, _Utils2.sym)("__wrappingComponent__");
  var LINKED_ROOTS = (0, _Utils2.sym)("__linkedRoots__");
  var UPDATED_BY = (0, _Utils2.sym)("__updatedBy__");
  function findWhereUnwrapped(wrapper2, predicate) {
    var filter4 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _RSTTraversal2.treeFilter;
    return wrapper2.flatMap(function(n) {
      return filter4(n.getNodeInternal(), predicate);
    });
  }
  function filterWhereUnwrapped(wrapper2, predicate) {
    return wrapper2.wrap(wrapper2.getNodesInternal().filter(predicate).filter(Boolean));
  }
  function getRootNodeInternal(wrapper2) {
    if (wrapper2[ROOT].length !== 1) {
      throw new Error("getRootNodeInternal(wrapper) can only be called when wrapper wraps one node");
    }
    if (wrapper2[ROOT] !== wrapper2) {
      return wrapper2[ROOT_NODES][0];
    }
    return wrapper2[ROOT][NODE];
  }
  function nodeParents(wrapper2, node2) {
    return (0, _RSTTraversal2.parentsOfNode)(node2, getRootNodeInternal(wrapper2));
  }
  function privateSetNodes(wrapper2, nodes) {
    if (!nodes) {
      (0, _Utils2.privateSet)(wrapper2, NODE, null);
      (0, _Utils2.privateSet)(wrapper2, NODES, []);
    } else if (!Array.isArray(nodes)) {
      (0, _Utils2.privateSet)(wrapper2, NODE, nodes);
      (0, _Utils2.privateSet)(wrapper2, NODES, [nodes]);
    } else {
      (0, _Utils2.privateSet)(wrapper2, NODE, nodes[0]);
      (0, _Utils2.privateSet)(wrapper2, NODES, nodes);
    }
    (0, _Utils2.privateSet)(wrapper2, "length", wrapper2[NODES].length);
  }
  var ReactWrapper2 = function() {
    function ReactWrapper22(nodes, root2) {
      var passedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      _classCallCheck2(this, ReactWrapper22);
      if (!globalThis.window && !globalThis.document) {
        throw new Error("It looks like you called `mount()` without a global document being loaded.");
      }
      var options2 = (0, _Utils2.makeOptions)(passedOptions);
      if (!root2) {
        var adapter = (0, _getAdapter22["default"])(options2);
        if (!adapter.isValidElement(nodes)) {
          throw new TypeError("ReactWrapper can only wrap valid elements");
        }
        var renderer = adapter.createRenderer((0, _object22["default"])({
          mode: "mount"
        }, options2));
        (0, _Utils2.privateSet)(this, RENDERER, renderer);
        renderer.render(nodes, options2.context);
        (0, _Utils2.privateSet)(this, ROOT, this);
        privateSetNodes(this, this[RENDERER].getNode());
        (0, _Utils2.privateSet)(this, OPTIONS, options2);
        (0, _Utils2.privateSet)(this, LINKED_ROOTS, []);
        if ((0, _Utils2.isCustomComponent)(options2.wrappingComponent, adapter)) {
          if (typeof this[RENDERER].getWrappingComponentRenderer !== "function") {
            throw new TypeError("your adapter does not support `wrappingComponent`. Try upgrading it!");
          }
          (0, _Utils2.privateSet)(this, WRAPPING_COMPONENT, new WrappingComponentWrapper(this, this[RENDERER].getWrappingComponentRenderer()));
          this[LINKED_ROOTS].push(this[WRAPPING_COMPONENT]);
        }
      } else {
        (0, _Utils2.privateSet)(this, RENDERER, root2[RENDERER]);
        (0, _Utils2.privateSet)(this, ROOT, root2);
        privateSetNodes(this, nodes);
        (0, _Utils2.privateSet)(this, ROOT_NODES, root2[NODES]);
        (0, _Utils2.privateSet)(this, OPTIONS, root2[OPTIONS]);
        (0, _Utils2.privateSet)(this, LINKED_ROOTS, []);
      }
      (0, _Utils2.privateSet)(this, UNRENDERED, nodes);
      (0, _Utils2.privateSet)(this, UPDATED_BY, null);
    }
    _createClass2(ReactWrapper22, [{
      key: "root",
      value: /* @__PURE__ */ function() {
        function root2() {
          return this[ROOT];
        }
        return root2;
      }()
      /**
       * Returns the wrapped component.
       *
       * @return {ReactComponent}
       */
    }, {
      key: "getNodeInternal",
      value: /* @__PURE__ */ function() {
        function getNodeInternal() {
          if (this.length !== 1) {
            throw new Error("ReactWrapper::getNode() can only be called when wrapping one node");
          }
          return this[NODES][0];
        }
        return getNodeInternal;
      }()
      /**
       * Returns the the wrapped components.
       *
       * @return {Array<ReactComponent>}
       */
    }, {
      key: "getNodesInternal",
      value: /* @__PURE__ */ function() {
        function getNodesInternal() {
          return this[NODES];
        }
        return getNodesInternal;
      }()
      /**
       * Returns the wrapped ReactElement.
       *
       * @return {ReactElement}
       */
    }, {
      key: "getElement",
      value: /* @__PURE__ */ function() {
        function getElement() {
          var _this = this;
          return this.single("getElement", function() {
            return (0, _getAdapter22["default"])(_this[OPTIONS]).nodeToElement(_this[NODE]);
          });
        }
        return getElement;
      }()
      /**
       * Returns the wrapped ReactElements.
       *
       * @return {Array<ReactElement>}
       */
    }, {
      key: "getElements",
      value: /* @__PURE__ */ function() {
        function getElements2() {
          var _this2 = this;
          return this[NODES].map(function(n) {
            return (0, _getAdapter22["default"])(_this2[OPTIONS]).nodeToElement(n);
          });
        }
        return getElements2;
      }()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getNode",
      value: /* @__PURE__ */ function() {
        function getNode() {
          throw new Error("ReactWrapper::getNode() is no longer supported. Use ReactWrapper::instance() instead");
        }
        return getNode;
      }()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getNodes",
      value: /* @__PURE__ */ function() {
        function getNodes() {
          throw new Error("ReactWrapper::getNodes() is no longer supported.");
        }
        return getNodes;
      }()
      /**
       * Returns the outer most DOMComponent of the current wrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {DOMComponent}
       */
    }, {
      key: "getDOMNode",
      value: /* @__PURE__ */ function() {
        function getDOMNode() {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return this.single("getDOMNode", function(n) {
            return adapter.nodeToHostNode(n, true);
          });
        }
        return getDOMNode;
      }()
      /**
       * If the root component contained a ref, you can access it here and get the relevant
       * react component instance or HTML element instance.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {String} refname
       * @returns {ReactComponent | HTMLElement}
       */
    }, {
      key: "ref",
      value: /* @__PURE__ */ function() {
        function ref2(refname) {
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::ref(refname) can only be called on the root");
          }
          return this.instance().refs[refname];
        }
        return ref2;
      }()
      /**
       * Returns the wrapper's underlying instance.
       *
       * Example:
       * ```
       * const wrapper = mount(<MyComponent />);
       * const inst = wrapper.instance();
       * expect(inst).to.be.instanceOf(MyComponent);
       * ```
       * @returns {ReactComponent|DOMComponent}
       */
    }, {
      key: "instance",
      value: /* @__PURE__ */ function() {
        function instance() {
          var _this3 = this;
          return this.single("instance", function() {
            return _this3[NODE].instance;
          });
        }
        return instance;
      }()
      /**
       * If a `wrappingComponent` was passed in `options`, this methods returns a `ReactWrapper` around
       * the rendered `wrappingComponent`. This `ReactWrapper` can be used to update the
       * `wrappingComponent`'s props, state, etc.
       *
       * @returns ReactWrapper
       */
    }, {
      key: "getWrappingComponent",
      value: /* @__PURE__ */ function() {
        function getWrappingComponent() {
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::getWrappingComponent() can only be called on the root");
          }
          if (!this[OPTIONS].wrappingComponent) {
            throw new Error("ReactWrapper::getWrappingComponent() can only be called on a wrapper that was originally passed a `wrappingComponent` option");
          }
          return this[WRAPPING_COMPONENT];
        }
        return getWrappingComponent;
      }()
      /**
       * Forces a re-render. Useful to run before checking the render output if something external
       * may be updating the state of the component somewhere.
       *
       * NOTE: no matter what instance this is called on, it will always update the root.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "update",
      value: /* @__PURE__ */ function() {
        function update2() {
          var _this4 = this;
          var root2 = this[ROOT];
          if (this !== root2) {
            return root2.update();
          }
          privateSetNodes(this, this[RENDERER].getNode());
          this[LINKED_ROOTS].forEach(function(linkedRoot) {
            if (linkedRoot !== _this4[UPDATED_BY]) {
              linkedRoot[UPDATED_BY] = _this4;
              try {
                linkedRoot.update();
              } finally {
                linkedRoot[UPDATED_BY] = null;
              }
            }
          });
          return this;
        }
        return update2;
      }()
      /**
       * A method that unmounts the component. This can be used to simulate a component going through
       * and unmount/mount lifecycle.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "unmount",
      value: /* @__PURE__ */ function() {
        function unmount() {
          var _this5 = this;
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::unmount() can only be called on the root");
          }
          this.single("unmount", function() {
            _this5[RENDERER].unmount();
            _this5.update();
          });
          return this;
        }
        return unmount;
      }()
      /**
       * A method that re-mounts the component, if it is not currently mounted.
       * This can be used to simulate a component going through
       * an unmount/mount lifecycle.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "mount",
      value: /* @__PURE__ */ function() {
        function mount2() {
          var _this6 = this;
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::mount() can only be called on the root");
          }
          this[RENDERER].render(this[UNRENDERED], this[OPTIONS].context, function() {
            return _this6.update();
          });
          return this;
        }
        return mount2;
      }()
      /**
       * A method that sets the props of the root component, and re-renders. Useful for when you are
       * wanting to test how the component behaves over time with changing props. Calling this, for
       * instance, will call the `componentWillReceiveProps` lifecycle method.
       *
       * Similar to `setState`, this method accepts a props object and will merge it in with the already
       * existing props.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} props object
       * @param {Function} cb - callback function
       * @returns {ReactWrapper}
       */
    }, {
      key: "setProps",
      value: /* @__PURE__ */ function() {
        function setProps(props) {
          var _this7 = this;
          var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::setProps() can only be called on the root");
          }
          if (arguments.length > 1 && typeof callback !== "function") {
            throw new TypeError("ReactWrapper::setProps() expects a function as its second argument");
          }
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          this[UNRENDERED] = (0, _Utils2.cloneElement)(adapter, this[UNRENDERED], props);
          this[RENDERER].render(this[UNRENDERED], null, function() {
            _this7.update();
            if (callback) {
              callback();
            }
          });
          return this;
        }
        return setProps;
      }()
      /**
       * A method to invoke `setState` on the root component instance similar to how you might in the
       * definition of the component, and re-renders.  This method is useful for testing your component
       * in hard to achieve states, however should be used sparingly. If possible, you should utilize
       * your component's external API in order to get it into whatever state you want to test, in order
       * to be as accurate of a test as possible. This is not always practical, however.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} state to merge
       * @param {Function} cb - callback function
       * @returns {ReactWrapper}
       */
    }, {
      key: "setState",
      value: /* @__PURE__ */ function() {
        function setState(state) {
          var _this8 = this;
          var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (this.instance() === null || this.getNodeInternal().nodeType !== "class") {
            throw new Error("ReactWrapper::setState() can only be called on class components");
          }
          if (arguments.length > 1 && typeof callback !== "function") {
            throw new TypeError("ReactWrapper::setState() expects a function as its second argument");
          }
          this.instance().setState(state, function() {
            _this8.update();
            if (callback) {
              var adapter = (0, _getAdapter22["default"])(_this8[OPTIONS]);
              var instance = _this8.instance();
              if (adapter.invokeSetStateCallback) {
                adapter.invokeSetStateCallback(instance, callback);
              } else {
                callback.call(instance);
              }
            }
          });
          return this;
        }
        return setState;
      }()
      /**
       * A method that sets the context of the root component, and re-renders. Useful for when you are
       * wanting to test how the component behaves over time with changing contexts.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} context object
       * @returns {ReactWrapper}
       */
    }, {
      key: "setContext",
      value: /* @__PURE__ */ function() {
        function setContext(context) {
          var _this9 = this;
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::setContext() can only be called on the root");
          }
          if (!this[OPTIONS].context) {
            throw new Error("ReactWrapper::setContext() can only be called on a wrapper that was originally passed a context option");
          }
          this[RENDERER].render(this[UNRENDERED], context, function() {
            return _this9.update();
          });
          return this;
        }
        return setContext;
      }()
      /**
       * Whether or not a given react element exists in the mount render tree.
       *
       * Example:
       * ```
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
       * ```
       *
       * @param {ReactElement|Array<ReactElement>} nodeOrNodes
       * @returns {Boolean}
       */
    }, {
      key: "contains",
      value: /* @__PURE__ */ function() {
        function contains2(nodeOrNodes) {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          var predicate = Array.isArray(nodeOrNodes) ? function(other) {
            return (0, _Utils2.containsChildrenSubArray)(_Utils2.nodeEqual, other, nodeOrNodes.map(function(node2) {
              return adapter.elementToNode(node2);
            }));
          } : function(other) {
            return (0, _Utils2.nodeEqual)(adapter.elementToNode(nodeOrNodes), other);
          };
          return findWhereUnwrapped(this, predicate).length > 0;
        }
        return contains2;
      }()
      /**
       * Whether or not a given react element exists in the current render tree.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * // MyComponent outputs <div><div class="foo">Hello</div></div>
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "containsMatchingElement",
      value: /* @__PURE__ */ function() {
        function containsMatchingElement(node2) {
          var rstNode = (0, _getAdapter22["default"])(this[OPTIONS]).elementToNode(node2);
          var predicate = /* @__PURE__ */ function() {
            function predicate2(other) {
              return (0, _Utils2.nodeMatches)(rstNode, other, function(a, b) {
                return a <= b;
              });
            }
            return predicate2;
          }();
          return findWhereUnwrapped(this, predicate).length > 0;
        }
        return containsMatchingElement;
      }()
      /**
       * Whether or not all the given react elements exist in the current render tree.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.containsAllMatchingElements([
       *   <div>Hello</div>,
       *   <div>Goodbye</div>,
       * ])).to.equal(true);
       * ```
       *
       * @param {Array<ReactElement>} nodes
       * @returns {Boolean}
       */
    }, {
      key: "containsAllMatchingElements",
      value: /* @__PURE__ */ function() {
        function containsAllMatchingElements(nodes) {
          var _this10 = this;
          if (!Array.isArray(nodes)) {
            throw new TypeError("nodes should be an Array");
          }
          return nodes.every(function(node2) {
            return _this10.containsMatchingElement(node2);
          });
        }
        return containsAllMatchingElements;
      }()
      /**
       * Whether or not one of the given react elements exists in the current render tree.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.containsAnyMatchingElements([
       *   <div>Hello</div>,
       *   <div>Goodbye</div>,
       * ])).to.equal(true);
       * ```
       *
       * @param {Array<ReactElement>} nodes
       * @returns {Boolean}
       */
    }, {
      key: "containsAnyMatchingElements",
      value: /* @__PURE__ */ function() {
        function containsAnyMatchingElements(nodes) {
          var _this11 = this;
          return Array.isArray(nodes) && nodes.some(function(node2) {
            return _this11.containsMatchingElement(node2);
          });
        }
        return containsAnyMatchingElements;
      }()
      /**
       * Whether or not a given react element exists in the render tree.
       *
       * Example:
       * ```
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "equals",
      value: /* @__PURE__ */ function() {
        function equals(node2) {
          var _this12 = this;
          return this.single("equals", function() {
            return (0, _Utils2.nodeEqual)(_this12.getNodeInternal(), node2);
          });
        }
        return equals;
      }()
      /**
       * Whether or not a given react element matches the render tree.
       * Match is based on the expected element and not on wrapper root node.
       * It will determine if the wrapper root node "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrapper root node and equals to each other.
       *
       * Example:
       * ```
       * // MyComponent outputs <div class="foo">Hello</div>
       * const wrapper = mount(<MyComponent />);
       * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "matchesElement",
      value: /* @__PURE__ */ function() {
        function matchesElement(node2) {
          var _this13 = this;
          return this.single("matchesElement", function() {
            var adapter = (0, _getAdapter22["default"])(_this13[OPTIONS]);
            var rstNode = adapter.elementToNode(node2);
            return (0, _Utils2.nodeMatches)(rstNode, _this13.getNodeInternal(), function(a, b) {
              return a <= b;
            });
          });
        }
        return matchesElement;
      }()
      /**
       * Finds every node in the render tree of the current wrapper that matches the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {ReactWrapper}
       */
    }, {
      key: "find",
      value: /* @__PURE__ */ function() {
        function find2(selector2) {
          return this.wrap((0, _selectors.reduceTreesBySelector)(selector2, this.getNodesInternal()));
        }
        return find2;
      }()
      /**
       * Returns whether or not current node matches a provided selector.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {EnzymeSelector} selector
       * @returns {boolean}
       */
    }, {
      key: "is",
      value: /* @__PURE__ */ function() {
        function is3(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.single("is", function(n) {
            return predicate(n);
          });
        }
        return is3;
      }()
      /**
       * Returns true if the component rendered nothing, i.e., null or false.
       *
       * @returns {boolean}
       */
    }, {
      key: "isEmptyRender",
      value: /* @__PURE__ */ function() {
        function isEmptyRender() {
          var nodes = this.getNodeInternal();
          return (0, _Utils2.renderedDive)(nodes);
        }
        return isEmptyRender;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
       * the provided predicate function.
       *
       * @param {Function} predicate
       * @returns {ReactWrapper}
       */
    }, {
      key: "filterWhere",
      value: /* @__PURE__ */ function() {
        function filterWhere(predicate) {
          var _this14 = this;
          return filterWhereUnwrapped(this, function(n) {
            return predicate(_this14.wrap(n));
          });
        }
        return filterWhere;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
       * the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {ReactWrapper}
       */
    }, {
      key: "filter",
      value: /* @__PURE__ */ function() {
        function filter4(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return filterWhereUnwrapped(this, predicate);
        }
        return filter4;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
       * the provided selector. Essentially the inverse of `filter`.
       *
       * @param {EnzymeSelector} selector
       * @returns {ReactWrapper}
       */
    }, {
      key: "not",
      value: /* @__PURE__ */ function() {
        function not2(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return filterWhereUnwrapped(this, function(n) {
            return !predicate(n);
          });
        }
        return not2;
      }()
      /**
       * Returns a string of the rendered text of the current render tree.  This function should be
       * looked at with skepticism if being used to test what the actual HTML output of the component
       * will be. If that is what you would like to test, use enzyme's `render` function instead.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {String}
       */
    }, {
      key: "text",
      value: /* @__PURE__ */ function() {
        function text2() {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return this.single("text", function(n) {
            return (0, _RSTTraversal2.getTextFromHostNodes)(n, adapter);
          });
        }
        return text2;
      }()
      /**
       * Returns the HTML of the node.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {String}
       */
    }, {
      key: "html",
      value: /* @__PURE__ */ function() {
        function html2() {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return this.single("html", function(n) {
            return (0, _RSTTraversal2.getHTMLFromHostNodes)(n, adapter);
          });
        }
        return html2;
      }()
      /**
       * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {CheerioWrapper}
       */
    }, {
      key: "render",
      value: /* @__PURE__ */ function() {
        function render3() {
          var html2 = this.html();
          return (0, _Utils2.loadCheerioRoot)(html2);
        }
        return render3;
      }()
      /**
       * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
       * testing events should be met with some skepticism.
       *
       * @param {String} event
       * @param {Object} mock (optional)
       * @returns {ReactWrapper}
       */
    }, {
      key: "simulate",
      value: /* @__PURE__ */ function() {
        function simulate(event) {
          var _this15 = this;
          var mock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return this.single("simulate", function(n) {
            _this15[RENDERER].simulateEvent(n, event, mock);
            _this15[ROOT].update();
            return _this15;
          });
        }
        return simulate;
      }()
      /**
       * Used to simulate throwing a rendering error. Pass an error to throw.
       *
       * @param {String} error
       * @returns {ReactWrapper}
       */
    }, {
      key: "simulateError",
      value: /* @__PURE__ */ function() {
        function simulateError(error) {
          var _this16 = this;
          if (this[ROOT] === this) {
            throw new Error("ReactWrapper::simulateError() may not be called on the root");
          }
          return this.single("simulateError", function(thisNode) {
            if (thisNode.nodeType === "host") {
              throw new Error("ReactWrapper::simulateError() can only be called on custom components");
            }
            var renderer = _this16[RENDERER];
            if (typeof renderer.simulateError !== "function") {
              throw new TypeError("your adapter does not support `simulateError`. Try upgrading it!");
            }
            var rootNode = getRootNodeInternal(_this16);
            var nodeHierarchy = [thisNode].concat(nodeParents(_this16, thisNode));
            renderer.simulateError(nodeHierarchy, rootNode, error);
            _this16[ROOT].update();
            return _this16;
          });
        }
        return simulateError;
      }()
      /**
       * Returns the props hash for the root node of the wrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {Object}
       */
    }, {
      key: "props",
      value: /* @__PURE__ */ function() {
        function props() {
          return this.single("props", _RSTTraversal2.propsOfNode);
        }
        return props;
      }()
      /**
       * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
       * will return just that value.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {String} name (optional)
       * @returns {*}
       */
    }, {
      key: "state",
      value: /* @__PURE__ */ function() {
        function state(name) {
          var _this17 = this;
          var thisNode = this[ROOT] === this ? this[RENDERER].getNode() : this.getNodeInternal();
          if (this.instance() === null || thisNode.nodeType !== "class") {
            throw new Error("ReactWrapper::state() can only be called on class components");
          }
          var _state = this.single("state", function() {
            return _this17.instance().state;
          });
          if (typeof name !== "undefined") {
            if (_state == null) {
              throw new TypeError('ReactWrapper::state("' + String(name) + '") requires that `state` not be `null` or `undefined`');
            }
            return _state[name];
          }
          return _state;
        }
        return state;
      }()
      /**
       * Returns the context hash for the root node of the wrapper.
       * Optionally pass in a prop name and it will return just that value.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {String} name (optional)
       * @returns {*}
       */
    }, {
      key: "context",
      value: /* @__PURE__ */ function() {
        function context(name) {
          var _this18 = this;
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::context() can only be called on the root");
          }
          var instance = this.single("context", function() {
            return _this18.instance();
          });
          if (instance === null) {
            throw new Error("ReactWrapper::context() can only be called on components with instances");
          }
          var _context = instance.context;
          if (typeof name !== "undefined") {
            return _context[name];
          }
          return _context;
        }
        return context;
      }()
      /**
       * Returns a new wrapper with all of the children of the current wrapper.
       *
       * @param {EnzymeSelector} [selector]
       * @returns {ReactWrapper}
       */
    }, {
      key: "children",
      value: /* @__PURE__ */ function() {
        function children3(selector2) {
          var allChildren = this.flatMap(function(n) {
            return (0, _RSTTraversal2.childrenOfNode)(n.getNodeInternal());
          });
          return selector2 ? allChildren.filter(selector2) : allChildren;
        }
        return children3;
      }()
      /**
       * Returns a new wrapper with a specific child
       *
       * @param {Number} [index]
       * @returns {ReactWrapper}
       */
    }, {
      key: "childAt",
      value: /* @__PURE__ */ function() {
        function childAt(index2) {
          var _this19 = this;
          return this.single("childAt", function() {
            return _this19.children().at(index2);
          });
        }
        return childAt;
      }()
      /**
       * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
       * in the current wrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {EnzymeSelector} [selector]
       * @returns {ReactWrapper}
       */
    }, {
      key: "parents",
      value: /* @__PURE__ */ function() {
        function parents(selector2) {
          var _this20 = this;
          return this.single("parents", function(n) {
            var allParents = _this20.wrap(nodeParents(_this20, n));
            return selector2 ? allParents.filter(selector2) : allParents;
          });
        }
        return parents;
      }()
      /**
       * Returns a wrapper around the immediate parent of the current node.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "parent",
      value: /* @__PURE__ */ function() {
        function parent() {
          return this.flatMap(function(n) {
            return [n.parents().get(0)];
          });
        }
        return parent;
      }()
      /**
       *
       * @param {EnzymeSelector} selector
       * @returns {ReactWrapper}
       */
    }, {
      key: "closest",
      value: /* @__PURE__ */ function() {
        function closest2(selector2) {
          if (this.is(selector2)) {
            return this;
          }
          var matchingAncestors = this.parents().filter(selector2);
          return matchingAncestors.length > 0 ? matchingAncestors.first() : this.findWhere(function() {
            return false;
          });
        }
        return closest2;
      }()
      /**
       * Returns the value of  prop with the given name of the root node.
       *
       * @param {String} propName
       * @returns {*}
       */
    }, {
      key: "prop",
      value: /* @__PURE__ */ function() {
        function prop2(propName) {
          return this.props()[propName];
        }
        return prop2;
      }()
      /**
       * Used to invoke a function prop.
       * Will invoke an function prop and return its value.
       *
       * @param {String} propName
       * @returns {Any}
       */
    }, {
      key: "invoke",
      value: /* @__PURE__ */ function() {
        function invoke(propName) {
          var _this21 = this;
          return this.single("invoke", function() {
            var handler = _this21.prop(propName);
            if (typeof handler !== "function") {
              throw new TypeError("ReactWrapper::invoke() requires the name of a prop whose value is a function");
            }
            return function() {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              var response = typeof _this21[RENDERER].wrapInvoke === "function" ? _this21[RENDERER].wrapInvoke(function() {
                return handler.apply(void 0, args);
              }) : handler.apply(void 0, args);
              _this21[ROOT].update();
              return response;
            };
          });
        }
        return invoke;
      }()
      /**
       * Returns a wrapper of the node rendered by the provided render prop.
       *
       * @param {String} propName
       * @returns {Function}
       */
    }, {
      key: "renderProp",
      value: /* @__PURE__ */ function() {
        function renderProp(propName) {
          var _this22 = this;
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          if (typeof adapter.wrap !== "function") {
            throw new RangeError("your adapter does not support `wrap`. Try upgrading it!");
          }
          return this.single("renderProp", function(n) {
            if (n.nodeType === "host") {
              throw new TypeError("ReactWrapper::renderProp() can only be called on custom components");
            }
            if (typeof propName !== "string") {
              throw new TypeError("ReactWrapper::renderProp(): `propName` must be a string");
            }
            var props = _this22.props();
            if (!(0, _has22["default"])(props, propName)) {
              throw new Error("ReactWrapper::renderProp(): no prop called “" + String(propName) + "“ found");
            }
            var propValue = props[propName];
            if (typeof propValue !== "function") {
              throw new TypeError("ReactWrapper::renderProp(): expected prop “" + String(propName) + "“ to contain a function, but it holds “" + (typeof propValue === "undefined" ? "undefined" : _typeof2(propValue)) + "“");
            }
            return function() {
              var element = propValue.apply(void 0, arguments);
              var wrapped = adapter.wrap(element);
              return _this22.wrap(wrapped, null, _this22[OPTIONS]);
            };
          });
        }
        return renderProp;
      }()
      /**
       * Returns the key assigned to the current node.
       *
       * @returns {String}
       */
    }, {
      key: "key",
      value: /* @__PURE__ */ function() {
        function key() {
          return this.single("key", function(n) {
            return n.key === void 0 ? null : n.key;
          });
        }
        return key;
      }()
      /**
       * Returns the type of the root node of this wrapper. If it's a composite component, this will be
       * the component constructor. If it's native DOM node, it will be a string.
       *
       * @returns {String|Function}
       */
    }, {
      key: "type",
      value: /* @__PURE__ */ function() {
        function type3() {
          return this.single("type", function(n) {
            return (0, _Utils2.typeOfNode)(n);
          });
        }
        return type3;
      }()
      /**
       * Returns the name of the root node of this wrapper.
       *
       * In order of precedence => type.displayName -> type.name -> type.
       *
       * @returns {String}
       */
    }, {
      key: "name",
      value: /* @__PURE__ */ function() {
        function name() {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return this.single("name", function(n) {
            return adapter.displayNameOfNode ? adapter.displayNameOfNode(n) : (0, _Utils2.displayNameOfNode)(n);
          });
        }
        return name;
      }()
      /**
       * Returns whether or not the current root node has the given class name or not.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {String} className
       * @returns {Boolean}
       */
    }, {
      key: "hasClass",
      value: /* @__PURE__ */ function() {
        function hasClass2(className2) {
          if (typeof className2 === "string" && className2.indexOf(".") !== -1) {
            console.warn("It looks like you're calling `ReactWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.");
          }
          return this.single("hasClass", function(n) {
            return (0, _RSTTraversal2.hasClassName)(n, className2);
          });
        }
        return hasClass2;
      }()
      /**
       * Iterates through each node of the current wrapper and executes the provided function with a
       * wrapper around the corresponding node passed in as the first argument.
       *
       * @param {Function} fn
       * @returns {ReactWrapper}
       */
    }, {
      key: "forEach",
      value: /* @__PURE__ */ function() {
        function forEach2(fn) {
          var _this23 = this;
          this.getNodesInternal().forEach(function(n, i) {
            return fn.call(_this23, _this23.wrap(n), i);
          });
          return this;
        }
        return forEach2;
      }()
      /**
       * Maps the current array of nodes to another array. Each node is passed in as a `ReactWrapper`
       * to the map function.
       *
       * @param {Function} fn
       * @returns {Array}
       */
    }, {
      key: "map",
      value: /* @__PURE__ */ function() {
        function map2(fn) {
          var _this24 = this;
          return this.getNodesInternal().map(function(n, i) {
            return fn.call(_this24, _this24.wrap(n), i);
          });
        }
        return map2;
      }()
      /**
       * Reduces the current array of nodes to another array.
       * Each node is passed in as a `ShallowWrapper` to the reducer function.
       *
       * @param {Function} fn - the reducer function
       * @param {*} initialValue - the initial value
       * @returns {*}
       */
    }, {
      key: "reduce",
      value: /* @__PURE__ */ function() {
        function reduce2(fn) {
          var _this25 = this;
          var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (arguments.length > 1) {
            return this.getNodesInternal().reduce(function(accum, n, i) {
              return fn.call(_this25, accum, _this25.wrap(n), i);
            }, initialValue);
          }
          return this.getNodesInternal().reduce(function(accum, n, i) {
            return fn.call(_this25, i === 1 ? _this25.wrap(accum) : accum, _this25.wrap(n), i);
          });
        }
        return reduce2;
      }()
      /**
       * Reduces the current array of nodes to another array, from right to left. Each node is passed
       * in as a `ShallowWrapper` to the reducer function.
       *
       * @param {Function} fn - the reducer function
       * @param {*} initialValue - the initial value
       * @returns {*}
       */
    }, {
      key: "reduceRight",
      value: /* @__PURE__ */ function() {
        function reduceRight(fn) {
          var _this26 = this;
          var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (arguments.length > 1) {
            return this.getNodesInternal().reduceRight(function(accum, n, i) {
              return fn.call(_this26, accum, _this26.wrap(n), i);
            }, initialValue);
          }
          return this.getNodesInternal().reduceRight(function(accum, n, i) {
            return fn.call(_this26, i === 1 ? _this26.wrap(accum) : accum, _this26.wrap(n), i);
          });
        }
        return reduceRight;
      }()
      /**
       * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
       * rules of `Array#slice`.
       *
       * @param {Number} begin
       * @param {Number} end
       * @returns {ShallowWrapper}
       */
    }, {
      key: "slice",
      value: /* @__PURE__ */ function() {
        function slice2(begin, end2) {
          return this.wrap(this.getNodesInternal().slice(begin, end2));
        }
        return slice2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper match the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {Boolean}
       */
    }, {
      key: "some",
      value: /* @__PURE__ */ function() {
        function some2(selector2) {
          if (this[ROOT] === this) {
            throw new Error("ReactWrapper::some() can not be called on the root");
          }
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.getNodesInternal().some(predicate);
        }
        return some2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
       *
       * @param {Function} predicate
       * @returns {Boolean}
       */
    }, {
      key: "someWhere",
      value: /* @__PURE__ */ function() {
        function someWhere(predicate) {
          var _this27 = this;
          return this.getNodesInternal().some(function(n, i) {
            return predicate.call(_this27, _this27.wrap(n), i);
          });
        }
        return someWhere;
      }()
      /**
       * Returns whether or not all of the nodes in the wrapper match the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {Boolean}
       */
    }, {
      key: "every",
      value: /* @__PURE__ */ function() {
        function every2(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.getNodesInternal().every(predicate);
        }
        return every2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
       *
       * @param {Function} predicate
       * @returns {Boolean}
       */
    }, {
      key: "everyWhere",
      value: /* @__PURE__ */ function() {
        function everyWhere(predicate) {
          var _this28 = this;
          return this.getNodesInternal().every(function(n, i) {
            return predicate.call(_this28, _this28.wrap(n), i);
          });
        }
        return everyWhere;
      }()
      /**
       * Utility method used to create new wrappers with a mapping function that returns an array of
       * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
       * all of the mapped nodes flattened (and de-duplicated).
       *
       * @param {Function} fn
       * @returns {ReactWrapper}
       */
    }, {
      key: "flatMap",
      value: /* @__PURE__ */ function() {
        function flatMap(fn) {
          var _this29 = this;
          var nodes = this.getNodesInternal().map(function(n, i) {
            return fn.call(_this29, _this29.wrap(n), i);
          });
          var flattened = (0, _arrayPrototype22["default"])(nodes, 1);
          return this.wrap(flattened.filter(Boolean));
        }
        return flatMap;
      }()
      /**
       * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
       * function.
       *
       * @param {Function} predicate
       * @returns {ReactWrapper}
       */
    }, {
      key: "findWhere",
      value: /* @__PURE__ */ function() {
        function findWhere(predicate) {
          var _this30 = this;
          return findWhereUnwrapped(this, function(n) {
            var node2 = _this30.wrap(n);
            return node2.length > 0 && predicate(node2);
          });
        }
        return findWhere;
      }()
      /**
       * Returns the node at a given index of the current wrapper.
       *
       * @param {Number} index
       * @returns {ReactElement}
       */
    }, {
      key: "get",
      value: /* @__PURE__ */ function() {
        function get3(index2) {
          return this.getElements()[index2];
        }
        return get3;
      }()
      /**
       * Returns a wrapper around the node at a given index of the current wrapper.
       *
       * @param {Number} index
       * @returns {ReactWrapper}
       */
    }, {
      key: "at",
      value: /* @__PURE__ */ function() {
        function at(index2) {
          var nodes = this.getNodesInternal();
          if (index2 < nodes.length) {
            return this.wrap(nodes[index2]);
          }
          return this.wrap([]);
        }
        return at;
      }()
      /**
       * Returns a wrapper around the first node of the current wrapper.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "first",
      value: /* @__PURE__ */ function() {
        function first2() {
          return this.at(0);
        }
        return first2;
      }()
      /**
       * Returns a wrapper around the last node of the current wrapper.
       *
       * @returns {ReactWrapper}
       */
    }, {
      key: "last",
      value: /* @__PURE__ */ function() {
        function last2() {
          return this.at(this.length - 1);
        }
        return last2;
      }()
      /**
       * Delegates to exists()
       *
       * @returns {boolean}
       */
    }, {
      key: "isEmpty",
      value: /* @__PURE__ */ function() {
        function isEmpty() {
          console.warn("Enzyme::Deprecated method isEmpty() called, use exists() instead.");
          return !this.exists();
        }
        return isEmpty;
      }()
      /**
       * Returns true if the current wrapper has nodes. False otherwise.
       * If called with a selector it returns `.find(selector).exists()` instead.
       *
       * @param {EnzymeSelector} selector (optional)
       * @returns {boolean}
       */
    }, {
      key: "exists",
      value: /* @__PURE__ */ function() {
        function exists() {
          var selector2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
          return arguments.length > 0 ? this.find(selector2).exists() : this.length > 0;
        }
        return exists;
      }()
      /**
       * Utility method that throws an error if the current instance has a length other than one.
       * This is primarily used to enforce that certain methods are only run on a wrapper when it is
       * wrapping a single node.
       *
       * @param {Function} fn
       * @returns {*}
       */
    }, {
      key: "single",
      value: /* @__PURE__ */ function() {
        function single(name, fn) {
          var fnName = typeof name === "string" ? name : "unknown";
          var callback = typeof fn === "function" ? fn : name;
          if (this.length !== 1) {
            throw new Error("Method “" + fnName + "” is meant to be run on 1 node. " + String(this.length) + " found instead.");
          }
          return callback.call(this, this.getNodeInternal());
        }
        return single;
      }()
      /**
       * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
       * any nodes passed in as the first parameter automatically wrapped.
       *
       * @param {ReactWrapper|ReactElement|Array<ReactElement>} node
       * @returns {ReactWrapper}
       */
    }, {
      key: "wrap",
      value: /* @__PURE__ */ function() {
        function wrap2(node2) {
          var root2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[ROOT];
          if (node2 instanceof ReactWrapper22) {
            return node2;
          }
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }
          return new (Function.prototype.bind.apply(ReactWrapper22, [null].concat([node2, root2], args)))();
        }
        return wrap2;
      }()
      /**
       * Returns an HTML-like string of the shallow render for debugging purposes.
       *
       * @param {Object} [options] - Property bag of additional options.
       * @param {boolean} [options.ignoreProps] - if true, props are omitted from the string.
       * @param {boolean} [options.verbose] - if true, arrays and objects to be verbosely printed.
       * @returns {String}
       */
    }, {
      key: "debug",
      value: /* @__PURE__ */ function() {
        function debug() {
          var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return (0, _Debug.debugNodes)(this.getNodesInternal(), options2);
        }
        return debug;
      }()
      /**
       * Invokes intercepter and returns itself. intercepter is called with itself.
       * This is helpful when debugging nodes in method chains.
       * @param fn
       * @returns {ReactWrapper}
       */
    }, {
      key: "tap",
      value: /* @__PURE__ */ function() {
        function tap(intercepter) {
          intercepter(this);
          return this;
        }
        return tap;
      }()
      /**
       * Detaches the react tree from the DOM. Runs `ReactDOM.unmountComponentAtNode()` under the hood.
       *
       * This method will most commonly be used as a "cleanup" method if you decide to use the
       * `attachTo` option in `mount(node, options)`.
       *
       * The method is intentionally not "fluent" (in that it doesn't return `this`) because you should
       * not be doing anything with this wrapper after this method is called.
       */
    }, {
      key: "detach",
      value: /* @__PURE__ */ function() {
        function detach() {
          if (this[ROOT] !== this) {
            throw new Error("ReactWrapper::detach() can only be called on the root");
          }
          if (!this[OPTIONS].attachTo) {
            throw new Error("ReactWrapper::detach() can only be called on when the `attachTo` option was passed into `mount()`.");
          }
          this[RENDERER].unmount();
        }
        return detach;
      }()
      /**
       * Strips out all the not host-nodes from the list of nodes
       *
       * This method is useful if you want to check for the presence of host nodes
       * (actually rendered HTML elements) ignoring the React nodes.
       */
    }, {
      key: "hostNodes",
      value: /* @__PURE__ */ function() {
        function hostNodes() {
          return this.filterWhere(function(n) {
            return typeof n.type() === "string";
          });
        }
        return hostNodes;
      }()
    }]);
    return ReactWrapper22;
  }();
  var WrappingComponentWrapper = function(_ReactWrapper3) {
    _inherits2(WrappingComponentWrapper2, _ReactWrapper3);
    function WrappingComponentWrapper2(root2, renderer) {
      _classCallCheck2(this, WrappingComponentWrapper2);
      var _this31 = _possibleConstructorReturn2(this, (WrappingComponentWrapper2.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2)).call(this, renderer.getNode(), root2));
      (0, _Utils2.privateSet)(_this31, ROOT, _this31);
      (0, _Utils2.privateSet)(_this31, RENDERER, renderer);
      _this31[LINKED_ROOTS].push(root2);
      return _this31;
    }
    _createClass2(WrappingComponentWrapper2, [{
      key: "getWrappingComponent",
      value: /* @__PURE__ */ function() {
        function getWrappingComponent() {
          throw new TypeError("ReactWrapper::getWrappingComponent() can only be called on the root");
        }
        return getWrappingComponent;
      }()
    }]);
    return WrappingComponentWrapper2;
  }(ReactWrapper2);
  if (_Utils2.ITERATOR_SYMBOL) {
    Object.defineProperty(ReactWrapper2.prototype, _Utils2.ITERATOR_SYMBOL, {
      configurable: true,
      value: /* @__PURE__ */ function() {
        function iterator() {
          var _ref;
          var iter = this[NODES][_Utils2.ITERATOR_SYMBOL]();
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return _ref = {}, _defineProperty2(_ref, _Utils2.ITERATOR_SYMBOL, function() {
            return this;
          }), _defineProperty2(_ref, "next", /* @__PURE__ */ function() {
            function next() {
              var next2 = iter.next();
              if (next2.done) {
                return {
                  done: true
                };
              }
              return {
                done: false,
                value: adapter.nodeToElement(next2.value)
              };
            }
            return next;
          }()), _ref;
        }
        return iterator;
      }()
    });
  }
  function privateWarning(prop2, extraMessage) {
    Object.defineProperty(ReactWrapper2.prototype, prop2, {
      get: /* @__PURE__ */ function() {
        function get3() {
          throw new Error("\n        Attempted to access ReactWrapper::" + String(prop2) + ", which was previously a private property on\n        Enzyme ReactWrapper instances, but is no longer and should not be relied upon.\n        " + String(extraMessage) + "\n      ");
        }
        return get3;
      }(),
      enumerable: false,
      configurable: false
    });
  }
  privateWarning("node", "Consider using the getElement() method instead.");
  privateWarning("nodes", "Consider using the getElements() method instead.");
  privateWarning("renderer", "");
  privateWarning("options", "");
  privateWarning("complexSelector", "");
  exports2["default"] = ReactWrapper2;
})(ReactWrapper);
var ShallowWrapper = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  var _get2 = /* @__PURE__ */ function() {
    function get3(object2, property2, receiver) {
      if (object2 === null)
        object2 = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object2, property2);
      if (desc === void 0) {
        var parent = Object.getPrototypeOf(object2);
        if (parent === null) {
          return void 0;
        } else {
          return get3(parent, property2, receiver);
        }
      } else if ("value" in desc) {
        return desc.value;
      } else {
        var getter = desc.get;
        if (getter === void 0) {
          return void 0;
        }
        return getter.call(receiver);
      }
    }
    return get3;
  }();
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties2(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties2(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _object5 = object_assign;
  var _object22 = _interopRequireDefault2(_object5);
  var _arrayPrototype3 = array_prototype_flat;
  var _arrayPrototype22 = _interopRequireDefault2(_arrayPrototype3);
  var _has3 = src$1;
  var _has22 = _interopRequireDefault2(_has3);
  var _enzymeShallowEqual = buildExports;
  var _enzymeShallowEqual2 = _interopRequireDefault2(_enzymeShallowEqual);
  var _Utils2 = Utils;
  var _getAdapter3 = getAdapter;
  var _getAdapter22 = _interopRequireDefault2(_getAdapter3);
  var _Debug = Debug;
  var _RSTTraversal2 = RSTTraversal;
  var _selectors = selectors;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  function _toConsumableArray2(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperty2(obj, key, value2) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value2,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value2;
    }
    return obj;
  }
  var NODE = (0, _Utils2.sym)("__node__");
  var NODES = (0, _Utils2.sym)("__nodes__");
  var RENDERER = (0, _Utils2.sym)("__renderer__");
  var UNRENDERED = (0, _Utils2.sym)("__unrendered__");
  var ROOT = (0, _Utils2.sym)("__root__");
  var OPTIONS = (0, _Utils2.sym)("__options__");
  var SET_STATE = (0, _Utils2.sym)("__setState__");
  var ROOT_NODES = (0, _Utils2.sym)("__rootNodes__");
  var CHILD_CONTEXT = (0, _Utils2.sym)("__childContext__");
  var WRAPPING_COMPONENT = (0, _Utils2.sym)("__wrappingComponent__");
  var PRIMARY_WRAPPER = (0, _Utils2.sym)("__primaryWrapper__");
  var ROOT_FINDER = (0, _Utils2.sym)("__rootFinder__");
  var PROVIDER_VALUES = (0, _Utils2.sym)("__providerValues__");
  function findWhereUnwrapped(wrapper2, predicate) {
    var filter4 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _RSTTraversal2.treeFilter;
    return wrapper2.flatMap(function(n) {
      return filter4(n.getNodeInternal(), predicate);
    });
  }
  function filterWhereUnwrapped(wrapper2, predicate) {
    return wrapper2.wrap(wrapper2.getNodesInternal().filter(predicate).filter(Boolean));
  }
  function validateOptions(options2) {
    var lifecycleExperimental = options2.lifecycleExperimental, disableLifecycleMethods = options2.disableLifecycleMethods, enableComponentDidUpdateOnSetState = options2.enableComponentDidUpdateOnSetState, supportPrevContextArgumentOfComponentDidUpdate = options2.supportPrevContextArgumentOfComponentDidUpdate, lifecycles = options2.lifecycles;
    if (typeof lifecycleExperimental !== "undefined" && typeof lifecycleExperimental !== "boolean") {
      throw new Error("lifecycleExperimental must be either true or false if provided");
    }
    if (typeof disableLifecycleMethods !== "undefined" && typeof disableLifecycleMethods !== "boolean") {
      throw new Error("disableLifecycleMethods must be either true or false if provided");
    }
    if (lifecycleExperimental != null && disableLifecycleMethods != null && lifecycleExperimental === disableLifecycleMethods) {
      throw new Error("lifecycleExperimental and disableLifecycleMethods cannot be set to the same value");
    }
    if (typeof enableComponentDidUpdateOnSetState !== "undefined" && lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState !== enableComponentDidUpdateOnSetState) {
      throw new TypeError("the legacy enableComponentDidUpdateOnSetState option should be matched by `lifecycles: { componentDidUpdate: { onSetState: true } }`, for compatibility");
    }
    if (typeof supportPrevContextArgumentOfComponentDidUpdate !== "undefined" && lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.prevContext !== supportPrevContextArgumentOfComponentDidUpdate) {
      throw new TypeError("the legacy supportPrevContextArgumentOfComponentDidUpdate option should be matched by `lifecycles: { componentDidUpdate: { prevContext: true } }`, for compatibility");
    }
  }
  function getAdapterLifecycles(_ref) {
    var options2 = _ref.options;
    var _options$lifecycles = options2.lifecycles, lifecycles = _options$lifecycles === void 0 ? {} : _options$lifecycles, enableComponentDidUpdateOnSetState = options2.enableComponentDidUpdateOnSetState, supportPrevContextArgumentOfComponentDidUpdate = options2.supportPrevContextArgumentOfComponentDidUpdate;
    var hasLegacySetStateArg = typeof enableComponentDidUpdateOnSetState !== "undefined";
    var hasLegacyPrevContextArg = typeof supportPrevContextArgumentOfComponentDidUpdate !== "undefined";
    var componentDidUpdate = hasLegacySetStateArg || hasLegacyPrevContextArg ? (0, _object22["default"])({}, hasLegacySetStateArg && {
      onSetState: !!enableComponentDidUpdateOnSetState
    }, hasLegacyPrevContextArg && {
      prevContext: !!supportPrevContextArgumentOfComponentDidUpdate
    }) : null;
    var originalGDSFP = lifecycles.getDerivedStateFromProps;
    var getDerivedStateFromProps = originalGDSFP ? {
      hasShouldComponentUpdateBug: !!originalGDSFP.hasShouldComponentUpdateBug
    } : false;
    return (0, _object22["default"])({}, lifecycles, {
      setState: (0, _object22["default"])({}, lifecycles.setState),
      getChildContext: (0, _object22["default"])({
        calledByRenderer: true
      }, lifecycles.getChildContext)
    }, componentDidUpdate && {
      componentDidUpdate
    }, {
      getDerivedStateFromProps
    });
  }
  function getRootNode(node2) {
    if (node2.nodeType === "host") {
      return node2;
    }
    return node2.rendered;
  }
  function getRootNodeInternal(wrapper2) {
    if (wrapper2[ROOT].length !== 1) {
      throw new Error("getRootNodeInternal(wrapper) can only be called when wrapper wraps one node");
    }
    if (wrapper2[ROOT] !== wrapper2) {
      return wrapper2[ROOT_NODES][0];
    }
    return wrapper2[ROOT][NODE];
  }
  function nodeParents(wrapper2, node2) {
    return (0, _RSTTraversal2.parentsOfNode)(node2, getRootNodeInternal(wrapper2));
  }
  function privateSetNodes(wrapper2, nodes) {
    if (!Array.isArray(nodes)) {
      (0, _Utils2.privateSet)(wrapper2, NODE, nodes);
      (0, _Utils2.privateSet)(wrapper2, NODES, [nodes]);
    } else {
      (0, _Utils2.privateSet)(wrapper2, NODE, nodes[0]);
      (0, _Utils2.privateSet)(wrapper2, NODES, nodes);
    }
    (0, _Utils2.privateSet)(wrapper2, "length", wrapper2[NODES].length);
  }
  function pureComponentShouldComponentUpdate(prevProps, props, prevState, state) {
    return !(0, _enzymeShallowEqual2["default"])(prevProps, props) || !(0, _enzymeShallowEqual2["default"])(prevState, state);
  }
  function isPureComponent(instance) {
    return instance && instance.isPureReactComponent;
  }
  function getChildContext(node2, hierarchy, renderer) {
    var instance = node2.instance, Component2 = node2.type;
    var componentName = (0, _Utils2.displayNameOfNode)(node2);
    if (_typeof2(Component2.childContextTypes) !== "object") {
      console.warn(String(componentName) + ".getChildContext(): childContextTypes must be defined in order to use getChildContext().");
      return {};
    }
    var childContext = instance.getChildContext();
    Object.keys(childContext).forEach(function(key) {
      if (!(key in Component2.childContextTypes)) {
        throw new Error(String(componentName) + '.getChildContext(): key "' + String(key) + '" is not defined in childContextTypes.');
      }
    });
    if (typeof renderer.checkPropTypes === "function") {
      renderer.checkPropTypes(Component2.childContextTypes, childContext, "child context", hierarchy);
    }
    return childContext;
  }
  function spyOnGetChildContextInitialRender(nodes, adapter) {
    if (!(0, _Utils2.isCustomComponentElement)(nodes, adapter) || !nodes.type.prototype || typeof nodes.type.prototype.getChildContext !== "function") {
      return null;
    }
    return (0, _Utils2.spyMethod)(nodes.type.prototype, "getChildContext");
  }
  function privateSetChildContext(adapter, wrapper2, instance, renderedNode, getChildContextSpy) {
    var renderer = wrapper2[RENDERER];
    if (adapter.options.legacyContextMode !== "parent") {
      return;
    }
    if (getChildContextSpy) {
      (0, _Utils2.privateSet)(wrapper2, CHILD_CONTEXT, getChildContextSpy.getLastReturnValue());
      getChildContextSpy.restore();
    } else if (typeof instance.getChildContext === "function") {
      var nodeHierarchy = [wrapper2[NODE]].concat(nodeParents(wrapper2, wrapper2[NODE]));
      var childContext = getChildContext(renderedNode, nodeHierarchy, renderer);
      (0, _Utils2.privateSet)(wrapper2, CHILD_CONTEXT, childContext);
    } else {
      (0, _Utils2.privateSet)(wrapper2, CHILD_CONTEXT, null);
    }
  }
  function mockSCUIfgDSFPReturnNonNull(node2, state) {
    var getDerivedStateFromProps = node2.type.getDerivedStateFromProps;
    if (typeof getDerivedStateFromProps === "function") {
      var instance = node2.instance;
      var _spyMethod = (0, _Utils2.spyMethod)(instance, "shouldComponentUpdate", function(originalSCU) {
        return /* @__PURE__ */ function() {
          function shouldComponentUpdate() {
            instance.state = state;
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var sCUResult = originalSCU.apply(instance, args);
            var nextState = args[1];
            instance.state = nextState;
            restore();
            return sCUResult;
          }
          return shouldComponentUpdate;
        }();
      }), restore = _spyMethod.restore;
    }
  }
  function deepRender(wrapper2, target, adapter) {
    var node2 = wrapper2[NODE];
    var element = node2 && adapter.nodeToElement(node2);
    if (wrapper2.type() === target) {
      return wrapper2.dive();
    }
    if (element && (0, _Utils2.isCustomComponentElement)(element, adapter)) {
      return deepRender(wrapper2.dive(), target, adapter);
    }
    var children3 = wrapper2.children();
    for (var i = 0; i < children3.length; i += 1) {
      var found = deepRender(children3.at(i), target, adapter);
      if (typeof found !== "undefined") {
        return found;
      }
    }
    return void 0;
  }
  function getContextFromWrappingComponent(wrapper2, adapter) {
    var rootFinder = deepRender(wrapper2, wrapper2[ROOT_FINDER], adapter);
    if (!rootFinder) {
      throw new Error("`wrappingComponent` must render its children!");
    }
    return {
      legacyContext: rootFinder[OPTIONS].context,
      providerValues: rootFinder[PROVIDER_VALUES]
    };
  }
  function makeShallowOptions(nodes, root2, passedOptions, wrapper2) {
    var options2 = (0, _Utils2.makeOptions)(passedOptions);
    var adapter = (0, _getAdapter22["default"])(passedOptions);
    (0, _Utils2.privateSet)(options2, PROVIDER_VALUES, passedOptions[PROVIDER_VALUES]);
    if (root2 || !(0, _Utils2.isCustomComponent)(options2.wrappingComponent, adapter)) {
      return options2;
    }
    if (typeof adapter.wrapWithWrappingComponent !== "function") {
      throw new TypeError("your adapter does not support `wrappingComponent`. Try upgrading it!");
    }
    var _adapter$wrapWithWrap = adapter.wrapWithWrappingComponent(nodes, options2), wrappedNode = _adapter$wrapWithWrap.node, RootFinder = _adapter$wrapWithWrap.RootFinder;
    var wrappingComponent = new WrappingComponentWrapper(wrappedNode, wrapper2, RootFinder);
    var _getContextFromWrappi = getContextFromWrappingComponent(wrappingComponent, adapter), wrappingComponentLegacyContext = _getContextFromWrappi.legacyContext, wrappingComponentProviderValues = _getContextFromWrappi.providerValues;
    (0, _Utils2.privateSet)(wrapper2, WRAPPING_COMPONENT, wrappingComponent);
    return (0, _object22["default"])({}, options2, _defineProperty2({
      context: (0, _object22["default"])({}, options2.context, wrappingComponentLegacyContext)
    }, PROVIDER_VALUES, wrappingComponentProviderValues));
  }
  function makeInheritedChildOptions(wrapper2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var childOptions = (0, _object22["default"])({}, wrapper2[OPTIONS], options2, {
      context: options2.context || (0, _object22["default"])({}, wrapper2[OPTIONS].context, wrapper2[ROOT][CHILD_CONTEXT])
    });
    (0, _Utils2.privateSet)(childOptions, PROVIDER_VALUES, wrapper2[ROOT][PROVIDER_VALUES]);
    return childOptions;
  }
  var ShallowWrapper2 = function() {
    function ShallowWrapper3(nodes, root2) {
      var _this = this;
      var passedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      _classCallCheck2(this, ShallowWrapper3);
      validateOptions(passedOptions);
      var options2 = makeShallowOptions(nodes, root2, passedOptions, this);
      var adapter = (0, _getAdapter22["default"])(options2);
      var lifecycles = getAdapterLifecycles(adapter);
      if (!root2) {
        if (!adapter.isValidElement(nodes)) {
          throw new TypeError("ShallowWrapper can only wrap valid elements");
        }
        var getChildContextSpy = lifecycles.getChildContext.calledByRenderer ? spyOnGetChildContextInitialRender(nodes, adapter) : null;
        (0, _Utils2.privateSet)(this, ROOT, this);
        (0, _Utils2.privateSet)(this, UNRENDERED, nodes);
        var renderer = adapter.createRenderer((0, _object22["default"])({
          mode: "shallow"
        }, options2));
        (0, _Utils2.privateSet)(this, RENDERER, renderer);
        var providerValues = new Map(options2[PROVIDER_VALUES] || []);
        this[RENDERER].render(nodes, options2.context, {
          providerValues
        });
        var renderedNode = this[RENDERER].getNode();
        privateSetNodes(this, getRootNode(renderedNode));
        (0, _Utils2.privateSet)(this, OPTIONS, options2);
        (0, _Utils2.privateSet)(this, PROVIDER_VALUES, providerValues);
        var instance = renderedNode.instance;
        if (instance && !options2.disableLifecycleMethods) {
          if (lifecycles.componentDidUpdate.onSetState && !instance[SET_STATE]) {
            (0, _Utils2.privateSet)(instance, SET_STATE, instance.setState);
            instance.setState = function(updater) {
              var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
              return _this.setState.apply(_this, _toConsumableArray2(callback == null ? [updater] : [updater, callback]));
            };
          }
          if (typeof instance.componentDidMount === "function") {
            this[RENDERER].batchedUpdates(function() {
              instance.componentDidMount();
            });
          }
          privateSetChildContext(adapter, this, instance, renderedNode, getChildContextSpy);
        }
      } else {
        (0, _Utils2.privateSet)(this, ROOT, root2);
        (0, _Utils2.privateSet)(this, UNRENDERED, null);
        (0, _Utils2.privateSet)(this, RENDERER, root2[RENDERER]);
        privateSetNodes(this, nodes);
        (0, _Utils2.privateSet)(this, OPTIONS, root2[OPTIONS]);
        (0, _Utils2.privateSet)(this, ROOT_NODES, root2[NODES]);
        (0, _Utils2.privateSet)(this, PROVIDER_VALUES, null);
      }
    }
    _createClass2(ShallowWrapper3, [{
      key: "root",
      value: /* @__PURE__ */ function() {
        function root2() {
          return this[ROOT];
        }
        return root2;
      }()
      /**
       * Returns the wrapped component.
       *
       * @return {ReactComponent}
       */
    }, {
      key: "getNodeInternal",
      value: /* @__PURE__ */ function() {
        function getNodeInternal() {
          if (this.length !== 1) {
            throw new Error("ShallowWrapper::getNode() can only be called when wrapping one node");
          }
          if (this[ROOT] === this) {
            this.update();
          }
          return this[NODE];
        }
        return getNodeInternal;
      }()
      /**
       * Returns the the wrapped components.
       *
       * @return {Array<ReactComponent>}
       */
    }, {
      key: "getNodesInternal",
      value: /* @__PURE__ */ function() {
        function getNodesInternal() {
          if (this[ROOT] === this && this.length === 1) {
            this.update();
          }
          return this[NODES];
        }
        return getNodesInternal;
      }()
      /**
       * Returns the wrapped ReactElement.
       *
       * @return {ReactElement}
       */
    }, {
      key: "getElement",
      value: /* @__PURE__ */ function() {
        function getElement() {
          var _this2 = this;
          return this.single("getElement", function(n) {
            return (0, _getAdapter22["default"])(_this2[OPTIONS]).nodeToElement(n);
          });
        }
        return getElement;
      }()
      /**
       * Returns the wrapped ReactElements.
       *
       * @return {Array<ReactElement>}
       */
    }, {
      key: "getElements",
      value: /* @__PURE__ */ function() {
        function getElements2() {
          var _this3 = this;
          return this.getNodesInternal().map(function(n) {
            return (0, _getAdapter22["default"])(_this3[OPTIONS]).nodeToElement(n);
          });
        }
        return getElements2;
      }()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getNode",
      value: /* @__PURE__ */ function() {
        function getNode() {
          throw new Error("ShallowWrapper::getNode() is no longer supported. Use ShallowWrapper::getElement() instead");
        }
        return getNode;
      }()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getNodes",
      value: /* @__PURE__ */ function() {
        function getNodes() {
          throw new Error("ShallowWrapper::getNodes() is no longer supported. Use ShallowWrapper::getElements() instead");
        }
        return getNodes;
      }()
      /**
       * Gets the instance of the component being rendered as the root node passed into `shallow()`.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * Example:
       * ```
       * const wrapper = shallow(<MyComponent />);
       * const inst = wrapper.instance();
       * expect(inst).to.be.instanceOf(MyComponent);
       * ```
       * @returns {ReactComponent}
       */
    }, {
      key: "instance",
      value: /* @__PURE__ */ function() {
        function instance() {
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::instance() can only be called on the root");
          }
          return this[RENDERER].getNode().instance;
        }
        return instance;
      }()
      /**
       * If a `wrappingComponent` was passed in `options`, this methods returns a `ShallowWrapper`
       * around the rendered `wrappingComponent`. This `ShallowWrapper` can be used to update the
       * `wrappingComponent`'s props, state, etc.
       *
       * @returns ShallowWrapper
       */
    }, {
      key: "getWrappingComponent",
      value: /* @__PURE__ */ function() {
        function getWrappingComponent() {
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::getWrappingComponent() can only be called on the root");
          }
          if (!this[OPTIONS].wrappingComponent) {
            throw new Error("ShallowWrapper::getWrappingComponent() can only be called on a wrapper that was originally passed a `wrappingComponent` option");
          }
          return this[WRAPPING_COMPONENT];
        }
        return getWrappingComponent;
      }()
      /**
       * Forces a re-render. Useful to run before checking the render output if something external
       * may be updating the state of the component somewhere.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @returns {ShallowWrapper}
       */
    }, {
      key: "update",
      value: /* @__PURE__ */ function() {
        function update2() {
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::update() can only be called on the root");
          }
          if (this.length !== 1) {
            throw new Error("ShallowWrapper::update() can only be called when wrapping one node");
          }
          privateSetNodes(this, getRootNode(this[RENDERER].getNode()));
          return this;
        }
        return update2;
      }()
      /**
       * A method that unmounts the component. This can be used to simulate a component going through
       * and unmount/mount lifecycle.
       * @returns {ShallowWrapper}
       */
    }, {
      key: "unmount",
      value: /* @__PURE__ */ function() {
        function unmount() {
          this[RENDERER].unmount();
          if (this[ROOT][WRAPPING_COMPONENT]) {
            this[ROOT][WRAPPING_COMPONENT].unmount();
          }
          return this;
        }
        return unmount;
      }()
      /**
       * A method is for re-render with new props and context.
       * This calls componentDidUpdate method if disableLifecycleMethods is not enabled.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} props
       * @param {Object} context
       * @returns {ShallowWrapper}
       */
    }, {
      key: "rerender",
      value: /* @__PURE__ */ function() {
        function rerender(props, context) {
          var _this4 = this;
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          this.single("rerender", function() {
            (0, _Utils2.withSetStateAllowed)(function() {
              var node2 = _this4[RENDERER].getNode();
              var instance = node2.instance || {};
              var type3 = node2.type || {};
              var state = instance.state;
              var prevProps = instance.props || _this4[UNRENDERED].props;
              var prevContext = instance.context || _this4[OPTIONS].context;
              var nextContext = context || prevContext;
              if (context) {
                _this4[OPTIONS] = (0, _object22["default"])({}, _this4[OPTIONS], {
                  context: nextContext
                });
              }
              _this4[RENDERER].batchedUpdates(function() {
                var lifecycles = getAdapterLifecycles(adapter);
                var shouldRender = true;
                var shouldComponentUpdateSpy = void 0;
                var getChildContextSpy = void 0;
                if (!_this4[OPTIONS].disableLifecycleMethods && instance) {
                  if (typeof instance.shouldComponentUpdate === "function") {
                    var gDSFP = lifecycles.getDerivedStateFromProps;
                    if (gDSFP && gDSFP.hasShouldComponentUpdateBug) {
                      mockSCUIfgDSFPReturnNonNull(node2, state);
                    }
                    shouldComponentUpdateSpy = (0, _Utils2.spyMethod)(instance, "shouldComponentUpdate");
                  }
                  if (lifecycles.getChildContext.calledByRenderer && typeof instance.getChildContext === "function") {
                    getChildContextSpy = (0, _Utils2.spyMethod)(instance, "getChildContext");
                  }
                }
                if (!shouldComponentUpdateSpy && isPureComponent(instance)) {
                  shouldRender = pureComponentShouldComponentUpdate(prevProps, props, state, instance.state);
                }
                if (props)
                  _this4[UNRENDERED] = (0, _Utils2.cloneElement)(adapter, _this4[UNRENDERED], props);
                _this4[RENDERER].render(_this4[UNRENDERED], nextContext, {
                  providerValues: _this4[PROVIDER_VALUES]
                });
                if (shouldComponentUpdateSpy) {
                  shouldRender = shouldComponentUpdateSpy.getLastReturnValue();
                  shouldComponentUpdateSpy.restore();
                }
                if (shouldRender && !_this4[OPTIONS].disableLifecycleMethods && instance) {
                  privateSetChildContext(adapter, _this4, instance, node2, getChildContextSpy);
                  if (lifecycles.getSnapshotBeforeUpdate) {
                    var snapshot = void 0;
                    if (typeof instance.getSnapshotBeforeUpdate === "function") {
                      snapshot = instance.getSnapshotBeforeUpdate(prevProps, state);
                    }
                    if (lifecycles.componentDidUpdate && typeof instance.componentDidUpdate === "function" && (!state || (0, _enzymeShallowEqual2["default"])(state, _this4.instance().state) || typeof type3.getDerivedStateFromProps === "function")) {
                      instance.componentDidUpdate(prevProps, state, snapshot);
                    }
                  } else if (lifecycles.componentDidUpdate && typeof instance.componentDidUpdate === "function") {
                    if (lifecycles.componentDidUpdate.prevContext) {
                      instance.componentDidUpdate(prevProps, state, prevContext);
                    } else if (!state || (0, _enzymeShallowEqual2["default"])(_this4.instance().state, state)) {
                      instance.componentDidUpdate(prevProps, state);
                    }
                  }
                } else if (!(0, _enzymeShallowEqual2["default"])(props, instance.props)) {
                  instance.props = (Object.freeze || Object)((0, _object22["default"])({}, instance.props, props));
                }
                _this4.update();
              });
            });
          });
          return this;
        }
        return rerender;
      }()
      /**
       * A method that sets the props of the root component, and re-renders. Useful for when you are
       * wanting to test how the component behaves over time with changing props. Calling this, for
       * instance, will call the `componentWillReceiveProps` lifecycle method.
       *
       * Similar to `setState`, this method accepts a props object and will merge it in with the already
       * existing props.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} props object
       * @param {Function} cb - callback function
       * @returns {ShallowWrapper}
       */
    }, {
      key: "setProps",
      value: /* @__PURE__ */ function() {
        function setProps(props) {
          var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::setProps() can only be called on the root");
          }
          if (arguments.length > 1 && typeof callback !== "function") {
            throw new TypeError("ReactWrapper::setProps() expects a function as its second argument");
          }
          this.rerender(props);
          if (callback) {
            callback();
          }
          return this;
        }
        return setProps;
      }()
      /**
       * A method to invoke `setState` on the root component instance similar to how you might in the
       * definition of the component, and re-renders.  This method is useful for testing your component
       * in hard to achieve states, however should be used sparingly. If possible, you should utilize
       * your component's external API in order to get it into whatever state you want to test, in order
       * to be as accurate of a test as possible. This is not always practical, however.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} state to merge
       * @param {Function} cb - callback function
       * @returns {ShallowWrapper}
       */
    }, {
      key: "setState",
      value: /* @__PURE__ */ function() {
        function setState(state) {
          var _this5 = this;
          var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::setState() can only be called on the root");
          }
          if (this.instance() === null || this[RENDERER].getNode().nodeType !== "class") {
            throw new Error("ShallowWrapper::setState() can only be called on class components");
          }
          if (arguments.length > 1 && typeof callback !== "function") {
            throw new TypeError("ReactWrapper::setState() expects a function as its second argument");
          }
          this.single("setState", function() {
            (0, _Utils2.withSetStateAllowed)(function() {
              var adapter = (0, _getAdapter22["default"])(_this5[OPTIONS]);
              var lifecycles = getAdapterLifecycles(adapter);
              var node2 = _this5[RENDERER].getNode();
              var instance = node2.instance;
              var prevProps = instance.props;
              var prevState = instance.state;
              var prevContext = instance.context;
              var statePayload = typeof state === "function" ? state.call(instance, prevState, prevProps) : state;
              var maybeHasUpdate = !lifecycles.setState.skipsComponentDidUpdateOnNullish || statePayload != null;
              var shouldComponentUpdateSpy = void 0;
              var getChildContextSpy = void 0;
              var shouldRender = true;
              if (!_this5[OPTIONS].disableLifecycleMethods && instance) {
                if (lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState && typeof instance.shouldComponentUpdate === "function") {
                  var gDSFP = lifecycles.getDerivedStateFromProps;
                  if (gDSFP && gDSFP.hasShouldComponentUpdateBug) {
                    mockSCUIfgDSFPReturnNonNull(node2, state);
                  }
                  shouldComponentUpdateSpy = (0, _Utils2.spyMethod)(instance, "shouldComponentUpdate");
                }
                if (lifecycles.getChildContext.calledByRenderer && typeof instance.getChildContext === "function") {
                  getChildContextSpy = (0, _Utils2.spyMethod)(instance, "getChildContext");
                }
              }
              if (!shouldComponentUpdateSpy && isPureComponent(instance)) {
                shouldRender = pureComponentShouldComponentUpdate(prevProps, instance.props, prevState, (0, _object22["default"])({}, prevState, statePayload));
              }
              if (instance[SET_STATE]) {
                instance[SET_STATE](statePayload);
              } else {
                instance.setState(statePayload);
              }
              if (shouldComponentUpdateSpy) {
                shouldRender = shouldComponentUpdateSpy.getLastReturnValue();
                shouldComponentUpdateSpy.restore();
              }
              if (maybeHasUpdate && shouldRender && !_this5[OPTIONS].disableLifecycleMethods) {
                privateSetChildContext(adapter, _this5, instance, node2, getChildContextSpy);
                if (lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState) {
                  if (lifecycles.getSnapshotBeforeUpdate && typeof instance.getSnapshotBeforeUpdate === "function") {
                    var snapshot = instance.getSnapshotBeforeUpdate(prevProps, prevState);
                    if (typeof instance.componentDidUpdate === "function") {
                      instance.componentDidUpdate(prevProps, prevState, snapshot);
                    }
                  } else if (typeof instance.componentDidUpdate === "function") {
                    if (lifecycles.componentDidUpdate.prevContext) {
                      instance.componentDidUpdate(prevProps, prevState, prevContext);
                    } else {
                      instance.componentDidUpdate(prevProps, prevState);
                    }
                  }
                }
              }
              _this5.update();
              if (callback) {
                if (adapter.invokeSetStateCallback) {
                  adapter.invokeSetStateCallback(instance, callback);
                } else {
                  callback.call(instance);
                }
              }
            });
          });
          return this;
        }
        return setState;
      }()
      /**
       * A method that sets the context of the root component, and re-renders. Useful for when you are
       * wanting to test how the component behaves over time with changing contexts.
       *
       * NOTE: can only be called on a wrapper instance that is also the root instance.
       *
       * @param {Object} context object
       * @returns {ShallowWrapper}
       */
    }, {
      key: "setContext",
      value: /* @__PURE__ */ function() {
        function setContext(context) {
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::setContext() can only be called on the root");
          }
          if (!this[OPTIONS].context) {
            throw new Error("ShallowWrapper::setContext() can only be called on a wrapper that was originally passed a context option");
          }
          return this.rerender(null, context);
        }
        return setContext;
      }()
      /**
       * Whether or not a given react element exists in the shallow render tree.
       *
       * Example:
       * ```
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
       * ```
       *
       * @param {ReactElement|Array<ReactElement>} nodeOrNodes
       * @returns {Boolean}
       */
    }, {
      key: "contains",
      value: /* @__PURE__ */ function() {
        function contains2(nodeOrNodes) {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          if (!(0, _Utils2.isReactElementAlike)(nodeOrNodes, adapter)) {
            throw new Error("ShallowWrapper::contains() can only be called with a ReactElement (or an array of them), a string, or a number as an argument.");
          }
          var predicate = Array.isArray(nodeOrNodes) ? function(other) {
            return (0, _Utils2.containsChildrenSubArray)(_Utils2.nodeEqual, other, nodeOrNodes.map(function(node2) {
              return adapter.elementToNode(node2);
            }));
          } : function(other) {
            return (0, _Utils2.nodeEqual)(adapter.elementToNode(nodeOrNodes), other);
          };
          return findWhereUnwrapped(this, predicate).length > 0;
        }
        return contains2;
      }()
      /**
       * Whether or not a given react element exists in the shallow render tree.
       * Match is based on the expected element and not on wrappers element.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * // MyComponent outputs <div><div class="foo">Hello</div></div>
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "containsMatchingElement",
      value: /* @__PURE__ */ function() {
        function containsMatchingElement(node2) {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          var rstNode = adapter.elementToNode(node2);
          var predicate = /* @__PURE__ */ function() {
            function predicate2(other) {
              return (0, _Utils2.nodeMatches)(rstNode, other, function(a, b) {
                return a <= b;
              });
            }
            return predicate2;
          }();
          return findWhereUnwrapped(this, predicate).length > 0;
        }
        return containsMatchingElement;
      }()
      /**
       * Whether or not all the given react elements exist in the shallow render tree.
       * Match is based on the expected element and not on wrappers element.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.containsAllMatchingElements([
       *   <div>Hello</div>,
       *   <div>Goodbye</div>,
       * ])).to.equal(true);
       * ```
       *
       * @param {Array<ReactElement>} nodes
       * @returns {Boolean}
       */
    }, {
      key: "containsAllMatchingElements",
      value: /* @__PURE__ */ function() {
        function containsAllMatchingElements(nodes) {
          var _this6 = this;
          if (!Array.isArray(nodes)) {
            throw new TypeError("nodes should be an Array");
          }
          return nodes.every(function(node2) {
            return _this6.containsMatchingElement(node2);
          });
        }
        return containsAllMatchingElements;
      }()
      /**
       * Whether or not one of the given react elements exists in the shallow render tree.
       * Match is based on the expected element and not on wrappers element.
       * It will determine if one of the wrappers element "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrappers element and equals to each other.
       *
       * Example:
       * ```
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.containsAnyMatchingElements([
       *   <div>Hello</div>,
       *   <div>Goodbye</div>,
       * ])).to.equal(true);
       * ```
       *
       * @param {Array<ReactElement>} nodes
       * @returns {Boolean}
       */
    }, {
      key: "containsAnyMatchingElements",
      value: /* @__PURE__ */ function() {
        function containsAnyMatchingElements(nodes) {
          var _this7 = this;
          return Array.isArray(nodes) && nodes.some(function(node2) {
            return _this7.containsMatchingElement(node2);
          });
        }
        return containsAnyMatchingElements;
      }()
      /**
       * Whether or not a given react element exists in the render tree.
       *
       * Example:
       * ```
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "equals",
      value: /* @__PURE__ */ function() {
        function equals(node2) {
          var _this8 = this;
          return this.single("equals", function() {
            return (0, _Utils2.nodeEqual)(_this8.getNodeInternal(), node2);
          });
        }
        return equals;
      }()
      /**
       * Whether or not a given react element matches the render tree.
       * Match is based on the expected element and not on wrapper root node.
       * It will determine if the wrapper root node "looks like" the expected
       * element by checking if all props of the expected element are present
       * on the wrapper root node and equals to each other.
       *
       * Example:
       * ```
       * // MyComponent outputs <div class="foo">Hello</div>
       * const wrapper = shallow(<MyComponent />);
       * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
       * ```
       *
       * @param {ReactElement} node
       * @returns {Boolean}
       */
    }, {
      key: "matchesElement",
      value: /* @__PURE__ */ function() {
        function matchesElement(node2) {
          var _this9 = this;
          return this.single("matchesElement", function() {
            var adapter = (0, _getAdapter22["default"])(_this9[OPTIONS]);
            var rstNode = adapter.elementToNode(node2);
            return (0, _Utils2.nodeMatches)(rstNode, _this9.getNodeInternal(), function(a, b) {
              return a <= b;
            });
          });
        }
        return matchesElement;
      }()
      /**
       * Finds every node in the render tree of the current wrapper that matches the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {ShallowWrapper}
       */
    }, {
      key: "find",
      value: /* @__PURE__ */ function() {
        function find2(selector2) {
          return this.wrap((0, _selectors.reduceTreesBySelector)(selector2, this.getNodesInternal()));
        }
        return find2;
      }()
      /**
       * Returns whether or not current node matches a provided selector.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {EnzymeSelector} selector
       * @returns {boolean}
       */
    }, {
      key: "is",
      value: /* @__PURE__ */ function() {
        function is3(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.single("is", function(n) {
            return predicate(n);
          });
        }
        return is3;
      }()
      /**
       * Returns true if the component rendered nothing, i.e., null or false.
       *
       * @returns {boolean}
       */
    }, {
      key: "isEmptyRender",
      value: /* @__PURE__ */ function() {
        function isEmptyRender() {
          var nodes = this.getNodesInternal();
          return nodes.every(function(n) {
            return (0, _Utils2.isEmptyValue)(n);
          });
        }
        return isEmptyRender;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
       * the provided predicate function. The predicate should receive a wrapped node as its first
       * argument.
       *
       * @param {Function} predicate
       * @returns {ShallowWrapper}
       */
    }, {
      key: "filterWhere",
      value: /* @__PURE__ */ function() {
        function filterWhere(predicate) {
          var _this10 = this;
          return filterWhereUnwrapped(this, function(n) {
            return predicate(_this10.wrap(n));
          });
        }
        return filterWhere;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
       * the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {ShallowWrapper}
       */
    }, {
      key: "filter",
      value: /* @__PURE__ */ function() {
        function filter4(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return filterWhereUnwrapped(this, predicate);
        }
        return filter4;
      }()
      /**
       * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
       * the provided selector. Essentially the inverse of `filter`.
       *
       * @param {EnzymeSelector} selector
       * @returns {ShallowWrapper}
       */
    }, {
      key: "not",
      value: /* @__PURE__ */ function() {
        function not2(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return filterWhereUnwrapped(this, function(n) {
            return !predicate(n);
          });
        }
        return not2;
      }()
      /**
       * Returns a string of the rendered text of the current render tree.  This function should be
       * looked at with skepticism if being used to test what the actual HTML output of the component
       * will be. If that is what you would like to test, use enzyme's `render` function instead.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {String}
       */
    }, {
      key: "text",
      value: /* @__PURE__ */ function() {
        function text2() {
          return this.single("text", _RSTTraversal2.getTextFromNode);
        }
        return text2;
      }()
      /**
       * Returns the HTML of the node.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {String}
       */
    }, {
      key: "html",
      value: /* @__PURE__ */ function() {
        function html2() {
          var _this11 = this;
          return this.single("html", function(n) {
            if (_this11.type() === null)
              return null;
            var adapter = (0, _getAdapter22["default"])(_this11[OPTIONS]);
            var renderer = adapter.createRenderer((0, _object22["default"])({}, _this11[OPTIONS], {
              mode: "string"
            }));
            return renderer.render(adapter.nodeToElement(n));
          });
        }
        return html2;
      }()
      /**
       * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {CheerioWrapper}
       */
    }, {
      key: "render",
      value: /* @__PURE__ */ function() {
        function render3() {
          var html2 = this.html();
          return (0, _Utils2.loadCheerioRoot)(html2);
        }
        return render3;
      }()
      /**
       * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
       * testing events should be met with some skepticism.
       *
       * @param {String} event
       * @param {Array} args
       * @returns {ShallowWrapper}
       */
    }, {
      key: "simulate",
      value: /* @__PURE__ */ function() {
        function simulate(event) {
          var _this12 = this;
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          return this.single("simulate", function(n) {
            var _RENDERER;
            (_RENDERER = _this12[RENDERER]).simulateEvent.apply(_RENDERER, [n, event].concat(args));
            _this12[ROOT].update();
            return _this12;
          });
        }
        return simulate;
      }()
      /**
       * Used to simulate throwing a rendering error. Pass an error to throw.
       *
       * @param {String} error
       * @returns {ShallowWrapper}
       */
    }, {
      key: "simulateError",
      value: /* @__PURE__ */ function() {
        function simulateError(error) {
          var _this13 = this;
          return this.single("simulateError", function(thisNode) {
            if (thisNode.nodeType === "host") {
              throw new TypeError("ShallowWrapper::simulateError() can only be called on custom components");
            }
            var renderer = _this13[RENDERER];
            if (typeof renderer.simulateError !== "function") {
              throw new TypeError("your adapter does not support `simulateError`. Try upgrading it!");
            }
            var rootNode = getRootNodeInternal(_this13);
            var nodeHierarchy = [thisNode].concat(nodeParents(_this13, thisNode));
            renderer.simulateError(nodeHierarchy, rootNode, error);
            return _this13;
          });
        }
        return simulateError;
      }()
      /**
       * Returns the props hash for the current node of the wrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @returns {Object}
       */
    }, {
      key: "props",
      value: /* @__PURE__ */ function() {
        function props() {
          return this.single("props", _RSTTraversal2.propsOfNode);
        }
        return props;
      }()
      /**
       * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
       * will return just that value.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {String} name (optional)
       * @returns {*}
       */
    }, {
      key: "state",
      value: /* @__PURE__ */ function() {
        function state(name) {
          var _this14 = this;
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::state() can only be called on the root");
          }
          if (this.instance() === null || this[RENDERER].getNode().nodeType !== "class") {
            throw new Error("ShallowWrapper::state() can only be called on class components");
          }
          var _state = this.single("state", function() {
            return _this14.instance().state;
          });
          if (typeof name !== "undefined") {
            if (_state == null) {
              throw new TypeError('ShallowWrapper::state("' + String(name) + '") requires that `state` not be `null` or `undefined`');
            }
            return _state[name];
          }
          return _state;
        }
        return state;
      }()
      /**
       * Returns the context hash for the root node of the wrapper.
       * Optionally pass in a prop name and it will return just that value.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {String} name (optional)
       * @returns {*}
       */
    }, {
      key: "context",
      value: /* @__PURE__ */ function() {
        function context(name) {
          var _this15 = this;
          if (this[ROOT] !== this) {
            throw new Error("ShallowWrapper::context() can only be called on the root");
          }
          if (!this[OPTIONS].context) {
            throw new Error("ShallowWrapper::context() can only be called on a wrapper that was originally passed a context option");
          }
          if (this.instance() === null) {
            throw new Error("ShallowWrapper::context() can only be called on wrapped nodes that have a non-null instance");
          }
          var _context = this.single("context", function() {
            return _this15.instance().context;
          });
          if (name) {
            return _context[name];
          }
          return _context;
        }
        return context;
      }()
      /**
       * Returns a new wrapper with all of the children of the current wrapper.
       *
       * @param {EnzymeSelector} [selector]
       * @returns {ShallowWrapper}
       */
    }, {
      key: "children",
      value: /* @__PURE__ */ function() {
        function children3(selector2) {
          var allChildren = this.flatMap(function(n) {
            return (0, _RSTTraversal2.childrenOfNode)(n.getNodeInternal());
          });
          return selector2 ? allChildren.filter(selector2) : allChildren;
        }
        return children3;
      }()
      /**
       * Returns a new wrapper with a specific child
       *
       * @param {Number} [index]
       * @returns {ShallowWrapper}
       */
    }, {
      key: "childAt",
      value: /* @__PURE__ */ function() {
        function childAt(index2) {
          var _this16 = this;
          return this.single("childAt", function() {
            return _this16.children().at(index2);
          });
        }
        return childAt;
      }()
      /**
       * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
       * in the current wrapper.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param {EnzymeSelector} [selector]
       * @returns {ShallowWrapper}
       */
    }, {
      key: "parents",
      value: /* @__PURE__ */ function() {
        function parents(selector2) {
          var _this17 = this;
          return this.single("parents", function(n) {
            var allParents = _this17.wrap(nodeParents(_this17, n));
            return selector2 ? allParents.filter(selector2) : allParents;
          });
        }
        return parents;
      }()
      /**
       * Returns a wrapper around the immediate parent of the current node.
       *
       * @returns {ShallowWrapper}
       */
    }, {
      key: "parent",
      value: /* @__PURE__ */ function() {
        function parent() {
          return this.flatMap(function(n) {
            return [n.parents().get(0)];
          });
        }
        return parent;
      }()
      /**
       *
       * @param {EnzymeSelector} selector
       * @returns {ShallowWrapper}
       */
    }, {
      key: "closest",
      value: /* @__PURE__ */ function() {
        function closest2(selector2) {
          if (this.is(selector2)) {
            return this;
          }
          var matchingAncestors = this.parents().filter(selector2);
          return matchingAncestors.length > 0 ? matchingAncestors.first() : this.findWhere(function() {
            return false;
          });
        }
        return closest2;
      }()
      /**
       * Shallow renders the current node and returns a shallow wrapper around it.
       *
       * NOTE: can only be called on wrapper of a single node.
       *
       * @param {Object} options
       * @returns {ShallowWrapper}
       */
    }, {
      key: "shallow",
      value: /* @__PURE__ */ function() {
        function shallow2() {
          var _this18 = this;
          var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return this.single("shallow", function(n) {
            var childOptions = makeInheritedChildOptions(_this18, options2);
            return _this18.wrap((0, _getAdapter22["default"])(_this18[OPTIONS]).nodeToElement(n), null, childOptions);
          });
        }
        return shallow2;
      }()
      /**
       * Returns the value of prop with the given name of the current node.
       *
       * @param propName
       * @returns {*}
       */
    }, {
      key: "prop",
      value: /* @__PURE__ */ function() {
        function prop2(propName) {
          return this.props()[propName];
        }
        return prop2;
      }()
      /**
       * Used to invoke a function prop.
       * Will invoke an function prop and return its value.
       *
       * @param {String} propName
       * @returns {Any}
       */
    }, {
      key: "invoke",
      value: /* @__PURE__ */ function() {
        function invoke(propName) {
          var _this19 = this;
          return this.single("invoke", function() {
            var handler = _this19.prop(propName);
            if (typeof handler !== "function") {
              throw new TypeError("ShallowWrapper::invoke() requires the name of a prop whose value is a function");
            }
            return function() {
              var response = handler.apply(void 0, arguments);
              _this19[ROOT].update();
              return response;
            };
          });
        }
        return invoke;
      }()
      /**
       * Returns a wrapper of the node rendered by the provided render prop.
       *
       * @param {String} propName
       * @returns {Function}
       */
    }, {
      key: "renderProp",
      value: /* @__PURE__ */ function() {
        function renderProp(propName) {
          var _this20 = this;
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          if (typeof adapter.wrap !== "function") {
            throw new RangeError("your adapter does not support `wrap`. Try upgrading it!");
          }
          return this.single("renderProp", function(n) {
            if (n.nodeType === "host") {
              throw new TypeError("ShallowWrapper::renderProp() can only be called on custom components");
            }
            if (typeof propName !== "string") {
              throw new TypeError("ShallowWrapper::renderProp(): `propName` must be a string");
            }
            var props = _this20.props();
            if (!(0, _has22["default"])(props, propName)) {
              throw new Error("ShallowWrapper::renderProp(): no prop called “" + String(propName) + "“ found");
            }
            var propValue = props[propName];
            if (typeof propValue !== "function") {
              throw new TypeError("ShallowWrapper::renderProp(): expected prop “" + String(propName) + "“ to contain a function, but it holds “" + (typeof propValue === "undefined" ? "undefined" : _typeof2(propValue)) + "“");
            }
            return function() {
              var element = propValue.apply(void 0, arguments);
              var wrapped = adapter.wrap(element);
              return _this20.wrap(wrapped, null, _this20[OPTIONS]);
            };
          });
        }
        return renderProp;
      }()
      /**
       * Returns the key assigned to the current node.
       *
       * @returns {String}
       */
    }, {
      key: "key",
      value: /* @__PURE__ */ function() {
        function key() {
          return this.single("key", function(n) {
            return n.key === void 0 ? null : n.key;
          });
        }
        return key;
      }()
      /**
       * Returns the type of the current node of this wrapper. If it's a composite component, this will
       * be the component constructor. If it's a native DOM node, it will be a string of the tag name.
       * If it's null, it will be null.
       *
       * @returns {String|Function|null}
       */
    }, {
      key: "type",
      value: /* @__PURE__ */ function() {
        function type3() {
          return this.single("type", function(n) {
            return (0, _Utils2.typeOfNode)(n);
          });
        }
        return type3;
      }()
      /**
       * Returns the name of the current node of this wrapper.
       *
       * In order of precedence => type.displayName -> type.name -> type.
       *
       * @returns {String}
       */
    }, {
      key: "name",
      value: /* @__PURE__ */ function() {
        function name() {
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return this.single("name", function(n) {
            return adapter.displayNameOfNode ? adapter.displayNameOfNode(n) : (0, _Utils2.displayNameOfNode)(n);
          });
        }
        return name;
      }()
      /**
       * Returns whether or not the current node has the given class name or not.
       *
       * NOTE: can only be called on a wrapper of a single node.
       *
       * @param className
       * @returns {Boolean}
       */
    }, {
      key: "hasClass",
      value: /* @__PURE__ */ function() {
        function hasClass2(className2) {
          if (typeof className2 === "string" && className2.indexOf(".") !== -1) {
            console.warn("It looks like you're calling `ShallowWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.");
          }
          return this.single("hasClass", function(n) {
            return (0, _RSTTraversal2.hasClassName)(n, className2);
          });
        }
        return hasClass2;
      }()
      /**
       * Iterates through each node of the current wrapper and executes the provided function with a
       * wrapper around the corresponding node passed in as the first argument.
       *
       * @param {Function} fn
       * @returns {ShallowWrapper}
       */
    }, {
      key: "forEach",
      value: /* @__PURE__ */ function() {
        function forEach2(fn) {
          var _this21 = this;
          this.getNodesInternal().forEach(function(n, i) {
            return fn.call(_this21, _this21.wrap(n), i);
          });
          return this;
        }
        return forEach2;
      }()
      /**
       * Maps the current array of nodes to another array. Each node is passed in as a `ShallowWrapper`
       * to the map function.
       *
       * @param {Function} fn
       * @returns {Array}
       */
    }, {
      key: "map",
      value: /* @__PURE__ */ function() {
        function map2(fn) {
          var _this22 = this;
          return this.getNodesInternal().map(function(n, i) {
            return fn.call(_this22, _this22.wrap(n), i);
          });
        }
        return map2;
      }()
      /**
       * Reduces the current array of nodes to a value. Each node is passed in as a `ShallowWrapper`
       * to the reducer function.
       *
       * @param {Function} fn - the reducer function
       * @param {*} initialValue - the initial value
       * @returns {*}
       */
    }, {
      key: "reduce",
      value: /* @__PURE__ */ function() {
        function reduce2(fn) {
          var _this23 = this;
          var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (arguments.length > 1) {
            return this.getNodesInternal().reduce(function(accum, n, i) {
              return fn.call(_this23, accum, _this23.wrap(n), i);
            }, initialValue);
          }
          return this.getNodesInternal().reduce(function(accum, n, i) {
            return fn.call(_this23, i === 1 ? _this23.wrap(accum) : accum, _this23.wrap(n), i);
          });
        }
        return reduce2;
      }()
      /**
       * Reduces the current array of nodes to another array, from right to left. Each node is passed
       * in as a `ShallowWrapper` to the reducer function.
       *
       * @param {Function} fn - the reducer function
       * @param {*} initialValue - the initial value
       * @returns {*}
       */
    }, {
      key: "reduceRight",
      value: /* @__PURE__ */ function() {
        function reduceRight(fn) {
          var _this24 = this;
          var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
          if (arguments.length > 1) {
            return this.getNodesInternal().reduceRight(function(accum, n, i) {
              return fn.call(_this24, accum, _this24.wrap(n), i);
            }, initialValue);
          }
          return this.getNodesInternal().reduceRight(function(accum, n, i) {
            return fn.call(_this24, i === 1 ? _this24.wrap(accum) : accum, _this24.wrap(n), i);
          });
        }
        return reduceRight;
      }()
      /**
       * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
       * rules of `Array#slice`.
       *
       * @param {Number} begin
       * @param {Number} end
       * @returns {ShallowWrapper}
       */
    }, {
      key: "slice",
      value: /* @__PURE__ */ function() {
        function slice2(begin, end2) {
          return this.wrap(this.getNodesInternal().slice(begin, end2));
        }
        return slice2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper match the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {Boolean}
       */
    }, {
      key: "some",
      value: /* @__PURE__ */ function() {
        function some2(selector2) {
          if (this[ROOT] === this) {
            throw new Error("ShallowWrapper::some() can not be called on the root");
          }
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.getNodesInternal().some(predicate);
        }
        return some2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
       *
       * @param {Function} predicate
       * @returns {Boolean}
       */
    }, {
      key: "someWhere",
      value: /* @__PURE__ */ function() {
        function someWhere(predicate) {
          var _this25 = this;
          return this.getNodesInternal().some(function(n, i) {
            return predicate.call(_this25, _this25.wrap(n), i);
          });
        }
        return someWhere;
      }()
      /**
       * Returns whether or not all of the nodes in the wrapper match the provided selector.
       *
       * @param {EnzymeSelector} selector
       * @returns {Boolean}
       */
    }, {
      key: "every",
      value: /* @__PURE__ */ function() {
        function every2(selector2) {
          var predicate = (0, _selectors.buildPredicate)(selector2);
          return this.getNodesInternal().every(predicate);
        }
        return every2;
      }()
      /**
       * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
       *
       * @param {Function} predicate
       * @returns {Boolean}
       */
    }, {
      key: "everyWhere",
      value: /* @__PURE__ */ function() {
        function everyWhere(predicate) {
          var _this26 = this;
          return this.getNodesInternal().every(function(n, i) {
            return predicate.call(_this26, _this26.wrap(n), i);
          });
        }
        return everyWhere;
      }()
      /**
       * Utility method used to create new wrappers with a mapping function that returns an array of
       * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
       * all of the mapped nodes flattened (and de-duplicated).
       *
       * @param {Function} fn
       * @returns {ShallowWrapper}
       */
    }, {
      key: "flatMap",
      value: /* @__PURE__ */ function() {
        function flatMap(fn) {
          var _this27 = this;
          var nodes = this.getNodesInternal().map(function(n, i) {
            return fn.call(_this27, _this27.wrap(n), i);
          });
          var flattened = (0, _arrayPrototype22["default"])(nodes, 1);
          return this.wrap(flattened.filter(Boolean));
        }
        return flatMap;
      }()
      /**
       * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
       * function. The predicate function will receive the nodes inside a ShallowWrapper as its
       * first argument.
       *
       * @param {Function} predicate
       * @returns {ShallowWrapper}
       */
    }, {
      key: "findWhere",
      value: /* @__PURE__ */ function() {
        function findWhere(predicate) {
          var _this28 = this;
          return findWhereUnwrapped(this, function(n) {
            var node2 = _this28.wrap(n);
            return node2.length > 0 && predicate(node2);
          });
        }
        return findWhere;
      }()
      /**
       * Returns the node at a given index of the current wrapper.
       *
       * @param index
       * @returns {ReactElement}
       */
    }, {
      key: "get",
      value: /* @__PURE__ */ function() {
        function get3(index2) {
          return this.getElements()[index2];
        }
        return get3;
      }()
      /**
       * Returns a wrapper around the node at a given index of the current wrapper.
       *
       * @param index
       * @returns {ShallowWrapper}
       */
    }, {
      key: "at",
      value: /* @__PURE__ */ function() {
        function at(index2) {
          var nodes = this.getNodesInternal();
          if (index2 < nodes.length) {
            return this.wrap(nodes[index2]);
          }
          return this.wrap([]);
        }
        return at;
      }()
      /**
       * Returns a wrapper around the first node of the current wrapper.
       *
       * @returns {ShallowWrapper}
       */
    }, {
      key: "first",
      value: /* @__PURE__ */ function() {
        function first2() {
          return this.at(0);
        }
        return first2;
      }()
      /**
       * Returns a wrapper around the last node of the current wrapper.
       *
       * @returns {ShallowWrapper}
       */
    }, {
      key: "last",
      value: /* @__PURE__ */ function() {
        function last2() {
          return this.at(this.length - 1);
        }
        return last2;
      }()
      /**
       * Delegates to exists()
       *
       * @returns {boolean}
       */
    }, {
      key: "isEmpty",
      value: /* @__PURE__ */ function() {
        function isEmpty() {
          console.warn("Enzyme::Deprecated method isEmpty() called, use exists() instead.");
          return !this.exists();
        }
        return isEmpty;
      }()
      /**
       * Returns true if the current wrapper has nodes. False otherwise.
       * If called with a selector it returns `.find(selector).exists()` instead.
       *
       * @param {EnzymeSelector} selector (optional)
       * @returns {boolean}
       */
    }, {
      key: "exists",
      value: /* @__PURE__ */ function() {
        function exists() {
          var selector2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
          return arguments.length > 0 ? this.find(selector2).exists() : this.length > 0;
        }
        return exists;
      }()
      /**
       * Utility method that throws an error if the current instance has a length other than one.
       * This is primarily used to enforce that certain methods are only run on a wrapper when it is
       * wrapping a single node.
       *
       * @param fn
       * @returns {*}
       */
    }, {
      key: "single",
      value: /* @__PURE__ */ function() {
        function single(name, fn) {
          var fnName = typeof name === "string" ? name : "unknown";
          var callback = typeof fn === "function" ? fn : name;
          if (this.length !== 1) {
            throw new Error("Method “" + fnName + "” is meant to be run on 1 node. " + String(this.length) + " found instead.");
          }
          return callback.call(this, this.getNodeInternal());
        }
        return single;
      }()
      /**
       * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
       * any nodes passed in as the first parameter automatically wrapped.
       *
       * @param node
       * @returns {ShallowWrapper}
       */
    }, {
      key: "wrap",
      value: /* @__PURE__ */ function() {
        function wrap2(node2) {
          var root2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[ROOT];
          if (node2 instanceof ShallowWrapper3) {
            return node2;
          }
          for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            args[_key3 - 2] = arguments[_key3];
          }
          return new (Function.prototype.bind.apply(ShallowWrapper3, [null].concat([node2, root2], args)))();
        }
        return wrap2;
      }()
      /**
       * Returns an HTML-like string of the shallow render for debugging purposes.
       *
       * @param {Object} [options] - Property bag of additional options.
       * @param {boolean} [options.ignoreProps] - if true, props are omitted from the string.
       * @param {boolean} [options.verbose] - if true, arrays and objects to be verbosely printed.
       * @returns {String}
       */
    }, {
      key: "debug",
      value: /* @__PURE__ */ function() {
        function debug() {
          var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return (0, _Debug.debugNodes)(this.getNodesInternal(), options2);
        }
        return debug;
      }()
      /**
       * Invokes intercepter and returns itself. intercepter is called with itself.
       * This is helpful when debugging nodes in method chains.
       * @param fn
       * @returns {ShallowWrapper}
       */
    }, {
      key: "tap",
      value: /* @__PURE__ */ function() {
        function tap(intercepter) {
          intercepter(this);
          return this;
        }
        return tap;
      }()
      /**
       * Primarily useful for HOCs (higher-order components), this method may only be
       * run on a single, non-DOM node, and will return the node, shallow-rendered.
       *
       * @param {Object} options
       * @returns {ShallowWrapper}
       */
    }, {
      key: "dive",
      value: /* @__PURE__ */ function() {
        function dive() {
          var _this29 = this;
          var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          var name = "dive";
          return this.single(name, function(n) {
            if (n && n.nodeType === "host") {
              throw new TypeError("ShallowWrapper::" + name + "() can not be called on Host Components");
            }
            var el = (0, _getAdapter22["default"])(_this29[OPTIONS]).nodeToElement(n);
            if (!(0, _Utils2.isCustomComponentElement)(el, adapter)) {
              throw new TypeError("ShallowWrapper::" + name + "() can only be called on components");
            }
            var childOptions = makeInheritedChildOptions(_this29, options2);
            return _this29.wrap(el, null, childOptions);
          });
        }
        return dive;
      }()
      /**
       * Strips out all the not host-nodes from the list of nodes
       *
       * This method is useful if you want to check for the presence of host nodes
       * (actually rendered HTML elements) ignoring the React nodes.
       */
    }, {
      key: "hostNodes",
      value: /* @__PURE__ */ function() {
        function hostNodes() {
          return this.filterWhere(function(n) {
            return typeof n.type() === "string";
          });
        }
        return hostNodes;
      }()
    }]);
    return ShallowWrapper3;
  }();
  function updatePrimaryRootContext(wrappingComponent) {
    var adapter = (0, _getAdapter22["default"])(wrappingComponent[OPTIONS]);
    var primaryWrapper = wrappingComponent[PRIMARY_WRAPPER];
    var primaryRenderer = primaryWrapper[RENDERER];
    var primaryNode = primaryRenderer.getNode();
    var _getContextFromWrappi2 = getContextFromWrappingComponent(wrappingComponent, adapter), legacyContext = _getContextFromWrappi2.legacyContext, providerValues = _getContextFromWrappi2.providerValues;
    var prevProviderValues = primaryWrapper[PROVIDER_VALUES];
    primaryWrapper.setContext((0, _object22["default"])({}, wrappingComponent[PRIMARY_WRAPPER][OPTIONS].context, legacyContext));
    primaryWrapper[PROVIDER_VALUES] = new Map([].concat(_toConsumableArray2(prevProviderValues), _toConsumableArray2(providerValues)));
    if (typeof adapter.isContextConsumer === "function" && adapter.isContextConsumer(primaryNode.type)) {
      var Consumer2 = primaryNode.type;
      var Provider2 = adapter.getProviderFromConsumer(Consumer2);
      var newValue = providerValues.get(Provider2);
      var oldValue = prevProviderValues.get(Provider2);
      if (newValue !== oldValue) {
        primaryWrapper.rerender();
      }
    }
  }
  var WrappingComponentWrapper = function(_ShallowWrapper3) {
    _inherits2(WrappingComponentWrapper2, _ShallowWrapper3);
    function WrappingComponentWrapper2(nodes, root2, RootFinder) {
      _classCallCheck2(this, WrappingComponentWrapper2);
      var _this30 = _possibleConstructorReturn2(this, (WrappingComponentWrapper2.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2)).call(this, nodes));
      (0, _Utils2.privateSet)(_this30, PRIMARY_WRAPPER, root2);
      (0, _Utils2.privateSet)(_this30, ROOT_FINDER, RootFinder);
      return _this30;
    }
    _createClass2(WrappingComponentWrapper2, [{
      key: "rerender",
      value: /* @__PURE__ */ function() {
        function rerender() {
          var _get22;
          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          var result = (_get22 = _get2(WrappingComponentWrapper2.prototype.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2.prototype), "rerender", this)).call.apply(_get22, [this].concat(args));
          updatePrimaryRootContext(this);
          return result;
        }
        return rerender;
      }()
      /**
       * Like setState() on ShallowWrapper, except it also does a "full render" of
       * itself and updates the primary ShallowWrapper's context.
       */
    }, {
      key: "setState",
      value: /* @__PURE__ */ function() {
        function setState() {
          var _get3;
          for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }
          var result = (_get3 = _get2(WrappingComponentWrapper2.prototype.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2.prototype), "setState", this)).call.apply(_get3, [this].concat(args));
          updatePrimaryRootContext(this);
          return result;
        }
        return setState;
      }()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "getWrappingComponent",
      value: /* @__PURE__ */ function() {
        function getWrappingComponent() {
          throw new Error("ShallowWrapper::getWrappingComponent() can only be called on the root");
        }
        return getWrappingComponent;
      }()
    }]);
    return WrappingComponentWrapper2;
  }(ShallowWrapper2);
  if (_Utils2.ITERATOR_SYMBOL) {
    Object.defineProperty(ShallowWrapper2.prototype, _Utils2.ITERATOR_SYMBOL, {
      configurable: true,
      value: /* @__PURE__ */ function() {
        function iterator() {
          var _ref2;
          var iter = this.getNodesInternal()[_Utils2.ITERATOR_SYMBOL]();
          var adapter = (0, _getAdapter22["default"])(this[OPTIONS]);
          return _ref2 = {}, _defineProperty2(_ref2, _Utils2.ITERATOR_SYMBOL, function() {
            return this;
          }), _defineProperty2(_ref2, "next", /* @__PURE__ */ function() {
            function next() {
              var next2 = iter.next();
              if (next2.done) {
                return {
                  done: true
                };
              }
              return {
                done: false,
                value: adapter.nodeToElement(next2.value)
              };
            }
            return next;
          }()), _ref2;
        }
        return iterator;
      }()
    });
  }
  function privateWarning(prop2, extraMessage) {
    Object.defineProperty(ShallowWrapper2.prototype, prop2, {
      get: /* @__PURE__ */ function() {
        function get3() {
          throw new Error("\n        Attempted to access ShallowWrapper::" + String(prop2) + ", which was previously a private property on\n        Enzyme ShallowWrapper instances, but is no longer and should not be relied upon.\n        " + String(extraMessage) + "\n      ");
        }
        return get3;
      }(),
      enumerable: false,
      configurable: false
    });
  }
  privateWarning("node", "Consider using the getElement() method instead.");
  privateWarning("nodes", "Consider using the getElements() method instead.");
  privateWarning("renderer", "");
  privateWarning("options", "");
  privateWarning("complexSelector", "");
  exports2["default"] = ShallowWrapper2;
})(ShallowWrapper);
var mount = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = mount2;
  var _ReactWrapper3 = ReactWrapper;
  var _ReactWrapper22 = _interopRequireDefault2(_ReactWrapper3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function mount2(node2, options2) {
    return new _ReactWrapper22["default"](node2, null, options2);
  }
})(mount);
var shallow = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = shallow2;
  var _ShallowWrapper3 = ShallowWrapper;
  var _ShallowWrapper22 = _interopRequireDefault2(_ShallowWrapper3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function shallow2(node2, options2) {
    return new _ShallowWrapper22["default"](node2, null, options2);
  }
})(shallow);
var render$1 = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2["default"] = render3;
  var _object5 = object_assign;
  var _object22 = _interopRequireDefault2(_object5);
  var _getAdapter3 = getAdapter;
  var _getAdapter22 = _interopRequireDefault2(_getAdapter3);
  var _Utils2 = Utils;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function render3(node2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var adapter = (0, _getAdapter22["default"])(options2);
    var renderer = adapter.createRenderer((0, _object22["default"])({
      mode: "string"
    }, options2));
    var html2 = renderer.render(node2, options2.context);
    return (0, _Utils2.loadCheerioRoot)(html2);
  }
})(render$1);
var _ReactWrapper = ReactWrapper;
var _ReactWrapper2 = _interopRequireDefault$8(_ReactWrapper);
var _ShallowWrapper = ShallowWrapper;
var _ShallowWrapper2 = _interopRequireDefault$8(_ShallowWrapper);
var _EnzymeAdapter = EnzymeAdapter_1;
var _EnzymeAdapter2 = _interopRequireDefault$8(_EnzymeAdapter);
var _mount = mount;
var _mount2 = _interopRequireDefault$8(_mount);
var _shallow = shallow;
var _shallow2 = _interopRequireDefault$8(_shallow);
var _render = render$1;
var _render2 = _interopRequireDefault$8(_render);
var _configuration = configuration$1;
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var build = {
  render: _render2["default"],
  shallow: _shallow2["default"],
  mount: _mount2["default"],
  ShallowWrapper: _ShallowWrapper2["default"],
  ReactWrapper: _ReactWrapper2["default"],
  configure: _configuration.merge,
  EnzymeAdapter: _EnzymeAdapter2["default"]
};
const TILE_LOADING_CHECK_INTERVAL = 100;
const changeOptions = (hgc, viewUid, trackUid, options2) => {
  for (const {
    viewId,
    trackId,
    track
  } of hgc.instance().iterateOverTracks()) {
    if (viewId === viewUid && trackId === trackUid) {
      track.options = {
        ...track.options,
        ...options2
      };
    }
  }
  hgc.setState(hgc.instance().state);
};
const areTransitionsActive = (hgc) => {
  for (const track of hgc.iterateOverTracks()) {
    const trackRenderer = getTrackRenderer(hgc, track.viewId, track.trackId);
    if (trackRenderer.activeTransitions > 0)
      return true;
  }
  return false;
};
const waitForTransitionsFinished = (hgc, callback) => {
  if (areTransitionsActive(hgc)) {
    setTimeout(() => {
      waitForTransitionsFinished(hgc, callback);
    }, TILE_LOADING_CHECK_INTERVAL);
  } else {
    callback();
  }
};
const waitForJsonComplete = (finished) => {
  if (requestsInFlight > 0) {
    setTimeout(() => waitForJsonComplete(finished), TILE_LOADING_CHECK_INTERVAL);
  } else {
    finished();
  }
};
const isWaitingOnTiles = (hgc) => {
  for (const track of hgc.iterateOverTracks()) {
    let trackObj = getTrackObjectFromHGC(hgc, track.viewId, track.trackId);
    if (!track.track.server && !track.track.tilesetUid && !(track.track.data && track.track.data.type === "divided")) {
      continue;
    } else if (track.track.data && track.track.data.type === "divided" || track.track.server && track.track.tilesetUid) {
      if (trackObj.originalTrack) {
        trackObj = trackObj.originalTrack;
      }
      if (!(trackObj.tilesetInfo || trackObj.chromInfo)) {
        return true;
      }
      if (trackObj.fetching && trackObj.fetching.size) {
        return true;
      }
    } else {
      throw Error('"server" and "tilesetUid" belong together');
    }
  }
  return false;
};
const waitForTilesLoaded = (hgc, tilesLoadedCallback) => {
  if (isWaitingOnTiles(hgc)) {
    setTimeout(() => {
      waitForTilesLoaded(hgc, tilesLoadedCallback);
    }, TILE_LOADING_CHECK_INTERVAL);
  } else {
    tilesLoadedCallback();
  }
};
const mountHGComponent = (prevDiv, prevHgc, viewConf, done, options2 = {}) => {
  const {
    style = "width:800px; background-color: lightgreen;",
    bounded = false,
    extendedDelay = false
  } = options2;
  if (prevHgc) {
    prevHgc.unmount();
    prevHgc.detach();
  }
  if (prevDiv) {
    globalThis.document.body.removeChild(prevDiv);
  }
  const div = globalThis.document.createElement("div");
  globalThis.document.body.appendChild(div);
  div.setAttribute("style", style);
  div.setAttribute("id", "simple-hg-component");
  const hgc = build.mount(/* @__PURE__ */ React$3.createElement(HiGlassComponent, {
    options: {
      bounded
    },
    viewConfig: viewConf
  }), {
    attachTo: div
  });
  hgc.update();
  waitForJsonComplete(() => {
    if (extendedDelay) {
      const doneWithDelay = () => setTimeout(() => {
        done();
      }, 1e3);
      waitForTilesLoaded(hgc.instance(), doneWithDelay);
    } else {
      waitForTilesLoaded(hgc.instance(), done);
    }
  });
  return (
    /** @type {const} */
    [div, hgc]
  );
};
const removeHGComponent = (div) => {
  if (!div)
    return;
  ReactDOM.unmountComponentAtNode(div);
  document.body.removeChild(div);
};
async function mountHGComponentAsync(prevDiv, prevHgc, viewConf, options2) {
  let res;
  await new Promise((resolve2) => {
    res = mountHGComponent(prevDiv, prevHgc, viewConf, resolve2, options2);
  });
  return res;
}
var frame = 0, timeout$1 = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now$2() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now$2() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail)
        taskTail._next = this;
      else
        taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time2;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time2) {
  var t = new Timer();
  t.restart(callback, delay, time2);
  return t;
}
function timerFlush() {
  now$2();
  ++frame;
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0)
      t._call.call(void 0, e);
    t = t._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke$1() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay)
    clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t02, t12 = taskHead, t22, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time)
        time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t22 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t22 : taskHead = t22;
    }
  }
  taskTail = t02;
  sleep(time2);
}
function sleep(time2) {
  if (frame)
    return;
  if (timeout$1)
    timeout$1 = clearTimeout(timeout$1);
  var delay = time2 - clockNow;
  if (delay > 24) {
    if (time2 < Infinity)
      timeout$1 = setTimeout(wake, time2 - clock.now() - clockSkew);
    if (interval)
      interval = clearInterval(interval);
  } else {
    if (!interval)
      clockLast = clock.now(), interval = setInterval(poke$1, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
function timeout(callback, delay, time2) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t;
}
var emptyOn = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function schedule(node2, name, id2, index2, group2, timing) {
  var schedules = node2.__transition;
  if (!schedules)
    node2.__transition = {};
  else if (id2 in schedules)
    return;
  create(node2, id2, {
    name,
    index: index2,
    // For context during callback.
    group: group2,
    // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}
function init(node2, id2) {
  var schedule2 = get$4(node2, id2);
  if (schedule2.state > CREATED)
    throw new Error("too late; already scheduled");
  return schedule2;
}
function set$2(node2, id2) {
  var schedule2 = get$4(node2, id2);
  if (schedule2.state > STARTED)
    throw new Error("too late; already running");
  return schedule2;
}
function get$4(node2, id2) {
  var schedule2 = node2.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2]))
    throw new Error("transition not found");
  return schedule2;
}
function create(node2, id2, self2) {
  var schedules = node2.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer(schedule2, 0, self2.time);
  function schedule2(elapsed) {
    self2.state = SCHEDULED;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed)
      start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self2.state !== SCHEDULED)
      return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name)
        continue;
      if (o.state === STARTED)
        return timeout(start2);
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout(function() {
      if (self2.state === STARTED) {
        self2.state = RUNNING;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING;
    self2.on.call("start", node2, node2.__data__, self2.index, self2.group);
    if (self2.state !== STARTING)
      return;
    self2.state = STARTED;
    tween = new Array(n = self2.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self2.tween[i].value.call(node2, node2.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node2, t);
    }
    if (self2.state === ENDING) {
      self2.on.call("end", node2, node2.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules)
      return;
    delete node2.__transition;
  }
}
function interrupt(node2, name) {
  var schedules = node2.__transition, schedule2, active3, empty2 = true, i;
  if (!schedules)
    return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active3 = schedule2.state > STARTING && schedule2.state < ENDING;
    schedule2.state = ENDED;
    schedule2.timer.stop();
    schedule2.on.call(active3 ? "interrupt" : "cancel", node2, node2.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2)
    delete node2.__transition;
}
function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}
function tweenRemove(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set$2(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction(id2, name, value2) {
  var tween0, tween1;
  if (typeof value2 !== "function")
    throw new Error();
  return function() {
    var schedule2 = set$2(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {
        name,
        value: value2
      }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n)
        tween1.push(t);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween(name, value2) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get$4(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value2 == null ? tweenRemove : tweenFunction)(id2, name, value2));
}
function tweenValue(transition3, name, value2) {
  var id2 = transition3._id;
  transition3.each(function() {
    var schedule2 = set$2(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value2.apply(this, arguments);
  });
  return function(node2) {
    return get$4(node2, id2).value[name];
  };
}
function interpolate$1(a, b) {
  var c2;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c2 = color(b)) ? (b = c2, interpolateRgb) : interpolateString)(a, b);
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction(name, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value2(this), string1;
    if (value1 == null)
      return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS(fullname, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value2(this), string1;
    if (value1 == null)
      return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr(name, value2) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
  return this.attrTween(name, typeof value2 === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value2)) : value2 == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value2));
}
function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS(fullname, value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function attrTween(name, value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolate(name, i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function transition_attrTween(name, value2) {
  var key = "attr." + name;
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value2));
}
function delayFunction(id2, value2) {
  return function() {
    init(this, id2).delay = +value2.apply(this, arguments);
  };
}
function delayConstant(id2, value2) {
  return value2 = +value2, function() {
    init(this, id2).delay = value2;
  };
}
function transition_delay(value2) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value2 === "function" ? delayFunction : delayConstant)(id2, value2)) : get$4(this.node(), id2).delay;
}
function durationFunction(id2, value2) {
  return function() {
    set$2(this, id2).duration = +value2.apply(this, arguments);
  };
}
function durationConstant(id2, value2) {
  return value2 = +value2, function() {
    set$2(this, id2).duration = value2;
  };
}
function transition_duration(value2) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value2 === "function" ? durationFunction : durationConstant)(id2, value2)) : get$4(this.node(), id2).duration;
}
function easeConstant(id2, value2) {
  if (typeof value2 !== "function")
    throw new Error();
  return function() {
    set$2(this, id2).ease = value2;
  };
}
function transition_ease(value2) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant(id2, value2)) : get$4(this.node(), id2).ease;
}
function easeVarying(id2, value2) {
  return function() {
    var v = value2.apply(this, arguments);
    if (typeof v !== "function")
      throw new Error();
    set$2(this, id2).ease = v;
  };
}
function transition_easeVarying(value2) {
  if (typeof value2 !== "function")
    throw new Error();
  return this.each(easeVarying(this._id, value2));
}
function transition_filter(match) {
  if (typeof match !== "function")
    match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Transition(subgroups, this._parents, this._name, this._id);
}
function transition_merge(transition3) {
  if (transition3._id !== this._id)
    throw new Error();
  for (var groups0 = this._groups, groups1 = transition3._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition(merges, this._parents, this._name, this._id);
}
function start$1(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0)
      t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction(id2, name, listener) {
  var on0, on1, sit = start$1(name) ? init : set$2;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0)
      (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get$4(this.node(), id2).on.on(name) : this.each(onFunction(id2, name, listener));
}
function removeFunction(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition)
      if (+i !== id2)
        return;
    if (parent)
      parent.removeChild(this);
  };
}
function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}
function transition_select(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2)
          subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id2, i, subgroup, get$4(node2, id2));
      }
    }
  }
  return new Transition(subgroups, this._parents, name, id2);
}
function transition_selectAll(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        for (var children3 = select2.call(node2, node2.__data__, i, group2), child, inherit2 = get$4(node2, id2), k = 0, l = children3.length; k < l; ++k) {
          if (child = children3[k]) {
            schedule(child, name, id2, k, children3, inherit2);
          }
        }
        subgroups.push(children3);
        parents.push(node2);
      }
    }
  }
  return new Transition(subgroups, parents, name, id2);
}
var Selection = selection.prototype.constructor;
function transition_selection() {
  return new Selection(this._groups, this._parents);
}
function styleNull(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction(name, interpolate2, value2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value2(this), string1 = value1 + "";
    if (value1 == null)
      string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove3;
  return function() {
    var schedule2 = set$2(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove3 || (remove3 = styleRemove(name)) : void 0;
    if (on !== on0 || listener0 !== listener)
      (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style(name, value2, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
  return value2 == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value2 === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value2))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value2), priority).on("end.style." + name, null);
}
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween(name, value2, priority) {
  var t, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value2;
  return tween;
}
function transition_styleTween(name, value2, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  return this.tween(key, styleTween(name, value2, priority == null ? "" : priority));
}
function textConstant(value2) {
  return function() {
    this.textContent = value2;
  };
}
function textFunction(value2) {
  return function() {
    var value1 = value2(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text(value2) {
  return this.tween("text", typeof value2 === "function" ? textFunction(tweenValue(this, "text", value2)) : textConstant(value2 == null ? "" : value2 + ""));
}
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween(value2) {
  var t02, i0;
  function tween() {
    var i = value2.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && textInterpolate(i);
    return t02;
  }
  tween._value = value2;
  return tween;
}
function transition_textTween(value2) {
  var key = "text";
  if (arguments.length < 1)
    return (key = this.tween(key)) && key._value;
  if (value2 == null)
    return this.tween(key, null);
  if (typeof value2 !== "function")
    throw new Error();
  return this.tween(key, textTween(value2));
}
function transition_transition() {
  var name = this._name, id0 = this._id, id1 = newId();
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        var inherit2 = get$4(node2, id0);
        schedule(node2, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition(groups2, this._parents, name, id1);
}
function transition_end() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve2, reject) {
    var cancel = {
      value: reject
    }, end2 = {
      value: function() {
        if (--size === 0)
          resolve2();
      }
    };
    that.each(function() {
      var schedule2 = set$2(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end2);
      }
      schedule2.on = on1;
    });
    if (size === 0)
      resolve2();
  });
}
var id = 0;
function Transition(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function transition(name) {
  return selection().transition(name);
}
function newId() {
  return ++id;
}
var selection_prototype = selection.prototype;
Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  selectChild: selection_prototype.selectChild,
  selectChildren: selection_prototype.selectChildren,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};
function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var defaultTiming = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};
function inherit(node2, id2) {
  var timing;
  while (!(timing = node2.__transition) || !(timing = timing[id2])) {
    if (!(node2 = node2.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition(name) {
  var id2, timing;
  if (name instanceof Transition) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId(), (timing = defaultTiming).time = now$2(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        schedule(node2, name, id2, i, group2, timing || inherit(node2, id2));
      }
    }
  }
  return new Transition(groups2, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;
var root$2 = [null];
function active$2(node2, name) {
  var schedules = node2.__transition, schedule2, i;
  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule2 = schedules[i]).state > SCHEDULED && schedule2.name === name) {
        return new Transition([[node2]], root$2, name, +i);
      }
    }
  }
  return null;
}
const d3Transition = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: active$2,
  interrupt,
  transition
}, Symbol.toStringTag, { value: "Module" }));
const constant$2 = (x) => () => x;
function ZoomEvent(type3, {
  sourceEvent: sourceEvent2,
  target,
  transform: transform3,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type3,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target,
      enumerable: true,
      configurable: true
    },
    transform: {
      value: transform3,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point2) {
    return [point2[0] * this.k + this.x, point2[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var identity$4 = new Transform(1, 0, 0);
transform$1.prototype = Transform.prototype;
function transform$1(node2) {
  while (!node2.__zoom)
    if (!(node2 = node2.parentNode))
      return identity$4;
  return node2.__zoom;
}
function nopropagation(event) {
  event.stopImmediatePropagation();
}
function noevent(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function defaultFilter(event) {
  return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function defaultExtent() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}
function defaultTransform() {
  return this.__zoom || identity$4;
}
function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 2e-3) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform3, extent2, translateExtent) {
  var dx0 = transform3.invertX(extent2[0][0]) - translateExtent[0][0], dx1 = transform3.invertX(extent2[1][0]) - translateExtent[1][0], dy0 = transform3.invertY(extent2[0][1]) - translateExtent[0][1], dy1 = transform3.invertY(extent2[1][1]) - translateExtent[1][1];
  return transform3.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function zoom() {
  var filter4 = defaultFilter, extent2 = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [0, Infinity], translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]], duration = 250, interpolate2 = interpolateZoom, listeners = dispatch$1("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
  function zoom2(selection2) {
    selection2.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
      passive: false
    }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  zoom2.transform = function(collection, transform3, point2, event) {
    var selection2 = collection.selection ? collection.selection() : collection;
    selection2.property("__zoom", defaultTransform);
    if (collection !== selection2) {
      schedule2(collection, transform3, point2, event);
    } else {
      selection2.interrupt().each(function() {
        gesture(this, arguments).event(event).start().zoom(null, typeof transform3 === "function" ? transform3.apply(this, arguments) : transform3).end();
      });
    }
  };
  zoom2.scaleBy = function(selection2, k, p, event) {
    zoom2.scaleTo(selection2, function() {
      var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    }, p, event);
  };
  zoom2.scaleTo = function(selection2, k, p, event) {
    zoom2.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t02 = this.__zoom, p02 = p == null ? centroid2(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t02.invert(p02), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t02, k1), p02, p1), e, translateExtent);
    }, p, event);
  };
  zoom2.translateBy = function(selection2, x, y, event) {
    zoom2.transform(selection2, function() {
      return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent2.apply(this, arguments), translateExtent);
    }, null, event);
  };
  zoom2.translateTo = function(selection2, x, y, p, event) {
    zoom2.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t = this.__zoom, p02 = p == null ? centroid2(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity$4.translate(p02[0], p02[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
    }, p, event);
  };
  function scale(transform3, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform3.k ? transform3 : new Transform(k, transform3.x, transform3.y);
  }
  function translate(transform3, p02, p1) {
    var x = p02[0] - p1[0] * transform3.k, y = p02[1] - p1[1] * transform3.k;
    return x === transform3.x && y === transform3.y ? transform3 : new Transform(transform3.k, x, y);
  }
  function centroid2(extent3) {
    return [(+extent3[0][0] + +extent3[1][0]) / 2, (+extent3[0][1] + +extent3[1][1]) / 2];
  }
  function schedule2(transition3, transform3, point2, event) {
    transition3.on("start.zoom", function() {
      gesture(this, arguments).event(event).start();
    }).on("interrupt.zoom end.zoom", function() {
      gesture(this, arguments).event(event).end();
    }).tween("zoom", function() {
      var that = this, args = arguments, g = gesture(that, args).event(event), e = extent2.apply(that, args), p = point2 == null ? centroid2(e) : typeof point2 === "function" ? point2.apply(that, args) : point2, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform3 === "function" ? transform3.apply(that, args) : transform3, i = interpolate2(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
      return function(t) {
        if (t === 1)
          t = b;
        else {
          var l = i(t), k = w / l[2];
          t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
        }
        g.zoom(null, t);
      };
    });
  }
  function gesture(that, args, clean) {
    return !clean && that.__zooming || new Gesture(that, args);
  }
  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent2.apply(that, args);
    this.taps = 0;
  }
  Gesture.prototype = {
    event: function(event) {
      if (event)
        this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform3) {
      if (this.mouse && key !== "mouse")
        this.mouse[1] = transform3.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch")
        this.touch0[1] = transform3.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch")
        this.touch1[1] = transform3.invert(this.touch1[0]);
      this.that.__zoom = transform3;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type3) {
      var d = select$1(this.that).datum();
      listeners.call(type3, this.that, new ZoomEvent(type3, {
        sourceEvent: this.sourceEvent,
        target: zoom2,
        type: type3,
        transform: this.that.__zoom,
        dispatch: listeners
      }), d);
    }
  };
  function wheeled(event, ...args) {
    if (!filter4.apply(this, arguments))
      return;
    var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    } else if (t.k === k)
      return;
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }
    noevent(event);
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }
  function mousedowned(event, ...args) {
    if (touchending || !filter4.apply(this, arguments))
      return;
    var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select$1(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x02 = event.clientX, y02 = event.clientY;
    dragDisable(event.view);
    nopropagation(event);
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();
    function mousemoved(event2) {
      noevent(event2);
      if (!g.moved) {
        var dx = event2.clientX - x02, dy = event2.clientY - y02;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.event(event2).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event2, currentTarget), g.mouse[1]), g.extent, translateExtent));
    }
    function mouseupped(event2) {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(event2.view, g.moved);
      noevent(event2);
      g.event(event2).end();
    }
  }
  function dblclicked(event, ...args) {
    if (!filter4.apply(this, arguments))
      return;
    var t02 = this.__zoom, p02 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t02.invert(p02), k1 = t02.k * (event.shiftKey ? 0.5 : 2), t12 = constrain(translate(scale(t02, k1), p02, p1), extent2.apply(this, args), translateExtent);
    noevent(event);
    if (duration > 0)
      select$1(this).transition().duration(duration).call(schedule2, t12, p02, event);
    else
      select$1(this).call(zoom2.transform, t12, p02, event);
  }
  function touchstarted(event, ...args) {
    if (!filter4.apply(this, arguments))
      return;
    var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
    nopropagation(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0)
        g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2])
        g.touch1 = p, g.taps = 0;
    }
    if (touchstarting)
      touchstarting = clearTimeout(touchstarting);
    if (started) {
      if (g.taps < 2)
        touchfirst = p[0], touchstarting = setTimeout(function() {
          touchstarting = null;
        }, touchDelay);
      interrupt(this);
      g.start();
    }
  }
  function touchmoved(event, ...args) {
    if (!this.__zooming)
      return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
    noevent(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      if (g.touch0 && g.touch0[2] === t.identifier)
        g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier)
        g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p02 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p02[0]) * dp + (dp = p1[1] - p02[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p02[0] + p1[0]) / 2, (p02[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    } else if (g.touch0)
      p = g.touch0[0], l = g.touch0[1];
    else
      return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }
  function touchended(event, ...args) {
    if (!this.__zooming)
      return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
    nopropagation(event);
    if (touchending)
      clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier)
        delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier)
        delete g.touch1;
    }
    if (g.touch1 && !g.touch0)
      g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0)
      g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      if (g.taps === 2) {
        t = pointer(t, this);
        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
          var p = select$1(this).on("dblclick.zoom");
          if (p)
            p.apply(this, arguments);
        }
      }
    }
  }
  zoom2.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant$2(+_), zoom2) : wheelDelta;
  };
  zoom2.filter = function(_) {
    return arguments.length ? (filter4 = typeof _ === "function" ? _ : constant$2(!!_), zoom2) : filter4;
  };
  zoom2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$2(!!_), zoom2) : touchable;
  };
  zoom2.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant$2([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom2) : extent2;
  };
  zoom2.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom2) : [scaleExtent[0], scaleExtent[1]];
  };
  zoom2.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom2) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };
  zoom2.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom2) : constrain;
  };
  zoom2.duration = function(_) {
    return arguments.length ? (duration = +_, zoom2) : duration;
  };
  zoom2.interpolate = function(_) {
    return arguments.length ? (interpolate2 = _, zoom2) : interpolate2;
  };
  zoom2.on = function() {
    var value2 = listeners.on.apply(listeners, arguments);
    return value2 === listeners ? zoom2 : value2;
  };
  zoom2.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom2) : Math.sqrt(clickDistance2);
  };
  zoom2.tapDistance = function(_) {
    return arguments.length ? (tapDistance = +_, zoom2) : tapDistance;
  };
  return zoom2;
}
const d3Zoom = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ZoomTransform: Transform,
  zoom,
  zoomIdentity: identity$4,
  zoomTransform: transform$1
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$1z(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1o(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1o(descriptor.key), descriptor);
  }
}
function _createClass$1x(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1o(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1o(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1o(arg) {
  var key = _toPrimitive$1o(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1o(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const TICK_HEIGHT$1 = 40;
const TICK_MARGIN = 0;
const TICK_LENGTH = 5;
const TICK_LABEL_MARGIN = 4;
let AxisPixi = /* @__PURE__ */ function() {
  function AxisPixi2(track) {
    _classCallCheck$1z(this, AxisPixi2);
    this.pAxis = new GLOBALS.PIXI.Graphics();
    this.track = track;
    this.axisTexts = [];
    this.axisTextFontFamily = "Arial";
    this.axisTextFontSize = 10;
  }
  _createClass$1x(AxisPixi2, [{
    key: "startAxis",
    value: function startAxis(axisHeight) {
      const graphics = this.pAxis;
      graphics.clear();
      graphics.lineStyle(1, this.track.getTheme() === THEME_DARK ? colorToHex("#ffffff") : 0, 1);
      graphics.moveTo(0, 0);
      graphics.lineTo(0, axisHeight);
    }
  }, {
    key: "createAxisTexts",
    value: function createAxisTexts(valueScale, axisHeight) {
      this.tickValues = this.calculateAxisTickValues(valueScale, axisHeight);
      let i = 0;
      const color2 = this.track.getTheme() === THEME_DARK ? "white" : "black";
      if (!this.track.options || !this.track.options.axisLabelFormatting || this.track.options.axisLabelFormatting === "scientific") {
        this.tickFormat = format$1(".2");
      } else {
        this.tickFormat = (x) => x;
      }
      while (i < this.tickValues.length) {
        const tick = this.tickValues[i];
        while (this.axisTexts.length <= i) {
          const newText = new GLOBALS.PIXI.Text(tick, {
            fontSize: `${this.axisTextFontSize}px`,
            fontFamily: this.axisTextFontFamily,
            fill: color2
          });
          this.axisTexts.push(newText);
          this.pAxis.addChild(newText);
        }
        this.axisTexts[i].text = this.tickFormat(tick);
        this.axisTexts[i].anchor.y = 0.5;
        this.axisTexts[i].anchor.x = 0.5;
        i++;
      }
      while (this.axisTexts.length > this.tickValues.length) {
        const lastText = this.axisTexts.pop();
        this.pAxis.removeChild(lastText);
        lastText.destroy(true);
      }
    }
  }, {
    key: "calculateAxisTickValues",
    value: function calculateAxisTickValues(valueScale, axisHeight) {
      const tickCount = Math.max(Math.ceil(axisHeight / TICK_HEIGHT$1), 1);
      let tickValues = valueScale.ticks(tickCount);
      if (tickValues.length < 1) {
        tickValues = valueScale.ticks(tickCount + 1);
        if (tickValues.length > 1) {
          tickValues = [tickValues[0]];
        }
      }
      return tickValues;
    }
  }, {
    key: "drawAxisLeft",
    value: function drawAxisLeft(valueScale, axisHeight) {
      this.startAxis(axisHeight);
      this.createAxisTexts(valueScale, axisHeight);
      const graphics = this.pAxis;
      if (this.track.getTheme() === THEME_DARK) {
        graphics.lineStyle(graphics.lineWidth || graphics._lineStyle.width, colorToHex("#ffffff"));
      }
      graphics.moveTo(0, 0);
      graphics.lineTo(-(TICK_MARGIN + TICK_LENGTH), 0);
      graphics.moveTo(0, axisHeight);
      graphics.lineTo(-(TICK_MARGIN + TICK_LENGTH), axisHeight);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        this.axisTexts[i].x = -(TICK_MARGIN + TICK_LENGTH + TICK_LABEL_MARGIN + this.axisTexts[i].width / 2);
        this.axisTexts[i].y = valueScale(tick);
        graphics.moveTo(-TICK_MARGIN, valueScale(tick));
        graphics.lineTo(-(TICK_MARGIN + TICK_LENGTH), valueScale(tick));
        if (this.track && this.track.flipText) {
          this.axisTexts[i].scale.x = -1;
        }
      }
      this.hideOverlappingAxisLabels();
    }
  }, {
    key: "drawAxisRight",
    value: function drawAxisRight(valueScale, axisHeight) {
      this.startAxis(axisHeight);
      this.createAxisTexts(valueScale, axisHeight);
      const graphics = this.pAxis;
      if (this.track.getTheme() === THEME_DARK) {
        graphics.lineStyle(graphics.lineWidth || graphics._lineStyle.width, colorToHex("#ffffff"));
      }
      graphics.moveTo(0, 0);
      graphics.lineTo(TICK_MARGIN + TICK_LENGTH, 0);
      graphics.moveTo(0, axisHeight);
      graphics.lineTo(TICK_MARGIN + TICK_LENGTH, axisHeight);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        this.axisTexts[i].x = TICK_MARGIN + TICK_LENGTH + TICK_LABEL_MARGIN + this.axisTexts[i].width / 2;
        this.axisTexts[i].y = valueScale(tick);
        graphics.moveTo(TICK_MARGIN, valueScale(tick));
        graphics.lineTo(TICK_MARGIN + TICK_LENGTH, valueScale(tick));
        if (this.track && this.track.flipText) {
          this.axisTexts[i].scale.x = -1;
        }
      }
      this.hideOverlappingAxisLabels();
    }
  }, {
    key: "hideOverlappingAxisLabels",
    value: function hideOverlappingAxisLabels() {
      for (let i = this.axisTexts.length - 1; i >= 0; i--) {
        this.axisTexts[i].visible = true;
      }
      for (let i = this.axisTexts.length - 1; i >= 0; i--) {
        if (!this.axisTexts[i].visible) {
          continue;
        }
        let j = i - 1;
        while (j >= 0) {
          if (this.axisTexts[i].y + this.axisTexts[i].height / 2 > this.axisTexts[j].y - this.axisTexts[j].height / 2) {
            this.axisTexts[j].visible = false;
          } else {
            break;
          }
          j -= 1;
        }
      }
    }
  }, {
    key: "exportVerticalAxis",
    value: function exportVerticalAxis(axisHeight) {
      const gAxis = document.createElement("g");
      gAxis.setAttribute("class", "axis-vertical");
      let stroke = "black";
      if (this.track && this.track.options.lineStrokeColor) {
        stroke = this.track.options.lineStrokeColor;
      }
      if (this.track.getTheme() === THEME_DARK)
        stroke = "#cccccc";
      const line = document.createElement("path");
      const lineVerticalAxisUniqueId = Math.random().toString(36).substring(7);
      line.setAttribute("fill", "transparent");
      line.setAttribute("stroke", stroke);
      line.setAttribute("id", `axis-line-${lineVerticalAxisUniqueId}`);
      line.setAttribute("d", `M0,0 L0,${axisHeight}`);
      gAxis.appendChild(line);
      return gAxis;
    }
  }, {
    key: "createAxisSVGLine",
    value: function createAxisSVGLine() {
      let stroke = "black";
      if (this.track && this.track.options.lineStrokeColor) {
        stroke = this.track.options.lineStrokeColor;
      }
      if (this.track.getTheme() === THEME_DARK)
        stroke = "#cccccc";
      const line = document.createElement("path");
      const lineAxisSVGUniqueId = Math.random().toString(36).substring(7);
      line.setAttribute("id", `tick-mark-${lineAxisSVGUniqueId}`);
      line.setAttribute("fill", "transparent");
      line.setAttribute("stroke", stroke);
      return line;
    }
  }, {
    key: "createAxisSVGText",
    value: function createAxisSVGText(text2) {
      const t = document.createElement("text");
      const textAxisSVGUniqueId = Math.random().toString(36).substring(7);
      t.innerHTML = text2;
      t.setAttribute("id", `axis-text-${textAxisSVGUniqueId}`);
      t.setAttribute("text-anchor", "middle");
      t.setAttribute("font-family", this.axisTextFontFamily);
      t.setAttribute("font-size", this.axisTextFontSize);
      t.setAttribute("dy", this.axisTextFontSize / 2 - 2);
      return t;
    }
  }, {
    key: "exportAxisLeftSVG",
    value: function exportAxisLeftSVG(valueScale, axisHeight) {
      const gAxis = this.exportVerticalAxis(axisHeight);
      const topTickLine = this.createAxisSVGLine();
      gAxis.appendChild(topTickLine);
      topTickLine.setAttribute("d", `M0,0 L${+(TICK_MARGIN + TICK_LENGTH)},0`);
      const bottomTickLine = this.createAxisSVGLine();
      gAxis.appendChild(bottomTickLine);
      bottomTickLine.setAttribute("d", `M0,${axisHeight} L${+(TICK_MARGIN + TICK_LENGTH)},${axisHeight}`);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        const text2 = this.axisTexts[i];
        const tickLine = this.createAxisSVGLine();
        gAxis.appendChild(tickLine);
        tickLine.setAttribute("d", `M${+TICK_MARGIN},${valueScale(tick)} L${+(TICK_MARGIN + TICK_LENGTH)},${valueScale(tick)}`);
        const g = document.createElement("g");
        gAxis.appendChild(g);
        if (text2.visible) {
          const t = this.createAxisSVGText(text2.text);
          g.appendChild(t);
        }
        g.setAttribute("transform", `translate(${text2.position.x},${text2.position.y})
             scale(${text2.scale.x},${text2.scale.y})`);
      }
      return gAxis;
    }
  }, {
    key: "exportAxisRightSVG",
    value: function exportAxisRightSVG(valueScale, axisHeight) {
      const gAxis = this.exportVerticalAxis(axisHeight);
      const topTickLine = this.createAxisSVGLine();
      gAxis.appendChild(topTickLine);
      topTickLine.setAttribute("d", `M0,0 L${-(TICK_MARGIN + TICK_LENGTH)},0`);
      const bottomTickLine = this.createAxisSVGLine();
      gAxis.appendChild(bottomTickLine);
      bottomTickLine.setAttribute("d", `M0,${axisHeight} L${-(TICK_MARGIN + TICK_LENGTH)},${axisHeight}`);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        const text2 = this.axisTexts[i];
        const tickLine = this.createAxisSVGLine();
        gAxis.appendChild(tickLine);
        tickLine.setAttribute("d", `M${-TICK_MARGIN},${valueScale(tick)} L${-(TICK_MARGIN + TICK_LENGTH)},${valueScale(tick)}`);
        const g = document.createElement("g");
        gAxis.appendChild(g);
        if (text2.visible) {
          const t = this.createAxisSVGText(text2.text);
          g.appendChild(t);
        }
        g.setAttribute("transform", `translate(${text2.position.x},${text2.position.y})
             scale(${text2.scale.x},${text2.scale.y})`);
      }
      return gAxis;
    }
  }, {
    key: "clearAxis",
    value: function clearAxis() {
      const graphics = this.pAxis;
      while (this.axisTexts.length) {
        const axisText = this.axisTexts.pop();
        graphics.removeChild(axisText);
      }
      graphics.clear();
    }
  }]);
  return AxisPixi2;
}();
const range$1 = (start2, end2) => {
  const values2 = [];
  for (let i = start2; i < end2; i++) {
    values2.push(i);
  }
  return values2;
};
const calculateZoomLevelFromResolutions = (resolutions, scale) => {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const trackWidth = scale.range()[1] - scale.range()[0];
  const binsDisplayed = sortedResolutions.map((r2) => (scale.domain()[1] - scale.domain()[0]) / r2);
  const binsPerPixel = binsDisplayed.map((b) => b / trackWidth);
  const displayableBinsPerPixel = binsPerPixel.filter((b) => b < 1);
  if (displayableBinsPerPixel.length === 0)
    return 0;
  return binsPerPixel.indexOf(displayableBinsPerPixel[displayableBinsPerPixel.length - 1]);
};
const calculateZoomLevel = (scale, minX, maxX, binsPerTile) => {
  const rangeWidth = scale.range()[1] - scale.range()[0];
  const zoomScale = Math.max((maxX - minX) / (scale.domain()[1] - scale.domain()[0]), 1);
  const VIEW_RESOLUTION = 384;
  const addedZoom = Math.max(0, Math.ceil(Math.log(rangeWidth / VIEW_RESOLUTION) / Math.LN2));
  let zoomLevel = Math.round(Math.log(zoomScale) / Math.LN2) + addedZoom;
  let binsPerTileCorrection = 0;
  if (binsPerTile) {
    binsPerTileCorrection = Math.floor(Math.log(256) / Math.log(2) - Math.log(binsPerTile) / Math.log(2));
  }
  zoomLevel += binsPerTileCorrection;
  return zoomLevel;
};
const calculate1DZoomLevel = (tilesetInfo, xScale, maxZoom) => {
  if (typeof maxZoom === "undefined") {
    maxZoom = Number.MAX_SAFE_INTEGER;
  }
  if (tilesetInfo.resolutions) {
    const zoomIndexX = calculateZoomLevelFromResolutions(tilesetInfo.resolutions, xScale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0] - 2);
    return zoomIndexX;
  }
  const xZoomLevel = calculateZoomLevel(xScale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0], tilesetInfo.bins_per_dimension || tilesetInfo.tile_size);
  const zoomLevel = Math.min(xZoomLevel, maxZoom);
  return Math.max(zoomLevel, 0);
};
const calculateTiles = (zoomLevel, scale, minX, maxX, maxZoom, maxDim) => {
  const zoomLevelFinal = Math.min(zoomLevel, maxZoom);
  const tileWidth = maxDim / 2 ** zoomLevelFinal;
  const epsilon3 = 1e-7;
  return range$1(Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth)), Math.min(2 ** zoomLevelFinal, Math.ceil((scale.domain()[1] - minX - epsilon3) / tileWidth)));
};
const calculateTilesFromResolution = (resolution, scale, minX, maxX = Number.MAX_VALUE, pixelsPerTile = 256) => {
  const epsilon3 = 1e-7;
  const tileWidth = resolution * pixelsPerTile;
  const MAX_TILES = 20;
  const lowerBound = Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth));
  const upperBound = Math.ceil(Math.min(maxX, scale.domain()[1] - minX - epsilon3) / tileWidth);
  let tileRange = range$1(lowerBound, upperBound);
  if (tileRange.length > MAX_TILES) {
    console.warn(`Too many visible tiles: ${tileRange.length} truncating to ${MAX_TILES}`);
    tileRange = tileRange.slice(0, MAX_TILES);
  }
  return tileRange;
};
const calculate1DVisibleTiles = (tilesetInfo, scale) => {
  if (!tilesetInfo) {
    return [];
  }
  const zoomLevel = calculate1DZoomLevel(tilesetInfo, scale, tilesetInfo.max_zoom);
  if (tilesetInfo.resolutions) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    const xTiles2 = calculateTilesFromResolution(sortedResolutions[zoomLevel], scale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0]);
    const tiles2 = xTiles2.map((x) => [zoomLevel, x]);
    return tiles2;
  }
  const xTiles = calculateTiles(zoomLevel, scale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0], tilesetInfo.max_zoom, tilesetInfo.max_width);
  const tiles = xTiles.map((x) => [zoomLevel, x]);
  return tiles;
};
const drawAxis = (track, valueScale) => {
  if (!track.axis) {
    track.axis = new AxisPixi(track);
    track.pBase.addChild(track.axis.pAxis);
  }
  if (!track.options.axisPositionVertical && !track.options.axisPositionHorizontal) {
    track.axis.clearAxis();
    return;
  }
  if (track.options.axisPositionVertical && track.options.axisPositionVertical === "hidden") {
    track.axis.clearAxis();
    return;
  }
  if (track.options.axisPositionHorizontal && track.options.axisPositionHorizontal === "hidden") {
    track.axis.clearAxis();
    return;
  }
  const margin = track.options.axisMargin || 0;
  if (track.options.axisPositionHorizontal === "left" || track.options.axisPositionVertical === "top") {
    track.axis.pAxis.position.x = track.position[0] + margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisRight(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "outsideLeft" || track.options.axisPositionVertical === "outsideTop") {
    track.axis.pAxis.position.x = track.position[0] + margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisLeft(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "right" || track.options.axisPositionVertical === "bottom") {
    track.axis.pAxis.position.x = track.position[0] + track.dimensions[0] - margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisLeft(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "outsideRight" || track.options.axisPositionVertical === "outsideBottom") {
    track.axis.pAxis.position.x = track.position[0] + track.dimensions[0] - margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisRight(valueScale, track.dimensions[1]);
  }
};
const movedY = (track, dY) => {
  const vst = track.valueScaleTransform;
  const {
    y,
    k
  } = vst;
  const height2 = track.dimensions[1];
  if (y + dY / k > -(k - 1) * height2 && y + dY / k < 0) {
    track.valueScaleTransform = vst.translate(0, dY / k);
  }
  Object.values(track.fetchedTiles).forEach((tile) => {
    tile.graphics.position.y = track.valueScaleTransform.y;
  });
  track.animate();
};
const zoomedY = (yPos, kMultiplier, transform3, height2) => {
  const k0 = transform3.k;
  const t02 = transform3.y;
  const dp = (yPos - t02) / k0;
  const k1 = Math.max(k0 / kMultiplier, 1);
  let t12 = k0 * dp + t02 - k1 * dp;
  t12 = Math.max(t12, -(k1 - 1) * height2);
  t12 = Math.min(t12, 0);
  return identity$4.translate(0, t12).scale(k1);
};
const getTilePosAndDimensions = (tilesetInfo, tileId) => {
  const zoomLevel = +tileId.split(".")[0];
  const xTilePos = +tileId.split(".")[1];
  const totalWidth = tilesetInfo.max_width;
  const minX = tilesetInfo.min_pos[0];
  const tileWidth = totalWidth / 2 ** zoomLevel;
  const tileX = minX + xTilePos * tileWidth;
  return {
    tileX,
    tileWidth
  };
};
function stretchRects(track, graphicsAccessors) {
  Object.values(track.fetchedTiles).forEach((tile) => {
    if (!tile.drawnAtScale)
      return;
    const dasRange = tile.drawnAtScale.range();
    const tRange = track._xScale.range();
    if (dasRange[0] !== tRange[0] || dasRange[1] !== tRange[1]) {
      track.renderTile(tile);
      return;
    }
    const tileK = (tile.drawnAtScale.domain()[1] - tile.drawnAtScale.domain()[0]) / (track._xScale.domain()[1] - track._xScale.domain()[0]);
    if (tileK > 2 || tileK < 0.5) {
      track.renderTile(tile);
    } else {
      const newRange = track._xScale.domain().map(tile.drawnAtScale);
      const posOffset = newRange[0];
      for (const graphicsAccessor of graphicsAccessors) {
        try {
          graphicsAccessor(tile).scale.x = tileK;
          graphicsAccessor(tile).x = -posOffset * tileK;
        } catch (err2) {
        }
      }
    }
  });
}
const trackUtils = {
  calculate1DVisibleTiles,
  calculate1DZoomLevel,
  drawAxis,
  movedY,
  getTilePosAndDimensions,
  stretchRects,
  zoomedY
};
const utils$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DenseDataExtrema1D,
  DenseDataExtrema2D,
  IS_TRACK_RANGE_SELECTABLE,
  absToChr,
  accessorTransposition,
  addArrays,
  addClass: addClass$1,
  base64ToCanvas,
  changeOptions,
  chrToAbs,
  chromInfoBisector,
  cloneEvent,
  colorDomainToRgbaArray,
  colorToHex,
  colorToRgba,
  dataToGenomicLoci,
  debounce: debounce$1,
  decToHexStr,
  dictFromTuples,
  dictItems,
  dictKeys,
  dictValues,
  download,
  expandCombinedTracks,
  fillInMinWidths,
  flatten: flatten$1,
  forEach: forEach$2,
  forwardEvent,
  genomeLociToPixels,
  genomicRangeToChromosomeChunks,
  getAggregationFunction,
  getDefaultTrackForDatatype,
  getElementDim,
  getTiledPlot,
  getTrackByUid,
  getTrackConfFromHGC,
  getTrackObjById,
  getTrackObjectFromHGC,
  getTrackPositionByUid,
  getTrackRenderer,
  getXylofon,
  gradient,
  hasClass: hasClass$1,
  hasParent,
  hexStrToInt,
  intoTheVoid,
  isTrackOrChildTrack,
  isWithin,
  latToY,
  lngToX,
  loadChromInfos,
  map: map$5,
  max: max$1,
  maxNonZero,
  min,
  minNonZero,
  mod,
  mountHGComponent,
  mountHGComponentAsync,
  ndarrayAssign,
  ndarrayFlatten,
  ndarrayToList,
  numericifyVersion,
  objVals,
  or,
  parseChromsizesRows,
  pixiTextToSvg,
  q: q$1,
  rangeQuery2d,
  reduce,
  relToAbsChromPos,
  removeClass: removeClass$1,
  removeHGComponent,
  resetD3BrushStyle,
  rgbToHex: rgbToHex$1,
  scalesCenterAndK,
  scalesToGenomeLoci,
  segmentsToRows,
  selectedItemsToSize,
  showMousePosition: setupShowMousePosition,
  some,
  sum,
  svgLine,
  throttleAndDebounce,
  tileToCanvas,
  timeout: timeout$2,
  toVoid,
  totalTrackPixelHeight,
  trackUtils,
  trimTrailingSlash,
  valueToColor,
  visitPositionedTracks,
  visitTracks,
  waitForJsonComplete,
  waitForTilesLoaded,
  waitForTransitionsFinished
}, Symbol.toStringTag, { value: "Module" }));
function _extends$m() {
  _extends$m = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$m.apply(this, arguments);
}
const {
  Provider: Provider$2,
  Consumer: Consumer$2
} = /* @__PURE__ */ React$3.createContext({
  close: toVoid,
  open: toVoid
});
const withTheme = (Component2) => /* @__PURE__ */ React$3.forwardRef((props, ref2) => /* @__PURE__ */ React$3.createElement(Consumer$2, null, (theme) => /* @__PURE__ */ React$3.createElement(Component2, _extends$m({
  ref: ref2
}, props, {
  theme
}))));
const classes$a = {
  "track-control": "_track-control_w7hx2_1",
  "track-control-vertical": "_track-control-vertical_w7hx2_2",
  "track-control-dark": "_track-control-dark_w7hx2_15",
  "track-control-active": "_track-control-active_w7hx2_16 _track-control_w7hx2_1",
  "track-control-left": "_track-control-left_w7hx2_24",
  "track-control-vertical-active": "_track-control-vertical-active_w7hx2_30",
  "track-control-padding-right": "_track-control-padding-right_w7hx2_48",
  "track-control-button": "_track-control-button_w7hx2_52",
  "track-control-button-vertical": "_track-control-button-vertical_w7hx2_81"
};
const getClassName = (props) => clsx({
  [classes$a["track-control-active"]]: props.isVisible,
  [classes$a["track-control"]]: !props.isVisible,
  [classes$a["track-control-left"]]: props.isAlignLeft,
  [classes$a["track-control-vertical"]]: props.isVertical,
  [classes$a["track-control-padding-right"]]: props.paddingRight,
  [classes$a["track-control-dark"]]: props.theme === THEME_DARK
});
const getButtonClassName = (props) => clsx("no-zoom", classes$a["track-control-button"], {
  [classes$a["track-control-button-vertical"]]: props.isVertical
});
let oldProps = null;
let DragHandle = null;
function TrackControl(props) {
  if (!props || !oldProps || Object.keys(props).some((key) => oldProps[key] !== props[key])) {
    oldProps = props;
    DragHandle = sortableHandle(() => /* @__PURE__ */ React$3.createElement("svg", {
      className: getButtonClassName(props),
      style: {
        height: "20px",
        width: "20px",
        ...props.imgStyleMove
      }
    }, /* @__PURE__ */ React$3.createElement("title", null, "Move track"), /* @__PURE__ */ React$3.createElement("use", {
      xlinkHref: "#move"
    })));
  }
  let imgConfig;
  let imgClose;
  return /* @__PURE__ */ React$3.createElement("div", {
    className: getClassName(props)
  }, props.isMoveable && /* @__PURE__ */ React$3.createElement(DragHandle, null), /* @__PURE__ */ React$3.createElement("svg", {
    ref: (c2) => {
      imgConfig = c2;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onConfigTrackMenuOpened(props.uid, imgConfig.getBoundingClientRect());
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleSettings
    }
  }, /* @__PURE__ */ React$3.createElement("title", null, "Configure track"), /* @__PURE__ */ React$3.createElement("use", {
    xlinkHref: "#cog"
  })), props.onAddSeries && /* @__PURE__ */ React$3.createElement("svg", {
    className: getButtonClassName(props),
    onClick: () => props.onAddSeries(props.uid),
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleAdd
    }
  }, /* @__PURE__ */ React$3.createElement("title", null, "Add series"), /* @__PURE__ */ React$3.createElement("use", {
    xlinkHref: "#plus"
  })), /* @__PURE__ */ React$3.createElement("svg", {
    ref: (c2) => {
      imgClose = c2;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onCloseTrackMenuOpened(props.uid, imgClose.getBoundingClientRect());
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleClose
    }
  }, /* @__PURE__ */ React$3.createElement("title", null, "Close track"), /* @__PURE__ */ React$3.createElement("use", {
    xlinkHref: "#cross"
  })));
}
TrackControl.propTypes = {
  imgStyleAdd: PropTypes.object,
  imgStyleClose: PropTypes.object,
  imgStyleMove: PropTypes.object,
  imgStyleSettings: PropTypes.object,
  isAlignLeft: PropTypes.bool,
  isMoveable: PropTypes.bool,
  isVertical: PropTypes.bool,
  isVisible: PropTypes.bool,
  onConfigTrackMenuOpened: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onAddSeries: PropTypes.func,
  paddingRight: PropTypes.bool,
  theme: PropTypes.symbol.isRequired,
  uid: PropTypes.string
};
const TrackControl$1 = withTheme(TrackControl);
const stylesCenterTrack = {
  "center-track": "_center-track_fiu64_1",
  "center-track-container": "_center-track-container_fiu64_6"
};
const stylesTrack = {
  "track-range-selection": "_track-range-selection_5bcsr_1",
  "track-range-selection-active": "_track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-active-primary": "_track-range-selection-active-primary_5bcsr_14 _track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-active-secondary": "_track-range-selection-active-secondary_5bcsr_18 _track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-group-inactive": "_track-range-selection-group-inactive_5bcsr_22",
  "track-range-selection-group-brush-selection": "_track-range-selection-group-brush-selection_5bcsr_26"
};
function _classCallCheck$1y(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1n(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1n(descriptor.key), descriptor);
  }
}
function _createClass$1w(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1n(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1n(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1n(arg) {
  var key = _toPrimitive$1n(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1n(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1q(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1f(subClass, superClass);
}
function _setPrototypeOf$1f(o, p) {
  _setPrototypeOf$1f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1f(o, p);
}
function _createSuper$1f(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1f();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1f(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1f(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1q(this, result);
  };
}
function _possibleConstructorReturn$1q(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1f(self2);
}
function _assertThisInitialized$1f(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1f() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1f(o) {
  _getPrototypeOf$1f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1f(o);
}
const STYLES$3 = {
  pointerEvents: "all"
};
function sourceEvent$2(event) {
  return event && event.sourceEvent;
}
let CenterTrack = /* @__PURE__ */ function(_React$Component) {
  _inherits$1q(CenterTrack2, _React$Component);
  var _super = _createSuper$1f(CenterTrack2);
  function CenterTrack2(props) {
    var _this;
    _classCallCheck$1y(this, CenterTrack2);
    _this = _super.call(this, props);
    _this.state = {
      isVisible: false
    };
    _this.brushBehaviorX = brushX().on("brush", _this.brushedX.bind(_assertThisInitialized$1f(_this))).on("end", _this.brushedXEnded.bind(_assertThisInitialized$1f(_this)));
    _this.brushBehaviorY = brushY().on("brush", _this.brushedY.bind(_assertThisInitialized$1f(_this))).on("end", _this.brushedYEnded.bind(_assertThisInitialized$1f(_this)));
    _this.brushBehaviorXY = brush().on("start", _this.brushStarted.bind(_assertThisInitialized$1f(_this))).on("brush", _this.brushedXY.bind(_assertThisInitialized$1f(_this))).on("end", _this.brushedXYEnded.bind(_assertThisInitialized$1f(_this)));
    return _this;
  }
  _createClass$1w(CenterTrack2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush2d();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggeredXY) {
        this.rangeSelectionTriggeredXY = false;
        if (this.rangeSelectionTriggeredXYEnd) {
          const dim1 = nextProps.rangeSelection[0] || null;
          this.moveBrushXY([dim1, nextProps.rangeSelection[1]], true);
          this.rangeSelectionTriggeredXYEnd = false;
        }
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        const dim1 = nextProps.rangeSelection[0] || null;
        if (this.props.is1dRangeSelection) {
          if (!this.rangeSelectionTriggeredX) {
            this.moveBrushX(dim1, nextProps.rangeSelectionEnd);
          }
          if (this.rangeSelectionTriggeredXEnd) {
            this.moveBrushX(dim1, nextProps.rangeSelectionEnd, true);
          }
          if (!this.rangeSelectionTriggeredY) {
            this.moveBrushY(dim1, nextProps.rangeSelectionEnd);
          }
          if (this.rangeSelectionTriggeredYEnd) {
            this.moveBrushY(dim1, nextProps.rangeSelectionEnd, true);
          }
          this.rangeSelectionTriggeredX = false;
          this.rangeSelectionTriggeredXEnd = false;
          this.rangeSelectionTriggeredY = false;
          this.rangeSelectionTriggeredYEnd = false;
        } else {
          this.moveBrushXY([dim1, nextProps.rangeSelection[1]], nextProps.rangeSelectionEnd);
        }
        const isUnset = this.props.is1dRangeSelection && !nextProps.is1dRangeSelection && dim1 === null;
        return this.state !== nextState || isUnset;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush2d();
      } else {
        this.removeBrush1d();
        this.removeBrush2d();
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush1d",
    value: function addBrush1d() {
      if (!this.brushElX || !this.brushElY || this.brushElXOld === this.brushElX && this.brushElYOld === this.brushElY) {
        return;
      }
      if (this.brushElXOld) {
        this.brushElXOld.on(".brush", null);
      }
      if (this.brushElYOld) {
        this.brushElYOld.on(".brush", null);
      }
      this.brushElX.call(this.brushBehaviorX);
      this.brushElY.call(this.brushBehaviorY);
      resetD3BrushStyle(this.brushElX, stylesTrack["track-range-selection-group-brush-selection"]);
      resetD3BrushStyle(this.brushElY, stylesTrack["track-range-selection-group-brush-selection"]);
      this.brushElXOld = this.brushElX;
      this.brushElYOld = this.brushElY;
      this.brushIs1dBound = true;
    }
  }, {
    key: "addBrush2d",
    value: function addBrush2d() {
      if (!this.brushElXY || this.brushElXYOld === this.brushElXY) {
        return;
      }
      if (this.brushElXYOld) {
        this.brushElXYOld.on(".brush", null);
      }
      this.brushElXY.call(this.brushBehaviorXY);
      this.brushElXYOld = this.brushElXY;
      this.brushIs2dBound = true;
      resetD3BrushStyle(this.brushElXY, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushedX",
    value: function brushedX(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionX || !this.props.is1dRangeSelection || rangeSelectionMoved)
        return;
      this.rangeSelectionTriggeredX = true;
      this.props.onRangeSelectionX(event.selection);
    }
  }, {
    key: "brushedXEnded",
    value: function brushedXEnded(event) {
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionX || !this.props.is1dRangeSelection || rangeSelectionMovedEnd)
        return;
      this.rangeSelectionTriggeredX = true;
      this.rangeSelectionTriggeredXEnd = true;
      this.props.onRangeSelectionXEnd(event.selection);
    }
  }, {
    key: "brushedY",
    value: function brushedY(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionY || !this.props.is1dRangeSelection || rangeSelectionMoved)
        return;
      this.rangeSelectionTriggeredY = true;
      this.props.onRangeSelectionY(event.selection);
    }
  }, {
    key: "brushedYEnded",
    value: function brushedYEnded(event) {
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionY || !this.props.is1dRangeSelection || rangeSelectionMovedEnd)
        return;
      this.rangeSelectionTriggeredY = true;
      this.rangeSelectionTriggeredYEnd = true;
      this.props.onRangeSelectionYEnd(event.selection);
    }
  }, {
    key: "brushedXY",
    value: function brushedXY(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionXY || rangeSelectionMoved || this.props.is1dRangeSelection)
        return;
      this.rangeSelectionTriggeredXY = true;
      this.props.onRangeSelectionXY([[event.selection[0][0], event.selection[1][0]], [event.selection[0][1], event.selection[1][1]]]);
    }
  }, {
    key: "brushedXYEnded",
    value: function brushedXYEnded(event) {
      if (this.props.is1dRangeSelection)
        return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelectionXY && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggeredXY = true;
        this.rangeSelectionTriggeredXYEnd = true;
        this.props.onRangeSelectionXYEnd([[event.selection[0][0], event.selection[1][0]], [event.selection[0][1], event.selection[1][1]]]);
      }
      if (!event.selection) {
        this.rangeSelectionTriggeredXY = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent$2(event))
        return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "moveBrushX",
    value: function moveBrushX(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      if (this.brushIs2dBound) {
        this.removeBrush2d();
        this.addBrush1d();
      }
      const relRangeX = rangeSelection ? [this.props.scaleX(rangeSelection[0]), this.props.scaleX(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElX.transition().call(this.brushBehaviorX.move, relRangeX);
      } else {
        this.brushElX.call(this.brushBehaviorX.move, relRangeX);
      }
    }
  }, {
    key: "moveBrushY",
    value: function moveBrushY(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      if (this.brushIs2dBound) {
        this.removeBrush2d();
        this.addBrush1d();
      }
      const relRangeY = rangeSelection ? [this.props.scaleY(rangeSelection[0]), this.props.scaleY(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElY.transition().call(this.brushBehaviorY.move, relRangeY);
      } else {
        this.brushElY.call(this.brushBehaviorY.move, relRangeY);
      }
    }
  }, {
    key: "moveBrushXY",
    value: function moveBrushXY(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = [[this.props.scaleX(rangeSelection[0][0]), this.props.scaleY(rangeSelection[1][0])], [this.props.scaleX(rangeSelection[0][1]), this.props.scaleY(rangeSelection[1][1])]];
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElXY.transition().call(this.brushBehaviorXY.move, relRange);
      } else {
        this.brushElXY.call(this.brushBehaviorXY.move, relRange);
      }
    }
  }, {
    key: "mouseEnterHandler",
    value: function mouseEnterHandler() {
      if (this.props.isRangeSelectionActive)
        return;
      this.setState({
        isVisible: true
      });
    }
  }, {
    key: "mouseLeaveHandler",
    value: function mouseLeaveHandler() {
      this.setState({
        isVisible: false
      });
    }
  }, {
    key: "removeBrush1d",
    value: function removeBrush1d() {
      if (!this.brushIs1dBound) {
        return;
      }
      if (this.brushElX) {
        this.brushElX.call(this.brushBehaviorX.move, null);
        this.brushElX.on(".brush", null);
      }
      if (this.brushElY) {
        this.brushElY.call(this.brushBehaviorY.move, null);
        this.brushElY.on(".brush", null);
      }
      this.brushIs1dBound = false;
    }
  }, {
    key: "removeBrush2d",
    value: function removeBrush2d() {
      if (!this.brushIs2dBound) {
        return;
      }
      if (this.brushElXY) {
        this.brushElXY.call(this.brushBehaviorXY.move, null);
        this.brushElXY.on(".brush", null);
        this.brushElXYOld = void 0;
        this.brushIs2dBound = false;
        if (!this.props.is1dRangeSelection)
          this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or, false);
      const menuClash = this.props.tracks.some((track) => {
        if (track.contents) {
          return track.contents.some((subTrack) => {
            if (subTrack.type === "heatmap") {
              return subTrack.options.colorbarPosition === "topRight";
            }
            return false;
          });
        }
        if (track.type === "heatmap") {
          return track.options.colorbarPosition === "topRight";
        }
        return false;
      });
      let rangeSelectorName = "track-range-selection";
      if (this.props.isRangeSelectionActive) {
        rangeSelectorName += this.props.is1dRangeSelection ? "-active-secondary" : "-active-primary";
      }
      const rangeSelectorGroup1dClass = clsx(!this.props.is1dRangeSelection && stylesTrack["track-range-selection-group-inactive"]);
      const rangeSelectorGroup2dClass = clsx(this.props.is1dRangeSelection && stylesTrack["track-range-selection-group-inactive"]);
      return /* @__PURE__ */ React$3.createElement("div", {
        className: clsx(this.props.className, stylesCenterTrack["center-track"]),
        onMouseEnter: this.mouseEnterHandler.bind(this),
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          height: this.props.height,
          width: this.props.width
        }
      }, isBrushable && /* @__PURE__ */ React$3.createElement("svg", {
        className: stylesTrack[rangeSelectorName],
        style: {
          height: this.props.height,
          width: this.props.width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ React$3.createElement("g", {
        ref: (el) => {
          this.brushElX = select$1(el);
        },
        className: rangeSelectorGroup1dClass
      }), /* @__PURE__ */ React$3.createElement("g", {
        ref: (el) => {
          this.brushElY = select$1(el);
        },
        className: rangeSelectorGroup1dClass
      }), /* @__PURE__ */ React$3.createElement("g", {
        ref: (el) => {
          this.brushElXY = select$1(el);
        },
        className: rangeSelectorGroup2dClass
      })), this.props.editable && // show track controls if config menu is visible or
      // mouse is within the bounds of the track
      /* @__PURE__ */ React$3.createElement(TrackControl$1, {
        imgStyleAdd: STYLES$3,
        imgStyleClose: STYLES$3,
        imgStyleMove: STYLES$3,
        imgStyleSettings: STYLES$3,
        isMoveable: false,
        isVisible: this.state.isVisible || this.props.uid === this.props.configTrackMenuId,
        onAddSeries: this.props.onAddSeries,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        paddingRight: menuClash,
        uid: this.props.uid
      }));
    }
  }]);
  return CenterTrack2;
}(React$3.Component);
CenterTrack.defaultProps = {
  className: "center-track",
  configTrackMenuId: null,
  is1dRangeSelection: false,
  rangeSelectionEnd: PropTypes.bool,
  isRangeSelectionActive: false,
  scaleX: (x) => x,
  scaleY: (x) => x
};
CenterTrack.propTypes = {
  className: PropTypes.string,
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  height: PropTypes.number.isRequired,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  onAddSeries: PropTypes.func.isRequired,
  onCloseTrackMenuOpened: PropTypes.func.isRequired,
  onConfigTrackMenuOpened: PropTypes.func.isRequired,
  onRangeSelectionX: PropTypes.func.isRequired,
  onRangeSelectionXEnd: PropTypes.func.isRequired,
  onRangeSelectionY: PropTypes.func.isRequired,
  onRangeSelectionYEnd: PropTypes.func.isRequired,
  onRangeSelectionXY: PropTypes.func.isRequired,
  onRangeSelectionXYEnd: PropTypes.func.isRequired,
  onRangeSelectionReset: PropTypes.func.isRequired,
  onRangeSelectionStart: PropTypes.func.isRequired,
  rangeSelection: PropTypes.array.isRequired,
  rangeSelectionEnd: PropTypes.bool,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func,
  tracks: PropTypes.array.isRequired,
  uid: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired
};
const fakePubSub = {
  __fake__: true,
  publish: () => {
  },
  subscribe: () => ({
    event: "",
    handler: () => {
    }
  }),
  unsubscribe: () => {
  },
  clear: () => {
  }
};
const {
  Provider: Provider$1,
  Consumer: Consumer$1
} = /* @__PURE__ */ React$3.createContext(fakePubSub);
function withPubSub(Component2) {
  return /* @__PURE__ */ React$3.forwardRef((props, ref2) => /* @__PURE__ */ React$3.createElement(Consumer$1, null, (pubSub) => /* @__PURE__ */ React$3.createElement(Component2, {
    ref: ref2,
    ...props,
    pubSub
  })));
}
const classes$9 = {
  "drag-listening-div-active": "_drag-listening-div-active_19gkt_1"
};
function _classCallCheck$1x(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1m(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1m(descriptor.key), descriptor);
  }
}
function _createClass$1v(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1m(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1m(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1m(arg) {
  var key = _toPrimitive$1m(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1m(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1p(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1e(subClass, superClass);
}
function _setPrototypeOf$1e(o, p) {
  _setPrototypeOf$1e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1e(o, p);
}
function _createSuper$1e(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1e();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1e(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1e(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1p(this, result);
  };
}
function _possibleConstructorReturn$1p(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1e(self2);
}
function _assertThisInitialized$1e(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1e() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1e(o) {
  _getPrototypeOf$1e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1e(o);
}
let DragListeningDiv = /* @__PURE__ */ function(_React$Component) {
  _inherits$1p(DragListeningDiv2, _React$Component);
  var _super = _createSuper$1e(DragListeningDiv2);
  function DragListeningDiv2(props) {
    var _this;
    _classCallCheck$1x(this, DragListeningDiv2);
    _this = _super.call(this, props);
    _this.state = {
      dragOnTop: false
    };
    return _this;
  }
  _createClass$1v(DragListeningDiv2, [{
    key: "render",
    value: function render3() {
      let background = "red";
      if (this.props.enabled && this.state.dragOnTop) {
        background = "green";
      } else if (this.props.enabled) {
        background = "blue";
      }
      return /* @__PURE__ */ React$3.createElement("div", {
        className: clsx("DragListeningDiv", {
          [classes$9["drag-listening-div-active"]]: this.props.enabled
        }),
        onDragEnter: () => {
          this.setState({
            dragOnTop: true
          });
        },
        onDragLeave: () => {
          this.setState({
            dragOnTop: false
          });
        },
        onDragOver: (evt) => {
          evt.preventDefault();
        },
        onDrop: () => {
          if (!this.props.enabled)
            return;
          const evtJson = this.props.draggingHappening;
          const newTrack = {
            type: this.props.defaultTrackType,
            uid: slugid$1.nice(),
            tilesetUid: evtJson.tilesetUid,
            server: evtJson.server
          };
          this.props.onTrackDropped(newTrack);
          this.props.pubSub.publish("trackDropped", newTrack);
        },
        style: {
          background,
          opacity: 0.6,
          ...this.props.style
        }
      });
    }
  }]);
  return DragListeningDiv2;
}(React$3.Component);
DragListeningDiv.defaultProps = {
  enabled: false,
  style: {},
  draggingHappening: {},
  onTrackDropped: () => {
  }
};
DragListeningDiv.propTypes = {
  enabled: PropTypes.bool,
  style: PropTypes.object,
  defaultTrackType: PropTypes.object,
  draggingHappening: PropTypes.object,
  onTrackDropped: PropTypes.func,
  position: PropTypes.string.isRequired,
  pubSub: PropTypes.object.isRequired
};
const DragListeningDiv$1 = withPubSub(DragListeningDiv);
const styles$6 = {
  "gallery-tracks": "_gallery-tracks_fbxxi_1",
  "gallery-track": "_gallery-track_fbxxi_1",
  "gallery-sub-track": "_gallery-sub-track_fbxxi_18",
  "gallery-invisible-track": "_gallery-invisible-track_fbxxi_19"
};
const horizontalList = "_horizontalList_1y7td_7";
const list = "_list_1y7td_14";
const stylizedList = "_stylizedList_1y7td_21";
const stylizedItem = "_stylizedItem_1y7td_28";
const stylizedHelper = "_stylizedHelper_1y7td_39";
const horizontalItem = "_horizontalItem_1y7td_44";
const domain = "_domain_1y7td_60";
const styles$5 = {
  "tiled-plot": "_tiled-plot_1y7td_1",
  horizontalList,
  list,
  stylizedList,
  stylizedItem,
  stylizedHelper,
  horizontalItem,
  "resizable-track": "_resizable-track_1y7td_55",
  domain
};
function _classCallCheck$1w(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1l(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1l(descriptor.key), descriptor);
  }
}
function _createClass$1u(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1l(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1l(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1l(arg) {
  var key = _toPrimitive$1l(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1l(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1o(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1d(subClass, superClass);
}
function _setPrototypeOf$1d(o, p) {
  _setPrototypeOf$1d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1d(o, p);
}
function _createSuper$1d(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1d();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1d(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1d(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1o(this, result);
  };
}
function _possibleConstructorReturn$1o(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1d(self2);
}
function _assertThisInitialized$1d(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1d() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1d(o) {
  _getPrototypeOf$1d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1d(o);
}
const STYLES$2 = {
  pointerEvents: "all"
};
let GalleryTracks = /* @__PURE__ */ function(_React$Component) {
  _inherits$1o(GalleryTracks2, _React$Component);
  var _super = _createSuper$1d(GalleryTracks2);
  function GalleryTracks2(props) {
    var _this;
    _classCallCheck$1w(this, GalleryTracks2);
    _this = _super.call(this, props);
    _this.state = {
      hovering: false
    };
    return _this;
  }
  _createClass$1u(GalleryTracks2, [{
    key: "mouseEnterHandler",
    value: function mouseEnterHandler() {
      this.setState({
        hovering: true
      });
    }
  }, {
    key: "mouseLeaveHandler",
    value: function mouseLeaveHandler() {
      this.setState({
        hovering: false
      });
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        className: clsx("gallery-tracks", styles$6["gallery-tracks"])
      }, this.props.tracks && this.props.tracks.map((track, index2) => /* @__PURE__ */ React$3.createElement("div", {
        key: track.uid || index2,
        className: styles$6["gallery-track"],
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          top: track.height * index2,
          right: track.height * index2,
          bottom: track.height * index2,
          left: track.height * index2
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: styles$6["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          right: 0,
          left: 0,
          height: track.height
        }
      }), /* @__PURE__ */ React$3.createElement("div", {
        className: styles$6["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          right: 0,
          bottom: 0,
          width: track.height
        }
      }), /* @__PURE__ */ React$3.createElement("div", {
        className: styles$6["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          right: 0,
          bottom: 0,
          left: 0,
          height: track.height
        }
      }), /* @__PURE__ */ React$3.createElement("div", {
        className: styles$6["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          bottom: 0,
          left: 0,
          width: track.height
        }
      }), /* @__PURE__ */ React$3.createElement("div", {
        className: styles$6["gallery-invisible-track"],
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          top: track.height,
          right: track.height,
          bottom: track.height,
          left: track.height
        }
      }), this.props.editable && /* @__PURE__ */ React$3.createElement(TrackControl$1, {
        configMenuVisible: true,
        imgStyleAdd: STYLES$2,
        imgStyleClose: STYLES$2,
        imgStyleMove: STYLES$2,
        imgStyleSettings: STYLES$2,
        isMoveable: false,
        isVisible: this.state.hovering,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        uid: track.uid || index2
      }))));
    }
  }]);
  return GalleryTracks2;
}(React$3.Component);
GalleryTracks.propTypes = {
  editable: PropTypes.bool,
  onCloseTrackMenuOpened: PropTypes.func.isRequired,
  onConfigTrackMenuOpened: PropTypes.func.isRequired,
  tracks: PropTypes.array
};
function _classCallCheck$1v(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1k(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1k(descriptor.key), descriptor);
  }
}
function _createClass$1t(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1k(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1k(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1k(arg) {
  var key = _toPrimitive$1k(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1k(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let Track = /* @__PURE__ */ function() {
  function Track2(context, options2) {
    _classCallCheck$1v(this, Track2);
    this.context = context;
    const {
      id: id2,
      pubSub,
      getTheme
    } = context;
    this.pubSub = pubSub ?? fakePubSub;
    this.id = id2;
    this._xScale = linear();
    this._yScale = linear();
    this._refXScale = linear();
    this._refYScale = linear();
    this.position = [0, 0];
    this.dimensions = [1, 1];
    this.options = options2;
    this.pubSubs = [];
    this.getTheme = getTheme ?? (() => void 0);
    this.pubSubs.push(this.pubSub.subscribe("app.mouseMove", this.defaultMouseMoveHandler.bind(this)));
    this.isLeftModified = false;
  }
  _createClass$1t(Track2, [{
    key: "isWithin",
    value: function isWithin$1(x, y) {
      let xx = x;
      let yy = y;
      let left2 = this.position[0];
      let top2 = this.position[1];
      if (this.isLeftModified) {
        xx = y;
        yy = x;
        left2 = this.position[1];
        top2 = this.position[0];
      }
      return isWithin(xx, yy, left2, this.dimensions[0] + left2, top2, this.dimensions[1] + top2);
    }
    /**
     * Get a property from the track.
     * @template {keyof this} T
     * @param {T} prop - The property to get.
     * @return {() => this[T]}
     */
  }, {
    key: "getProp",
    value: function getProp2(prop2) {
      return () => this[prop2];
    }
  }, {
    key: "getData",
    value: function getData3() {
    }
    /**
     * Capture click events. x and y are relative to the track position
     * @template T
     * @param {number} x - X position of the click event.
     * @param {number} y - Y position of the click event.
     * @param {T} evt - The event.
     * @return {{ type: 'generic', event: T, payload: null }}
     */
  }, {
    key: "click",
    value: function click(x, y, evt) {
      return {
        type: "generic",
        event: evt,
        payload: null
      };
    }
    /** There was a click event outside the track * */
  }, {
    key: "clickOutside",
    value: function clickOutside() {
    }
    /** @returns {[number, number]} */
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return this.dimensions;
    }
    /** @param {[number, number]} newDimensions */
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      this._xScale.range([0, this.dimensions[0]]);
      this._yScale.range([0, this.dimensions[1]]);
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the reference xScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "refXScale",
    value: function refXScale(scale) {
      if (!scale)
        return this._refXScale;
      this._refXScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the reference yScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "refYScale",
    value: function refYScale(scale) {
      if (!scale)
        return this._refYScale;
      this._refYScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the xScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "xScale",
    value: function xScale(scale) {
      if (!scale)
        return this._xScale;
      this._xScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the yScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "yScale",
    value: function yScale(scale) {
      if (!scale)
        return this._yScale;
      this._yScale = scale;
      return this;
    }
    /**
     * @param {import('./types').Scale} newXScale
     * @param {import('./types').Scale} newYScale
     * @returns {void}
     */
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
    }
    /**
     * @param {import('./types').Scale} refXScale
     * @param {import('./types').Scale} refYScale
     * @returns {void}
     */
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      this._refXScale = refXScale;
      this._refYScale = refYScale;
    }
    /** @returns {void} */
  }, {
    key: "draw",
    value: function draw() {
    }
    /** @returns {[number, number]} */
  }, {
    key: "getPosition",
    value: function getPosition2() {
      return this.position;
    }
    /**
     * @param {[number, number]} newPosition
     * @returns {void}
     */
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
    }
    /**
     * A blank handler for MouseMove / Zoom events. Should be overriden
     * by individual tracks to provide
     *
     * @param {{}} evt
     * @returns {void}
     */
  }, {
    key: "defaultMouseMoveHandler",
    value: function defaultMouseMoveHandler(evt) {
    }
    /** @returns {void} */
  }, {
    key: "remove",
    value: function remove3() {
      this.pubSubs.forEach((subscription) => this.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
    }
    /**
     * @param {Options} options
     * @returns {void}
     */
  }, {
    key: "rerender",
    value: function rerender(options2) {
    }
    /**
     * This function is for seeing whether this track should respond
     * to events at this mouse position. The difference to `isWithin()` is that it
     * can be overwritten if a track is inactive for example.
     *
     * @param {number} x - X position to be tested.
     * @param {number} y - Y position to be tested.
     * @returns {boolean}
     */
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return this.isWithin(x, y);
    }
    /**
     * @param {number} trackY
     * @param {number} kMultiplier
     * @returns {void}
     */
  }, {
    key: "zoomedY",
    value: function zoomedY2(trackY, kMultiplier) {
    }
    /**
     * @param {number} dY
     * @returns {void}
     */
  }, {
    key: "movedY",
    value: function movedY2(dY) {
    }
  }]);
  return Track2;
}();
function _classCallCheck$1u(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1j(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1j(descriptor.key), descriptor);
  }
}
function _createClass$1s(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1j(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1j(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1j(arg) {
  var key = _toPrimitive$1j(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1j(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$D() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$D = Reflect.get.bind();
  } else {
    _get$D = function _get2(target, property2, receiver) {
      var base = _superPropBase$D(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$D.apply(this, arguments);
}
function _superPropBase$D(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$1c(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1n(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1c(subClass, superClass);
}
function _setPrototypeOf$1c(o, p) {
  _setPrototypeOf$1c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1c(o, p);
}
function _createSuper$1c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1c();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1c(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1c(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1n(this, result);
  };
}
function _possibleConstructorReturn$1n(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1c(self2);
}
function _assertThisInitialized$1c(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1c() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1c(o) {
  _getPrototypeOf$1c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1c(o);
}
function formatResolutionText(resolution, maxResolutionSize) {
  const pp = precisionPrefix(maxResolutionSize, resolution);
  const f2 = formatPrefix(`.${pp}`, resolution);
  const formattedResolution = f2(resolution);
  return formattedResolution;
}
function getResolutionBasedResolutionText(resolutions, zoomLevel) {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const resolution = sortedResolutions[zoomLevel];
  const maxResolutionSize = sortedResolutions[sortedResolutions.length - 1];
  return formatResolutionText(resolution, maxResolutionSize);
}
function getWidthBasedResolutionText(zoomLevel, maxWidth, binsPerDimension, maxZoom) {
  const resolution = maxWidth / (2 ** zoomLevel * binsPerDimension);
  if (!Number.isNaN(resolution)) {
    const maxResolutionSize = maxWidth / (2 ** maxZoom * binsPerDimension);
    const pp = precisionPrefix(maxResolutionSize, resolution);
    const f2 = formatPrefix(`.${pp}`, resolution);
    const formattedResolution = f2(resolution);
    return formattedResolution;
  }
  console.warn("NaN resolution, screen is probably too small.");
  return "";
}
let PixiTrack = /* @__PURE__ */ function(_Track) {
  _inherits$1n(PixiTrack2, _Track);
  var _super = _createSuper$1c(PixiTrack2);
  function PixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1u(this, PixiTrack2);
    _this = _super.call(this, context, options2);
    const {
      scene
    } = context;
    _this.scene = scene;
    _this.delayDrawing = false;
    _this.pBase = new GLOBALS.PIXI.Graphics();
    _this.pMasked = new GLOBALS.PIXI.Graphics();
    _this.pMask = new GLOBALS.PIXI.Graphics();
    _this.pMain = new GLOBALS.PIXI.Graphics();
    _this.pBorder = new GLOBALS.PIXI.Graphics();
    _this.pBackground = new GLOBALS.PIXI.Graphics();
    _this.pForeground = new GLOBALS.PIXI.Graphics();
    _this.pLabel = new GLOBALS.PIXI.Graphics();
    _this.pMobile = new GLOBALS.PIXI.Graphics();
    _this.pAxis = new GLOBALS.PIXI.Graphics();
    _this.pMouseOver = new GLOBALS.PIXI.Graphics();
    _this.scene.addChild(_this.pBase);
    _this.pBase.addChild(_this.pMasked);
    _this.pMasked.addChild(_this.pBackground);
    _this.pMasked.addChild(_this.pMain);
    _this.pMasked.addChild(_this.pMask);
    _this.pMasked.addChild(_this.pMobile);
    _this.pMasked.addChild(_this.pBorder);
    _this.pMasked.addChild(_this.pLabel);
    _this.pMasked.addChild(_this.pForeground);
    _this.pMasked.addChild(_this.pMouseOver);
    _this.pBase.addChild(_this.pAxis);
    _this.pMasked.mask = _this.pMask;
    _this.prevOptions = "";
    _this.options = Object.assign(_this.options, options2);
    const labelTextText = _this.getName();
    _this.labelTextFontFamily = "Arial";
    _this.labelTextFontSize = 12;
    _this.labelXOffset = 0;
    _this.labelText = new GLOBALS.PIXI.Text(labelTextText, {
      fontSize: `${_this.labelTextFontSize}px`,
      fontFamily: _this.labelTextFontFamily,
      fill: "black"
    });
    _this.pLabel.addChild(_this.labelText);
    _this.errorText = new GLOBALS.PIXI.Text("", {
      fontSize: "12px",
      fontFamily: "Arial",
      fill: "red"
    });
    _this.errorText.anchor.x = 0.5;
    _this.errorText.anchor.y = 0.5;
    _this.pLabel.addChild(_this.errorText);
    _this.errorTextText = "";
    _this.flipText = false;
    _this.tilesetInfo = void 0;
    return _this;
  }
  _createClass$1s(PixiTrack2, [{
    key: "setLabelText",
    value: function setLabelText() {
    }
    /** @param {[number, number]} newPosition */
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.drawBorder();
      this.drawLabel();
      this.drawBackground();
      this.setMask(this.position, this.dimensions);
      this.setForeground();
    }
    /** @param {[number, number]} newDimensions */
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$D(_getPrototypeOf$1c(PixiTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.drawBorder();
      this.drawLabel();
      this.drawBackground();
      this.setMask(this.position, this.dimensions);
      this.setForeground();
    }
    /**
     * @param {[number, number]} position
     * @param {[number, number]} dimensions
     */
  }, {
    key: "setMask",
    value: function setMask(position, dimensions) {
      this.pMask.clear();
      this.pMask.beginFill();
      this.pMask.drawRect(position[0], position[1], dimensions[0], dimensions[1]);
      this.pMask.endFill();
    }
  }, {
    key: "setForeground",
    value: function setForeground() {
      this.pForeground.position.y = this.position[1];
      this.pForeground.position.x = this.position[0];
    }
    /**
     * We're going to destroy this object, so we need to detach its
     * graphics from the scene
     */
  }, {
    key: "remove",
    value: function remove3() {
      this.pBase.clear();
      this.scene.removeChild(this.pBase);
    }
    /**
     * Draw a border around each track.
     */
  }, {
    key: "drawBorder",
    value: function drawBorder() {
      const graphics = this.pBorder;
      if (!graphics || !graphics._geometry)
        return;
      graphics.clear();
      if (!this.options || !this.options.trackBorderWidth)
        return;
      const stroke = colorToHex(this.options.trackBorderColor ? this.options.trackBorderColor : "white");
      graphics.lineStyle(this.options.trackBorderWidth, stroke);
      graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
    }
  }, {
    key: "drawError",
    value: function drawError() {
      if (this && this.position && this.errorText && this.errorTextText && this.errorTextText.length) {
        this.errorText.x = this.position[0] + this.dimensions[0] / 2;
        this.errorText.y = this.position[1] + this.dimensions[1] / 2;
        this.errorText.text = this.errorTextText;
        const graphics = this.pBorder;
        if (!graphics || !graphics._geometry)
          return;
        graphics.clear();
        graphics.lineStyle(1, colorToHex("red"));
        graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
      } else {
        this.errorText.text = "";
        const graphics = this.pBorder;
        if (!graphics || !graphics._geometry)
          return;
        graphics.clear();
      }
    }
  }, {
    key: "drawBackground",
    value: function drawBackground() {
      const graphics = this.pBackground;
      if (!graphics || !graphics._geometry)
        return;
      graphics.clear();
      if (!this.options || !this.options.backgroundColor) {
        return;
      }
      let opacity = 1;
      let color2 = this.options.backgroundColor;
      if (this.options.backgroundColor === "transparent") {
        opacity = 0;
        color2 = "white";
      }
      const hexColor = colorToHex(color2);
      graphics.beginFill(hexColor, opacity);
      graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
    }
    /**
     * Determine the label color based on the number of options.
     *
     * @return {string} The color to use for the label.
     */
  }, {
    key: "getLabelColor",
    value: function getLabelColor() {
      if (this.options.labelColor && this.options.labelColor !== "[glyph-color]") {
        return this.options.labelColor;
      }
      return this.options.lineStrokeColor || this.options.barFillColor || "black";
    }
  }, {
    key: "getName",
    value: function getName3() {
      return this.options.name ? this.options.name : this.tilesetInfo && this.tilesetInfo.name || "";
    }
  }, {
    key: "drawLabel",
    value: function drawLabel() {
      if (!this.labelText)
        return;
      const graphics = this.pLabel;
      if (!graphics || !graphics._geometry)
        return;
      graphics.clear();
      if (!this.options || !this.options.labelPosition || this.options.labelPosition === "hidden") {
        this.labelText.alpha = 0;
        return;
      }
      const {
        labelBackgroundColor = "white",
        labelBackgroundOpacity = 0.5
      } = this.options;
      graphics.beginFill(colorToHex(labelBackgroundColor), +labelBackgroundOpacity);
      const fontColor = colorToHex(this.getLabelColor());
      const labelBackgroundMargin = 2;
      if (this.dimensions[0] < 0) {
        return;
      }
      let labelTextText = this.options.labelShowAssembly && this.tilesetInfo && this.tilesetInfo.coordSystem ? `${this.tilesetInfo.coordSystem} | ` : "";
      labelTextText += this.getName();
      if (this.options.labelShowResolution && isLegacyTilesetInfo(this.tilesetInfo) && this.tilesetInfo.bins_per_dimension) {
        const formattedResolution = getWidthBasedResolutionText(this.calculateZoomLevel(), this.tilesetInfo.max_width, this.tilesetInfo.bins_per_dimension, this.tilesetInfo.max_zoom);
        labelTextText += `
[Current data resolution: ${formattedResolution}]`;
      } else if (this.options.labelShowResolution && isResolutionsTilesetInfo(this.tilesetInfo)) {
        const formattedResolution = getResolutionBasedResolutionText(this.tilesetInfo.resolutions, this.calculateZoomLevel());
        labelTextText += `
[Current data resolution: ${formattedResolution}]`;
      }
      if (this.options && this.options.dataTransform) {
        let chosenTransform = null;
        if (this.tilesetInfo && this.tilesetInfo.transforms) {
          for (const transform3 of this.tilesetInfo.transforms) {
            if (transform3.value === this.options.dataTransform) {
              chosenTransform = transform3;
            }
          }
        }
        if (chosenTransform) {
          labelTextText += `
[Transform: ${chosenTransform.name}]`;
        } else if (this.options.dataTransform === "None") {
          labelTextText += "\n[Transform: None ]";
        } else {
          labelTextText += "\n[Transform: Default ]";
        }
      }
      this.labelText.text = labelTextText;
      this.labelText.style = {
        fontSize: `${this.labelTextFontSize}px`,
        fontFamily: this.labelTextFontFamily,
        fill: fontColor
      };
      this.labelText.alpha = typeof this.options.labelTextOpacity !== "undefined" ? this.options.labelTextOpacity : 1;
      this.labelText.visible = true;
      if (this.flipText) {
        this.labelText.scale.x = -1;
      }
      const {
        labelLeftMargin = 0,
        labelRightMargin = 0,
        labelTopMargin = 0,
        labelBottomMargin = 0
      } = this.options;
      if (this.options.labelPosition === "topLeft") {
        this.labelText.x = this.position[0] + labelLeftMargin + this.labelXOffset;
        this.labelText.y = this.position[1] + labelTopMargin;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0;
        this.labelText.x += this.labelText.width / 2;
        graphics.drawRect(this.position[0] + labelLeftMargin + this.labelXOffset, this.position[1] + labelTopMargin, this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "bottomLeft" && !this.flipText || this.options.labelPosition === "topRight" && this.flipText) {
        this.labelText.x = this.position[0] + (labelLeftMargin || labelTopMargin);
        this.labelText.y = this.position[1] + this.dimensions[1] - (labelBottomMargin || labelRightMargin);
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 1;
        this.labelText.x += this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + (labelLeftMargin || labelTopMargin) + this.labelXOffset, this.position[1] + this.dimensions[1] - this.labelText.height - labelBackgroundMargin - (labelBottomMargin || labelRightMargin), this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "topRight" && !this.flipText || this.options.labelPosition === "bottomLeft" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] - (labelRightMargin || labelBottomMargin);
        this.labelText.y = this.position[1] + (labelTopMargin || labelLeftMargin);
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0;
        this.labelText.x -= this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + this.dimensions[0] - this.labelText.width - labelBackgroundMargin - (labelRightMargin || labelBottomMargin) - this.labelXOffset, this.position[1] + (labelTopMargin || labelLeftMargin), this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "bottomRight") {
        this.labelText.x = this.position[0] + this.dimensions[0] - labelRightMargin;
        this.labelText.y = this.position[1] + this.dimensions[1] - labelBottomMargin;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 1;
        this.labelText.x -= this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + this.dimensions[0] - this.labelText.width - labelBackgroundMargin - labelRightMargin - this.labelXOffset, this.position[1] + this.dimensions[1] - this.labelText.height - labelBackgroundMargin - labelBottomMargin, this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "outerLeft" && !this.flipText || this.options.labelPosition === "outerTop" && this.flipText) {
        this.labelText.x = this.position[0];
        this.labelText.y = this.position[1] + this.dimensions[1] / 2;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.x -= this.labelText.width / 2 + 3;
      } else if (this.options.labelPosition === "outerTop" && !this.flipText || this.options.labelPosition === "outerLeft" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] / 2;
        this.labelText.y = this.position[1];
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.y -= this.labelText.height / 2 + 3;
      } else if (this.options.labelPosition === "outerBottom" && !this.flipText || this.options.labelPosition === "outerRight" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] / 2;
        this.labelText.y = this.position[1] + this.dimensions[1];
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.y += this.labelText.height / 2 + 3;
      } else if (this.options.labelPosition === "outerRight" && !this.flipText || this.options.labelPosition === "outerBottom" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0];
        this.labelText.y = this.position[1] + this.dimensions[1] / 2;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.x += this.labelText.width / 2 + 3;
      } else {
        this.labelText.visible = false;
      }
      if (this.options.labelPosition === "outerLeft" || this.options.labelPosition === "outerRight" || this.options.labelPosition === "outerTop" || this.options.labelPosition === "outerBottom") {
        this.pLabel.setParent(this.pBase);
      } else {
        this.pLabel.setParent(this.pMasked);
      }
    }
    /** @param {PixiTrackOptions} options */
  }, {
    key: "rerender",
    value: function rerender(options2) {
      this.options = options2;
      this.draw();
      this.drawBackground();
      this.drawLabel();
      this.drawError();
      this.drawBorder();
    }
    /**
     * Draw all the data associated with this track
     */
  }, {
    key: "draw",
    value: function draw() {
      this.drawError();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {[HTMLElement, HTMLElement]} The two returned DOM nodes are both SVG
     * elements [base, track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const gBase = document.createElement("g");
      const rectBackground = document.createElement("rect");
      rectBackground.setAttribute("x", `${this.position[0]}`);
      rectBackground.setAttribute("y", `${this.position[1]}`);
      rectBackground.setAttribute("width", `${this.dimensions[0]}`);
      rectBackground.setAttribute("height", `${this.dimensions[1]}`);
      if (this.options && this.options.backgroundColor) {
        rectBackground.setAttribute("fill", this.options.backgroundColor);
      } else {
        rectBackground.setAttribute("fill-opacity", "0");
      }
      const gClipped = document.createElement("g");
      gClipped.setAttribute("class", "g-clipped");
      gBase.appendChild(gClipped);
      gClipped.appendChild(rectBackground);
      const gTrack = document.createElement("g");
      gClipped.setAttribute("class", "g-track");
      gClipped.appendChild(gTrack);
      const gLabels = document.createElement("g");
      gClipped.setAttribute("class", "g-labels");
      gClipped.appendChild(gLabels);
      const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
      gBase.appendChild(clipPath);
      const clipPolygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      clipPath.appendChild(clipPolygon);
      clipPolygon.setAttribute("points", `${this.position[0]},${this.position[1]} ${this.position[0] + this.dimensions[0]},${this.position[1]} ${this.position[0] + this.dimensions[0]},${this.position[1] + this.dimensions[1]} ${this.position[0]},${this.position[1] + this.dimensions[1]} `);
      const clipPathId = slugid$1.nice();
      clipPath.setAttribute("id", clipPathId);
      gClipped.setAttribute("style", `clip-path:url(#${clipPathId});`);
      const lineParts = this.labelText.text.split("\n");
      let ddy = 0;
      const paddingBottom = 3;
      const labelTextHeight = (this.labelTextFontSize + 2) * lineParts.length + paddingBottom;
      if (this.labelText.anchor.y === 0.5) {
        ddy = labelTextHeight / 2;
      } else if (this.labelText.anchor.y === 1) {
        ddy = -labelTextHeight;
      }
      for (let i = 0; i < lineParts.length; i++) {
        const text2 = document.createElement("text");
        text2.setAttribute("font-family", this.labelTextFontFamily);
        text2.setAttribute("font-size", `${this.labelTextFontSize}px`);
        text2.innerText = lineParts[i];
        if (this.options.labelPosition === "topLeft" || this.options.labelPosition === "topRight") {
          const dy = ddy + (i + 1) * (this.labelTextFontSize + 2);
          text2.setAttribute("dy", String(dy));
        } else if (this.options.labelPosition === "bottomLeft" || this.options.labelPosition === "bottomRight") {
          text2.setAttribute("dy", String(ddy + i * (this.labelTextFontSize + 2)));
        }
        text2.setAttribute("fill", this.options.labelColor ?? "");
        if (this.labelText.anchor.x === 0.5) {
          text2.setAttribute("text-anchor", "middle");
        } else if (this.labelText.anchor.x === 1) {
          text2.setAttribute("text-anchor", "end");
        }
        gLabels.appendChild(text2);
      }
      gLabels.setAttribute("transform", `translate(${this.labelText.x},${this.labelText.y})scale(${this.labelText.scale.x},1)`);
      return [gBase, gTrack];
    }
    /**
     * @returns {number}
     */
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      throw new Error("Must be implemented by subclass");
    }
  }]);
  return PixiTrack2;
}(Track);
function _classCallCheck$1t(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1i(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1i(descriptor.key), descriptor);
  }
}
function _createClass$1r(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1i(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1i(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1i(arg) {
  var key = _toPrimitive$1i(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1i(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function isTuple(x) {
  return x.length === 2;
}
function createDefaultTileSource(pubSub) {
  return {
    fetchTiles(request2) {
      const ids = request2.tileIds;
      return new Promise((done, _reject) => {
        fetchTilesDebounced({
          ...request2,
          ids,
          done
        }, pubSub, true);
      });
    },
    fetchTilesetInfo({
      server,
      tilesetUid
    }) {
      return new Promise((resolve2, reject) => {
        trackInfo(server, tilesetUid, resolve2, reject, pubSub);
      });
    },
    registerTileset({
      server,
      url,
      filetype,
      coordSystem
    }) {
      const serverUrl = `${trimTrailingSlash(server)}/register_url/`;
      const payload = {
        fileurl: url,
        filetype,
        coordSystem
      };
      return fetch(serverUrl, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }
  };
}
let DataFetcher = /* @__PURE__ */ function() {
  function DataFetcher2(dataConfig, pubSub, tileSource) {
    _classCallCheck$1t(this, DataFetcher2);
    this.tileSource = tileSource || createDefaultTileSource(pubSub);
    this.tilesetInfoLoading = true;
    if (!dataConfig) {
      console.error("No dataconfig provided");
      return;
    }
    this.dataConfig = JSON.parse(JSON.stringify(dataConfig));
    this.uuid = slugid$1.nice();
    this.pubSub = pubSub;
    if (dataConfig.children) {
      this.dataConfig.children = dataConfig.children.map((c2) => new DataFetcher2(c2, pubSub));
    }
  }
  _createClass$1r(DataFetcher2, [{
    key: "registerFileUrl",
    value: async function registerFileUrl({
      server,
      url,
      filetype,
      coordSystem
    }) {
      return this.tileSource.registerTileset({
        server,
        url,
        filetype,
        coordSystem
      });
    }
    /**
     * Obtain tileset infos for all of the tilesets listed
     * @param {import('../types').HandleTilesetInfoFinished} finished - A callback that will be called
     */
  }, {
    key: "tilesetInfo",
    value: function tilesetInfo(finished) {
      const {
        server,
        url,
        filetype,
        coordSystem
      } = this.dataConfig;
      if (server && url && filetype) {
        return this.registerFileUrl({
          server,
          url,
          filetype,
          coordSystem
        }).then((data2) => data2.json()).then((data2) => {
          this.dataConfig.tilesetUid = data2.uid;
          this.tilesetInfoAfterRegister(finished);
        }).catch((rejected) => {
          console.error("Error registering url", rejected);
        });
      }
      return new Promise(() => {
        this.tilesetInfoAfterRegister(finished);
      });
    }
    /**
     * Obtain tileset infos for all of the tilesets listed
     *
     * If there is more than one tileset info, this function
     * should (not currently implemented) check if the tileset
     * infos have the same dimensions and then return a common
     * one.
     *
     * @param {import('../types').HandleTilesetInfoFinished} finished - A callback that will be called
     *  when all tileset infos are loaded
     */
  }, {
    key: "tilesetInfoAfterRegister",
    value: function tilesetInfoAfterRegister(finished) {
      if (!this.dataConfig.children) {
        const {
          server,
          tilesetUid
        } = this.dataConfig;
        if (!server || !tilesetUid) {
          console.warn("No dataConfig children, server or tilesetUid:", this.dataConfig);
          finished(null);
        } else {
          this.tileSource.fetchTilesetInfo({
            server,
            tilesetUid
          }).then((tilesetInfo) => {
            this.dataConfig.tilesetInfo = tilesetInfo[tilesetUid];
            finished(tilesetInfo[tilesetUid], tilesetUid);
          }).catch((error) => {
            this.tilesetInfoLoading = false;
            finished({
              error
            });
          });
        }
      } else {
        const promises = this.dataConfig.children.map((x) => (
          /** @type {Promise<TilesetInfo>} */
          new Promise((resolve2) => {
            x.tilesetInfo(resolve2);
          })
        ));
        Promise.all(promises).then((values2) => {
          finished(values2[0]);
        });
      }
    }
    /**
     * @param {string} tilesetUid - Uid of the tileset on the server
     * @param {string} tileId - The tileId of the tile
     * @returns {string} The full tile id that the server will parse.
     *
     * @example
     * ```javascript
     * // returns 'xyxx.0.0.0'
     * fullTileId('xyxx', '0.0.0');
     * ```
     */
  }, {
    key: "fullTileId",
    value: function fullTileId(tilesetUid, tileId) {
      return `${tilesetUid}.${tileId}`;
    }
    /**
     * Fetch a set of tiles.
     *
     * Because the track shouldn't care about tileset ids, the tile ids
     * should just include positions and any necessary transforms.
     *
     * @param {(tiles: Record<string, DividedTile | Tile>) => void} receivedTiles - A function to call once the tiles have been fetched
     * @param {string[]} tileIds - The tile ids to fetch
     * @returns {Promise<Record<string, DividedTile | Tile>>}
     */
  }, {
    key: "fetchTilesDebounced",
    value: function fetchTilesDebounced2(receivedTiles, tileIds) {
      var _a;
      if (this.dataConfig.type === "horizontal-section") {
        return this.fetchHorizontalSection(receivedTiles, tileIds);
      }
      if (this.dataConfig.type === "vertical-section") {
        return this.fetchHorizontalSection(receivedTiles, tileIds, true);
      }
      if (!this.dataConfig.children && this.dataConfig.tilesetUid) {
        const promise = this.tileSource.fetchTiles({
          id: slugid$1.nice(),
          server: this.dataConfig.server,
          tileIds: tileIds.map((x) => `${this.dataConfig.tilesetUid}.${x}`),
          options: this.dataConfig.options
        });
        return (
          /** @type {Promise<Record<string, Tile>>} */
          promise.then((returnedTiles) => {
            const tilesetUid = dictValues(returnedTiles)[0].tilesetUid;
            const newTiles = {};
            for (let i = 0; i < tileIds.length; i++) {
              const fullTileId = this.fullTileId(tilesetUid, tileIds[i]);
              returnedTiles[fullTileId].tilePositionId = tileIds[i];
              newTiles[tileIds[i]] = returnedTiles[fullTileId];
            }
            receivedTiles(newTiles);
            return newTiles;
          })
        );
      }
      const promises = ((_a = this.dataConfig.children) == null ? void 0 : _a.map((x) => (
        /** @type {Promise<Record<string, Tile | DividedTile>>} */
        new Promise((resolve2) => {
          x.fetchTilesDebounced(resolve2, tileIds);
        })
      ))) ?? [];
      return Promise.all(promises).then((returnedTiles) => {
        if (this.dataConfig.type === "divided" && isTuple(returnedTiles)) {
          const newTiles = this.makeDivided(returnedTiles, tileIds);
          receivedTiles(newTiles);
          return newTiles;
        }
        console.warn("Unimplemented dataConfig type. Returning first data source.", this.dataConfig);
        receivedTiles(returnedTiles[0]);
        return returnedTiles[0];
      });
    }
    /**
     * Return an array consisting of the division of the numerator
     * array by the denominator array
     *
     * @param {ArrayLike<number>} numeratorData - An array of numerical values
     * @param {ArrayLike<number>} denominatorData - An array of numerical values
     *
     * @returns {Float32Array} An array consisting of the division of the numerator by the denominator
     */
  }, {
    key: "divideData",
    value: function divideData(numeratorData, denominatorData) {
      const result = new Float32Array(numeratorData.length);
      for (let i = 0; i < result.length; i++) {
        if (denominatorData[i] === 0)
          result[i] = NaN;
        else
          result[i] = numeratorData[i] / denominatorData[i];
      }
      return result;
    }
    /*
     * Take a horizontal slice across the returned tiles at the
     * given position.
     *
     * @param {list} returnedTiles: The tiles returned from a fetch request
     * @param {Number} sliceYPos: The y position across which to slice
     */
  }, {
    key: "horizontalSlice",
    value: function horizontalSlice() {
      return null;
    }
    /**
     * Extract a slice from a matrix at a given position.
     *
     * @param {Array<number> | Float32Array} inputData - An array containing a matrix stored row-wise
     * @param {Array<number>} arrayShape - The shape of the array, should be a
     *  two element array e.g. [256,256].
     * @param {number} sliceIndex - The index across which to take the slice
     * @param {number=} axis - The axis along which to take the slice
     * @returns {Array<number> | Float32Array} an array corresponding to a slice of this matrix
     */
  }, {
    key: "extractDataSlice",
    value: function extractDataSlice(inputData, arrayShape, sliceIndex, axis2) {
      if (!axis2) {
        return inputData.slice(arrayShape[1] * sliceIndex, arrayShape[1] * (sliceIndex + 1));
      }
      const returnArray = new Array(arrayShape[1]);
      for (let i = sliceIndex; i < inputData.length; i += arrayShape[0]) {
        returnArray[Math.floor(i / arrayShape[0])] = inputData[i];
      }
      return returnArray;
    }
    /**
     * Fetch a horizontal section of a 2D dataset
     * @param {(tiles: Record<string, Tile>) => void} receivedTiles - A function to call once the tiles have been fetched
     * @param {string[]} tileIds - The tile ids to fetch
     * @param {boolean=} vertical - Whether to fetch a vertical section
     * @returns {Promise<Record<string, Tile>>}
     */
  }, {
    key: "fetchHorizontalSection",
    value: function fetchHorizontalSection(receivedTiles, tileIds, vertical = false) {
      const newTileIds = [];
      const mirrored = [];
      const {
        slicePos,
        tilesetInfo
      } = this.dataConfig;
      if (!slicePos || !tilesetInfo) {
        throw new Error("No slice position or tileset info");
      }
      for (const tileId of tileIds) {
        const parts = tileId.split(".");
        const zoomLevel = +parts[0];
        const xTilePos = +parts[1];
        const scale = linear().domain([slicePos, slicePos]);
        let yTiles = [];
        if ("resolutions" in tilesetInfo) {
          const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
          yTiles = calculateTilesFromResolution$1(sortedResolutions[zoomLevel], scale, tilesetInfo.min_pos[vertical ? 1 : 0], tilesetInfo.max_pos[vertical ? 1 : 0]);
        } else {
          yTiles = calculateTiles$1(zoomLevel, scale, tilesetInfo.min_pos[vertical ? 1 : 0], tilesetInfo.max_pos[vertical ? 1 : 0], tilesetInfo.max_zoom, tilesetInfo.max_width);
        }
        const sortedPosition = [xTilePos, yTiles[0]].sort((a, b) => a - b);
        if (sortedPosition[0] === xTilePos) {
          mirrored.push(false);
        } else {
          mirrored.push(true);
        }
        const newTileId = `${zoomLevel}.${sortedPosition[0]}.${sortedPosition[1]}`;
        newTileIds.push(newTileId);
      }
      const promise = this.tileSource.fetchTiles({
        id: slugid$1.nice(),
        server: this.dataConfig.server,
        tileIds: newTileIds.map((x) => `${this.dataConfig.tilesetUid}.${x}`)
      });
      return promise.then((returnedTiles) => {
        const tilesetUid = dictValues(returnedTiles)[0].tilesetUid;
        const newTiles = {};
        for (let i = 0; i < newTileIds.length; i++) {
          const parts = newTileIds[i].split(".");
          const zoomLevel = +parts[0];
          const xTilePos = +parts[1];
          const yTilePos = +parts[2];
          const sliceIndex = calculateTileAndPosInTile(
            tilesetInfo,
            // @ts-expect-error - This is undefined for legacy tilesets, but
            // `calculateTileAndPosInTile` ignores this argument with `resolutions`.
            // We should probably refactor `calculateTileAndPosInTile` to just take
            // the `tilesetInfo` object.
            tilesetInfo.max_width,
            tilesetInfo.min_pos[1],
            zoomLevel,
            +slicePos
          )[1];
          const fullTileId = this.fullTileId(tilesetUid, newTileIds[i]);
          const tile = returnedTiles[fullTileId];
          let dataSlice = null;
          if (xTilePos === yTilePos) {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex);
            const mirroredDataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex, 1);
            for (let j = 0; j < dataSlice.length; j++) {
              dataSlice[j] += mirroredDataSlice[j];
            }
          } else if (mirrored[i]) {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex, 1);
          } else {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex);
          }
          const newTile = {
            // @ts-expect-error - this is ok because float32 array can be spread as number[]
            min_value: Math.min.apply(null, dataSlice),
            // @ts-expect-error - this is ok because float32 array can be spread as number[]
            max_value: Math.max.apply(null, dataSlice),
            denseDataExtrema: new DenseDataExtrema1D(dataSlice),
            minNonZero: minNonZero(dataSlice),
            maxNonZero: maxNonZero(dataSlice),
            dense: dataSlice,
            dtype: tile.dtype,
            server: tile.server,
            tilePos: mirrored[i] ? [yTilePos] : [xTilePos],
            tilePositionId: tileIds[i],
            tilesetUid,
            zoomLevel: tile.zoomLevel
          };
          newTiles[tileIds[i]] = newTile;
        }
        receivedTiles(newTiles);
        return newTiles;
      });
    }
    /**
     * @typedef {{ zoomLevel: number, tilePos: number[], dense?: ArrayLike<number> }} Dividable
     * @param {[Record<string, Dividable>, Record<string, Dividable>]} returnedTiles
     * @param {string[]} tileIds
     * @returns {Record<string, DividedTile>}
     */
  }, {
    key: "makeDivided",
    value: function makeDivided(returnedTiles, tileIds) {
      if (returnedTiles.length < 2) {
        console.warn("Only one tileset specified for a divided datafetcher:", this.dataConfig);
      }
      const newTiles = {};
      for (let i = 0; i < tileIds.length; i++) {
        const zoomLevel = returnedTiles[0][tileIds[i]].zoomLevel;
        const tilePos = returnedTiles[0][tileIds[i]].tilePos;
        let newTile = {
          zoomLevel,
          tilePos,
          tilePositionId: tileIds[i]
        };
        const denseA = returnedTiles[0][tileIds[i]].dense;
        const denseB = returnedTiles[1][tileIds[i]].dense;
        if (denseA && denseB) {
          const newData = this.divideData(denseA, denseB);
          const dde = tilePos.length === 2 ? new DenseDataExtrema2D(newData) : new DenseDataExtrema1D(newData);
          newTile = {
            dense: newData,
            denseDataExtrema: dde,
            minNonZero: minNonZero(newData),
            maxNonZero: maxNonZero(newData),
            zoomLevel,
            tilePos,
            tilePositionId: tileIds[i]
          };
        }
        newTiles[tileIds[i]] = newTile;
      }
      return newTiles;
    }
  }]);
  return DataFetcher2;
}();
function _classCallCheck$1s(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1h(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1h(descriptor.key), descriptor);
  }
}
function _createClass$1q(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1h(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1h(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1h(arg) {
  var key = _toPrimitive$1h(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1h(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function isNullDataTask(task) {
  return task.data === null;
}
let BackgroundTaskScheduler = /* @__PURE__ */ function() {
  function BackgroundTaskScheduler2() {
    _classCallCheck$1s(this, BackgroundTaskScheduler2);
    this.taskList = [];
    this.taskHandle = null;
    this.requestIdleCallbackTimeout = 300;
  }
  _createClass$1q(BackgroundTaskScheduler2, [{
    key: "enqueueTask",
    value: function enqueueTask(taskHandler, taskData, trackId = null) {
      if (trackId === null) {
        this.taskList.push({
          handler: taskHandler,
          data: taskData
        });
      } else {
        this.taskList = this.taskList.filter((task) => task.trackId !== trackId);
        this.taskList.push({
          handler: taskHandler,
          data: taskData,
          trackId
        });
      }
      if (!this.taskHandle) {
        this.taskHandle = requestIdleCallback(this.runTaskQueue.bind(this), {
          timeout: this.requestIdleCallbackTimeout
        });
      }
    }
    /**
     * @param {{ timeRemaining(): number, didTimeout: boolean }} deadline
     */
  }, {
    key: "runTaskQueue",
    value: function runTaskQueue(deadline) {
      while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length) {
        const task = this.taskList.shift();
        if (task && isNullDataTask(task)) {
          task.handler();
        } else if (task) {
          task.handler(task.data);
        }
      }
      if (this.taskList.length) {
        this.taskHandle = requestIdleCallback(this.runTaskQueue.bind(this), {
          timeout: this.requestIdleCallbackTimeout
        });
      } else {
        this.taskHandle = 0;
      }
    }
  }]);
  return BackgroundTaskScheduler2;
}();
const backgroundTaskScheduler = new BackgroundTaskScheduler();
function _classCallCheck$1r(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1g(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1g(descriptor.key), descriptor);
  }
}
function _createClass$1p(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1g(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1g(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1g(arg) {
  var key = _toPrimitive$1g(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1g(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$C() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$C = Reflect.get.bind();
  } else {
    _get$C = function _get2(target, property2, receiver) {
      var base = _superPropBase$C(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$C.apply(this, arguments);
}
function _superPropBase$C(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$1b(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1m(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1b(subClass, superClass);
}
function _setPrototypeOf$1b(o, p) {
  _setPrototypeOf$1b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1b(o, p);
}
function _createSuper$1b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1b();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1b(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1b(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1m(this, result);
  };
}
function _possibleConstructorReturn$1m(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1b(self2);
}
function _assertThisInitialized$1b(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1b() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1b(o) {
  _getPrototypeOf$1b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1b(o);
}
function getValueScale(scalingType, minValue, pseudocountIn, maxValue, defaultScaling) {
  const scalingTypeToUse = scalingType || defaultScaling;
  const pseudocount = 0;
  if (scalingTypeToUse === "log" && minValue > 0) {
    return ["log", log$4().range([254, 0]).domain([minValue + pseudocount, maxValue + pseudocount])];
  }
  return ["linear", linear().range([254, 0]).domain([minValue, maxValue])];
}
let TiledPixiTrack = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$1m(TiledPixiTrack2, _PixiTrack);
  var _super = _createSuper$1b(TiledPixiTrack2);
  function TiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1r(this, TiledPixiTrack2);
    _this = _super.call(this, context, options2);
    const {
      pubSub,
      dataConfig,
      handleTilesetInfoReceived,
      animate,
      onValueScaleChanged
    } = context;
    _this.renderVersion = 1;
    _this.visibleTiles = /* @__PURE__ */ new Set();
    _this.visibleTileIds = /* @__PURE__ */ new Set();
    _this.renderingTiles = /* @__PURE__ */ new Set();
    _this.fetching = /* @__PURE__ */ new Set();
    _this.scale = {};
    _this.fetchedTiles = {};
    _this.tileGraphics = {};
    _this.maxZoom = 0;
    _this.medianVisibleValue = null;
    _this.backgroundTaskScheduler = backgroundTaskScheduler;
    _this.continuousScaling = "requestIdleCallback" in window;
    _this.valueScaleMin = null;
    _this.fixedValueScaleMin = null;
    _this.valueScaleMax = null;
    _this.fixedValueScaleMax = null;
    _this.listeners = {};
    _this.pubSub = pubSub;
    _this.animate = animate;
    _this.onValueScaleChanged = onValueScaleChanged;
    _this.prevValueScale = null;
    if (!context.dataFetcher) {
      _this.dataFetcher = new DataFetcher(dataConfig, _this.pubSub);
    } else {
      _this.dataFetcher = context.dataFetcher;
    }
    _this.tilesetInfo = null;
    _this.uuid = slugid$1.nice();
    _this.trackNotFoundText = new GLOBALS.PIXI.Text("", {
      fontSize: "12px",
      fontFamily: "Arial",
      fill: "black"
    });
    _this.pLabel.addChild(_this.trackNotFoundText);
    _this.refreshTilesDebounced = throttleAndDebounce(_this.refreshTiles.bind(_assertThisInitialized$1b(_this)), ZOOM_DEBOUNCE, ZOOM_DEBOUNCE);
    _this.dataFetcher.tilesetInfo((tilesetInfo, tilesetUid) => {
      if (!tilesetInfo)
        return;
      _this.tilesetInfo = tilesetInfo;
      if (!_this.dataFetcher.dataConfig.tilesetUid) {
        _this.dataFetcher.dataConfig.tilesetUid = tilesetUid;
      }
      _this.tilesetUid = _this.dataFetcher.dataConfig.tilesetUid;
      _this.server = _this.dataFetcher.dataConfig.server || "unknown";
      if (_this.tilesetInfo && _this.tilesetInfo.chromsizes) {
        _this.chromInfo = parseChromsizesRows(_this.tilesetInfo.chromsizes);
      }
      if ("error" in _this.tilesetInfo) {
        console.warn("Error retrieving tilesetInfo:", dataConfig, _this.tilesetInfo.error);
        _this.tilesetInfo = null;
        _this.setError(_this.tilesetInfo.error);
        return;
      }
      if (_this.tilesetInfo.resolutions) {
        _this.maxZoom = _this.tilesetInfo.resolutions.length;
      } else {
        _this.maxZoom = +_this.tilesetInfo.max_zoom;
      }
      if (_this.options && _this.options.maxZoom) {
        if (_this.options.maxZoom >= 0) {
          _this.maxZoom = Math.min(_this.options.maxZoom, _this.maxZoom);
        } else {
          console.error("Invalid maxZoom on track:", _assertThisInitialized$1b(_this));
        }
      }
      _this.refreshTiles();
      if (handleTilesetInfoReceived)
        handleTilesetInfoReceived(tilesetInfo);
      if (!_this.options)
        _this.options = {};
      _this.options.name = _this.options.name || tilesetInfo.name;
      _this.checkValueScaleLimits();
      _this.draw();
      _this.drawLabel();
      _this.animate();
    });
    return _this;
  }
  _createClass$1p(TiledPixiTrack2, [{
    key: "setError",
    value: function setError(error) {
      this.errorTextText = error;
      this.draw();
      this.animate();
    }
  }, {
    key: "setFixedValueScaleMin",
    value: function setFixedValueScaleMin(value2) {
      if (!Number.isNaN(+value2))
        this.fixedValueScaleMin = +value2;
      else
        this.fixedValueScaleMin = null;
    }
  }, {
    key: "setFixedValueScaleMax",
    value: function setFixedValueScaleMax(value2) {
      if (!Number.isNaN(+value2))
        this.fixedValueScaleMax = +value2;
      else
        this.fixedValueScaleMax = null;
    }
  }, {
    key: "checkValueScaleLimits",
    value: function checkValueScaleLimits() {
      this.valueScaleMin = typeof this.options.valueScaleMin !== "undefined" ? +this.options.valueScaleMin : null;
      if (this.fixedValueScaleMin !== null) {
        this.valueScaleMin = this.fixedValueScaleMin;
      }
      this.valueScaleMax = typeof this.options.valueScaleMax !== "undefined" ? +this.options.valueScaleMax : null;
      if (this.fixedValueScaleMax !== null) {
        this.valueScaleMax = this.fixedValueScaleMax;
      }
    }
    /**
     * Register an event listener for track events. Currently, the only supported
     * event is ``dataChanged``.
     *
     * @param {string} event The event to listen for
     * @param {function} callback The callback to call when the event occurs. The
     *  parameters for the event depend on the event called.
     *
     * @example
     *
     *  trackObj.on('dataChanged', (newData) => {
     *   console.log('newData:', newData)
     *  });
     */
  }, {
    key: "on",
    value: function on(event, callback) {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      const id2 = this.listeners[event].indexOf(callback);
      if (id2 === -1 || id2 >= this.listeners[event].length)
        return;
      this.listeners[event].splice(id2, 1);
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
      _get$C(_getPrototypeOf$1b(TiledPixiTrack2.prototype), "rerender", this).call(this, options2);
      this.renderVersion += 1;
      if (!this.tilesetInfo) {
        return;
      }
      this.checkValueScaleLimits();
      if (this.tilesetInfo.resolutions) {
        this.maxZoom = this.tilesetInfo.resolutions.length;
      } else {
        this.maxZoom = +this.tilesetInfo.max_zoom;
      }
      if (this.options && this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          this.maxZoom = Math.min(this.options.maxZoom, this.maxZoom);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
    }
    /**
     * Return the set of ids of all tiles which are both visible and fetched.
     */
  }, {
    key: "visibleAndFetchedIds",
    value: function visibleAndFetchedIds() {
      return Object.keys(this.fetchedTiles).filter((x) => this.visibleTileIds.has(x));
    }
  }, {
    key: "visibleAndFetchedTiles",
    value: function visibleAndFetchedTiles() {
      return this.visibleAndFetchedIds().map((x) => this.fetchedTiles[x]);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x),
        mirrored: x.mirrored
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "removeOldTiles",
    value: function removeOldTiles() {
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toRemove = [...fetchedTileIDs].filter((x) => !this.visibleTileIds.has(x));
      this.removeTiles(toRemove);
    }
  }, {
    key: "refreshTiles",
    value: function refreshTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toFetch = [...this.visibleTiles].filter((x) => !this.fetching.has(x.remoteId) && !fetchedTileIDs.has(x.tileId));
      for (let i = 0; i < toFetch.length; i++) {
        this.fetching.add(toFetch[i].remoteId);
      }
      this.removeOldTiles();
      this.fetchNewTiles(toFetch);
    }
  }, {
    key: "parentInFetched",
    value: function parentInFetched(tile) {
      const uid = tile.tileData.tilesetUid;
      let zl = tile.tileData.zoomLevel;
      let pos = tile.tileData.tilePos;
      while (zl > 0) {
        zl -= 1;
        pos = pos.map((x) => Math.floor(x / 2));
        const parentId = `${uid}.${zl}.${pos.join(".")}`;
        if (parentId in this.fetchedTiles) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "parentTileId",
    value: function parentTileId(tile) {
      const parentZoomLevel = tile.tileData.zoomLevel - 1;
      const parentPos = tile.tileData.tilePos.map((x) => Math.floor(x / 2));
      const parentUid = tile.tileData.tilesetUid;
      return `${parentUid}.${parentZoomLevel}.${parentPos.join(".")}`;
    }
    /**
     * Remove obsolete tiles
     *
     * @param toRemoveIds: An array of tile ids to remove from the list of fetched tiles.
     */
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      if (!toRemoveIds.length || !this.areAllVisibleTilesLoaded() || this.renderingTiles.size) {
        return;
      }
      toRemoveIds.forEach((x) => {
        const tileIdStr = x;
        this.destroyTile(this.fetchedTiles[tileIdStr]);
        if (tileIdStr in this.tileGraphics) {
          this.pMain.removeChild(this.tileGraphics[tileIdStr]);
          delete this.tileGraphics[tileIdStr];
        }
        delete this.fetchedTiles[tileIdStr];
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k = 1, tx = 0, ty = 0) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTilesDebounced();
      this.pMobile.position.x = tx;
      this.pMobile.position.y = this.position[1];
      this.pMobile.scale.x = k;
      this.pMobile.scale.y = 1;
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$C(_getPrototypeOf$1b(TiledPixiTrack2.prototype), "setPosition", this).call(this, newPosition);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$C(_getPrototypeOf$1b(TiledPixiTrack2.prototype), "setDimensions", this).call(this, newDimensions);
    }
    /**
     * Check to see if all the visible tiles are loaded.
     *
     * If they are, remove all other tiles.
     */
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const visibleTileIdsList = [...this.visibleTileIds];
      for (let i = 0; i < visibleTileIdsList.length; i++) {
        if (!fetchedTileIDs.has(visibleTileIdsList[i])) {
          return false;
        }
      }
      return true;
    }
    /**
     * Function is called when all tiles that should be visible have
     * been received.
     */
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
    }
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (_) {
        this.scale.minValue = _;
        return this;
      }
      return this.valueScaleMin !== null ? this.valueScaleMin : this.scale.minValue;
    }
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (_) {
        this.scale.maxValue = _;
        return this;
      }
      return this.valueScaleMax !== null ? this.valueScaleMax : this.scale.maxValue;
    }
  }, {
    key: "minRawValue",
    value: function minRawValue() {
      return this.scale.minRawValue;
    }
  }, {
    key: "maxRawValue",
    value: function maxRawValue() {
      return this.scale.maxRawValue;
    }
  }, {
    key: "initTile",
    value: function initTile() {
      this.scale.minRawValue = this.continuousScaling ? this.minVisibleValue() : this.minVisibleValueInTiles();
      this.scale.maxRawValue = this.continuousScaling ? this.maxVisibleValue() : this.maxVisibleValueInTiles();
      this.scale.minValue = this.scale.minRawValue;
      this.scale.maxValue = this.scale.maxRawValue;
    }
  }, {
    key: "updateTile",
    value: function updateTile() {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile() {
    }
  }, {
    key: "addMissingGraphics",
    value: function addMissingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      this.renderVersion += 1;
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        if (!(fetchedTileIDs[i] in this.tileGraphics)) {
          const newGraphics = new GLOBALS.PIXI.Graphics();
          this.pMain.addChild(newGraphics);
          this.fetchedTiles[fetchedTileIDs[i]].graphics = newGraphics;
          this.initTile(this.fetchedTiles[fetchedTileIDs[i]]);
          this.tileGraphics[fetchedTileIDs[i]] = newGraphics;
        }
      }
    }
    /**
     * Change the graphics for existing tiles
     */
  }, {
    key: "updateExistingGraphics",
    value: function updateExistingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        const tile = this.fetchedTiles[fetchedTileIDs[i]];
        this.updateTile(tile);
      }
    }
  }, {
    key: "synchronizeTilesAndGraphics",
    value: function synchronizeTilesAndGraphics() {
      try {
        this.addMissingGraphics();
        this.removeOldTiles();
        this.updateExistingGraphics();
        if (this.listeners.dataChanged) {
          for (const callback of this.listeners.dataChanged) {
            callback(this.visibleAndFetchedTiles().map((x) => x.tileData));
          }
        }
      } catch (err2) {
      }
    }
  }, {
    key: "loadTileData",
    value: function loadTileData(tile, dataLoader) {
      let loadedTileData = this.lruCache.get(tile.tileId);
      if (!loadedTileData) {
        loadedTileData = dataLoader(tile.data, tile.type);
        this.lruCache.put(tile.tileId, loadedTileData);
      }
      return loadedTileData;
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      if (toFetch.length > 0) {
        const toFetchList = [...new Set(toFetch.map((x) => x.remoteId))];
        this.dataFetcher.fetchTilesDebounced(this.receivedTiles.bind(this), toFetchList);
      }
    }
    /**
     * We've gotten a bunch of tiles from the server in
     * response to a request from fetchTiles.
     */
  }, {
    key: "receivedTiles",
    value: function receivedTiles(loadedTiles) {
      for (let i = 0; i < this.visibleTiles.length; i++) {
        const {
          tileId
        } = this.visibleTiles[i];
        if (!loadedTiles[this.visibleTiles[i].remoteId])
          continue;
        if (this.visibleTiles[i].remoteId in loadedTiles) {
          if (!(tileId in this.fetchedTiles)) {
            this.fetchedTiles[tileId] = this.visibleTiles[i];
          }
          if (Array.isArray(loadedTiles[this.visibleTiles[i].remoteId])) {
            const tileData = loadedTiles[this.visibleTiles[i].remoteId];
            this.fetchedTiles[tileId].tileData = [...tileData];
            Object.keys(tileData).filter((key) => Number.isNaN(+key)).forEach((key) => {
              this.fetchedTiles[tileId].tileData[key] = tileData[key];
            });
          } else {
            this.fetchedTiles[tileId].tileData = {
              ...loadedTiles[this.visibleTiles[i].remoteId]
            };
          }
          if (this.fetchedTiles[tileId].tileData.error) {
            console.warn("Error in loaded tile", tileId, this.fetchedTiles[tileId].tileData);
          }
        }
      }
      for (const key in loadedTiles) {
        if (loadedTiles[key]) {
          const tileId = loadedTiles[key].tilePositionId;
          if (this.fetching.has(tileId)) {
            this.fetching.delete(tileId);
          }
        }
      }
      this.synchronizeTilesAndGraphics();
      this.draw();
      this.drawLabel();
      if (this.valueScale) {
        if (!this.prevValueScale || JSON.stringify(this.valueScale.domain()) !== JSON.stringify(this.prevValueScale.domain())) {
          this.prevValueScale = this.valueScale.copy();
          if (this.onValueScaleChanged) {
            this.onValueScaleChanged();
          }
        }
      }
      this.animate();
      if (this.areAllVisibleTilesLoaded()) {
        if (this.pubSub) {
          this.pubSub.publish("TiledPixiTrack.tilesLoaded", {
            uuid: this.uuid
          });
        }
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      if (this.delayDrawing)
        return;
      if (!this.tilesetInfo) {
        if (this.dataFetcher.tilesetInfoLoading) {
          this.trackNotFoundText.text = "Loading...";
        } else {
          this.trackNotFoundText.text = `Tileset info not found. Server: [${this.server}] tilesetUid: [${this.tilesetUid}]`;
        }
        [this.trackNotFoundText.x, this.trackNotFoundText.y] = this.position;
        if (this.flipText) {
          this.trackNotFoundText.anchor.x = 1;
          this.trackNotFoundText.scale.x = -1;
        }
        this.trackNotFoundText.visible = true;
      } else {
        this.trackNotFoundText.visible = false;
      }
      if (this.pubSub) {
        this.pubSub.publish("TiledPixiTrack.tilesDrawnStart", {
          uuid: this.uuid
        });
      }
      const errors = Object.values(this.fetchedTiles).map((x) => x.tileData && x.tileData.error && `${x.tileId}: ${x.tileData.error}`).filter((x) => x);
      if (errors.length) {
        this.errorTextText = errors.join("\n");
      } else {
        this.errorTextText = "";
      }
      _get$C(_getPrototypeOf$1b(TiledPixiTrack2.prototype), "draw", this).call(this);
      Object.keys(this.fetchedTiles).forEach((tilesetUid) => {
        this.drawTile(this.fetchedTiles[tilesetUid]);
      });
      if (this.pubSub) {
        this.pubSub.publish("TiledPixiTrack.tilesDrawnEnd", {
          uuid: this.uuid
        });
      }
    }
    /**
     * Draw a tile on some graphics
     */
  }, {
    key: "drawTile",
    value: function drawTile() {
    }
  }, {
    key: "calculateMedianVisibleValue",
    value: function calculateMedianVisibleValue() {
      if (this.areAllVisibleTilesLoaded()) {
        this.allTilesLoaded();
      }
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const values2 = [].concat(...visibleAndFetchedIds.filter((x) => this.fetchedTiles[x].tileData.dense).map((x) => Array.from(this.fetchedTiles[x].tileData.dense))).filter((x) => x > 0);
      this.medianVisibleValue = median$1(values2);
      return this.medianVisibleValue;
    }
  }, {
    key: "allVisibleValues",
    value: function allVisibleValues() {
      return [].concat(...this.visibleAndFetchedIds().map((x) => Array.from(this.fetchedTiles[x].tileData.dense)));
    }
    // Should be overwriten by child clases to get the true minimal
    // visible value in the currently viewed area
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      return this.minVisibleValueInTiles(ignoreFixedScale);
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let min2 = Math.min(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.minNonZero));
      if (min2 === Number.MAX_SAFE_INTEGER) {
        min2 = null;
      }
      if (ignoreFixedScale)
        return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
    // Should be overwriten by child clases to get the true maximal
    // visible value in the currently viewed area
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      return this.maxVisibleValueInTiles(ignoreFixedScale);
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let max2 = Math.max(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.maxNonZero));
      if (max2 === Number.MIN_SAFE_INTEGER) {
        max2 = null;
      }
      if (ignoreFixedScale)
        return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
  }, {
    key: "makeValueScale",
    value: function makeValueScale(minValue, medianValue, maxValue, inMargin) {
      let valueScale = null;
      let offsetValue = 0;
      let margin = inMargin;
      if (margin === null || typeof margin === "undefined") {
        margin = 6;
      }
      let minDimension = Math.min(this.dimensions[1] - margin, margin);
      let maxDimension = Math.max(this.dimensions[1] - margin, margin);
      if (this.dimensions[1] - margin < margin) {
        minDimension = this.dimensions[1] / 2;
        maxDimension = this.dimensions[1] / 2;
      }
      if (this.options.valueScaling === "log") {
        offsetValue = medianValue;
        if (!offsetValue) {
          offsetValue = minValue;
        }
        valueScale = log$4().domain([offsetValue, maxValue + offsetValue]).range([minDimension, maxDimension]);
      } else if (this.options.valueScaling === "quantile") {
        const start2 = this.dimensions[1] - margin;
        const end2 = margin;
        const quantScale = quantile().domain(this.allVisibleValues()).range(range$2(start2, end2, (end2 - start2) / 256));
        quantScale.ticks = (n) => ticks(start2, end2, n);
        return [quantScale, 0];
      } else if (this.options.valueScaling === "setquantile") {
        const start2 = this.dimensions[1] - margin;
        const end2 = margin;
        const s = new Set(this.allVisibleValues());
        const quantScale = quantile().domain([...s]).range(range$2(start2, end2, (end2 - start2) / 256));
        quantScale.ticks = (n) => ticks(start2, end2, n);
        return [quantScale, 0];
      } else {
        valueScale = linear().domain([minValue, maxValue]).range([maxDimension, minDimension]);
      }
      return [valueScale, offsetValue];
    }
  }]);
  return TiledPixiTrack2;
}(PixiTrack);
function _classCallCheck$1q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1f(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1f(descriptor.key), descriptor);
  }
}
function _createClass$1o(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1f(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1f(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1f(arg) {
  var key = _toPrimitive$1f(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1f(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$B() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$B = Reflect.get.bind();
  } else {
    _get$B = function _get2(target, property2, receiver) {
      var base = _superPropBase$B(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$B.apply(this, arguments);
}
function _superPropBase$B(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$1a(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1l(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1a(subClass, superClass);
}
function _setPrototypeOf$1a(o, p) {
  _setPrototypeOf$1a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1a(o, p);
}
function _createSuper$1a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1a();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1a(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1a(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1l(this, result);
  };
}
function _possibleConstructorReturn$1l(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1a(self2);
}
function _assertThisInitialized$1a(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1a() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1a(o) {
  _getPrototypeOf$1a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1a(o);
}
const COLORBAR_MAX_HEIGHT = 200;
const COLORBAR_WIDTH = 10;
const COLORBAR_LABELS_WIDTH = 40;
const COLORBAR_MARGIN = 10;
const BRUSH_WIDTH = COLORBAR_MARGIN;
const BRUSH_HEIGHT = 4;
const BRUSH_COLORBAR_GAP = 1;
const BRUSH_MARGIN = 4;
const SCALE_LIMIT_PRECISION = 5;
const BINS_PER_TILE$1 = 256;
const COLORBAR_AREA_WIDTH = COLORBAR_WIDTH + COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN + BRUSH_COLORBAR_GAP + BRUSH_WIDTH + BRUSH_MARGIN;
let HeatmapTiledPixiTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$1l(HeatmapTiledPixiTrack2, _TiledPixiTrack);
  var _super = _createSuper$1a(HeatmapTiledPixiTrack2);
  function HeatmapTiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1q(this, HeatmapTiledPixiTrack2);
    const newContext = {
      ...context
    };
    newContext.onValueScaleChanged = () => {
      context.onValueScaleChanged();
      _this.drawColorbar();
    };
    _this = _super.call(this, newContext, options2);
    const {
      pubSub,
      animate,
      svgElement,
      onTrackOptionsChanged,
      onMouseMoveZoom,
      isShowGlobalMousePosition,
      isValueScaleLocked
    } = context;
    _this.pubSub = pubSub;
    _this.is2d = true;
    _this.animate = animate;
    _this.uid = slugid$1.nice();
    _this.scaleBrush = brushY();
    _this.onTrackOptionsChanged = onTrackOptionsChanged;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.isValueScaleLocked = isValueScaleLocked;
    _this.pColorbarArea = new GLOBALS.PIXI.Graphics();
    _this.pMasked.addChild(_this.pColorbarArea);
    _this.pColorbar = new GLOBALS.PIXI.Graphics();
    _this.pColorbarArea.addChild(_this.pColorbar);
    _this.axis = new AxisPixi(_assertThisInitialized$1a(_this));
    _this.pColorbarArea.addChild(_this.axis.pAxis);
    _this.colorScale = HEATED_OBJECT_MAP;
    if (options2 && options2.colorRange) {
      _this.colorScale = colorDomainToRgbaArray(options2.colorRange);
    }
    _this.gBase = select$1(svgElement).append("g");
    _this.gMain = _this.gBase.append("g");
    _this.gColorscaleBrush = _this.gMain.append("g");
    _this.brushing = false;
    _this.prevOptions = "";
    _this.prevIndUpperLeftTile = "";
    _this.onMouseMoveZoom = onMouseMoveZoom;
    _this.setDataLensSize(11);
    _this.dataLens = new Float32Array(_this.dataLensSize ** 2);
    _this.mouseMoveHandlerBound = _this.mouseMoveHandler.bind(_assertThisInitialized$1a(_this));
    if (_this.onMouseMoveZoom) {
      _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandlerBound));
    }
    if (_this.options && _this.options.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_assertThisInitialized$1a(_this), _this.is2d, _this.isShowGlobalMousePosition());
    }
    _this.prevOptions = JSON.stringify(options2);
    return _this;
  }
  _createClass$1o(HeatmapTiledPixiTrack2, [{
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(e) {
      if (!this.isWithin(e.x, e.y))
        return;
      this.mouseX = e.x;
      this.mouseY = e.y;
      this.mouseMoveZoomHandler();
    }
    /**
     * Mouse move and zoom handler. Is triggered on both events.
     *
     * @param  {Number}  absX  Absolute X coordinate.
     * @param  {Number}  absY  Absolute Y coordinate
     */
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(absX = this.mouseX, absY = this.mouseY) {
      if (typeof absX === "undefined" || typeof absY === "undefined" || !this.areAllVisibleTilesLoaded())
        return;
      if (!this.tilesetInfo) {
        return;
      }
      const relX = absX - this.position[0];
      const relY = absY - this.position[1];
      let data2;
      let dataLens;
      try {
        dataLens = this.getVisibleRectangleData(relX - this.dataLensPadding, relY - this.dataLensPadding, this.dataLensSize, this.dataLensSize);
        data2 = dataLens.get(this.dataLensPadding, this.dataLensPadding);
      } catch (e) {
        return;
      }
      const dim = this.dataLensSize;
      let toRgb2;
      try {
        toRgb2 = valueToColor(this.limitedValueScale, this.colorScale, this.valueScale.domain()[0]);
      } catch (err2) {
        return;
      }
      if (!toRgb2)
        return;
      const dataX = Math.round(this._xScale.invert(relX));
      const dataY = Math.round(this._yScale.invert(relY));
      let center2 = [dataX, dataY];
      let xRange = [Math.round(this._xScale.invert(relX - this.dataLensPadding)), Math.round(this._xScale.invert(relX + this.dataLensPadding))];
      let yRange = [Math.round(this._yScale.invert(relY - this.dataLensPadding)), Math.round(this._yScale.invert(relY + this.dataLensPadding))];
      if (this.chromInfo) {
        center2 = center2.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
        xRange = xRange.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
        yRange = yRange.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
      }
      this.onMouseMoveZoom({
        trackId: this.id,
        data: data2,
        absX,
        absY,
        relX,
        relY,
        dataX,
        dataY,
        orientation: "2d",
        // Specific to 2D matrices
        dataLens,
        dim,
        toRgb: toRgb2,
        center: center2,
        xRange,
        yRange,
        isGenomicCoords: !!this.chromInfo
      });
    }
  }, {
    key: "scheduleRerender",
    value: function scheduleRerender() {
      this.backgroundTaskScheduler.enqueueTask(this.handleRerender.bind(this), null, this.uuid);
    }
  }, {
    key: "handleRerender",
    value: function handleRerender() {
      this.rerender(this.options, true);
    }
    /**
     * Get absolute (i.e., display) tile dimension and position.
     *
     * @param {Number}  zoomLevel  Current zoom level.
     * @param {Array}  tilePos  Tile position.
     * @return {Object}  Object holding the absolute x, y, width, and height.
     */
  }, {
    key: "getAbsTileDim",
    value: function getAbsTileDim(zoomLevel, tilePos, mirrored) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      const dim = {};
      dim.width = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
      dim.height = this._refYScale(tileY + tileHeight) - this._refYScale(tileY);
      if (mirrored) {
        dim.x = this._refXScale(tileY);
        dim.y = this._refYScale(tileX);
      } else {
        dim.x = this._refXScale(tileX);
        dim.y = this._refYScale(tileY);
      }
      return dim;
    }
  }, {
    key: "updateValueScale",
    value: function updateValueScale() {
      let minValue = this.minValue();
      let maxValue = this.maxValue();
      const epsilon3 = 1e-6;
      if (minValue !== void 0 && minValue !== null && maxValue !== void 0 && maxValue !== null && Math.abs(minValue - maxValue) < epsilon3) {
        const offset2 = 1e-3;
        minValue = Math.max(epsilon3, minValue - offset2);
        maxValue += offset2;
      }
      const [scaleType, valueScale] = getValueScale(this.options && this.options.heatmapValueScaling || "log", minValue, this.medianVisibleValue, maxValue, "log");
      this.valueScale = valueScale;
      this.limitedValueScale = this.valueScale.copy();
      if (this.options && typeof this.options.scaleStartPercent !== "undefined" && typeof this.options.scaleEndPercent !== "undefined") {
        this.limitedValueScale.domain([this.valueScale.domain()[0] + (this.valueScale.domain()[1] - this.valueScale.domain()[0]) * this.options.scaleStartPercent, this.valueScale.domain()[0] + (this.valueScale.domain()[1] - this.valueScale.domain()[0]) * this.options.scaleEndPercent]);
      }
      return [scaleType, valueScale];
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "rerender", this).call(this, options2, force);
      this.updateValueScale();
      const strOptions = JSON.stringify(options2);
      this.drawColorbar();
      if (!force && strOptions === this.prevOptions)
        return;
      this.prevOptions = strOptions;
      this.options = options2;
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "rerender", this).call(this, options2, force);
      this.calculateVisibleTiles();
      if (options2 && options2.colorRange) {
        this.colorScale = colorDomainToRgbaArray(options2.colorRange);
      }
      this.visibleAndFetchedTiles().forEach((tile) => this.renderTile(tile));
      if (this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
      if (this.options && this.options.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
    }
  }, {
    key: "drawLabel",
    value: function drawLabel() {
      if (this.options.labelPosition === this.options.colorbarPosition) {
        this.labelXOffset = COLORBAR_AREA_WIDTH;
      } else {
        this.labelXOffset = 0;
      }
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "drawLabel", this).call(this);
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      canvas.width = this.binsPerTile();
      canvas.height = this.binsPerTile();
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const pix = new ImageData(pixData, canvas.width, canvas.height);
      ctx.putImageData(pix, 0, 0);
      return canvas;
    }
  }, {
    key: "exportData",
    value: function exportData() {
      if (this.tilesetInfo) {
        const data2 = this.getVisibleRectangleData(0, 0, this.dimensions[0], this.dimensions[1]);
        const output = {
          bounds: [this._xScale.domain(), this._yScale.domain()],
          dimensions: data2.shape,
          data: ndarrayFlatten(data2)
        };
        download("data.json", JSON.stringify(output));
      }
    }
    /**
     * Position sprite (the rendered tile)
     *
     * @param  {Object}  sprite  PIXI sprite object.
     * @param  {Number}  zoomLevel  Current zoom level.
     * @param  {Array}  tilePos  X,Y position of tile.
     * @param  {Boolean}  mirrored  If `true` tile is mirrored.
     */
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos, mirrored) {
      const dim = this.getAbsTileDim(zoomLevel, tilePos, mirrored);
      sprite.width = dim.width;
      sprite.height = dim.height;
      sprite.x = dim.x;
      sprite.y = dim.y;
      if (mirrored && tilePos[0] !== tilePos[1]) {
        sprite.rotation = -Math.PI / 2;
        sprite.scale.x = Math.abs(sprite.scale.x) * -1;
      }
    }
  }, {
    key: "refXScale",
    value: function refXScale(_) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "refXScale", this).call(this, _);
      this.draw();
    }
  }, {
    key: "refYScale",
    value: function refYScale(_) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "refYScale", this).call(this, _);
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "draw", this).call(this);
    }
  }, {
    key: "newBrushOptions",
    value: function newBrushOptions(selection2) {
      const newOptions = JSON.parse(JSON.stringify(this.options));
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      const endDomain = axisValueScale.invert(selection2[0]);
      const startDomain = axisValueScale.invert(selection2[1]);
      const startPercent = (startDomain - axisValueScale.domain()[0]) / // eslint-disable-line operator-linebreak
      (axisValueScale.domain()[1] - axisValueScale.domain()[0]);
      const endPercent = (endDomain - axisValueScale.domain()[0]) / // eslint-disable-line operator-linebreak
      (axisValueScale.domain()[1] - axisValueScale.domain()[0]);
      newOptions.scaleStartPercent = startPercent.toFixed(SCALE_LIMIT_PRECISION);
      newOptions.scaleEndPercent = endPercent.toFixed(SCALE_LIMIT_PRECISION);
      return newOptions;
    }
  }, {
    key: "brushStart",
    value: function brushStart() {
      this.brushing = true;
    }
  }, {
    key: "brushMoved",
    value: function brushMoved(event) {
      if (!event.selection) {
        return;
      }
      const newOptions = this.newBrushOptions(event.selection);
      const strOptions = JSON.stringify(newOptions);
      this.gColorscaleBrush.selectAll(".handle--custom").attr("y", (d) => d.type === "n" ? event.selection[0] : event.selection[1] - BRUSH_HEIGHT / 2);
      if (strOptions === this.prevOptions)
        return;
      this.prevOptions = strOptions;
      this.rerender(newOptions, true);
      this.onTrackOptionsChanged(newOptions);
      if (this.isValueScaleLocked()) {
        this.onValueScaleChanged();
      }
    }
  }, {
    key: "brushEnd",
    value: function brushEnd() {
      this.brushing = false;
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.drawColorbar();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.drawColorbar();
    }
  }, {
    key: "removeColorbar",
    value: function removeColorbar() {
      this.pColorbarArea.visible = false;
      if (this.scaleBrush.on(".brush")) {
        this.gColorscaleBrush.call(this.scaleBrush.move, null);
      }
      this.gColorscaleBrush.on(".brush", null);
      this.gColorscaleBrush.selectAll("rect").remove();
    }
  }, {
    key: "drawColorbar",
    value: function drawColorbar() {
      this.pColorbar.clear();
      if (!this.options || !this.options.colorbarPosition || this.options.colorbarPosition === "hidden") {
        this.removeColorbar();
        return;
      }
      this.pColorbarArea.visible = true;
      if (!this.valueScale) {
        return;
      }
      if (Number.isNaN(+this.valueScale.domain()[0]) || Number.isNaN(+this.valueScale.domain()[1])) {
        return;
      }
      const colorbarAreaHeight = Math.min(this.dimensions[1] / 2, COLORBAR_MAX_HEIGHT);
      this.colorbarHeight = colorbarAreaHeight - 2 * COLORBAR_MARGIN;
      if (this.colorbarHeight < 0) {
        this.removeColorbar();
        return;
      }
      if (this.valueScale.domain()[1] === this.valueScale.domain()[0]) {
        this.removeColorbar();
        return;
      }
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        this.scaleBrush.extent([[BRUSH_MARGIN, 0], [BRUSH_WIDTH, this.colorbarHeight]]);
      } else {
        this.scaleBrush.extent([[0, 0], [BRUSH_WIDTH - BRUSH_MARGIN, this.colorbarHeight]]);
      }
      if (this.options.colorbarPosition === "topLeft") {
        [this.pColorbarArea.x, this.pColorbarArea.y] = this.position;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP + COLORBAR_WIDTH;
        this.pColorbar.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + BRUSH_MARGIN},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "topRight") {
        this.pColorbarArea.x = this.position[0] + this.dimensions[0] - COLORBAR_AREA_WIDTH;
        this.pColorbarArea.y = this.position[1];
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.pColorbar.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + this.pColorbar.x + COLORBAR_WIDTH + 2},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "bottomRight") {
        this.pColorbarArea.x = this.position[0] + this.dimensions[0] - COLORBAR_AREA_WIDTH;
        this.pColorbarArea.y = this.position[1] + this.dimensions[1] - colorbarAreaHeight;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.pColorbar.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + this.pColorbar.x + COLORBAR_WIDTH + BRUSH_COLORBAR_GAP},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "bottomLeft") {
        this.pColorbarArea.x = this.position[0];
        this.pColorbarArea.y = this.position[1] + this.dimensions[1] - colorbarAreaHeight;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP + COLORBAR_WIDTH;
        this.pColorbar.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + 2},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      this.pColorbarArea.clear();
      this.pColorbarArea.beginFill(colorToHex(this.options.colorbarBackgroundColor || "white"), +this.options.colorbarBackgroundOpacity >= 0 ? +this.options.colorbarBackgroundOpacity : 0.6);
      this.pColorbarArea.drawRect(0, 0, COLORBAR_AREA_WIDTH, colorbarAreaHeight);
      if (!this.options) {
        this.options = {
          scaleStartPercent: 0,
          scaleEndPercent: 1
        };
      } else {
        if (!this.options.scaleStartPercent) {
          this.options.scaleStartPercent = 0;
        }
        if (!this.options.scaleEndPercent) {
          this.options.scaleEndPercent = 1;
        }
      }
      const domainWidth = axisValueScale.domain()[1] - axisValueScale.domain()[0];
      const startBrush = axisValueScale(this.options.scaleStartPercent * domainWidth + axisValueScale.domain()[0]);
      const endBrush = axisValueScale(this.options.scaleEndPercent * domainWidth + axisValueScale.domain()[0]);
      if (!this.brushing) {
        this.scaleBrush.on("start", this.brushStart.bind(this)).on("brush", this.brushMoved.bind(this)).on("end", this.brushEnd.bind(this)).handleSize(0);
        this.gColorscaleBrush.on(".brush", null);
        this.gColorscaleBrush.call(this.scaleBrush);
        this.northHandle = this.gColorscaleBrush.selectAll(".handle--custom").data([{
          type: "n"
        }, {
          type: "s"
        }]).enter().append("rect").classed("handle--custom", true).attr("cursor", "ns-resize").attr("width", BRUSH_WIDTH).attr("height", BRUSH_HEIGHT).style("fill", "#666").style("stroke", "white");
        if (this.flipText) {
          this.northHandle.attr("cursor", "ew-resize");
        }
        this.gColorscaleBrush.call(this.scaleBrush.move, [endBrush, startBrush]);
      }
      const posScale = linear().domain([0, 255]).range([0, this.colorbarHeight]);
      for (let i = 0; i < this.colorbarHeight; i++) {
        const value2 = this.limitedValueScale(axisValueScale.invert(i));
        const rgbIdx = Math.max(0, Math.min(254, Math.floor(value2)));
        this.pColorbar.beginFill(colorToHex(`rgb(${this.colorScale[rgbIdx][0]},${this.colorScale[rgbIdx][1]},${this.colorScale[rgbIdx][2]})`));
        this.pColorbar.drawRect(0, i, COLORBAR_WIDTH, 1);
      }
      this.pAxis.position.x = COLORBAR_WIDTH;
      this.pAxis.position.y = posScale(0);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        this.axis.drawAxisRight(axisValueScale, this.colorbarHeight);
      } else if (this.options.colorbarPosition === "topRight" || this.options.colorbarPosition === "bottomRight") {
        this.axis.drawAxisLeft(axisValueScale, this.colorbarHeight);
      }
    }
  }, {
    key: "exportColorBarSVG",
    value: function exportColorBarSVG() {
      const gColorbarArea = document.createElement("g");
      gColorbarArea.setAttribute("class", "color-bar");
      if (!this.options.colorbarPosition || this.options.colorbarPosition === "hidden") {
        return gColorbarArea;
      }
      if (!this.valueScale)
        return gColorbarArea;
      gColorbarArea.setAttribute("transform", `translate(${this.pColorbarArea.x}, ${this.pColorbarArea.y})`);
      const rectColorbarArea = document.createElement("rect");
      gColorbarArea.appendChild(rectColorbarArea);
      const gColorbar = document.createElement("g");
      gColorbarArea.appendChild(gColorbar);
      gColorbar.setAttribute("transform", `translate(${this.pColorbar.x}, ${this.pColorbar.y})`);
      const colorbarAreaHeight = Math.min(this.dimensions[1] / 2, COLORBAR_MAX_HEIGHT);
      this.colorbarHeight = colorbarAreaHeight - 2 * COLORBAR_MARGIN;
      rectColorbarArea.setAttribute("x", 0);
      rectColorbarArea.setAttribute("y", 0);
      rectColorbarArea.setAttribute("width", COLORBAR_AREA_WIDTH);
      rectColorbarArea.setAttribute("height", colorbarAreaHeight);
      rectColorbarArea.setAttribute("style", "fill: white; stroke-width: 0; opacity: 0.7");
      const barsToDraw = 256;
      const posScale = linear().domain([0, barsToDraw - 1]).range([0, this.colorbarHeight]);
      const colorHeight = this.colorbarHeight / barsToDraw;
      for (let i = 0; i < barsToDraw; i++) {
        const rectColor = document.createElement("rect");
        gColorbar.appendChild(rectColor);
        rectColor.setAttribute("x", 0);
        rectColor.setAttribute("y", posScale(i));
        rectColor.setAttribute("width", COLORBAR_WIDTH);
        rectColor.setAttribute("height", colorHeight);
        rectColor.setAttribute("class", "color-rect");
        const limitedIndex = Math.min(this.colorScale.length - 1, Math.max(0, Math.floor(this.limitedValueScale(this.valueScale.invert(i)))));
        const color2 = this.colorScale[limitedIndex];
        if (color2) {
          rectColor.setAttribute("style", `fill: rgb(${color2[0]}, ${color2[1]}, ${color2[2]})`);
        } else {
          rectColor.setAttribute("style", `fill: rgb(255,255,255,0)`);
        }
      }
      const gAxisHolder = document.createElement("g");
      gColorbarArea.appendChild(gAxisHolder);
      gAxisHolder.setAttribute("transform", `translate(${this.axis.pAxis.position.x},${this.axis.pAxis.position.y})`);
      let gAxis = null;
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        gAxis = this.axis.exportAxisRightSVG(axisValueScale, this.colorbarHeight);
      } else if (this.options.colorbarPosition === "topRight" || this.options.colorbarPosition === "bottomRight") {
        gAxis = this.axis.exportAxisLeftSVG(axisValueScale, this.colorbarHeight);
      }
      gAxisHolder.appendChild(gAxis);
      return gColorbarArea;
    }
    /**
     * Set data lens size
     *
     * @param  {Integer}  newDataLensSize  New data lens size. Needs to be an odd
     *   integer.
     */
  }, {
    key: "setDataLensSize",
    value: function setDataLensSize(newDataLensSize) {
      this.dataLensPadding = Math.max(0, Math.floor((newDataLensSize - 1) / 2));
      this.dataLensSize = this.dataLensPadding * 2 + 1;
    }
  }, {
    key: "binsPerTile",
    value: function binsPerTile() {
      return this.tilesetInfo.bins_per_dimension || BINS_PER_TILE$1;
    }
    /**
     * Get the data in the visible rectangle
     *
     * The parameter coordinates are in pixel coordinates
     *
     * @param {int} x: The upper left corner of the rectangle in pixel coordinates
     * @param {int} y: The upper left corner of the rectangle in pixel coordinates
     * @param {int} width: The width of the rectangle (pixels)
     * @param {int} height: The height of the rectangle (pixels)
     *
     * @returns {Array} A numjs array containing the data in the visible region
     *
     */
  }, {
    key: "getVisibleRectangleData",
    value: function getVisibleRectangleData(x, y, width, height2) {
      let zoomLevel = this.calculateZoomLevel();
      zoomLevel = this.tilesetInfo.max_zoom ? Math.min(this.tilesetInfo.max_zoom, zoomLevel) : zoomLevel;
      const calculatedWidth = calculateTileWidth(this.tilesetInfo, zoomLevel, this.binsPerTile());
      const tileRes = calculatedWidth / this.binsPerTile();
      const xDomain = [this._xScale.invert(x), this._xScale.invert(x + width)];
      const yDomain = [this._yScale.invert(y), this._yScale.invert(y + height2)];
      const limitedXDomain = [Math.max(xDomain[0], this.tilesetInfo.min_pos[0]), Math.min(xDomain[1], this.tilesetInfo.max_pos[0])];
      const limitedYDomain = [Math.max(yDomain[0], this.tilesetInfo.min_pos[1]), Math.min(yDomain[1], this.tilesetInfo.max_pos[1])];
      const leftXBin = Math.floor(limitedXDomain[0] / tileRes);
      const leftYBin = Math.floor(limitedYDomain[0] / tileRes);
      const binWidth = Math.max(0, Math.ceil((limitedXDomain[1] - limitedXDomain[0]) / tileRes));
      const binHeight = Math.max(0, Math.ceil((limitedYDomain[1] - limitedYDomain[0]) / tileRes));
      const out = ndarray$1(new Array(binHeight * binWidth).fill(NaN), [binHeight, binWidth]);
      this.visibleAndFetchedTiles().forEach((tile) => {
        const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
        const {
          tileX,
          tileY,
          tileWidth,
          tileHeight
        } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tilePos, this.binsPerTile());
        const tileXStartBin = Math.floor(tileX / tileRes);
        const tileXEndBin = Math.floor((tileX + tileWidth) / tileRes);
        const tileYStartBin = Math.floor(tileY / tileRes);
        const tileYEndBin = Math.floor((tileY + tileHeight) / tileRes);
        let tileSliceXStart = Math.max(leftXBin, tileXStartBin) - tileXStartBin;
        let tileSliceYStart = Math.max(leftYBin, tileYStartBin) - tileYStartBin;
        const tileSliceXEnd = Math.min(leftXBin + binWidth, tileXEndBin) - tileXStartBin;
        const tileSliceYEnd = Math.min(leftYBin + binHeight, tileYEndBin) - tileYStartBin;
        const tileXOffset = Math.max(tileXStartBin - leftXBin, 0);
        const tileYOffset = Math.max(tileYStartBin - leftYBin, 0);
        const tileSliceWidth = tileSliceXEnd - tileSliceXStart;
        const tileSliceHeight = tileSliceYEnd - tileSliceYStart;
        if (tileSliceWidth < 0 || tileSliceHeight < 0)
          return;
        if (tile.mirrored && tileSliceXStart > tileSliceYStart) {
          const tmp = tileSliceXStart;
          tileSliceXStart = tileSliceYStart;
          tileSliceYStart = tmp;
        }
        ndarrayAssign(out.hi(tileYOffset + tileSliceHeight, tileXOffset + tileSliceWidth).lo(tileYOffset, tileXOffset), tile.dataArray.hi(tileSliceYStart + tileSliceHeight, tileSliceXStart + tileSliceWidth).lo(tileSliceYStart, tileSliceXStart));
      });
      return out;
    }
    /**
     * Convert the raw tile data to a rendered array of values which can be represented as a sprite.
     *
     * @param tile: The data structure containing all the tile information. Relevant to
     *              this function are tile.tileData = \{'dense': [...], ...\}
     *              and tile.graphics
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "initTile", this).call(this, tile);
      if (tile.tileData.dense.length === this.binsPerTile() ** 2) {
        tile.dataArray = ndarray$1(Array.from(tile.tileData.dense), [this.binsPerTile(), this.binsPerTile()]);
        if (this.continuousScaling && tile.tileData.tilePos[0] === tile.tileData.tilePos[1] && tile.mirrored) {
          tile.tileData.denseDataExtrema.mirrorPrecomputedExtrema();
          _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "initTile", this).call(this, tile);
        }
      }
      if (this.scale.minValue === null || this.scale.maxValue === null) {
        return;
      }
      this.renderTile(tile);
    }
    // /**
    //  * Draw a border around tiles
    //  *
    //  * @param  {Array}  pixData  Pixel data to be adjusted
    //  */
    // addBorder(pixData) {
    //   for (let i = 0; i < 256; i++) {
    //     if (i === 0) {
    //       const prefix = i * 256 * 4;
    //       for (let j = 0; j < 255; j++) {
    //         pixData[prefix + (j * 4)] = 0;
    //         pixData[prefix + (j * 4) + 1] = 0;
    //         pixData[prefix + (j * 4) + 2] = 255;
    //         pixData[prefix + (j * 4) + 3] = 255;
    //       }
    //     }
    //     pixData[(i * 256 * 4)] = 0;
    //     pixData[(i * 256 * 4) + 1] = 0;
    //     pixData[(i * 256 * 4) + 2] = 255;
    //     pixData[(i * 256 * 4) + 3] = 255;
    //   }
    // }
    //
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
      if (tile.scale && this.scale && this.scale.minValue === tile.scale.minValue && this.scale.maxValue === tile.scale.maxValue)
        ;
      else {
        this.renderTile(tile);
        this.drawColorbar();
      }
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.sprite.destroy(true);
      tile.canvas = null;
      tile.sprite = null;
      tile.texture = null;
    }
  }, {
    key: "pixDataFunction",
    value: function pixDataFunction(tile, pixData) {
      if (pixData) {
        const {
          graphics
        } = tile;
        const canvas = this.tileDataToCanvas(pixData.pixData);
        if (tile.sprite) {
          tile.sprite.destroy(true);
        }
        const texture = GLOBALS.PIXI.VERSION[0] === "4" ? GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST) : GLOBALS.PIXI.Texture.from(canvas, {
          scaleMode: GLOBALS.PIXI.SCALE_MODES.NEAREST
        });
        const sprite = new GLOBALS.PIXI.Sprite(texture);
        tile.sprite = sprite;
        tile.texture = texture;
        tile.canvas = canvas;
        this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
        graphics.removeChildren();
        graphics.addChild(tile.sprite);
      }
      this.renderingTiles.delete(tile.tileId);
    }
    /**
     * Render / draw a tile.
     *
     * @param {Object}  tile  Tile data to be rendered.
     */
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      const [scaleType] = this.updateValueScale();
      const pseudocount = 0;
      this.renderingTiles.add(tile.tileId);
      if (this.tilesetInfo.tile_size) {
        if (tile.tileData.dense.length < this.tilesetInfo.tile_size) {
          const newArray = new Float32Array(this.tilesetInfo.tile_size);
          newArray.fill(NaN);
          newArray.set(tile.tileData.dense);
          tile.tileData.dense = newArray;
        }
      }
      tileDataToPixData(
        tile,
        scaleType,
        this.limitedValueScale.domain(),
        pseudocount,
        // used as a pseudocount to prevent taking the log of 0
        this.colorScale,
        (pixData) => this.pixDataFunction(tile, pixData),
        this.mirrorTiles() && !tile.mirrored && tile.tileData.tilePos[0] === tile.tileData.tilePos[1],
        this.options.extent === "upper-right" && tile.tileData.tilePos[0] === tile.tileData.tilePos[1],
        this.options.zeroValueColor ? colorToRgba(this.options.zeroValueColor) : void 0,
        {
          selectedRows: this.options.selectRows,
          selectedRowsAggregationMode: this.options.selectRowsAggregationMode,
          selectedRowsAggregationWithRelativeHeight: this.options.selectRowsAggregationWithRelativeHeight,
          selectedRowsAggregationMethod: this.options.selectRowsAggregationMethod
        }
      );
    }
    /**
     * Remove this track from the view
     */
  }, {
    key: "remove",
    value: function remove3() {
      this.visibleAndFetchedTiles().forEach((tile) => this.destroyTile(tile));
      this.gMain.remove();
      this.gMain = null;
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "remove", this).call(this);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "refScalesChanged", this).call(this, refXScale, refYScale);
      objVals(this.fetchedTiles).filter((tile) => tile.sprite).forEach((tile) => this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored));
    }
    /**
     * Bypass this track's exportSVG function
     */
  }, {
    key: "superSVG",
    value: function superSVG() {
      return _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "exportSVG", this).call(this);
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.pMain.position.x},${this.pMain.position.y}) scale(${this.pMain.scale.x},${this.pMain.scale.y})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        const rotation2 = tile.sprite.rotation * 180 / Math.PI;
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${tile.sprite.x},${tile.sprite.y}) rotate(${rotation2}) scale(${tile.sprite.scale.x},${tile.sprite.scale.y})`);
        const image = document.createElement("image");
        image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", tile.canvas.toDataURL());
        image.setAttribute("width", tile.canvas.width);
        image.setAttribute("height", tile.canvas.height);
        image.setAttribute("style", "image-rendering: pixelated");
        g.appendChild(image);
        output.appendChild(g);
      }
      const gColorbar = this.exportColorBarSVG();
      track.appendChild(gColorbar);
      return [base, base];
    }
    // This function gets the indices of the visible part of the upper left tile.
    // The indices are 'rounded' to the grid used by the DenseDataExrema module.
    // It is used to determine if we should check for a new value scale in
    // the case of continuous scaling
  }, {
    key: "getVisiblePartOfUppLeftTile",
    value: function getVisiblePartOfUppLeftTile() {
      const tilePositions = this.visibleAndFetchedTiles().map((tile) => {
        const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
        return [tilePos[0], tilePos[1], tile.tileId];
      });
      if (tilePositions.length === 0)
        return null;
      let minTilePosition = tilePositions[0];
      for (let i = 0; i < tilePositions.length; i++) {
        const curPos = tilePositions[i];
        if (curPos[0] < minTilePosition[0] || curPos[1] < minTilePosition[1]) {
          minTilePosition = curPos;
        }
      }
      const numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_2D_TTILE, this.binsPerTile());
      const subsetSize = this.binsPerTile() / numSubsets;
      const upperLeftTile = this.visibleAndFetchedTiles().filter((tile) => tile.tileId === minTilePosition[2])[0];
      const upperLeftTileInd = this.getIndicesOfVisibleDataInTile(upperLeftTile);
      const startX = upperLeftTileInd[0];
      const startY = upperLeftTileInd[1];
      const startXadjusted = startX - startX % subsetSize;
      const startYadjusted = startY - startY % subsetSize;
      return [upperLeftTile.tileId, startXadjusted, startYadjusted];
    }
  }, {
    key: "getIndicesOfVisibleDataInTile",
    value: function getIndicesOfVisibleDataInTile(tile) {
      const visibleX = this._xScale.range();
      const visibleY = this._yScale.range();
      const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tilePos, this.binsPerTile());
      const tileXScale = linear().domain([0, this.binsPerTile()]).range([tileX, tileX + tileWidth]);
      const startX = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visibleX[0]))) - 1);
      const endX = Math.min(this.binsPerTile(), Math.round(tileXScale.invert(this._xScale.invert(visibleX[1]))));
      const tileYScale = linear().domain([0, this.binsPerTile()]).range([tileY, tileY + tileHeight]);
      const startY = Math.max(0, Math.round(tileYScale.invert(this._yScale.invert(visibleY[0]))) - 1);
      const endY = Math.min(this.binsPerTile(), Math.round(tileYScale.invert(this._yScale.invert(visibleY[1]))));
      const result = tile.mirrored && tilePos[0] !== tilePos[1] ? [startY, startX, endY, endX] : [startX, startY, endX, endY];
      return result;
    }
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      const minimumsPerTile = this.visibleAndFetchedTiles().map((tile) => {
        if (tile.tileData.denseDataExtrema === void 0) {
          return null;
        }
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMinNonZeroInSubset(ind);
      });
      if (minimumsPerTile.length === 0 && this.valueScaleMax === null) {
        return null;
      }
      const min2 = Math.min.apply(null, minimumsPerTile);
      if (min2 === Number.MAX_SAFE_INTEGER) {
        return _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "minVisibleValue", this).call(this, ignoreFixedScale);
      }
      if (ignoreFixedScale)
        return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      const maximumsPerTile = this.visibleAndFetchedTiles().map((tile) => {
        if (tile.tileData.denseDataExtrema === void 0) {
          return null;
        }
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMaxNonZeroInSubset(ind);
      });
      if (maximumsPerTile.length === 0 && this.valueScaleMax === null) {
        return null;
      }
      const max2 = Math.max.apply(null, maximumsPerTile);
      if (max2 === Number.MIN_SAFE_INTEGER) {
        return _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "maxVisibleValue", this).call(this, ignoreFixedScale);
      }
      if (ignoreFixedScale)
        return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      if (this.brushing) {
        return;
      }
      _get$B(_getPrototypeOf$1a(HeatmapTiledPixiTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.pMain.position.x = tx;
      this.pMain.position.y = ty;
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      const isValueScaleLocked = this.isValueScaleLocked();
      if (this.continuousScaling && this.minValue() !== void 0 && this.maxValue() !== void 0) {
        const indUpperLeftTile = JSON.stringify(this.getVisiblePartOfUppLeftTile());
        if (this.valueScaleMin === null && this.valueScaleMax === null && !isValueScaleLocked && // syncs the recomputation with the grid used in the DenseDataExtrema module
        indUpperLeftTile !== this.prevIndUpperLeftTile) {
          const newMin = this.minVisibleValue();
          const newMax = this.maxVisibleValue();
          const epsilon3 = 1e-6;
          if (newMin !== null && // can happen if tiles haven't loaded
          newMax !== null && (Math.abs(this.minValue() - newMin) > epsilon3 || Math.abs(this.maxValue() - newMax) > epsilon3)) {
            this.minValue(newMin);
            this.maxValue(newMax);
            this.scheduleRerender();
          }
          this.prevIndUpperLeftTile = indUpperLeftTile;
        }
        if (isValueScaleLocked) {
          this.onValueScaleChanged();
        }
      }
      this.mouseMoveZoomHandler();
    }
    /**
     * Helper method for adding a tile ID in place. Used by `tilesToId()`.
     *
     * @param  {Array}  tiles  Array tile ID should be added to.
     * @param  {Integer}  zoomLevel  Zoom level.
     * @param  {Integer}  row  Column ID, i.e., y.
     * @param  {Integer}  column  Column ID, i.e., x.
     * @param  {Objwect}  dataTransform  ??
     * @param  {Boolean}  mirrored  If `true` tile is mirrored.
     */
  }, {
    key: "addTileId",
    value: function addTileId(tiles, zoomLevel, row, column, dataTransform, mirrored = false) {
      const newTile = [zoomLevel, row, column];
      newTile.mirrored = mirrored;
      newTile.dataTransform = dataTransform;
      tiles.push(newTile);
    }
    /**
     * Convert tile positions to tile IDs
     *
     * @param  {Array}  xTiles  X positions of tiles
     * @param  {Array}  yTiles  Y positions of tiles
     * @param  {Array}  zoomLevel  Current zoom level
     * @return  {Array}  List of tile IDs
     */
  }, {
    key: "tilesToId",
    value: function tilesToId(xTiles, yTiles, zoomLevel) {
      const rows = xTiles;
      const cols = yTiles;
      const dataTransform = this.options && this.options.dataTransform || "default";
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          if (this.mirrorTiles()) {
            if (rows[i] >= cols[j]) {
              if (this.options.extent !== "lower-left") {
                this.addTileId(tiles, zoomLevel, cols[j], rows[i], dataTransform, true);
              }
            } else if (this.options.extent !== "upper-right") {
              this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
            }
            if (rows[i] === cols[j] && this.options.extent === "lower-left") {
              this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
            }
          } else {
            this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
          }
        }
      }
      return tiles;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = calculateTilesFromResolution$1(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        this.yTiles = calculateTilesFromResolution$1(sortedResolutions[this.zoomLevel], this._yScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      } else {
        this.xTiles = calculateTiles$1(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
        this.yTiles = calculateTiles$1(this.zoomLevel, this._yScale, this.options.reverseYAxis ? -this.tilesetInfo.max_pos[1] : this.tilesetInfo.min_pos[1], this.options.reverseYAxis ? -this.tilesetInfo.min_pos[1] : this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width1 || this.tilesetInfo.max_width);
      }
      this.setVisibleTiles(this.tilesToId(this.xTiles, this.yTiles, this.zoomLevel));
    }
  }, {
    key: "mirrorTiles",
    value: function mirrorTiles() {
      return !(this.tilesetInfo.mirror_tiles && (this.tilesetInfo.mirror_tiles === false || this.tilesetInfo.mirror_tiles === "false"));
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      if (!this.options || !this.options.showTooltip && !isShiftDown) {
        return "";
      }
      if (!this.tilesetInfo) {
        return "";
      }
      const currentResolution = calculateResolution(this.tilesetInfo, this.zoomLevel);
      const maxWidth = Math.max(this.tilesetInfo.max_pos[1] - this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[0] - this.tilesetInfo.min_pos[0]);
      const formatResolution = Math.ceil(Math.log(maxWidth / currentResolution) / Math.log(10));
      this.setDataLensSize(1);
      const dataX = this._xScale.invert(trackX);
      const dataY = this._yScale.invert(trackY);
      let positionText = "<b>Position:</b> ";
      if (this.chromInfo) {
        const atcX = absToChr(dataX, this.chromInfo);
        const atcY = absToChr(dataY, this.chromInfo);
        const f2 = (n) => format$1(`.${formatResolution}s`)(n);
        positionText += `${atcX[0]}:${f2(atcX[1])} & ${atcY[0]}:${f2(atcY[1])}`;
        positionText += "<br/>";
      }
      let data2 = null;
      try {
        data2 = this.getVisibleRectangleData(trackX, trackY, 1, 1).get(0, 0);
      } catch (err2) {
        return "";
      }
      if (this.options && this.options.heatmapValueScaling === "log") {
        if (data2 > 0) {
          return `${positionText}<b>Value:</b> 1e${format$1(".3f")(Math.log(data2) / Math.log(10))}`;
        }
        if (data2 === 0) {
          return `${positionText}<b>Value:</b> 0`;
        }
        return `${positionText}<b>Value:</b> N/A`;
      }
      return `${positionText}<b>Value:</b> ${format$1(".3f")(data2)}`;
    }
    /**
     * Get the tile's position in its coordinate system.
     *
     * @description
     * Normally the absolute coordinate system are the genome basepair positions
     */
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos, binsPerTileIn) {
      const binsPerTile = binsPerTileIn || this.binsPerTile();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const chosenResolution = sortedResolutions[zoomLevel];
        const tileWidth2 = chosenResolution * binsPerTile;
        const tileHeight2 = tileWidth2;
        const tileX2 = chosenResolution * binsPerTile * tilePos[0];
        const tileY2 = chosenResolution * binsPerTile * tilePos[1];
        return {
          tileX: tileX2,
          tileY: tileY2,
          tileWidth: tileWidth2,
          tileHeight: tileHeight2
        };
      }
      const xTilePos = tilePos[0];
      const yTilePos = tilePos[1];
      const minX = this.tilesetInfo.min_pos[0];
      const minY = this.options.reverseYAxis ? -this.tilesetInfo.max_pos[1] : this.tilesetInfo.min_pos[1];
      const tileWidth = this.tilesetInfo.max_width / 2 ** zoomLevel;
      const tileHeight = this.tilesetInfo.max_width / 2 ** zoomLevel;
      const tileX = minX + xTilePos * tileWidth;
      const tileY = minY + yTilePos * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      this.tilesetInfo.min_pos[0];
      this.tilesetInfo.max_pos[0];
      this.tilesetInfo.min_pos[1];
      this.tilesetInfo.max_pos[1];
      let zoomLevel = null;
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = calculateZoomLevelFromResolutions$1(this.tilesetInfo.resolutions, this._xScale);
        const zoomIndexY = calculateZoomLevelFromResolutions$1(this.tilesetInfo.resolutions, this._yScale);
        zoomLevel = Math.min(zoomIndexX, zoomIndexY);
      } else {
        const xZoomLevel = calculateZoomLevel$1(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.binsPerTile());
        const yZoomLevel = calculateZoomLevel$1(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.binsPerTile());
        zoomLevel = Math.max(xZoomLevel, yZoomLevel);
        zoomLevel = Math.min(zoomLevel, this.maxZoom);
      }
      if (this.options && this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
    /**
     * The local tile identifier
     *
     * @param {array}  tile  Tile definition array to be converted to id. Tile
     *   array must contain `[zoomLevel, xPos, yPos]` and two props `mirrored` and
     *   `dataTransform`.
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      if (tile.dataTransform && tile.dataTransform !== "default") {
        return `${tile.join(".")}.${tile.mirrored}.${tile.dataTransform}`;
      }
      return `${tile.join(".")}.${tile.mirrored}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      if (tile.dataTransform && tile.dataTransform !== "default") {
        return `${tile.join(".")}.${tile.dataTransform}`;
      }
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }]);
  return HeatmapTiledPixiTrack2;
}(TiledPixiTrack);
function _classCallCheck$1p(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1e(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1e(descriptor.key), descriptor);
  }
}
function _createClass$1n(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1e(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1e(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1e(arg) {
  var key = _toPrimitive$1e(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1e(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$19(subClass, superClass);
}
function _setPrototypeOf$19(o, p) {
  _setPrototypeOf$19 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$19(o, p);
}
function _createSuper$19(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$19();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$19(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$19(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1k(this, result);
  };
}
function _possibleConstructorReturn$1k(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$19(self2);
}
function _assertThisInitialized$19(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$19() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$19(o) {
  _getPrototypeOf$19 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$19(o);
}
function _drawTile(tile) {
  if (!tile.graphics) {
    return;
  }
  const graphics = tile.graphics;
  const {
    tileX,
    tileY,
    tileWidth
  } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
  tile.drawnAtScale = this._xScale.copy();
  const tSX = 1 / ((this._xScale(1) - this._xScale(0)) / (this._refXScale(1) - this._refXScale(0)));
  const tSY = 1 / ((this._yScale(1) - this._yScale(0)) / (this._refYScale(1) - this._refYScale(0)));
  tile.text.scale.x = tSX;
  tile.text.scale.y = tSY;
  const tilePixelWidth = this._xScale(tileWidth) - this._xScale(0);
  tile.textGraphics.scale.x = tilePixelWidth / 256;
  tile.textGraphics.scale.y = tilePixelWidth / 256;
  graphics.clear();
  graphics.lineStyle(4 * tSX, 255, 1);
  graphics.beginFill(16740363, 0.4);
  graphics.alpha = 0.5;
  if (tile.mirrored) {
    const tileScaledWidth = this._refXScale(tileY + tileWidth) - this._refXScale(tileY);
    const tileScaledHeight = this._refYScale(tileX + tileWidth) - this._refYScale(tileX);
    tile.textGraphics.position.x = this._refXScale(tileY) + tileScaledWidth / 2;
    tile.textGraphics.position.y = this._refYScale(tileX) + tileScaledHeight / 2;
    graphics.drawRect(this._refXScale(tileY), this._refYScale(tileX), tileScaledWidth, tileScaledHeight);
  } else {
    const tileScaledWidth = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
    const tileScaledHeight = this._refYScale(tileY + tileWidth) - this._refYScale(tileY);
    tile.textGraphics.position.x = this._refXScale(tileX) + tileScaledWidth / 2;
    tile.textGraphics.position.y = this._refYScale(tileY) + tileScaledHeight / 2;
    graphics.drawRect(this._refXScale(tileX), this._refYScale(tileY), tileScaledWidth, tileScaledHeight);
  }
}
function _initTile(tile) {
  const graphics = tile.graphics;
  tile.textGraphics = new GLOBALS.PIXI.Graphics();
  if (tile.mirrored) {
    tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${[tile.tileData.tilePos[1], tile.tileData.tilePos[0]].join("/")}`, {
      fontFamily: "Arial",
      fontSize: 24,
      fill: 16715792,
      align: "center"
    });
  } else {
    tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
      fontFamily: "Arial",
      fontSize: 24,
      fill: 16715792,
      align: "center"
    });
  }
  tile.textGraphics.addChild(tile.text);
  tile.text.anchor.x = 0.5;
  tile.text.anchor.y = 0.5;
  graphics.addChild(tile.textGraphics);
}
let Id2DTiledPixiTrack = /* @__PURE__ */ function(_HeatmapTiledPixiTrac) {
  _inherits$1k(Id2DTiledPixiTrack2, _HeatmapTiledPixiTrac);
  var _super = _createSuper$19(Id2DTiledPixiTrack2);
  function Id2DTiledPixiTrack2() {
    _classCallCheck$1p(this, Id2DTiledPixiTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$1n(Id2DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _initTile.bind(this)(tile);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _drawTile.bind(this)(tile);
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[0],
          tilePos: keyParts.slice(1, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
    }
  }]);
  return Id2DTiledPixiTrack2;
}(HeatmapTiledPixiTrack);
function _classCallCheck$1o(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1d(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1d(descriptor.key), descriptor);
  }
}
function _createClass$1m(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1d(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1d(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1d(arg) {
  var key = _toPrimitive$1d(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1d(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$A() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$A = Reflect.get.bind();
  } else {
    _get$A = function _get2(target, property2, receiver) {
      var base = _superPropBase$A(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$A.apply(this, arguments);
}
function _superPropBase$A(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$18(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$18(subClass, superClass);
}
function _setPrototypeOf$18(o, p) {
  _setPrototypeOf$18 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$18(o, p);
}
function _createSuper$18(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$18();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$18(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$18(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1j(this, result);
  };
}
function _possibleConstructorReturn$1j(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$18(self2);
}
function _assertThisInitialized$18(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$18() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$18(o) {
  _getPrototypeOf$18 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$18(o);
}
const BINS_PER_TILE = 1024;
let Tiled1DPixiTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$1j(Tiled1DPixiTrack2, _TiledPixiTrack);
  var _super = _createSuper$18(Tiled1DPixiTrack2);
  function Tiled1DPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1o(this, Tiled1DPixiTrack2);
    _this = _super.call(this, context, options2);
    const {
      onMouseMoveZoom,
      isValueScaleLocked,
      getLockGroupExtrema
    } = context;
    _this.onMouseMoveZoom = onMouseMoveZoom;
    _this.isValueScaleLocked = isValueScaleLocked;
    _this.getLockGroupExtrema = getLockGroupExtrema;
    if (_this.onMouseMoveZoom) {
      _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandler.bind(_assertThisInitialized$18(_this))));
    }
    return _this;
  }
  _createClass$1m(Tiled1DPixiTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      _get$A(_getPrototypeOf$18(Tiled1DPixiTrack2.prototype), "initTile", this).call(this, tile);
    }
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return null;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const xTiles2 = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        const tiles2 = xTiles2.map((x) => [this.zoomLevel, x]);
        this.setVisibleTiles(tiles2);
        return;
      }
      const xTiles = api.calculateTiles(this.zoomLevel, this.relevantScale(), this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const tiles = xTiles.map((x) => [this.zoomLevel, x]);
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos, binsPerTileIn) {
      const xTilePos = tilePos[0];
      const yTilePos = tilePos[0];
      if (this.tilesetInfo.resolutions) {
        const binsPerTile = binsPerTileIn || BINS_PER_TILE;
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const chosenResolution = sortedResolutions[zoomLevel];
        const tileWidth2 = chosenResolution * binsPerTile;
        const tileHeight2 = tileWidth2;
        const tileX2 = chosenResolution * binsPerTile * tilePos[0];
        const tileY2 = chosenResolution * binsPerTile * tilePos[1];
        return {
          tileX: tileX2,
          tileY: tileY2,
          tileWidth: tileWidth2,
          tileHeight: tileHeight2
        };
      }
      const totalWidth = this.tilesetInfo.max_width;
      const totalHeight = this.tilesetInfo.max_width;
      const minX = this.tilesetInfo.min_pos[0];
      const minY = this.tilesetInfo.min_pos[1];
      const tileWidth = totalWidth / 2 ** zoomLevel;
      const tileHeight = totalHeight / 2 ** zoomLevel;
      const tileX = minX + xTilePos * tileWidth;
      const tileY = minY + yTilePos * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "scheduleRerender",
    value: function scheduleRerender() {
      this.backgroundTaskScheduler.enqueueTask(this.handleRerender.bind(this), null, this.uuid);
    }
  }, {
    key: "handleRerender",
    value: function handleRerender() {
      this.rerender(this.options, false);
    }
  }, {
    key: "getIndicesOfVisibleDataInTile",
    value: function getIndicesOfVisibleDataInTile(tile) {
      const visible = this._xScale.range();
      if (!this.tilesetInfo)
        return [null, null];
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension]).range([tileX, tileX + tileWidth]);
      const start2 = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visible[0]))));
      const end2 = Math.min(tile.tileData.dense.length, Math.round(tileXScale.invert(this._xScale.invert(visible[1]))));
      return [start2, end2];
    }
    /**
     * Returns the minimum in the visible area (not visible tiles)
     */
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const minimumsPerTile = visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).map((tile) => {
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMinNonZeroInSubset(ind);
      });
      const min2 = Math.min(...minimumsPerTile);
      if (ignoreFixedScale)
        return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
    /**
     * Returns the maximum in the visible area (not visible tiles)
     */
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const maximumsPerTile = visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).map((tile) => {
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMaxNonZeroInSubset(ind);
      });
      const max2 = Math.max(...maximumsPerTile);
      if (ignoreFixedScale)
        return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
    /**
     * Return an aggregated visible value. For example, the minimum or maximum.
     *
     * @description
     *   The difference to `minVisibleValueInTiles`
     *   is that the truly visible min or max value is returned instead of the
     *   min or max value of the tile. The latter is not necessarily visible.
     *
     *   For 'min' and 'max' this is identical to minVisibleValue and maxVisibleValue
     *
     * @param  {string} aggregator Aggregation method. Currently supports `min`
     *   and `max` only.
     * @return {number} The aggregated value.
     */
  }, {
    key: "getAggregatedVisibleValue",
    value: function getAggregatedVisibleValue(aggregator = "max") {
      const aggregate = aggregator === "min" ? Math.min : Math.max;
      const limit2 = aggregator === "min" ? Infinity : -Infinity;
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const visible = this._xScale.range();
      return visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).map((tile) => {
        if (!tile.tileData.tilePos) {
          return aggregator === "min" ? this.minVisibleValue() : this.maxVisibleValue();
        }
        const {
          tileX,
          tileWidth
        } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
        const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension]).range([tileX, tileX + tileWidth]);
        const start2 = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visible[0]))));
        const end2 = Math.min(tile.tileData.dense.length, Math.round(tileXScale.invert(this._xScale.invert(visible[1]))));
        return tile.tileData.dense.slice(start2, end2);
      }).reduce((smallest, current) => aggregate(smallest, ...current), limit2);
    }
    /**
     * Get the data value at a relative pixel position
     * @param   {number}  relPos  Relative pixel position, where 0 indicates the
     *   start of the track
     * @return  {number}  The data value at `relPos`
     */
  }, {
    key: "getDataAtPos",
    value: function getDataAtPos(relPos) {
      let value2;
      if (!this.tilesetInfo)
        return value2;
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(relPos) / tileWidth;
      const tileId = this.tileToLocalId([zoomLevel, Math.floor(tilePos)]);
      const fetchedTile = this.fetchedTiles[tileId];
      if (!fetchedTile)
        return value2;
      const posInTileX = this.tilesetInfo.tile_size * (tilePos - Math.floor(tilePos));
      if (fetchedTile.tileData.dense) {
        return fetchedTile.tileData.dense[Math.floor(posInTileX)];
      }
      return null;
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler({
      x,
      y
    } = {}) {
      if (!this.isWithin(x, y))
        return;
      this.mouseX = x;
      this.mouseY = y;
      this.mouseMoveZoomHandler();
    }
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler() {
    }
  }, {
    key: "zoomed",
    value: function zoomed(...args) {
      _get$A(_getPrototypeOf$18(Tiled1DPixiTrack2.prototype), "zoomed", this).call(this, ...args);
      this.mouseMoveZoomHandler();
    }
  }]);
  return Tiled1DPixiTrack2;
}(TiledPixiTrack);
function _classCallCheck$1n(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1c(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1c(descriptor.key), descriptor);
  }
}
function _createClass$1l(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1c(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1c(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1c(arg) {
  var key = _toPrimitive$1c(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1c(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$z() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$z = Reflect.get.bind();
  } else {
    _get$z = function _get2(target, property2, receiver) {
      var base = _superPropBase$z(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$z.apply(this, arguments);
}
function _superPropBase$z(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$17(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$17(subClass, superClass);
}
function _setPrototypeOf$17(o, p) {
  _setPrototypeOf$17 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$17(o, p);
}
function _createSuper$17(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$17();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$17(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$17(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1i(this, result);
  };
}
function _possibleConstructorReturn$1i(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$17(self2);
}
function _assertThisInitialized$17(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$17() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$17(o) {
  _getPrototypeOf$17 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$17(o);
}
let HorizontalTiled1DPixiTrack = /* @__PURE__ */ function(_Tiled1DPixiTrack) {
  _inherits$1i(HorizontalTiled1DPixiTrack2, _Tiled1DPixiTrack);
  var _super = _createSuper$17(HorizontalTiled1DPixiTrack2);
  function HorizontalTiled1DPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1n(this, HorizontalTiled1DPixiTrack2);
    _this = _super.call(this, context, options2);
    const {
      animate,
      isShowGlobalMousePosition
    } = context;
    _this.constIndicator = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.constIndicator);
    _this.axis = new AxisPixi(_assertThisInitialized$17(_this));
    _this.pBase.addChild(_this.axis.pAxis);
    _this.animate = animate;
    _this.options = options2;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.pubSubs = [];
    if (_this.options.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_assertThisInitialized$17(_this), _this.is2d, _this.isShowGlobalMousePosition());
    }
    return _this;
  }
  _createClass$1l(HorizontalTiled1DPixiTrack2, [{
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions)
        return;
      _get$z(_getPrototypeOf$17(HorizontalTiled1DPixiTrack2.prototype), "rerender", this).call(this, options2, force);
      this.prevOptions = strOptions;
      this.options = options2;
      if (this.options.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
      if (!this.options.showMousePosition && this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0] - 2);
        return zoomIndexX;
      }
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
    /**
     * Which scale should we use for calculating tile positions?
     *
     * Horizontal tracks should use the xScale and vertical tracks
     * should use the yScale
     *
     * This function should be overwritten by HorizontalTiled1DPixiTrack.js
     * and VerticalTiled1DPixiTrack.js
     */
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return this._xScale;
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$z(_getPrototypeOf$17(HorizontalTiled1DPixiTrack2.prototype), "draw", this).call(this);
      this.drawConstIndicator();
    }
  }, {
    key: "drawAxis",
    value: function drawAxis2(valueScale) {
      if (!this.options.axisPositionVertical && !this.options.axisPositionHorizontal) {
        this.axis.clearAxis();
        return;
      }
      if (this.options.axisPositionVertical && this.options.axisPositionVertical === "hidden") {
        this.axis.clearAxis();
        return;
      }
      if (this.options.axisPositionHorizontal && this.options.axisPositionHorizontal === "hidden") {
        this.axis.clearAxis();
        return;
      }
      const margin = this.options.axisMargin || 0;
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        this.axis.pAxis.position.x = this.position[0] + margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisRight(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "outsideLeft" || this.options.axisPositionVertical === "outsideTop") {
        this.axis.pAxis.position.x = this.position[0] + margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisLeft(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        this.axis.pAxis.position.x = this.position[0] + this.dimensions[0] - margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisLeft(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "outsideRight" || this.options.axisPositionVertical === "outsideBottom") {
        this.axis.pAxis.position.x = this.position[0] + this.dimensions[0] - margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisRight(valueScale, this.dimensions[1]);
      }
    }
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(absX = this.mouseX, absY = this.mouseY) {
      if (typeof absX === "undefined" || !this.areAllVisibleTilesLoaded() || !this.tilesetInfo)
        return;
      let dataPosX = 0;
      let dataPosY = 0;
      let orientation2 = "1d-horizontal";
      if (this.isLeftModified) {
        dataPosX = absY - this.position[1];
        dataPosY = absX - this.position[0];
        orientation2 = "1d-vertical";
      } else {
        dataPosX = absX - this.position[0];
        dataPosY = absY - this.position[1];
      }
      const relX = absX - this.position[0];
      const relY = absY - this.position[1];
      const dataX = this._xScale.invert(dataPosX);
      const dataY = this._yScale.invert(dataPosY);
      const data2 = this.getDataAtPos(dataPosX);
      if (!data2)
        return;
      this.onMouseMoveZoom({
        trackId: this.id,
        data: data2,
        absX,
        absY,
        relX,
        relY,
        dataX,
        dataY,
        orientation: orientation2
      });
    }
  }, {
    key: "drawConstIndicator",
    value: function drawConstIndicator() {
      if (!this.constIndicator || !this.constIndicator._graphics) {
        return;
      }
      try {
        this.constIndicator.clear();
        while (this.constIndicator.children[0]) {
          this.constIndicator.removeChild(this.constIndicator.children[0]);
        }
        if (!this.options.constIndicators || !this.valueScale)
          return;
        this.options.constIndicators.forEach(({
          color: color2 = "black",
          opacity = 1,
          label = null,
          labelColor = "black",
          labelOpacity = 1,
          labelPosition = "leftTop",
          labelSize = 12,
          value: value2 = 0
        } = {}) => {
          const colorHex = colorToHex(color2);
          const labelColorHex = colorToHex(labelColor);
          this.constIndicator.beginFill(colorHex, opacity);
          const y = this.valueScale(value2);
          let xOffset = 0;
          let widthOffset = 0;
          if (label) {
            const labelG = new GLOBALS.PIXI.Text(label, {
              fontFamily: "Arial",
              fontSize: labelSize,
              fill: labelColorHex
            });
            labelG.alpha = labelOpacity;
            switch (labelPosition) {
              case "right":
                labelG.anchor.x = 1;
                labelG.anchor.y = 0.5;
                labelG.x = this.position[0] + this.dimensions[0] - 6;
                labelG.y = y;
                widthOffset = labelG.width + 8;
                break;
              case "rightBottom":
                labelG.anchor.x = 1;
                labelG.anchor.y = 0;
                labelG.x = this.position[0] + this.dimensions[0] - 6;
                labelG.y = y;
                break;
              case "rightTop":
                labelG.anchor.x = 1;
                labelG.anchor.y = 1;
                labelG.x = this.position[0] + this.dimensions[0] - 6;
                labelG.y = y;
                break;
              case "left":
                labelG.anchor.x = 0;
                labelG.anchor.y = 0.5;
                labelG.x = this.position[0] + 2;
                labelG.y = y;
                xOffset = labelG.width + 4;
                break;
              case "leftBottom":
                labelG.anchor.x = 0;
                labelG.anchor.y = 0;
                labelG.x = this.position[0] + 2;
                labelG.y = y;
                break;
              case "leftTop":
              default:
                labelG.anchor.x = 0;
                labelG.anchor.y = 1;
                labelG.x = this.position[0] + 2;
                labelG.y = y;
                break;
            }
            this.constIndicator.addChild(labelG);
          }
          this.constIndicator.drawRect(this.position[0] + xOffset, y, this.dimensions[0] - widthOffset, 1);
        });
      } catch (err2) {
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$z(_getPrototypeOf$17(HorizontalTiled1DPixiTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$z(_getPrototypeOf$17(HorizontalTiled1DPixiTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "horizontal-tiled-1d-track");
      const output = document.createElement("g");
      track.appendChild(output);
      if (this.options.constIndicators) {
        this.options.constIndicators.forEach(({
          color: color2 = "black",
          opacity = 1,
          label = null,
          labelColor = "black",
          labelOpacity = 1,
          labelPosition = "leftTop",
          labelSize = 12,
          value: value2 = 0
        } = {}) => {
          const y = this.valueScale(value2);
          if (label) {
            const labelEl = document.createElement("text");
            labelEl.textContent = label;
            labelEl.setAttribute("x", this.position[0]);
            labelEl.setAttribute("y", y);
            labelEl.setAttribute("style", `font-family: 'Arial'; font-size: ${labelSize}px; fill: ${labelColor}; fill-opacity: ${labelOpacity};`);
            switch (labelPosition) {
              case "rightBottom":
                labelEl.setAttribute("x", this.position[0] + this.dimensions[0] - 6);
                labelEl.setAttribute("y", y + labelSize + 2);
                labelEl.setAttribute("text-anchor", "end");
                break;
              case "right":
              case "rightTop":
                labelEl.setAttribute("x", this.position[0] + this.dimensions[0] - 6);
                labelEl.setAttribute("y", y - 2);
                labelEl.setAttribute("text-anchor", "end");
                break;
              case "leftBottom":
                labelEl.setAttribute("x", this.position[0] + 2);
                labelEl.setAttribute("y", y + labelSize + 2);
                break;
              case "left":
              case "leftTop":
              default:
                labelEl.setAttribute("x", this.position[0] + 2);
                labelEl.setAttribute("y", y - 2);
                break;
            }
            output.appendChild(labelEl);
          }
          const line = document.createElement("line");
          line.setAttribute("x1", this.position[0]);
          line.setAttribute("y1", y);
          line.setAttribute("x2", this.dimensions[0]);
          line.setAttribute("y2", y);
          line.setAttribute("stroke", color2);
          line.setAttribute("stroke-opacity", opacity);
          output.appendChild(line);
        });
      }
      return [base, track];
    }
  }]);
  return HorizontalTiled1DPixiTrack2;
}(Tiled1DPixiTrack);
function _classCallCheck$1m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1b(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1b(descriptor.key), descriptor);
  }
}
function _createClass$1k(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1b(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1b(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1b(arg) {
  var key = _toPrimitive$1b(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1b(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$y() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$y = Reflect.get.bind();
  } else {
    _get$y = function _get2(target, property2, receiver) {
      var base = _superPropBase$y(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$y.apply(this, arguments);
}
function _superPropBase$y(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$16(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$16(subClass, superClass);
}
function _setPrototypeOf$16(o, p) {
  _setPrototypeOf$16 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$16(o, p);
}
function _createSuper$16(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$16();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$16(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$16(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1h(this, result);
  };
}
function _possibleConstructorReturn$1h(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$16(self2);
}
function _assertThisInitialized$16(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$16() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$16(o) {
  _getPrototypeOf$16 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$16(o);
}
let IdHorizontal1DTiledPixiTrack = /* @__PURE__ */ function(_HorizontalTiled1DPix) {
  _inherits$1h(IdHorizontal1DTiledPixiTrack2, _HorizontalTiled1DPix);
  var _super = _createSuper$16(IdHorizontal1DTiledPixiTrack2);
  function IdHorizontal1DTiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$1m(this, IdHorizontal1DTiledPixiTrack2);
    _this = _super.call(this, context, options2);
    _this.pMain = _this.pMobile;
    return _this;
  }
  _createClass$1k(IdHorizontal1DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const graphics = tile.graphics;
      tile.textGraphics = new GLOBALS.PIXI.Graphics();
      tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
        fontFamily: "Arial",
        fontSize: 32,
        fill: 16715792,
        align: "center"
      });
      tile.textGraphics.addChild(tile.text);
      tile.text.anchor.x = 0.5;
      tile.text.anchor.y = 0.5;
      graphics.addChild(tile.textGraphics);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.graphics.destroy(true);
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.visibleAndFetchedTiles().forEach((tile) => this.destroyTile(tile));
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _get$y(_getPrototypeOf$16(IdHorizontal1DTiledPixiTrack2.prototype), "drawTile", this).call(this, tile);
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tSX = 1 / ((this._xScale(1) - this._xScale(0)) / (this._refXScale(1) - this._refXScale(0)));
      tile.text.scale.x = tSX;
      graphics.clear();
      const tileScaledHeight = this.dimensions[1];
      const tileScaledWidth = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
      tile.textGraphics.position.x = this._refXScale(tileX) + tileScaledWidth / 2;
      tile.textGraphics.position.y = tileScaledHeight / 2;
      const rectX = this._refXScale(tileX);
      graphics.lineStyle(4 * tSX, 255, 1);
      graphics.beginFill(16740363, 0.4);
      graphics.alpha = 0.5;
      graphics.moveTo(rectX, 0);
      graphics.lineTo(rectX, tileScaledHeight);
      graphics.moveTo(rectX + tileScaledWidth, 0);
      graphics.lineTo(rectX + tileScaledWidth, tileScaledHeight);
      graphics.lineStyle(0, 255, 1);
      graphics.drawRect(rectX, 0, tileScaledWidth, tileScaledHeight);
    }
  }]);
  return IdHorizontal1DTiledPixiTrack2;
}(HorizontalTiled1DPixiTrack);
function _classCallCheck$1l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1a(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1a(descriptor.key), descriptor);
  }
}
function _createClass$1j(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1a(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1a(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1a(arg) {
  var key = _toPrimitive$1a(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1a(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$x() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$x = Reflect.get.bind();
  } else {
    _get$x = function _get2(target, property2, receiver) {
      var base = _superPropBase$x(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$x.apply(this, arguments);
}
function _superPropBase$x(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$15(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1g(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$15(subClass, superClass);
}
function _setPrototypeOf$15(o, p) {
  _setPrototypeOf$15 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$15(o, p);
}
function _createSuper$15(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$15();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$15(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$15(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1g(this, result);
  };
}
function _possibleConstructorReturn$1g(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$15(self2);
}
function _assertThisInitialized$15(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$15() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$15(o) {
  _getPrototypeOf$15 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$15(o);
}
let VerticalTiled1DPixiTrack = /* @__PURE__ */ function(_Tiled1DPixiTrack) {
  _inherits$1g(VerticalTiled1DPixiTrack2, _Tiled1DPixiTrack);
  var _super = _createSuper$15(VerticalTiled1DPixiTrack2);
  function VerticalTiled1DPixiTrack2() {
    _classCallCheck$1l(this, VerticalTiled1DPixiTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$1j(VerticalTiled1DPixiTrack2, [{
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const yZoomLevel = api.calculateZoomLevel(this._yScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const zoomLevel = Math.min(yZoomLevel, this.maxZoom);
      return zoomLevel;
    }
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return this._yScale;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _get$x(_getPrototypeOf$15(VerticalTiled1DPixiTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      const scaleX = 1;
      const scaleY = (newYScale(1) - newYScale(0)) / (this._refYScale(1) - this._refYScale(0));
      const translateX2 = this.position[0];
      const translateY2 = newYScale(0) + this.position[1] - this._refYScale(1) * scaleY;
      this.pMain.position.x = translateX2;
      this.pMain.position.y = translateY2;
      this.pMain.scale.x = scaleX;
      this.pMain.scale.y = scaleY;
    }
  }]);
  return VerticalTiled1DPixiTrack2;
}(Tiled1DPixiTrack);
function _classCallCheck$1k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$19(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$19(descriptor.key), descriptor);
  }
}
function _createClass$1i(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$19(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$19(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$19(arg) {
  var key = _toPrimitive$19(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$19(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$w() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$w = Reflect.get.bind();
  } else {
    _get$w = function _get2(target, property2, receiver) {
      var base = _superPropBase$w(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$w.apply(this, arguments);
}
function _superPropBase$w(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$14(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$14(subClass, superClass);
}
function _setPrototypeOf$14(o, p) {
  _setPrototypeOf$14 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$14(o, p);
}
function _createSuper$14(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$14();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$14(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$14(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1f(this, result);
  };
}
function _possibleConstructorReturn$1f(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$14(self2);
}
function _assertThisInitialized$14(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$14() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$14(o) {
  _getPrototypeOf$14 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$14(o);
}
let IdVertical1DTiledPixiTrack = /* @__PURE__ */ function(_VerticalTiled1DPixiT) {
  _inherits$1f(IdVertical1DTiledPixiTrack2, _VerticalTiled1DPixiT);
  var _super = _createSuper$14(IdVertical1DTiledPixiTrack2);
  function IdVertical1DTiledPixiTrack2() {
    _classCallCheck$1k(this, IdVertical1DTiledPixiTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$1i(IdVertical1DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const graphics = tile.graphics;
      tile.textGraphics = new GLOBALS.PIXI.Graphics();
      tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
        fontFamily: "Arial",
        fontSize: 32,
        fill: 16715792,
        align: "center"
      });
      tile.textGraphics.addChild(tile.text);
      tile.text.anchor.x = 0.5;
      tile.text.anchor.y = 0.5;
      tile.text.rotation = -Math.PI / 2;
      graphics.addChild(tile.textGraphics);
      this.drawTile(tile, graphics);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _get$w(_getPrototypeOf$14(IdVertical1DTiledPixiTrack2.prototype), "drawTile", this).call(this, tile);
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileY,
        tileHeight
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tSY = 1 / ((this._yScale(1) - this._yScale(0)) / (this._refYScale(1) - this._refYScale(0)));
      tile.text.scale.x = tSY;
      graphics.clear();
      graphics.lineStyle(4 * tSY, 255, 1);
      graphics.beginFill(16740363, 0.4);
      graphics.alpha = 0.5;
      const tileScaledWidth = this.dimensions[0];
      const tileScaledHeight = this._refYScale(tileY + tileHeight) - this._refYScale(tileY);
      tile.textGraphics.position.x = tileScaledWidth / 2;
      tile.textGraphics.position.y = this._refYScale(tileY) + tileScaledHeight / 2;
      graphics.drawRect(0, this._refYScale(tileY), tileScaledWidth, tileScaledHeight);
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[1],
          tilePos: keyParts.slice(2, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
    }
  }]);
  return IdVertical1DTiledPixiTrack2;
}(VerticalTiled1DPixiTrack);
var slice$1 = Array.prototype.slice;
function identity$3(x) {
  return x;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon$1 = 1e-6;
function translateX(x) {
  return "translate(" + x + ",0)";
}
function translateY(y) {
  return "translate(0," + y + ")";
}
function number(scale) {
  return (d) => +scale(d);
}
function center(scale, offset2) {
  offset2 = Math.max(0, scale.bandwidth() - offset2 * 2) / 2;
  if (scale.round())
    offset2 = Math.round(offset2);
  return (d) => +scale(d) + offset2;
}
function entering() {
  return !this.__axis;
}
function axis(orient2, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset2 = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient2 === top || orient2 === left ? -1 : 1, x = orient2 === left || orient2 === right ? "x" : "y", transform3 = orient2 === top || orient2 === bottom ? translateX : translateY;
  function axis2(context) {
    var values2 = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$3 : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range2 = scale.range(), range0 = +range2[0] + offset2, range1 = +range2[range2.length - 1] + offset2, position = (scale.bandwidth ? center : number)(scale.copy(), offset2), selection2 = context.selection ? context.selection() : context, path = selection2.selectAll(".domain").data([null]), tick = selection2.selectAll(".tick").data(values2, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text2 = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
    text2 = text2.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient2 === top ? "0em" : orient2 === bottom ? "0.71em" : "0.32em"));
    if (context !== selection2) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text2 = text2.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon$1).attr("transform", function(d) {
        return isFinite(d = position(d)) ? transform3(d + offset2) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon$1).attr("transform", function(d) {
        var p = this.parentNode.__axis;
        return transform3((p && isFinite(p = p(d)) ? p : position(d)) + offset2);
      });
    }
    tickExit.remove();
    path.attr("d", orient2 === left || orient2 === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset2 + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset2 + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset2 + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset2 + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d) {
      return transform3(position(d) + offset2);
    });
    line.attr(x + "2", k * tickSizeInner);
    text2.attr(x, k * spacing).text(format2);
    selection2.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient2 === right ? "start" : orient2 === left ? "end" : "middle");
    selection2.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_) {
    return arguments.length ? (scale = _, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis2;
  };
  axis2.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_) {
    return arguments.length ? (tickFormat2 = _, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis2) : tickPadding;
  };
  axis2.offset = function(_) {
    return arguments.length ? (offset2 = +_, axis2) : offset2;
  };
  return axis2;
}
function axisTop(scale) {
  return axis(top, scale);
}
function axisRight(scale) {
  return axis(right, scale);
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
const d3Axis = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  axisBottom,
  axisLeft,
  axisRight,
  axisTop
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$1j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$18(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$18(descriptor.key), descriptor);
  }
}
function _createClass$1h(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$18(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$18(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$18(arg) {
  var key = _toPrimitive$18(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$18(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$13(subClass, superClass);
}
function _setPrototypeOf$13(o, p) {
  _setPrototypeOf$13 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$13(o, p);
}
function _createSuper$13(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$13();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$13(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$13(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1e(this, result);
  };
}
function _possibleConstructorReturn$1e(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$13(self2);
}
function _assertThisInitialized$13(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$13() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$13(o) {
  _getPrototypeOf$13 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$13(o);
}
let SVGTrack = /* @__PURE__ */ function(_Track) {
  _inherits$1e(SVGTrack2, _Track);
  var _super = _createSuper$13(SVGTrack2);
  function SVGTrack2(context, options2) {
    var _this;
    _classCallCheck$1j(this, SVGTrack2);
    _this = _super.call(this, context, options2);
    const {
      svgElement
    } = context;
    _this.gMain = select$1(svgElement).append("g");
    _this.clipUid = slugid$1.nice();
    _this.clipRect = _this.gMain.append("clipPath").attr("id", `track-bounds-${_this.clipUid}`).append("rect");
    _this.gMain.attr("clip-path", `url(#track-bounds-${_this.clipUid})`);
    return _this;
  }
  _createClass$1h(SVGTrack2, [{
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.gMain.attr("transform", `translate(${this.position[0]},${this.position[1]})`);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      this._xScale.range([0, this.dimensions[0]]);
      this._yScale.range([0, this.dimensions[1]]);
      if (newDimensions[0] >= 0 && newDimensions[1] >= 0) {
        this.clipRect.attr("width", newDimensions[0]);
        this.clipRect.attr("height", newDimensions[1]);
      } else {
        this.clipRect.attr("width", 0);
        this.clipRect.attr("height", 0);
      }
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.gMain.remove();
      this.gMain = null;
    }
  }, {
    key: "draw",
    value: function draw() {
      return this;
    }
  }]);
  return SVGTrack2;
}(Track);
function _classCallCheck$1i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$17(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$17(descriptor.key), descriptor);
  }
}
function _createClass$1g(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$17(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$17(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$17(arg) {
  var key = _toPrimitive$17(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$17(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$v() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$v = Reflect.get.bind();
  } else {
    _get$v = function _get2(target, property2, receiver) {
      var base = _superPropBase$v(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$v.apply(this, arguments);
}
function _superPropBase$v(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$12(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$12(subClass, superClass);
}
function _setPrototypeOf$12(o, p) {
  _setPrototypeOf$12 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$12(o, p);
}
function _createSuper$12(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$12();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$12(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$12(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1d(this, result);
  };
}
function _possibleConstructorReturn$1d(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$12(self2);
}
function _assertThisInitialized$12(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$12() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$12(o) {
  _getPrototypeOf$12 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$12(o);
}
let TopAxisTrack = /* @__PURE__ */ function(_SVGTrack) {
  _inherits$1d(TopAxisTrack2, _SVGTrack);
  var _super = _createSuper$12(TopAxisTrack2);
  function TopAxisTrack2(context, options2) {
    var _this;
    _classCallCheck$1i(this, TopAxisTrack2);
    _this = _super.call(this, context, options2);
    _this.axis = axisTop(_this._xScale);
    _this.gAxis = _this.gMain.append("g");
    _this.tilesetInfo = true;
    return _this;
  }
  _createClass$1g(TopAxisTrack2, [{
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$v(_getPrototypeOf$12(TopAxisTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.axis.ticks(Math.ceil(this.dimensions[0] / 150));
      this.gAxis.attr("transform", `translate(0,${newDimensions[1]})`);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.axis.scale(this._xScale);
      this.gAxis.call(this.axis);
      return this;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _get$v(_getPrototypeOf$12(TopAxisTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.draw();
    }
  }]);
  return TopAxisTrack2;
}(SVGTrack);
function _classCallCheck$1h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$16(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$16(descriptor.key), descriptor);
  }
}
function _createClass$1f(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$16(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$16(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$16(arg) {
  var key = _toPrimitive$16(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$16(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$u() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$u = Reflect.get.bind();
  } else {
    _get$u = function _get2(target, property2, receiver) {
      var base = _superPropBase$u(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$u.apply(this, arguments);
}
function _superPropBase$u(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$11(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$11(subClass, superClass);
}
function _setPrototypeOf$11(o, p) {
  _setPrototypeOf$11 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$11(o, p);
}
function _createSuper$11(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$11();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$11(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$11(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1c(this, result);
  };
}
function _possibleConstructorReturn$1c(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$11(self2);
}
function _assertThisInitialized$11(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$11() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$11(o) {
  _getPrototypeOf$11 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$11(o);
}
let LeftAxisTrack = /* @__PURE__ */ function(_SVGTrack) {
  _inherits$1c(LeftAxisTrack2, _SVGTrack);
  var _super = _createSuper$11(LeftAxisTrack2);
  function LeftAxisTrack2(context, options2) {
    var _this;
    _classCallCheck$1h(this, LeftAxisTrack2);
    _this = _super.call(this, context, options2);
    _this.axis = axisLeft(_this._yScale);
    _this.gAxis = _this.gMain.append("g");
    _this.tilesetInfo = true;
    return _this;
  }
  _createClass$1f(LeftAxisTrack2, [{
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$u(_getPrototypeOf$11(LeftAxisTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.axis.ticks(Math.ceil(this.dimensions[1] / 150));
      this.gAxis.attr("transform", `translate(${newDimensions[0]},0)`);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.axis.scale(this._yScale);
      this.gAxis.call(this.axis);
      return this;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _get$u(_getPrototypeOf$11(LeftAxisTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.draw();
    }
  }]);
  return LeftAxisTrack2;
}(SVGTrack);
var pool$3 = {};
var twiddle = {};
var INT_BITS = 32;
twiddle.INT_BITS = INT_BITS;
twiddle.INT_MAX = 2147483647;
twiddle.INT_MIN = -1 << INT_BITS - 1;
twiddle.sign = function(v) {
  return (v > 0) - (v < 0);
};
twiddle.abs = function(v) {
  var mask = v >> INT_BITS - 1;
  return (v ^ mask) - mask;
};
twiddle.min = function(x, y) {
  return y ^ (x ^ y) & -(x < y);
};
twiddle.max = function(x, y) {
  return x ^ (x ^ y) & -(x < y);
};
twiddle.isPow2 = function(v) {
  return !(v & v - 1) && !!v;
};
twiddle.log2 = function(v) {
  var r2, shift2;
  r2 = (v > 65535) << 4;
  v >>>= r2;
  shift2 = (v > 255) << 3;
  v >>>= shift2;
  r2 |= shift2;
  shift2 = (v > 15) << 2;
  v >>>= shift2;
  r2 |= shift2;
  shift2 = (v > 3) << 1;
  v >>>= shift2;
  r2 |= shift2;
  return r2 | v >> 1;
};
twiddle.log10 = function(v) {
  return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
};
twiddle.popCount = function(v) {
  v = v - (v >>> 1 & 1431655765);
  v = (v & 858993459) + (v >>> 2 & 858993459);
  return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
};
function countTrailingZeros(v) {
  var c2 = 32;
  v &= -v;
  if (v)
    c2--;
  if (v & 65535)
    c2 -= 16;
  if (v & 16711935)
    c2 -= 8;
  if (v & 252645135)
    c2 -= 4;
  if (v & 858993459)
    c2 -= 2;
  if (v & 1431655765)
    c2 -= 1;
  return c2;
}
twiddle.countTrailingZeros = countTrailingZeros;
twiddle.nextPow2 = function(v) {
  v += v === 0;
  --v;
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v + 1;
};
twiddle.prevPow2 = function(v) {
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v - (v >>> 1);
};
twiddle.parity = function(v) {
  v ^= v >>> 16;
  v ^= v >>> 8;
  v ^= v >>> 4;
  v &= 15;
  return 27030 >>> v & 1;
};
var REVERSE_TABLE = new Array(256);
(function(tab) {
  for (var i = 0; i < 256; ++i) {
    var v = i, r2 = i, s = 7;
    for (v >>>= 1; v; v >>>= 1) {
      r2 <<= 1;
      r2 |= v & 1;
      --s;
    }
    tab[i] = r2 << s & 255;
  }
})(REVERSE_TABLE);
twiddle.reverse = function(v) {
  return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
};
twiddle.interleave2 = function(x, y) {
  x &= 65535;
  x = (x | x << 8) & 16711935;
  x = (x | x << 4) & 252645135;
  x = (x | x << 2) & 858993459;
  x = (x | x << 1) & 1431655765;
  y &= 65535;
  y = (y | y << 8) & 16711935;
  y = (y | y << 4) & 252645135;
  y = (y | y << 2) & 858993459;
  y = (y | y << 1) & 1431655765;
  return x | y << 1;
};
twiddle.deinterleave2 = function(v, n) {
  v = v >>> n & 1431655765;
  v = (v | v >>> 1) & 858993459;
  v = (v | v >>> 2) & 252645135;
  v = (v | v >>> 4) & 16711935;
  v = (v | v >>> 16) & 65535;
  return v << 16 >> 16;
};
twiddle.interleave3 = function(x, y, z) {
  x &= 1023;
  x = (x | x << 16) & 4278190335;
  x = (x | x << 8) & 251719695;
  x = (x | x << 4) & 3272356035;
  x = (x | x << 2) & 1227133513;
  y &= 1023;
  y = (y | y << 16) & 4278190335;
  y = (y | y << 8) & 251719695;
  y = (y | y << 4) & 3272356035;
  y = (y | y << 2) & 1227133513;
  x |= y << 1;
  z &= 1023;
  z = (z | z << 16) & 4278190335;
  z = (z | z << 8) & 251719695;
  z = (z | z << 4) & 3272356035;
  z = (z | z << 2) & 1227133513;
  return x | z << 2;
};
twiddle.deinterleave3 = function(v, n) {
  v = v >>> n & 1227133513;
  v = (v | v >>> 2) & 3272356035;
  v = (v | v >>> 4) & 251719695;
  v = (v | v >>> 8) & 4278190335;
  v = (v | v >>> 16) & 1023;
  return v << 22 >> 22;
};
twiddle.nextCombination = function(v) {
  var t = v | v - 1;
  return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
};
function dupe_array(count2, value2, i) {
  var c2 = count2[i] | 0;
  if (c2 <= 0) {
    return [];
  }
  var result = new Array(c2), j;
  if (i === count2.length - 1) {
    for (j = 0; j < c2; ++j) {
      result[j] = value2;
    }
  } else {
    for (j = 0; j < c2; ++j) {
      result[j] = dupe_array(count2, value2, i + 1);
    }
  }
  return result;
}
function dupe_number(count2, value2) {
  var result, i;
  result = new Array(count2);
  for (i = 0; i < count2; ++i) {
    result[i] = value2;
  }
  return result;
}
function dupe(count2, value2) {
  if (typeof value2 === "undefined") {
    value2 = 0;
  }
  switch (typeof count2) {
    case "number":
      if (count2 > 0) {
        return dupe_number(count2 | 0, value2);
      }
      break;
    case "object":
      if (typeof count2.length === "number") {
        return dupe_array(count2, value2, 0);
      }
      break;
  }
  return [];
}
var dup$1 = dupe;
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code$1.length; i < len; ++i) {
  lookup[i] = code$1[i];
  revLookup[code$1.charCodeAt(i)] = i;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var validLen = b64.indexOf("=");
  if (validLen === -1)
    validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 255;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start2, end2) {
  var tmp;
  var output = [];
  for (var i = start2; i < end2; i += 3) {
    tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (uint8[i + 2] & 255);
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var parts = [];
  var maxChunkLength = 16383;
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
  }
  return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer2, offset2, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer2[offset2 + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer2[offset2 + i], i += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer2, value2, offset2, isLE, mLen, nBytes) {
  var e, m, c2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value2 < 0 || value2 === 0 && 1 / value2 < 0 ? 1 : 0;
  value2 = Math.abs(value2);
  if (isNaN(value2) || value2 === Infinity) {
    m = isNaN(value2) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value2) / Math.LN2);
    if (value2 * (c2 = Math.pow(2, -e)) < 1) {
      e--;
      c2 *= 2;
    }
    if (e + eBias >= 1) {
      value2 += rt / c2;
    } else {
      value2 += rt * Math.pow(2, 1 - eBias);
    }
    if (value2 * c2 >= 2) {
      e++;
      c2 /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value2 * c2 - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value2 * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset2 + i] = m & 255, i += d, m /= 256, mLen -= 8) {
  }
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset2 + i] = e & 255, i += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset2 + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(exports2) {
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey3(descriptor.key), descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _toPropertyKey3(arg) {
    var key = _toPrimitive3(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive3(input, hint) {
    if (typeof input !== "object" || input === null)
      return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object")
        return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass)
      _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call2) {
    if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
      return call2;
    } else if (call2 !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  const base64 = base64Js;
  const ieee754$1 = ieee754;
  const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
  exports2.Buffer = Buffer2;
  exports2.SlowBuffer = SlowBuffer;
  exports2.INSPECT_MAX_BYTES = 50;
  const K_MAX_LENGTH = 2147483647;
  exports2.kMaxLength = K_MAX_LENGTH;
  Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
  if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
    console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  }
  function typedArraySupport() {
    try {
      const arr = new Uint8Array(1);
      const proto2 = {
        foo: function() {
          return 42;
        }
      };
      Object.setPrototypeOf(proto2, Uint8Array.prototype);
      Object.setPrototypeOf(arr, proto2);
      return arr.foo() === 42;
    } catch (e) {
      return false;
    }
  }
  Object.defineProperty(Buffer2.prototype, "parent", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.buffer;
    }
  });
  Object.defineProperty(Buffer2.prototype, "offset", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.byteOffset;
    }
  });
  function createBuffer(length2) {
    if (length2 > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length2 + '" is invalid for option "size"');
    }
    const buf = new Uint8Array(length2);
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function Buffer2(arg, encodingOrOffset, length2) {
    if (typeof arg === "number") {
      if (typeof encodingOrOffset === "string") {
        throw new TypeError('The "string" argument must be of type string. Received type number');
      }
      return allocUnsafe2(arg);
    }
    return from(arg, encodingOrOffset, length2);
  }
  Buffer2.poolSize = 8192;
  function from(value2, encodingOrOffset, length2) {
    if (typeof value2 === "string") {
      return fromString(value2, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value2)) {
      return fromArrayView(value2);
    }
    if (value2 == null) {
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value2);
    }
    if (isInstance(value2, ArrayBuffer) || value2 && isInstance(value2.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value2, encodingOrOffset, length2);
    }
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value2, SharedArrayBuffer) || value2 && isInstance(value2.buffer, SharedArrayBuffer))) {
      return fromArrayBuffer(value2, encodingOrOffset, length2);
    }
    if (typeof value2 === "number") {
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    }
    const valueOf = value2.valueOf && value2.valueOf();
    if (valueOf != null && valueOf !== value2) {
      return Buffer2.from(valueOf, encodingOrOffset, length2);
    }
    const b = fromObject(value2);
    if (b)
      return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value2[Symbol.toPrimitive] === "function") {
      return Buffer2.from(value2[Symbol.toPrimitive]("string"), encodingOrOffset, length2);
    }
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value2);
  }
  Buffer2.from = function(value2, encodingOrOffset, length2) {
    return from(value2, encodingOrOffset, length2);
  };
  Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
  Object.setPrototypeOf(Buffer2, Uint8Array);
  function assertSize(size) {
    if (typeof size !== "number") {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }
  function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== void 0) {
      return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }
  Buffer2.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
  };
  function allocUnsafe2(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }
  Buffer2.allocUnsafe = function(size) {
    return allocUnsafe2(size);
  };
  Buffer2.allocUnsafeSlow = function(size) {
    return allocUnsafe2(size);
  };
  function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") {
      encoding = "utf8";
    }
    if (!Buffer2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
    const length2 = byteLength2(string, encoding) | 0;
    let buf = createBuffer(length2);
    const actual = buf.write(string, encoding);
    if (actual !== length2) {
      buf = buf.slice(0, actual);
    }
    return buf;
  }
  function fromArrayLike(array2) {
    const length2 = array2.length < 0 ? 0 : checked(array2.length) | 0;
    const buf = createBuffer(length2);
    for (let i = 0; i < length2; i += 1) {
      buf[i] = array2[i] & 255;
    }
    return buf;
  }
  function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
      const copy2 = new Uint8Array(arrayView);
      return fromArrayBuffer(copy2.buffer, copy2.byteOffset, copy2.byteLength);
    }
    return fromArrayLike(arrayView);
  }
  function fromArrayBuffer(array2, byteOffset, length2) {
    if (byteOffset < 0 || array2.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array2.byteLength < byteOffset + (length2 || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    let buf;
    if (byteOffset === void 0 && length2 === void 0) {
      buf = new Uint8Array(array2);
    } else if (length2 === void 0) {
      buf = new Uint8Array(array2, byteOffset);
    } else {
      buf = new Uint8Array(array2, byteOffset, length2);
    }
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function fromObject(obj) {
    if (Buffer2.isBuffer(obj)) {
      const len = checked(obj.length) | 0;
      const buf = createBuffer(len);
      if (buf.length === 0) {
        return buf;
      }
      obj.copy(buf, 0, 0, len);
      return buf;
    }
    if (obj.length !== void 0) {
      if (typeof obj.length !== "number" || numberIsNaN2(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }
  function checked(length2) {
    if (length2 >= K_MAX_LENGTH) {
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    }
    return length2 | 0;
  }
  function SlowBuffer(length2) {
    if (+length2 != length2) {
      length2 = 0;
    }
    return Buffer2.alloc(+length2);
  }
  Buffer2.isBuffer = function isBuffer2(b) {
    return b != null && b._isBuffer === true && b !== Buffer2.prototype;
  };
  Buffer2.compare = function compare2(a, b) {
    if (isInstance(a, Uint8Array))
      a = Buffer2.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array))
      b = Buffer2.from(b, b.offset, b.byteLength);
    if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }
    if (a === b)
      return 0;
    let x = a.length;
    let y = b.length;
    for (let i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }
    if (x < y)
      return -1;
    if (y < x)
      return 1;
    return 0;
  };
  Buffer2.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  };
  Buffer2.concat = function concat2(list2, length2) {
    if (!Array.isArray(list2)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list2.length === 0) {
      return Buffer2.alloc(0);
    }
    let i;
    if (length2 === void 0) {
      length2 = 0;
      for (i = 0; i < list2.length; ++i) {
        length2 += list2[i].length;
      }
    }
    const buffer2 = Buffer2.allocUnsafe(length2);
    let pos = 0;
    for (i = 0; i < list2.length; ++i) {
      let buf = list2[i];
      if (isInstance(buf, Uint8Array)) {
        if (pos + buf.length > buffer2.length) {
          if (!Buffer2.isBuffer(buf))
            buf = Buffer2.from(buf);
          buf.copy(buffer2, pos);
        } else {
          Uint8Array.prototype.set.call(buffer2, buf, pos);
        }
      } else if (!Buffer2.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      } else {
        buf.copy(buffer2, pos);
      }
      pos += buf.length;
    }
    return buffer2;
  };
  function byteLength2(string, encoding) {
    if (Buffer2.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== "string") {
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    }
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0)
      return 0;
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "ascii":
        case "latin1":
        case "binary":
          return len;
        case "utf8":
        case "utf-8":
          return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return len * 2;
        case "hex":
          return len >>> 1;
        case "base64":
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length;
          }
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.byteLength = byteLength2;
  function slowToString(encoding, start2, end2) {
    let loweredCase = false;
    if (start2 === void 0 || start2 < 0) {
      start2 = 0;
    }
    if (start2 > this.length) {
      return "";
    }
    if (end2 === void 0 || end2 > this.length) {
      end2 = this.length;
    }
    if (end2 <= 0) {
      return "";
    }
    end2 >>>= 0;
    start2 >>>= 0;
    if (end2 <= start2) {
      return "";
    }
    if (!encoding)
      encoding = "utf8";
    while (true) {
      switch (encoding) {
        case "hex":
          return hexSlice(this, start2, end2);
        case "utf8":
        case "utf-8":
          return utf8Slice(this, start2, end2);
        case "ascii":
          return asciiSlice(this, start2, end2);
        case "latin1":
        case "binary":
          return latin1Slice(this, start2, end2);
        case "base64":
          return base64Slice(this, start2, end2);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16leSlice(this, start2, end2);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = (encoding + "").toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.prototype._isBuffer = true;
  function swap2(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
  }
  Buffer2.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    }
    for (let i = 0; i < len; i += 2) {
      swap2(this, i, i + 1);
    }
    return this;
  };
  Buffer2.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    }
    for (let i = 0; i < len; i += 4) {
      swap2(this, i, i + 3);
      swap2(this, i + 1, i + 2);
    }
    return this;
  };
  Buffer2.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    }
    for (let i = 0; i < len; i += 8) {
      swap2(this, i, i + 7);
      swap2(this, i + 1, i + 6);
      swap2(this, i + 2, i + 5);
      swap2(this, i + 3, i + 4);
    }
    return this;
  };
  Buffer2.prototype.toString = function toString3() {
    const length2 = this.length;
    if (length2 === 0)
      return "";
    if (arguments.length === 0)
      return utf8Slice(this, 0, length2);
    return slowToString.apply(this, arguments);
  };
  Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
  Buffer2.prototype.equals = function equals(b) {
    if (!Buffer2.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    if (this === b)
      return true;
    return Buffer2.compare(this, b) === 0;
  };
  Buffer2.prototype.inspect = function inspect2() {
    let str = "";
    const max2 = exports2.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max2)
      str += " ... ";
    return "<Buffer " + str + ">";
  };
  if (customInspectSymbol) {
    Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
  }
  Buffer2.prototype.compare = function compare2(target, start2, end2, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer2.from(target, target.offset, target.byteLength);
    }
    if (!Buffer2.isBuffer(target)) {
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    }
    if (start2 === void 0) {
      start2 = 0;
    }
    if (end2 === void 0) {
      end2 = target ? target.length : 0;
    }
    if (thisStart === void 0) {
      thisStart = 0;
    }
    if (thisEnd === void 0) {
      thisEnd = this.length;
    }
    if (start2 < 0 || end2 > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError("out of range index");
    }
    if (thisStart >= thisEnd && start2 >= end2) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start2 >= end2) {
      return 1;
    }
    start2 >>>= 0;
    end2 >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
      return 0;
    let x = thisEnd - thisStart;
    let y = end2 - start2;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start2, end2);
    for (let i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
      }
    }
    if (x < y)
      return -1;
    if (y < x)
      return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer2, val2, byteOffset, encoding, dir) {
    if (buffer2.length === 0)
      return -1;
    if (typeof byteOffset === "string") {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 2147483647) {
      byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
      byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN2(byteOffset)) {
      byteOffset = dir ? 0 : buffer2.length - 1;
    }
    if (byteOffset < 0)
      byteOffset = buffer2.length + byteOffset;
    if (byteOffset >= buffer2.length) {
      if (dir)
        return -1;
      else
        byteOffset = buffer2.length - 1;
    } else if (byteOffset < 0) {
      if (dir)
        byteOffset = 0;
      else
        return -1;
    }
    if (typeof val2 === "string") {
      val2 = Buffer2.from(val2, encoding);
    }
    if (Buffer2.isBuffer(val2)) {
      if (val2.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer2, val2, byteOffset, encoding, dir);
    } else if (typeof val2 === "number") {
      val2 = val2 & 255;
      if (typeof Uint8Array.prototype.indexOf === "function") {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer2, val2, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer2, val2, byteOffset);
        }
      }
      return arrayIndexOf(buffer2, [val2], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
  }
  function arrayIndexOf(arr, val2, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val2.length;
    if (encoding !== void 0) {
      encoding = String(encoding).toLowerCase();
      if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
        if (arr.length < 2 || val2.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i2) {
      if (indexSize === 1) {
        return buf[i2];
      } else {
        return buf.readUInt16BE(i2 * indexSize);
      }
    }
    let i;
    if (dir) {
      let foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val2, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1)
            foundIndex = i;
          if (i - foundIndex + 1 === valLength)
            return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1)
            i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength)
        byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        let found = true;
        for (let j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val2, j)) {
            found = false;
            break;
          }
        }
        if (found)
          return i;
      }
    }
    return -1;
  }
  Buffer2.prototype.includes = function includes(val2, byteOffset, encoding) {
    return this.indexOf(val2, byteOffset, encoding) !== -1;
  };
  Buffer2.prototype.indexOf = function indexOf2(val2, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val2, byteOffset, encoding, true);
  };
  Buffer2.prototype.lastIndexOf = function lastIndexOf(val2, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val2, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset2, length2) {
    offset2 = Number(offset2) || 0;
    const remaining = buf.length - offset2;
    if (!length2) {
      length2 = remaining;
    } else {
      length2 = Number(length2);
      if (length2 > remaining) {
        length2 = remaining;
      }
    }
    const strLen = string.length;
    if (length2 > strLen / 2) {
      length2 = strLen / 2;
    }
    let i;
    for (i = 0; i < length2; ++i) {
      const parsed = parseInt(string.substr(i * 2, 2), 16);
      if (numberIsNaN2(parsed))
        return i;
      buf[offset2 + i] = parsed;
    }
    return i;
  }
  function utf8Write(buf, string, offset2, length2) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset2), buf, offset2, length2);
  }
  function asciiWrite(buf, string, offset2, length2) {
    return blitBuffer(asciiToBytes(string), buf, offset2, length2);
  }
  function base64Write(buf, string, offset2, length2) {
    return blitBuffer(base64ToBytes(string), buf, offset2, length2);
  }
  function ucs2Write(buf, string, offset2, length2) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset2), buf, offset2, length2);
  }
  Buffer2.prototype.write = function write(string, offset2, length2, encoding) {
    if (offset2 === void 0) {
      encoding = "utf8";
      length2 = this.length;
      offset2 = 0;
    } else if (length2 === void 0 && typeof offset2 === "string") {
      encoding = offset2;
      length2 = this.length;
      offset2 = 0;
    } else if (isFinite(offset2)) {
      offset2 = offset2 >>> 0;
      if (isFinite(length2)) {
        length2 = length2 >>> 0;
        if (encoding === void 0)
          encoding = "utf8";
      } else {
        encoding = length2;
        length2 = void 0;
      }
    } else {
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    }
    const remaining = this.length - offset2;
    if (length2 === void 0 || length2 > remaining)
      length2 = remaining;
    if (string.length > 0 && (length2 < 0 || offset2 < 0) || offset2 > this.length) {
      throw new RangeError("Attempt to write outside buffer bounds");
    }
    if (!encoding)
      encoding = "utf8";
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "hex":
          return hexWrite(this, string, offset2, length2);
        case "utf8":
        case "utf-8":
          return utf8Write(this, string, offset2, length2);
        case "ascii":
        case "latin1":
        case "binary":
          return asciiWrite(this, string, offset2, length2);
        case "base64":
          return base64Write(this, string, offset2, length2);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ucs2Write(this, string, offset2, length2);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer2.prototype.toJSON = function toJSON2() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function base64Slice(buf, start2, end2) {
    if (start2 === 0 && end2 === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start2, end2));
    }
  }
  function utf8Slice(buf, start2, end2) {
    end2 = Math.min(buf.length, end2);
    const res = [];
    let i = start2;
    while (i < end2) {
      const firstByte = buf[i];
      let codePoint = null;
      let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
      if (i + bytesPerSequence <= end2) {
        let secondByte, thirdByte, fourthByte, tempCodePoint;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 128) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 192) === 128) {
              tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
              if (tempCodePoint > 127) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
              if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
              if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 65533;
        bytesPerSequence = 1;
      } else if (codePoint > 65535) {
        codePoint -= 65536;
        res.push(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      res.push(codePoint);
      i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  const MAX_ARGUMENTS_LENGTH = 4096;
  function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    let res = "";
    let i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }
  function asciiSlice(buf, start2, end2) {
    let ret = "";
    end2 = Math.min(buf.length, end2);
    for (let i = start2; i < end2; ++i) {
      ret += String.fromCharCode(buf[i] & 127);
    }
    return ret;
  }
  function latin1Slice(buf, start2, end2) {
    let ret = "";
    end2 = Math.min(buf.length, end2);
    for (let i = start2; i < end2; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret;
  }
  function hexSlice(buf, start2, end2) {
    const len = buf.length;
    if (!start2 || start2 < 0)
      start2 = 0;
    if (!end2 || end2 < 0 || end2 > len)
      end2 = len;
    let out = "";
    for (let i = start2; i < end2; ++i) {
      out += hexSliceLookupTable[buf[i]];
    }
    return out;
  }
  function utf16leSlice(buf, start2, end2) {
    const bytes = buf.slice(start2, end2);
    let res = "";
    for (let i = 0; i < bytes.length - 1; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
  }
  Buffer2.prototype.slice = function slice2(start2, end2) {
    const len = this.length;
    start2 = ~~start2;
    end2 = end2 === void 0 ? len : ~~end2;
    if (start2 < 0) {
      start2 += len;
      if (start2 < 0)
        start2 = 0;
    } else if (start2 > len) {
      start2 = len;
    }
    if (end2 < 0) {
      end2 += len;
      if (end2 < 0)
        end2 = 0;
    } else if (end2 > len) {
      end2 = len;
    }
    if (end2 < start2)
      end2 = start2;
    const newBuf = this.subarray(start2, end2);
    Object.setPrototypeOf(newBuf, Buffer2.prototype);
    return newBuf;
  };
  function checkOffset(offset2, ext, length2) {
    if (offset2 % 1 !== 0 || offset2 < 0)
      throw new RangeError("offset is not uint");
    if (offset2 + ext > length2)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset2, byteLength3, noAssert) {
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset2, byteLength3, this.length);
    let val2 = this[offset2];
    let mul = 1;
    let i = 0;
    while (++i < byteLength3 && (mul *= 256)) {
      val2 += this[offset2 + i] * mul;
    }
    return val2;
  };
  Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset2, byteLength3, noAssert) {
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      checkOffset(offset2, byteLength3, this.length);
    }
    let val2 = this[offset2 + --byteLength3];
    let mul = 1;
    while (byteLength3 > 0 && (mul *= 256)) {
      val2 += this[offset2 + --byteLength3] * mul;
    }
    return val2;
  };
  Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 1, this.length);
    return this[offset2];
  };
  Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 2, this.length);
    return this[offset2] | this[offset2 + 1] << 8;
  };
  Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 2, this.length);
    return this[offset2] << 8 | this[offset2 + 1];
  };
  Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return (this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16) + this[offset2 + 3] * 16777216;
  };
  Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return this[offset2] * 16777216 + (this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3]);
  };
  Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset2) {
    offset2 = offset2 >>> 0;
    validateNumber(offset2, "offset");
    const first2 = this[offset2];
    const last2 = this[offset2 + 7];
    if (first2 === void 0 || last2 === void 0) {
      boundsError(offset2, this.length - 8);
    }
    const lo = first2 + this[++offset2] * 2 ** 8 + this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 24;
    const hi = this[++offset2] + this[++offset2] * 2 ** 8 + this[++offset2] * 2 ** 16 + last2 * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
  });
  Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset2) {
    offset2 = offset2 >>> 0;
    validateNumber(offset2, "offset");
    const first2 = this[offset2];
    const last2 = this[offset2 + 7];
    if (first2 === void 0 || last2 === void 0) {
      boundsError(offset2, this.length - 8);
    }
    const hi = first2 * 2 ** 24 + this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 8 + this[++offset2];
    const lo = this[++offset2] * 2 ** 24 + this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 8 + last2;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
  });
  Buffer2.prototype.readIntLE = function readIntLE(offset2, byteLength3, noAssert) {
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset2, byteLength3, this.length);
    let val2 = this[offset2];
    let mul = 1;
    let i = 0;
    while (++i < byteLength3 && (mul *= 256)) {
      val2 += this[offset2 + i] * mul;
    }
    mul *= 128;
    if (val2 >= mul)
      val2 -= Math.pow(2, 8 * byteLength3);
    return val2;
  };
  Buffer2.prototype.readIntBE = function readIntBE(offset2, byteLength3, noAssert) {
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset2, byteLength3, this.length);
    let i = byteLength3;
    let mul = 1;
    let val2 = this[offset2 + --i];
    while (i > 0 && (mul *= 256)) {
      val2 += this[offset2 + --i] * mul;
    }
    mul *= 128;
    if (val2 >= mul)
      val2 -= Math.pow(2, 8 * byteLength3);
    return val2;
  };
  Buffer2.prototype.readInt8 = function readInt8(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 1, this.length);
    if (!(this[offset2] & 128))
      return this[offset2];
    return (255 - this[offset2] + 1) * -1;
  };
  Buffer2.prototype.readInt16LE = function readInt16LE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 2, this.length);
    const val2 = this[offset2] | this[offset2 + 1] << 8;
    return val2 & 32768 ? val2 | 4294901760 : val2;
  };
  Buffer2.prototype.readInt16BE = function readInt16BE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 2, this.length);
    const val2 = this[offset2 + 1] | this[offset2] << 8;
    return val2 & 32768 ? val2 | 4294901760 : val2;
  };
  Buffer2.prototype.readInt32LE = function readInt32LE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return this[offset2] | this[offset2 + 1] << 8 | this[offset2 + 2] << 16 | this[offset2 + 3] << 24;
  };
  Buffer2.prototype.readInt32BE = function readInt32BE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return this[offset2] << 24 | this[offset2 + 1] << 16 | this[offset2 + 2] << 8 | this[offset2 + 3];
  };
  Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset2) {
    offset2 = offset2 >>> 0;
    validateNumber(offset2, "offset");
    const first2 = this[offset2];
    const last2 = this[offset2 + 7];
    if (first2 === void 0 || last2 === void 0) {
      boundsError(offset2, this.length - 8);
    }
    const val2 = this[offset2 + 4] + this[offset2 + 5] * 2 ** 8 + this[offset2 + 6] * 2 ** 16 + (last2 << 24);
    return (BigInt(val2) << BigInt(32)) + BigInt(first2 + this[++offset2] * 2 ** 8 + this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 24);
  });
  Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset2) {
    offset2 = offset2 >>> 0;
    validateNumber(offset2, "offset");
    const first2 = this[offset2];
    const last2 = this[offset2 + 7];
    if (first2 === void 0 || last2 === void 0) {
      boundsError(offset2, this.length - 8);
    }
    const val2 = (first2 << 24) + // Overflow
    this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 8 + this[++offset2];
    return (BigInt(val2) << BigInt(32)) + BigInt(this[++offset2] * 2 ** 24 + this[++offset2] * 2 ** 16 + this[++offset2] * 2 ** 8 + last2);
  });
  Buffer2.prototype.readFloatLE = function readFloatLE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return ieee754$1.read(this, offset2, true, 23, 4);
  };
  Buffer2.prototype.readFloatBE = function readFloatBE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 4, this.length);
    return ieee754$1.read(this, offset2, false, 23, 4);
  };
  Buffer2.prototype.readDoubleLE = function readDoubleLE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 8, this.length);
    return ieee754$1.read(this, offset2, true, 52, 8);
  };
  Buffer2.prototype.readDoubleBE = function readDoubleBE(offset2, noAssert) {
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkOffset(offset2, 8, this.length);
    return ieee754$1.read(this, offset2, false, 52, 8);
  };
  function checkInt(buf, value2, offset2, ext, max2, min2) {
    if (!Buffer2.isBuffer(buf))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value2 > max2 || value2 < min2)
      throw new RangeError('"value" argument is out of bounds');
    if (offset2 + ext > buf.length)
      throw new RangeError("Index out of range");
  }
  Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value2, offset2, byteLength3, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value2, offset2, byteLength3, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset2] = value2 & 255;
    while (++i < byteLength3 && (mul *= 256)) {
      this[offset2 + i] = value2 / mul & 255;
    }
    return offset2 + byteLength3;
  };
  Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value2, offset2, byteLength3, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value2, offset2, byteLength3, maxBytes, 0);
    }
    let i = byteLength3 - 1;
    let mul = 1;
    this[offset2 + i] = value2 & 255;
    while (--i >= 0 && (mul *= 256)) {
      this[offset2 + i] = value2 / mul & 255;
    }
    return offset2 + byteLength3;
  };
  Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 1, 255, 0);
    this[offset2] = value2 & 255;
    return offset2 + 1;
  };
  Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 2, 65535, 0);
    this[offset2] = value2 & 255;
    this[offset2 + 1] = value2 >>> 8;
    return offset2 + 2;
  };
  Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 2, 65535, 0);
    this[offset2] = value2 >>> 8;
    this[offset2 + 1] = value2 & 255;
    return offset2 + 2;
  };
  Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 4, 4294967295, 0);
    this[offset2 + 3] = value2 >>> 24;
    this[offset2 + 2] = value2 >>> 16;
    this[offset2 + 1] = value2 >>> 8;
    this[offset2] = value2 & 255;
    return offset2 + 4;
  };
  Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 4, 4294967295, 0);
    this[offset2] = value2 >>> 24;
    this[offset2 + 1] = value2 >>> 16;
    this[offset2 + 2] = value2 >>> 8;
    this[offset2 + 3] = value2 & 255;
    return offset2 + 4;
  };
  function wrtBigUInt64LE(buf, value2, offset2, min2, max2) {
    checkIntBI(value2, min2, max2, buf, offset2, 7);
    let lo = Number(value2 & BigInt(4294967295));
    buf[offset2++] = lo;
    lo = lo >> 8;
    buf[offset2++] = lo;
    lo = lo >> 8;
    buf[offset2++] = lo;
    lo = lo >> 8;
    buf[offset2++] = lo;
    let hi = Number(value2 >> BigInt(32) & BigInt(4294967295));
    buf[offset2++] = hi;
    hi = hi >> 8;
    buf[offset2++] = hi;
    hi = hi >> 8;
    buf[offset2++] = hi;
    hi = hi >> 8;
    buf[offset2++] = hi;
    return offset2;
  }
  function wrtBigUInt64BE(buf, value2, offset2, min2, max2) {
    checkIntBI(value2, min2, max2, buf, offset2, 7);
    let lo = Number(value2 & BigInt(4294967295));
    buf[offset2 + 7] = lo;
    lo = lo >> 8;
    buf[offset2 + 6] = lo;
    lo = lo >> 8;
    buf[offset2 + 5] = lo;
    lo = lo >> 8;
    buf[offset2 + 4] = lo;
    let hi = Number(value2 >> BigInt(32) & BigInt(4294967295));
    buf[offset2 + 3] = hi;
    hi = hi >> 8;
    buf[offset2 + 2] = hi;
    hi = hi >> 8;
    buf[offset2 + 1] = hi;
    hi = hi >> 8;
    buf[offset2] = hi;
    return offset2 + 8;
  }
  Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value2, offset2 = 0) {
    return wrtBigUInt64LE(this, value2, offset2, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value2, offset2 = 0) {
    return wrtBigUInt64BE(this, value2, offset2, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeIntLE = function writeIntLE(value2, offset2, byteLength3, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert) {
      const limit2 = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value2, offset2, byteLength3, limit2 - 1, -limit2);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset2] = value2 & 255;
    while (++i < byteLength3 && (mul *= 256)) {
      if (value2 < 0 && sub === 0 && this[offset2 + i - 1] !== 0) {
        sub = 1;
      }
      this[offset2 + i] = (value2 / mul >> 0) - sub & 255;
    }
    return offset2 + byteLength3;
  };
  Buffer2.prototype.writeIntBE = function writeIntBE(value2, offset2, byteLength3, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert) {
      const limit2 = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value2, offset2, byteLength3, limit2 - 1, -limit2);
    }
    let i = byteLength3 - 1;
    let mul = 1;
    let sub = 0;
    this[offset2 + i] = value2 & 255;
    while (--i >= 0 && (mul *= 256)) {
      if (value2 < 0 && sub === 0 && this[offset2 + i + 1] !== 0) {
        sub = 1;
      }
      this[offset2 + i] = (value2 / mul >> 0) - sub & 255;
    }
    return offset2 + byteLength3;
  };
  Buffer2.prototype.writeInt8 = function writeInt8(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 1, 127, -128);
    if (value2 < 0)
      value2 = 255 + value2 + 1;
    this[offset2] = value2 & 255;
    return offset2 + 1;
  };
  Buffer2.prototype.writeInt16LE = function writeInt16LE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 2, 32767, -32768);
    this[offset2] = value2 & 255;
    this[offset2 + 1] = value2 >>> 8;
    return offset2 + 2;
  };
  Buffer2.prototype.writeInt16BE = function writeInt16BE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 2, 32767, -32768);
    this[offset2] = value2 >>> 8;
    this[offset2 + 1] = value2 & 255;
    return offset2 + 2;
  };
  Buffer2.prototype.writeInt32LE = function writeInt32LE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 4, 2147483647, -2147483648);
    this[offset2] = value2 & 255;
    this[offset2 + 1] = value2 >>> 8;
    this[offset2 + 2] = value2 >>> 16;
    this[offset2 + 3] = value2 >>> 24;
    return offset2 + 4;
  };
  Buffer2.prototype.writeInt32BE = function writeInt32BE(value2, offset2, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert)
      checkInt(this, value2, offset2, 4, 2147483647, -2147483648);
    if (value2 < 0)
      value2 = 4294967295 + value2 + 1;
    this[offset2] = value2 >>> 24;
    this[offset2 + 1] = value2 >>> 16;
    this[offset2 + 2] = value2 >>> 8;
    this[offset2 + 3] = value2 & 255;
    return offset2 + 4;
  };
  Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value2, offset2 = 0) {
    return wrtBigUInt64LE(this, value2, offset2, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value2, offset2 = 0) {
    return wrtBigUInt64BE(this, value2, offset2, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function checkIEEE754(buf, value2, offset2, ext, max2, min2) {
    if (offset2 + ext > buf.length)
      throw new RangeError("Index out of range");
    if (offset2 < 0)
      throw new RangeError("Index out of range");
  }
  function writeFloat(buf, value2, offset2, littleEndian, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value2, offset2, 4);
    }
    ieee754$1.write(buf, value2, offset2, littleEndian, 23, 4);
    return offset2 + 4;
  }
  Buffer2.prototype.writeFloatLE = function writeFloatLE(value2, offset2, noAssert) {
    return writeFloat(this, value2, offset2, true, noAssert);
  };
  Buffer2.prototype.writeFloatBE = function writeFloatBE(value2, offset2, noAssert) {
    return writeFloat(this, value2, offset2, false, noAssert);
  };
  function writeDouble(buf, value2, offset2, littleEndian, noAssert) {
    value2 = +value2;
    offset2 = offset2 >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value2, offset2, 8);
    }
    ieee754$1.write(buf, value2, offset2, littleEndian, 52, 8);
    return offset2 + 8;
  }
  Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value2, offset2, noAssert) {
    return writeDouble(this, value2, offset2, true, noAssert);
  };
  Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value2, offset2, noAssert) {
    return writeDouble(this, value2, offset2, false, noAssert);
  };
  Buffer2.prototype.copy = function copy2(target, targetStart, start2, end2) {
    if (!Buffer2.isBuffer(target))
      throw new TypeError("argument should be a Buffer");
    if (!start2)
      start2 = 0;
    if (!end2 && end2 !== 0)
      end2 = this.length;
    if (targetStart >= target.length)
      targetStart = target.length;
    if (!targetStart)
      targetStart = 0;
    if (end2 > 0 && end2 < start2)
      end2 = start2;
    if (end2 === start2)
      return 0;
    if (target.length === 0 || this.length === 0)
      return 0;
    if (targetStart < 0) {
      throw new RangeError("targetStart out of bounds");
    }
    if (start2 < 0 || start2 >= this.length)
      throw new RangeError("Index out of range");
    if (end2 < 0)
      throw new RangeError("sourceEnd out of bounds");
    if (end2 > this.length)
      end2 = this.length;
    if (target.length - targetStart < end2 - start2) {
      end2 = target.length - targetStart + start2;
    }
    const len = end2 - start2;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
      this.copyWithin(targetStart, start2, end2);
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start2, end2), targetStart);
    }
    return len;
  };
  Buffer2.prototype.fill = function fill(val2, start2, end2, encoding) {
    if (typeof val2 === "string") {
      if (typeof start2 === "string") {
        encoding = start2;
        start2 = 0;
        end2 = this.length;
      } else if (typeof end2 === "string") {
        encoding = end2;
        end2 = this.length;
      }
      if (encoding !== void 0 && typeof encoding !== "string") {
        throw new TypeError("encoding must be a string");
      }
      if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      if (val2.length === 1) {
        const code2 = val2.charCodeAt(0);
        if (encoding === "utf8" && code2 < 128 || encoding === "latin1") {
          val2 = code2;
        }
      }
    } else if (typeof val2 === "number") {
      val2 = val2 & 255;
    } else if (typeof val2 === "boolean") {
      val2 = Number(val2);
    }
    if (start2 < 0 || this.length < start2 || this.length < end2) {
      throw new RangeError("Out of range index");
    }
    if (end2 <= start2) {
      return this;
    }
    start2 = start2 >>> 0;
    end2 = end2 === void 0 ? this.length : end2 >>> 0;
    if (!val2)
      val2 = 0;
    let i;
    if (typeof val2 === "number") {
      for (i = start2; i < end2; ++i) {
        this[i] = val2;
      }
    } else {
      const bytes = Buffer2.isBuffer(val2) ? val2 : Buffer2.from(val2, encoding);
      const len = bytes.length;
      if (len === 0) {
        throw new TypeError('The value "' + val2 + '" is invalid for argument "value"');
      }
      for (i = 0; i < end2 - start2; ++i) {
        this[i + start2] = bytes[i % len];
      }
    }
    return this;
  };
  const errors = {};
  function E2(sym, getMessage, Base) {
    errors[sym] = /* @__PURE__ */ function(_Base) {
      _inherits2(NodeError, _Base);
      var _super = _createSuper2(NodeError);
      function NodeError() {
        var _this;
        _classCallCheck2(this, NodeError);
        _this = _super.call(this);
        Object.defineProperty(_assertThisInitialized2(_this), "message", {
          value: getMessage.apply(_assertThisInitialized2(_this), arguments),
          writable: true,
          configurable: true
        });
        _this.name = `${_this.name} [${sym}]`;
        _this.stack;
        delete _this.name;
        return _this;
      }
      _createClass2(NodeError, [{
        key: "code",
        get: function() {
          return sym;
        },
        set: function(value2) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value: value2,
            writable: true
          });
        }
      }, {
        key: "toString",
        value: function toString3() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      }]);
      return NodeError;
    }(Base);
  }
  E2("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) {
      return `${name} is outside of buffer bounds`;
    }
    return "Attempt to access memory outside buffer bounds";
  }, RangeError);
  E2("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
  }, TypeError);
  E2("ERR_OUT_OF_RANGE", function(str, range2, input) {
    let msg2 = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input));
    } else if (typeof input === "bigint") {
      received = String(input);
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received);
      }
      received += "n";
    }
    msg2 += ` It must be ${range2}. Received ${received}`;
    return msg2;
  }, RangeError);
  function addNumericalSeparator(val2) {
    let res = "";
    let i = val2.length;
    const start2 = val2[0] === "-" ? 1 : 0;
    for (; i >= start2 + 4; i -= 3) {
      res = `_${val2.slice(i - 3, i)}${res}`;
    }
    return `${val2.slice(0, i)}${res}`;
  }
  function checkBounds(buf, offset2, byteLength3) {
    validateNumber(offset2, "offset");
    if (buf[offset2] === void 0 || buf[offset2 + byteLength3] === void 0) {
      boundsError(offset2, buf.length - (byteLength3 + 1));
    }
  }
  function checkIntBI(value2, min2, max2, buf, offset2, byteLength3) {
    if (value2 > max2 || value2 < min2) {
      const n = typeof min2 === "bigint" ? "n" : "";
      let range2;
      if (byteLength3 > 3) {
        if (min2 === 0 || min2 === BigInt(0)) {
          range2 = `>= 0${n} and < 2${n} ** ${(byteLength3 + 1) * 8}${n}`;
        } else {
          range2 = `>= -(2${n} ** ${(byteLength3 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength3 + 1) * 8 - 1}${n}`;
        }
      } else {
        range2 = `>= ${min2}${n} and <= ${max2}${n}`;
      }
      throw new errors.ERR_OUT_OF_RANGE("value", range2, value2);
    }
    checkBounds(buf, offset2, byteLength3);
  }
  function validateNumber(value2, name) {
    if (typeof value2 !== "number") {
      throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value2);
    }
  }
  function boundsError(value2, length2, type3) {
    if (Math.floor(value2) !== value2) {
      validateNumber(value2, type3);
      throw new errors.ERR_OUT_OF_RANGE(type3 || "offset", "an integer", value2);
    }
    if (length2 < 0) {
      throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(type3 || "offset", `>= ${type3 ? 1 : 0} and <= ${length2}`, value2);
  }
  const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = str.split("=")[0];
    str = str.trim().replace(INVALID_BASE64_RE, "");
    if (str.length < 2)
      return "";
    while (str.length % 4 !== 0) {
      str = str + "=";
    }
    return str;
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length2 = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for (let i = 0; i < length2; ++i) {
      codePoint = string.charCodeAt(i);
      if (codePoint > 55295 && codePoint < 57344) {
        if (!leadSurrogate) {
          if (codePoint > 56319) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          } else if (i + 1 === length2) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 56320) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1)
          bytes.push(239, 191, 189);
      }
      leadSurrogate = null;
      if (codePoint < 128) {
        if ((units -= 1) < 0)
          break;
        bytes.push(codePoint);
      } else if (codePoint < 2048) {
        if ((units -= 2) < 0)
          break;
        bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
      } else if (codePoint < 65536) {
        if ((units -= 3) < 0)
          break;
        bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else if (codePoint < 1114112) {
        if ((units -= 4) < 0)
          break;
        bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else {
        throw new Error("Invalid code point");
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    const byteArray = [];
    for (let i = 0; i < str.length; ++i) {
      byteArray.push(str.charCodeAt(i) & 255);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    let c2, hi, lo;
    const byteArray = [];
    for (let i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0)
        break;
      c2 = str.charCodeAt(i);
      hi = c2 >> 8;
      lo = c2 % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }
  function blitBuffer(src2, dst, offset2, length2) {
    let i;
    for (i = 0; i < length2; ++i) {
      if (i + offset2 >= dst.length || i >= src2.length)
        break;
      dst[i + offset2] = src2[i];
    }
    return i;
  }
  function isInstance(obj, type3) {
    return obj instanceof type3 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type3.name;
  }
  function numberIsNaN2(obj) {
    return obj !== obj;
  }
  const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for (let i = 0; i < 16; ++i) {
      const i16 = i * 16;
      for (let j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[i] + alphabet[j];
      }
    }
    return table;
  }();
  function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
  }
  function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
  }
})(buffer);
var bits$2 = twiddle;
var dup = dup$1;
var Buffer$3 = buffer.Buffer;
if (!globalThis.__TYPEDARRAY_POOL) {
  globalThis.__TYPEDARRAY_POOL = {
    UINT8: dup([32, 0]),
    UINT16: dup([32, 0]),
    UINT32: dup([32, 0]),
    BIGUINT64: dup([32, 0]),
    INT8: dup([32, 0]),
    INT16: dup([32, 0]),
    INT32: dup([32, 0]),
    BIGINT64: dup([32, 0]),
    FLOAT: dup([32, 0]),
    DOUBLE: dup([32, 0]),
    DATA: dup([32, 0]),
    UINT8C: dup([32, 0]),
    BUFFER: dup([32, 0])
  };
}
var hasUint8C = typeof Uint8ClampedArray !== "undefined";
var hasBigUint64 = typeof BigUint64Array !== "undefined";
var hasBigInt64 = typeof BigInt64Array !== "undefined";
var POOL = globalThis.__TYPEDARRAY_POOL;
if (!POOL.UINT8C) {
  POOL.UINT8C = dup([32, 0]);
}
if (!POOL.BIGUINT64) {
  POOL.BIGUINT64 = dup([32, 0]);
}
if (!POOL.BIGINT64) {
  POOL.BIGINT64 = dup([32, 0]);
}
if (!POOL.BUFFER) {
  POOL.BUFFER = dup([32, 0]);
}
var DATA = POOL.DATA, BUFFER = POOL.BUFFER;
pool$3.free = function free(array2) {
  if (Buffer$3.isBuffer(array2)) {
    BUFFER[bits$2.log2(array2.length)].push(array2);
  } else {
    if (Object.prototype.toString.call(array2) !== "[object ArrayBuffer]") {
      array2 = array2.buffer;
    }
    if (!array2) {
      return;
    }
    var n = array2.length || array2.byteLength;
    var log_n = bits$2.log2(n) | 0;
    DATA[log_n].push(array2);
  }
};
function freeArrayBuffer(buffer2) {
  if (!buffer2) {
    return;
  }
  var n = buffer2.length || buffer2.byteLength;
  var log_n = bits$2.log2(n);
  DATA[log_n].push(buffer2);
}
function freeTypedArray(array2) {
  freeArrayBuffer(array2.buffer);
}
pool$3.freeUint8 = pool$3.freeUint16 = pool$3.freeUint32 = pool$3.freeBigUint64 = pool$3.freeInt8 = pool$3.freeInt16 = pool$3.freeInt32 = pool$3.freeBigInt64 = pool$3.freeFloat32 = pool$3.freeFloat = pool$3.freeFloat64 = pool$3.freeDouble = pool$3.freeUint8Clamped = pool$3.freeDataView = freeTypedArray;
pool$3.freeArrayBuffer = freeArrayBuffer;
pool$3.freeBuffer = function freeBuffer(array2) {
  BUFFER[bits$2.log2(array2.length)].push(array2);
};
pool$3.malloc = function malloc(n, dtype) {
  if (dtype === void 0 || dtype === "arraybuffer") {
    return mallocArrayBuffer(n);
  } else {
    switch (dtype) {
      case "uint8":
        return mallocUint8(n);
      case "uint16":
        return mallocUint16(n);
      case "uint32":
        return mallocUint32(n);
      case "int8":
        return mallocInt8(n);
      case "int16":
        return mallocInt16(n);
      case "int32":
        return mallocInt32(n);
      case "float":
      case "float32":
        return mallocFloat(n);
      case "double":
      case "float64":
        return mallocDouble(n);
      case "uint8_clamped":
        return mallocUint8Clamped(n);
      case "bigint64":
        return mallocBigInt64(n);
      case "biguint64":
        return mallocBigUint64(n);
      case "buffer":
        return mallocBuffer(n);
      case "data":
      case "dataview":
        return mallocDataView(n);
      default:
        return null;
    }
  }
  return null;
};
function mallocArrayBuffer(n) {
  var n = bits$2.nextPow2(n);
  var log_n = bits$2.log2(n);
  var d = DATA[log_n];
  if (d.length > 0) {
    return d.pop();
  }
  return new ArrayBuffer(n);
}
pool$3.mallocArrayBuffer = mallocArrayBuffer;
function mallocUint8(n) {
  return new Uint8Array(mallocArrayBuffer(n), 0, n);
}
pool$3.mallocUint8 = mallocUint8;
function mallocUint16(n) {
  return new Uint16Array(mallocArrayBuffer(2 * n), 0, n);
}
pool$3.mallocUint16 = mallocUint16;
function mallocUint32(n) {
  return new Uint32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$3.mallocUint32 = mallocUint32;
function mallocInt8(n) {
  return new Int8Array(mallocArrayBuffer(n), 0, n);
}
pool$3.mallocInt8 = mallocInt8;
function mallocInt16(n) {
  return new Int16Array(mallocArrayBuffer(2 * n), 0, n);
}
pool$3.mallocInt16 = mallocInt16;
function mallocInt32(n) {
  return new Int32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$3.mallocInt32 = mallocInt32;
function mallocFloat(n) {
  return new Float32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$3.mallocFloat32 = pool$3.mallocFloat = mallocFloat;
function mallocDouble(n) {
  return new Float64Array(mallocArrayBuffer(8 * n), 0, n);
}
pool$3.mallocFloat64 = pool$3.mallocDouble = mallocDouble;
function mallocUint8Clamped(n) {
  if (hasUint8C) {
    return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n);
  } else {
    return mallocUint8(n);
  }
}
pool$3.mallocUint8Clamped = mallocUint8Clamped;
function mallocBigUint64(n) {
  if (hasBigUint64) {
    return new BigUint64Array(mallocArrayBuffer(8 * n), 0, n);
  } else {
    return null;
  }
}
pool$3.mallocBigUint64 = mallocBigUint64;
function mallocBigInt64(n) {
  if (hasBigInt64) {
    return new BigInt64Array(mallocArrayBuffer(8 * n), 0, n);
  } else {
    return null;
  }
}
pool$3.mallocBigInt64 = mallocBigInt64;
function mallocDataView(n) {
  return new DataView(mallocArrayBuffer(n), 0, n);
}
pool$3.mallocDataView = mallocDataView;
function mallocBuffer(n) {
  n = bits$2.nextPow2(n);
  var log_n = bits$2.log2(n);
  var cache2 = BUFFER[log_n];
  if (cache2.length > 0) {
    return cache2.pop();
  }
  return new Buffer$3(n);
}
pool$3.mallocBuffer = mallocBuffer;
pool$3.clearCache = function clearCache() {
  for (var i = 0; i < 32; ++i) {
    POOL.UINT8[i].length = 0;
    POOL.UINT16[i].length = 0;
    POOL.UINT32[i].length = 0;
    POOL.INT8[i].length = 0;
    POOL.INT16[i].length = 0;
    POOL.INT32[i].length = 0;
    POOL.FLOAT[i].length = 0;
    POOL.DOUBLE[i].length = 0;
    POOL.BIGUINT64[i].length = 0;
    POOL.BIGINT64[i].length = 0;
    POOL.UINT8C[i].length = 0;
    DATA[i].length = 0;
    BUFFER[i].length = 0;
  }
};
var sort = wrapper;
var INSERT_SORT_CUTOFF = 32;
function wrapper(data2, n0) {
  if (n0 <= 4 * INSERT_SORT_CUTOFF) {
    insertionSort$1(0, n0 - 1, data2);
  } else {
    quickSort(0, n0 - 1, data2);
  }
}
function insertionSort$1(left2, right2, data2) {
  var ptr = 2 * (left2 + 1);
  for (var i = left2 + 1; i <= right2; ++i) {
    var a = data2[ptr++];
    var b = data2[ptr++];
    var j = i;
    var jptr = ptr - 2;
    while (j-- > left2) {
      var x = data2[jptr - 2];
      var y = data2[jptr - 1];
      if (x < a) {
        break;
      } else if (x === a && y < b) {
        break;
      }
      data2[jptr] = x;
      data2[jptr + 1] = y;
      jptr -= 2;
    }
    data2[jptr] = a;
    data2[jptr + 1] = b;
  }
}
function swap$1(i, j, data2) {
  i *= 2;
  j *= 2;
  var x = data2[i];
  var y = data2[i + 1];
  data2[i] = data2[j];
  data2[i + 1] = data2[j + 1];
  data2[j] = x;
  data2[j + 1] = y;
}
function move(i, j, data2) {
  i *= 2;
  j *= 2;
  data2[i] = data2[j];
  data2[i + 1] = data2[j + 1];
}
function rotate(i, j, k, data2) {
  i *= 2;
  j *= 2;
  k *= 2;
  var x = data2[i];
  var y = data2[i + 1];
  data2[i] = data2[j];
  data2[i + 1] = data2[j + 1];
  data2[j] = data2[k];
  data2[j + 1] = data2[k + 1];
  data2[k] = x;
  data2[k + 1] = y;
}
function shufflePivot(i, j, px, py, data2) {
  i *= 2;
  j *= 2;
  data2[i] = data2[j];
  data2[j] = px;
  data2[i + 1] = data2[j + 1];
  data2[j + 1] = py;
}
function compare(i, j, data2) {
  i *= 2;
  j *= 2;
  var x = data2[i], y = data2[j];
  if (x < y) {
    return false;
  } else if (x === y) {
    return data2[i + 1] > data2[j + 1];
  }
  return true;
}
function comparePivot(i, y, b, data2) {
  i *= 2;
  var x = data2[i];
  if (x < y) {
    return true;
  } else if (x === y) {
    return data2[i + 1] < b;
  }
  return false;
}
function quickSort(left2, right2, data2) {
  var sixth = (right2 - left2 + 1) / 6 | 0, index1 = left2 + sixth, index5 = right2 - sixth, index3 = left2 + right2 >> 1, index2 = index3 - sixth, index4 = index3 + sixth, el1 = index1, el2 = index2, el3 = index3, el4 = index4, el5 = index5, less = left2 + 1, great = right2 - 1, tmp = 0;
  if (compare(el1, el2, data2)) {
    tmp = el1;
    el1 = el2;
    el2 = tmp;
  }
  if (compare(el4, el5, data2)) {
    tmp = el4;
    el4 = el5;
    el5 = tmp;
  }
  if (compare(el1, el3, data2)) {
    tmp = el1;
    el1 = el3;
    el3 = tmp;
  }
  if (compare(el2, el3, data2)) {
    tmp = el2;
    el2 = el3;
    el3 = tmp;
  }
  if (compare(el1, el4, data2)) {
    tmp = el1;
    el1 = el4;
    el4 = tmp;
  }
  if (compare(el3, el4, data2)) {
    tmp = el3;
    el3 = el4;
    el4 = tmp;
  }
  if (compare(el2, el5, data2)) {
    tmp = el2;
    el2 = el5;
    el5 = tmp;
  }
  if (compare(el2, el3, data2)) {
    tmp = el2;
    el2 = el3;
    el3 = tmp;
  }
  if (compare(el4, el5, data2)) {
    tmp = el4;
    el4 = el5;
    el5 = tmp;
  }
  var pivot1X = data2[2 * el2];
  var pivot1Y = data2[2 * el2 + 1];
  var pivot2X = data2[2 * el4];
  var pivot2Y = data2[2 * el4 + 1];
  var ptr0 = 2 * el1;
  var ptr2 = 2 * el3;
  var ptr4 = 2 * el5;
  var ptr5 = 2 * index1;
  var ptr6 = 2 * index3;
  var ptr7 = 2 * index5;
  for (var i1 = 0; i1 < 2; ++i1) {
    var x = data2[ptr0 + i1];
    var y = data2[ptr2 + i1];
    var z = data2[ptr4 + i1];
    data2[ptr5 + i1] = x;
    data2[ptr6 + i1] = y;
    data2[ptr7 + i1] = z;
  }
  move(index2, left2, data2);
  move(index4, right2, data2);
  for (var k = less; k <= great; ++k) {
    if (comparePivot(k, pivot1X, pivot1Y, data2)) {
      if (k !== less) {
        swap$1(k, less, data2);
      }
      ++less;
    } else {
      if (!comparePivot(k, pivot2X, pivot2Y, data2)) {
        while (true) {
          if (!comparePivot(great, pivot2X, pivot2Y, data2)) {
            if (--great < k) {
              break;
            }
            continue;
          } else {
            if (comparePivot(great, pivot1X, pivot1Y, data2)) {
              rotate(k, less, great, data2);
              ++less;
              --great;
            } else {
              swap$1(k, great, data2);
              --great;
            }
            break;
          }
        }
      }
    }
  }
  shufflePivot(left2, less - 1, pivot1X, pivot1Y, data2);
  shufflePivot(right2, great + 1, pivot2X, pivot2Y, data2);
  if (less - 2 - left2 <= INSERT_SORT_CUTOFF) {
    insertionSort$1(left2, less - 2, data2);
  } else {
    quickSort(left2, less - 2, data2);
  }
  if (right2 - (great + 2) <= INSERT_SORT_CUTOFF) {
    insertionSort$1(great + 2, right2, data2);
  } else {
    quickSort(great + 2, right2, data2);
  }
  if (great - less <= INSERT_SORT_CUTOFF) {
    insertionSort$1(less, great, data2);
  } else {
    quickSort(less, great, data2);
  }
}
var sweep$2 = {
  init: sqInit,
  sweepBipartite,
  sweepComplete,
  scanBipartite,
  scanComplete
};
var pool$2 = pool$3;
var bits$1 = twiddle;
var isort = sort;
var BLUE_FLAG = 1 << 28;
var INIT_CAPACITY$1 = 1024;
var RED_SWEEP_QUEUE = pool$2.mallocInt32(INIT_CAPACITY$1);
var RED_SWEEP_INDEX = pool$2.mallocInt32(INIT_CAPACITY$1);
var BLUE_SWEEP_QUEUE = pool$2.mallocInt32(INIT_CAPACITY$1);
var BLUE_SWEEP_INDEX = pool$2.mallocInt32(INIT_CAPACITY$1);
var COMMON_SWEEP_QUEUE = pool$2.mallocInt32(INIT_CAPACITY$1);
var COMMON_SWEEP_INDEX = pool$2.mallocInt32(INIT_CAPACITY$1);
var SWEEP_EVENTS = pool$2.mallocDouble(INIT_CAPACITY$1 * 8);
function sqInit(count2) {
  var rcount = bits$1.nextPow2(count2);
  if (RED_SWEEP_QUEUE.length < rcount) {
    pool$2.free(RED_SWEEP_QUEUE);
    RED_SWEEP_QUEUE = pool$2.mallocInt32(rcount);
  }
  if (RED_SWEEP_INDEX.length < rcount) {
    pool$2.free(RED_SWEEP_INDEX);
    RED_SWEEP_INDEX = pool$2.mallocInt32(rcount);
  }
  if (BLUE_SWEEP_QUEUE.length < rcount) {
    pool$2.free(BLUE_SWEEP_QUEUE);
    BLUE_SWEEP_QUEUE = pool$2.mallocInt32(rcount);
  }
  if (BLUE_SWEEP_INDEX.length < rcount) {
    pool$2.free(BLUE_SWEEP_INDEX);
    BLUE_SWEEP_INDEX = pool$2.mallocInt32(rcount);
  }
  if (COMMON_SWEEP_QUEUE.length < rcount) {
    pool$2.free(COMMON_SWEEP_QUEUE);
    COMMON_SWEEP_QUEUE = pool$2.mallocInt32(rcount);
  }
  if (COMMON_SWEEP_INDEX.length < rcount) {
    pool$2.free(COMMON_SWEEP_INDEX);
    COMMON_SWEEP_INDEX = pool$2.mallocInt32(rcount);
  }
  var eventLength = 8 * rcount;
  if (SWEEP_EVENTS.length < eventLength) {
    pool$2.free(SWEEP_EVENTS);
    SWEEP_EVENTS = pool$2.mallocDouble(eventLength);
  }
}
function sqPop(queue2, index2, count2, item) {
  var idx = index2[item];
  var top2 = queue2[count2 - 1];
  queue2[idx] = top2;
  index2[top2] = idx;
}
function sqPush(queue2, index2, count2, item) {
  queue2[count2] = item;
  index2[item] = count2;
}
function sweepBipartite(d, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
  var ptr = 0;
  var elemSize = 2 * d;
  var istart = d - 1;
  var iend = elemSize - 1;
  for (var i = redStart; i < redEnd; ++i) {
    var idx = redIndex[i];
    var redOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
    SWEEP_EVENTS[ptr++] = -(idx + 1);
    SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
    SWEEP_EVENTS[ptr++] = idx;
  }
  for (var i = blueStart; i < blueEnd; ++i) {
    var idx = blueIndex[i] + BLUE_FLAG;
    var blueOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + iend];
    SWEEP_EVENTS[ptr++] = idx;
  }
  var n = ptr >>> 1;
  isort(SWEEP_EVENTS, n);
  var redActive = 0;
  var blueActive = 0;
  for (var i = 0; i < n; ++i) {
    var e = SWEEP_EVENTS[2 * i + 1] | 0;
    if (e >= BLUE_FLAG) {
      e = e - BLUE_FLAG | 0;
      sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, e);
    } else if (e >= 0) {
      sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e);
    } else if (e <= -BLUE_FLAG) {
      e = -e - BLUE_FLAG | 0;
      for (var j = 0; j < redActive; ++j) {
        var retval = visit(RED_SWEEP_QUEUE[j], e);
        if (retval !== void 0) {
          return retval;
        }
      }
      sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, e);
    } else {
      e = -e - 1 | 0;
      for (var j = 0; j < blueActive; ++j) {
        var retval = visit(e, BLUE_SWEEP_QUEUE[j]);
        if (retval !== void 0) {
          return retval;
        }
      }
      sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, e);
    }
  }
}
function sweepComplete(d, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
  var ptr = 0;
  var elemSize = 2 * d;
  var istart = d - 1;
  var iend = elemSize - 1;
  for (var i = redStart; i < redEnd; ++i) {
    var idx = redIndex[i] + 1 << 1;
    var redOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
    SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
    SWEEP_EVENTS[ptr++] = idx;
  }
  for (var i = blueStart; i < blueEnd; ++i) {
    var idx = blueIndex[i] + 1 << 1;
    var blueOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx | 1;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + iend];
    SWEEP_EVENTS[ptr++] = idx | 1;
  }
  var n = ptr >>> 1;
  isort(SWEEP_EVENTS, n);
  var redActive = 0;
  var blueActive = 0;
  var commonActive = 0;
  for (var i = 0; i < n; ++i) {
    var e = SWEEP_EVENTS[2 * i + 1] | 0;
    var color2 = e & 1;
    if (i < n - 1 && e >> 1 === SWEEP_EVENTS[2 * i + 3] >> 1) {
      color2 = 2;
      i += 1;
    }
    if (e < 0) {
      var id2 = -(e >> 1) - 1;
      for (var j = 0; j < commonActive; ++j) {
        var retval = visit(COMMON_SWEEP_QUEUE[j], id2);
        if (retval !== void 0) {
          return retval;
        }
      }
      if (color2 !== 0) {
        for (var j = 0; j < redActive; ++j) {
          var retval = visit(RED_SWEEP_QUEUE[j], id2);
          if (retval !== void 0) {
            return retval;
          }
        }
      }
      if (color2 !== 1) {
        for (var j = 0; j < blueActive; ++j) {
          var retval = visit(BLUE_SWEEP_QUEUE[j], id2);
          if (retval !== void 0) {
            return retval;
          }
        }
      }
      if (color2 === 0) {
        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, id2);
      } else if (color2 === 1) {
        sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, id2);
      } else if (color2 === 2) {
        sqPush(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive++, id2);
      }
    } else {
      var id2 = (e >> 1) - 1;
      if (color2 === 0) {
        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, id2);
      } else if (color2 === 1) {
        sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, id2);
      } else if (color2 === 2) {
        sqPop(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive--, id2);
      }
    }
  }
}
function scanBipartite(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
  var ptr = 0;
  var elemSize = 2 * d;
  var istart = axis2;
  var iend = axis2 + d;
  var redShift = 1;
  var blueShift = 1;
  if (flip2) {
    blueShift = BLUE_FLAG;
  } else {
    redShift = BLUE_FLAG;
  }
  for (var i = redStart; i < redEnd; ++i) {
    var idx = i + redShift;
    var redOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
    SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
    SWEEP_EVENTS[ptr++] = idx;
  }
  for (var i = blueStart; i < blueEnd; ++i) {
    var idx = i + blueShift;
    var blueOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
  }
  var n = ptr >>> 1;
  isort(SWEEP_EVENTS, n);
  var redActive = 0;
  for (var i = 0; i < n; ++i) {
    var e = SWEEP_EVENTS[2 * i + 1] | 0;
    if (e < 0) {
      var idx = -e;
      var isRed = false;
      if (idx >= BLUE_FLAG) {
        isRed = !flip2;
        idx -= BLUE_FLAG;
      } else {
        isRed = !!flip2;
        idx -= 1;
      }
      if (isRed) {
        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, idx);
      } else {
        var blueId = blueIndex[idx];
        var bluePtr = elemSize * idx;
        var b0 = blue2[bluePtr + axis2 + 1];
        var b1 = blue2[bluePtr + axis2 + 1 + d];
        red_loop:
          for (var j = 0; j < redActive; ++j) {
            var oidx = RED_SWEEP_QUEUE[j];
            var redPtr = elemSize * oidx;
            if (b1 < red2[redPtr + axis2 + 1] || red2[redPtr + axis2 + 1 + d] < b0) {
              continue;
            }
            for (var k = axis2 + 2; k < d; ++k) {
              if (blue2[bluePtr + k + d] < red2[redPtr + k] || red2[redPtr + k + d] < blue2[bluePtr + k]) {
                continue red_loop;
              }
            }
            var redId = redIndex[oidx];
            var retval;
            if (flip2) {
              retval = visit(blueId, redId);
            } else {
              retval = visit(redId, blueId);
            }
            if (retval !== void 0) {
              return retval;
            }
          }
      }
    } else {
      sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e - redShift);
    }
  }
}
function scanComplete(d, axis2, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
  var ptr = 0;
  var elemSize = 2 * d;
  var istart = axis2;
  var iend = axis2 + d;
  for (var i = redStart; i < redEnd; ++i) {
    var idx = i + BLUE_FLAG;
    var redOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
    SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
    SWEEP_EVENTS[ptr++] = idx;
  }
  for (var i = blueStart; i < blueEnd; ++i) {
    var idx = i + 1;
    var blueOffset = elemSize * i;
    SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
    SWEEP_EVENTS[ptr++] = -idx;
  }
  var n = ptr >>> 1;
  isort(SWEEP_EVENTS, n);
  var redActive = 0;
  for (var i = 0; i < n; ++i) {
    var e = SWEEP_EVENTS[2 * i + 1] | 0;
    if (e < 0) {
      var idx = -e;
      if (idx >= BLUE_FLAG) {
        RED_SWEEP_QUEUE[redActive++] = idx - BLUE_FLAG;
      } else {
        idx -= 1;
        var blueId = blueIndex[idx];
        var bluePtr = elemSize * idx;
        var b0 = blue2[bluePtr + axis2 + 1];
        var b1 = blue2[bluePtr + axis2 + 1 + d];
        red_loop:
          for (var j = 0; j < redActive; ++j) {
            var oidx = RED_SWEEP_QUEUE[j];
            var redId = redIndex[oidx];
            if (redId === blueId) {
              break;
            }
            var redPtr = elemSize * oidx;
            if (b1 < red2[redPtr + axis2 + 1] || red2[redPtr + axis2 + 1 + d] < b0) {
              continue;
            }
            for (var k = axis2 + 2; k < d; ++k) {
              if (blue2[bluePtr + k + d] < red2[redPtr + k] || red2[redPtr + k + d] < blue2[bluePtr + k]) {
                continue red_loop;
              }
            }
            var retval = visit(redId, blueId);
            if (retval !== void 0) {
              return retval;
            }
          }
      }
    } else {
      var idx = e - BLUE_FLAG;
      for (var j = redActive - 1; j >= 0; --j) {
        if (RED_SWEEP_QUEUE[j] === idx) {
          for (var k = j + 1; k < redActive; ++k) {
            RED_SWEEP_QUEUE[k - 1] = RED_SWEEP_QUEUE[k];
          }
          break;
        }
      }
      --redActive;
    }
  }
}
var brute = {};
var DIMENSION = "d";
var AXIS = "ax";
var VISIT = "vv";
var FLIP = "fp";
var ELEM_SIZE = "es";
var RED_START = "rs";
var RED_END = "re";
var RED_BOXES = "rb";
var RED_INDEX = "ri";
var RED_PTR = "rp";
var BLUE_START = "bs";
var BLUE_END = "be";
var BLUE_BOXES = "bb";
var BLUE_INDEX = "bi";
var BLUE_PTR = "bp";
var RETVAL = "rv";
var INNER_LABEL = "Q";
var ARGS = [DIMENSION, AXIS, VISIT, RED_START, RED_END, RED_BOXES, RED_INDEX, BLUE_START, BLUE_END, BLUE_BOXES, BLUE_INDEX];
function generateBruteForce(redMajor, flip2, full) {
  var funcName = "bruteForce" + (redMajor ? "Red" : "Blue") + (flip2 ? "Flip" : "") + (full ? "Full" : "");
  var code2 = ["function ", funcName, "(", ARGS.join(), "){", "var ", ELEM_SIZE, "=2*", DIMENSION, ";"];
  var redLoop = "for(var i=" + RED_START + "," + RED_PTR + "=" + ELEM_SIZE + "*" + RED_START + ";i<" + RED_END + ";++i," + RED_PTR + "+=" + ELEM_SIZE + "){var x0=" + RED_BOXES + "[" + AXIS + "+" + RED_PTR + "],x1=" + RED_BOXES + "[" + AXIS + "+" + RED_PTR + "+" + DIMENSION + "],xi=" + RED_INDEX + "[i];";
  var blueLoop = "for(var j=" + BLUE_START + "," + BLUE_PTR + "=" + ELEM_SIZE + "*" + BLUE_START + ";j<" + BLUE_END + ";++j," + BLUE_PTR + "+=" + ELEM_SIZE + "){var y0=" + BLUE_BOXES + "[" + AXIS + "+" + BLUE_PTR + "]," + (full ? "y1=" + BLUE_BOXES + "[" + AXIS + "+" + BLUE_PTR + "+" + DIMENSION + "]," : "") + "yi=" + BLUE_INDEX + "[j];";
  if (redMajor) {
    code2.push(redLoop, INNER_LABEL, ":", blueLoop);
  } else {
    code2.push(blueLoop, INNER_LABEL, ":", redLoop);
  }
  if (full) {
    code2.push("if(y1<x0||x1<y0)continue;");
  } else if (flip2) {
    code2.push("if(y0<=x0||x1<y0)continue;");
  } else {
    code2.push("if(y0<x0||x1<y0)continue;");
  }
  code2.push("for(var k=" + AXIS + "+1;k<" + DIMENSION + ";++k){var r0=" + RED_BOXES + "[k+" + RED_PTR + "],r1=" + RED_BOXES + "[k+" + DIMENSION + "+" + RED_PTR + "],b0=" + BLUE_BOXES + "[k+" + BLUE_PTR + "],b1=" + BLUE_BOXES + "[k+" + DIMENSION + "+" + BLUE_PTR + "];if(r1<b0||b1<r0)continue " + INNER_LABEL + ";}var " + RETVAL + "=" + VISIT + "(");
  if (flip2) {
    code2.push("yi,xi");
  } else {
    code2.push("xi,yi");
  }
  code2.push(");if(" + RETVAL + "!==void 0)return " + RETVAL + ";}}}");
  return {
    name: funcName,
    code: code2.join("")
  };
}
function bruteForcePlanner(full) {
  var funcName = "bruteForce" + (full ? "Full" : "Partial");
  var prefix2 = [];
  var fargs = ARGS.slice();
  if (!full) {
    fargs.splice(3, 0, FLIP);
  }
  var code2 = ["function " + funcName + "(" + fargs.join() + "){"];
  function invoke(redMajor, flip2) {
    var res = generateBruteForce(redMajor, flip2, full);
    prefix2.push(res.code);
    code2.push("return " + res.name + "(" + ARGS.join() + ");");
  }
  code2.push("if(" + RED_END + "-" + RED_START + ">" + BLUE_END + "-" + BLUE_START + "){");
  if (full) {
    invoke(true, false);
    code2.push("}else{");
    invoke(false, false);
  } else {
    code2.push("if(" + FLIP + "){");
    invoke(true, true);
    code2.push("}else{");
    invoke(true, false);
    code2.push("}}else{if(" + FLIP + "){");
    invoke(false, true);
    code2.push("}else{");
    invoke(false, false);
    code2.push("}");
  }
  code2.push("}}return " + funcName);
  var codeStr = prefix2.join("") + code2.join("");
  var proc = new Function(codeStr);
  return proc();
}
brute.partial = bruteForcePlanner(false);
brute.full = bruteForcePlanner(true);
var partition = genPartition$2;
var code = "for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m";
function genPartition$2(predicate, args) {
  var fargs = "abcdef".split("").concat(args);
  var reads = [];
  if (predicate.indexOf("lo") >= 0) {
    reads.push("lo=e[k+n]");
  }
  if (predicate.indexOf("hi") >= 0) {
    reads.push("hi=e[k+o]");
  }
  fargs.push(code.replace("_", reads.join()).replace("$", predicate));
  return Function.apply(void 0, fargs);
}
var median = findMedian$1;
var genPartition$1 = partition;
var partitionStartLessThan$1 = genPartition$1("lo<p0", ["p0"]);
var PARTITION_THRESHOLD = 8;
function insertionSort(d, axis2, start2, end2, boxes, ids) {
  var elemSize = 2 * d;
  var boxPtr = elemSize * (start2 + 1) + axis2;
  for (var i = start2 + 1; i < end2; ++i, boxPtr += elemSize) {
    var x = boxes[boxPtr];
    for (var j = i, ptr = elemSize * (i - 1); j > start2 && boxes[ptr + axis2] > x; --j, ptr -= elemSize) {
      var aPtr = ptr;
      var bPtr = ptr + elemSize;
      for (var k = 0; k < elemSize; ++k, ++aPtr, ++bPtr) {
        var y = boxes[aPtr];
        boxes[aPtr] = boxes[bPtr];
        boxes[bPtr] = y;
      }
      var tmp = ids[j];
      ids[j] = ids[j - 1];
      ids[j - 1] = tmp;
    }
  }
}
function findMedian$1(d, axis2, start2, end2, boxes, ids) {
  if (end2 <= start2 + 1) {
    return start2;
  }
  var lo = start2;
  var hi = end2;
  var mid = end2 + start2 >>> 1;
  var elemSize = 2 * d;
  var pivot = mid;
  var value2 = boxes[elemSize * mid + axis2];
  while (lo < hi) {
    if (hi - lo < PARTITION_THRESHOLD) {
      insertionSort(d, axis2, lo, hi, boxes, ids);
      value2 = boxes[elemSize * mid + axis2];
      break;
    }
    var count2 = hi - lo;
    var pivot0 = Math.random() * count2 + lo | 0;
    var value0 = boxes[elemSize * pivot0 + axis2];
    var pivot1 = Math.random() * count2 + lo | 0;
    var value1 = boxes[elemSize * pivot1 + axis2];
    var pivot2 = Math.random() * count2 + lo | 0;
    var value22 = boxes[elemSize * pivot2 + axis2];
    if (value0 <= value1) {
      if (value22 >= value1) {
        pivot = pivot1;
        value2 = value1;
      } else if (value0 >= value22) {
        pivot = pivot0;
        value2 = value0;
      } else {
        pivot = pivot2;
        value2 = value22;
      }
    } else {
      if (value1 >= value22) {
        pivot = pivot1;
        value2 = value1;
      } else if (value22 >= value0) {
        pivot = pivot0;
        value2 = value0;
      } else {
        pivot = pivot2;
        value2 = value22;
      }
    }
    var aPtr = elemSize * (hi - 1);
    var bPtr = elemSize * pivot;
    for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
      var x = boxes[aPtr];
      boxes[aPtr] = boxes[bPtr];
      boxes[bPtr] = x;
    }
    var y = ids[hi - 1];
    ids[hi - 1] = ids[pivot];
    ids[pivot] = y;
    pivot = partitionStartLessThan$1(d, axis2, lo, hi - 1, boxes, ids, value2);
    var aPtr = elemSize * (hi - 1);
    var bPtr = elemSize * pivot;
    for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
      var x = boxes[aPtr];
      boxes[aPtr] = boxes[bPtr];
      boxes[bPtr] = x;
    }
    var y = ids[hi - 1];
    ids[hi - 1] = ids[pivot];
    ids[pivot] = y;
    if (mid < pivot) {
      hi = pivot - 1;
      while (lo < hi && boxes[elemSize * (hi - 1) + axis2] === value2) {
        hi -= 1;
      }
      hi += 1;
    } else if (pivot < mid) {
      lo = pivot + 1;
      while (lo < hi && boxes[elemSize * lo + axis2] === value2) {
        lo += 1;
      }
    } else {
      break;
    }
  }
  return partitionStartLessThan$1(d, axis2, start2, mid, boxes, ids, boxes[elemSize * mid + axis2]);
}
var intersect = boxIntersectIter$1;
var pool$1 = pool$3;
var bits = twiddle;
var bruteForce = brute;
var bruteForcePartial = bruteForce.partial;
var bruteForceFull = bruteForce.full;
var sweep$1 = sweep$2;
var findMedian = median;
var genPartition = partition;
var BRUTE_FORCE_CUTOFF = 128;
var SCAN_CUTOFF = 1 << 22;
var SCAN_COMPLETE_CUTOFF = 1 << 22;
var partitionInteriorContainsInterval = genPartition("!(lo>=p0)&&!(p1>=hi)", ["p0", "p1"]);
var partitionStartEqual = genPartition("lo===p0", ["p0"]);
var partitionStartLessThan = genPartition("lo<p0", ["p0"]);
var partitionEndLessThanEqual = genPartition("hi<=p0", ["p0"]);
var partitionContainsPoint = genPartition("lo<=p0&&p0<=hi", ["p0"]);
var partitionContainsPointProper = genPartition("lo<p0&&p0<=hi", ["p0"]);
var IFRAME_SIZE = 6;
var DFRAME_SIZE = 2;
var INIT_CAPACITY = 1024;
var BOX_ISTACK = pool$1.mallocInt32(INIT_CAPACITY);
var BOX_DSTACK = pool$1.mallocDouble(INIT_CAPACITY);
function iterInit(d, count2) {
  var levels = 8 * bits.log2(count2 + 1) * (d + 1) | 0;
  var maxInts = bits.nextPow2(IFRAME_SIZE * levels);
  if (BOX_ISTACK.length < maxInts) {
    pool$1.free(BOX_ISTACK);
    BOX_ISTACK = pool$1.mallocInt32(maxInts);
  }
  var maxDoubles = bits.nextPow2(DFRAME_SIZE * levels);
  if (BOX_DSTACK.length < maxDoubles) {
    pool$1.free(BOX_DSTACK);
    BOX_DSTACK = pool$1.mallocDouble(maxDoubles);
  }
}
function iterPush(ptr, axis2, redStart, redEnd, blueStart, blueEnd, state, lo, hi) {
  var iptr = IFRAME_SIZE * ptr;
  BOX_ISTACK[iptr] = axis2;
  BOX_ISTACK[iptr + 1] = redStart;
  BOX_ISTACK[iptr + 2] = redEnd;
  BOX_ISTACK[iptr + 3] = blueStart;
  BOX_ISTACK[iptr + 4] = blueEnd;
  BOX_ISTACK[iptr + 5] = state;
  var dptr = DFRAME_SIZE * ptr;
  BOX_DSTACK[dptr] = lo;
  BOX_DSTACK[dptr + 1] = hi;
}
function onePointPartial(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueOffset, blue2, blueId) {
  var elemSize = 2 * d;
  var bluePtr = blueOffset * elemSize;
  var blueX = blue2[bluePtr + axis2];
  red_loop:
    for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
      var r0 = red2[redPtr + axis2];
      var r1 = red2[redPtr + axis2 + d];
      if (blueX < r0 || r1 < blueX) {
        continue;
      }
      if (flip2 && blueX === r0) {
        continue;
      }
      var redId = redIndex[i];
      for (var j = axis2 + 1; j < d; ++j) {
        var r0 = red2[redPtr + j];
        var r1 = red2[redPtr + j + d];
        var b0 = blue2[bluePtr + j];
        var b1 = blue2[bluePtr + j + d];
        if (r1 < b0 || b1 < r0) {
          continue red_loop;
        }
      }
      var retval;
      if (flip2) {
        retval = visit(blueId, redId);
      } else {
        retval = visit(redId, blueId);
      }
      if (retval !== void 0) {
        return retval;
      }
    }
}
function onePointFull(d, axis2, visit, redStart, redEnd, red2, redIndex, blueOffset, blue2, blueId) {
  var elemSize = 2 * d;
  var bluePtr = blueOffset * elemSize;
  var blueX = blue2[bluePtr + axis2];
  red_loop:
    for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
      var redId = redIndex[i];
      if (redId === blueId) {
        continue;
      }
      var r0 = red2[redPtr + axis2];
      var r1 = red2[redPtr + axis2 + d];
      if (blueX < r0 || r1 < blueX) {
        continue;
      }
      for (var j = axis2 + 1; j < d; ++j) {
        var r0 = red2[redPtr + j];
        var r1 = red2[redPtr + j + d];
        var b0 = blue2[bluePtr + j];
        var b1 = blue2[bluePtr + j + d];
        if (r1 < b0 || b1 < r0) {
          continue red_loop;
        }
      }
      var retval = visit(redId, blueId);
      if (retval !== void 0) {
        return retval;
      }
    }
}
function boxIntersectIter$1(d, visit, initFull, xSize, xBoxes, xIndex, ySize, yBoxes, yIndex) {
  iterInit(d, xSize + ySize);
  var top2 = 0;
  var elemSize = 2 * d;
  var retval;
  iterPush(top2++, 0, 0, xSize, 0, ySize, initFull ? 16 : 0, -Infinity, Infinity);
  if (!initFull) {
    iterPush(top2++, 0, 0, ySize, 0, xSize, 1, -Infinity, Infinity);
  }
  while (top2 > 0) {
    top2 -= 1;
    var iptr = top2 * IFRAME_SIZE;
    var axis2 = BOX_ISTACK[iptr];
    var redStart = BOX_ISTACK[iptr + 1];
    var redEnd = BOX_ISTACK[iptr + 2];
    var blueStart = BOX_ISTACK[iptr + 3];
    var blueEnd = BOX_ISTACK[iptr + 4];
    var state = BOX_ISTACK[iptr + 5];
    var dptr = top2 * DFRAME_SIZE;
    var lo = BOX_DSTACK[dptr];
    var hi = BOX_DSTACK[dptr + 1];
    var flip2 = state & 1;
    var full = !!(state & 16);
    var red2 = xBoxes;
    var redIndex = xIndex;
    var blue2 = yBoxes;
    var blueIndex = yIndex;
    if (flip2) {
      red2 = yBoxes;
      redIndex = yIndex;
      blue2 = xBoxes;
      blueIndex = xIndex;
    }
    if (state & 2) {
      redEnd = partitionStartLessThan(d, axis2, redStart, redEnd, red2, redIndex, hi);
      if (redStart >= redEnd) {
        continue;
      }
    }
    if (state & 4) {
      redStart = partitionEndLessThanEqual(d, axis2, redStart, redEnd, red2, redIndex, lo);
      if (redStart >= redEnd) {
        continue;
      }
    }
    var redCount = redEnd - redStart;
    var blueCount = blueEnd - blueStart;
    if (full) {
      if (d * redCount * (redCount + blueCount) < SCAN_COMPLETE_CUTOFF) {
        retval = sweep$1.scanComplete(d, axis2, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
        if (retval !== void 0) {
          return retval;
        }
        continue;
      }
    } else {
      if (d * Math.min(redCount, blueCount) < BRUTE_FORCE_CUTOFF) {
        retval = bruteForcePartial(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
        if (retval !== void 0) {
          return retval;
        }
        continue;
      } else if (d * redCount * blueCount < SCAN_CUTOFF) {
        retval = sweep$1.scanBipartite(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
        if (retval !== void 0) {
          return retval;
        }
        continue;
      }
    }
    var red0 = partitionInteriorContainsInterval(d, axis2, redStart, redEnd, red2, redIndex, lo, hi);
    if (redStart < red0) {
      if (d * (red0 - redStart) < BRUTE_FORCE_CUTOFF) {
        retval = bruteForceFull(d, axis2 + 1, visit, redStart, red0, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
        if (retval !== void 0) {
          return retval;
        }
      } else if (axis2 === d - 2) {
        if (flip2) {
          retval = sweep$1.sweepBipartite(d, visit, blueStart, blueEnd, blue2, blueIndex, redStart, red0, red2, redIndex);
        } else {
          retval = sweep$1.sweepBipartite(d, visit, redStart, red0, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
        }
        if (retval !== void 0) {
          return retval;
        }
      } else {
        iterPush(top2++, axis2 + 1, redStart, red0, blueStart, blueEnd, flip2, -Infinity, Infinity);
        iterPush(top2++, axis2 + 1, blueStart, blueEnd, redStart, red0, flip2 ^ 1, -Infinity, Infinity);
      }
    }
    if (red0 < redEnd) {
      var blue0 = findMedian(d, axis2, blueStart, blueEnd, blue2, blueIndex);
      var mid = blue2[elemSize * blue0 + axis2];
      var blue1 = partitionStartEqual(d, axis2, blue0, blueEnd, blue2, blueIndex, mid);
      if (blue1 < blueEnd) {
        iterPush(top2++, axis2, red0, redEnd, blue1, blueEnd, (flip2 | 4) + (full ? 16 : 0), mid, hi);
      }
      if (blueStart < blue0) {
        iterPush(top2++, axis2, red0, redEnd, blueStart, blue0, (flip2 | 2) + (full ? 16 : 0), lo, mid);
      }
      if (blue0 + 1 === blue1) {
        if (full) {
          retval = onePointFull(d, axis2, visit, red0, redEnd, red2, redIndex, blue0, blue2, blueIndex[blue0]);
        } else {
          retval = onePointPartial(d, axis2, visit, flip2, red0, redEnd, red2, redIndex, blue0, blue2, blueIndex[blue0]);
        }
        if (retval !== void 0) {
          return retval;
        }
      } else if (blue0 < blue1) {
        var red1;
        if (full) {
          red1 = partitionContainsPoint(d, axis2, red0, redEnd, red2, redIndex, mid);
          if (red0 < red1) {
            var redX = partitionStartEqual(d, axis2, red0, red1, red2, redIndex, mid);
            if (axis2 === d - 2) {
              if (red0 < redX) {
                retval = sweep$1.sweepComplete(d, visit, red0, redX, red2, redIndex, blue0, blue1, blue2, blueIndex);
                if (retval !== void 0) {
                  return retval;
                }
              }
              if (redX < red1) {
                retval = sweep$1.sweepBipartite(d, visit, redX, red1, red2, redIndex, blue0, blue1, blue2, blueIndex);
                if (retval !== void 0) {
                  return retval;
                }
              }
            } else {
              if (red0 < redX) {
                iterPush(top2++, axis2 + 1, red0, redX, blue0, blue1, 16, -Infinity, Infinity);
              }
              if (redX < red1) {
                iterPush(top2++, axis2 + 1, redX, red1, blue0, blue1, 0, -Infinity, Infinity);
                iterPush(top2++, axis2 + 1, blue0, blue1, redX, red1, 1, -Infinity, Infinity);
              }
            }
          }
        } else {
          if (flip2) {
            red1 = partitionContainsPointProper(d, axis2, red0, redEnd, red2, redIndex, mid);
          } else {
            red1 = partitionContainsPoint(d, axis2, red0, redEnd, red2, redIndex, mid);
          }
          if (red0 < red1) {
            if (axis2 === d - 2) {
              if (flip2) {
                retval = sweep$1.sweepBipartite(d, visit, blue0, blue1, blue2, blueIndex, red0, red1, red2, redIndex);
              } else {
                retval = sweep$1.sweepBipartite(d, visit, red0, red1, red2, redIndex, blue0, blue1, blue2, blueIndex);
              }
            } else {
              iterPush(top2++, axis2 + 1, red0, red1, blue0, blue1, flip2, -Infinity, Infinity);
              iterPush(top2++, axis2 + 1, blue0, blue1, red0, red1, flip2 ^ 1, -Infinity, Infinity);
            }
          }
        }
      }
    }
  }
}
var boxIntersect_1 = boxIntersectWrapper;
var pool = pool$3;
var sweep = sweep$2;
var boxIntersectIter = intersect;
function boxEmpty(d, box) {
  for (var j = 0; j < d; ++j) {
    if (!(box[j] <= box[j + d])) {
      return true;
    }
  }
  return false;
}
function convertBoxes(boxes, d, data2, ids) {
  var ptr = 0;
  var count2 = 0;
  for (var i = 0, n = boxes.length; i < n; ++i) {
    var b = boxes[i];
    if (boxEmpty(d, b)) {
      continue;
    }
    for (var j = 0; j < 2 * d; ++j) {
      data2[ptr++] = b[j];
    }
    ids[count2++] = i;
  }
  return count2;
}
function boxIntersect(red2, blue2, visit, full) {
  var n = red2.length;
  var m = blue2.length;
  if (n <= 0 || m <= 0) {
    return;
  }
  var d = red2[0].length >>> 1;
  if (d <= 0) {
    return;
  }
  var retval;
  var redList = pool.mallocDouble(2 * d * n);
  var redIds = pool.mallocInt32(n);
  n = convertBoxes(red2, d, redList, redIds);
  if (n > 0) {
    if (d === 1 && full) {
      sweep.init(n);
      retval = sweep.sweepComplete(d, visit, 0, n, redList, redIds, 0, n, redList, redIds);
    } else {
      var blueList = pool.mallocDouble(2 * d * m);
      var blueIds = pool.mallocInt32(m);
      m = convertBoxes(blue2, d, blueList, blueIds);
      if (m > 0) {
        sweep.init(n + m);
        if (d === 1) {
          retval = sweep.sweepBipartite(d, visit, 0, n, redList, redIds, 0, m, blueList, blueIds);
        } else {
          retval = boxIntersectIter(d, visit, full, n, redList, redIds, m, blueList, blueIds);
        }
        pool.free(blueList);
        pool.free(blueIds);
      }
    }
    pool.free(redList);
    pool.free(redIds);
  }
  return retval;
}
var RESULT;
function appendItem(i, j) {
  RESULT.push([i, j]);
}
function intersectFullArray(x) {
  RESULT = [];
  boxIntersect(x, x, appendItem, true);
  return RESULT;
}
function intersectBipartiteArray(x, y) {
  RESULT = [];
  boxIntersect(x, y, appendItem, false);
  return RESULT;
}
function boxIntersectWrapper(arg0, arg1, arg2) {
  switch (arguments.length) {
    case 1:
      return intersectFullArray(arg0);
    case 2:
      if (typeof arg1 === "function") {
        return boxIntersect(arg0, arg0, arg1, true);
      } else {
        return intersectBipartiteArray(arg0, arg1);
      }
    case 3:
      return boxIntersect(arg0, arg1, arg2, false);
    default:
      throw new Error("box-intersect: Invalid arguments");
  }
}
const boxIntersect$1 = /* @__PURE__ */ getDefaultExportFromCjs(boxIntersect_1);
var orientation = { exports: {} };
var twoProduct_1 = twoProduct$1;
var SPLITTER = +(Math.pow(2, 27) + 1);
function twoProduct$1(a, b, result) {
  var x = a * b;
  var c2 = SPLITTER * a;
  var abig = c2 - a;
  var ahi = c2 - abig;
  var alo = a - ahi;
  var d = SPLITTER * b;
  var bbig = d - b;
  var bhi = d - bbig;
  var blo = b - bhi;
  var err1 = x - ahi * bhi;
  var err2 = err1 - alo * bhi;
  var err3 = err2 - ahi * blo;
  var y = alo * blo - err3;
  if (result) {
    result[0] = y;
    result[1] = x;
    return result;
  }
  return [y, x];
}
var robustSum = linearExpansionSum;
function scalarScalar$1(a, b) {
  var x = a + b;
  var bv = x - a;
  var av = x - bv;
  var br = b - bv;
  var ar = a - av;
  var y = ar + br;
  if (y) {
    return [y, x];
  }
  return [x];
}
function linearExpansionSum(e, f2) {
  var ne = e.length | 0;
  var nf = f2.length | 0;
  if (ne === 1 && nf === 1) {
    return scalarScalar$1(e[0], f2[0]);
  }
  var n = ne + nf;
  var g = new Array(n);
  var count2 = 0;
  var eptr = 0;
  var fptr = 0;
  var abs2 = Math.abs;
  var ei = e[eptr];
  var ea = abs2(ei);
  var fi = f2[fptr];
  var fa = abs2(fi);
  var a, b;
  if (ea < fa) {
    b = ei;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
      ea = abs2(ei);
    }
  } else {
    b = fi;
    fptr += 1;
    if (fptr < nf) {
      fi = f2[fptr];
      fa = abs2(fi);
    }
  }
  if (eptr < ne && ea < fa || fptr >= nf) {
    a = ei;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
      ea = abs2(ei);
    }
  } else {
    a = fi;
    fptr += 1;
    if (fptr < nf) {
      fi = f2[fptr];
      fa = abs2(fi);
    }
  }
  var x = a + b;
  var bv = x - a;
  var y = b - bv;
  var q0 = y;
  var q1 = x;
  var _x, _bv, _av, _br, _ar;
  while (eptr < ne && fptr < nf) {
    if (ea < fa) {
      a = ei;
      eptr += 1;
      if (eptr < ne) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      a = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = f2[fptr];
        fa = abs2(fi);
      }
    }
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
  }
  while (eptr < ne) {
    a = ei;
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
    }
  }
  while (fptr < nf) {
    a = fi;
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
    fptr += 1;
    if (fptr < nf) {
      fi = f2[fptr];
    }
  }
  if (q0) {
    g[count2++] = q0;
  }
  if (q1) {
    g[count2++] = q1;
  }
  if (!count2) {
    g[count2++] = 0;
  }
  g.length = count2;
  return g;
}
var twoSum$1 = fastTwoSum;
function fastTwoSum(a, b, result) {
  var x = a + b;
  var bv = x - a;
  var av = x - bv;
  var br = b - bv;
  var ar = a - av;
  if (result) {
    result[0] = ar + br;
    result[1] = x;
    return result;
  }
  return [ar + br, x];
}
var twoProduct = twoProduct_1;
var twoSum = twoSum$1;
var robustScale = scaleLinearExpansion;
function scaleLinearExpansion(e, scale) {
  var n = e.length;
  if (n === 1) {
    var ts = twoProduct(e[0], scale);
    if (ts[0]) {
      return ts;
    }
    return [ts[1]];
  }
  var g = new Array(2 * n);
  var q = [0.1, 0.1];
  var t = [0.1, 0.1];
  var count2 = 0;
  twoProduct(e[0], scale, q);
  if (q[0]) {
    g[count2++] = q[0];
  }
  for (var i = 1; i < n; ++i) {
    twoProduct(e[i], scale, t);
    var pq = q[1];
    twoSum(pq, t[0], q);
    if (q[0]) {
      g[count2++] = q[0];
    }
    var a = t[1];
    var b = q[1];
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    q[1] = x;
    if (y) {
      g[count2++] = y;
    }
  }
  if (q[1]) {
    g[count2++] = q[1];
  }
  if (count2 === 0) {
    g[count2++] = 0;
  }
  g.length = count2;
  return g;
}
var robustDiff = robustSubtract;
function scalarScalar(a, b) {
  var x = a + b;
  var bv = x - a;
  var av = x - bv;
  var br = b - bv;
  var ar = a - av;
  var y = ar + br;
  if (y) {
    return [y, x];
  }
  return [x];
}
function robustSubtract(e, f2) {
  var ne = e.length | 0;
  var nf = f2.length | 0;
  if (ne === 1 && nf === 1) {
    return scalarScalar(e[0], -f2[0]);
  }
  var n = ne + nf;
  var g = new Array(n);
  var count2 = 0;
  var eptr = 0;
  var fptr = 0;
  var abs2 = Math.abs;
  var ei = e[eptr];
  var ea = abs2(ei);
  var fi = -f2[fptr];
  var fa = abs2(fi);
  var a, b;
  if (ea < fa) {
    b = ei;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
      ea = abs2(ei);
    }
  } else {
    b = fi;
    fptr += 1;
    if (fptr < nf) {
      fi = -f2[fptr];
      fa = abs2(fi);
    }
  }
  if (eptr < ne && ea < fa || fptr >= nf) {
    a = ei;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
      ea = abs2(ei);
    }
  } else {
    a = fi;
    fptr += 1;
    if (fptr < nf) {
      fi = -f2[fptr];
      fa = abs2(fi);
    }
  }
  var x = a + b;
  var bv = x - a;
  var y = b - bv;
  var q0 = y;
  var q1 = x;
  var _x, _bv, _av, _br, _ar;
  while (eptr < ne && fptr < nf) {
    if (ea < fa) {
      a = ei;
      eptr += 1;
      if (eptr < ne) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      a = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = -f2[fptr];
        fa = abs2(fi);
      }
    }
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
  }
  while (eptr < ne) {
    a = ei;
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
    eptr += 1;
    if (eptr < ne) {
      ei = e[eptr];
    }
  }
  while (fptr < nf) {
    a = fi;
    b = q0;
    x = a + b;
    bv = x - a;
    y = b - bv;
    if (y) {
      g[count2++] = y;
    }
    _x = q1 + x;
    _bv = _x - q1;
    _av = _x - _bv;
    _br = x - _bv;
    _ar = q1 - _av;
    q0 = _ar + _br;
    q1 = _x;
    fptr += 1;
    if (fptr < nf) {
      fi = -f2[fptr];
    }
  }
  if (q0) {
    g[count2++] = q0;
  }
  if (q1) {
    g[count2++] = q1;
  }
  if (!count2) {
    g[count2++] = 0;
  }
  g.length = count2;
  return g;
}
(function(module2) {
  var twoProduct2 = twoProduct_1;
  var robustSum$1 = robustSum;
  var robustScale$1 = robustScale;
  var robustSubtract2 = robustDiff;
  var NUM_EXPAND = 5;
  var EPSILON = 11102230246251565e-32;
  var ERRBOUND3 = (3 + 16 * EPSILON) * EPSILON;
  var ERRBOUND4 = (7 + 56 * EPSILON) * EPSILON;
  function orientation_3(sum2, prod, scale, sub) {
    return function orientation3Exact2(m0, m1, m2) {
      var p = sum2(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
      var n = sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
      var d = sub(p, n);
      return d[d.length - 1];
    };
  }
  function orientation_4(sum2, prod, scale, sub) {
    return function orientation4Exact2(m0, m1, m2, m3) {
      var p = sum2(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
      var n = sum2(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum2(scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
      var d = sub(p, n);
      return d[d.length - 1];
    };
  }
  function orientation_5(sum2, prod, scale, sub) {
    return function orientation5Exact(m0, m1, m2, m3, m4) {
      var p = sum2(sum2(sum2(scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum2(scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum2(scale(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum2(scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum2(sum2(scale(sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum2(scale(sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum2(scale(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum2(scale(sum2(scale(sum2(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum2(scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
      var n = sum2(sum2(sum2(scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum2(scale(sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum2(scale(sum2(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum2(sum2(scale(sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum2(scale(sum2(scale(sum2(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum2(scale(sum2(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum2(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
      var d = sub(p, n);
      return d[d.length - 1];
    };
  }
  function orientation2(n) {
    var fn = n === 3 ? orientation_3 : n === 4 ? orientation_4 : orientation_5;
    return fn(robustSum$1, twoProduct2, robustScale$1, robustSubtract2);
  }
  var orientation3Exact = orientation2(3);
  var orientation4Exact = orientation2(4);
  var CACHED = [function orientation0() {
    return 0;
  }, function orientation1() {
    return 0;
  }, function orientation22(a, b) {
    return b[0] - a[0];
  }, function orientation3(a, b, c2) {
    var l = (a[1] - c2[1]) * (b[0] - c2[0]);
    var r2 = (a[0] - c2[0]) * (b[1] - c2[1]);
    var det = l - r2;
    var s;
    if (l > 0) {
      if (r2 <= 0) {
        return det;
      } else {
        s = l + r2;
      }
    } else if (l < 0) {
      if (r2 >= 0) {
        return det;
      } else {
        s = -(l + r2);
      }
    } else {
      return det;
    }
    var tol = ERRBOUND3 * s;
    if (det >= tol || det <= -tol) {
      return det;
    }
    return orientation3Exact(a, b, c2);
  }, function orientation4(a, b, c2, d) {
    var adx = a[0] - d[0];
    var bdx = b[0] - d[0];
    var cdx = c2[0] - d[0];
    var ady = a[1] - d[1];
    var bdy = b[1] - d[1];
    var cdy = c2[1] - d[1];
    var adz = a[2] - d[2];
    var bdz = b[2] - d[2];
    var cdz = c2[2] - d[2];
    var bdxcdy = bdx * cdy;
    var cdxbdy = cdx * bdy;
    var cdxady = cdx * ady;
    var adxcdy = adx * cdy;
    var adxbdy = adx * bdy;
    var bdxady = bdx * ady;
    var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    var tol = ERRBOUND4 * permanent;
    if (det > tol || -det > tol) {
      return det;
    }
    return orientation4Exact(a, b, c2, d);
  }];
  function slowOrient(args) {
    var proc2 = CACHED[args.length];
    if (!proc2) {
      proc2 = CACHED[args.length] = orientation2(args.length);
    }
    return proc2.apply(void 0, args);
  }
  function proc(slow, o0, o1, o2, o3, o4, o5) {
    return function getOrientation(a0, a1, a2, a3, a4) {
      switch (arguments.length) {
        case 0:
        case 1:
          return 0;
        case 2:
          return o2(a0, a1);
        case 3:
          return o3(a0, a1, a2);
        case 4:
          return o4(a0, a1, a2, a3);
        case 5:
          return o5(a0, a1, a2, a3, a4);
      }
      var s = new Array(arguments.length);
      for (var i = 0; i < arguments.length; ++i) {
        s[i] = arguments[i];
      }
      return slow(s);
    };
  }
  function generateOrientationProc() {
    while (CACHED.length <= NUM_EXPAND) {
      CACHED.push(orientation2(CACHED.length));
    }
    module2.exports = proc.apply(void 0, [slowOrient].concat(CACHED));
    for (var i = 0; i <= NUM_EXPAND; ++i) {
      module2.exports[i] = CACHED[i];
    }
  }
  generateOrientationProc();
})(orientation);
var orientationExports = orientation.exports;
var robustPnp = robustPointInPolygon;
var orient = orientationExports;
function robustPointInPolygon(vs, point2) {
  var x = point2[0];
  var y = point2[1];
  var n = vs.length;
  var inside = 1;
  var lim = n;
  for (var i = 0, j = n - 1; i < lim; j = i++) {
    var a = vs[i];
    var b = vs[j];
    var yi = a[1];
    var yj = b[1];
    if (yj < yi) {
      if (yj < y && y < yi) {
        var s = orient(a, b, point2);
        if (s === 0) {
          return 0;
        } else {
          inside ^= 0 < s | 0;
        }
      } else if (y === yi) {
        var c2 = vs[(i + 1) % n];
        var yk = c2[1];
        if (yi < yk) {
          var s = orient(a, b, point2);
          if (s === 0) {
            return 0;
          } else {
            inside ^= 0 < s | 0;
          }
        }
      }
    } else if (yi < yj) {
      if (yi < y && y < yj) {
        var s = orient(a, b, point2);
        if (s === 0) {
          return 0;
        } else {
          inside ^= s < 0 | 0;
        }
      } else if (y === yi) {
        var c2 = vs[(i + 1) % n];
        var yk = c2[1];
        if (yk < yi) {
          var s = orient(a, b, point2);
          if (s === 0) {
            return 0;
          } else {
            inside ^= s < 0 | 0;
          }
        }
      }
    } else if (y === yi) {
      var x02 = Math.min(a[0], b[0]);
      var x12 = Math.max(a[0], b[0]);
      if (i === 0) {
        while (j > 0) {
          var k = (j + n - 1) % n;
          var p = vs[k];
          if (p[1] !== y) {
            break;
          }
          var px = p[0];
          x02 = Math.min(x02, px);
          x12 = Math.max(x12, px);
          j = k;
        }
        if (j === 0) {
          if (x02 <= x && x <= x12) {
            return 0;
          }
          return 1;
        }
        lim = j + 1;
      }
      var y02 = vs[(j + n - 1) % n][1];
      while (i + 1 < lim) {
        var p = vs[i + 1];
        if (p[1] !== y) {
          break;
        }
        var px = p[0];
        x02 = Math.min(x02, px);
        x12 = Math.max(x12, px);
        i += 1;
      }
      if (x02 <= x && x <= x12) {
        return 0;
      }
      var y12 = vs[(i + 1) % n][1];
      if (x < x02 && y02 < y !== y12 < y) {
        inside ^= 1;
      }
    }
  }
  return 2 * inside - 1;
}
const classifyPoint = /* @__PURE__ */ getDefaultExportFromCjs(robustPnp);
function _classCallCheck$1g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$15(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$15(descriptor.key), descriptor);
  }
}
function _createClass$1e(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$15(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$15(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$15(arg) {
  var key = _toPrimitive$15(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$15(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$t() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$t = Reflect.get.bind();
  } else {
    _get$t = function _get2(target, property2, receiver) {
      var base = _superPropBase$t(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$t.apply(this, arguments);
}
function _superPropBase$t(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$10(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$10(subClass, superClass);
}
function _setPrototypeOf$10(o, p) {
  _setPrototypeOf$10 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$10(o, p);
}
function _createSuper$10(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$10();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$10(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$10(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1b(this, result);
  };
}
function _possibleConstructorReturn$1b(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$10(self2);
}
function _assertThisInitialized$10(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$10() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$10(o) {
  _getPrototypeOf$10 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$10(o);
}
const GENE_RECT_HEIGHT$1 = 16;
const MAX_TEXTS$1 = 50;
const MAX_TILE_ENTRIES = 5e3;
const STAGGERED_OFFSET = 5;
const FONT_SIZE$1 = 14;
const TEXT_STYLE = {
  fontSize: `${FONT_SIZE$1}px`,
  fontFamily: "Arial",
  stroke: "white",
  strokeThickness: 2,
  fontWeight: 400,
  dropShadow: true,
  dropShadowColor: "white",
  dropShadowDistance: 0,
  dropShadowBlur: 2
};
let BedLikeTrack = /* @__PURE__ */ function(_HorizontalTiled1DPix) {
  _inherits$1b(BedLikeTrack2, _HorizontalTiled1DPix);
  var _super = _createSuper$10(BedLikeTrack2);
  function BedLikeTrack2(context, options2) {
    var _this;
    _classCallCheck$1g(this, BedLikeTrack2);
    _this = _super.call(this, context, options2);
    _this.valueScaleTransform = identity$4;
    return _this;
  }
  _createClass$1e(BedLikeTrack2, [{
    key: "initialize",
    value: function initialize() {
      if (this.initialized)
        return;
      [this.prevK, this.vertK, this.vertY] = [1, 1, 0];
      if (!this.drawnRects) {
        this.drawnRects = {};
      }
      if (!this.colorScale) {
        if (this.options.colorRange) {
          this.colorScale = colorDomainToRgbaArray(this.options.colorRange);
        } else {
          this.colorScale = HEATED_OBJECT_MAP;
        }
      }
      this.initialized = true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      tile.texts = {};
      tile.rectGraphics = new GLOBALS.PIXI.Graphics();
      tile.textGraphics = new GLOBALS.PIXI.Graphics();
      tile.graphics.addChild(tile.rectGraphics);
      tile.graphics.addChild(tile.textGraphics);
      let plusStrandRows = [];
      let minusStrandRows = [];
      if (tile.tileData && tile.tileData.length) {
        tile.tileData.sort((a, b) => b.importance - a.importance);
        if (!this.options || !this.options.valueColumn) {
          const segments = tile.tileData.map((x) => {
            const chrOffset = +x.chrOffset;
            return {
              from: +x.fields[1] + chrOffset,
              to: +x.fields[2] + chrOffset,
              value: x,
              text: x.fields[3],
              strand: x.fields.length >= 6 && x.fields[5] === "-" ? "-" : "+"
            };
          });
          plusStrandRows = segmentsToRows(segments.filter((x) => x.strand === "+"));
          minusStrandRows = segmentsToRows(segments.filter((x) => x.strand === "-"));
        } else {
          plusStrandRows = [tile.tileData.map((x) => ({
            value: x
          }))];
        }
        tile.plusStrandRows = plusStrandRows;
        tile.minusStrandRows = minusStrandRows;
        if (this.options.showTexts) {
          tile.tileData.forEach((td, i) => {
            const geneInfo = td.fields;
            if (!td.importance) {
              td.importance = Math.random();
            }
            tile.textWidths = {};
            tile.textHeights = {};
            if (i >= (+this.options.maxTexts || MAX_TEXTS$1)) {
              return;
            }
            const text2 = new GLOBALS.PIXI.Text(geneInfo[3], {
              ...TEXT_STYLE,
              fontSize: +this.options.fontSize || TEXT_STYLE.fontSize
            });
            if (this.flipText) {
              text2.scale.x = -1;
            }
            text2.anchor.x = 0.5;
            text2.anchor.y = 0.5;
            tile.texts[td.uid] = text2;
            tile.textGraphics.addChild(text2);
          });
        }
      }
      tile.initialized = true;
    }
    /**
     * Remove the tile's rectangles from the list of drawnRects so that they
     * can be drawn again.
     */
  }, {
    key: "removeTileRects",
    value: function removeTileRects(tile) {
      const zoomLevel = +tile.tileId.split(".")[0];
      tile.rectGraphics.clear();
      tile.rendered = false;
      if (tile.tileData && tile.tileData.length) {
        tile.tileData.forEach((td, i) => {
          if (this.drawnRects[zoomLevel] && this.drawnRects[zoomLevel][td.uid]) {
            if (this.drawnRects[zoomLevel][td.uid][2] === tile.tileId) {
              delete this.drawnRects[zoomLevel][td.uid];
            }
          }
        });
      }
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      this.removeTileRects(tile);
      tile.graphics.destroy(true);
    }
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "removeTiles", this).call(this, toRemoveIds);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (this.options && this.options.valueColumn) {
        if (this.valueScale)
          this.drawAxis(this.valueScale);
      }
    }
  }, {
    key: "remove",
    value: function remove3() {
      if (this.visibleTileIds) {
        this.removeTiles([...this.visibleTileIds]);
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "rerender", this).call(this, options2, force);
      this.valueScale = null;
      this.drawnRects = {};
      if (this.options.colorRange) {
        this.colorScale = colorDomainToRgbaArray(this.options.colorRange);
      } else {
        this.colorScale = HEATED_OBJECT_MAP;
      }
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
      if (this.areAllVisibleTilesLoaded()) {
        this.renderTile(tile);
      }
    }
    /**
     * Use this only when there's one row
     *
     * @return {[type]} [description]
     */
  }, {
    key: "allVisibleRects",
    value: function allVisibleRects() {
      const allRects = {};
      Object.values(this.fetchedTiles).forEach((x) => {
        if (!x.plusStrandRows)
          return;
        for (const row of x.plusStrandRows[0]) {
          if (!allRects[row.value.uid]) {
            allRects[row.value.uid] = row;
          }
        }
      });
      const sortedRows = Object.values(allRects).sort((a, b) => a.from - b.from);
      let startPos = 0;
      let startStaggered = 0;
      for (let i = 0; i < sortedRows.length; i++) {
        if (sortedRows[i].staggeredStartPosition !== void 0) {
          startPos = i;
          startStaggered = sortedRows[i].staggeredStartPosition;
          break;
        }
      }
      for (let i = startPos; i < sortedRows.length; i++) {
        sortedRows[i].staggeredStartPosition = (startStaggered + i - startPos) % 2;
      }
      for (let i = startPos; i >= 0 && sortedRows.length; i--) {
        sortedRows[i].staggeredStartPosition = (startStaggered + startPos - i) % 2;
      }
      return allRects;
    }
  }, {
    key: "drawSegmentStyle",
    value: function drawSegmentStyle(tile, xStartPos, xEndPos, rectY, rectHeight, strand) {
      const hw = 0.1;
      const centerY = rectY + rectHeight / 2;
      const poly = [
        xStartPos,
        rectY,
        // upper left
        xStartPos + 2 * hw,
        rectY,
        // upper right
        xStartPos + 2 * hw,
        centerY - hw,
        xEndPos - 2 * hw,
        centerY - hw,
        xEndPos - 2 * hw,
        rectY,
        xEndPos,
        rectY,
        xEndPos,
        rectY + rectHeight,
        xEndPos - 2 * hw,
        rectY + rectHeight,
        xEndPos - 2 * hw,
        centerY + hw,
        xStartPos + 2 * hw,
        centerY + hw,
        xStartPos + 2 * hw,
        rectY + rectHeight,
        xStartPos,
        rectY + rectHeight
      ];
      tile.rectGraphics.drawPolygon(poly);
      return poly;
    }
  }, {
    key: "drawPoly",
    value: function drawPoly(tile, xStartPos, xEndPos, rectY, rectHeight, strand) {
      let drawnPoly = null;
      if (this.options.annotationStyle === "segment") {
        return this.drawSegmentStyle(tile, xStartPos, xEndPos, rectY, rectHeight, strand);
      }
      if ((strand === "+" || strand === "-") && xEndPos - xStartPos < GENE_RECT_HEIGHT$1 / 2) {
        drawnPoly = [
          xStartPos,
          rectY,
          // top
          xStartPos + rectHeight / 2,
          rectY + rectHeight / 2,
          // right point
          xStartPos,
          rectY + rectHeight
          // bottom
        ];
        if (strand === "+") {
          tile.rectGraphics.drawPolygon(drawnPoly);
        } else {
          drawnPoly = [
            xEndPos,
            rectY,
            // top
            xEndPos - rectHeight / 2,
            rectY + rectHeight / 2,
            // left point
            xEndPos,
            rectY + rectHeight
            // bottom
          ];
          tile.rectGraphics.drawPolygon(drawnPoly);
        }
      } else {
        if (strand === "+") {
          drawnPoly = [
            xStartPos,
            rectY,
            // left top
            xEndPos - rectHeight / 2,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight / 2,
            xEndPos - rectHeight / 2,
            rectY + rectHeight,
            // right bottom
            xStartPos,
            rectY + rectHeight
            // left bottom
          ];
        } else if (strand === "-") {
          drawnPoly = [
            xStartPos + rectHeight / 2,
            rectY,
            // left top
            xEndPos,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight,
            // right bottom
            xStartPos + rectHeight / 2,
            rectY + rectHeight,
            // left bottom
            xStartPos,
            rectY + rectHeight / 2
          ];
        } else {
          drawnPoly = [
            xStartPos,
            rectY,
            // left top
            xEndPos,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight,
            // right bottom
            xStartPos,
            rectY + rectHeight
            // left bottom
          ];
        }
        tile.rectGraphics.drawPolygon(drawnPoly);
      }
      return drawnPoly;
    }
    /** The value scale is used to arrange annotations vertically
        based on a value */
  }, {
    key: "setValueScale",
    value: function setValueScale() {
      this.valueScale = null;
      if (this.options && this.options.valueColumn) {
        const min2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[0] : this.minVisibleValueInTiles(+this.options.valueColumn);
        const max2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[1] : this.maxVisibleValueInTiles(+this.options.valueColumn);
        if (this.options.valueColumn) {
          [this.valueScale] = this.makeValueScale(min2, this.calculateMedianVisibleValue(+this.options.valueColumn), max2);
        }
      }
    }
    /** The color value scale is used to map some value to a coloring */
  }, {
    key: "setColorValueScale",
    value: function setColorValueScale() {
      this.colorValueScale = null;
      if (this.options && this.options.colorEncoding && this.options.colorEncoding !== "itemRgb") {
        const min2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[0] : this.minVisibleValueInTiles(+this.options.colorEncoding);
        const max2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[1] : this.maxVisibleValueInTiles(+this.options.colorEncoding);
        this.colorValueScale = linear().domain([min2, max2]).range([0, 255]);
      }
    }
  }, {
    key: "renderRows",
    value: function renderRows(tile, rows, maxRows, startY, endY, fill) {
      const zoomLevel = +tile.tileId.split(".")[0];
      this.initialize();
      const rowScale = band().domain(range$2(maxRows)).range([startY, endY]).paddingInner(0.1);
      this.allVisibleRects();
      let allRects = null;
      if (this.options.staggered) {
        allRects = this.allVisibleRects();
      }
      for (let j = 0; j < rows.length; j++) {
        for (let i = 0; i < rows[j].length; i++) {
          const td = rows[j][i].value;
          const geneInfo = td.fields;
          const chrOffset = +td.chrOffset;
          const txStart = +geneInfo[1] + chrOffset;
          const txEnd = +geneInfo[2] + chrOffset;
          const txMiddle = (txStart + txEnd) / 2;
          let yMiddle = rowScale(j) + rowScale.step() / 2;
          let rectHeight = this.options.annotationHeight || GENE_RECT_HEIGHT$1;
          if (rectHeight === "scaled") {
            rectHeight = rowScale.bandwidth();
            if (this.options.maxAnnotationHeight) {
              rectHeight = Math.min(rectHeight, +this.options.maxAnnotationHeight);
            }
          }
          if (this.options && this.options.colorEncoding === "itemRgb" && td.fields[8]) {
            const parts = td.fields[8].split(",");
            if (parts.length === 3) {
              const color2 = `rgb(${td.fields[8]})`;
              fill = color2;
            }
          } else if (this.colorValueScale) {
            const rgb2 = valueToColor(
              this.colorValueScale,
              this.colorScale,
              0,
              // pseudocounts
              -Number.MIN_VALUE
            )(+geneInfo[+this.options.colorEncoding - 1]);
            fill = `rgba(${rgb2.join(",")})`;
          }
          if (this.valueScale) {
            const value2 = +geneInfo[+this.options.valueColumn - 1];
            yMiddle = this.valueScale(value2);
          }
          const opacity = this.options.fillOpacity || 0.3;
          tile.rectGraphics.lineStyle(1, colorToHex(fill), opacity);
          tile.rectGraphics.beginFill(colorToHex(fill), opacity);
          let rectY = yMiddle - rectHeight / 2;
          const xStartPos = this._xScale(txStart);
          const xEndPos = this._xScale(txEnd);
          if (this.options.staggered) {
            const rect = allRects[td.uid];
            if (rect.staggeredStartPosition) {
              rectY -= STAGGERED_OFFSET / 2;
            } else {
              rectY += STAGGERED_OFFSET / 2;
            }
          }
          let alreadyDrawn = true;
          if (!(zoomLevel in this.drawnRects && td.uid in this.drawnRects[zoomLevel])) {
            alreadyDrawn = false;
            if (!this.drawnRects[zoomLevel])
              this.drawnRects[zoomLevel] = {};
            const drawnPoly = this.drawPoly(tile, xStartPos, xEndPos, rectY * this.prevK, rectHeight * this.prevK, geneInfo[5]);
            this.drawnRects[zoomLevel][td.uid] = [drawnPoly, {
              start: txStart,
              end: txEnd,
              value: td,
              tile,
              fill
            }, tile.tileId];
          }
          if (!this.options.showTexts)
            continue;
          if (!tile.texts)
            return;
          if (i >= (+this.options.maxTexts || MAX_TEXTS$1))
            continue;
          if (!tile.texts[td.uid])
            continue;
          const text2 = tile.texts[td.uid];
          text2.position.x = this._xScale(txMiddle);
          text2.position.y = rectY + rectHeight / 2;
          text2.nominalY = rectY + rectHeight / 2;
          if (alreadyDrawn) {
            text2.alreadyDrawn = true;
          }
          const fontColor = this.options.fontColor !== void 0 ? colorToHex(this.options.fontColor) : fill;
          text2.style = {
            ...TEXT_STYLE,
            fill: fontColor,
            fontSize: +this.options.fontSize || TEXT_STYLE.fontSize
          };
          if (!(geneInfo[3] in tile.textWidths)) {
            text2.updateTransform();
            const textWidth = text2.getBounds().width;
            const textHeight = text2.getBounds().height;
            const TEXT_SIZE_ADJUSTMENT = 5;
            tile.textWidths[geneInfo[3]] = textWidth;
            tile.textHeights[geneInfo[3]] = textHeight - TEXT_SIZE_ADJUSTMENT;
          }
        }
      }
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      let maxPlusRows = tile.plusStrandRows ? tile.plusStrandRows.length : 1;
      let maxMinusRows = tile.minusStrandRows ? tile.minusStrandRows.length : 1;
      for (const otherTile of this.visibleAndFetchedTiles()) {
        if (!otherTile.initialized)
          return;
        if (!otherTile.plusStrandRows && !otherTile.minusStrandRows)
          continue;
        maxPlusRows = Math.max(otherTile.plusStrandRows.length, maxPlusRows);
        maxMinusRows = Math.max(otherTile.minusStrandRows.length, maxMinusRows);
      }
      if (tile.rendered) {
        this.removeTileRects(tile);
      }
      tile.drawnAtScale = this._xScale.copy();
      tile.rendered = true;
      this.setValueScale();
      this.setColorValueScale();
      if (tile.tileData && tile.tileData.length) {
        const fill = this.options.plusStrandColor || this.options.fillColor || "blue";
        const minusStrandFill = this.options.minusStrandColor || this.options.fillColor || "purple";
        const MIDDLE_SPACE = 0;
        let plusHeight = 0;
        if (this.options.separatePlusMinusStrands) {
          plusHeight = maxPlusRows * this.dimensions[1] / (maxPlusRows + maxMinusRows) - MIDDLE_SPACE / 2;
        } else {
          plusHeight = this.dimensions[1];
        }
        this.renderRows(tile, tile.plusStrandRows, maxPlusRows, 0, plusHeight, fill);
        this.renderRows(tile, tile.minusStrandRows, maxMinusRows, this.options.separatePlusMinusStrands ? plusHeight + MIDDLE_SPACE / 2 : 0, this.dimensions[1], minusStrandFill);
      }
      trackUtils.stretchRects(this, [(x) => x.rectGraphics]);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles(valueColumn) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let min2 = Math.min.apply(null, visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData && x.tileData.length).map((x) => Math.min.apply(null, x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]).filter((y) => !Number.isNaN(y)))));
      if (min2 === Number.MAX_SAFE_INTEGER) {
        min2 = null;
      }
      return min2;
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles(valueColumn) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let max2 = Math.max.apply(null, visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData && x.tileData.length).map((x) => Math.max.apply(null, x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]).filter((y) => !Number.isNaN(y)))));
      if (max2 === Number.MIN_SAFE_INTEGER) {
        max2 = null;
      }
      return max2;
    }
  }, {
    key: "calculateMedianVisibleValue",
    value: function calculateMedianVisibleValue(valueColumn) {
      if (this.areAllVisibleTilesLoaded()) {
        this.allTilesLoaded();
      }
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const values2 = [].concat(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData && x.tileData.length).map((x) => x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]))).filter((x) => x > 0);
      this.medianVisibleValue = median$1(values2);
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "draw", this).call(this);
      this.allTexts = [];
      this.allBoxes = [];
      for (const fetchedTileId in this.fetchedTiles) {
        const tile = this.fetchedTiles[fetchedTileId];
        tile.rectGraphics.scale.y = this.vertK;
        tile.rectGraphics.position.y = this.vertY;
        if (!tile.drawnAtScale) {
          return;
        }
        trackUtils.stretchRects(this, [(x) => x.rectGraphics]);
        const parentInFetched = this.parentInFetched(tile);
        if (!tile.initialized) {
          continue;
        }
        if (tile.tileData && tile.tileData.length) {
          tile.tileData.forEach((td) => {
            if (!tile.texts) {
              return;
            }
            const geneInfo = td.fields;
            const geneName = geneInfo[3];
            const text2 = tile.texts[td.uid];
            if (!text2) {
              return;
            }
            const chrOffset = +td.chrOffset;
            const txStart = +geneInfo[1] + chrOffset;
            const txEnd = +geneInfo[2] + chrOffset;
            const txMiddle = (txStart + txEnd) / 2;
            text2.position.x = this._xScale(txMiddle);
            text2.position.y = text2.nominalY * (this.vertK * this.prevK) + this.vertY;
            if (!parentInFetched && !text2.alreadyDrawn) {
              text2.visible = true;
              const TEXT_MARGIN = 3;
              this.allBoxes.push([text2.position.x - TEXT_MARGIN, text2.position.y - tile.textHeights[geneInfo[3]] / 2, text2.position.x + tile.textWidths[geneInfo[3]] + TEXT_MARGIN, text2.position.y + tile.textHeights[geneInfo[3]] / 2]);
              this.allTexts.push({
                importance: td.importance,
                text: text2,
                caption: geneName,
                strand: geneInfo[5]
              });
            } else {
              text2.visible = false;
            }
          });
        }
      }
      this.hideOverlaps(this.allBoxes, this.allTexts);
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allBoxes, allTexts) {
      boxIntersect$1(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          if (allTexts[i].text.visible) {
            allTexts[j].text.visible = false;
          }
        } else if (allTexts[j].text.visible) {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "setPosition", this).call(this, newPosition);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "setDimensions", this).call(this, newDimensions);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$t(_getPrototypeOf$10(BedLikeTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const rectOutput = document.createElement("g");
      const textOutput = document.createElement("g");
      output.appendChild(rectOutput);
      output.appendChild(textOutput);
      for (const tile of this.visibleAndFetchedTiles()) {
        if (!tile.tileData.length) {
          continue;
        }
        tile.tileData.forEach((td) => {
          console.log(`exportSVG tile ${tile.tileId}`);
          const zoomLevel = +tile.tileId.split(".")[0];
          const gTile = document.createElement("g");
          gTile.setAttribute("transform", `translate(${tile.rectGraphics.position.x},${tile.rectGraphics.position.y})scale(${tile.rectGraphics.scale.x},${tile.rectGraphics.scale.y})`);
          rectOutput.appendChild(gTile);
          if (this.drawnRects[zoomLevel] && td.uid in this.drawnRects[zoomLevel]) {
            const rect = this.drawnRects[zoomLevel][td.uid][0];
            const r2 = document.createElement("path");
            let d = `M ${rect[0]} ${rect[1]}`;
            for (let i = 2; i < rect.length; i += 2) {
              d += ` L ${rect[i]} ${rect[i + 1]}`;
            }
            const fill = this.drawnRects[zoomLevel][td.uid][1].fill;
            const fontColor = this.options.fontColor !== void 0 ? colorToHex(this.options.fontColor) : fill;
            r2.setAttribute("d", d);
            r2.setAttribute("fill", fill);
            r2.setAttribute("opacity", 0.3);
            r2.style.stroke = fill;
            r2.style.strokeWidth = "1px";
            gTile.appendChild(r2);
            if (tile.texts[td.uid]) {
              const text2 = tile.texts[td.uid];
              if (!text2.visible) {
                return;
              }
              const g = document.createElement("g");
              const t = document.createElement("text");
              textOutput.appendChild(g);
              g.appendChild(t);
              g.setAttribute("transform", `translate(${text2.x},${text2.y})scale(${text2.scale.x},1)`);
              t.setAttribute("text-anchor", "middle");
              t.setAttribute("font-family", TEXT_STYLE.fontFamily);
              t.setAttribute("font-size", +this.options.fontSize || TEXT_STYLE.fontSize);
              t.setAttribute("font-weight", "bold");
              t.setAttribute("dy", "5px");
              t.setAttribute("fill", fontColor);
              t.setAttribute("stroke", TEXT_STYLE.stroke);
              t.setAttribute("stroke-width", "0.4");
              t.setAttribute("text-shadow", "0px 0px 2px grey");
              t.innerHTML = text2.text;
            }
          }
        });
      }
      return [base, base];
    }
    /** Move event for the y-axis */
  }, {
    key: "movedY",
    value: function movedY2(dY) {
      Object.values(this.fetchedTiles).forEach((tile) => {
        const vst = this.valueScaleTransform;
        const {
          y,
          k
        } = vst;
        const height2 = this.dimensions[1];
        if (y + dY / k > -(k - 1) * height2 && y + dY / k < 0) {
          this.valueScaleTransform = vst.translate(0, dY / k);
        }
        tile.rectGraphics.position.y = this.valueScaleTransform.y;
        this.vertY = this.valueScaleTransform.y;
      });
      this.animate();
    }
    /** Zoomed along the y-axis */
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
      const newTransform = trackUtils.zoomedY(yPos, kMultiplier, this.valueScaleTransform, this.dimensions[1]);
      this.valueScaleTransform = newTransform;
      let k1 = newTransform.k;
      const t12 = newTransform.y;
      let toStretch = false;
      k1 /= this.prevK;
      if (k1 > 1.5 || k1 < 1 / 1.5) {
        this.prevK *= k1;
        k1 = 1;
        toStretch = true;
      }
      this.vertK = k1;
      this.vertY = t12;
      Object.values(this.fetchedTiles).forEach((tile) => {
        if (toStretch)
          this.renderTile(tile);
        tile.rectGraphics.scale.y = k1;
        tile.rectGraphics.position.y = t12;
      });
      this.draw();
      this.animate();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      if (!this.tilesetInfo) {
        return "";
      }
      if (!this.drawnRects) {
        return "";
      }
      if (!this.options.showTooltip && !isShiftDown) {
        this.animate();
        return "";
      }
      const zoomLevel = this.calculateZoomLevel();
      const point2 = [trackX, trackY];
      if (this.drawnRects[zoomLevel]) {
        const visibleRects = Object.values(this.drawnRects[zoomLevel]);
        for (let i = 0; i < visibleRects.length; i++) {
          const rect = visibleRects[i][0].slice(0);
          const tileKx = visibleRects[i][1].tile.rectGraphics.scale.x;
          const tilePx = visibleRects[i][1].tile.rectGraphics.position.x;
          const tileKy = visibleRects[i][1].tile.rectGraphics.scale.y;
          const tilePy = visibleRects[i][1].tile.rectGraphics.position.y;
          const newArr = [];
          while (rect.length) {
            const [x, y] = rect.splice(0, 2);
            newArr.push([x * tileKx + tilePx, y * tileKy + tilePy]);
          }
          const pc = classifyPoint(newArr, point2);
          if (pc === -1) {
            let isNumber2 = function(value2) {
              return typeof value2 === "number";
            };
            const parts = visibleRects[i][1].value.fields;
            let output = `<div class="track-mouseover-menu-table">`;
            const identifierText = parts.length >= 4 ? parts[3] : null;
            if (identifierText) {
              output += `
            <div class="track-mouseover-menu-table-item">
              <label for="identifier" class="track-mouseover-menu-table-item-label">Identifier</label>
              <div name="identifier" class="track-mouseover-menu-table-item-value">${identifierText}</div>
            </div>
            `;
            }
            const intervalText = parts.length >= 5 && typeof parts[5] !== "undefined" ? `${parts[0]}:${+parts[1]}-${+parts[2]} (${parts[5]})` : `${parts[0]}:${+parts[1]}-${+parts[2]}`;
            if (intervalText && intervalText !== identifierText) {
              output += `
            <div class="track-mouseover-menu-table-item">
              <label for="interval" class="track-mouseover-menu-table-item-label">Interval</label>
              <div name="interval" class="track-mouseover-menu-table-item-value">${intervalText}</div>
            </div>
            `;
            }
            const scoreText = parts.length >= 5 ? isNumber2(Number(parts[4])) ? Number(parts[4]).toExponential(3) : null : null;
            if (scoreText) {
              output += `
            <div class="track-mouseover-menu-table-item">
              <label for="score" class="track-mouseover-menu-table-item-label">Score</label>
              <div name="score" class="track-mouseover-menu-table-item-value">${scoreText}</div>
            </div>
            `;
            }
            output += `</div>`;
            return output;
          }
        }
      }
      return "";
    }
  }]);
  return BedLikeTrack2;
}(HorizontalTiled1DPixiTrack);
function _classCallCheck$1f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$14(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$14(descriptor.key), descriptor);
  }
}
function _createClass$1d(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$14(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$14(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$14(arg) {
  var key = _toPrimitive$14(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$14(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$s() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$s = Reflect.get.bind();
  } else {
    _get$s = function _get2(target, property2, receiver) {
      var base = _superPropBase$s(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$s.apply(this, arguments);
}
function _superPropBase$s(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$$(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$1a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$$(subClass, superClass);
}
function _setPrototypeOf$$(o, p) {
  _setPrototypeOf$$ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$$(o, p);
}
function _createSuper$$(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$$();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$$(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$$(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1a(this, result);
  };
}
function _possibleConstructorReturn$1a(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$$(self2);
}
function _assertThisInitialized$$(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$$() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$$(o) {
  _getPrototypeOf$$ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$$(o);
}
const drawRectOnGraphics = (x, y, width, height2, graphics) => {
  graphics.drawRect(x, y, width, height2);
};
const drawRectOnSvg = (x, y, width, height2, svg, {
  fill = 0,
  fillOpacity = 0,
  stroke = 0,
  strokeWidth = 0,
  strokeOpacity = 0
} = {}) => {
  const r2 = document.createElement("rect");
  r2.setAttribute("x", x);
  r2.setAttribute("y", y);
  r2.setAttribute("width", width);
  r2.setAttribute("height", height2);
  r2.setAttribute("fill", `#${decToHexStr(fill)}`);
  r2.setAttribute("fill-opacity", fillOpacity);
  r2.setAttribute("stroke", `#${decToHexStr(stroke)}`);
  r2.setAttribute("stroke-opacity", strokeOpacity);
  r2.setAttribute("stroke-width", strokeWidth);
  svg.appendChild(r2);
};
const drawRect = (x, y, width, height2, target, options2) => {
  if (target instanceof HTMLElement)
    drawRectOnSvg(x, y, width, height2, target, options2);
  else
    drawRectOnGraphics(x, y, width, height2, target);
};
const drawRectWithPositionedBorder = (graphics, xPos, yPos, width, height2, fill, stroke, outline, {
  isVertical = false,
  svg = null
} = {}) => {
  let finalXPos = xPos;
  let finalYPos = yPos;
  let finalWidth = width;
  let finalHeight = height2;
  const outlineWidth = outline.width * 2 > width ? width / 2 : outline.width;
  const outlineHeight = outline.width * 2 > height2 ? height2 / 2 : outline.width;
  const target = svg || graphics;
  const colors = {
    fill: 0,
    fillOpacity: 0,
    stroke: 0,
    strokeOpacity: 0,
    strokeWidth: 1
  };
  if (outline.positions && outline.positions.length) {
    graphics.lineStyle(1, 0, 0);
    graphics.beginFill(outline.color, outline.opacity);
    colors.fill = outline.color;
    colors.fillOpacity = outline.opacity;
    colors.stroke = 0;
    colors.strokeOpacity = 0;
    colors.strokeWidth = 1;
    outline.positions.forEach((pos) => {
      if (pos === "top" && !isVertical || pos === "left" && isVertical) {
        drawRect(xPos - outlineWidth, yPos - outlineHeight, width + outlineWidth * 2, outlineHeight, target, colors);
      } else if (pos === "bottom" && !isVertical || pos === "right" && isVertical) {
        drawRect(xPos - outlineWidth, yPos + height2, width + outlineWidth * 2, outlineHeight, target, colors);
      } else if (pos === "left" && !isVertical || pos === "top" && isVertical) {
        drawRect(xPos - outlineWidth, yPos - outlineHeight, outlineWidth, height2 + outlineHeight * 2, target, colors);
      } else if (pos === "right" && !isVertical || pos === "bottom" && isVertical) {
        drawRect(xPos + width, yPos - outlineHeight, outlineWidth, height2 + outlineHeight * 2, target, colors);
      }
    });
  } else if (outline.width > 0 && outline.opacity > 0) {
    graphics.lineStyle(outline.width, outline.color, outline.opacity);
    graphics.beginFill(0, 0);
    colors.fill = 0;
    colors.fillOpacity = 0;
    colors.stroke = outline.color;
    colors.strokeOpacity = outline.opacity;
    colors.strokeWidth = outline.width;
    drawRect(xPos - outlineWidth, yPos - outlineHeight, width + outlineWidth * 2, height2 + outlineHeight * 2, target, colors);
  }
  if (stroke.positions && stroke.positions.length) {
    graphics.lineStyle(1, 0, 0);
    graphics.beginFill(stroke.color, stroke.opacity);
    const strokeWidth = stroke.width * 2 > width ? width / 2 : stroke.width;
    const strokeHeight = stroke.width * 2 > height2 ? height2 / 2 : stroke.width;
    colors.fill = stroke.color;
    colors.fillOpacity = stroke.opacity;
    colors.stroke = 0;
    colors.strokeOpacity = 0;
    colors.strokeWidth = 1;
    stroke.positions.forEach((pos) => {
      if (pos === "top" && !isVertical || pos === "left" && isVertical) {
        drawRect(xPos, yPos, width, strokeHeight, target, colors);
        finalYPos += strokeHeight;
        finalHeight -= strokeHeight;
      } else if (pos === "bottom" && !isVertical || pos === "right" && isVertical) {
        drawRect(xPos, yPos + height2 - strokeHeight, width, strokeHeight, target, colors);
        finalHeight -= strokeHeight;
      } else if (pos === "left" && !isVertical || pos === "top" && isVertical) {
        drawRect(xPos, yPos, strokeWidth, height2, target, colors);
        finalXPos += strokeWidth;
        finalWidth -= strokeWidth;
      } else if (pos === "right" && !isVertical || pos === "bottom" && isVertical) {
        drawRect(xPos + width - strokeWidth, yPos, strokeWidth, height2, target, colors);
        finalWidth -= strokeWidth;
      }
    });
  } else {
    graphics.lineStyle(stroke.width, stroke.color, stroke.opacity);
    colors.stroke = stroke.color;
    colors.strokeOpacity = stroke.opacity;
    colors.strokeWidth = stroke.width;
  }
  graphics.beginFill(fill.color, fill.opacity);
  colors.fill = fill.color;
  colors.fillOpacity = fill.opacity;
  drawRect(finalXPos, finalYPos, finalWidth, finalHeight, target, colors);
};
let OverlayTrack = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$1a(OverlayTrack2, _PixiTrack);
  var _super = _createSuper$$(OverlayTrack2);
  function OverlayTrack2(context, options2) {
    var _this;
    _classCallCheck$1f(this, OverlayTrack2);
    _this = _super.call(this, context, options2);
    _this.options = options2 || {};
    _this.drawnRects = {};
    return _this;
  }
  _createClass$1d(OverlayTrack2, [{
    key: "drawHorizontalOverlay",
    value: function drawHorizontalOverlay(graphics, position, extent2, minWidth = 0, fill, stroke, outline, options2) {
      if (!extent2 || extent2.length < 2)
        return;
      let xPos = this.position[0] + position.left + this._xScale(extent2[0]);
      const yPos = this.position[1] + position.top;
      const height2 = position.height;
      let width = this._xScale(extent2[1]) - this._xScale(extent2[0]);
      if (width < minWidth) {
        xPos -= (minWidth - width) / 2;
        width = minWidth;
      }
      drawRectWithPositionedBorder(graphics, xPos, yPos, width, height2, fill, stroke, outline, options2);
    }
  }, {
    key: "drawVerticalOverlay",
    value: function drawVerticalOverlay(graphics, position, extent2, minHeight = 0, fill, stroke, outline, options2 = {}) {
      if (!extent2 || extent2.length < 2)
        return;
      const xPos = this.position[0] + position.left;
      let yPos = this.position[1] + position.top + this._yScale(extent2.length >= 4 ? extent2[2] : extent2[0]);
      const topPosition = this.position[1] + position.top;
      const bottomPosition = this.position[1] + position.top + position.height;
      if (yPos > bottomPosition) {
        return;
      }
      if (yPos < topPosition) {
        yPos = topPosition;
      }
      const width = position.width;
      let height2 = this._yScale(extent2.length >= 4 ? extent2[3] : extent2[1]) - yPos + position.top + this.position[1];
      if (height2 < 0) {
        return;
      }
      if (yPos + height2 > bottomPosition) {
        height2 += bottomPosition - (yPos + height2);
      }
      if (height2 < minHeight) {
        yPos -= (minHeight - height2) / 2;
        height2 = minHeight;
      }
      options2.isVertical = true;
      drawRectWithPositionedBorder(graphics, xPos, yPos, width, height2, fill, stroke, outline, options2);
    }
  }, {
    key: "draw",
    value: function draw(options2) {
      _get$s(_getPrototypeOf$$(OverlayTrack2.prototype), "draw", this).call(this);
      const graphics = this.pMain;
      const fill = {
        color: colorToHex(this.options.fill || this.options.fillColor || "blue"),
        opacity: Number.isNaN(+this.options.fillOpacity) ? 0.3 : +this.options.fillOpacity
      };
      const stroke = {
        color: colorToHex(this.options.stroke || "blue"),
        opacity: +this.options.strokeOpacity || 1,
        width: +this.options.strokeWidth || 0,
        positions: !this.options.strokePos || Array.isArray(this.options.strokePos) ? this.options.strokePos : [this.options.strokePos]
      };
      const outline = {
        color: colorToHex(this.options.outline || "white"),
        opacity: +this.options.outlineOpacity || 1,
        width: +this.options.outlineWidth || 0,
        positions: !this.options.outlinePos || Array.isArray(this.options.outlinePos) ? this.options.outlinePos : [this.options.outlinePos]
      };
      if (!options2 || !options2.svg)
        graphics.clear();
      graphics.lineStyle(stroke.width, stroke, +!stroke.positions * stroke.opacity);
      graphics.beginFill(fill.color, fill.opacity);
      const minWidth = Math.max(0, +this.options.minWidth || 0);
      const minHeight = Math.max(0, +this.options.minHeight || 0);
      if (Array.isArray(this.options.extent)) {
        this.options.orientationsAndPositions.forEach((op) => {
          if (op.orientation === "1d-horizontal" || op.orientation === "2d") {
            this.options.extent.forEach((extent2) => this.drawHorizontalOverlay(graphics, op.position, extent2, minWidth, fill, stroke, outline, options2));
          }
          if (op.orientation === "1d-vertical" || op.orientation === "2d") {
            this.options.extent.forEach((extent2) => this.drawVerticalOverlay(graphics, op.position, extent2, minHeight, fill, stroke, outline, options2));
          }
        });
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$s(_getPrototypeOf$$(OverlayTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$s(_getPrototypeOf$$(OverlayTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$s(_getPrototypeOf$$(OverlayTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$s(_getPrototypeOf$$(OverlayTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      this.draw({
        svg: output
      });
      return [base, track];
    }
  }]);
  return OverlayTrack2;
}(PixiTrack);
function _classCallCheck$1e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$13(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$13(descriptor.key), descriptor);
  }
}
function _createClass$1c(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$13(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$13(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$13(arg) {
  var key = _toPrimitive$13(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$13(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$r() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$r = Reflect.get.bind();
  } else {
    _get$r = function _get2(target, property2, receiver) {
      var base = _superPropBase$r(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$r.apply(this, arguments);
}
function _superPropBase$r(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$_(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$19(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$_(subClass, superClass);
}
function _setPrototypeOf$_(o, p) {
  _setPrototypeOf$_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$_(o, p);
}
function _createSuper$_(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$_();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$_(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$_(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$19(this, result);
  };
}
function _possibleConstructorReturn$19(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$_(self2);
}
function _assertThisInitialized$_(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$_() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$_(o) {
  _getPrototypeOf$_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$_(o);
}
let HorizontalLine1DPixiTrack = /* @__PURE__ */ function(_HorizontalTiled1DPix) {
  _inherits$19(HorizontalLine1DPixiTrack2, _HorizontalTiled1DPix);
  var _super = _createSuper$_(HorizontalLine1DPixiTrack2);
  function HorizontalLine1DPixiTrack2() {
    _classCallCheck$1e(this, HorizontalLine1DPixiTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$1c(HorizontalLine1DPixiTrack2, [{
    key: "stopHover",
    value: function stopHover() {
      this.pMouseOver.clear();
      this.animate();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      if (!this.tilesetInfo || !this.valueScale)
        return "";
      const value2 = this.getDataAtPos(trackX);
      let textValue = "";
      if (value2)
        textValue = format$1(".3f")(value2);
      const graphics = this.pMouseOver;
      const colorHex = 0;
      const yPos = this.valueScale(value2);
      graphics.clear();
      if (!this.options.showTooltip && !isShiftDown) {
        this.animate();
        return "";
      }
      graphics.beginFill(colorHex, 0.5);
      graphics.lineStyle(1, colorHex, 1);
      const markerWidth = 4;
      graphics.drawRect(trackX - markerWidth / 2, yPos - markerWidth / 2, markerWidth, markerWidth);
      this.animate();
      if (!textValue || textValue.length === 0)
        return "";
      let output = "";
      if (!this.options.isCombined) {
        output = `<div class="track-mouseover-menu-table">`;
        output += `
        <div class="track-mouseover-menu-table-item">
          <label for="value" class="track-mouseover-menu-table-item-label">Value</label>
          <div name="value" class="track-mouseover-menu-table-item-value">${textValue}</div>
        </div>
        `;
        output += `</div>`;
      } else {
        output = this.options.isFirst ? `<div class="track-mouseover-menu-table">` : "";
        if (this.options.isFirst && this.options.chromInfo) {
          const dataX = this._xScale.invert(trackX);
          const atcX = absToChr(dataX, this.options.chromInfo);
          const chrom = atcX[0];
          const position = Math.ceil(atcX[1]);
          const positionText = `${chrom}:${position}`;
          output += `
          <div class="track-mouseover-menu-table-item">
            <label for="position" class="track-mouseover-menu-table-item-label">Position</label>
            <div name="position" class="track-mouseover-menu-table-item-value">${positionText}</div>
          </div>
          `;
        }
        const colorLabelBox = this.options.barFillColor ? `<div style="border:1px solid black;background-color:${this.options.barFillColor};width:10px;height:10px;display:inline-block;margin-right:5px;margin-left:2px;"></div>` : "";
        const itemLabel = this.options.name ? `${colorLabelBox}${this.options.name}` : "Value";
        output += `
        <div class="track-mouseover-menu-table-item">
          <label for="value" class="track-mouseover-menu-table-item-label">${itemLabel}</label>
          <div name="value" class="track-mouseover-menu-table-item-value">${textValue}</div>
        </div>
        `;
        output += this.options.isLast ? `</div>` : "";
      }
      return output;
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "initTile", this).call(this, tile);
      if (!tile.tileData || !tile.tileData.dense) {
        console.warn("emptyTile:", tile);
        return;
      }
      tile.xValues = new Array(tile.tileData.dense.length);
      tile.yValues = new Array(tile.tileData.dense.length);
      if (this.isValueScaleLocked()) {
        const glge = this.getLockGroupExtrema();
        if (glge !== null) {
          this.minValue(glge[0]);
          this.maxValue(glge[1]);
        }
      }
      this.drawTile(tile);
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "rerender", this).call(this, options2, force);
      this.options = options2;
      _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "draw", this).call(this);
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      this.drawTile(tile);
      this.drawAxis(this.valueScale);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "drawTile", this).call(this, tile);
      if (!tile.graphics) {
        return;
      }
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      const [vs, offsetValue] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue());
      this.valueScale = vs;
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      if (!this.tilesetInfo.tile_size && !this.tilesetInfo.bins_per_dimension) {
        console.warn("No tileset_info.tile_size or tileset_info.bins_per_dimension", this.tilesetInfo);
      }
      const tileSize = this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension;
      const tileXScale = linear().domain([0, tileSize]).range([tileX, tileX + tileWidth]);
      const strokeWidth = this.options.lineStrokeWidth ? this.options.lineStrokeWidth : 1;
      graphics.lineStyle(strokeWidth, stroke, 1);
      tile.segments = [];
      let currentSegment = [];
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + offsetValue);
        if (this.options.valueScaling === "log" && tileValues[i] === 0 || Number.isNaN(yPos)) {
          if (currentSegment.length > 1) {
            tile.segments.push(currentSegment);
          }
          currentSegment = [];
          continue;
        }
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        currentSegment.push([xPos, yPos]);
      }
      if (currentSegment.length > 1) {
        tile.segments.push(currentSegment);
      }
      for (const segment of tile.segments) {
        const first2 = segment[0];
        const rest = segment.slice(1);
        graphics.moveTo(first2[0], first2[1]);
        for (const point2 of rest) {
          graphics.lineTo(point2[0], point2[1]);
        }
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
      this.pMouseOver.position.y = this.position[1];
      this.pMouseOver.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
      const isValueScaleLocked = this.isValueScaleLocked();
      if (this.continuousScaling && this.minValue() !== void 0 && this.maxValue() !== void 0) {
        if (this.valueScaleMin === null && this.valueScaleMax === null && !isValueScaleLocked) {
          const newMin = this.minVisibleValue();
          const newMax = this.maxVisibleValue();
          const epsilon3 = 1e-6;
          if (newMin !== null && newMax !== null && (Math.abs(this.minValue() - newMin) > epsilon3 || Math.abs(this.maxValue() - newMax) > epsilon3)) {
            this.minValue(newMin);
            this.maxValue(newMax);
            this.scheduleRerender();
          }
        }
        if (isValueScaleLocked) {
          this.onValueScaleChanged();
        }
      }
    }
  }, {
    key: "superSVG",
    value: function superSVG() {
      return _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "exportSVG", this).call(this);
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$r(_getPrototypeOf$_(HorizontalLine1DPixiTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      const stroke = this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue";
      this.visibleAndFetchedTiles().forEach((tile) => {
        if (tile.hasOwnProperty("segments")) {
          const p = document.createElement("path");
          p.setAttribute("fill", "transparent");
          p.setAttribute("stroke", stroke);
          let d = "";
          for (const segment of tile.segments) {
            const first2 = segment[0];
            const rest = segment.slice(1);
            d += `M${first2[0]} ${first2[1]}`;
            for (const point2 of rest) {
              d += `L${point2[0]} ${point2[1]}`;
            }
          }
          p.setAttribute("d", d);
          output.appendChild(p);
        } else if (tile.hasOwnProperty("tileData")) {
          const {
            tileX,
            tileWidth
          } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
          const tileValues = tile.tileData.dense;
          if (tileValues.length !== 0) {
            tile.svgData = void 0;
            const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension]).range([tileX, tileX + tileWidth]);
            let xPos;
            let width;
            let yPos;
            let height2;
            let color2 = this.options.barFillColor || "none";
            const [valueScale, pseudocount] = this.makeValueScale(this.minValue(), 0, this.maxValue(), 0);
            this.valueScale = valueScale;
            this.colorScale = colorDomainToRgbaArray(this.options.colorRange);
            const colorScale = valueScale.copy();
            colorScale.range([254, 0]).clamp(true);
            for (let i = 0; i < tileValues.length; i++) {
              xPos = this._xScale(tileXScale(i));
              yPos = this.valueScale(this.maxValue() + pseudocount);
              width = this._xScale(tileXScale(i + 1)) - xPos;
              height2 = this.dimensions[1];
              if (this.colorScale && !this.options.colorRangeGradient) {
                try {
                  const v = Math.round(colorScale(tileValues[i] + pseudocount));
                  color2 = "#" + this.colorScale[v].map((e) => e.toString(16).padStart(2, 0)).join("");
                  if (Number.isNaN(tileValues[i]) || height2 < 0 || yPos < 0) {
                    height2 = this.dimensions[1];
                    color2 = "#ffffff";
                  }
                  this.addSVGInfo(tile, xPos, yPos, width, height2, color2);
                } catch (err2) {
                }
              }
            }
            const data2 = tile.svgData;
            for (let j = 0; j < data2.barXValues.length; j++) {
              const barColor = data2.barColors[j];
              const barColorFull = barColor.substring(0, barColor.length - 2);
              const barColorAlpha = parseFloat(parseInt(barColor.substring(barColor.length - 2), 16)) / 255;
              const rect = document.createElement("rect");
              rect.setAttribute("fill", barColorFull);
              rect.setAttribute("fill-opacity", barColorAlpha);
              rect.setAttribute("x", data2.barXValues[j]);
              rect.setAttribute("y", data2.barYValues[j]);
              rect.setAttribute("height", data2.barHeights[j]);
              rect.setAttribute("width", data2.barWidths[j]);
              if (tile.barBorders) {
                rect.setAttribute("stroke-width", "0.1");
                rect.setAttribute("stroke", "black");
              }
              output.appendChild(rect);
            }
          }
        }
      });
      const gAxis = document.createElement("g");
      const gAxisUniqueId = Math.random().toString(36).substring(7);
      gAxis.setAttribute("id", `axis-${gAxisUniqueId}`);
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      if (this.options.aggregationMode && this.options.aggregationMode !== "mean") {
        return `${tile.join(".")}.${this.options.aggregationMode}`;
      }
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return this.tileToLocalId(tile);
    }
  }]);
  return HorizontalLine1DPixiTrack2;
}(HorizontalTiled1DPixiTrack);
function _classCallCheck$1d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$12(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$12(descriptor.key), descriptor);
  }
}
function _createClass$1b(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$12(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$12(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$12(arg) {
  var key = _toPrimitive$12(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$12(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$q() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$q = Reflect.get.bind();
  } else {
    _get$q = function _get2(target, property2, receiver) {
      var base = _superPropBase$q(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$q.apply(this, arguments);
}
function _superPropBase$q(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$Z(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$18(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$Z(subClass, superClass);
}
function _setPrototypeOf$Z(o, p) {
  _setPrototypeOf$Z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$Z(o, p);
}
function _createSuper$Z(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Z();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Z(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Z(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$18(this, result);
  };
}
function _possibleConstructorReturn$18(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$Z(self2);
}
function _assertThisInitialized$Z(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$Z() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Z(o) {
  _getPrototypeOf$Z = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$Z(o);
}
let HorizontalPoint1DPixiTrack = /* @__PURE__ */ function(_HorizontalLine1DPixi) {
  _inherits$18(HorizontalPoint1DPixiTrack2, _HorizontalLine1DPixi);
  var _super = _createSuper$Z(HorizontalPoint1DPixiTrack2);
  function HorizontalPoint1DPixiTrack2() {
    _classCallCheck$1d(this, HorizontalPoint1DPixiTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$1b(HorizontalPoint1DPixiTrack2, [{
    key: "initTile",
    value: (
      /**
       * Create whatever is needed to draw this tile.
       */
      function initTile(tile) {
        tile.barXValues = new Array(tile.tileData.dense.length);
        tile.barYValues = new Array(tile.tileData.dense.length);
        tile.barWidths = new Array(tile.tileData.dense.length);
        tile.barHeights = new Array(tile.tileData.dense.length);
        _get$q(_getPrototypeOf$Z(HorizontalPoint1DPixiTrack2.prototype), "initTile", this).call(this, tile);
      }
    )
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      let pseudocount = 0;
      this.valueScale = null;
      if (this.options.valueScaling === "log") {
        let offsetValue = this.medianVisibleValue;
        if (!this.medianVisibleValue) {
          offsetValue = this.minValue();
        }
        this.valueScale = log$4().domain([offsetValue, this.maxValue() + offsetValue]).range([this.dimensions[1], 0]);
        pseudocount = offsetValue;
      } else {
        this.valueScale = linear().domain([this.minValue(), this.maxValue()]).range([this.dimensions[1], 0]);
      }
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const squareSide = this.options.pointSize ? this.options.pointSize : 3;
      const pointColor = colorToHex(this.options.pointColor ? this.options.pointColor : "red");
      graphics.beginFill(pointColor, 1);
      tile.drawnAtScale = this._xScale.copy();
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + pseudocount);
        tile.barXValues[i] = xPos - squareSide / 2 / this.pMain.scale.x;
        tile.barYValues[i] = yPos - squareSide / 2 / this.pMain.scale.y;
        tile.barWidths[i] = squareSide / this.pMain.scale.x;
        tile.barHeights[i] = squareSide / this.pMain.scale.y;
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        graphics.drawRect(xPos - squareSide / 2 / this.pMain.scale.x, yPos - squareSide / 2 / this.pMain.scale.y, squareSide / this.pMain.scale.x, squareSide / this.pMain.scale.y);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$q(_getPrototypeOf$Z(HorizontalPoint1DPixiTrack2.prototype), "draw", this).call(this);
      for (const tile of dictValues(this.fetchedTiles)) {
        const tileK = (tile.drawnAtScale.domain()[1] - tile.drawnAtScale.domain()[0]) / (this._xScale.domain()[1] - this._xScale.domain()[0]);
        const newRange = this._xScale.domain().map(tile.drawnAtScale);
        const posOffset = newRange[0];
        tile.graphics.scale.x = tileK;
        tile.graphics.position.x = -posOffset * tileK;
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _get$q(_getPrototypeOf$Z(HorizontalPoint1DPixiTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _get$q(_getPrototypeOf$Z(HorizontalPoint1DPixiTrack2.prototype), "superSVG", this).call(this);
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        for (let i = 0; i < tile.barXValues.length; i++) {
          const rect = document.createElement("rect");
          const strokeColor = this.options.lineStrokeColor || "blue";
          const pointColor = this.options.pointColor || "red";
          rect.setAttribute("fill", pointColor);
          rect.setAttribute("stroke", strokeColor);
          rect.setAttribute("stroke-width", 0);
          rect.setAttribute("x", tile.barXValues[i]);
          rect.setAttribute("y", tile.barYValues[i]);
          rect.setAttribute("height", tile.barHeights[i]);
          rect.setAttribute("width", tile.barWidths[i]);
          output.appendChild(rect);
        }
      }
      const gAxis = document.createElement("g");
      const gAxisUniqueId = Math.random().toString(36).substring(7);
      gAxis.setAttribute("id", `axis-${gAxisUniqueId}`);
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }]);
  return HorizontalPoint1DPixiTrack2;
}(HorizontalLine1DPixiTrack);
function cumsum(values2) {
  let sum2 = 0;
  const result = [];
  values2.forEach((v) => {
    sum2 += +v || 0;
    result.push(sum2);
  });
  return Float64Array.from(result);
}
const selectedItemsToCumWeights = (selectedItems, withRelativeSize) => {
  const totalLength = selectedItemsToSize(selectedItems, withRelativeSize);
  return cumsum(selectedItems.map((d) => (Array.isArray(d) && withRelativeSize ? d.length : 1) / totalLength));
};
function _classCallCheck$1c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$11(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$11(descriptor.key), descriptor);
  }
}
function _createClass$1a(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$11(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$11(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$11(arg) {
  var key = _toPrimitive$11(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$11(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$p() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$p = Reflect.get.bind();
  } else {
    _get$p = function _get2(target, property2, receiver) {
      var base = _superPropBase$p(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$p.apply(this, arguments);
}
function _superPropBase$p(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$Y(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$17(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$Y(subClass, superClass);
}
function _setPrototypeOf$Y(o, p) {
  _setPrototypeOf$Y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$Y(o, p);
}
function _createSuper$Y(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Y();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Y(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Y(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$17(this, result);
  };
}
function _possibleConstructorReturn$17(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$Y(self2);
}
function _assertThisInitialized$Y(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$Y() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Y(o) {
  _getPrototypeOf$Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$Y(o);
}
let HorizontalMultivecTrack = /* @__PURE__ */ function(_HeatmapTiledPixiTrac) {
  _inherits$17(HorizontalMultivecTrack2, _HeatmapTiledPixiTrac);
  var _super = _createSuper$Y(HorizontalMultivecTrack2);
  function HorizontalMultivecTrack2(context, options2) {
    var _this;
    _classCallCheck$1c(this, HorizontalMultivecTrack2);
    _this = _super.call(this, context, options2);
    _this.pMain = _this.pMobile;
    _this.continuousScaling = false;
    _this.updateDataFetcher(options2);
    return _this;
  }
  _createClass$1a(HorizontalMultivecTrack2, [{
    key: "updateDataFetcher",
    value: function updateDataFetcher(options2) {
      if (options2 && options2.selectRows && options2.selectRowsAggregationMethod === "server") {
        const {
          pubSub,
          dataFetcher: prevDataFetcher
        } = this;
        const prevDataConfigOptions = prevDataFetcher.dataConfig.options;
        const nextDataConfigOptions = {
          aggGroups: options2.selectRows,
          aggFunc: options2.selectRowsAggregationMode
        };
        if (JSON.stringify(prevDataConfigOptions) !== JSON.stringify(nextDataConfigOptions)) {
          const newDataConfig = {
            ...prevDataFetcher.dataConfig,
            options: nextDataConfigOptions
          };
          this.dataFetcher = new prevDataFetcher.constructor(newDataConfig, pubSub);
          if (this.dataFetcher.dataConfig.tilesetUid) {
            this.fetchNewTiles(Object.keys(this.fetchedTiles).map((x) => ({
              tileId: x,
              remoteId: x
            })));
          }
        }
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      this.updateDataFetcher(options2);
      _get$p(_getPrototypeOf$Y(HorizontalMultivecTrack2.prototype), "rerender", this).call(this, options2, force);
      if (options2.selectRows) {
        this.selectRowsCumWeights = selectedItemsToCumWeights(options2.selectRows, options2.selectRowsAggregationWithRelativeHeight);
      }
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      if (this.options.selectRows && this.tilesetInfo.shape) {
        canvas.width = this.tilesetInfo.shape[0];
        canvas.height = selectedItemsToSize(this.options.selectRows, this.options.selectRowsAggregationWithRelativeHeight);
      } else if (this.tilesetInfo.shape) {
        canvas.width = this.tilesetInfo.shape[0];
        canvas.height = this.tilesetInfo.shape[1];
      } else {
        canvas.width = this.tilesetInfo.tile_size;
        canvas.height = 1;
      }
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      if (pixData.length !== 0 && pixData.length === 4 * canvas.width * canvas.height) {
        const pix = new ImageData(pixData, canvas.width, canvas.height);
        ctx.putImageData(pix, 0, 0);
      } else {
        console.warn("HorizontalMultivecTrack: pixData has an incorrect length.");
      }
      return canvas;
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos) {
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(zoomLevel, tilePos, this.tilesetInfo.tile_size);
      const tileEndX = tileX + tileWidth;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this.dimensions[1];
      sprite.x = this._refXScale(tileX);
      sprite.y = 0;
    }
  }, {
    key: "leftTrackZoomed",
    value: function leftTrackZoomed(newXScale, newYScale, k, tx, ty) {
      const offset2 = this._xScale(0) - k * this._refXScale(0);
      this.pMobile.position.x = offset2 + this.position[0];
      this.pMobile.position.y = this.position[1];
      this.pMobile.scale.x = k;
      this.pMobile.scale.y = 1;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx) {
      _get$p(_getPrototypeOf$Y(HorizontalMultivecTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = 1;
      this.drawColorbar();
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], null, this.tilesetInfo.tile_size);
      } else {
        this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      }
      const tiles = this.xTiles.map((x) => [this.zoomLevel, x]);
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      if (!this.tilesetInfo)
        return void 0;
      const minX = this.tilesetInfo.min_pos[0];
      let zoomIndexX = null;
      if (this.tilesetInfo.resolutions) {
        zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, minX);
      } else {
        zoomIndexX = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      }
      return zoomIndexX;
    }
    /**
     * Create the local tile identifier, which be used with the
     * tile stores in TiledPixiTrack
     *
     * @param {array} tile: [zoomLevel, xPos]
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return tile.join(".");
    }
    /**
     * Create the remote tile identifier, which will be used to identify the
     * tile on the server
     *
     * @param {array} tile: [zoomLevel, xPos]
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return tile.join(".");
    }
    /**
     * Calculate the tile position at the given track position
     *
     * @param {Number} trackX: The track's X position
     * @param {Number} trackY: The track's Y position
     *
     * @return {array} [zoomLevel, tilePos]
     */
  }, {
    key: "getTilePosAtPosition",
    value: function getTilePosAtPosition(trackX, trackY) {
      if (!this.tilesetInfo)
        return void 0;
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(trackX) / tileWidth;
      return [zoomLevel, Math.floor(tilePos)];
    }
    /**
     * Return the data currently visible at position X and Y
     *
     * @param {Number} trackX: The x position relative to the track's start and end
     * @param {Number} trakcY: The y position relative to the track's start and end
     */
  }, {
    key: "getVisibleData",
    value: function getVisibleData(trackX, trackY) {
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(trackX) / tileWidth;
      let numRows = this.tilesetInfo.shape ? this.tilesetInfo.shape[1] : 1;
      if (this.options.selectRows) {
        numRows = selectedItemsToSize(this.options.selectRows, this.options.selectRowsAggregationWithRelativeHeight);
      }
      let posInTileX = this.tilesetInfo.tile_size * (tilePos - Math.floor(tilePos));
      const posInTileYNormalized = trackY / this.dimensions[1];
      const posInTileY = posInTileYNormalized * numRows;
      let selectedRowIndex = Math.floor(posInTileY);
      let selectedRowItem;
      if (this.options.selectRows) {
        if (this.options.selectRowsAggregationWithRelativeHeight) {
          selectedRowIndex = this.selectRowsCumWeights.findIndex((weight, i) => posInTileYNormalized <= weight && (i === this.selectRowsCumWeights.length - 1 || this.selectRowsCumWeights[i + 1] >= posInTileYNormalized));
        }
        selectedRowItem = this.options.selectRows[selectedRowIndex];
      }
      const tileId = this.tileToLocalId([zoomLevel, Math.floor(tilePos)]);
      const fetchedTile = this.fetchedTiles[tileId];
      let value2 = "";
      if (fetchedTile) {
        if (!this.tilesetInfo.shape) {
          posInTileX = fetchedTile.tileData.dense.length * (tilePos - Math.floor(tilePos));
        }
        let index2 = null;
        if (this.tilesetInfo.shape) {
          if (Array.isArray(selectedRowItem) && this.options.selectRowsAggregationMethod === "client") {
            index2 = selectedRowItem.map((rowI) => this.tilesetInfo.shape[0] * rowI + Math.floor(posInTileX));
          } else if (selectedRowItem && this.options.selectRowsAggregationMethod === "client") {
            index2 = this.tilesetInfo.shape[0] * selectedRowItem + Math.floor(posInTileX);
          } else {
            index2 = this.tilesetInfo.shape[0] * selectedRowIndex + Math.floor(posInTileX);
          }
        } else {
          index2 = fetchedTile.tileData.dense.length * selectedRowIndex + Math.floor(posInTileX);
        }
        if (Array.isArray(index2)) {
          const aggFunc = getAggregationFunction(this.options.selectRowsAggregationMode);
          const values2 = index2.map((i) => fetchedTile.tileData.dense[i]);
          value2 = format$1(".3f")(aggFunc(values2));
          value2 += "<br/>";
          value2 += `${index2.length}-item ${this.options.selectRowsAggregationMode}`;
        } else {
          value2 = format$1(".3f")(fetchedTile.tileData.dense[index2]);
          if (Array.isArray(selectedRowItem)) {
            value2 += "<br/>";
            value2 += `${selectedRowItem.length}-item ${this.options.selectRowsAggregationMode}`;
          }
        }
      }
      if (this.tilesetInfo.row_infos) {
        value2 += "<br/>";
        let rowInfo = "";
        if (this.options.selectRows && !Array.isArray(selectedRowItem)) {
          rowInfo = this.tilesetInfo.row_infos[selectedRowItem];
        } else if (selectedRowIndex >= 0 && selectedRowIndex < this.tilesetInfo.row_infos.length) {
          rowInfo = this.tilesetInfo.row_infos[selectedRowIndex];
        }
        if (typeof rowInfo === "object") {
          value2 += Object.values(rowInfo).join("	");
        } else {
          value2 += rowInfo;
        }
      }
      return `${value2}`;
    }
    /**
     * Get some information to display when the mouse is over this
     * track
     *
     * @param {Number} trackX: the x position of the mouse over the track
     * @param {Number} trackY: the y position of the mouse over the track
     *
     * @return {string}: A HTML string containing the information to display
     *
     */
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      if (!this.tilesetInfo || !this.options.showTooltip && !isShiftDown)
        return "";
      const tilePos = this.getTilePosAtPosition(trackX, trackY);
      let output = "";
      const visibleData = this.getVisibleData(trackX, trackY);
      const elements = visibleData.split("<br/>");
      if (this.options && this.options.heatmapValueScaling && this.options.heatmapValueScaling === "categorical" && this.options.colorRange) {
        let capitalize = function(text2) {
          return text2[0].toUpperCase() + text2.substring(1);
        };
        const color2 = this.options.colorRange[parseInt(elements[0], 10) - 1];
        if (Number.isNaN(color2) || color2 === "NaN" || typeof color2 === "undefined" || color2 === "undefined") {
          return "";
        }
        let label = elements[1];
        const colorIndex = parseInt(elements[0], 10);
        if (!label || label === "undefined" || typeof label === "undefined")
          return "";
        let colorLabel = "NA";
        if (this.options.colorLabels) {
          colorLabel = this.options.colorLabels[colorIndex] ? this.options.colorLabels[colorIndex][0] : null;
          if (!colorLabel || colorLabel === "undefined" || typeof colorLabel === "undefined")
            colorLabel = "NA";
          label += ` | ${colorLabel}`;
        }
        const dataX = this._xScale.invert(trackX);
        let positionText = null;
        if (this.options.chromInfo && this.options.binSize) {
          const atcX = absToChr(dataX, this.options.chromInfo);
          const chrom = atcX[0];
          const position = Math.ceil(atcX[1] / this.options.binSize) * this.options.binSize - this.options.binSize;
          positionText = `${chrom}:${position}`;
        }
        const metadataElements = elements[1].split("|").map((d) => d.trim());
        output = `<div class="track-mouseover-menu-table">`;
        if (positionText) {
          output += `
        <div class="track-mouseover-menu-table-item">
          <label for="position" class="track-mouseover-menu-table-item-label">Position</label>
          <div name="position" class="track-mouseover-menu-table-item-value">${positionText}</div>
        </div>
        `;
        }
        const sampleName = capitalize(metadataElements[1]);
        const specificSampleName = metadataElements.length === 3 && metadataElements[1] !== metadataElements[2] ? `(${metadataElements[2]})` : "";
        output += `<div class="track-mouseover-menu-table-item">
        <label for="sampleName" class="track-mouseover-menu-table-item-label">Biosample</label>
        <div name="sampleName" class="track-mouseover-menu-table-item-value">${sampleName} ${specificSampleName}</div>
      </div>`;
        const sampleId = metadataElements[0];
        output += `<div class="track-mouseover-menu-table-item">
        <label for="sampleId" class="track-mouseover-menu-table-item-label">Identifier</label>
        <div name="sampleId" class="track-mouseover-menu-table-item-value">${sampleId}</div>
      </div>`;
        const stateColor = color2;
        const stateName = colorLabel;
        const stateRGBMarkup = `<svg width="10" height="10" style="position:relative; top:-2px;"><rect width="10" height="10" rx="2" ry="2" style="fill:${stateColor};stroke:black;stroke-width:2;"></svg> ${stateName}`;
        output += `
        <div class="track-mouseover-menu-table-item">
          <label for="stateName" class="track-mouseover-menu-table-item-label">Chromatin state</label>
          <div name="stateName" class="track-mouseover-menu-table-item-value">${stateRGBMarkup}</div>
        </div>`;
        output += `</div>`;
      } else if (this.options && this.options.heatmapType && this.options.heatmapType === "genericIndexDHS") {
        let componentLongNameToColor = null;
        if (this.options.heatmapComponents) {
          componentLongNameToColor = {};
          for (const [key, value2] of Object.entries(this.options.heatmapComponents)) {
            componentLongNameToColor[value2.longName] = value2.color;
          }
        }
        elements[0];
        const biosampleMetadataElements = elements[1].split("|").map((d) => d.trim());
        const biosampleMetadata = {
          normalizedDensity: elements[0],
          taxonomyName: biosampleMetadataElements[0],
          componentName: biosampleMetadataElements[1]
        };
        const dataX = this._xScale.invert(trackX);
        let positionText = null;
        if (this.options.chromInfo && this.options.binSize) {
          const atcX = absToChr(dataX, this.options.chromInfo);
          const chrom = atcX[0];
          const position = Math.ceil(atcX[1] / this.options.binSize) * this.options.binSize - this.options.binSize;
          positionText = `${chrom}:${position}`;
        }
        output += `<div class="track-mouseover-menu-table">`;
        if (positionText) {
          output += `
        <div class="track-mouseover-menu-table-item">
          <label for="position" class="track-mouseover-menu-table-item-label">Position</label>
          <div name="position" class="track-mouseover-menu-table-item-value">${positionText}</div>
        </div>
        `;
        }
        output += `
        <div class="track-mouseover-menu-table-item">
          <label for="normalizedDensity" class="track-mouseover-menu-table-item-label">Normalized density</label>
          <div name="normalizedDensity" class="track-mouseover-menu-table-item-value">${biosampleMetadata.normalizedDensity}</div>
        </div>
        <div class="track-mouseover-menu-table-item">
          <label for="taxonomyName" class="track-mouseover-menu-table-item-label">Taxonomy name</label>
          <div name="taxonomyName" class="track-mouseover-menu-table-item-value">${biosampleMetadata.taxonomyName}</div>
        </div>`;
        if (componentLongNameToColor) {
          const componentColor = componentLongNameToColor[biosampleMetadata.componentName];
          const componentName = biosampleMetadata.componentName;
          const componentRGBMarkup = `<svg width="10" height="10"><rect width="10" height="10" rx="2" ry="2" style="fill:${componentColor};stroke:black;stroke-width:2;"></svg> ${componentName}`;
          output += `
          <div class="track-mouseover-menu-table-item">
            <label for="componentName" class="track-mouseover-menu-table-item-label">Component</label>
            <div name="componentName" class="track-mouseover-menu-table-item-value">${componentRGBMarkup}</div>
          </div>`;
        } else {
          output += `
          <div class="track-mouseover-menu-table-item">
            <label for="componentName" class="track-mouseover-menu-table-item-label">Component</label>
            <div name="componentName" class="track-mouseover-menu-table-item-value">${biosampleMetadata.componentName}</div>
          </div>`;
        }
        output += `</div>`;
      } else {
        output += `Data value: ${this.getVisibleData(trackX, trackY)}</br>`;
        output += `Zoom level: ${tilePos[0]} tile position: ${tilePos[1]}`;
      }
      return output;
    }
  }]);
  return HorizontalMultivecTrack2;
}(HeatmapTiledPixiTrack);
function _classCallCheck$1b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$10(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$10(descriptor.key), descriptor);
  }
}
function _createClass$19(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$10(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$10(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$10(arg) {
  var key = _toPrimitive$10(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$10(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$o() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$o = Reflect.get.bind();
  } else {
    _get$o = function _get2(target, property2, receiver) {
      var base = _superPropBase$o(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$o.apply(this, arguments);
}
function _superPropBase$o(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$X(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$16(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$X(subClass, superClass);
}
function _setPrototypeOf$X(o, p) {
  _setPrototypeOf$X = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$X(o, p);
}
function _createSuper$X(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$X();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$X(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$X(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$16(this, result);
  };
}
function _possibleConstructorReturn$16(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$X(self2);
}
function _assertThisInitialized$X(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$X() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$X(o) {
  _getPrototypeOf$X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$X(o);
}
const HEX_WHITE = colorToHex("#FFFFFF");
let BarTrack = /* @__PURE__ */ function(_HorizontalLine1DPixi) {
  _inherits$16(BarTrack2, _HorizontalLine1DPixi);
  var _super = _createSuper$X(BarTrack2);
  function BarTrack2(...args) {
    var _this;
    _classCallCheck$1b(this, BarTrack2);
    _this = _super.call(this, ...args);
    _this.zeroLine = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.zeroLine);
    _this.valueScaleTransform = identity$4;
    if (_this.options && _this.options.colorRange) {
      if (_this.options.colorRangeGradient) {
        _this.setColorGradient(_this.options.colorRange);
      } else {
        _this.setColorScale(_this.options.colorRange);
      }
    }
    _this.initialized = true;
    return _this;
  }
  _createClass$19(BarTrack2, [{
    key: "setColorScale",
    value: function setColorScale(colorRange) {
      if (!colorRange)
        return;
      this.colorScale = colorDomainToRgbaArray(colorRange);
      this.colorScale = this.colorScale.map((rgb2) => rgb2.map((channel) => channel / 255));
    }
  }, {
    key: "setColorGradient",
    value: function setColorGradient(colorGradient) {
      if (!colorGradient)
        return;
      const N = colorGradient.length - 1;
      this.colorGradientColors = this.options.align === "bottom" ? colorGradient.slice().reverse().map((color2, i) => ({
        from: i / N,
        color: color2
      })) : colorGradient.map((color2, i) => ({
        from: i / N,
        color: color2
      }));
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      if (!this.initialized)
        return;
      _get$o(_getPrototypeOf$X(BarTrack2.prototype), "initTile", this).call(this, tile);
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
      if (!tile.valueScale || !this.scale || this.scale.minValue !== tile.scale.minValue || this.scale.maxValue !== tile.scale.maxValue) {
        this.renderTile(tile);
      }
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!this.initialized)
        return;
      _get$o(_getPrototypeOf$X(BarTrack2.prototype), "renderTile", this).call(this, tile);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics)
        return;
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const {
        graphics
      } = tile;
      tile.svgData = void 0;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0)
        return;
      const [valueScale, pseudocount] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue(), 0);
      valueScale.clamp(true);
      this.valueScale = valueScale;
      const colorScale = valueScale.copy();
      colorScale.range([254, 0]).clamp(true);
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor || "blue");
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const color2 = this.options.barFillColor || "grey";
      const colorHex = colorToHex(color2);
      const opacity = "barOpacity" in this.options ? this.options.barOpacity : 1;
      graphics.beginFill(colorHex, opacity);
      tile.drawnAtScale = this._xScale.copy();
      const isTopAligned = this.options.align === "top";
      let xPos;
      let width;
      let yPos;
      let height2;
      let barMask;
      let barSprite;
      if (this.colorGradientColors) {
        barMask = new GLOBALS.PIXI.Graphics();
        barMask.beginFill(HEX_WHITE, 1);
        const canvas = gradient(
          this.colorGradientColors,
          1,
          this.dimensions[1],
          // width, height
          0,
          0,
          0,
          this.dimensions[1]
          // fromX, fromY, toX, toY
        );
        barSprite = new GLOBALS.PIXI.Sprite(GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST));
        barSprite.x = this._xScale(tileX);
        barSprite.width = this._xScale(tileX + tileWidth) - barSprite.x;
      }
      for (let i = 0; i < tileValues.length; i++) {
        xPos = this._xScale(tileXScale(i));
        yPos = this.valueScale(tileValues[i] + pseudocount);
        width = this._xScale(tileXScale(i + 1)) - xPos;
        height2 = this.dimensions[1] - yPos;
        if (isTopAligned)
          yPos = 0;
        if (Number.isNaN(height2) || height2 < 0 || yPos < 0)
          continue;
        this.addSVGInfo(tile, xPos, yPos, width, height2, color2);
        if (tileXScale(i) > this.tilesetInfo.max_pos[0])
          break;
        if (this.colorScale && !this.options.colorRangeGradient) {
          const rgbIdx = Math.round(colorScale(tileValues[i] + pseudocount));
          const rgb2 = this.colorScale[rgbIdx];
          const hex2 = GLOBALS.PIXI.utils.rgb2hex(rgb2);
          graphics.beginFill(hex2, opacity);
        }
        (barMask || graphics).drawRect(xPos, yPos, width, height2);
      }
      if (this.colorGradientColors) {
        barSprite.mask = barMask;
        graphics.removeChildren();
        graphics.addChild(barSprite, barMask);
      }
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.graphics.destroy(true);
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.visibleAndFetchedTiles().forEach((tile) => this.destroyTile(tile));
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      if (options2 && options2.colorRange) {
        if (options2.colorRangeGradient) {
          this.setColorGradient(options2.colorRange);
        } else {
          this.setColorScale(options2.colorRange);
        }
      }
      _get$o(_getPrototypeOf$X(BarTrack2.prototype), "rerender", this).call(this, options2, force);
    }
  }, {
    key: "drawZeroLine",
    value: function drawZeroLine() {
      this.zeroLine.clear();
      const color2 = colorToHex(this.options.barFillColor || "grey");
      const opacity = +this.options.barOpacity || 1;
      const demarcationColor = this.options.zeroLineColor ? colorToHex(this.options.zeroLineColor) : color2;
      const demarcationOpacity = Number.isNaN(+this.options.zeroLineOpacity) ? opacity : +this.options.zeroLineOpacity;
      this.zeroLine.beginFill(demarcationColor, demarcationOpacity);
      this.zeroLine.drawRect(0, this.dimensions[1] - 1, this.dimensions[0], 1);
    }
  }, {
    key: "drawZeroLineSvg",
    value: function drawZeroLineSvg(output) {
      const zeroLine = document.createElement("rect");
      const zeroLineUniqueID = Math.random().toString(36).substring(7);
      zeroLine.setAttribute("id", `zero-line-${zeroLineUniqueID}`);
      zeroLine.setAttribute("x", 0);
      zeroLine.setAttribute("y", this.dimensions[1] - 1);
      zeroLine.setAttribute("height", 1);
      zeroLine.setAttribute("width", this.dimensions[0]);
      zeroLine.setAttribute("fill", this.options.zeroLineColor || this.options.barFillColor);
      zeroLine.setAttribute("fill-opacity", this.options.zeroLineOpacity || this.options.barOpacity);
      output.appendChild(zeroLine);
    }
  }, {
    key: "getXScaleAndOffset",
    value: function getXScaleAndOffset(drawnAtScale) {
      const dA = drawnAtScale.domain();
      const dB = this._xScale.domain();
      const tileK = (dA[1] - dA[0]) / (dB[1] - dB[0]);
      const newRange = this._xScale.domain().map(drawnAtScale);
      const posOffset = newRange[0];
      return [tileK, -posOffset * tileK];
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.initialized)
        return;
      _get$o(_getPrototypeOf$X(BarTrack2.prototype), "draw", this).call(this);
      if (this.zeroLine && this.zeroLine._graphics && this.options.zeroLineVisible) {
        this.drawZeroLine();
      } else if (this.zeroLine && this.zeroLine._graphics) {
        this.zeroLine.clear();
      }
      Object.values(this.fetchedTiles).forEach((tile) => {
        if (!tile || !tile.graphics) {
          return;
        }
        try {
          const [graphicsXScale, graphicsXPos] = this.getXScaleAndOffset(tile.drawnAtScale);
          tile.graphics.scale.x = graphicsXScale;
          tile.graphics.position.x = graphicsXPos;
        } catch (err2) {
        }
      });
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _get$o(_getPrototypeOf$X(BarTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
    }
  }, {
    key: "movedY",
    value: function movedY2(dY) {
    }
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
    }
    /**
     * Adds information to recreate the track in SVG to the tile
     *
     * @param tile
     * @param x x value of bar
     * @param y y value of bar
     * @param width width of bar
     * @param height height of bar
     * @param color color of bar (not converted to hex)
     */
  }, {
    key: "addSVGInfo",
    value: function addSVGInfo(tile, x, y, width, height2, color2) {
      if (tile.svgData) {
        tile.svgData.barXValues.push(x);
        tile.svgData.barYValues.push(y);
        tile.svgData.barWidths.push(width);
        tile.svgData.barHeights.push(height2);
        tile.svgData.barColors.push(color2);
      } else {
        tile.svgData = {
          barXValues: [x],
          barYValues: [y],
          barWidths: [width],
          barHeights: [height2],
          barColors: [color2]
        };
      }
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _get$o(_getPrototypeOf$X(BarTrack2.prototype), "superSVG", this).call(this);
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      if (this.options.zeroLine)
        this.drawZeroLineSvg(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.svgData && tile.svgData.barXValues).forEach((tile) => {
        const data2 = tile.svgData;
        for (let i = 0; i < data2.barXValues.length; i++) {
          const barColor = data2.barColors[i];
          const barColorFull = barColor.length === 9 ? barColor.substring(0, barColor.length - 2) : barColor;
          const barColorAlpha = barColor.length === 9 ? parseFloat(parseInt(barColor.substring(barColor.length - 2), 16)) / 255 : 1;
          const rect = document.createElement("rect");
          rect.setAttribute("fill", barColorFull);
          rect.setAttribute("fill-opacity", barColorAlpha);
          rect.setAttribute("x", data2.barXValues[i]);
          rect.setAttribute("y", data2.barYValues[i]);
          rect.setAttribute("height", data2.barHeights[i]);
          rect.setAttribute("width", data2.barWidths[i]);
          if (tile.barBorders) {
            rect.setAttribute("stroke-width", "0.1");
            rect.setAttribute("stroke", "black");
          }
          output.appendChild(rect);
        }
      });
      const gAxis = document.createElement("g");
      const gAxisUniqueId = Math.random().toString(36).substring(7);
      gAxis.setAttribute("id", `axis-${gAxisUniqueId}`);
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }]);
  return BarTrack2;
}(HorizontalLine1DPixiTrack);
function _classCallCheck$1a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$$(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$$(descriptor.key), descriptor);
  }
}
function _createClass$18(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$$(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$$(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$$(arg) {
  var key = _toPrimitive$$(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$$(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$15(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$W(subClass, superClass);
}
function _setPrototypeOf$W(o, p) {
  _setPrototypeOf$W = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$W(o, p);
}
function _createSuper$W(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$W();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$W(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$W(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$15(this, result);
  };
}
function _possibleConstructorReturn$15(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$W(self2);
}
function _assertThisInitialized$W(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$W() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$W(o) {
  _getPrototypeOf$W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$W(o);
}
let DivergentBarTrack = /* @__PURE__ */ function(_BarTrack) {
  _inherits$15(DivergentBarTrack2, _BarTrack);
  var _super = _createSuper$W(DivergentBarTrack2);
  function DivergentBarTrack2() {
    _classCallCheck$1a(this, DivergentBarTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$18(DivergentBarTrack2, [{
    key: "drawTile",
    value: function drawTile(tile) {
      this.renderTile(tile);
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      let pseudocount = 0;
      this.valueScale = null;
      if (this.options.valueScaling === "log") {
        let offsetValue = this.medianVisibleValue;
        if (!this.medianVisibleValue) {
          offsetValue = this.minValue();
        }
        this.valueScale = log$4().domain([offsetValue, this.maxValue() + offsetValue]).range([this.dimensions[1], 0]);
        pseudocount = offsetValue;
      } else {
        this.valueScale = linear().domain([this.minValue(), this.maxValue()]).range([this.dimensions[1], 0]);
      }
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const topColor = this.options.barFillColorTop ? this.options.barFillColorTop : "green";
      const bottomColor = this.options.barFillColorBottom ? this.options.barFillColorBottom : "red";
      const topColorHex = colorToHex(topColor);
      const bottomColorHex = colorToHex(bottomColor);
      const opacity = "barOpacity" in this.options ? this.options.barOpacity : 1;
      tile.drawnAtScale = this._xScale.copy();
      let baseline = 0;
      if (this.options.valueScaling === "log") {
        baseline = this.valueScale(1);
      } else {
        baseline = this.valueScale(0);
      }
      delete tile.svgData;
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + pseudocount);
        const width = this._xScale(tileXScale(i + 1)) - xPos;
        if (yPos > baseline) {
          graphics.beginFill(bottomColorHex, opacity);
          this.addSVGInfo(tile, xPos, baseline, width, yPos - baseline, bottomColor);
        } else {
          graphics.beginFill(topColorHex, opacity);
          this.addSVGInfo(tile, xPos, yPos, width, baseline - yPos, topColor);
        }
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        graphics.drawRect(xPos, tile.svgData.barYValues[i], width, tile.svgData.barHeights[i]);
      }
    }
  }]);
  return DivergentBarTrack2;
}(BarTrack);
function _classCallCheck$19(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$_(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$_(descriptor.key), descriptor);
  }
}
function _createClass$17(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$_(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$_(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$_(arg) {
  var key = _toPrimitive$_(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$_(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$n() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$n = Reflect.get.bind();
  } else {
    _get$n = function _get2(target, property2, receiver) {
      var base = _superPropBase$n(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$n.apply(this, arguments);
}
function _superPropBase$n(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$V(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$14(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$V(subClass, superClass);
}
function _setPrototypeOf$V(o, p) {
  _setPrototypeOf$V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$V(o, p);
}
function _createSuper$V(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$V();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$V(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$V(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$14(this, result);
  };
}
function _possibleConstructorReturn$14(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$V(self2);
}
function _assertThisInitialized$V(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$V() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$V(o) {
  _getPrototypeOf$V = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$V(o);
}
let Horizontal1dHeatmapTrack = /* @__PURE__ */ function(_HorizontalLine1DPixi) {
  _inherits$14(Horizontal1dHeatmapTrack2, _HorizontalLine1DPixi);
  var _super = _createSuper$V(Horizontal1dHeatmapTrack2);
  function Horizontal1dHeatmapTrack2(context, options2) {
    var _this;
    _classCallCheck$19(this, Horizontal1dHeatmapTrack2);
    _this = _super.call(this, context, options2);
    _this.setColorScale(options2.colorRange);
    _this.opacity = options2.opacity || 1;
    return _this;
  }
  _createClass$17(Horizontal1dHeatmapTrack2, [{
    key: "setColorScale",
    value: function setColorScale(colorRange) {
      this.colorScale = colorRange ? colorDomainToRgbaArray(colorRange) : HEATED_OBJECT_MAP;
      this.colorScale = this.colorScale.map((rgb2) => rgb2.map((channel) => channel / 255));
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
      if (options2 && options2.colorRange) {
        this.setColorScale(options2.colorRange);
      }
      this.opacity = options2.opacity || 1;
      _get$n(_getPrototypeOf$V(Horizontal1dHeatmapTrack2.prototype), "rerender", this).call(this, options2);
    }
  }, {
    key: "drawAxis",
    value: function drawAxis2() {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics || !tile.tileData || !tile.tileData.dense)
        return;
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0)
        return;
      const [valueScale, pseudocount] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue());
      valueScale.range([254, 0]).clamp(true);
      this.valueScale = valueScale;
      graphics.clear();
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      graphics.lineStyle(0, 0, 0);
      for (let i = 0; i < tileValues.length; i++) {
        if (Number.isNaN(tileValues[i]))
          continue;
        const rgbIdx = Math.round(this.valueScale(tileValues[i] + pseudocount));
        if (Number.isNaN(+rgbIdx))
          continue;
        const xPos = this._xScale(tileXScale(i));
        const width = this._xScale(tileXScale(i + 1)) - xPos;
        const height2 = this.dimensions[1];
        tile.xValues[i] = xPos;
        tile.yValues[i] = rgbIdx;
        const rgb2 = this.colorScale[rgbIdx];
        const hex2 = GLOBALS.PIXI.utils.rgb2hex(rgb2);
        graphics.beginFill(hex2, this.opacity);
        if (i === 0)
          continue;
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        if (tileValues[i] !== 0) {
          graphics.drawRect(xPos, 0, width, height2);
        }
      }
    }
  }]);
  return Horizontal1dHeatmapTrack2;
}(HorizontalLine1DPixiTrack);
function _classCallCheck$18(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$Z(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$Z(descriptor.key), descriptor);
  }
}
function _createClass$16(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$Z(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$Z(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$Z(arg) {
  var key = _toPrimitive$Z(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$Z(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$13(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$U(subClass, superClass);
}
function _setPrototypeOf$U(o, p) {
  _setPrototypeOf$U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$U(o, p);
}
function _createSuper$U(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$U();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$U(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$U(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$13(this, result);
  };
}
function _possibleConstructorReturn$13(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$U(self2);
}
function _assertThisInitialized$U(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$U() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$U(o) {
  _getPrototypeOf$U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$U(o);
}
let CNVIntervalTrack = /* @__PURE__ */ function(_HorizontalTiled1DPix) {
  _inherits$13(CNVIntervalTrack2, _HorizontalTiled1DPix);
  var _super = _createSuper$U(CNVIntervalTrack2);
  function CNVIntervalTrack2(context, options2) {
    var _this;
    _classCallCheck$18(this, CNVIntervalTrack2);
    _this = _super.call(this, context, options2);
    _this.seen = /* @__PURE__ */ new Set();
    _this.pMain = _this.pMobile;
    _this.rows = [];
    return _this;
  }
  _createClass$16(CNVIntervalTrack2, [{
    key: "uid",
    value: function uid(item) {
      return item[item.length - 2];
    }
  }, {
    key: "segmentOverlap",
    value: function segmentOverlap(segment1, segment2) {
    }
  }, {
    key: "drawAll",
    value: function drawAll(allTileData) {
      this.pMain.clear();
      const seen = /* @__PURE__ */ new Set();
      const segments = allTileData.map((x) => {
        if (seen.has(this.uid(x))) {
          return null;
        }
        seen.add(this.uid(x));
        return {
          from: +x[1],
          to: +x[2],
          type: x[4],
          uid: this.uid(x)
        };
      }).filter((x) => x);
      const rows = segmentsToRows(segments);
      this.rows = rows;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const rows = this.rows;
      if (!rows) {
        return;
      }
      const valueScale = band().range([0, this.dimensions[1]]).padding(0.1).domain(range$2(0, this.maxRows()));
      const graphics = this.pMain;
      graphics.clear();
      graphics.lineStyle(1, 255, 0);
      graphics.beginFill(16740363, 0.8);
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < rows[i].length; j++) {
          const interval2 = rows[i][j];
          const x12 = this._refXScale(interval2.from);
          const x2 = this._refXScale(interval2.to);
          const y12 = valueScale(i);
          const y2 = y12 + valueScale.bandwidth();
          const width = x2 - x12;
          const height2 = y2 - y12;
          graphics.drawRect(x12, y12, width, height2);
        }
      }
    }
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
      const visibleAndFetchedIds = this.visibleAndFetchedIds();
      const tileDatas = visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.discrete);
      const allTileData = [].concat(...tileDatas);
      this.drawAll(allTileData);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
    }
  }, {
    key: "maxRows",
    value: function maxRows() {
      return this.rows.length;
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.tileData.discrete.forEach((x) => {
        const uid = x[x.length - 2];
        if (this.seen.has(uid)) {
          this.seen.delete(uid);
        }
      });
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
    }
  }]);
  return CNVIntervalTrack2;
}(HorizontalTiled1DPixiTrack);
function _classCallCheck$17(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$Y(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$Y(descriptor.key), descriptor);
  }
}
function _createClass$15(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$Y(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$Y(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$Y(arg) {
  var key = _toPrimitive$Y(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$Y(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let LeftTrackModifier = /* @__PURE__ */ function() {
  function LeftTrackModifier2(originalTrack) {
    _classCallCheck$17(this, LeftTrackModifier2);
    this.scene = originalTrack.scene;
    this.originalTrack = originalTrack;
    this.pBase = new GLOBALS.PIXI.Graphics();
    this.scene.removeChild(originalTrack.pBase);
    this.scene.addChild(this.pBase);
    this.moveToOrigin = new GLOBALS.PIXI.Graphics();
    this.moveToOrigin.addChild(originalTrack.pBase);
    this.pBase.addChild(this.moveToOrigin);
    this.moveToOrigin.rotation = Math.PI / 2;
    originalTrack.isLeftModified = true;
    originalTrack.flipText = true;
    this.svgOutput = null;
    if (originalTrack.gBase && originalTrack.gMain) {
      this.originalTrack.gBase.attr("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                             rotate(90)
                             scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
      this.originalTrack.gMain.attr("transform", `translate(${this.originalTrack.pBase.position.x},${this.originalTrack.pBase.position.y})`);
    }
  }
  _createClass$15(LeftTrackModifier2, [{
    key: "remove",
    value: function remove3() {
      this.originalTrack.remove();
      this.pBase.clear();
      this.scene.removeChild(this.pBase);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      const reversedDimensions = [newDimensions[1], newDimensions[0]];
      this.originalTrack.setDimensions(reversedDimensions);
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.originalTrack.setPosition(newPosition);
      this.originalTrack.pBase.position.x = -this.originalTrack.position[0];
      this.originalTrack.pBase.position.y = -this.originalTrack.position[1];
      this.moveToOrigin.scale.y = -1;
      this.moveToOrigin.scale.x = 1;
      this.moveToOrigin.position.x = this.originalTrack.position[0];
      this.moveToOrigin.position.y = this.originalTrack.position[1];
      if (this.originalTrack.gMain) {
        this.originalTrack.gBase.attr("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                                 rotate(90)
                                 scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
        this.originalTrack.gMain.attr("transform", `translate(${this.originalTrack.pBase.position.x},${this.originalTrack.pBase.position.y})`);
      }
    }
  }, {
    key: "refXScale",
    value: function refXScale(_) {
      if (!arguments.length) {
        return this.originalTrack._refYScale;
      }
      this.originalTrack._refXScale = _;
      return this;
    }
  }, {
    key: "refYScale",
    value: function refYScale(_) {
      if (!arguments.length) {
        return this.originalTrack._refXScale;
      }
      this.originalTrack._refYScale = _;
      return this;
    }
  }, {
    key: "xScale",
    value: function xScale(_) {
      if (!arguments.length) {
        return this.originalTrack._xScale;
      }
      this.originalTrack._yScale = _;
      return this;
    }
  }, {
    key: "yScale",
    value: function yScale(_) {
      if (!arguments.length) {
        return this.originalTrack._yScale;
      }
      this.originalTrack._xScale = _;
      return this;
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      return this.originalTrack.getMouseOverHtml(trackY, trackX, isShiftDown);
    }
  }, {
    key: "clickOutside",
    value: function clickOutside() {
      this.originalTrack.clickOutside();
    }
  }, {
    key: "click",
    value: function click(...args) {
      this.originalTrack.click(...args);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.originalTrack.draw();
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k = 1, tx = 0, ty = 0, xPositionOffset = 0, yPositionOffset = 0) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      if (this.originalTrack.leftTrackZoomed) {
        if (this.originalTrack.refreshTiles) {
          this.originalTrack.refreshTiles();
        }
        this.originalTrack.leftTrackZoomed(newXScale, newYScale, k, tx, ty);
        this.originalTrack.draw();
        return;
      }
      const offset2 = this.originalTrack._xScale(0) - k * this.originalTrack._refXScale(0);
      this.originalTrack.pMobile.position.x = offset2 + this.originalTrack.position[0];
      this.originalTrack.pMobile.position.y = this.originalTrack.position[1] + this.originalTrack.dimensions[1];
      this.originalTrack.pMobile.scale.x = k;
      this.originalTrack.pMobile.scale.y = k;
      if (this.originalTrack.options.oneDHeatmapFlipped) {
        this.originalTrack.pMobile.scale.y = -k;
        this.originalTrack.pMobile.position.y = this.originalTrack.position[1];
      }
      if (this.originalTrack.leftTrackDraw) {
        if (this.originalTrack.refreshTiles) {
          this.originalTrack.refreshTiles();
        }
        this.originalTrack.leftTrackDraw();
        return;
      }
      this.originalTrack.zoomed(this.xScale(), this.yScale());
    }
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
      this.originalTrack.zoomedY(yPos, kMultiplier);
    }
  }, {
    key: "movedY",
    value: function movedY2(dY) {
      this.originalTrack.movedY(dY);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      this.originalTrack.refScalesChanged(refYScale, refXScale);
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
      this.originalTrack.rerender(options2);
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                             rotate(90)
                             scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
      if (this.originalTrack.exportSVG) {
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${this.originalTrack.pBase.position.x}, ${this.originalTrack.pBase.position.y})`);
        g.appendChild(this.originalTrack.exportSVG()[0]);
        output.appendChild(g);
      }
      return [output, output];
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return x >= this.position[0] && x <= this.dimensions[0] + this.position[0] && y >= this.position[1] && y <= this.dimensions[1] + this.position[1];
    }
  }]);
  return LeftTrackModifier2;
}();
function _classCallCheck$16(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$X(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$X(descriptor.key), descriptor);
  }
}
function _createClass$14(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$X(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$X(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$X(arg) {
  var key = _toPrimitive$X(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$X(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$m() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$m = Reflect.get.bind();
  } else {
    _get$m = function _get2(target, property2, receiver) {
      var base = _superPropBase$m(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$m.apply(this, arguments);
}
function _superPropBase$m(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$T(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$12(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$T(subClass, superClass);
}
function _setPrototypeOf$T(o, p) {
  _setPrototypeOf$T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$T(o, p);
}
function _createSuper$T(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$T();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$T(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$T(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$12(this, result);
  };
}
function _possibleConstructorReturn$12(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$T(self2);
}
function _assertThisInitialized$T(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$T() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$T(o) {
  _getPrototypeOf$T = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$T(o);
}
const FONT_SIZE = 11;
const FONT_FAMILY = "Arial";
const GENE_LABEL_POS = "outside";
const GENE_RECT_HEIGHT = 10;
const GENE_STRAND_SPACING = 4;
const MAX_TEXTS = 20;
const WHITE_HEX = colorToHex("#ffffff");
const EXON_LINE_HEIGHT = 2;
const EXON_HEIGHT = 2 * GENE_RECT_HEIGHT / 3;
const GENE_MINI_TRIANGLE_HEIGHT = 2 * EXON_HEIGHT / 3;
const MAX_GENE_ENTRIES = 50;
const MAX_FILLER_ENTRIES = 5e3;
const DEFAULT_PLUS_STRAND_COLOR = "blue";
const DEFAULT_MINUS_STRAND_COLOR = "red";
const geneClickFunc = (event, track, payload) => {
  if (payload.type === "filler")
    return;
  track.pubSub.publish("app.click", {
    type: "gene-annotation",
    event,
    payload
  });
};
const flagOverlappingFillers = (genes, fillers) => {
  const regions = genes.concat(fillers);
  const boxes = regions.map((x) => [x.xStart, 1, x.xEnd, 1]);
  boxIntersect$1(boxes, (i, j) => {
    let filler = null;
    let gene = null;
    if (regions[i].type === "filler") {
      filler = regions[i];
    } else {
      gene = regions[i];
    }
    if (regions[j].type === "filler") {
      if (filler)
        return;
      filler = regions[j];
    } else {
      if (!filler)
        return;
      gene = regions[j];
    }
    if (filler.xStart >= gene.xStart && filler.xEnd <= gene.xEnd) {
      filler.hide = true;
    }
  });
};
function externalInitTile(track, tile, options2) {
  const {
    flipText,
    fontSize,
    fontFamily,
    plusStrandColor,
    minusStrandColor,
    maxGeneEntries,
    maxFillerEntries,
    maxTexts
  } = options2;
  tile.texts = {};
  tile.rectGraphics = new GLOBALS.PIXI.Graphics();
  tile.textBgGraphics = new GLOBALS.PIXI.Graphics();
  tile.textGraphics = new GLOBALS.PIXI.Graphics();
  tile.rectMaskGraphics = new GLOBALS.PIXI.Graphics();
  tile.graphics.addChild(tile.rectGraphics);
  tile.graphics.addChild(tile.textBgGraphics);
  tile.graphics.addChild(tile.textGraphics);
  tile.graphics.addChild(tile.rectMaskGraphics);
  tile.rectGraphics.mask = tile.rectMaskGraphics;
  if (!tile.tileData.sort)
    return;
  tile.tileData.sort((a, b) => b.importance - a.importance);
  const geneEntries = tile.tileData.filter((td) => td.type !== "filler").slice(0, maxGeneEntries);
  const fillerEntries = tile.tileData.filter((td) => td.type === "filler").slice(0, maxFillerEntries);
  tile.tileData = geneEntries.concat(fillerEntries);
  tile.tileData.forEach((td, i) => {
    if (td.type === "filler") {
      return;
    }
    const geneInfo = td.fields;
    const geneName = geneInfo[3];
    const geneId = track.geneId(geneInfo, td.type);
    const strand = td.strand || geneInfo[5];
    td.strand = td.strand || strand;
    let fill = plusStrandColor || DEFAULT_PLUS_STRAND_COLOR;
    if (strand === "-") {
      fill = minusStrandColor || DEFAULT_MINUS_STRAND_COLOR;
    }
    tile.textWidths = {};
    tile.textHeights = {};
    if (i >= maxTexts)
      return;
    const text2 = new GLOBALS.PIXI.Text(geneName, {
      fontSize: `${fontSize}px`,
      fontFamily,
      fill: colorToHex(fill)
    });
    text2.interactive = true;
    if (flipText)
      text2.scale.x = -1;
    text2.anchor.x = 0.5;
    text2.anchor.y = 1;
    tile.texts[geneId] = text2;
    tile.texts[geneId].strand = strand;
    tile.textGraphics.addChild(text2);
  });
  tile.initialized = true;
}
function renderRects(rects, track, tile, someGraphics, xScale, color2, alpha, centerY, height2) {
  const topY = centerY - height2 / 2;
  const FILLER_PADDING = 0;
  rects.forEach((td) => {
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, 0.1);
    graphics.lineStyle(0, color2);
    const poly = [xScale(td.xStart) - FILLER_PADDING, topY, xScale(td.xEnd) + FILLER_PADDING, topY, xScale(td.xEnd) + FILLER_PADDING, topY + height2, xScale(td.xStart) - FILLER_PADDING, topY + height2, xScale(td.xStart) - FILLER_PADDING, topY];
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (event) => geneClickFunc(event, track, td);
    graphics.drawPolygon(poly);
    tile.allRects.push([poly, td.strand, td]);
  });
}
function drawExons(track, graphics, txStart, txEnd, exonStarts, exonEnds, chrOffset, centerY, height2, strand) {
  const topY = centerY - height2 / 2;
  const exonOffsetStarts = exonStarts.split(",").map((x) => +x + chrOffset);
  const exonOffsetEnds = exonEnds.split(",").map((x) => +x + chrOffset);
  const xStartPos = track._xScale(txStart);
  const xEndPos = track._xScale(txEnd);
  const width = xEndPos - xStartPos;
  const yMiddle = centerY;
  const polys = [];
  let poly = [xStartPos, yMiddle - EXON_LINE_HEIGHT / 2, xStartPos + width, yMiddle - EXON_LINE_HEIGHT / 2, xStartPos + width, yMiddle + EXON_LINE_HEIGHT / 2, xStartPos, yMiddle + EXON_LINE_HEIGHT / 2];
  graphics.drawPolygon(poly);
  polys.push(poly);
  const triangleInterval = 2 * height2;
  for (let j = Math.max(track.position[0], xStartPos) + triangleInterval; j < Math.min(track.position[0] + track.dimensions[0], xStartPos + width); j += triangleInterval) {
    if (strand === "+") {
      poly = [j, yMiddle - GENE_MINI_TRIANGLE_HEIGHT / 2, j + GENE_MINI_TRIANGLE_HEIGHT / 2, yMiddle, j, yMiddle + GENE_MINI_TRIANGLE_HEIGHT / 2];
    } else {
      poly = [j, yMiddle - GENE_MINI_TRIANGLE_HEIGHT / 2, j - GENE_MINI_TRIANGLE_HEIGHT / 2, yMiddle, j, yMiddle + GENE_MINI_TRIANGLE_HEIGHT / 2];
    }
    polys.push(poly);
    graphics.drawPolygon(poly);
  }
  for (let j = 0; j < exonOffsetStarts.length; j++) {
    const exonStart = exonOffsetStarts[j];
    const exonEnd = exonOffsetEnds[j];
    const xStart = track._xScale(exonStart);
    const localWidth = Math.max(1, track._xScale(exonEnd) - track._xScale(exonStart));
    let minX = xStartPos;
    let maxX = xEndPos;
    const pointerWidth = track.geneRectHeight / 2;
    let localPoly = null;
    if (strand === "+") {
      maxX = xEndPos - pointerWidth;
      localPoly = [Math.min(xStart, maxX), topY, Math.min(xStart + localWidth, maxX), topY, Math.min(xStart + localWidth, maxX), topY + height2, Math.min(xStart, maxX), topY + height2, Math.min(xStart, maxX), topY];
    } else {
      minX = xStartPos + pointerWidth;
      localPoly = [Math.max(xStart, minX), topY, Math.max(xStart + localWidth, minX), topY, Math.max(xStart + localWidth, minX), topY + height2, Math.max(xStart, minX), topY + height2, Math.max(xStart, minX), topY];
    }
    polys.push(localPoly);
    graphics.drawPolygon(localPoly);
  }
  return polys;
}
function renderGeneSymbols(genes, track, tile, oldGraphics, xScale, color2, alpha, centerY, height2) {
  const topY = centerY - height2 / 2;
  genes.forEach((gene) => {
    const xStart = track._xScale(gene.xStart);
    const xEnd = track._xScale(gene.xEnd);
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, alpha);
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (evt) => geneClickFunc(evt, track, gene);
    const pointerWidth = track.geneRectHeight / 2;
    let poly = [];
    if (gene.strand === "+" || gene.fields[5] === "+") {
      const pointerStart = Math.max(xStart, xEnd - pointerWidth);
      const pointerEnd = pointerStart + pointerWidth;
      poly = [pointerStart, topY, pointerEnd, topY + track.geneRectHeight / 2, pointerStart, topY + track.geneRectHeight];
    } else {
      const pointerStart = Math.min(xEnd, xStart + pointerWidth);
      const pointerEnd = pointerStart - pointerWidth;
      poly = [pointerStart, topY, pointerEnd, topY + track.geneRectHeight / 2, pointerStart, topY + track.geneRectHeight];
    }
    graphics.drawPolygon(poly);
    tile.allRects.push([poly, gene.strand, gene]);
  });
}
function renderGeneExons(genes, track, tile, rectGraphics, xScale, color2, alpha, centerY, height2) {
  genes.forEach((gene) => {
    const geneInfo = gene.fields;
    const chrOffset = +gene.chrOffset;
    const exonStarts = geneInfo[12];
    const exonEnds = geneInfo[13];
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, alpha);
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (evt) => geneClickFunc(evt, track, gene);
    tile.allRects = tile.allRects.concat(drawExons(
      track,
      graphics,
      gene.xStart,
      gene.xEnd,
      exonStarts,
      exonEnds,
      chrOffset,
      // not used for now because we have just one chromosome
      centerY,
      height2,
      gene.strand || gene.fields[5]
    ).map((x) => [x, gene.strand, gene]));
  });
}
function renderGenes(genes, track, tile, graphics, xScale, color2, alpha, centerY, height2) {
  renderGeneSymbols(genes, track, tile, graphics, xScale, color2, alpha, centerY, height2);
  renderGeneExons(genes, track, tile, graphics, xScale, color2, alpha, centerY, height2);
}
function renderMask(track, tile) {
  const {
    tileX,
    tileWidth
  } = trackUtils.getTilePosAndDimensions(track.tilesetInfo, tile.tileId);
  tile.rectMaskGraphics.clear();
  const randomColor = Math.floor(Math.random() * 16 ** 6);
  tile.rectMaskGraphics.beginFill(randomColor, 0.3);
  const x = track._xScale(tileX);
  const y = 0;
  const width = track._xScale(tileX + tileWidth) - track._xScale(tileX);
  const height2 = track.dimensions[1];
  tile.rectMaskGraphics.drawRect(x, y, width, height2);
}
let HorizontalGeneAnnotationsTrack = /* @__PURE__ */ function(_HorizontalTiled1DPix) {
  _inherits$12(HorizontalGeneAnnotationsTrack2, _HorizontalTiled1DPix);
  var _super = _createSuper$T(HorizontalGeneAnnotationsTrack2);
  function HorizontalGeneAnnotationsTrack2(context, options2) {
    var _this;
    _classCallCheck$16(this, HorizontalGeneAnnotationsTrack2);
    _this = _super.call(this, context, options2);
    const {
      animate
    } = context;
    _this.animate = animate;
    _this.options = options2;
    _this.fontSize = +_this.options.fontSize || FONT_SIZE;
    _this.geneLabelPos = _this.options.geneLabelPosition || GENE_LABEL_POS;
    _this.geneRectHeight = +_this.options.geneAnnotationHeight || GENE_RECT_HEIGHT;
    _this.geneRectHeight -= 2;
    _this.geneStrandSpacing = +_this.options.geneStrandSpacing || GENE_STRAND_SPACING;
    _this.geneStrandHSpacing = _this.geneStrandSpacing / 2;
    _this.geneRectHHeight = _this.geneRectHeight / 2;
    return _this;
  }
  _createClass$14(HorizontalGeneAnnotationsTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      externalInitTile(this, tile, {
        flipText: this.flipText,
        fontSize: this.fontSize,
        fontFamily: FONT_FAMILY,
        plusStrandColor: this.options.plusStrandColor,
        minusStrandColor: this.options.minusStrandColor,
        maxGeneEntries: MAX_GENE_ENTRIES,
        maxFillerEntries: MAX_FILLER_ENTRIES,
        maxTexts: MAX_TEXTS
      });
      this.renderTile(tile);
    }
    /** cleanup */
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.rectGraphics.destroy();
      tile.rectMaskGraphics.destroy();
      tile.textGraphics.destroy(true);
      tile.textBgGraphics.destroy();
      tile.graphics.destroy();
    }
  }, {
    key: "remove",
    value: function remove3() {
      if (this.visibleTileIds) {
        this.removeTiles([...this.visibleTileIds]);
      }
    }
    /*
     * Redraw the track because the options
     * changed
     */
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions)
        return;
      _get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "rerender", this).call(this, options2, force);
      this.fontSize = +this.options.fontSize || FONT_SIZE;
      this.geneLabelPos = this.options.geneLabelPosition || GENE_LABEL_POS;
      this.geneRectHeight = +this.options.geneAnnotationHeight || GENE_RECT_HEIGHT;
      this.geneStrandHSpacing = this.geneStrandSpacing / 2;
      this.geneRectHHeight = this.geneRectHeight / 2;
      this.prevOptions = strOptions;
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "drawTile",
    value: function drawTile() {
    }
  }, {
    key: "geneId",
    value: function geneId(geneInfo, type3) {
      return `${type3}_${geneInfo[0]}_${geneInfo[1]}_${geneInfo[2]}_${geneInfo[3]}`;
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!tile.initialized)
        return;
      tile.allRects = [];
      tile.drawnAtScale = this._xScale.copy();
      tile.rectGraphics.removeChildren();
      tile.rectGraphics.clear();
      tile.textBgGraphics.clear();
      const fill = {};
      const FILLER_RECT_ALPHA = 0.3;
      const GENE_ALPHA = 0.3;
      fill["+"] = colorToHex(this.options.plusStrandColor || DEFAULT_PLUS_STRAND_COLOR);
      fill["-"] = colorToHex(this.options.minusStrandColor || DEFAULT_MINUS_STRAND_COLOR);
      let plusFillerRects = tile.tileData.filter((td) => td.type === "filler" && td.strand === "+");
      let minusFillerRects = tile.tileData.filter((td) => td.type === "filler" && td.strand === "-");
      const plusGenes = tile.tileData.filter((td) => td.type !== "filler" && (td.strand === "+" || td.fields[5] === "+"));
      const minusGenes = tile.tileData.filter((td) => td.type !== "filler" && (td.strand === "-" || td.fields[5] === "-"));
      flagOverlappingFillers(plusGenes, plusFillerRects);
      flagOverlappingFillers(minusGenes, minusFillerRects);
      plusFillerRects = plusFillerRects.filter((x) => !x.hide);
      minusFillerRects = minusFillerRects.filter((x) => !x.hide);
      const yMiddle = this.dimensions[1] / 2;
      const plusStrandCenterY = yMiddle - this.geneRectHeight / 2 - this.geneStrandSpacing / 2;
      const minusStrandCenterY = yMiddle + this.geneRectHeight / 2 + this.geneStrandSpacing / 2;
      const plusRenderContext = [this, tile, tile.rectGraphics, this._xScale, fill["+"], FILLER_RECT_ALPHA, plusStrandCenterY, this.geneRectHeight];
      const minusRenderContext = [this, tile, tile.rectGraphics, this._xScale, fill["-"], FILLER_RECT_ALPHA, minusStrandCenterY, this.geneRectHeight];
      renderRects(plusFillerRects, ...plusRenderContext);
      renderRects(minusFillerRects, ...minusRenderContext);
      plusRenderContext[5] = GENE_ALPHA;
      minusRenderContext[5] = GENE_ALPHA;
      renderGenes(plusGenes, ...plusRenderContext);
      renderGenes(minusGenes, ...minusRenderContext);
      renderMask(this, tile);
      trackUtils.stretchRects(this, [(x) => x.rectGraphics, (x) => x.rectMaskGraphics]);
      for (const text2 of Object.values(tile.texts)) {
        text2.style = {
          fontSize: `${this.fontSize}px`,
          FONT_FAMILY,
          fill: colorToHex(text2.strand === "-" ? this.options.minusStrandColor || DEFAULT_MINUS_STRAND_COLOR : this.options.plusStrandColor || DEFAULT_PLUS_STRAND_COLOR)
        };
      }
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "draw", this).call(this);
      this.allTexts = [];
      this.allBoxes = [];
      const allTiles = [];
      this.geneAreaHeight = this.geneRectHeight;
      const fontSizeHalf = this.fontSize / 2;
      trackUtils.stretchRects(this, [(x) => x.rectGraphics, (x) => x.rectMaskGraphics]);
      Object.values(this.fetchedTiles).filter((tile) => tile.drawnAtScale).forEach((tile) => {
        try {
          if (!tile.textBgGraphics)
            return;
          tile.textBgGraphics.clear();
          tile.textBgGraphics.beginFill(typeof this.options.labelBackgroundColor !== "undefined" ? colorToHex(this.options.labelBackgroundColor) : WHITE_HEX);
          const parentInFetched = this.parentInFetched(tile);
          if (!tile.initialized)
            return;
          tile.tileData.forEach((td) => {
            if (!tile.texts)
              return;
            if (td.type === "filler")
              return;
            const geneInfo = td.fields;
            const geneName = geneInfo[3];
            const geneId = this.geneId(geneInfo, td.type);
            const text2 = tile.texts[geneId];
            if (!text2)
              return;
            const chrOffset = +td.chrOffset;
            const txStart = +geneInfo[1] + chrOffset;
            const txEnd = +geneInfo[2] + chrOffset;
            const txMiddle = (txStart + txEnd) / 2;
            let textYMiddle = this.dimensions[1] / 2;
            const fontRectPadding = (this.geneAreaHeight - this.fontSize) / 2;
            if (geneInfo[5] === "+") {
              textYMiddle -= this.geneLabelPos === "inside" ? fontRectPadding + this.geneStrandSpacing - 2 : this.fontSize / 2 + this.geneAreaHeight - 2;
            } else {
              textYMiddle += this.geneLabelPos === "inside" ? this.fontSize + this.geneStrandSpacing / 2 + fontRectPadding + 1 : 1.5 * this.fontSize + this.geneAreaHeight + 2;
            }
            text2.position.x = this._xScale(txMiddle);
            text2.position.y = textYMiddle;
            if (!tile.textWidths[geneId]) {
              try {
                if (text2 && text2.getBounds) {
                  const textWidth = text2.getBounds().width;
                  const textHeight = text2.getBounds().height;
                  tile.textHeights[geneId] = textHeight;
                  tile.textWidths[geneId] = textWidth;
                }
              } catch (err2) {
                tile.textHeights[geneId] = 0;
                tile.textWidths[geneId] = 0;
              }
            }
            if (!parentInFetched) {
              text2.visible = true;
              const TEXT_MARGIN = 2;
              if (this.flipText) {
                this.allBoxes.push([text2.position.x - tile.textHeights[geneId] / 2 - TEXT_MARGIN, textYMiddle - fontSizeHalf - 1, text2.position.x + tile.textHeights[geneId] / 2 + TEXT_MARGIN, textYMiddle + fontSizeHalf - 1, geneName]);
              } else {
                this.allBoxes.push([text2.position.x - tile.textWidths[geneId] / 2 - TEXT_MARGIN, textYMiddle - fontSizeHalf - 1, text2.position.x + tile.textWidths[geneId] / 2 + TEXT_MARGIN, textYMiddle + fontSizeHalf - 1, geneName]);
              }
              this.allTexts.push({
                importance: +geneInfo[4],
                text: text2,
                caption: geneName,
                strand: geneInfo[5]
              });
              allTiles.push(tile.textBgGraphics);
            } else {
              text2.visible = false;
            }
          });
        } catch (err2) {
        }
      });
      this.hideOverlaps(this.allBoxes, this.allTexts);
      this.renderTextBg(this.allBoxes, this.allTexts, allTiles);
    }
  }, {
    key: "renderTextBg",
    value: function renderTextBg(allBoxes, allTexts, allTiles) {
      allTexts.forEach((text2, i) => {
        if (text2.text.visible && allBoxes[i] && allTiles[i]) {
          const [minX, minY, maxX, maxY] = allBoxes[i];
          const width = maxX - minX;
          const height2 = maxY - minY;
          allTiles[i].drawRect(minX - width / 2, minY - height2 / 2, width, height2);
        }
      });
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allBoxes, allTexts) {
      boxIntersect$1(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = false;
        } else {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "setPosition", this).call(this, newPosition);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "setDimensions", this).call(this, newDimensions);
      this.halfRectHHeight = this.dimensions[1] / 2;
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY, isShiftDown) {
      if (!this.tilesetInfo || !this.options.showTooltip && !isShiftDown) {
        return "";
      }
      const point2 = [trackX, trackY];
      for (const tile of this.visibleAndFetchedTiles()) {
        for (let i = 0; i < tile.allRects.length; i++) {
          if (tile.allRects[i][2].type === "filler") {
            continue;
          }
          const rect = tile.allRects[i][0].slice(0);
          const newArr = [];
          while (rect.length) {
            const newPoint = rect.splice(0, 2);
            newPoint[0] = newPoint[0] * tile.rectGraphics.scale.x + tile.rectGraphics.position.x;
            newPoint[1] = newPoint[1] * tile.rectGraphics.scale.y + tile.rectGraphics.position.y;
            newArr.push(newPoint);
          }
          const pc = classifyPoint(newArr, point2);
          if (pc === -1) {
            const gene = tile.allRects[i][2];
            let output = `<div class="track-mouseover-menu-table">`;
            let symbolNameText = gene.fields.length >= 4 ? `${gene.fields[3]}` : null;
            if (symbolNameText) {
              output += `
            <div class="track-mouseover-menu-table-item">
              <label for="name" class="track-mouseover-menu-table-item-label">Name</label>
              <div name="name" class="track-mouseover-menu-table-item-value">${symbolNameText}</div>
            </div>
            `;
            }
            let strandText = gene.fields.length >= 6 ? `${gene.fields[5]}` : null;
            let positionText = gene.fields.length >= 3 ? strandText ? `${gene.fields[0]}:${gene.fields[1]}-${gene.fields[2]} (${strandText})` : `${gene.fields[0]}:${gene.fields[1]}-${gene.fields[2]}` : null;
            if (positionText) {
              output += `
            <div class="track-mouseover-menu-table-item">
              <label for="position" class="track-mouseover-menu-table-item-label">Position</label>
              <div name="position" class="track-mouseover-menu-table-item-value">${positionText}</div>
            </div>
            `;
            }
            return output;
          }
        }
      }
      return "";
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$m(_getPrototypeOf$T(HorizontalGeneAnnotationsTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.allRects).forEach((tile) => {
        const gTile = document.createElement("g");
        gTile.setAttribute("transform", `translate(${tile.rectGraphics.position.x},
          ${tile.rectGraphics.position.y})
          scale(${tile.rectGraphics.scale.x},
          ${tile.rectGraphics.scale.y})`);
        tile.allRects.forEach((rect) => {
          const r2 = document.createElement("path");
          const poly = rect[0];
          let d = `M ${poly[0]} ${poly[1]}`;
          for (let i = 2; i < poly.length; i += 2) {
            d += ` L ${poly[i]} ${poly[i + 1]}`;
          }
          r2.setAttribute("d", d);
          if (rect[1] === "+") {
            r2.setAttribute("fill", this.options.plusStrandColor);
          } else {
            r2.setAttribute("fill", this.options.minusStrandColor);
          }
          r2.setAttribute("opacity", "0.3");
          gTile.appendChild(r2);
        });
        output.appendChild(gTile);
      });
      this.allTexts.filter((text2) => text2.text.visible).forEach((text2) => {
        const g = document.createElement("g");
        const t = document.createElement("text");
        t.setAttribute("text-anchor", "middle");
        t.setAttribute("font-family", FONT_FAMILY);
        t.setAttribute("font-size", `${this.fontSize}px`);
        t.setAttribute("dy", "-.2em");
        g.setAttribute("transform", `scale(${text2.text.scale.x},1)`);
        if (text2.strand === "+") {
          t.setAttribute("fill", this.options.plusStrandColor);
        } else {
          t.setAttribute("fill", this.options.minusStrandColor);
        }
        t.innerHTML = text2.text.text;
        g.appendChild(t);
        g.setAttribute("transform", `translate(${text2.text.x},${text2.text.y})scale(${text2.text.scale.x},1)`);
        output.appendChild(g);
      });
      return [base, base];
    }
  }]);
  return HorizontalGeneAnnotationsTrack2;
}(HorizontalTiled1DPixiTrack);
colorToHex("#ffffff");
function _classCallCheck$15(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$W(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$W(descriptor.key), descriptor);
  }
}
function _createClass$13(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$W(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$W(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$W(arg) {
  var key = _toPrimitive$W(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$W(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$l() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$l = Reflect.get.bind();
  } else {
    _get$l = function _get2(target, property2, receiver) {
      var base = _superPropBase$l(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$l.apply(this, arguments);
}
function _superPropBase$l(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$S(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$11(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$S(subClass, superClass);
}
function _setPrototypeOf$S(o, p) {
  _setPrototypeOf$S = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$S(o, p);
}
function _createSuper$S(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$S();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$S(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$S(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$11(this, result);
  };
}
function _possibleConstructorReturn$11(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$S(self2);
}
function _assertThisInitialized$S(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$S() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$S(o) {
  _getPrototypeOf$S = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$S(o);
}
function drawAnnotation(track, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, flipDiagonal) {
  const startX = flipDiagonal ? track._xScale(td.yStart) : track._xScale(td.xStart);
  const endX = flipDiagonal ? track._xScale(td.yEnd) : track._xScale(td.xEnd);
  const startY = flipDiagonal ? track._yScale(td.xStart) : track._yScale(td.yStart);
  const endY = flipDiagonal ? track._yScale(td.xEnd) : track._yScale(td.yEnd);
  const uid = td.uid + flipDiagonal;
  const width = endX - startX;
  const height2 = endY - startY;
  let drawnRect = {
    x: startX,
    y: startY,
    width,
    height: height2
  };
  if (minSquareSize) {
    if (width < minSquareSize || height2 < minSquareSize) {
      drawnRect = {
        x: startX - minSquareSize / 2,
        y: startY - minSquareSize / 2,
        width: minSquareSize,
        height: minSquareSize
      };
    }
  }
  track.drawnRects[uid] = drawnRect;
  const dRxMax = drawnRect.x + drawnRect.width;
  const dRyMax = drawnRect.y + drawnRect.height;
  if (drawnRect.x > xMin && drawnRect.x < xMax || dRxMax > xMin && dRxMax < xMax || drawnRect.y > yMin && drawnRect.y < yMax || dRyMax > yMin && dRyMax < yMax) {
    if (drawnRect.width > minThres || drawnRect.height > minThres) {
      graphics.drawRect(drawnRect.x, drawnRect.y, drawnRect.width, drawnRect.height);
      track.publish("annotationDrawn", {
        trackUuid: track.uuid,
        annotationUuid: uid,
        viewPos: [drawnRect.x, drawnRect.y, drawnRect.width, drawnRect.height],
        dataPos: [td.xStart, td.xEnd, td.yStart, td.yEnd],
        importance: td.importance,
        info: {
          patternType: track.options.patternType
        }
      });
    }
  }
}
let ArrowheadDomainsTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$11(ArrowheadDomainsTrack2, _TiledPixiTrack);
  var _super = _createSuper$S(ArrowheadDomainsTrack2);
  function ArrowheadDomainsTrack2(...args) {
    var _this;
    _classCallCheck$15(this, ArrowheadDomainsTrack2);
    _this = _super.call(this, ...args);
    _this.drawnRects = {};
    const {
      publish: publish2,
      subscribe: subscribe2,
      unsubscribe: unsubscribe2
    } = createPubSub();
    _this.publish = publish2;
    _this.subscribe = subscribe2;
    _this.unsubscribe = unsubscribe2;
    return _this;
  }
  _createClass$13(ArrowheadDomainsTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      return zoomLevel;
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.remoteId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile() {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile() {
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnRects = {};
      _get$l(_getPrototypeOf$S(ArrowheadDomainsTrack2.prototype), "draw", this).call(this);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      const graphics = tile.graphics;
      if (!graphics) {
        return;
      }
      graphics.clear();
      const stroke = colorToHex(this.options.rectangleDomainStrokeColor || "black");
      const fill = colorToHex(this.options.rectangleDomainFillColor || "grey");
      graphics.lineStyle(typeof this.options.rectangleDomainStrokeWidth !== "undefined" ? this.options.rectangleDomainStrokeWidth : 1, stroke, typeof this.options.rectangleDomainStrokeOpacity !== "undefined" ? this.options.rectangleDomainStrokeOpacity : 1);
      graphics.beginFill(fill, typeof this.options.rectangleDomainFillOpacity !== "undefined" ? this.options.rectangleDomainFillOpacity : 0.4);
      graphics.alpha = this.options.rectangleDomainOpacity || 0.5;
      const minSquareSize = this.options.minSquareSize && this.options.minSquareSize !== "none" ? +this.options.minSquareSize : 0;
      const minThres = this.options.rectangleMinSize ? +this.options.rectangleMinSize : 0;
      const xMin = this._xScale.range()[0];
      const xMax = this._xScale.range()[1];
      const yMin = this._yScale.range()[0];
      const yMax = this._yScale.range()[1];
      if (!tile.tileData.length)
        return;
      tile.tileData.filter((td) => !(td.uid in this.drawnRects)).forEach((td) => {
        drawAnnotation(this, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, this.options.flipDiagonal === "yes");
        if (this.options.flipDiagonal && this.options.flipDiagonal === "copy") {
          drawAnnotation(this, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, true);
        }
      });
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$l(_getPrototypeOf$S(ArrowheadDomainsTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$l(_getPrototypeOf$S(ArrowheadDomainsTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      for (const flipDiagonal of [true, false]) {
        for (const tile of this.visibleAndFetchedTiles()) {
          if (!tile.tileData || !tile.tileData.length)
            continue;
          tile.tileData.forEach((td) => {
            const uid = td.uid + flipDiagonal;
            const gTile = document.createElement("g");
            gTile.setAttribute("transform", `translate(${tile.graphics.position.x},${tile.graphics.position.y})scale(${tile.graphics.scale.x},${tile.graphics.scale.y})`);
            output.appendChild(gTile);
            if (uid in this.drawnRects) {
              const rect = this.drawnRects[uid];
              const r2 = document.createElement("rect");
              r2.setAttribute("x", rect.x);
              r2.setAttribute("y", rect.y);
              r2.setAttribute("width", rect.width);
              r2.setAttribute("height", rect.height);
              r2.setAttribute("fill", this.options.rectangleDomainFillColor ? this.options.rectangleDomainFillColor : "grey");
              r2.setAttribute("opacity", 0.3);
              r2.style.stroke = "black";
              r2.style.strokeWidth = "1px";
              gTile.appendChild(r2);
            }
          });
        }
      }
      return [base, base];
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$l(_getPrototypeOf$S(ArrowheadDomainsTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      if (this.xScale().domain()[0] === newXScale.domain()[0] && this.xScale().domain()[1] === newXScale.domain()[1] && this.yScale().domain()[0] === newYScale.domain()[0] && this.yScale().domain()[1] === newYScale.domain()[1])
        return;
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }]);
  return ArrowheadDomainsTrack2;
}(TiledPixiTrack);
function _classCallCheck$14(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$V(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$V(descriptor.key), descriptor);
  }
}
function _createClass$12(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$V(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$V(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$V(arg) {
  var key = _toPrimitive$V(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$V(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$k() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$k = Reflect.get.bind();
  } else {
    _get$k = function _get2(target, property2, receiver) {
      var base = _superPropBase$k(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$k.apply(this, arguments);
}
function _superPropBase$k(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$R(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$10(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$R(subClass, superClass);
}
function _setPrototypeOf$R(o, p) {
  _setPrototypeOf$R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$R(o, p);
}
function _createSuper$R(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$R();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$R(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$R(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$10(this, result);
  };
}
function _possibleConstructorReturn$10(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$R(self2);
}
function _assertThisInitialized$R(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$R() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$R(o) {
  _getPrototypeOf$R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$R(o);
}
const MOUSE_CLICK_TIME = 250;
let Annotations2dTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$10(Annotations2dTrack2, _TiledPixiTrack);
  var _super = _createSuper$R(Annotations2dTrack2);
  function Annotations2dTrack2(context, options2) {
    var _this;
    _classCallCheck$14(this, Annotations2dTrack2);
    _this = _super.call(this, context, options2);
    const {
      pubSub
    } = context;
    _this.drawnAnnotations = {};
    _this.drawnAnnoGfx = {};
    _this.selectedAnno = null;
    _this.options.minSquareSize = +_this.options.minSquareSize;
    const {
      publish: publish2,
      subscribe: subscribe2,
      unsubscribe: unsubscribe2
    } = createPubSub();
    _this.publish = publish2;
    _this.subscribe = subscribe2;
    _this.unsubscribe = unsubscribe2;
    _this.sT = 0;
    _this.annoSelectedBound = _this.annoSelected.bind(_assertThisInitialized$R(_this));
    _this.pubSubs.push(pubSub.subscribe("annoSelected", _this.annoSelectedBound));
    return _this;
  }
  _createClass$12(Annotations2dTrack2, [{
    key: "minX",
    get: function() {
      return this.tilesetInfo && this.tilesetInfo.min_pos ? this.tilesetInfo.min_pos[0] : 0;
    }
  }, {
    key: "maxX",
    get: function() {
      return this.tilesetInfo && this.tilesetInfo.max_pos ? this.tilesetInfo.max_pos[0] : this.tilesetInfo.max_width || this.tilesetInfo.max_size;
    }
  }, {
    key: "minY",
    get: function() {
      return this.minX;
    }
  }, {
    key: "maxY",
    get: function() {
      return this.maxX;
    }
  }, {
    key: "maxSize",
    get: function() {
      const maxSize = this.tilesetInfo.max_pos && Math.max(this.tilesetInfo.max_pos[0] - this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[1] - this.tilesetInfo.min_pos[1]);
      if (maxSize)
        return maxSize;
      if (this.tilesetInfo.max_size)
        return this.tilesetInfo.max_size;
      return 0;
    }
    /**
     * Point projection from the data to the view (pixel) coordinates
     * @param   {number}  x  Data X coordinate
     * @param   {number}  y  Data Y coordinate
     * @return  {array}  Tuple [x,y] containing the translated view coordinates.
     */
  }, {
    key: "projection",
    value: function projection2([x, y]) {
      return [this._xScale(x), this._yScale(y)];
    }
    /**
     * The local tile identifier
     *
     * @param  {Array}  tile  Array containing [zoomLevel, xPos, yPos]
     * @return  {String}  Joined ID string
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     *
     * @param  {Array}  tile  Array containing [zoomLevel, xPos, yPos]
     * @return  {String}  Joined ID string
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.minX, this.maxX);
      const yZoomLevel = api.calculateZoomLevel(this._yScale, this.minY, this.maxY);
      return min(max$1(xZoomLevel, yZoomLevel), this.maxZoom);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo)
        return;
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.minX, this.maxX, this.tilesetInfo.max_zoom, this.maxSize);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.minY, this.maxY, this.tilesetInfo.max_zoom, this.maxSize);
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < this.xTiles.length; i++) {
        for (let j = 0; j < this.yTiles.length; j++) {
          tiles.push([zoomLevel, this.xTiles[i], this.yTiles[j]]);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnAnnotations = {};
      _get$k(_getPrototypeOf$R(Annotations2dTrack2.prototype), "draw", this).call(this);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile, force = false, silent = false) {
      if (!tile.graphics)
        return;
      tile.graphics.__tile__ = tile;
      const graphics = tile.graphics;
      graphics.clear();
      this.setBorderStyle(graphics);
      this.setFill(graphics);
      graphics.alpha = +this.options.rectangleDomainOpacity;
      if (!tile.tileData.length)
        return;
      tile.tileData.filter((td) => !(td.uid in this.drawnAnnotations) || force).forEach((td) => {
        const [startX, startY] = this.projection([td.xStart, td.yStart]);
        const [endX, endY] = this.projection([td.xEnd, td.yEnd]);
        if (this.options.exclude && this.options.exclude.indexOf(td.uid) >= 0) {
          return;
        }
        this.drawAnnotation(this.prepAnnotation(graphics, td.uid, startX, startY, endX - startX, endY - startY, td), silent);
      });
    }
  }, {
    key: "prepAnnotation",
    value: function prepAnnotation(graphics, uid, startX, startY, width, height2, td) {
      let info;
      try {
        info = JSON.parse(td.fields);
      } catch (e) {
      }
      return {
        graphics,
        id: td.id,
        uid,
        annotation: {
          x: startX,
          y: startY,
          width,
          height: height2
        },
        dataPos: [td.xStart, td.xEnd, td.yStart, td.yEnd],
        importance: td.importance,
        info
      };
    }
  }, {
    key: "drawAnnotation",
    value: function drawAnnotation2({
      graphics,
      id: id2,
      uid,
      annotation,
      dataPos,
      importance,
      info
    }, silent) {
      if (this.options.minSquareSize) {
        if (annotation.width < this.options.minSquareSize || annotation.height < this.options.minSquareSize) {
          annotation.x = (annotation.x + annotation.width) / 2;
          annotation.y = (annotation.y + annotation.height) / 2;
          annotation.width = this.options.minSquareSize;
          annotation.height = this.options.minSquareSize;
        }
      }
      this.drawnAnnotations[uid] = annotation;
      const viewPos = [annotation.x, annotation.y, annotation.width, annotation.height];
      let rectGfx = this.drawnAnnoGfx[uid];
      if (!rectGfx) {
        rectGfx = new GLOBALS.PIXI.Graphics();
        this.drawnAnnoGfx[uid] = rectGfx;
      }
      if (graphics.children.indexOf(rectGfx) === -1) {
        graphics.addChild(rectGfx);
      }
      this._drawRect(rectGfx, viewPos, uid);
      graphics.interactive = true;
      rectGfx.interactive = true;
      rectGfx.buttonMode = true;
      const payload = {
        id: id2,
        uid,
        dataPos,
        importance,
        info,
        viewPos: [
          annotation.x,
          annotation.y,
          // To have the same format as `dataPos`, i.e.:
          // a quadruple of [x0, y0, x1, y1]
          annotation.x + annotation.width,
          annotation.y + annotation.height
        ]
      };
      rectGfx.mouseover = () => this.hover(rectGfx, viewPos, uid);
      rectGfx.mouseout = () => this.blur(rectGfx, viewPos, uid);
      rectGfx.mousedown = () => this.mouseDown();
      rectGfx.mouseup = (event) => this.mouseUp(rectGfx, viewPos, uid, event, payload);
      if (!silent) {
        this.publish("annotationDrawn", {
          trackUuids: this.uuid,
          annotationUuid: uid,
          annotationId: id2,
          viewPos,
          dataPos,
          importance,
          info
        });
      }
    }
  }, {
    key: "_drawRect",
    value: function _drawRect(graphics, viewPos, uid) {
      let stroke = this.options.rectangleDomainStrokeColor;
      let strokeWidth = this.options.rectangleDomainStrokeWidth;
      let strokeAlpha = this.options.rectangleDomainStrokeOpacity;
      let fill = this.options.rectangleDomainFillColor;
      let fillAlpha = this.options.rectangleDomainFillOpacity;
      if (this.hoveredAnno === uid) {
        stroke = this.options.hoverColor;
        strokeWidth = this.options.rectangleDomainStrokeWidth + 1 || 2;
        strokeAlpha = 1;
        fill = this.options.hoverColor;
        fillAlpha = this.options.rectangleDomainFillOpacity;
      }
      if (this.selectedAnno && this.selectedAnno.uid === uid) {
        stroke = this.options.selectColor;
        strokeWidth = this.options.rectangleDomainStrokeWidth + 1 || 2;
        strokeAlpha = 1;
        fill = this.options.selectColor;
        fillAlpha = max$1(0.33, this.options.rectangleDomainFillOpacity);
      }
      graphics.clear();
      if (this.options.trackBorderBgWidth) {
        this.setBorderStyle(graphics, this.options.trackBorderBgColor, this.options.trackBorderBgWidth, this.options.trackBorderBgAlpha);
        this.setFill(graphics, fill, 0);
        graphics.drawRect(...viewPos);
      }
      this.setBorderStyle(graphics, stroke, strokeWidth, strokeAlpha);
      this.setFill(graphics, fill, fillAlpha);
      graphics.drawRect(...viewPos);
      graphics.__viewPos__ = viewPos;
    }
  }, {
    key: "context",
    value: function context(graphics, viewPos, uid) {
      return (proc) => proc(graphics, viewPos, uid);
    }
  }, {
    key: "click",
    value: function click(graphics, viewPos, uid, event, payload) {
      this.select(graphics, viewPos, uid);
      this.pubSub.publish("app.click", {
        type: "annotation",
        event,
        payload
      });
    }
  }, {
    key: "mouseDown",
    value: function mouseDown() {
      this.sT = performance.now();
    }
  }, {
    key: "mouseUp",
    value: function mouseUp(graphics, viewPos, uid, event, payload) {
      if (performance.now() - this.sT <= MOUSE_CLICK_TIME) {
        this.click(graphics, viewPos, uid, event, payload);
      }
    }
  }, {
    key: "hover",
    value: function hover3(graphics, viewPos, uid) {
      this.hoveredAnno = uid;
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "focus",
    value: function focus(graphics, viewPos, uid) {
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "blur",
    value: function blur(graphics, viewPos, uid) {
      this.hoveredAnno = null;
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "select",
    value: function select2(graphics, viewPos, uid, silent = false) {
      let prevGfx = null;
      let prevUid = null;
      if (this.selectedAnno) {
        prevGfx = this.selectedAnno.graphics;
        prevUid = this.selectedAnno.uid;
      }
      this.selectedAnno = {
        graphics,
        uid
      };
      this.focus(graphics, viewPos, uid);
      if (this.options.onSelect && !silent) {
        window[this.options.onSelect](uid);
        this.pubSub.publish("annoSelected", uid);
      }
      if (prevGfx && prevUid) {
        this.blur(prevGfx, prevGfx.__viewPos__, prevUid);
      }
    }
  }, {
    key: "unselect",
    value: function unselect() {
      const gfx = this.selectedAnno.graphics;
      const uid = this.selectedAnno.uid;
      this.selectedAnno = null;
      this.blur(gfx, gfx.__viewPos__, uid);
    }
  }, {
    key: "annoSelected",
    value: function annoSelected(uid) {
      if (!this.selectedAnno || this.selectedAnno.uid !== uid) {
        if (this.selectedAnno)
          this.unselect();
        const gfx = this.drawnAnnoGfx[uid];
        if (gfx)
          this.select(gfx, gfx.__viewPos__, uid, true);
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$k(_getPrototypeOf$R(Annotations2dTrack2.prototype), "exportSVG", this)) {
        [base, track] = _get$k(_getPrototypeOf$R(Annotations2dTrack2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.tileData && tile.tileData.length).map((tile) => ({
        graphics: tile.graphics,
        td: tile.tileData
      })).forEach(({
        td,
        graphics
      }) => {
        const gTile = document.createElement("g");
        gTile.setAttribute("transform", `translate(${graphics.position.x},${graphics.position.y})scale(${graphics.scale.x},${graphics.scale.y})`);
        output.appendChild(gTile);
        if (td.uid in this.drawnAnnotations) {
          const rect = this.drawnAnnotations[td.uid];
          const r2 = document.createElement("rect");
          r2.setAttribute("x", rect.x);
          r2.setAttribute("y", rect.y);
          r2.setAttribute("width", rect.width);
          r2.setAttribute("height", rect.height);
          r2.setAttribute("fill", this.options.fillColor || "grey");
          r2.setAttribute("opacity", 0.3);
          r2.style.stroke = this.options.fillColor || "grey";
          r2.style.strokeWidth = "1px";
          gTile.appendChild(r2);
        }
      });
      return [base, base];
    }
  }, {
    key: "setBorderStyle",
    value: function setBorderStyle(graphics, color2 = this.options.rectangleDomainStrokeColor, width = this.options.rectangleDomainStrokeWidth, alpha = this.options.rectangleDomainStrokeOpacity) {
      graphics.lineStyle(typeof width !== "undefined" ? width : 1, colorToHex(color2 || "black"), typeof alpha !== "undefined" ? alpha : 1);
    }
  }, {
    key: "setFill",
    value: function setFill(graphics, color2 = this.options.rectangleDomainFillColor, alpha = this.options.rectangleDomainFillOpacity) {
      graphics.beginFill(colorToHex(color2 || "grey"), typeof alpha !== "undefined" ? alpha : 0.4);
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$k(_getPrototypeOf$R(Annotations2dTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }]);
  return Annotations2dTrack2;
}(TiledPixiTrack);
function _classCallCheck$13(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$U(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$U(descriptor.key), descriptor);
  }
}
function _createClass$11(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$U(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$U(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$U(arg) {
  var key = _toPrimitive$U(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$U(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$j() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$j = Reflect.get.bind();
  } else {
    _get$j = function _get2(target, property2, receiver) {
      var base = _superPropBase$j(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$j.apply(this, arguments);
}
function _superPropBase$j(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$Q(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$$(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$Q(subClass, superClass);
}
function _setPrototypeOf$Q(o, p) {
  _setPrototypeOf$Q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$Q(o, p);
}
function _createSuper$Q(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$Q();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$Q(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$Q(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$$(this, result);
  };
}
function _possibleConstructorReturn$$(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$Q(self2);
}
function _assertThisInitialized$Q(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$Q() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$Q(o) {
  _getPrototypeOf$Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$Q(o);
}
let Annotations1dTrack = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$$(Annotations1dTrack2, _PixiTrack);
  var _super = _createSuper$Q(Annotations1dTrack2);
  function Annotations1dTrack2(context, options2, isVertical) {
    var _this;
    _classCallCheck$13(this, Annotations1dTrack2);
    _this = _super.call(this, context, options2);
    _this.pubSub = context.pubSub;
    _this.options = options2;
    _this.isVertical = isVertical;
    _this.rects = {};
    _this.defaultColor = color("red");
    return _this;
  }
  _createClass$11(Annotations1dTrack2, [{
    key: "draw",
    value: function draw() {
      const globalMinRectWidth = typeof this.options.minRectWidth !== "undefined" ? this.options.minRectWidth : 10;
      const globalFill = typeof this.options.fill !== "undefined" ? color(this.options.fill) : this.defaultColor;
      const globalFillOpacity = typeof this.options.fillOpacity !== "undefined" ? +this.options.fillOpacity : 0.2;
      const globalStroke = typeof this.options.stroke !== "undefined" ? color(this.options.stroke) : this.defaultColor;
      const globalStrokeWidth = typeof this.options.strokeWidth !== "undefined" ? +this.options.strokeWidth : 1;
      const globalStrokeOpacity = typeof this.options.strokeOpacity !== "undefined" ? +this.options.strokeOpacity : 0;
      let strokePos;
      if (this.options.strokePos && this.options.strokePos.length) {
        strokePos = Array.isArray(this.options.strokePos) ? this.options.strokePos : [this.options.strokePos];
      }
      _get$j(_getPrototypeOf$Q(Annotations1dTrack2.prototype), "draw", this).call(this);
      const graphics = this.pMain;
      graphics.clear();
      const timeStamp = performance.now();
      this.options.regions.forEach((region) => {
        const id2 = `${region[0]}-${region[1]}`;
        if (!this.rects[id2]) {
          this.rects[id2] = {
            graphics: new GLOBALS.PIXI.Graphics()
          };
          graphics.addChild(this.rects[id2].graphics);
        }
        this.rects[id2].timeStamp = timeStamp;
        const fill = color(region[2]) || globalFill;
        let stroke = color(region[3]) || globalStroke;
        if (!stroke) {
          stroke = fill;
        }
        const fillHex = GLOBALS.PIXI.utils.rgb2hex([fill.r / 255, fill.g / 255, fill.b / 255]);
        const strokeHex = GLOBALS.PIXI.utils.rgb2hex([stroke.r / 255, stroke.g / 255, stroke.b / 255]);
        if (strokePos) {
          graphics.lineStyle(1, strokeHex, 0);
          graphics.beginFill(strokeHex, +region[5] || globalStrokeOpacity);
        } else {
          graphics.lineStyle(globalStrokeWidth, strokeHex, +region[5] || globalStrokeOpacity);
          graphics.beginFill(fillHex, +region[4] || globalFillOpacity);
        }
        const scale = this.isVertical ? this._yScale : this._xScale;
        let start2 = scale(+region[0]);
        const end2 = scale(+region[1]);
        let width = end2 - start2;
        const minRectWidth = typeof region[6] !== "undefined" ? region[6] : globalMinRectWidth;
        if (width < minRectWidth) {
          start2 = (start2 + end2) / 2 - minRectWidth / 2;
          width = minRectWidth;
        }
        if (strokePos) {
          graphics.lineStyle(1, strokeHex, 0);
          graphics.beginFill(strokeHex, +region[5] || globalStrokeOpacity);
          strokePos.forEach((pos) => {
            if (pos === "top" || pos === "around") {
              if (this.isVertical) {
                graphics.drawRect(0, start2, globalStrokeWidth, width);
              } else {
                graphics.drawRect(start2, 0, width, globalStrokeWidth);
              }
            }
            if (pos === "right" || pos === "around") {
              if (this.isVertical) {
                graphics.drawRect(0, start2, this.dimensions[0], globalStrokeWidth);
              } else {
                graphics.drawRect(start2, 0, globalStrokeWidth, this.dimensions[1]);
              }
            }
            if (pos === "bottom" || pos === "around") {
              if (this.isVertical) {
                graphics.drawRect(this.dimensions[0] - globalStrokeWidth, start2, globalStrokeWidth, width);
              } else {
                graphics.drawRect(start2, this.dimensions[1] - globalStrokeWidth, width, globalStrokeWidth);
              }
            }
            if (pos === "left" || pos === "around") {
              if (this.isVertical) {
                graphics.drawRect(0, start2 + width - globalStrokeWidth, this.dimensions[0], globalStrokeWidth);
              } else {
                graphics.drawRect(start2 + width - globalStrokeWidth, 0, globalStrokeWidth, this.dimensions[1]);
              }
            }
          });
        } else {
          graphics.lineStyle(globalStrokeWidth, strokeHex, +region[5] || globalStrokeOpacity);
        }
        this.rects[id2].graphics.clear();
        this.rects[id2].graphics.interactive = true;
        this.rects[id2].graphics.buttonMode = true;
        graphics.beginFill(fillHex, +region[4] || globalFillOpacity);
        if (this.isVertical) {
          graphics.drawRect(0, start2, this.dimensions[0], width);
          this.rects[id2].graphics.hitArea = new GLOBALS.PIXI.Rectangle(0, start2, this.dimensions[0], width);
        } else {
          graphics.drawRect(start2, 0, width, this.dimensions[1]);
          this.rects[id2].graphics.hitArea = new GLOBALS.PIXI.Rectangle(start2, 0, width, this.dimensions[1]);
        }
        this.rects[id2].graphics.mousedown = () => {
          this.rects[id2].mouseDownTime = performance.now();
        };
        this.rects[id2].graphics.mouseup = (event) => {
          if (performance.now() - this.rects[id2].mouseDownTime < MAX_CLICK_DELAY$1) {
            this.pubSub.publish("app.click", {
              type: "annotation",
              event,
              payload: region
            });
          }
        };
      });
      Object.values(this.rects).filter((rect) => rect.timeStamp !== timeStamp).forEach((rect) => graphics.removeChild(rect.graphics));
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$j(_getPrototypeOf$Q(Annotations1dTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }]);
  return Annotations1dTrack2;
}(PixiTrack);
function _classCallCheck$12(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$T(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$T(descriptor.key), descriptor);
  }
}
function _createClass$10(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$T(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$T(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$T(arg) {
  var key = _toPrimitive$T(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$T(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$i() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$i = Reflect.get.bind();
  } else {
    _get$i = function _get2(target, property2, receiver) {
      var base = _superPropBase$i(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$i.apply(this, arguments);
}
function _superPropBase$i(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$P(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$_(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$P(subClass, superClass);
}
function _setPrototypeOf$P(o, p) {
  _setPrototypeOf$P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$P(o, p);
}
function _createSuper$P(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$P();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$P(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$P(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$_(this, result);
  };
}
function _possibleConstructorReturn$_(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$P(self2);
}
function _assertThisInitialized$P(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$P() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$P(o) {
  _getPrototypeOf$P = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$P(o);
}
let Horizontal2DDomainsTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$_(Horizontal2DDomainsTrack2, _TiledPixiTrack);
  var _super = _createSuper$P(Horizontal2DDomainsTrack2);
  function Horizontal2DDomainsTrack2(context, options2) {
    var _this;
    _classCallCheck$12(this, Horizontal2DDomainsTrack2);
    _this = _super.call(this, context, options2);
    _this.drawnRects = /* @__PURE__ */ new Set();
    _this.pMain = _this.pMobile;
    return _this;
  }
  _createClass$10(Horizontal2DDomainsTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      if (this.options && this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      const expandedXScale = this._xScale.copy();
      expandedXScale.domain([this._xScale.invert(this._xScale.range()[0] - this.dimensions[1] * Math.sqrt(2)), this._xScale.invert(this._xScale.range()[1] + this.dimensions[1] * Math.sqrt(2))]);
      this.xTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const maxWidth = this.tilesetInfo.max_width;
      const tileWidth = maxWidth / 2 ** zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = i; j < cols.length; j++) {
          const tileBottomPosition = (j - i - 2) * (this._xScale(tileWidth) - this._xScale(0)) * Math.sqrt(2) / 2;
          if (tileBottomPosition > this.dimensions[1]) {
            continue;
          }
          const newTile = [zoomLevel, rows[i], cols[j]];
          newTile.mirrored = false;
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _get$i(_getPrototypeOf$P(Horizontal2DDomainsTrack2.prototype), "initTile", this).call(this, tile);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.delayDrawing) {
        this.drawnRects.clear();
      }
      _get$i(_getPrototypeOf$P(Horizontal2DDomainsTrack2.prototype), "draw", this).call(this);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      graphics.clear();
      const stroke = colorToHex(this.options.rectangleDomainStrokeColor ? this.options.rectangleDomainStrokeColor : "black");
      const fill = colorToHex(this.options.rectangleDomainFillColor ? this.options.rectangleDomainFillColor : "grey");
      graphics.lineStyle(1 / this.pMain.scale.x, stroke, 1);
      graphics.beginFill(fill, 0.4);
      graphics.alpha = this.options.rectangleDomainOpacity ? this.options.rectangleDomainOpacity : 0.5;
      if (!tile.tileData.sort)
        return;
      for (const td of tile.tileData) {
        const startX = this._refXScale(td.xStart);
        const endX = this._refXScale(td.xEnd);
        const startY = this._refYScale(td.yStart);
        const endY = this._refYScale(td.yEnd);
        const uid = td.uid;
        if (this.drawnRects.has(uid)) {
          continue;
        }
        this.drawnRects.add(uid);
        graphics.drawRect(startX, startY, endX - startX, endY - startY);
        graphics.pivot.x = this._refXScale(0);
        graphics.pivot.y = this._refYScale(0);
        graphics.scale.x = -1 / Math.sqrt(2);
        graphics.rotation = -3 * Math.PI / 4;
        graphics.scale.y = 1 / Math.sqrt(2);
        graphics.position.x = this._refXScale(0);
        graphics.position.y = 0;
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$i(_getPrototypeOf$P(Horizontal2DDomainsTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _get$i(_getPrototypeOf$P(Horizontal2DDomainsTrack2.prototype), "refScalesChanged", this).call(this, refXScale, refYScale);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          const graphics = tile.graphics;
          graphics.pivot.x = this._refXScale(0);
          graphics.pivot.y = this._refYScale(0);
          graphics.scale.x = -1 / Math.sqrt(2);
          graphics.rotation = -3 * Math.PI / 4;
          graphics.scale.y = 1 / Math.sqrt(2);
          graphics.position.x = this._refXScale(0);
          graphics.position.y = 0;
        }
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _get$i(_getPrototypeOf$P(Horizontal2DDomainsTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale, k, tx, ty);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1] + this.dimensions[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      if (this.options.oneDHeatmapFlipped) {
        this.pMain.scale.y = -k;
        this.pMain.position.y = this.position[1];
      }
      this.draw();
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }]);
  return Horizontal2DDomainsTrack2;
}(TiledPixiTrack);
function _classCallCheck$11(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$S(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$S(descriptor.key), descriptor);
  }
}
function _createClass$$(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$S(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$S(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$S(arg) {
  var key = _toPrimitive$S(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$S(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$h() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$h = Reflect.get.bind();
  } else {
    _get$h = function _get2(target, property2, receiver) {
      var base = _superPropBase$h(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$h.apply(this, arguments);
}
function _superPropBase$h(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$O(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$Z(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$O(subClass, superClass);
}
function _setPrototypeOf$O(o, p) {
  _setPrototypeOf$O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$O(o, p);
}
function _createSuper$O(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$O();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$O(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$O(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Z(this, result);
  };
}
function _possibleConstructorReturn$Z(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$O(self2);
}
function _assertThisInitialized$O(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$O() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$O(o) {
  _getPrototypeOf$O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$O(o);
}
let SquareMarkersTrack = /* @__PURE__ */ function(_TiledPixiTrack) {
  _inherits$Z(SquareMarkersTrack2, _TiledPixiTrack);
  var _super = _createSuper$O(SquareMarkersTrack2);
  function SquareMarkersTrack2(context, options2) {
    var _this;
    _classCallCheck$11(this, SquareMarkersTrack2);
    _this = _super.call(this, context, options2);
    _this.drawnRects = /* @__PURE__ */ new Set();
    return _this;
  }
  _createClass$$(SquareMarkersTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      return zoomLevel;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles(mirrorTiles = true) {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnRects.clear();
      _get$h(_getPrototypeOf$O(SquareMarkersTrack2.prototype), "draw", this).call(this);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      graphics.clear();
      const fill = colorToHex("green");
      graphics.lineStyle(1, 255, 1);
      graphics.beginFill(fill, 0.8);
      graphics.alpha = 0.5;
      for (const td of tile.tileData) {
        const startX = this._xScale(td.xStart);
        const endX = this._xScale(td.xEnd);
        const startY = this._yScale(td.yStart);
        const endY = this._yScale(td.yEnd);
        const uid = td.uid;
        if (this.drawnRects.has(uid)) {
          continue;
        }
        this.drawnRects.add(uid);
        const MIN_WIDTH = 6;
        const MIN_HEIGHT = 6;
        let width = endY - startY;
        let height2 = endX - startX;
        const centerX = (startX + endX) / 2;
        const centerY = (startY + endY) / 2;
        if (width < MIN_WIDTH) {
          width = MIN_WIDTH;
        }
        if (height2 < MIN_HEIGHT) {
          height2 = MIN_HEIGHT;
        }
        graphics.drawRect(centerX - width / 2, centerY - height2 / 2, width, height2);
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$h(_getPrototypeOf$O(SquareMarkersTrack2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }]);
  return SquareMarkersTrack2;
}(TiledPixiTrack);
function ChromosomeInfo(filepath, success, pubSub = fakePubSub) {
  const ret = {};
  ret.absToChr = (absPos) => ret.chrPositions ? absToChr(absPos, ret) : null;
  ret.chrToAbs = ([chrName, chrPos] = []) => ret.chrPositions ? chrToAbs(chrName, chrPos, ret) : null;
  return api.text(filepath, (error, chrInfoText) => {
    if (error) {
      if (success)
        success(null);
    } else {
      const data2 = tsvParseRows(chrInfoText);
      const chromInfo = parseChromsizesRows(data2);
      Object.keys(chromInfo).forEach((key) => {
        ret[key] = chromInfo[key];
      });
      if (success)
        success(ret);
    }
  }, pubSub).then(() => ret);
}
function _classCallCheck$10(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$R(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$R(descriptor.key), descriptor);
  }
}
function _createClass$_(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$R(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$R(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$R(arg) {
  var key = _toPrimitive$R(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$R(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let SearchField = /* @__PURE__ */ function() {
  function SearchField2(chromInfo) {
    _classCallCheck$10(this, SearchField2);
    this.chromInfo = chromInfo;
    this.chromInfoBisector = bisector((d) => d.pos).left;
  }
  _createClass$_(SearchField2, [{
    key: "scalesToPositionText",
    value: function scalesToPositionText(xScale, yScale, twoD = false) {
      if (this.chromInfo === null) {
        return "";
      }
      if (!xScale || !yScale) {
        return "";
      }
      const x12 = absToChr(xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(xScale.domain()[1], this.chromInfo);
      const y12 = absToChr(yScale.domain()[0], this.chromInfo);
      const y2 = absToChr(yScale.domain()[1], this.chromInfo);
      let positionString = null;
      const stringFormat = format$1(",d");
      if (x12[0] !== x2[0]) {
        positionString = `${x12[0]}:${stringFormat(Math.floor(x12[1]))}-${x2[0]}:${stringFormat(Math.ceil(x2[1]))}`;
      } else {
        positionString = `${x12[0]}:${stringFormat(Math.floor(x12[1]))}-${stringFormat(Math.ceil(x2[1]))}`;
      }
      if (twoD) {
        if (y12[0] !== y2[0]) {
          positionString += ` & ${y12[0]}:${stringFormat(Math.floor(y12[1]))}-${y2[0]}:${stringFormat(Math.ceil(y2[1]))}`;
        } else {
          positionString += ` & ${y12[0]}:${stringFormat(Math.floor(y12[1]))}-${stringFormat(Math.ceil(y2[1]))}`;
        }
      }
      if (x12[2] <= 0 || x2[2] > 0 || twoD && (y12[2] <= 0 || y2[2] > 0)) {
        positionString += ` [offset ${x12[2]},${x2[2]}`;
        if (twoD) {
          positionString += `:${y12[2]},${y2[2]}`;
        }
        positionString += "]";
      }
      return positionString;
    }
  }, {
    key: "convertNumberNotation",
    value: function convertNumberNotation(numStr) {
      let newNumStr = numStr;
      if (!newNumStr.includes("M", newNumStr.length - 1) && !newNumStr.includes("K", newNumStr.length - 1)) {
        return newNumStr;
      }
      let numZerosToAdd = 0;
      let decPointPosFromEnd = 0;
      if (newNumStr.includes("M", newNumStr.length - 1)) {
        numZerosToAdd = 6;
        newNumStr = newNumStr.replace("M", "");
      } else {
        numZerosToAdd = 3;
        newNumStr = newNumStr.replace("K", "");
      }
      if (Number.isNaN(+newNumStr)) {
        return numStr;
      }
      newNumStr = (+newNumStr).toString();
      if (newNumStr.includes(".")) {
        decPointPosFromEnd = newNumStr.length - 1 - newNumStr.indexOf(".");
        newNumStr = (+newNumStr.replace(".", "")).toString();
      }
      const totalZerosToAdd = numZerosToAdd - decPointPosFromEnd;
      if (totalZerosToAdd < 0) {
        return numStr;
      }
      newNumStr += "0".repeat(totalZerosToAdd);
      return newNumStr;
    }
  }, {
    key: "parsePosition",
    value: function parsePosition(positionText, prevChr = null) {
      const positionParts = positionText.split(":");
      let chr = null;
      let pos = 0;
      if (positionParts.length > 1) {
        chr = positionParts[0];
        pos = +this.convertNumberNotation(positionParts[1].replace(/,/g, ""));
      } else if (positionParts[0] in this.chromInfo.chrPositions) {
        chr = positionParts[0];
        pos = 0;
        if (prevChr !== null) {
          pos = +this.chromInfo.chromLengths[chr];
        }
      } else {
        pos = +this.convertNumberNotation(positionParts[0].replace(/,/g, ""));
        chr = null;
        if (prevChr)
          chr = prevChr;
      }
      let retPos = null;
      if (chr === null) {
        chr = prevChr;
        retPos = pos;
      } else if (chr in this.chromInfo.chrPositions) {
        retPos = this.chromInfo.chrPositions[chr].pos + pos;
      }
      return [chr, pos, retPos];
    }
  }, {
    key: "matchRangesToLarger",
    value: function matchRangesToLarger(range1, range2) {
      if (range1[1] - range1[0] < range2[1] - range2[0]) {
        const toExpand2 = range2[1] - range2[0] - (range1[1] - range1[0]);
        return [[range1[0] - toExpand2 / 2, range1[1] + toExpand2 / 2], range2];
      }
      const toExpand = range1[1] - range1[0] - (range2[1] - range2[0]);
      return [range1, [range2[0] - toExpand / 2, range2[1] + toExpand / 2]];
    }
  }, {
    key: "getSearchRange",
    value: function getSearchRange(term) {
      if (term.length === 0) {
        return null;
      }
      let parts = term.split("-");
      parts = parts.filter((d) => d.length > 0);
      let range2 = null;
      if (parts[0].indexOf("-") === 0) {
        parts[0] = parts[0].slice(3, parts[0].length);
      }
      if (parts.length > 1) {
        let [chr1, chrPos1, genomePos1] = this.parsePosition(parts[0]);
        let [chr2, chrPos2, genomePos2] = this.parsePosition(parts[1], chr1);
        const tempRange1 = [genomePos1, genomePos2];
        [chr1, chrPos1, genomePos1] = this.parsePosition(parts[1]);
        [chr2, chrPos2, genomePos2] = this.parsePosition(parts[0], chr1);
        if (chr1 === null && chr2 !== null) {
          [chr1, chrPos1, genomePos1] = this.parsePosition(parts[1], chr2);
        }
        const tempRange2 = [genomePos1, genomePos2];
        if (tempRange2[1] - tempRange2[0] > tempRange1[1] - tempRange1[0])
          return tempRange2;
        return tempRange1;
      }
      if (parts[0] in this.chromInfo.chrPositions) {
        const chromPosition = +this.chromInfo.chrPositions[parts[0]].pos;
        range2 = [chromPosition, chromPosition + +this.chromInfo.chromLengths[parts[0]]];
      } else {
        const [chr1, chrPos1, pos1] = this.parsePosition(parts[0]);
        range2 = [pos1 - 8e6, pos1 + 8e6];
      }
      if (range2[0] > range2[1]) {
        return [range2[1], range2[0]];
      }
      return range2;
    }
  }, {
    key: "parseOffset",
    value: function parseOffset(offsetText) {
      const parts = offsetText.split(":");
      if (parts.length === 0) {
        return [[0, 0], [0, 0]];
      }
      if (parts.length === 1) {
        const sparts = parts[0].split(",");
        return [[+sparts[0], +sparts[1]], [0, 0]];
      }
      const sparts0 = parts[0].split(",");
      const sparts1 = parts[1].split(",");
      return [[+sparts0[0], +sparts0[1]], [+sparts1[0], +sparts1[1]]];
    }
  }, {
    key: "searchPosition",
    value: function searchPosition(text2) {
      let range1 = null;
      let range2 = null;
      text2 = text2.trim();
      const offsetRe = /\[offset (.+?)\]/.exec(text2);
      let offset2 = [[0, 0], [0, 0]];
      if (offsetRe) {
        text2 = text2.replace(offsetRe[0], "");
        offset2 = this.parseOffset(offsetRe[1]);
      }
      const parts = text2.split(" & ");
      if (parts.length > 1) {
        range1 = this.getSearchRange(parts[0].split(" ")[0]);
        range2 = this.getSearchRange(parts[1].split(" ")[0]);
      } else {
        range1 = this.getSearchRange(parts[0]);
      }
      if (range1 !== null && range2 !== null) {
        [range1, range2] = this.matchRangesToLarger(range1, range2);
      }
      if (range1) {
        range1[0] += offset2[0][0];
        range1[1] += offset2[0][1];
      }
      if (range2) {
        range2[0] += offset2[1][0];
        range2[1] += offset2[1][1];
      }
      return [range1, range2];
    }
  }]);
  return SearchField2;
}();
function _classCallCheck$$(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$Q(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$Q(descriptor.key), descriptor);
  }
}
function _createClass$Z(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$Q(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$Q(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$Q(arg) {
  var key = _toPrimitive$Q(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$Q(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$g() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$g = Reflect.get.bind();
  } else {
    _get$g = function _get2(target, property2, receiver) {
      var base = _superPropBase$g(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$g.apply(this, arguments);
}
function _superPropBase$g(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$N(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$Y(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$N(subClass, superClass);
}
function _setPrototypeOf$N(o, p) {
  _setPrototypeOf$N = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$N(o, p);
}
function _createSuper$N(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$N();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$N(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$N(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Y(this, result);
  };
}
function _possibleConstructorReturn$Y(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$N(self2);
}
function _assertThisInitialized$N(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$N() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$N(o) {
  _getPrototypeOf$N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$N(o);
}
let Chromosome2DLabels = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$Y(Chromosome2DLabels2, _PixiTrack);
  var _super = _createSuper$N(Chromosome2DLabels2);
  function Chromosome2DLabels2(context, options2) {
    var _this;
    _classCallCheck$$(this, Chromosome2DLabels2);
    _this = _super.call(this, context, options2);
    const {
      dataConfig,
      animate,
      pubSub
    } = context;
    _this.searchField = null;
    _this.chromInfo = null;
    _this.animate = animate;
    const server = dataConfig.server;
    const uid = dataConfig.tilesetUid;
    const chromSizesPath = `${server}/chrom-sizes/?id=${uid}`;
    ChromosomeInfo(chromSizesPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.searchField = new SearchField(_this.chromInfo);
      _this.draw();
      _this.texts = [];
      for (let i = 0; i < _this.chromInfo.cumPositions.length; i++) {
        const thisTexts = [];
        for (let j = 0; j < _this.chromInfo.cumPositions.length; j++) {
          const textStr = `${_this.chromInfo.cumPositions[i].chr}/${_this.chromInfo.cumPositions[j].chr}`;
          const text2 = new GLOBALS.PIXI.Text(textStr, {
            fontSize: "14px",
            fontFamily: "Arial",
            fill: "red"
          });
          text2.anchor.x = 0.5;
          text2.anchor.y = 0.5;
          text2.visible = false;
          text2.hashValue = Math.random();
          thisTexts.push(text2);
          _this.pMain.addChild(text2);
        }
        _this.texts.push(thisTexts);
      }
      _this.draw();
      _this.animate();
    }, pubSub);
    return _this;
  }
  _createClass$Z(Chromosome2DLabels2, [{
    key: "draw",
    value: function draw() {
      const allTexts = [];
      if (!this.texts) {
        return;
      }
      if (!this.searchField) {
        return;
      }
      const x12 = absToChr(this._xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(this._xScale.domain()[1], this.chromInfo);
      const y12 = absToChr(this._yScale.domain()[0], this.chromInfo);
      const y2 = absToChr(this._yScale.domain()[1], this.chromInfo);
      for (let i = 0; i < this.texts.length; i++) {
        for (let j = 0; j < this.texts.length; j++) {
          this.texts[i][j].visible = false;
        }
      }
      for (let i = x12[3]; i <= x2[3]; i++) {
        for (let j = y12[3]; j <= y2[3]; j++) {
          const xCumPos = this.chromInfo.cumPositions[i];
          const yCumPos = this.chromInfo.cumPositions[j];
          const midX = xCumPos.pos + this.chromInfo.chromLengths[xCumPos.chr] / 2;
          const midY = yCumPos.pos + this.chromInfo.chromLengths[yCumPos.chr] / 2;
          const viewportMidX = this._xScale(midX);
          const viewportMidY = this._yScale(midY);
          const text2 = this.texts[i][j];
          text2.x = viewportMidX;
          text2.y = viewportMidY;
          text2.updateTransform();
          const bbox = text2.getBounds();
          const bwh = bbox.width / 2;
          const bhh = bbox.height / 2;
          if (viewportMidX + bwh > this.dimensions[0]) {
            text2.x -= viewportMidX + bwh - this.dimensions[0];
          } else if (viewportMidX - bwh < 0) {
            text2.x -= viewportMidX - bwh;
          }
          if (viewportMidY + bhh > this.dimensions[1]) {
            text2.y -= viewportMidY + bhh - this.dimensions[1];
          } else if (viewportMidY - bhh < 0) {
            text2.y -= viewportMidY - bhh;
          }
          text2.visible = true;
          allTexts.push({
            importance: this.texts[i][j].hashValue,
            text: this.texts[i][j],
            caption: null
          });
        }
      }
      this.hideOverlaps(allTexts);
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allTexts) {
      let allBoxes = [];
      allBoxes = allTexts.map((val2) => {
        const text2 = val2.text;
        text2.updateTransform();
        const b = text2.getBounds();
        const box = [b.x, b.y, b.x + b.width, b.y + b.height];
        return box;
      });
      boxIntersect$1(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = 0;
        } else {
          allTexts[i].text.visible = 0;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$g(_getPrototypeOf$N(Chromosome2DLabels2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }]);
  return Chromosome2DLabels2;
}(PixiTrack);
function _classCallCheck$_(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$P(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$P(descriptor.key), descriptor);
  }
}
function _createClass$Y(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$P(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$P(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$P(arg) {
  var key = _toPrimitive$P(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$P(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$f() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$f = Reflect.get.bind();
  } else {
    _get$f = function _get2(target, property2, receiver) {
      var base = _superPropBase$f(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$f.apply(this, arguments);
}
function _superPropBase$f(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$M(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$X(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$M(subClass, superClass);
}
function _setPrototypeOf$M(o, p) {
  _setPrototypeOf$M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$M(o, p);
}
function _createSuper$M(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$M();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$M(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$M(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$X(this, result);
  };
}
function _possibleConstructorReturn$X(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$M(self2);
}
function _assertThisInitialized$M(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$M() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$M(o) {
  _getPrototypeOf$M = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$M(o);
}
let ChromosomeGrid = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$X(ChromosomeGrid2, _PixiTrack);
  var _super = _createSuper$M(ChromosomeGrid2);
  function ChromosomeGrid2(context, options2) {
    var _this;
    _classCallCheck$_(this, ChromosomeGrid2);
    _this = _super.call(this, context, options2);
    const {
      chromInfoPath,
      dataConfig,
      animate,
      pubSub,
      orientation: orientation2 = "2d",
      isOverlay = false
    } = context;
    _this.searchField = null;
    _this.chromInfo = null;
    _this.animate = animate;
    _this.orientation = orientation2;
    _this.isOverlay = isOverlay;
    let chromSizesPath = chromInfoPath;
    if (!chromSizesPath) {
      chromSizesPath = `${dataConfig.server}/chrom-sizes/?id=${dataConfig.tilesetUid}`;
    }
    ChromosomeInfo(chromSizesPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.searchField = new SearchField(_this.chromInfo);
      _this.texts = [];
      _this.lineGraphics = new GLOBALS.PIXI.Graphics();
      _this.lineGraphics1dH = new GLOBALS.PIXI.Graphics();
      _this.lineGraphics1dV = new GLOBALS.PIXI.Graphics();
      _this.lineGraphics2d = new GLOBALS.PIXI.Graphics();
      _this.mask1dH = new GLOBALS.PIXI.Graphics();
      _this.mask1dV = new GLOBALS.PIXI.Graphics();
      _this.mask2d = new GLOBALS.PIXI.Graphics();
      _this.lineGraphics.addChild(_this.lineGraphics1dH);
      _this.lineGraphics1dH.addChild(_this.mask1dH);
      _this.lineGraphics.addChild(_this.lineGraphics1dV);
      _this.lineGraphics1dV.addChild(_this.mask1dV);
      _this.lineGraphics.addChild(_this.lineGraphics2d);
      _this.lineGraphics2d.addChild(_this.mask2d);
      _this.pMain.addChild(_this.lineGraphics);
      _this.draw();
      _this.animate();
    }, pubSub);
    return _this;
  }
  _createClass$Y(ChromosomeGrid2, [{
    key: "drawLines",
    value: function drawLines(orientation2 = this.orientation, left2 = 0, top2 = 0) {
      let graphics = this.lineGraphics;
      if (this.isOverlay && orientation2 === "1d-horizontal") {
        graphics = this.lineGraphics1dH;
      }
      if (this.isOverlay && orientation2 === "1d-vertical") {
        graphics = this.lineGraphics1dV;
      }
      if (this.isOverlay && orientation2 === "2d") {
        graphics = this.lineGraphics2d;
      }
      const strokeColor = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const strokeWidth = this.options.lineStrokeWidth ? this.options.lineStrokeWidth : 1;
      graphics.lineStyle(strokeWidth, strokeColor, 1);
      if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
        graphics.moveTo(this._xScale(0) + left2, top2);
        graphics.lineTo(this._xScale(0) + left2, this.dimensions[1] + top2);
      }
      if (orientation2 === "2d" || orientation2 === "1d-vertical") {
        graphics.moveTo(left2, this._yScale(0) + top2);
        graphics.lineTo(this.dimensions[0] + left2, this._yScale(0) + top2);
      }
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chrPos = this.chromInfo.cumPositions[i];
        const chrEnd = chrPos.pos + +this.chromInfo.chromLengths[chrPos.chr] + 1;
        if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
          graphics.moveTo(this._xScale(chrEnd) + left2, top2);
          graphics.lineTo(this._xScale(chrEnd) + left2, this.dimensions[1] + top2);
        }
        if (orientation2 === "2d" || orientation2 === "1d-vertical") {
          graphics.moveTo(left2, this._yScale(chrEnd) + top2);
          graphics.lineTo(this.dimensions[0] + left2, this._yScale(chrEnd) + top2);
        }
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.texts) {
        return;
      }
      if (!this.searchField) {
        return;
      }
      this.lineGraphics.clear();
      if (this.isOverlay) {
        this.lineGraphics1dH.clear();
        this.lineGraphics1dV.clear();
        this.lineGraphics2d.clear();
        this.mask1dH.clear();
        this.mask1dV.clear();
        this.mask2d.clear();
        this.mask1dH.beginFill(16777215);
        this.mask1dV.beginFill(16777215);
        this.mask2d.beginFill(16711680);
        for (let i = 0; i < this.options.orientationsAndPositions.length; i++) {
          const orientation2 = this.options.orientationsAndPositions[i].orientation;
          const {
            left: left2,
            top: top2,
            width,
            height: height2
          } = this.options.orientationsAndPositions[i].position;
          if (orientation2 === "1d-horizontal") {
            this.mask1dH.drawRect(left2, top2, width, height2);
          }
          if (orientation2 === "1d-vertical") {
            this.mask1dV.drawRect(left2, top2, width, height2);
          }
          if (orientation2 === "2d") {
            this.mask2d.drawRect(left2, top2, width, height2);
          }
          this.drawLines(orientation2, left2, top2);
        }
        this.lineGraphics1dH.mask = this.mask1dH;
        this.lineGraphics1dV.mask = this.mask1dV;
        this.lineGraphics2d.mask = this.mask2d;
      } else {
        this.drawLines();
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$f(_getPrototypeOf$M(ChromosomeGrid2.prototype), "setPosition", this).call(this, newPosition);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "createSvgLine",
    value: function createSvgLine(x12, x2, y12, y2, stroke, strokeWidth) {
      const line = document.createElement("line");
      line.setAttribute("x1", x12);
      line.setAttribute("x2", x2);
      line.setAttribute("y1", y12);
      line.setAttribute("y2", y2);
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", strokeWidth);
      return line;
    }
  }, {
    key: "drawLinesSvg",
    value: function drawLinesSvg(output, orientation2, width, height2, left2 = 0, top2 = 0) {
      const strokeColor = this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue";
      const strokeWidth = this.options.lineStrokeWidth;
      if (orientation2 === "2d" || orientation2 === "1d-vertical") {
        const y = this._yScale(0);
        if (y > 0 && y < top2 + height2) {
          output.appendChild(this.createSvgLine(left2, width + left2, y + top2, y + top2, strokeColor, strokeWidth));
        }
      }
      if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
        const x = this._xScale(0);
        if (x > 0 && x < left2 + width) {
          output.appendChild(this.createSvgLine(x + left2, x + left2, top2, height2 + top2, strokeColor, strokeWidth));
        }
      }
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chrPos = this.chromInfo.cumPositions[i];
        const chrEnd = chrPos.pos + +this.chromInfo.chromLengths[chrPos.chr] + 1;
        if (orientation2 === "2d" || orientation2 === "1d-vertical") {
          const y = this._yScale(chrEnd);
          if (y > 0 && y < top2 + height2) {
            output.appendChild(this.createSvgLine(left2, width + left2, y + top2, y + top2, strokeColor, strokeWidth));
          }
        }
        if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
          const x = this._xScale(chrEnd);
          if (x > 0 && x < left2 + width) {
            output.appendChild(this.createSvgLine(x + left2, x + left2, top2, height2 + top2, strokeColor, strokeWidth));
          }
        }
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$f(_getPrototypeOf$M(ChromosomeGrid2.prototype), "exportSVG", this)) {
        [base, track] = _get$f(_getPrototypeOf$M(ChromosomeGrid2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      const cgUniqueUd = Math.random().toString(36).substring(7);
      base.setAttribute("id", `ChromosomeGrid-${cgUniqueUd}`);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      if (!this.chromInfo) {
        return [base, track];
      }
      if (this.isOverlay) {
        for (let i = 0; i < this.options.orientationsAndPositions.length; i++) {
          const orientation2 = this.options.orientationsAndPositions[i].orientation;
          const {
            left: left2,
            top: top2,
            width,
            height: height2
          } = this.options.orientationsAndPositions[i].position;
          this.drawLinesSvg(output, orientation2, width, height2, left2, top2);
        }
      } else {
        this.drawLinesSvg(output, this.orientation, ...this.dimensions);
      }
      return [base, track];
    }
  }]);
  return ChromosomeGrid2;
}(PixiTrack);
function _classCallCheck$Z(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$O(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$O(descriptor.key), descriptor);
  }
}
function _createClass$X(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$O(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$O(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$O(arg) {
  var key = _toPrimitive$O(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$O(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$e() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$e = Reflect.get.bind();
  } else {
    _get$e = function _get2(target, property2, receiver) {
      var base = _superPropBase$e(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$e.apply(this, arguments);
}
function _superPropBase$e(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$L(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$W(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$L(subClass, superClass);
}
function _setPrototypeOf$L(o, p) {
  _setPrototypeOf$L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$L(o, p);
}
function _createSuper$L(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$L();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$L(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$L(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$W(this, result);
  };
}
function _possibleConstructorReturn$W(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$L(self2);
}
function _assertThisInitialized$L(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$L() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$L(o) {
  _getPrototypeOf$L = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$L(o);
}
const MAX_CLICK_DELAY = 300;
let Chromosome2DAnnotations = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$W(Chromosome2DAnnotations2, _PixiTrack);
  var _super = _createSuper$L(Chromosome2DAnnotations2);
  function Chromosome2DAnnotations2(context, options2) {
    var _this;
    _classCallCheck$Z(this, Chromosome2DAnnotations2);
    _this = _super.call(this, context, options2);
    const {
      chromInfoPath,
      pubSub
    } = context;
    _this.pubSub = pubSub;
    _this.rects = {};
    ChromosomeInfo(chromInfoPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.draw();
    }, _this.pubSub);
    return _this;
  }
  _createClass$X(Chromosome2DAnnotations2, [{
    key: "draw",
    value: function draw() {
      if (!this.chromInfo) {
        return;
      }
      const minRectWidth = this.options.minRectWidth ? this.options.minRectWidth : 10;
      const minRectHeight = this.options.minRectWidth ? this.options.minRectHeight : 10;
      _get$e(_getPrototypeOf$L(Chromosome2DAnnotations2.prototype), "draw", this).call(this);
      const graphics = this.pMain;
      graphics.clear();
      const timeStamp = performance.now();
      this.options.regions.forEach((region) => {
        const id2 = region.slice(0, 6).join("-");
        if (!this.rects[id2]) {
          this.rects[id2] = {
            graphics: new GLOBALS.PIXI.Graphics()
          };
          graphics.addChild(this.rects[id2].graphics);
        }
        this.rects[id2].timeStamp = timeStamp;
        const colorFill = color(region[6]);
        let colorLine = color(region[7]);
        if (!colorLine) {
          colorLine = colorFill;
        }
        const colorFillHex = GLOBALS.PIXI.utils.rgb2hex([colorFill.r / 255, colorFill.g / 255, colorFill.b / 255]);
        const colorLineHex = GLOBALS.PIXI.utils.rgb2hex([colorLine.r / 255, colorLine.g / 255, colorLine.b / 255]);
        graphics.lineStyle(1, colorLineHex, colorLine.opacity);
        graphics.beginFill(colorFillHex, colorFill.opacity);
        let startX = this._xScale(this.chromInfo.chrPositions[region[0]].pos + +region[1]);
        const endX = this._xScale(this.chromInfo.chrPositions[region[0]].pos + +region[2]);
        let startY = this._yScale(this.chromInfo.chrPositions[region[3]].pos + +region[4]);
        const endY = this._yScale(this.chromInfo.chrPositions[region[3]].pos + +region[5]);
        let width = endX - startX;
        let height2 = endY - startY;
        const _minRectWidth = typeof region[8] !== "undefined" ? region[8] : minRectWidth;
        const _minRectHeight = typeof region[9] !== "undefined" ? region[9] : minRectHeight;
        if (width < _minRectWidth) {
          startX = (startX + endX) / 2 - _minRectWidth / 2;
          width = _minRectWidth;
        }
        if (height2 < _minRectHeight) {
          startY = (startY + endY) / 2 - _minRectHeight / 2;
          height2 = _minRectHeight;
        }
        graphics.drawRect(startX, startY, width, height2);
        this.rects[id2].graphics.clear();
        this.rects[id2].graphics.interactive = true;
        this.rects[id2].graphics.buttonMode = true;
        this.rects[id2].graphics.hitArea = new GLOBALS.PIXI.Rectangle(startX, startY, width, height2);
        this.rects[id2].graphics.mousedown = () => {
          this.rects[id2].mouseDownTime = performance.now();
        };
        this.rects[id2].graphics.mouseup = (event) => {
          if (performance.now() - this.rects[id2].mouseDownTime < MAX_CLICK_DELAY) {
            this.pubSub.publish("app.click", {
              type: "annotation",
              event,
              payload: region
            });
          }
        };
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$e(_getPrototypeOf$L(Chromosome2DAnnotations2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }]);
  return Chromosome2DAnnotations2;
}(PixiTrack);
function _classCallCheck$Y(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$N(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$N(descriptor.key), descriptor);
  }
}
function _createClass$W(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$N(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$N(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$N(arg) {
  var key = _toPrimitive$N(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$N(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$d() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$d = Reflect.get.bind();
  } else {
    _get$d = function _get2(target, property2, receiver) {
      var base = _superPropBase$d(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$d.apply(this, arguments);
}
function _superPropBase$d(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$K(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$V(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$K(subClass, superClass);
}
function _setPrototypeOf$K(o, p) {
  _setPrototypeOf$K = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$K(o, p);
}
function _createSuper$K(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$K();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$K(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$K(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$V(this, result);
  };
}
function _possibleConstructorReturn$V(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$K(self2);
}
function _assertThisInitialized$K(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$K() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$K(o) {
  _getPrototypeOf$K = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$K(o);
}
const TICK_WIDTH = 200;
const TICK_HEIGHT = 6;
const TICK_TEXT_SEPARATION = 2;
const TICK_COLOR = 7829367;
let HorizontalChromosomeLabels = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$V(HorizontalChromosomeLabels2, _PixiTrack);
  var _super = _createSuper$K(HorizontalChromosomeLabels2);
  function HorizontalChromosomeLabels2(context, options2) {
    var _this;
    _classCallCheck$Y(this, HorizontalChromosomeLabels2);
    _this = _super.call(this, context, options2);
    const {
      dataConfig,
      animate,
      chromInfoPath,
      isShowGlobalMousePosition
    } = context;
    _this.searchField = null;
    _this.chromInfo = null;
    _this.dataConfig = dataConfig;
    _this.pTicks = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.pTicks);
    _this.gTicks = {};
    _this.tickTexts = {};
    _this.options = options2;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.textFontSize = 12;
    _this.textFontFamily = "Arial";
    _this.textFontColor = "#808080";
    _this.textStrokeColor = _this.getTheme() === THEME_DARK ? "#000000" : "#ffffff";
    _this.pixiTextConfig = {
      fontSize: +_this.options.fontSize ? `${+_this.options.fontSize}px` : `${_this.textFontSize}px`,
      fontFamily: _this.textFontFamily,
      fill: _this.options.color || _this.textFontColor,
      lineJoin: "round",
      stroke: _this.options.stroke || _this.textStrokeColor,
      strokeThickness: 2
    };
    _this.stroke = colorToHex(_this.pixiTextConfig.stroke);
    _this.tickWidth = TICK_WIDTH;
    _this.tickHeight = TICK_HEIGHT;
    _this.tickTextSeparation = TICK_TEXT_SEPARATION;
    _this.tickColor = _this.options.tickColor ? colorToHex(_this.options.tickColor) : TICK_COLOR;
    _this.animate = animate;
    _this.pubSubs = [];
    if (_this.options.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_assertThisInitialized$K(_this), _this.is2d, _this.isShowGlobalMousePosition());
    }
    let chromSizesPath = chromInfoPath;
    if (!chromSizesPath) {
      chromSizesPath = `${dataConfig.server}/chrom-sizes/?id=${dataConfig.tilesetUid}`;
    }
    ChromosomeInfo(chromSizesPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.searchField = new SearchField(_this.chromInfo);
      try {
        _this.rerender(_this.options, true);
        _this.draw();
      } catch (err2) {
      } finally {
        _this.animate();
      }
    }, _this.pubSub);
    return _this;
  }
  _createClass$W(HorizontalChromosomeLabels2, [{
    key: "initBoundsTicks",
    value: function initBoundsTicks() {
      if (this.pTicks) {
        this.pMain.removeChild(this.pTicks);
        this.pTicks = null;
      }
      if (!this.gBoundTicks) {
        this.gBoundTicks = new GLOBALS.PIXI.Graphics();
        this.leftBoundTick = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        this.rightBoundTick = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        this.gBoundTicks.addChild(this.leftBoundTick);
        this.gBoundTicks.addChild(this.rightBoundTick);
        this.pMain.addChild(this.gBoundTicks);
      }
      this.texts = [];
    }
  }, {
    key: "initChromLabels",
    value: function initChromLabels() {
      if (!this.chromInfo)
        return;
      if (this.gBoundTicks) {
        this.pMain.removeChild(this.gBoundTicks);
        this.gBoundTicks = null;
      }
      if (!this.pTicks) {
        this.pTicks = new GLOBALS.PIXI.Graphics();
        this.pMain.addChild(this.pTicks);
      }
      this.texts = [];
      this.pTicks.removeChildren();
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chromName = this.chromInfo.cumPositions[i].chr;
        this.gTicks[chromName] = new GLOBALS.PIXI.Graphics();
        if (!this.tickTexts[chromName])
          this.tickTexts[chromName] = [];
        const text2 = new GLOBALS.PIXI.Text(chromName, this.pixiTextConfig);
        text2.hashValue = Math.random();
        this.pTicks.addChild(text2);
        this.pTicks.addChild(this.gTicks[chromName]);
        this.texts.push(text2);
      }
    }
  }, {
    key: "remove",
    value: function remove3() {
      if (this.visibleTileIds) {
        this.removeTiles([...this.visibleTileIds]);
      }
      if (this.texts) {
        for (let idx = 0; idx < this.texts.length; idx++) {
          this.texts[idx].destroy();
        }
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions)
        return;
      this.prevOptions = strOptions;
      this.options = options2;
      this.tickTexts = {};
      this.pixiTextConfig.fontSize = +this.options.fontSize ? `${+this.options.fontSize}px` : this.pixiTextConfig.fontSize;
      this.pixiTextConfig.fill = this.options.color || this.pixiTextConfig.fill;
      this.pixiTextConfig.stroke = this.options.stroke || this.pixiTextConfig.stroke;
      this.stroke = colorToHex(this.pixiTextConfig.stroke);
      this.tickColor = this.options.tickColor ? colorToHex(this.options.tickColor) : TICK_COLOR;
      if (this.options.tickPositions === "ends") {
        this.initBoundsTicks();
      } else {
        this.initChromLabels();
      }
      _get$d(_getPrototypeOf$K(HorizontalChromosomeLabels2.prototype), "rerender", this).call(this, options2, force);
      if (this.options.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
      if (!this.options.showMousePosition && this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
    }
  }, {
    key: "formatTick",
    value: function formatTick(pos) {
      const domain2 = this._xScale.domain();
      const viewWidth = domain2[1] - domain2[0];
      const p = precisionPrefix(pos, viewWidth);
      const fPlain = format$1(",");
      const fPrecision = formatPrefix(`,.${p}`, viewWidth);
      let f2 = fPlain;
      if (this.options.tickFormat === "si") {
        f2 = fPrecision;
      } else if (this.options.tickFormat === "plain") {
        f2 = fPlain;
      } else if (this.options.tickPositions === "ends") {
        f2 = fPrecision;
      }
      return f2(pos);
    }
  }, {
    key: "drawBoundsTicks",
    value: function drawBoundsTicks(x12, x2) {
      const graphics = this.gBoundTicks;
      graphics.clear();
      graphics.lineStyle(1, 0);
      const lineYStart = this.options.reverseOrientation ? 0 : this.dimensions[1];
      const lineYEnd = this.options.reverseOrientation ? this.tickHeight : this.dimensions[1] - this.tickHeight;
      graphics.moveTo(1, lineYStart);
      graphics.lineTo(1, lineYEnd);
      graphics.moveTo(this.dimensions[0] - 1, lineYStart);
      graphics.lineTo(this.dimensions[0] - 1, lineYEnd);
      this.leftBoundTick.x = 0;
      this.leftBoundTick.y = this.options.reverseOrientation ? lineYEnd + this.tickTextSeparation : lineYEnd - this.tickTextSeparation;
      this.leftBoundTick.text = `${x12[0]}: ${this.formatTick(x12[1])}`;
      this.leftBoundTick.anchor.y = this.options.reverseOrientation ? 0 : 1;
      this.rightBoundTick.x = this.dimensions[0];
      this.rightBoundTick.text = `${x2[0]}: ${this.formatTick(x2[1])}`;
      this.rightBoundTick.y = this.options.reverseOrientation ? lineYEnd + this.tickTextSeparation : lineYEnd - this.tickTextSeparation;
      this.rightBoundTick.anchor.y = this.options.reverseOrientation ? 0 : 1;
      this.rightBoundTick.anchor.x = 1;
      if (this.flipText) {
        this.leftBoundTick.scale.x = -1;
        this.leftBoundTick.anchor.x = 1;
        this.rightBoundTick.scale.x = -1;
        this.rightBoundTick.anchor.x = 0;
      }
      this.leftBoundTick.tickLine = [1, this.dimensions[1], 1, this.dimensions[1] - this.tickHeight];
      this.rightBoundTick.tickLine = [this.dimensions[0] - 1, this.dimensions[1], this.dimensions[0] - 1, this.dimensions[1] - this.tickHeight];
      this.tickTexts = {};
      this.tickTexts.all = [this.leftBoundTick, this.rightBoundTick];
    }
  }, {
    key: "drawTicks",
    value: function drawTicks(cumPos) {
      const graphics = this.gTicks[cumPos.chr];
      graphics.visible = true;
      graphics.clear();
      const chromLen = +this.chromInfo.chromLengths[cumPos.chr];
      const vpLeft = Math.max(this._xScale(cumPos.pos), 0);
      const vpRight = Math.min(this._xScale(cumPos.pos + chromLen), this.dimensions[0]);
      const numTicks = (vpRight - vpLeft) / this.tickWidth;
      const xScale = linear().domain([Math.max(1, this._xScale.invert(0) - cumPos.pos), Math.min(chromLen, this._xScale.invert(this.dimensions[0]) - cumPos.pos)]).range(vpLeft, vpRight);
      const ticks2 = xScale.ticks(numTicks).filter((tick) => Number.isInteger(tick));
      const tickTexts = this.tickTexts[cumPos.chr];
      const tickHeight = this.options.fontIsLeftAligned ? (+this.options.fontSize || this.textFontSize) / 2 : this.tickHeight;
      const flipTextSign = this.flipText ? -1 : 1;
      const xPadding = this.options.fontIsLeftAligned ? flipTextSign * 4 : 0;
      let yPadding = this.options.fontIsLeftAligned ? 0 : tickHeight + this.tickTextSeparation;
      if (this.options.reverseOrientation) {
        yPadding = this.dimensions[1] - yPadding;
      }
      while (tickTexts.length < ticks2.length) {
        const newText = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        tickTexts.push(newText);
        this.gTicks[cumPos.chr].addChild(newText);
      }
      while (tickTexts.length > ticks2.length) {
        const text2 = tickTexts.pop();
        this.gTicks[cumPos.chr].removeChild(text2);
        text2.destroy();
      }
      let i = 0;
      while (i < ticks2.length) {
        tickTexts[i].visible = true;
        tickTexts[i].anchor.x = this.options.fontIsLeftAligned ? 0 : 0.5;
        tickTexts[i].anchor.y = this.options.reverseOrientation ? 0 : 1;
        if (this.flipText)
          tickTexts[i].scale.x = -1;
        tickTexts[i].x = this._xScale(cumPos.pos + ticks2[i]) + xPadding;
        tickTexts[i].y = this.dimensions[1] - yPadding;
        tickTexts[i].text = ticks2[i] === 0 ? `${cumPos.chr}: 1` : `${cumPos.chr}: ${this.formatTick(ticks2[i])}`;
        const x = this._xScale(cumPos.pos + ticks2[i]);
        tickTexts[i].tickLine = [x - 1, this.dimensions[1], x - 1, this.dimensions[1] - tickHeight - 1];
        const lineYStart = this.options.reverseOrientation ? 0 : this.dimensions[1];
        const lineYEnd = this.options.reverseOrientation ? tickHeight : this.dimensions[1] - tickHeight;
        graphics.lineStyle(1, this.stroke);
        graphics.moveTo(x - 1, lineYStart);
        graphics.lineTo(x - 1, lineYEnd - 1);
        if (this.options.fontIsLeftAligned) {
          graphics.lineTo(x + 2 * flipTextSign + 1 * flipTextSign, lineYEnd - 1);
          graphics.lineTo(x + 2 * flipTextSign + 1 * flipTextSign, lineYEnd + 1);
          graphics.lineTo(x + 1, lineYEnd + 1);
        } else {
          graphics.lineTo(x + 1, lineYEnd - 1);
        }
        graphics.lineTo(x + 1, lineYStart);
        graphics.lineStyle(1, this.tickColor);
        graphics.moveTo(x, lineYStart);
        graphics.lineTo(x, lineYEnd);
        if (this.options.fontIsLeftAligned) {
          graphics.lineTo(x + 2 * flipTextSign, lineYEnd);
        }
        i += 1;
      }
      while (i < tickTexts.length) {
        tickTexts[i].visible = false;
        i += 1;
      }
      return ticks2.length;
    }
  }, {
    key: "draw",
    value: function draw() {
      this.allTexts = [];
      if (!this.texts || !this.searchField)
        return;
      const x12 = absToChr(this._xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(this._xScale.domain()[1], this.chromInfo);
      if (!x12 || !x2) {
        console.warn("Empty chromInfo:", this.dataConfig, this.chromInfo);
        return;
      }
      if (this.options.tickPositions === "ends") {
        if (!this.gBoundTicks)
          return;
        this.gBoundTicks.visible = true;
        this.drawBoundsTicks(x12, x2);
        return;
      }
      if (!this.pTicks) {
        return;
      }
      for (let i = 0; i < this.texts.length; i++) {
        this.texts[i].visible = false;
        this.gTicks[this.chromInfo.cumPositions[i].chr].visible = false;
      }
      let yPadding = this.options.fontIsLeftAligned ? 0 : this.tickHeight + this.tickTextSeparation;
      if (this.options.reverseOrientation) {
        yPadding = this.dimensions[1] - yPadding;
      }
      Object.keys(this.chromInfo.chrPositions).forEach((chrom) => {
        if (this.tickTexts[chrom]) {
          for (let j = 0; j < this.tickTexts[chrom].length; j++) {
            this.tickTexts[chrom][j].visible = false;
          }
        }
      });
      for (let i = x12[3]; i <= x2[3]; i++) {
        const xCumPos = this.chromInfo.cumPositions[i];
        const midX = xCumPos.pos + this.chromInfo.chromLengths[xCumPos.chr] / 2;
        const viewportMidX = this._xScale(midX);
        const text2 = this.texts[i];
        text2.anchor.x = this.options.fontIsLeftAligned ? 0 : 0.5;
        text2.anchor.y = this.options.reverseOrientation ? 0 : 1;
        text2.x = viewportMidX;
        text2.y = this.dimensions[1] - yPadding;
        text2.updateTransform();
        if (this.flipText)
          text2.scale.x = -1;
        const numTicksDrawn = this.drawTicks(xCumPos);
        text2.visible = numTicksDrawn <= 0;
        this.allTexts.push({
          importance: text2.hashValue,
          text: text2,
          caption: null
        });
      }
      this.hideOverlaps(this.allTexts);
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allTexts) {
      let allBoxes = [];
      allBoxes = allTexts.map(({
        text: text2
      }, i) => {
        text2.updateTransform();
        const b = text2.getBounds();
        const box = [b.x, b.y, b.x + b.width, b.y + b.height];
        return box;
      });
      boxIntersect$1(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = false;
        } else {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$d(_getPrototypeOf$K(HorizontalChromosomeLabels2.prototype), "setPosition", this).call(this, newPosition);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$d(_getPrototypeOf$K(HorizontalChromosomeLabels2.prototype), "exportSVG", this)) {
        [base, track] = _get$d(_getPrototypeOf$K(HorizontalChromosomeLabels2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "chromosome-labels");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      this.allTexts.filter((text2) => text2.text.visible).forEach((text2) => {
        const g = pixiTextToSvg(text2.text);
        output.appendChild(g);
      });
      Object.values(this.tickTexts).forEach((texts) => {
        texts.filter((x) => x.visible).forEach((text2) => {
          let g = pixiTextToSvg(text2);
          output.appendChild(g);
          g = svgLine(text2.x, this.options.reverseOrientation ? 0 : this.dimensions[1], text2.x, this.options.reverseOrientation ? this.tickHeight : this.dimensions[1] - this.tickHeight, 1, this.tickColor);
          const line = document.createElement("line");
          line.setAttribute("x1", text2.tickLine[0]);
          line.setAttribute("y1", text2.tickLine[1]);
          line.setAttribute("x2", text2.tickLine[2]);
          line.setAttribute("y2", text2.tickLine[3]);
          line.setAttribute("style", "stroke: grey");
          output.appendChild(g);
          output.appendChild(line);
        });
      });
      return [base, track];
    }
  }]);
  return HorizontalChromosomeLabels2;
}(PixiTrack);
function _classCallCheck$X(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$M(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$M(descriptor.key), descriptor);
  }
}
function _createClass$V(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$M(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$M(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$M(arg) {
  var key = _toPrimitive$M(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$M(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$c() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$c = Reflect.get.bind();
  } else {
    _get$c = function _get2(target, property2, receiver) {
      var base = _superPropBase$c(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$c.apply(this, arguments);
}
function _superPropBase$c(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$J(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$U(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$J(subClass, superClass);
}
function _setPrototypeOf$J(o, p) {
  _setPrototypeOf$J = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$J(o, p);
}
function _createSuper$J(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$J();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$J(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$J(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$U(this, result);
  };
}
function _possibleConstructorReturn$U(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$J(self2);
}
function _assertThisInitialized$J(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$J() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$J(o) {
  _getPrototypeOf$J = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$J(o);
}
let HorizontalHeatmapTrack = /* @__PURE__ */ function(_HeatmapTiledPixiTrac) {
  _inherits$U(HorizontalHeatmapTrack2, _HeatmapTiledPixiTrac);
  var _super = _createSuper$J(HorizontalHeatmapTrack2);
  function HorizontalHeatmapTrack2(context, options2) {
    var _this;
    _classCallCheck$X(this, HorizontalHeatmapTrack2);
    _this = _super.call(this, context, options2);
    const {
      animate
    } = context;
    _this.pMain = _this.pMobile;
    _this.colorScale = HEATED_OBJECT_MAP;
    _this.continuousScaling = false;
    if (options2 && options2.colorRange) {
      _this.colorScale = colorDomainToRgbaArray(options2.colorRange);
    }
    _this.animate = animate;
    _this.options = options2;
    _this.pubSubs = [];
    return _this;
  }
  _createClass$V(HorizontalHeatmapTrack2, [{
    key: "rerender",
    value: function rerender(options2, force) {
      _get$c(_getPrototypeOf$J(HorizontalHeatmapTrack2.prototype), "rerender", this).call(this, options2, force);
      this.zoomed(this.xScale(), this.yScale(), this.pMain.scale.x, this.pMain.position.x, this.pMain.position.y);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      let zoomLevel = null;
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        const zoomIndexY = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
        zoomLevel = Math.min(zoomIndexX, zoomIndexY);
      } else {
        const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
        zoomLevel = Math.max(xZoomLevel, yZoomLevel);
        zoomLevel = Math.min(zoomLevel, this.maxZoom);
      }
      if (this.options && this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      const expandedXScale = this._xScale.copy();
      expandedXScale.domain([this._xScale.invert(this._xScale.range()[0] - this.dimensions[1] * Math.sqrt(2)), this._xScale.invert(this._xScale.range()[1] + this.dimensions[1] * Math.sqrt(2))]);
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        this.yTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      } else {
        this.xTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
        this.yTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      }
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const maxWidth = this.tilesetInfo.max_width;
      const tileWidth = maxWidth / 2 ** zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = i; j < cols.length; j++) {
          const tileBottomPosition = (j - i - 2) * (this._xScale(tileWidth) - this._xScale(0)) * Math.sqrt(2) / 2;
          if (tileBottomPosition > this.dimensions[1]) {
            continue;
          }
          const newTile = [zoomLevel, rows[i], cols[j]];
          newTile.mirrored = false;
          newTile.dataTransform = this.options.dataTransform ? this.options.dataTransform : "default";
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      canvas.width = 256;
      canvas.height = 256;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const pix = new ImageData(pixData, canvas.width, canvas.height);
      ctx.putImageData(pix, 0, 0);
      return canvas;
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos, mirrored) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      const tileEndX = tileX + tileWidth;
      const tileEndY = tileY + tileHeight;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this._refYScale(tileEndY) - this._refYScale(tileY);
      sprite.x = this._refXScale(tileX);
      sprite.y = this._refYScale(tileY);
    }
  }, {
    key: "pixDataFunction",
    value: function pixDataFunction(tile, pixData) {
      if (pixData) {
        const graphics = tile.graphics;
        const canvas = this.tileDataToCanvas(pixData.pixData);
        const texture = GLOBALS.PIXI.VERSION[0] === "4" ? GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST) : GLOBALS.PIXI.Texture.from(canvas, {
          scaleMode: GLOBALS.PIXI.SCALE_MODES.NEAREST
        });
        tile.sprite = new GLOBALS.PIXI.Sprite(texture);
        tile.canvas = canvas;
        this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
        graphics.pivot.x = this._refXScale(0);
        graphics.pivot.y = this._refYScale(0);
        graphics.scale.x = -1 / Math.sqrt(2);
        graphics.rotation = -3 * Math.PI / 4;
        graphics.scale.y = 1 / Math.sqrt(2);
        graphics.position.x = this._refXScale(0);
        graphics.position.y = 0;
        graphics.removeChildren();
        graphics.addChild(tile.sprite);
      }
      this.renderingTiles.delete(tile.tileId);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _get$c(_getPrototypeOf$J(HorizontalHeatmapTrack2.prototype), "refScalesChanged", this).call(this, refXScale, refYScale);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
          const graphics = tile.graphics;
          graphics.pivot.x = this._refXScale(0);
          graphics.pivot.y = this._refYScale(0);
          graphics.scale.x = -1 / Math.sqrt(2);
          graphics.rotation = -3 * Math.PI / 4;
          graphics.scale.y = 1 / Math.sqrt(2);
          graphics.position.x = this._refXScale(0);
          graphics.position.y = 0;
        }
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _get$c(_getPrototypeOf$J(HorizontalHeatmapTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale, k, tx, ty);
      _get$c(_getPrototypeOf$J(HorizontalHeatmapTrack2.prototype), "draw", this).call(this);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1] + this.dimensions[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      if (this.options.oneDHeatmapFlipped) {
        this.pMain.scale.y = -k;
        this.pMain.position.y = this.position[1];
      }
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _get$c(_getPrototypeOf$J(HorizontalHeatmapTrack2.prototype), "superSVG", this).call(this);
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.pMain.position.x},${this.pMain.position.y}) scale(${this.pMain.scale.x},${this.pMain.scale.y})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        const gGraphics = document.createElement("g");
        const graphics = tile.graphics;
        const graphicsRotation = graphics.rotation * 180 / Math.PI;
        const transformText = `translate(${graphics.position.x},${graphics.position.y}) rotate(${graphicsRotation}) scale(${graphics.scale.x},${graphics.scale.y}) translate(${-graphics.pivot.x},${-graphics.pivot.y})`;
        gGraphics.setAttribute("transform", transformText);
        const rotation2 = tile.sprite.rotation * 180 / Math.PI;
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${tile.sprite.x},${tile.sprite.y}) rotate(${rotation2}) scale(${tile.sprite.scale.x},${tile.sprite.scale.y})`);
        const image = document.createElement("image");
        image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", tile.canvas.toDataURL());
        image.setAttribute("width", 256);
        image.setAttribute("height", 256);
        g.appendChild(image);
        gGraphics.appendChild(g);
        output.appendChild(gGraphics);
      }
      const gColorbar = this.exportColorBarSVG();
      track.appendChild(gColorbar);
      return [base, base];
    }
  }]);
  return HorizontalHeatmapTrack2;
}(HeatmapTiledPixiTrack);
function _classCallCheck$W(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$L(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$L(descriptor.key), descriptor);
  }
}
function _createClass$U(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$L(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$L(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$L(arg) {
  var key = _toPrimitive$L(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$L(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$T(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$I(subClass, superClass);
}
function _setPrototypeOf$I(o, p) {
  _setPrototypeOf$I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$I(o, p);
}
function _createSuper$I(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$I();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$I(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$I(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$T(this, result);
  };
}
function _possibleConstructorReturn$T(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$I(self2);
}
function _assertThisInitialized$I(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$I() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$I(o) {
  _getPrototypeOf$I = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$I(o);
}
let UnknownPixiTrack = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$T(UnknownPixiTrack2, _PixiTrack);
  var _super = _createSuper$I(UnknownPixiTrack2);
  function UnknownPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$W(this, UnknownPixiTrack2);
    _this = _super.call(this, context, options2);
    _this.tilesetInfo = {};
    _this.errorTextText = `Unknown track type: ${options2.type}`;
    return _this;
  }
  _createClass$U(UnknownPixiTrack2, [{
    key: "zoomed",
    value: function zoomed() {
      this.draw();
    }
  }]);
  return UnknownPixiTrack2;
}(PixiTrack);
function _classCallCheck$V(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$K(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$K(descriptor.key), descriptor);
  }
}
function _createClass$T(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$K(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$K(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$K(arg) {
  var key = _toPrimitive$K(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$K(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$S(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$H(subClass, superClass);
}
function _setPrototypeOf$H(o, p) {
  _setPrototypeOf$H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$H(o, p);
}
function _createSuper$H(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$H();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$H(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$H(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$S(this, result);
  };
}
function _possibleConstructorReturn$S(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$H(self2);
}
function _assertThisInitialized$H(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$H() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$H(o) {
  _getPrototypeOf$H = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$H(o);
}
let ValueIntervalTrack = /* @__PURE__ */ function(_HorizontalLine1DPixi) {
  _inherits$S(ValueIntervalTrack2, _HorizontalLine1DPixi);
  var _super = _createSuper$H(ValueIntervalTrack2);
  function ValueIntervalTrack2(context, options2) {
    var _this;
    _classCallCheck$V(this, ValueIntervalTrack2);
    _this = _super.call(this, context, options2);
    _this.axis = new AxisPixi(_assertThisInitialized$H(_this));
    _this.pBase.addChild(_this.axis.pAxis);
    return _this;
  }
  _createClass$T(ValueIntervalTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      this.scale.minRawValue = this.minVisibleValueInTiles();
      this.scale.maxRawValue = this.minVisibleValueInTiles();
      this.scale.minValue = this.scale.minRawValue;
      this.scale.maxValue = this.scale.maxRawValue;
      this.drawTile(tile);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const RECT_HEIGHT = 6;
      const MIN_RECT_WIDTH = 4;
      graphics.clear();
      this.valueScale = log$4().domain([this.minValue() + 0.01, this.maxValue()]).range([this.dimensions[1] - RECT_HEIGHT / 2, RECT_HEIGHT / 2]);
      const fill = colorToHex("black");
      graphics.lineStyle(1, fill, 0.3);
      graphics.beginFill(fill, 0.3);
      this.drawAxis(this.valueScale);
      tile.tileData.forEach((td) => {
        const fields = td.fields;
        const chrOffset = +td.chrOffset;
        const genomeStart = +fields[1] + chrOffset;
        const genomeEnd = +fields[2] + chrOffset;
        const value2 = +fields[3];
        const startPos = this._xScale(genomeStart);
        const endPos = this._xScale(genomeEnd);
        const width = Math.max(endPos - startPos, MIN_RECT_WIDTH);
        const midY = this.valueScale(value2);
        const midX = (endPos + startPos) / 2;
        graphics.drawRect(midX - width / 2, midY - RECT_HEIGHT / 2, width, RECT_HEIGHT);
      });
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles() {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const min2 = Math.min.apply(null, visibleAndFetchedIds.map((x) => +Math.min(...this.fetchedTiles[x].tileData.filter((y) => !Number.isNaN(y.fields[3])).map((y) => +y.fields[3]))));
      return min2;
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles() {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const max2 = Math.max.apply(null, visibleAndFetchedIds.map((x) => +Math.max(...this.fetchedTiles[x].tileData.filter((y) => !Number.isNaN(y.fields[3])).map((y) => +y.fields[3]))));
      return max2;
    }
  }]);
  return ValueIntervalTrack2;
}(HorizontalLine1DPixiTrack);
function _classCallCheck$U(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$J(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$J(descriptor.key), descriptor);
  }
}
function _createClass$S(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$J(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$J(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$J(arg) {
  var key = _toPrimitive$J(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$J(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$b() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$b = Reflect.get.bind();
  } else {
    _get$b = function _get2(target, property2, receiver) {
      var base = _superPropBase$b(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$b.apply(this, arguments);
}
function _superPropBase$b(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$G(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$R(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$G(subClass, superClass);
}
function _setPrototypeOf$G(o, p) {
  _setPrototypeOf$G = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$G(o, p);
}
function _createSuper$G(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$G();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$G(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$G(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$R(this, result);
  };
}
function _possibleConstructorReturn$R(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$G(self2);
}
function _assertThisInitialized$G(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$G() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$G(o) {
  _getPrototypeOf$G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$G(o);
}
let ViewportTracker2D$1 = /* @__PURE__ */ function(_SVGTrack) {
  _inherits$R(ViewportTracker2D2, _SVGTrack);
  var _super = _createSuper$G(ViewportTracker2D2);
  function ViewportTracker2D2(context, options2) {
    var _this;
    _classCallCheck$U(this, ViewportTracker2D2);
    _this = _super.call(this, context, options2);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid$1.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionXDomain || !context.projectionYDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : context.projectionXDomain;
    _this.viewportYDomain = _this.hasFromView ? null : context.projectionYDomain;
    _this.brush = brush().on("brush", _this.brushed.bind(_assertThisInitialized$G(_this)));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--n").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--s").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--w").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--e").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_assertThisInitialized$G(_this)));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _createClass$S(ViewportTracker2D2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = [this._xScale.invert(s[0][0]), this._xScale.invert(s[1][0])];
      const yDomain = [this._yScale.invert(s[0][1]), this._yScale.invert(s[1][1])];
      if (!this.hasFromView) {
        this.viewportXDomain = xDomain;
        this.viewportYDomain = yDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.removeViewportChanged(this.uid);
      _get$b(_getPrototypeOf$G(ViewportTracker2D2.prototype), "remove", this).call(this);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const x02 = this._xScale(this.viewportXDomain[0]);
      const y02 = this._yScale(this.viewportYDomain[0]);
      const x12 = this._xScale(this.viewportXDomain[1]);
      const y12 = this._yScale(this.viewportYDomain[1]);
      const dest = [[x02, y02], [x12, y12]];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$b(_getPrototypeOf$G(ViewportTracker2D2.prototype), "setPosition", this).call(this, newPosition);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$b(_getPrototypeOf$G(ViewportTracker2D2.prototype), "setDimensions", this).call(this, newDimensions);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const xDiff = xRange[1] - xRange[0];
      const yDiff = yRange[1] - yRange[0];
      this.brush.extent([[xRange[0] - xDiff, yRange[0] - yDiff], [xRange[1] + xDiff, yRange[1] + yDiff]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
  return ViewportTracker2D2;
}(SVGTrack);
function _classCallCheck$T(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$I(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$I(descriptor.key), descriptor);
  }
}
function _createClass$R(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$I(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$I(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$I(arg) {
  var key = _toPrimitive$I(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$I(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$a() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$a = Reflect.get.bind();
  } else {
    _get$a = function _get2(target, property2, receiver) {
      var base = _superPropBase$a(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$a.apply(this, arguments);
}
function _superPropBase$a(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$F(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$Q(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$F(subClass, superClass);
}
function _setPrototypeOf$F(o, p) {
  _setPrototypeOf$F = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$F(o, p);
}
function _createSuper$F(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$F();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$F(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$F(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$Q(this, result);
  };
}
function _possibleConstructorReturn$Q(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$F(self2);
}
function _assertThisInitialized$F(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$F() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$F(o) {
  _getPrototypeOf$F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$F(o);
}
let ViewportTrackerHorizontal = /* @__PURE__ */ function(_SVGTrack) {
  _inherits$Q(ViewportTrackerHorizontal2, _SVGTrack);
  var _super = _createSuper$F(ViewportTrackerHorizontal2);
  function ViewportTrackerHorizontal2(context, options2) {
    var _this;
    _classCallCheck$T(this, ViewportTrackerHorizontal2);
    _this = _super.call(this, context, options2);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid$1.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionXDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : context.projectionXDomain;
    _this.viewportYDomain = _this.hasFromView ? null : [0, 0];
    _this.brush = brushX().on("brush", _this.brushed.bind(_assertThisInitialized$F(_this)));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--ne").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--nw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--sw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--se").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--n").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--s").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_assertThisInitialized$F(_this)));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _createClass$R(ViewportTrackerHorizontal2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = [this._xScale.invert(s[0]), this._xScale.invert(s[1])];
      const yDomain = this.viewportYDomain;
      if (!this.hasFromView) {
        this.viewportXDomain = xDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale, update2 = true) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.removeViewportChanged(this.uid);
      _get$a(_getPrototypeOf$F(ViewportTrackerHorizontal2.prototype), "remove", this).call(this);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const x02 = this._xScale(this.viewportXDomain[0]);
      const x12 = this._xScale(this.viewportXDomain[1]);
      const dest = [x02, x12];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$a(_getPrototypeOf$F(ViewportTrackerHorizontal2.prototype), "setPosition", this).call(this, newPosition);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$a(_getPrototypeOf$F(ViewportTrackerHorizontal2.prototype), "setDimensions", this).call(this, newDimensions);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const xDiff = xRange[1] - xRange[0];
      this.brush.extent([[xRange[0] - xDiff, yRange[0]], [xRange[1] + xDiff, yRange[1]]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
  return ViewportTrackerHorizontal2;
}(SVGTrack);
function _classCallCheck$S(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$H(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$H(descriptor.key), descriptor);
  }
}
function _createClass$Q(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$H(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$H(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$H(arg) {
  var key = _toPrimitive$H(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$H(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$9() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$9 = Reflect.get.bind();
  } else {
    _get$9 = function _get2(target, property2, receiver) {
      var base = _superPropBase$9(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$9.apply(this, arguments);
}
function _superPropBase$9(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$E(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$P(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$E(subClass, superClass);
}
function _setPrototypeOf$E(o, p) {
  _setPrototypeOf$E = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$E(o, p);
}
function _createSuper$E(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$E();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$E(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$E(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$P(this, result);
  };
}
function _possibleConstructorReturn$P(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$E(self2);
}
function _assertThisInitialized$E(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$E() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$E(o) {
  _getPrototypeOf$E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$E(o);
}
let ViewportTrackerVertical = /* @__PURE__ */ function(_SVGTrack) {
  _inherits$P(ViewportTrackerVertical2, _SVGTrack);
  var _super = _createSuper$E(ViewportTrackerVertical2);
  function ViewportTrackerVertical2(context, options2) {
    var _this;
    _classCallCheck$S(this, ViewportTrackerVertical2);
    _this = _super.call(this, context, options2);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid$1.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionYDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : [0, 0];
    _this.viewportYDomain = _this.hasFromView ? null : context.projectionYDomain;
    _this.brush = brushY().on("brush", _this.brushed.bind(_assertThisInitialized$E(_this)));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--ne").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--nw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--sw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--se").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--e").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--w").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_assertThisInitialized$E(_this)));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _createClass$Q(ViewportTrackerVertical2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = this.viewportXDomain;
      const yDomain = [this._yScale.invert(s[0]), this._yScale.invert(s[1])];
      if (!this.hasFromView) {
        this.viewportYDomain = yDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale, update2 = true) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove3() {
      this.removeViewportChanged(this.uid);
      _get$9(_getPrototypeOf$E(ViewportTrackerVertical2.prototype), "remove", this).call(this);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const y02 = this._yScale(this.viewportYDomain[0]);
      const y12 = this._yScale(this.viewportYDomain[1]);
      const dest = [y02, y12];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$9(_getPrototypeOf$E(ViewportTrackerVertical2.prototype), "setPosition", this).call(this, newPosition);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$9(_getPrototypeOf$E(ViewportTrackerVertical2.prototype), "setDimensions", this).call(this, newDimensions);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const yDiff = yRange[1] - yRange[0];
      this.brush.extent([[xRange[0], yRange[0] - yDiff], [xRange[1], yRange[1] + yDiff]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
  return ViewportTrackerVertical2;
}(SVGTrack);
function _classCallCheck$R(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$G(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$G(descriptor.key), descriptor);
  }
}
function _createClass$P(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$G(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$G(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$G(arg) {
  var key = _toPrimitive$G(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$G(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
const _appliedMixin = "__mixwith_appliedMixin";
const _wrappedMixin = "__mixwith_wrappedMixin";
const unwrap = (wrapper2) => wrapper2[_wrappedMixin] || wrapper2;
const apply$1 = (superclass, mixin) => {
  const application = mixin(superclass);
  application.prototype[_appliedMixin] = unwrap(mixin);
  return application;
};
const isApplicationOf = (proto2, mixin) => proto2.hasOwnProperty(_appliedMixin) && proto2[_appliedMixin] === unwrap(mixin);
const hasMixin = (o, mixin) => {
  while (o !== null) {
    if (isApplicationOf(o, mixin))
      return true;
    o = Object.getPrototypeOf(o);
  }
  return false;
};
const wrap = (mixin, wrapper2) => {
  Object.setPrototypeOf(wrapper2, mixin);
  if (!mixin[_wrappedMixin]) {
    mixin[_wrappedMixin] = mixin;
  }
  return wrapper2;
};
const _cachedApplications = "__mixwith_cachedApplications";
const Cached = (mixin) => wrap(mixin, (superclass) => {
  let cachedApplications = superclass[_cachedApplications];
  if (!cachedApplications) {
    superclass[_cachedApplications] = /* @__PURE__ */ new Map();
    cachedApplications = superclass[_cachedApplications];
  }
  let application = cachedApplications.get(mixin);
  if (!application) {
    application = mixin(superclass);
    cachedApplications.set(mixin, application);
  }
  return application;
});
const DeDupe = (mixin) => wrap(mixin, (superclass) => hasMixin(superclass.prototype, mixin) ? superclass : mixin(superclass));
const BareMixin = (mixin) => wrap(mixin, (s) => apply$1(s, mixin));
const Mixin = (mixin) => DeDupe(Cached(BareMixin(mixin)));
let MixinBuilder = /* @__PURE__ */ function() {
  function MixinBuilder2(superclass) {
    _classCallCheck$R(this, MixinBuilder2);
    this.superclass = superclass || /* @__PURE__ */ function() {
      function _class() {
        _classCallCheck$R(this, _class);
      }
      return _createClass$P(_class);
    }();
  }
  _createClass$P(MixinBuilder2, [{
    key: "with",
    value: function _with(...mixins) {
      return mixins.reduce((c2, m) => m(c2), this.superclass);
    }
  }]);
  return MixinBuilder2;
}();
const mix = (superclass) => new MixinBuilder(superclass);
function _classCallCheck$Q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$F(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$F(descriptor.key), descriptor);
  }
}
function _createClass$O(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$F(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$F(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$F(arg) {
  var key = _toPrimitive$F(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$F(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$8() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$8 = Reflect.get.bind();
  } else {
    _get$8 = function _get2(target, property2, receiver) {
      var base = _superPropBase$8(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$8.apply(this, arguments);
}
function _superPropBase$8(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$D(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$O(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$D(subClass, superClass);
}
function _setPrototypeOf$D(o, p) {
  _setPrototypeOf$D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$D(o, p);
}
function _createSuper$D(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$D();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$D(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$D(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$O(this, result);
  };
}
function _possibleConstructorReturn$O(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$D(self2);
}
function _assertThisInitialized$D(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$D() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$D(o) {
  _getPrototypeOf$D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$D(o);
}
const RuleMixin = Mixin((superclass) => /* @__PURE__ */ function(_superclass) {
  _inherits$O(_class, _superclass);
  var _super = _createSuper$D(_class);
  function _class(context, options2) {
    var _this;
    _classCallCheck$Q(this, _class);
    _this = _super.call(this, context, options2);
    const {
      animate
    } = context;
    _this.highlighted = false;
    _this.animate = animate;
    _this.MOUSEOVER_RADIUS = 4;
    _this.pubSub = context.pubSub;
    _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandler.bind(_assertThisInitialized$D(_this))));
    return _this;
  }
  _createClass$O(_class, [{
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$8(_getPrototypeOf$D(_class.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.x = this.position[0];
      this.pMain.position.y = this.position[1];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _get$8(_getPrototypeOf$D(_class.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.draw();
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition() {
      return this.highlighted;
    }
  }]);
  return _class;
}(superclass));
function _get$7() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$7 = Reflect.get.bind();
  } else {
    _get$7 = function _get2(target, property2, receiver) {
      var base = _superPropBase$7(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$7.apply(this, arguments);
}
function _superPropBase$7(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$C(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _classCallCheck$P(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$E(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$E(descriptor.key), descriptor);
  }
}
function _createClass$N(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$E(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$E(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$E(arg) {
  var key = _toPrimitive$E(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$E(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$N(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$C(subClass, superClass);
}
function _setPrototypeOf$C(o, p) {
  _setPrototypeOf$C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$C(o, p);
}
function _createSuper$C(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$C();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$C(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$C(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$N(this, result);
  };
}
function _possibleConstructorReturn$N(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$C(self2);
}
function _assertThisInitialized$C(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$C() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$C(o) {
  _getPrototypeOf$C = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$C(o);
}
const HorizontalRuleMixin = Mixin((superclass) => /* @__PURE__ */ function(_superclass) {
  _inherits$N(_class, _superclass);
  var _super = _createSuper$C(_class);
  function _class() {
    _classCallCheck$P(this, _class);
    return _super.apply(this, arguments);
  }
  _createClass$N(_class, [{
    key: "drawHorizontalRule",
    value: function drawHorizontalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[0]) {
        graphics.moveTo(pos, this._yScale(this.yPosition));
        graphics.lineTo(pos + this.dashLength, this._yScale(this.yPosition));
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverHorizontalLine",
    value: function isMouseOverHorizontalLine(mousePos) {
      if (Math.abs(mousePos.y - this.position[1] - this._yScale(this.yPosition)) < this.MOUSEOVER_RADIUS) {
        return true;
      }
      return false;
    }
  }]);
  return _class;
}(superclass));
let HorizontalRule = /* @__PURE__ */ function(_mix$with) {
  _inherits$N(HorizontalRule2, _mix$with);
  var _super2 = _createSuper$C(HorizontalRule2);
  function HorizontalRule2(context, options2) {
    var _this;
    _classCallCheck$P(this, HorizontalRule2);
    _this = _super2.call(this, context, options2);
    _this.yPosition = context.yPosition;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _createClass$N(HorizontalRule2, [{
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      if (this.isWithin(mousePos.x, mousePos.y) && this.isMouseOverHorizontalLine(mousePos)) {
        this.highlighted = true;
        this.draw();
        return;
      }
      this.highlighted = false;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawHorizontalRule(graphics);
      this.animate();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$7(_getPrototypeOf$C(HorizontalRule2.prototype), "exportSVG", this)) {
        [base, track] = _get$7(_getPrototypeOf$C(HorizontalRule2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "horizontal-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const line = document.createElement("line");
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", this.strokeWidth);
      line.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      line.setAttribute("x1", 0);
      line.setAttribute("y1", this._yScale(this.yPosition));
      line.setAttribute("x2", this.dimensions[0]);
      line.setAttribute("y2", this._yScale(this.yPosition));
      output.appendChild(line);
      return [base, track];
    }
  }]);
  return HorizontalRule2;
}(mix(PixiTrack).with(RuleMixin, HorizontalRuleMixin));
function _get$6() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$6 = Reflect.get.bind();
  } else {
    _get$6 = function _get2(target, property2, receiver) {
      var base = _superPropBase$6(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$6.apply(this, arguments);
}
function _superPropBase$6(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$B(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _classCallCheck$O(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$D(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$D(descriptor.key), descriptor);
  }
}
function _createClass$M(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$D(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$D(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$D(arg) {
  var key = _toPrimitive$D(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$D(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$M(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$B(subClass, superClass);
}
function _setPrototypeOf$B(o, p) {
  _setPrototypeOf$B = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$B(o, p);
}
function _createSuper$B(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$B();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$B(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$B(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$M(this, result);
  };
}
function _possibleConstructorReturn$M(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$B(self2);
}
function _assertThisInitialized$B(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$B() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$B(o) {
  _getPrototypeOf$B = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$B(o);
}
const VerticalRuleMixin = Mixin((superclass) => /* @__PURE__ */ function(_superclass) {
  _inherits$M(_class, _superclass);
  var _super = _createSuper$B(_class);
  function _class() {
    _classCallCheck$O(this, _class);
    return _super.apply(this, arguments);
  }
  _createClass$M(_class, [{
    key: "drawVerticalRule",
    value: function drawVerticalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[1]) {
        graphics.moveTo(this._xScale(this.xPosition), pos);
        graphics.lineTo(this._xScale(this.xPosition), pos + this.dashLength);
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverVerticalLine",
    value: function isMouseOverVerticalLine(mousePos) {
      return Math.abs(mousePos.x - this.position[0] - this._xScale(this.xPosition)) < this.MOUSEOVER_RADIUS;
    }
  }]);
  return _class;
}(superclass));
let VerticalRule = /* @__PURE__ */ function(_mix$with) {
  _inherits$M(VerticalRule2, _mix$with);
  var _super2 = _createSuper$B(VerticalRule2);
  function VerticalRule2(context, options2) {
    var _this;
    _classCallCheck$O(this, VerticalRule2);
    _this = _super2.call(this, context, options2);
    _this.xPosition = context.xPosition;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _createClass$M(VerticalRule2, [{
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawVerticalRule(graphics);
      this.animate();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$6(_getPrototypeOf$B(VerticalRule2.prototype), "exportSVG", this)) {
        [base, track] = _get$6(_getPrototypeOf$B(VerticalRule2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "vertical-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const line = document.createElement("line");
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", this.strokeWidth);
      line.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      line.setAttribute("x1", this._xScale(this.xPosition));
      line.setAttribute("y1", 0);
      line.setAttribute("x2", this._xScale(this.xPosition));
      line.setAttribute("y2", this.dimensions[1]);
      output.appendChild(line);
      return [base, track];
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      this.highlighted = this.isWithin(mousePos.x, mousePos.y) && this.isMouseOverVerticalLine(mousePos);
      this.draw();
    }
  }]);
  return VerticalRule2;
}(mix(PixiTrack).with(RuleMixin, VerticalRuleMixin));
function _classCallCheck$N(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$C(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$C(descriptor.key), descriptor);
  }
}
function _createClass$L(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$C(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$C(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$C(arg) {
  var key = _toPrimitive$C(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$C(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$5() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$5 = Reflect.get.bind();
  } else {
    _get$5 = function _get2(target, property2, receiver) {
      var base = _superPropBase$5(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$5.apply(this, arguments);
}
function _superPropBase$5(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$A(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$L(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$A(subClass, superClass);
}
function _setPrototypeOf$A(o, p) {
  _setPrototypeOf$A = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$A(o, p);
}
function _createSuper$A(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$A();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$A(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$A(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$L(this, result);
  };
}
function _possibleConstructorReturn$L(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$A(self2);
}
function _assertThisInitialized$A(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$A() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$A(o) {
  _getPrototypeOf$A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$A(o);
}
let CrossRule = /* @__PURE__ */ function(_mix$with) {
  _inherits$L(CrossRule2, _mix$with);
  var _super = _createSuper$A(CrossRule2);
  function CrossRule2(context, options2) {
    var _this;
    _classCallCheck$N(this, CrossRule2);
    _this = _super.call(this, context, options2);
    const {
      x,
      y
    } = context;
    _this.xPosition = x;
    _this.yPosition = y;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _createClass$L(CrossRule2, [{
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawHorizontalRule(graphics);
      this.drawVerticalRule(graphics);
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      this.highlighted = this.isWithin(mousePos.x, mousePos.y) && (this.isMouseOverHorizontalLine(mousePos) || this.isMouseOverVerticalLine(mousePos));
      this.draw();
    }
  }, {
    key: "drawHorizontalRule",
    value: function drawHorizontalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[0]) {
        graphics.moveTo(pos, this._yScale(this.yPosition));
        graphics.lineTo(pos + this.dashLength, this._yScale(this.yPosition));
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverHorizontalLine",
    value: function isMouseOverHorizontalLine(mousePos) {
      return Math.abs(mousePos.y - this.position[1] - this._yScale(this.yPosition)) < this.MOUSEOVER_RADIUS;
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_get$5(_getPrototypeOf$A(CrossRule2.prototype), "exportSVG", this)) {
        [base, track] = _get$5(_getPrototypeOf$A(CrossRule2.prototype), "exportSVG", this).call(this);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "cross-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const verticalLine = document.createElement("line");
      verticalLine.setAttribute("stroke", stroke);
      verticalLine.setAttribute("stroke-width", this.strokeWidth);
      verticalLine.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      verticalLine.setAttribute("x1", this._xScale(this.xPosition));
      verticalLine.setAttribute("y1", 0);
      verticalLine.setAttribute("x2", this._xScale(this.xPosition));
      verticalLine.setAttribute("y2", this.dimensions[1]);
      const horizontalLine = document.createElement("line");
      horizontalLine.setAttribute("stroke", stroke);
      horizontalLine.setAttribute("stroke-width", this.strokeWidth);
      horizontalLine.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      horizontalLine.setAttribute("x1", 0);
      horizontalLine.setAttribute("y1", this._yScale(this.yPosition));
      horizontalLine.setAttribute("x2", this.dimensions[0]);
      horizontalLine.setAttribute("y2", this._yScale(this.yPosition));
      output.appendChild(verticalLine);
      output.appendChild(horizontalLine);
      return [base, track];
    }
  }]);
  return CrossRule2;
}(mix(PixiTrack).with(RuleMixin, VerticalRuleMixin));
function _classCallCheck$M(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$B(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$B(descriptor.key), descriptor);
  }
}
function _createClass$K(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$B(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$B(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$B(arg) {
  var key = _toPrimitive$B(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$B(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$4() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$4 = Reflect.get.bind();
  } else {
    _get$4 = function _get2(target, property2, receiver) {
      var base = _superPropBase$4(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$4.apply(this, arguments);
}
function _superPropBase$4(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$z(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$K(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$z(subClass, superClass);
}
function _setPrototypeOf$z(o, p) {
  _setPrototypeOf$z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$z(o, p);
}
function _createSuper$z(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$z();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$z(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$z(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$K(this, result);
  };
}
function _possibleConstructorReturn$K(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$z(self2);
}
function _assertThisInitialized$z(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$z() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$z(o) {
  _getPrototypeOf$z = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$z(o);
}
let OSMTilesTrack = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$K(OSMTilesTrack2, _PixiTrack);
  var _super = _createSuper$z(OSMTilesTrack2);
  function OSMTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$M(this, OSMTilesTrack2);
    _this = _super.call(this, context, options2);
    const {
      animate
    } = context;
    _this.visibleTiles = /* @__PURE__ */ new Set();
    _this.visibleTileIds = /* @__PURE__ */ new Set();
    _this.fetching = /* @__PURE__ */ new Set();
    _this.fetchedTiles = {};
    _this.tileGraphics = {};
    _this.minX = typeof _this.options.minPos !== "undefined" && !Number.isNaN(+_this.options.minPos) ? +_this.options.minPos : -180;
    _this.maxX = +_this.options.maxPos || 180;
    _this.maxX = typeof _this.options.maxPos !== "undefined" && !Number.isNaN(+_this.options.maxPos) ? +_this.options.maxPos : 180;
    _this.minY = _this.options.minY || _this.minX;
    _this.maxY = _this.options.maxY || _this.maxX;
    _this.maxZoom = 19;
    _this.maxWidth = _this.maxX - _this.minX;
    _this.animate = animate;
    _this.uuid = slugid$1.nice();
    _this.refreshTilesDebounced = debounce$1(_this.refreshTiles.bind(_assertThisInitialized$z(_this)), ZOOM_DEBOUNCE);
    return _this;
  }
  _createClass$K(OSMTilesTrack2, [{
    key: "visibleAndFetchedIds",
    value: function visibleAndFetchedIds() {
      return Object.keys(this.fetchedTiles).filter((x) => this.visibleTileIds.has(x));
    }
  }, {
    key: "visibleAndFetchedTiles",
    value: function visibleAndFetchedTiles() {
      return this.visibleAndFetchedIds().map((x) => this.fetchedTiles[x]);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x),
        mirrored: x.mirrored
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "removeAllTiles",
    value: function removeAllTiles() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      this.removeTiles([...fetchedTileIDs]);
    }
  }, {
    key: "refreshTiles",
    value: function refreshTiles() {
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toFetch = [...this.visibleTiles].filter((x) => !this.fetching.has(x.remoteId) && !fetchedTileIDs.has(x.tileId));
      for (let i = 0; i < toFetch.length; i++) {
        this.fetching.add(toFetch[i].remoteId);
      }
      const toRemove = [...fetchedTileIDs].filter((x) => !this.visibleTileIds.has(x));
      this.removeTiles(toRemove);
      this.fetchNewTiles(toFetch);
    }
    /**
     * Remove obsolete tiles
     *
     * @param toRemoveIds: An array of tile ids to remove from the list of fetched tiles.
     */
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      if (!toRemoveIds.length) {
        return;
      }
      if (!this.areAllVisibleTilesLoaded()) {
        return;
      }
      toRemoveIds.forEach((x) => {
        const tileIdStr = x;
        this.destroyTile(this.fetchedTiles[tileIdStr]);
        if (tileIdStr in this.tileGraphics) {
          this.pMain.removeChild(this.tileGraphics[tileIdStr]);
          delete this.tileGraphics[tileIdStr];
        }
        delete this.fetchedTiles[tileIdStr];
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
    }
    /*
     * The local tile identifier.
     * @param  {array}  tile  Contains `[zoomLevel, xPos, yPos]`.
     * @return  {string}  Remote ID string
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return tile.join(".");
    }
    /**
     * The tile identifier used on the server.
     * @param   {array}  tile  Contains `[zoomLevel, xPos, yPos]`.
     * @return  {string}  Remote ID string
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return tile.join(".");
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.minX, this.maxX);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.minY, this.maxY);
      let zoomLevel = Math.min(Math.max(xZoomLevel, yZoomLevel), this.maxZoom);
      if (this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.minX, this.maxX, this.maxZoom, this.maxWidth);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.minY, this.maxY, this.maxZoom, this.maxWidth);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _get$4(_getPrototypeOf$z(OSMTilesTrack2.prototype), "zoomed", this).call(this, newXScale, newYScale);
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.pMain.position.x = tx;
      this.pMain.position.y = ty;
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      this.refreshTilesDebounced();
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$4(_getPrototypeOf$z(OSMTilesTrack2.prototype), "setPosition", this).call(this, newPosition);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _get$4(_getPrototypeOf$z(OSMTilesTrack2.prototype), "setDimensions", this).call(this, newDimensions);
    }
    /**
     * Check to see if all the visible tiles are loaded.
     *
     * If they are, remove all other tiles.
     */
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const visibleTileIdsList = [...this.visibleTileIds];
      for (let i = 0; i < visibleTileIdsList.length; i++) {
        if (!fetchedTileIDs.has(visibleTileIdsList[i])) {
          return false;
        }
      }
      return true;
    }
    /**
     * Function is called when all tiles that should be visible have
     * been received.
     */
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
    }
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (_) {
        this.scale.minValue = _;
      }
      return this.scale.minValue;
    }
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (_) {
        this.scale.maxValue = _;
      }
      return this.scale.maxValue;
    }
  }, {
    key: "minRawValue",
    value: function minRawValue() {
      return this.scale.minRawValue;
    }
  }, {
    key: "maxRawValue",
    value: function maxRawValue() {
      return this.scale.maxRawValue;
    }
    /**
     * Get the tile's position in its coordinate system.
     */
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos) {
      const tileWidth = this.maxWidth / 2 ** zoomLevel;
      const tileHeight = tileWidth;
      const tileX = this.minX + tilePos[0] * tileWidth;
      const tileY = this.minY + tilePos[1] * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      sprite.x = this._refXScale(tileX);
      sprite.y = this._refYScale(tileY);
      const tileEndX = tileX + tileWidth;
      const tileEndY = tileY + tileHeight;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this._refYScale(tileEndY) - this._refYScale(tileY);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const texture = new GLOBALS.PIXI.Texture(new GLOBALS.PIXI.BaseTexture(tile.tileData.img));
      const sprite = new GLOBALS.PIXI.Sprite(texture);
      const graphics = tile.graphics;
      tile.sprite = sprite;
      this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos);
      graphics.removeChildren();
      graphics.addChild(tile.sprite);
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
    }
    /**
     * Add graphics for tiles that have no graphics
     */
  }, {
    key: "addMissingGraphics",
    value: function addMissingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        if (!(fetchedTileIDs[i] in this.tileGraphics)) {
          const newGraphics = new GLOBALS.PIXI.Graphics();
          this.pMain.addChild(newGraphics);
          this.fetchedTiles[fetchedTileIDs[i]].graphics = newGraphics;
          this.initTile(this.fetchedTiles[fetchedTileIDs[i]]);
          this.tileGraphics[fetchedTileIDs[i]] = newGraphics;
        }
      }
    }
    /**
     * Change the graphics for existing tiles
     */
  }, {
    key: "updateExistingGraphics",
    value: function updateExistingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        this.updateTile(this.fetchedTiles[fetchedTileIDs[i]]);
      }
    }
    /**
     * Make sure that we have a one to one mapping between tiles
     * and graphics objects
     */
  }, {
    key: "synchronizeTilesAndGraphics",
    value: function synchronizeTilesAndGraphics() {
      this.addMissingGraphics();
      this.updateExistingGraphics();
    }
    /**
     * Extract drawable data from a tile loaded by a generic tile loader
     *
     * @param tile: A tile returned by a TiledArea.
     * @param dataLoader: A function for extracting drawable data from a tile. This
     *                    usually means differentiating the between dense and sparse
     *                    tiles and putting the data into an array.
     */
  }, {
    key: "loadTileData",
    value: function loadTileData(tile, dataLoader) {
      let loadedTileData = this.lruCache.get(tile.tileId);
      if (!loadedTileData) {
        loadedTileData = dataLoader(tile.data, tile.type);
        this.lruCache.put(tile.tileId, loadedTileData);
      }
      return loadedTileData;
    }
    /**
     * Get the url used to fetch the tile data
     */
  }, {
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      const serverPrefixes = ["a", "b", "c"];
      const serverPrefixIndex = Math.floor(Math.random() * serverPrefixes.length);
      const src2 = `https://${serverPrefixes[serverPrefixIndex]}.tile.openstreetmap.org/${tileZxy[0]}/${tileZxy[1]}/${tileZxy[2]}.png`;
      return src2;
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      if (toFetch.length > 0) {
        const toFetchList = [...new Set(toFetch.map((x) => x.remoteId))];
        for (const tileId of toFetchList) {
          const parts = tileId.split(".");
          const src2 = this.getTileUrl(parts);
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.src = src2;
          img.onload = () => {
            const loadedTiles = {};
            loadedTiles[tileId] = {
              tileId,
              img,
              zoomLevel: +parts[0],
              tilePos: [+parts[1], +parts[2]],
              tileSrc: src2
            };
            this.receivedTiles(loadedTiles);
          };
        }
      }
    }
    /**
     * We've gotten a bunch of tiles from the server in
     * response to a request from fetchTiles.
     */
  }, {
    key: "receivedTiles",
    value: function receivedTiles(loadedTiles) {
      for (let i = 0; i < this.visibleTiles.length; i++) {
        const tileId = this.visibleTiles[i].tileId;
        if (!loadedTiles[this.visibleTiles[i].remoteId])
          continue;
        if (this.visibleTiles[i].remoteId in loadedTiles) {
          if (!(tileId in this.fetchedTiles)) {
            this.fetchedTiles[tileId] = this.visibleTiles[i];
          }
          this.fetchedTiles[tileId].tileData = loadedTiles[this.visibleTiles[i].remoteId];
        }
      }
      for (const key in loadedTiles) {
        if (loadedTiles[key]) {
          if (this.fetching.has(key)) {
            this.fetching.delete(key);
          }
        }
      }
      this.synchronizeTilesAndGraphics();
      this.refreshTiles();
      this.draw();
      this.animate();
    }
  }, {
    key: "draw",
    value: function draw() {
      if (this.delayDrawing)
        return;
      _get$4(_getPrototypeOf$z(OSMTilesTrack2.prototype), "draw", this).call(this);
    }
    /**
     * Draw a tile on some graphics
     */
  }, {
    key: "drawTile",
    value: function drawTile() {
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _get$4(_getPrototypeOf$z(OSMTilesTrack2.prototype), "refScalesChanged", this).call(this, refXScale, refYScale);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos);
        }
      }
    }
  }]);
  return OSMTilesTrack2;
}(PixiTrack);
function _classCallCheck$L(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$A(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$A(descriptor.key), descriptor);
  }
}
function _createClass$J(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$A(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$A(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$A(arg) {
  var key = _toPrimitive$A(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$A(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$3() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$3 = Reflect.get.bind();
  } else {
    _get$3 = function _get2(target, property2, receiver) {
      var base = _superPropBase$3(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$3.apply(this, arguments);
}
function _superPropBase$3(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$y(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$J(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$y(subClass, superClass);
}
function _setPrototypeOf$y(o, p) {
  _setPrototypeOf$y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$y(o, p);
}
function _createSuper$y(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$y();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$y(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$y(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$J(this, result);
  };
}
function _possibleConstructorReturn$J(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$y(self2);
}
function _assertThisInitialized$y(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$y() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$y(o) {
  _getPrototypeOf$y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$y(o);
}
let OSMTileIdsTrack = /* @__PURE__ */ function(_OSMTilesTrack) {
  _inherits$J(OSMTileIdsTrack2, _OSMTilesTrack);
  var _super = _createSuper$y(OSMTileIdsTrack2);
  function OSMTileIdsTrack2() {
    _classCallCheck$L(this, OSMTileIdsTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$J(OSMTileIdsTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      _initTile.bind(this)(tile);
      this.drawTile(tile);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _drawTile.bind(this)(tile);
    }
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[0],
          tilePos: keyParts.slice(1, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
      this.animate();
    }
  }, {
    key: "draw",
    value: function draw() {
      _get$3(_getPrototypeOf$y(OSMTileIdsTrack2.prototype), "draw", this).call(this);
    }
  }]);
  return OSMTileIdsTrack2;
}(OSMTilesTrack);
function _classCallCheck$K(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$z(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$z(descriptor.key), descriptor);
  }
}
function _createClass$I(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$z(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$z(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$z(arg) {
  var key = _toPrimitive$z(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$z(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$2() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$2 = Reflect.get.bind();
  } else {
    _get$2 = function _get2(target, property2, receiver) {
      var base = _superPropBase$2(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$2.apply(this, arguments);
}
function _superPropBase$2(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$x(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$I(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$x(subClass, superClass);
}
function _setPrototypeOf$x(o, p) {
  _setPrototypeOf$x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$x(o, p);
}
function _createSuper$x(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$x();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$x(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$x(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$I(this, result);
  };
}
function _possibleConstructorReturn$I(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$x(self2);
}
function _assertThisInitialized$x(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$x() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$x(o) {
  _getPrototypeOf$x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$x(o);
}
let MapboxTilesTrack = /* @__PURE__ */ function(_OSMTilesTrack) {
  _inherits$I(MapboxTilesTrack2, _OSMTilesTrack);
  var _super = _createSuper$x(MapboxTilesTrack2);
  function MapboxTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$K(this, MapboxTilesTrack2);
    _this = _super.call(this, context, options2);
    _this.style = options2.style;
    if (!_this.options.accessToken) {
      _this.errorTextText = "No access token provided in the viewconf's track options ('accessToken' option).";
      _this.drawError();
    }
    return _this;
  }
  _createClass$I(MapboxTilesTrack2, [{
    key: "rerender",
    value: function rerender(newOptions) {
      _get$2(_getPrototypeOf$x(MapboxTilesTrack2.prototype), "rerender", this).call(this, newOptions);
      if (newOptions.style === this.style)
        return;
      this.style = newOptions.style;
      this.removeAllTiles();
      this.refreshTiles();
    }
    /**
     * Get the url used to fetch the tile data
     */
  }, {
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      const mapStyle = this.options && this.options.style ? this.options.style : "streets-v10";
      const tileSize = this.options && +this.options.tileSize ? +this.options.tileSize : 256;
      return `https://api.mapbox.com/styles/v1/mapbox/${mapStyle}/tiles/${tileSize}/${tileZxy[0]}/${tileZxy[1]}/${tileZxy[2]}?access_token=${this.options.accessToken}`;
    }
  }]);
  return MapboxTilesTrack2;
}(OSMTilesTrack);
function _classCallCheck$J(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$y(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$y(descriptor.key), descriptor);
  }
}
function _createClass$H(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$y(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$y(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$y(arg) {
  var key = _toPrimitive$y(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$y(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$H(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$w(subClass, superClass);
}
function _setPrototypeOf$w(o, p) {
  _setPrototypeOf$w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$w(o, p);
}
function _createSuper$w(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$w();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$w(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$w(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$H(this, result);
  };
}
function _possibleConstructorReturn$H(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$w(self2);
}
function _assertThisInitialized$w(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$w() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$w(o) {
  _getPrototypeOf$w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$w(o);
}
let RasterTilesTrack = /* @__PURE__ */ function(_OSMTilesTrack) {
  _inherits$H(RasterTilesTrack2, _OSMTilesTrack);
  var _super = _createSuper$w(RasterTilesTrack2);
  function RasterTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$J(this, RasterTilesTrack2);
    _this = _super.call(this, context, options2);
    _this.style = options2.style;
    if (!_this.options.tileSource) {
      _this.errorTextText = "No tile source string provided in the options. It should be in the form of http://a.com/{z}/{x}/{y}";
      _this.drawError();
    }
    return _this;
  }
  _createClass$H(RasterTilesTrack2, [{
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      let newUrl = this.options.tileSource.replace("{z}", tileZxy[0]);
      newUrl = newUrl.replace("{x}", tileZxy[1]);
      newUrl = newUrl.replace("{y}", tileZxy[2]);
      return newUrl;
    }
  }]);
  return RasterTilesTrack2;
}(OSMTilesTrack);
var common = {};
(function(exports2) {
  var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
  function _has3(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
  exports2.assign = function(obj) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while (sources.length) {
      var source = sources.shift();
      if (!source) {
        continue;
      }
      if (typeof source !== "object") {
        throw new TypeError(source + "must be non-object");
      }
      for (var p in source) {
        if (_has3(source, p)) {
          obj[p] = source[p];
        }
      }
    }
    return obj;
  };
  exports2.shrinkBuf = function(buf, size) {
    if (buf.length === size) {
      return buf;
    }
    if (buf.subarray) {
      return buf.subarray(0, size);
    }
    buf.length = size;
    return buf;
  };
  var fnTyped = {
    arraySet: function(dest, src2, src_offs, len, dest_offs) {
      if (src2.subarray && dest.subarray) {
        dest.set(src2.subarray(src_offs, src_offs + len), dest_offs);
        return;
      }
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src2[src_offs + i];
      }
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
      var i, l, len, pos, chunk, result;
      len = 0;
      for (i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      }
      result = new Uint8Array(len);
      pos = 0;
      for (i = 0, l = chunks.length; i < l; i++) {
        chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
      }
      return result;
    }
  };
  var fnUntyped = {
    arraySet: function(dest, src2, src_offs, len, dest_offs) {
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src2[src_offs + i];
      }
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
      return [].concat.apply([], chunks);
    }
  };
  exports2.setTyped = function(on) {
    if (on) {
      exports2.Buf8 = Uint8Array;
      exports2.Buf16 = Uint16Array;
      exports2.Buf32 = Int32Array;
      exports2.assign(exports2, fnTyped);
    } else {
      exports2.Buf8 = Array;
      exports2.Buf16 = Array;
      exports2.Buf32 = Array;
      exports2.assign(exports2, fnUntyped);
    }
  };
  exports2.setTyped(TYPED_OK);
})(common);
var deflate$4 = {};
var deflate$3 = {};
var trees$1 = {};
var utils$6 = common;
var Z_FIXED$1 = 4;
var Z_BINARY = 0;
var Z_TEXT = 1;
var Z_UNKNOWN$1 = 2;
function zero$1(buf) {
  var len = buf.length;
  while (--len >= 0) {
    buf[len] = 0;
  }
}
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
var MIN_MATCH$1 = 3;
var MAX_MATCH$1 = 258;
var LENGTH_CODES$1 = 29;
var LITERALS$1 = 256;
var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
var D_CODES$1 = 30;
var BL_CODES$1 = 19;
var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
var MAX_BITS$1 = 15;
var Buf_size = 16;
var MAX_BL_BITS = 7;
var END_BLOCK = 256;
var REP_3_6 = 16;
var REPZ_3_10 = 17;
var REPZ_11_138 = 18;
var extra_lbits = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
);
var extra_dbits = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
);
var extra_blbits = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
);
var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
var DIST_CODE_LEN = 512;
var static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
var static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
var _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
var base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
var base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
  this.static_tree = static_tree;
  this.extra_bits = extra_bits;
  this.extra_base = extra_base;
  this.elems = elems;
  this.max_length = max_length;
  this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;
  this.max_code = 0;
  this.stat_desc = stat_desc;
}
function d_code(dist2) {
  return dist2 < 256 ? _dist_code[dist2] : _dist_code[256 + (dist2 >>> 7)];
}
function put_short(s, w) {
  s.pending_buf[s.pending++] = w & 255;
  s.pending_buf[s.pending++] = w >>> 8 & 255;
}
function send_bits(s, value2, length2) {
  if (s.bi_valid > Buf_size - length2) {
    s.bi_buf |= value2 << s.bi_valid & 65535;
    put_short(s, s.bi_buf);
    s.bi_buf = value2 >> Buf_size - s.bi_valid;
    s.bi_valid += length2 - Buf_size;
  } else {
    s.bi_buf |= value2 << s.bi_valid & 65535;
    s.bi_valid += length2;
  }
}
function send_code(s, c2, tree) {
  send_bits(
    s,
    tree[c2 * 2],
    tree[c2 * 2 + 1]
    /*.Len*/
  );
}
function bi_reverse(code2, len) {
  var res = 0;
  do {
    res |= code2 & 1;
    code2 >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;
  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 255;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}
function gen_bitlen(s, desc) {
  var tree = desc.dyn_tree;
  var max_code = desc.max_code;
  var stree = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var extra = desc.stat_desc.extra_bits;
  var base = desc.stat_desc.extra_base;
  var max_length = desc.stat_desc.max_length;
  var h;
  var n, m;
  var bits2;
  var xbits;
  var f2;
  var overflow = 0;
  for (bits2 = 0; bits2 <= MAX_BITS$1; bits2++) {
    s.bl_count[bits2] = 0;
  }
  tree[s.heap[s.heap_max] * 2 + 1] = 0;
  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits2 = tree[tree[n * 2 + 1] * 2 + 1] + 1;
    if (bits2 > max_length) {
      bits2 = max_length;
      overflow++;
    }
    tree[n * 2 + 1] = bits2;
    if (n > max_code) {
      continue;
    }
    s.bl_count[bits2]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f2 = tree[n * 2];
    s.opt_len += f2 * (bits2 + xbits);
    if (has_stree) {
      s.static_len += f2 * (stree[n * 2 + 1] + xbits);
    }
  }
  if (overflow === 0) {
    return;
  }
  do {
    bits2 = max_length - 1;
    while (s.bl_count[bits2] === 0) {
      bits2--;
    }
    s.bl_count[bits2]--;
    s.bl_count[bits2 + 1] += 2;
    s.bl_count[max_length]--;
    overflow -= 2;
  } while (overflow > 0);
  for (bits2 = max_length; bits2 !== 0; bits2--) {
    n = s.bl_count[bits2];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) {
        continue;
      }
      if (tree[m * 2 + 1] !== bits2) {
        s.opt_len += (bits2 - tree[m * 2 + 1]) * tree[m * 2];
        tree[m * 2 + 1] = bits2;
      }
      n--;
    }
  }
}
function gen_codes(tree, max_code, bl_count) {
  var next_code = new Array(MAX_BITS$1 + 1);
  var code2 = 0;
  var bits2;
  var n;
  for (bits2 = 1; bits2 <= MAX_BITS$1; bits2++) {
    next_code[bits2] = code2 = code2 + bl_count[bits2 - 1] << 1;
  }
  for (n = 0; n <= max_code; n++) {
    var len = tree[n * 2 + 1];
    if (len === 0) {
      continue;
    }
    tree[n * 2] = bi_reverse(next_code[len]++, len);
  }
}
function tr_static_init() {
  var n;
  var bits2;
  var length2;
  var code2;
  var dist2;
  var bl_count = new Array(MAX_BITS$1 + 1);
  length2 = 0;
  for (code2 = 0; code2 < LENGTH_CODES$1 - 1; code2++) {
    base_length[code2] = length2;
    for (n = 0; n < 1 << extra_lbits[code2]; n++) {
      _length_code[length2++] = code2;
    }
  }
  _length_code[length2 - 1] = code2;
  dist2 = 0;
  for (code2 = 0; code2 < 16; code2++) {
    base_dist[code2] = dist2;
    for (n = 0; n < 1 << extra_dbits[code2]; n++) {
      _dist_code[dist2++] = code2;
    }
  }
  dist2 >>= 7;
  for (; code2 < D_CODES$1; code2++) {
    base_dist[code2] = dist2 << 7;
    for (n = 0; n < 1 << extra_dbits[code2] - 7; n++) {
      _dist_code[256 + dist2++] = code2;
    }
  }
  for (bits2 = 0; bits2 <= MAX_BITS$1; bits2++) {
    bl_count[bits2] = 0;
  }
  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1] = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1] = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1] = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1] = 8;
    n++;
    bl_count[8]++;
  }
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1] = 5;
    static_dtree[n * 2] = bi_reverse(n, 5);
  }
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}
function init_block(s) {
  var n;
  for (n = 0; n < L_CODES$1; n++) {
    s.dyn_ltree[n * 2] = 0;
  }
  for (n = 0; n < D_CODES$1; n++) {
    s.dyn_dtree[n * 2] = 0;
  }
  for (n = 0; n < BL_CODES$1; n++) {
    s.bl_tree[n * 2] = 0;
  }
  s.dyn_ltree[END_BLOCK * 2] = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}
function bi_windup(s) {
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}
function copy_block(s, buf, len, header) {
  bi_windup(s);
  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
  utils$6.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
function pqdownheap(s, tree, k) {
  var v = s.heap[k];
  var j = k << 1;
  while (j <= s.heap_len) {
    if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    if (smaller(tree, v, s.heap[j], s.depth)) {
      break;
    }
    s.heap[k] = s.heap[j];
    k = j;
    j <<= 1;
  }
  s.heap[k] = v;
}
function compress_block(s, ltree, dtree) {
  var dist2;
  var lc;
  var lx = 0;
  var code2;
  var extra;
  if (s.last_lit !== 0) {
    do {
      dist2 = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
      lc = s.pending_buf[s.l_buf + lx];
      lx++;
      if (dist2 === 0) {
        send_code(s, lc, ltree);
      } else {
        code2 = _length_code[lc];
        send_code(s, code2 + LITERALS$1 + 1, ltree);
        extra = extra_lbits[code2];
        if (extra !== 0) {
          lc -= base_length[code2];
          send_bits(s, lc, extra);
        }
        dist2--;
        code2 = d_code(dist2);
        send_code(s, code2, dtree);
        extra = extra_dbits[code2];
        if (extra !== 0) {
          dist2 -= base_dist[code2];
          send_bits(s, dist2, extra);
        }
      }
    } while (lx < s.last_lit);
  }
  send_code(s, END_BLOCK, ltree);
}
function build_tree(s, desc) {
  var tree = desc.dyn_tree;
  var stree = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems = desc.stat_desc.elems;
  var n, m;
  var max_code = -1;
  var node2;
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;
  for (n = 0; n < elems; n++) {
    if (tree[n * 2] !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;
    } else {
      tree[n * 2 + 1] = 0;
    }
  }
  while (s.heap_len < 2) {
    node2 = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
    tree[node2 * 2] = 1;
    s.depth[node2] = 0;
    s.opt_len--;
    if (has_stree) {
      s.static_len -= stree[node2 * 2 + 1];
    }
  }
  desc.max_code = max_code;
  for (n = s.heap_len >> 1; n >= 1; n--) {
    pqdownheap(s, tree, n);
  }
  node2 = elems;
  do {
    n = s.heap[
      1
      /*SMALLEST*/
    ];
    s.heap[
      1
      /*SMALLEST*/
    ] = s.heap[s.heap_len--];
    pqdownheap(
      s,
      tree,
      1
      /*SMALLEST*/
    );
    m = s.heap[
      1
      /*SMALLEST*/
    ];
    s.heap[--s.heap_max] = n;
    s.heap[--s.heap_max] = m;
    tree[node2 * 2] = tree[n * 2] + tree[m * 2];
    s.depth[node2] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1] = tree[m * 2 + 1] = node2;
    s.heap[
      1
      /*SMALLEST*/
    ] = node2++;
    pqdownheap(
      s,
      tree,
      1
      /*SMALLEST*/
    );
  } while (s.heap_len >= 2);
  s.heap[--s.heap_max] = s.heap[
    1
    /*SMALLEST*/
  ];
  gen_bitlen(s, desc);
  gen_codes(tree, max_code, s.bl_count);
}
function scan_tree(s, tree, max_code) {
  var n;
  var prevlen = -1;
  var curlen;
  var nextlen = tree[0 * 2 + 1];
  var count2 = 0;
  var max_count = 7;
  var min_count = 4;
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1] = 65535;
  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1];
    if (++count2 < max_count && curlen === nextlen) {
      continue;
    } else if (count2 < min_count) {
      s.bl_tree[curlen * 2] += count2;
    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        s.bl_tree[curlen * 2]++;
      }
      s.bl_tree[REP_3_6 * 2]++;
    } else if (count2 <= 10) {
      s.bl_tree[REPZ_3_10 * 2]++;
    } else {
      s.bl_tree[REPZ_11_138 * 2]++;
    }
    count2 = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;
    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}
function send_tree(s, tree, max_code) {
  var n;
  var prevlen = -1;
  var curlen;
  var nextlen = tree[0 * 2 + 1];
  var count2 = 0;
  var max_count = 7;
  var min_count = 4;
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1];
    if (++count2 < max_count && curlen === nextlen) {
      continue;
    } else if (count2 < min_count) {
      do {
        send_code(s, curlen, s.bl_tree);
      } while (--count2 !== 0);
    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count2--;
      }
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count2 - 3, 2);
    } else if (count2 <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count2 - 3, 3);
    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count2 - 11, 7);
    }
    count2 = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;
    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}
function build_bl_tree(s) {
  var max_blindex;
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
  build_tree(s, s.bl_desc);
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) {
      break;
    }
  }
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  return max_blindex;
}
function send_all_trees(s, lcodes, dcodes, blcodes) {
  var rank2;
  send_bits(s, lcodes - 257, 5);
  send_bits(s, dcodes - 1, 5);
  send_bits(s, blcodes - 4, 4);
  for (rank2 = 0; rank2 < blcodes; rank2++) {
    send_bits(s, s.bl_tree[bl_order[rank2] * 2 + 1], 3);
  }
  send_tree(s, s.dyn_ltree, lcodes - 1);
  send_tree(s, s.dyn_dtree, dcodes - 1);
}
function detect_data_type(s) {
  var black_mask = 4093624447;
  var n;
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) {
      return Z_BINARY;
    }
  }
  if (s.dyn_ltree[9 * 2] !== 0 || s.dyn_ltree[10 * 2] !== 0 || s.dyn_ltree[13 * 2] !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2] !== 0) {
      return Z_TEXT;
    }
  }
  return Z_BINARY;
}
var static_init_done = false;
function _tr_init(s) {
  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }
  s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
  s.bi_buf = 0;
  s.bi_valid = 0;
  init_block(s);
}
function _tr_stored_block(s, buf, stored_len, last2) {
  send_bits(s, (STORED_BLOCK << 1) + (last2 ? 1 : 0), 3);
  copy_block(s, buf, stored_len, true);
}
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}
function _tr_flush_block(s, buf, stored_len, last2) {
  var opt_lenb, static_lenb;
  var max_blindex = 0;
  if (s.level > 0) {
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }
    build_tree(s, s.l_desc);
    build_tree(s, s.d_desc);
    max_blindex = build_bl_tree(s);
    opt_lenb = s.opt_len + 3 + 7 >>> 3;
    static_lenb = s.static_len + 3 + 7 >>> 3;
    if (static_lenb <= opt_lenb) {
      opt_lenb = static_lenb;
    }
  } else {
    opt_lenb = static_lenb = stored_len + 5;
  }
  if (stored_len + 4 <= opt_lenb && buf !== -1) {
    _tr_stored_block(s, buf, stored_len, last2);
  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
    send_bits(s, (STATIC_TREES << 1) + (last2 ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);
  } else {
    send_bits(s, (DYN_TREES << 1) + (last2 ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  init_block(s);
  if (last2) {
    bi_windup(s);
  }
}
function _tr_tally(s, dist2, lc) {
  s.pending_buf[s.d_buf + s.last_lit * 2] = dist2 >>> 8 & 255;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist2 & 255;
  s.pending_buf[s.l_buf + s.last_lit] = lc & 255;
  s.last_lit++;
  if (dist2 === 0) {
    s.dyn_ltree[lc * 2]++;
  } else {
    s.matches++;
    dist2--;
    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]++;
    s.dyn_dtree[d_code(dist2) * 2]++;
  }
  return s.last_lit === s.lit_bufsize - 1;
}
trees$1._tr_init = _tr_init;
trees$1._tr_stored_block = _tr_stored_block;
trees$1._tr_flush_block = _tr_flush_block;
trees$1._tr_tally = _tr_tally;
trees$1._tr_align = _tr_align;
function adler32$2(adler, buf, len, pos) {
  var s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n = 0;
  while (len !== 0) {
    n = len > 2e3 ? 2e3 : len;
    len -= n;
    do {
      s1 = s1 + buf[pos++] | 0;
      s2 = s2 + s1 | 0;
    } while (--n);
    s1 %= 65521;
    s2 %= 65521;
  }
  return s1 | s2 << 16 | 0;
}
var adler32_1 = adler32$2;
function makeTable() {
  var c2, table = [];
  for (var n = 0; n < 256; n++) {
    c2 = n;
    for (var k = 0; k < 8; k++) {
      c2 = c2 & 1 ? 3988292384 ^ c2 >>> 1 : c2 >>> 1;
    }
    table[n] = c2;
  }
  return table;
}
var crcTable = makeTable();
function crc32$2(crc, buf, len, pos) {
  var t = crcTable, end2 = pos + len;
  crc ^= -1;
  for (var i = pos; i < end2; i++) {
    crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 255];
  }
  return crc ^ -1;
}
var crc32_1 = crc32$2;
var messages = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
};
var utils$5 = common;
var trees = trees$1;
var adler32$1 = adler32_1;
var crc32$1 = crc32_1;
var msg$2 = messages;
var Z_NO_FLUSH$1 = 0;
var Z_PARTIAL_FLUSH = 1;
var Z_FULL_FLUSH = 3;
var Z_FINISH$2 = 4;
var Z_BLOCK$1 = 5;
var Z_OK$2 = 0;
var Z_STREAM_END$2 = 1;
var Z_STREAM_ERROR$1 = -2;
var Z_DATA_ERROR$1 = -3;
var Z_BUF_ERROR$1 = -5;
var Z_DEFAULT_COMPRESSION$1 = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY$1 = 0;
var Z_UNKNOWN = 2;
var Z_DEFLATED$2 = 8;
var MAX_MEM_LEVEL = 9;
var MAX_WBITS$1 = 15;
var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
var LITERALS = 256;
var L_CODES = LITERALS + 1 + LENGTH_CODES;
var D_CODES = 30;
var BL_CODES = 19;
var HEAP_SIZE = 2 * L_CODES + 1;
var MAX_BITS = 15;
var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 32;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1;
var BS_BLOCK_DONE = 2;
var BS_FINISH_STARTED = 3;
var BS_FINISH_DONE = 4;
var OS_CODE = 3;
function err(strm, errorCode) {
  strm.msg = msg$2[errorCode];
  return errorCode;
}
function rank(f2) {
  return (f2 << 1) - (f2 > 4 ? 9 : 0);
}
function zero(buf) {
  var len = buf.length;
  while (--len >= 0) {
    buf[len] = 0;
  }
}
function flush_pending(strm) {
  var s = strm.state;
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) {
    return;
  }
  utils$5.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}
function flush_block_only(s, last2) {
  trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last2);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}
function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}
function putShortMSB(s, b) {
  s.pending_buf[s.pending++] = b >>> 8 & 255;
  s.pending_buf[s.pending++] = b & 255;
}
function read_buf(strm, buf, start2, size) {
  var len = strm.avail_in;
  if (len > size) {
    len = size;
  }
  if (len === 0) {
    return 0;
  }
  strm.avail_in -= len;
  utils$5.arraySet(buf, strm.input, strm.next_in, len, start2);
  if (strm.state.wrap === 1) {
    strm.adler = adler32$1(strm.adler, buf, len, start2);
  } else if (strm.state.wrap === 2) {
    strm.adler = crc32$1(strm.adler, buf, len, start2);
  }
  strm.next_in += len;
  strm.total_in += len;
  return len;
}
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;
  var scan2 = s.strstart;
  var match;
  var len;
  var best_len = s.prev_length;
  var nice_match = s.nice_match;
  var limit2 = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
  var _win = s.window;
  var wmask = s.w_mask;
  var prev = s.prev;
  var strend = s.strstart + MAX_MATCH;
  var scan_end1 = _win[scan2 + best_len - 1];
  var scan_end = _win[scan2 + best_len];
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  if (nice_match > s.lookahead) {
    nice_match = s.lookahead;
  }
  do {
    match = cur_match;
    if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan2] || _win[++match] !== _win[scan2 + 1]) {
      continue;
    }
    scan2 += 2;
    match++;
    do {
    } while (_win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && _win[++scan2] === _win[++match] && scan2 < strend);
    len = MAX_MATCH - (strend - scan2);
    scan2 = strend - MAX_MATCH;
    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1 = _win[scan2 + best_len - 1];
      scan_end = _win[scan2 + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit2 && --chain_length !== 0);
  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;
  do {
    more = s.window_size - s.lookahead - s.strstart;
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
      utils$5.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      s.block_start -= _w_size;
      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);
      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
      while (s.insert) {
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
}
function deflate_stored(s, flush) {
  var max_block_size = 65535;
  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }
  for (; ; ) {
    if (s.lookahead <= 1) {
      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    s.strstart += s.lookahead;
    s.lookahead = 0;
    var max_start = s.block_start + max_block_size;
    if (s.strstart === 0 || s.strstart >= max_start) {
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
    if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$2) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.strstart > s.block_start) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_NEED_MORE;
}
function deflate_fast(s, flush) {
  var hash_head;
  var bflush;
  for (; ; ) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    hash_head = 0;
    if (s.lookahead >= MIN_MATCH) {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
    }
    if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
      s.match_length = longest_match(s, hash_head);
    }
    if (s.match_length >= MIN_MATCH) {
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
      s.lookahead -= s.match_length;
      if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH) {
        s.match_length--;
        do {
          s.strstart++;
          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
        } while (--s.match_length !== 0);
        s.strstart++;
      } else {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
      }
    } else {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$2) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_slow(s, flush) {
  var hash_head;
  var bflush;
  var max_insert;
  for (; ; ) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    hash_head = 0;
    if (s.lookahead >= MIN_MATCH) {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
    }
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;
    if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
      s.match_length = longest_match(s, hash_head);
      if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096)) {
        s.match_length = MIN_MATCH - 1;
      }
    }
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;
      if (bflush) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
      }
    } else if (s.match_available) {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
      if (bflush) {
        flush_block_only(s, false);
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  if (s.match_available) {
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$2) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_rle(s, flush) {
  var bflush;
  var prev;
  var scan2, strend;
  var _win = s.window;
  for (; ; ) {
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan2 = s.strstart - 1;
      prev = _win[scan2];
      if (prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2]) {
        strend = s.strstart + MAX_MATCH;
        do {
        } while (prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && prev === _win[++scan2] && scan2 < strend);
        s.match_length = MAX_MATCH - (strend - scan2);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
    }
    if (s.match_length >= MIN_MATCH) {
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$2) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_huff(s, flush) {
  var bflush;
  for (; ; ) {
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$1) {
          return BS_NEED_MORE;
        }
        break;
      }
    }
    s.match_length = 0;
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$2) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}
var configuration_table;
configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
];
function lm_init(s) {
  s.window_size = 2 * s.w_size;
  zero(s.head);
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;
  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}
function DeflateState() {
  this.strm = null;
  this.status = 0;
  this.pending_buf = null;
  this.pending_buf_size = 0;
  this.pending_out = 0;
  this.pending = 0;
  this.wrap = 0;
  this.gzhead = null;
  this.gzindex = 0;
  this.method = Z_DEFLATED$2;
  this.last_flush = -1;
  this.w_size = 0;
  this.w_bits = 0;
  this.w_mask = 0;
  this.window = null;
  this.window_size = 0;
  this.prev = null;
  this.head = null;
  this.ins_h = 0;
  this.hash_size = 0;
  this.hash_bits = 0;
  this.hash_mask = 0;
  this.hash_shift = 0;
  this.block_start = 0;
  this.match_length = 0;
  this.prev_match = 0;
  this.match_available = 0;
  this.strstart = 0;
  this.match_start = 0;
  this.lookahead = 0;
  this.prev_length = 0;
  this.max_chain_length = 0;
  this.max_lazy_match = 0;
  this.level = 0;
  this.strategy = 0;
  this.good_match = 0;
  this.nice_match = 0;
  this.dyn_ltree = new utils$5.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree = new utils$5.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree = new utils$5.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);
  this.l_desc = null;
  this.d_desc = null;
  this.bl_desc = null;
  this.bl_count = new utils$5.Buf16(MAX_BITS + 1);
  this.heap = new utils$5.Buf16(2 * L_CODES + 1);
  zero(this.heap);
  this.heap_len = 0;
  this.heap_max = 0;
  this.depth = new utils$5.Buf16(2 * L_CODES + 1);
  zero(this.depth);
  this.l_buf = 0;
  this.lit_bufsize = 0;
  this.last_lit = 0;
  this.d_buf = 0;
  this.opt_len = 0;
  this.static_len = 0;
  this.matches = 0;
  this.insert = 0;
  this.bi_buf = 0;
  this.bi_valid = 0;
}
function deflateResetKeep(strm) {
  var s;
  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR$1);
  }
  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;
  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;
  if (s.wrap < 0) {
    s.wrap = -s.wrap;
  }
  s.status = s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = s.wrap === 2 ? 0 : 1;
  s.last_flush = Z_NO_FLUSH$1;
  trees._tr_init(s);
  return Z_OK$2;
}
function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK$2) {
    lm_init(strm.state);
  }
  return ret;
}
function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  if (strm.state.wrap !== 2) {
    return Z_STREAM_ERROR$1;
  }
  strm.state.gzhead = head;
  return Z_OK$2;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) {
    return Z_STREAM_ERROR$1;
  }
  var wrap2 = 1;
  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }
  if (windowBits < 0) {
    wrap2 = 0;
    windowBits = -windowBits;
  } else if (windowBits > 15) {
    wrap2 = 2;
    windowBits -= 16;
  }
  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR$1);
  }
  if (windowBits === 8) {
    windowBits = 9;
  }
  var s = new DeflateState();
  strm.state = s;
  s.strm = strm;
  s.wrap = wrap2;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;
  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
  s.window = new utils$5.Buf8(s.w_size * 2);
  s.head = new utils$5.Buf16(s.hash_size);
  s.prev = new utils$5.Buf16(s.w_size);
  s.lit_bufsize = 1 << memLevel + 6;
  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new utils$5.Buf8(s.pending_buf_size);
  s.d_buf = 1 * s.lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;
  s.level = level;
  s.strategy = strategy;
  s.method = method;
  return deflateReset(strm);
}
function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
}
function deflate$2(strm, flush) {
  var old_flush, s;
  var beg, val2;
  if (!strm || !strm.state || flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
  }
  s = strm.state;
  if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH$2) {
    return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
  }
  s.strm = strm;
  old_flush = s.last_flush;
  s.last_flush = flush;
  if (s.status === INIT_STATE) {
    if (s.wrap === 2) {
      strm.adler = 0;
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) {
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      } else {
        put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
        put_byte(s, s.gzhead.time & 255);
        put_byte(s, s.gzhead.time >> 8 & 255);
        put_byte(s, s.gzhead.time >> 16 & 255);
        put_byte(s, s.gzhead.time >> 24 & 255);
        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
        put_byte(s, s.gzhead.os & 255);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 255);
          put_byte(s, s.gzhead.extra.length >> 8 & 255);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    } else {
      var header = Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
      var level_flags = -1;
      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= level_flags << 6;
      if (s.strstart !== 0) {
        header |= PRESET_DICT;
      }
      header += 31 - header % 31;
      s.status = BUSY_STATE;
      putShortMSB(s, header);
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 65535);
      }
      strm.adler = 1;
    }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra) {
      beg = s.pending;
      while (s.gzindex < (s.gzhead.extra.length & 65535)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 255);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    } else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name) {
      beg = s.pending;
      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val2 = 1;
            break;
          }
        }
        if (s.gzindex < s.gzhead.name.length) {
          val2 = s.gzhead.name.charCodeAt(s.gzindex++) & 255;
        } else {
          val2 = 0;
        }
        put_byte(s, val2);
      } while (val2 !== 0);
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val2 === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    } else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment) {
      beg = s.pending;
      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val2 = 1;
            break;
          }
        }
        if (s.gzindex < s.gzhead.comment.length) {
          val2 = s.gzhead.comment.charCodeAt(s.gzindex++) & 255;
        } else {
          val2 = 0;
        }
        put_byte(s, val2);
      } while (val2 !== 0);
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val2 === 0) {
        s.status = HCRC_STATE;
      }
    } else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 255);
        put_byte(s, strm.adler >> 8 & 255);
        strm.adler = 0;
        s.status = BUSY_STATE;
      }
    } else {
      s.status = BUSY_STATE;
    }
  }
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      s.last_flush = -1;
      return Z_OK$2;
    }
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$2) {
    return err(strm, Z_BUF_ERROR$1);
  }
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }
  if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH$1 && s.status !== FINISH_STATE) {
    var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
      }
      return Z_OK$2;
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      } else if (flush !== Z_BLOCK$1) {
        trees._tr_stored_block(s, 0, 0, false);
        if (flush === Z_FULL_FLUSH) {
          zero(s.head);
          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        return Z_OK$2;
      }
    }
  }
  if (flush !== Z_FINISH$2) {
    return Z_OK$2;
  }
  if (s.wrap <= 0) {
    return Z_STREAM_END$2;
  }
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 255);
    put_byte(s, strm.adler >> 8 & 255);
    put_byte(s, strm.adler >> 16 & 255);
    put_byte(s, strm.adler >> 24 & 255);
    put_byte(s, strm.total_in & 255);
    put_byte(s, strm.total_in >> 8 & 255);
    put_byte(s, strm.total_in >> 16 & 255);
    put_byte(s, strm.total_in >> 24 & 255);
  } else {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 65535);
  }
  flush_pending(strm);
  if (s.wrap > 0) {
    s.wrap = -s.wrap;
  }
  return s.pending !== 0 ? Z_OK$2 : Z_STREAM_END$2;
}
function deflateEnd(strm) {
  var status;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  status = strm.state.status;
  if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
    return err(strm, Z_STREAM_ERROR$1);
  }
  strm.state = null;
  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$1) : Z_OK$2;
}
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;
  var s;
  var str, n;
  var wrap2;
  var avail;
  var next;
  var input;
  var tmpDict;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  s = strm.state;
  wrap2 = s.wrap;
  if (wrap2 === 2 || wrap2 === 1 && s.status !== INIT_STATE || s.lookahead) {
    return Z_STREAM_ERROR$1;
  }
  if (wrap2 === 1) {
    strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
  }
  s.wrap = 0;
  if (dictLength >= s.w_size) {
    if (wrap2 === 0) {
      zero(s.head);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    tmpDict = new utils$5.Buf8(s.w_size);
    utils$5.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
      s.prev[str & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap2;
  return Z_OK$2;
}
deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var strings$2 = {};
var utils$4 = common;
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;
try {
  String.fromCharCode.apply(null, [0]);
} catch (__) {
  STR_APPLY_OK = false;
}
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
  STR_APPLY_UIA_OK = false;
}
var _utf8len = new utils$4.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
}
_utf8len[254] = _utf8len[254] = 1;
strings$2.string2buf = function(str) {
  var buf, c2, c22, m_pos, i, str_len = str.length, buf_len = 0;
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c2 = str.charCodeAt(m_pos);
    if ((c2 & 64512) === 55296 && m_pos + 1 < str_len) {
      c22 = str.charCodeAt(m_pos + 1);
      if ((c22 & 64512) === 56320) {
        c2 = 65536 + (c2 - 55296 << 10) + (c22 - 56320);
        m_pos++;
      }
    }
    buf_len += c2 < 128 ? 1 : c2 < 2048 ? 2 : c2 < 65536 ? 3 : 4;
  }
  buf = new utils$4.Buf8(buf_len);
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c2 = str.charCodeAt(m_pos);
    if ((c2 & 64512) === 55296 && m_pos + 1 < str_len) {
      c22 = str.charCodeAt(m_pos + 1);
      if ((c22 & 64512) === 56320) {
        c2 = 65536 + (c2 - 55296 << 10) + (c22 - 56320);
        m_pos++;
      }
    }
    if (c2 < 128) {
      buf[i++] = c2;
    } else if (c2 < 2048) {
      buf[i++] = 192 | c2 >>> 6;
      buf[i++] = 128 | c2 & 63;
    } else if (c2 < 65536) {
      buf[i++] = 224 | c2 >>> 12;
      buf[i++] = 128 | c2 >>> 6 & 63;
      buf[i++] = 128 | c2 & 63;
    } else {
      buf[i++] = 240 | c2 >>> 18;
      buf[i++] = 128 | c2 >>> 12 & 63;
      buf[i++] = 128 | c2 >>> 6 & 63;
      buf[i++] = 128 | c2 & 63;
    }
  }
  return buf;
};
function buf2binstring(buf, len) {
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
      return String.fromCharCode.apply(null, utils$4.shrinkBuf(buf, len));
    }
  }
  var result = "";
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}
strings$2.buf2binstring = function(buf) {
  return buf2binstring(buf, buf.length);
};
strings$2.binstring2buf = function(str) {
  var buf = new utils$4.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};
strings$2.buf2string = function(buf, max2) {
  var i, out, c2, c_len;
  var len = max2 || buf.length;
  var utf16buf = new Array(len * 2);
  for (out = 0, i = 0; i < len; ) {
    c2 = buf[i++];
    if (c2 < 128) {
      utf16buf[out++] = c2;
      continue;
    }
    c_len = _utf8len[c2];
    if (c_len > 4) {
      utf16buf[out++] = 65533;
      i += c_len - 1;
      continue;
    }
    c2 &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7;
    while (c_len > 1 && i < len) {
      c2 = c2 << 6 | buf[i++] & 63;
      c_len--;
    }
    if (c_len > 1) {
      utf16buf[out++] = 65533;
      continue;
    }
    if (c2 < 65536) {
      utf16buf[out++] = c2;
    } else {
      c2 -= 65536;
      utf16buf[out++] = 55296 | c2 >> 10 & 1023;
      utf16buf[out++] = 56320 | c2 & 1023;
    }
  }
  return buf2binstring(utf16buf, out);
};
strings$2.utf8border = function(buf, max2) {
  var pos;
  max2 = max2 || buf.length;
  if (max2 > buf.length) {
    max2 = buf.length;
  }
  pos = max2 - 1;
  while (pos >= 0 && (buf[pos] & 192) === 128) {
    pos--;
  }
  if (pos < 0) {
    return max2;
  }
  if (pos === 0) {
    return max2;
  }
  return pos + _utf8len[buf[pos]] > max2 ? pos : max2;
};
function ZStream$2() {
  this.input = null;
  this.next_in = 0;
  this.avail_in = 0;
  this.total_in = 0;
  this.output = null;
  this.next_out = 0;
  this.avail_out = 0;
  this.total_out = 0;
  this.msg = "";
  this.state = null;
  this.data_type = 2;
  this.adler = 0;
}
var zstream = ZStream$2;
var zlib_deflate = deflate$3;
var utils$3 = common;
var strings$1 = strings$2;
var msg$1 = messages;
var ZStream$1 = zstream;
var toString$3 = Object.prototype.toString;
var Z_NO_FLUSH = 0;
var Z_FINISH$1 = 4;
var Z_OK$1 = 0;
var Z_STREAM_END$1 = 1;
var Z_SYNC_FLUSH = 2;
var Z_DEFAULT_COMPRESSION = -1;
var Z_DEFAULT_STRATEGY = 0;
var Z_DEFLATED$1 = 8;
function Deflate(options2) {
  if (!(this instanceof Deflate))
    return new Deflate(options2);
  this.options = utils$3.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ""
  }, options2 || {});
  var opt = this.options;
  if (opt.raw && opt.windowBits > 0) {
    opt.windowBits = -opt.windowBits;
  } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
    opt.windowBits += 16;
  }
  this.err = 0;
  this.msg = "";
  this.ended = false;
  this.chunks = [];
  this.strm = new ZStream$1();
  this.strm.avail_out = 0;
  var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
  if (status !== Z_OK$1) {
    throw new Error(msg$1[status]);
  }
  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }
  if (opt.dictionary) {
    var dict;
    if (typeof opt.dictionary === "string") {
      dict = strings$1.string2buf(opt.dictionary);
    } else if (toString$3.call(opt.dictionary) === "[object ArrayBuffer]") {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }
    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
    if (status !== Z_OK$1) {
      throw new Error(msg$1[status]);
    }
    this._dict_set = true;
  }
}
Deflate.prototype.push = function(data2, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;
  if (this.ended) {
    return false;
  }
  _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH$1 : Z_NO_FLUSH;
  if (typeof data2 === "string") {
    strm.input = strings$1.string2buf(data2);
  } else if (toString$3.call(data2) === "[object ArrayBuffer]") {
    strm.input = new Uint8Array(data2);
  } else {
    strm.input = data2;
  }
  strm.next_in = 0;
  strm.avail_in = strm.input.length;
  do {
    if (strm.avail_out === 0) {
      strm.output = new utils$3.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);
    if (status !== Z_STREAM_END$1 && status !== Z_OK$1) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH$1 || _mode === Z_SYNC_FLUSH)) {
      if (this.options.to === "string") {
        this.onData(strings$1.buf2binstring(utils$3.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils$3.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END$1);
  if (_mode === Z_FINISH$1) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK$1;
  }
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK$1);
    strm.avail_out = 0;
    return true;
  }
  return true;
};
Deflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};
Deflate.prototype.onEnd = function(status) {
  if (status === Z_OK$1) {
    if (this.options.to === "string") {
      this.result = this.chunks.join("");
    } else {
      this.result = utils$3.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};
function deflate$1(input, options2) {
  var deflator = new Deflate(options2);
  deflator.push(input, true);
  if (deflator.err) {
    throw deflator.msg || msg$1[deflator.err];
  }
  return deflator.result;
}
function deflateRaw(input, options2) {
  options2 = options2 || {};
  options2.raw = true;
  return deflate$1(input, options2);
}
function gzip(input, options2) {
  options2 = options2 || {};
  options2.gzip = true;
  return deflate$1(input, options2);
}
deflate$4.Deflate = Deflate;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw;
deflate$4.gzip = gzip;
var inflate$4 = {};
var inflate$3 = {};
var BAD$1 = 30;
var TYPE$1 = 12;
var inffast = function inflate_fast(strm, start2) {
  var state;
  var _in;
  var last2;
  var _out;
  var beg;
  var end2;
  var dmax;
  var wsize;
  var whave;
  var wnext;
  var s_window;
  var hold;
  var bits2;
  var lcode;
  var dcode;
  var lmask;
  var dmask;
  var here;
  var op;
  var len;
  var dist2;
  var from;
  var from_source;
  var input, output;
  state = strm.state;
  _in = strm.next_in;
  input = strm.input;
  last2 = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start2 - strm.avail_out);
  end2 = _out + (strm.avail_out - 257);
  dmax = state.dmax;
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits2 = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;
  top:
    do {
      if (bits2 < 15) {
        hold += input[_in++] << bits2;
        bits2 += 8;
        hold += input[_in++] << bits2;
        bits2 += 8;
      }
      here = lcode[hold & lmask];
      dolen:
        for (; ; ) {
          op = here >>> 24;
          hold >>>= op;
          bits2 -= op;
          op = here >>> 16 & 255;
          if (op === 0) {
            output[_out++] = here & 65535;
          } else if (op & 16) {
            len = here & 65535;
            op &= 15;
            if (op) {
              if (bits2 < op) {
                hold += input[_in++] << bits2;
                bits2 += 8;
              }
              len += hold & (1 << op) - 1;
              hold >>>= op;
              bits2 -= op;
            }
            if (bits2 < 15) {
              hold += input[_in++] << bits2;
              bits2 += 8;
              hold += input[_in++] << bits2;
              bits2 += 8;
            }
            here = dcode[hold & dmask];
            dodist:
              for (; ; ) {
                op = here >>> 24;
                hold >>>= op;
                bits2 -= op;
                op = here >>> 16 & 255;
                if (op & 16) {
                  dist2 = here & 65535;
                  op &= 15;
                  if (bits2 < op) {
                    hold += input[_in++] << bits2;
                    bits2 += 8;
                    if (bits2 < op) {
                      hold += input[_in++] << bits2;
                      bits2 += 8;
                    }
                  }
                  dist2 += hold & (1 << op) - 1;
                  if (dist2 > dmax) {
                    strm.msg = "invalid distance too far back";
                    state.mode = BAD$1;
                    break top;
                  }
                  hold >>>= op;
                  bits2 -= op;
                  op = _out - beg;
                  if (dist2 > op) {
                    op = dist2 - op;
                    if (op > whave) {
                      if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD$1;
                        break top;
                      }
                    }
                    from = 0;
                    from_source = s_window;
                    if (wnext === 0) {
                      from += wsize - op;
                      if (op < len) {
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist2;
                        from_source = output;
                      }
                    } else if (wnext < op) {
                      from += wsize + wnext - op;
                      op -= wnext;
                      if (op < len) {
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = 0;
                        if (wnext < len) {
                          op = wnext;
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = _out - dist2;
                          from_source = output;
                        }
                      }
                    } else {
                      from += wnext - op;
                      if (op < len) {
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist2;
                        from_source = output;
                      }
                    }
                    while (len > 2) {
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      len -= 3;
                    }
                    if (len) {
                      output[_out++] = from_source[from++];
                      if (len > 1) {
                        output[_out++] = from_source[from++];
                      }
                    }
                  } else {
                    from = _out - dist2;
                    do {
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      len -= 3;
                    } while (len > 2);
                    if (len) {
                      output[_out++] = output[from++];
                      if (len > 1) {
                        output[_out++] = output[from++];
                      }
                    }
                  }
                } else if ((op & 64) === 0) {
                  here = dcode[(here & 65535) + (hold & (1 << op) - 1)];
                  continue dodist;
                } else {
                  strm.msg = "invalid distance code";
                  state.mode = BAD$1;
                  break top;
                }
                break;
              }
          } else if ((op & 64) === 0) {
            here = lcode[(here & 65535) + (hold & (1 << op) - 1)];
            continue dolen;
          } else if (op & 32) {
            state.mode = TYPE$1;
            break top;
          } else {
            strm.msg = "invalid literal/length code";
            state.mode = BAD$1;
            break top;
          }
          break;
        }
    } while (_in < last2 && _out < end2);
  len = bits2 >> 3;
  _in -= len;
  bits2 -= len << 3;
  hold &= (1 << bits2) - 1;
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = _in < last2 ? 5 + (last2 - _in) : 5 - (_in - last2);
  strm.avail_out = _out < end2 ? 257 + (end2 - _out) : 257 - (_out - end2);
  state.hold = hold;
  state.bits = bits2;
  return;
};
var utils$2 = common;
var MAXBITS = 15;
var ENOUGH_LENS$1 = 852;
var ENOUGH_DISTS$1 = 592;
var CODES$1 = 0;
var LENS$1 = 1;
var DISTS$1 = 2;
var lbase = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
];
var lext = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
];
var dbase = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
];
var dext = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
];
var inftrees = function inflate_table(type3, lens, lens_index, codes, table, table_index, work, opts) {
  var bits2 = opts.bits;
  var len = 0;
  var sym = 0;
  var min2 = 0, max2 = 0;
  var root2 = 0;
  var curr = 0;
  var drop = 0;
  var left2 = 0;
  var used = 0;
  var huff = 0;
  var incr;
  var fill;
  var low;
  var mask;
  var next;
  var base = null;
  var base_index = 0;
  var end2;
  var count2 = new utils$2.Buf16(MAXBITS + 1);
  var offs = new utils$2.Buf16(MAXBITS + 1);
  var extra = null;
  var extra_index = 0;
  var here_bits, here_op, here_val;
  for (len = 0; len <= MAXBITS; len++) {
    count2[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count2[lens[lens_index + sym]]++;
  }
  root2 = bits2;
  for (max2 = MAXBITS; max2 >= 1; max2--) {
    if (count2[max2] !== 0) {
      break;
    }
  }
  if (root2 > max2) {
    root2 = max2;
  }
  if (max2 === 0) {
    table[table_index++] = 1 << 24 | 64 << 16 | 0;
    table[table_index++] = 1 << 24 | 64 << 16 | 0;
    opts.bits = 1;
    return 0;
  }
  for (min2 = 1; min2 < max2; min2++) {
    if (count2[min2] !== 0) {
      break;
    }
  }
  if (root2 < min2) {
    root2 = min2;
  }
  left2 = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left2 <<= 1;
    left2 -= count2[len];
    if (left2 < 0) {
      return -1;
    }
  }
  if (left2 > 0 && (type3 === CODES$1 || max2 !== 1)) {
    return -1;
  }
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count2[len];
  }
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }
  if (type3 === CODES$1) {
    base = extra = work;
    end2 = 19;
  } else if (type3 === LENS$1) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end2 = 256;
  } else {
    base = dbase;
    extra = dext;
    end2 = -1;
  }
  huff = 0;
  sym = 0;
  len = min2;
  next = table_index;
  curr = root2;
  drop = 0;
  low = -1;
  used = 1 << root2;
  mask = used - 1;
  if (type3 === LENS$1 && used > ENOUGH_LENS$1 || type3 === DISTS$1 && used > ENOUGH_DISTS$1) {
    return 1;
  }
  for (; ; ) {
    here_bits = len - drop;
    if (work[sym] < end2) {
      here_op = 0;
      here_val = work[sym];
    } else if (work[sym] > end2) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    } else {
      here_op = 32 + 64;
      here_val = 0;
    }
    incr = 1 << len - drop;
    fill = 1 << curr;
    min2 = fill;
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
    } while (fill !== 0);
    incr = 1 << len - 1;
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }
    sym++;
    if (--count2[len] === 0) {
      if (len === max2) {
        break;
      }
      len = lens[lens_index + work[sym]];
    }
    if (len > root2 && (huff & mask) !== low) {
      if (drop === 0) {
        drop = root2;
      }
      next += min2;
      curr = len - drop;
      left2 = 1 << curr;
      while (curr + drop < max2) {
        left2 -= count2[curr + drop];
        if (left2 <= 0) {
          break;
        }
        curr++;
        left2 <<= 1;
      }
      used += 1 << curr;
      if (type3 === LENS$1 && used > ENOUGH_LENS$1 || type3 === DISTS$1 && used > ENOUGH_DISTS$1) {
        return 1;
      }
      low = huff & mask;
      table[low] = root2 << 24 | curr << 16 | next - table_index | 0;
    }
  }
  if (huff !== 0) {
    table[next + huff] = len - drop << 24 | 64 << 16 | 0;
  }
  opts.bits = root2;
  return 0;
};
var utils$1 = common;
var adler32 = adler32_1;
var crc32 = crc32_1;
var inflate_fast2 = inffast;
var inflate_table2 = inftrees;
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
var Z_DEFLATED = 8;
var HEAD = 1;
var FLAGS = 2;
var TIME$1 = 3;
var OS = 4;
var EXLEN = 5;
var EXTRA = 6;
var NAME = 7;
var COMMENT = 8;
var HCRC = 9;
var DICTID = 10;
var DICT = 11;
var TYPE = 12;
var TYPEDO = 13;
var STORED = 14;
var COPY_ = 15;
var COPY = 16;
var TABLE = 17;
var LENLENS = 18;
var CODELENS = 19;
var LEN_ = 20;
var LEN = 21;
var LENEXT = 22;
var DIST = 23;
var DISTEXT = 24;
var MATCH = 25;
var LIT = 26;
var CHECK = 27;
var LENGTH = 28;
var DONE = 29;
var BAD = 30;
var MEM = 31;
var SYNC = 32;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
var MAX_WBITS = 15;
var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
  return (q >>> 24 & 255) + (q >>> 8 & 65280) + ((q & 65280) << 8) + ((q & 255) << 24);
}
function InflateState() {
  this.mode = 0;
  this.last = false;
  this.wrap = 0;
  this.havedict = false;
  this.flags = 0;
  this.dmax = 0;
  this.check = 0;
  this.total = 0;
  this.head = null;
  this.wbits = 0;
  this.wsize = 0;
  this.whave = 0;
  this.wnext = 0;
  this.window = null;
  this.hold = 0;
  this.bits = 0;
  this.length = 0;
  this.offset = 0;
  this.extra = 0;
  this.lencode = null;
  this.distcode = null;
  this.lenbits = 0;
  this.distbits = 0;
  this.ncode = 0;
  this.nlen = 0;
  this.ndist = 0;
  this.have = 0;
  this.next = null;
  this.lens = new utils$1.Buf16(320);
  this.work = new utils$1.Buf16(288);
  this.lendyn = null;
  this.distdyn = null;
  this.sane = 0;
  this.back = 0;
  this.was = 0;
}
function inflateResetKeep(strm) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = "";
  if (state.wrap) {
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null;
  state.hold = 0;
  state.bits = 0;
  state.lencode = state.lendyn = new utils$1.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils$1.Buf32(ENOUGH_DISTS);
  state.sane = 1;
  state.back = -1;
  return Z_OK;
}
function inflateReset(strm) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
  var wrap2;
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  if (windowBits < 0) {
    wrap2 = 0;
    windowBits = -windowBits;
  } else {
    wrap2 = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }
  state.wrap = wrap2;
  state.wbits = windowBits;
  return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
  var ret;
  var state;
  if (!strm) {
    return Z_STREAM_ERROR;
  }
  state = new InflateState();
  strm.state = state;
  state.window = null;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null;
  }
  return ret;
}
function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}
var virgin = true;
var lenfix, distfix;
function fixedtables(state) {
  if (virgin) {
    var sym;
    lenfix = new utils$1.Buf32(512);
    distfix = new utils$1.Buf32(32);
    sym = 0;
    while (sym < 144) {
      state.lens[sym++] = 8;
    }
    while (sym < 256) {
      state.lens[sym++] = 9;
    }
    while (sym < 280) {
      state.lens[sym++] = 7;
    }
    while (sym < 288) {
      state.lens[sym++] = 8;
    }
    inflate_table2(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
      bits: 9
    });
    sym = 0;
    while (sym < 32) {
      state.lens[sym++] = 5;
    }
    inflate_table2(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
      bits: 5
    });
    virgin = false;
  }
  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}
function updatewindow(strm, src2, end2, copy2) {
  var dist2;
  var state = strm.state;
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;
    state.window = new utils$1.Buf8(state.wsize);
  }
  if (copy2 >= state.wsize) {
    utils$1.arraySet(state.window, src2, end2 - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  } else {
    dist2 = state.wsize - state.wnext;
    if (dist2 > copy2) {
      dist2 = copy2;
    }
    utils$1.arraySet(state.window, src2, end2 - copy2, dist2, state.wnext);
    copy2 -= dist2;
    if (copy2) {
      utils$1.arraySet(state.window, src2, end2 - copy2, copy2, 0);
      state.wnext = copy2;
      state.whave = state.wsize;
    } else {
      state.wnext += dist2;
      if (state.wnext === state.wsize) {
        state.wnext = 0;
      }
      if (state.whave < state.wsize) {
        state.whave += dist2;
      }
    }
  }
  return 0;
}
function inflate$2(strm, flush) {
  var state;
  var input, output;
  var next;
  var put2;
  var have, left2;
  var hold;
  var bits2;
  var _in, _out;
  var copy2;
  var from;
  var from_source;
  var here = 0;
  var here_bits, here_op, here_val;
  var last_bits, last_op, last_val;
  var len;
  var ret;
  var hbuf = new utils$1.Buf8(4);
  var opts;
  var n;
  var order2 = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  if (state.mode === TYPE) {
    state.mode = TYPEDO;
  }
  put2 = strm.next_out;
  output = strm.output;
  left2 = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits2 = state.bits;
  _in = have;
  _out = left2;
  ret = Z_OK;
  inf_leave:
    for (; ; ) {
      switch (state.mode) {
        case HEAD:
          if (state.wrap === 0) {
            state.mode = TYPEDO;
            break;
          }
          while (bits2 < 16) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if (state.wrap & 2 && hold === 35615) {
            state.check = 0;
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
            hold = 0;
            bits2 = 0;
            state.mode = FLAGS;
            break;
          }
          state.flags = 0;
          if (state.head) {
            state.head.done = false;
          }
          if (!(state.wrap & 1) || /* check if zlib header allowed */
          (((hold & 255) << 8) + (hold >> 8)) % 31) {
            strm.msg = "incorrect header check";
            state.mode = BAD;
            break;
          }
          if ((hold & 15) !== Z_DEFLATED) {
            strm.msg = "unknown compression method";
            state.mode = BAD;
            break;
          }
          hold >>>= 4;
          bits2 -= 4;
          len = (hold & 15) + 8;
          if (state.wbits === 0) {
            state.wbits = len;
          } else if (len > state.wbits) {
            strm.msg = "invalid window size";
            state.mode = BAD;
            break;
          }
          state.dmax = 1 << len;
          strm.adler = state.check = 1;
          state.mode = hold & 512 ? DICTID : TYPE;
          hold = 0;
          bits2 = 0;
          break;
        case FLAGS:
          while (bits2 < 16) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          state.flags = hold;
          if ((state.flags & 255) !== Z_DEFLATED) {
            strm.msg = "unknown compression method";
            state.mode = BAD;
            break;
          }
          if (state.flags & 57344) {
            strm.msg = "unknown header flags set";
            state.mode = BAD;
            break;
          }
          if (state.head) {
            state.head.text = hold >> 8 & 1;
          }
          if (state.flags & 512) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
          }
          hold = 0;
          bits2 = 0;
          state.mode = TIME$1;
        case TIME$1:
          while (bits2 < 32) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if (state.head) {
            state.head.time = hold;
          }
          if (state.flags & 512) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            hbuf[2] = hold >>> 16 & 255;
            hbuf[3] = hold >>> 24 & 255;
            state.check = crc32(state.check, hbuf, 4, 0);
          }
          hold = 0;
          bits2 = 0;
          state.mode = OS;
        case OS:
          while (bits2 < 16) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if (state.head) {
            state.head.xflags = hold & 255;
            state.head.os = hold >> 8;
          }
          if (state.flags & 512) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
          }
          hold = 0;
          bits2 = 0;
          state.mode = EXLEN;
        case EXLEN:
          if (state.flags & 1024) {
            while (bits2 < 16) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            state.length = hold;
            if (state.head) {
              state.head.extra_len = hold;
            }
            if (state.flags & 512) {
              hbuf[0] = hold & 255;
              hbuf[1] = hold >>> 8 & 255;
              state.check = crc32(state.check, hbuf, 2, 0);
            }
            hold = 0;
            bits2 = 0;
          } else if (state.head) {
            state.head.extra = null;
          }
          state.mode = EXTRA;
        case EXTRA:
          if (state.flags & 1024) {
            copy2 = state.length;
            if (copy2 > have) {
              copy2 = have;
            }
            if (copy2) {
              if (state.head) {
                len = state.head.extra_len - state.length;
                if (!state.head.extra) {
                  state.head.extra = new Array(state.head.extra_len);
                }
                utils$1.arraySet(
                  state.head.extra,
                  input,
                  next,
                  // extra field is limited to 65536 bytes
                  // - no need for additional size check
                  copy2,
                  /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                  len
                );
              }
              if (state.flags & 512) {
                state.check = crc32(state.check, input, copy2, next);
              }
              have -= copy2;
              next += copy2;
              state.length -= copy2;
            }
            if (state.length) {
              break inf_leave;
            }
          }
          state.length = 0;
          state.mode = NAME;
        case NAME:
          if (state.flags & 2048) {
            if (have === 0) {
              break inf_leave;
            }
            copy2 = 0;
            do {
              len = input[next + copy2++];
              if (state.head && len && state.length < 65536) {
                state.head.name += String.fromCharCode(len);
              }
            } while (len && copy2 < have);
            if (state.flags & 512) {
              state.check = crc32(state.check, input, copy2, next);
            }
            have -= copy2;
            next += copy2;
            if (len) {
              break inf_leave;
            }
          } else if (state.head) {
            state.head.name = null;
          }
          state.length = 0;
          state.mode = COMMENT;
        case COMMENT:
          if (state.flags & 4096) {
            if (have === 0) {
              break inf_leave;
            }
            copy2 = 0;
            do {
              len = input[next + copy2++];
              if (state.head && len && state.length < 65536) {
                state.head.comment += String.fromCharCode(len);
              }
            } while (len && copy2 < have);
            if (state.flags & 512) {
              state.check = crc32(state.check, input, copy2, next);
            }
            have -= copy2;
            next += copy2;
            if (len) {
              break inf_leave;
            }
          } else if (state.head) {
            state.head.comment = null;
          }
          state.mode = HCRC;
        case HCRC:
          if (state.flags & 512) {
            while (bits2 < 16) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            if (hold !== (state.check & 65535)) {
              strm.msg = "header crc mismatch";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits2 = 0;
          }
          if (state.head) {
            state.head.hcrc = state.flags >> 9 & 1;
            state.head.done = true;
          }
          strm.adler = state.check = 0;
          state.mode = TYPE;
          break;
        case DICTID:
          while (bits2 < 32) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          strm.adler = state.check = zswap32(hold);
          hold = 0;
          bits2 = 0;
          state.mode = DICT;
        case DICT:
          if (state.havedict === 0) {
            strm.next_out = put2;
            strm.avail_out = left2;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits2;
            return Z_NEED_DICT;
          }
          strm.adler = state.check = 1;
          state.mode = TYPE;
        case TYPE:
          if (flush === Z_BLOCK || flush === Z_TREES) {
            break inf_leave;
          }
        case TYPEDO:
          if (state.last) {
            hold >>>= bits2 & 7;
            bits2 -= bits2 & 7;
            state.mode = CHECK;
            break;
          }
          while (bits2 < 3) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          state.last = hold & 1;
          hold >>>= 1;
          bits2 -= 1;
          switch (hold & 3) {
            case 0:
              state.mode = STORED;
              break;
            case 1:
              fixedtables(state);
              state.mode = LEN_;
              if (flush === Z_TREES) {
                hold >>>= 2;
                bits2 -= 2;
                break inf_leave;
              }
              break;
            case 2:
              state.mode = TABLE;
              break;
            case 3:
              strm.msg = "invalid block type";
              state.mode = BAD;
          }
          hold >>>= 2;
          bits2 -= 2;
          break;
        case STORED:
          hold >>>= bits2 & 7;
          bits2 -= bits2 & 7;
          while (bits2 < 32) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if ((hold & 65535) !== (hold >>> 16 ^ 65535)) {
            strm.msg = "invalid stored block lengths";
            state.mode = BAD;
            break;
          }
          state.length = hold & 65535;
          hold = 0;
          bits2 = 0;
          state.mode = COPY_;
          if (flush === Z_TREES) {
            break inf_leave;
          }
        case COPY_:
          state.mode = COPY;
        case COPY:
          copy2 = state.length;
          if (copy2) {
            if (copy2 > have) {
              copy2 = have;
            }
            if (copy2 > left2) {
              copy2 = left2;
            }
            if (copy2 === 0) {
              break inf_leave;
            }
            utils$1.arraySet(output, input, next, copy2, put2);
            have -= copy2;
            next += copy2;
            left2 -= copy2;
            put2 += copy2;
            state.length -= copy2;
            break;
          }
          state.mode = TYPE;
          break;
        case TABLE:
          while (bits2 < 14) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          state.nlen = (hold & 31) + 257;
          hold >>>= 5;
          bits2 -= 5;
          state.ndist = (hold & 31) + 1;
          hold >>>= 5;
          bits2 -= 5;
          state.ncode = (hold & 15) + 4;
          hold >>>= 4;
          bits2 -= 4;
          if (state.nlen > 286 || state.ndist > 30) {
            strm.msg = "too many length or distance symbols";
            state.mode = BAD;
            break;
          }
          state.have = 0;
          state.mode = LENLENS;
        case LENLENS:
          while (state.have < state.ncode) {
            while (bits2 < 3) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            state.lens[order2[state.have++]] = hold & 7;
            hold >>>= 3;
            bits2 -= 3;
          }
          while (state.have < 19) {
            state.lens[order2[state.have++]] = 0;
          }
          state.lencode = state.lendyn;
          state.lenbits = 7;
          opts = {
            bits: state.lenbits
          };
          ret = inflate_table2(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
          state.lenbits = opts.bits;
          if (ret) {
            strm.msg = "invalid code lengths set";
            state.mode = BAD;
            break;
          }
          state.have = 0;
          state.mode = CODELENS;
        case CODELENS:
          while (state.have < state.nlen + state.ndist) {
            for (; ; ) {
              here = state.lencode[hold & (1 << state.lenbits) - 1];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (here_bits <= bits2) {
                break;
              }
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            if (here_val < 16) {
              hold >>>= here_bits;
              bits2 -= here_bits;
              state.lens[state.have++] = here_val;
            } else {
              if (here_val === 16) {
                n = here_bits + 2;
                while (bits2 < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                hold >>>= here_bits;
                bits2 -= here_bits;
                if (state.have === 0) {
                  strm.msg = "invalid bit length repeat";
                  state.mode = BAD;
                  break;
                }
                len = state.lens[state.have - 1];
                copy2 = 3 + (hold & 3);
                hold >>>= 2;
                bits2 -= 2;
              } else if (here_val === 17) {
                n = here_bits + 3;
                while (bits2 < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                hold >>>= here_bits;
                bits2 -= here_bits;
                len = 0;
                copy2 = 3 + (hold & 7);
                hold >>>= 3;
                bits2 -= 3;
              } else {
                n = here_bits + 7;
                while (bits2 < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                hold >>>= here_bits;
                bits2 -= here_bits;
                len = 0;
                copy2 = 11 + (hold & 127);
                hold >>>= 7;
                bits2 -= 7;
              }
              if (state.have + copy2 > state.nlen + state.ndist) {
                strm.msg = "invalid bit length repeat";
                state.mode = BAD;
                break;
              }
              while (copy2--) {
                state.lens[state.have++] = len;
              }
            }
          }
          if (state.mode === BAD) {
            break;
          }
          if (state.lens[256] === 0) {
            strm.msg = "invalid code -- missing end-of-block";
            state.mode = BAD;
            break;
          }
          state.lenbits = 9;
          opts = {
            bits: state.lenbits
          };
          ret = inflate_table2(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
          state.lenbits = opts.bits;
          if (ret) {
            strm.msg = "invalid literal/lengths set";
            state.mode = BAD;
            break;
          }
          state.distbits = 6;
          state.distcode = state.distdyn;
          opts = {
            bits: state.distbits
          };
          ret = inflate_table2(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
          state.distbits = opts.bits;
          if (ret) {
            strm.msg = "invalid distances set";
            state.mode = BAD;
            break;
          }
          state.mode = LEN_;
          if (flush === Z_TREES) {
            break inf_leave;
          }
        case LEN_:
          state.mode = LEN;
        case LEN:
          if (have >= 6 && left2 >= 258) {
            strm.next_out = put2;
            strm.avail_out = left2;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits2;
            inflate_fast2(strm, _out);
            put2 = strm.next_out;
            output = strm.output;
            left2 = strm.avail_out;
            next = strm.next_in;
            input = strm.input;
            have = strm.avail_in;
            hold = state.hold;
            bits2 = state.bits;
            if (state.mode === TYPE) {
              state.back = -1;
            }
            break;
          }
          state.back = 0;
          for (; ; ) {
            here = state.lencode[hold & (1 << state.lenbits) - 1];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 255;
            here_val = here & 65535;
            if (here_bits <= bits2) {
              break;
            }
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if (here_op && (here_op & 240) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;
            for (; ; ) {
              here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (last_bits + here_bits <= bits2) {
                break;
              }
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            hold >>>= last_bits;
            bits2 -= last_bits;
            state.back += last_bits;
          }
          hold >>>= here_bits;
          bits2 -= here_bits;
          state.back += here_bits;
          state.length = here_val;
          if (here_op === 0) {
            state.mode = LIT;
            break;
          }
          if (here_op & 32) {
            state.back = -1;
            state.mode = TYPE;
            break;
          }
          if (here_op & 64) {
            strm.msg = "invalid literal/length code";
            state.mode = BAD;
            break;
          }
          state.extra = here_op & 15;
          state.mode = LENEXT;
        case LENEXT:
          if (state.extra) {
            n = state.extra;
            while (bits2 < n) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            state.length += hold & (1 << state.extra) - 1;
            hold >>>= state.extra;
            bits2 -= state.extra;
            state.back += state.extra;
          }
          state.was = state.length;
          state.mode = DIST;
        case DIST:
          for (; ; ) {
            here = state.distcode[hold & (1 << state.distbits) - 1];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 255;
            here_val = here & 65535;
            if (here_bits <= bits2) {
              break;
            }
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits2;
            bits2 += 8;
          }
          if ((here_op & 240) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;
            for (; ; ) {
              here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (last_bits + here_bits <= bits2) {
                break;
              }
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            hold >>>= last_bits;
            bits2 -= last_bits;
            state.back += last_bits;
          }
          hold >>>= here_bits;
          bits2 -= here_bits;
          state.back += here_bits;
          if (here_op & 64) {
            strm.msg = "invalid distance code";
            state.mode = BAD;
            break;
          }
          state.offset = here_val;
          state.extra = here_op & 15;
          state.mode = DISTEXT;
        case DISTEXT:
          if (state.extra) {
            n = state.extra;
            while (bits2 < n) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            state.offset += hold & (1 << state.extra) - 1;
            hold >>>= state.extra;
            bits2 -= state.extra;
            state.back += state.extra;
          }
          if (state.offset > state.dmax) {
            strm.msg = "invalid distance too far back";
            state.mode = BAD;
            break;
          }
          state.mode = MATCH;
        case MATCH:
          if (left2 === 0) {
            break inf_leave;
          }
          copy2 = _out - left2;
          if (state.offset > copy2) {
            copy2 = state.offset - copy2;
            if (copy2 > state.whave) {
              if (state.sane) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
              }
            }
            if (copy2 > state.wnext) {
              copy2 -= state.wnext;
              from = state.wsize - copy2;
            } else {
              from = state.wnext - copy2;
            }
            if (copy2 > state.length) {
              copy2 = state.length;
            }
            from_source = state.window;
          } else {
            from_source = output;
            from = put2 - state.offset;
            copy2 = state.length;
          }
          if (copy2 > left2) {
            copy2 = left2;
          }
          left2 -= copy2;
          state.length -= copy2;
          do {
            output[put2++] = from_source[from++];
          } while (--copy2);
          if (state.length === 0) {
            state.mode = LEN;
          }
          break;
        case LIT:
          if (left2 === 0) {
            break inf_leave;
          }
          output[put2++] = state.length;
          left2--;
          state.mode = LEN;
          break;
        case CHECK:
          if (state.wrap) {
            while (bits2 < 32) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold |= input[next++] << bits2;
              bits2 += 8;
            }
            _out -= left2;
            strm.total_out += _out;
            state.total += _out;
            if (_out) {
              strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/
              state.flags ? crc32(state.check, output, _out, put2 - _out) : adler32(state.check, output, _out, put2 - _out);
            }
            _out = left2;
            if ((state.flags ? hold : zswap32(hold)) !== state.check) {
              strm.msg = "incorrect data check";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits2 = 0;
          }
          state.mode = LENGTH;
        case LENGTH:
          if (state.wrap && state.flags) {
            while (bits2 < 32) {
              if (have === 0) {
                break inf_leave;
              }
              have--;
              hold += input[next++] << bits2;
              bits2 += 8;
            }
            if (hold !== (state.total & 4294967295)) {
              strm.msg = "incorrect length check";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits2 = 0;
          }
          state.mode = DONE;
        case DONE:
          ret = Z_STREAM_END;
          break inf_leave;
        case BAD:
          ret = Z_DATA_ERROR;
          break inf_leave;
        case MEM:
          return Z_MEM_ERROR;
        case SYNC:
        default:
          return Z_STREAM_ERROR;
      }
    }
  strm.next_out = put2;
  strm.avail_out = left2;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits2;
  if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out))
      ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}
function inflateEnd(strm) {
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}
function inflateGetHeader(strm, head) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  if ((state.wrap & 2) === 0) {
    return Z_STREAM_ERROR;
  }
  state.head = head;
  head.done = false;
  return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;
  var state;
  var dictid;
  var ret;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  state = strm.state;
  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }
  if (state.mode === DICT) {
    dictid = 1;
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  return Z_OK;
}
inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
var constants$1 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
function GZheader$1() {
  this.text = 0;
  this.time = 0;
  this.xflags = 0;
  this.os = 0;
  this.extra = null;
  this.extra_len = 0;
  this.name = "";
  this.comment = "";
  this.hcrc = 0;
  this.done = false;
}
var gzheader = GZheader$1;
var zlib_inflate = inflate$3;
var utils = common;
var strings = strings$2;
var c = constants$1;
var msg = messages;
var ZStream = zstream;
var GZheader = gzheader;
var toString$2 = Object.prototype.toString;
function Inflate(options2) {
  if (!(this instanceof Inflate))
    return new Inflate(options2);
  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ""
  }, options2 || {});
  var opt = this.options;
  if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) {
      opt.windowBits = -15;
    }
  }
  if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options2 && options2.windowBits)) {
    opt.windowBits += 32;
  }
  if (opt.windowBits > 15 && opt.windowBits < 48) {
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }
  this.err = 0;
  this.msg = "";
  this.ended = false;
  this.chunks = [];
  this.strm = new ZStream();
  this.strm.avail_out = 0;
  var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }
  this.header = new GZheader();
  zlib_inflate.inflateGetHeader(this.strm, this.header);
  if (opt.dictionary) {
    if (typeof opt.dictionary === "string") {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString$2.call(opt.dictionary) === "[object ArrayBuffer]") {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) {
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}
Inflate.prototype.push = function(data2, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var allowBufError = false;
  if (this.ended) {
    return false;
  }
  _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;
  if (typeof data2 === "string") {
    strm.input = strings.binstring2buf(data2);
  } else if (toString$2.call(data2) === "[object ArrayBuffer]") {
    strm.input = new Uint8Array(data2);
  } else {
    strm.input = data2;
  }
  strm.next_in = 0;
  strm.avail_in = strm.input.length;
  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);
    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }
    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }
    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH)) {
        if (this.options.to === "string") {
          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) {
            utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
          }
          this.onData(utf8str);
        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }
  return true;
};
Inflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};
Inflate.prototype.onEnd = function(status) {
  if (status === c.Z_OK) {
    if (this.options.to === "string") {
      this.result = this.chunks.join("");
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};
function inflate$1(input, options2) {
  var inflator = new Inflate(options2);
  inflator.push(input, true);
  if (inflator.err) {
    throw inflator.msg || msg[inflator.err];
  }
  return inflator.result;
}
function inflateRaw(input, options2) {
  options2 = options2 || {};
  options2.raw = true;
  return inflate$1(input, options2);
}
inflate$4.Inflate = Inflate;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw;
inflate$4.ungzip = inflate$1;
var assign3 = common.assign;
var deflate = deflate$4;
var inflate = inflate$4;
var constants = constants$1;
var pako = {};
assign3(pako, deflate, inflate, constants);
var pako_1 = pako;
const pako$1 = /* @__PURE__ */ getDefaultExportFromCjs(pako_1);
var months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const MONTHS = months;
function genbankToJson(sequence) {
  if (typeof sequence !== "string") {
    throw new TypeError("input must be a string");
  }
  let resultsArray = [];
  let result;
  let currentFeatureNote;
  let genbankAnnotationKey = {
    // Contains in order: locus name, sequence length, molecule type (e.g. DNA), genbank division (see 1-18 below), modification date
    // locus definition has changed with time, use accession number for a unique identifier
    LOCUS_TAG: "LOCUS",
    DEFINITION_TAG: "DEFINITION",
    // Accession tag
    // Example: Z78533
    ACCESSION_TAG: "ACCESSION",
    // The version tag contains 2 informations
    // The accession number with a revision
    // The GI (GenInfo Identifier), a ncbi sequential number
    // Example: Z78533.1  GI:2765658
    // Unicity garanteed with respect to sequence. If 1 nucleotide changes, the version is different.
    VERSION_TAG: "VERSION",
    KEYWORDS_TAG: "KEYWORDS",
    // SEGMENT_TAG:"SEGMENT"
    // Source is free text
    SOURCE_TAG: "SOURCE",
    ORGANISM_TAG: "ORGANISM",
    REFERENCE_TAG: "REFERENCE",
    AUTHORS_TAG: "AUTHORS",
    CONSORTIUM_TAG: "CONSRTM",
    TITLE_TAG: "TITLE",
    // Can be multiple journal tags
    JOURNAL_TAG: "JOURNAL",
    PUBMED_TAG: "PUBMED",
    REMARK_TAG: "REMARK",
    FEATURES_TAG: "FEATURES",
    BASE_COUNT_TAG: "BASE COUNT",
    // CONTIG_TAG: "CONTIG"
    ORIGIN_TAG: "ORIGIN",
    END_SEQUENCE_TAG: "//"
  };
  let lines = sequence.split(/\r?\n/);
  let fieldName;
  let subFieldType;
  let featureLocationIndentation;
  let lastLineWasFeaturesTag;
  let lastLineWasLocation;
  let hasFoundLocus = false;
  for (let line of lines) {
    if (line === null)
      break;
    let lineFieldName = getLineFieldName(line);
    let val2 = getLineVal(line);
    let isSubKey = isSubKeyword(line);
    let isKey2 = isKeyword(line);
    if (lineFieldName === genbankAnnotationKey.END_SEQUENCE_TAG || isKey2) {
      fieldName = lineFieldName;
      subFieldType = null;
    } else if (isSubKey) {
      subFieldType = lineFieldName;
    }
    if (line.trim() === "" || lineFieldName === ";") {
      continue;
    }
    if (!hasFoundLocus && fieldName !== genbankAnnotationKey.LOCUS_TAG) {
      break;
    }
    switch (fieldName) {
      case genbankAnnotationKey.LOCUS_TAG:
        hasFoundLocus = true;
        parseLocus(line);
        break;
      case genbankAnnotationKey.FEATURES_TAG:
        parseFeatures(line, lineFieldName, val2);
        break;
      case genbankAnnotationKey.ORIGIN_TAG:
        parseOrigin(line, lineFieldName);
        break;
      case genbankAnnotationKey.DEFINITION_TAG:
      case genbankAnnotationKey.ACCESSION_TAG:
      case genbankAnnotationKey.VERSION_TAG:
      case genbankAnnotationKey.KEYWORDS_TAG:
        parseMultiLineField(fieldName, line, fieldName.toLowerCase());
        break;
      case genbankAnnotationKey.SOURCE_TAG:
        if (subFieldType === genbankAnnotationKey.ORGANISM_TAG) {
          parseMultiLineField(subFieldType, line, "organism");
        } else {
          parseMultiLineField(lineFieldName, line, "source");
        }
        break;
      case genbankAnnotationKey.REFERENCE_TAG:
        if (lineFieldName === genbankAnnotationKey.REFERENCE_TAG) {
          const ref2 = result.references || [];
          result.references = ref2;
          ref2.push({});
        }
        parseReference(line, subFieldType);
        break;
      case genbankAnnotationKey.END_SEQUENCE_TAG:
        endSeq();
        break;
    }
  }
  if (resultsArray[resultsArray.length - 1] !== result) {
    endSeq();
  }
  return resultsArray;
  function endSeq() {
    postProcessCurSeq();
    resultsArray.push(result);
  }
  function getCurrentFeature() {
    return result.features[result.features.length - 1];
  }
  function postProcessCurSeq() {
    if (result && result.features) {
      for (let i = 0; i < result.features.length; i++) {
        result.features[i] = postProcessGenbankFeature(result.features[i]);
      }
    }
  }
  function parseOrigin(line, key) {
    if (key !== genbankAnnotationKey.ORIGIN_TAG) {
      let newLine = line.replace(/[\s]*[0-9]*/g, "");
      result.sequence += newLine;
    }
  }
  function parseLocus(line) {
    result = {
      features: [],
      name: "Untitled sequence",
      sequence: "",
      references: []
    };
    line = removeFieldName(genbankAnnotationKey.LOCUS_TAG, line);
    const m = line.match(/^([^\s]+)\s+(\d+)\s+bp\s+([^\s]+)\s+([^\s]+)\s+([^\s]+)\s*([^\s]+)?$/);
    let locusName = m[1];
    let size = +m[2];
    let moleculeType = m[3];
    let circular = m[4] === "circular";
    const seq = result;
    let dateStr = "";
    if (!m[6]) {
      dateStr = m[5];
    } else {
      seq.genbankDivision = m[5];
      dateStr = m[6];
    }
    seq.circular = circular;
    seq.moleculeType = moleculeType;
    const dateMatch = dateStr.match(/^(\d{2})-(.{3})-(\d{4})$/);
    const date2 = /* @__PURE__ */ new Date();
    date2.setFullYear(+dateMatch[3]);
    date2.setUTCMonth(MONTHS.indexOf(dateMatch[2].toUpperCase()));
    date2.setDate(+dateMatch[1]);
    date2.setUTCHours(12);
    date2.setMinutes(0);
    date2.setSeconds(0);
    date2.setMilliseconds(0);
    seq.date = date2.toISOString();
    seq.name = locusName;
    seq.size = size;
  }
  function removeFieldName(fName, line) {
    line = line.replace(/^\s*/, "");
    if (line.indexOf(fName) === 0) {
      line = line.replace(fName, "");
    }
    return line.trim();
  }
  function parseReference(line, subType) {
    const refs = result.references;
    let lastRef = refs[refs.length - 1];
    if (!subType) {
      parseMultiLineField(genbankAnnotationKey.REFERENCE_TAG, line, "description", lastRef);
    } else {
      parseMultiLineField(subType, line, subType.toLowerCase(), lastRef);
    }
  }
  function parseFeatures(line, key, val2) {
    let strand;
    if (key === genbankAnnotationKey.FEATURES_TAG) {
      lastLineWasFeaturesTag = true;
      return;
    }
    if (lastLineWasFeaturesTag) {
      featureLocationIndentation = getLengthOfWhiteSpaceBeforeStartOfLetters(line);
      lastLineWasFeaturesTag = false;
    }
    if (isFeatureLineRunon(line, featureLocationIndentation)) {
      if (lastLineWasLocation) {
        parseFeatureLocation(line.trim());
        lastLineWasLocation = true;
      } else {
        if (currentFeatureNote) {
          currentFeatureNote[currentFeatureNote.length - 1] += line.trim().replace(/"/g, "");
        }
        lastLineWasLocation = false;
      }
    } else {
      if (isNote(line)) {
        if (getCurrentFeature()) {
          parseFeatureNote(line);
          lastLineWasLocation = false;
        }
      } else {
        if (val2.match(/complement/g)) {
          strand = -1;
        } else {
          strand = 1;
        }
        newFeature();
        let feat = getCurrentFeature();
        feat.type = key;
        feat.strand = strand;
        parseFeatureLocation(val2);
        lastLineWasLocation = true;
      }
    }
  }
  function newFeature() {
    result.features.push({
      notes: {}
    });
  }
  function isNote(line) {
    let qual = false;
    if (line.trim().charAt(0).match(/\//)) {
      qual = true;
    } else if (line.match(/^[\s]*\/[\w]+=[\S]+/)) {
      qual = true;
    }
    return qual;
  }
  function parseFeatureLocation(locStr) {
    locStr = locStr.trim();
    let locArr = [];
    locStr.replace(/(\d+)/g, function(string, match) {
      locArr.push(match);
    });
    let feat = getCurrentFeature();
    feat.start = +locArr[0];
    feat.end = locArr[1] === void 0 ? +locArr[0] : +locArr[1];
  }
  function parseFeatureNote(line) {
    let newLine, lineArr;
    newLine = line.trim();
    newLine = newLine.replace(/^\/|"$/g, "");
    lineArr = newLine.split(/="|=/);
    let val2 = lineArr[1];
    if (val2) {
      val2 = val2.replace(/\\/g, " ");
      if (line.match(/="/g)) {
        val2 = val2.replace(/".*/g, "");
      } else if (val2.match(/^\d+$/g)) {
        val2 = +val2;
      }
    }
    let key = lineArr[0];
    let currentNotes = getCurrentFeature().notes;
    if (currentNotes[key]) {
      currentNotes[key].push(val2);
    } else {
      currentNotes[key] = [val2];
    }
    currentFeatureNote = currentNotes[key];
  }
  function getLineFieldName(line) {
    let arr;
    line = line.trim();
    arr = line.split(/[\s]+/);
    return arr[0];
  }
  function parseMultiLineField(fName, line, resultKey, r2) {
    r2 = r2 || result;
    let fieldValue = removeFieldName(fName, line);
    r2[resultKey] = r2[resultKey] ? `${r2[resultKey]} ` : "";
    r2[resultKey] += fieldValue;
  }
  function getLineVal(line) {
    let arr;
    if (line.indexOf("=") < 0) {
      line = line.replace(/^[\s]*[\S]+[\s]+|[\s]+$/, "");
      line = line.trim();
      return line;
    } else {
      arr = line.split(/=/);
      return arr[1];
    }
  }
  function isKeyword(line) {
    let isKey2 = false;
    if (line.substr(0, 10).match(/^[\S]+/)) {
      isKey2 = true;
    }
    return isKey2;
  }
  function isSubKeyword(line) {
    let isSubKey = false;
    if (line.substr(0, 10).match(/^[\s]+[\S]+/)) {
      isSubKey = true;
    }
    return isSubKey;
  }
  function postProcessGenbankFeature(feat) {
    if (feat.notes.label) {
      feat.name = feat.notes.label[0];
    } else if (feat.notes.gene) {
      feat.name = feat.notes.gene[0];
    } else if (feat.notes.ApEinfo_label) {
      feat.name = feat.notes.ApEinfo_label[0];
    } else if (feat.notes.name) {
      feat.name = feat.notes.name[0];
    } else if (feat.notes.organism) {
      feat.name = feat.notes.organism[0];
    } else if (feat.notes.locus_tag) {
      feat.name = feat.notes.locus_tag[0];
    } else if (feat.notes.note) {
      feat.name = feat.notes.note[0];
    } else {
      feat.name = "Untitled Feature";
    }
    feat.name = typeof feat.name === "string" ? feat.name : String(feat.name);
    return feat;
  }
}
function isFeatureLineRunon(line, featureLocationIndentation) {
  let indentationOfLine = getLengthOfWhiteSpaceBeforeStartOfLetters(line);
  if (featureLocationIndentation === indentationOfLine) {
    return false;
  }
  let trimmed = line.trim();
  if (trimmed.charAt(0).match(/\//)) {
    return false;
  }
  return true;
}
function getLengthOfWhiteSpaceBeforeStartOfLetters(string) {
  let match = /^\s*/.exec(string);
  if (match !== null) {
    return match[0].length;
  } else {
    return 0;
  }
}
var src = genbankToJson;
const genbankParser = /* @__PURE__ */ getDefaultExportFromCjs(src);
function _classCallCheck$I(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$x(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$x(descriptor.key), descriptor);
  }
}
function _createClass$G(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$x(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$x(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$x(arg) {
  var key = _toPrimitive$x(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$x(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function collapse(segments, scale, strand) {
  const collapsed2 = [];
  const MAX_DIST_BETWEEN = 5;
  if (!segments.length) {
    return [];
  }
  let currStart = segments[0].start;
  let currEnd = segments[0].end;
  for (let i = 1; i < segments.length; i++) {
    if (segments[i].start < currEnd + MAX_DIST_BETWEEN * 1 / scale) {
      currEnd = Math.max(currEnd, segments[i].end);
    } else {
      collapsed2.push({
        type: "filler",
        start: currStart,
        end: currEnd,
        strand
      });
      currStart = segments[i].start;
      currEnd = segments[i].end;
    }
  }
  collapsed2.push({
    start: currStart,
    end: currEnd,
    type: "filler",
    strand
  });
  return collapsed2;
}
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}
function isFillerSegment(x) {
  return x.type === "filler";
}
function genbankFeatureToHiGlassGeneAnnotation(gb) {
  const importance = gb.end - gb.start;
  const strand = gb.strand === 1 ? "+" : "-";
  const uid = slugid$1.nice();
  if (isFillerSegment(gb)) {
    return {
      xStart: gb.start,
      xEnd: gb.end,
      strand: gb.strand,
      fields: [],
      type: "filler",
      uid
    };
  }
  return {
    xStart: gb.start,
    xEnd: gb.end,
    strand,
    chrOffset: 0,
    importance: gb.end - gb.start,
    uid,
    type: gb.type,
    fields: ["chrom", gb.start, gb.end, gb.name, importance, strand, "", "", gb.type, gb.name, gb.start.toString(), gb.end.toString(), gb.start.toString(), gb.end.toString()]
  };
}
function gbToJsonAndFeatures(gbText) {
  const gbJson = genbankParser(gbText);
  const features = shuffle(gbJson[0].features.filter((f2) => f2.type !== "source").sort((a, b) => a.start - b.start));
  return {
    json: gbJson,
    features
  };
}
async function extractResponse(response, {
  gzipped
}) {
  if (!gzipped)
    return response.text();
  const buffer2 = await response.arrayBuffer();
  return pako$1.inflate(buffer2, {
    to: "string"
  });
}
let GBKDataFetcher = /* @__PURE__ */ function() {
  function GBKDataFetcher2(dataConfig) {
    _classCallCheck$I(this, GBKDataFetcher2);
    this.dataConfig = dataConfig;
    this.trackUid = slugid$1.nice();
    this.errorTxt = "";
    let textPromise;
    if (dataConfig.url) {
      const extension = dataConfig.url.slice(dataConfig.url.length - 3);
      textPromise = fetch(dataConfig.url, {
        mode: "cors",
        redirect: "follow",
        method: "GET"
      }).then((r2) => extractResponse(r2, {
        gzipped: extension === ".gz"
      }));
    } else if (dataConfig.text) {
      textPromise = Promise.resolve(dataConfig.text);
    } else {
      throw new Error("No data or URL specified");
    }
    this.gbDataPromise = textPromise.then((text2) => gbToJsonAndFeatures(text2));
  }
  _createClass$G(GBKDataFetcher2, [{
    key: "tilesetInfo",
    value: function tilesetInfo(callback) {
      this.tilesetInfoLoading = true;
      return this.gbDataPromise.then((gbData) => {
        this.tilesetInfoLoading = false;
        const TILE_SIZE = 1024;
        const retVal = {
          name: `genbank-${this.trackUid}`,
          tile_size: TILE_SIZE,
          max_zoom: Math.ceil(Math.log(gbData.json[0].size / TILE_SIZE) / Math.log(2)),
          max_width: gbData.json[0].size,
          min_pos: [0],
          max_pos: [gbData.json[0].size]
        };
        if (callback) {
          callback(retVal);
        }
        return retVal;
      }).catch((err2) => {
        this.tilesetInfoLoading = false;
        if (callback) {
          callback({
            error: `Error parsing genbank: ${err2}`
          });
        }
        return void 0;
      });
    }
    /**
     * @param {(tiles: Record<string, GenbankTile>) => void} receivedTiles
     * @param {string[]} tileIds
     * @returns {Promise<Record<string, GenbankTile>>}
     */
  }, {
    key: "fetchTilesDebounced",
    value: async function fetchTilesDebounced2(receivedTiles, tileIds) {
      const tiles = {};
      const validTileIds = [];
      const tilePromises = [];
      for (const tileId of tileIds) {
        const parts = tileId.split(".");
        const z = parseInt(parts[0], 10);
        const x = parseInt(parts[1], 10);
        if (Number.isNaN(x) || Number.isNaN(z)) {
          console.warn("Invalid tile zoom or position:", z, x);
          continue;
        }
        validTileIds.push(tileId);
        tilePromises.push(this.tile(z, x));
      }
      const values2 = await Promise.all(tilePromises);
      for (let i = 0; i < values2.length; i++) {
        const validTileId = validTileIds[i];
        tiles[validTileId] = values2[i];
        tiles[validTileId].tilePositionId = validTileId;
      }
      receivedTiles(tiles);
      return tiles;
    }
    /**
     * @param {number} z
     * @param {number} x
     * @returns {Promise<GeneAnnotation[]>}
     */
  }, {
    key: "tile",
    value: async function tile(z, x) {
      const [tsInfo, gbData] = await Promise.all([this.tilesetInfo(), this.gbDataPromise]);
      if (!tsInfo) {
        throw new Error("No tileset info");
      }
      const tileWidth = +tsInfo.max_width / 2 ** +z;
      const minX = tsInfo.min_pos[0] + x * tileWidth;
      const maxX = tsInfo.min_pos[0] + (x + 1) * tileWidth;
      const filtered = gbData.features.filter((v) => v.end > minX && v.start < maxX);
      const scaleFactor = 1024 / 2 ** (tsInfo.max_zoom - z);
      const collapsedPlus = collapse(filtered.filter((v) => v.strand === 1), scaleFactor, "+");
      const collapsedMinus = collapse(filtered.filter((v) => v.strand !== 1), scaleFactor, "-");
      const values2 = [];
      const TILE_CAPACITY = 20;
      for (let i = 0; i < gbData.features.length; i++) {
        if (values2.length >= TILE_CAPACITY) {
          break;
        }
        if (gbData.features[i].end >= minX && gbData.features[i].start <= maxX) {
          values2.push(gbData.features[i]);
        }
      }
      return [values2, collapsedPlus, collapsedMinus].flatMap((v) => v.map(genbankFeatureToHiGlassGeneAnnotation));
    }
  }]);
  return GBKDataFetcher2;
}();
function _classCallCheck$H(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$w(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$w(descriptor.key), descriptor);
  }
}
function _createClass$F(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$w(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$w(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$w(arg) {
  var key = _toPrimitive$w(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$w(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
let LocalTileDataFetcher = /* @__PURE__ */ function() {
  function LocalTileDataFetcher2(dataConfig) {
    _classCallCheck$H(this, LocalTileDataFetcher2);
    this.dataConfig = dataConfig;
    this.tilesetInfoData = Object.values(this.dataConfig.tilesetInfo)[0];
    this.tilesData = {};
    this.tilesetInfoLoading = true;
  }
  _createClass$F(LocalTileDataFetcher2, [{
    key: "tilesetInfo",
    value: async function tilesetInfo(callback) {
      this.tilesetInfoLoading = false;
      callback(this.tilesetInfoData);
      return this.tilesetInfoData;
    }
    /** We expect there to be a tilesetUid in the provided tilesetInfo
     * and tiles data since tileResponseToData needs it
     *
     * It is also easier for users to paste in request responses for debugging.
     *
     * @param {(tiles: Record<string, LocalTile>) => void} receivedTiles
     * @param {string[]} tileIds
     */
  }, {
    key: "fetchTilesDebounced",
    value: async function fetchTilesDebounced2(receivedTiles, tileIds) {
      this.tilesData = {};
      for (const key of Object.keys(this.dataConfig.tiles)) {
        const keyParts = key.split(".");
        const newKey = `localtile.${keyParts.slice(1).join(".")}`;
        this.tilesData[newKey] = this.dataConfig.tiles[key];
      }
      const ret = {};
      const newTileIds = tileIds.map((x) => `localtile.${x}`);
      tileResponseToData(this.tilesData, "", newTileIds);
      for (const tileId of tileIds) {
        ret[tileId] = this.tilesData[`localtile.${tileId}`];
      }
      receivedTiles(ret);
      return ret;
    }
    /**
     * @param {number} z
     * @param {number} x
     * @returns {void}
     */
  }, {
    key: "tile",
    value: function tile(z, x) {
    }
  }]);
  return LocalTileDataFetcher2;
}();
const getDataFetcher$1 = (dataConfig, pubSub, pluginDataFetchers, availableForPlugins = AVAILABLE_FOR_PLUGINS) => {
  const pluginDataFetcher = pluginDataFetchers[dataConfig.type];
  if (pluginDataFetcher) {
    return new pluginDataFetcher.dataFetcher(availableForPlugins, dataConfig, pubSub);
  }
  if (dataConfig.type === "genbank") {
    return new GBKDataFetcher(dataConfig, pubSub);
  }
  if (dataConfig.type === "local-tiles") {
    return new LocalTileDataFetcher(dataConfig, pubSub);
  }
  return new DataFetcher(dataConfig, pubSub);
};
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
  return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
  return (x = sin(x / 2)) * x;
}
function noop$2() {
}
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
var streamObjectType = {
  Feature: function(object2, stream) {
    streamGeometry(object2.geometry, stream);
  },
  FeatureCollection: function(object2, stream) {
    var features = object2.features, i = -1, n = features.length;
    while (++i < n)
      streamGeometry(features[i].geometry, stream);
  }
};
var streamGeometryType = {
  Sphere: function(object2, stream) {
    stream.sphere();
  },
  Point: function(object2, stream) {
    object2 = object2.coordinates;
    stream.point(object2[0], object2[1], object2[2]);
  },
  MultiPoint: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      object2 = coordinates2[i], stream.point(object2[0], object2[1], object2[2]);
  },
  LineString: function(object2, stream) {
    streamLine(object2.coordinates, stream, 0);
  },
  MultiLineString: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      streamLine(coordinates2[i], stream, 0);
  },
  Polygon: function(object2, stream) {
    streamPolygon(object2.coordinates, stream);
  },
  MultiPolygon: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      streamPolygon(coordinates2[i], stream);
  },
  GeometryCollection: function(object2, stream) {
    var geometries = object2.geometries, i = -1, n = geometries.length;
    while (++i < n)
      streamGeometry(geometries[i], stream);
  }
};
function streamLine(coordinates2, stream, closed) {
  var i = -1, n = coordinates2.length - closed, coordinate;
  stream.lineStart();
  while (++i < n)
    coordinate = coordinates2[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates2, stream) {
  var i = -1, n = coordinates2.length;
  stream.polygonStart();
  while (++i < n)
    streamLine(coordinates2[i], stream, 1);
  stream.polygonEnd();
}
function geoStream(object2, stream) {
  if (object2 && streamObjectType.hasOwnProperty(object2.type)) {
    streamObjectType[object2.type](object2, stream);
  } else {
    streamGeometry(object2, stream);
  }
}
var areaRingSum$1 = new Adder();
var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
var areaStream$1 = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function() {
    areaRingSum$1 = new Adder();
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum$1;
    areaSum$1.add(areaRing < 0 ? tau + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$2;
  },
  sphere: function() {
    areaSum$1.add(tau);
  }
};
function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}
function areaRingEnd$1() {
  areaPoint$1(lambda00$2, phi00$2);
}
function areaPointFirst$1(lambda, phi) {
  areaStream$1.point = areaPoint$1;
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, cosPhi0$1 = cos(phi = phi / 2 + quarterPi), sinPhi0$1 = sin(phi);
}
function areaPoint$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi;
  var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos(phi), sinPhi = sin(phi), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos(adLambda), v = k * sdLambda * sin(adLambda);
  areaRingSum$1.add(atan2(v, u));
  lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
}
function area(object2) {
  areaSum$1 = new Adder();
  geoStream(object2, areaStream$1);
  return areaSum$1 * 2;
}
function spherical(cartesian2) {
  return [atan2(cartesian2[1], cartesian2[0]), asin(cartesian2[2])];
}
function cartesian(spherical2) {
  var lambda = spherical2[0], phi = spherical2[1], cosPhi = cos(phi);
  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
}
function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}
var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
var boundsStream$2 = {
  point: boundsPoint$1,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream$2.point = boundsRingPoint;
    boundsStream$2.lineStart = boundsRingStart;
    boundsStream$2.lineEnd = boundsRingEnd;
    deltaSum = new Adder();
    areaStream$1.polygonStart();
  },
  polygonEnd: function() {
    areaStream$1.polygonEnd();
    boundsStream$2.point = boundsPoint$1;
    boundsStream$2.lineStart = boundsLineStart;
    boundsStream$2.lineEnd = boundsLineEnd;
    if (areaRingSum$1 < 0)
      lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon)
      phi1 = 90;
    else if (deltaSum < -epsilon)
      phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  },
  sphere: function() {
    lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};
function boundsPoint$1(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0)
    phi0 = phi;
  if (phi > phi1)
    phi1 = phi;
}
function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p), equatorial = [normal[1], -normal[0], 0], inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2, sign2 = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign2, phii, antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda)) {
      phii = inflection[1] * degrees;
      if (phii > phi1)
        phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda)) {
      phii = -inflection[1] * degrees;
      if (phii < phi0)
        phi0 = phii;
    } else {
      if (phi < phi0)
        phi0 = phi;
      if (phi > phi1)
        phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1))
          lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1))
          lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1)
          lambda0$1 = lambda;
        if (lambda > lambda1)
          lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1))
            lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1))
            lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0)
    phi0 = phi;
  if (phi > phi1)
    phi1 = phi;
  p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
  boundsStream$2.point = linePoint;
}
function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream$2.point = boundsPoint$1;
  p0 = null;
}
function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream$1.point(lambda, phi);
  linePoint(lambda, phi);
}
function boundsRingStart() {
  areaStream$1.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream$1.lineEnd();
  if (abs(deltaSum) > epsilon)
    lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}
function angle(lambda02, lambda12) {
  return (lambda12 -= lambda02) < 0 ? lambda12 + 360 : lambda12;
}
function rangeCompare(a, b) {
  return a[0] - b[0];
}
function rangeContains(range2, x) {
  return range2[0] <= range2[1] ? range2[0] <= x && x <= range2[1] : x < range2[0] || range2[1] < x;
}
function bounds(feature) {
  var i, n, a, b, merged, deltaMax, delta;
  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream$2);
  if (n = ranges.length) {
    ranges.sort(rangeCompare);
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1]))
          a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1]))
          a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax)
        deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }
  ranges = range = null;
  return lambda0$1 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0$1, phi0], [lambda1, phi1]];
}
var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0;
var centroidStream$1 = {
  sphere: noop$2,
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  }
};
function centroidPoint$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
}
function centroidPointCartesian(x, y, z) {
  ++W0;
  X0$1 += (x - X0$1) / W0;
  Y0$1 += (y - Y0$1) / W0;
  Z0$1 += (z - Z0$1) / W0;
}
function centroidLineStart$1() {
  centroidStream$1.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi);
  x0$4 = cosPhi * cos(lambda);
  y0$4 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidStream$1.point = centroidLinePoint;
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi), x = cosPhi * cos(lambda), y = cosPhi * sin(lambda), z = sin(phi), w = atan2(sqrt((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingStart$1() {
  centroidStream$1.point = centroidRingPointFirst;
}
function centroidRingEnd$1() {
  centroidRingPoint(lambda00, phi00);
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  centroidStream$1.point = centroidRingPoint;
  var cosPhi = cos(phi);
  x0$4 = cosPhi * cos(lambda);
  y0$4 = cosPhi * sin(lambda);
  z0 = sin(phi);
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos(phi), x = cosPhi * cos(lambda), y = cosPhi * sin(lambda), z = sin(phi), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin(m), v = m && -w / m;
  X2$1.add(v * cx);
  Y2$1.add(v * cy);
  Z2$1.add(v * cz);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroid(object2) {
  W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
  X2$1 = new Adder();
  Y2$1 = new Adder();
  Z2$1 = new Adder();
  geoStream(object2, centroidStream$1);
  var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
  if (m < epsilon2) {
    x = X1$1, y = Y1$1, z = Z1$1;
    if (W1 < epsilon)
      x = X0$1, y = Y0$1, z = Z0$1;
    m = hypot(x, y, z);
    if (m < epsilon2)
      return [NaN, NaN];
  }
  return [atan2(y, x) * degrees, asin(z / m) * degrees];
}
function constant$1(x) {
  return function() {
    return x;
  };
}
function compose(a, b) {
  function compose2(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }
  if (a.invert && b.invert)
    compose2.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
  return compose2;
}
function rotationIdentity(lambda, phi) {
  return [abs(lambda) > pi ? lambda + Math.round(-lambda / tau) * tau : lambda, phi];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
  };
}
function rotationLambda(deltaLambda) {
  var rotation2 = forwardRotationLambda(deltaLambda);
  rotation2.invert = forwardRotationLambda(-deltaLambda);
  return rotation2;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos(deltaPhi), sinDeltaPhi = sin(deltaPhi), cosDeltaGamma = cos(deltaGamma), sinDeltaGamma = sin(deltaGamma);
  function rotation2(lambda, phi) {
    var cosPhi = cos(phi), x = cos(lambda) * cosPhi, y = sin(lambda) * cosPhi, z = sin(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), asin(k * cosDeltaGamma + y * sinDeltaGamma)];
  }
  rotation2.invert = function(lambda, phi) {
    var cosPhi = cos(phi), x = cos(lambda) * cosPhi, y = sin(lambda) * cosPhi, z = sin(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), asin(k * cosDeltaPhi - x * sinDeltaPhi)];
  };
  return rotation2;
}
function rotation(rotate2) {
  rotate2 = rotateRadians(rotate2[0] * radians, rotate2[1] * radians, rotate2.length > 2 ? rotate2[2] * radians : 0);
  function forward(coordinates2) {
    coordinates2 = rotate2(coordinates2[0] * radians, coordinates2[1] * radians);
    return coordinates2[0] *= degrees, coordinates2[1] *= degrees, coordinates2;
  }
  forward.invert = function(coordinates2) {
    coordinates2 = rotate2.invert(coordinates2[0] * radians, coordinates2[1] * radians);
    return coordinates2[0] *= degrees, coordinates2[1] *= degrees, coordinates2;
  };
  return forward;
}
function circleStream(stream, radius, delta, direction, t02, t12) {
  if (!delta)
    return;
  var cosRadius = cos(radius), sinRadius = sin(radius), step = direction * delta;
  if (t02 == null) {
    t02 = radius + direction * tau;
    t12 = radius - step / 2;
  } else {
    t02 = circleRadius(cosRadius, t02);
    t12 = circleRadius(cosRadius, t12);
    if (direction > 0 ? t02 < t12 : t02 > t12)
      t02 += direction * tau;
  }
  for (var point2, t = t02; direction > 0 ? t > t12 : t < t12; t -= step) {
    point2 = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
    stream.point(point2[0], point2[1]);
  }
}
function circleRadius(cosRadius, point2) {
  point2 = cartesian(point2), point2[0] -= cosRadius;
  cartesianNormalizeInPlace(point2);
  var radius = acos(-point2[1]);
  return ((-point2[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
}
function circle$1() {
  var center2 = constant$1([0, 0]), radius = constant$1(90), precision = constant$1(6), ring, rotate2, stream = {
    point: point2
  };
  function point2(x, y) {
    ring.push(x = rotate2(x, y));
    x[0] *= degrees, x[1] *= degrees;
  }
  function circle2() {
    var c2 = center2.apply(this, arguments), r2 = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate2 = rotateRadians(-c2[0] * radians, -c2[1] * radians, 0).invert;
    circleStream(stream, r2, p, 1);
    c2 = {
      type: "Polygon",
      coordinates: [ring]
    };
    ring = rotate2 = null;
    return c2;
  }
  circle2.center = function(_) {
    return arguments.length ? (center2 = typeof _ === "function" ? _ : constant$1([+_[0], +_[1]]), circle2) : center2;
  };
  circle2.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$1(+_), circle2) : radius;
  };
  circle2.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$1(+_), circle2) : precision;
  };
  return circle2;
}
function clipBuffer() {
  var lines = [], line;
  return {
    point: function(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$2,
    rejoin: function() {
      if (lines.length > 1)
        lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}
function pointEqual(a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
}
function Intersection(point2, points, other, entry) {
  this.x = point2;
  this.z = points;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream) {
  var subject = [], clip2 = [], i, n;
  segments.forEach(function(segment) {
    if ((n2 = segment.length - 1) <= 0)
      return;
    var n2, p02 = segment[0], p1 = segment[n2], x;
    if (pointEqual(p02, p1)) {
      if (!p02[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n2; ++i)
          stream.point((p02 = segment[i])[0], p02[1]);
        stream.lineEnd();
        return;
      }
      p1[0] += 2 * epsilon;
    }
    subject.push(x = new Intersection(p02, segment, null, true));
    clip2.push(x.o = new Intersection(p02, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip2.push(x.o = new Intersection(p1, null, x, true));
  });
  if (!subject.length)
    return;
  clip2.sort(compareIntersection2);
  link(subject);
  link(clip2);
  for (i = 0, n = clip2.length; i < n; ++i) {
    clip2[i].e = startInside = !startInside;
  }
  var start2 = subject[0], points, point2;
  while (1) {
    var current = start2, isSubject = true;
    while (current.v)
      if ((current = current.n) === start2)
        return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i)
            stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i)
            stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link(array2) {
  if (!(n = array2.length))
    return;
  var n, i = 0, a = array2[0], b;
  while (++i < n) {
    a.n = b = array2[i];
    b.p = a;
    a = b;
  }
  a.n = b = array2[0];
  b.p = a;
}
function longitude(point2) {
  if (abs(point2[0]) <= pi)
    return point2[0];
  else
    return sign(point2[0]) * ((abs(point2[0]) + pi) % tau - pi);
}
function polygonContains(polygon, point2) {
  var lambda = longitude(point2), phi = point2[1], sinPhi = sin(phi), normal = [sin(lambda), -cos(lambda), 0], angle2 = 0, winding = 0;
  var sum2 = new Adder();
  if (sinPhi === 1)
    phi = halfPi + epsilon;
  else if (sinPhi === -1)
    phi = -halfPi - epsilon;
  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length))
      continue;
    var ring, m, point0 = ring[m - 1], lambda02 = longitude(point0), phi02 = point0[1] / 2 + quarterPi, sinPhi02 = sin(phi02), cosPhi02 = cos(phi02);
    for (var j = 0; j < m; ++j, lambda02 = lambda12, sinPhi02 = sinPhi1, cosPhi02 = cosPhi1, point0 = point1) {
      var point1 = ring[j], lambda12 = longitude(point1), phi12 = point1[1] / 2 + quarterPi, sinPhi1 = sin(phi12), cosPhi1 = cos(phi12), delta = lambda12 - lambda02, sign2 = delta >= 0 ? 1 : -1, absDelta = sign2 * delta, antimeridian = absDelta > pi, k = sinPhi02 * sinPhi1;
      sum2.add(atan2(k * sign2 * sin(absDelta), cosPhi02 * cosPhi1 + k * cos(absDelta)));
      angle2 += antimeridian ? delta + sign2 * tau : delta;
      if (antimeridian ^ lambda02 >= lambda ^ lambda12 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection2 = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection2);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection2[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle2 < -epsilon || angle2 < epsilon && sum2 < -epsilon2) ^ winding & 1;
}
function clip(pointVisible, clipLine2, interpolate2, start2) {
  return function(sink) {
    var line = clipLine2(sink), ringBuffer = clipBuffer(), ringSink = clipLine2(ringBuffer), polygonStarted = false, polygon, segments, ring;
    var clip2 = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        clip2.point = pointRing;
        clip2.lineStart = ringStart;
        clip2.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip2.point = point2;
        clip2.lineStart = lineStart;
        clip2.lineEnd = lineEnd;
        segments = merge$4(segments);
        var startInside = polygonContains(polygon, start2);
        if (segments.length) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate2, sink);
        } else if (startInside) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate2(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted)
          sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate2(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point2(lambda, phi) {
      if (pointVisible(lambda, phi))
        sink.point(lambda, phi);
    }
    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }
    function lineStart() {
      clip2.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip2.point = point2;
      line.lineEnd();
    }
    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point3;
      ring.pop();
      polygon.push(ring);
      ring = null;
      if (!n)
        return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i)
            sink.point((point3 = segment[i])[0], point3[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n > 1 && clean & 2)
        ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip2;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
}
const clipAntimeridian = clip(function() {
  return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [-pi, -halfPi]);
function clipAntimeridianLine(stream) {
  var lambda02 = NaN, phi02 = NaN, sign0 = NaN, clean;
  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda12, phi12) {
      var sign1 = lambda12 > 0 ? pi : -pi, delta = abs(lambda12 - lambda02);
      if (abs(delta - pi) < epsilon) {
        stream.point(lambda02, phi02 = (phi02 + phi12) / 2 > 0 ? halfPi : -halfPi);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        stream.point(lambda12, phi02);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi) {
        if (abs(lambda02 - sign0) < epsilon)
          lambda02 -= sign0 * epsilon;
        if (abs(lambda12 - sign1) < epsilon)
          lambda12 -= sign1 * epsilon;
        phi02 = clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        clean = 0;
      }
      stream.point(lambda02 = lambda12, phi02 = phi12);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda02 = phi02 = NaN;
    },
    clean: function() {
      return 2 - clean;
    }
  };
}
function clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12) {
  var cosPhi02, cosPhi1, sinLambda0Lambda1 = sin(lambda02 - lambda12);
  return abs(sinLambda0Lambda1) > epsilon ? atan((sin(phi02) * (cosPhi1 = cos(phi12)) * sin(lambda12) - sin(phi12) * (cosPhi02 = cos(phi02)) * sin(lambda02)) / (cosPhi02 * cosPhi1 * sinLambda0Lambda1)) : (phi02 + phi12) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi;
    stream.point(-pi, phi);
    stream.point(0, phi);
    stream.point(pi, phi);
    stream.point(pi, 0);
    stream.point(pi, -phi);
    stream.point(0, -phi);
    stream.point(-pi, -phi);
    stream.point(-pi, 0);
    stream.point(-pi, phi);
  } else if (abs(from[0] - to[0]) > epsilon) {
    var lambda = from[0] < to[0] ? pi : -pi;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}
function clipCircle(radius) {
  var cr = cos(radius), delta = 6 * radians, smallRadius = cr > 0, notHemisphere = abs(cr) > epsilon;
  function interpolate2(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }
  function visible(lambda, phi) {
    return cos(lambda) * cos(phi) > cr;
  }
  function clipLine2(stream) {
    var point0, c0, v0, v00, clean;
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi], point2, v = visible(lambda, phi), c2 = smallRadius ? v ? 0 : code2(lambda, phi) : v ? code2(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
        if (!point0 && (v00 = v0 = v))
          stream.lineStart();
        if (v !== v0) {
          point2 = intersect2(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2))
            point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            stream.lineStart();
            point2 = intersect2(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            point2 = intersect2(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          if (!(c2 & c0) && (t = intersect2(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c2;
      },
      lineEnd: function() {
        if (v0)
          stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect2(a, b, two) {
    var pa = cartesian(a), pb = cartesian(b);
    var n1 = [1, 0, 0], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
    if (!determinant)
      return !two && a;
    var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A5 = cartesianScale(n1, c1), B2 = cartesianScale(n2, c2);
    cartesianAddInPlace(A5, B2);
    var u = n1xn2, w = cartesianDot(A5, u), uu = cartesianDot(u, u), t22 = w * w - uu * (cartesianDot(A5, A5) - 1);
    if (t22 < 0)
      return;
    var t = sqrt(t22), q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A5);
    q = spherical(q);
    if (!two)
      return q;
    var lambda02 = a[0], lambda12 = b[0], phi02 = a[1], phi12 = b[1], z;
    if (lambda12 < lambda02)
      z = lambda02, lambda02 = lambda12, lambda12 = z;
    var delta2 = lambda12 - lambda02, polar = abs(delta2 - pi) < epsilon, meridian = polar || delta2 < epsilon;
    if (!polar && phi12 < phi02)
      z = phi02, phi02 = phi12, phi12 = z;
    if (meridian ? polar ? phi02 + phi12 > 0 ^ q[1] < (abs(q[0] - lambda02) < epsilon ? phi02 : phi12) : phi02 <= q[1] && q[1] <= phi12 : delta2 > pi ^ (lambda02 <= q[0] && q[0] <= lambda12)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A5);
      return [q, spherical(q1)];
    }
  }
  function code2(lambda, phi) {
    var r2 = smallRadius ? radius : pi - radius, code3 = 0;
    if (lambda < -r2)
      code3 |= 1;
    else if (lambda > r2)
      code3 |= 2;
    if (phi < -r2)
      code3 |= 4;
    else if (phi > r2)
      code3 |= 8;
    return code3;
  }
  return clip(visible, clipLine2, interpolate2, smallRadius ? [0, -radius] : [-pi, radius - pi]);
}
function clipLine(a, b, x02, y02, x12, y12) {
  var ax = a[0], ay = a[1], bx = b[0], by = b[1], t02 = 0, t12 = 1, dx = bx - ax, dy = by - ay, r2;
  r2 = x02 - ax;
  if (!dx && r2 > 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  } else if (dx > 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  }
  r2 = x12 - ax;
  if (!dx && r2 < 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  } else if (dx > 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  }
  r2 = y02 - ay;
  if (!dy && r2 > 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  } else if (dy > 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  }
  r2 = y12 - ay;
  if (!dy && r2 < 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  } else if (dy > 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  }
  if (t02 > 0)
    a[0] = ax + t02 * dx, a[1] = ay + t02 * dy;
  if (t12 < 1)
    b[0] = ax + t12 * dx, b[1] = ay + t12 * dy;
  return true;
}
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x02, y02, x12, y12) {
  function visible(x, y) {
    return x02 <= x && x <= x12 && y02 <= y && y <= y12;
  }
  function interpolate2(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do
        stream.point(a === 0 || a === 3 ? x02 : x12, a > 1 ? y12 : y02);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p, direction) {
    return abs(p[0] - x02) < epsilon ? direction > 0 ? 0 : 3 : abs(p[0] - x12) < epsilon ? direction > 0 ? 2 : 1 : abs(p[1] - y02) < epsilon ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection2(a, b) {
    return comparePoint(a.x, b.x);
  }
  function comparePoint(a, b) {
    var ca = corner(a, 1), cb = corner(b, 1);
    return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
  }
  return function(stream) {
    var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first2, clean;
    var clipStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart,
      polygonEnd
    };
    function point2(x, y) {
      if (visible(x, y))
        activeStream.point(x, y);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring2 = polygon[i], j = 1, m = ring2.length, point3 = ring2[0], a0, a1, b0 = point3[0], b1 = point3[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point3 = ring2[j], b0 = point3[0], b1 = point3[1];
          if (a1 <= y12) {
            if (b1 > y12 && (b0 - a0) * (y12 - a1) > (b1 - a1) * (x02 - a0))
              ++winding;
          } else {
            if (b1 <= y12 && (b0 - a0) * (y12 - a1) < (b1 - a1) * (x02 - a0))
              --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = merge$4(segments)).length;
      if (cleanInside || visible2) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate2(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible2) {
          clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint2;
      if (polygon)
        polygon.push(ring = []);
      first2 = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint2(x__, y__);
        if (v__ && v_)
          bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point2;
      if (v_)
        activeStream.lineEnd();
    }
    function linePoint2(x, y) {
      var v = visible(x, y);
      if (polygon)
        ring.push([x, y]);
      if (first2) {
        x__ = x, y__ = y, v__ = v;
        first2 = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_)
          activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x02, y02, x12, y12)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v)
              activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }
    return clipStream;
  };
}
function extent() {
  var x02 = 0, y02 = 0, x12 = 960, y12 = 500, cache2, cacheStream, clip2;
  return clip2 = {
    stream: function(stream) {
      return cache2 && cacheStream === stream ? cache2 : cache2 = clipRectangle(x02, y02, x12, y12)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1], cache2 = cacheStream = null, clip2) : [[x02, y02], [x12, y12]];
    }
  };
}
var lengthSum$1, lambda0, sinPhi0, cosPhi0;
var lengthStream$1 = {
  sphere: noop$2,
  point: noop$2,
  lineStart: lengthLineStart,
  lineEnd: noop$2,
  polygonStart: noop$2,
  polygonEnd: noop$2
};
function lengthLineStart() {
  lengthStream$1.point = lengthPointFirst$1;
  lengthStream$1.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
  lengthStream$1.point = lengthStream$1.lineEnd = noop$2;
}
function lengthPointFirst$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0 = lambda, sinPhi0 = sin(phi), cosPhi0 = cos(phi);
  lengthStream$1.point = lengthPoint$1;
}
function lengthPoint$1(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin(phi), cosPhi = cos(phi), delta = abs(lambda - lambda0), cosDelta = cos(delta), sinDelta = sin(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum$1.add(atan2(sqrt(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}
function length(object2) {
  lengthSum$1 = new Adder();
  geoStream(object2, lengthStream$1);
  return +lengthSum$1;
}
var coordinates = [null, null], object = {
  type: "LineString",
  coordinates
};
function distance(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length(object);
}
var containsObjectType = {
  Feature: function(object2, point2) {
    return containsGeometry(object2.geometry, point2);
  },
  FeatureCollection: function(object2, point2) {
    var features = object2.features, i = -1, n = features.length;
    while (++i < n)
      if (containsGeometry(features[i].geometry, point2))
        return true;
    return false;
  }
};
var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object2, point2) {
    return containsPoint(object2.coordinates, point2);
  },
  MultiPoint: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      if (containsPoint(coordinates2[i], point2))
        return true;
    return false;
  },
  LineString: function(object2, point2) {
    return containsLine(object2.coordinates, point2);
  },
  MultiLineString: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      if (containsLine(coordinates2[i], point2))
        return true;
    return false;
  },
  Polygon: function(object2, point2) {
    return containsPolygon(object2.coordinates, point2);
  },
  MultiPolygon: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n)
      if (containsPolygon(coordinates2[i], point2))
        return true;
    return false;
  },
  GeometryCollection: function(object2, point2) {
    var geometries = object2.geometries, i = -1, n = geometries.length;
    while (++i < n)
      if (containsGeometry(geometries[i], point2))
        return true;
    return false;
  }
};
function containsGeometry(geometry, point2) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point2) : false;
}
function containsPoint(coordinates2, point2) {
  return distance(coordinates2, point2) === 0;
}
function containsLine(coordinates2, point2) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates2.length; i < n; i++) {
    bo = distance(coordinates2[i], point2);
    if (bo === 0)
      return true;
    if (i > 0) {
      ab = distance(coordinates2[i], coordinates2[i - 1]);
      if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab)
        return true;
    }
    ao = bo;
  }
  return false;
}
function containsPolygon(coordinates2, point2) {
  return !!polygonContains(coordinates2.map(ringRadians), pointRadians(point2));
}
function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point2) {
  return [point2[0] * radians, point2[1] * radians];
}
function contains$1(object2, point2) {
  return (object2 && containsObjectType.hasOwnProperty(object2.type) ? containsObjectType[object2.type] : containsGeometry)(object2, point2);
}
function graticuleX(y02, y12, dy) {
  var y = range$2(y02, y12 - epsilon, dy).concat(y12);
  return function(x) {
    return y.map(function(y2) {
      return [x, y2];
    });
  };
}
function graticuleY(x02, x12, dx) {
  var x = range$2(x02, x12 - epsilon, dx).concat(x12);
  return function(y) {
    return x.map(function(x2) {
      return [x2, y];
    });
  };
}
function graticule() {
  var x12, x02, X12, X02, y12, y02, Y12, Y02, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X3, Y3, precision = 2.5;
  function graticule2() {
    return {
      type: "MultiLineString",
      coordinates: lines()
    };
  }
  function lines() {
    return range$2(ceil(X02 / DX) * DX, X12, DX).map(X3).concat(range$2(ceil(Y02 / DY) * DY, Y12, DY).map(Y3)).concat(range$2(ceil(x02 / dx) * dx, x12, dx).filter(function(x2) {
      return abs(x2 % DX) > epsilon;
    }).map(x)).concat(range$2(ceil(y02 / dy) * dy, y12, dy).filter(function(y2) {
      return abs(y2 % DY) > epsilon;
    }).map(y));
  }
  graticule2.lines = function() {
    return lines().map(function(coordinates2) {
      return {
        type: "LineString",
        coordinates: coordinates2
      };
    });
  };
  graticule2.outline = function() {
    return {
      type: "Polygon",
      coordinates: [X3(X02).concat(Y3(Y12).slice(1), X3(X12).reverse().slice(1), Y3(Y02).reverse().slice(1))]
    };
  };
  graticule2.extent = function(_) {
    if (!arguments.length)
      return graticule2.extentMinor();
    return graticule2.extentMajor(_).extentMinor(_);
  };
  graticule2.extentMajor = function(_) {
    if (!arguments.length)
      return [[X02, Y02], [X12, Y12]];
    X02 = +_[0][0], X12 = +_[1][0];
    Y02 = +_[0][1], Y12 = +_[1][1];
    if (X02 > X12)
      _ = X02, X02 = X12, X12 = _;
    if (Y02 > Y12)
      _ = Y02, Y02 = Y12, Y12 = _;
    return graticule2.precision(precision);
  };
  graticule2.extentMinor = function(_) {
    if (!arguments.length)
      return [[x02, y02], [x12, y12]];
    x02 = +_[0][0], x12 = +_[1][0];
    y02 = +_[0][1], y12 = +_[1][1];
    if (x02 > x12)
      _ = x02, x02 = x12, x12 = _;
    if (y02 > y12)
      _ = y02, y02 = y12, y12 = _;
    return graticule2.precision(precision);
  };
  graticule2.step = function(_) {
    if (!arguments.length)
      return graticule2.stepMinor();
    return graticule2.stepMajor(_).stepMinor(_);
  };
  graticule2.stepMajor = function(_) {
    if (!arguments.length)
      return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule2;
  };
  graticule2.stepMinor = function(_) {
    if (!arguments.length)
      return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule2;
  };
  graticule2.precision = function(_) {
    if (!arguments.length)
      return precision;
    precision = +_;
    x = graticuleX(y02, y12, 90);
    y = graticuleY(x02, x12, precision);
    X3 = graticuleX(Y02, Y12, 90);
    Y3 = graticuleY(X02, X12, precision);
    return graticule2;
  };
  return graticule2.extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]]).extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
}
function graticule10() {
  return graticule()();
}
function interpolate(a, b) {
  var x02 = a[0] * radians, y02 = a[1] * radians, x12 = b[0] * radians, y12 = b[1] * radians, cy0 = cos(y02), sy0 = sin(y02), cy1 = cos(y12), sy1 = sin(y12), kx0 = cy0 * cos(x02), ky0 = cy0 * sin(x02), kx1 = cy1 * cos(x12), ky1 = cy1 * sin(x12), d = 2 * asin(sqrt(haversin(y12 - y02) + cy0 * cy1 * haversin(x12 - x02))), k = sin(d);
  var interpolate2 = d ? function(t) {
    var B2 = sin(t *= d) / k, A5 = sin(d - t) / k, x = A5 * kx0 + B2 * kx1, y = A5 * ky0 + B2 * ky1, z = A5 * sy0 + B2 * sy1;
    return [atan2(y, x) * degrees, atan2(z, sqrt(x * x + y * y)) * degrees];
  } : function() {
    return [x02 * degrees, y02 * degrees];
  };
  interpolate2.distance = d;
  return interpolate2;
}
const identity$2 = (x) => x;
var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
var areaStream = {
  point: noop$2,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$2;
    areaSum.add(abs(areaRingSum));
    areaRingSum = new Adder();
  },
  result: function() {
    var area2 = areaSum / 2;
    areaSum = new Adder();
    return area2;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00$2 = x0$3 = x, y00$2 = y0$3 = y;
}
function areaPoint(x, y) {
  areaRingSum.add(y0$3 * x - x0$3 * y);
  x0$3 = x, y0$3 = y;
}
function areaRingEnd() {
  areaPoint(x00$2, y00$2);
}
const pathArea = areaStream;
var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$2,
  lineEnd: noop$2,
  polygonStart: noop$2,
  polygonEnd: noop$2,
  result: function() {
    var bounds2 = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds2;
  }
};
function boundsPoint(x, y) {
  if (x < x0$2)
    x0$2 = x;
  if (x > x1)
    x1 = x;
  if (y < y0$2)
    y0$2 = y;
  if (y > y1)
    y1 = y;
}
const boundsStream$1 = boundsStream;
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid2 = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
    return centroid2;
  }
};
function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidPointLine(x, y) {
  var dx = x - x0$1, dy = y - y0$1, z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
}
function centroidPointRing(x, y) {
  var dx = x - x0$1, dy = y - y0$1, z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  z = y0$1 * x - x0$1 * y;
  X2 += z * (x0$1 + x);
  Y2 += z * (y0$1 + y);
  Z2 += z * 3;
  centroidPoint(x0$1 = x, y0$1 = y);
}
const pathCentroid = centroidStream;
function PathContext(context) {
  this._context = context;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0)
      this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau);
        break;
      }
    }
  },
  result: noop$2
};
var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
  point: noop$2,
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing)
      lengthPoint(x00, y00);
    lengthStream.point = noop$2;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length2 = +lengthSum;
    lengthSum = new Adder();
    return length2;
  }
};
function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(sqrt(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}
const pathMeasure = lengthStream;
function PathString() {
  this._string = [];
}
PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius)
      this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0)
      this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null)
          this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};
function circle(radius) {
  return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}
function index(projection2, context) {
  var pointRadius = 4.5, projectionStream, contextStream;
  function path(object2) {
    if (object2) {
      if (typeof pointRadius === "function")
        contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object2, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path.area = function(object2) {
    geoStream(object2, projectionStream(pathArea));
    return pathArea.result();
  };
  path.measure = function(object2) {
    geoStream(object2, projectionStream(pathMeasure));
    return pathMeasure.result();
  };
  path.bounds = function(object2) {
    geoStream(object2, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };
  path.centroid = function(object2) {
    geoStream(object2, projectionStream(pathCentroid));
    return pathCentroid.result();
  };
  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection2 = null, identity$2) : (projection2 = _).stream, path) : projection2;
  };
  path.context = function(_) {
    if (!arguments.length)
      return context;
    contextStream = _ == null ? (context = null, new PathString()) : new PathContext(context = _);
    if (typeof pointRadius !== "function")
      contextStream.pointRadius(pointRadius);
    return path;
  };
  path.pointRadius = function(_) {
    if (!arguments.length)
      return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };
  return path.projection(projection2).context(context);
}
function transform(methods) {
  return {
    stream: transformer(methods)
  };
}
function transformer(methods) {
  return function(stream) {
    var s = new TransformStream();
    for (var key in methods)
      s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}
function TransformStream() {
}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) {
    this.stream.point(x, y);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fit(projection2, fitBounds, object2) {
  var clip2 = projection2.clipExtent && projection2.clipExtent();
  projection2.scale(150).translate([0, 0]);
  if (clip2 != null)
    projection2.clipExtent(null);
  geoStream(object2, projection2.stream(boundsStream$1));
  fitBounds(boundsStream$1.result());
  if (clip2 != null)
    projection2.clipExtent(clip2);
  return projection2;
}
function fitExtent(projection2, extent2, object2) {
  return fit(projection2, function(b) {
    var w = extent2[1][0] - extent2[0][0], h = extent2[1][1] - extent2[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent2[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent2[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
function fitSize(projection2, size, object2) {
  return fitExtent(projection2, [[0, 0], size], object2);
}
function fitWidth(projection2, width, object2) {
  return fit(projection2, function(b) {
    var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
function fitHeight(projection2, height2, object2) {
  return fit(projection2, function(b) {
    var h = +height2, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
var maxDepth = 16, cosMinDistance = cos(30 * radians);
function resample(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}
function resample$1(project, delta2) {
  function resampleLineTo(x02, y02, lambda02, a0, b0, c0, x12, y12, lambda12, a1, b1, c1, depth, stream) {
    var dx = x12 - x02, dy = y12 - y02, d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1, b = b0 + b1, c2 = c0 + c1, m = sqrt(a * a + b * b + c2 * c2), phi2 = asin(c2 /= m), lambda22 = abs(abs(c2) - 1) < epsilon || abs(lambda02 - lambda12) < epsilon ? (lambda02 + lambda12) / 2 : atan2(b, a), p = project(lambda22, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x02, dy2 = y2 - y02, dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x02, y02, lambda02, a0, b0, c0, x2, y2, lambda22, a /= m, b /= m, c2, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda22, a, b, c2, x12, y12, lambda12, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda002, x002, y002, a00, b00, c00, lambda02, x02, y02, a0, b0, c0;
    var resampleStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function() {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point2(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }
    function lineStart() {
      x02 = NaN;
      resampleStream.point = linePoint2;
      stream.lineStart();
    }
    function linePoint2(lambda, phi) {
      var c2 = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x02, y02, lambda02, a0, b0, c0, x02 = p[0], y02 = p[1], lambda02 = lambda, a0 = c2[0], b0 = c2[1], c0 = c2[2], maxDepth, stream);
      stream.point(x02, y02);
    }
    function lineEnd() {
      resampleStream.point = point2;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi) {
      linePoint2(lambda002 = lambda, phi), x002 = x02, y002 = y02, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint2;
    }
    function ringEnd() {
      resampleLineTo(x02, y02, lambda02, a0, b0, c0, x002, y002, lambda002, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}
var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});
function transformRotate(rotate2) {
  return transformer({
    point: function(x, y) {
      var r2 = rotate2(x, y);
      return this.stream.point(r2[0], r2[1]);
    }
  });
}
function scaleTranslate(k, dx, dy, sx, sy) {
  function transform3(x, y) {
    x *= sx;
    y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform3.invert = function(x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform3;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  if (!alpha)
    return scaleTranslate(k, dx, dy, sx, sy);
  var cosAlpha = cos(alpha), sinAlpha = sin(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform3(x, y) {
    x *= sx;
    y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform3.invert = function(x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform3;
}
function projection(project) {
  return projectionMutator(function() {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate2, alpha = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x02 = null, y02, x12, y12, postclip = identity$2, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache2, cacheStream;
  function projection2(point2) {
    return projectRotateTransform(point2[0] * radians, point2[1] * radians);
  }
  function invert(point2) {
    point2 = projectRotateTransform.invert(point2[0], point2[1]);
    return point2 && [point2[0] * degrees, point2[1] * degrees];
  }
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transformRadians(transformRotate(rotate2)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection2.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = void 0, reset2()) : preclip;
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x02 = y02 = x12 = y12 = null, reset2()) : postclip;
  };
  projection2.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset2()) : theta * degrees;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x02 = y02 = x12 = y12 = null, identity$2) : clipRectangle(x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset2()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };
  projection2.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };
  projection2.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
  };
  projection2.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };
  projection2.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset2()) : sqrt(delta2);
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height2, object2) {
    return fitHeight(projection2, height2, object2);
  };
  function recenter() {
    var center2 = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform3 = scaleTranslateRotate(k, x - center2[0], y - center2[1], sx, sy, alpha);
    rotate2 = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform3);
    projectRotateTransform = compose(rotate2, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset2();
  }
  function reset2() {
    cache2 = cacheStream = null;
    return projection2;
  }
  return function() {
    project = projectAt.apply(this, arguments);
    projection2.invert = project.invert && invert;
    return recenter();
  };
}
function conicProjection(projectAt) {
  var phi02 = 0, phi12 = pi / 3, m = projectionMutator(projectAt), p = m(phi02, phi12);
  p.parallels = function(_) {
    return arguments.length ? m(phi02 = _[0] * radians, phi12 = _[1] * radians) : [phi02 * degrees, phi12 * degrees];
  };
  return p;
}
function cylindricalEqualAreaRaw(phi02) {
  var cosPhi02 = cos(phi02);
  function forward(lambda, phi) {
    return [lambda * cosPhi02, sin(phi) / cosPhi02];
  }
  forward.invert = function(x, y) {
    return [x / cosPhi02, asin(y * cosPhi02)];
  };
  return forward;
}
function conicEqualAreaRaw(y02, y12) {
  var sy0 = sin(y02), n = (sy0 + sin(y12)) / 2;
  if (abs(n) < epsilon)
    return cylindricalEqualAreaRaw(y02);
  var c2 = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c2) / n;
  function project(x, y) {
    var r2 = sqrt(c2 - 2 * n * sin(y)) / n;
    return [r2 * sin(x *= n), r0 - r2 * cos(x)];
  }
  project.invert = function(x, y) {
    var r0y = r0 - y, l = atan2(x, abs(r0y)) * sign(r0y);
    if (r0y * n < 0)
      l -= pi * sign(x) * sign(r0y);
    return [l / n, asin((c2 - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };
  return project;
}
function conicEqualArea() {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}
function albers() {
  return conicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) {
      var i = -1;
      while (++i < n)
        streams[i].point(x, y);
    },
    sphere: function() {
      var i = -1;
      while (++i < n)
        streams[i].sphere();
    },
    lineStart: function() {
      var i = -1;
      while (++i < n)
        streams[i].lineStart();
    },
    lineEnd: function() {
      var i = -1;
      while (++i < n)
        streams[i].lineEnd();
    },
    polygonStart: function() {
      var i = -1;
      while (++i < n)
        streams[i].polygonStart();
    },
    polygonEnd: function() {
      var i = -1;
      while (++i < n)
        streams[i].polygonEnd();
    }
  };
}
function albersUsa() {
  var cache2, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, point2, pointStream = {
    point: function(x, y) {
      point2 = [x, y];
    }
  };
  function albersUsa2(coordinates2) {
    var x = coordinates2[0], y = coordinates2[1];
    return point2 = null, (lower48Point.point(x, y), point2) || (alaskaPoint.point(x, y), point2) || (hawaiiPoint.point(x, y), point2);
  }
  albersUsa2.invert = function(coordinates2) {
    var k = lower48.scale(), t = lower48.translate(), x = (coordinates2[0] - t[0]) / k, y = (coordinates2[1] - t[1]) / k;
    return (y >= 0.12 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates2);
  };
  albersUsa2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa2.precision = function(_) {
    if (!arguments.length)
      return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset2();
  };
  albersUsa2.scale = function(_) {
    if (!arguments.length)
      return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa2.translate(lower48.translate());
  };
  albersUsa2.translate = function(_) {
    if (!arguments.length)
      return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon, y + 0.12 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    return reset2();
  };
  albersUsa2.fitExtent = function(extent2, object2) {
    return fitExtent(albersUsa2, extent2, object2);
  };
  albersUsa2.fitSize = function(size, object2) {
    return fitSize(albersUsa2, size, object2);
  };
  albersUsa2.fitWidth = function(width, object2) {
    return fitWidth(albersUsa2, width, object2);
  };
  albersUsa2.fitHeight = function(height2, object2) {
    return fitHeight(albersUsa2, height2, object2);
  };
  function reset2() {
    cache2 = cacheStream = null;
    return albersUsa2;
  }
  return albersUsa2.scale(1070);
}
function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos(x), cy = cos(y), k = scale(cx * cy);
    if (k === Infinity)
      return [2, 0];
    return [k * cy * sin(x), k * sin(y)];
  };
}
function azimuthalInvert(angle2) {
  return function(x, y) {
    var z = sqrt(x * x + y * y), c2 = angle2(z), sc = sin(c2), cc = cos(c2);
    return [atan2(x * sc, z * cc), asin(z && y * sc / z)];
  };
}
var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});
function azimuthalEqualArea() {
  return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}
var azimuthalEquidistantRaw = azimuthalRaw(function(c2) {
  return (c2 = acos(c2)) && c2 / sin(c2);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});
function azimuthalEquidistant() {
  return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi + phi) / 2))];
}
mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi];
};
function mercator() {
  return mercatorProjection(mercatorRaw).scale(961 / tau);
}
function mercatorProjection(project) {
  var m = projection(project), center2 = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x02 = null, y02, x12, y12;
  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };
  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };
  m.center = function(_) {
    return arguments.length ? (center2(_), reclip()) : center2();
  };
  m.clipExtent = function(_) {
    return arguments.length ? (_ == null ? x02 = y02 = x12 = y12 = null : (x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reclip()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  function reclip() {
    var k = pi * scale(), t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x02 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x02), y02], [Math.min(t[0] + k, x12), y12]] : [[x02, Math.max(t[1] - k, y02)], [x12, Math.min(t[1] + k, y12)]]);
  }
  return reclip();
}
function tany(y) {
  return tan((halfPi + y) / 2);
}
function conicConformalRaw(y02, y12) {
  var cy0 = cos(y02), n = y02 === y12 ? sin(y02) : log(cy0 / cos(y12)) / log(tany(y12) / tany(y02)), f2 = cy0 * pow(tany(y02), n) / n;
  if (!n)
    return mercatorRaw;
  function project(x, y) {
    if (f2 > 0) {
      if (y < -halfPi + epsilon)
        y = -halfPi + epsilon;
    } else {
      if (y > halfPi - epsilon)
        y = halfPi - epsilon;
    }
    var r2 = f2 / pow(tany(y), n);
    return [r2 * sin(n * x), f2 - r2 * cos(n * x)];
  }
  project.invert = function(x, y) {
    var fy = f2 - y, r2 = sign(n) * sqrt(x * x + fy * fy), l = atan2(x, abs(fy)) * sign(fy);
    if (fy * n < 0)
      l -= pi * sign(x) * sign(fy);
    return [l / n, 2 * atan(pow(f2 / r2, 1 / n)) - halfPi];
  };
  return project;
}
function conicConformal() {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}
function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}
equirectangularRaw.invert = equirectangularRaw;
function equirectangular() {
  return projection(equirectangularRaw).scale(152.63);
}
function conicEquidistantRaw(y02, y12) {
  var cy0 = cos(y02), n = y02 === y12 ? sin(y02) : (cy0 - cos(y12)) / (y12 - y02), g = cy0 / n + y02;
  if (abs(n) < epsilon)
    return equirectangularRaw;
  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin(nx), g - gy * cos(nx)];
  }
  project.invert = function(x, y) {
    var gy = g - y, l = atan2(x, abs(gy)) * sign(gy);
    if (gy * n < 0)
      l -= pi * sign(x) * sign(gy);
    return [l / n, g - sign(n) * sqrt(x * x + gy * gy)];
  };
  return project;
}
function conicEquidistant() {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}
var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = sqrt(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
  var l = asin(M * sin(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [lambda * cos(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))), l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))];
}
equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (abs(delta) < epsilon2)
      break;
  }
  return [M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos(l), asin(sin(l) / M)];
};
function equalEarth() {
  return projection(equalEarthRaw).scale(177.158);
}
function gnomonicRaw(x, y) {
  var cy = cos(y), k = cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}
gnomonicRaw.invert = azimuthalInvert(atan);
function gnomonic() {
  return projection(gnomonicRaw).scale(144.049).clipAngle(60);
}
function identity$1() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x02 = null, y02, x12, y12, kx = 1, ky = 1, transform3 = transformer({
    point: function(x, y) {
      var p = projection2([x, y]);
      this.stream.point(p[0], p[1]);
    }
  }), postclip = identity$2, cache2, cacheStream;
  function reset2() {
    kx = k * sx;
    ky = k * sy;
    cache2 = cacheStream = null;
    return projection2;
  }
  function projection2(p) {
    var x = p[0] * kx, y = p[1] * ky;
    if (alpha) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }
    return [x + tx, y + ty];
  }
  projection2.invert = function(p) {
    var x = p[0] - tx, y = p[1] - ty;
    if (alpha) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transform3(postclip(cacheStream = stream));
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x02 = y02 = x12 = y12 = null, reset2()) : postclip;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x02 = y02 = x12 = y12 = null, identity$2) : clipRectangle(x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset2()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k = +_, reset2()) : k;
  };
  projection2.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset2()) : [tx, ty];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * radians, sa = sin(alpha), ca = cos(alpha), reset2()) : alpha * degrees;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset2()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset2()) : sy < 0;
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height2, object2) {
    return fitHeight(projection2, height2, object2);
  };
  return projection2;
}
function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (3971e-6 * phi2 - 1529e-6 * phi4))), phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 5916e-6 * phi4)))];
}
naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 5916e-6 * phi4))) - y) / (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 5916e-6 * 11 * phi4)));
  } while (abs(delta) > epsilon && --i > 0);
  return [x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (3971e-6 - 1529e-6 * phi2)))), phi];
};
function naturalEarth1() {
  return projection(naturalEarth1Raw).scale(175.295);
}
function orthographicRaw(x, y) {
  return [cos(y) * sin(x), sin(y)];
}
orthographicRaw.invert = azimuthalInvert(asin);
function orthographic() {
  return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon);
}
function stereographicRaw(x, y) {
  var cy = cos(y), k = 1 + cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}
stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});
function stereographic() {
  return projection(stereographicRaw).scale(250).clipAngle(142);
}
function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi + phi) / 2)), -lambda];
}
transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi];
};
function transverseMercator() {
  var m = mercatorProjection(transverseMercatorRaw), center2 = m.center, rotate2 = m.rotate;
  m.center = function(_) {
    return arguments.length ? center2([-_[1], _[0]]) : (_ = center2(), [_[1], -_[0]]);
  };
  m.rotate = function(_) {
    return arguments.length ? rotate2([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate2(), [_[0], _[1], _[2] - 90]);
  };
  return rotate2([0, 0, 90]).scale(159.155);
}
const d3Geo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  geoAlbers: albers,
  geoAlbersUsa: albersUsa,
  geoArea: area,
  geoAzimuthalEqualArea: azimuthalEqualArea,
  geoAzimuthalEqualAreaRaw: azimuthalEqualAreaRaw,
  geoAzimuthalEquidistant: azimuthalEquidistant,
  geoAzimuthalEquidistantRaw: azimuthalEquidistantRaw,
  geoBounds: bounds,
  geoCentroid: centroid,
  geoCircle: circle$1,
  geoClipAntimeridian: clipAntimeridian,
  geoClipCircle: clipCircle,
  geoClipExtent: extent,
  geoClipRectangle: clipRectangle,
  geoConicConformal: conicConformal,
  geoConicConformalRaw: conicConformalRaw,
  geoConicEqualArea: conicEqualArea,
  geoConicEqualAreaRaw: conicEqualAreaRaw,
  geoConicEquidistant: conicEquidistant,
  geoConicEquidistantRaw: conicEquidistantRaw,
  geoContains: contains$1,
  geoDistance: distance,
  geoEqualEarth: equalEarth,
  geoEqualEarthRaw: equalEarthRaw,
  geoEquirectangular: equirectangular,
  geoEquirectangularRaw: equirectangularRaw,
  geoGnomonic: gnomonic,
  geoGnomonicRaw: gnomonicRaw,
  geoGraticule: graticule,
  geoGraticule10: graticule10,
  geoIdentity: identity$1,
  geoInterpolate: interpolate,
  geoLength: length,
  geoMercator: mercator,
  geoMercatorRaw: mercatorRaw,
  geoNaturalEarth1: naturalEarth1,
  geoNaturalEarth1Raw: naturalEarth1Raw,
  geoOrthographic: orthographic,
  geoOrthographicRaw: orthographicRaw,
  geoPath: index,
  geoProjection: projection,
  geoProjectionMutator: projectionMutator,
  geoRotation: rotation,
  geoStereographic: stereographic,
  geoStereographicRaw: stereographicRaw,
  geoStream,
  geoTransform: transform,
  geoTransverseMercator: transverseMercator,
  geoTransverseMercatorRaw: transverseMercatorRaw
}, Symbol.toStringTag, { value: "Module" }));
var slice = [].slice;
var noabort = {};
function Queue(size) {
  this._size = size;
  this._call = this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting = this._active = this._ended = this._start = 0;
}
Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function")
      throw new Error("invalid callback");
    if (this._call)
      throw new Error("defer after await");
    if (this._error != null)
      return this;
    var t = slice.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke(this);
    return this;
  },
  abort: function() {
    if (this._error == null)
      abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function")
      throw new Error("invalid callback");
    if (this._call)
      throw new Error("multiple await");
    this._call = function(error, results) {
      callback.apply(null, [error].concat(results));
    };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function")
      throw new Error("invalid callback");
    if (this._call)
      throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};
function poke(q) {
  if (!q._start) {
    try {
      start(q);
    } catch (e) {
      if (q._tasks[q._ended + q._active - 1])
        abort(q, e);
      else if (!q._data)
        throw e;
    }
  }
}
function start(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active, t = q._tasks[i], j = t.length - 1, c2 = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c2.apply(null, t);
    if (!q._tasks[i])
      continue;
    q._tasks[i] = t || noabort;
  }
}
function end(q, i) {
  return function(e, r2) {
    if (!q._tasks[i])
      return;
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null)
      return;
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r2;
      if (q._waiting)
        poke(q);
      else
        maybeNotify(q);
    }
  };
}
function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e;
  q._data = void 0;
  q._waiting = NaN;
  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try {
          t.abort();
        } catch (e3) {
        }
      }
    }
  }
  q._active = NaN;
  maybeNotify(q);
}
function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = void 0;
    q._call(q._error, d);
  }
}
function queue(concurrency) {
  if (concurrency == null)
    concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1))
    throw new Error("invalid concurrency");
  return new Queue(concurrency);
}
const d3Queue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  queue
}, Symbol.toStringTag, { value: "Module" }));
var prefix = "$";
function Map$3() {
}
Map$3.prototype = map$2.prototype = {
  constructor: Map$3,
  has: function(key) {
    return prefix + key in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value2) {
    this[prefix + key] = value2;
    return this;
  },
  remove: function(key) {
    var property2 = prefix + key;
    return property2 in this && delete this[property2];
  },
  clear: function() {
    for (var property2 in this)
      if (property2[0] === prefix)
        delete this[property2];
  },
  keys: function() {
    var keys3 = [];
    for (var property2 in this)
      if (property2[0] === prefix)
        keys3.push(property2.slice(1));
    return keys3;
  },
  values: function() {
    var values2 = [];
    for (var property2 in this)
      if (property2[0] === prefix)
        values2.push(this[property2]);
    return values2;
  },
  entries: function() {
    var entries2 = [];
    for (var property2 in this)
      if (property2[0] === prefix)
        entries2.push({
          key: property2.slice(1),
          value: this[property2]
        });
    return entries2;
  },
  size: function() {
    var size = 0;
    for (var property2 in this)
      if (property2[0] === prefix)
        ++size;
    return size;
  },
  empty: function() {
    for (var property2 in this)
      if (property2[0] === prefix)
        return false;
    return true;
  },
  each: function(f2) {
    for (var property2 in this)
      if (property2[0] === prefix)
        f2(this[property2], property2.slice(1), this);
  }
};
function map$2(object2, f2) {
  var map2 = new Map$3();
  if (object2 instanceof Map$3)
    object2.each(function(value2, key2) {
      map2.set(key2, value2);
    });
  else if (Array.isArray(object2)) {
    var i = -1, n = object2.length, o;
    if (f2 == null)
      while (++i < n)
        map2.set(i, object2[i]);
    else
      while (++i < n)
        map2.set(f2(o = object2[i], i, object2), o);
  } else if (object2)
    for (var key in object2)
      map2.set(key, object2[key]);
  return map2;
}
function Set$3() {
}
var proto = map$2.prototype;
Set$3.prototype = {
  constructor: Set$3,
  has: proto.has,
  add: function(value2) {
    value2 += "";
    this[prefix + value2] = value2;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};
var noop$1 = {
  value: function() {
  }
};
function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t))
      throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}
function Dispatch(_) {
  this._ = _;
}
function parseTypenames(typenames, types2) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0)
      name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types2.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    return {
      type: t,
      name
    };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
    if (arguments.length < 2) {
      while (++i < n)
        if ((t = (typename = T[i]).type) && (t = get$3(_[t], typename.name)))
          return t;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type)
        _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null)
        for (t in _)
          _[t] = set$1(_[t], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _ = this._;
    for (var t in _)
      copy2[t] = _[t].slice();
    return new Dispatch(copy2);
  },
  call: function(type3, that) {
    if ((n = arguments.length - 2) > 0)
      for (var args = new Array(n), i = 0, n, t; i < n; ++i)
        args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type3))
      throw new Error("unknown type: " + type3);
    for (t = this._[type3], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  },
  apply: function(type3, that, args) {
    if (!this._.hasOwnProperty(type3))
      throw new Error("unknown type: " + type3);
    for (var t = this._[type3], i = 0, n = t.length; i < n; ++i)
      t[i].value.apply(that, args);
  }
};
function get$3(type3, name) {
  for (var i = 0, n = type3.length, c2; i < n; ++i) {
    if ((c2 = type3[i]).name === name) {
      return c2.value;
    }
  }
}
function set$1(type3, name, callback) {
  for (var i = 0, n = type3.length; i < n; ++i) {
    if (type3[i].name === name) {
      type3[i] = noop$1, type3 = type3.slice(0, i).concat(type3.slice(i + 1));
      break;
    }
  }
  if (callback != null)
    type3.push({
      name,
      value: callback
    });
  return type3;
}
function request(url, callback) {
  var request2, event = dispatch("beforesend", "progress", "load", "error"), mimeType, headers = map$2(), xhr = new XMLHttpRequest(), user = null, password = null, response, responseType, timeout2 = 0;
  if (typeof XDomainRequest !== "undefined" && !("withCredentials" in xhr) && /^(http(s)?:)?\/\//.test(url))
    xhr = new XDomainRequest();
  "onload" in xhr ? xhr.onload = xhr.onerror = xhr.ontimeout = respond : xhr.onreadystatechange = function(o) {
    xhr.readyState > 3 && respond(o);
  };
  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr) || status >= 200 && status < 300 || status === 304) {
      if (response) {
        try {
          result = response.call(request2, xhr);
        } catch (e) {
          event.call("error", request2, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request2, result);
    } else {
      event.call("error", request2, o);
    }
  }
  xhr.onprogress = function(e) {
    event.call("progress", request2, e);
  };
  request2 = {
    header: function(name, value2) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2)
        return headers.get(name);
      if (value2 == null)
        headers.remove(name);
      else
        headers.set(name, value2 + "");
      return request2;
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value2) {
      if (!arguments.length)
        return mimeType;
      mimeType = value2 == null ? null : value2 + "";
      return request2;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value2) {
      if (!arguments.length)
        return responseType;
      responseType = value2;
      return request2;
    },
    timeout: function(value2) {
      if (!arguments.length)
        return timeout2;
      timeout2 = +value2;
      return request2;
    },
    user: function(value2) {
      return arguments.length < 1 ? user : (user = value2 == null ? null : value2 + "", request2);
    },
    password: function(value2) {
      return arguments.length < 1 ? password : (password = value2 == null ? null : value2 + "", request2);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value2) {
      response = value2;
      return request2;
    },
    // Alias for send("GET", …).
    get: function(data2, callback2) {
      return request2.send("GET", data2, callback2);
    },
    // Alias for send("POST", …).
    post: function(data2, callback2) {
      return request2.send("POST", data2, callback2);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(method, data2, callback2) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept"))
        headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader)
        headers.each(function(value2, name) {
          xhr.setRequestHeader(name, value2);
        });
      if (mimeType != null && xhr.overrideMimeType)
        xhr.overrideMimeType(mimeType);
      if (responseType != null)
        xhr.responseType = responseType;
      if (timeout2 > 0)
        xhr.timeout = timeout2;
      if (callback2 == null && typeof data2 === "function")
        callback2 = data2, data2 = null;
      if (callback2 != null && callback2.length === 1)
        callback2 = fixCallback(callback2);
      if (callback2 != null)
        request2.on("error", callback2).on("load", function(xhr2) {
          callback2(null, xhr2);
        });
      event.call("beforesend", request2, xhr);
      xhr.send(data2 == null ? null : data2);
      return request2;
    },
    abort: function() {
      xhr.abort();
      return request2;
    },
    on: function() {
      var value2 = event.on.apply(event, arguments);
      return value2 === event ? request2 : value2;
    }
  };
  if (callback != null) {
    if (typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    return request2.get(callback);
  }
  return request2;
}
function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}
function hasResponse(xhr) {
  var type3 = xhr.responseType;
  return type3 && type3 !== "text" ? xhr.response : xhr.responseText;
}
function type$3(defaultMimeType, response) {
  return function(url, callback) {
    var r2 = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function")
        throw new Error("invalid callback: " + callback);
      return r2.get(callback);
    }
    return r2;
  };
}
const html = type$3("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});
const json = type$3("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});
const text = type$3("text/plain", function(xhr) {
  return xhr.responseText;
});
const xml = type$3("application/xml", function(xhr) {
  var xml2 = xhr.responseXML;
  if (!xml2)
    throw new Error("parse error");
  return xml2;
});
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter(columns, f2) {
  var object2 = objectConverter(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad(value2, width) {
  var s = value2 + "", length2 = s.length;
  return length2 < width ? new Array(width - length2 + 1).join(0) + s : s;
}
function formatYear(year) {
  return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date2) {
  var hours = date2.getUTCHours(), minutes = date2.getUTCMinutes(), seconds = date2.getUTCSeconds(), milliseconds = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear(date2.getUTCFullYear()) + "-" + pad(date2.getUTCMonth() + 1, 2) + "-" + pad(date2.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}
function dsv$1(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse2(text2, f2) {
    var convert, columns, rows = parseRows(text2, function(row, i) {
      if (convert)
        return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter(row, f2) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text2, f2) {
    var rows = [], N = text2.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
    if (text2.charCodeAt(N - 1) === NEWLINE)
      --N;
    if (text2.charCodeAt(N - 1) === RETURN)
      --N;
    function token2() {
      if (eof)
        return EOF;
      if (eol)
        return eol = false, EOL;
      var i, j = I, c2;
      if (text2.charCodeAt(j) === QUOTE) {
        while (I++ < N && text2.charCodeAt(I) !== QUOTE || text2.charCodeAt(++I) === QUOTE)
          ;
        if ((i = I) >= N)
          eof = true;
        else if ((c2 = text2.charCodeAt(I++)) === NEWLINE)
          eol = true;
        else if (c2 === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE)
            ++I;
        }
        return text2.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c2 = text2.charCodeAt(i = I++)) === NEWLINE)
          eol = true;
        else if (c2 === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE)
            ++I;
        } else if (c2 !== DELIMITER)
          continue;
        return text2.slice(j, i);
      }
      return eof = true, text2.slice(j, N);
    }
    while ((t = token2()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF)
        row.push(t), t = token2();
      if (f2 && (row = f2(row, n++)) == null)
        continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value2) {
    return value2 == null ? "" : value2 instanceof Date ? formatDate(value2) : reFormat.test(value2 += "") ? '"' + value2.replace(/"/g, '""') + '"' : value2;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv$1 = dsv$1(",");
var csvParse = csv$1.parse;
var tsv$1 = dsv$1("	");
var tsvParse = tsv$1.parse;
function dsv(defaultMimeType, parse2) {
  return function(url, row, callback) {
    if (arguments.length < 3)
      callback = row, row = null;
    var r2 = request(url).mimeType(defaultMimeType);
    r2.row = function(_) {
      return arguments.length ? r2.response(responseOf(parse2, row = _)) : row;
    };
    r2.row(row);
    return callback ? r2.get(callback) : r2;
  };
}
function responseOf(parse2, row) {
  return function(request2) {
    return parse2(request2.responseText, row);
  };
}
const csv = dsv("text/csv", csvParse);
const tsv = dsv("text/tab-separated-values", tsvParse);
const d3Request = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  csv,
  html,
  json,
  request,
  text,
  tsv,
  xml
}, Symbol.toStringTag, { value: "Module" }));
function _extends$l() {
  _extends$l = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$l.apply(this, arguments);
}
function _classCallCheck$G(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$v(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$v(descriptor.key), descriptor);
  }
}
function _createClass$E(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$v(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$v(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$v(arg) {
  var key = _toPrimitive$v(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$v(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$G(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$v(subClass, superClass);
}
function _setPrototypeOf$v(o, p) {
  _setPrototypeOf$v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$v(o, p);
}
function _createSuper$v(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$v();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$v(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$v(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$G(this, result);
  };
}
function _possibleConstructorReturn$G(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$v(self2);
}
function _assertThisInitialized$v(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$v() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$v(o) {
  _getPrototypeOf$v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$v(o);
}
let ListWrapper = /* @__PURE__ */ function(_React$Component) {
  _inherits$G(ListWrapper2, _React$Component);
  var _super = _createSuper$v(ListWrapper2);
  function ListWrapper2({
    items: items2
  }) {
    var _this;
    _classCallCheck$G(this, ListWrapper2);
    _this = _super.call(this);
    _this.state = {
      items: items2,
      isSorting: false
    };
    return _this;
  }
  _createClass$E(ListWrapper2, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        items: nextProps.items
      });
    }
  }, {
    key: "onSortStart",
    value: function onSortStart({
      node: node2,
      index: index2,
      collection
    }, e) {
      e.stopImmediatePropagation();
      const {
        onSortStart: onSortStart2
      } = this.props;
      this.setState({
        isSorting: true
      });
      if (onSortStart2) {
        onSortStart2(this.ref);
      }
      this.sortingIndex = index2;
      this.sortStartTop = e.offsetTop;
      this.sortStartLeft = e.offsetLeft;
    }
  }, {
    key: "onSortMove",
    value: function onSortMove() {
    }
  }, {
    key: "onSortEnd",
    value: function onSortEnd({
      oldIndex,
      newIndex
    }) {
      const {
        onSortEnd: onSortEnd2
      } = this.props;
      const {
        items: items2
      } = this.state;
      this.setState({
        items: arrayMove(items2, oldIndex, newIndex),
        isSorting: false
      });
      if (onSortEnd2) {
        onSortEnd2(this.state.items);
      }
      this.sortingIndex = null;
    }
  }, {
    key: "render",
    value: function render3() {
      const Component2 = this.props.component;
      const {
        items: items2,
        isSorting
      } = this.state;
      const props = {
        isSorting,
        items: items2,
        onSortEnd: this.onSortEnd.bind(this),
        onSortStart: this.onSortStart.bind(this),
        onSortMove: this.onSortMove.bind(this)
      };
      return /* @__PURE__ */ React$3.createElement(Component2, _extends$l({}, this.props, props, {
        ref: (element) => {
          this.ref = element;
        }
      }));
    }
  }]);
  return ListWrapper2;
}(React$3.Component);
ListWrapper.propTypes = {
  axis: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.func,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  height: PropTypes.number,
  helperClass: PropTypes.string,
  itemClass: PropTypes.string,
  itemControlAlignLeft: PropTypes.bool,
  itemReactClass: PropTypes.func,
  items: PropTypes.array,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onSortEnd: PropTypes.func,
  onSortStart: PropTypes.func,
  referenceAncestor: PropTypes.string,
  resizeHandles: PropTypes.object,
  useDragHandle: PropTypes.bool,
  width: PropTypes.number
};
ListWrapper.defaultProps = {
  className: "list stylizedList",
  itemClass: "item stylizedItem",
  width: 400,
  height: 600
};
const classes$8 = {
  "top-right-handle": "_top-right-handle_cizw2_1",
  "bottom-right-handle": "_bottom-right-handle_cizw2_2",
  "top-left-handle": "_top-left-handle_cizw2_7",
  "bottom-left-handle": "_bottom-left-handle_cizw2_8",
  "top-draggable-handle": "_top-draggable-handle_cizw2_13",
  "bottom-draggable-handle": "_bottom-draggable-handle_cizw2_14",
  "left-draggable-handle": "_left-draggable-handle_cizw2_15",
  "right-draggable-handle": "_right-draggable-handle_cizw2_16",
  "draggable-div": "_draggable-div_cizw2_22",
  "top-draggable-handle-grabber": "_top-draggable-handle-grabber_cizw2_27",
  "bottom-draggable-handle-grabber": "_bottom-draggable-handle-grabber_cizw2_28",
  "left-draggable-handle-grabber": "_left-draggable-handle-grabber_cizw2_43",
  "right-draggable-handle-grabber": "_right-draggable-handle-grabber_cizw2_44"
};
function _classCallCheck$F(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$u(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$u(descriptor.key), descriptor);
  }
}
function _createClass$D(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$u(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$u(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$u(arg) {
  var key = _toPrimitive$u(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$u(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$F(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$u(subClass, superClass);
}
function _setPrototypeOf$u(o, p) {
  _setPrototypeOf$u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$u(o, p);
}
function _createSuper$u(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$u();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$u(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$u(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$F(this, result);
  };
}
function _possibleConstructorReturn$F(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$u(self2);
}
function _assertThisInitialized$u(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$u() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$u(o) {
  _getPrototypeOf$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$u(o);
}
let DraggableDiv = /* @__PURE__ */ function(_React$Component) {
  _inherits$F(DraggableDiv2, _React$Component);
  var _super = _createSuper$u(DraggableDiv2);
  function DraggableDiv2(props) {
    var _this;
    _classCallCheck$F(this, DraggableDiv2);
    _this = _super.call(this, props);
    _this.dragTopRight = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragTopRightFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragTopLeft = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragTopLeftFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragBottomRight = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragBottomRightFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragBottomLeft = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragBottomLeftFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragBottom = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragBottomFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragTop = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragTopFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragLeft = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragLeftFunc.bind(_assertThisInitialized$u(_this)));
    _this.dragRight = drag().on("start", _this.dragStart.bind(_assertThisInitialized$u(_this))).on("drag", _this.dragRightFunc.bind(_assertThisInitialized$u(_this)));
    _this.minWidth = 10;
    _this.minHeight = 10;
    _this.bottomHandleWidth = 20;
    _this.state = {
      uid: _this.props.uid,
      width: _this.props.width,
      height: _this.props.height,
      top: _this.props.top,
      left: _this.props.left
    };
    _this.domBody = select$1("body").node();
    return _this;
  }
  _createClass$D(DraggableDiv2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      select$1(this.bottomHandle).call(this.dragBottom);
      select$1(this.topHandle).call(this.dragTop);
      select$1(this.leftHandle).call(this.dragLeft);
      select$1(this.rightHandle).call(this.dragRight);
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if ("width" in newProps) {
        this.setState({
          width: newProps.width
        });
      }
      if ("height" in newProps) {
        this.setState({
          height: newProps.height
        });
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "dragBottomFunc",
    value: function dragBottomFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      this.setState({
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragLeftFunc",
    value: function dragLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      this.setState({
        left: newLeft,
        width: newWidth
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopFunc",
    value: function dragTopFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      this.setState({
        top: newTop,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragRightFunc",
    value: function dragRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      this.setState({
        width: newWidth
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragBottomLeftFunc",
    value: function dragBottomLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      this.setState({
        left: newLeft,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragBottomRightFunc",
    value: function dragBottomRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      this.setState({
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopRightFunc",
    value: function dragTopRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      this.setState({
        top: newTop,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopLeftFunc",
    value: function dragTopLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      this.setState({
        top: newTop,
        left: newLeft,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragStart",
    value: function dragStart(event) {
      this.dragStartMousePos = pointer(event, this.domBody);
      this.dragStartWidth = this.state.width;
      this.dragStartHeight = this.state.height;
      this.dragStartTop = this.state.top;
      this.dragStartLeft = this.state.left;
      event.sourceEvent.stopPropagation();
    }
  }, {
    key: "sizeChanged",
    value: function sizeChanged() {
      if (this.props.sizeChanged) {
        this.props.sizeChanged(this.state);
      }
    }
  }, {
    key: "rotateClicked",
    value: function rotateClicked() {
      this.props.trackRotated(this.state.uid);
    }
  }, {
    key: "closeClicked",
    value: function closeClicked() {
      this.props.trackClosed(this.state.uid);
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const dragColor = this.props.theme === THEME_DARK ? "white" : "black";
      const divStyle = {
        top: this.state.top,
        left: this.state.left,
        width: this.state.width,
        height: this.state.height,
        opacity: this.props.opacity
      };
      const resizeWidth = 24;
      const resizeHeight = 24;
      const horizStyle = {
        left: this.state.width / 2 - resizeWidth / 2,
        width: resizeWidth
      };
      const vertStyle = {
        top: this.state.height / 2 - resizeHeight / 2,
        height: resizeHeight
      };
      const styles2 = {
        bottom: {
          ...horizStyle,
          bottom: 1
        },
        top: {
          ...horizStyle,
          top: 1
        },
        left: {
          ...vertStyle,
          left: 1
        },
        right: {
          ...vertStyle,
          right: 1
        }
      };
      const resizeHandles = [...this.props.resizeHandles].map((x) => /* @__PURE__ */ React$3.createElement("div", {
        key: x,
        ref: (c2) => {
          this[`${x}Handle`] = c2;
        },
        className: classes$8[`${x}-draggable-handle`],
        style: styles2[x],
        title: "Resize track"
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: classes$8[`${x}-draggable-handle-grabber`],
        style: {
          borderColor: dragColor
        }
      })));
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.divContainer = c2;
        },
        className: clsx(this.props.className, classes$8["draggable-div"]),
        style: divStyle
      }, resizeHandles);
    }
  }]);
  return DraggableDiv2;
}(React$3.Component);
DraggableDiv.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  left: PropTypes.number,
  opacity: PropTypes.number,
  resizeHandles: PropTypes.object,
  sizeChanged: PropTypes.func,
  top: PropTypes.number,
  trackClosed: PropTypes.func,
  trackRotated: PropTypes.func,
  uid: PropTypes.string,
  width: PropTypes.number,
  theme: PropTypes.symbol
};
const DraggableDiv$1 = withTheme(DraggableDiv);
function _classCallCheck$E(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$t(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$t(descriptor.key), descriptor);
  }
}
function _createClass$C(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$t(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$t(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$t(arg) {
  var key = _toPrimitive$t(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$t(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$E(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$t(subClass, superClass);
}
function _setPrototypeOf$t(o, p) {
  _setPrototypeOf$t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$t(o, p);
}
function _createSuper$t(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$t();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$t(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$t(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$E(this, result);
  };
}
function _possibleConstructorReturn$E(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$t(self2);
}
function _assertThisInitialized$t(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$t() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$t(o) {
  _getPrototypeOf$t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$t(o);
}
let TrackArea = /* @__PURE__ */ function(_React$Component) {
  _inherits$E(TrackArea2, _React$Component);
  var _super = _createSuper$t(TrackArea2);
  function TrackArea2(props) {
    var _this;
    _classCallCheck$E(this, TrackArea2);
    _this = _super.call(this, props);
    _this.state = {
      controlsVisible: false
    };
    return _this;
  }
  _createClass$C(TrackArea2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.resizing;
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        controlsVisible: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        controlsVisible: false
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.setState({
        controlsVisible: true
      });
    }
  }, {
    key: "getControls",
    value: function getControls() {
      let Handle = null;
      if (this.moveable) {
        Handle = sortableHandle(() => /* @__PURE__ */ React$3.createElement("svg", {
          className: "no-zoom",
          height: "10px",
          onClick: () => {
          },
          style: this.getMoveImgStyle(),
          width: "10px"
        }, /* @__PURE__ */ React$3.createElement("use", {
          xlinkHref: "#move"
        })));
      } else {
        Handle = sortableHandle(() => /* @__PURE__ */ React$3.createElement("div", null));
      }
      return /* @__PURE__ */ React$3.createElement("div", {
        style: {
          position: "absolute",
          backgroundColor: "rgba(255,255,255,0.7)",
          right: "3px",
          top: "3px",
          pointerEvents: "none",
          paddingLeft: "5px",
          paddingRight: "5px",
          borderRadius: "5px",
          border: "1px solid #dddddd"
        }
      }, /* @__PURE__ */ React$3.createElement(Handle, null), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.imgConfig = c2;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => {
          const imgDom = ReactDOM.findDOMNode(this.imgConfig);
          const bbox = imgDom.getBoundingClientRect();
          this.props.onConfigTrackMenuOpened(this.props.uid, bbox);
        },
        style: this.getSettingsImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#cog"
      })), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.imgAdd = c2;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => this.props.onAddSeries(this.props.uid),
        style: this.getAddImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#plus"
      })), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.imgClose = c2;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => {
          const imgDom = ReactDOM.findDOMNode(this.imgClose);
          const bbox = imgDom.getBoundingClientRect();
          this.props.onCloseTrackMenuOpened(this.props.uid, bbox);
        },
        style: this.getCloseImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#cross"
      })));
    }
  }]);
  return TrackArea2;
}(React$3.Component);
TrackArea.propTypes = {
  configMenuOpen: PropTypes.bool,
  onConfigTrackMenuOpened: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onAddSeries: PropTypes.func,
  uid: PropTypes.string
};
function _classCallCheck$D(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$s(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$s(descriptor.key), descriptor);
  }
}
function _createClass$B(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$s(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$s(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$s(arg) {
  var key = _toPrimitive$s(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$s(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$D(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$s(subClass, superClass);
}
function _setPrototypeOf$s(o, p) {
  _setPrototypeOf$s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$s(o, p);
}
function _createSuper$s(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$s();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$s(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$s(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$D(this, result);
  };
}
function _possibleConstructorReturn$D(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$s(self2);
}
function _assertThisInitialized$s(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$s() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$s(o) {
  _getPrototypeOf$s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$s(o);
}
let MoveableTrack = /* @__PURE__ */ function(_TrackArea) {
  _inherits$D(MoveableTrack2, _TrackArea);
  var _super = _createSuper$s(MoveableTrack2);
  function MoveableTrack2(props) {
    var _this;
    _classCallCheck$D(this, MoveableTrack2);
    _this = _super.call(this, props);
    _this.moveable = true;
    return _this;
  }
  _createClass$B(MoveableTrack2, [{
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (r2) => {
          this.el = r2;
        },
        className: this.props.className,
        onMouseEnter: this.handleMouseEnter.bind(this),
        onMouseLeave: () => {
          this.handleMouseLeave();
        },
        style: {
          height: this.props.height,
          width: this.props.width
        }
      }, /* @__PURE__ */ React$3.createElement(DraggableDiv$1, {
        key: this.props.uid,
        height: this.props.height,
        resizeHandles: this.props.editable ? this.props.resizeHandles : /* @__PURE__ */ new Set(),
        sizeChanged: (stuff) => this.props.handleResizeTrack(this.props.uid, stuff.width, stuff.height),
        style: {
          background: "transparent"
        },
        uid: this.props.uid,
        width: this.props.width
      }), this.props.editable && this.getControls(this.state.controlsVisible || this.props.item.configMenuVisible));
    }
  }]);
  return MoveableTrack2;
}(TrackArea);
MoveableTrack.propTypes = {
  className: PropTypes.string,
  uid: PropTypes.string,
  item: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number
};
function _classCallCheck$C(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$r(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$r(descriptor.key), descriptor);
  }
}
function _createClass$A(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$r(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$r(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$r(arg) {
  var key = _toPrimitive$r(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$r(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$C(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$r(subClass, superClass);
}
function _setPrototypeOf$r(o, p) {
  _setPrototypeOf$r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$r(o, p);
}
function _createSuper$r(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$r();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$r(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$r(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$C(this, result);
  };
}
function _possibleConstructorReturn$C(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$r(self2);
}
function _assertThisInitialized$r(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$r() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$r(o) {
  _getPrototypeOf$r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$r(o);
}
const STYLES$1 = {
  pointerEvents: "all"
};
let HorizontalTrack = /* @__PURE__ */ function(_MoveableTrack) {
  _inherits$C(HorizontalTrack2, _MoveableTrack);
  var _super = _createSuper$r(HorizontalTrack2);
  function HorizontalTrack2() {
    _classCallCheck$C(this, HorizontalTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$A(HorizontalTrack2, [{
    key: "getControls",
    value: function getControls(isVisible) {
      return /* @__PURE__ */ React$3.createElement(TrackControl$1, {
        configMenuVisible: this.props.item.configMenuVisible,
        imgStyleAdd: STYLES$1,
        imgStyleClose: STYLES$1,
        imgStyleMove: STYLES$1,
        imgStyleSettings: STYLES$1,
        isMoveable: this.moveable,
        isVisible,
        onAddSeries: this.props.onAddSeries,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        uid: this.props.uid
      });
    }
  }]);
  return HorizontalTrack2;
}(MoveableTrack);
const HorizontalItem = sortableElement((props) => /* @__PURE__ */ React$3.createElement(HorizontalTrack, {
  className: props.className,
  editable: props.editable,
  handleConfigTrack: props.handleConfigTrack,
  handleResizeTrack: props.handleResizeTrack,
  height: props.height,
  item: props.item,
  onAddSeries: props.onAddSeries,
  onCloseTrack: props.onCloseTrack,
  onCloseTrackMenuOpened: props.onCloseTrackMenuOpened,
  onConfigTrackMenuOpened: props.onConfigTrackMenuOpened,
  resizeHandles: props.resizeHandles,
  uid: props.uid,
  width: props.width
}));
function _extends$k() {
  _extends$k = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$k.apply(this, arguments);
}
const SortableList = sortableContainer(({
  className: className2,
  items: items2,
  itemClass,
  itemControlAlignLeft,
  sortingIndex,
  useDragHandle,
  sortableHandlers,
  height: height2,
  width,
  onCloseTrack,
  onCloseTrackMenuOpened,
  onConfigTrackMenuOpened,
  onAddSeries,
  handleConfigTrack,
  editable,
  itemReactClass,
  handleResizeTrack,
  resizeHandles
}) => {
  const itemElements = items2.map((item, index2) => /* @__PURE__ */ React$3.createElement(itemReactClass, {
    key: `sci-${item.uid}-${Math.random().toString(36).substring(7)}`,
    className: itemClass,
    controlAlignLeft: itemControlAlignLeft,
    sortingIndex,
    index: index2,
    uid: item.uid,
    height: item.height,
    width: item.width,
    item,
    useDragHandle,
    onCloseTrack,
    onCloseTrackMenuOpened,
    onConfigTrackMenuOpened,
    onAddSeries,
    handleConfigTrack,
    editable,
    handleResizeTrack,
    resizeHandles
  }));
  return /* @__PURE__ */ React$3.createElement("div", _extends$k({
    className: className2,
    style: {
      height: height2,
      width,
      background: "transparent"
    }
  }, sortableHandlers), itemElements);
});
const styles$4 = {
  "horizontal-tiled-plot": "_horizontal-tiled-plot_1bqkg_1"
};
function _classCallCheck$B(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$q(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$q(descriptor.key), descriptor);
  }
}
function _createClass$z(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$q(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$q(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$q(arg) {
  var key = _toPrimitive$q(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$q(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$B(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$q(subClass, superClass);
}
function _setPrototypeOf$q(o, p) {
  _setPrototypeOf$q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$q(o, p);
}
function _createSuper$q(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$q();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$q(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$q(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$B(this, result);
  };
}
function _possibleConstructorReturn$B(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$q(self2);
}
function _assertThisInitialized$q(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$q() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$q(o) {
  _getPrototypeOf$q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$q(o);
}
function sourceEvent$1(event) {
  return event && event.sourceEvent;
}
let HorizontalTiledPlot = /* @__PURE__ */ function(_React$Component) {
  _inherits$B(HorizontalTiledPlot2, _React$Component);
  var _super = _createSuper$q(HorizontalTiledPlot2);
  function HorizontalTiledPlot2(props) {
    var _this;
    _classCallCheck$B(this, HorizontalTiledPlot2);
    _this = _super.call(this, props);
    _this.brushBehavior = brushX().on("start", _this.brushStarted.bind(_assertThisInitialized$q(_this))).on("brush", _this.brushed.bind(_assertThisInitialized$q(_this))).on("end", _this.brushedEnded.bind(_assertThisInitialized$q(_this)));
    return _this;
  }
  _createClass$z(HorizontalTiledPlot2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggered) {
        this.rangeSelectionTriggered = false;
        if (this.rangeSelectionTriggeredEnd && this.props.rangeSelection !== nextProps.rangeSelection) {
          this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, true);
        }
        this.rangeSelectionTriggeredEnd = false;
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, nextProps.rangeSelectionEnd);
        return this.state !== nextState;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      } else {
        this.removeBrush();
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush",
    value: function addBrush() {
      if (!this.brushEl || this.brushElAddedBefore === this.brushEl) {
        return;
      }
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.on(".brush", null);
      }
      this.brushEl.call(this.brushBehavior);
      this.brushElAddedBefore = this.brushEl;
      resetD3BrushStyle(this.brushEl, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushed",
    value: function brushed(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$1(event) || !this.props.onRangeSelection || rangeSelectionMoved)
        return;
      this.rangeSelectionTriggered = true;
      this.props.onRangeSelection(event.selection);
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent$1(event) || !event.selection)
        return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "brushedEnded",
    value: function brushedEnded(event) {
      if (!this.props.is1dRangeSelection)
        return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelection && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggered = true;
        this.rangeSelectionTriggeredEnd = true;
        this.props.onRangeSelectionEnd(event.selection);
      }
      if (!event.selection) {
        this.rangeSelectionTriggered = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "moveBrush",
    value: function moveBrush(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = rangeSelection ? [this.props.scale(rangeSelection[0]), this.props.scale(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushEl.transition().call(this.brushBehavior.move, relRange);
      } else {
        this.brushEl.call(this.brushBehavior.move, relRange);
      }
    }
  }, {
    key: "removeBrush",
    value: function removeBrush() {
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.call(this.brushBehavior.move, null);
        this.brushElAddedBefore.on(".brush", null);
        this.brushElAddedBefore = void 0;
        this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const height2 = this.props.tracks.map((x) => x.height).reduce(sum, 0);
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or, false);
      const rangeSelectorClass = this.props.isRangeSelectionActive ? stylesTrack["track-range-selection-active"] : stylesTrack["track-range-selection"];
      return /* @__PURE__ */ React$3.createElement("div", {
        className: clsx("horizontal-tiled-plot", styles$4["horizontal-tiled-plot"])
      }, isBrushable && /* @__PURE__ */ React$3.createElement("svg", {
        ref: (el) => {
          this.brushEl = select$1(el);
        },
        className: rangeSelectorClass,
        style: {
          height: height2,
          width: this.props.width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }), /* @__PURE__ */ React$3.createElement(ListWrapper, {
        className: clsx(styles$5.list, styles$5.stylizedList),
        component: SortableList,
        editable: this.props.editable,
        handleConfigTrack: this.props.handleConfigTrack,
        handleResizeTrack: this.props.handleResizeTrack,
        height: height2,
        helperClass: styles$5.stylizedHelper,
        itemClass: styles$5.stylizedItem,
        itemReactClass: HorizontalItem,
        items: this.props.tracks.map((d) => ({
          configMenuVisible: d.uid === this.props.configTrackMenuId,
          uid: d.uid || slugid$1.nice(),
          width: this.props.width,
          height: d.height,
          value: d.value
        })),
        onAddSeries: this.props.onAddSeries,
        onCloseTrack: this.props.onCloseTrack,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        onSortEnd: this.props.handleSortEnd,
        referenceAncestor: this.props.referenceAncestor,
        resizeHandles: this.props.resizeHandles,
        useDragHandle: true,
        width: this.props.width
      }));
    }
  }]);
  return HorizontalTiledPlot2;
}(React$3.Component);
HorizontalTiledPlot.propTypes = {
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  handleSortEnd: PropTypes.func,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onRangeSelection: PropTypes.func,
  onRangeSelectionEnd: PropTypes.func,
  onRangeSelectionReset: PropTypes.func,
  onRangeSelectionStart: PropTypes.func,
  rangeSelection: PropTypes.array,
  rangeSelectionEnd: PropTypes.bool,
  referenceAncestor: PropTypes.func,
  resizeHandles: PropTypes.object,
  scale: PropTypes.func,
  tracks: PropTypes.array,
  width: PropTypes.number
};
function _classCallCheck$A(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$p(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$p(descriptor.key), descriptor);
  }
}
function _createClass$y(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$p(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$p(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$p(arg) {
  var key = _toPrimitive$p(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$p(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$A(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$p(subClass, superClass);
}
function _setPrototypeOf$p(o, p) {
  _setPrototypeOf$p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$p(o, p);
}
function _createSuper$p(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$p();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$p(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$p(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$A(this, result);
  };
}
function _possibleConstructorReturn$A(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$p(self2);
}
function _assertThisInitialized$p(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$p() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$p(o) {
  _getPrototypeOf$p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$p(o);
}
const STYLES = {
  pointerEvents: "all"
};
let VerticalTrack = /* @__PURE__ */ function(_MoveableTrack) {
  _inherits$A(VerticalTrack2, _MoveableTrack);
  var _super = _createSuper$p(VerticalTrack2);
  function VerticalTrack2() {
    _classCallCheck$A(this, VerticalTrack2);
    return _super.apply(this, arguments);
  }
  _createClass$y(VerticalTrack2, [{
    key: "getControls",
    value: function getControls(isVisible) {
      return /* @__PURE__ */ React$3.createElement(TrackControl$1, {
        imgStyleAdd: STYLES,
        imgStyleClose: STYLES,
        imgStyleMove: STYLES,
        imgStyleSettings: STYLES,
        isAlignLeft: this.props.controlAlignLeft,
        isMoveable: this.moveable,
        isVertical: true,
        isVisible,
        onAddSeries: this.props.onAddSeries,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        uid: this.props.uid
      });
    }
  }]);
  return VerticalTrack2;
}(MoveableTrack);
function _classCallCheck$z(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$o(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$o(descriptor.key), descriptor);
  }
}
function _createClass$x(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$o(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$o(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$o(arg) {
  var key = _toPrimitive$o(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$o(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get$1() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get$1 = Reflect.get.bind();
  } else {
    _get$1 = function _get2(target, property2, receiver) {
      var base = _superPropBase$1(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get$1.apply(this, arguments);
}
function _superPropBase$1(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$o(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$z(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$o(subClass, superClass);
}
function _setPrototypeOf$o(o, p) {
  _setPrototypeOf$o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$o(o, p);
}
function _createSuper$o(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$o();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$o(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$o(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$z(this, result);
  };
}
function _possibleConstructorReturn$z(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$o(self2);
}
function _assertThisInitialized$o(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$o() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$o(o) {
  _getPrototypeOf$o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$o(o);
}
let ViewportTracker2D = /* @__PURE__ */ function(_PixiTrack) {
  _inherits$z(ViewportTracker2D2, _PixiTrack);
  var _super = _createSuper$o(ViewportTracker2D2);
  function ViewportTracker2D2(context, options2) {
    var _this;
    _classCallCheck$z(this, ViewportTracker2D2);
    _this = _super.call(this, context, options2);
    const {
      registerViewportChanged,
      removeViewportChanged
    } = context;
    const uid = slugid$1.nice();
    _this.uid = uid;
    _this.removeViewportChanged = removeViewportChanged;
    _this.viewportXDomain = null;
    _this.viewportYDomain = null;
    registerViewportChanged(uid, _this.viewportChanged.bind(_assertThisInitialized$o(_this)));
    return _this;
  }
  _createClass$x(ViewportTracker2D2, [{
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      graphics.clear();
      graphics.lineStyle(1, 255, 1);
      graphics.beginFill(16740363, 1);
      const x = this._xScale(this.viewportXDomain[0]);
      const y = this._yScale(this.viewportYDomain[0]);
      const width = this._xScale(this.viewportXDomain[1]) - this._xScale(this.viewportXDomain[0]);
      const height2 = this._yScale(this.viewportYDomain[1]) - this._yScale(this.viewportYDomain[0]);
      this.pMain.drawRect(x, y, width, height2);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _get$1(_getPrototypeOf$o(ViewportTracker2D2.prototype), "setPosition", this).call(this, newPosition);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
      this.draw();
    }
  }]);
  return ViewportTracker2D2;
}(PixiTrack);
function LruCache(limit2) {
  this.size = 0;
  this.limit = limit2;
  this._keymap = {};
}
function put(key, value2) {
  const entry = {
    key,
    value: value2
  };
  this._keymap[key] = entry;
  if (this.tail) {
    this.tail.newer = entry;
    entry.older = this.tail;
  } else {
    this.head = entry;
  }
  this.tail = entry;
  if (this.size === this.limit) {
    return this.shift();
  }
  this.size += 1;
  return void 0;
}
function shift() {
  const entry = this.head;
  if (entry) {
    if (this.head.newer) {
      this.head = this.head.newer;
      this.head.older = void 0;
    } else {
      this.head = void 0;
      this.tail = void 0;
    }
    entry.newer = void 0;
    entry.older = void 0;
    delete this._keymap[entry.key];
    this.size -= 1;
  }
  return entry;
}
function get$2(key, returnEntry) {
  const entry = this._keymap[key];
  if (entry === void 0)
    return void 0;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  if (entry.newer) {
    if (entry === this.head)
      this.head = entry.newer;
    entry.newer.older = entry.older;
  }
  if (entry.older)
    entry.older.newer = entry.newer;
  entry.newer = void 0;
  entry.older = this.tail;
  if (this.tail)
    this.tail.newer = entry;
  this.tail = entry;
  return returnEntry ? entry : entry.value;
}
function find(key) {
  return this._keymap[key];
}
function set(key, value2) {
  const entry = this.get(key, true);
  let oldvalue;
  if (entry) {
    oldvalue = entry.value;
    entry.value = value2;
  } else {
    oldvalue = this.put(key, value2);
    if (oldvalue)
      oldvalue = oldvalue.value;
  }
  return oldvalue;
}
function remove2(key) {
  const entry = this._keymap[key];
  if (!entry)
    return void 0;
  delete this._keymap[entry.key];
  if (entry.newer && entry.older) {
    entry.older.newer = entry.newer;
    entry.newer.older = entry.older;
  } else if (entry.newer) {
    entry.newer.older = void 0;
    this.head = entry.newer;
  } else if (entry.older) {
    entry.older.newer = void 0;
    this.tail = entry.older;
  } else {
    this.head = void 0;
    this.tail = void 0;
  }
  this.size -= 1;
  return entry.value;
}
function removeAll() {
  this.head = void 0;
  this.tail = void 0;
  this.size = 0;
  this._keymap = {};
}
function keys$1() {
  return Object.keys(this._keymap);
}
function forEach$1(fun, context, desc) {
  let entry;
  if (context === true) {
    desc = true;
    context = void 0;
  } else if (typeof context !== "object") {
    context = this;
  }
  if (desc) {
    entry = this.tail;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.older;
    }
  } else {
    entry = this.head;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.newer;
    }
  }
}
function toJSON() {
  const s = [];
  let entry = this.head;
  while (entry) {
    s.push({
      key: entry.key.toJSON(),
      value: entry.value.toJSON()
    });
    entry = entry.newer;
  }
  return s;
}
function toString$1() {
  let s = "";
  let entry = this.head;
  while (entry) {
    s += `${String(entry.key)}:${entry.value}`;
    entry = entry.newer;
    if (entry)
      s += " < ";
  }
  return s;
}
Object.assign(LruCache.prototype, {
  put,
  get: get$2,
  find,
  keys: keys$1,
  set,
  shift,
  remove: remove2,
  removeAll,
  forEach: forEach$1,
  toJSON,
  toString: toString$1
});
const version = "1.13.4";
const button = "_button_1wnjn_1";
const classes$7 = {
  button,
  "button-shortcut": "_button-shortcut_1wnjn_35"
};
const Button = /* @__PURE__ */ React$3.forwardRef((props, ref2) => /* @__PURE__ */ React$3.createElement("button", {
  ref: ref2,
  className: classes$7[props.styleName] ?? classes$7.button,
  disabled: props.disable,
  onBlur: props.onBlur,
  onClick: props.onClick,
  onMouseDown: props.onMouseDown,
  onMouseOut: props.onMouseOut,
  onMouseUp: props.onMouseUp,
  type: "button"
}, props.children, props.shortcut && /* @__PURE__ */ React$3.createElement("span", {
  className: classes$7["button-shortcut"]
}, props.shortcut)));
Button.defaultProps = {
  onClick: () => {
  },
  styleName: "",
  type: "button"
};
Button.propTypes = {
  children: PropTypes.any,
  disable: PropTypes.bool,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseUp: PropTypes.func,
  shortcut: PropTypes.string,
  type: PropTypes.string,
  styleName: PropTypes.string
};
const cross = "_cross_2ke8w_1";
const classes$6 = {
  cross
};
function Cross() {
  return /* @__PURE__ */ React$3.createElement("div", {
    className: classes$6.cross
  });
}
function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$j.apply(this, arguments);
}
const {
  Provider,
  Consumer
} = /* @__PURE__ */ React$3.createContext({
  close: toVoid,
  open: toVoid
});
const withModal = (Component2) => /* @__PURE__ */ React$3.forwardRef((props, ref2) => /* @__PURE__ */ React$3.createElement(Consumer, null, (modal2) => /* @__PURE__ */ React$3.createElement(Component2, _extends$j({
  ref: ref2
}, props, {
  modal: modal2
}))));
const classes$5 = {
  "modal-background": "_modal-background_zzhoe_1",
  "fade-in": "_fade-in_zzhoe_1",
  "modal-hide": "_modal-hide_zzhoe_13",
  "modal-wrap": "_modal-wrap_zzhoe_17",
  "modal-window": "_modal-window_zzhoe_25",
  "fade-scale-in": "_fade-scale-in_zzhoe_1",
  "modal-window-max-height": "_modal-window-max-height_zzhoe_38",
  "modal-content": "_modal-content_zzhoe_42"
};
function Modal(props) {
  const handleClose = () => {
    props.modal.close();
    if (props.onClose)
      props.onClose();
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    className: clsx(classes$5["modal-background"], {
      [classes$5["modal-hide"]]: props.hide
    })
  }, /* @__PURE__ */ React$3.createElement("div", {
    className: classes$5["modal-wrap"]
  }, /* @__PURE__ */ React$3.createElement("div", {
    className: clsx(classes$5["modal-window"], {
      [classes$5["modal-window-max-height"]]: props.maxHeight
    })
  }, props.closeButton && /* @__PURE__ */ React$3.createElement(Button, {
    onClick: handleClose
  }, /* @__PURE__ */ React$3.createElement(Cross, null)), /* @__PURE__ */ React$3.createElement("div", {
    className: classes$5["modal-content"]
  }, props.children))));
}
Modal.defaultProps = {
  closeButton: true,
  hide: false,
  maxHeight: false
};
Modal.propTypes = {
  children: PropTypes.element.isRequired,
  closeButton: PropTypes.bool,
  hide: PropTypes.bool,
  maxHeight: PropTypes.bool,
  modal: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
const Modal$1 = withModal(Modal);
const classes$4 = {
  "dialog-header": "_dialog-header_wp50s_1",
  "dialog-main-max-height": "_dialog-main-max-height_wp50s_20",
  "dialog-footer": "_dialog-footer_wp50s_31",
  "dialog-footer-max-height": "_dialog-footer-max-height_wp50s_31"
};
function Dialog(props) {
  const handleCancel = () => {
    props.modal.close();
    if (props.onCancel)
      props.onCancel();
  };
  const handleOkay = () => {
    props.modal.close();
    if (props.onOkay)
      props.onOkay();
  };
  return /* @__PURE__ */ React$3.createElement(Modal$1, {
    closeButton: false,
    hide: props.hide,
    maxHeight: props.maxHeight
  }, /* @__PURE__ */ React$3.createElement(React$3.Fragment, null, /* @__PURE__ */ React$3.createElement("header", {
    className: classes$4["dialog-header"]
  }, /* @__PURE__ */ React$3.createElement("h3", null, props.title), /* @__PURE__ */ React$3.createElement(Button, {
    onClick: handleCancel
  }, /* @__PURE__ */ React$3.createElement(Cross, null))), props.maxHeight ? /* @__PURE__ */ React$3.createElement("main", {
    className: clsx(props.maxHeight && classes$4["dialog-main-max-height"])
  }, props.children) : /* @__PURE__ */ React$3.createElement("main", null, props.children), /* @__PURE__ */ React$3.createElement("footer", {
    className: classes$4[props.maxHeight ? "dialog-footer-max-height" : "dialog-footer"]
  }, props.okayOnly ? /* @__PURE__ */ React$3.createElement("div", null) : /* @__PURE__ */ React$3.createElement(Button, {
    onClick: handleCancel,
    shortcut: props.cancelShortcut
  }, props.cancelTitle), /* @__PURE__ */ React$3.createElement(Button, {
    onClick: handleOkay,
    shortcut: props.okayShortcut
  }, props.okayTitle))));
}
Dialog.defaultProps = {
  cancelTitle: "Cancel",
  hide: false,
  maxHeight: false,
  okayOnly: false,
  okayTitle: "Ok"
};
Dialog.propTypes = {
  cancelShortcut: PropTypes.string,
  cancelTitle: PropTypes.string,
  children: PropTypes.object,
  hide: PropTypes.bool,
  maxHeight: PropTypes.bool,
  modal: PropTypes.object.isRequired,
  okayShortcut: PropTypes.string,
  okayTitle: PropTypes.string,
  okayOnly: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onOkay: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
const Dialog$1 = withModal(Dialog);
var lib$2 = {};
var flattenNames$1 = {};
var freeGlobal = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
const freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
const root$1 = root;
var Symbol$1 = root$1.Symbol;
const Symbol$2 = Symbol$1;
var objectProto$f = Object.prototype;
var hasOwnProperty$c = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value2) {
  var isOwn = hasOwnProperty$c.call(value2, symToStringTag$1), tag = value2[symToStringTag$1];
  try {
    value2[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag$1] = tag;
    } else {
      delete value2[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString(value2) {
  return nativeObjectToString.call(value2);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString(value2);
}
var isArray = Array.isArray;
const isArray$1 = isArray;
function isObjectLike(value2) {
  return value2 != null && typeof value2 == "object";
}
var stringTag$4 = "[object String]";
function isString2(value2) {
  return typeof value2 == "string" || !isArray$1(value2) && isObjectLike(value2) && baseGetTag(value2) == stringTag$4;
}
const isString$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: isString2
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(isString$1);
function createBaseFor(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length2 = props.length;
    while (length2--) {
      var key = props[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor = createBaseFor();
const baseFor$1 = baseFor;
function baseTimes(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value2) {
  return isObjectLike(value2) && baseGetTag(value2) == argsTag$3;
}
var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;
var isArguments2 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value2) {
  return isObjectLike(value2) && hasOwnProperty$b.call(value2, "callee") && !propertyIsEnumerable$1.call(value2, "callee");
};
const isArguments$1 = isArguments2;
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$2 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
const isBuffer$1 = isBuffer;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value2, length2) {
  var type3 = typeof value2;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type3 == "number" || type3 != "symbol" && reIsUint.test(value2)) && value2 > -1 && value2 % 1 == 0 && value2 < length2;
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value2) {
  return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
}
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$2 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value2) {
  return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
}
function baseUnary(func) {
  return function(value2) {
    return func(value2);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
var objectProto$c = Object.prototype;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
function arrayLikeKeys(value2, inherited) {
  var isArr = isArray$1(value2), isArg = !isArr && isArguments$1(value2), isBuff = !isArr && !isArg && isBuffer$1(value2), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value2.length, String) : [], length2 = result.length;
  for (var key in value2) {
    if ((inherited || hasOwnProperty$a.call(value2, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$b = Object.prototype;
function isPrototype(value2) {
  var Ctor = value2 && value2.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$b;
  return value2 === proto2;
}
function overArg(func, transform3) {
  return function(arg) {
    return func(transform3(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$a = Object.prototype;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys$1(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$9.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function isObject(value2) {
  var type3 = typeof value2;
  return value2 != null && (type3 == "object" || type3 == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value2) {
  if (!isObject(value2)) {
    return false;
  }
  var tag = baseGetTag(value2);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
function isArrayLike(value2) {
  return value2 != null && isLength(value2.length) && !isFunction(value2);
}
function keys2(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function baseForOwn(object2, iteratee) {
  return object2 && baseFor$1(object2, iteratee, keys2);
}
function identity(value2) {
  return value2;
}
function castFunction(value2) {
  return typeof value2 == "function" ? value2 : identity;
}
function forOwn(object2, iteratee) {
  return object2 && baseForOwn(object2, castFunction(iteratee));
}
const forOwn$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: forOwn
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(forOwn$1);
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
var objectTag$3 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$9 = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject(value2) {
  if (!isObjectLike(value2) || baseGetTag(value2) != objectTag$3) {
    return false;
  }
  var proto2 = getPrototype$1(value2);
  if (proto2 === null) {
    return true;
  }
  var Ctor = hasOwnProperty$8.call(proto2, "constructor") && proto2.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
const isPlainObject$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: isPlainObject
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(isPlainObject$1);
function arrayMap(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
function assocIndexOf(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value2) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value2]);
  } else {
    data2[index2][1] = value2;
  }
  return this;
}
function ListCache(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var coreJsData = root$1["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$8 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value2) {
  if (!isObject(value2) || isMasked(value2)) {
    return false;
  }
  var pattern2 = isFunction(value2) ? reIsNative : reIsHostCtor;
  return pattern2.test(toSource(value2));
}
function getValue(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value2 = getValue(object2, key);
  return baseIsNative(value2) ? value2 : void 0;
}
var Map$1 = getNative(root$1, "Map");
const Map$2 = Map$1;
var nativeCreate = getNative(Object, "create");
const nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function hashGet(key) {
  var data2 = this.__data__;
  if (nativeCreate$1) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data2, key) ? data2[key] : void 0;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function hashHas(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$5.call(data2, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value2) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate$1 && value2 === void 0 ? HASH_UNDEFINED$1 : value2;
  return this;
}
function Hash(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value2) {
  var type3 = typeof value2;
  return type3 == "string" || type3 == "number" || type3 == "symbol" || type3 == "boolean" ? value2 !== "__proto__" : value2 === null;
}
function getMapData(map2, key) {
  var data2 = map2.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value2) {
  var data2 = getMapData(this, key), size = data2.size;
  data2.set(key, value2);
  this.size += data2.size == size ? 0 : 1;
  return this;
}
function MapCache(entries2) {
  var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries2[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value2) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache) {
    var pairs2 = data2.__data__;
    if (!Map$2 || pairs2.length < LARGE_ARRAY_SIZE - 1) {
      pairs2.push([key, value2]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache(pairs2);
  }
  data2.set(key, value2);
  this.size = data2.size;
  return this;
}
function Stack(entries2) {
  var data2 = this.__data__ = new ListCache(entries2);
  this.size = data2.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value2) {
  this.__data__.set(value2, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value2) {
  return this.__data__.has(value2);
}
function SetCache(values2) {
  var index2 = -1, length2 = values2 == null ? 0 : values2.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values2[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array2);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array2, other);
  stack.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array2);
  stack["delete"](other);
  return result;
}
var Uint8Array$1 = root$1.Uint8Array;
const Uint8Array$2 = Uint8Array$1;
function mapToArray(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value2, key) {
    result[++index2] = [key, value2];
  });
  return result;
}
function setToArray(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value2) {
    result[++index2] = value2;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", mapTag$4 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]";
var symbolProto$2 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$2:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object2), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag$2:
    case dateTag$2:
    case numberTag$2:
      return eq(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$2:
    case stringTag$2:
      return object2 == other + "";
    case mapTag$4:
      var convert = mapToArray;
    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object2) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
function arrayPush(array2, values2) {
  var index2 = -1, length2 = values2.length, offset2 = array2.length;
  while (++index2 < length2) {
    array2[offset2 + index2] = values2[index2];
  }
  return array2;
}
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$1(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
function arrayFilter(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value2 = array2[index2];
    if (predicate(value2, index2, array2)) {
      result[resIndex++] = value2;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols$1(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
const getSymbols$1 = getSymbols;
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys2, getSymbols$1);
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$4.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var DataView$1 = getNative(root$1, "DataView");
const DataView$2 = DataView$1;
var Promise$1 = getNative(root$1, "Promise");
const Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
const Set$2 = Set$1;
var WeakMap$1 = getNative(root$1, "WeakMap");
const WeakMap$2 = WeakMap$1;
var mapTag$3 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$2), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function(value2) {
    var result = baseGetTag(value2), Ctor = result == objectTag$2 ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object2), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag$1 : getTag$1(object2), othTag = othIsArr ? arrayTag$1 : getTag$1(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object2)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$3.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$3.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value2, other, bitmask, customizer, stack) {
  if (value2 === other) {
    return true;
  }
  if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
    return value2 !== value2 && other !== other;
  }
  return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value2) {
  return value2 === value2 && !isObject(value2);
}
function getMatchData(object2) {
  var result = keys2(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value2 = object2[key];
    result[length2] = [key, value2, isStrictComparable(value2)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var symbolTag$2 = "[object Symbol]";
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag(value2) == symbolTag$2;
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value2, object2) {
  if (isArray$1(value2)) {
    return false;
  }
  var type3 = typeof value2;
  if (type3 == "number" || type3 == "symbol" || type3 == "boolean" || value2 == null || isSymbol(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object2 != null && value2 in Object(object2);
}
var FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number3, quote2, subString) {
    result.push(quote2 ? subString.replace(reEscapeChar, "$1") : number3 || match);
  });
  return result;
});
const stringToPath$1 = stringToPath2;
var INFINITY$1 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray$1(value2)) {
    return arrayMap(value2, baseToString) + "";
  }
  if (isSymbol(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -INFINITY$1 ? "-0" : result;
}
function toString(value2) {
  return value2 == null ? "" : baseToString(value2);
}
function castPath(value2, object2) {
  if (isArray$1(value2)) {
    return value2;
  }
  return isKey(value2, object2) ? [value2] : stringToPath$1(toString(value2));
}
var INFINITY = 1 / 0;
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol(value2)) {
    return value2;
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -INFINITY ? "-0" : result;
}
function baseGet(object2, path) {
  path = castPath(path, object2);
  var index2 = 0, length2 = path.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey(path[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
function get$1(object2, path, defaultValue) {
  var result = object2 == null ? void 0 : baseGet(object2, path);
  return result === void 0 ? defaultValue : result;
}
function baseHasIn(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath(object2, path, hasFunc) {
  path = castPath(path, object2);
  var index2 = -1, length2 = path.length, result = false;
  while (++index2 < length2) {
    var key = toKey(path[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray$1(object2) || isArguments$1(object2));
}
function hasIn(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object2) {
    var objValue = get$1(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
function basePropertyDeep(path) {
  return function(object2) {
    return baseGet(object2, path);
  };
}
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value2) {
  if (typeof value2 == "function") {
    return value2;
  }
  if (value2 == null) {
    return identity;
  }
  if (typeof value2 == "object") {
    return isArray$1(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
  }
  return property(value2);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
const baseEach$1 = baseEach;
function baseMap(collection, iteratee) {
  var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function(value2, key, collection2) {
    result[++index2] = iteratee(value2, key, collection2);
  });
  return result;
}
function map(collection, iteratee) {
  var func = isArray$1(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}
const map$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: map
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(map$1);
Object.defineProperty(flattenNames$1, "__esModule", {
  value: true
});
flattenNames$1.flattenNames = void 0;
var _isString2 = require$$0$1;
var _isString3 = _interopRequireDefault$7(_isString2);
var _forOwn2$2 = require$$0;
var _forOwn3$2 = _interopRequireDefault$7(_forOwn2$2);
var _isPlainObject2 = require$$2;
var _isPlainObject3 = _interopRequireDefault$7(_isPlainObject2);
var _map2 = require$$3;
var _map3 = _interopRequireDefault$7(_map2);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var flattenNames = flattenNames$1.flattenNames = function flattenNames2() {
  var things = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var names2 = [];
  (0, _map3.default)(things, function(thing) {
    if (Array.isArray(thing)) {
      flattenNames2(thing).map(function(name) {
        return names2.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3$2.default)(thing, function(value2, key) {
        value2 === true && names2.push(key);
        names2.push(key + "-" + value2);
      });
    } else if ((0, _isString3.default)(thing)) {
      names2.push(thing);
    }
  });
  return names2;
};
flattenNames$1.default = flattenNames;
var mergeClasses$1 = {};
function arrayEach(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
}();
const defineProperty$1 = defineProperty;
function baseAssignValue(object2, key, value2) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value2,
      "writable": true
    });
  } else {
    object2[key] = value2;
  }
}
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function assignValue(object2, key, value2) {
  var objValue = object2[key];
  if (!(hasOwnProperty$2.call(object2, key) && eq(objValue, value2)) || value2 === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value2);
  }
}
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
function baseAssign(object2, source) {
  return object2 && copyObject(source, keys2(source), object2);
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$1.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
function baseAssignIn(object2, source) {
  return object2 && copyObject(source, keysIn(source), object2);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$1 = moduleExports ? root$1.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(buffer2, isDeep) {
  if (isDeep) {
    return buffer2.slice();
  }
  var length2 = buffer2.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer2.constructor(length2);
  buffer2.copy(result);
  return result;
}
function copyArray(source, array2) {
  var index2 = -1, length2 = source.length;
  array2 || (array2 = Array(length2));
  while (++index2 < length2) {
    array2[index2] = source[index2];
  }
  return array2;
}
function copySymbols(source, object2) {
  return copyObject(source, getSymbols$1(source), object2);
}
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
  var result = [];
  while (object2) {
    arrayPush(result, getSymbols$1(object2));
    object2 = getPrototype$1(object2);
  }
  return result;
};
const getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(source, object2) {
  return copyObject(source, getSymbolsIn$1(source), object2);
}
function getAllKeysIn(object2) {
  return baseGetAllKeys(object2, keysIn, getSymbolsIn$1);
}
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function initCloneArray(array2) {
  var length2 = array2.length, result = new array2.constructor(length2);
  if (length2 && typeof array2[0] == "string" && hasOwnProperty.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object2, tag, isDeep) {
  var Ctor = object2.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object2);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object2);
    case dataViewTag$1:
      return cloneDataView(object2, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object2, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object2);
    case regexpTag$1:
      return cloneRegExp(object2);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object2);
  }
}
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
  function object2() {
  }
  return function(proto2) {
    if (!isObject(proto2)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto2);
    }
    object2.prototype = proto2;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
const baseCreate$1 = baseCreate;
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate$1(getPrototype$1(object2)) : {};
}
var mapTag$1 = "[object Map]";
function baseIsMap(value2) {
  return isObjectLike(value2) && getTag$1(value2) == mapTag$1;
}
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
const isMap$1 = isMap;
var setTag$1 = "[object Set]";
function baseIsSet(value2) {
  return isObjectLike(value2) && getTag$1(value2) == setTag$1;
}
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
const isSet$1 = isSet;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value2, bitmask, customizer, key, object2, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object2 ? customizer(value2, key, object2, stack) : customizer(value2);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject(value2)) {
    return value2;
  }
  var isArr = isArray$1(value2);
  if (isArr) {
    result = initCloneArray(value2);
    if (!isDeep) {
      return copyArray(value2, result);
    }
  } else {
    var tag = getTag$1(value2), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value2)) {
      return cloneBuffer(value2, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object2) {
      result = isFlat || isFunc ? {} : initCloneObject(value2);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value2, baseAssignIn(result, value2)) : copySymbols(value2, baseAssign(result, value2));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object2 ? value2 : {};
      }
      result = initCloneByTag(value2, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value2);
  if (stacked) {
    return stacked;
  }
  stack.set(value2, result);
  if (isSet$1(value2)) {
    value2.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value2, stack));
    });
  } else if (isMap$1(value2)) {
    value2.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys2;
  var props = isArr ? void 0 : keysFunc(value2);
  arrayEach(props || value2, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value2[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value2, stack));
  });
  return result;
}
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value2) {
  return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
const cloneDeep$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cloneDeep
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(cloneDeep$1);
Object.defineProperty(mergeClasses$1, "__esModule", {
  value: true
});
mergeClasses$1.mergeClasses = void 0;
var _forOwn2$1 = require$$0;
var _forOwn3$1 = _interopRequireDefault$6(_forOwn2$1);
var _cloneDeep2 = require$$1;
var _cloneDeep3 = _interopRequireDefault$6(_cloneDeep2);
var _extends$i = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var mergeClasses = mergeClasses$1.mergeClasses = function mergeClasses2(classes2) {
  var activeNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var styles2 = classes2.default && (0, _cloneDeep3.default)(classes2.default) || {};
  activeNames.map(function(name) {
    var toMerge = classes2[name];
    if (toMerge) {
      (0, _forOwn3$1.default)(toMerge, function(value2, key) {
        if (!styles2[key]) {
          styles2[key] = {};
        }
        styles2[key] = _extends$i({}, styles2[key], toMerge[key]);
      });
    }
    return name;
  });
  return styles2;
};
mergeClasses$1.default = mergeClasses;
var autoprefix$1 = {};
Object.defineProperty(autoprefix$1, "__esModule", {
  value: true
});
autoprefix$1.autoprefix = void 0;
var _forOwn2 = require$$0;
var _forOwn3 = _interopRequireDefault$5(_forOwn2);
var _extends$h = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var transforms = {
  borderRadius: function borderRadius(value2) {
    return {
      msBorderRadius: value2,
      MozBorderRadius: value2,
      OBorderRadius: value2,
      WebkitBorderRadius: value2,
      borderRadius: value2
    };
  },
  boxShadow: function boxShadow(value2) {
    return {
      msBoxShadow: value2,
      MozBoxShadow: value2,
      OBoxShadow: value2,
      WebkitBoxShadow: value2,
      boxShadow: value2
    };
  },
  userSelect: function userSelect(value2) {
    return {
      WebkitTouchCallout: value2,
      KhtmlUserSelect: value2,
      MozUserSelect: value2,
      msUserSelect: value2,
      WebkitUserSelect: value2,
      userSelect: value2
    };
  },
  flex: function flex(value2) {
    return {
      WebkitBoxFlex: value2,
      MozBoxFlex: value2,
      WebkitFlex: value2,
      msFlex: value2,
      flex: value2
    };
  },
  flexBasis: function flexBasis(value2) {
    return {
      WebkitFlexBasis: value2,
      flexBasis: value2
    };
  },
  justifyContent: function justifyContent(value2) {
    return {
      WebkitJustifyContent: value2,
      justifyContent: value2
    };
  },
  transition: function transition2(value2) {
    return {
      msTransition: value2,
      MozTransition: value2,
      OTransition: value2,
      WebkitTransition: value2,
      transition: value2
    };
  },
  transform: function transform2(value2) {
    return {
      msTransform: value2,
      MozTransform: value2,
      OTransform: value2,
      WebkitTransform: value2,
      transform: value2
    };
  },
  absolute: function absolute(value2) {
    var direction = value2 && value2.split(" ");
    return {
      position: "absolute",
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend2(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      "extend": name
    };
  }
};
var autoprefix = autoprefix$1.autoprefix = function autoprefix2(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function(styles2, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles2, function(value2, key) {
      var transform3 = transforms[key];
      if (transform3) {
        expanded = _extends$h({}, expanded, transform3(value2));
      } else {
        expanded[key] = value2;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};
autoprefix$1.default = autoprefix;
var hover$1 = {};
Object.defineProperty(hover$1, "__esModule", {
  value: true
});
hover$1.hover = void 0;
var _extends$g = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$4 = React$3;
var _react2$3 = _interopRequireDefault$4(_react$4);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$y(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$y(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$y(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = hover$1.hover = function hover2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$y(Hover, _React$Component);
    function Hover() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$y(this, Hover);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$y(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        hover: false
      }, _this.handleMouseOver = function() {
        return _this.setState({
          hover: true
        });
      }, _this.handleMouseOut = function() {
        return _this.setState({
          hover: false
        });
      }, _this.render = function() {
        return _react2$3.default.createElement(Span, {
          onMouseOver: _this.handleMouseOver,
          onMouseOut: _this.handleMouseOut
        }, _react2$3.default.createElement(Component2, _extends$g({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn$y(_this, _ret);
    }
    return Hover;
  }(_react2$3.default.Component);
};
hover$1.default = hover;
var active$1 = {};
Object.defineProperty(active$1, "__esModule", {
  value: true
});
active$1.active = void 0;
var _extends$f = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$3 = React$3;
var _react2$2 = _interopRequireDefault$3(_react$3);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck$x(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$x(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$x(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = active$1.active = function active2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$x(Active, _React$Component);
    function Active() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$x(this, Active);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$x(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this.handleMouseDown = function() {
        return _this.setState({
          active: true
        });
      }, _this.handleMouseUp = function() {
        return _this.setState({
          active: false
        });
      }, _this.render = function() {
        return _react2$2.default.createElement(Span, {
          onMouseDown: _this.handleMouseDown,
          onMouseUp: _this.handleMouseUp
        }, _react2$2.default.createElement(Component2, _extends$f({}, _this.props, _this.state)));
      }, _temp), _possibleConstructorReturn$x(_this, _ret);
    }
    return Active;
  }(_react2$2.default.Component);
};
active$1.default = active;
var loop = {};
Object.defineProperty(loop, "__esModule", {
  value: true
});
var loopable = function loopable2(i, length2) {
  var props = {};
  var setProp2 = function setProp3(name) {
    var value2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    props[name] = value2;
  };
  i === 0 && setProp2("first-child");
  i === length2 - 1 && setProp2("last-child");
  (i === 0 || i % 2 === 0) && setProp2("even");
  Math.abs(i % 2) === 1 && setProp2("odd");
  setProp2("nth-child", i);
  return props;
};
loop.default = loopable;
Object.defineProperty(lib$2, "__esModule", {
  value: true
});
lib$2.ReactCSS = lib$2.loop = lib$2.handleActive = handleHover = lib$2.handleHover = lib$2.hover = void 0;
var _flattenNames = flattenNames$1;
var _flattenNames2 = _interopRequireDefault$2(_flattenNames);
var _mergeClasses = mergeClasses$1;
var _mergeClasses2 = _interopRequireDefault$2(_mergeClasses);
var _autoprefix = autoprefix$1;
var _autoprefix2 = _interopRequireDefault$2(_autoprefix);
var _hover2 = hover$1;
var _hover3 = _interopRequireDefault$2(_hover2);
var _active = active$1;
var _active2 = _interopRequireDefault$2(_active);
var _loop2 = loop;
var _loop3 = _interopRequireDefault$2(_loop2);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
lib$2.hover = _hover3.default;
var handleHover = lib$2.handleHover = _hover3.default;
lib$2.handleActive = _active2.default;
lib$2.loop = _loop3.default;
var ReactCSS = lib$2.ReactCSS = function ReactCSS2(classes2) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }
  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes2, activeNames);
  return (0, _autoprefix2.default)(merged);
};
var _default$3 = lib$2.default = ReactCSS;
var calculateChange$2 = function calculateChange(e, hsl2, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var a = void 0;
    if (top2 < 0) {
      a = 0;
    } else if (top2 > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top2 * 100 / containerHeight) / 100;
    }
    if (hsl2.a !== a) {
      return {
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a,
        source: "rgb"
      };
    }
  } else {
    var _a = void 0;
    if (left2 < 0) {
      _a = 0;
    } else if (left2 > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left2 * 100 / containerWidth) / 100;
    }
    if (initialA !== _a) {
      return {
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a: _a,
        source: "rgb"
      };
    }
  }
  return null;
};
var checkboardCache = {};
var render = function render2(c1, c2, size, serverCanvas) {
  if (typeof document === "undefined" && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};
var get = function get2(c1, c2, size, serverCanvas) {
  var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
var _extends$e = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var Checkboard = function Checkboard2(_ref) {
  var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius2 = _ref.borderRadius, boxShadow2 = _ref.boxShadow, children3 = _ref.children;
  var styles2 = _default$3({
    "default": {
      grid: {
        borderRadius: borderRadius2,
        boxShadow: boxShadow2,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get(white, grey, size, renderers.canvas) + ") center left"
      }
    }
  });
  return /* @__PURE__ */ isValidElement(children3) ? /* @__PURE__ */ React$3.cloneElement(children3, _extends$e({}, children3.props, {
    style: _extends$e({}, children3.props.style, styles2.grid)
  })) : /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.grid
  });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$d = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$w = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$w(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$w(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$w(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
  _inherits$w(Alpha2, _ref);
  function Alpha2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck$w(this, Alpha2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$w(this, (_ref2 = Alpha2.__proto__ || Object.getPrototypeOf(Alpha2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e) {
      var change = calculateChange$2(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleChange);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$w(_this, _ret);
  }
  _createClass$w(Alpha2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var rgb2 = this.props.rgb;
      var styles2 = _default$3({
        "default": {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 0) 0%,\n           rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: rgb2.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 0) 0%,\n           rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: rgb2.a * 100 + "%"
          }
        },
        "overwrite": _extends$d({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: true
      });
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.alpha
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.checkboard
      }, /* @__PURE__ */ React$3.createElement(Checkboard, {
        renderers: this.props.renderers
      })), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.gradient
      }), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.container,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React$3.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.slider
      }))));
    }
  }]);
  return Alpha2;
}(PureComponent || Component);
var _createClass$v = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _defineProperty(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value2,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _classCallCheck$v(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$v(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$v(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode2(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue2(value2) {
  return Number(String(value2).replace(/%/g, ""));
};
var idCounter = 1;
var EditableInput = function(_ref) {
  _inherits$v(EditableInput2, _ref);
  function EditableInput2(props) {
    _classCallCheck$v(this, EditableInput2);
    var _this = _possibleConstructorReturn$v(this, (EditableInput2.__proto__ || Object.getPrototypeOf(EditableInput2)).call(this));
    _this.handleBlur = function() {
      if (_this.state.blurValue) {
        _this.setState({
          value: _this.state.blurValue,
          blurValue: null
        });
      }
    };
    _this.handleChange = function(e) {
      _this.setUpdatedValue(e.target.value, e);
    };
    _this.handleKeyDown = function(e) {
      var value2 = getNumberValue(e.target.value);
      if (!isNaN(value2) && isValidKeyCode(e.keyCode)) {
        var offset2 = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value2 + offset2 : value2 - offset2;
        _this.setUpdatedValue(updatedValue, e);
      }
    };
    _this.handleDrag = function(e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };
    _this.handleMouseDown = function(e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener("mousemove", _this.handleDrag);
        window.addEventListener("mouseup", _this.handleMouseUp);
      }
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleDrag);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    };
    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    _this.inputId = "rc-editable-input-" + idCounter++;
    return _this;
  }
  _createClass$v(EditableInput2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({
            blurValue: String(this.props.value).toUpperCase()
          });
        } else {
          this.setState({
            value: String(this.props.value).toUpperCase(),
            blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function getValueObjectWithLabel(value2) {
      return _defineProperty({}, this.props.label, value2);
    }
  }, {
    key: "getArrowOffset",
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function setUpdatedValue(value2, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value2) : value2;
      this.props.onChange && this.props.onChange(onChangeValue, e);
      this.setState({
        value: value2
      });
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles2 = _default$3({
        "default": {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": true
      }, this.props);
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.wrap
      }, /* @__PURE__ */ React$3.createElement("input", {
        id: this.inputId,
        style: styles2.input,
        ref: function ref2(input) {
          return _this2.input = input;
        },
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        placeholder: this.props.placeholder,
        spellCheck: "false"
      }), this.props.label && !this.props.hideLabel ? /* @__PURE__ */ React$3.createElement("label", {
        htmlFor: this.inputId,
        style: styles2.label,
        onMouseDown: this.handleMouseDown
      }, this.props.label) : null);
    }
  }]);
  return EditableInput2;
}(PureComponent || Component);
var calculateChange$1 = function calculateChange2(e, direction, hsl2, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var h = void 0;
    if (top2 < 0) {
      h = 359;
    } else if (top2 > containerHeight) {
      h = 0;
    } else {
      var percent = -(top2 * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }
    if (hsl2.h !== h) {
      return {
        h,
        s: hsl2.s,
        l: hsl2.l,
        a: hsl2.a,
        source: "hsl"
      };
    }
  } else {
    var _h = void 0;
    if (left2 < 0) {
      _h = 0;
    } else if (left2 > containerWidth) {
      _h = 359;
    } else {
      var _percent = left2 * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }
    if (hsl2.h !== _h) {
      return {
        h: _h,
        s: hsl2.s,
        l: hsl2.l,
        a: hsl2.a,
        source: "hsl"
      };
    }
  }
  return null;
};
var _createClass$u = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$u(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$u(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$u(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
  _inherits$u(Hue2, _ref);
  function Hue2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck$u(this, Hue2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$u(this, (_ref2 = Hue2.__proto__ || Object.getPrototypeOf(Hue2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e) {
      var change = calculateChange$1(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$u(_this, _ret);
  }
  _createClass$u(Hue2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _props$direction = this.props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction;
      var styles2 = _default$3({
        "default": {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, {
        vertical: direction === "vertical"
      });
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.hue
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: "hue-" + direction,
        style: styles2.container,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React$3.createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React$3.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.slider
      }))));
    }
  }]);
  return Hue2;
}(PureComponent || Component);
function assignMergeValue(object2, key, value2) {
  if (value2 !== void 0 && !eq(object2[key], value2) || value2 === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value2);
  }
}
function isArrayLikeObject(value2) {
  return isObjectLike(value2) && isArrayLike(value2);
}
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
function toPlainObject(value2) {
  return copyObject(value2, keysIn(value2));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$1(srcValue), isBuff = !isArr && isBuffer$1(srcValue), isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack) {
  if (object2 === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn);
}
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var nativeMax$1 = Math.max;
function overRest(func, start2, transform3) {
  start2 = nativeMax$1(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$1(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform3(array2);
    return apply(func, this, otherArgs);
  };
}
function constant(value2) {
  return function() {
    return value2;
  };
}
var baseSetToString = !defineProperty$1 ? identity : function(func, string) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
const baseSetToString$1 = baseSetToString;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count2 = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count2 >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count2 = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString$1);
const setToString$1 = setToString;
function baseRest(func, start2) {
  return setToString$1(overRest(func, start2, identity), func + "");
}
function isIterateeCall(value2, index2, object2) {
  if (!isObject(object2)) {
    return false;
  }
  var type3 = typeof index2;
  if (type3 == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type3 == "string" && index2 in object2) {
    return eq(object2[index2], value2);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object2, sources) {
    var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length2 < 3 ? void 0 : customizer;
      length2 = 1;
    }
    object2 = Object(object2);
    while (++index2 < length2) {
      var source = sources[index2];
      if (source) {
        assigner(object2, source, index2, customizer);
      }
    }
    return object2;
  });
}
var merge = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
const merge$1 = merge;
var Raised = function Raised2(_ref) {
  var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children3 = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles;
  var styles2 = _default$3(merge$1({
    "default": {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
        borderRadius: radius,
        background
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    "square": {
      bg: {
        borderRadius: "0"
      }
    },
    "circle": {
      bg: {
        borderRadius: "50%"
      }
    }
  }, passedStyles), {
    "zDepth-1": zDepth === 1
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.wrap
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.bg
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.content
  }, children3));
};
Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now = function() {
  return root$1.Date.now();
};
const now$1 = now;
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value2) {
  if (typeof value2 == "number") {
    return value2;
  }
  if (isSymbol(value2)) {
    return NAN;
  }
  if (isObject(value2)) {
    var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
    value2 = isObject(other) ? other + "" : other;
  }
  if (typeof value2 != "string") {
    return value2 === 0 ? value2 : +value2;
  }
  value2 = baseTrim(value2);
  var isBinary = reIsBinary.test(value2);
  return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$1();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time2 = now$1(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options2) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options2)) {
    leading = "leading" in options2 ? !!options2.leading : leading;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var calculateChange3 = function calculateChange4(e, hsl2, container) {
  var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (left2 < 0) {
    left2 = 0;
  } else if (left2 > containerWidth) {
    left2 = containerWidth;
  }
  if (top2 < 0) {
    top2 = 0;
  } else if (top2 > containerHeight) {
    top2 = containerHeight;
  }
  var saturation = left2 / containerWidth;
  var bright = 1 - top2 / containerHeight;
  return {
    h: hsl2.h,
    s: saturation,
    v: bright,
    a: hsl2.a,
    source: "hsv"
  };
};
var _createClass$t = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$t(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$t(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$t(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
  _inherits$t(Saturation2, _ref);
  function Saturation2(props) {
    _classCallCheck$t(this, Saturation2);
    var _this = _possibleConstructorReturn$t(this, (Saturation2.__proto__ || Object.getPrototypeOf(Saturation2)).call(this, props));
    _this.handleChange = function(e) {
      typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, calculateChange3(e, _this.props.hsl, _this.container), e);
    };
    _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener("mousemove", _this.handleChange);
      renderWindow.addEventListener("mouseup", _this.handleMouseUp);
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.throttle = throttle(function(fn, data2, e) {
      fn(data2, e);
    }, 50);
    return _this;
  }
  _createClass$t(Saturation2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function getContainerRenderWindow() {
      var container = this.container;
      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener("mousemove", this.handleChange);
      renderWindow.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _ref2 = this.props.style || {}, color2 = _ref2.color, white = _ref2.white, black = _ref2.black, pointer2 = _ref2.pointer, circle2 = _ref2.circle;
      var styles2 = _default$3({
        "default": {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        "custom": {
          color: color2,
          white,
          black,
          pointer: pointer2,
          circle: circle2
        }
      }, {
        "custom": !!this.props.style
      });
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.color,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React$3.createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.white,
        className: "saturation-white"
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.black,
        className: "saturation-black"
      }), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React$3.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.circle
      }))));
    }
  }]);
  return Saturation2;
}(PureComponent || Component);
function forEach(collection, iteratee) {
  var func = isArray$1(collection) ? arrayEach : baseEach$1;
  return func(collection, castFunction(iteratee));
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color2, opts) {
  color2 = color2 ? color2 : "";
  opts = opts || {};
  if (color2 instanceof tinycolor) {
    return color2;
  }
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color2, opts);
  }
  var rgb2 = inputToRGB(color2);
  this._originalInput = color2, this._r = rgb2.r, this._g = rgb2.g, this._b = rgb2.b, this._a = rgb2.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb2.format;
  this._gradientType = opts.gradientType;
  if (this._r < 1)
    this._r = Math.round(this._r);
  if (this._g < 1)
    this._g = Math.round(this._g);
  if (this._b < 1)
    this._b = Math.round(this._b);
  this._ok = rgb2.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    var rgb2 = this.toRgb();
    return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
  },
  getLuminance: function getLuminance() {
    var rgb2 = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B2;
    RsRGB = rgb2.r / 255;
    GsRGB = rgb2.g / 255;
    BsRGB = rgb2.b / 255;
    if (RsRGB <= 0.03928)
      R = RsRGB / 12.92;
    else
      R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928)
      G = GsRGB / 12.92;
    else
      G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928)
      B2 = BsRGB / 12.92;
    else
      B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B2;
  },
  setAlpha: function setAlpha(value2) {
    this._a = boundAlpha(value2);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl2 = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl2.h * 360,
      s: hsl2.s,
      l: hsl2.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl2 = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl2.h * 360), s = Math.round(hsl2.s * 100), l = Math.round(hsl2.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString2(format2) {
    var formatSet = !!format2;
    format2 = format2 || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format2 === "hex" || format2 === "hex6" || format2 === "hex3" || format2 === "hex4" || format2 === "hex8" || format2 === "name");
    if (needsAlphaFormat) {
      if (format2 === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format2 === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format2 === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format2 === "hex" || format2 === "hex6") {
      formattedString = this.toHexString();
    }
    if (format2 === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format2 === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format2 === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format2 === "name") {
      formattedString = this.toName();
    }
    if (format2 === "hsl") {
      formattedString = this.toHslString();
    }
    if (format2 === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone2() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color2 = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color2._r;
    this._g = color2._g;
    this._b = color2._b;
    this.setAlpha(color2._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(color2, opts) {
  if (_typeof$1(color2) == "object") {
    var newColor = {};
    for (var i in color2) {
      if (color2.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color2[i];
        } else {
          newColor[i] = convertToPercentage(color2[i]);
        }
      }
    }
    color2 = newColor;
  }
  return tinycolor(color2, opts);
};
function inputToRGB(color2) {
  var rgb2 = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format2 = false;
  if (typeof color2 == "string") {
    color2 = stringInputToObject(color2);
  }
  if (_typeof$1(color2) == "object") {
    if (isValidCSSUnit(color2.r) && isValidCSSUnit(color2.g) && isValidCSSUnit(color2.b)) {
      rgb2 = rgbToRgb(color2.r, color2.g, color2.b);
      ok = true;
      format2 = String(color2.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.v)) {
      s = convertToPercentage(color2.s);
      v = convertToPercentage(color2.v);
      rgb2 = hsvToRgb(color2.h, s, v);
      ok = true;
      format2 = "hsv";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.l)) {
      s = convertToPercentage(color2.s);
      l = convertToPercentage(color2.l);
      rgb2 = hslToRgb(color2.h, s, l);
      ok = true;
      format2 = "hsl";
    }
    if (color2.hasOwnProperty("a")) {
      a = color2.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color2.format || format2,
    r: Math.min(255, Math.max(rgb2.r, 0)),
    g: Math.min(255, Math.max(rgb2.g, 0)),
    b: Math.min(255, Math.max(rgb2.b, 0)),
    a
  };
}
function rgbToRgb(r2, g, b) {
  return {
    r: bound01(r2, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r2, g, b) {
  r2 = bound01(r2, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max2 = Math.max(r2, g, b), min2 = Math.min(r2, g, b);
  var h, s, l = (max2 + min2) / 2;
  if (max2 == min2) {
    h = s = 0;
  } else {
    var d = max2 - min2;
    s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
    switch (max2) {
      case r2:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r2) / d + 2;
        break;
      case b:
        h = (r2 - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    l
  };
}
function hslToRgb(h, s, l) {
  var r2, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p2, q2, t) {
    if (t < 0)
      t += 1;
    if (t > 1)
      t -= 1;
    if (t < 1 / 6)
      return p2 + (q2 - p2) * 6 * t;
    if (t < 1 / 2)
      return q2;
    if (t < 2 / 3)
      return p2 + (q2 - p2) * (2 / 3 - t) * 6;
    return p2;
  }
  if (s === 0) {
    r2 = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r2 = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r2 * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHsv(r2, g, b) {
  r2 = bound01(r2, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max2 = Math.max(r2, g, b), min2 = Math.min(r2, g, b);
  var h, s, v = max2;
  var d = max2 - min2;
  s = max2 === 0 ? 0 : d / max2;
  if (max2 == min2) {
    h = 0;
  } else {
    switch (max2) {
      case r2:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r2) / d + 2;
        break;
      case b:
        h = (r2 - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    v
  };
}
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h), f2 = h - i, p = v * (1 - s), q = v * (1 - f2 * s), t = v * (1 - (1 - f2) * s), mod2 = i % 6, r2 = [v, q, p, p, t, v][mod2], g = [t, v, v, q, p, p][mod2], b = [p, p, t, v, v, q][mod2];
  return {
    r: r2 * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHex(r2, g, b, allow3Char) {
  var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  if (allow3Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1)) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
  }
  return hex2.join("");
}
function rgbaToHex(r2, g, b, a, allow4Char) {
  var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
  if (allow4Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1) && hex2[3].charAt(0) == hex2[3].charAt(1)) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
  }
  return hex2.join("");
}
function rgbaToArgbHex(r2, g, b, a) {
  var hex2 = [pad2(convertDecimalToHex(a)), pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex2.join("");
}
tinycolor.equals = function(color1, color2) {
  if (!color1 || !color2)
    return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.s -= amount / 100;
  hsl2.s = clamp01(hsl2.s);
  return tinycolor(hsl2);
}
function _saturate(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.s += amount / 100;
  hsl2.s = clamp01(hsl2.s);
  return tinycolor(hsl2);
}
function _greyscale(color2) {
  return tinycolor(color2).desaturate(100);
}
function _lighten(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.l += amount / 100;
  hsl2.l = clamp01(hsl2.l);
  return tinycolor(hsl2);
}
function _brighten(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb2 = tinycolor(color2).toRgb();
  rgb2.r = Math.max(0, Math.min(255, rgb2.r - Math.round(255 * -(amount / 100))));
  rgb2.g = Math.max(0, Math.min(255, rgb2.g - Math.round(255 * -(amount / 100))));
  rgb2.b = Math.max(0, Math.min(255, rgb2.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb2);
}
function _darken(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.l -= amount / 100;
  hsl2.l = clamp01(hsl2.l);
  return tinycolor(hsl2);
}
function _spin(color2, amount) {
  var hsl2 = tinycolor(color2).toHsl();
  var hue = (hsl2.h + amount) % 360;
  hsl2.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl2);
}
function _complement(color2) {
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.h = (hsl2.h + 180) % 360;
  return tinycolor(hsl2);
}
function polyad(color2, number3) {
  if (isNaN(number3) || number3 <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl2 = tinycolor(color2).toHsl();
  var result = [tinycolor(color2)];
  var step = 360 / number3;
  for (var i = 1; i < number3; i++) {
    result.push(tinycolor({
      h: (hsl2.h + i * step) % 360,
      s: hsl2.s,
      l: hsl2.l
    }));
  }
  return result;
}
function _splitcomplement(color2) {
  var hsl2 = tinycolor(color2).toHsl();
  var h = hsl2.h;
  return [tinycolor(color2), tinycolor({
    h: (h + 72) % 360,
    s: hsl2.s,
    l: hsl2.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl2.s,
    l: hsl2.l
  })];
}
function _analogous(color2, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl2 = tinycolor(color2).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color2)];
  for (hsl2.h = (hsl2.h - (part * results >> 1) + 720) % 360; --results; ) {
    hsl2.h = (hsl2.h + part) % 360;
    ret.push(tinycolor(hsl2));
  }
  return ret;
}
function _monochromatic(color2, results) {
  results = results || 6;
  var hsv = tinycolor(color2).toHsv();
  var h = hsv.h, s = hsv.s, v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h,
      s,
      v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}
tinycolor.mix = function(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba2 = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba2);
};
tinycolor.readability = function(color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};
tinycolor.mostReadable = function(baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level,
    size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
var hexNames = tinycolor.hexNames = flip(names);
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function bound01(n, max2) {
  if (isOnePointZero(n))
    n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max2, Math.max(0, parseFloat(n)));
  if (processPercent) {
    n = parseInt(n * max2, 10) / 100;
  }
  if (Math.abs(n - max2) < 1e-6) {
    return 1;
  }
  return n % max2 / parseFloat(max2);
}
function clamp01(val2) {
  return Math.min(1, Math.max(0, val2));
}
function parseIntFromHex(val2) {
  return parseInt(val2, 16);
}
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}
function pad2(c2) {
  return c2.length == 1 ? "0" + c2 : "" + c2;
}
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function() {
  var CSS_INTEGER = "[-\\+]?\\d+%?";
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function isValidCSSUnit(color2) {
  return !!matchers.CSS_UNIT.exec(color2);
}
function stringInputToObject(color2) {
  color2 = color2.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named2 = false;
  if (names[color2]) {
    color2 = names[color2];
    named2 = true;
  } else if (color2 == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }
  var match;
  if (match = matchers.rgb.exec(color2)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color2)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color2)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named2 ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color2)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named2 ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color2)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named2 ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color2)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named2 ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level,
    size
  };
}
var simpleCheckForValidColor = function simpleCheckForValidColor2(data2) {
  var keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
  var checked = 0;
  var passed = 0;
  forEach(keysToCheck, function(letter) {
    if (data2[letter]) {
      checked += 1;
      if (!isNaN(data2[letter])) {
        passed += 1;
      }
      if (letter === "s" || letter === "l") {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data2[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data2 : false;
};
var toState = function toState2(data2, oldHue) {
  var color2 = data2.hex ? tinycolor(data2.hex) : tinycolor(data2);
  var hsl2 = color2.toHsl();
  var hsv = color2.toHsv();
  var rgb2 = color2.toRgb();
  var hex2 = color2.toHex();
  if (hsl2.s === 0) {
    hsl2.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex2 === "000000" && rgb2.a === 0;
  return {
    hsl: hsl2,
    hex: transparent ? "transparent" : "#" + hex2,
    rgb: rgb2,
    hsv,
    oldHue: data2.h || oldHue || hsl2.h,
    source: data2.source
  };
};
var isValidHex = function isValidHex2(hex2) {
  if (hex2 === "transparent") {
    return true;
  }
  var lh = String(hex2).charAt(0) === "#" ? 1 : 0;
  return hex2.length !== 4 + lh && hex2.length < 7 + lh && tinycolor(hex2).isValid();
};
var getContrastingColor = function getContrastingColor2(data2) {
  if (!data2) {
    return "#fff";
  }
  var col = toState(data2);
  if (col.hex === "transparent") {
    return "rgba(0,0,0,0.4)";
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1e3;
  return yiq >= 128 ? "#000" : "#fff";
};
var isvalidColorString = function isvalidColorString2(string, type3) {
  var stringWithoutDegree = string.replace("°", "");
  return tinycolor(type3 + " (" + stringWithoutDegree + ")")._ok;
};
var _extends$c = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$s = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$s(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$s(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$s(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap2(Picker) {
  var ColorPicker = function(_ref) {
    _inherits$s(ColorPicker2, _ref);
    function ColorPicker2(props) {
      _classCallCheck$s(this, ColorPicker2);
      var _this = _possibleConstructorReturn$s(this, (ColorPicker2.__proto__ || Object.getPrototypeOf(ColorPicker2)).call(this));
      _this.handleChange = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };
      _this.handleSwatchHover = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };
      _this.state = _extends$c({}, toState(props.color, 0));
      _this.debounce = debounce(function(fn, data2, event) {
        fn(data2, event);
      }, 100);
      return _this;
    }
    _createClass$s(ColorPicker2, [{
      key: "render",
      value: function render3() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }
        return /* @__PURE__ */ React$3.createElement(Picker, _extends$c({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$c({}, toState(nextProps.color, state.oldHue));
      }
    }]);
    return ColorPicker2;
  }(PureComponent || Component);
  ColorPicker.propTypes = _extends$c({}, Picker.propTypes);
  ColorPicker.defaultProps = _extends$c({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  });
  return ColorPicker;
};
var _extends$b = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$r = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$r(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$r(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$r(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$r(Focus, _React$Component);
    function Focus() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$r(this, Focus);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$r(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        focus: false
      }, _this.handleFocus = function() {
        return _this.setState({
          focus: true
        });
      }, _this.handleBlur = function() {
        return _this.setState({
          focus: false
        });
      }, _temp), _possibleConstructorReturn$r(_this, _ret);
    }
    _createClass$r(Focus, [{
      key: "render",
      value: function render3() {
        return /* @__PURE__ */ React$3.createElement(Span, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, /* @__PURE__ */ React$3.createElement(Component2, _extends$b({}, this.props, this.state)));
      }
    }]);
    return Focus;
  }(React$3.Component);
};
var _extends$a = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var ENTER = 13;
var Swatch = function Swatch2(_ref) {
  var color2 = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title2 = _ref$title === void 0 ? color2 : _ref$title, children3 = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === void 0 ? {} : _ref$focusStyle;
  var transparent = color2 === "transparent";
  var styles2 = _default$3({
    default: {
      swatch: _extends$a({
        background: color2,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, style, focus ? focusStyle : {})
    }
  });
  var handleClick = function handleClick2(e) {
    return onClick(color2, e);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    return e.keyCode === ENTER && onClick(color2, e);
  };
  var handleHover2 = function handleHover3(e) {
    return onHover(color2, e);
  };
  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover2;
  }
  return /* @__PURE__ */ React$3.createElement("div", _extends$a({
    style: styles2.swatch,
    onClick: handleClick,
    title: title2,
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, optionalEvents), children3, transparent && /* @__PURE__ */ React$3.createElement(Checkboard, {
    borderRadius: styles2.swatch.borderRadius,
    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
  }));
};
const Swatch$1 = handleFocus(Swatch);
var AlphaPointer = function AlphaPointer2(_ref) {
  var direction = _ref.direction;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, {
    vertical: direction === "vertical"
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var _extends$9 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var AlphaPicker = function AlphaPicker2(_ref) {
  var rgb2 = _ref.rgb, hsl2 = _ref.hsl, width = _ref.width, height2 = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer2 = _ref.pointer, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3({
    "default": {
      picker: {
        position: "relative",
        width,
        height: height2
      },
      alpha: {
        radius: "2px",
        style
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "alpha-picker " + className2
  }, /* @__PURE__ */ React$3.createElement(Alpha, _extends$9({}, styles2.alpha, {
    rgb: rgb2,
    hsl: hsl2,
    pointer: pointer2,
    renderers,
    onChange,
    direction
  })));
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);
var BlockSwatches = function BlockSwatches2(_ref) {
  var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var styles2 = _default$3({
    "default": {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatches
  }, map(colors, function(c2) {
    return /* @__PURE__ */ React$3.createElement(Swatch$1, {
      key: c2,
      color: c2,
      style: styles2.swatch,
      onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "0 0 4px " + c2
      }
    });
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.clear
  }));
};
var Block = function Block2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex2 = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var transparent = hex2 === "transparent";
  var handleChange = function handleChange2(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: "hex"
    }, e);
  };
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: hex2,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(hex2),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + hex2 + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle === "hide"
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.card,
    className: "block-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.triangle
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.head
  }, transparent && /* @__PURE__ */ React$3.createElement(Checkboard, {
    borderRadius: "6px 6px 0 0"
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.label
  }, hex2)), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React$3.createElement(BlockSwatches, {
    colors,
    onClick: handleChange,
    onSwatchHover
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input
    },
    value: hex2,
    onChange: handleChange
  })));
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["top", "hide"]),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap(Block);
var red = {
  "50": "#ffebee",
  "100": "#ffcdd2",
  "200": "#ef9a9a",
  "300": "#e57373",
  "400": "#ef5350",
  "500": "#f44336",
  "600": "#e53935",
  "700": "#d32f2f",
  "800": "#c62828",
  "900": "#b71c1c",
  "a100": "#ff8a80",
  "a200": "#ff5252",
  "a400": "#ff1744",
  "a700": "#d50000"
};
var pink = {
  "50": "#fce4ec",
  "100": "#f8bbd0",
  "200": "#f48fb1",
  "300": "#f06292",
  "400": "#ec407a",
  "500": "#e91e63",
  "600": "#d81b60",
  "700": "#c2185b",
  "800": "#ad1457",
  "900": "#880e4f",
  "a100": "#ff80ab",
  "a200": "#ff4081",
  "a400": "#f50057",
  "a700": "#c51162"
};
var purple = {
  "50": "#f3e5f5",
  "100": "#e1bee7",
  "200": "#ce93d8",
  "300": "#ba68c8",
  "400": "#ab47bc",
  "500": "#9c27b0",
  "600": "#8e24aa",
  "700": "#7b1fa2",
  "800": "#6a1b9a",
  "900": "#4a148c",
  "a100": "#ea80fc",
  "a200": "#e040fb",
  "a400": "#d500f9",
  "a700": "#aa00ff"
};
var deepPurple = {
  "50": "#ede7f6",
  "100": "#d1c4e9",
  "200": "#b39ddb",
  "300": "#9575cd",
  "400": "#7e57c2",
  "500": "#673ab7",
  "600": "#5e35b1",
  "700": "#512da8",
  "800": "#4527a0",
  "900": "#311b92",
  "a100": "#b388ff",
  "a200": "#7c4dff",
  "a400": "#651fff",
  "a700": "#6200ea"
};
var indigo = {
  "50": "#e8eaf6",
  "100": "#c5cae9",
  "200": "#9fa8da",
  "300": "#7986cb",
  "400": "#5c6bc0",
  "500": "#3f51b5",
  "600": "#3949ab",
  "700": "#303f9f",
  "800": "#283593",
  "900": "#1a237e",
  "a100": "#8c9eff",
  "a200": "#536dfe",
  "a400": "#3d5afe",
  "a700": "#304ffe"
};
var blue = {
  "50": "#e3f2fd",
  "100": "#bbdefb",
  "200": "#90caf9",
  "300": "#64b5f6",
  "400": "#42a5f5",
  "500": "#2196f3",
  "600": "#1e88e5",
  "700": "#1976d2",
  "800": "#1565c0",
  "900": "#0d47a1",
  "a100": "#82b1ff",
  "a200": "#448aff",
  "a400": "#2979ff",
  "a700": "#2962ff"
};
var lightBlue = {
  "50": "#e1f5fe",
  "100": "#b3e5fc",
  "200": "#81d4fa",
  "300": "#4fc3f7",
  "400": "#29b6f6",
  "500": "#03a9f4",
  "600": "#039be5",
  "700": "#0288d1",
  "800": "#0277bd",
  "900": "#01579b",
  "a100": "#80d8ff",
  "a200": "#40c4ff",
  "a400": "#00b0ff",
  "a700": "#0091ea"
};
var cyan = {
  "50": "#e0f7fa",
  "100": "#b2ebf2",
  "200": "#80deea",
  "300": "#4dd0e1",
  "400": "#26c6da",
  "500": "#00bcd4",
  "600": "#00acc1",
  "700": "#0097a7",
  "800": "#00838f",
  "900": "#006064",
  "a100": "#84ffff",
  "a200": "#18ffff",
  "a400": "#00e5ff",
  "a700": "#00b8d4"
};
var teal = {
  "50": "#e0f2f1",
  "100": "#b2dfdb",
  "200": "#80cbc4",
  "300": "#4db6ac",
  "400": "#26a69a",
  "500": "#009688",
  "600": "#00897b",
  "700": "#00796b",
  "800": "#00695c",
  "900": "#004d40",
  "a100": "#a7ffeb",
  "a200": "#64ffda",
  "a400": "#1de9b6",
  "a700": "#00bfa5"
};
var green = {
  "50": "#e8f5e9",
  "100": "#c8e6c9",
  "200": "#a5d6a7",
  "300": "#81c784",
  "400": "#66bb6a",
  "500": "#4caf50",
  "600": "#43a047",
  "700": "#388e3c",
  "800": "#2e7d32",
  "900": "#1b5e20",
  "a100": "#b9f6ca",
  "a200": "#69f0ae",
  "a400": "#00e676",
  "a700": "#00c853"
};
var lightGreen = {
  "50": "#f1f8e9",
  "100": "#dcedc8",
  "200": "#c5e1a5",
  "300": "#aed581",
  "400": "#9ccc65",
  "500": "#8bc34a",
  "600": "#7cb342",
  "700": "#689f38",
  "800": "#558b2f",
  "900": "#33691e",
  "a100": "#ccff90",
  "a200": "#b2ff59",
  "a400": "#76ff03",
  "a700": "#64dd17"
};
var lime = {
  "50": "#f9fbe7",
  "100": "#f0f4c3",
  "200": "#e6ee9c",
  "300": "#dce775",
  "400": "#d4e157",
  "500": "#cddc39",
  "600": "#c0ca33",
  "700": "#afb42b",
  "800": "#9e9d24",
  "900": "#827717",
  "a100": "#f4ff81",
  "a200": "#eeff41",
  "a400": "#c6ff00",
  "a700": "#aeea00"
};
var yellow = {
  "50": "#fffde7",
  "100": "#fff9c4",
  "200": "#fff59d",
  "300": "#fff176",
  "400": "#ffee58",
  "500": "#ffeb3b",
  "600": "#fdd835",
  "700": "#fbc02d",
  "800": "#f9a825",
  "900": "#f57f17",
  "a100": "#ffff8d",
  "a200": "#ffff00",
  "a400": "#ffea00",
  "a700": "#ffd600"
};
var amber = {
  "50": "#fff8e1",
  "100": "#ffecb3",
  "200": "#ffe082",
  "300": "#ffd54f",
  "400": "#ffca28",
  "500": "#ffc107",
  "600": "#ffb300",
  "700": "#ffa000",
  "800": "#ff8f00",
  "900": "#ff6f00",
  "a100": "#ffe57f",
  "a200": "#ffd740",
  "a400": "#ffc400",
  "a700": "#ffab00"
};
var orange = {
  "50": "#fff3e0",
  "100": "#ffe0b2",
  "200": "#ffcc80",
  "300": "#ffb74d",
  "400": "#ffa726",
  "500": "#ff9800",
  "600": "#fb8c00",
  "700": "#f57c00",
  "800": "#ef6c00",
  "900": "#e65100",
  "a100": "#ffd180",
  "a200": "#ffab40",
  "a400": "#ff9100",
  "a700": "#ff6d00"
};
var deepOrange = {
  "50": "#fbe9e7",
  "100": "#ffccbc",
  "200": "#ffab91",
  "300": "#ff8a65",
  "400": "#ff7043",
  "500": "#ff5722",
  "600": "#f4511e",
  "700": "#e64a19",
  "800": "#d84315",
  "900": "#bf360c",
  "a100": "#ff9e80",
  "a200": "#ff6e40",
  "a400": "#ff3d00",
  "a700": "#dd2c00"
};
var brown = {
  "50": "#efebe9",
  "100": "#d7ccc8",
  "200": "#bcaaa4",
  "300": "#a1887f",
  "400": "#8d6e63",
  "500": "#795548",
  "600": "#6d4c41",
  "700": "#5d4037",
  "800": "#4e342e",
  "900": "#3e2723"
};
var blueGrey = {
  "50": "#eceff1",
  "100": "#cfd8dc",
  "200": "#b0bec5",
  "300": "#90a4ae",
  "400": "#78909c",
  "500": "#607d8b",
  "600": "#546e7a",
  "700": "#455a64",
  "800": "#37474f",
  "900": "#263238"
};
var CircleSwatch = function CircleSwatch2(_ref) {
  var color2 = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover3 = _ref.hover, active3 = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
  var styles2 = _default$3({
    "default": {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color2,
        transition: "100ms box-shadow ease"
      }
    },
    "hover": {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    "active": {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + color2
      }
    }
  }, {
    hover: hover3,
    active: active3
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(Swatch$1, {
    style: styles2.Swatch,
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: styles2.Swatch.boxShadow + ", 0 0 5px " + color2
    }
  }));
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = handleHover(CircleSwatch);
var Circle = function Circle2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(hexCode, e) {
    return onChange({
      hex: hexCode,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.card,
    className: "circle-picker " + className2
  }, map(colors, function(c2) {
    return /* @__PURE__ */ React$3.createElement(CircleSwatch$1, {
      key: c2,
      color: c2,
      onClick: handleChange,
      onSwatchHover,
      active: hex2 === c2.toLowerCase(),
      circleSize,
      circleSpacing
    });
  }));
};
Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red["500"], pink["500"], purple["500"], deepPurple["500"], indigo["500"], blue["500"], lightBlue["500"], cyan["500"], teal["500"], green["500"], lightGreen["500"], lime["500"], yellow["500"], amber["500"], orange["500"], deepOrange["500"], brown["500"], blueGrey["500"]],
  styles: {}
};
ColorWrap(Circle);
function isUndefined(value2) {
  return value2 === void 0;
}
var UnfoldMoreHorizontalIcon = {};
Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: true
});
var _extends$8 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$2 = React$3;
var _react2$1 = _interopRequireDefault$1(_react$2);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties$2(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
var DEFAULT_SIZE$1 = 24;
var _default$2 = UnfoldMoreHorizontalIcon.default = function(_ref) {
  var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? DEFAULT_SIZE$1 : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? DEFAULT_SIZE$1 : _ref$height, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties$2(_ref, ["fill", "width", "height", "style"]);
  return _react2$1.default.createElement("svg", _extends$8({
    viewBox: "0 0 " + DEFAULT_SIZE$1 + " " + DEFAULT_SIZE$1,
    style: _extends$8({
      fill,
      width,
      height: height2
    }, style)
  }, props), _react2$1.default.createElement("path", {
    d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
  }));
};
var _createClass$q = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$q(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$q(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$q(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
  _inherits$q(ChromeFields2, _React$Component);
  function ChromeFields2(props) {
    _classCallCheck$q(this, ChromeFields2);
    var _this = _possibleConstructorReturn$q(this, (ChromeFields2.__proto__ || Object.getPrototypeOf(ChromeFields2)).call(this));
    _this.toggleViews = function() {
      if (_this.state.view === "hex") {
        _this.setState({
          view: "rgb"
        });
      } else if (_this.state.view === "rgb") {
        _this.setState({
          view: "hsl"
        });
      } else if (_this.state.view === "hsl") {
        if (_this.props.hsl.a === 1) {
          _this.setState({
            view: "hex"
          });
        } else {
          _this.setState({
            view: "rgb"
          });
        }
      }
    };
    _this.handleChange = function(data2, e) {
      if (data2.hex) {
        isValidHex(data2.hex) && _this.props.onChange({
          hex: data2.hex,
          source: "hex"
        }, e);
      } else if (data2.r || data2.g || data2.b) {
        _this.props.onChange({
          r: data2.r || _this.props.rgb.r,
          g: data2.g || _this.props.rgb.g,
          b: data2.b || _this.props.rgb.b,
          source: "rgb"
        }, e);
      } else if (data2.a) {
        if (data2.a < 0) {
          data2.a = 0;
        } else if (data2.a > 1) {
          data2.a = 1;
        }
        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data2.a * 100) / 100,
          source: "rgb"
        }, e);
      } else if (data2.h || data2.s || data2.l) {
        if (typeof data2.s === "string" && data2.s.includes("%")) {
          data2.s = data2.s.replace("%", "");
        }
        if (typeof data2.l === "string" && data2.l.includes("%")) {
          data2.l = data2.l.replace("%", "");
        }
        if (data2.s == 1) {
          data2.s = 0.01;
        } else if (data2.l == 1) {
          data2.l = 0.01;
        }
        _this.props.onChange({
          h: data2.h || _this.props.hsl.h,
          s: Number(!isUndefined(data2.s) ? data2.s : _this.props.hsl.s),
          l: Number(!isUndefined(data2.l) ? data2.l : _this.props.hsl.l),
          source: "hsl"
        }, e);
      }
    };
    _this.showHighlight = function(e) {
      e.currentTarget.style.background = "#eee";
    };
    _this.hideHighlight = function(e) {
      e.currentTarget.style.background = "transparent";
    };
    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }
  _createClass$q(ChromeFields2, [{
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles2 = _default$3({
        "default": {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        "disableAlpha": {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state);
      var fields = void 0;
      if (this.state.view === "hex") {
        fields = /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "hex",
          value: this.props.hex,
          onChange: this.handleChange
        })));
      } else if (this.state.view === "rgb") {
        fields = /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "r",
          value: this.props.rgb.r,
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "g",
          value: this.props.rgb.g,
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "b",
          value: this.props.rgb.b,
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.alpha
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "a",
          value: this.props.rgb.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      } else if (this.state.view === "hsl") {
        fields = /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "h",
          value: Math.round(this.props.hsl.h),
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "s",
          value: Math.round(this.props.hsl.s * 100) + "%",
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "l",
          value: Math.round(this.props.hsl.l * 100) + "%",
          onChange: this.handleChange
        })), /* @__PURE__ */ React$3.createElement("div", {
          style: styles2.alpha
        }, /* @__PURE__ */ React$3.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "a",
          value: this.props.hsl.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      }
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.wrap,
        className: "flexbox-fix"
      }, fields, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.toggle
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.icon,
        onClick: this.toggleViews,
        ref: function ref2(icon) {
          return _this2.icon = icon;
        }
      }, /* @__PURE__ */ React$3.createElement(_default$2, {
        style: styles2.svg,
        onMouseOver: this.showHighlight,
        onMouseEnter: this.showHighlight,
        onMouseOut: this.hideHighlight
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === "hex") {
        return {
          view: "rgb"
        };
      }
      return null;
    }
  }]);
  return ChromeFields2;
}(React$3.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function ChromePointer2() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var ChromePointerCircle = function ChromePointerCircle2() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var Chrome = function Chrome2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hsv = _ref.hsv, hex2 = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className, defaultView2 = _ref.defaultView;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + rgb2.r + ", " + rgb2.g + ", " + rgb2.b + ", " + rgb2.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    "disableAlpha": {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, passedStyles), {
    disableAlpha
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "chrome-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React$3.createElement(Saturation, {
    style: styles2.Saturation,
    hsl: hsl2,
    hsv,
    pointer: ChromePointerCircle,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.color
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.active
  }), /* @__PURE__ */ React$3.createElement(Checkboard, {
    renderers
  }))), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.toggles
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React$3.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    pointer: ChromePointer,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React$3.createElement(Alpha, {
    style: styles2.Alpha,
    rgb: rgb2,
    hsl: hsl2,
    pointer: ChromePointer,
    renderers,
    onChange
  })))), /* @__PURE__ */ React$3.createElement(ChromeFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    view: defaultView2,
    onChange,
    disableAlpha
  })));
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};
ColorWrap(Chrome);
var CompactColor = function CompactColor2(_ref) {
  var color2 = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active3 = _ref.active;
  var styles2 = _default$3({
    "default": {
      color: {
        background: color2,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(color2),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    "active": {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    "transparent": {
      dot: {
        background: "#000"
      }
    }
  }, {
    active: active3,
    "color-#FFFFFF": color2 === "#FFFFFF",
    "transparent": color2 === "transparent"
  });
  return /* @__PURE__ */ React$3.createElement(Swatch$1, {
    style: styles2.color,
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: "0 0 4px " + color2
    }
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.dot
  }));
};
var CompactFields = function CompactFields2(_ref) {
  var hex2 = _ref.hex, rgb2 = _ref.rgb, onChange = _ref.onChange;
  var styles2 = _default$3({
    "default": {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: hex2
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    } else {
      onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    }
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.fields,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.active
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  }));
};
var Compact = function Compact2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, rgb2 = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else {
      onChange(data2, e);
    }
  };
  return /* @__PURE__ */ React$3.createElement(Raised, {
    style: styles2.Compact,
    styles: passedStyles
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.compact,
    className: "compact-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", null, map(colors, function(c2) {
    return /* @__PURE__ */ React$3.createElement(CompactColor, {
      key: c2,
      color: c2,
      active: c2.toLowerCase() === hex2,
      onClick: handleChange,
      onSwatchHover
    });
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.clear
  })), /* @__PURE__ */ React$3.createElement(CompactFields, {
    hex: hex2,
    rgb: rgb2,
    onChange: handleChange
  })));
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap(Compact);
var GithubSwatch = function GithubSwatch2(_ref) {
  var hover3 = _ref.hover, color2 = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var hoverSwatch = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  };
  var styles2 = _default$3({
    "default": {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    "hover": {
      swatch: hoverSwatch
    }
  }, {
    hover: hover3
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(Swatch$1, {
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: hoverSwatch
  }));
};
const GithubSwatch$1 = handleHover(GithubSwatch);
var Github = function Github2(_ref) {
  var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right",
    "bottom-left-triangle": triangle === "bottom-left",
    "bottom-right-triangle": triangle === "bottom-right"
  });
  var handleChange = function handleChange2(hex2, e) {
    return onChange({
      hex: hex2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.card,
    className: "github-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.triangleShadow
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.triangle
  }), map(colors, function(c2) {
    return /* @__PURE__ */ React$3.createElement(GithubSwatch$1, {
      color: c2,
      key: c2,
      onClick: handleChange,
      onSwatchHover
    });
  }));
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Github);
var SliderPointer$1 = function SliderPointer(_ref) {
  var direction = _ref.direction;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, {
    vertical: direction === "vertical"
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var _extends$7 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var HuePicker = function HuePicker2(_ref) {
  var width = _ref.width, height2 = _ref.height, onChange = _ref.onChange, hsl2 = _ref.hsl, direction = _ref.direction, pointer2 = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        position: "relative",
        width,
        height: height2
      },
      hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2) {
    return onChange({
      a: 1,
      h: data2.h,
      l: 0.5,
      s: 1
    });
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "hue-picker " + className2
  }, /* @__PURE__ */ React$3.createElement(Hue, _extends$7({}, styles2.hue, {
    hsl: hsl2,
    pointer: pointer2,
    onChange: handleChange,
    direction
  })));
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);
var Material = function Material2(_ref) {
  var onChange = _ref.onChange, hex2 = _ref.hex, rgb2 = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + hex2,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    }
  };
  return /* @__PURE__ */ React$3.createElement(Raised, {
    styles: passedStyles
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.material,
    className: "material-picker " + className2
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.split,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  })))));
};
ColorWrap(Material);
var PhotoshopPicker = function PhotoshopPicker2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsv = _ref.hsv, hex2 = _ref.hex;
  var styles2 = _default$3({
    "default": {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2["#"]) {
      isValidHex(data2["#"]) && onChange({
        hex: data2["#"],
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    } else if (data2.h || data2.s || data2.v) {
      onChange({
        h: data2.h || hsv.h,
        s: data2.s || hsv.s,
        v: data2.v || hsv.v,
        source: "hsv"
      }, e);
    }
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.fields
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "h",
    value: Math.round(hsv.h),
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "s",
    value: Math.round(hsv.s * 100),
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "v",
    value: Math.round(hsv.v * 100),
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.divider
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.divider
  }), /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "#",
    value: hex2.replace("#", ""),
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.fieldSymbols
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.symbol
  }, "°"), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.symbol
  }, "%"), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.symbol
  }, "%")));
};
var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle(_ref) {
  var hsl2 = _ref.hsl;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, {
    "black-outline": hsl2.l > 0.5
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var PhotoshopPointerCircle2 = function PhotoshopPointerCircle3() {
  var styles2 = _default$3({
    "default": {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.pointer
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.left
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.leftInside
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.right
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.rightInside
  })));
};
var PhotoshopButton = function PhotoshopButton2(_ref) {
  var onClick = _ref.onClick, label = _ref.label, children3 = _ref.children, active3 = _ref.active;
  var styles2 = _default$3({
    "default": {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    "active": {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, {
    active: active3
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.button,
    onClick
  }, label || children3);
};
var PhotoshopPreviews = function PhotoshopPreviews2(_ref) {
  var rgb2 = _ref.rgb, currentColor = _ref.currentColor;
  var styles2 = _default$3({
    "default": {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + rgb2.r + "," + rgb2.g + ", " + rgb2.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: currentColor,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", null, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.label
  }, "new"), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.new
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.current
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.label
  }, "current"));
};
var _createClass$p = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$p(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$p(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$p(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
  _inherits$p(Photoshop2, _React$Component);
  function Photoshop2(props) {
    _classCallCheck$p(this, Photoshop2);
    var _this = _possibleConstructorReturn$p(this, (Photoshop2.__proto__ || Object.getPrototypeOf(Photoshop2)).call(this));
    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }
  _createClass$p(Photoshop2, [{
    key: "render",
    value: function render3() {
      var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === void 0 ? {} : _props$styles, _props$className = _props.className, className2 = _props$className === void 0 ? "" : _props$className;
      var styles2 = _default$3(merge$1({
        "default": {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, passedStyles));
      return /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.picker,
        className: "photoshop-picker " + className2
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.head
      }, this.props.header), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.body,
        className: "flexbox-fix"
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.saturation
      }, /* @__PURE__ */ React$3.createElement(Saturation, {
        hsl: this.props.hsl,
        hsv: this.props.hsv,
        pointer: PhotoshopPointerCircle$1,
        onChange: this.props.onChange
      })), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.hue
      }, /* @__PURE__ */ React$3.createElement(Hue, {
        direction: "vertical",
        hsl: this.props.hsl,
        pointer: PhotoshopPointerCircle2,
        onChange: this.props.onChange
      })), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.controls
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.top,
        className: "flexbox-fix"
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.previews
      }, /* @__PURE__ */ React$3.createElement(PhotoshopPreviews, {
        rgb: this.props.rgb,
        currentColor: this.state.currentColor
      })), /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.actions
      }, /* @__PURE__ */ React$3.createElement(PhotoshopButton, {
        label: "OK",
        onClick: this.props.onAccept,
        active: true
      }), /* @__PURE__ */ React$3.createElement(PhotoshopButton, {
        label: "Cancel",
        onClick: this.props.onCancel
      }), /* @__PURE__ */ React$3.createElement(PhotoshopPicker, {
        onChange: this.props.onChange,
        rgb: this.props.rgb,
        hsv: this.props.hsv,
        hex: this.props.hex
      }))))));
    }
  }]);
  return Photoshop2;
}(React$3.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap(Photoshop);
var SketchFields = function SketchFields2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hex2 = _ref.hex, disableAlpha = _ref.disableAlpha;
  var styles2 = _default$3({
    "default": {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    "disableAlpha": {
      alpha: {
        display: "none"
      }
    }
  }, {
    disableAlpha
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        a: rgb2.a,
        source: "rgb"
      }, e);
    } else if (data2.a) {
      if (data2.a < 0) {
        data2.a = 0;
      } else if (data2.a > 100) {
        data2.a = 100;
      }
      data2.a /= 100;
      onChange({
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a: data2.a,
        source: "rgb"
      }, e);
    }
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.fields,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.double
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "hex",
    value: hex2.replace("#", ""),
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "a",
    value: Math.round(rgb2.a * 100),
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "100"
  })));
};
var _extends$6 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var SketchPresetColors = function SketchPresetColors2(_ref) {
  var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
  var styles2 = _default$3({
    "default": {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !colors || !colors.length
  });
  var handleClick = function handleClick2(hex2, e) {
    onClick({
      hex: hex2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.colors,
    className: "flexbox-fix"
  }, colors.map(function(colorObjOrString) {
    var c2 = typeof colorObjOrString === "string" ? {
      color: colorObjOrString
    } : colorObjOrString;
    var key = "" + c2.color + (c2.title || "");
    return /* @__PURE__ */ React$3.createElement("div", {
      key,
      style: styles2.swatchWrap
    }, /* @__PURE__ */ React$3.createElement(Swatch$1, _extends$6({}, c2, {
      style: styles2.swatch,
      onClick: handleClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c2.color
      }
    })));
  }));
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};
var _extends$5 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var Sketch = function Sketch2(_ref) {
  var width = _ref.width, rgb2 = _ref.rgb, hex2 = _ref.hex, hsv = _ref.hsv, hsl2 = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": _extends$5({
      picker: {
        width,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + "," + rgb2.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, passedStyles),
    "disableAlpha": {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, passedStyles), {
    disableAlpha
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "sketch-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React$3.createElement(Saturation, {
    style: styles2.Saturation,
    hsl: hsl2,
    hsv,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.sliders
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React$3.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React$3.createElement(Alpha, {
    style: styles2.Alpha,
    rgb: rgb2,
    hsl: hsl2,
    renderers,
    onChange
  }))), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.color
  }, /* @__PURE__ */ React$3.createElement(Checkboard, null), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.activeColor
  }))), /* @__PURE__ */ React$3.createElement(SketchFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    onChange,
    disableAlpha
  }), /* @__PURE__ */ React$3.createElement(SketchPresetColors, {
    colors: presetColors,
    onClick: onChange,
    onSwatchHover
  }));
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const SketchPicker = ColorWrap(Sketch);
var SliderSwatch = function SliderSwatch2(_ref) {
  var hsl2 = _ref.hsl, offset2 = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, active3 = _ref.active, first2 = _ref.first, last2 = _ref.last;
  var styles2 = _default$3({
    "default": {
      swatch: {
        height: "12px",
        background: "hsl(" + hsl2.h + ", 50%, " + offset2 * 100 + "%)",
        cursor: "pointer"
      }
    },
    "first": {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    "last": {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    "active": {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, {
    active: active3,
    first: first2,
    last: last2
  });
  var handleClick = function handleClick2(e) {
    return onClick({
      h: hsl2.h,
      s: 0.5,
      l: offset2,
      source: "hsl"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch,
    onClick: handleClick
  });
};
var SliderSwatches = function SliderSwatches2(_ref) {
  var onClick = _ref.onClick, hsl2 = _ref.hsl;
  var styles2 = _default$3({
    "default": {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  });
  var epsilon3 = 0.1;
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".80",
    active: Math.abs(hsl2.l - 0.8) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick,
    first: true
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".65",
    active: Math.abs(hsl2.l - 0.65) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".50",
    active: Math.abs(hsl2.l - 0.5) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".35",
    active: Math.abs(hsl2.l - 0.35) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React$3.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".20",
    active: Math.abs(hsl2.l - 0.2) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick,
    last: true
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.clear
  }));
};
var SliderPointer2 = function SliderPointer3() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
var Slider = function Slider2(_ref) {
  var hsl2 = _ref.hsl, onChange = _ref.onChange, pointer2 = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.wrap || {},
    className: "slider-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React$3.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    pointer: pointer2,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React$3.createElement(SliderSwatches, {
    hsl: hsl2,
    onClick: onChange
  })));
};
Slider.propTypes = {
  styles: PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer2,
  styles: {}
};
ColorWrap(Slider);
var CheckIcon = {};
Object.defineProperty(CheckIcon, "__esModule", {
  value: true
});
var _extends$4 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$1 = React$3;
var _react2 = _interopRequireDefault(_react$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties$1(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
var DEFAULT_SIZE = 24;
var _default$1 = CheckIcon.default = function(_ref) {
  var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties$1(_ref, ["fill", "width", "height", "style"]);
  return _react2.default.createElement("svg", _extends$4({
    viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
    style: _extends$4({
      fill,
      width,
      height: height2
    }, style)
  }, props), _react2.default.createElement("path", {
    d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
  }));
};
var SwatchesColor = function SwatchesColor2(_ref) {
  var color2 = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first2 = _ref.first, last2 = _ref.last, active3 = _ref.active;
  var styles2 = _default$3({
    "default": {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: color2,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(color2),
        marginLeft: "8px",
        display: "none"
      }
    },
    "first": {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    "last": {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    "active": {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    "transparent": {
      check: {
        color: "#333"
      }
    }
  }, {
    first: first2,
    last: last2,
    active: active3,
    "color-#FFFFFF": color2 === "#FFFFFF",
    "transparent": color2 === "transparent"
  });
  return /* @__PURE__ */ React$3.createElement(Swatch$1, {
    color: color2,
    style: styles2.color,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: "0 0 4px " + color2
    }
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.check
  }, /* @__PURE__ */ React$3.createElement(_default$1, null)));
};
var SwatchesGroup = function SwatchesGroup2(_ref) {
  var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group2 = _ref.group, active3 = _ref.active;
  var styles2 = _default$3({
    "default": {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.group
  }, map(group2, function(color2, i) {
    return /* @__PURE__ */ React$3.createElement(SwatchesColor, {
      key: color2,
      color: color2,
      active: color2.toLowerCase() === active3,
      first: i === 0,
      last: i === group2.length - 1,
      onClick,
      onSwatchHover
    });
  }));
};
var Swatches = function Swatches2(_ref) {
  var width = _ref.width, height2 = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        height: height2
      },
      overflow: {
        height: height2,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    return onChange({
      hex: data2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "swatches-picker " + className2
  }, /* @__PURE__ */ React$3.createElement(Raised, null, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.overflow
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.body
  }, map(colors, function(group2) {
    return /* @__PURE__ */ React$3.createElement(SwatchesGroup, {
      key: group2.toString(),
      group: group2,
      active: hex2,
      onClick: handleChange,
      onSwatchHover
    });
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.clear
  })))));
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red["900"], red["700"], red["500"], red["300"], red["100"]], [pink["900"], pink["700"], pink["500"], pink["300"], pink["100"]], [purple["900"], purple["700"], purple["500"], purple["300"], purple["100"]], [deepPurple["900"], deepPurple["700"], deepPurple["500"], deepPurple["300"], deepPurple["100"]], [indigo["900"], indigo["700"], indigo["500"], indigo["300"], indigo["100"]], [blue["900"], blue["700"], blue["500"], blue["300"], blue["100"]], [lightBlue["900"], lightBlue["700"], lightBlue["500"], lightBlue["300"], lightBlue["100"]], [cyan["900"], cyan["700"], cyan["500"], cyan["300"], cyan["100"]], [teal["900"], teal["700"], teal["500"], teal["300"], teal["100"]], ["#194D33", green["700"], green["500"], green["300"], green["100"]], [lightGreen["900"], lightGreen["700"], lightGreen["500"], lightGreen["300"], lightGreen["100"]], [lime["900"], lime["700"], lime["500"], lime["300"], lime["100"]], [yellow["900"], yellow["700"], yellow["500"], yellow["300"], yellow["100"]], [amber["900"], amber["700"], amber["500"], amber["300"], amber["100"]], [orange["900"], orange["700"], orange["500"], orange["300"], orange["100"]], [deepOrange["900"], deepOrange["700"], deepOrange["500"], deepOrange["300"], deepOrange["100"]], [brown["900"], brown["700"], brown["500"], brown["300"], brown["100"]], [blueGrey["900"], blueGrey["700"], blueGrey["500"], blueGrey["300"], blueGrey["100"]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap(Swatches);
var Twitter = function Twitter2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex2 = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right"
  });
  var handleChange = function handleChange2(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.card,
    className: "twitter-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.triangleShadow
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.triangle
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.body
  }, map(colors, function(c2, i) {
    return /* @__PURE__ */ React$3.createElement(Swatch$1, {
      key: i,
      color: c2,
      hex: c2,
      style: styles2.swatch,
      onClick: handleChange,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "0 0 4px " + c2
      }
    });
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.hash
  }, "#"), /* @__PURE__ */ React$3.createElement(EditableInput, {
    label: null,
    style: {
      input: styles2.input
    },
    value: hex2.replace("#", ""),
    onChange: handleChange
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.clear
  })));
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right"]),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Twitter);
var GooglePointerCircle = function GooglePointerCircle2(props) {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.5
  }
};
var GooglePointer = function GooglePointer2(props) {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker
  });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.5
  }
};
var GoogleFields = function GoogleFields2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hex2 = _ref.hex, hsv = _ref.hsv;
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.rgb) {
      var values2 = data2.rgb.split(",");
      isvalidColorString(data2.rgb, "rgb") && onChange({
        r: values2[0],
        g: values2[1],
        b: values2[2],
        a: 1,
        source: "rgb"
      }, e);
    } else if (data2.hsv) {
      var _values = data2.hsv.split(",");
      if (isvalidColorString(data2.hsv, "hsv")) {
        _values[2] = _values[2].replace("%", "");
        _values[1] = _values[1].replace("%", "");
        _values[0] = _values[0].replace("°", "");
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: "hsv"
        }, e);
      }
    } else if (data2.hsl) {
      var _values2 = data2.hsl.split(",");
      if (isvalidColorString(data2.hsl, "hsl")) {
        _values2[2] = _values2[2].replace("%", "");
        _values2[1] = _values2[1].replace("%", "");
        _values2[0] = _values2[0].replace("°", "");
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: "hsl"
        }, e);
      }
    }
  };
  var styles2 = _default$3({
    "default": {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  });
  var rgbValue = rgb2.r + ", " + rgb2.g + ", " + rgb2.b;
  var hslValue = Math.round(hsl2.h) + "°, " + Math.round(hsl2.s * 100) + "%, " + Math.round(hsl2.l * 100) + "%";
  var hsvValue = Math.round(hsv.h) + "°, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.wrap,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.fields
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.double
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.column
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "rgb",
    value: rgbValue,
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "hsv",
    value: hsvValue,
    onChange: handleChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React$3.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "hsl",
    value: hslValue,
    onChange: handleChange
  })))));
};
var Google = function Google2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hsv = _ref.hsv, hex2 = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className2 = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + rgb2.r + ", " + rgb2.g + ", " + rgb2.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.picker,
    className: "google-picker " + className2
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.head
  }, header), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.swatch
  }), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React$3.createElement(Saturation, {
    hsl: hsl2,
    hsv,
    pointer: GooglePointerCircle,
    onChange
  })), /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React$3.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React$3.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    radius: "4px",
    pointer: GooglePointer,
    onChange
  }))), /* @__PURE__ */ React$3.createElement(GoogleFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    hsv,
    onChange
  })));
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap(Google);
function _classCallCheck$o(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$n(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$n(descriptor.key), descriptor);
  }
}
function _createClass$o(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$n(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$n(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$n(arg) {
  var key = _toPrimitive$n(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$n(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$o(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$n(subClass, superClass);
}
function _setPrototypeOf$n(o, p) {
  _setPrototypeOf$n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$n(o, p);
}
function _createSuper$n(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$n();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$n(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$n(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$o(this, result);
  };
}
function _possibleConstructorReturn$o(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$n(self2);
}
function _assertThisInitialized$n(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$n() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$n(o) {
  _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$n(o);
}
let SketchInlinePicker = /* @__PURE__ */ function(_React$Component) {
  _inherits$o(SketchInlinePicker2, _React$Component);
  var _super = _createSuper$n(SketchInlinePicker2);
  function SketchInlinePicker2(props) {
    var _this;
    _classCallCheck$o(this, SketchInlinePicker2);
    _this = _super.call(this, props);
    const startColor = rgb(props.color);
    _this.state = {
      displayColorPicker: false,
      color: {
        r: startColor.r,
        g: startColor.g,
        b: startColor.b,
        a: startColor.opacity
      }
    };
    return _this;
  }
  _createClass$o(SketchInlinePicker2, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState((prevState) => ({
        displayColorPicker: !prevState.displayColorPicker
      }));
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        displayColorPicker: false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(color2) {
      const rgb2 = color2.rgb;
      const colorString = `rgba(${rgb2.r},${rgb2.g},${rgb2.b},${rgb2.a})`;
      this.props.onChange(colorString);
      this.setState({
        color: color2.rgb
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const styles2 = _default$3({
        default: {
          color: {
            width: "32px",
            height: "14px",
            borderRadius: "2px",
            background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`
          },
          swatch: {
            padding: "5px",
            background: "#fff",
            cursor: "pointer",
            borderRadius: "1px"
          },
          popover: {
            position: "absolute",
            zIndex: "2"
          },
          cover: {
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px"
          }
        }
      });
      return /* @__PURE__ */ React$3.createElement("div", null, /* @__PURE__ */ React$3.createElement("div", {
        onClick: this.handleClick.bind(this),
        style: styles2.swatch
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.color
      })), this.state.displayColorPicker ? /* @__PURE__ */ React$3.createElement("div", {
        style: styles2.popover
      }, /* @__PURE__ */ React$3.createElement("div", {
        onClick: this.handleClose.bind(this),
        style: styles2.cover
      }), /* @__PURE__ */ React$3.createElement(SketchPicker, {
        color: this.state.color,
        onChange: this.handleChange.bind(this)
      })) : null);
    }
  }]);
  return SketchInlinePicker2;
}(React$3.Component);
SketchInlinePicker.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func
};
function _classCallCheck$n(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$m(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$m(descriptor.key), descriptor);
  }
}
function _createClass$n(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$m(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$m(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$m(arg) {
  var key = _toPrimitive$m(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$m(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$n(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$m(subClass, superClass);
}
function _setPrototypeOf$m(o, p) {
  _setPrototypeOf$m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$m(o, p);
}
function _createSuper$m(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$m();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$m(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$m(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$n(this, result);
  };
}
function _possibleConstructorReturn$n(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$m(self2);
}
function _assertThisInitialized$m(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$m() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$m(o) {
  _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$m(o);
}
let HeatmapOptions = /* @__PURE__ */ function(_React$Component) {
  _inherits$n(HeatmapOptions2, _React$Component);
  var _super = _createSuper$m(HeatmapOptions2);
  function HeatmapOptions2(props) {
    var _this;
    _classCallCheck$n(this, HeatmapOptions2);
    _this = _super.call(this, props);
    _this.state = {
      colors: props.track.options.colorRange.slice()
    };
    return _this;
  }
  _createClass$n(HeatmapOptions2, [{
    key: "handleColorsChanged",
    value: function handleColorsChanged(newColors) {
      this.setState({
        colors: newColors
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      const options2 = this.props.track.options;
      options2.colorRange = this.state.colors;
      this.props.onSubmit(this.props.track.options);
    }
    /**
     * Add a color to the end
     */
  }, {
    key: "handleAddColor",
    value: function handleAddColor() {
      this.setState((prevState) => ({
        colors: prevState.colors.concat(prevState.colors[prevState.colors.length - 1])
      }));
    }
    /**
     * Remove one of the colors from the color map
     */
  }, {
    key: "handleRemoveColor",
    value: function handleRemoveColor(i) {
      this.setState((prevState) => ({
        colors: prevState.colors.slice(0, i).concat(prevState.colors.slice(i + 1))
      }));
    }
  }, {
    key: "render",
    value: function render3() {
      const track = JSON.parse(JSON.stringify(this.props.track));
      const centerTrack = Object.assign(track, {
        options: {
          colorRange: this.state.colors
        }
      });
      const mvConfig = {
        editable: false,
        zoomFixed: true,
        views: [{
          uid: `hmo-${this.props.track.uid}`,
          initialXDomain: this.props.xScale ? this.props.xScale.domain() : [0, 1],
          initialYDomain: this.props.yScale ? this.props.yScale.domain() : [0, 1],
          tracks: {
            center: [centerTrack]
          },
          layout: {
            x: 0,
            y: 0,
            h: 12,
            w: 12,
            i: `hmo-${this.props.track.id}`
          }
        }]
      };
      const colorFields = this.state.colors.map((x, i) => {
        const removeButton = this.state.colors.length > 2 && i === this.state.colors.length - 1 ? /* @__PURE__ */ React$3.createElement("div", {
          onClick: () => this.handleRemoveColor(i),
          style: {
            background: "white",
            position: "absolute",
            top: 0,
            right: 0,
            opacity: 1,
            width: 14,
            height: 14,
            borderRadius: 2,
            cursor: "pointer"
          }
        }, /* @__PURE__ */ React$3.createElement("svg", {
          height: "10px",
          style: {
            position: "absolute",
            top: 2,
            right: 2,
            opacity: 0.5,
            width: 10,
            height: 10
          }
        }, /* @__PURE__ */ React$3.createElement("use", {
          xlinkHref: "#cross"
        }))) : null;
        return (
          /* eslint-disable react/no-array-index-key */
          // Colors may be repeated, so the array index is the best choice here.
          /* @__PURE__ */ React$3.createElement("div", {
            key: `l${i}`,
            style: {
              borderRadius: "1px",
              boxShadow: "0 0 0 1px #E5E5E5",
              position: "relative",
              outline: "none"
            }
          }, removeButton, /* @__PURE__ */ React$3.createElement(SketchInlinePicker, {
            key: i,
            color: this.state.colors[i],
            onChange: (c2) => {
              this.setState((prevState) => {
                const colors = prevState.colors.slice();
                colors[i] = c2;
                return {
                  colors
                };
              }, () => {
                this.handleColorsChanged(this.state.colors);
              });
            }
          }))
        );
      }).reverse();
      const addButton = this.state.colors.length < 10 ? /* @__PURE__ */ React$3.createElement("div", {
        onClick: this.handleAddColor.bind(this),
        style: {
          position: "relative",
          outline: "none",
          height: "25px",
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px #E5E5E5",
          cursor: "pointer"
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: {
          textAlign: "center",
          width: "32px",
          height: "14px"
        }
      }, /* @__PURE__ */ React$3.createElement("svg", {
        height: "100%",
        style: {
          opacity: 0.5,
          margin: "auto",
          display: "block"
        },
        width: "10px"
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#plus"
      })))) : null;
      return /* @__PURE__ */ React$3.createElement(Dialog$1, {
        okayTitle: "Submit",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmit.bind(this),
        title: "Custom Color Map"
      }, /* @__PURE__ */ React$3.createElement("table", {
        className: "table-track-options"
      }, /* @__PURE__ */ React$3.createElement("thead", null), /* @__PURE__ */ React$3.createElement("tbody", {
        style: {
          verticalAlign: "top"
        }
      }, /* @__PURE__ */ React$3.createElement("tr", null, /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options"
      }, /* @__PURE__ */ React$3.createElement("table", null, /* @__PURE__ */ React$3.createElement("tbody", null, /* @__PURE__ */ React$3.createElement("tr", null, /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options"
      }, "Preview")), /* @__PURE__ */ React$3.createElement("tr", null, /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options",
        "aria-label": "Track options"
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: {
          width: 200
        }
      }, /* @__PURE__ */ React$3.createElement(HiGlassComponent, {
        options: {
          bounded: false
        },
        viewConfig: mvConfig
      }))))))), /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options"
      }, /* @__PURE__ */ React$3.createElement("table", null, /* @__PURE__ */ React$3.createElement("tbody", null, /* @__PURE__ */ React$3.createElement("tr", null, /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options"
      }, "Colors")), /* @__PURE__ */ React$3.createElement("tr", null, /* @__PURE__ */ React$3.createElement("td", {
        className: "td-track-options"
      }, addButton, /* @__PURE__ */ React$3.createElement("div", {
        style: {
          position: "relative"
        }
      }, colorFields))))))))));
    }
  }]);
  return HeatmapOptions2;
}(React$3.Component);
HeatmapOptions.propTypes = {
  handleCancel: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  track: PropTypes.object,
  xScale: PropTypes.object,
  yScale: PropTypes.object
};
const valueColumnOptions = (track) => {
  if (!track.header)
    return [];
  const headerParts = track.header.split("	");
  const options2 = [];
  for (let i = 0; i < headerParts.length; i++) {
    options2.push({
      name: headerParts[i],
      value: i + 1
    });
  }
  return options2;
};
const sizesInPx = (sizes, unit2 = "", multiplier = 1) => sizes.reduce((sizeOption, size) => {
  sizeOption[size] = {
    name: `${size * multiplier}${unit2}`,
    value: size
  };
  return sizeOption;
}, {});
const YES_NO = {
  yes: {
    name: "Yes",
    value: true
  },
  no: {
    name: "No",
    value: false
  }
};
const AVAILABLE_COLORS = {
  black: {
    name: "Black",
    value: "black"
  },
  blue: {
    name: "Blue",
    value: "blue"
  },
  brown: {
    name: "Brown",
    value: "brown"
  },
  cyan: {
    name: "Cyan",
    value: "cyan"
  },
  green: {
    name: "Green",
    value: "green"
  },
  grey: {
    name: "Grey",
    value: "grey"
  },
  orange: {
    name: "Orange",
    value: "orange"
  },
  purple: {
    name: "Purple",
    value: "purple"
  },
  turquoise: {
    name: "Turquoise",
    value: "turquoise"
  },
  red: {
    name: "Red",
    value: "red"
  },
  white: {
    name: "White",
    value: "white"
  }
};
const SPECIAL_COLORS = {
  use_stroke: {
    name: "Glyph color",
    value: "[glyph-color]"
  }
};
const AVAILABLE_WIDTHS = sizesInPx([1, 2, 3, 5, 8, 13, 21]);
const AVAILABLE_WIDTHS_AND_NONE = Object.assign(AVAILABLE_WIDTHS, {
  none: {
    name: "none",
    value: "none"
  }
});
const AVAILABLE_MARGIN = sizesInPx([0, 2, 4, 8, 16, 32, 64, 128, 256]);
const OPACITY_OPTIONS = sizesInPx([0, 0.2, 0.4, 0.6, 0.8, 1], "%", 100);
const OPACITY_OPTIONS_NO_ZERO = sizesInPx([0.2, 0.4, 0.6, 0.8, 1], "%", 100);
const OPTIONS_INFO = {
  axisLabelFormatting: {
    name: "Axis Label Formatting",
    inlineOptions: {
      normal: {
        name: "normal",
        value: "normal"
      },
      scientific: {
        name: "scientific",
        value: "scientific"
      }
    }
  },
  flipDiagonal: {
    name: "Flip Across Diagonal",
    inlineOptions: {
      none: {
        name: "No",
        value: "none"
      },
      yes: {
        name: "Yes",
        value: "yes"
      },
      copy: {
        name: "Copy",
        value: "copy"
      }
    }
  },
  heatmapValueScaling: {
    name: "Value Scaling",
    inlineOptions: {
      linear: {
        name: "Linear",
        value: "linear"
      },
      log: {
        name: "Log",
        value: "log"
      }
    }
  },
  valueScaling: {
    name: "Value Scaling",
    inlineOptions: {
      linear: {
        name: "Linear",
        value: "linear"
      },
      log: {
        name: "Log",
        value: "log"
      }
    }
  },
  extent: {
    name: "Extent",
    inlineOptions: {
      full: {
        name: "Full",
        value: "full"
      },
      upperRight: {
        name: "Upper Right",
        value: "upper-right"
      },
      lowerLeft: {
        name: "Lower Left",
        value: "lower-left"
      }
    }
  },
  labelLeftMargin: {
    name: "Label Left Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelRightMargin: {
    name: "Label Right Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelTopMargin: {
    name: "Label Top Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelBottomMargin: {
    name: "Label Bottom Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelShowResolution: {
    name: "Label Show Resolution",
    inlineOptions: YES_NO
  },
  labelShowAssembly: {
    name: "Label Show Assembly",
    inlineOptions: YES_NO
  },
  lineStrokeWidth: {
    name: "Stroke Width",
    inlineOptions: AVAILABLE_WIDTHS
  },
  strokeWidth: {
    name: "Stroke Width",
    inlineOptions: AVAILABLE_WIDTHS
  },
  trackBorderWidth: {
    name: "Track Border Width",
    inlineOptions: AVAILABLE_WIDTHS
  },
  separatePlusMinusStrands: {
    name: "Separate +/- strands",
    inlineOptions: YES_NO
  },
  sortLargestOnTop: {
    name: "Sort Largest On Top",
    inlineOptions: YES_NO
  },
  showTexts: {
    name: "Show texts",
    inlineOptions: YES_NO
  },
  staggered: {
    name: "Staggered",
    inlineOptions: YES_NO
  },
  minSquareSize: {
    name: "Minimum size",
    inlineOptions: AVAILABLE_WIDTHS_AND_NONE
  },
  pointSize: {
    name: "Point Size",
    inlineOptions: AVAILABLE_WIDTHS
  },
  pointColor: {
    name: "Point Color",
    inlineOptions: AVAILABLE_COLORS
  },
  trackBorderColor: {
    name: "Track Border Color",
    inlineOptions: AVAILABLE_COLORS
  },
  backgroundColor: {
    name: "Background Color",
    inlineOptions: {
      white: {
        name: "White",
        value: "white"
      },
      lightGrey: {
        name: "Light Grey",
        value: "#eeeeee"
      },
      grey: {
        name: "Grey",
        value: "#cccccc"
      },
      black: {
        name: "Black",
        value: "black"
      },
      transparent: {
        name: "Transparent",
        value: "transparent"
      }
    }
  },
  colorScale: {
    name: "Color Scale",
    inlineOptions: {
      epilogos: {
        name: "Epilogos",
        values: ["#FF0000", "#FF4500", "#32CD32", "#008000", "#006400", "#C2E105", "#FFFF00", "#66CDAA", "#8A91D0", "#CD5C5C", "#E9967A", "#BDB76B", "#808080", "#C0C0C0", "#FFFFFF"]
      },
      category10: {
        name: "D3 Category10",
        values: ["#1F77B4", "#FF7F0E", "#2CA02C", "#D62728", "#9467BD", "#8C564B", "#E377C2", "#7F7F7F", "#BCBD22", "#17BECF"]
      }
    }
  },
  minusStrandColor: {
    name: "- Strand Color",
    inlineOptions: AVAILABLE_COLORS
  },
  plusStrandColor: {
    name: "+ Strand Color",
    inlineOptions: AVAILABLE_COLORS
  },
  lineStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  projectionStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  projectionFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  stroke: {
    name: "Stroke Color",
    inlineOptions: AVAILABLE_COLORS
  },
  strokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  fill: {
    name: "Fill Color",
    inlineOptions: AVAILABLE_COLORS
  },
  color: {
    name: "Color",
    inlineOptions: AVAILABLE_COLORS
  },
  fontColor: {
    name: "Font color",
    inlineOptions: AVAILABLE_COLORS
  },
  fillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColorTop: {
    name: "Top Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColorBottom: {
    name: "Bottom Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barOpacity: {
    name: "Bar opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  zeroLineVisible: {
    name: "Zero line visible",
    inlineOptions: YES_NO
  },
  zeroLineColor: {
    name: "Zero line color",
    inlineOptions: AVAILABLE_COLORS
  },
  zeroLineOpacity: {
    name: "Zero line opacity",
    inlineOptions: OPACITY_OPTIONS_NO_ZERO
  },
  fillOpacity: {
    name: "Fill Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  strokeOpacity: {
    name: "Stroke Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  strokePos: {
    name: "Stroke Position",
    inlineOptions: {
      aroundInner: {
        name: "Around Inner",
        value: "around"
      },
      aroundCenter: {
        name: "Around Center",
        value: null
      },
      hidden: {
        name: "Hidden",
        value: "hidden"
      },
      top: {
        name: "Top",
        value: "top"
      },
      right: {
        name: "Right",
        value: "right"
      },
      bottom: {
        name: "Bottom",
        value: "bottom"
      },
      left: {
        name: "Left",
        value: "left"
      }
    }
  },
  barBorder: {
    name: "Bar border",
    inlineOptions: YES_NO
  },
  scaledHeight: {
    name: "Scaled height",
    inlineOptions: YES_NO
  },
  rectangleDomainStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  rectangleDomainFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  rectangleDomainFillOpacity: {
    name: "Fill opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  rectangleDomainOpacity: {
    name: "Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  mapboxStyle: {
    name: "Map style",
    inlineOptions: {
      streets: {
        name: "streets",
        value: "mapbox.streets"
      },
      light: {
        name: "light",
        value: "mapbox.light"
      },
      dark: {
        name: "dark",
        value: "mapbox.dark"
      },
      satellite: {
        name: "satellite",
        value: "mapbox.satellite"
      },
      "streets-satellite": {
        name: "streets-satellite",
        value: "mapbox.streets-satellite"
      },
      wheatpaste: {
        name: "wheatpaste",
        value: "mapbox.wheatpaste"
      },
      "streets-basic": {
        name: "streets-basic",
        value: "mapbox.streets-basic"
      },
      comic: {
        name: "comic",
        value: "mapbox.comic"
      },
      outdoors: {
        name: "outdoors",
        value: "mapbox.outdoors"
      },
      "run-bike-hike": {
        name: "run-bike-hike",
        value: "mapbox.run-bike-hike"
      },
      pencil: {
        name: "pencil",
        value: "mapbox.pencil"
      },
      pirates: {
        name: "pirates",
        value: "mapbox.pirates"
      },
      emerald: {
        name: "emerald",
        value: "mapbox.emerald"
      },
      "high-contrast": {
        name: "high-contrast",
        value: "mapbox.high-contrast"
      }
    }
  },
  oneDHeatmapFlipped: {
    name: "Flip Heatmap",
    inlineOptions: {
      yes: {
        name: "Yes",
        value: "yes"
      },
      no: {
        name: "No",
        value: null
      }
    }
  },
  showMousePosition: {
    name: "Show Mouse Position",
    inlineOptions: YES_NO
  },
  showTooltip: {
    name: "Show Tooltip",
    inlineOptions: YES_NO
  },
  fontSize: {
    name: "Font Size",
    inlineOptions: sizesInPx([8, 9, 10, 11, 12, 14, 16, 18, 24], "px")
  },
  tickPositions: {
    name: "Tick Positions",
    inlineOptions: {
      even: {
        name: "Even",
        value: "even"
      },
      ends: {
        name: "Ends",
        value: "ends"
      }
    }
  },
  tickFormat: {
    name: "Tick Format",
    inlineOptions: {
      plain: {
        name: "Plain",
        value: "plain"
      },
      si: {
        name: "SI",
        value: "si"
      }
    }
  },
  colorEncoding: {
    name: "Color Encode Annotations",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      },
      itemRgb: {
        name: "itemRgb",
        value: "itemRgb"
      }
    },
    generateOptions: valueColumnOptions
  },
  fontIsAligned: {
    name: "Left-Align Font",
    inlineOptions: YES_NO
  },
  axisPositionHorizontal: {
    name: "Axis Position",
    inlineOptions: {
      left: {
        name: "Left",
        value: "left"
      },
      outsideLeft: {
        name: "Outside left",
        value: "outsideLeft"
      },
      right: {
        name: "Right",
        value: "right"
      },
      outsideRight: {
        name: "Outside right",
        value: "outsideRight"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  axisPositionVertical: {
    name: "Axis Position",
    inlineOptions: {
      top: {
        name: "Top",
        value: "top"
      },
      outsideTop: {
        name: "Outside top",
        value: "outsideTop"
      },
      bottom: {
        name: "Bottom",
        value: "bottom"
      },
      outsideBottom: {
        name: "Outside bottom",
        value: "outsideBottom"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  axisMargin: {
    name: "Axis Margin",
    inlineOptions: sizesInPx([0, 10, 20, 30, 40, 50, 100, 200, 400], "px")
  },
  colorbarPosition: {
    name: "Colorbar Position",
    inlineOptions: {
      topLeft: {
        name: "Top Left",
        value: "topLeft"
      },
      topRight: {
        name: "Top Right",
        value: "topRight"
      },
      bottomLeft: {
        name: "Bottom Left",
        value: "bottomLeft"
      },
      bottomRight: {
        name: "Bottom Right",
        value: "bottomRight"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  colorbarBackgroundColor: {
    name: "Colorbar Background Color",
    inlineOptions: AVAILABLE_COLORS
  },
  colorbarBackgroundOpacity: {
    name: "Colorbar Background Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  /*
  colorbarOrientation: {
    name: 'Colorbar Orientation',
    inlineOptions: {
      'horizontal': { name: 'Horizontal', value: 'horizontal' },
      'vertical': { name: 'Vertical', value: 'vertical' },
    }
  },
  */
  // This will default to 'inside' if it's not set when colorbarPosition
  // is set
  colorbarLabelsPosition: {
    name: "Colorbar Labels Position",
    inlineOptions: {
      inside: {
        name: "Inside",
        value: "inside"
      },
      outside: {
        name: "Outside",
        value: "outside"
      }
    }
  },
  labelColor: {
    name: "Label Color",
    inlineOptions: {
      ...AVAILABLE_COLORS,
      ...SPECIAL_COLORS
    }
  },
  labelPosition: {
    name: "Label Position",
    inlineOptions: {
      ol: {
        name: "Outer left",
        value: "outerLeft"
      },
      or: {
        name: "Outer right",
        value: "outerRight"
      },
      ot: {
        name: "Outer top",
        value: "outerTop"
      },
      ob: {
        name: "Outer bottom",
        value: "outerBottom"
      },
      tl: {
        name: "Top left",
        value: "topLeft"
      },
      tr: {
        name: "Top right",
        value: "topRight"
      },
      bl: {
        name: "Bottom left",
        value: "bottomLeft"
      },
      br: {
        name: "Bottom right",
        value: "bottomRight"
      },
      hidden: {
        name: "Hidden",
        value: "hidden"
      }
    }
  },
  labelTextOpacity: {
    name: "Label Text Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  geneAnnotationHeight: {
    name: "Gene Annotation Height",
    inlineOptions: {
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      }
    }
  },
  annotationHeight: {
    name: "Annotation Height",
    inlineOptions: {
      5: {
        name: "5px",
        value: 5
      },
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      },
      20: {
        name: "20px",
        value: 20
      },
      scaled: {
        name: "scaled",
        value: "scaled"
      }
    }
  },
  maxAnnotationHeight: {
    name: "Max Annotation Height",
    inlineOptions: {
      5: {
        name: "5px",
        value: 5
      },
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      },
      20: {
        name: "20px",
        value: 20
      },
      none: {
        name: "none",
        value: null
      }
    }
  },
  annotationStyle: {
    name: "Annotation Style",
    inlineOptions: {
      box: {
        name: "Box",
        value: "box"
      },
      segment: {
        name: "Segment",
        value: "segment"
      }
    }
  },
  geneLabelPosition: {
    name: "Gene Label Position",
    inlineOptions: {
      inside: {
        name: "Inside",
        value: "inside"
      },
      outside: {
        name: "Outside",
        value: "outside"
      }
    }
  },
  geneStrandSpacing: {
    name: "Gene Strand Spacing",
    inlineOptions: {
      2: {
        name: "2px",
        value: 2
      },
      4: {
        name: "4px",
        value: 4
      },
      8: {
        name: "8px",
        value: 8
      }
    }
  },
  labelBackgroundColor: {
    name: "Label Background Color",
    inlineOptions: AVAILABLE_COLORS
  },
  labelBackgroundOpacity: {
    name: "Label Background Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  viewResolution: {
    name: "View Resolution",
    inlineOptions: {
      high: {
        name: "High",
        value: 384
      },
      medium: {
        name: "Medium",
        value: 1024
      },
      low: {
        name: "Low",
        value: 2048
      }
    }
  },
  // colormaps are mostly taken from here:
  // http://matplotlib.org/api/pyplot_summary.html?highlight=colormaps#matplotlib.pyplot.colormaps
  colorRange: {
    name: "Color map",
    inlineOptions: {
      afmhot: {
        name: "afmhot",
        value: ["rgba(0,0,0,1.0)", "rgba(128,0,0,1.0)", "rgba(256,129,1,1.0)", "rgba(256,256,129,1.0)", "rgba(256,256,256,1.0)"]
      },
      fall: {
        name: "fall",
        value: ["white", "rgba(245,166,35,1.0)", "rgba(208,2,27,1.0)", "black"]
      },
      hot: {
        name: "hot",
        value: ["rgba(10,0,0,1.0)", "rgba(179,0,0,1.0)", "rgba(256,91,0,1.0)", "rgba(256,256,6,1.0)", "rgba(256,256,256,1.0)"]
      },
      jet: {
        name: "jet",
        value: ["rgba(0,0,128,1.0)", "rgba(0,129,256,1.0)", "rgba(125,256,122,1.0)", "rgba(256,148,0,1.0)", "rgba(128,0,0,1.0)"]
      },
      bwr: {
        name: "bwr",
        value: ["rgba(0,0,256,1.0)", "rgba(128,128,256,1.0)", "rgba(256,254,254,1.0)", "rgba(256,126,126,1.0)", "rgba(256,0,0,1.0)"]
      },
      cubehelix: {
        name: "cubehelix",
        value: ["rgba(0,0,0,1.0)", "rgba(21,83,76,1.0)", "rgba(162,121,74,1.0)", "rgba(199,180,238,1.0)", "rgba(256,256,256,1.0)"]
      },
      rainbow: {
        name: "rainbow",
        value: ["rgba(128,0,256,1.0)", "rgba(0,181,236,1.0)", "rgba(129,255,180,1.0)", "rgba(256,179,96,1.0)", "rgba(256,0,0,1.0)"]
      },
      gray: {
        name: "greys",
        value: ["rgba(255,255,255,1)", "rgba(0,0,0,1)"]
      },
      red: {
        name: "White to red",
        value: ["rgba(255,255,255,1)", "rgba(255,0,0,1)"]
      },
      green: {
        name: "White to green",
        value: ["rgba(255,255,255,1)", "rgba(0,255,0,1)"]
      },
      blue: {
        name: "White to blue",
        value: ["rgba(255,255,255,1)", "rgba(0,0,255,1)"]
      },
      custard: {
        name: "custard",
        value: ["#FFFFFF", "#F8E71C", "rgba(245,166,35,1)", "rgba(0,0,0,1)"]
      },
      magma: {
        name: "magma",
        value: ["rgba(0,0,3,1)", "rgba(0,0,4,1)", "rgba(0,0,6,1)", "rgba(1,0,7,1)", "rgba(1,1,9,1)", "rgba(1,1,11,1)", "rgba(2,2,13,1)", "rgba(2,2,15,1)", "rgba(3,3,17,1)", "rgba(4,3,19,1)", "rgba(4,4,21,1)", "rgba(5,4,23,1)", "rgba(6,5,25,1)", "rgba(7,5,27,1)", "rgba(8,6,29,1)", "rgba(9,7,32,1)", "rgba(10,7,34,1)", "rgba(11,8,36,1)", "rgba(12,9,38,1)", "rgba(13,10,40,1)", "rgba(14,10,42,1)", "rgba(15,11,45,1)", "rgba(16,12,47,1)", "rgba(17,12,49,1)", "rgba(19,13,51,1)", "rgba(20,13,54,1)", "rgba(21,14,56,1)", "rgba(22,14,58,1)", "rgba(23,15,61,1)", "rgba(25,15,63,1)", "rgba(26,16,66,1)", "rgba(27,16,68,1)", "rgba(28,16,70,1)", "rgba(30,17,73,1)", "rgba(31,17,75,1)", "rgba(33,17,78,1)", "rgba(34,17,80,1)", "rgba(36,17,83,1)", "rgba(37,17,85,1)", "rgba(39,17,87,1)", "rgba(40,17,90,1)", "rgba(42,17,92,1)", "rgba(43,17,94,1)", "rgba(45,17,97,1)", "rgba(47,16,99,1)", "rgba(49,16,101,1)", "rgba(50,16,103,1)", "rgba(52,16,105,1)", "rgba(54,15,107,1)", "rgba(55,15,108,1)", "rgba(57,15,110,1)", "rgba(59,15,112,1)", "rgba(61,15,113,1)", "rgba(62,15,114,1)", "rgba(64,15,116,1)", "rgba(66,15,117,1)", "rgba(67,15,118,1)", "rgba(69,15,119,1)", "rgba(71,15,120,1)", "rgba(72,16,120,1)", "rgba(74,16,121,1)", "rgba(76,16,122,1)", "rgba(77,17,123,1)", "rgba(79,17,123,1)", "rgba(81,18,124,1)", "rgba(82,18,124,1)", "rgba(84,19,125,1)", "rgba(85,20,125,1)", "rgba(87,20,126,1)", "rgba(88,21,126,1)", "rgba(90,21,126,1)", "rgba(92,22,127,1)", "rgba(93,23,127,1)", "rgba(95,23,127,1)", "rgba(96,24,128,1)", "rgba(98,25,128,1)", "rgba(99,25,128,1)", "rgba(101,26,128,1)", "rgba(103,26,128,1)", "rgba(104,27,129,1)", "rgba(106,28,129,1)", "rgba(107,28,129,1)", "rgba(109,29,129,1)", "rgba(110,30,129,1)", "rgba(112,30,129,1)", "rgba(113,31,129,1)", "rgba(115,32,129,1)", "rgba(117,32,129,1)", "rgba(118,33,129,1)", "rgba(120,33,129,1)", "rgba(121,34,130,1)", "rgba(123,35,130,1)", "rgba(124,35,130,1)", "rgba(126,36,130,1)", "rgba(128,36,130,1)", "rgba(129,37,129,1)", "rgba(131,37,129,1)", "rgba(132,38,129,1)", "rgba(134,39,129,1)", "rgba(136,39,129,1)", "rgba(137,40,129,1)", "rgba(139,40,129,1)", "rgba(140,41,129,1)", "rgba(142,41,129,1)", "rgba(144,42,129,1)", "rgba(145,42,129,1)", "rgba(147,43,128,1)", "rgba(148,43,128,1)", "rgba(150,44,128,1)", "rgba(152,44,128,1)", "rgba(153,45,128,1)", "rgba(155,46,127,1)", "rgba(157,46,127,1)", "rgba(158,47,127,1)", "rgba(160,47,127,1)", "rgba(161,48,126,1)", "rgba(163,48,126,1)", "rgba(165,49,126,1)", "rgba(166,49,125,1)", "rgba(168,50,125,1)", "rgba(170,50,125,1)", "rgba(171,51,124,1)", "rgba(173,51,124,1)", "rgba(175,52,123,1)", "rgba(176,52,123,1)", "rgba(178,53,123,1)", "rgba(180,53,122,1)", "rgba(181,54,122,1)", "rgba(183,55,121,1)", "rgba(185,55,121,1)", "rgba(186,56,120,1)", "rgba(188,56,120,1)", "rgba(189,57,119,1)", "rgba(191,57,118,1)", "rgba(193,58,118,1)", "rgba(194,59,117,1)", "rgba(196,59,117,1)", "rgba(198,60,116,1)", "rgba(199,61,115,1)", "rgba(201,61,115,1)", "rgba(202,62,114,1)", "rgba(204,63,113,1)", "rgba(206,63,113,1)", "rgba(207,64,112,1)", "rgba(209,65,111,1)", "rgba(210,66,110,1)", "rgba(212,67,110,1)", "rgba(213,67,109,1)", "rgba(215,68,108,1)", "rgba(216,69,107,1)", "rgba(218,70,107,1)", "rgba(219,71,106,1)", "rgba(221,72,105,1)", "rgba(222,73,104,1)", "rgba(223,74,103,1)", "rgba(225,75,103,1)", "rgba(226,76,102,1)", "rgba(227,78,101,1)", "rgba(229,79,100,1)", "rgba(230,80,100,1)", "rgba(231,81,99,1)", "rgba(232,83,98,1)", "rgba(233,84,97,1)", "rgba(234,85,97,1)", "rgba(236,87,96,1)", "rgba(237,88,95,1)", "rgba(238,90,95,1)", "rgba(239,91,94,1)", "rgba(239,93,94,1)", "rgba(240,95,93,1)", "rgba(241,96,93,1)", "rgba(242,98,93,1)", "rgba(243,100,92,1)", "rgba(243,101,92,1)", "rgba(244,103,92,1)", "rgba(245,105,92,1)", "rgba(246,107,92,1)", "rgba(246,108,92,1)", "rgba(247,110,92,1)", "rgba(247,112,92,1)", "rgba(248,114,92,1)", "rgba(248,116,92,1)", "rgba(249,118,92,1)", "rgba(249,120,92,1)", "rgba(250,121,93,1)", "rgba(250,123,93,1)", "rgba(250,125,94,1)", "rgba(251,127,94,1)", "rgba(251,129,95,1)", "rgba(251,131,95,1)", "rgba(252,133,96,1)", "rgba(252,135,97,1)", "rgba(252,137,97,1)", "rgba(252,139,98,1)", "rgba(253,140,99,1)", "rgba(253,142,100,1)", "rgba(253,144,101,1)", "rgba(253,146,102,1)", "rgba(253,148,103,1)", "rgba(254,150,104,1)", "rgba(254,152,105,1)", "rgba(254,154,106,1)", "rgba(254,156,107,1)", "rgba(254,157,108,1)", "rgba(254,159,109,1)", "rgba(254,161,110,1)", "rgba(254,163,111,1)", "rgba(254,165,112,1)", "rgba(255,167,114,1)", "rgba(255,169,115,1)", "rgba(255,171,116,1)", "rgba(255,172,118,1)", "rgba(255,174,119,1)", "rgba(255,176,120,1)", "rgba(255,178,122,1)", "rgba(255,180,123,1)", "rgba(255,182,124,1)", "rgba(255,184,126,1)", "rgba(255,185,127,1)", "rgba(255,187,129,1)", "rgba(255,189,130,1)", "rgba(255,191,132,1)", "rgba(255,193,133,1)", "rgba(255,195,135,1)", "rgba(255,197,136,1)", "rgba(255,198,138,1)", "rgba(255,200,140,1)", "rgba(255,202,141,1)", "rgba(255,204,143,1)", "rgba(254,206,144,1)", "rgba(254,208,146,1)", "rgba(254,209,148,1)", "rgba(254,211,149,1)", "rgba(254,213,151,1)", "rgba(254,215,153,1)", "rgba(254,217,155,1)", "rgba(254,219,156,1)", "rgba(254,220,158,1)", "rgba(254,222,160,1)", "rgba(254,224,162,1)", "rgba(254,226,163,1)", "rgba(253,228,165,1)", "rgba(253,230,167,1)", "rgba(253,231,169,1)", "rgba(253,233,171,1)", "rgba(253,235,172,1)", "rgba(253,237,174,1)", "rgba(253,239,176,1)", "rgba(253,241,178,1)", "rgba(253,242,180,1)", "rgba(253,244,182,1)", "rgba(253,246,184,1)", "rgba(252,248,186,1)", "rgba(252,250,188,1)", "rgba(252,251,189,1)", "rgba(252,253,191,1)"]
      },
      viridis: {
        name: "viridis",
        value: ["rgba(68,1,84,1)", "rgba(68,2,85,1)", "rgba(69,3,87,1)", "rgba(69,5,88,1)", "rgba(69,6,90,1)", "rgba(70,8,91,1)", "rgba(70,9,93,1)", "rgba(70,11,94,1)", "rgba(70,12,96,1)", "rgba(71,14,97,1)", "rgba(71,15,98,1)", "rgba(71,17,100,1)", "rgba(71,18,101,1)", "rgba(71,20,102,1)", "rgba(72,21,104,1)", "rgba(72,22,105,1)", "rgba(72,24,106,1)", "rgba(72,25,108,1)", "rgba(72,26,109,1)", "rgba(72,28,110,1)", "rgba(72,29,111,1)", "rgba(72,30,112,1)", "rgba(72,32,113,1)", "rgba(72,33,115,1)", "rgba(72,34,116,1)", "rgba(72,36,117,1)", "rgba(72,37,118,1)", "rgba(72,38,119,1)", "rgba(72,39,120,1)", "rgba(71,41,121,1)", "rgba(71,42,121,1)", "rgba(71,43,122,1)", "rgba(71,44,123,1)", "rgba(71,46,124,1)", "rgba(70,47,125,1)", "rgba(70,48,126,1)", "rgba(70,49,126,1)", "rgba(70,51,127,1)", "rgba(69,52,128,1)", "rgba(69,53,129,1)", "rgba(69,54,129,1)", "rgba(68,56,130,1)", "rgba(68,57,131,1)", "rgba(68,58,131,1)", "rgba(67,59,132,1)", "rgba(67,60,132,1)", "rgba(67,62,133,1)", "rgba(66,63,133,1)", "rgba(66,64,134,1)", "rgba(65,65,134,1)", "rgba(65,66,135,1)", "rgba(65,67,135,1)", "rgba(64,69,136,1)", "rgba(64,70,136,1)", "rgba(63,71,136,1)", "rgba(63,72,137,1)", "rgba(62,73,137,1)", "rgba(62,74,137,1)", "rgba(61,75,138,1)", "rgba(61,77,138,1)", "rgba(60,78,138,1)", "rgba(60,79,138,1)", "rgba(59,80,139,1)", "rgba(59,81,139,1)", "rgba(58,82,139,1)", "rgba(58,83,139,1)", "rgba(57,84,140,1)", "rgba(57,85,140,1)", "rgba(56,86,140,1)", "rgba(56,87,140,1)", "rgba(55,88,140,1)", "rgba(55,89,140,1)", "rgba(54,91,141,1)", "rgba(54,92,141,1)", "rgba(53,93,141,1)", "rgba(53,94,141,1)", "rgba(52,95,141,1)", "rgba(52,96,141,1)", "rgba(51,97,141,1)", "rgba(51,98,141,1)", "rgba(51,99,141,1)", "rgba(50,100,142,1)", "rgba(50,101,142,1)", "rgba(49,102,142,1)", "rgba(49,103,142,1)", "rgba(48,104,142,1)", "rgba(48,105,142,1)", "rgba(47,106,142,1)", "rgba(47,107,142,1)", "rgba(47,108,142,1)", "rgba(46,109,142,1)", "rgba(46,110,142,1)", "rgba(45,111,142,1)", "rgba(45,112,142,1)", "rgba(45,112,142,1)", "rgba(44,113,142,1)", "rgba(44,114,142,1)", "rgba(43,115,142,1)", "rgba(43,116,142,1)", "rgba(43,117,142,1)", "rgba(42,118,142,1)", "rgba(42,119,142,1)", "rgba(41,120,142,1)", "rgba(41,121,142,1)", "rgba(41,122,142,1)", "rgba(40,123,142,1)", "rgba(40,124,142,1)", "rgba(40,125,142,1)", "rgba(39,126,142,1)", "rgba(39,127,142,1)", "rgba(38,128,142,1)", "rgba(38,129,142,1)", "rgba(38,130,142,1)", "rgba(37,131,142,1)", "rgba(37,131,142,1)", "rgba(37,132,142,1)", "rgba(36,133,142,1)", "rgba(36,134,142,1)", "rgba(35,135,142,1)", "rgba(35,136,142,1)", "rgba(35,137,142,1)", "rgba(34,138,141,1)", "rgba(34,139,141,1)", "rgba(34,140,141,1)", "rgba(33,141,141,1)", "rgba(33,142,141,1)", "rgba(33,143,141,1)", "rgba(32,144,141,1)", "rgba(32,145,140,1)", "rgba(32,146,140,1)", "rgba(32,147,140,1)", "rgba(31,147,140,1)", "rgba(31,148,140,1)", "rgba(31,149,139,1)", "rgba(31,150,139,1)", "rgba(31,151,139,1)", "rgba(30,152,139,1)", "rgba(30,153,138,1)", "rgba(30,154,138,1)", "rgba(30,155,138,1)", "rgba(30,156,137,1)", "rgba(30,157,137,1)", "rgba(30,158,137,1)", "rgba(30,159,136,1)", "rgba(30,160,136,1)", "rgba(31,161,136,1)", "rgba(31,162,135,1)", "rgba(31,163,135,1)", "rgba(31,163,134,1)", "rgba(32,164,134,1)", "rgba(32,165,134,1)", "rgba(33,166,133,1)", "rgba(33,167,133,1)", "rgba(34,168,132,1)", "rgba(35,169,131,1)", "rgba(35,170,131,1)", "rgba(36,171,130,1)", "rgba(37,172,130,1)", "rgba(38,173,129,1)", "rgba(39,174,129,1)", "rgba(40,175,128,1)", "rgba(41,175,127,1)", "rgba(42,176,127,1)", "rgba(43,177,126,1)", "rgba(44,178,125,1)", "rgba(46,179,124,1)", "rgba(47,180,124,1)", "rgba(48,181,123,1)", "rgba(50,182,122,1)", "rgba(51,183,121,1)", "rgba(53,183,121,1)", "rgba(54,184,120,1)", "rgba(56,185,119,1)", "rgba(57,186,118,1)", "rgba(59,187,117,1)", "rgba(61,188,116,1)", "rgba(62,189,115,1)", "rgba(64,190,114,1)", "rgba(66,190,113,1)", "rgba(68,191,112,1)", "rgba(70,192,111,1)", "rgba(72,193,110,1)", "rgba(73,194,109,1)", "rgba(75,194,108,1)", "rgba(77,195,107,1)", "rgba(79,196,106,1)", "rgba(81,197,105,1)", "rgba(83,198,104,1)", "rgba(85,198,102,1)", "rgba(88,199,101,1)", "rgba(90,200,100,1)", "rgba(92,201,99,1)", "rgba(94,201,98,1)", "rgba(96,202,96,1)", "rgba(98,203,95,1)", "rgba(101,204,94,1)", "rgba(103,204,92,1)", "rgba(105,205,91,1)", "rgba(108,206,90,1)", "rgba(110,206,88,1)", "rgba(112,207,87,1)", "rgba(115,208,85,1)", "rgba(117,208,84,1)", "rgba(119,209,82,1)", "rgba(122,210,81,1)", "rgba(124,210,79,1)", "rgba(127,211,78,1)", "rgba(129,212,76,1)", "rgba(132,212,75,1)", "rgba(134,213,73,1)", "rgba(137,213,72,1)", "rgba(139,214,70,1)", "rgba(142,215,68,1)", "rgba(144,215,67,1)", "rgba(147,216,65,1)", "rgba(149,216,63,1)", "rgba(152,217,62,1)", "rgba(155,217,60,1)", "rgba(157,218,58,1)", "rgba(160,218,57,1)", "rgba(163,219,55,1)", "rgba(165,219,53,1)", "rgba(168,220,51,1)", "rgba(171,220,50,1)", "rgba(173,221,48,1)", "rgba(176,221,46,1)", "rgba(179,221,45,1)", "rgba(181,222,43,1)", "rgba(184,222,41,1)", "rgba(187,223,39,1)", "rgba(189,223,38,1)", "rgba(192,223,36,1)", "rgba(195,224,35,1)", "rgba(197,224,33,1)", "rgba(200,225,32,1)", "rgba(203,225,30,1)", "rgba(205,225,29,1)", "rgba(208,226,28,1)", "rgba(211,226,27,1)", "rgba(213,226,26,1)", "rgba(216,227,25,1)", "rgba(219,227,24,1)", "rgba(221,227,24,1)", "rgba(224,228,24,1)", "rgba(226,228,24,1)", "rgba(229,228,24,1)", "rgba(232,229,25,1)", "rgba(234,229,25,1)", "rgba(237,229,26,1)", "rgba(239,230,27,1)", "rgba(242,230,28,1)", "rgba(244,230,30,1)", "rgba(247,230,31,1)", "rgba(249,231,33,1)", "rgba(251,231,35,1)", "rgba(254,231,36,1)"]
      },
      custom: {
        name: "Custom...",
        componentPickers: {
          heatmap: HeatmapOptions,
          "horizontal-heatmap": HeatmapOptions
        }
      }
    }
  },
  align: {
    name: "Align",
    inlineOptions: {
      white: {
        name: "Top",
        value: "top"
      },
      lightGrey: {
        name: "Bottom",
        value: "bottom"
      }
    }
  },
  colorRangeGradient: {
    name: "Color Gradient",
    inlineOptions: YES_NO
  },
  dataTransform: {
    name: "Transforms",
    inlineOptions: {
      default: {
        name: "Default",
        value: "default"
      },
      None: {
        name: "None",
        value: "None"
      }
    },
    generateOptions: (track) => {
      const inlineOptions = [];
      if (track.transforms) {
        for (const transform3 of track.transforms) {
          inlineOptions.push({
            name: transform3.name,
            value: transform3.value
          });
        }
      }
      return inlineOptions;
    }
  },
  aggregationMode: {
    name: "Aggregation Mode",
    inlineOptions: {},
    generateOptions: (track) => {
      const inlineOptions = [];
      if (track.aggregationModes) {
        Object.values(track.aggregationModes).forEach(({
          name,
          value: value2
        }) => {
          inlineOptions.push({
            name,
            value: value2
          });
        });
      } else {
        inlineOptions.push({
          name: "Default",
          value: "default"
        });
      }
      return inlineOptions;
    }
  },
  maxZoom: {
    name: "Zoom limit",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      }
    },
    generateOptions: (track) => {
      if (track.maxZoom) {
        const inlineOptions = [];
        for (let i = 0; i <= track.maxZoom; i++) {
          const {
            maxWidth,
            binsPerDimension,
            maxZoom
          } = track;
          let maxResolutionSize = 1;
          let resolution = 1;
          if (track.resolutions) {
            const sortedResolutions = track.resolutions.map((x) => +x).sort((a, b) => b - a);
            [maxResolutionSize] = sortedResolutions;
            resolution = sortedResolutions[i];
          } else {
            resolution = track.maxWidth / (2 ** i * track.binsPerDimension);
            maxResolutionSize = maxWidth / (2 ** maxZoom * binsPerDimension);
          }
          const pp = precisionPrefix(maxResolutionSize, resolution);
          const f2 = formatPrefix(`.${pp}`, resolution);
          const formattedResolution = f2(resolution);
          inlineOptions.push({
            name: formattedResolution,
            value: i.toString()
          });
        }
        return inlineOptions;
      }
      return [];
    }
  },
  valueColumn: {
    name: "Value column",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      }
    },
    generateOptions: valueColumnOptions
  },
  zeroValueColor: {
    name: "Zero Value Color",
    inlineOptions: AVAILABLE_COLORS
  }
};
const configs = {
  ..._configs,
  IS_TRACK_RANGE_SELECTABLE,
  OPTIONS_INFO
};
const libraries = {
  d3Array,
  d3Axis,
  d3Brush,
  d3Color,
  d3Drag,
  d3Dsv,
  d3Format,
  d3Geo,
  d3Queue,
  d3Request,
  d3Scale,
  d3Selection,
  d3Transition,
  d3Zoom,
  PIXI: configs.GLOBALS.PIXI,
  mix,
  slugid: slugid$1
};
const tracks$1 = {
  Annotations1dTrack,
  Annotations2dTrack,
  ArrowheadDomainsTrack,
  BarTrack,
  BedLikeTrack,
  CNVIntervalTrack,
  Chromosome2DAnnotations,
  Chromosome2DLabels,
  ChromosomeGrid,
  CombinedTrack,
  CrossRule,
  DivergentBarTrack,
  HeatmapTiledPixiTrack,
  Horizontal1dHeatmapTrack,
  Horizontal2DDomainsTrack,
  HorizontalChromosomeLabels,
  HorizontalGeneAnnotationsTrack,
  HorizontalHeatmapTrack,
  HorizontalLine1DPixiTrack,
  HorizontalMultivecTrack,
  HorizontalPoint1DPixiTrack,
  HorizontalRule,
  HorizontalTiled1DPixiTrack,
  HorizontalTiledPlot,
  HorizontalTrack,
  Id2DTiledPixiTrack,
  IdHorizontal1DTiledPixiTrack,
  IdVertical1DTiledPixiTrack,
  LeftAxisTrack,
  MapboxTilesTrack,
  MoveableTrack,
  OSMTileIdsTrack,
  OSMTilesTrack,
  OverlayTrack,
  PixiTrack,
  RasterTilesTrack,
  SVGTrack,
  SquareMarkersTrack,
  Tiled1DPixiTrack,
  TiledPixiTrack,
  TopAxisTrack,
  Track,
  ValueIntervalTrack,
  VerticalRule,
  VerticalTiled1DPixiTrack,
  VerticalTrack,
  ViewportTracker2D: ViewportTracker2D$1,
  ViewportTracker2DPixi: ViewportTracker2D,
  ViewportTrackerHorizontal,
  ViewportTrackerVertical
};
const factories = {
  ContextMenuItem,
  DataFetcher,
  LruCache
};
const chromosomes = {
  ChromosomeInfo,
  SearchField
};
const dataFetchers = {
  DataFetcher,
  GBKDataFetcher,
  LocalDataFetcher: LocalTileDataFetcher,
  getDataFetcher: getDataFetcher$1
};
const AVAILABLE_FOR_PLUGINS = {
  chromosomes,
  libraries,
  tracks: tracks$1,
  dataFetchers,
  factories,
  services,
  utils: utils$7,
  configs,
  VERSION: version
};
const classes$3 = {
  "track-renderer": "_track-renderer_11dwb_1",
  "track-renderer-element": "_track-renderer-element_11dwb_5",
  "track-renderer-events": "_track-renderer-events_11dwb_6"
};
function _classCallCheck$m(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$l(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$l(descriptor.key), descriptor);
  }
}
function _createClass$m(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$l(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$l(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$l(arg) {
  var key = _toPrimitive$l(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$l(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$m(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$l(subClass, superClass);
}
function _setPrototypeOf$l(o, p) {
  _setPrototypeOf$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$l(o, p);
}
function _createSuper$l(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$l();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$l(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$l(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$m(this, result);
  };
}
function _possibleConstructorReturn$m(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$l(self2);
}
function _assertThisInitialized$l(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$l() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$l(o) {
  _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$l(o);
}
const {
  getDataFetcher
} = AVAILABLE_FOR_PLUGINS.dataFetchers;
const SCROLL_TIMEOUT = 100;
let TrackRenderer = /* @__PURE__ */ function(_React$Component) {
  _inherits$m(TrackRenderer2, _React$Component);
  var _super = _createSuper$l(TrackRenderer2);
  function TrackRenderer2(props) {
    var _this;
    _classCallCheck$m(this, TrackRenderer2);
    _this = _super.call(this, props);
    _this.dragging = false;
    _this.element = null;
    _this.eventTracker = null;
    _this.eventTrackerOld = null;
    _this.closing = false;
    _this.yPositionOffset = 0;
    _this.xPositionOffset = 0;
    _this.scrollTop = 0;
    _this.scrollTimeout = null;
    _this.activeTransitions = 0;
    _this.zoomTransform = identity$4;
    _this.windowScrolledBound = _this.windowScrolled.bind(_assertThisInitialized$l(_this));
    _this.zoomStartedBound = _this.zoomStarted.bind(_assertThisInitialized$l(_this));
    _this.zoomedBound = _this.zoomed.bind(_assertThisInitialized$l(_this));
    _this.zoomEndedBound = _this.zoomEnded.bind(_assertThisInitialized$l(_this));
    _this.uid = slugid$1.nice();
    _this.viewUid = _this.props.uid;
    _this.availableForPlugins = {
      ...AVAILABLE_FOR_PLUGINS,
      services: {
        ...AVAILABLE_FOR_PLUGINS.services,
        pubSub: _this.props.pubSub,
        pixiRenderer: _this.props.pixiRenderer
      }
    };
    _this.mounted = false;
    _this.emptyZoomBehavior = zoom();
    _this.currentProps = props;
    _this.prevPropsStr = "";
    _this.zoomBehavior = /** @type {import("d3-zoom").ZoomBehavior<HTMLElement, any>} */
    zoom().filter((event) => {
      if (event.target.classList.contains("no-zoom")) {
        return false;
      }
      if (event.target.classList.contains("react-resizable-handle")) {
        return false;
      }
      return true;
    }).on("start", _this.zoomStartedBound).on("zoom", _this.zoomedBound).on("end", _this.zoomEndedBound);
    _this.zoomTransform = identity$4;
    _this.prevZoomTransform = identity$4;
    _this.initialXDomain = [0, 1];
    _this.initialYDomain = [0, 1];
    _this.xDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];
    _this.yDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];
    _this.zoomLimits = [0, Number.MAX_SAFE_INTEGER];
    _this.prevCenterX = _this.currentProps.paddingLeft + _this.currentProps.leftWidth + _this.currentProps.centerWidth / 2;
    _this.prevCenterY = _this.currentProps.paddingTop + _this.currentProps.topHeight + _this.currentProps.centerHeight / 2;
    _this.cumCenterXOffset = 0;
    _this.cumCenterYOffset = 0;
    _this.setUpInitialScales(_this.currentProps.initialXDomain, _this.currentProps.initialYDomain, _this.currentProps.xDomainLimits, _this.currentProps.yDomainLimits, _this.currentProps.zoomLimits);
    _this.setUpScales();
    _this.trackDefObjects = {};
    _this.metaTracks = {};
    _this.pubSubs = [];
    if (window.higlassTracksByType) {
      for (const pluginTrackType in window.higlassTracksByType) {
        TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
      }
    }
    _this.boundForwardEvent = _this.forwardEvent.bind(_assertThisInitialized$l(_this));
    _this.boundScrollEvent = _this.scrollEvent.bind(_assertThisInitialized$l(_this));
    _this.boundForwardContextMenu = _this.forwardContextMenu.bind(_assertThisInitialized$l(_this));
    _this.dispatchEventBound = _this.dispatchEvent.bind(_assertThisInitialized$l(_this));
    _this.zoomToDataPosHandlerBound = _this.zoomToDataPosHandler.bind(_assertThisInitialized$l(_this));
    _this.onScrollHandlerBound = _this.onScrollHandler.bind(_assertThisInitialized$l(_this));
    _this.elementPos = {
      height: 0,
      width: 0,
      left: 0,
      top: 0
    };
    _this.elementSelection = null;
    return _this;
  }
  _createClass$m(TrackRenderer2, [{
    key: "xScale",
    get: function() {
      if (!this._xScale) {
        throw new Error("xScale is not defined");
      }
      return this._xScale;
    }
  }, {
    key: "yScale",
    get: function() {
      if (!this._yScale) {
        throw new Error("yScale is not defined");
      }
      return this._yScale;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.pubSubs = [];
      this.pubSubs.push(this.props.pubSub.subscribe("scroll", this.windowScrolledBound));
      this.pubSubs.push(this.props.pubSub.subscribe("app.event", this.dispatchEventBound));
      this.pubSubs.push(this.props.pubSub.subscribe("zoomToDataPos", this.zoomToDataPosHandlerBound));
      this.pubSubs.push(this.props.pubSub.subscribe("app.scroll", this.onScrollHandlerBound));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.element) {
        throw new Error("Component did not mount, this.element is not defined.");
      }
      this.elementPos = this.element.getBoundingClientRect();
      this.elementSelection = select$1(this.element);
      this.pStage = new GLOBALS.PIXI.Graphics();
      this.pMask = new GLOBALS.PIXI.Graphics();
      this.pOutline = new GLOBALS.PIXI.Graphics();
      this.pBackground = new GLOBALS.PIXI.Graphics();
      this.pStage.addChild(this.pMask);
      this.pStage.addChild(this.pOutline);
      this.currentProps.pixiStage.addChild(this.pStage);
      this.pStage.mask = this.pMask;
      if (!this.props.isRangeSelection)
        this.addZoom();
      if (!this.currentProps.svgElement || !this.currentProps.canvasElement) {
        return;
      }
      this.svgElement = this.currentProps.svgElement;
      this.syncTrackObjects(this.currentProps.positionedTracks);
      this.syncMetaTracks(this.currentProps.metaTracks);
      this.currentProps.setCentersFunction(this.setCenter.bind(this));
      this.currentProps.registerDraggingChangedListener(this.draggingChanged.bind(this));
      this.draggingChanged(true);
      this.addEventTracker();
      const transExt = [[this.xScale(this.xDomainLimits[0]), this.yScale(this.yDomainLimits[0])], [this.xScale(this.xDomainLimits[1]), this.yScale(this.yDomainLimits[1])]];
      const svgBBox = this.svgElement.getBoundingClientRect();
      const ext = [[Math.max(transExt[0][0], 0), Math.max(transExt[0][1], 0)], [Math.min(transExt[1][0], svgBBox.width), Math.min(transExt[1][1], svgBBox.height)]];
      this.zoomBehavior.extent(ext).translateExtent(transExt).scaleExtent(this.zoomLimits);
    }
    // eslint-disable-next-line camelcase
    /** @param {TrackRendererProps} nextProps */
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!nextProps.svgElement || !nextProps.canvasElement) {
        return;
      }
      const nextPropsStr = this.updatablePropsToString(nextProps);
      this.currentProps = nextProps;
      if (this.prevPropsStr === nextPropsStr)
        return;
      this.setBackground();
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.delayDrawing = true;
      }
      this.prevPropsStr = nextPropsStr;
      this.setUpInitialScales(nextProps.initialXDomain, nextProps.initialYDomain, nextProps.xDomainLimits, nextProps.yDomainLimits, nextProps.zoomLimits);
      this.setUpScales(nextProps.width !== this.props.width || nextProps.height !== this.props.height);
      this.svgElement = nextProps.svgElement;
      const transExt = [[this.xScale(this.xDomainLimits[0]), this.yScale(this.yDomainLimits[0])], [this.xScale(this.xDomainLimits[1]), this.yScale(this.yDomainLimits[1])]];
      const svgBBox = this.svgElement.getBoundingClientRect();
      const ext = [[Math.max(transExt[0][0], 0), Math.max(transExt[0][1], 0)], [Math.min(transExt[1][0], svgBBox.width), Math.min(transExt[1][1], svgBBox.height)]];
      this.zoomBehavior.extent(ext).translateExtent(transExt).scaleExtent(this.zoomLimits);
      this.syncTrackObjects(nextProps.positionedTracks);
      this.syncMetaTracks(nextProps.metaTracks);
      for (const track of nextProps.positionedTracks) {
        const options2 = track.track.options;
        const trackObject = this.trackDefObjects[track.track.uid].trackObject;
        trackObject.rerender(options2);
        if (isCombinedTrackConfig(track.track)) {
          const ctDefs = {};
          for (const ct of track.track.contents) {
            ctDefs[ct.uid] = ct;
          }
          for (const uid in trackObject.createdTracks) {
            trackObject.createdTracks[uid].rerender(ctDefs[uid].options);
          }
        }
      }
      this.props.onNewTilesLoaded();
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.delayDrawing = false;
        track.draw();
      }
    }
    /** @param {TrackRendererProps} prevProps */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.initialXDomain[0] !== prevProps.initialXDomain[0] || this.props.initialXDomain[1] !== prevProps.initialXDomain[1] || this.props.initialYDomain[0] !== prevProps.initialYDomain[0] || this.props.initialYDomain[1] !== prevProps.initialYDomain[1]) {
        if (this.element)
          this.element.__zoom = identity$4;
      }
      if (prevProps.isRangeSelection !== this.props.isRangeSelection) {
        if (this.props.isRangeSelection) {
          this.removeZoom();
        } else {
          this.addZoom();
        }
      }
      if (prevProps.zoomable !== this.props.zoomable) {
        if (this.props.zoomable) {
          this.addZoom();
        } else {
          this.removeZoom();
        }
      }
      this.addEventTracker();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a, _b;
      this.mounted = false;
      this.removeTracks(Object.keys(this.trackDefObjects));
      this.removeMetaTracks(Object.keys(this.metaTracks));
      this.currentProps.removeDraggingChangedListener(this.draggingChanged);
      if (this.pStage)
        this.currentProps.pixiStage.removeChild(this.pStage);
      (_a = this.pMask) == null ? void 0 : _a.destroy(true);
      (_b = this.pStage) == null ? void 0 : _b.destroy(true);
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
      this.removeEventTracker();
    }
    /* --------------------------- Custom Methods ----------------------------- */
    /**
     * Dispatch a forwarded event on the main DOM element
     *
     * @param  {Event & { sourceUid: string, type: string }} event Event to be dispatched.
     */
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent2(event) {
      if (event.sourceUid === this.uid && event.type !== "contextmenu") {
        if (this.element)
          forwardEvent(event, this.element);
      }
    }
    /**
     * Check of a view position (i.e., pixel coords) is within this view
     *
     * @param {number} x - X position to be tested.
     * @param {number} y - Y position to be tested.
     * @return {boolean} If `true` position is within this view.
     */
  }, {
    key: "isWithin",
    value: function isWithin2(x, y) {
      const withinX = x >= this.elementPos.left && x <= this.elementPos.width + this.elementPos.left;
      const withinY = y >= this.elementPos.top && y <= this.elementPos.height + this.elementPos.top;
      return withinX && withinY;
    }
    /** @param {{ pos: [number, number, number, number], animateTime: number }} opts */
  }, {
    key: "zoomToDataPosHandler",
    value: function zoomToDataPosHandler({
      pos,
      animateTime
    }) {
      this.zoomToDataPos(...pos, animateTime);
    }
  }, {
    key: "addZoom",
    value: function addZoom() {
      if (!this.elementSelection || !this.currentProps.zoomable)
        return;
      this.elementSelection.call(this.zoomBehavior);
      this.zoomBehavior.transform(this.elementSelection, this.zoomTransform);
    }
  }, {
    key: "removeZoom",
    value: function removeZoom() {
      if (this.elementSelection) {
        this.zoomEnded();
        this.elementSelection.on(".zoom", null);
      }
    }
    /*
     * Add a mask to make sure that the tracks displayed in this view
     * don't overflow its bounds.
     */
  }, {
    key: "setMask",
    value: function setMask() {
      var _a, _b, _c, _d;
      (_a = this.pMask) == null ? void 0 : _a.clear();
      (_b = this.pMask) == null ? void 0 : _b.beginFill();
      (_c = this.pMask) == null ? void 0 : _c.drawRect(this.xPositionOffset, this.yPositionOffset, this.currentProps.width, this.currentProps.height);
      (_d = this.pMask) == null ? void 0 : _d.endFill();
    }
  }, {
    key: "setBackground",
    value: function setBackground() {
      var _a, _b, _c, _d, _e;
      const defBgColor = this.props.theme === THEME_DARK ? "black" : "white";
      const bgColor = colorToHex(((_a = this.currentProps.viewOptions) == null ? void 0 : _a.backgroundColor) ?? defBgColor);
      (_b = this.pBackground) == null ? void 0 : _b.clear();
      (_c = this.pBackground) == null ? void 0 : _c.beginFill(bgColor);
      (_d = this.pBackground) == null ? void 0 : _d.drawRect(this.xPositionOffset, this.yPositionOffset, this.currentProps.width, this.currentProps.height);
      (_e = this.pBackground) == null ? void 0 : _e.endFill();
    }
  }, {
    key: "windowScrolled",
    value: function windowScrolled() {
      this.removeZoom();
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(() => {
        this.addZoom();
      }, SCROLL_TIMEOUT);
    }
    /**
     * @param {[number, number]} initialXDomain
     * @param {[number, number]} initialYDomain
     * @param {[number, number]} xDomainLimits
     * @param {[number, number]} yDomainLimits
     * @param {[number, number]} zoomLimits
     */
  }, {
    key: "setUpInitialScales",
    value: function setUpInitialScales(initialXDomain = [0, 1], initialYDomain = [0, 1], xDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER], yDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER], zoomLimits = [0, Number.MAX_SAFE_INTEGER]) {
      zoomLimits[0] = zoomLimits[0] === null ? 0 : zoomLimits[0];
      zoomLimits[1] = zoomLimits[1] === null ? Infinity : zoomLimits[1];
      const xWidth = initialXDomain[1] - initialXDomain[0];
      const yCenter = (initialYDomain[0] + initialYDomain[1]) / 2;
      initialYDomain[0] = yCenter - xWidth / 2;
      initialYDomain[1] = yCenter + xWidth / 2;
      if (initialXDomain[0] === this.initialXDomain[0] && initialXDomain[1] === this.initialXDomain[1] && initialYDomain[0] === this.initialYDomain[0] && initialYDomain[1] === this.initialYDomain[1] && xDomainLimits[0] === this.xDomainLimits[0] && xDomainLimits[1] === this.xDomainLimits[1] && yDomainLimits[0] === this.yDomainLimits[0] && yDomainLimits[1] === this.yDomainLimits[1] && zoomLimits[0] === this.zoomLimits[0] && zoomLimits[1] === this.zoomLimits[1])
        return;
      this.initialXDomain = initialXDomain;
      this.initialYDomain = initialYDomain;
      this.xDomainLimits = xDomainLimits;
      this.yDomainLimits = yDomainLimits;
      this.zoomLimits = zoomLimits;
      this.zoomTransform = identity$4;
      this.prevZoomTransform = identity$4;
      this.cumCenterYOffset = 0;
      this.cumCenterXOffset = 0;
      this.drawableToDomainX = linear().domain([this.currentProps.paddingLeft + this.currentProps.leftWidth, this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth]).range([initialXDomain[0], initialXDomain[1]]);
      let startY;
      let endY;
      if (this.currentProps.centerWidth === 0) {
        startY = this.currentProps.paddingTop + this.currentProps.topHeight;
        endY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight;
      } else {
        startY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2 - this.currentProps.centerWidth / 2;
        endY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2 + this.currentProps.centerWidth / 2;
      }
      this.drawableToDomainY = linear().domain([startY, endY]).range([initialYDomain[0], initialYDomain[1]]);
      this.prevCenterX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      this.prevCenterY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
    }
    /** @param {TrackRendererProps} props */
  }, {
    key: "updatablePropsToString",
    value: function updatablePropsToString(props) {
      return JSON.stringify({
        positionedTracks: props.positionedTracks,
        initialXDomain: props.initialXDomain,
        initialYDomain: props.initialYDomain,
        width: props.width,
        height: props.height,
        paddingLeft: props.paddingLeft,
        paddingTop: props.paddingTop,
        leftWidth: props.leftWidth,
        topHeight: props.topHeight,
        dragging: props.dragging,
        viewOptions: props.viewOptions
      });
    }
    /** @param {boolean} draggingStatus */
  }, {
    key: "draggingChanged",
    value: function draggingChanged(draggingStatus) {
      this.dragging = draggingStatus;
      this.timedUpdatePositionAndDimensions();
    }
  }, {
    key: "setUpScales",
    value: function setUpScales(notify = false) {
      const currentCenterX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      const currentCenterY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
      if (!this.drawableToDomainX || !this.drawableToDomainY) {
        return;
      }
      const centerDomainXOffset = (this.drawableToDomainX(currentCenterX) - this.drawableToDomainX(this.prevCenterX)) / this.zoomTransform.k;
      const centerDomainYOffset = (this.drawableToDomainY(currentCenterY) - this.drawableToDomainY(this.prevCenterY)) / this.zoomTransform.k;
      this.cumCenterYOffset += centerDomainYOffset;
      this.cumCenterXOffset += centerDomainXOffset;
      this.prevCenterY = currentCenterY;
      this.prevCenterX = currentCenterX;
      const visibleXDomain = [this.drawableToDomainX(0) - this.cumCenterXOffset, this.drawableToDomainX(this.currentProps.width) - this.cumCenterXOffset];
      const visibleYDomain = [this.drawableToDomainY(0) - this.cumCenterYOffset, this.drawableToDomainY(this.currentProps.height) - this.cumCenterYOffset];
      this._xScale = linear().domain(visibleXDomain).range([0, this.currentProps.width]);
      this._yScale = linear().domain(visibleYDomain).range([0, this.currentProps.height]);
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.refScalesChanged(this.xScale, this.yScale);
      }
      this.applyZoomTransform(notify);
    }
    /**
     * Get a track's viewconf definition by its object
     *
     * @param {TrackObject} trackObjectIn
     */
  }, {
    key: "getTrackDef",
    value: function getTrackDef(trackObjectIn) {
      const trackDefItems = dictItems(this.trackDefObjects);
      for (const [, {
        trackDef,
        trackObject
      }] of trackDefItems) {
        if (trackObject === trackObjectIn) {
          return trackDef.track;
        }
        if (isCombinedTrackConfig(trackDef.track)) {
          for (const subTrackDef of trackDef.track.contents) {
            if (trackObject.createdTracks[subTrackDef.uid] === trackObjectIn) {
              return subTrackDef;
            }
          }
        }
      }
      return null;
    }
    /**
     * Fetch the trackObject for a track with a given ID
     *
     * @param {string} trackId
     * @return {TrackObject | undefined}
     */
  }, {
    key: "getTrackObject",
    value: function getTrackObject(trackId) {
      const trackDefItems = dictItems(this.trackDefObjects);
      for (let i = 0; i < trackDefItems.length; i++) {
        const uid = trackDefItems[i][0];
        const trackObject = trackDefItems[i][1].trackObject;
        if (uid === trackId) {
          return trackObject;
        }
        if (trackObject.createdTracks) {
          const createdTrackItems = dictItems(trackObject.createdTracks);
          for (let j = 0; j < createdTrackItems.length; j++) {
            const createdTrackUid = createdTrackItems[j][0];
            const createdTrackObject = createdTrackItems[j][1];
            if (createdTrackUid === trackId) {
              return createdTrackObject;
            }
          }
        }
      }
      return void 0;
    }
  }, {
    key: "timedUpdatePositionAndDimensions",
    value: function timedUpdatePositionAndDimensions() {
      if (this.closing || !this.element)
        return;
      this.elementPos = this.element.getBoundingClientRect();
      if (this.dragging) {
        this.yPositionOffset = this.element.getBoundingClientRect().top - this.currentProps.canvasElement.getBoundingClientRect().top + this.scrollTop;
        this.xPositionOffset = this.element.getBoundingClientRect().left - this.currentProps.canvasElement.getBoundingClientRect().left;
        this.setMask();
        this.setBackground();
        const updated = this.updateTrackPositions();
        if (updated) {
          this.applyZoomTransform(true);
        }
        requestAnimationFrame(this.timedUpdatePositionAndDimensions.bind(this));
      }
    }
    /**
     * @param {Array<TrackConfig>} trackDefinitions
     */
  }, {
    key: "syncMetaTracks",
    value: function syncMetaTracks(trackDefinitions) {
      const knownMetaTrackIds = Object.keys(this.metaTracks);
      const newMetaTracks = new Set(trackDefinitions.map((def) => def.uid));
      this.addMetaTracks(trackDefinitions.filter((def) => !this.metaTracks[def.uid]));
      this.updateMetaTracks(trackDefinitions.filter((def) => this.metaTracks[def.uid]));
      this.removeMetaTracks(knownMetaTrackIds.filter((def) => !newMetaTracks.has(def)));
    }
    /**
     * @param {Array<TrackDefinition>} trackDefinitions
     */
  }, {
    key: "syncTrackObjects",
    value: function syncTrackObjects(trackDefinitions) {
      this.prevTrackDefinitions = JSON.stringify(trackDefinitions);
      const receivedTracksDict = {};
      for (let i = 0; i < trackDefinitions.length; i++) {
        receivedTracksDict[trackDefinitions[i].track.uid] = trackDefinitions[i];
      }
      const knownTracks = new Set(Object.keys(this.trackDefObjects));
      const receivedTracks = new Set(Object.keys(receivedTracksDict));
      const enterTrackDefs = new Set([...receivedTracks].filter((x) => !knownTracks.has(x)));
      const exitTracks = new Set([...knownTracks].filter((x) => !receivedTracks.has(x)));
      const updateTrackDefs = new Set([...receivedTracks].filter((x) => knownTracks.has(x)));
      this.updateExistingTrackDefs([...updateTrackDefs].map((x) => receivedTracksDict[x]));
      this.addNewTracks([...enterTrackDefs].map((x) => receivedTracksDict[x]));
      this.updateExistingTrackDefs([...enterTrackDefs].map((x) => receivedTracksDict[x]));
      this.removeTracks([...exitTracks]);
    }
    /**
     * Add new meta tracks
     *
     * @param {Array<TrackConfig>} metaTrackDefs  Definitions of meta tracks to be added.
     */
  }, {
    key: "addMetaTracks",
    value: function addMetaTracks(metaTrackDefs) {
      metaTrackDefs.filter((metaTrackDef) => !this.metaTracks[metaTrackDef.uid]).forEach((metaTrackDef) => {
        this.metaTracks[metaTrackDef.uid] = {
          trackDef: metaTrackDef,
          trackObject: this.createMetaTrack(metaTrackDef)
        };
      });
    }
    /**
     * @param {Array<TrackDefinition>} newTrackDefinitions
     */
  }, {
    key: "addNewTracks",
    value: function addNewTracks(newTrackDefinitions) {
      if (!this.currentProps.pixiStage) {
        return;
      }
      for (let i = 0; i < newTrackDefinitions.length; i++) {
        const newTrackDef = newTrackDefinitions[i];
        const newTrackObj = this.createTrackObject(newTrackDef.track);
        newTrackObj.refScalesChanged(this.xScale, this.yScale);
        this.trackDefObjects[newTrackDef.track.uid] = {
          trackDef: newTrackDef,
          trackObject: newTrackObj
        };
        const zoomedXScale = this.zoomTransform.rescaleX(this.xScale);
        const zoomedYScale = this.zoomTransform.rescaleY(this.yScale);
        newTrackObj.setDimensions([newTrackDef.width, newTrackDef.height]);
        newTrackObj.zoomed(zoomedXScale, zoomedYScale);
      }
      this.applyZoomTransform(false);
    }
    /** @param {unknown} _unused */
  }, {
    key: "updateMetaTracks",
    value: function updateMetaTracks(_unused) {
    }
    /** @param {Array<TrackDefinition>} newTrackDefs */
  }, {
    key: "updateExistingTrackDefs",
    value: function updateExistingTrackDefs(newTrackDefs) {
      for (const trackDef of newTrackDefs) {
        const ref2 = this.trackDefObjects[trackDef.track.uid];
        ref2.trackDef = trackDef;
        if (isCombinedTrackConfig(trackDef.track)) {
          ref2.trackObject.updateContents(trackDef.track.contents, this.createTrackObject.bind(this)).refScalesChanged(this.xScale, this.yScale);
        }
      }
      const updated = this.updateTrackPositions();
      if (updated) {
        this.applyZoomTransform(false);
      }
    }
  }, {
    key: "updateTrackPositions",
    value: function updateTrackPositions() {
      let updated = false;
      for (const uid in this.trackDefObjects) {
        const trackDef = this.trackDefObjects[uid].trackDef;
        const trackObject = this.trackDefObjects[uid].trackObject;
        const prevPosition = trackObject.position;
        const prevDimensions = trackObject.dimensions;
        const newPosition = [this.xPositionOffset + trackDef.left, this.yPositionOffset + trackDef.top];
        const newDimensions = [trackDef.width, trackDef.height];
        if (!prevPosition || newPosition[0] !== prevPosition[0] || newPosition[1] !== prevPosition[1]) {
          trackObject.setPosition(newPosition);
          updated = true;
        }
        if (!prevDimensions || newDimensions[0] !== prevDimensions[0] || newDimensions[1] !== prevDimensions[1]) {
          trackObject.setDimensions(newDimensions);
          updated = true;
        }
      }
      return updated;
    }
    /** @param {string[]} trackIds */
  }, {
    key: "removeMetaTracks",
    value: function removeMetaTracks(trackIds) {
      trackIds.forEach((id2) => {
        this.metaTracks[id2].trackObject.remove();
        this.metaTracks[id2] = void 0;
        delete this.metaTracks[id2];
      });
    }
    /** @param {string[]} trackUids */
  }, {
    key: "removeTracks",
    value: function removeTracks(trackUids) {
      for (let i = 0; i < trackUids.length; i++) {
        if (this.trackDefObjects[trackUids[i]] == null)
          return;
        if (this.trackDefObjects[trackUids[i]].trackObject == null)
          return;
        try {
          this.trackDefObjects[trackUids[i]].trackObject.remove();
          delete this.trackDefObjects[trackUids[i]];
        } catch (err2) {
        }
      }
    }
    /**
     * Set the center of this view to a paticular X and Y coordinate
     * @param  {number}  centerX  Centeral X data? position.
     * @param  {number}  centerY  Central Y data? position.
     * @param  {number}  sourceK  Source zoom level? @Pete what's the source?
     * @param  {boolean}  notify  If `true` notify listeners that the scales
     *   have changed. This can be turned off to prevent circular updates when
     *   scales are locked.
     * @param  {number}  animateTime  Animation time in milliseconds. Only used
     *   when `animate` is true.
     * @param  {Scale}  xScale  The scale to use for the X axis.
     * @param  {Scale}  yScale  The scale to use for the Y axis.
     */
  }, {
    key: "setCenter",
    value: function setCenter(centerX, centerY, sourceK, notify = false, animateTime = 0, xScale = this.xScale, yScale = this.yScale) {
      const refK = this.xScale.invert(1) - this.xScale.invert(0);
      const k = refK / sourceK;
      const middleViewX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      const middleViewY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
      const translateX2 = middleViewX - xScale(centerX) * k;
      const translateY2 = middleViewY - yScale(centerY) * k;
      let last2;
      const setZoom = () => {
        const newTransform = identity$4.translate(translateX2, translateY2).scale(k);
        this.zoomTransform = newTransform;
        if (this.elementSelection) {
          this.emptyZoomBehavior.transform(this.elementSelection, newTransform);
        }
        last2 = this.applyZoomTransform(notify);
      };
      if (animateTime && this.elementSelection) {
        let selection2 = this.elementSelection;
        this.activeTransitions += 1;
        if (!document.hidden) {
          selection2 = selection2.transition().duration(animateTime);
        }
        selection2.call(this.zoomBehavior.transform, identity$4.translate(translateX2, translateY2).scale(k)).on("end", () => {
          setZoom();
          this.activeTransitions -= 1;
        });
      } else {
        setZoom();
      }
      return last2;
    }
    /** @param {number} movement */
  }, {
    key: "valueScaleMove",
    value: function valueScaleMove(movement) {
      if (!this.zoomStartPos) {
        return;
      }
      for (const track of this.getTracksAtPosition(...this.zoomStartPos)) {
        track.movedY(movement);
      }
      if (this.zoomStartTransform)
        this.zoomTransform = this.zoomStartTransform;
    }
    /**
     * @param {{ sourceEvent: Event }} event
     * @param {string | null} orientation
     */
  }, {
    key: "valueScaleZoom",
    value: function valueScaleZoom(event, orientation2) {
      if (!isWheelEvent(event.sourceEvent)) {
        return;
      }
      const mdy = event.sourceEvent.deltaY;
      const mdm = event.sourceEvent.deltaMode;
      const myWheelDelta = (dy, dm) => dy * (dm ? 120 : 1) / 500;
      const mwd = myWheelDelta(mdy, mdm);
      const cp = pointer(event.sourceEvent, this.props.canvasElement);
      for (const track of this.getTracksAtPosition(...cp)) {
        const yPos = orientation2 === "1d-horizontal" ? cp[1] - track.position[1] : cp[0] - track.position[0];
        track.zoomedY(yPos, 2 ** mwd);
      }
      if (this.zoomStartTransform)
        this.zoomTransform = this.zoomStartTransform;
    }
    /**
     * Respond to a zoom event.
     *
     * We need to update our local record of the zoom transform and apply it
     * to all the tracks.
     *
     * @param {import("d3-zoom").D3ZoomEvent<HTMLElement, unknown> & { shiftKey?: boolean }} event
     */
  }, {
    key: "zoomed",
    value: function zoomed(event) {
      var _a;
      let trackOrientation = null;
      if (this.zoomStartPos) {
        const tracksAtZoomStart = this.getTracksAtPosition(...this.zoomStartPos);
        if (tracksAtZoomStart.length) {
          const trackAtZoomStart = tracksAtZoomStart[0];
          const trackDef = this.getTrackDef(trackAtZoomStart);
          if (!trackDef) {
            return;
          }
          if ((_a = TRACKS_INFO_BY_TYPE[trackDef.type]) == null ? void 0 : _a.orientation) {
            trackOrientation = TRACKS_INFO_BY_TYPE[trackDef.type].orientation;
          }
          if (trackAtZoomStart instanceof LeftTrackModifier) {
            trackOrientation = "1d-vertical";
          }
        }
      }
      if (trackOrientation && event.sourceEvent) {
        if (event.shiftKey || this.valueScaleZooming) {
          if (event.sourceEvent.deltaY !== void 0) {
            this.valueScaleZoom(event, trackOrientation);
            return;
          }
          if (trackOrientation === "1d-horizontal") {
            this.valueScaleMove(event.sourceEvent.movementY);
          } else if (trackOrientation === "1d-vertical") {
            this.valueScaleMove(event.sourceEvent.movementX);
          }
        }
        if (trackOrientation === "1d-horizontal" && event.sourceEvent.movementY) {
          this.valueScaleMove(event.sourceEvent.movementY);
        } else if (trackOrientation === "1d-vertical" && event.sourceEvent.movementX) {
          this.valueScaleMove(event.sourceEvent.movementX);
        }
      }
      this.zoomTransform = !this.currentProps.zoomable ? identity$4 : event.transform;
      const zooming = this.prevZoomTransform.k !== this.zoomTransform.k;
      if (!zooming) {
        if (trackOrientation === "1d-horizontal") {
          this.zoomTransform = identity$4.translate(this.zoomTransform.x, this.prevZoomTransform.y).scale(this.zoomTransform.k);
        } else if (trackOrientation === "1d-vertical") {
          this.zoomTransform = identity$4.translate(this.prevZoomTransform.x, this.zoomTransform.y).scale(this.zoomTransform.k);
        }
        if (this.element)
          this.element.__zoom = this.zoomTransform;
      }
      this.applyZoomTransform(true);
      this.prevZoomTransform = this.zoomTransform;
      this.props.pubSub.publish("app.zoom", event);
      if (event.sourceEvent) {
        event.sourceEvent.stopPropagation();
        event.sourceEvent.preventDefault();
      }
    }
    /**
     * Return a list of tracks under this position.
     *
     * The position should be relative to this.props.canvasElement.
     *
     * @param {number} x The query x position
     * @param {number} y The query y position
     * @return {Array<TrackObject>}  An array of tracks at this position
     */
  }, {
    key: "getTracksAtPosition",
    value: function getTracksAtPosition(x, y) {
      const foundTracks = [];
      let tracksToVisit = [];
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        if (track.childTracks) {
          tracksToVisit = tracksToVisit.concat(track.childTracks);
        } else {
          tracksToVisit.push(track);
        }
      }
      for (const track of tracksToVisit) {
        const withinX = track.position[0] <= x && x <= track.position[0] + track.dimensions[0];
        const withinY = track.position[1] <= y && y <= track.position[1] + track.dimensions[1];
        if (withinX && withinY) {
          foundTracks.push(track);
        }
      }
      return foundTracks;
    }
    /** @param {import('d3-zoom').D3ZoomEvent<HTMLElement, unknown>=} event */
  }, {
    key: "zoomStarted",
    value: function zoomStarted(event) {
      this.zooming = true;
      if (event && event.sourceEvent) {
        this.zoomStartPos = pointer(event.sourceEvent, this.props.canvasElement);
        if (event.sourceEvent.shiftKey) {
          this.valueScaleZooming = true;
        }
      }
      this.zoomStartTransform = this.zoomTransform;
      this.props.pubSub.publish("app.zoomStart");
    }
  }, {
    key: "zoomEnded",
    value: function zoomEnded() {
      this.zooming = false;
      this.zoomStartPos = null;
      if (this.valueScaleZooming) {
        this.valueScaleZooming = false;
        if (this.element)
          this.element.__zoom = this.zoomStartTransform;
      }
      this.props.pubSub.publish("app.zoomEnd");
    }
    /**
     * @param {boolean=} notify
     * @returns {[Scale, Scale] | undefined}
     */
  }, {
    key: "applyZoomTransform",
    value: function applyZoomTransform(notify = true) {
      const props = this.currentProps;
      const paddingleft = props.paddingLeft + props.leftWidth;
      const paddingTop = props.paddingTop + props.topHeight;
      if (!this.xScale || !this.yScale) {
        return void 0;
      }
      this.zoomedXScale = this.zoomTransform.rescaleX(this.xScale);
      this.zoomedYScale = this.zoomTransform.rescaleY(this.yScale);
      const newXScale = linear().domain([paddingleft, paddingleft + props.centerWidth].map(this.zoomedXScale.invert)).range([0, props.centerWidth]);
      const newYScale = linear().domain([paddingTop, paddingTop + props.centerHeight].map(this.zoomedYScale.invert)).range([0, props.centerHeight]);
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        const trackDef = this.trackDefObjects[uid].trackDef;
        let orientation2 = "unknown";
        if (TRACKS_INFO_BY_TYPE[trackDef.track.type]) {
          orientation2 = TRACKS_INFO_BY_TYPE[trackDef.track.type].orientation;
        }
        if (orientation2 === "whole") {
          const trackXScale = linear().domain([props.paddingLeft, props.width - props.paddingLeft].map(this.zoomedXScale.invert)).range([0, props.width - 2 * props.paddingLeft]);
          const trackYScale = linear().domain([props.paddingTop, props.height - props.paddingTop].map(this.zoomedYScale.invert)).range([0, props.height - 2 * props.paddingTop]);
          track.zoomed(trackXScale, trackYScale);
          continue;
        }
        if (this.trackDefObjects[uid].trackDef.track.position === "gallery") {
          const trackXScale = linear().domain([props.paddingLeft + props.leftWidthNoGallery, props.paddingLeft + props.leftWidth + props.centerWidth + props.galleryDim].map(this.zoomedXScale.invert)).range([0, props.centerWidth + 2 * props.galleryDim]);
          const trackYScale = linear().domain([props.paddingTop + props.topHeightNoGallery, props.paddingTop + props.topHeight + props.centerHeight + props.galleryDim].map(this.zoomedYScale.invert)).range([0, props.centerHeight - 2 * props.galleryDim]);
          track.zoomed(trackXScale.copy(), trackYScale.copy(), this.zoomTransform.k);
          continue;
        }
        track.zoomed(newXScale.copy(), newYScale.copy(), this.zoomTransform.k, this.zoomTransform.x + this.xPositionOffset, this.zoomTransform.y + this.yPositionOffset, props.paddingLeft + props.leftWidth, props.paddingTop + props.topHeight);
      }
      this.currentXScale = newXScale;
      this.currentYScale = newYScale;
      if (notify) {
        this.currentProps.onScalesChanged(newXScale, newYScale);
      }
      return [newXScale, newYScale];
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createMetaTrack",
    value: function createMetaTrack(track) {
      switch (track.type) {
        default: {
          const pluginTrack = this.props.pluginTracks[track.type];
          if (pluginTrack == null ? void 0 : pluginTrack.isMetaTrack) {
            const context = {
              getTrackObject: this.getTrackObject.bind(this),
              onNewTilesLoaded: () => {
                this.currentProps.onNewTilesLoaded(track.uid);
              },
              definition: track
            };
            try {
              return new pluginTrack.track(
                // eslint-disable-line new-cap
                this.availableForPlugins,
                context,
                track.options
              );
            } catch (e) {
              console.error("Plugin meta track", track.type, "failed to instantiate.", e);
            }
          }
          console.warn(`Unknown meta track of type: ${track.type}`);
          return new UnknownPixiTrack(this.pStage, {
            name: "Unknown Track Type",
            type: track.type
          });
        }
      }
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createTrackObject",
    value: function createTrackObject(track) {
      const trackObject = this.createLocationAgnosticTrackObject(track);
      if (track.position === "left" || track.position === "right") {
        if (TRACKS_INFO_BY_TYPE[track.type].orientation === "1d-horizontal") {
          return new LeftTrackModifier(trackObject);
        }
      }
      return trackObject;
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createLocationAgnosticTrackObject",
    value: function createLocationAgnosticTrackObject(track) {
      let dataConfig = track.data;
      if (!dataConfig) {
        dataConfig = {
          server: trimTrailingSlash(track.server),
          tilesetUid: track.tilesetUid
        };
      }
      if (track.coordSystem) {
        dataConfig.coordSystem = track.coordSystem;
      }
      const dataFetcher = getDataFetcher(dataConfig, this.props.pubSub, this.props.pluginDataFetchers, this.availableForPlugins);
      if (!this.pStage || !this.svgElement) {
        throw new Error("No PIXI stage or svg element");
      }
      const context = {
        id: track.uid,
        trackUid: track.uid,
        trackType: track.type,
        viewUid: this.viewUid,
        pubSub: this.props.pubSub,
        scene: this.pStage,
        dataConfig,
        dataFetcher,
        getLockGroupExtrema: () => this.currentProps.getLockGroupExtrema(track.uid),
        handleTilesetInfoReceived: (tilesetInfo) => {
          this.currentProps.onTilesetInfoReceived(track.uid, tilesetInfo);
        },
        animate: () => {
          this.currentProps.onNewTilesLoaded(track.uid);
        },
        svgElement: this.svgElement,
        isValueScaleLocked: () => this.currentProps.isValueScaleLocked(track.uid),
        onValueScaleChanged: () => {
          this.currentProps.onValueScaleChanged(track.uid);
        },
        onTrackOptionsChanged: (newOptions) => {
          this.currentProps.onTrackOptionsChanged(track.uid, newOptions);
        },
        onMouseMoveZoom: this.props.onMouseMoveZoom,
        chromInfoPath: track.chromInfoPath,
        isShowGlobalMousePosition: () => this.props.isShowGlobalMousePosition,
        getTheme: () => this.props.theme
      };
      if (track.y) {
        context.yPosition = track.y;
      }
      if (track.x) {
        context.xPosition = track.x;
      }
      if (track.projectionXDomain) {
        context.projectionXDomain = track.projectionXDomain;
      }
      if (track.projectionYDomain) {
        context.projectionYDomain = track.projectionYDomain;
      }
      switch (track.type) {
        case "left-axis":
          return new LeftAxisTrack(context, track.options);
        case "top-axis":
          return new TopAxisTrack(context, track.options);
        case "heatmap":
          return new HeatmapTiledPixiTrack(context, track.options);
        case "multivec":
        case "vector-heatmap":
        case "horizontal-multivec":
        case "horizontal-vector-heatmap":
        case "vertical-multivec":
        case "vertical-vector-heatmap":
          return new HorizontalMultivecTrack(context, track.options);
        case "1d-heatmap":
        case "horizontal-1d-heatmap":
        case "vertical-1d-heatmap":
          return new Horizontal1dHeatmapTrack(context, track.options);
        case "line":
        case "horizontal-line":
        case "vertical-line":
          return new HorizontalLine1DPixiTrack(context, track.options);
        case "point":
        case "horizontal-point":
        case "vertical-point":
          return new HorizontalPoint1DPixiTrack(context, track.options);
        case "bar":
        case "horizontal-bar":
        case "vertical-bar":
          return new BarTrack(context, track.options);
        case "divergent-bar":
        case "horizontal-divergent-bar":
        case "vertical-divergent-bar":
          return new DivergentBarTrack(context, track.options);
        case "horizontal-1d-tiles":
          return new IdHorizontal1DTiledPixiTrack(context, track.options);
        case "vertical-1d-tiles":
          return new IdVertical1DTiledPixiTrack(context, track.options);
        case "2d-tiles":
          return new Id2DTiledPixiTrack(context, track.options);
        case "stacked-interval":
        case "top-stacked-interval":
        case "left-stacked-interval":
          return new CNVIntervalTrack(context, track.options);
        case "viewport-projection-center":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTracker2D$1(context, track.options);
          }
          return new Track(context, {});
        case "viewport-projection-horizontal":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTrackerHorizontal(context, track.options);
          }
          return new Track(context, {});
        case "viewport-projection-vertical":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTrackerVertical(context, track.options);
          }
          return new Track(context, {});
        case "gene-annotations":
        case "horizontal-gene-annotations":
        case "vertical-gene-annotations":
          return new HorizontalGeneAnnotationsTrack(context, track.options);
        case "2d-rectangle-domains":
        case "arrowhead-domains":
          return new ArrowheadDomainsTrack(context, track.options);
        case "horizontal-1d-annotations":
          return new Annotations1dTrack(context, track.options);
        case "vertical-1d-annotations":
          return new Annotations1dTrack(context, track.options, true);
        case "2d-annotations":
          return new Annotations2dTrack(context, track.options);
        case "linear-2d-rectangle-domains":
        case "horizontal-2d-rectangle-domains":
        case "vertical-2d-rectangle-domains":
          return new Horizontal2DDomainsTrack(context, track.options);
        case "square-markers":
          return new SquareMarkersTrack(context, track.options);
        case "combined":
          context.tracks = track.contents;
          context.createTrackObject = this.createTrackObject.bind(this);
          return new CombinedTrack(context);
        case "2d-chromosome-labels":
          return new Chromosome2DLabels(context, track.options);
        case "horizontal-chromosome-grid":
          context.orientation = "1d-horizontal";
          return new ChromosomeGrid(context, track.options);
        case "vertical-chromosome-grid":
          context.orientation = "1d-vertical";
          return new ChromosomeGrid(context, track.options);
        case "2d-chromosome-grid":
          return new ChromosomeGrid(context, track.options);
        case "chromosome-labels":
        case "horizontal-chromosome-labels":
        case "vertical-chromosome-labels":
          return new HorizontalChromosomeLabels(context, track.options);
        case "linear-heatmap":
        case "horizontal-heatmap":
        case "vertical-heatmap":
          return new HorizontalHeatmapTrack(context, track.options);
        case "2d-chromosome-annotations":
          return new Chromosome2DAnnotations(context, track.options);
        case "1d-value-interval":
        case "horizontal-1d-value-interval":
        case "vertical-1d-value-interval":
          return new ValueIntervalTrack(context, track.options);
        case "osm":
        case "osm-tiles":
          return new OSMTilesTrack(context, track.options);
        case "osm-2d-tile-ids":
          return new OSMTileIdsTrack(context, track.options);
        case "mapbox":
        case "mapbox-tiles":
          return new MapboxTilesTrack(context, track.options);
        case "raster-tiles":
          return new RasterTilesTrack(context, track.options);
        case "bedlike":
        case "vertical-bedlike":
          return new BedLikeTrack(context, track.options);
        case "overlay-track":
          return new OverlayTrack(context, track.options);
        case "overlay-chromosome-grid-track":
          context.isOverlay = true;
          return new ChromosomeGrid(context, track.options);
        case "horizontal-rule":
          return new HorizontalRule(context, track.options);
        case "vertical-rule":
          return new VerticalRule(context, track.options);
        case "cross-rule":
          context.x = track.x;
          context.y = track.y;
          return new CrossRule(context, track.options);
        case "simple-svg":
          return new SVGTrack(context, track.options);
        case "empty": {
          const options2 = track.options;
          return new PixiTrack(context, options2);
        }
        default: {
          const pluginTrack = this.props.pluginTracks[track.type];
          if (pluginTrack && !pluginTrack.isMetaTrack) {
            context.AVAILABLE_FOR_PLUGINS = this.availableForPlugins;
            context.baseEl = this.baseEl;
            context.definition = track;
            if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
              context.registerViewportChanged = track.registerViewportChanged;
              context.removeViewportChanged = track.removeViewportChanged;
              context.setDomainsCallback = track.setDomainsCallback;
            }
            try {
              return new pluginTrack.track(
                // eslint-disable-line new-cap
                this.availableForPlugins,
                context,
                track.options
              );
            } catch (e) {
              console.error("Plugin track", track.type, "failed to instantiate.", e);
            }
          }
          console.warn("Unknown track type:", track.type);
          return new UnknownPixiTrack(context, {
            name: "Unknown Track Type",
            type: track.type
          });
        }
      }
    }
    /**
     * Zoom to a location given the data coordinates
     * @param   {number}  dataXStart  Data start X coordinate.
     * @param   {number}  dataXEnd  Data end X coordinate.
     * @param   {number}  dataYStart  Data start Y coordinate.
     * @param   {number}  dataYEnd  Data end Y coordinate.
     * @param   {number}  animateTime  Animation time in milliseconds.
     * @param   {ProjectorFunction | null}  projector  If not `null` a projector function that
     *   provides adjusted x and y scales.
     */
  }, {
    key: "zoomToDataPos",
    value: function zoomToDataPos(dataXStart, dataXEnd, dataYStart, dataYEnd, animateTime = 3e3, projector = null) {
      const [centerX, centerY, k] = scalesCenterAndK(this.xScale.copy().domain([dataXStart, dataXEnd]), this.yScale.copy().domain([dataYStart, dataYEnd]));
      const projectedScales = projector ? projector(this.xScale, this.yScale) : [this.xScale, this.yScale];
      this.setCenter(centerX, centerY, k, false, animateTime, projectedScales[0], projectedScales[1]);
    }
    /**
     * @param {{ altKey: boolean, preventDefault: () => void }} e
     */
  }, {
    key: "forwardContextMenu",
    value: function forwardContextMenu(e) {
      if (this.props.disableTrackMenu || e.altKey)
        return;
      e.preventDefault();
      setTimeout(() => {
        this.props.pubSub.publish("contextmenu", e);
      }, 0);
    }
  }, {
    key: "addEventTracker",
    value: function addEventTracker() {
      if (!this.eventTracker || this.eventTracker === this.eventTrackerOld)
        return;
      if (!this.eventTrackerOld)
        this.eventTrackerOld = this.eventTracker;
      this.eventTracker = this.eventTrackerOld;
      this.eventTracker.addEventListener("click", this.boundForwardEvent);
      this.eventTracker.addEventListener("contextmenu", this.boundForwardContextMenu);
      this.eventTracker.addEventListener("dblclick", this.boundForwardEvent);
      this.eventTracker.addEventListener("wheel", this.boundForwardEvent);
      this.eventTracker.addEventListener("dragstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("selectstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseover", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseenter", this.boundForwardEvent);
      this.eventTracker.addEventListener("mousedown", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseup", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseout", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseleave", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchend", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchmove", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchcancel", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerover", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerenter", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerdown", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerup", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointercancel", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerout", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerleave", this.boundForwardEvent);
      window.addEventListener("scroll", this.boundScrollEvent);
    }
  }, {
    key: "removeEventTracker",
    value: function removeEventTracker() {
      if (!this.eventTracker)
        return;
      this.eventTracker.removeEventListener("click", this.boundForwardEvent);
      this.eventTracker.removeEventListener("contextmenu", this.boundForwardContextMenu);
      this.eventTracker.removeEventListener("dblclick", this.boundForwardEvent);
      this.eventTracker.removeEventListener("wheel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("dragstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("selectstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseover", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseenter", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mousedown", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseup", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseout", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseleave", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchend", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchcancel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerover", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerenter", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerdown", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerup", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointercancel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerout", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerleave", this.boundForwardEvent);
      window.removeEventListener("scroll", this.boundScrollEvent);
    }
  }, {
    key: "scrollEvent",
    value: function scrollEvent() {
      if (!this.element)
        return;
      this.elementPos = this.element.getBoundingClientRect();
    }
    /**
     * Publishes an event to the pubSub channel, first overriding the
     * sourceUid to be the uid of this track renderer.
     *
     * @template {Event} T
     * @param {T & { sourceUid?: string; forwarded?: boolean }} event
     */
  }, {
    key: "forwardEvent",
    value: function forwardEvent2(event) {
      event.sourceUid = this.uid;
      event.forwarded = true;
      this.props.pubSub.publish("app.event", event);
    }
    /** @param {number} scrollTop */
  }, {
    key: "onScrollHandler",
    value: function onScrollHandler(scrollTop2) {
      this.scrollTop = scrollTop2;
    }
    /* ------------------------------- Render ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.baseEl = c2;
        },
        className: clsx("track-renderer-div", classes$3["track-renderer"]),
        style: {
          height: this.currentProps.height,
          width: this.currentProps.width
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.element = c2;
        },
        className: clsx("track-renderer-element", classes$3["track-renderer-element"])
      }), /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.eventTracker = c2;
        },
        className: clsx("track-renderer-events", classes$3["track-renderer-events"])
      }, this.currentProps.children));
    }
  }]);
  return TrackRenderer2;
}(React$3.Component);
TrackRenderer.defaultProps = {
  pluginDataFetchers: {},
  pluginTracks: {},
  canvasElement: null,
  centerHeight: 0,
  centerWidth: 0,
  children: [],
  galleryDim: 0,
  height: 0,
  initialXDomain: [],
  initialYDomain: [],
  isShowGlobalMousePosition: false,
  isRangeSelection: false,
  leftWidth: 0,
  leftWidthNoGallery: 0,
  paddingLeft: 0,
  paddingTop: 0,
  positionedTracks: [],
  topHeight: 0,
  topHeightNoGallery: 0,
  width: 0,
  metaTracks: []
};
TrackRenderer.propTypes = {
  canvasElement: PropTypes.object,
  centerHeight: PropTypes.number,
  centerWidth: PropTypes.number,
  children: PropTypes.array,
  disableTrackMenu: PropTypes.bool,
  galleryDim: PropTypes.number,
  height: PropTypes.number,
  initialXDomain: PropTypes.array,
  initialYDomain: PropTypes.array,
  isShowGlobalMousePosition: PropTypes.bool,
  isRangeSelection: PropTypes.bool,
  leftWidth: PropTypes.number,
  leftWidthNoGallery: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingTop: PropTypes.number,
  metaTracks: PropTypes.array,
  onMouseMoveZoom: PropTypes.func,
  onNewTilesLoaded: PropTypes.func.isRequired,
  onScalesChanged: PropTypes.func.isRequired,
  pixiRenderer: PropTypes.object.isRequired,
  pixiStage: PropTypes.object.isRequired,
  pluginDataFetchers: PropTypes.object,
  pluginTracks: PropTypes.object,
  positionedTracks: PropTypes.array,
  pubSub: PropTypes.object.isRequired,
  setCentersFunction: PropTypes.func,
  svgElement: PropTypes.object.isRequired,
  theme: PropTypes.symbol.isRequired,
  topHeight: PropTypes.number,
  topHeightNoGallery: PropTypes.number,
  viewOptions: PropTypes.object,
  width: PropTypes.number,
  xDomainLimits: PropTypes.array,
  yDomainLimits: PropTypes.array,
  valueScaleZoom: PropTypes.bool,
  zoomable: PropTypes.bool.isRequired,
  zoomDomain: PropTypes.array,
  uid: PropTypes.string,
  zoomLimits: PropTypes.array
};
const TrackRenderer$1 = withPubSub(withTheme(TrackRenderer));
var index_browser = { exports: {} };
/*! react-checkbox-tree - v1.8.0 | 2022 */
(function(module2, exports2) {
  /*! For license information please see index.browser.js.LICENSE.txt */
  !function(e, t) {
    module2.exports = t(React$3);
  }(self, (e) => (() => {
    var t = {
      4184: (e22, t22) => {
        var r22;
        !function() {
          var n2 = {}.hasOwnProperty;
          function o2() {
            for (var e3 = [], t32 = 0; t32 < arguments.length; t32++) {
              var r3 = arguments[t32];
              if (r3) {
                var i = typeof r3;
                if ("string" === i || "number" === i)
                  e3.push(r3);
                else if (Array.isArray(r3)) {
                  if (r3.length) {
                    var a = o2.apply(null, r3);
                    a && e3.push(a);
                  }
                } else if ("object" === i)
                  if (r3.toString === Object.prototype.toString)
                    for (var c2 in r3)
                      n2.call(r3, c2) && r3[c2] && e3.push(c2);
                  else
                    e3.push(r3.toString());
              }
            }
            return e3.join(" ");
          }
          e22.exports ? (o2.default = o2, e22.exports = o2) : void 0 === (r22 = (function() {
            return o2;
          }).apply(t22, [])) || (e22.exports = r22);
        }();
      },
      8552: (e22, t22, r22) => {
        var n2 = r22(852)(r22(5639), "DataView");
        e22.exports = n2;
      },
      1989: (e22, t22, r22) => {
        var n2 = r22(1789), o2 = r22(401), i = r22(7667), a = r22(1327), c2 = r22(1866);
        function s(e3) {
          var t32 = -1, r3 = null == e3 ? 0 : e3.length;
          for (this.clear(); ++t32 < r3; ) {
            var n3 = e3[t32];
            this.set(n3[0], n3[1]);
          }
        }
        s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c2, e22.exports = s;
      },
      8407: (e22, t22, r22) => {
        var n2 = r22(7040), o2 = r22(4125), i = r22(2117), a = r22(7518), c2 = r22(4705);
        function s(e3) {
          var t32 = -1, r3 = null == e3 ? 0 : e3.length;
          for (this.clear(); ++t32 < r3; ) {
            var n3 = e3[t32];
            this.set(n3[0], n3[1]);
          }
        }
        s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c2, e22.exports = s;
      },
      7071: (e22, t22, r22) => {
        var n2 = r22(852)(r22(5639), "Map");
        e22.exports = n2;
      },
      3369: (e22, t22, r22) => {
        var n2 = r22(4785), o2 = r22(1285), i = r22(6e3), a = r22(9916), c2 = r22(5265);
        function s(e3) {
          var t32 = -1, r3 = null == e3 ? 0 : e3.length;
          for (this.clear(); ++t32 < r3; ) {
            var n3 = e3[t32];
            this.set(n3[0], n3[1]);
          }
        }
        s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c2, e22.exports = s;
      },
      3818: (e22, t22, r22) => {
        var n2 = r22(852)(r22(5639), "Promise");
        e22.exports = n2;
      },
      8525: (e22, t22, r22) => {
        var n2 = r22(852)(r22(5639), "Set");
        e22.exports = n2;
      },
      8668: (e22, t22, r22) => {
        var n2 = r22(3369), o2 = r22(619), i = r22(2385);
        function a(e3) {
          var t32 = -1, r3 = null == e3 ? 0 : e3.length;
          for (this.__data__ = new n2(); ++t32 < r3; )
            this.add(e3[t32]);
        }
        a.prototype.add = a.prototype.push = o2, a.prototype.has = i, e22.exports = a;
      },
      6384: (e22, t22, r22) => {
        var n2 = r22(8407), o2 = r22(7465), i = r22(3779), a = r22(7599), c2 = r22(4758), s = r22(4309);
        function l(e3) {
          var t32 = this.__data__ = new n2(e3);
          this.size = t32.size;
        }
        l.prototype.clear = o2, l.prototype.delete = i, l.prototype.get = a, l.prototype.has = c2, l.prototype.set = s, e22.exports = l;
      },
      2705: (e22, t22, r22) => {
        var n2 = r22(5639).Symbol;
        e22.exports = n2;
      },
      1149: (e22, t22, r22) => {
        var n2 = r22(5639).Uint8Array;
        e22.exports = n2;
      },
      577: (e22, t22, r22) => {
        var n2 = r22(852)(r22(5639), "WeakMap");
        e22.exports = n2;
      },
      4963: (e22) => {
        e22.exports = function(e3, t22) {
          for (var r22 = -1, n2 = null == e3 ? 0 : e3.length, o2 = 0, i = []; ++r22 < n2; ) {
            var a = e3[r22];
            t22(a, r22, e3) && (i[o2++] = a);
          }
          return i;
        };
      },
      4636: (e22, t22, r22) => {
        var n2 = r22(2545), o2 = r22(5694), i = r22(1469), a = r22(4144), c2 = r22(5776), s = r22(6719), l = Object.prototype.hasOwnProperty;
        e22.exports = function(e3, t32) {
          var r3 = i(e3), u = !r3 && o2(e3), p = !r3 && !u && a(e3), f2 = !r3 && !u && !p && s(e3), d = r3 || u || p || f2, h = d ? n2(e3.length, String) : [], y = h.length;
          for (var b in e3)
            !t32 && !l.call(e3, b) || d && ("length" == b || p && ("offset" == b || "parent" == b) || f2 && ("buffer" == b || "byteLength" == b || "byteOffset" == b) || c2(b, y)) || h.push(b);
          return h;
        };
      },
      2488: (e22) => {
        e22.exports = function(e3, t22) {
          for (var r22 = -1, n2 = t22.length, o2 = e3.length; ++r22 < n2; )
            e3[o2 + r22] = t22[r22];
          return e3;
        };
      },
      2908: (e22) => {
        e22.exports = function(e3, t22) {
          for (var r22 = -1, n2 = null == e3 ? 0 : e3.length; ++r22 < n2; )
            if (t22(e3[r22], r22, e3))
              return true;
          return false;
        };
      },
      8470: (e22, t22, r22) => {
        var n2 = r22(7813);
        e22.exports = function(e3, t32) {
          for (var r3 = e3.length; r3--; )
            if (n2(e3[r3][0], t32))
              return r3;
          return -1;
        };
      },
      8866: (e22, t22, r22) => {
        var n2 = r22(2488), o2 = r22(1469);
        e22.exports = function(e3, t32, r3) {
          var i = t32(e3);
          return o2(e3) ? i : n2(i, r3(e3));
        };
      },
      4239: (e22, t22, r22) => {
        var n2 = r22(2705), o2 = r22(9607), i = r22(2333), a = n2 ? n2.toStringTag : void 0;
        e22.exports = function(e3) {
          return null == e3 ? void 0 === e3 ? "[object Undefined]" : "[object Null]" : a && a in Object(e3) ? o2(e3) : i(e3);
        };
      },
      9454: (e22, t22, r22) => {
        var n2 = r22(4239), o2 = r22(7005);
        e22.exports = function(e3) {
          return o2(e3) && "[object Arguments]" == n2(e3);
        };
      },
      939: (e22, t22, r22) => {
        var n2 = r22(2492), o2 = r22(7005);
        e22.exports = function e3(t32, r3, i, a, c2) {
          return t32 === r3 || (null == t32 || null == r3 || !o2(t32) && !o2(r3) ? t32 != t32 && r3 != r3 : n2(t32, r3, i, a, e3, c2));
        };
      },
      2492: (e22, t22, r22) => {
        var n2 = r22(6384), o2 = r22(7114), i = r22(8351), a = r22(6096), c2 = r22(4160), s = r22(1469), l = r22(4144), u = r22(6719), p = "[object Arguments]", f2 = "[object Array]", d = "[object Object]", h = Object.prototype.hasOwnProperty;
        e22.exports = function(e3, t32, r3, y, b, v) {
          var g = s(e3), m = s(t32), x = g ? f2 : c2(e3), O = m ? f2 : c2(t32), k = (x = x == p ? d : x) == d, j = (O = O == p ? d : O) == d, _ = x == O;
          if (_ && l(e3)) {
            if (!l(t32))
              return false;
            g = true, k = false;
          }
          if (_ && !k)
            return v || (v = new n2()), g || u(e3) ? o2(e3, t32, r3, y, b, v) : i(e3, t32, x, r3, y, b, v);
          if (!(1 & r3)) {
            var w = k && h.call(e3, "__wrapped__"), C2 = j && h.call(t32, "__wrapped__");
            if (w || C2) {
              var P = w ? e3.value() : e3, E2 = C2 ? t32.value() : t32;
              return v || (v = new n2()), b(P, E2, r3, y, v);
            }
          }
          return !!_ && (v || (v = new n2()), a(e3, t32, r3, y, b, v));
        };
      },
      8458: (e22, t22, r22) => {
        var n2 = r22(3560), o2 = r22(5346), i = r22(3218), a = r22(346), c2 = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, f2 = RegExp("^" + u.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        e22.exports = function(e3) {
          return !(!i(e3) || o2(e3)) && (n2(e3) ? f2 : c2).test(a(e3));
        };
      },
      8749: (e22, t22, r22) => {
        var n2 = r22(4239), o2 = r22(1780), i = r22(7005), a = {};
        a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = true, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = false, e22.exports = function(e3) {
          return i(e3) && o2(e3.length) && !!a[n2(e3)];
        };
      },
      280: (e22, t22, r22) => {
        var n2 = r22(5726), o2 = r22(6916), i = Object.prototype.hasOwnProperty;
        e22.exports = function(e3) {
          if (!n2(e3))
            return o2(e3);
          var t32 = [];
          for (var r3 in Object(e3))
            i.call(e3, r3) && "constructor" != r3 && t32.push(r3);
          return t32;
        };
      },
      2545: (e22) => {
        e22.exports = function(e3, t22) {
          for (var r22 = -1, n2 = Array(e3); ++r22 < e3; )
            n2[r22] = t22(r22);
          return n2;
        };
      },
      1717: (e22) => {
        e22.exports = function(e3) {
          return function(t22) {
            return e3(t22);
          };
        };
      },
      4757: (e22) => {
        e22.exports = function(e3, t22) {
          return e3.has(t22);
        };
      },
      4429: (e22, t22, r22) => {
        var n2 = r22(5639)["__core-js_shared__"];
        e22.exports = n2;
      },
      7114: (e22, t22, r22) => {
        var n2 = r22(8668), o2 = r22(2908), i = r22(4757);
        e22.exports = function(e3, t32, r3, a, c2, s) {
          var l = 1 & r3, u = e3.length, p = t32.length;
          if (u != p && !(l && p > u))
            return false;
          var f2 = s.get(e3), d = s.get(t32);
          if (f2 && d)
            return f2 == t32 && d == e3;
          var h = -1, y = true, b = 2 & r3 ? new n2() : void 0;
          for (s.set(e3, t32), s.set(t32, e3); ++h < u; ) {
            var v = e3[h], g = t32[h];
            if (a)
              var m = l ? a(g, v, h, t32, e3, s) : a(v, g, h, e3, t32, s);
            if (void 0 !== m) {
              if (m)
                continue;
              y = false;
              break;
            }
            if (b) {
              if (!o2(t32, function(e4, t4) {
                if (!i(b, t4) && (v === e4 || c2(v, e4, r3, a, s)))
                  return b.push(t4);
              })) {
                y = false;
                break;
              }
            } else if (v !== g && !c2(v, g, r3, a, s)) {
              y = false;
              break;
            }
          }
          return s.delete(e3), s.delete(t32), y;
        };
      },
      8351: (e22, t22, r22) => {
        var n2 = r22(2705), o2 = r22(1149), i = r22(7813), a = r22(7114), c2 = r22(8776), s = r22(1814), l = n2 ? n2.prototype : void 0, u = l ? l.valueOf : void 0;
        e22.exports = function(e3, t32, r3, n3, l2, p, f2) {
          switch (r3) {
            case "[object DataView]":
              if (e3.byteLength != t32.byteLength || e3.byteOffset != t32.byteOffset)
                return false;
              e3 = e3.buffer, t32 = t32.buffer;
            case "[object ArrayBuffer]":
              return !(e3.byteLength != t32.byteLength || !p(new o2(e3), new o2(t32)));
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return i(+e3, +t32);
            case "[object Error]":
              return e3.name == t32.name && e3.message == t32.message;
            case "[object RegExp]":
            case "[object String]":
              return e3 == t32 + "";
            case "[object Map]":
              var d = c2;
            case "[object Set]":
              var h = 1 & n3;
              if (d || (d = s), e3.size != t32.size && !h)
                return false;
              var y = f2.get(e3);
              if (y)
                return y == t32;
              n3 |= 2, f2.set(e3, t32);
              var b = a(d(e3), d(t32), n3, l2, p, f2);
              return f2.delete(e3), b;
            case "[object Symbol]":
              if (u)
                return u.call(e3) == u.call(t32);
          }
          return false;
        };
      },
      6096: (e22, t22, r22) => {
        var n2 = r22(8234), o2 = Object.prototype.hasOwnProperty;
        e22.exports = function(e3, t32, r3, i, a, c2) {
          var s = 1 & r3, l = n2(e3), u = l.length;
          if (u != n2(t32).length && !s)
            return false;
          for (var p = u; p--; ) {
            var f2 = l[p];
            if (!(s ? f2 in t32 : o2.call(t32, f2)))
              return false;
          }
          var d = c2.get(e3), h = c2.get(t32);
          if (d && h)
            return d == t32 && h == e3;
          var y = true;
          c2.set(e3, t32), c2.set(t32, e3);
          for (var b = s; ++p < u; ) {
            var v = e3[f2 = l[p]], g = t32[f2];
            if (i)
              var m = s ? i(g, v, f2, t32, e3, c2) : i(v, g, f2, e3, t32, c2);
            if (!(void 0 === m ? v === g || a(v, g, r3, i, c2) : m)) {
              y = false;
              break;
            }
            b || (b = "constructor" == f2);
          }
          if (y && !b) {
            var x = e3.constructor, O = t32.constructor;
            x == O || !("constructor" in e3) || !("constructor" in t32) || "function" == typeof x && x instanceof x && "function" == typeof O && O instanceof O || (y = false);
          }
          return c2.delete(e3), c2.delete(t32), y;
        };
      },
      1957: (e22, t22, r22) => {
        var n2 = "object" == typeof r22.g && r22.g && r22.g.Object === Object && r22.g;
        e22.exports = n2;
      },
      8234: (e22, t22, r22) => {
        var n2 = r22(8866), o2 = r22(9551), i = r22(3674);
        e22.exports = function(e3) {
          return n2(e3, i, o2);
        };
      },
      5050: (e22, t22, r22) => {
        var n2 = r22(7019);
        e22.exports = function(e3, t32) {
          var r3 = e3.__data__;
          return n2(t32) ? r3["string" == typeof t32 ? "string" : "hash"] : r3.map;
        };
      },
      852: (e22, t22, r22) => {
        var n2 = r22(8458), o2 = r22(7801);
        e22.exports = function(e3, t32) {
          var r3 = o2(e3, t32);
          return n2(r3) ? r3 : void 0;
        };
      },
      9607: (e22, t22, r22) => {
        var n2 = r22(2705), o2 = Object.prototype, i = o2.hasOwnProperty, a = o2.toString, c2 = n2 ? n2.toStringTag : void 0;
        e22.exports = function(e3) {
          var t32 = i.call(e3, c2), r3 = e3[c2];
          try {
            e3[c2] = void 0;
            var n3 = true;
          } catch (e4) {
          }
          var o3 = a.call(e3);
          return n3 && (t32 ? e3[c2] = r3 : delete e3[c2]), o3;
        };
      },
      9551: (e22, t22, r22) => {
        var n2 = r22(4963), o2 = r22(479), i = Object.prototype.propertyIsEnumerable, a = Object.getOwnPropertySymbols, c2 = a ? function(e3) {
          return null == e3 ? [] : (e3 = Object(e3), n2(a(e3), function(t32) {
            return i.call(e3, t32);
          }));
        } : o2;
        e22.exports = c2;
      },
      4160: (e22, t22, r22) => {
        var n2 = r22(8552), o2 = r22(7071), i = r22(3818), a = r22(8525), c2 = r22(577), s = r22(4239), l = r22(346), u = "[object Map]", p = "[object Promise]", f2 = "[object Set]", d = "[object WeakMap]", h = "[object DataView]", y = l(n2), b = l(o2), v = l(i), g = l(a), m = l(c2), x = s;
        (n2 && x(new n2(new ArrayBuffer(1))) != h || o2 && x(new o2()) != u || i && x(i.resolve()) != p || a && x(new a()) != f2 || c2 && x(new c2()) != d) && (x = function(e3) {
          var t32 = s(e3), r3 = "[object Object]" == t32 ? e3.constructor : void 0, n3 = r3 ? l(r3) : "";
          if (n3)
            switch (n3) {
              case y:
                return h;
              case b:
                return u;
              case v:
                return p;
              case g:
                return f2;
              case m:
                return d;
            }
          return t32;
        }), e22.exports = x;
      },
      7801: (e22) => {
        e22.exports = function(e3, t22) {
          return null == e3 ? void 0 : e3[t22];
        };
      },
      1789: (e22, t22, r22) => {
        var n2 = r22(4536);
        e22.exports = function() {
          this.__data__ = n2 ? n2(null) : {}, this.size = 0;
        };
      },
      401: (e22) => {
        e22.exports = function(e3) {
          var t22 = this.has(e3) && delete this.__data__[e3];
          return this.size -= t22 ? 1 : 0, t22;
        };
      },
      7667: (e22, t22, r22) => {
        var n2 = r22(4536), o2 = Object.prototype.hasOwnProperty;
        e22.exports = function(e3) {
          var t32 = this.__data__;
          if (n2) {
            var r3 = t32[e3];
            return "__lodash_hash_undefined__" === r3 ? void 0 : r3;
          }
          return o2.call(t32, e3) ? t32[e3] : void 0;
        };
      },
      1327: (e22, t22, r22) => {
        var n2 = r22(4536), o2 = Object.prototype.hasOwnProperty;
        e22.exports = function(e3) {
          var t32 = this.__data__;
          return n2 ? void 0 !== t32[e3] : o2.call(t32, e3);
        };
      },
      1866: (e22, t22, r22) => {
        var n2 = r22(4536);
        e22.exports = function(e3, t32) {
          var r3 = this.__data__;
          return this.size += this.has(e3) ? 0 : 1, r3[e3] = n2 && void 0 === t32 ? "__lodash_hash_undefined__" : t32, this;
        };
      },
      5776: (e22) => {
        var t22 = /^(?:0|[1-9]\d*)$/;
        e22.exports = function(e3, r22) {
          var n2 = typeof e3;
          return !!(r22 = null == r22 ? 9007199254740991 : r22) && ("number" == n2 || "symbol" != n2 && t22.test(e3)) && e3 > -1 && e3 % 1 == 0 && e3 < r22;
        };
      },
      7019: (e22) => {
        e22.exports = function(e3) {
          var t22 = typeof e3;
          return "string" == t22 || "number" == t22 || "symbol" == t22 || "boolean" == t22 ? "__proto__" !== e3 : null === e3;
        };
      },
      5346: (e22, t22, r22) => {
        var n2, o2 = r22(4429), i = (n2 = /[^.]+$/.exec(o2 && o2.keys && o2.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n2 : "";
        e22.exports = function(e3) {
          return !!i && i in e3;
        };
      },
      5726: (e22) => {
        var t22 = Object.prototype;
        e22.exports = function(e3) {
          var r22 = e3 && e3.constructor;
          return e3 === ("function" == typeof r22 && r22.prototype || t22);
        };
      },
      7040: (e22) => {
        e22.exports = function() {
          this.__data__ = [], this.size = 0;
        };
      },
      4125: (e22, t22, r22) => {
        var n2 = r22(8470), o2 = Array.prototype.splice;
        e22.exports = function(e3) {
          var t32 = this.__data__, r3 = n2(t32, e3);
          return !(r3 < 0 || (r3 == t32.length - 1 ? t32.pop() : o2.call(t32, r3, 1), --this.size, 0));
        };
      },
      2117: (e22, t22, r22) => {
        var n2 = r22(8470);
        e22.exports = function(e3) {
          var t32 = this.__data__, r3 = n2(t32, e3);
          return r3 < 0 ? void 0 : t32[r3][1];
        };
      },
      7518: (e22, t22, r22) => {
        var n2 = r22(8470);
        e22.exports = function(e3) {
          return n2(this.__data__, e3) > -1;
        };
      },
      4705: (e22, t22, r22) => {
        var n2 = r22(8470);
        e22.exports = function(e3, t32) {
          var r3 = this.__data__, o2 = n2(r3, e3);
          return o2 < 0 ? (++this.size, r3.push([e3, t32])) : r3[o2][1] = t32, this;
        };
      },
      4785: (e22, t22, r22) => {
        var n2 = r22(1989), o2 = r22(8407), i = r22(7071);
        e22.exports = function() {
          this.size = 0, this.__data__ = {
            hash: new n2(),
            map: new (i || o2)(),
            string: new n2()
          };
        };
      },
      1285: (e22, t22, r22) => {
        var n2 = r22(5050);
        e22.exports = function(e3) {
          var t32 = n2(this, e3).delete(e3);
          return this.size -= t32 ? 1 : 0, t32;
        };
      },
      6e3: (e22, t22, r22) => {
        var n2 = r22(5050);
        e22.exports = function(e3) {
          return n2(this, e3).get(e3);
        };
      },
      9916: (e22, t22, r22) => {
        var n2 = r22(5050);
        e22.exports = function(e3) {
          return n2(this, e3).has(e3);
        };
      },
      5265: (e22, t22, r22) => {
        var n2 = r22(5050);
        e22.exports = function(e3, t32) {
          var r3 = n2(this, e3), o2 = r3.size;
          return r3.set(e3, t32), this.size += r3.size == o2 ? 0 : 1, this;
        };
      },
      8776: (e22) => {
        e22.exports = function(e3) {
          var t22 = -1, r22 = Array(e3.size);
          return e3.forEach(function(e4, n2) {
            r22[++t22] = [n2, e4];
          }), r22;
        };
      },
      4536: (e22, t22, r22) => {
        var n2 = r22(852)(Object, "create");
        e22.exports = n2;
      },
      6916: (e22, t22, r22) => {
        var n2 = r22(5569)(Object.keys, Object);
        e22.exports = n2;
      },
      1167: (e22, t22, r22) => {
        e22 = r22.nmd(e22);
        var n2 = r22(1957), o2 = t22 && !t22.nodeType && t22, i = o2 && e22 && !e22.nodeType && e22, a = i && i.exports === o2 && n2.process, c2 = function() {
          try {
            return i && i.require && i.require("util").types || a && a.binding && a.binding("util");
          } catch (e3) {
          }
        }();
        e22.exports = c2;
      },
      2333: (e22) => {
        var t22 = Object.prototype.toString;
        e22.exports = function(e3) {
          return t22.call(e3);
        };
      },
      5569: (e22) => {
        e22.exports = function(e3, t22) {
          return function(r22) {
            return e3(t22(r22));
          };
        };
      },
      5639: (e22, t22, r22) => {
        var n2 = r22(1957), o2 = "object" == typeof self && self && self.Object === Object && self, i = n2 || o2 || Function("return this")();
        e22.exports = i;
      },
      619: (e22) => {
        e22.exports = function(e3) {
          return this.__data__.set(e3, "__lodash_hash_undefined__"), this;
        };
      },
      2385: (e22) => {
        e22.exports = function(e3) {
          return this.__data__.has(e3);
        };
      },
      1814: (e22) => {
        e22.exports = function(e3) {
          var t22 = -1, r22 = Array(e3.size);
          return e3.forEach(function(e4) {
            r22[++t22] = e4;
          }), r22;
        };
      },
      7465: (e22, t22, r22) => {
        var n2 = r22(8407);
        e22.exports = function() {
          this.__data__ = new n2(), this.size = 0;
        };
      },
      3779: (e22) => {
        e22.exports = function(e3) {
          var t22 = this.__data__, r22 = t22.delete(e3);
          return this.size = t22.size, r22;
        };
      },
      7599: (e22) => {
        e22.exports = function(e3) {
          return this.__data__.get(e3);
        };
      },
      4758: (e22) => {
        e22.exports = function(e3) {
          return this.__data__.has(e3);
        };
      },
      4309: (e22, t22, r22) => {
        var n2 = r22(8407), o2 = r22(7071), i = r22(3369);
        e22.exports = function(e3, t32) {
          var r3 = this.__data__;
          if (r3 instanceof n2) {
            var a = r3.__data__;
            if (!o2 || a.length < 199)
              return a.push([e3, t32]), this.size = ++r3.size, this;
            r3 = this.__data__ = new i(a);
          }
          return r3.set(e3, t32), this.size = r3.size, this;
        };
      },
      346: (e22) => {
        var t22 = Function.prototype.toString;
        e22.exports = function(e3) {
          if (null != e3) {
            try {
              return t22.call(e3);
            } catch (e4) {
            }
            try {
              return e3 + "";
            } catch (e4) {
            }
          }
          return "";
        };
      },
      7813: (e22) => {
        e22.exports = function(e3, t22) {
          return e3 === t22 || e3 != e3 && t22 != t22;
        };
      },
      5694: (e22, t22, r22) => {
        var n2 = r22(9454), o2 = r22(7005), i = Object.prototype, a = i.hasOwnProperty, c2 = i.propertyIsEnumerable, s = n2(/* @__PURE__ */ function() {
          return arguments;
        }()) ? n2 : function(e3) {
          return o2(e3) && a.call(e3, "callee") && !c2.call(e3, "callee");
        };
        e22.exports = s;
      },
      1469: (e22) => {
        var t22 = Array.isArray;
        e22.exports = t22;
      },
      8612: (e22, t22, r22) => {
        var n2 = r22(3560), o2 = r22(1780);
        e22.exports = function(e3) {
          return null != e3 && o2(e3.length) && !n2(e3);
        };
      },
      4144: (e22, t22, r22) => {
        e22 = r22.nmd(e22);
        var n2 = r22(5639), o2 = r22(5062), i = t22 && !t22.nodeType && t22, a = i && e22 && !e22.nodeType && e22, c2 = a && a.exports === i ? n2.Buffer : void 0, s = (c2 ? c2.isBuffer : void 0) || o2;
        e22.exports = s;
      },
      8446: (e22, t22, r22) => {
        var n2 = r22(939);
        e22.exports = function(e3, t32) {
          return n2(e3, t32);
        };
      },
      3560: (e22, t22, r22) => {
        var n2 = r22(4239), o2 = r22(3218);
        e22.exports = function(e3) {
          if (!o2(e3))
            return false;
          var t32 = n2(e3);
          return "[object Function]" == t32 || "[object GeneratorFunction]" == t32 || "[object AsyncFunction]" == t32 || "[object Proxy]" == t32;
        };
      },
      1780: (e22) => {
        e22.exports = function(e3) {
          return "number" == typeof e3 && e3 > -1 && e3 % 1 == 0 && e3 <= 9007199254740991;
        };
      },
      3218: (e22) => {
        e22.exports = function(e3) {
          var t22 = typeof e3;
          return null != e3 && ("object" == t22 || "function" == t22);
        };
      },
      7005: (e22) => {
        e22.exports = function(e3) {
          return null != e3 && "object" == typeof e3;
        };
      },
      6719: (e22, t22, r22) => {
        var n2 = r22(8749), o2 = r22(1717), i = r22(1167), a = i && i.isTypedArray, c2 = a ? o2(a) : n2;
        e22.exports = c2;
      },
      3674: (e22, t22, r22) => {
        var n2 = r22(4636), o2 = r22(280), i = r22(8612);
        e22.exports = function(e3) {
          return i(e3) ? n2(e3) : o2(e3);
        };
      },
      8306: (e22, t22, r22) => {
        var n2 = r22(3369);
        function o2(e3, t32) {
          if ("function" != typeof e3 || null != t32 && "function" != typeof t32)
            throw new TypeError("Expected a function");
          var r3 = function() {
            var n3 = arguments, o3 = t32 ? t32.apply(this, n3) : n3[0], i = r3.cache;
            if (i.has(o3))
              return i.get(o3);
            var a = e3.apply(this, n3);
            return r3.cache = i.set(o3, a) || i, a;
          };
          return r3.cache = new (o2.Cache || n2)(), r3;
        }
        o2.Cache = n2, e22.exports = o2;
      },
      479: (e22) => {
        e22.exports = function() {
          return [];
        };
      },
      5062: (e22) => {
        e22.exports = function() {
          return false;
        };
      },
      2703: (e22, t22, r22) => {
        var n2 = r22(414);
        function o2() {
        }
        function i() {
        }
        i.resetWarningCache = o2, e22.exports = function() {
          function e3(e4, t4, r4, o3, i2, a) {
            if (a !== n2) {
              var c2 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw c2.name = "Invariant Violation", c2;
            }
          }
          function t32() {
            return e3;
          }
          e3.isRequired = e3;
          var r3 = {
            array: e3,
            bigint: e3,
            bool: e3,
            func: e3,
            number: e3,
            object: e3,
            string: e3,
            symbol: e3,
            any: e3,
            arrayOf: t32,
            element: e3,
            elementType: e3,
            instanceOf: t32,
            node: e3,
            objectOf: t32,
            oneOf: t32,
            oneOfType: t32,
            shape: t32,
            exact: t32,
            checkPropTypes: i,
            resetWarningCache: o2
          };
          return r3.PropTypes = r3, r3;
        };
      },
      5697: (e22, t22, r22) => {
        e22.exports = r22(2703)();
      },
      414: (e22) => {
        e22.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      9787: (t22) => {
        t22.exports = e;
      }
    }, r2 = {};
    function n(e22) {
      var o2 = r2[e22];
      if (void 0 !== o2)
        return o2.exports;
      var i = r2[e22] = {
        id: e22,
        loaded: false,
        exports: {}
      };
      return t[e22](i, i.exports, n), i.loaded = true, i.exports;
    }
    n.n = (e22) => {
      var t22 = e22 && e22.__esModule ? () => e22.default : () => e22;
      return n.d(t22, {
        a: t22
      }), t22;
    }, n.d = (e22, t22) => {
      for (var r22 in t22)
        n.o(t22, r22) && !n.o(e22, r22) && Object.defineProperty(e22, r22, {
          enumerable: true,
          get: t22[r22]
        });
    }, n.g = function() {
      if ("object" == typeof globalThis)
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e22) {
        if ("object" == typeof window)
          return window;
      }
    }(), n.o = (e22, t22) => Object.prototype.hasOwnProperty.call(e22, t22), n.r = (e22) => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e22, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e22, "__esModule", {
        value: true
      });
    }, n.nmd = (e22) => (e22.paths = [], e22.children || (e22.children = []), e22);
    var o = {};
    return (() => {
      n.r(o), n.d(o, {
        default: () => xe,
        expandNodesToLevel: () => me
      });
      var e22 = n(4184), t22 = n.n(e22), r22 = n(8446), i = n.n(r22), a = n(8306), c2 = n.n(a);
      let s = (e3 = 21) => crypto.getRandomValues(new Uint8Array(e3)).reduce((e4, t32) => e4 + ((t32 &= 63) < 36 ? t32.toString(36) : t32 < 62 ? (t32 - 26).toString(36).toUpperCase() : t32 > 62 ? "-" : "_"), "");
      var l = n(5697), u = n.n(l), p = n(9787), f2 = n.n(p);
      function d(e3) {
        return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
          return typeof e4;
        } : function(e4) {
          return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
        }, d(e3);
      }
      var h = ["children", "title"];
      function y() {
        return y = Object.assign ? Object.assign.bind() : function(e3) {
          for (var t32 = 1; t32 < arguments.length; t32++) {
            var r3 = arguments[t32];
            for (var n2 in r3)
              Object.prototype.hasOwnProperty.call(r3, n2) && (e3[n2] = r3[n2]);
          }
          return e3;
        }, y.apply(this, arguments);
      }
      function b(e3, t32) {
        if (!(e3 instanceof t32))
          throw new TypeError("Cannot call a class as a function");
      }
      function v(e3, t32) {
        for (var r3 = 0; r3 < t32.length; r3++) {
          var n2 = t32[r3];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
        }
      }
      function g(e3, t32) {
        return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
          return e4.__proto__ = t4, e4;
        }, g(e3, t32);
      }
      function m(e3, t32) {
        if (t32 && ("object" === d(t32) || "function" == typeof t32))
          return t32;
        if (void 0 !== t32)
          throw new TypeError("Derived constructors may only return object or undefined");
        return function(e4) {
          if (void 0 === e4)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e4;
        }(e3);
      }
      function x(e3) {
        return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
          return e4.__proto__ || Object.getPrototypeOf(e4);
        }, x(e3);
      }
      function O(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      var k = function(e3) {
        !function(e4, t4) {
          if ("function" != typeof t4 && null !== t4)
            throw new TypeError("Super expression must either be null or a function");
          e4.prototype = Object.create(t4 && t4.prototype, {
            constructor: {
              value: e4,
              writable: true,
              configurable: true
            }
          }), Object.defineProperty(e4, "prototype", {
            writable: false
          }), t4 && g(e4, t4);
        }(a2, e3);
        var t32, r3, n2, o2, i2 = (n2 = a2, o2 = function() {
          if ("undefined" == typeof Reflect || !Reflect.construct)
            return false;
          if (Reflect.construct.sham)
            return false;
          if ("function" == typeof Proxy)
            return true;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), true;
          } catch (e4) {
            return false;
          }
        }(), function() {
          var e4, t4 = x(n2);
          if (o2) {
            var r4 = x(this).constructor;
            e4 = Reflect.construct(t4, arguments, r4);
          } else
            e4 = t4.apply(this, arguments);
          return m(this, e4);
        });
        function a2() {
          return b(this, a2), i2.apply(this, arguments);
        }
        return t32 = a2, (r3 = [{
          key: "render",
          value: function() {
            var e4 = this.props, t4 = e4.children, r4 = e4.title, n3 = function(e52, t5) {
              if (null == e52)
                return {};
              var r5, n4, o3 = function(e6, t6) {
                if (null == e6)
                  return {};
                var r6, n5, o4 = {}, i4 = Object.keys(e6);
                for (n5 = 0; n5 < i4.length; n5++)
                  r6 = i4[n5], t6.indexOf(r6) >= 0 || (o4[r6] = e6[r6]);
                return o4;
              }(e52, t5);
              if (Object.getOwnPropertySymbols) {
                var i3 = Object.getOwnPropertySymbols(e52);
                for (n4 = 0; n4 < i3.length; n4++)
                  r5 = i3[n4], t5.indexOf(r5) >= 0 || Object.prototype.propertyIsEnumerable.call(e52, r5) && (o3[r5] = e52[r5]);
              }
              return o3;
            }(e4, h);
            return f2().createElement("button", y({
              "aria-label": r4,
              title: r4,
              type: "button"
            }, n3), t4);
          }
        }]) && v(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
          writable: false
        }), a2;
      }(f2().PureComponent);
      O(k, "propTypes", {
        children: u().node.isRequired,
        title: u().string
      }), O(k, "defaultProps", {
        title: null
      });
      const j = k, _ = {
        ALL: "all",
        PARENT: "parent",
        LEAF: "leaf"
      };
      function w(e3) {
        this.message = e3, this.stack = Error().stack;
      }
      w.prototype = Object.create(Error.prototype), w.prototype.name = "CheckboxTreeError";
      const C2 = w;
      function P(e3, t32) {
        var r3 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e3);
          t32 && (n2 = n2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), r3.push.apply(r3, n2);
        }
        return r3;
      }
      function E2(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      function N(e3, t32) {
        if (!(e3 instanceof t32))
          throw new TypeError("Cannot call a class as a function");
      }
      function A5(e3, t32) {
        for (var r3 = 0; r3 < t32.length; r3++) {
          var n2 = t32[r3];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
        }
      }
      var S = _;
      const T = function() {
        function e3(t4) {
          var r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          N(this, e3), this.props = t4, this.flatNodes = r4;
        }
        var t32, r3;
        return t32 = e3, r3 = [{
          key: "setProps",
          value: function(e4) {
            this.props = e4;
          }
        }, {
          key: "clone",
          value: function() {
            var t4 = this, r4 = {};
            return Object.keys(this.flatNodes).forEach(function(e4) {
              var n2 = t4.flatNodes[e4];
              r4[e4] = function(e52) {
                for (var t5 = 1; t5 < arguments.length; t5++) {
                  var r5 = null != arguments[t5] ? arguments[t5] : {};
                  t5 % 2 ? P(Object(r5), true).forEach(function(t6) {
                    E2(e52, t6, r5[t6]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e52, Object.getOwnPropertyDescriptors(r5)) : P(Object(r5)).forEach(function(t6) {
                    Object.defineProperty(e52, t6, Object.getOwnPropertyDescriptor(r5, t6));
                  });
                }
                return e52;
              }({}, n2);
            }), new e3(this.props, r4);
          }
        }, {
          key: "getNode",
          value: function(e4) {
            return this.flatNodes[e4];
          }
        }, {
          key: "reset",
          value: function() {
            this.flatNodes = {};
          }
        }, {
          key: "flattenNodes",
          value: function(e4) {
            var t4 = this, r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            if (Array.isArray(e4) && 0 !== e4.length) {
              var o2 = this.props, i2 = o2.disabled, a2 = o2.noCascade;
              e4.forEach(function(e52, o3) {
                var c22 = t4.nodeHasChildren(e52);
                if (void 0 !== t4.flatNodes[e52.value])
                  throw new C2("Duplicate value '".concat(e52.value, "' detected. All node values must be unique."));
                t4.flatNodes[e52.value] = {
                  label: e52.label,
                  value: e52.value,
                  children: e52.children,
                  parent: r4,
                  isChild: void 0 !== r4.value,
                  isParent: c22,
                  isLeaf: !c22,
                  showCheckbox: void 0 === e52.showCheckbox || e52.showCheckbox,
                  disabled: t4.getDisabledState(e52, r4, i2, a2),
                  treeDepth: n2,
                  index: o3
                }, t4.flattenNodes(e52.children, e52, n2 + 1);
              });
            }
          }
        }, {
          key: "nodeHasChildren",
          value: function(e4) {
            return Array.isArray(e4.children);
          }
        }, {
          key: "getDisabledState",
          value: function(e4, t4, r4, n2) {
            return !!r4 || !(n2 || !t4.disabled) || Boolean(e4.disabled);
          }
        }, {
          key: "deserializeLists",
          value: function(e4) {
            var t4 = this, r4 = ["checked", "expanded"];
            Object.keys(this.flatNodes).forEach(function(e52) {
              r4.forEach(function(r5) {
                t4.flatNodes[e52][r5] = false;
              });
            }), r4.forEach(function(r5) {
              e4[r5].forEach(function(e52) {
                void 0 !== t4.flatNodes[e52] && (t4.flatNodes[e52][r5] = true);
              });
            });
          }
        }, {
          key: "serializeList",
          value: function(e4) {
            var t4 = this, r4 = [];
            return Object.keys(this.flatNodes).forEach(function(n2) {
              t4.flatNodes[n2][e4] && r4.push(n2);
            }), r4;
          }
        }, {
          key: "expandAllNodes",
          value: function(e4) {
            var t4 = this;
            return Object.keys(this.flatNodes).forEach(function(r4) {
              t4.flatNodes[r4].isParent && (t4.flatNodes[r4].expanded = e4);
            }), this;
          }
        }, {
          key: "toggleChecked",
          value: function(e4, t4, r4, n2) {
            var o2 = this, i2 = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], a2 = this.flatNodes[e4.value], c22 = [S.PARENT, S.ALL].indexOf(r4) > -1, s2 = [S.LEAF, S.ALL].indexOf(r4) > -1;
            if (a2.isLeaf || n2) {
              if (e4.disabled)
                return this;
              this.toggleNode(e4.value, "checked", t4);
            } else
              (c22 || 0 === a2.children.length) && this.toggleNode(e4.value, "checked", t4), s2 && a2.children.forEach(function(e52) {
                o2.toggleChecked(e52, t4, r4, n2, false);
              });
            return i2 && !n2 && a2.isChild && c22 && this.toggleParentStatus(a2.parent, r4), this;
          }
        }, {
          key: "toggleParentStatus",
          value: function(e4, t4) {
            var r4 = this.flatNodes[e4.value];
            r4.isChild ? (t4 === S.ALL && this.toggleNode(e4.value, "checked", this.isEveryChildChecked(r4)), this.toggleParentStatus(r4.parent, t4)) : this.toggleNode(e4.value, "checked", this.isEveryChildChecked(r4));
          }
        }, {
          key: "isEveryChildChecked",
          value: function(e4) {
            var t4 = this;
            return e4.children.every(function(e52) {
              return t4.getNode(e52.value).checked;
            });
          }
        }, {
          key: "toggleNode",
          value: function(e4, t4, r4) {
            return this.flatNodes[e4][t4] = r4, this;
          }
        }], r3 && A5(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
          writable: false
        }), e3;
      }();
      function R(e3) {
        return R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
          return typeof e4;
        } : function(e4) {
          return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
        }, R(e3);
      }
      function L() {
        return L = Object.assign ? Object.assign.bind() : function(e3) {
          for (var t32 = 1; t32 < arguments.length; t32++) {
            var r3 = arguments[t32];
            for (var n2 in r3)
              Object.prototype.hasOwnProperty.call(r3, n2) && (e3[n2] = r3[n2]);
          }
          return e3;
        }, L.apply(this, arguments);
      }
      function D2(e3, t32) {
        var r3 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e3);
          t32 && (n2 = n2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), r3.push.apply(r3, n2);
        }
        return r3;
      }
      function I(e3, t32) {
        if (!(e3 instanceof t32))
          throw new TypeError("Cannot call a class as a function");
      }
      function z(e3, t32) {
        for (var r3 = 0; r3 < t32.length; r3++) {
          var n2 = t32[r3];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
        }
      }
      function q(e3, t32) {
        return q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
          return e4.__proto__ = t4, e4;
        }, q(e3, t32);
      }
      function B2(e3, t32) {
        if (t32 && ("object" === R(t32) || "function" == typeof t32))
          return t32;
        if (void 0 !== t32)
          throw new TypeError("Derived constructors may only return object or undefined");
        return function(e4) {
          if (void 0 === e4)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e4;
        }(e3);
      }
      function F(e3) {
        return F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
          return e4.__proto__ || Object.getPrototypeOf(e4);
        }, F(e3);
      }
      function M2(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      var U = function(e3) {
        !function(e4, t4) {
          if ("function" != typeof t4 && null !== t4)
            throw new TypeError("Super expression must either be null or a function");
          e4.prototype = Object.create(t4 && t4.prototype, {
            constructor: {
              value: e4,
              writable: true,
              configurable: true
            }
          }), Object.defineProperty(e4, "prototype", {
            writable: false
          }), t4 && q(e4, t4);
        }(a2, e3);
        var t32, r3, n2, o2, i2 = (n2 = a2, o2 = function() {
          if ("undefined" == typeof Reflect || !Reflect.construct)
            return false;
          if (Reflect.construct.sham)
            return false;
          if ("function" == typeof Proxy)
            return true;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), true;
          } catch (e4) {
            return false;
          }
        }(), function() {
          var e4, t4 = F(n2);
          if (o2) {
            var r4 = F(this).constructor;
            e4 = Reflect.construct(t4, arguments, r4);
          } else
            e4 = t4.apply(this, arguments);
          return B2(this, e4);
        });
        function a2() {
          return I(this, a2), i2.apply(this, arguments);
        }
        return t32 = a2, r3 = [{
          key: "componentDidMount",
          value: function() {
            this.updateDeterminateProperty();
          }
        }, {
          key: "componentDidUpdate",
          value: function() {
            this.updateDeterminateProperty();
          }
        }, {
          key: "updateDeterminateProperty",
          value: function() {
            var e4 = this.props.indeterminate;
            this.checkbox.indeterminate = e4;
          }
        }, {
          key: "render",
          value: function() {
            var e4 = this, t4 = function(e52) {
              for (var t5 = 1; t5 < arguments.length; t5++) {
                var r4 = null != arguments[t5] ? arguments[t5] : {};
                t5 % 2 ? D2(Object(r4), true).forEach(function(t6) {
                  M2(e52, t6, r4[t6]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e52, Object.getOwnPropertyDescriptors(r4)) : D2(Object(r4)).forEach(function(t6) {
                  Object.defineProperty(e52, t6, Object.getOwnPropertyDescriptor(r4, t6));
                });
              }
              return e52;
            }({}, this.props);
            return delete t4.indeterminate, f2().createElement("input", L({}, t4, {
              ref: function(t5) {
                e4.checkbox = t5;
              },
              type: "checkbox"
            }));
          }
        }], r3 && z(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
          writable: false
        }), a2;
      }(f2().PureComponent);
      M2(U, "propTypes", {
        indeterminate: u().bool
      }), M2(U, "defaultProps", {
        indeterminate: false
      });
      const K2 = U, H = u().shape({
        check: u().node,
        uncheck: u().node,
        halfCheck: u().node,
        expandClose: u().node,
        expandOpen: u().node,
        expandAll: u().node,
        collapseAll: u().node,
        parentClose: u().node,
        parentOpen: u().node,
        leaf: u().node
      }), $ = u().shape({
        collapseAll: u().string.isRequired,
        expandAll: u().string.isRequired,
        toggle: u().string.isRequired
      });
      function V(e3) {
        return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
          return typeof e4;
        } : function(e4) {
          return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
        }, V(e3);
      }
      function W(e3, t32) {
        for (var r3 = 0; r3 < t32.length; r3++) {
          var n2 = t32[r3];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
        }
      }
      function J(e3, t32) {
        return J = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
          return e4.__proto__ = t4, e4;
        }, J(e3, t32);
      }
      function G(e3, t32) {
        if (t32 && ("object" === V(t32) || "function" == typeof t32))
          return t32;
        if (void 0 !== t32)
          throw new TypeError("Derived constructors may only return object or undefined");
        return Y3(e3);
      }
      function Y3(e3) {
        if (void 0 === e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e3;
      }
      function Q(e3) {
        return Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
          return e4.__proto__ || Object.getPrototypeOf(e4);
        }, Q(e3);
      }
      function X3(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      var Z = function(e3) {
        !function(e4, t32) {
          if ("function" != typeof t32 && null !== t32)
            throw new TypeError("Super expression must either be null or a function");
          e4.prototype = Object.create(t32 && t32.prototype, {
            constructor: {
              value: e4,
              writable: true,
              configurable: true
            }
          }), Object.defineProperty(e4, "prototype", {
            writable: false
          }), t32 && J(e4, t32);
        }(c22, e3);
        var r3, n2, o2, i2, a2 = (o2 = c22, i2 = function() {
          if ("undefined" == typeof Reflect || !Reflect.construct)
            return false;
          if (Reflect.construct.sham)
            return false;
          if ("function" == typeof Proxy)
            return true;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), true;
          } catch (e4) {
            return false;
          }
        }(), function() {
          var e4, t32 = Q(o2);
          if (i2) {
            var r4 = Q(this).constructor;
            e4 = Reflect.construct(t32, arguments, r4);
          } else
            e4 = t32.apply(this, arguments);
          return G(this, e4);
        });
        function c22(e4) {
          var t32;
          return function(e52, t4) {
            if (!(e52 instanceof t4))
              throw new TypeError("Cannot call a class as a function");
          }(this, c22), (t32 = a2.call(this, e4)).onCheck = t32.onCheck.bind(Y3(t32)), t32.onCheckboxKeyPress = t32.onCheckboxKeyPress.bind(Y3(t32)), t32.onCheckboxKeyUp = t32.onCheckboxKeyUp.bind(Y3(t32)), t32.onClick = t32.onClick.bind(Y3(t32)), t32.onExpand = t32.onExpand.bind(Y3(t32)), t32;
        }
        return r3 = c22, (n2 = [{
          key: "onCheck",
          value: function() {
            var e4 = this.props, t32 = e4.value;
            (0, e4.onCheck)({
              value: t32,
              checked: this.getCheckState({
                toggle: true
              })
            });
          }
        }, {
          key: "onCheckboxKeyPress",
          value: function(e4) {
            32 === e4.which && e4.preventDefault();
          }
        }, {
          key: "onCheckboxKeyUp",
          value: function(e4) {
            var t32 = e4.keyCode;
            [13, 32].includes(t32) && this.onCheck();
          }
        }, {
          key: "onClick",
          value: function() {
            var e4 = this.props, t32 = e4.expandOnClick, r4 = e4.isParent, n3 = e4.value, o3 = e4.onClick;
            r4 && t32 && this.onExpand(), o3({
              value: n3,
              checked: this.getCheckState({
                toggle: false
              })
            });
          }
        }, {
          key: "onExpand",
          value: function() {
            var e4 = this.props, t32 = e4.expanded, r4 = e4.value;
            (0, e4.onExpand)({
              value: r4,
              expanded: !t32
            });
          }
        }, {
          key: "getCheckState",
          value: function(e4) {
            var t32 = e4.toggle, r4 = this.props, n3 = r4.checked, o3 = r4.optimisticToggle;
            return !(0 !== n3 || !t32) || 1 === n3 && !t32 || 2 === n3 && o3;
          }
        }, {
          key: "renderCollapseButton",
          value: function() {
            var e4 = this.props, t32 = e4.expandDisabled, r4 = e4.isLeaf, n3 = e4.lang;
            return r4 ? f2().createElement("span", {
              className: "rct-collapse"
            }, f2().createElement("span", {
              className: "rct-icon"
            })) : f2().createElement(j, {
              className: "rct-collapse rct-collapse-btn",
              disabled: t32,
              title: n3.toggle,
              onClick: this.onExpand
            }, this.renderCollapseIcon());
          }
        }, {
          key: "renderCollapseIcon",
          value: function() {
            var e4 = this.props, t32 = e4.expanded, r4 = e4.icons, n3 = r4.expandClose, o3 = r4.expandOpen;
            return t32 ? o3 : n3;
          }
        }, {
          key: "renderCheckboxIcon",
          value: function() {
            var e4 = this.props, t32 = e4.checked, r4 = e4.icons, n3 = r4.uncheck, o3 = r4.check, i3 = r4.halfCheck;
            return 0 === t32 ? n3 : 1 === t32 ? o3 : i3;
          }
        }, {
          key: "renderNodeIcon",
          value: function() {
            var e4 = this.props, t32 = e4.expanded, r4 = e4.icon, n3 = e4.icons, o3 = n3.leaf, i3 = n3.parentClose, a3 = n3.parentOpen, c3 = e4.isLeaf;
            return null !== r4 ? r4 : c3 ? o3 : t32 ? a3 : i3;
          }
        }, {
          key: "renderBareLabel",
          value: function(e4) {
            var t32 = this.props, r4 = t32.onClick, n3 = t32.title, o3 = null !== r4;
            return f2().createElement("span", {
              className: "rct-bare-label",
              title: n3
            }, o3 ? f2().createElement("span", {
              className: "rct-node-clickable",
              onClick: this.onClick,
              onKeyPress: this.onClick,
              role: "button",
              tabIndex: 0
            }, e4) : e4);
          }
        }, {
          key: "renderCheckboxLabel",
          value: function(e4) {
            var t32 = this.props, r4 = t32.checked, n3 = t32.disabled, o3 = t32.title, i3 = t32.treeId, a3 = t32.value, c3 = null !== t32.onClick, s2 = "".concat(i3, "-").concat(String(a3).split(" ").join("_")), l2 = [f2().createElement("label", {
              key: 0,
              htmlFor: s2,
              title: o3
            }, f2().createElement(K2, {
              checked: 1 === r4,
              disabled: n3,
              id: s2,
              indeterminate: 2 === r4,
              onClick: this.onCheck,
              onChange: function() {
              }
            }), f2().createElement("span", {
              "aria-checked": 1 === r4,
              "aria-disabled": n3,
              className: "rct-checkbox",
              role: "checkbox",
              tabIndex: 0,
              onKeyPress: this.onCheckboxKeyPress,
              onKeyUp: this.onCheckboxKeyUp
            }, this.renderCheckboxIcon()), c3 ? null : e4)];
            return c3 && l2.push(f2().createElement("span", {
              key: 1,
              className: "rct-node-clickable",
              onClick: this.onClick,
              onKeyPress: this.onClick,
              role: "link",
              tabIndex: 0
            }, e4)), l2;
          }
        }, {
          key: "renderLabel",
          value: function() {
            var e4 = this.props, t32 = e4.label, r4 = e4.showCheckbox, n3 = [e4.showNodeIcon ? f2().createElement("span", {
              key: 0,
              className: "rct-node-icon"
            }, this.renderNodeIcon()) : null, f2().createElement("span", {
              key: 1,
              className: "rct-title"
            }, t32)];
            return r4 ? this.renderCheckboxLabel(n3) : this.renderBareLabel(n3);
          }
        }, {
          key: "renderChildren",
          value: function() {
            return this.props.expanded ? this.props.children : null;
          }
        }, {
          key: "render",
          value: function() {
            var e4 = this.props, r4 = e4.className, n3 = e4.disabled, o3 = e4.expanded, i3 = e4.isLeaf, a3 = t22()({
              "rct-node": true,
              "rct-node-leaf": i3,
              "rct-node-parent": !i3,
              "rct-node-expanded": !i3 && o3,
              "rct-node-collapsed": !i3 && !o3,
              "rct-disabled": n3
            }, r4);
            return f2().createElement("li", {
              className: a3
            }, f2().createElement("span", {
              className: "rct-text"
            }, this.renderCollapseButton(), this.renderLabel()), this.renderChildren());
          }
        }]) && W(r3.prototype, n2), Object.defineProperty(r3, "prototype", {
          writable: false
        }), c22;
      }(f2().PureComponent);
      X3(Z, "propTypes", {
        checked: u().number.isRequired,
        disabled: u().bool.isRequired,
        expandDisabled: u().bool.isRequired,
        expanded: u().bool.isRequired,
        icons: H.isRequired,
        isLeaf: u().bool.isRequired,
        isParent: u().bool.isRequired,
        label: u().node.isRequired,
        lang: $.isRequired,
        optimisticToggle: u().bool.isRequired,
        showNodeIcon: u().bool.isRequired,
        treeId: u().string.isRequired,
        value: u().oneOfType([u().string, u().number]).isRequired,
        onCheck: u().func.isRequired,
        onExpand: u().func.isRequired,
        children: u().node,
        className: u().string,
        expandOnClick: u().bool,
        icon: u().node,
        showCheckbox: u().bool,
        title: u().string,
        onClick: u().func
      }), X3(Z, "defaultProps", {
        children: null,
        className: null,
        expandOnClick: false,
        icon: null,
        showCheckbox: true,
        title: null,
        onClick: function() {
        }
      });
      const ee = Z, te = u().oneOfType([u().arrayOf(u().string), u().arrayOf(u().number)]);
      function re2(e3, t32) {
        var r3 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e3);
          t32 && (n2 = n2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), r3.push.apply(r3, n2);
        }
        return r3;
      }
      function ne(e3) {
        for (var t32 = 1; t32 < arguments.length; t32++) {
          var r3 = null != arguments[t32] ? arguments[t32] : {};
          t32 % 2 ? re2(Object(r3), true).forEach(function(t4) {
            oe(e3, t4, r3[t4]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r3)) : re2(Object(r3)).forEach(function(t4) {
            Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r3, t4));
          });
        }
        return e3;
      }
      function oe(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      var ie = {
        label: u().node.isRequired,
        value: u().oneOfType([u().string, u().number]).isRequired,
        disabled: u().bool,
        icon: u().node,
        showCheckbox: u().bool,
        title: u().string
      };
      const ae = u().oneOfType([u().shape(ie), u().shape(ne(ne({}, ie), {}, {
        children: u().arrayOf(ie).isRequired
      }))]);
      function ce(e3) {
        return ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
          return typeof e4;
        } : function(e4) {
          return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
        }, ce(e3);
      }
      function se(e3, t32) {
        var r3 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e3);
          t32 && (n2 = n2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), r3.push.apply(r3, n2);
        }
        return r3;
      }
      function le(e3) {
        for (var t32 = 1; t32 < arguments.length; t32++) {
          var r3 = null != arguments[t32] ? arguments[t32] : {};
          t32 % 2 ? se(Object(r3), true).forEach(function(t4) {
            ye(e3, t4, r3[t4]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r3)) : se(Object(r3)).forEach(function(t4) {
            Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r3, t4));
          });
        }
        return e3;
      }
      function ue(e3, t32) {
        for (var r3 = 0; r3 < t32.length; r3++) {
          var n2 = t32[r3];
          n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
        }
      }
      function pe(e3, t32) {
        return pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
          return e4.__proto__ = t4, e4;
        }, pe(e3, t32);
      }
      function fe(e3, t32) {
        if (t32 && ("object" === ce(t32) || "function" == typeof t32))
          return t32;
        if (void 0 !== t32)
          throw new TypeError("Derived constructors may only return object or undefined");
        return de(e3);
      }
      function de(e3) {
        if (void 0 === e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e3;
      }
      function he(e3) {
        return he = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
          return e4.__proto__ || Object.getPrototypeOf(e4);
        }, he(e3);
      }
      function ye(e3, t32, r3) {
        return t32 in e3 ? Object.defineProperty(e3, t32, {
          value: r3,
          enumerable: true,
          configurable: true,
          writable: true
        }) : e3[t32] = r3, e3;
      }
      var be = function(e3) {
        !function(e4, t32) {
          if ("function" != typeof t32 && null !== t32)
            throw new TypeError("Super expression must either be null or a function");
          e4.prototype = Object.create(t32 && t32.prototype, {
            constructor: {
              value: e4,
              writable: true,
              configurable: true
            }
          }), Object.defineProperty(e4, "prototype", {
            writable: false
          }), t32 && pe(e4, t32);
        }(p2, e3);
        var r3, n2, o2, a2, l2, u2 = (a2 = p2, l2 = function() {
          if ("undefined" == typeof Reflect || !Reflect.construct)
            return false;
          if (Reflect.construct.sham)
            return false;
          if ("function" == typeof Proxy)
            return true;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), true;
          } catch (e4) {
            return false;
          }
        }(), function() {
          var e4, t32 = he(a2);
          if (l2) {
            var r4 = he(this).constructor;
            e4 = Reflect.construct(t32, arguments, r4);
          } else
            e4 = t32.apply(this, arguments);
          return fe(this, e4);
        });
        function p2(e4) {
          var t32;
          !function(e52, t4) {
            if (!(e52 instanceof t4))
              throw new TypeError("Cannot call a class as a function");
          }(this, p2), t32 = u2.call(this, e4);
          var r4 = new T(e4);
          return r4.flattenNodes(e4.nodes), r4.deserializeLists({
            checked: e4.checked,
            expanded: e4.expanded
          }), t32.state = {
            id: e4.id || "rct-".concat(s()),
            model: r4,
            prevProps: e4
          }, t32.onCheck = t32.onCheck.bind(de(t32)), t32.onExpand = t32.onExpand.bind(de(t32)), t32.onNodeClick = t32.onNodeClick.bind(de(t32)), t32.onExpandAll = t32.onExpandAll.bind(de(t32)), t32.onCollapseAll = t32.onCollapseAll.bind(de(t32)), t32.combineMemorized = c2()(function(e52, t4) {
            return le(le({}, e52), t4);
          }).bind(de(t32)), t32;
        }
        return r3 = p2, n2 = [{
          key: "onCheck",
          value: function(e4) {
            var t32 = this.props, r4 = t32.checkModel, n3 = t32.noCascade, o3 = t32.onCheck, i2 = this.state.model.clone(), a3 = i2.getNode(e4.value);
            i2.toggleChecked(e4, e4.checked, r4, n3), o3(i2.serializeList("checked"), le(le({}, a3), e4));
          }
        }, {
          key: "onExpand",
          value: function(e4) {
            var t32 = this.props.onExpand, r4 = this.state.model.clone(), n3 = r4.getNode(e4.value);
            r4.toggleNode(e4.value, "expanded", e4.expanded), t32(r4.serializeList("expanded"), le(le({}, n3), e4));
          }
        }, {
          key: "onNodeClick",
          value: function(e4) {
            (0, this.props.onClick)(le(le({}, this.state.model.getNode(e4.value)), e4));
          }
        }, {
          key: "onExpandAll",
          value: function() {
            this.expandAllNodes();
          }
        }, {
          key: "onCollapseAll",
          value: function() {
            this.expandAllNodes(false);
          }
        }, {
          key: "expandAllNodes",
          value: function() {
            var e4 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], t32 = this.props.onExpand;
            t32(this.state.model.clone().expandAllNodes(e4).serializeList("expanded"));
          }
        }, {
          key: "determineShallowCheckState",
          value: function(e4, t32) {
            var r4 = this.state.model.getNode(e4.value);
            return r4.isLeaf || t32 || 0 === e4.children.length ? r4.checked ? 1 : 0 : this.isEveryChildChecked(e4) ? 1 : this.isSomeChildChecked(e4) ? 2 : 0;
          }
        }, {
          key: "isEveryChildChecked",
          value: function(e4) {
            var t32 = this;
            return e4.children.every(function(e52) {
              return 1 === t32.state.model.getNode(e52.value).checkState;
            });
          }
        }, {
          key: "isSomeChildChecked",
          value: function(e4) {
            var t32 = this;
            return e4.children.some(function(e52) {
              return t32.state.model.getNode(e52.value).checkState > 0;
            });
          }
        }, {
          key: "renderTreeNodes",
          value: function(e4) {
            var t32 = this, r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n3 = this.props, o3 = n3.expandDisabled, i2 = n3.expandOnClick, a3 = n3.icons, c22 = n3.lang, s2 = n3.noCascade, l3 = n3.onClick, u3 = n3.onlyLeafCheckboxes, d2 = n3.optimisticToggle, h2 = n3.showNodeTitle, y2 = n3.showNodeIcon, b2 = this.state, v2 = b2.id, g2 = b2.model, m2 = p2.defaultProps.icons, x2 = e4.map(function(e52) {
              var n4 = e52.value, p3 = g2.getNode(e52.value), b3 = p3.isParent ? t32.renderTreeNodes(e52.children, e52) : null;
              p3.checkState = t32.determineShallowCheckState(e52, s2);
              var x3 = u3 ? p3.isLeaf : p3.showCheckbox;
              return !r4.value || g2.getNode(r4.value).expanded ? f2().createElement(ee, {
                key: n4,
                checked: p3.checkState,
                className: e52.className,
                disabled: p3.disabled,
                expandDisabled: o3,
                expandOnClick: i2,
                expanded: p3.expanded,
                icon: e52.icon,
                icons: t32.combineMemorized(m2, a3),
                label: e52.label,
                lang: c22,
                optimisticToggle: d2,
                isLeaf: p3.isLeaf,
                isParent: p3.isParent,
                showCheckbox: x3,
                showNodeIcon: y2,
                title: h2 ? e52.title || e52.label : e52.title,
                treeId: v2,
                value: e52.value,
                onCheck: t32.onCheck,
                onClick: l3 && t32.onNodeClick,
                onExpand: t32.onExpand
              }, b3) : null;
            });
            return f2().createElement("ol", null, x2);
          }
        }, {
          key: "renderExpandAll",
          value: function() {
            var e4 = this.props, t32 = e4.icons, r4 = t32.expandAll, n3 = t32.collapseAll, o3 = e4.lang;
            return e4.showExpandAll ? f2().createElement("div", {
              className: "rct-options"
            }, f2().createElement(j, {
              className: "rct-option rct-option-expand-all",
              title: o3.expandAll,
              onClick: this.onExpandAll
            }, r4), f2().createElement(j, {
              className: "rct-option rct-option-collapse-all",
              title: o3.collapseAll,
              onClick: this.onCollapseAll
            }, n3)) : null;
          }
        }, {
          key: "renderHiddenInput",
          value: function() {
            var e4 = this.props, t32 = e4.name, r4 = e4.nameAsArray;
            return void 0 === t32 ? null : r4 ? this.renderArrayHiddenInput() : this.renderJoinedHiddenInput();
          }
        }, {
          key: "renderArrayHiddenInput",
          value: function() {
            var e4 = this.props, t32 = e4.checked, r4 = e4.name;
            return t32.map(function(e52) {
              var t4 = "".concat(r4, "[]");
              return f2().createElement("input", {
                key: e52,
                name: t4,
                type: "hidden",
                value: e52
              });
            });
          }
        }, {
          key: "renderJoinedHiddenInput",
          value: function() {
            var e4 = this.props, t32 = e4.checked, r4 = e4.name, n3 = t32.join(",");
            return f2().createElement("input", {
              name: r4,
              type: "hidden",
              value: n3
            });
          }
        }, {
          key: "render",
          value: function() {
            var e4, r4 = this.props, n3 = r4.direction, o3 = r4.disabled, i2 = r4.iconsClass, a3 = r4.nodes, c22 = r4.nativeCheckboxes, s2 = this.state.id, l3 = this.renderTreeNodes(a3), u3 = t22()((ye(e4 = {
              "react-checkbox-tree": true,
              "rct-disabled": o3
            }, "rct-icons-".concat(i2), true), ye(e4, "rct-native-display", c22), ye(e4, "rct-direction-rtl", "rtl" === n3), e4));
            return f2().createElement("div", {
              className: u3,
              id: s2
            }, this.renderExpandAll(), this.renderHiddenInput(), l3);
          }
        }], o2 = [{
          key: "getDerivedStateFromProps",
          value: function(e4, t32) {
            var r4 = t32.model, n3 = t32.prevProps, o3 = e4.disabled, a3 = e4.id, c22 = e4.nodes, s2 = le(le({}, t32), {}, {
              prevProps: e4
            });
            return r4.setProps(e4), i()(n3.nodes, c22) && n3.disabled === o3 || (r4.reset(), r4.flattenNodes(c22)), null !== a3 && (s2 = le(le({}, s2), {}, {
              id: a3
            })), r4.deserializeLists({
              checked: e4.checked,
              expanded: e4.expanded
            }), s2;
          }
        }], n2 && ue(r3.prototype, n2), o2 && ue(r3, o2), Object.defineProperty(r3, "prototype", {
          writable: false
        }), p2;
      }(f2().Component);
      function ve(e3) {
        return function(e4) {
          if (Array.isArray(e4))
            return ge(e4);
        }(e3) || function(e4) {
          if ("undefined" != typeof Symbol && null != e4[Symbol.iterator] || null != e4["@@iterator"])
            return Array.from(e4);
        }(e3) || function(e4, t32) {
          if (e4) {
            if ("string" == typeof e4)
              return ge(e4, t32);
            var r3 = Object.prototype.toString.call(e4).slice(8, -1);
            return "Object" === r3 && e4.constructor && (r3 = e4.constructor.name), "Map" === r3 || "Set" === r3 ? Array.from(e4) : "Arguments" === r3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r3) ? ge(e4, t32) : void 0;
          }
        }(e3) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function ge(e3, t32) {
        (null == t32 || t32 > e3.length) && (t32 = e3.length);
        for (var r3 = 0, n2 = new Array(t32); r3 < t32; r3++)
          n2[r3] = e3[r3];
        return n2;
      }
      function me(e3, t32) {
        var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r3 > t32)
          return [];
        var n2 = [];
        return e3.forEach(function(e4) {
          e4.children && (n2 = [].concat(ve(n2), [e4.value], ve(me(e4.children, t32, r3 + 1))));
        }), n2;
      }
      ye(be, "propTypes", {
        nodes: u().arrayOf(ae).isRequired,
        checkModel: u().oneOf([_.LEAF, _.ALL]),
        checked: te,
        direction: u().string,
        disabled: u().bool,
        expandDisabled: u().bool,
        expandOnClick: u().bool,
        expanded: te,
        icons: H,
        iconsClass: u().string,
        id: u().string,
        lang: $,
        name: u().string,
        nameAsArray: u().bool,
        nativeCheckboxes: u().bool,
        noCascade: u().bool,
        onlyLeafCheckboxes: u().bool,
        optimisticToggle: u().bool,
        showExpandAll: u().bool,
        showNodeIcon: u().bool,
        showNodeTitle: u().bool,
        onCheck: u().func,
        onClick: u().func,
        onExpand: u().func
      }), ye(be, "defaultProps", {
        checkModel: _.LEAF,
        checked: [],
        direction: "ltr",
        disabled: false,
        expandDisabled: false,
        expandOnClick: false,
        expanded: [],
        icons: {
          check: f2().createElement("span", {
            className: "rct-icon rct-icon-check"
          }),
          uncheck: f2().createElement("span", {
            className: "rct-icon rct-icon-uncheck"
          }),
          halfCheck: f2().createElement("span", {
            className: "rct-icon rct-icon-half-check"
          }),
          expandClose: f2().createElement("span", {
            className: "rct-icon rct-icon-expand-close"
          }),
          expandOpen: f2().createElement("span", {
            className: "rct-icon rct-icon-expand-open"
          }),
          expandAll: f2().createElement("span", {
            className: "rct-icon rct-icon-expand-all"
          }),
          collapseAll: f2().createElement("span", {
            className: "rct-icon rct-icon-collapse-all"
          }),
          parentClose: f2().createElement("span", {
            className: "rct-icon rct-icon-parent-close"
          }),
          parentOpen: f2().createElement("span", {
            className: "rct-icon rct-icon-parent-open"
          }),
          leaf: f2().createElement("span", {
            className: "rct-icon rct-icon-leaf"
          })
        },
        iconsClass: "fa4",
        id: null,
        lang: {
          collapseAll: "Collapse all",
          expandAll: "Expand all",
          toggle: "Toggle"
        },
        name: void 0,
        nameAsArray: false,
        nativeCheckboxes: false,
        noCascade: false,
        onlyLeafCheckboxes: false,
        optimisticToggle: true,
        showExpandAll: false,
        showNodeIcon: true,
        showNodeTitle: false,
        onCheck: function() {
        },
        onClick: null,
        onExpand: function() {
        }
      });
      const xe = be;
    })(), o;
  })());
})(index_browser);
var index_browserExports = index_browser.exports;
const CheckboxTree = /* @__PURE__ */ getDefaultExportFromCjs(index_browserExports);
function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$k(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$k(descriptor.key), descriptor);
  }
}
function _createClass$l(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$k(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$k(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$k(arg) {
  var key = _toPrimitive$k(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$k(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$l(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$k(subClass, superClass);
}
function _setPrototypeOf$k(o, p) {
  _setPrototypeOf$k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$k(o, p);
}
function _createSuper$k(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$k();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$k(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$k(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$l(this, result);
  };
}
function _possibleConstructorReturn$l(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$k(self2);
}
function _assertThisInitialized$k(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$k() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$k(o) {
  _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$k(o);
}
let TilesetFinder = /* @__PURE__ */ function(_React$Component) {
  _inherits$l(TilesetFinder2, _React$Component);
  var _super = _createSuper$k(TilesetFinder2);
  function TilesetFinder2(props) {
    var _this;
    _classCallCheck$l(this, TilesetFinder2);
    _this = _super.call(this, props);
    _this.localTracks = TRACKS_INFO.filter((x) => x.local && !x.hidden).map((x) => {
      const y = {
        ...x
      };
      y.datatype = x.datatype[0];
      return y;
    });
    _this.augmentedTracksInfo = TRACKS_INFO;
    if (window.higlassTracksByType) {
      Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
        _this.augmentedTracksInfo.push(window.higlassTracksByType[pluginTrackType].config);
      });
    }
    if (props.datatype) {
      _this.localTracks = _this.localTracks.filter((x) => x.datatype[0] === props.datatype);
    } else {
      _this.localTracks = _this.localTracks.filter((x) => x.orientation === _this.props.orientation);
    }
    _this.localTracks.forEach((x) => {
      x.uuid = slugid$1.nice();
    });
    const newOptions = _this.prepareNewEntries("", _this.localTracks, {});
    const availableTilesetKeys = Object.keys(newOptions);
    const selectedUuid = availableTilesetKeys.length ? [availableTilesetKeys[0]] : null;
    _this.mounted = false;
    _this.state = {
      selectedUuid,
      options: newOptions,
      filter: "",
      checked: [],
      expanded: []
    };
    _this.requestTilesetLists();
    return _this;
  }
  _createClass$l(TilesetFinder2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.requestTilesetLists();
      this.searchBox.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "prepareNewEntries",
    value: function prepareNewEntries(sourceServer, newEntries, existingOptions) {
      const newOptions = existingOptions;
      const entries2 = newEntries.map((ne) => {
        const ane = {
          ...ne,
          server: sourceServer,
          tilesetUid: ne.uuid,
          serverUidKey: this.serverUidKey(sourceServer, ne.uuid),
          datatype: ne.datatype,
          name: ne.name,
          uid: slugid$1.nice()
        };
        return ane;
      });
      entries2.forEach((ne) => {
        newOptions[ne.serverUidKey] = ne;
      });
      return newOptions;
    }
  }, {
    key: "serverUidKey",
    value: function serverUidKey(server, uid) {
      return `${server}/${uid}`;
    }
  }, {
    key: "requestTilesetLists",
    value: function requestTilesetLists() {
      let datatypesQuery = null;
      if (this.props.datatype) {
        datatypesQuery = `dt=${this.props.datatype}`;
      } else {
        const datatypes = new Set([].concat(...this.augmentedTracksInfo.filter((x) => x.datatype).filter((x) => {
          return x.orientation === this.props.orientation || this.props.orientation === "1d-vertical" && x.orientation === "1d-horizontal";
        }).map((x) => x.datatype)));
        datatypesQuery = [...datatypes].map((x) => `dt=${x}`).join("&");
      }
      if (!this.props.trackSourceServers) {
        console.warn("No track source servers specified in the viewconf");
        return;
      }
      this.props.trackSourceServers.forEach((sourceServer) => {
        api.json(`${sourceServer}/tilesets/?limit=10000&${datatypesQuery}`, (error, data2) => {
          if (error) {
            console.error("ERROR:", error);
          } else {
            const newOptions = this.prepareNewEntries(sourceServer, data2.results, this.state.options);
            const availableTilesetKeys = Object.keys(newOptions);
            let {
              selectedUuid
            } = this.state;
            if (!selectedUuid) {
              selectedUuid = availableTilesetKeys.length ? [availableTilesetKeys[0]] : null;
              const selectedTileset = this.state.options[selectedUuid[0]];
              this.props.selectedTilesetChanged([selectedTileset]);
            }
            if (this.mounted) {
              this.setState({
                selectedUuid,
                options: newOptions
              });
            }
          }
        }, this.props.pubSub);
      });
    }
    /**
     * Double clicked on an element. Should be selected
     * and this window will be closed.
     */
  }, {
    key: "handleOptionDoubleClick",
    value: function handleOptionDoubleClick(x) {
      const value2 = this.state.options[x.target.value];
      this.props.onDoubleClick(value2);
    }
  }, {
    key: "handleSelectedOptions",
    value: function handleSelectedOptions(selectedOptions) {
      const selectedValues = [];
      const selectedTilesets = [];
      for (let i = 0; i < selectedOptions.length; i++) {
        selectedValues.push(selectedOptions[i]);
        selectedTilesets.push(this.state.options[selectedOptions[i]]);
      }
      this.props.selectedTilesetChanged(selectedTilesets);
      this.setState({
        selectedUuid: selectedValues
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect() {
      const {
        selectedOptions
      } = this.multiSelect;
      const selectedOptionsList = [];
      for (let i = 0; i < selectedOptions.length; i++) {
        const selectedOption = selectedOptions[i];
        selectedOptionsList.push(selectedOption.value);
      }
      this.handleSelectedOptions(selectedOptionsList);
    }
  }, {
    key: "handleSearchChange",
    value: function handleSearchChange() {
      const domElement = this.searchBox;
      this.setState({
        filter: domElement.value
      });
    }
    /*
     * Create the nested checkbox tree by partitioning the
     * list of available datasets according to their group
     *
     * @param {object} datasetsDict A dictionary of id -> tileset
     *  def mappings
     * @param {string} filter A string to filter the results by
     * @returns {array} A list of items that define the nested checkbox
     *  structure
     *  {
     *    'name': 'blah',
     *    'value': 'blah',
     *    'children': [],
     *  }
     */
  }, {
    key: "partitionByGroup",
    value: function partitionByGroup(datasetsDict, filter4) {
      const itemsByGroup = {
        "": {
          name: "",
          value: "",
          children: []
        }
      };
      for (const uuid2 of Object.keys(datasetsDict)) {
        const item = datasetsDict[uuid2];
        if (!item.name.toLowerCase().includes(filter4)) {
          continue;
        }
        if ("project_name" in item) {
          const group2 = item.project_name;
          if (!(group2 in itemsByGroup)) {
            itemsByGroup[group2] = {
              value: group2,
              label: group2,
              children: []
            };
          }
          itemsByGroup[group2].children.push({
            label: item.name,
            value: uuid2
          });
        } else {
          itemsByGroup[""].children.push({
            label: item.name,
            value: uuid2
          });
        }
      }
      const allItems = itemsByGroup[""].children;
      for (const group2 of Object.keys(itemsByGroup)) {
        if (group2 !== "") {
          itemsByGroup[group2].children.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), "en"));
          allItems.push(itemsByGroup[group2]);
        }
      }
      allItems.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), "en"));
      return allItems;
    }
  }, {
    key: "handleChecked",
    value: function handleChecked(checked) {
      this.handleSelectedOptions(checked);
      this.setState({
        checked
      });
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(expanded) {
      this.setState({
        expanded
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const optionsList = [];
      for (const key in this.state.options) {
        optionsList.push(this.state.options[key]);
      }
      const nestedItems = this.partitionByGroup(this.state.options, this.state.filter);
      const svgStyle = {
        width: 15,
        height: 15,
        top: 2,
        right: 2,
        position: "relative"
      };
      const halfSvgStyle = JSON.parse(JSON.stringify(svgStyle));
      halfSvgStyle.opacity = 0.5;
      const form = /* @__PURE__ */ React$3.createElement("form", {
        onSubmit: (evt) => {
          evt.preventDefault();
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: "tileset-finder-search-bar"
      }, /* @__PURE__ */ React$3.createElement("span", {
        className: "tileset-finder-label"
      }, "Select tileset:"), /* @__PURE__ */ React$3.createElement("input", {
        ref: (c2) => {
          this.searchBox = c2;
        },
        className: "tileset-finder-search-box",
        onChange: this.handleSearchChange.bind(this),
        placeholder: "Search Term",
        type: "text"
      })), /* @__PURE__ */ React$3.createElement("div", {
        className: "tileset-finder-checkbox-tree"
      }, /* @__PURE__ */ React$3.createElement(CheckboxTree, {
        checked: this.state.checked,
        expanded: this.state.expanded,
        icons: {
          uncheck: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#square_o"
          })),
          check: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#check_square_o"
          })),
          halfCheck: /* @__PURE__ */ React$3.createElement("svg", {
            style: halfSvgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#check_square_o"
          })),
          leaf: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#file_o"
          })),
          expandClose: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#chevron_right"
          })),
          expandOpen: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#chevron_down"
          })),
          parentClose: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#folder_o"
          })),
          parentOpen: /* @__PURE__ */ React$3.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React$3.createElement("use", {
            xlinkHref: "#folder_open_o"
          }))
        },
        nodes: nestedItems,
        onCheck: this.handleChecked.bind(this),
        onExpand: this.handleExpanded.bind(this)
      })));
      return /* @__PURE__ */ React$3.createElement("div", null, form);
    }
  }]);
  return TilesetFinder2;
}(React$3.Component);
TilesetFinder.propTypes = {
  datatype: PropTypes.string,
  orientation: PropTypes.string,
  onDoubleClick: PropTypes.func,
  pubSub: PropTypes.object.isRequired,
  selectedTilesetChanged: PropTypes.func,
  trackSourceServers: PropTypes.array
};
const TilesetFinder$1 = withPubSub(TilesetFinder);
function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$j(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$j(descriptor.key), descriptor);
  }
}
function _createClass$k(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$j(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$j(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$j(arg) {
  var key = _toPrimitive$j(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$j(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$k(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$j(subClass, superClass);
}
function _setPrototypeOf$j(o, p) {
  _setPrototypeOf$j = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$j(o, p);
}
function _createSuper$j(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$j();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$j(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$j(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$k(this, result);
  };
}
function _possibleConstructorReturn$k(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$j(self2);
}
function _assertThisInitialized$j(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$j() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$j(o) {
  _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$j(o);
}
let PlotTypeChooser = /* @__PURE__ */ function(_React$Component) {
  _inherits$k(PlotTypeChooser2, _React$Component);
  var _super = _createSuper$j(PlotTypeChooser2);
  function PlotTypeChooser2(props) {
    var _this;
    _classCallCheck$k(this, PlotTypeChooser2);
    _this = _super.call(this, props);
    _this.DATATYPE_TO_TRACK_TYPE = DATATYPE_TO_TRACK_TYPE(_this.props.orientation);
    _this.AVAILABLE_TRACK_TYPES = AVAILABLE_TRACK_TYPES(_this.props.datatypes, _this.props.orientation);
    _this.state = {
      selectedPlotType: _this.AVAILABLE_TRACK_TYPES[0]
    };
    return _this;
  }
  _createClass$k(PlotTypeChooser2, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.AVAILABLE_TRACK_TYPES = AVAILABLE_TRACK_TYPES(newProps.datatypes, this.props.orientation);
      if (!this.AVAILABLE_TRACK_TYPES) {
        return;
      }
      if (!newProps.allTracksSameDatatype) {
        return;
      }
      if (this.AVAILABLE_TRACK_TYPES.length > 0) {
        if (!this.AVAILABLE_TRACK_TYPES.includes(this.state.selectedPlotType)) {
          const defaultTrackType = getDefaultTrackForDatatype(newProps.datatypes[0][0], this.props.position, this.AVAILABLE_TRACK_TYPES);
          this.handlePlotTypeSelected(defaultTrackType);
        }
      }
    }
  }, {
    key: "handlePlotTypeSelected",
    value: function handlePlotTypeSelected(key) {
      this.setState({
        selectedPlotType: key
      });
      this.props.onPlotTypeSelected(key.type);
    }
  }, {
    key: "render",
    value: function render3() {
      let AVAILABLE_TRACK_TYPES_LIST = "No plot types available for track";
      const trackTypeToInfo = {};
      TRACKS_INFO.forEach((ti) => {
        trackTypeToInfo[ti.type] = ti;
      });
      if (this.AVAILABLE_TRACK_TYPES) {
        AVAILABLE_TRACK_TYPES_LIST = this.AVAILABLE_TRACK_TYPES.sort((a, b) => a.type < b.type).map((x) => {
          const thumbnail = trackTypeToInfo[x.type].thumbnail;
          const plotTypeClass = this.state.selectedPlotType.type === x.type ? "plot-type-item plot-type-selected" : "plot-type-item";
          const imgTag = trackTypeToInfo[x.type].thumbnail ? /* @__PURE__ */ React$3.createElement("div", {
            className: "track-thumbnail",
            dangerouslySetInnerHTML: {
              __html: thumbnail.outerHTML
            }
          }) : /* @__PURE__ */ React$3.createElement("div", {
            className: "track-thumbnail"
          }, /* @__PURE__ */ React$3.createElement("svg", {
            height: 20,
            width: 30
          }));
          return /* @__PURE__ */ React$3.createElement("li", {
            key: x.type,
            className: plotTypeClass,
            onClick: (e) => {
              this.setState({
                selectedPlotType: x
              });
              this.props.onPlotTypeSelected(x.type);
            },
            style: {
              listStyle: "none",
              paddingLeft: 5,
              paddingBottom: 0
            }
          }, imgTag, /* @__PURE__ */ React$3.createElement("span", {
            style: {
              verticalAlign: "middle"
            }
          }, x.type));
        });
      }
      return /* @__PURE__ */ React$3.createElement("div", null, AVAILABLE_TRACK_TYPES_LIST.length > 0 && this.props.allTracksSameDatatype && /* @__PURE__ */ React$3.createElement("div", {
        className: "plot-type-container"
      }, AVAILABLE_TRACK_TYPES_LIST), !this.props.allTracksSameDatatype && /* @__PURE__ */ React$3.createElement("div", {
        className: "plot-type-container-empty"
      }, "Datasets with multiple datatypes chosen. They will be added with their default track types."));
    }
  }]);
  return PlotTypeChooser2;
}(React$3.Component);
PlotTypeChooser.propTypes = {
  allTracksSameDatatype: PropTypes.bool,
  datatypes: PropTypes.array,
  orientation: PropTypes.string,
  onPlotTypeSelected: PropTypes.func,
  position: PropTypes.string
};
const collapsed = "_collapsed_ub7s6_9";
const modal = "_modal_ub7s6_14";
const AddTrackDialog_module = {
  "collapse-toggle-icon": "_collapse-toggle-icon_ub7s6_1",
  collapsed,
  "modal-title": "_modal-title_ub7s6_14",
  "modal-container": "_modal-container_ub7s6_19",
  modal,
  "modal-backdrop": "_modal-backdrop_ub7s6_23",
  "modal-dialog": "_modal-dialog_ub7s6_27"
};
function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$i(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$i(descriptor.key), descriptor);
  }
}
function _createClass$j(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$i(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$i(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$i(arg) {
  var key = _toPrimitive$i(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$i(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$j(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$i(subClass, superClass);
}
function _setPrototypeOf$i(o, p) {
  _setPrototypeOf$i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$i(o, p);
}
function _createSuper$i(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$i();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$i(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$i(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$j(this, result);
  };
}
function _possibleConstructorReturn$j(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$i(self2);
}
function _assertThisInitialized$i(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$i() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$i(o) {
  _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$i(o);
}
let AddTrackDialog = /* @__PURE__ */ function(_React$Component) {
  _inherits$j(AddTrackDialog2, _React$Component);
  var _super = _createSuper$i(AddTrackDialog2);
  function AddTrackDialog2(props) {
    var _this;
    _classCallCheck$j(this, AddTrackDialog2);
    _this = _super.call(this, props);
    _this.options = {};
    _this.state = {
      selectedTilesets: [{
        datatype: "none"
      }],
      allTracksSameDatatype: true
      // Do all selected tracks have the same datatype
    };
    _this.handleSubmitBound = _this.handleSubmit.bind(_assertThisInitialized$i(_this));
    _this.handleTilesetPickerDoubleClickBound = _this.handleTilesetPickerDoubleClick.bind(_assertThisInitialized$i(_this));
    _this.selectedTilesetsChangedBound = _this.selectedTilesetsChanged.bind(_assertThisInitialized$i(_this));
    return _this;
  }
  _createClass$j(AddTrackDialog2, [{
    key: "getOrientation",
    value: function getOrientation(position) {
      let orientation2 = null;
      if (position === "top" || position === "bottom") {
        orientation2 = "1d-horizontal";
      } else if (position === "left" || position === "right") {
        orientation2 = "1d-vertical";
      } else {
        orientation2 = "2d";
      }
      return orientation2;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(evt) {
      if (evt)
        evt.preventDefault();
      this.props.onTracksChosen(this.state.selectedTilesets, this.props.position, this.props.host);
    }
    /**
     * The user double clicked a tileset in the tileset finder dialog.
     * This means that only one is selected.
     *
     * Arguments
     * ---------
     *  tileset: { uuid: 'CXCX', filetype: 'cooler' ....}
     */
  }, {
    key: "handleTilesetPickerDoubleClick",
    value: function handleTilesetPickerDoubleClick(tileset) {
      this.selectedTilesetsChanged([tileset]);
      this.props.onTracksChosen(this.state.selectedTilesets, this.props.position, this.props.host);
    }
  }, {
    key: "handleOptionsChanged",
    value: function handleOptionsChanged(newOptions) {
      this.options = newOptions;
    }
  }, {
    key: "handlePlotTypeSelected",
    value: function handlePlotTypeSelected(newPlotType) {
      const {
        selectedTilesets
      } = this.state;
      for (const tileset of selectedTilesets) {
        tileset.type = newPlotType;
      }
      this.selectedPlotType = newPlotType;
      this.setState({
        selectedTilesets
      });
    }
  }, {
    key: "selectedTilesetsChanged",
    value: function selectedTilesetsChanged(selectedTilesetsIn) {
      let selectedTilesets = null;
      if (selectedTilesetsIn.length === 0) {
        selectedTilesets = [{
          datatype: "none"
        }];
      } else {
        selectedTilesets = selectedTilesetsIn;
      }
      let allTracksSameDatatype = true;
      const firstDatatype = selectedTilesets[0].datatype;
      for (const tileset of selectedTilesets) {
        if (tileset.datatype !== firstDatatype) {
          allTracksSameDatatype = false;
        }
      }
      if (allTracksSameDatatype) {
        for (const tileset of selectedTilesets) {
          tileset.type = this.selectedPlotType;
        }
      } else {
        for (const tileset of selectedTilesets) {
          let datatypes = [tileset.datatype];
          const orientation2 = this.getOrientation(this.props.position);
          if (tileset.filetype === "cooler") {
            datatypes = [tileset.datatype, "chromsizes"];
          }
          const availableTrackTypes = AVAILABLE_TRACK_TYPES([datatypes], orientation2);
          const defaultTrackType = getDefaultTrackForDatatype(datatypes[0], this.props.position, availableTrackTypes);
          tileset.type = defaultTrackType.type;
        }
      }
      this.setState({
        selectedTilesets,
        allTracksSameDatatype
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const orientation2 = this.getOrientation(this.props.position);
      const form = /* @__PURE__ */ React$3.createElement("div", null, /* @__PURE__ */ React$3.createElement(
        TilesetFinder$1,
        {
          ref: (c2) => {
            this.tilesetFinder = c2;
          },
          datatype: this.props.datatype,
          onDoubleClick: this.handleTilesetPickerDoubleClick.bind(this),
          onTracksChosen: (value2) => this.props.onTracksChosen(value2, this.props.position),
          orientation: orientation2,
          selectedTilesetChanged: this.selectedTilesetsChanged.bind(this),
          trackSourceServers: this.props.trackSourceServers
        }
      ));
      return /* @__PURE__ */ React$3.createElement(Dialog$1, {
        maxHeight: true,
        okayTitle: "Submit",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmitBound,
        title: "Add Track"
      }, /* @__PURE__ */ React$3.createElement(React$3.Fragment, null, form, /* @__PURE__ */ React$3.createElement(
        PlotTypeChooser,
        {
          ref: (c2) => {
            this.plotTypeChooser = c2;
          },
          allTracksSameDatatype: this.state.allTracksSameDatatype,
          datatypes: this.state.selectedTilesets.map((x) => {
            if (x.filetype === "cooler") {
              return [x.datatype, "chromsizes"];
            }
            return [x.datatype];
          }),
          onPlotTypeSelected: this.handlePlotTypeSelected.bind(this),
          orientation: orientation2,
          position: this.props.position
        }
      )));
    }
  }]);
  return AddTrackDialog2;
}(React$3.Component);
AddTrackDialog.defaultProps = {
  position: "top"
};
AddTrackDialog.propTypes = {
  datatype: PropTypes.string,
  host: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onTracksChosen: PropTypes.func.isRequired,
  position: PropTypes.string,
  trackSourceServers: PropTypes.array.isRequired
};
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$h(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$h(descriptor.key), descriptor);
  }
}
function _createClass$i(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$h(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$h(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$h(arg) {
  var key = _toPrimitive$h(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$h(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$i(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$h(subClass, superClass);
}
function _setPrototypeOf$h(o, p) {
  _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$h(o, p);
}
function _createSuper$h(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$h();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$h(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$h(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$i(this, result);
  };
}
function _possibleConstructorReturn$i(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$h(self2);
}
function _assertThisInitialized$h(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$h() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$h(o) {
  _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$h(o);
}
let CustomTrackDialog = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$i(CustomTrackDialog2, _React$PureComponent);
  var _super = _createSuper$h(CustomTrackDialog2);
  function CustomTrackDialog2() {
    _classCallCheck$i(this, CustomTrackDialog2);
    return _super.apply(this, arguments);
  }
  _createClass$i(CustomTrackDialog2, [{
    key: "render",
    value: function render3() {
      const childrenWithProp = [];
      this.props.children.forEach((Child, i) => {
        const key = `customTrackDialog_${i}`;
        childrenWithProp.push(/* @__PURE__ */ React$3.createElement(Child, _extends$3({
          key
        }, this.props.bodyProps[i])));
      });
      return /* @__PURE__ */ React$3.createElement(Dialog$1, {
        maxHeight: true,
        okayOnly: true,
        okayTitle: "Close",
        onCancel: this.props.onCancel,
        onOkay: this.props.onCancel,
        title: this.props.title
      }, childrenWithProp);
    }
  }]);
  return CustomTrackDialog2;
}(React$3.PureComponent);
CustomTrackDialog.defaultProps = {};
CustomTrackDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  bodyProps: PropTypes.array,
  children: PropTypes.array
};
function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$g(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$g(descriptor.key), descriptor);
  }
}
function _createClass$h(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$g(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$g(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$g(arg) {
  var key = _toPrimitive$g(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$g(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$h(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$g(subClass, superClass);
}
function _setPrototypeOf$g(o, p) {
  _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$g(o, p);
}
function _createSuper$g(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$g();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$g(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$g(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$h(this, result);
  };
}
function _possibleConstructorReturn$h(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$g(self2);
}
function _assertThisInitialized$g(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$g(o) {
  _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$g(o);
}
const TRACK_CONTROL_HEIGHT = 20;
let ContextMenuContainer = /* @__PURE__ */ function(_React$Component) {
  _inherits$h(ContextMenuContainer2, _React$Component);
  var _super = _createSuper$g(ContextMenuContainer2);
  function ContextMenuContainer2(props) {
    var _this;
    _classCallCheck$h(this, ContextMenuContainer2);
    _this = _super.call(this, props);
    _this.adjusted = false;
    _this.state = {
      orientation: _this.props.orientation ? _this.props.orientation : "right",
      left: _this.props.position.left,
      top: _this.props.position.top,
      submenuShown: null
    };
    return _this;
  }
  _createClass$h(ContextMenuContainer2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateOrientation();
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.adjusted = false;
      this.setState({
        left: newProps.position.left,
        top: newProps.position.top
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateOrientation();
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "handleItemMouseEnterWithRect",
    value: function handleItemMouseEnterWithRect(clientRect, series) {
      this.setState({
        submenuShown: series,
        submenuSourceBbox: clientRect
      });
    }
  }, {
    key: "handleItemMouseEnter",
    value: function handleItemMouseEnter(evt, series) {
      this.handleItemMouseEnterWithRect(evt.currentTarget.getBoundingClientRect(), series);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
    }
  }, {
    key: "handleOtherMouseEnter",
    value: function handleOtherMouseEnter() {
      this.setState({
        submenuShown: null
      });
    }
    /*
    handleSeriesMouseEnter(evt, uid) {
      let domNode = evt.currentTarget;
       this.setState({
        submenuShown: uid,
        submenuSourceBbox: domNode.getBoundingClientRect()
      });
    }
     handleMouseLeave(evt) {
      return;
    }
     handleOtherMouseEnter(evt) {
      this.setState({
        submenuShown: null
      });
    }
    */
  }, {
    key: "updateOrientation",
    value: function updateOrientation() {
      if (this.adjusted)
        return;
      this.adjusted = true;
      this.divDom = ReactDOM.findDOMNode(this.div);
      const bbox = this.divDom.getBoundingClientRect();
      const parentBbox = this.props.parentBbox ? this.props.parentBbox : {
        top: this.props.position.top,
        left: this.props.position.left,
        width: 0,
        height: 0
      };
      let orientation2 = this.state.orientation;
      let topPosition = parentBbox.top;
      if (parentBbox.top + bbox.height > window.innerHeight) {
        if (parentBbox.top - bbox.height > 0) {
          topPosition = parentBbox.top - bbox.height + TRACK_CONTROL_HEIGHT;
        } else {
          topPosition = parentBbox.top - bbox.height + TRACK_CONTROL_HEIGHT;
          topPosition -= topPosition + bbox.height - window.innerHeight;
        }
      }
      if (this.state.orientation === "left") {
        let leftPosition = parentBbox.left - bbox.width;
        if (leftPosition < 0) {
          if (parentBbox.left + parentBbox.width + bbox.width > window.innerWidth) {
            leftPosition = 0;
          } else {
            leftPosition = parentBbox.left + parentBbox.width;
            orientation2 = "right";
          }
        }
        this.setState({
          left: leftPosition,
          top: topPosition,
          orientation: orientation2
        });
      } else {
        let leftPosition = parentBbox.left + parentBbox.width;
        if (parentBbox.left + parentBbox.width + bbox.width > window.innerWidth) {
          if (parentBbox.left - bbox.width < 0) {
            leftPosition = 0;
            orientation2 = "right";
          } else {
            leftPosition = parentBbox.left - bbox.width;
            orientation2 = "left";
          }
        }
        this.setState({
          left: leftPosition,
          top: topPosition,
          orientation: orientation2
        });
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const stylePosition = this.state.left ? {
        left: this.state.left
      } : {
        right: this.state.right
      };
      const otherStyle = {
        top: this.state.top
      };
      const wholeStyle = Object.assign(stylePosition, otherStyle);
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx("context-menu-item", classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        style: wholeStyle
      }, this.props.children);
    }
  }]);
  return ContextMenuContainer2;
}(React$3.Component);
ContextMenuContainer.propTypes = {
  children: PropTypes.node,
  orientation: PropTypes.string,
  parentBbox: PropTypes.object,
  position: PropTypes.object,
  theme: PropTypes.symbol.isRequired
};
function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$f(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$f(descriptor.key), descriptor);
  }
}
function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$f(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$f(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$f(arg) {
  var key = _toPrimitive$f(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$f(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$g(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$f(subClass, superClass);
}
function _setPrototypeOf$f(o, p) {
  _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$f(o, p);
}
function _createSuper$f(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$f();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$f(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$f(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$g(this, result);
  };
}
function _possibleConstructorReturn$g(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$f(self2);
}
function _assertThisInitialized$f(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$f() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$f(o) {
  _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$f(o);
}
let NestedContextMenu = /* @__PURE__ */ function(_ContextMenuContainer) {
  _inherits$g(NestedContextMenu2, _ContextMenuContainer);
  var _super = _createSuper$f(NestedContextMenu2);
  function NestedContextMenu2() {
    _classCallCheck$g(this, NestedContextMenu2);
    return _super.apply(this, arguments);
  }
  _createClass$g(NestedContextMenu2, [{
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const menuItem = this.state.submenuShown;
        return /* @__PURE__ */ React$3.createElement(NestedContextMenu2, {
          menuItems: menuItem.children,
          orientation: this.state.orientation,
          parentBbox: bbox,
          position,
          theme: this.props.theme
        });
      }
      return /* @__PURE__ */ React$3.createElement("div", null);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
    }
  }, {
    key: "render",
    value: function render3() {
      const menuItems = [];
      for (const menuItemKey in this.props.menuItems) {
        const menuItem = this.props.menuItems[menuItemKey];
        menuItems.push(/* @__PURE__ */ React$3.createElement(ContextMenuItem, {
          key: menuItemKey,
          onClick: menuItem.handler ? menuItem.handler : () => null,
          onMouseEnter: menuItem.children ? (e) => this.handleItemMouseEnter(e, menuItem) : this.handleOtherMouseEnter.bind(this),
          onMouseLeave: this.handleMouseLeave
        }, menuItem.name, menuItem.children && /* @__PURE__ */ React$3.createElement("svg", {
          className: classes$b["play-icon"]
        }, /* @__PURE__ */ React$3.createElement("use", {
          xlinkHref: "#play"
        }))));
      }
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx(classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, menuItems, this.getSubmenu());
    }
  }]);
  return NestedContextMenu2;
}(ContextMenuContainer);
function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$e(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$e(descriptor.key), descriptor);
  }
}
function _createClass$f(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$e(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$e(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$e(arg) {
  var key = _toPrimitive$e(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$e(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$f(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$e(subClass, superClass);
}
function _setPrototypeOf$e(o, p) {
  _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$e(o, p);
}
function _createSuper$e(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$e(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$e(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$f(this, result);
  };
}
function _possibleConstructorReturn$f(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$e(self2);
}
function _assertThisInitialized$e(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$e(o) {
  _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$e(o);
}
let SeriesListMenu = /* @__PURE__ */ function(_ContextMenuContainer) {
  _inherits$f(SeriesListMenu2, _ContextMenuContainer);
  var _super = _createSuper$e(SeriesListMenu2);
  function SeriesListMenu2() {
    _classCallCheck$f(this, SeriesListMenu2);
    return _super.apply(this, arguments);
  }
  _createClass$f(SeriesListMenu2, [{
    key: "getConfigureSeriesMenu",
    value: function getConfigureSeriesMenu(position, bbox, track) {
      const menuItems = {};
      const pluginOptionsInfo = window.higlassTracksByType && window.higlassTracksByType[track.type] && window.higlassTracksByType[track.type].config && window.higlassTracksByType[track.type].config.optionsInfo;
      if (pluginOptionsInfo) {
        for (const key of Object.keys(pluginOptionsInfo)) {
          OPTIONS_INFO[key] = pluginOptionsInfo[key];
        }
      }
      if (!TRACKS_INFO_BY_TYPE[track.type] || !TRACKS_INFO_BY_TYPE[track.type].availableOptions) {
        return null;
      }
      for (const optionType of TRACKS_INFO_BY_TYPE[track.type].availableOptions) {
        if (optionType in OPTIONS_INFO) {
          menuItems[optionType] = {
            name: OPTIONS_INFO[optionType].name
          };
          if (OPTIONS_INFO[optionType].generateOptions) {
            const generatedOptions = OPTIONS_INFO[optionType].generateOptions(track);
            if (!menuItems[optionType].children) {
              menuItems[optionType].children = {};
            }
            for (const generatedOption of generatedOptions) {
              const optionSelectorSettings = {
                name: generatedOption.name,
                value: generatedOption.value,
                handler: () => {
                  track.options[optionType] = generatedOption.value;
                  this.props.onTrackOptionsChanged(track.uid, track.options);
                  this.props.closeMenu();
                }
              };
              menuItems[optionType].children[generatedOption.value] = optionSelectorSettings;
            }
          }
          if (OPTIONS_INFO[optionType].inlineOptions) {
            for (const inlineOptionKey in OPTIONS_INFO[optionType].inlineOptions) {
              const inlineOption = OPTIONS_INFO[optionType].inlineOptions[inlineOptionKey];
              if (!menuItems[optionType].children) {
                menuItems[optionType].children = {};
              }
              const optionSelectorSettings = {
                name: inlineOption.name,
                value: inlineOption.value
                // missing handler to be filled in below
              };
              if (inlineOption.componentPickers && inlineOption.componentPickers[track.type]) {
                optionSelectorSettings.handler = () => {
                  this.props.onConfigureTrack(track, inlineOption.componentPickers[track.type]);
                  this.props.closeMenu();
                };
              } else {
                optionSelectorSettings.handler = () => {
                  track.options[optionType] = inlineOption.value;
                  this.props.onTrackOptionsChanged(track.uid, track.options);
                  this.props.closeMenu();
                };
              }
              menuItems[optionType].children[inlineOptionKey] = optionSelectorSettings;
            }
          } else if (OPTIONS_INFO[optionType].componentPickers && OPTIONS_INFO[optionType].componentPickers[track.type]) {
            menuItems[optionType].handler = () => {
              this.props.onConfigureTrack(track, OPTIONS_INFO[optionType].componentPickers[track.type]);
              this.props.closeMenu();
            };
          }
        }
      }
      return /* @__PURE__ */ React$3.createElement(NestedContextMenu, {
        key: "config-series-menu",
        closeMenu: this.props.closeMenu,
        menuItems,
        orientation: this.state.orientation,
        parentBbox: bbox,
        position,
        theme: this.props.theme
      });
    }
    /**
     * Return a list of track types that can be used
     * with the data for this track
     *
     * @param {Object} position The position where to draw ths menu (e.g. {left: 42, top: 88})
     *
     * @param (Object) bbox
     *  The bounding box of the parent menu, used to determine whether
     *  to draw the child menu on the left or the right
     *
     * @param (Object) track The track definition for this series (as in the viewconf)
     */
  }, {
    key: "getTrackTypeItems",
    value: function getTrackTypeItems(position, bbox, track) {
      if (window.higlassTracksByType) {
        Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
          TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
        });
      }
      let {
        datatype
      } = track;
      let orientation2 = null;
      if (track.type in TRACKS_INFO_BY_TYPE) {
        if (!datatype) {
          datatype = TRACKS_INFO_BY_TYPE[track.type].datatype[0];
        }
        ({
          orientation: orientation2
        } = TRACKS_INFO_BY_TYPE[track.type]);
      }
      const availableTrackTypes = Object.values(TRACKS_INFO_BY_TYPE).filter((x) => x.datatype).filter((x) => x.orientation).filter((x) => x.datatype.includes(datatype)).filter((x) => x.orientation === orientation2).map((x) => x.type);
      const menuItems = {};
      for (let i = 0; i < availableTrackTypes.length; i++) {
        menuItems[availableTrackTypes[i]] = {
          value: availableTrackTypes[i],
          name: availableTrackTypes[i],
          handler: () => {
            this.props.onChangeTrackType(track.uid, availableTrackTypes[i]);
          }
        };
      }
      return /* @__PURE__ */ React$3.createElement(NestedContextMenu, {
        key: "track-type-items",
        closeMenu: this.props.closeMenu,
        menuItems,
        orientation: this.state.orientation,
        parentBbox: bbox,
        position,
        theme: this.props.theme
      });
    }
  }, {
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const subMenuData = this.state.submenuShown;
        const track = subMenuData.value;
        if (subMenuData.option === "track-type") {
          return this.getTrackTypeItems(position, bbox, track);
        }
        return this.getConfigureSeriesMenu(position, bbox, track);
      }
      return /* @__PURE__ */ React$3.createElement("div", null);
    }
  }, {
    key: "getDivideByMenuItem",
    value: function getDivideByMenuItem() {
      if (this.props.series.data && this.props.series.data.type === "divided") {
        const newData = {
          tilesetUid: this.props.series.data.children[0].tilesetUid,
          server: this.props.series.data.children[0].server
        };
        return /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
          className: classes$b["context-menu-item"],
          onClick: () => this.props.onChangeTrackData(this.props.series.uid, newData),
          onMouseEnter: (e) => this.handleOtherMouseEnter(e)
        }, /* @__PURE__ */ React$3.createElement("span", {
          className: classes$b["context-menu-span"]
        }, "Remove divisor"));
      }
      return /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        className: classes$b["context-menu-item"],
        onClick: () => this.props.onAddDivisor(this.props.series),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, /* @__PURE__ */ React$3.createElement("span", {
        className: classes$b["context-menu-span"]
      }, "Divide by"));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
    }
  }, {
    key: "render",
    value: function render3() {
      let exportDataMenuItem = null;
      if (TRACKS_INFO_BY_TYPE[this.props.series.type] && TRACKS_INFO_BY_TYPE[this.props.series.type].exportable) {
        exportDataMenuItem = /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
          className: classes$b["context-menu-item"],
          onClick: () => this.props.onExportData(this.props.hostTrack.uid, this.props.track.uid),
          onMouseEnter: (e) => this.handleOtherMouseEnter(e)
        }, /* @__PURE__ */ React$3.createElement("span", {
          className: classes$b["context-menu-span"]
        }, "Export Data"));
      }
      const replaceSeriesItem = this.props.onAddSeries ? /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        className: classes$b["context-menu-item"],
        onClick: () => {
          this.props.onCloseTrack(this.props.series.uid);
          this.props.onAddSeries(this.props.hostTrack.uid);
        },
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, /* @__PURE__ */ React$3.createElement("span", {
        className: classes$b["context-menu-span"]
      }, "Replace Series")) : null;
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx(classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "SeriesListMenu",
        onMouseLeave: this.props.handleMouseLeave,
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => {
        },
        onMouseEnter: (e) => this.handleItemMouseEnter(e, {
          option: "configure-series",
          value: this.props.track
        }),
        onMouseLeave: (e) => this.handleMouseLeave(e)
      }, "Configure Series", /* @__PURE__ */ React$3.createElement("svg", {
        className: classes$b["play-icon"]
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#play"
      }))), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        className: classes$b["context-menu-item"],
        onClick: () => {
        },
        onMouseEnter: (e) => this.handleItemMouseEnter(e, {
          option: "track-type",
          value: this.props.track
        }),
        onMouseLeave: (e) => this.handleMouseLeave(e)
      }, /* @__PURE__ */ React$3.createElement("span", {
        className: classes$b["context-menu-span"]
      }, "Track Type", /* @__PURE__ */ React$3.createElement("svg", {
        className: classes$b["play-icon"]
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#play"
      })))), exportDataMenuItem, this.getDivideByMenuItem(), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        className: classes$b["context-menu-item"],
        onClick: this.props.onCloseTrack,
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, /* @__PURE__ */ React$3.createElement("span", {
        className: classes$b["context-menu-span"]
      }, "Close Series")), replaceSeriesItem, this.getSubmenu());
    }
  }]);
  return SeriesListMenu2;
}(ContextMenuContainer);
const getAllTracksAndSubtracks = (tracks2) => {
  let series = [];
  for (const track of tracks2) {
    if (track.contents) {
      series = series.concat(track.contents);
    } else {
      series.push(track);
    }
  }
  return series;
};
const getSeriesItems = (tracks2, onItemMouseEnter, onItemMouseLeave, onItemClick) => {
  if (!tracks2)
    return null;
  if (window.higlassTracksByType) {
    Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
      TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
    });
  }
  return getAllTracksAndSubtracks(tracks2).map((x) => {
    const thumbnail = TRACKS_INFO_BY_TYPE[x.type] ? TRACKS_INFO_BY_TYPE[x.type].thumbnail : null;
    const imgTag = thumbnail ? /* @__PURE__ */ React$3.createElement("div", {
      className: classes$b["context-menu-icon"],
      dangerouslySetInnerHTML: {
        __html: thumbnail.outerHTML
      }
    }) : /* @__PURE__ */ React$3.createElement("div", {
      className: classes$b["context-menu-icon"]
    }, /* @__PURE__ */ React$3.createElement("svg", null));
    return /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
      key: x.uid,
      className: classes$b["context-menu-item"],
      onClick: () => {
        if (onItemClick)
          onItemClick(x.uid);
      },
      onMouseEnter: (e) => {
        if (onItemMouseEnter)
          onItemMouseEnter(e, x);
      },
      onMouseLeave: (e) => {
        if (onItemMouseLeave)
          onItemMouseLeave(e);
      }
    }, imgTag, /* @__PURE__ */ React$3.createElement("span", {
      className: classes$b["context-menu-span"]
    }, x.options && x.options.name && x.options.name.length ? x.options.name : x.type, onItemMouseEnter && onItemMouseLeave ? /* @__PURE__ */ React$3.createElement("svg", {
      className: classes$b["play-icon"]
    }, /* @__PURE__ */ React$3.createElement("use", {
      xlinkHref: "#play"
    })) : null));
  });
};
function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$d(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$d(descriptor.key), descriptor);
  }
}
function _createClass$e(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$d(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$d(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$d(arg) {
  var key = _toPrimitive$d(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$d(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$d(subClass, superClass);
}
function _setPrototypeOf$d(o, p) {
  _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$d(o, p);
}
function _createSuper$d(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$d(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$d(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$e(this, result);
  };
}
function _possibleConstructorReturn$e(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$d(self2);
}
function _assertThisInitialized$d(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$d() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$d(o) {
  _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$d(o);
}
const SeriesListSubmenuMixin = Mixin((superclass) => /* @__PURE__ */ function(_superclass) {
  _inherits$e(_class, _superclass);
  var _super = _createSuper$d(_class);
  function _class() {
    _classCallCheck$e(this, _class);
    return _super.apply(this, arguments);
  }
  _createClass$e(_class, [{
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        let position = null;
        if (this.state.orientation === "left") {
          position = {
            left: this.state.left,
            top: bbox.top
          };
        } else {
          position = {
            left: this.state.left + bbox.width + 7,
            top: bbox.top
          };
        }
        const series = getAllTracksAndSubtracks(this.props.tracks);
        const selectedTrack = series.filter((t) => t.uid === this.state.submenuShown.uid)[0];
        const canBeReplaced = selectedTrack && !(selectedTrack.position === "whole");
        return /* @__PURE__ */ React$3.createElement(SeriesListMenu, {
          key: `series-list-menu-${selectedTrack.uid}`,
          ref: (c2) => {
            this.seriesListMenu = c2;
          },
          closeMenu: this.props.closeMenu,
          hostTrack: this.props.tracks[0],
          onAddDivisor: this.props.onAddDivisor,
          onAddSeries: canBeReplaced ? this.props.onAddSeries : null,
          onChangeTrackData: this.props.onChangeTrackData,
          onChangeTrackType: this.props.onChangeTrackType,
          onCloseTrack: () => this.props.onCloseTrack(this.state.submenuShown.uid),
          onConfigureTrack: this.props.onConfigureTrack,
          onDivideSeries: this.props.onDivideSeries,
          onExportData: this.props.onExportData,
          onLockScales: this.props.onLockScales,
          onTrackOptionsChanged: this.props.onTrackOptionsChanged,
          orientation: this.state.orientation,
          parentBbox: bbox,
          position,
          series: this.state.submenuShown,
          theme: this.props.theme,
          track: selectedTrack,
          trackOrientation: this.props.trackOrientation,
          trackSourceServers: this.props.trackSourceServers
        });
      }
      return /* @__PURE__ */ React$3.createElement("div", null);
    }
  }]);
  return _class;
}(superclass));
function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$c(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$c(descriptor.key), descriptor);
  }
}
function _createClass$d(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$c(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$c(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$c(arg) {
  var key = _toPrimitive$c(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$c(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get2(target, property2, receiver) {
      var base = _superPropBase(target, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _superPropBase(object2, property2) {
  while (!Object.prototype.hasOwnProperty.call(object2, property2)) {
    object2 = _getPrototypeOf$c(object2);
    if (object2 === null)
      break;
  }
  return object2;
}
function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$c(subClass, superClass);
}
function _setPrototypeOf$c(o, p) {
  _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$c(o, p);
}
function _createSuper$c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$c(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$c(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$d(this, result);
  };
}
function _possibleConstructorReturn$d(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$c(self2);
}
function _assertThisInitialized$c(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$c(o) {
  _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$c(o);
}
let ConfigTrackMenu = /* @__PURE__ */ function(_mix$with) {
  _inherits$d(ConfigTrackMenu2, _mix$with);
  var _super = _createSuper$c(ConfigTrackMenu2);
  function ConfigTrackMenu2(props) {
    var _this;
    _classCallCheck$d(this, ConfigTrackMenu2);
    _this = _super.call(this, props);
    _this.seriesRefs = {};
    _this.seriesListMenu = null;
    return _this;
  }
  _createClass$d(ConfigTrackMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf$c(ConfigTrackMenu2.prototype), "componentDidMount", this).call(this);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx(classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ConfigTrackMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, getSeriesItems(this.props.tracks, this.handleItemMouseEnter.bind(this), this.handleMouseLeave.bind(this), null), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onLockValueScale(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Lock Value Scale With"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onUnlockValueScale(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Unlock Value Scale"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onAddSeries(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Series"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onCloseTrack(this.props.tracks[0].uid)
      }, "Close Track"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => {
          this.props.onReplaceTrack(this.props.tracks[0].uid, this.props.trackOrientation);
        }
      }, "Replace Track"), this.getSubmenu());
    }
  }]);
  return ConfigTrackMenu2;
}(mix(ContextMenuContainer).with(SeriesListSubmenuMixin));
function CloseTrackMenu(props) {
  return /* @__PURE__ */ React$3.createElement("div", null, getSeriesItems(props.tracks, null, null, props.onCloseTrack), /* @__PURE__ */ React$3.createElement("hr", {
    className: classes$b["context-menu-hr"]
  }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
    onClick: () => props.onCloseTrack(props.tracks[0].uid)
  }, "Close all series"));
}
CloseTrackMenu.propTypes = {
  onCloseTrack: PropTypes.func.isRequired,
  tracks: PropTypes.array.isRequired
};
function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$b(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$b(descriptor.key), descriptor);
  }
}
function _createClass$c(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$b(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$b(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$b(arg) {
  var key = _toPrimitive$b(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$b(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$b(subClass, superClass);
}
function _setPrototypeOf$b(o, p) {
  _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$b(o, p);
}
function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$b(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$b(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$c(this, result);
  };
}
function _possibleConstructorReturn$c(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$b(self2);
}
function _assertThisInitialized$b(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$b(o) {
  _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$b(o);
}
let PopupMenu = /* @__PURE__ */ function(_React$Component) {
  _inherits$c(PopupMenu2, _React$Component);
  var _super = _createSuper$b(PopupMenu2);
  function PopupMenu2(props) {
    var _this;
    _classCallCheck$c(this, PopupMenu2);
    _this = _super.call(this, props);
    _this.clickHandlerBound = _this.clickHandler.bind(_assertThisInitialized$b(_this));
    _this.contextMenuHandlerBound = _this.contextMenuHandler.bind(_assertThisInitialized$b(_this));
    _this.resizeHandlerBound = _this.resizeHandler.bind(_assertThisInitialized$b(_this));
    return _this;
  }
  _createClass$c(PopupMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.popup = document.createElement("div");
      document.body.appendChild(this.popup);
      this.popup.style.zIndex = 99;
      this.popup.style.position = "absolute";
      this.popup.className = "hg-popup";
      document.addEventListener("click", this.clickHandlerBound, true);
      document.addEventListener("contextmenu", this.contextMenuHandlerBound, true);
      window.addEventListener("resize", this.resizeHandlerBound, true);
      this._renderLayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._renderLayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.clickHandlerBound, true);
      document.removeEventListener("contextmenu", this.contextMenuHandlerBound, true);
      window.removeEventListener("resize", this.resizeHandlerBound, true);
      ReactDOM.unmountComponentAtNode(this.popup);
      document.body.removeChild(this.popup);
    }
  }, {
    key: "_renderLayer",
    value: function _renderLayer() {
      ReactDOM.render(this.props.children, this.popup);
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(event) {
      if (!this.popup.contains(event.target)) {
        if (this.props.onMenuClosed)
          this.props.onMenuClosed(event);
      }
    }
  }, {
    key: "contextMenuHandler",
    value: function contextMenuHandler(event) {
      if (event.altKey)
        return;
      event.preventDefault();
      this.clickHandler(event);
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      this.props.onMenuClosed(null);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", null);
    }
  }]);
  return PopupMenu2;
}(React$3.Component);
PopupMenu.defaultProps = {
  onMenuClosed: intoTheVoid
};
PopupMenu.propTypes = {
  children: PropTypes.node.isRequired,
  onMenuClosed: PropTypes.func
};
const VerticalItem = sortableElement((props) => /* @__PURE__ */ React$3.createElement(VerticalTrack, {
  className: props.className,
  controlAlignLeft: props.controlAlignLeft,
  editable: props.editable,
  handleConfigTrack: props.handleConfigTrack,
  handleResizeTrack: props.handleResizeTrack,
  height: props.height,
  item: props.item,
  onAddSeries: props.onAddSeries,
  onCloseTrack: props.onCloseTrack,
  onCloseTrackMenuOpened: props.onCloseTrackMenuOpened,
  onConfigTrackMenuOpened: props.onConfigTrackMenuOpened,
  resizeHandles: props.resizeHandles,
  uid: props.uid,
  width: props.width
}));
const styles$3 = {
  "vertical-tiled-plot": "_vertical-tiled-plot_f3ho8_1"
};
function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$a(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$a(descriptor.key), descriptor);
  }
}
function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$a(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$a(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$a(arg) {
  var key = _toPrimitive$a(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$a(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$a(subClass, superClass);
}
function _setPrototypeOf$a(o, p) {
  _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$a(o, p);
}
function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$a(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$a(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$b(this, result);
  };
}
function _possibleConstructorReturn$b(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$a(self2);
}
function _assertThisInitialized$a(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$a(o) {
  _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$a(o);
}
function sourceEvent(event) {
  return event && event.sourceEvent;
}
let VerticalTiledPlot = /* @__PURE__ */ function(_React$Component) {
  _inherits$b(VerticalTiledPlot2, _React$Component);
  var _super = _createSuper$a(VerticalTiledPlot2);
  function VerticalTiledPlot2(props) {
    var _this;
    _classCallCheck$b(this, VerticalTiledPlot2);
    _this = _super.call(this, props);
    _this.brushBehavior = brushY().on("start", _this.brushStarted.bind(_assertThisInitialized$a(_this))).on("brush", _this.brushed.bind(_assertThisInitialized$a(_this))).on("end", _this.brushedEnded.bind(_assertThisInitialized$a(_this)));
    return _this;
  }
  _createClass$b(VerticalTiledPlot2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggered) {
        this.rangeSelectionTriggered = false;
        if (this.rangeSelectionTriggeredEnd && this.props.rangeSelection !== nextProps.rangeSelection) {
          this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, true);
        }
        this.rangeSelectionTriggeredEnd = false;
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        const accessor = this.props.is1dRangeSelection ? 0 : 1;
        this.moveBrush(nextProps.rangeSelection[accessor] ? nextProps.rangeSelection[accessor] : null, nextProps.rangeSelectionEnd);
        return this.state !== nextState;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      } else {
        this.removeBrush();
      }
    }
    /* --------------------------- Getter / Setter ---------------------------- */
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush",
    value: function addBrush() {
      if (!this.brushEl || this.brushElAddedBefore === this.brushEl) {
        return;
      }
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.on(".brush", null);
      }
      this.brushEl.call(this.brushBehavior);
      this.brushElAddedBefore = this.brushEl;
      resetD3BrushStyle(this.brushEl, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushed",
    value: function brushed(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent(event) || !this.props.onRangeSelection || rangeSelectionMoved)
        return;
      this.rangeSelectionTriggered = true;
      this.props.onRangeSelection(event.selection);
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent(event) || !event.selection)
        return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "brushedEnded",
    value: function brushedEnded(event) {
      if (!this.props.is1dRangeSelection)
        return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelection && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggered = true;
        this.rangeSelectionTriggeredEnd = true;
        this.props.onRangeSelectionEnd(event.selection);
      }
      if (!event.selection) {
        this.rangeSelectionTriggered = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "moveBrush",
    value: function moveBrush(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = rangeSelection ? [this.props.scale(rangeSelection[0]), this.props.scale(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushEl.transition().call(this.brushBehavior.move, relRange);
      } else {
        this.brushEl.call(this.brushBehavior.move, relRange);
      }
    }
  }, {
    key: "removeBrush",
    value: function removeBrush() {
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.call(this.brushBehavior.move, null);
        this.brushElAddedBefore.on(".brush", null);
        this.brushElAddedBefore = void 0;
        this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const width = this.props.tracks.map((x) => x.width).reduce(sum, 0);
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or, false);
      const rangeSelectorClass = stylesTrack[this.props.isRangeSelectionActive ? "track-range-selection-active" : "track-range-selection"];
      return /* @__PURE__ */ React$3.createElement("div", {
        className: styles$3["vertical-tiled-plot"]
      }, isBrushable && /* @__PURE__ */ React$3.createElement("svg", {
        ref: (el) => {
          this.brushEl = select$1(el);
        },
        className: rangeSelectorClass,
        style: {
          height: this.props.height,
          width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }), /* @__PURE__ */ React$3.createElement(ListWrapper, {
        axis: "x",
        className: clsx(styles$5.list, styles$5.stylizedList, styles$5.horizontalList),
        component: SortableList,
        editable: this.props.editable,
        handleConfigTrack: this.props.handleConfigTrack,
        handleResizeTrack: this.props.handleResizeTrack,
        height: this.props.height,
        helperClass: styles$5.stylizedHelper,
        itemClass: clsx(styles$5.stylizedItem, styles$5.horizontalItem),
        itemControlAlignLeft: this.props.tracksControlAlignLeft,
        itemReactClass: VerticalItem,
        items: this.props.tracks.map((d) => ({
          configMenuVisible: d.uid === this.props.configTrackMenuId,
          uid: d.uid || slugid$1.nice(),
          height: this.props.height,
          width: d.width,
          value: d.value
        })),
        onAddSeries: this.props.onAddSeries,
        onCloseTrack: this.props.onCloseTrack,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        onSortEnd: this.props.handleSortEnd,
        referenceAncestor: this.props.referenceAncestor,
        resizeHandles: this.props.resizeHandles,
        useDragHandle: true,
        width
      }));
    }
  }]);
  return VerticalTiledPlot2;
}(React$3.Component);
VerticalTiledPlot.propTypes = {
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  handleSortEnd: PropTypes.func,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  height: PropTypes.number,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onRangeSelection: PropTypes.func,
  onRangeSelectionEnd: PropTypes.func,
  onRangeSelectionReset: PropTypes.func,
  onRangeSelectionStart: PropTypes.func,
  rangeSelection: PropTypes.array,
  rangeSelectionEnd: PropTypes.bool,
  referenceAncestor: PropTypes.func,
  resizeHandles: PropTypes.object,
  scale: PropTypes.func,
  tracks: PropTypes.array,
  tracksControlAlignLeft: PropTypes.bool
};
function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$9(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$9(descriptor.key), descriptor);
  }
}
function _createClass$a(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$9(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$9(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$9(arg) {
  var key = _toPrimitive$9(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$9(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$9(subClass, superClass);
}
function _setPrototypeOf$9(o, p) {
  _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$9(o, p);
}
function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$9(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$9(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$a(this, result);
  };
}
function _possibleConstructorReturn$a(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$9(self2);
}
function _assertThisInitialized$9(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$9(o) {
  _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$9(o);
}
let ViewContextMenu = /* @__PURE__ */ function(_mix$with) {
  _inherits$a(ViewContextMenu2, _mix$with);
  var _super = _createSuper$9(ViewContextMenu2);
  function ViewContextMenu2() {
    _classCallCheck$a(this, ViewContextMenu2);
    return _super.apply(this, arguments);
  }
  _createClass$a(ViewContextMenu2, [{
    key: "render",
    value: function render3() {
      const seriesItems = getSeriesItems(this.props.tracks, this.handleItemMouseEnter.bind(this), this.handleMouseLeave.bind(this));
      const customItemsWrapped = this.props.customItems ? React$3.Children.map(this.props.customItems, (child) => /* @__PURE__ */ React$3.cloneElement(child, {
        onMouseEnter: (e) => {
          this.handleOtherMouseEnter(e);
        }
      })) : null;
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx(classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ViewContextMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, customItemsWrapped, customItemsWrapped && /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), seriesItems, seriesItems && /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "horizontal-rule",
          y: this.props.coords[1],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Horizontal Rule"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "vertical-rule",
          x: this.props.coords[0],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Vertical Rule"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "cross-rule",
          x: this.props.coords[0],
          y: this.props.coords[1],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Cross Rule"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), this.hasMatrixTrack(this.props.tracks) && /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.handleAddHorizontalSection.bind(this),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Horizontal Cross Section"), this.hasMatrixTrack(this.props.tracks) && /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.handleAddVerticalSection.bind(this),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Vertical Cross Section"), this.getSubmenu());
    }
  }, {
    key: "hasMatrixTrack",
    value: function hasMatrixTrack(tracks2) {
      const trackList = expandCombinedTracks(this.props.tracks);
      return trackList.filter((track) => track.type === "heatmap").length > 0;
    }
  }, {
    key: "handleAddHorizontalSection",
    value: function handleAddHorizontalSection() {
      const trackList = expandCombinedTracks(this.props.tracks);
      const matrixTrack = trackList.filter((track) => track.type === "heatmap")[0];
      this.props.onAddTrack({
        type: "horizontal-rule",
        y: this.props.coords[1],
        position: "whole"
      });
      this.props.onAddTrack({
        data: {
          type: "horizontal-section",
          server: matrixTrack.server,
          tilesetUid: matrixTrack.tilesetUid,
          slicePos: this.props.coords[1]
        },
        options: {
          valueScaling: "log"
        },
        type: "horizontal-bar",
        height: 30,
        position: "top"
      });
    }
  }, {
    key: "handleAddVerticalSection",
    value: function handleAddVerticalSection() {
      const trackList = expandCombinedTracks(this.props.tracks);
      const matrixTrack = trackList.filter((track) => track.type === "heatmap")[0];
      this.props.onAddTrack({
        type: "vertical-rule",
        x: this.props.coords[0],
        position: "whole"
      });
      this.props.onAddTrack({
        data: {
          type: "vertical-section",
          server: matrixTrack.server,
          tilesetUid: matrixTrack.tilesetUid,
          slicePos: this.props.coords[0]
        },
        options: {
          valueScaling: "log"
        },
        type: "vertical-bar",
        height: 30,
        position: "left"
      });
    }
  }]);
  return ViewContextMenu2;
}(mix(ContextMenuContainer).with(SeriesListSubmenuMixin));
ViewContextMenu.propTypes = {
  // the data coordinates where this context menu was initiated
  coords: PropTypes.array,
  customItems: PropTypes.array
};
function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$8(descriptor.key), descriptor);
  }
}
function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$8(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$8(arg) {
  var key = _toPrimitive$8(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$8(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$8(subClass, superClass);
}
function _setPrototypeOf$8(o, p) {
  _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$8(o, p);
}
function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$8(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$8(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$9(this, result);
  };
}
function _possibleConstructorReturn$9(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$8(self2);
}
function _assertThisInitialized$8(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$8(o) {
  _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$8(o);
}
let TiledPlot = /* @__PURE__ */ function(_React$Component) {
  _inherits$9(TiledPlot2, _React$Component);
  var _super = _createSuper$8(TiledPlot2);
  function TiledPlot2(props) {
    var _this;
    _classCallCheck$9(this, TiledPlot2);
    _this = _super.call(this, props);
    _this.closing = false;
    const {
      tracks: tracks2
    } = _this.props;
    _this.canvasElement = null;
    _this.tracksByUidInit = {};
    [..._this.props.tracks.top || [], ..._this.props.tracks.right || [], ..._this.props.tracks.bottom || [], ..._this.props.tracks.left || [], ..._this.props.tracks.gallery || [], ..._this.props.tracks.center || []].forEach((track) => {
      if (track.type === "combined") {
        track.contents.forEach((track2) => {
          _this.tracksByUidInit[track2.uid] = false;
        });
      } else {
        _this.tracksByUidInit[track.uid] = false;
      }
    });
    _this.xScale = null;
    _this.yScale = null;
    _this.addUidsToTracks(tracks2);
    _this.trackToReplace = null;
    _this.trackRenderer = null;
    _this.configTrackMenu = null;
    _this.state = {
      sizeMeasured: false,
      height: 10,
      width: 10,
      tracks: tracks2,
      init: false,
      addTrackPosition: null,
      customDialog: null,
      mouseOverOverlayUid: null,
      // trackOptions: null
      // trackOptions: trackOptions
      forceUpdate: 0,
      // a random value that will be assigned by
      // crucial functions to force an update
      rangeSelection: [null, null],
      rangeSelectionEnd: false,
      chromInfo: null,
      defaultChromSizes: null,
      contextMenuCustomItems: null,
      contextMenuPosition: null,
      addDivisorDialog: null
    };
    _this.reset = true;
    if (window.higlassTracksByType) {
      Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
        TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
      });
    }
    _this.topHeight = 0;
    _this.bottomHeight = 0;
    _this.leftWidth = 0;
    _this.rightWidth = 0;
    _this.centerHeight = 0;
    _this.centerWidth = 0;
    _this.dragTimeout = null;
    _this.previousPropsStr = "";
    _this.contextMenuHandlerBound = _this.contextMenuHandler.bind(_assertThisInitialized$8(_this));
    _this.handleNoTrackAddedBound = _this.handleNoTrackAdded.bind(_assertThisInitialized$8(_this));
    _this.handleTracksAddedBound = _this.handleTracksAdded.bind(_assertThisInitialized$8(_this));
    _this.closeMenusBound = _this.closeMenus.bind(_assertThisInitialized$8(_this));
    _this.handleAddDivisorBound = _this.handleAddDivisor.bind(_assertThisInitialized$8(_this));
    _this.handleAddSeriesBound = _this.handleAddSeries.bind(_assertThisInitialized$8(_this));
    _this.handleChangeTrackDataBound = _this.handleChangeTrackData.bind(_assertThisInitialized$8(_this));
    _this.handleChangeTrackTypeBound = _this.handleChangeTrackType.bind(_assertThisInitialized$8(_this));
    _this.handleCloseTrackBound = _this.handleCloseTrack.bind(_assertThisInitialized$8(_this));
    _this.handleConfigureTrackBound = _this.handleConfigureTrack.bind(_assertThisInitialized$8(_this));
    _this.handleExportTrackDataBound = _this.handleExportTrackData.bind(_assertThisInitialized$8(_this));
    _this.handleLockValueScaleBound = _this.handleLockValueScale.bind(_assertThisInitialized$8(_this));
    _this.handleReplaceTrackBound = _this.handleReplaceTrack.bind(_assertThisInitialized$8(_this));
    _this.handleTrackOptionsChangedBound = _this.handleTrackOptionsChanged.bind(_assertThisInitialized$8(_this));
    _this.handleUnlockValueScaleBound = _this.handleUnlockValueScale.bind(_assertThisInitialized$8(_this));
    _this.onAddTrack = _this.handleAddTrack.bind(_assertThisInitialized$8(_this));
    return _this;
  }
  _createClass$9(TiledPlot2, [{
    key: "waitForDOMAttachment",
    value: function waitForDOMAttachment(callback) {
      if (!this.mounted)
        return;
      const thisElement = ReactDOM.findDOMNode(this);
      if (document.body.contains(thisElement)) {
        callback();
      } else {
        requestAnimationFrame(() => this.waitForDOMAttachment(callback));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.element = ReactDOM.findDOMNode(this);
      this.canvasElement = ReactDOM.findDOMNode(this.props.canvasElement);
      this.waitForDOMAttachment(() => {
        cssElementQueries.ElementQueries.listen();
        this.resizeSensor = new cssElementQueries.ResizeSensor(this.element.parentNode, this.measureSize.bind(this));
        this.measureSize();
      });
      this.addEventListeners();
      this.pubSubs = [];
      this.pubSubs.push(this.props.pubSub.subscribe("contextmenu", this.contextMenuHandlerBound));
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.addUidsToTracks(newProps.tracks);
      this.setState({
        tracks: newProps.tracks
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      const thisPropsStr = this.previousPropsStr;
      const nextPropsStr = this.updatablePropsToString(nextProps);
      const thisStateStr = JSON.stringify(this.state);
      const nextStateStr = JSON.stringify(nextState);
      const toUpdate = thisPropsStr !== nextPropsStr || thisStateStr !== nextStateStr || this.props.chooseTrackHandler !== nextProps.chooseTrackHandler || this.props.customDialog !== nextProps.customDialog;
      if (toUpdate)
        this.previousPropsStr = nextPropsStr;
      const numPrevTracks = this.numTracks;
      this.numTracks = 0;
      visitPositionedTracks(this.props.tracks, () => this.numTracks++);
      this.reset = this.reset || numPrevTracks === 0 && this.numTracks > 0;
      if (!this.numTracks)
        this.tracksByUidInit = {};
      return toUpdate;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.rangeSelection !== this.state.rangeSelection) {
        let genomicRange = [null, null];
        if (this.state.defaultChromSizes && this.state.rangeSelection.every((range2) => range2 && range2.length)) {
          genomicRange = this.state.rangeSelection.map((range2) => dataToGenomicLoci(...range2, this.state.defaultChromSizes));
        }
        this.props.onRangeSelection({
          dataRange: this.state.rangeSelection,
          genomicRange
        });
      }
      if (this.state.customDialog || this.props.customDialog) {
        const dialogData = this.state.customDialog || this.props.customDialog;
        if (dialogData.length > 0) {
          const componentArray = [];
          const bodyPropsArray = [];
          dialogData.forEach((dd) => {
            componentArray.push(dd.bodyComponent);
            bodyPropsArray.push(dd.bodyProps);
          });
          this.props.modal.open(/* @__PURE__ */ React$3.createElement(CustomTrackDialog, {
            children: componentArray,
            bodyProps: bodyPropsArray,
            onCancel: this.props.closeCustomDialog,
            title: dialogData[0].title
          }));
        }
      }
      if (prevProps.tracks.center !== this.props.tracks.center)
        ;
      if (this.state.addTrackPosition || this.props.addTrackPosition) {
        this.props.modal.open(/* @__PURE__ */ React$3.createElement(AddTrackDialog, {
          host: this.state.addTrackHost,
          onCancel: this.handleNoTrackAddedBound,
          onTracksChosen: this.handleTracksAddedBound,
          position: this.state.addTrackPosition || this.props.addTrackPosition,
          trackSourceServers: this.props.trackSourceServers
        }));
      }
      if (this.state.addDivisorDialog) {
        const series = this.state.addDivisorDialog;
        this.props.modal.open(/* @__PURE__ */ React$3.createElement(AddTrackDialog, {
          datatype: TRACKS_INFO_BY_TYPE[series.type].datatype[0],
          host: this.state.addTrackHost,
          onCancel: () => {
            this.setState({
              addDivisorDialog: null
            });
          },
          onTracksChosen: (newTrack) => {
            this.handleDivisorChosen(series, newTrack);
          },
          trackSourceServers: this.props.trackSourceServers
        }));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closing = true;
      this.removeEventListeners();
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
    }
  }, {
    key: "addUidsToTracks",
    value: function addUidsToTracks(positionedTracks) {
      Object.keys(positionedTracks).forEach((position) => {
        positionedTracks[position].forEach((track) => {
          track.uid = track.uid || slugid$1.nice();
        });
      });
    }
    /*
    getDefaultChromSizes() {
      try {
        const centralHeatmap = this.findCentralHeatmapTrack(
          this.props.tracks.center
        );
        this.getChromInfo = chromInfo
          .get(`${centralHeatmap.server}/chrom-sizes/?id=${centralHeatmap.tilesetUid}`)
          .then(defaultChromSizes => this.setState({ defaultChromSizes }));
      } catch (err) {  }
    }
    */
  }, {
    key: "contextMenuHandler",
    value: function contextMenuHandler(e) {
      if (!this.divTiledPlot)
        return;
      const bBox = this.divTiledPlot.getBoundingClientRect();
      const isClickWithin = isWithin(e.clientX, e.clientY, bBox.left, bBox.left + bBox.width, bBox.top, bBox.top + bBox.height);
      if (!isClickWithin)
        return;
      const mousePos = [e.clientX, e.clientY];
      const canvasMousePos = pointer(e, this.divTiledPlot);
      const xVal = this.trackRenderer.zoomedXScale.invert(canvasMousePos[0]);
      const yVal = this.trackRenderer.zoomedYScale.invert(canvasMousePos[1]);
      let contextMenuCustomItems = null;
      if (e.hgCustomItems) {
        contextMenuCustomItems = e.hgCustomItems.map((item) => /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
          key: item.key,
          onClick: item.onClick
        }, item.text));
      }
      this.setState({
        contextMenuCustomItems,
        contextMenuPosition: {
          left: mousePos[0],
          top: mousePos[1],
          canvasLeft: canvasMousePos[0] + this.trackRenderer.xPositionOffset,
          canvasTop: canvasMousePos[1] + this.trackRenderer.yPositionOffset
        },
        contextMenuDataX: xVal,
        contextMenuDataY: yVal
      });
    }
  }, {
    key: "measureSize",
    value: function measureSize() {
      if (this.element.clientWidth > 0 && this.element.clientHeight > 0) {
        this.setState({
          sizeMeasured: true,
          width: this.element.clientWidth,
          height: this.element.clientHeight
        });
      }
    }
  }, {
    key: "handleTrackOptionsChanged",
    value: function handleTrackOptionsChanged(trackUid, newOptions) {
      return this.props.onTrackOptionsChanged(trackUid, newOptions);
    }
  }, {
    key: "handleScalesChanged",
    value: function handleScalesChanged(x, y) {
      this.xScale = x;
      this.yScale = y;
      this.props.onScalesChanged(x, y);
    }
    /**
     * We've received information about a tileset from the server. Register it
     * with the track definition.
     * @param trackUid (string): The identifier for the track
     * @param tilesetInfo (object): Information about the track (hopefully including
     *                              its name.
     */
  }, {
    key: "handleTilesetInfoReceived",
    value: function handleTilesetInfoReceived(trackUid, tilesetInfo) {
      const track = getTrackByUid(this.props.tracks, trackUid);
      if (!track) {
        console.warn("Strange, track not found:", trackUid);
        return;
      }
      this.tracksByUidInit[track.uid] = true;
      this.checkAllTilesetInfoReceived();
      if (!track.options) {
        track.options = {};
      }
      track.name = tilesetInfo.name;
      track.maxWidth = tilesetInfo.max_width;
      track.transforms = tilesetInfo.transforms;
      track.aggregationModes = tilesetInfo.aggregation_modes;
      track.header = tilesetInfo.header;
      track.binsPerDimension = tilesetInfo.bins_per_dimension;
      if (tilesetInfo.resolutions) {
        track.maxZoom = tilesetInfo.resolutions.length - 1;
        track.resolutions = tilesetInfo.resolutions;
      } else {
        track.maxZoom = tilesetInfo.max_zoom;
      }
      track.coordSystem = tilesetInfo.coordSystem;
      track.datatype = tilesetInfo.datatype;
    }
    /**
     * Check if all track which are expecting a tileset info have been loaded.
     */
  }, {
    key: "checkAllTilesetInfoReceived",
    value: function checkAllTilesetInfoReceived() {
      if (this.state.init && !this.reset || !this.trackRenderer || !this.props.zoomToDataExtentOnInit()) {
        return;
      }
      const allTracksWithTilesetInfos = Object.keys(this.trackRenderer.trackDefObjects).map((trackUuid) => {
        const track = this.trackRenderer.trackDefObjects[trackUuid].trackObject;
        if (track.childTracks)
          return track.childTracks;
        return track;
      }).reduce((a, b) => a.concat(b), []).filter(({
        tilesetInfo
      }) => typeof tilesetInfo !== "undefined" && tilesetInfo !== true);
      const loadedTilesetInfos = Object.values(this.tracksByUidInit).filter((x) => x).length;
      if (allTracksWithTilesetInfos.length === loadedTilesetInfos) {
        this.setState({
          init: true
        });
        this.reset = false;
        this.handleZoomToData();
      }
    }
  }, {
    key: "handleOverlayMouseEnter",
    value: function handleOverlayMouseEnter(uid) {
      this.setState({
        mouseOverOverlayUid: uid
      });
    }
  }, {
    key: "handleOverlayMouseLeave",
    value: function handleOverlayMouseLeave(uid) {
      if (uid === this.state.mouseOverOverlayUid) {
        this.setState({
          mouseOverOverlayUid: null
        });
      }
    }
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(pTrack) {
      this.setState({
        mouseOverOverlayUid: null
      });
      this.props.chooseTrackHandler(pTrack.track.uid);
    }
  }, {
    key: "handleNoTrackAdded",
    value: function handleNoTrackAdded() {
      this.trackToReplace = null;
      this.props.onNoTrackAdded();
      this.setState({
        addTrackPosition: null,
        addTrackHost: null
      });
    }
  }, {
    key: "handleAddDivisor",
    value: function handleAddDivisor(series) {
      this.setState({
        addDivisorDialog: series
      });
    }
    /**
     * The user has selected a track that they wish to use to normalize another
     * track.
     */
  }, {
    key: "handleDivisorChosen",
    value: function handleDivisorChosen(series, newTrack) {
      this.setState({
        addDivisorDialog: null
      });
      const numerator = series.data ? {
        server: series.data.server,
        tilesetUid: series.data.tilesetUid
      } : {
        server: series.server,
        tilesetUid: series.tilesetUid
      };
      const denominator = {
        server: newTrack[0].server,
        tilesetUid: newTrack[0].uuid
      };
      this.handleChangeTrackData(series.uid, {
        type: "divided",
        children: [numerator, denominator]
      });
    }
  }, {
    key: "handleDivideSeries",
    value: function handleDivideSeries(seriesUid) {
    }
  }, {
    key: "handleAddSeries",
    value: function handleAddSeries(trackUid) {
      const trackPosition = getTrackPositionByUid(this.props.tracks, trackUid);
      const track = getTrackByUid(this.props.tracks, trackUid);
      this.setState({
        addTrackPosition: trackPosition,
        addTrackHost: track
      });
    }
  }, {
    key: "handleReplaceTrack",
    value: function handleReplaceTrack(uid, orientation2) {
      this.trackToReplace = uid;
      this.handleAddTrack(orientation2);
    }
  }, {
    key: "handleAddTrack",
    value: function handleAddTrack(position) {
      this.setState({
        addTrackPosition: position,
        addTrackHost: null
      });
    }
  }, {
    key: "handleResizeTrack",
    value: function handleResizeTrack(uid, width, height2) {
      const {
        tracks: tracks2
      } = this.state;
      for (const trackType in tracks2) {
        const theseTracks = tracks2[trackType];
        const filteredTracks = theseTracks.filter((d) => d.uid === uid);
        if (filteredTracks.length > 0) {
          filteredTracks[0].width = width;
          filteredTracks[0].height = height2;
        }
      }
      this.setState({
        tracks: tracks2,
        forceUpdate: Math.random()
      });
      this.props.onResizeTrack();
    }
  }, {
    key: "closeMenus",
    value: function closeMenus() {
      this.setState({
        closeTrackMenuId: null,
        configTrackMenuId: null,
        contextMenuPosition: null,
        contextMenuCustomItems: null
      });
    }
  }, {
    key: "handleLockValueScale",
    value: function handleLockValueScale(uid) {
      this.closeMenus();
      this.props.onLockValueScale(uid);
    }
  }, {
    key: "handleUnlockValueScale",
    value: function handleUnlockValueScale(uid) {
      this.closeMenus();
      this.props.onUnlockValueScale(uid);
    }
  }, {
    key: "handleCloseTrack",
    value: function handleCloseTrack(uid) {
      this.closeMenus();
      this.props.onCloseTrack(uid);
    }
  }, {
    key: "handleChangeTrackType",
    value: function handleChangeTrackType(uid, newType) {
      this.closeMenus();
      this.props.onChangeTrackType(uid, newType);
    }
    /**
     * Change this tracks data section so that it
     * is either of type "divided" or the "divided"
     * type is removed
     */
  }, {
    key: "handleChangeTrackData",
    value: function handleChangeTrackData(uid, newData) {
      this.closeMenus();
      this.props.onChangeTrackData(uid, newData);
    }
  }, {
    key: "handleTracksAdded",
    value: function handleTracksAdded(newTracks, position, host) {
      if (this.trackToReplace) {
        this.handleCloseTrack(this.trackToReplace);
        this.trackToReplace = null;
      }
      this.props.onTracksAdded(newTracks, position, host);
      this.setState({
        addTrackPosition: null,
        addTrackHost: null
      });
      return newTracks;
    }
  }, {
    key: "handleCloseTrackMenuOpened",
    value: function handleCloseTrackMenuOpened(uid, clickPosition) {
      this.setState({
        closeTrackMenuId: uid,
        closeTrackMenuLocation: clickPosition
      });
    }
  }, {
    key: "handleCloseContextMenu",
    value: function handleCloseContextMenu() {
      this.setState({
        contextMenuCustomItems: null,
        contextMenuPosition: null,
        contextMenuDataX: null,
        contextMenuDataY: null
      });
    }
  }, {
    key: "handleCloseTrackMenuClosed",
    value: function handleCloseTrackMenuClosed() {
      this.setState({
        closeTrackMenuId: null
      });
    }
  }, {
    key: "handleConfigTrackMenuOpened",
    value: function handleConfigTrackMenuOpened(uid, clickPosition) {
      this.closeMenus();
      this.setState({
        configTrackMenuId: uid,
        configTrackMenuLocation: clickPosition
      });
    }
  }, {
    key: "handleConfigureTrack",
    value: function handleConfigureTrack(track, configComponent) {
      this.setState({
        configTrackMenuId: null,
        trackOptions: {
          track,
          configComponent
        }
      });
      this.closeMenus();
    }
  }, {
    key: "handleSortEnd",
    value: function handleSortEnd(sortedTracks) {
      this.setState((prevState) => {
        const tracks2 = prevState.tracks;
        const positions = {};
        for (let i = 0; i < sortedTracks.length; i++) {
          positions[sortedTracks[i].uid] = i;
        }
        for (const trackType in tracks2) {
          const theseTracks = tracks2[trackType];
          if (!theseTracks.length) {
            continue;
          }
          if (theseTracks[0].uid in positions) {
            const newTracks = new Array(theseTracks.length);
            for (let i = 0; i < theseTracks.length; i++) {
              newTracks[positions[theseTracks[i].uid]] = theseTracks[i];
            }
            tracks2[trackType] = newTracks;
          }
        }
        return {
          tracks: tracks2,
          forceUpdate: Math.random()
        };
      });
    }
  }, {
    key: "createTracksAndLocations",
    value: function createTracksAndLocations() {
      const tracksAndLocations = [];
      const {
        tracks: tracks2
      } = this.state;
      TRACK_LOCATIONS.forEach((location) => {
        if (tracks2[location]) {
          tracks2[location].forEach((track) => {
            if (track.contents) {
              track.contents.forEach((content) => {
                content.position = location;
              });
            }
            track.position = location;
            tracksAndLocations.push({
              track,
              location
            });
          });
        }
      });
      return tracksAndLocations;
    }
    /**
     * Calculate where a track is absoluately positioned within the drawing area
     *
     * @param track: The track object (with members, e.g. track.uid, track.width,
     *   track.height)
     * @param location: Where it's being plotted (e.g. 'top', 'bottom')
     * @return: The position of the track and it's height and width
     *          (e.g. {left: 10, top: 20, width: 30, height: 40}
     */
  }, {
    key: "calculateTrackPosition",
    value: function calculateTrackPosition(track, location) {
      let top2 = this.props.paddingTop;
      let bottom2 = this.props.paddingBottom;
      let left2 = this.props.paddingLeft;
      let right2 = this.props.paddingRight;
      let width = this.centerWidth;
      let height2 = track.height;
      let offsetX = 0;
      let offsetY = 0;
      switch (location) {
        case "top":
          left2 += this.leftWidth;
          for (let i = 0; i < this.state.tracks.top.length; i++) {
            if (this.state.tracks.top[i].uid === track.uid) {
              break;
            } else {
              top2 += this.state.tracks.top[i].height;
            }
          }
          break;
        case "bottom":
          left2 += this.leftWidth;
          top2 += this.topHeight + this.centerHeight + this.galleryDim;
          for (let i = 0; i < this.state.tracks.bottom.length; i++) {
            if (this.state.tracks.bottom[i].uid === track.uid) {
              break;
            } else {
              top2 += this.state.tracks.bottom[i].height;
            }
          }
          break;
        case "left":
          top2 += this.topHeight;
          width = track.width;
          height2 = this.centerHeight;
          for (let i = 0; i < this.state.tracks.left.length; i++) {
            if (this.state.tracks.left[i].uid === track.uid) {
              break;
            } else {
              left2 += this.state.tracks.left[i].width;
            }
          }
          break;
        case "right":
          left2 += this.leftWidth + this.centerWidth + this.galleryDim;
          top2 += this.topHeight;
          width = track.width;
          height2 = this.centerHeight;
          for (let i = 0; i < this.state.tracks.right.length; i++) {
            if (this.state.tracks.right[i].uid === track.uid) {
              break;
            } else {
              left2 += this.state.tracks.right[i].width;
            }
          }
          break;
        case "center":
          left2 += this.leftWidth;
          top2 += this.topHeight;
          height2 = this.centerHeight;
          break;
        case "gallery":
          left2 += this.leftWidthNoGallery;
          top2 += this.topHeightNoGallery;
          width = this.state.width - this.leftWidthNoGallery - this.rightWidthNoGallery - this.props.paddingLeft;
          height2 = this.state.height - this.topHeightNoGallery - this.bottomHeightNoGallery - this.props.paddingTop;
          offsetX = this.galleryDim;
          offsetY = this.galleryDim;
          for (let i = 0; i < this.state.tracks.gallery.length; i++) {
            if (this.state.tracks.gallery[i].uid === track.uid) {
              break;
            } else {
              width -= 2 * this.state.tracks.gallery[i].height;
              height2 -= 2 * this.state.tracks.gallery[i].height;
              left2 += this.state.tracks.gallery[i].height;
              top2 += this.state.tracks.gallery[i].height;
              offsetX -= this.state.tracks.gallery[i].height;
              offsetY -= this.state.tracks.gallery[i].height;
            }
          }
          for (let i = 0; i < this.state.tracks.right.length; i++) {
            right2 += this.state.tracks.right[i].width;
          }
          for (let i = 0; i < this.state.tracks.bottom.length; i++) {
            bottom2 += this.state.tracks.bottom[i].height;
          }
          track.offsetX = offsetX;
          track.offsetY = offsetY;
          track.offsetTop = top2;
          track.offsetRight = right2;
          track.offsetBottom = bottom2;
          track.offsetLeft = left2;
          break;
        case "whole":
        default:
          width = this.leftWidth + this.centerWidth + this.rightWidth;
          height2 = this.topHeight + this.centerHeight + this.bottomHeight;
      }
      if (TRACK_LOCATIONS.indexOf(location) === -1) {
        console.warn("Track with unknown position present:", location, track);
      }
      return {
        left: left2,
        top: top2,
        width,
        height: height2,
        track
      };
    }
    /**
     * Find a central heatmap track among all displayed tracks
     *
     * @param  {Array}  tracks  Tracks to be searched.
     * @return  {Object}  The first central heatmap track or `undefined`.
     */
  }, {
    key: "findCentralHeatmapTrack",
    value: function findCentralHeatmapTrack(tracks2) {
      for (let i = 0; i < tracks2.length; i++) {
        if (tracks2[i].type === "combined") {
          return this.findCentralHeatmapTrack(tracks2[i].contents);
        }
        if (tracks2[i].type === "heatmap")
          return tracks2[i];
      }
      return void 0;
    }
  }, {
    key: "trackUuidToOrientation",
    value: function trackUuidToOrientation(trackUuid) {
    }
  }, {
    key: "overlayTracks",
    value: function overlayTracks(positionedTracks) {
      if (this.props.overlays) {
        const overlayDefs = this.props.overlays.filter((overlayTrack) => overlayTrack.includes && overlayTrack.includes.length).map((overlayTrack) => {
          const type3 = overlayTrack.type ? `overlay-${overlayTrack.type}-track` : "overlay-track";
          const overlayDef = {
            ...overlayTrack,
            uid: overlayTrack.uid || slugid$1.nice(),
            includes: overlayTrack.includes,
            type: type3,
            options: Object.assign(overlayTrack.options, {
              orientationsAndPositions: overlayTrack.includes.map((trackUuid) => {
                const includedTrack = getTrackByUid(this.props.tracks, trackUuid);
                if (!includedTrack) {
                  console.warn(`OverlayTrack included uid (${trackUuid}) not found in the track list`);
                  return null;
                }
                const trackPos = getTrackPositionByUid(this.props.tracks, includedTrack.uid);
                let orientation2;
                if (trackPos === "top" || trackPos === "bottom") {
                  orientation2 = "1d-horizontal";
                }
                if (trackPos === "left" || trackPos === "right") {
                  orientation2 = "1d-vertical";
                }
                if (trackPos === "center") {
                  orientation2 = "2d";
                }
                if (!orientation2) {
                  console.warn("Only top, bottom, left, right, or center tracks can be overlaid at the moment");
                  return null;
                }
                const positionedTrack = positionedTracks.filter((track) => track.track.uid === trackUuid);
                if (!positionedTrack.length) {
                  return null;
                }
                const position = {
                  left: positionedTrack[0].left - this.props.paddingLeft,
                  top: positionedTrack[0].top - this.props.paddingTop,
                  width: positionedTrack[0].width,
                  height: positionedTrack[0].height
                };
                return {
                  orientation: orientation2,
                  position
                };
              }).filter((x) => x)
              // filter out null entries
            })
          };
          return {
            top: this.props.paddingTop,
            left: this.props.paddingLeft,
            width: this.leftWidth + this.centerWidth + this.rightWidth,
            height: this.topHeight + this.centerHeight + this.bottomHeight + this.props.marginTop + this.props.marginBottom,
            track: overlayDef
          };
        });
        return overlayDefs;
      }
      return [];
    }
  }, {
    key: "positionedTracks",
    value: function positionedTracks() {
      const tracksAndLocations = this.createTracksAndLocations().map(({
        track,
        location
      }) => this.calculateTrackPosition(track, location));
      return tracksAndLocations;
    }
  }, {
    key: "createTrackPositionTexts",
    value: function createTrackPositionTexts() {
      const positionedTracks = this.positionedTracks();
      this.createTracksAndLocations();
      const trackElements = positionedTracks.map((trackPosition) => {
        const {
          track
        } = trackPosition;
        return /* @__PURE__ */ React$3.createElement("div", {
          key: track.uid,
          style: {
            left: trackPosition.left,
            top: trackPosition.top,
            width: trackPosition.width,
            height: trackPosition.height,
            position: "absolute"
          }
        }, track.uid.slice(0, 2));
      });
      return trackElements;
    }
  }, {
    key: "handleExportTrackData",
    value: function handleExportTrackData(hostTrackUid, trackUid) {
      const track = getTrackByUid(this.props.tracks, trackUid);
      let trackObject = null;
      if (hostTrackUid !== trackUid) {
        trackObject = this.trackRenderer.trackDefObjects[hostTrackUid].trackObject.createdTracks[track.uid];
      } else {
        ({
          trackObject
        } = this.trackRenderer.trackDefObjects[hostTrackUid]);
      }
      trackObject.exportData();
      this.closeMenus();
    }
    /**
     * List all the tracks that are under this mouse position
     */
  }, {
    key: "listTracksAtPosition",
    value: function listTracksAtPosition(x, y, isReturnTrackObj = false) {
      const trackObjectsAtPosition = [];
      if (!this.trackRenderer)
        return [];
      for (const uid in this.trackRenderer.trackDefObjects) {
        const trackObj = this.trackRenderer.trackDefObjects[uid].trackObject;
        if (trackObj.respondsToPosition(x, y)) {
          if (isReturnTrackObj) {
            if (this.props.tracks.center) {
              if (this.props.tracks.center.contents) {
                for (let i = 0; i < this.props.tracks.center.contents.length; i++) {
                  if (this.props.tracks.center.contents[i].uid === uid) {
                    trackObj.is2d = true;
                  }
                }
              } else if (this.props.tracks.center && this.props.tracks.center.length && this.props.tracks.center[0].uid === uid) {
                trackObj.is2d = true;
              }
            }
            trackObjectsAtPosition.push(trackObj);
          } else {
            trackObjectsAtPosition.push(this.trackRenderer.trackDefObjects[uid].trackDef.track);
          }
        }
      }
      return trackObjectsAtPosition;
    }
  }, {
    key: "listAllTrackObjects",
    value: function listAllTrackObjects() {
      const trackObjectsToCheck = [];
      for (const uid in this.trackRenderer.trackDefObjects) {
        const tdo = this.trackRenderer.trackDefObjects[uid];
        if (tdo.trackObject.createdTracks) {
          for (const uid1 in tdo.trackObject.createdTracks) {
            const trackObject = tdo.trackObject.createdTracks[uid1];
            trackObjectsToCheck.push(trackObject);
          }
        } else {
          trackObjectsToCheck.push(tdo.trackObject);
        }
      }
      return trackObjectsToCheck;
    }
  }, {
    key: "handleZoomToData",
    value: function handleZoomToData() {
      const maxSafeInt = Number.MAX_SAFE_INTEGER;
      const minSafeInt = Number.MIN_SAFE_INTEGER;
      const minPos = [maxSafeInt, maxSafeInt];
      const maxPos = [minSafeInt, minSafeInt];
      const trackObjectsToCheck = this.listAllTrackObjects();
      for (const trackObject of trackObjectsToCheck) {
        if (trackObject.tilesetInfo) {
          if (trackObject.tilesetInfo.min_pos) {
            for (let j = 0; j < trackObject.tilesetInfo.min_pos.length; j++) {
              if (trackObject.tilesetInfo.min_pos[j] < minPos[j]) {
                minPos[j] = trackObject.tilesetInfo.min_pos[j];
              }
              if (trackObject.tilesetInfo.max_pos[j] > maxPos[j]) {
                maxPos[j] = trackObject.tilesetInfo.max_pos[j];
              }
            }
          }
        }
      }
      const left2 = this.trackRenderer.currentProps.paddingLeft + this.trackRenderer.currentProps.leftWidth;
      let newXDomain = [left2, left2 + this.trackRenderer.currentProps.centerWidth].map(this.trackRenderer.zoomTransform.rescaleX(this.trackRenderer.xScale).invert);
      const top2 = this.trackRenderer.currentProps.paddingTop + this.trackRenderer.currentProps.topHeight;
      let newYDomain = [top2, top2 + this.trackRenderer.currentProps.centerHeight].map(this.trackRenderer.zoomTransform.rescaleY(this.trackRenderer.yScale).invert);
      this.trackRenderer.zoomTransform.k = 1;
      this.trackRenderer.zoomTransform.x = 0;
      this.trackRenderer.zoomTransform.y = 0;
      this.trackRenderer.applyZoomTransform();
      if (minPos[0] < Number.MAX_SAFE_INTEGER && maxPos[0] > Number.MIN_SAFE_INTEGER) {
        newXDomain = [minPos[0], maxPos[0]];
      }
      if (minPos[1] < Number.MAX_SAFE_INTEGER && maxPos[1] > Number.MIN_SAFE_INTEGER) {
        newYDomain = [minPos[1], maxPos[1]];
      }
      this.props.onDataDomainChanged(newXDomain, newYDomain);
    }
  }, {
    key: "resetViewport",
    value: function resetViewport() {
      this.trackRenderer.zoomTransform.k = 1;
      this.trackRenderer.zoomTransform.x = 0;
      this.trackRenderer.zoomTransform.y = 0;
      this.trackRenderer.applyZoomTransform();
      this.props.onDataDomainChanged(this.props.initialXDomain, this.props.initialYDomain);
    }
  }, {
    key: "updatablePropsToString",
    value: function updatablePropsToString(props) {
      return JSON.stringify({
        tracks: props.tracks,
        overlays: props.overlays,
        viewOptions: props.viewOptions,
        uid: props.uid,
        addTrackPosition: props.addTrackPosition,
        editable: props.editable,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        paddingTop: props.paddingTop,
        paddingBottom: props.paddingBottom,
        paddingLeft: props.paddingLeft,
        paddingRight: props.paddingRight,
        mouseTool: props.mouseTool,
        initialXDomain: props.initialXDomain,
        initialYDomain: props.initialYDomain,
        trackSourceServers: props.trackSourceServers,
        zoomable: props.zoomable,
        draggingHappening: props.draggingHappening
      });
    }
  }, {
    key: "getXYScales",
    value: function getXYScales() {
      if (this.trackRenderer) {
        this.xScale = this.trackRenderer.currentXScale;
        this.yScale = this.trackRenderer.currentYScale;
      }
    }
    /**
     * Translate view to data location.
     *
     * @description
     * The view location is in pixels relative to the browser window. The data
     * location is given by the scaling relative to the initial x and y domains.
     * And the genomic location depends on the chrom sizes.
     *
     * @method  rangeViewToDataLoci
     * @author  Fritz Lekschas
     * @date    2018-01-14
     * @param  {Array}  range  Selected view range
     * @param  {Function}  scale  View to data scaling
     * @return  {Array}  2D array of data locations
     */
  }, {
    key: "rangeViewToDataLoci",
    value: function rangeViewToDataLoci(range2, scale) {
      if (!scale)
        return [null, null];
      return [parseInt(scale.invert(range2[0]), 10), parseInt(scale.invert(range2[1]), 10)];
    }
  }, {
    key: "rangeSelectionResetHandler",
    value: function rangeSelectionResetHandler() {
      if (this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: null,
          rangeSelection: [null, null],
          rangeSelectionMaster: null,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection1dEndHandler",
    value: function rangeSelection1dEndHandler(axis2) {
      if (!this.xScale || !this.yScale) {
        this.getXYScales();
      }
      const scale = axis2 === "x" ? this.xScale : this.yScale;
      return (range2) => {
        this.setState((prevState) => {
          const newRangeSelection = prevState.is1dRangeSelection ? [null, null] : prevState.rangeSelection.slice();
          const accessor = !this.state.is1dRangeSelection && axis2 === "y" ? 1 : 0;
          let dataPos = this.rangeViewToDataLoci(range2, scale);
          const size = dataPos[1] - dataPos[0];
          if (this.props.rangeSelection1dSize[0] > size) {
            const center2 = dataPos[0] + size / 2;
            dataPos = [center2 - this.props.rangeSelection1dSize[0] / 2, center2 + this.props.rangeSelection1dSize[0] / 2];
          } else if (this.props.rangeSelection1dSize[1] < size) {
            const center2 = dataPos[0] + size / 2;
            dataPos = [center2 - this.props.rangeSelection1dSize[1] / 2, center2 + this.props.rangeSelection1dSize[1] / 2];
          }
          newRangeSelection[accessor] = dataPos;
          if (this.props.rangeSelectionToInt) {
            newRangeSelection[accessor] = newRangeSelection[accessor].map((x) => Math.round(x));
          }
          return {
            rangeSelection: newRangeSelection,
            rangeSelectionEnd: true
          };
        });
      };
    }
  }, {
    key: "rangeSelection1dHandler",
    value: function rangeSelection1dHandler(axis2) {
      if (!this.xScale || !this.yScale)
        this.getXYScales();
      const scale = axis2 === "x" ? this.xScale : this.yScale;
      return (range2) => {
        this.setState((prevState) => {
          const newRangeSelection = prevState.is1dRangeSelection ? [null, null] : prevState.rangeSelection.slice();
          const accessor = !prevState.is1dRangeSelection && axis2 === "y" ? 1 : 0;
          newRangeSelection[accessor] = this.rangeViewToDataLoci(range2, scale);
          return {
            rangeSelection: newRangeSelection,
            rangeSelectionEnd: false
          };
        });
      };
    }
  }, {
    key: "rangeSelection1dStartHandler",
    value: function rangeSelection1dStartHandler() {
      if (!this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: true,
          rangeSelectionMaster: true,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection2dHandler",
    value: function rangeSelection2dHandler(range2) {
      if (!this.xScale || !this.yScale)
        this.getXYScales();
      this.setState({
        rangeSelection: [this.rangeViewToDataLoci(range2[0], this.xScale), this.rangeViewToDataLoci(range2[1], this.yScale)],
        rangeSelectionEnd: false
      });
    }
  }, {
    key: "rangeSelection2dStartHandler",
    value: function rangeSelection2dStartHandler() {
      if (!this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: false,
          rangeSelectionMaster: true,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection2dEndHandler",
    value: function rangeSelection2dEndHandler(range2) {
      if (!this.xScale || !this.yScale)
        this.getXYScales();
      const dataPosX = this.rangeViewToDataLoci(range2[0], this.xScale);
      const dataPosY = this.rangeViewToDataLoci(range2[1], this.yScale);
      let dataPos = [dataPosX, dataPosY];
      const sizeX = dataPosX[1] - dataPosX[0];
      const sizeY = dataPosY[1] - dataPosY[0];
      const size = [sizeX, sizeY];
      dataPos.forEach((pos, i) => {
        if (this.props.rangeSelection1dSize[0] > size[i]) {
          const center2 = pos[0] + Math.round(size[i] / 2);
          pos[0] = center2 - this.props.rangeSelection1dSize[0] / 2;
          pos[1] = center2 + this.props.rangeSelection1dSize[0] / 2;
        } else if (this.props.rangeSelection1dSize[1] < size[i]) {
          const center2 = pos[0] + Math.round(size[i] / 2);
          pos[0] = center2 - this.props.rangeSelection1dSize[1] / 2;
          pos[1] = center2 + this.props.rangeSelection1dSize[1] / 2;
        }
      });
      if (this.props.rangeSelectionToInt) {
        dataPos = dataPos.map((x) => x.map((y) => Math.round(y)));
      }
      this.setState({
        rangeSelection: dataPos,
        rangeSelectionEnd: true
      });
    }
  }, {
    key: "getContextMenu",
    value: function getContextMenu() {
      if (this.state.contextMenuPosition) {
        const relevantTracks = this.listTracksAtPosition(this.state.contextMenuPosition.canvasLeft, this.state.contextMenuPosition.canvasTop);
        return /* @__PURE__ */ React$3.createElement(PopupMenu, {
          onMenuClosed: this.closeMenusBound
        }, /* @__PURE__ */ React$3.createElement(ViewContextMenu, {
          closeMenu: this.closeMenusBound,
          coords: [this.state.contextMenuDataX, this.state.contextMenuDataY],
          customItems: this.state.contextMenuCustomItems,
          onAddDivisor: this.handleAddDivisorBound,
          onAddSeries: this.handleAddSeriesBound,
          onAddTrack: (newTrack) => {
            this.props.onTracksAdded([newTrack], newTrack.position, null);
            this.handleCloseContextMenu();
          },
          onChangeTrackData: this.handleChangeTrackDataBound,
          onChangeTrackType: this.handleChangeTrackTypeBound,
          onCloseTrack: this.handleCloseTrackBound,
          onConfigureTrack: this.handleConfigureTrackBound,
          onExportData: this.handleExportTrackDataBound,
          onLockValueScale: this.handleLockValueScaleBound,
          onReplaceTrack: this.handleReplaceTrackBound,
          onTrackOptionsChanged: this.handleTrackOptionsChangedBound,
          onUnlockValueScale: this.handleUnlockValueScaleBound,
          orientation: "right",
          position: this.state.contextMenuPosition,
          theme: this.props.theme,
          tracks: relevantTracks,
          trackSourceServers: this.props.trackSourceServers
        }));
      }
      return null;
    }
    /**
     * Draw an overlay that shows the positions of all the different
     * track areas
     */
  }, {
    key: "getIdealizedTrackPositionsOverlay",
    value: function getIdealizedTrackPositionsOverlay() {
      const evtJson = this.props.draggingHappening;
      if (typeof evtJson === "boolean") {
        return void 0;
      }
      const datatype = evtJson.datatype;
      if (datatype === void 0) {
        return;
      }
      if (!(datatype in DEFAULT_TRACKS_FOR_DATATYPE) && !evtJson.defaultTracks) {
        console.warn("unknown data type:", evtJson.higlassTrack);
        return void 0;
      }
      const orientationToPositions = {
        "1d-horizontal": ["top", "bottom", "left", "right"],
        "2d": ["center"],
        "1d-vertical": ["left", "right"]
      };
      const defaultTracks = DEFAULT_TRACKS_FOR_DATATYPE[datatype] || {};
      if (evtJson.defaultTracks) {
        for (const trackType of evtJson.defaultTracks) {
          if (!TRACKS_INFO_BY_TYPE[trackType]) {
            console.warn("unknown track type", trackType);
          } else {
            for (const position of orientationToPositions[TRACKS_INFO_BY_TYPE[trackType].orientation]) {
              defaultTracks[position] = trackType;
            }
          }
        }
      }
      const presentTracks = new Set(["top", "left", "right", "center", "bottom"].filter((x) => x in this.state.tracks && this.state.tracks[x].length));
      const topAllowed = "top" in defaultTracks;
      const leftAllowed = "left" in defaultTracks;
      const rightAllowed = "right" in defaultTracks;
      const bottomAllowed = "bottom" in defaultTracks;
      const centerAllowed = "center" in defaultTracks;
      const hasVerticalComponent = "center" in defaultTracks || presentTracks.has("left") || presentTracks.has("right") || presentTracks.has("center");
      const topDisplayed = "top" in defaultTracks;
      const bottomDisplayed = "bottom" in defaultTracks && hasVerticalComponent;
      const leftDisplayed = "left" in defaultTracks && hasVerticalComponent;
      const rightDisplayed = "right" in defaultTracks && hasVerticalComponent;
      const centerDisplayed = Object.keys(defaultTracks).length && ("center" in defaultTracks || hasVerticalComponent);
      const topLeftDiv = /* @__PURE__ */ React$3.createElement("div", {
        style: {
          flexGrow: 1
        }
      });
      const topRightDiv = /* @__PURE__ */ React$3.cloneElement(topLeftDiv);
      const topDiv = /* @__PURE__ */ React$3.createElement("div", {
        style: {
          display: "flex",
          flexGrow: 1
        }
      }, topDisplayed && (centerDisplayed || leftDisplayed) ? topLeftDiv : null, /* @__PURE__ */ React$3.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.top,
        draggingHappening: this.props.draggingHappening,
        enabled: topAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "top"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      }), topDisplayed && (centerDisplayed || leftDisplayed) ? topRightDiv : null);
      const bottomDiv = /* @__PURE__ */ React$3.createElement("div", {
        style: {
          display: "flex",
          flexGrow: 1
        }
      }, topDisplayed && (centerDisplayed || leftDisplayed) ? topLeftDiv : null, /* @__PURE__ */ React$3.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.bottom,
        draggingHappening: this.props.draggingHappening,
        enabled: bottomAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "bottom"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      }), topDisplayed && (centerDisplayed || leftDisplayed) ? topRightDiv : null);
      const leftDiv = /* @__PURE__ */ React$3.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.left,
        draggingHappening: this.props.draggingHappening,
        enabled: leftAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "left"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      });
      const centerDiv = /* @__PURE__ */ React$3.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.center,
        draggingHappening: this.props.draggingHappening,
        enabled: centerAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "center"),
        position: "center",
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      });
      const rightDiv = /* @__PURE__ */ React$3.cloneElement(leftDiv, {
        defaultTrackType: defaultTracks.right,
        enabled: rightAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "right")
      });
      return /* @__PURE__ */ React$3.createElement("div", {
        style: {
          position: "absolute",
          left: "0px",
          top: "0px",
          width: this.state.width,
          height: this.state.height
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        style: {
          position: "absolute",
          width: this.state.width,
          height: this.state.height,
          background: "white",
          opacity: 0.4
        }
      }), /* @__PURE__ */ React$3.createElement("div", {
        style: {
          width: this.state.width,
          height: this.state.height,
          position: "absolute",
          display: "flex",
          flexDirection: "column"
        }
      }, topDisplayed ? topDiv : null, hasVerticalComponent && /* @__PURE__ */ React$3.createElement("div", {
        style: {
          display: "flex",
          height: topDisplayed || bottomDisplayed ? "40%" : "100%",
          width: "100%"
        }
      }, leftDisplayed ? leftDiv : null, centerDisplayed ? centerDiv : null, rightDisplayed ? rightDiv : null), bottomDisplayed ? bottomDiv : null));
    }
  }, {
    key: "render",
    value: function render3() {
      this.galleryDim = this.props.tracks.gallery ? this.props.tracks.gallery.map((x) => x.height).reduce(sum, 0) : 0;
      this.topHeightNoGallery = this.props.tracks.top.map((x) => x.height).reduce(sum, 0);
      this.topHeight = this.topHeightNoGallery + this.galleryDim;
      this.bottomHeightNoGallery = this.props.tracks.bottom.map((x) => x.height).reduce(sum, 0);
      this.bottomHeight = this.bottomHeightNoGallery + this.galleryDim;
      this.leftWidthNoGallery = this.props.tracks.left.map((x) => x.width).reduce(sum, 0);
      this.leftWidth = this.leftWidthNoGallery + this.galleryDim;
      this.rightWidthNoGallery = this.props.tracks.right.map((x) => x.width).reduce(sum, 0);
      this.rightWidth = this.rightWidthNoGallery + this.galleryDim;
      const verticalPadding = this.props.paddingTop + this.props.paddingBottom;
      const horizontalPadding = this.props.paddingLeft + this.props.paddingRight;
      this.centerHeight = Math.max(0, this.state.height - this.topHeight - this.bottomHeight - verticalPadding);
      this.centerWidth = Math.max(0, this.state.width - this.leftWidth - this.rightWidth - horizontalPadding);
      const trackOutline = "none";
      const topTracks = /* @__PURE__ */ React$3.createElement("div", {
        className: "top-track-container",
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          top: this.props.paddingTop,
          width: this.centerWidth,
          height: this.topHeightNoGallery,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React$3.createElement(HorizontalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("x").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("x").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["bottom"]),
        scale: this.xScale,
        tracks: this.props.tracks.top,
        width: this.centerWidth
      }));
      const leftTracks = /* @__PURE__ */ React$3.createElement("div", {
        className: "left-track-container",
        style: {
          left: this.props.paddingLeft,
          top: this.topHeight + this.props.paddingTop,
          width: this.leftWidthNoGallery,
          height: this.centerHeight,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React$3.createElement(VerticalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        height: this.centerHeight,
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("y").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("y").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["right"]),
        scale: this.yScale,
        tracks: this.props.tracks.left
      }));
      const rightTracks = /* @__PURE__ */ React$3.createElement("div", {
        className: "right-track-container",
        style: {
          right: this.props.paddingRight,
          top: this.topHeight + this.props.paddingTop,
          width: this.rightWidthNoGallery,
          height: this.centerHeight,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React$3.createElement(VerticalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        height: this.centerHeight,
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("y").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("y").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["left"]),
        scale: this.yScale,
        tracks: this.props.tracks.right,
        tracksControlAlignLeft: true
      }));
      const bottomTracks = /* @__PURE__ */ React$3.createElement("div", {
        className: "bottom-track-container",
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          bottom: this.props.paddingBottom,
          width: this.centerWidth,
          height: this.bottomHeightNoGallery,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React$3.createElement(HorizontalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("x").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("x").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["top"]),
        scale: this.xScale,
        tracks: this.props.tracks.bottom,
        width: this.centerWidth
      }));
      const galleryTracks = /* @__PURE__ */ React$3.createElement("div", {
        key: "galleryTracksDiv",
        className: "gallery-track-container",
        style: {
          left: this.leftWidthNoGallery + this.props.paddingLeft,
          top: this.topHeightNoGallery + this.props.paddingTop,
          width: this.centerWidth + 2 * this.galleryDim,
          height: this.centerHeight + 2 * this.galleryDim,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React$3.createElement(GalleryTracks, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        height: this.centerHeight + 2 * this.galleryDim,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        tracks: this.props.tracks.gallery,
        width: this.centerWidth + 2 * this.galleryDim
      }));
      let centerTrack = /* @__PURE__ */ React$3.createElement("div", {
        className: ["center-track-container", stylesCenterTrack["center-track-container"]].join(" "),
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          top: this.topHeight + this.props.paddingTop,
          width: this.centerWidth,
          height: this.bottomHeight,
          outline: trackOutline
        }
      });
      if (this.props.tracks.center.length) {
        centerTrack = /* @__PURE__ */ React$3.createElement("div", {
          className: ["center-track-container", stylesCenterTrack["center-track-container"]].join(" "),
          style: {
            left: this.leftWidth + this.props.paddingLeft,
            top: this.topHeight + this.props.paddingTop,
            width: this.centerWidth,
            height: this.centerHeight,
            outline: trackOutline
          }
        }, /* @__PURE__ */ React$3.createElement(CenterTrack, {
          configTrackMenuId: this.state.configTrackMenuId,
          editable: this.props.editable,
          height: this.centerHeight,
          is1dRangeSelection: this.state.is1dRangeSelection,
          isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
          onAddSeries: this.handleAddSeries.bind(this),
          onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
          onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
          onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
          onRangeSelectionStart: this.rangeSelection2dStartHandler.bind(this),
          onRangeSelectionX: this.rangeSelection1dHandler("x").bind(this),
          onRangeSelectionXEnd: this.rangeSelection1dEndHandler("x").bind(this),
          onRangeSelectionXY: this.rangeSelection2dHandler.bind(this),
          onRangeSelectionXYEnd: this.rangeSelection2dEndHandler.bind(this),
          onRangeSelectionY: this.rangeSelection1dHandler("y").bind(this),
          onRangeSelectionYEnd: this.rangeSelection1dEndHandler("y").bind(this),
          rangeSelection: this.state.rangeSelection,
          rangeSelectionEnd: this.state.rangeSelectionEnd,
          scaleX: this.xScale,
          scaleY: this.yScale,
          tracks: this.props.tracks.center,
          uid: this.props.tracks.center[0].uid,
          width: this.centerWidth
        }));
      }
      this.createTrackPositionTexts();
      let positionedTracks = this.positionedTracks();
      positionedTracks = positionedTracks.concat(this.overlayTracks(positionedTracks));
      let trackRenderer = null;
      if (this.state.sizeMeasured) {
        trackRenderer = /* @__PURE__ */ React$3.createElement(
          TrackRenderer$1,
          {
            ref: (c2) => {
              this.trackRenderer = c2;
              this.checkAllTilesetInfoReceived();
            },
            canvasElement: this.canvasElement,
            centerHeight: this.centerHeight,
            centerWidth: this.centerWidth,
            disableTrackMenu: this.props.disableTrackMenu,
            dragging: this.props.dragging,
            galleryDim: this.galleryDim,
            getLockGroupExtrema: this.props.getLockGroupExtrema,
            height: this.state.height,
            initialXDomain: this.props.initialXDomain,
            initialYDomain: this.props.initialYDomain,
            isRangeSelection: this.props.mouseTool === MOUSE_TOOL_SELECT,
            isShowGlobalMousePosition: this.props.isShowGlobalMousePosition,
            isValueScaleLocked: this.props.isValueScaleLocked,
            leftWidth: this.leftWidth,
            leftWidthNoGallery: this.leftWidthNoGallery,
            metaTracks: this.props.metaTracks,
            onMouseMoveZoom: this.props.onMouseMoveZoom,
            onNewTilesLoaded: this.props.onNewTilesLoaded,
            onScalesChanged: this.handleScalesChanged.bind(this),
            onTilesetInfoReceived: this.handleTilesetInfoReceived.bind(this),
            onTrackOptionsChanged: this.handleTrackOptionsChanged.bind(this),
            onValueScaleChanged: this.props.onValueScaleChanged,
            paddingLeft: this.props.paddingLeft,
            paddingTop: this.props.paddingTop,
            pixiRenderer: this.props.pixiRenderer,
            pixiStage: this.props.pixiStage,
            pluginDataFetchers: this.props.pluginDataFetchers,
            pluginTracks: this.props.pluginTracks,
            positionedTracks,
            registerDraggingChangedListener: this.props.registerDraggingChangedListener,
            removeDraggingChangedListener: this.props.removeDraggingChangedListener,
            setCentersFunction: this.props.setCentersFunction,
            svgElement: this.props.svgElement,
            topHeight: this.topHeight,
            topHeightNoGallery: this.topHeightNoGallery,
            uid: this.props.uid,
            viewOptions: this.props.viewOptions,
            width: this.state.width,
            xDomainLimits: this.props.xDomainLimits,
            yDomainLimits: this.props.yDomainLimits,
            zoomable: this.props.zoomable,
            zoomLimits: this.props.zoomLimits
          },
          topTracks,
          leftTracks,
          rightTracks,
          bottomTracks,
          galleryTracks,
          centerTrack
        );
      }
      let configTrackMenu = null;
      let closeTrackMenu = null;
      if (this.state.configTrackMenuId) {
        configTrackMenu = /* @__PURE__ */ React$3.createElement(PopupMenu, {
          onMenuClosed: this.closeMenusBound
        }, /* @__PURE__ */ React$3.createElement(ConfigTrackMenu, {
          ref: (c2) => {
            this.configTrackMenu = c2;
          },
          closeMenu: this.closeMenusBound,
          onAddDivisor: this.handleAddDivisorBound,
          onAddSeries: this.handleAddSeriesBound,
          onAddTrack: this.handleAddTrackBound,
          onChangeTrackType: this.handleChangeTrackTypeBound,
          onCloseTrack: this.handleCloseTrackBound,
          onConfigureTrack: this.handleConfigureTrackBound,
          onExportData: this.handleExportTrackDataBound,
          onLockValueScale: this.handleLockValueScaleBound,
          onReplaceTrack: this.handleReplaceTrackBound,
          onTrackOptionsChanged: this.handleTrackOptionsChangedBound,
          onUnlockValueScale: this.handleUnlockValueScaleBound,
          position: this.state.configTrackMenuLocation,
          theme: this.props.theme,
          trackOrientation: getTrackPositionByUid(this.props.tracks, this.state.configTrackMenuId),
          tracks: [getTrackByUid(this.props.tracks, this.state.configTrackMenuId)]
        }));
      }
      if (this.state.closeTrackMenuId) {
        closeTrackMenu = /* @__PURE__ */ React$3.createElement(PopupMenu, {
          onMenuClosed: this.handleCloseTrackMenuClosed.bind(this)
        }, /* @__PURE__ */ React$3.createElement(ContextMenuContainer, {
          position: this.state.closeTrackMenuLocation,
          theme: this.props.theme
        }, /* @__PURE__ */ React$3.createElement(CloseTrackMenu, {
          onCloseTrack: this.handleCloseTrack.bind(this),
          tracks: [getTrackByUid(this.props.tracks, this.state.closeTrackMenuId)]
        })));
      }
      let overlays = null;
      if (this.props.chooseTrackHandler) {
        overlays = positionedTracks.filter((pTrack) => pTrack.track.position !== "whole").map((pTrack) => {
          let background = "transparent";
          let border = "none";
          if (this.state.mouseOverOverlayUid === pTrack.track.uid) {
            background = "yellow";
            border = "1px solid black";
          }
          return /* @__PURE__ */ React$3.createElement("div", {
            key: pTrack.track.uid,
            className: "tiled-plot-track-overlay",
            onClick: () => this.handleTrackPositionChosen(pTrack),
            onDragEnter: (evt) => {
              this.handleOverlayMouseEnter(pTrack.track.uid);
              evt.preventDefault();
            },
            onDragLeave: () => this.handleOverlayMouseLeave(pTrack.track.uid),
            onDragOver: (evt) => evt.preventDefault(),
            onDrop: () => this.handleTrackPositionChosen(pTrack),
            onMouseEnter: () => this.handleOverlayMouseEnter(pTrack.track.uid),
            onMouseLeave: () => this.handleOverlayMouseLeave(pTrack.track.uid),
            style: {
              position: "absolute",
              left: pTrack.left,
              top: pTrack.top,
              width: pTrack.width,
              height: pTrack.height,
              background,
              opacity: 0.4,
              border,
              zIndex: 1
            }
          });
        });
      }
      let trackOptionsElement = null;
      if (this.xScale && this.yScale && this.props.editable && this.state.trackOptions) {
        const configComponent = this.state.trackOptions.configComponent;
        const track = this.state.trackOptions.track;
        trackOptionsElement = /* @__PURE__ */ React$3.createElement(configComponent, {
          track,
          xScale: this.xScale,
          yScale: this.yScale,
          onCancel: () => {
            this.setState({
              trackOptions: null
            });
          },
          onTrackOptionsChanged: (newOptions) => newOptions,
          onSubmit: (newOptions) => {
            this.handleTrackOptionsChanged(this.state.trackOptions.track.uid, newOptions);
            this.setState({
              trackOptions: null
            });
          }
        });
      }
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.divTiledPlot = c2;
        },
        className: ["tiled-plot-div", styles$5["tiled-plot"]].join(" "),
        style: {
          marginBottom: this.props.marginBottom,
          marginLeft: this.props.marginLeft,
          marginRight: this.props.marginRight,
          marginTop: this.props.marginTop
        }
      }, trackRenderer, overlays, configTrackMenu, closeTrackMenu, trackOptionsElement, this.getContextMenu(), this.props.draggingHappening && this.getIdealizedTrackPositionsOverlay());
    }
    /* -------------------- Custom Methods -----------------------*/
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      this.eventListeners = [];
      this.eventListeners.forEach((event) => document.addEventListener(event.name, event.callback, false));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach((event) => document.removeEventListener(event.name, event.callback));
    }
  }]);
  return TiledPlot2;
}(React$3.Component);
TiledPlot.defaultProps = {
  isShowGlobalMousePosition: false,
  pluginDataFetchers: {},
  pluginTracks: {},
  metaTracks: [],
  zoomable: true
};
TiledPlot.propTypes = {
  addTrackPosition: PropTypes.string,
  canvasElement: PropTypes.object,
  chooseTrackHandler: PropTypes.func,
  chromInfoPath: PropTypes.string,
  customDialog: PropTypes.array,
  closeCustomDialog: PropTypes.func,
  disableTrackMenu: PropTypes.bool,
  dragging: PropTypes.bool,
  draggingHappening: PropTypes.bool,
  editable: PropTypes.bool,
  getLockGroupExtrema: PropTypes.func,
  initialXDomain: PropTypes.array,
  initialYDomain: PropTypes.array,
  isShowGlobalMousePosition: PropTypes.bool,
  isValueScaleLocked: PropTypes.func,
  marginBottom: PropTypes.number.isRequired,
  marginLeft: PropTypes.number.isRequired,
  marginRight: PropTypes.number.isRequired,
  marginTop: PropTypes.number.isRequired,
  paddingBottom: PropTypes.number.isRequired,
  paddingLeft: PropTypes.number.isRequired,
  paddingRight: PropTypes.number.isRequired,
  paddingTop: PropTypes.number.isRequired,
  metaTracks: PropTypes.array,
  modal: PropTypes.object,
  mouseTool: PropTypes.string,
  onCloseTrack: PropTypes.func,
  onChangeTrackData: PropTypes.func,
  onChangeTrackType: PropTypes.func,
  onDataDomainChanged: PropTypes.func,
  onLockValueScale: PropTypes.func,
  onMouseMoveZoom: PropTypes.func,
  onNewTilesLoaded: PropTypes.func,
  onNoTrackAdded: PropTypes.func,
  onRangeSelection: PropTypes.func.isRequired,
  onScalesChanged: PropTypes.func,
  onTrackOptionsChanged: PropTypes.func,
  onTrackPositionChosen: PropTypes.func,
  onTracksAdded: PropTypes.func,
  onUnlockValueScale: PropTypes.func,
  onValueScaleChanged: PropTypes.func,
  onResizeTrack: PropTypes.func,
  overlays: PropTypes.array,
  openModal: PropTypes.func,
  pixiRenderer: PropTypes.object,
  pixiStage: PropTypes.object,
  pluginDataFetchers: PropTypes.object,
  pluginTracks: PropTypes.object,
  pubSub: PropTypes.object.isRequired,
  rangeSelection1dSize: PropTypes.array,
  rangeSelectionToInt: PropTypes.bool,
  registerDraggingChangedListener: PropTypes.func,
  removeDraggingChangedListener: PropTypes.func,
  setCentersFunction: PropTypes.func,
  svgElement: PropTypes.object,
  theme: PropTypes.symbol.isRequired,
  tracks: PropTypes.object,
  trackSourceServers: PropTypes.array,
  uid: PropTypes.string,
  viewOptions: PropTypes.object,
  xDomainLimits: PropTypes.array,
  yDomainLimits: PropTypes.array,
  zoomable: PropTypes.bool,
  zoomLimits: PropTypes.array,
  zoomToDataExtentOnInit: PropTypes.func
};
const TiledPlot$1 = withPubSub(withModal(withTheme(TiledPlot)));
var _extends$2 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top2) {
  var ret = w["page" + (top2 ? "Y" : "X") + "Offset"];
  var method = "scroll" + (top2 ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== "number") {
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val2 = "";
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
  if (computedStyle) {
    val2 = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val2;
}
var _RE_NUM_NO_PX = new RegExp("^(" + RE_NUM + ")(?!px)[a-z%]+$", "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name) {
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    var style = elem.style;
    var left2 = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
    style[LEFT] = name === "fontSize" ? "1em" : ret || 0;
    ret = style.pixelLeft + PX;
    style[LEFT] = left2;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === "" ? "auto" : ret;
}
var getComputedStyleX = void 0;
if (typeof window !== "undefined") {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options2, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;
  for (name in options2) {
    if (options2.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options2[name];
    }
  }
  callback.call(elem);
  for (name in options2) {
    if (options2.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value2 = 0;
  var prop2 = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop2 = props[j];
    if (prop2) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop2 === "border") {
          cssProp = prop2 + which[i] + "Width";
        } else {
          cssProp = prop2 + which[i];
        }
        value2 += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value2;
}
function isWindow(obj) {
  return obj != null && obj == obj.window;
}
var domUtils = {};
each(["Width", "Height"], function(name) {
  domUtils["doc" + name] = function(refWin) {
    var d = refWin.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d.documentElement["scroll" + name],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d.body["scroll" + name],
      domUtils["viewport" + name](d)
    );
  };
  domUtils["viewport" + name] = function(win) {
    var prop2 = "client" + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop2];
    return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop2] || documentElementProp;
  };
});
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  var borderBoxValue = name === "width" ? elem.offsetWidth : elem.offsetHeight;
  getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = void 0;
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === void 0) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
  var val2 = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val2 - getPBMWidth(elem, ["border", "padding"], which);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which);
    return val2 + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay(elem) {
  var val2 = void 0;
  var args = arguments;
  if (elem.offsetWidth !== 0) {
    val2 = getWH.apply(void 0, args);
  } else {
    swap(elem, cssShow, function() {
      val2 = getWH.apply(void 0, args);
    });
  }
  return val2;
}
function css(el, name, v) {
  var value2 = v;
  if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return void 0;
  }
  if (typeof value2 !== "undefined") {
    if (typeof value2 === "number") {
      value2 += "px";
    }
    el.style[name] = value2;
    return void 0;
  }
  return getComputedStyleX(el, name);
}
each(["width", "height"], function(name) {
  var first2 = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer" + first2] = function(el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[name] = function(elem, val2) {
    if (val2 !== void 0) {
      if (elem) {
        getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val2 += getPBMWidth(elem, ["padding", "border"], which);
        }
        return css(elem, name, val2);
      }
      return void 0;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function setOffset(elem, offset2) {
  if (css(elem, "position") === "static") {
    elem.style.position = "relative";
  }
  var old = getOffset(elem);
  var ret = {};
  var current = void 0;
  var key = void 0;
  for (key in offset2) {
    if (offset2.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset2[key] - old[key];
    }
  }
  css(elem, ret);
}
var util$7 = _extends$2({
  getWindow: function getWindow(node2) {
    var doc = node2.ownerDocument || node2;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value2) {
    if (typeof value2 !== "undefined") {
      setOffset(el, value2);
    } else {
      return getOffset(el);
    }
  },
  isWindow,
  each,
  css,
  clone: function clone3(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === void 0) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === void 0) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === void 0) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === void 0) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },
  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);
var util$6 = util$7;
function scrollIntoView$1(elem, container, config) {
  config = config || {};
  if (container.nodeType === 9) {
    container = util$6.getWindow(container);
  }
  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;
  allowHorizontalScroll = allowHorizontalScroll === void 0 ? true : allowHorizontalScroll;
  var isWin = util$6.isWindow(container);
  var elemOffset = util$6.offset(elem);
  var eh = util$6.outerHeight(elem);
  var ew = util$6.outerWidth(elem);
  var containerOffset = void 0;
  var ch = void 0;
  var cw = void 0;
  var containerScroll = void 0;
  var diffTop = void 0;
  var diffBottom = void 0;
  var win = void 0;
  var winScroll = void 0;
  var ww = void 0;
  var wh = void 0;
  if (isWin) {
    win = container;
    wh = util$6.height(win);
    ww = util$6.width(win);
    winScroll = {
      left: util$6.scrollLeft(win),
      top: util$6.scrollTop(win)
    };
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util$6.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util$6.css(container, "borderLeftWidth")) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util$6.css(container, "borderTopWidth")) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util$6.css(container, "borderRightWidth")) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util$6.css(container, "borderBottomWidth")) || 0)) + offsetBottom
    };
  }
  if (diffTop.top < 0 || diffBottom.top > 0) {
    if (alignWithTop === true) {
      util$6.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util$6.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      if (diffTop.top < 0) {
        util$6.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util$6.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === void 0 ? true : !!alignWithTop;
      if (alignWithTop) {
        util$6.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util$6.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }
  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      if (alignWithLeft === true) {
        util$6.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util$6.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        if (diffTop.left < 0) {
          util$6.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util$6.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === void 0 ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util$6.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util$6.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}
var domScrollIntoView = scrollIntoView$1;
var lib$1 = domScrollIntoView;
const scrollIntoView = /* @__PURE__ */ getDefaultExportFromCjs(lib$1);
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$7(descriptor.key), descriptor);
  }
}
function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$7(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$7(arg) {
  var key = _toPrimitive$7(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$7(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$7(subClass, superClass);
}
function _setPrototypeOf$7(o, p) {
  _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$7(o, p);
}
function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$7(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$7(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$8(this, result);
  };
}
function _possibleConstructorReturn$8(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$7(self2);
}
function _assertThisInitialized$7(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$7(o) {
  _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$7(o);
}
const _debugStates = [];
let Autocomplete = /* @__PURE__ */ function(_React$Component) {
  _inherits$8(Autocomplete2, _React$Component);
  var _super = _createSuper$7(Autocomplete2);
  function Autocomplete2(props) {
    var _this;
    _classCallCheck$8(this, Autocomplete2);
    _this = _super.call(this, props);
    _this.state = {
      highlightedIndex: null,
      menuTop: 0,
      menuLeft: 0,
      menuWidth: 0,
      isOpen: false
    };
    _this.keyDownHandlers = {
      ArrowDown(event) {
        event.preventDefault();
        const itemsLength = this.getFilteredItems().length;
        if (!itemsLength)
          return;
        const {
          highlightedIndex
        } = this.state;
        const index2 = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index2,
          isOpen: true
        });
      },
      ArrowUp(event) {
        event.preventDefault();
        const itemsLength = this.getFilteredItems().length;
        if (!itemsLength)
          return;
        const {
          highlightedIndex
        } = this.state;
        const index2 = highlightedIndex === 0 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index2,
          isOpen: true
        });
      },
      Enter(event) {
        if (this.state.isOpen === false)
          ;
        else if (this.state.highlightedIndex === null) {
          this.setState({
            isOpen: false
          }, () => {
            this.inputEl.select();
          });
        } else {
          event.preventDefault();
          const item = this.getFilteredItems()[this.state.highlightedIndex];
          const value2 = this.props.getItemValue(item);
          this.setState({
            isOpen: false,
            highlightedIndex: null
          }, () => {
            this.inputEl.setSelectionRange(value2.length, value2.length);
            this.props.onSelect(value2, item);
          });
        }
      },
      Escape() {
        this.setState({
          highlightedIndex: null,
          isOpen: false
        });
      }
    };
    return _this;
  }
  _createClass$8(Autocomplete2, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        isOpen: false,
        highlightedIndex: null
      };
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._ignoreBlur = false;
      this._performAutoCompleteOnUpdate = false;
      this._performAutoCompleteOnKeyUp = false;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this._performAutoCompleteOnUpdate = true;
      if (this.props.items !== nextProps.items || // The entries in `items` may have been changed even though the
      // object reference remains the same, double check by seeing
      // if `highlightedIndex` points to an existing item
      this.state.highlightedIndex >= nextProps.items.length) {
        this.setState({
          highlightedIndex: null
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isOpen === true && prevState.isOpen === false) {
        this.setMenuPositions();
      }
      if (this.state.isOpen && this._performAutoCompleteOnUpdate) {
        this._performAutoCompleteOnUpdate = false;
        this.maybeAutoCompleteText();
      }
      this.maybeScrollItemIntoView();
      if (prevState.isOpen !== this.state.isOpen) {
        this.props.onMenuVisibilityChange(this.state.isOpen, this.inputEl);
      }
    }
  }, {
    key: "maybeScrollItemIntoView",
    value: function maybeScrollItemIntoView() {
      if (this.state.isOpen === true && this.state.highlightedIndex !== null) {
        const itemNode = this.refs[`item-${this.state.highlightedIndex}`];
        const menuNode = this.refs.menu;
        if (itemNode) {
          scrollIntoView(findDOMNode$1(itemNode), findDOMNode$1(menuNode), {
            onlyScrollIfNeeded: true
          });
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.keyDownHandlers[event.key]) {
        this.keyDownHandlers[event.key].call(this, event);
      } else {
        this.setState({
          highlightedIndex: null,
          isOpen: true
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this._performAutoCompleteOnKeyUp = true;
      this.props.onChange(event, event.target.value);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {
      if (this._performAutoCompleteOnKeyUp) {
        this._performAutoCompleteOnKeyUp = false;
        this.maybeAutoCompleteText();
      }
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems() {
      let items2 = this.props.items;
      if (this.props.shouldItemRender) {
        items2 = items2.filter((item) => this.props.shouldItemRender(item, this.props.value));
      }
      if (this.props.sortItems) {
        items2.sort((a, b) => this.props.sortItems(a, b, this.props.value));
      }
      return items2;
    }
  }, {
    key: "maybeAutoCompleteText",
    value: function maybeAutoCompleteText() {
      if (!this.props.autoHighlight || this.props.value === "") {
        return;
      }
      const {
        highlightedIndex
      } = this.state;
      const items2 = this.getFilteredItems();
      if (items2.length === 0) {
        return;
      }
      const matchedItem = highlightedIndex !== null ? items2[highlightedIndex] : items2[0];
      const itemValue = this.props.getItemValue(matchedItem);
      const itemValueDoesMatch = itemValue.toLowerCase().indexOf(this.props.value.toLowerCase()) === 0;
      if (itemValueDoesMatch && highlightedIndex === null) {
        this.setState({
          highlightedIndex: 0
        });
      }
    }
  }, {
    key: "setMenuPositions",
    value: function setMenuPositions() {
      const node2 = this.inputEl;
      const rect = node2.getBoundingClientRect();
      const computedStyle = globalThis.window.getComputedStyle(node2);
      const marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
      const marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
      const marginRight = parseInt(computedStyle.marginRight, 10) || 0;
      this.setState({
        menuTop: rect.bottom + marginBottom,
        menuLeft: rect.left + marginLeft,
        menuWidth: rect.width + marginLeft + marginRight
      });
    }
  }, {
    key: "highlightItemFromMouse",
    value: function highlightItemFromMouse(index2) {
      this.setState({
        highlightedIndex: index2
      });
    }
  }, {
    key: "selectItemFromMouse",
    value: function selectItemFromMouse(item) {
      const value2 = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, () => {
        this.props.onSelect(value2, item);
        this.inputEl.focus();
      });
    }
  }, {
    key: "setIgnoreBlur",
    value: function setIgnoreBlur(ignore2) {
      this._ignoreBlur = ignore2;
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      const items2 = this.getFilteredItems().map((item, index2) => {
        const element = this.props.renderItem(item, this.state.highlightedIndex === index2, {
          cursor: "default"
        });
        return /* @__PURE__ */ React$3.cloneElement(element, {
          onMouseDown: () => this.setIgnoreBlur(true),
          // Ignore blur to prevent menu from de-rendering before we can process click
          onMouseEnter: () => this.highlightItemFromMouse(index2),
          onClick: () => this.selectItemFromMouse(item),
          ref: `item-${index2}`
        });
      });
      const style = {
        left: this.state.menuLeft,
        top: this.state.menuTop,
        minWidth: this.state.menuWidth
      };
      if (!items2.length)
        return null;
      const menu = this.props.renderMenu(items2, this.props.value, style);
      return /* @__PURE__ */ React$3.cloneElement(menu, {
        ref: "menu"
      });
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
      if (this._ignoreBlur) {
        return;
      }
      this.setState({
        isOpen: false,
        highlightedIndex: null
      });
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      if (this.props.onFocus) {
        this.props.onFocus(true);
      }
      if (this._ignoreBlur) {
        this.setIgnoreBlur(false);
        return;
      }
      this._ignoreClick = true;
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "isInputFocused",
    value: function isInputFocused() {
      return this.inputEl.ownerDocument && this.inputEl === this.inputEl.ownerDocument.activeElement;
    }
  }, {
    key: "handleInputClick",
    value: function handleInputClick() {
      if (this.isInputFocused() && this.state.isOpen === false) {
        this.setState({
          isOpen: true
        });
      } else if (this.state.highlightedIndex !== null && !this._ignoreClick) {
        this.selectItemFromMouse(this.getFilteredItems()[this.state.highlightedIndex]);
      }
      this._ignoreClick = false;
    }
  }, {
    key: "composeEventHandlers",
    value: function composeEventHandlers(internal, external) {
      return external ? (e) => {
        internal(e);
        external(e);
      } : internal;
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      if (this.props.debug) {
        _debugStates.push({
          id: _debugStates.length,
          state: this.state
        });
      }
      const {
        inputProps
      } = this.props;
      return /* @__PURE__ */ React$3.createElement("div", _extends$1({
        style: {
          ...this.props.wrapperStyle
        }
      }, this.props.wrapperProps), /* @__PURE__ */ React$3.createElement("input", _extends$1({}, inputProps, {
        ref: (el) => {
          this.inputEl = el;
        },
        "aria-autocomplete": "list",
        autoComplete: "off",
        onBlur: this.composeEventHandlers(this.handleInputBlur.bind(this), inputProps.onBlur && inputProps.onBlur.bind(this)),
        onChange: this.handleChange.bind(this),
        onClick: this.composeEventHandlers(this.handleInputClick.bind(this), inputProps.onClick && inputProps.onClick.bind(this)),
        onFocus: this.composeEventHandlers(this.handleInputFocus.bind(this), inputProps.onFocus && inputProps.onFocus.bind(this)),
        onKeyDown: this.composeEventHandlers(this.handleKeyDown.bind(this), inputProps.onKeyDown && inputProps.onKeyDown.bind(this)),
        onKeyUp: this.composeEventHandlers(this.handleKeyUp.bind(this), inputProps.onKeyUp && inputProps.onKeyUp.bind(this)),
        role: "combobox",
        value: this.props.value
      })), ("open" in this.props ? this.props.open : this.state.isOpen) && this.renderMenu(), this.props.debug && /* @__PURE__ */ React$3.createElement("pre", {
        style: {
          marginLeft: 300
        }
      }, JSON.stringify(_debugStates.slice(_debugStates.length - 5, _debugStates.length), null, 2)));
    }
  }]);
  return Autocomplete2;
}(React$3.Component);
Autocomplete.defaultProps = {
  value: "",
  wrapperProps: {},
  wrapperStyle: {
    display: "inline-block"
  },
  inputProps: {},
  onChange() {
  },
  onSelect() {
  },
  renderMenu(items2, value2, style) {
    return (
      /* eslint-disable react/no-this-in-sfc */
      /* @__PURE__ */ React$3.createElement("div", {
        style: {
          ...style,
          ...this.menuStyle
        }
      }, items2)
    );
  },
  shouldItemRender() {
    return true;
  },
  menuStyle: {
    borderRadius: "3px",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
    background: "rgba(255, 255, 255, 0.9)",
    padding: "2px 0",
    fontSize: "90%",
    position: "fixed",
    overflow: "auto",
    maxHeight: "50%"
    // TODO: don't cheat, let it flow to the bottom
  },
  autoHighlight: true,
  onMenuVisibilityChange() {
  }
};
Autocomplete.propTypes = {
  autoHighlight: PropTypes.bool,
  debug: PropTypes.bool,
  getItemValue: PropTypes.func.isRequired,
  inputProps: PropTypes.object,
  items: PropTypes.array,
  menuStyle: PropTypes.object,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onMenuVisibilityChange: PropTypes.func,
  onSelect: PropTypes.func,
  open: PropTypes.bool,
  renderItem: PropTypes.func.isRequired,
  renderMenu: PropTypes.func,
  shouldItemRender: PropTypes.func,
  sortItems: PropTypes.func,
  value: PropTypes.any,
  wrapperProps: PropTypes.object,
  wrapperStyle: PropTypes.object
};
const btn = "_btn_1l2sx_95";
const styles$2 = {
  "genome-position-search": "_genome-position-search_1l2sx_1",
  "genome-position-search-focus": "_genome-position-search-focus_1l2sx_2",
  "genome-position-search-bar": "_genome-position-search-bar_1l2sx_16",
  "genome-position-search-dark": "_genome-position-search-dark_1l2sx_34",
  "genome-position-search-bar-button": "_genome-position-search-bar-button_1l2sx_38",
  "genome-position-search-bar-button-focus": "_genome-position-search-bar-button-focus_1l2sx_39",
  "genome-position-search-bar-icon": "_genome-position-search-bar-icon_1l2sx_62",
  "genome-position-search-bar-icon-focus": "_genome-position-search-bar-icon-focus_1l2sx_63",
  "genome-position-search-bar-suggestions": "_genome-position-search-bar-suggestions_1l2sx_83",
  btn,
  "btn-sm": "_btn-sm_1l2sx_116",
  "btn-default": "_btn-default_1l2sx_122"
};
function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$6(arg) {
  var key = _toPrimitive$6(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$6(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$6(subClass, superClass);
}
function _setPrototypeOf$6(o, p) {
  _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$6(o, p);
}
function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$6(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$6(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$7(this, result);
  };
}
function _possibleConstructorReturn$7(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$6(self2);
}
function _assertThisInitialized$6(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$6(o) {
  _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$6(o);
}
let GenomePositionSearchBox = /* @__PURE__ */ function(_React$Component) {
  _inherits$7(GenomePositionSearchBox2, _React$Component);
  var _super = _createSuper$6(GenomePositionSearchBox2);
  function GenomePositionSearchBox2(props) {
    var _this;
    _classCallCheck$7(this, GenomePositionSearchBox2);
    _this = _super.call(this, props);
    _this.mounted = false;
    _this.uid = slugid$1.nice();
    _this.chromInfo = null;
    _this.searchField = null;
    _this.autocompleteMenu = null;
    _this.xScale = null;
    _this.yScale = null;
    _this.prevParts = [];
    _this.props.registerViewportChangedListener(_this.scalesChanged.bind(_assertThisInitialized$6(_this)));
    _this.menuPosition = {
      left: 0,
      top: 0
    };
    _this.positionText = "chr4:190,998,876-191,000,255";
    _this.state = {
      genes: [],
      isFocused: false,
      autocompleteServer: _this.props.autocompleteServer,
      autocompleteId: _this.props.autocompleteId,
      availableAssemblies: [],
      selectedAssembly: null
    };
    _this.styles = {
      item: {
        padding: "2px 6px",
        cursor: "default"
      },
      highlightedItem: {
        color: "white",
        background: "hsl(200, 50%, 50%)",
        padding: "2px 6px",
        cursor: "default"
      },
      menu: {
        border: "solid 1px #ccc"
      }
    };
    _this.availableAutocompletes = {};
    if (_this.props.autocompleteId) {
      _this.availableAutocompletes[_this.props.chromInfoId] = /* @__PURE__ */ new Set([{
        server: _this.props.autocompleteServer,
        acId: _this.props.autocompleteId
      }]);
    }
    _this.availableChromSizes = {};
    return _this;
  }
  _createClass$7(GenomePositionSearchBox2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      select$1(this.autocompleteMenu.inputEl).on("keypress", this.autocompleteKeyPress.bind(this));
      this.findAvailableAutocompleteSources();
      this.findAvailableChromSizes();
      if (this.props.chromInfoPath) {
        this.searchPosition = true;
        ChromosomeInfo(this.props.chromInfoPath, (chromInfo) => {
          if (!chromInfo) {
            this.searchPosition = null;
            return;
          }
          this.chromInfo = chromInfo;
          this.searchField = new SearchField(this.chromInfo);
          this.setPositionText();
        });
      }
      this.setPositionText();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.props.removeViewportChangedListener();
    }
  }, {
    key: "onAutocompleteChange",
    value: function onAutocompleteChange(evt, value2) {
      this.positionText = value2;
      this.setState({
        value: value2,
        loading: true
      });
      this.changedPart = null;
      const spaceParts = value2.split(/ /);
      let partIndex = 0;
      const newParts = [];
      let changedAtStartOfWord = false;
      for (let j = 0; j < spaceParts.length; j++) {
        const parts = spaceParts[j].split(/-/);
        for (let i = 0; i < parts.length; i++) {
          partIndex += 1;
          newParts.push(parts[i]);
          if (i === 0)
            changedAtStartOfWord = true;
          else
            changedAtStartOfWord = false;
          if (i === this.prevParts.length) {
            this.changedPart = partIndex - 1;
            break;
          }
          if (parts[i] !== this.prevParts[i]) {
            this.changedPart = partIndex - 1;
            break;
          }
        }
      }
      this.prevParts = newParts;
      if (!(this.state.autocompleteServer && this.state.autocompleteId)) {
        return;
      }
      if (this.changedPart !== null) {
        this.setState({
          loading: true
        });
        let url = `${this.state.autocompleteServer}/suggest/`;
        url += `?d=${this.state.autocompleteId}&ac=${newParts[this.changedPart].toLowerCase()}`;
        api.json(url, (error, data2) => {
          if (error) {
            this.setState({
              loading: false,
              genes: []
            });
          } else if (this.changedPart > 0 && !changedAtStartOfWord) {
            const url1 = `${this.state.autocompleteServer}/suggest/?d=${this.state.autocompleteId}&ac=${newParts[this.changedPart - 1].toLowerCase()}-${newParts[this.changedPart].toLowerCase()}`;
            api.json(url1, (error1, data1) => {
              if (error1) {
                this.setState({
                  loading: false,
                  genes: data2
                });
              } else {
                this.setState({
                  loading: false,
                  genes: data1.concat(data2)
                });
              }
            }, this.props.pubSub);
          } else {
            this.setState({
              loading: false,
              genes: data2
            });
          }
        }, this.props.pubSub);
      }
    }
  }, {
    key: "setAvailableAssemblies",
    value: function setAvailableAssemblies() {
      const chromsizeKeys = new Set(dictKeys(this.availableChromSizes));
      const commonKeys = /* @__PURE__ */ new Set([...chromsizeKeys]);
      if (this.gpsbForm) {
        this.setState({
          availableAssemblies: [...commonKeys]
        });
      }
    }
  }, {
    key: "setSelectedAssembly",
    value: function setSelectedAssembly(assemblyName) {
      if (!this.mounted)
        return;
      if (!this.availableChromSizes[assemblyName])
        return;
      const serverAndChromInfoToUse = [...this.availableChromSizes[assemblyName]][0];
      this.setState({
        autocompleteServer: serverAndChromInfoToUse.server
      });
      const {
        server
      } = serverAndChromInfoToUse;
      if (this.availableAutocompletes[assemblyName]) {
        const newAcId = [...this.availableAutocompletes[assemblyName]][0].acId;
        this.props.onSelectedAssemblyChanged(assemblyName, newAcId, server);
        if (this.gpsbForm) {
          this.setState({
            autocompleteId: newAcId
          });
        }
      } else {
        this.props.onSelectedAssemblyChanged(assemblyName, null, server);
        if (this.gpsbForm) {
          this.setState({
            autocompleteId: null
          });
        }
      }
      this.fetchChromInfo(serverAndChromInfoToUse.uuid, serverAndChromInfoToUse.server);
    }
  }, {
    key: "setPositionText",
    value: function setPositionText() {
      if (!this.mounted) {
        return;
      }
      if (!this.searchField) {
        return;
      }
      const positionString = this.searchField.scalesToPositionText(this.xScale, this.yScale, this.props.twoD);
      this.prevParts = positionString.split(/[ -]/);
      if (this.gpsbForm) {
        this.positionText = positionString;
        this.origPositionText = positionString;
        this.autocompleteMenu.inputEl.value = positionString;
      }
    }
  }, {
    key: "scalesChanged",
    value: function scalesChanged(xScale, yScale) {
      this.xScale = xScale;
      this.yScale = yScale;
      this.setPositionText();
    }
  }, {
    key: "findAvailableChromSizes",
    value: function findAvailableChromSizes() {
      if (!this.props.trackSourceServers) {
        return;
      }
      this.props.trackSourceServers.forEach((sourceServer) => {
        api.json(`${sourceServer}/available-chrom-sizes/`, (error, data2) => {
          if (error) {
            console.error(error);
          } else {
            data2.results.forEach((x) => {
              if (!(x.coordSystem in this.availableChromSizes)) {
                this.availableChromSizes[x.coordSystem] = /* @__PURE__ */ new Set();
              }
              this.availableChromSizes[x.coordSystem].add({
                server: sourceServer,
                uuid: x.uuid
              });
              this.setAvailableAssemblies();
            });
            if (!this.searchField) {
              this.fetchChromInfo(this.props.chromInfoId in this.availableChromSizes ? [...this.availableChromSizes[this.props.chromInfoId]][0].uuid : this.props.chromInfoId, this.props.chromInfoId in this.availableChromSizes ? [...this.availableChromSizes[this.props.chromInfoId]][0].server : this.props.chromInfoServer);
            }
          }
        }, this.props.pubSub);
      });
    }
  }, {
    key: "findAvailableAutocompleteSources",
    value: function findAvailableAutocompleteSources() {
      if (!this.props.trackSourceServers) {
        return;
      }
      this.props.trackSourceServers.forEach((sourceServer) => {
        api.json(`${sourceServer}/tilesets/?limit=100&dt=gene-annotation`, (error, data2) => {
          if (error) {
            console.error(error);
          } else {
            data2.results.forEach((x) => {
              if (!(x.coordSystem in this.availableAutocompletes)) {
                this.availableAutocompletes[x.coordSystem] = /* @__PURE__ */ new Set();
              }
              this.availableAutocompletes[x.coordSystem].add({
                server: sourceServer,
                acId: x.uuid
              });
              this.setAvailableAssemblies();
            });
            if (!this.state.autocompleteId) {
              if (this.gpsbForm) {
                if (this.availableAutocompletes[this.props.chromInfoId]) {
                  this.setState({
                    autocompleteId: [...this.availableAutocompletes[this.props.chromInfoId]][0].acId
                  });
                }
              }
            }
          }
        }, this.props.pubSub);
      });
    }
    /**
     * The user has selected an assembly to use for the coordinate search box.
     * Once the appropriate ChromInfo file is fetched, it is stored locally
     *
     * @param {string} chromInfoId The name of the chromosome info set to use
     */
  }, {
    key: "fetchChromInfo",
    value: function fetchChromInfo(chromInfoId, server) {
      ChromosomeInfo(`${server}/chrom-sizes/?id=${chromInfoId}`, (newChromInfo) => {
        if (!newChromInfo) {
          return;
        }
        api.json(`${server}/tileset_info/?d=${chromInfoId}`, (error2, tilesetInfo) => {
          if (error2) {
            return;
          }
          if (this.gpsbForm) {
            this.setState({
              selectedAssembly: tilesetInfo[chromInfoId].coordSystem
            });
          }
        }, this.props.pubSub);
        this.chromInfo = newChromInfo;
        this.searchField = new SearchField(this.chromInfo);
        this.setPositionText();
      }, this.props.pubSub);
    }
  }, {
    key: "autocompleteKeyPress",
    value: function autocompleteKeyPress(event) {
      const ENTER_KEY_CODE = 13;
      if (event.keyCode === ENTER_KEY_CODE) {
        this.buttonClick();
      }
    }
  }, {
    key: "genePositionToSearchBarText",
    value: function genePositionToSearchBarText(genePosition) {
    }
  }, {
    key: "replaceGenesWithLoadedPositions",
    value: function replaceGenesWithLoadedPositions(genePositions) {
      const origSearchText = this.positionText;
      const spaceParts = origSearchText.split(" ");
      let foundGeneSymbol = false;
      for (let i = 0; i < spaceParts.length; i++) {
        const dashParts = spaceParts[i].split("-");
        let j = 0;
        let k = 0;
        let spacePart = "";
        while (j < dashParts.length) {
          k = dashParts.length;
          while (k > j) {
            const dashChunk = dashParts.slice(j, k).join("-");
            if (genePositions[dashChunk.toLowerCase()]) {
              const genePosition = genePositions[dashChunk.toLowerCase()];
              const extension = Math.floor((genePosition.txEnd - genePosition.txStart) / 4);
              if (j === 0 && k < dashParts.length) {
                spacePart = `${genePosition.chr}:${genePosition.txStart - extension}`;
              } else if (j === 0 && k === dashParts.length) {
                spacePart = `${genePosition.chr}:${genePosition.txStart - extension}-${genePosition.txEnd + extension}`;
              } else {
                spacePart += `- ${genePosition.chr}:${genePosition.txEnd + extension}`;
              }
              foundGeneSymbol = true;
              break;
            } else if (k === j + 1) {
              if (spacePart.length) {
                spacePart += "-";
              }
              spacePart += dashChunk;
            }
            k -= 1;
          }
          j = k + 1;
        }
        spaceParts[i] = spacePart;
      }
      const newValue = spaceParts.join(" ");
      this.prevParts = newValue.split(/[ -]/);
      this.positionText = newValue;
      this.setState({
        value: newValue
      });
      return foundGeneSymbol ? origSearchText : null;
    }
  }, {
    key: "replaceGenesWithPositions",
    value: function replaceGenesWithPositions(finished) {
      const valueParts = this.positionText.split(/[ -]/);
      const requests = [];
      for (let i = 0; i < valueParts.length; i++) {
        if (valueParts[i].length === 0) {
          continue;
        }
        const retPos = this.searchField.parsePosition(valueParts[i])[2];
        if (retPos === null || Number.isNaN(+retPos)) {
          const url = `${this.state.autocompleteServer}/suggest/?d=${this.state.autocompleteId}&ac=${valueParts[i].toLowerCase()}`;
          requests.push(api.json(url, toVoid, this.props.pubSub));
        }
      }
      Promise.all(requests).then((files) => {
        if (files) {
          const genePositions = {};
          for (let i = 0; i < files.length; i++) {
            if (!files[i][0]) {
              continue;
            }
            for (let j = 0; j < files[i].length; j++) {
              genePositions[files[i][j].geneName.toLowerCase()] = files[i][j];
            }
          }
          const geneSymbol = this.replaceGenesWithLoadedPositions(genePositions);
          finished(geneSymbol);
        }
      }).catch((error) => console.error(error));
    }
  }, {
    key: "buttonClick",
    value: function buttonClick() {
      this.setState({
        genes: []
      });
      this.replaceGenesWithPositions((geneSymbol) => {
        const searchFieldValue = this.positionText;
        if (this.searchField !== null) {
          const rangePair = this.searchField.searchPosition(searchFieldValue);
          const range1 = rangePair[0];
          let range2 = rangePair[1];
          if (!range1) {
            this.setPositionText();
            return;
          }
          if (range1 && (Number.isNaN(+range1[0]) || Number.isNaN(+range1[1])) || range2 && (Number.isNaN(+range2[0]) || Number.isNaN(+range2[1]))) {
            return;
          }
          if (!range2) {
            range2 = range1;
          }
          const newXScale = this.xScale.copy().domain(range1);
          const newYScale = this.yScale.copy().domain(range2);
          const [centerX, centerY, k] = scalesCenterAndK(newXScale, newYScale);
          if (geneSymbol) {
            this.props.onGeneSearch({
              geneSymbol,
              range: range1,
              centerX,
              centerY
            });
          }
          this.props.setCenters(centerX, centerY, k, ZOOM_TRANSITION_DURATION);
        }
      });
    }
  }, {
    key: "searchFieldSubmit",
    value: function searchFieldSubmit() {
      this.buttonClick();
    }
  }, {
    key: "pathJoin",
    value: function pathJoin(parts, sep) {
      const separator = sep || "/";
      const replace = new RegExp(`${separator}{1,}`, "g");
      return parts.join(separator).replace(replace, separator);
    }
  }, {
    key: "geneSelected",
    value: function geneSelected(value2, objct) {
      const parts = this.positionText.split(" ");
      let partCount = this.changedPart;
      for (let i = 0; i < parts.length; i++) {
        const dashParts = parts[i].split("-");
        const geneParts = objct.geneName.split("-");
        if (partCount > dashParts.length - 1) {
          partCount -= dashParts.length;
        } else {
          dashParts[partCount] = objct.geneName;
          if (geneParts.length === 2 && partCount > 0 && dashParts[partCount - 1].toLowerCase() === geneParts[0].toLowerCase()) {
            const newDashParts = dashParts.slice(0, partCount - 1);
            newDashParts.push(geneParts.join("-"));
            if (partCount < dashParts.length - 1) {
              newDashParts.push(dashParts.slice(partCount + 1));
            }
            parts[i] = newDashParts.join("-");
          } else {
            parts[i] = dashParts.join("-");
          }
          break;
        }
      }
      this.prevParts = parts.join(" ").split(/[ -]/);
      this.positionText = parts.join(" ");
      this.setState({
        value: parts.join(" "),
        genes: []
      });
    }
  }, {
    key: "handleMenuVisibilityChange",
    value: function handleMenuVisibilityChange(isOpen, inputEl) {
      const box = inputEl.getBoundingClientRect();
      this.menuPosition = {
        left: box.left,
        top: box.top + box.height
      };
      this.setState({
        menuOpened: isOpen
      });
    }
  }, {
    key: "handleRenderMenu",
    value: function handleRenderMenu(items2) {
      return /* @__PURE__ */ React$3.createElement(PopupMenu, null, /* @__PURE__ */ React$3.createElement("div", {
        className: styles$2["genome-position-search-bar-suggestions"],
        style: {
          left: this.menuPosition.left,
          top: this.menuPosition.top
        }
      }, items2));
    }
  }, {
    key: "handleAssemblySelectEvt",
    value: function handleAssemblySelectEvt(evt) {
      this.handleAssemblySelect(evt.target.value);
    }
  }, {
    key: "handleAssemblySelect",
    value: function handleAssemblySelect(assembly) {
      this.setSelectedAssembly(assembly);
      this.setState({
        selectedAssembly: assembly
      });
    }
  }, {
    key: "focusHandler",
    value: function focusHandler(isFocused) {
      this.setState({
        isFocused
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const assemblyMenuItems = this.state.availableAssemblies.map((x) => /* @__PURE__ */ React$3.createElement("option", {
        key: x,
        value: x
      }, x));
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.gpsbForm = c2;
        },
        className: clsx({
          [styles$2["genome-position-search-focus"]]: this.state.isFocused,
          [styles$2["genome-position-search"]]: !this.state.isFocused,
          [styles$2["genome-position-search-dark"]]: this.props.theme === THEME_DARK
        })
      }, !this.props.hideAvailableAssemblies && /* @__PURE__ */ React$3.createElement("select", {
        ref: (c2) => {
          this.assemblyPickButton = c2;
        },
        className: styles$2["genome-position-search-bar-button"],
        id: this.uid,
        onChange: this.handleAssemblySelectEvt.bind(this),
        value: this.state.selectedAssembly || void 0
      }, assemblyMenuItems), /* @__PURE__ */ React$3.createElement(Autocomplete, {
        ref: (c2) => {
          this.autocompleteMenu = c2;
        },
        getItemValue: (item) => item.geneName,
        inputProps: {
          className: styles$2["genome-position-search-bar"],
          title: "Current location: enter a symbol or location to change the position of the current view"
        },
        items: this.state.genes,
        menuStyle: {
          position: "absolute",
          left: this.menuPosition.left,
          top: this.menuPosition.top,
          border: "1px solid black"
        },
        onChange: this.onAutocompleteChange.bind(this),
        onFocus: this.focusHandler.bind(this),
        onMenuVisibilityChange: this.handleMenuVisibilityChange.bind(this),
        onSelect: (value2, objct) => this.geneSelected(value2, objct),
        onSubmit: this.searchFieldSubmit.bind(this),
        renderItem: (item, isHighlighted) => /* @__PURE__ */ React$3.createElement("div", {
          key: item.refseqid,
          id: item.refseqid,
          style: isHighlighted ? this.styles.highlightedItem : this.styles.item
        }, item.geneName),
        renderMenu: this.handleRenderMenu.bind(this),
        value: this.state.selectedAssembly ? this.positionText : "No valid assembly selected",
        wrapperStyle: {
          width: "100%"
        }
      }), /* @__PURE__ */ React$3.createElement(SearchIcon, {
        onClick: this.buttonClick.bind(this),
        theStyle: "multitrack-header-icon"
      }));
    }
  }]);
  return GenomePositionSearchBox2;
}(React$3.Component);
GenomePositionSearchBox.propTypes = {
  autocompleteId: PropTypes.string,
  autocompleteServer: PropTypes.string,
  chromInfoId: PropTypes.string,
  chromInfoServer: PropTypes.string,
  chromInfoPath: PropTypes.string,
  hideAvailableAssemblies: PropTypes.bool,
  isFocused: PropTypes.bool,
  pubSub: PropTypes.object,
  onFocus: PropTypes.func,
  onGeneSearch: PropTypes.func,
  onSelectedAssemblyChanged: PropTypes.func,
  registerViewportChangedListener: PropTypes.func,
  removeViewportChangedListener: PropTypes.func,
  setCenters: PropTypes.func,
  theme: PropTypes.symbol.isRequired,
  trackSourceServers: PropTypes.array,
  twoD: PropTypes.bool
};
const GenomePositionSearchBox$1 = withPubSub(withTheme(GenomePositionSearchBox));
const classes$2 = {
  "export-link-dialog-wrapper": "_export-link-dialog-wrapper_p9gxw_1"
};
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor);
  }
}
function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$5(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$5(subClass, superClass);
}
function _setPrototypeOf$5(o, p) {
  _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$5(o, p);
}
function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$5(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$5(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$6(this, result);
  };
}
function _possibleConstructorReturn$6(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$5(self2);
}
function _assertThisInitialized$5(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$5(o) {
  _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$5(o);
}
let ExportLinkDialog = /* @__PURE__ */ function(_React$Component) {
  _inherits$6(ExportLinkDialog2, _React$Component);
  var _super = _createSuper$5(ExportLinkDialog2);
  function ExportLinkDialog2() {
    _classCallCheck$6(this, ExportLinkDialog2);
    return _super.apply(this, arguments);
  }
  _createClass$6(ExportLinkDialog2, [{
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement(Dialog$1, {
        okayOnly: true,
        okayTitle: "Done",
        onOkay: this.props.onDone,
        title: "Share view link"
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: classes$2["export-link-dialog-wrapper"]
      }, /* @__PURE__ */ React$3.createElement("input", {
        ref: (element) => {
          if (!element)
            return;
          this.input = element;
          element.focus();
          element.select();
        },
        onClick: (event) => {
          event.target.select();
        },
        placeholder: "Generating the link...",
        readOnly: true,
        value: this.props.url
      }), /* @__PURE__ */ React$3.createElement(Button, {
        onClick: (event) => {
          this.input.select();
          document.execCommand("copy");
        }
      }, "Copy")));
    }
  }]);
  return ExportLinkDialog2;
}(React$3.Component);
ExportLinkDialog.defaultProps = {
  onDone: () => {
  },
  url: ""
};
ExportLinkDialog.propTypes = {
  onDone: PropTypes.func,
  url: PropTypes.string
};
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
  }
}
function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$4(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$4(subClass, superClass);
}
function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$4(o, p);
}
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$4(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$4(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$5(this, result);
  };
}
function _possibleConstructorReturn$5(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$4(self2);
}
function _assertThisInitialized$4(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$4(o);
}
let ConfigViewMenu = /* @__PURE__ */ function(_ContextMenuContainer) {
  _inherits$5(ConfigViewMenu2, _ContextMenuContainer);
  var _super = _createSuper$4(ConfigViewMenu2);
  function ConfigViewMenu2(props) {
    var _this;
    _classCallCheck$5(this, ConfigViewMenu2);
    _this = _super.call(this, props);
    _this.state = {
      submenuShown: false
    };
    return _this;
  }
  _createClass$5(ConfigViewMenu2, [{
    key: "getConfigureViewMenu",
    value: function getConfigureViewMenu(position, bbox) {
      const availableOptions = ["backgroundColor"];
      const menuItems = {};
      const newOptions = {};
      for (const optionType of availableOptions) {
        if (optionType in Object.keys(OPTIONS_INFO)) {
          menuItems[optionType] = {
            name: OPTIONS_INFO[optionType].name
          };
          if (OPTIONS_INFO[optionType].inlineOptions) {
            for (const inlineOptionKey in OPTIONS_INFO[optionType].inlineOptions) {
              const inlineOption = OPTIONS_INFO[optionType].inlineOptions[inlineOptionKey];
              if (!menuItems[optionType].children) {
                menuItems[optionType].children = {};
              }
              const optionSelectorSettings = {
                name: inlineOption.name,
                value: inlineOption.value
                // missing handler to be filled in below
              };
              optionSelectorSettings.handler = () => {
                newOptions[optionType] = inlineOption.value;
                this.props.onOptionsChanged(newOptions);
              };
              menuItems[optionType].children[inlineOptionKey] = optionSelectorSettings;
            }
          }
        }
      }
      return /* @__PURE__ */ React$3.createElement(NestedContextMenu, {
        key: "config-series-menu",
        closeMenu: this.props.closeMenu,
        menuItems,
        orientation: this.state.orientation,
        parentBbox: bbox,
        position,
        theme: this.props.theme
      });
    }
  }, {
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const subMenuData = this.state.submenuShown;
        if (subMenuData.option === "options") {
          return this.getConfigureViewMenu(position, bbox);
        }
        return /* @__PURE__ */ React$3.createElement("div", null);
      }
      return /* @__PURE__ */ React$3.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.div = c2;
        },
        className: clsx(classes$b["context-menu"], {
          [classes$b["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ConfigViewMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onTogglePositionSearchBox(e)
      }, "Toggle position search box"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onZoomToData(e)
      }, "Zoom to data extent"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onClearView(e)
      }, "Clear View"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankZoom(e)
      }, "Take zoom from"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankLocation(e)
      }, "Take location from"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankZoomAndLocation(e)
      }, "Take zoom and location from"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.props.onLockZoom
      }, "Lock zoom with"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.props.onLockLocation
      }, "Lock location with"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.props.onLockZoomAndLocation
      }, "Lock zoom and location with"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: this.props.onTakeAndLockZoomAndLocation
      }, "Take and lock zoom and location with"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockZoom(e)
      }, "Unlock zoom"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockLocation(e)
      }, "Unlock location"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockZoomAndLocation(e)
      }, "Unlock zoom and location"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onProjectViewport(e)
      }, "Show this viewport on"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onEditViewConfig(e)
      }, "Edit view config"), /* @__PURE__ */ React$3.createElement("hr", {
        className: classes$b["context-menu-hr"]
      }), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportSVG()
      }, "Export views as SVG"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportPNG()
      }, "Export views as PNG"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportViewAsJSON()
      }, "Export views as JSON"), /* @__PURE__ */ React$3.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportViewAsLink()
      }, "Export views as Link"), this.getSubmenu());
    }
  }]);
  return ConfigViewMenu2;
}(ContextMenuContainer);
ConfigViewMenu.propTypes = {
  onEditViewConfig: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func,
  onExportPNG: PropTypes.func,
  onExportViewAsJSON: PropTypes.func,
  onExportViewAsLink: PropTypes.func,
  onLockLocation: PropTypes.func,
  onLockZoom: PropTypes.func,
  onLockZoomAndLocation: PropTypes.func,
  onProjectViewport: PropTypes.func,
  onTakeAndLockZoomAndLocation: PropTypes.func,
  onTogglePositionSearchBox: PropTypes.func,
  onUnlockLocation: PropTypes.func,
  onUnlockZoom: PropTypes.func,
  onUnlockZoomAndLocation: PropTypes.func,
  onYankLocation: PropTypes.func,
  onYankZoom: PropTypes.func,
  onYankZoomAndLocation: PropTypes.func,
  onZoomToData: PropTypes.func,
  theme: PropTypes.symbol
};
const classes$1 = {
  "add-track-position-table": "_add-track-position-table_wdy5w_1",
  "add-track-position-table-dark": "_add-track-position-table-dark_wdy5w_7",
  "add-track-position-other": "_add-track-position-other_wdy5w_11",
  "add-track-position-top-center": "_add-track-position-top-center_wdy5w_15",
  "add-track-position-middle-left": "_add-track-position-middle-left_wdy5w_30",
  "add-track-position-middle-right": "_add-track-position-middle-right_wdy5w_45",
  "add-track-position-middle-middle": "_add-track-position-middle-middle_wdy5w_60",
  "add-track-position-bottom-middle": "_add-track-position-bottom-middle_wdy5w_71",
  "add-track-position-span": "_add-track-position-span_wdy5w_86"
};
function AddTrackPositionMenu(props) {
  return /* @__PURE__ */ React$3.createElement("div", null, /* @__PURE__ */ React$3.createElement("div", {
    className: classes$1["add-track-position-span"]
  }, "Add Track..."), /* @__PURE__ */ React$3.createElement("table", {
    className: clsx(classes$1["add-track-position-table"], {
      [classes$1["add-track-position-table-dark"]]: props.theme === THEME_DARK
    })
  }, /* @__PURE__ */ React$3.createElement("tbody", null, /* @__PURE__ */ React$3.createElement("tr", {
    style: {
      height: "30px"
    }
  }, /* @__PURE__ */ React$3.createElement("td", {
    "aria-hidden": "true",
    className: classes$1["add-track-position-other"]
  }), /* @__PURE__ */ React$3.createElement("td", {
    className: classes$1["add-track-position-top-center"],
    onClick: () => props.onTrackPositionChosen("top")
  }, "top"), /* @__PURE__ */ React$3.createElement("td", {
    "aria-hidden": "true",
    className: classes$1["add-track-position-other"]
  })), /* @__PURE__ */ React$3.createElement("tr", {
    style: {
      height: "80px"
    }
  }, /* @__PURE__ */ React$3.createElement("td", {
    className: classes$1["add-track-position-middle-left"],
    onClick: () => props.onTrackPositionChosen("left")
  }, "left"), /* @__PURE__ */ React$3.createElement("td", {
    className: classes$1["add-track-position-middle-middle"],
    onClick: () => props.onTrackPositionChosen("center")
  }, "center"), /* @__PURE__ */ React$3.createElement("td", {
    className: classes$1["add-track-position-middle-right"],
    onClick: () => props.onTrackPositionChosen("right")
  }, "right")), /* @__PURE__ */ React$3.createElement("tr", {
    style: {
      height: "30px"
    }
  }, /* @__PURE__ */ React$3.createElement("td", {
    "aria-hidden": "true",
    className: classes$1["add-track-position-other"]
  }), /* @__PURE__ */ React$3.createElement("td", {
    className: classes$1["add-track-position-bottom-middle"],
    onClick: () => props.onTrackPositionChosen("bottom")
  }, "bottom"), /* @__PURE__ */ React$3.createElement("td", {
    "aria-hidden": "true",
    className: classes$1["add-track-position-other"]
  })))));
}
AddTrackPositionMenu.propTypes = {
  onTrackPositionChosen: PropTypes.func.isRequired,
  theme: PropTypes.symbol.isRequired
};
const AddTrackPositionMenu$1 = withTheme(AddTrackPositionMenu);
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$3(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$3(o, p);
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$4(this, result);
  };
}
function _possibleConstructorReturn$4(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$3(self2);
}
function _assertThisInitialized$3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$3(o);
}
let ViewHeader = /* @__PURE__ */ function(_React$Component) {
  _inherits$4(ViewHeader2, _React$Component);
  var _super = _createSuper$3(ViewHeader2);
  function ViewHeader2(props) {
    var _this;
    _classCallCheck$4(this, ViewHeader2);
    _this = _super.call(this, props);
    _this.configImg = null;
    _this.plusImg = null;
    _this.state = {
      addTrackPositionMenuUid: null,
      addTrackPositionMenuPosition: null,
      configMenuUid: null,
      configMenuPosition: null,
      isFocused: false,
      width: -1
    };
    _this.handleTrackPositionChosenBound = _this.handleTrackPositionChosen.bind(_assertThisInitialized$3(_this));
    return _this;
  }
  _createClass$4(ViewHeader2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        width: this.el.clientWidth
      });
    }
  }, {
    key: "checkWidth",
    value: function checkWidth() {
      const width = this.el.clientWidth;
      if (width !== this.state.width)
        this.setState({
          width
        });
    }
    /**
     * The user clicked on the `cog` of the menu so we need to open
     * it.
     */
  }, {
    key: "handleConfigMenuOpened",
    value: function handleConfigMenuOpened(uid) {
      this.setState({
        configMenuUid: uid,
        configMenuPosition: this.configImg.getBoundingClientRect()
      });
    }
    /**
     * The user has clicked on the 'plus' sign at the top of a TiledPlot
     * so we need to open the Track Position Chooser dialog
     */
  }, {
    key: "handleAddTrackPositionMenuOpened",
    value: function handleAddTrackPositionMenuOpened(uid) {
      this.setState({
        addTrackPositionMenuUid: uid,
        addTrackPositionMenuPosition: this.plusImg.getBoundingClientRect()
      });
    }
    /**
     * The user has chosen a position for the new track. The actual
     * track selection will be handled by TiledPlot
     *
     * We just need to close the menu here.
     */
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(position) {
      this.props.onTrackPositionChosen(position);
      this.setState({
        addTrackPositionMenuUid: null,
        addTrackPositionMenuPosition: null
      });
    }
  }, {
    key: "render",
    value: function render3() {
      let configMenu = null;
      let addTrackPositionMenu = null;
      if (this.state.addTrackPositionMenuPosition) {
        addTrackPositionMenu = /* @__PURE__ */ React$3.createElement(PopupMenu, {
          onMenuClosed: () => {
            this.setState({
              addTrackPositionMenuUid: null,
              addTrackPositionMenuPosition: null
            });
          }
        }, /* @__PURE__ */ React$3.createElement(ContextMenuContainer, {
          orientation: "left",
          position: this.state.addTrackPositionMenuPosition,
          theme: this.props.theme
        }, /* @__PURE__ */ React$3.createElement(AddTrackPositionMenu$1, {
          onTrackPositionChosen: this.handleTrackPositionChosenBound
        })));
      }
      if (this.state.configMenuUid) {
        configMenu = /* @__PURE__ */ React$3.createElement(PopupMenu, {
          onMenuClosed: () => this.setState({
            configMenuUid: null
          })
        }, /* @__PURE__ */ React$3.createElement(ConfigViewMenu, {
          onClearView: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onClearView();
          },
          onEditViewConfig: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onEditViewConfig(this.state.configMenuUid);
          },
          onExportPNG: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportPNG();
          },
          onExportSVG: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportSVG();
          },
          onExportViewAsJSON: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportViewsAsJSON();
          },
          onExportViewAsLink: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportViewsAsLink();
          },
          onLockLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockLocation(this.state.configMenuUid);
          },
          onLockZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockZoom(this.state.configMenuUid);
          },
          onLockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockZoomAndLocation(this.state.configMenuUid);
          },
          onOptionsChanged: (newOptions) => {
            this.props.onViewOptionsChanged(newOptions);
            this.setState({
              configMenuUid: null
            });
          },
          onProjectViewport: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onProjectViewport(this.state.configMenuUid);
          },
          onTakeAndLockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onTakeAndLockZoomAndLocation(this.state.configMenuUid);
          },
          onTogglePositionSearchBox: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onTogglePositionSearchBox(this.state.configMenuUid);
          },
          onUnlockLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockLocation(this.state.configMenuUid);
          },
          onUnlockZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockZoom(this.state.configMenuUid);
          },
          onUnlockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockZoomAndLocation(this.state.configMenuUid);
          },
          onYankLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankLocation(this.state.configMenuUid);
          },
          onYankZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankZoom(this.state.configMenuUid);
          },
          onYankZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankZoomAndLocation(this.state.configMenuUid);
          },
          onZoomToData: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onZoomToData(this.state.configMenuUid);
          },
          orientation: "left",
          position: this.state.configMenuPosition,
          theme: this.props.theme
        }));
      }
      const GenomePositionSearchBox2 = this.props.getGenomePositionSearchBox(this.state.isFocused, (focus) => {
        this.setState({
          isFocused: focus
        });
      });
      const className2 = clsx(this.state.isFocused ? stylesMTHeader["multitrack-header-focus"] : stylesMTHeader["multitrack-header"], {
        [stylesMTHeader["multitrack-header-dark"]]: this.props.theme === THEME_DARK
      });
      const classNameIcon = this.state.width <= VIEW_HEADER_MED_WIDTH_SEARCH_BAR ? stylesMTHeader["multitrack-header-icon-squeazed"] : stylesMTHeader["multitrack-header-icon"];
      return /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.el = c2;
        },
        className: className2
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: stylesMTHeader["multitrack-header-left"]
      }, this.props.mouseTool === MOUSE_TOOL_SELECT && /* @__PURE__ */ React$3.createElement("svg", {
        className: clsx(stylesMTHeader["mouse-tool-selection"], classNameIcon),
        title: "Selection tool active"
      }, /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#select"
      })), /* @__PURE__ */ React$3.createElement("div", {
        className: stylesMTHeader["multitrack-header-grabber"],
        title: "Drag to move the view"
      }, /* @__PURE__ */ React$3.createElement("div", null), /* @__PURE__ */ React$3.createElement("div", null), /* @__PURE__ */ React$3.createElement("div", null)), this.state.width > VIEW_HEADER_MIN_WIDTH_SEARCH_BAR && /* @__PURE__ */ React$3.createElement("div", {
        className: stylesMTHeader["multitrack-header-search"]
      }, this.props.isGenomePositionSearchBoxVisible && GenomePositionSearchBox2)), /* @__PURE__ */ React$3.createElement("nav", {
        className: stylesMTHeader["multitrack-header-nav-list"]
      }, /* @__PURE__ */ React$3.createElement("svg", {
        className: classNameIcon,
        onClick: this.props.onAddView
      }, /* @__PURE__ */ React$3.createElement("title", null, "Add new view (clone this view)"), /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#copy"
      })), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.configImg = c2;
        },
        className: classNameIcon,
        onClick: () => this.handleConfigMenuOpened(this.props.viewUid)
      }, /* @__PURE__ */ React$3.createElement("title", null, "Configure this view"), /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#cog"
      })), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.plusImg = c2;
        },
        className: classNameIcon,
        onClick: () => this.handleAddTrackPositionMenuOpened(this.props.viewUid)
      }, /* @__PURE__ */ React$3.createElement("title", null, "Add Track"), /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#plus"
      })), /* @__PURE__ */ React$3.createElement("svg", {
        className: classNameIcon,
        onClick: this.props.onCloseView
      }, /* @__PURE__ */ React$3.createElement("title", null, "Close View"), /* @__PURE__ */ React$3.createElement("use", {
        xlinkHref: "#cross"
      }))), configMenu, addTrackPositionMenu);
    }
  }]);
  return ViewHeader2;
}(React$3.Component);
ViewHeader.defaultProps = {
  isGenomePositionSearchBoxVisible: false
};
ViewHeader.propTypes = {
  getGenomePositionSearchBox: PropTypes.func.isRequired,
  isGenomePositionSearchBoxVisible: PropTypes.bool,
  mouseTool: PropTypes.string.isRequired,
  onAddView: PropTypes.func.isRequired,
  onClearView: PropTypes.func.isRequired,
  onCloseView: PropTypes.func.isRequired,
  onEditViewConfig: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func.isRequired,
  onExportPNG: PropTypes.func.isRequired,
  onExportViewsAsJSON: PropTypes.func.isRequired,
  onExportViewsAsLink: PropTypes.func.isRequired,
  onLockLocation: PropTypes.func.isRequired,
  onLockZoom: PropTypes.func.isRequired,
  onLockZoomAndLocation: PropTypes.func.isRequired,
  onProjectViewport: PropTypes.func.isRequired,
  onTakeAndLockZoomAndLocation: PropTypes.func.isRequired,
  onTogglePositionSearchBox: PropTypes.func.isRequired,
  onTrackPositionChosen: PropTypes.func.isRequired,
  onUnlockLocation: PropTypes.func.isRequired,
  onUnlockZoom: PropTypes.func.isRequired,
  onUnlockZoomAndLocation: PropTypes.func.isRequired,
  onViewOptionsChanged: PropTypes.func.isRequired,
  onYankLocation: PropTypes.func.isRequired,
  onYankZoom: PropTypes.func.isRequired,
  onYankZoomAndLocation: PropTypes.func.isRequired,
  onZoomToData: PropTypes.func.isRequired,
  theme: PropTypes.symbol.isRequired,
  viewUid: PropTypes.string.isRequired
};
const ViewHeader$1 = withTheme(ViewHeader);
var lib = {};
Object.defineProperty(lib, "__esModule", {
  value: true
});
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$3 = /* @__PURE__ */ function() {
  function defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = React$3;
var React = _interopRequireWildcard(_react);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key))
          newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _objectWithoutProperties(obj, keys3) {
  var target = {};
  for (var i in obj) {
    if (keys3.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$3(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var KEYCODE_ENTER = 13;
var KEYCODE_TAB = 9;
var KEYCODE_BACKSPACE = 8;
var KEYCODE_Y = 89;
var KEYCODE_Z = 90;
var KEYCODE_M = 77;
var KEYCODE_PARENS = 57;
var KEYCODE_BRACKETS = 219;
var KEYCODE_QUOTE = 222;
var KEYCODE_BACK_QUOTE = 192;
var KEYCODE_ESCAPE = 27;
var HISTORY_LIMIT = 100;
var HISTORY_TIME_GAP = 3e3;
var isWindows = "navigator" in globalThis && /Win/i.test(navigator.platform);
var isMacLike = "navigator" in globalThis && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
var className = "npm__react-simple-code-editor__textarea";
var cssText = (
  /* CSS */
  "\n/**\n * Reset the text fill color so that placeholder is visible\n */\n." + className + ":empty {\n  -webkit-text-fill-color: inherit !important;\n}\n\n/**\n * Hack to apply on some CSS on IE10 and IE11\n */\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /**\n    * IE doesn't support '-webkit-text-fill-color'\n    * So we use 'color: transparent' to make the text transparent on IE\n    * Unlike other browsers, it doesn't affect caret color in IE\n    */\n  ." + className + " {\n    color: transparent !important;\n  }\n\n  ." + className + "::selection {\n    background-color: #accef7 !important;\n    color: transparent !important;\n  }\n}\n"
);
var Editor = function(_React$Component) {
  _inherits$3(Editor2, _React$Component);
  function Editor2() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck$3(this, Editor2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = Editor2.__proto__ || Object.getPrototypeOf(Editor2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      capture: true
    }, _this._recordCurrentState = function() {
      var input = _this._input;
      if (!input)
        return;
      var value2 = input.value, selectionStart = input.selectionStart, selectionEnd = input.selectionEnd;
      _this._recordChange({
        value: value2,
        selectionStart,
        selectionEnd
      });
    }, _this._getLines = function(text2, position) {
      return text2.substring(0, position).split("\n");
    }, _this._recordChange = function(record) {
      var overwrite = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var _this$_history = _this._history, stack = _this$_history.stack, offset2 = _this$_history.offset;
      if (stack.length && offset2 > -1) {
        _this._history.stack = stack.slice(0, offset2 + 1);
        var count2 = _this._history.stack.length;
        if (count2 > HISTORY_LIMIT) {
          var extras = count2 - HISTORY_LIMIT;
          _this._history.stack = stack.slice(extras, count2);
          _this._history.offset = Math.max(_this._history.offset - extras, 0);
        }
      }
      var timestamp = Date.now();
      if (overwrite) {
        var last2 = _this._history.stack[_this._history.offset];
        if (last2 && timestamp - last2.timestamp < HISTORY_TIME_GAP) {
          var re2 = /[^a-z0-9]([a-z0-9]+)$/i;
          var previous = _this._getLines(last2.value, last2.selectionStart).pop().match(re2);
          var current = _this._getLines(record.value, record.selectionStart).pop().match(re2);
          if (previous && current && current[1].startsWith(previous[1])) {
            _this._history.stack[_this._history.offset] = _extends({}, record, {
              timestamp
            });
            return;
          }
        }
      }
      _this._history.stack.push(_extends({}, record, {
        timestamp
      }));
      _this._history.offset++;
    }, _this._updateInput = function(record) {
      var input = _this._input;
      if (!input)
        return;
      input.value = record.value;
      input.selectionStart = record.selectionStart;
      input.selectionEnd = record.selectionEnd;
      _this.props.onValueChange(record.value);
    }, _this._applyEdits = function(record) {
      var input = _this._input;
      var last2 = _this._history.stack[_this._history.offset];
      if (last2 && input) {
        _this._history.stack[_this._history.offset] = _extends({}, last2, {
          selectionStart: input.selectionStart,
          selectionEnd: input.selectionEnd
        });
      }
      _this._recordChange(record);
      _this._updateInput(record);
    }, _this._undoEdit = function() {
      var _this$_history2 = _this._history, stack = _this$_history2.stack, offset2 = _this$_history2.offset;
      var record = stack[offset2 - 1];
      if (record) {
        _this._updateInput(record);
        _this._history.offset = Math.max(offset2 - 1, 0);
      }
    }, _this._redoEdit = function() {
      var _this$_history3 = _this._history, stack = _this$_history3.stack, offset2 = _this$_history3.offset;
      var record = stack[offset2 + 1];
      if (record) {
        _this._updateInput(record);
        _this._history.offset = Math.min(offset2 + 1, stack.length - 1);
      }
    }, _this._handleKeyDown = function(e) {
      var _this$props = _this.props, tabSize = _this$props.tabSize, insertSpaces = _this$props.insertSpaces, ignoreTabKey = _this$props.ignoreTabKey, onKeyDown = _this$props.onKeyDown;
      if (onKeyDown) {
        onKeyDown(e);
        if (e.defaultPrevented) {
          return;
        }
      }
      if (e.keyCode === KEYCODE_ESCAPE) {
        e.target.blur();
      }
      var _e$target = e.target, value2 = _e$target.value, selectionStart = _e$target.selectionStart, selectionEnd = _e$target.selectionEnd;
      var tabCharacter = (insertSpaces ? " " : "	").repeat(tabSize);
      if (e.keyCode === KEYCODE_TAB && !ignoreTabKey && _this.state.capture) {
        e.preventDefault();
        if (e.shiftKey) {
          var linesBeforeCaret = _this._getLines(value2, selectionStart);
          var startLine = linesBeforeCaret.length - 1;
          var endLine = _this._getLines(value2, selectionEnd).length - 1;
          var nextValue = value2.split("\n").map(function(line2, i) {
            if (i >= startLine && i <= endLine && line2.startsWith(tabCharacter)) {
              return line2.substring(tabCharacter.length);
            }
            return line2;
          }).join("\n");
          if (value2 !== nextValue) {
            var startLineText = linesBeforeCaret[startLine];
            _this._applyEdits({
              value: nextValue,
              // Move the start cursor if first line in selection was modified
              // It was modified only if it started with a tab
              selectionStart: startLineText.startsWith(tabCharacter) ? selectionStart - tabCharacter.length : selectionStart,
              // Move the end cursor by total number of characters removed
              selectionEnd: selectionEnd - (value2.length - nextValue.length)
            });
          }
        } else if (selectionStart !== selectionEnd) {
          var _linesBeforeCaret = _this._getLines(value2, selectionStart);
          var _startLine = _linesBeforeCaret.length - 1;
          var _endLine = _this._getLines(value2, selectionEnd).length - 1;
          var _startLineText = _linesBeforeCaret[_startLine];
          _this._applyEdits({
            value: value2.split("\n").map(function(line2, i) {
              if (i >= _startLine && i <= _endLine) {
                return tabCharacter + line2;
              }
              return line2;
            }).join("\n"),
            // Move the start cursor by number of characters added in first line of selection
            // Don't move it if it there was no text before cursor
            selectionStart: /\S/.test(_startLineText) ? selectionStart + tabCharacter.length : selectionStart,
            // Move the end cursor by total number of characters added
            selectionEnd: selectionEnd + tabCharacter.length * (_endLine - _startLine + 1)
          });
        } else {
          var updatedSelection = selectionStart + tabCharacter.length;
          _this._applyEdits({
            // Insert tab character at caret
            value: value2.substring(0, selectionStart) + tabCharacter + value2.substring(selectionEnd),
            // Update caret position
            selectionStart: updatedSelection,
            selectionEnd: updatedSelection
          });
        }
      } else if (e.keyCode === KEYCODE_BACKSPACE) {
        var hasSelection = selectionStart !== selectionEnd;
        var textBeforeCaret = value2.substring(0, selectionStart);
        if (textBeforeCaret.endsWith(tabCharacter) && !hasSelection) {
          e.preventDefault();
          var _updatedSelection = selectionStart - tabCharacter.length;
          _this._applyEdits({
            // Remove tab character at caret
            value: value2.substring(0, selectionStart - tabCharacter.length) + value2.substring(selectionEnd),
            // Update caret position
            selectionStart: _updatedSelection,
            selectionEnd: _updatedSelection
          });
        }
      } else if (e.keyCode === KEYCODE_ENTER) {
        if (selectionStart === selectionEnd) {
          var line = _this._getLines(value2, selectionStart).pop();
          var matches = line.match(/^\s+/);
          if (matches && matches[0]) {
            e.preventDefault();
            var indent2 = "\n" + matches[0];
            var _updatedSelection2 = selectionStart + indent2.length;
            _this._applyEdits({
              // Insert indentation character at caret
              value: value2.substring(0, selectionStart) + indent2 + value2.substring(selectionEnd),
              // Update caret position
              selectionStart: _updatedSelection2,
              selectionEnd: _updatedSelection2
            });
          }
        }
      } else if (e.keyCode === KEYCODE_PARENS || e.keyCode === KEYCODE_BRACKETS || e.keyCode === KEYCODE_QUOTE || e.keyCode === KEYCODE_BACK_QUOTE) {
        var chars = void 0;
        if (e.keyCode === KEYCODE_PARENS && e.shiftKey) {
          chars = ["(", ")"];
        } else if (e.keyCode === KEYCODE_BRACKETS) {
          if (e.shiftKey) {
            chars = ["{", "}"];
          } else {
            chars = ["[", "]"];
          }
        } else if (e.keyCode === KEYCODE_QUOTE) {
          if (e.shiftKey) {
            chars = ['"', '"'];
          } else {
            chars = ["'", "'"];
          }
        } else if (e.keyCode === KEYCODE_BACK_QUOTE && !e.shiftKey) {
          chars = ["`", "`"];
        }
        if (selectionStart !== selectionEnd && chars) {
          e.preventDefault();
          _this._applyEdits({
            value: value2.substring(0, selectionStart) + chars[0] + value2.substring(selectionStart, selectionEnd) + chars[1] + value2.substring(selectionEnd),
            // Update caret position
            selectionStart,
            selectionEnd: selectionEnd + 2
          });
        }
      } else if ((isMacLike ? (
        // Trigger undo with ⌘+Z on Mac
        e.metaKey && e.keyCode === KEYCODE_Z
      ) : (
        // Trigger undo with Ctrl+Z on other platforms
        e.ctrlKey && e.keyCode === KEYCODE_Z
      )) && !e.shiftKey && !e.altKey) {
        e.preventDefault();
        _this._undoEdit();
      } else if ((isMacLike ? (
        // Trigger redo with ⌘+Shift+Z on Mac
        e.metaKey && e.keyCode === KEYCODE_Z && e.shiftKey
      ) : isWindows ? (
        // Trigger redo with Ctrl+Y on Windows
        e.ctrlKey && e.keyCode === KEYCODE_Y
      ) : (
        // Trigger redo with Ctrl+Shift+Z on other platforms
        e.ctrlKey && e.keyCode === KEYCODE_Z && e.shiftKey
      )) && !e.altKey) {
        e.preventDefault();
        _this._redoEdit();
      } else if (e.keyCode === KEYCODE_M && e.ctrlKey && (isMacLike ? e.shiftKey : true)) {
        e.preventDefault();
        _this.setState(function(state) {
          return {
            capture: !state.capture
          };
        });
      }
    }, _this._handleChange = function(e) {
      var _e$target2 = e.target, value2 = _e$target2.value, selectionStart = _e$target2.selectionStart, selectionEnd = _e$target2.selectionEnd;
      _this._recordChange({
        value: value2,
        selectionStart,
        selectionEnd
      }, true);
      _this.props.onValueChange(value2);
    }, _this._history = {
      stack: [],
      offset: -1
    }, _temp), _possibleConstructorReturn$3(_this, _ret);
  }
  _createClass$3(Editor2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._recordCurrentState();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _props = this.props, value2 = _props.value, style = _props.style, padding = _props.padding, highlight = _props.highlight, textareaId = _props.textareaId, autoFocus = _props.autoFocus, disabled = _props.disabled, form = _props.form, maxLength = _props.maxLength, minLength = _props.minLength, name = _props.name, placeholder = _props.placeholder, readOnly = _props.readOnly, required3 = _props.required, onClick = _props.onClick, onFocus = _props.onFocus, onBlur = _props.onBlur, onKeyUp = _props.onKeyUp;
      _props.onKeyDown;
      _props.onValueChange;
      _props.tabSize;
      _props.insertSpaces;
      _props.ignoreTabKey;
      var rest = _objectWithoutProperties(_props, ["value", "style", "padding", "highlight", "textareaId", "autoFocus", "disabled", "form", "maxLength", "minLength", "name", "placeholder", "readOnly", "required", "onClick", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onValueChange", "tabSize", "insertSpaces", "ignoreTabKey"]);
      var contentStyle = {
        paddingTop: padding,
        paddingRight: padding,
        paddingBottom: padding,
        paddingLeft: padding
      };
      var highlighted = highlight(value2);
      return React.createElement("div", _extends({}, rest, {
        style: _extends({}, styles$1.container, style)
      }), React.createElement("textarea", {
        ref: function ref2(c2) {
          return _this2._input = c2;
        },
        style: _extends({}, styles$1.editor, styles$1.textarea, contentStyle),
        className,
        id: textareaId,
        value: value2,
        onChange: this._handleChange,
        onKeyDown: this._handleKeyDown,
        onClick,
        onKeyUp,
        onFocus,
        onBlur,
        disabled,
        form,
        maxLength,
        minLength,
        name,
        placeholder,
        readOnly,
        required: required3,
        autoFocus,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: false,
        "data-gramm": false
      }), React.createElement("pre", _extends({
        "aria-hidden": "true",
        style: _extends({}, styles$1.editor, styles$1.highlight, contentStyle)
      }, typeof highlighted === "string" ? {
        dangerouslySetInnerHTML: {
          __html: highlighted + "<br />"
        }
      } : {
        children: highlighted
      })), React.createElement("style", {
        type: "text/css",
        dangerouslySetInnerHTML: {
          __html: cssText
        }
      }));
    }
  }, {
    key: "session",
    get: function get3() {
      return {
        history: this._history
      };
    },
    set: function set2(session) {
      this._history = session.history;
    }
  }]);
  return Editor2;
}(React.Component);
Editor.defaultProps = {
  tabSize: 2,
  insertSpaces: true,
  ignoreTabKey: false,
  padding: 0
};
var _default = lib.default = Editor;
var styles$1 = {
  container: {
    position: "relative",
    textAlign: "left",
    boxSizing: "border-box",
    padding: 0,
    overflow: "hidden"
  },
  textarea: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    resize: "none",
    color: "inherit",
    overflow: "hidden",
    MozOsxFontSmoothing: "grayscale",
    WebkitFontSmoothing: "antialiased",
    WebkitTextFillColor: "transparent"
  },
  highlight: {
    position: "relative",
    pointerEvents: "none"
  },
  editor: {
    margin: 0,
    border: 0,
    background: "none",
    boxSizing: "inherit",
    display: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "inherit",
    fontVariantLigatures: "inherit",
    fontWeight: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit",
    tabSize: "inherit",
    textIndent: "inherit",
    textRendering: "inherit",
    textTransform: "inherit",
    whiteSpace: "pre-wrap",
    wordBreak: "keep-all",
    overflowWrap: "break-word"
  }
};
var prismCore = { exports: {} };
(function(module2) {
  var _self = typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var Prism2 = function(_self2) {
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    var plainTextGrammar = {};
    var _ = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: _self2.Prism && _self2.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: _self2.Prism && _self2.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function encode2(tokens) {
          if (tokens instanceof Token) {
            return new Token(tokens.type, encode2(tokens.content), tokens.alias);
          } else if (Array.isArray(tokens)) {
            return tokens.map(encode2);
          } else {
            return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          }
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(o) {
          return Object.prototype.toString.call(o).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(obj) {
          if (!obj["__id"]) {
            Object.defineProperty(obj, "__id", {
              value: ++uniqueId
            });
          }
          return obj["__id"];
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function deepClone(o, visited) {
          visited = visited || {};
          var clone4;
          var id2;
          switch (_.util.type(o)) {
            case "Object":
              id2 = _.util.objId(o);
              if (visited[id2]) {
                return visited[id2];
              }
              clone4 = /** @type {Record<string, any>} */
              {};
              visited[id2] = clone4;
              for (var key in o) {
                if (o.hasOwnProperty(key)) {
                  clone4[key] = deepClone(o[key], visited);
                }
              }
              return (
                /** @type {any} */
                clone4
              );
            case "Array":
              id2 = _.util.objId(o);
              if (visited[id2]) {
                return visited[id2];
              }
              clone4 = [];
              visited[id2] = clone4;
              o.forEach(function(v, i) {
                clone4[i] = deepClone(v, visited);
              });
              return (
                /** @type {any} */
                clone4
              );
            default:
              return o;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(element) {
          while (element) {
            var m = lang.exec(element.className);
            if (m) {
              return m[1].toLowerCase();
            }
            element = element.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(element, language) {
          element.className = element.className.replace(RegExp(lang, "gi"), "");
          element.classList.add("language-" + language);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document === "undefined") {
            return null;
          }
          if ("currentScript" in document && 1 < 2) {
            return (
              /** @type {any} */
              document.currentScript
            );
          }
          try {
            throw new Error();
          } catch (err2) {
            var src2 = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err2.stack) || [])[1];
            if (src2) {
              var scripts = document.getElementsByTagName("script");
              for (var i in scripts) {
                if (scripts[i].src == src2) {
                  return scripts[i];
                }
              }
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(element, className2, defaultActivation) {
          var no = "no-" + className2;
          while (element) {
            var classList2 = element.classList;
            if (classList2.contains(className2)) {
              return true;
            }
            if (classList2.contains(no)) {
              return false;
            }
            element = element.parentElement;
          }
          return !!defaultActivation;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: plainTextGrammar,
        plaintext: plainTextGrammar,
        text: plainTextGrammar,
        txt: plainTextGrammar,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(id2, redef) {
          var lang2 = _.util.clone(_.languages[id2]);
          for (var key in redef) {
            lang2[key] = redef[key];
          }
          return lang2;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(inside, before2, insert, root2) {
          root2 = root2 || /** @type {any} */
          _.languages;
          var grammar2 = root2[inside];
          var ret = {};
          for (var token2 in grammar2) {
            if (grammar2.hasOwnProperty(token2)) {
              if (token2 == before2) {
                for (var newToken in insert) {
                  if (insert.hasOwnProperty(newToken)) {
                    ret[newToken] = insert[newToken];
                  }
                }
              }
              if (!insert.hasOwnProperty(token2)) {
                ret[token2] = grammar2[token2];
              }
            }
          }
          var old = root2[inside];
          root2[inside] = ret;
          _.languages.DFS(_.languages, function(key, value2) {
            if (value2 === old && key != inside) {
              this[key] = ret;
            }
          });
          return ret;
        },
        // Traverse a language definition with Depth First Search
        DFS: function DFS(o, callback, type3, visited) {
          visited = visited || {};
          var objId = _.util.objId;
          for (var i in o) {
            if (o.hasOwnProperty(i)) {
              callback.call(o, i, o[i], type3 || i);
              var property2 = o[i];
              var propertyType = _.util.type(property2);
              if (propertyType === "Object" && !visited[objId(property2)]) {
                visited[objId(property2)] = true;
                DFS(property2, callback, null, visited);
              } else if (propertyType === "Array" && !visited[objId(property2)]) {
                visited[objId(property2)] = true;
                DFS(property2, callback, i, visited);
              }
            }
          }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(async2, callback) {
        _.highlightAllUnder(document, async2, callback);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(container, async2, callback) {
        var env = {
          callback,
          container,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        _.hooks.run("before-highlightall", env);
        env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
        _.hooks.run("before-all-elements-highlight", env);
        for (var i = 0, element; element = env.elements[i++]; ) {
          _.highlightElement(element, async2 === true, env.callback);
        }
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(element, async2, callback) {
        var language = _.util.getLanguage(element);
        var grammar2 = _.languages[language];
        _.util.setLanguage(element, language);
        var parent = element.parentElement;
        if (parent && parent.nodeName.toLowerCase() === "pre") {
          _.util.setLanguage(parent, language);
        }
        var code2 = element.textContent;
        var env = {
          element,
          language,
          grammar: grammar2,
          code: code2
        };
        function insertHighlightedCode(highlightedCode) {
          env.highlightedCode = highlightedCode;
          _.hooks.run("before-insert", env);
          env.element.innerHTML = env.highlightedCode;
          _.hooks.run("after-highlight", env);
          _.hooks.run("complete", env);
          callback && callback.call(env.element);
        }
        _.hooks.run("before-sanity-check", env);
        parent = env.element.parentElement;
        if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) {
          parent.setAttribute("tabindex", "0");
        }
        if (!env.code) {
          _.hooks.run("complete", env);
          callback && callback.call(env.element);
          return;
        }
        _.hooks.run("before-highlight", env);
        if (!env.grammar) {
          insertHighlightedCode(_.util.encode(env.code));
          return;
        }
        if (async2 && _self2.Worker) {
          var worker = new Worker(_.filename);
          worker.onmessage = function(evt) {
            insertHighlightedCode(evt.data);
          };
          worker.postMessage(JSON.stringify({
            language: env.language,
            code: env.code,
            immediateClose: true
          }));
        } else {
          insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        }
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(text2, grammar2, language) {
        var env = {
          code: text2,
          grammar: grammar2,
          language
        };
        _.hooks.run("before-tokenize", env);
        if (!env.grammar) {
          throw new Error('The language "' + env.language + '" has no grammar.');
        }
        env.tokens = _.tokenize(env.code, env.grammar);
        _.hooks.run("after-tokenize", env);
        return Token.stringify(_.util.encode(env.tokens), env.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(text2, grammar2) {
        var rest = grammar2.rest;
        if (rest) {
          for (var token2 in rest) {
            grammar2[token2] = rest[token2];
          }
          delete grammar2.rest;
        }
        var tokenList = new LinkedList();
        addAfter(tokenList, tokenList.head, text2);
        matchGrammar(text2, tokenList, grammar2, tokenList.head, 0);
        return toArray2(tokenList);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(name, callback) {
          var hooks = _.hooks.all;
          hooks[name] = hooks[name] || [];
          hooks[name].push(callback);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(name, env) {
          var callbacks = _.hooks.all[name];
          if (!callbacks || !callbacks.length) {
            return;
          }
          for (var i = 0, callback; callback = callbacks[i++]; ) {
            callback(env);
          }
        }
      },
      Token
    };
    _self2.Prism = _;
    function Token(type3, content, alias, matchedStr) {
      this.type = type3;
      this.content = content;
      this.alias = alias;
      this.length = (matchedStr || "").length | 0;
    }
    Token.stringify = function stringify2(o, language) {
      if (typeof o == "string") {
        return o;
      }
      if (Array.isArray(o)) {
        var s = "";
        o.forEach(function(e) {
          s += stringify2(e, language);
        });
        return s;
      }
      var env = {
        type: o.type,
        content: stringify2(o.content, language),
        tag: "span",
        classes: ["token", o.type],
        attributes: {},
        language
      };
      var aliases2 = o.alias;
      if (aliases2) {
        if (Array.isArray(aliases2)) {
          Array.prototype.push.apply(env.classes, aliases2);
        } else {
          env.classes.push(aliases2);
        }
      }
      _.hooks.run("wrap", env);
      var attributes2 = "";
      for (var name in env.attributes) {
        attributes2 += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
      }
      return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes2 + ">" + env.content + "</" + env.tag + ">";
    };
    function matchPattern(pattern2, pos, text2, lookbehind) {
      pattern2.lastIndex = pos;
      var match = pattern2.exec(text2);
      if (match && lookbehind && match[1]) {
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
      }
      return match;
    }
    function matchGrammar(text2, tokenList, grammar2, startNode, startPos, rematch) {
      for (var token2 in grammar2) {
        if (!grammar2.hasOwnProperty(token2) || !grammar2[token2]) {
          continue;
        }
        var patterns = grammar2[token2];
        patterns = Array.isArray(patterns) ? patterns : [patterns];
        for (var j = 0; j < patterns.length; ++j) {
          if (rematch && rematch.cause == token2 + "," + j) {
            return;
          }
          var patternObj = patterns[j];
          var inside = patternObj.inside;
          var lookbehind = !!patternObj.lookbehind;
          var greedy = !!patternObj.greedy;
          var alias = patternObj.alias;
          if (greedy && !patternObj.pattern.global) {
            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
          }
          var pattern2 = patternObj.pattern || patternObj;
          for (var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
            if (rematch && pos >= rematch.reach) {
              break;
            }
            var str = currentNode.value;
            if (tokenList.length > text2.length) {
              return;
            }
            if (str instanceof Token) {
              continue;
            }
            var removeCount = 1;
            var match;
            if (greedy) {
              match = matchPattern(pattern2, pos, text2, lookbehind);
              if (!match || match.index >= text2.length) {
                break;
              }
              var from = match.index;
              var to = match.index + match[0].length;
              var p = pos;
              p += currentNode.value.length;
              while (from >= p) {
                currentNode = currentNode.next;
                p += currentNode.value.length;
              }
              p -= currentNode.value.length;
              pos = p;
              if (currentNode.value instanceof Token) {
                continue;
              }
              for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next) {
                removeCount++;
                p += k.value.length;
              }
              removeCount--;
              str = text2.slice(pos, p);
              match.index -= pos;
            } else {
              match = matchPattern(pattern2, 0, str, lookbehind);
              if (!match) {
                continue;
              }
            }
            var from = match.index;
            var matchStr = match[0];
            var before2 = str.slice(0, from);
            var after2 = str.slice(from + matchStr.length);
            var reach = pos + str.length;
            if (rematch && reach > rematch.reach) {
              rematch.reach = reach;
            }
            var removeFrom = currentNode.prev;
            if (before2) {
              removeFrom = addAfter(tokenList, removeFrom, before2);
              pos += before2.length;
            }
            removeRange(tokenList, removeFrom, removeCount);
            var wrapped = new Token(token2, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
            currentNode = addAfter(tokenList, removeFrom, wrapped);
            if (after2) {
              addAfter(tokenList, currentNode, after2);
            }
            if (removeCount > 1) {
              var nestedRematch = {
                cause: token2 + "," + j,
                reach
              };
              matchGrammar(text2, tokenList, grammar2, currentNode.prev, pos, nestedRematch);
              if (rematch && nestedRematch.reach > rematch.reach) {
                rematch.reach = nestedRematch.reach;
              }
            }
          }
        }
      }
    }
    function LinkedList() {
      var head = {
        value: null,
        prev: null,
        next: null
      };
      var tail = {
        value: null,
        prev: head,
        next: null
      };
      head.next = tail;
      this.head = head;
      this.tail = tail;
      this.length = 0;
    }
    function addAfter(list2, node2, value2) {
      var next = node2.next;
      var newNode = {
        value: value2,
        prev: node2,
        next
      };
      node2.next = newNode;
      next.prev = newNode;
      list2.length++;
      return newNode;
    }
    function removeRange(list2, node2, count2) {
      var next = node2.next;
      for (var i = 0; i < count2 && next !== list2.tail; i++) {
        next = next.next;
      }
      node2.next = next;
      next.prev = node2;
      list2.length -= i;
    }
    function toArray2(list2) {
      var array2 = [];
      var node2 = list2.head.next;
      while (node2 !== list2.tail) {
        array2.push(node2.value);
        node2 = node2.next;
      }
      return array2;
    }
    if (!_self2.document) {
      if (!_self2.addEventListener) {
        return _;
      }
      if (!_.disableWorkerMessageHandler) {
        _self2.addEventListener("message", function(evt) {
          var message = JSON.parse(evt.data);
          var lang2 = message.language;
          var code2 = message.code;
          var immediateClose = message.immediateClose;
          _self2.postMessage(_.highlight(code2, _.languages[lang2], lang2));
          if (immediateClose) {
            _self2.close();
          }
        }, false);
      }
      return _;
    }
    var script = _.util.currentScript();
    if (script) {
      _.filename = script.src;
      if (script.hasAttribute("data-manual")) {
        _.manual = true;
      }
    }
    function highlightAutomaticallyCallback() {
      if (!_.manual) {
        _.highlightAll();
      }
    }
    if (!_.manual) {
      var readyState = document.readyState;
      if (readyState === "loading" || readyState === "interactive" && script && script.defer) {
        document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
      } else {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(highlightAutomaticallyCallback);
        } else {
          window.setTimeout(highlightAutomaticallyCallback, 16);
        }
      }
    }
    return _;
  }(_self);
  if (module2.exports) {
    module2.exports = Prism2;
  }
  if (typeof globalThis !== "undefined") {
    globalThis.Prism = Prism2;
  }
})(prismCore);
var prismCoreExports = prismCore.exports;
Prism.languages.json = {
  "property": {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: true,
    greedy: true
  },
  "string": {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    lookbehind: true,
    greedy: true
  },
  "comment": {
    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: true
  },
  "number": /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  "punctuation": /[{}[\],]/,
  "operator": /:/,
  "boolean": /\b(?:false|true)\b/,
  "null": {
    pattern: /\bnull\b/,
    alias: "keyword"
  }
};
Prism.languages.webmanifest = Prism.languages.json;
var uri_all = { exports: {} };
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function(module2, exports2) {
  (function(global, factory) {
    factory(exports2);
  })(commonjsGlobal, function(exports22) {
    function merge2() {
      for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
      }
      if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x = 1; x < xl; ++x) {
          sets[x] = sets[x].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join("");
      } else {
        return sets[0];
      }
    }
    function subexp(str) {
      return "(?:" + str + ")";
    }
    function typeOf(o) {
      return o === void 0 ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
      return str.toUpperCase();
    }
    function toArray2(obj) {
      return obj !== void 0 && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
    }
    function assign4(target, source) {
      var obj = target;
      if (source) {
        for (var key in source) {
          obj[key] = source[key];
        }
      }
      return obj;
    }
    function buildExps(isIRI2) {
      var ALPHA$$ = "[A-Za-z]", DIGIT$$ = "[0-9]", HEXDIG$$2 = merge2(DIGIT$$, "[A-Fa-f]"), PCT_ENCODED$2 = subexp(subexp("%[EFef]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%" + HEXDIG$$2 + HEXDIG$$2)), GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge2(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI2 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", IPRIVATE$$ = isIRI2 ? "[\\uE000-\\uF8FF]" : "[]", UNRESERVED$$2 = merge2(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$);
      subexp(ALPHA$$ + merge2(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*");
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]")) + "*");
      var DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$2 + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$2 + "|" + PCT_ENCODED$2) + "+");
      subexp("[vV]" + HEXDIG$$2 + "+\\." + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]") + "+");
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$)) + "*");
      var PCHAR$ = subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@]"));
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\@]")) + "+");
      subexp(subexp(PCHAR$ + "|" + merge2("[\\/\\?]", IPRIVATE$$)) + "*");
      return {
        NOT_SCHEME: new RegExp(merge2("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge2("[^\\%\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge2("[^\\%\\[\\]\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge2("[^\\%\\/\\:\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge2("[^\\%\\/\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge2("[^]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$2, "g"),
        OTHER_CHARS: new RegExp(merge2("[^\\%]", UNRESERVED$$2, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$2, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$2 + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$")
        //RFC 6874, with relaxed parsing rules
      };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = /* @__PURE__ */ function() {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = void 0;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
              break;
          }
        } catch (err2) {
          _d = true;
          _e = err2;
        } finally {
          try {
            if (!_n && _i["return"])
              _i["return"]();
          } finally {
            if (_d)
              throw _e;
          }
        }
        return _arr;
      }
      return function(arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var toConsumableArray = function(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
          arr2[i] = arr[i];
        return arr2;
      } else {
        return Array.from(arr);
      }
    };
    var maxInt = 2147483647;
    var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128;
    var delimiter = "-";
    var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/;
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
    var errors = {
      "overflow": "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    };
    var baseMinusTMin = base - tMin;
    var floor3 = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    function error$1(type3) {
      throw new RangeError(errors[type3]);
    }
    function map2(array2, fn) {
      var result = [];
      var length2 = array2.length;
      while (length2--) {
        result[length2] = fn(array2[length2]);
      }
      return result;
    }
    function mapDomain(string, fn) {
      var parts = string.split("@");
      var result = "";
      if (parts.length > 1) {
        result = parts[0] + "@";
        string = parts[1];
      }
      string = string.replace(regexSeparators, ".");
      var labels = string.split(".");
      var encoded = map2(labels, fn).join(".");
      return result + encoded;
    }
    function ucs2decode(string) {
      var output = [];
      var counter = 0;
      var length2 = string.length;
      while (counter < length2) {
        var value2 = string.charCodeAt(counter++);
        if (value2 >= 55296 && value2 <= 56319 && counter < length2) {
          var extra = string.charCodeAt(counter++);
          if ((extra & 64512) == 56320) {
            output.push(((value2 & 1023) << 10) + (extra & 1023) + 65536);
          } else {
            output.push(value2);
            counter--;
          }
        } else {
          output.push(value2);
        }
      }
      return output;
    }
    var ucs2encode = function ucs2encode2(array2) {
      return String.fromCodePoint.apply(String, toConsumableArray(array2));
    };
    var basicToDigit = function basicToDigit2(codePoint) {
      if (codePoint - 48 < 10) {
        return codePoint - 22;
      }
      if (codePoint - 65 < 26) {
        return codePoint - 65;
      }
      if (codePoint - 97 < 26) {
        return codePoint - 97;
      }
      return base;
    };
    var digitToBasic = function digitToBasic2(digit, flag) {
      return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    var adapt = function adapt2(delta, numPoints, firstTime) {
      var k = 0;
      delta = firstTime ? floor3(delta / damp) : delta >> 1;
      delta += floor3(delta / numPoints);
      for (
        ;
        /* no initialization */
        delta > baseMinusTMin * tMax >> 1;
        k += base
      ) {
        delta = floor3(delta / baseMinusTMin);
      }
      return floor3(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    var decode2 = function decode22(input) {
      var output = [];
      var inputLength = input.length;
      var i = 0;
      var n = initialN;
      var bias = initialBias;
      var basic = input.lastIndexOf(delimiter);
      if (basic < 0) {
        basic = 0;
      }
      for (var j = 0; j < basic; ++j) {
        if (input.charCodeAt(j) >= 128) {
          error$1("not-basic");
        }
        output.push(input.charCodeAt(j));
      }
      for (var index2 = basic > 0 ? basic + 1 : 0; index2 < inputLength; ) {
        var oldi = i;
        for (
          var w = 1, k = base;
          ;
          /* no condition */
          k += base
        ) {
          if (index2 >= inputLength) {
            error$1("invalid-input");
          }
          var digit = basicToDigit(input.charCodeAt(index2++));
          if (digit >= base || digit > floor3((maxInt - i) / w)) {
            error$1("overflow");
          }
          i += digit * w;
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (digit < t) {
            break;
          }
          var baseMinusT = base - t;
          if (w > floor3(maxInt / baseMinusT)) {
            error$1("overflow");
          }
          w *= baseMinusT;
        }
        var out = output.length + 1;
        bias = adapt(i - oldi, out, oldi == 0);
        if (floor3(i / out) > maxInt - n) {
          error$1("overflow");
        }
        n += floor3(i / out);
        i %= out;
        output.splice(i++, 0, n);
      }
      return String.fromCodePoint.apply(String, output);
    };
    var encode2 = function encode22(input) {
      var output = [];
      input = ucs2decode(input);
      var inputLength = input.length;
      var n = initialN;
      var delta = 0;
      var bias = initialBias;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _currentValue2 = _step.value;
          if (_currentValue2 < 128) {
            output.push(stringFromCharCode(_currentValue2));
          }
        }
      } catch (err2) {
        _didIteratorError = true;
        _iteratorError = err2;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      var basicLength = output.length;
      var handledCPCount = basicLength;
      if (basicLength) {
        output.push(delimiter);
      }
      while (handledCPCount < inputLength) {
        var m = maxInt;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = void 0;
        try {
          for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var currentValue = _step2.value;
            if (currentValue >= n && currentValue < m) {
              m = currentValue;
            }
          }
        } catch (err2) {
          _didIteratorError2 = true;
          _iteratorError2 = err2;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor3((maxInt - delta) / handledCPCountPlusOne)) {
          error$1("overflow");
        }
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = void 0;
        try {
          for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _currentValue = _step3.value;
            if (_currentValue < n && ++delta > maxInt) {
              error$1("overflow");
            }
            if (_currentValue == n) {
              var q = delta;
              for (
                var k = base;
                ;
                /* no condition */
                k += base
              ) {
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (q < t) {
                  break;
                }
                var qMinusT = q - t;
                var baseMinusT = base - t;
                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                q = floor3(qMinusT / baseMinusT);
              }
              output.push(stringFromCharCode(digitToBasic(q, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }
        } catch (err2) {
          _didIteratorError3 = true;
          _iteratorError3 = err2;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
        ++delta;
        ++n;
      }
      return output.join("");
    };
    var toUnicode = function toUnicode2(input) {
      return mapDomain(input, function(string) {
        return regexPunycode.test(string) ? decode2(string.slice(4).toLowerCase()) : string;
      });
    };
    var toASCII = function toASCII2(input) {
      return mapDomain(input, function(string) {
        return regexNonASCII.test(string) ? "xn--" + encode2(string) : string;
      });
    };
    var punycode = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      "version": "2.1.0",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      "ucs2": {
        "decode": ucs2decode,
        "encode": ucs2encode
      },
      "decode": decode2,
      "encode": encode2,
      "toASCII": toASCII,
      "toUnicode": toUnicode
    };
    var SCHEMES = {};
    function pctEncChar(chr) {
      var c2 = chr.charCodeAt(0);
      var e = void 0;
      if (c2 < 16)
        e = "%0" + c2.toString(16).toUpperCase();
      else if (c2 < 128)
        e = "%" + c2.toString(16).toUpperCase();
      else if (c2 < 2048)
        e = "%" + (c2 >> 6 | 192).toString(16).toUpperCase() + "%" + (c2 & 63 | 128).toString(16).toUpperCase();
      else
        e = "%" + (c2 >> 12 | 224).toString(16).toUpperCase() + "%" + (c2 >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c2 & 63 | 128).toString(16).toUpperCase();
      return e;
    }
    function pctDecChars(str) {
      var newStr = "";
      var i = 0;
      var il = str.length;
      while (i < il) {
        var c2 = parseInt(str.substr(i + 1, 2), 16);
        if (c2 < 128) {
          newStr += String.fromCharCode(c2);
          i += 3;
        } else if (c2 >= 194 && c2 < 224) {
          if (il - i >= 6) {
            var c22 = parseInt(str.substr(i + 4, 2), 16);
            newStr += String.fromCharCode((c2 & 31) << 6 | c22 & 63);
          } else {
            newStr += str.substr(i, 6);
          }
          i += 6;
        } else if (c2 >= 224) {
          if (il - i >= 9) {
            var _c = parseInt(str.substr(i + 4, 2), 16);
            var c3 = parseInt(str.substr(i + 7, 2), 16);
            newStr += String.fromCharCode((c2 & 15) << 12 | (_c & 63) << 6 | c3 & 63);
          } else {
            newStr += str.substr(i, 9);
          }
          i += 9;
        } else {
          newStr += str.substr(i, 3);
          i += 3;
        }
      }
      return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
      function decodeUnreserved2(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
      }
      if (components.scheme)
        components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_SCHEME, "");
      if (components.userinfo !== void 0)
        components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.host !== void 0)
        components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.path !== void 0)
        components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.query !== void 0)
        components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.fragment !== void 0)
        components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      return components;
    }
    function _stripLeadingZeros(str) {
      return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
      var matches = host.match(protocol.IPV4ADDRESS) || [];
      var _matches = slicedToArray(matches, 2), address = _matches[1];
      if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
      } else {
        return host;
      }
    }
    function _normalizeIPv6(host, protocol) {
      var matches = host.match(protocol.IPV6ADDRESS) || [];
      var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
      if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last2 = _address$toLowerCase$2[0], first2 = _address$toLowerCase$2[1];
        var firstFields = first2 ? first2.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last2.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields = Array(fieldCount);
        for (var x = 0; x < fieldCount; ++x) {
          fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
        }
        if (isLastFieldIPv4Address) {
          fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
        }
        var allZeroFields = fields.reduce(function(acc, field, index2) {
          if (!field || field === "0") {
            var lastLongest = acc[acc.length - 1];
            if (lastLongest && lastLongest.index + lastLongest.length === index2) {
              lastLongest.length++;
            } else {
              acc.push({
                index: index2,
                length: 1
              });
            }
          }
          return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function(a, b) {
          return b.length - a.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
          var newFirst = fields.slice(0, longestZeroFields.index);
          var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
          newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
          newHost = fields.join(":");
        }
        if (zone) {
          newHost += "%" + zone;
        }
        return newHost;
      } else {
        return host;
      }
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === void 0;
    function parse2(uriString) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var components = {};
      var protocol = options2.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
      if (options2.reference === "suffix")
        uriString = (options2.scheme ? options2.scheme + ":" : "") + "//" + uriString;
      var matches = uriString.match(URI_PARSE);
      if (matches) {
        if (NO_MATCH_IS_UNDEFINED) {
          components.scheme = matches[1];
          components.userinfo = matches[3];
          components.host = matches[4];
          components.port = parseInt(matches[5], 10);
          components.path = matches[6] || "";
          components.query = matches[7];
          components.fragment = matches[8];
          if (isNaN(components.port)) {
            components.port = matches[5];
          }
        } else {
          components.scheme = matches[1] || void 0;
          components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : void 0;
          components.host = uriString.indexOf("//") !== -1 ? matches[4] : void 0;
          components.port = parseInt(matches[5], 10);
          components.path = matches[6] || "";
          components.query = uriString.indexOf("?") !== -1 ? matches[7] : void 0;
          components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : void 0;
          if (isNaN(components.port)) {
            components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : void 0;
          }
        }
        if (components.host) {
          components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        if (components.scheme === void 0 && components.userinfo === void 0 && components.host === void 0 && components.port === void 0 && !components.path && components.query === void 0) {
          components.reference = "same-document";
        } else if (components.scheme === void 0) {
          components.reference = "relative";
        } else if (components.fragment === void 0) {
          components.reference = "absolute";
        } else {
          components.reference = "uri";
        }
        if (options2.reference && options2.reference !== "suffix" && options2.reference !== components.reference) {
          components.error = components.error || "URI is not a " + options2.reference + " reference.";
        }
        var schemeHandler = SCHEMES[(options2.scheme || components.scheme || "").toLowerCase()];
        if (!options2.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
          if (components.host && (options2.domainHost || schemeHandler && schemeHandler.domainHost)) {
            try {
              components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
            } catch (e) {
              components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
            }
          }
          _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
          _normalizeComponentEncoding(components, protocol);
        }
        if (schemeHandler && schemeHandler.parse) {
          schemeHandler.parse(components, options2);
        }
      } else {
        components.error = components.error || "URI can not be parsed.";
      }
      return components;
    }
    function _recomposeAuthority(components, options2) {
      var protocol = options2.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
      var uriTokens = [];
      if (components.userinfo !== void 0) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
      }
      if (components.host !== void 0) {
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
          return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
      }
      if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
      }
      return uriTokens.length ? uriTokens.join("") : void 0;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
      var output = [];
      while (input.length) {
        if (input.match(RDS1)) {
          input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
          input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
          input = input.replace(RDS3, "/");
          output.pop();
        } else if (input === "." || input === "..") {
          input = "";
        } else {
          var im = input.match(RDS5);
          if (im) {
            var s = im[0];
            input = input.slice(s.length);
            output.push(s);
          } else {
            throw new Error("Unexpected dot segment condition");
          }
        }
      }
      return output.join("");
    }
    function serialize2(components) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var protocol = options2.iri ? IRI_PROTOCOL : URI_PROTOCOL;
      var uriTokens = [];
      var schemeHandler = SCHEMES[(options2.scheme || components.scheme || "").toLowerCase()];
      if (schemeHandler && schemeHandler.serialize)
        schemeHandler.serialize(components, options2);
      if (components.host) {
        if (protocol.IPV6ADDRESS.test(components.host))
          ;
        else if (options2.domainHost || schemeHandler && schemeHandler.domainHost) {
          try {
            components.host = !options2.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
          } catch (e) {
            components.error = components.error || "Host's domain name can not be converted to " + (!options2.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
          }
        }
      }
      _normalizeComponentEncoding(components, protocol);
      if (options2.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
      }
      var authority = _recomposeAuthority(components, options2);
      if (authority !== void 0) {
        if (options2.reference !== "suffix") {
          uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
          uriTokens.push("/");
        }
      }
      if (components.path !== void 0) {
        var s = components.path;
        if (!options2.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
          s = removeDotSegments(s);
        }
        if (authority === void 0) {
          s = s.replace(/^\/\//, "/%2F");
        }
        uriTokens.push(s);
      }
      if (components.query !== void 0) {
        uriTokens.push("?");
        uriTokens.push(components.query);
      }
      if (components.fragment !== void 0) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
      }
      return uriTokens.join("");
    }
    function resolveComponents(base2, relative) {
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var skipNormalization = arguments[3];
      var target = {};
      if (!skipNormalization) {
        base2 = parse2(serialize2(base2, options2), options2);
        relative = parse2(serialize2(relative, options2), options2);
      }
      options2 = options2 || {};
      if (!options2.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || "");
        target.query = relative.query;
      } else {
        if (relative.userinfo !== void 0 || relative.host !== void 0 || relative.port !== void 0) {
          target.userinfo = relative.userinfo;
          target.host = relative.host;
          target.port = relative.port;
          target.path = removeDotSegments(relative.path || "");
          target.query = relative.query;
        } else {
          if (!relative.path) {
            target.path = base2.path;
            if (relative.query !== void 0) {
              target.query = relative.query;
            } else {
              target.query = base2.query;
            }
          } else {
            if (relative.path.charAt(0) === "/") {
              target.path = removeDotSegments(relative.path);
            } else {
              if ((base2.userinfo !== void 0 || base2.host !== void 0 || base2.port !== void 0) && !base2.path) {
                target.path = "/" + relative.path;
              } else if (!base2.path) {
                target.path = relative.path;
              } else {
                target.path = base2.path.slice(0, base2.path.lastIndexOf("/") + 1) + relative.path;
              }
              target.path = removeDotSegments(target.path);
            }
            target.query = relative.query;
          }
          target.userinfo = base2.userinfo;
          target.host = base2.host;
          target.port = base2.port;
        }
        target.scheme = base2.scheme;
      }
      target.fragment = relative.fragment;
      return target;
    }
    function resolve2(baseURI, relativeURI, options2) {
      var schemelessOptions = assign4({
        scheme: "null"
      }, options2);
      return serialize2(resolveComponents(parse2(baseURI, schemelessOptions), parse2(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize2(uri2, options2) {
      if (typeof uri2 === "string") {
        uri2 = serialize2(parse2(uri2, options2), options2);
      } else if (typeOf(uri2) === "object") {
        uri2 = parse2(serialize2(uri2, options2), options2);
      }
      return uri2;
    }
    function equal3(uriA, uriB, options2) {
      if (typeof uriA === "string") {
        uriA = serialize2(parse2(uriA, options2), options2);
      } else if (typeOf(uriA) === "object") {
        uriA = serialize2(uriA, options2);
      }
      if (typeof uriB === "string") {
        uriB = serialize2(parse2(uriB, options2), options2);
      } else if (typeOf(uriB) === "object") {
        uriB = serialize2(uriB, options2);
      }
      return uriA === uriB;
    }
    function escapeComponent(str, options2) {
      return str && str.toString().replace(!options2 || !options2.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options2) {
      return str && str.toString().replace(!options2 || !options2.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
      scheme: "http",
      domainHost: true,
      parse: function parse22(components, options2) {
        if (!components.host) {
          components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
      },
      serialize: function serialize22(components, options2) {
        var secure = String(components.scheme).toLowerCase() === "https";
        if (components.port === (secure ? 443 : 80) || components.port === "") {
          components.port = void 0;
        }
        if (!components.path) {
          components.path = "/";
        }
        return components;
      }
    };
    var handler$1 = {
      scheme: "https",
      domainHost: handler.domainHost,
      parse: handler.parse,
      serialize: handler.serialize
    };
    function isSecure(wsComponents) {
      return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    var handler$2 = {
      scheme: "ws",
      domainHost: true,
      parse: function parse22(components, options2) {
        var wsComponents = components;
        wsComponents.secure = isSecure(wsComponents);
        wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
        wsComponents.path = void 0;
        wsComponents.query = void 0;
        return wsComponents;
      },
      serialize: function serialize22(wsComponents, options2) {
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
          wsComponents.port = void 0;
        }
        if (typeof wsComponents.secure === "boolean") {
          wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
          wsComponents.secure = void 0;
        }
        if (wsComponents.resourceName) {
          var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
          wsComponents.path = path && path !== "/" ? path : void 0;
          wsComponents.query = query;
          wsComponents.resourceName = void 0;
        }
        wsComponents.fragment = void 0;
        return wsComponents;
      }
    };
    var handler$3 = {
      scheme: "wss",
      domainHost: handler$2.domainHost,
      parse: handler$2.parse,
      serialize: handler$2.serialize
    };
    var O = {};
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]";
    var HEXDIG$$ = "[0-9A-Fa-f]";
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$));
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge2(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge2("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge2("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
      var decStr = pctDecChars(str);
      return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
      scheme: "mailto",
      parse: function parse$$1(components, options2) {
        var mailtoComponents = components;
        var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = void 0;
        if (mailtoComponents.query) {
          var unknownHeaders = false;
          var headers = {};
          var hfields = mailtoComponents.query.split("&");
          for (var x = 0, xl = hfields.length; x < xl; ++x) {
            var hfield = hfields[x].split("=");
            switch (hfield[0]) {
              case "to":
                var toAddrs = hfield[1].split(",");
                for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                  to.push(toAddrs[_x]);
                }
                break;
              case "subject":
                mailtoComponents.subject = unescapeComponent(hfield[1], options2);
                break;
              case "body":
                mailtoComponents.body = unescapeComponent(hfield[1], options2);
                break;
              default:
                unknownHeaders = true;
                headers[unescapeComponent(hfield[0], options2)] = unescapeComponent(hfield[1], options2);
                break;
            }
          }
          if (unknownHeaders)
            mailtoComponents.headers = headers;
        }
        mailtoComponents.query = void 0;
        for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
          var addr = to[_x2].split("@");
          addr[0] = unescapeComponent(addr[0]);
          if (!options2.unicodeSupport) {
            try {
              addr[1] = punycode.toASCII(unescapeComponent(addr[1], options2).toLowerCase());
            } catch (e) {
              mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
            }
          } else {
            addr[1] = unescapeComponent(addr[1], options2).toLowerCase();
          }
          to[_x2] = addr.join("@");
        }
        return mailtoComponents;
      },
      serialize: function serialize$$1(mailtoComponents, options2) {
        var components = mailtoComponents;
        var to = toArray2(mailtoComponents.to);
        if (to) {
          for (var x = 0, xl = to.length; x < xl; ++x) {
            var toAddr = String(to[x]);
            var atIdx = toAddr.lastIndexOf("@");
            var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
            var domain2 = toAddr.slice(atIdx + 1);
            try {
              domain2 = !options2.iri ? punycode.toASCII(unescapeComponent(domain2, options2).toLowerCase()) : punycode.toUnicode(domain2);
            } catch (e) {
              components.error = components.error || "Email address's domain name can not be converted to " + (!options2.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
            to[x] = localPart + "@" + domain2;
          }
          components.path = to.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject)
          headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body)
          headers["body"] = mailtoComponents.body;
        var fields = [];
        for (var name in headers) {
          if (headers[name] !== O[name]) {
            fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
          }
        }
        if (fields.length) {
          components.query = fields.join("&");
        }
        return components;
      }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    var handler$5 = {
      scheme: "urn",
      parse: function parse$$1(components, options2) {
        var matches = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches) {
          var scheme = options2.scheme || urnComponents.scheme || "urn";
          var nid = matches[1].toLowerCase();
          var nss = matches[2];
          var urnScheme = scheme + ":" + (options2.nid || nid);
          var schemeHandler = SCHEMES[urnScheme];
          urnComponents.nid = nid;
          urnComponents.nss = nss;
          urnComponents.path = void 0;
          if (schemeHandler) {
            urnComponents = schemeHandler.parse(urnComponents, options2);
          }
        } else {
          urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
      },
      serialize: function serialize$$1(urnComponents, options2) {
        var scheme = options2.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options2.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
          urnComponents = schemeHandler.serialize(urnComponents, options2);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options2.nid) + ":" + nss;
        return uriComponents;
      }
    };
    var UUID2 = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    var handler$6 = {
      scheme: "urn:uuid",
      parse: function parse22(urnComponents, options2) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = void 0;
        if (!options2.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID2))) {
          uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
      },
      serialize: function serialize22(uuidComponents, options2) {
        var urnComponents = uuidComponents;
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
      }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports22.SCHEMES = SCHEMES;
    exports22.pctEncChar = pctEncChar;
    exports22.pctDecChars = pctDecChars;
    exports22.parse = parse2;
    exports22.removeDotSegments = removeDotSegments;
    exports22.serialize = serialize2;
    exports22.resolveComponents = resolveComponents;
    exports22.resolve = resolve2;
    exports22.normalize = normalize2;
    exports22.equal = equal3;
    exports22.escapeComponent = escapeComponent;
    exports22.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports22, "__esModule", {
      value: true
    });
  });
})(uri_all, uri_all.exports);
var uri_allExports = uri_all.exports;
var fastDeepEqual = function equal(a, b) {
  if (a === b)
    return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    if (a.constructor !== b.constructor)
      return false;
    var length2, i, keys3;
    if (Array.isArray(a)) {
      length2 = a.length;
      if (length2 != b.length)
        return false;
      for (i = length2; i-- !== 0; )
        if (!equal(a[i], b[i]))
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b.toString();
    keys3 = Object.keys(a);
    length2 = keys3.length;
    if (length2 !== Object.keys(b).length)
      return false;
    for (i = length2; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys3[i]))
        return false;
    for (i = length2; i-- !== 0; ) {
      var key = keys3[i];
      if (!equal(a[key], b[key]))
        return false;
    }
    return true;
  }
  return a !== a && b !== b;
};
var ucs2length$1 = function ucs2length(str) {
  var length2 = 0, len = str.length, pos = 0, value2;
  while (pos < len) {
    length2++;
    value2 = str.charCodeAt(pos++);
    if (value2 >= 55296 && value2 <= 56319 && pos < len) {
      value2 = str.charCodeAt(pos);
      if ((value2 & 64512) == 56320)
        pos++;
    }
  }
  return length2;
};
var util$5 = {
  copy,
  checkDataType,
  checkDataTypes,
  coerceToTypes,
  toHash: toHash$1,
  getProperty,
  escapeQuotes,
  equal: fastDeepEqual,
  ucs2length: ucs2length$1,
  varOccurences,
  varReplace,
  schemaHasRules,
  schemaHasRulesExcept,
  schemaUnknownRules,
  toQuotedString,
  getPathExpr,
  getPath,
  getData: getData2,
  unescapeFragment,
  unescapeJsonPointer,
  escapeFragment,
  escapeJsonPointer
};
function copy(o, to) {
  to = to || {};
  for (var key in o)
    to[key] = o[key];
  return to;
}
function checkDataType(dataType, data2, strictNumbers, negate) {
  var EQUAL = negate ? " !== " : " === ", AND = negate ? " || " : " && ", OK = negate ? "!" : "", NOT = negate ? "" : "!";
  switch (dataType) {
    case "null":
      return data2 + EQUAL + "null";
    case "array":
      return OK + "Array.isArray(" + data2 + ")";
    case "object":
      return "(" + OK + data2 + AND + "typeof " + data2 + EQUAL + '"object"' + AND + NOT + "Array.isArray(" + data2 + "))";
    case "integer":
      return "(typeof " + data2 + EQUAL + '"number"' + AND + NOT + "(" + data2 + " % 1)" + AND + data2 + EQUAL + data2 + (strictNumbers ? AND + OK + "isFinite(" + data2 + ")" : "") + ")";
    case "number":
      return "(typeof " + data2 + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + "isFinite(" + data2 + ")" : "") + ")";
    default:
      return "typeof " + data2 + EQUAL + '"' + dataType + '"';
  }
}
function checkDataTypes(dataTypes, data2, strictNumbers) {
  switch (dataTypes.length) {
    case 1:
      return checkDataType(dataTypes[0], data2, strictNumbers, true);
    default:
      var code2 = "";
      var types2 = toHash$1(dataTypes);
      if (types2.array && types2.object) {
        code2 = types2.null ? "(" : "(!" + data2 + " || ";
        code2 += "typeof " + data2 + ' !== "object")';
        delete types2.null;
        delete types2.array;
        delete types2.object;
      }
      if (types2.number)
        delete types2.integer;
      for (var t in types2)
        code2 += (code2 ? " && " : "") + checkDataType(t, data2, strictNumbers, true);
      return code2;
  }
}
var COERCE_TO_TYPES = toHash$1(["string", "number", "integer", "boolean", "null"]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
  if (Array.isArray(dataTypes)) {
    var types2 = [];
    for (var i = 0; i < dataTypes.length; i++) {
      var t = dataTypes[i];
      if (COERCE_TO_TYPES[t])
        types2[types2.length] = t;
      else if (optionCoerceTypes === "array" && t === "array")
        types2[types2.length] = t;
    }
    if (types2.length)
      return types2;
  } else if (COERCE_TO_TYPES[dataTypes]) {
    return [dataTypes];
  } else if (optionCoerceTypes === "array" && dataTypes === "array") {
    return ["array"];
  }
}
function toHash$1(arr) {
  var hash = {};
  for (var i = 0; i < arr.length; i++)
    hash[arr[i]] = true;
  return hash;
}
var IDENTIFIER$1 = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return typeof key == "number" ? "[" + key + "]" : IDENTIFIER$1.test(key) ? "." + key : "['" + escapeQuotes(key) + "']";
}
function escapeQuotes(str) {
  return str.replace(SINGLE_QUOTE, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
function varOccurences(str, dataVar) {
  dataVar += "[^0-9]";
  var matches = str.match(new RegExp(dataVar, "g"));
  return matches ? matches.length : 0;
}
function varReplace(str, dataVar, expr) {
  dataVar += "([^0-9])";
  expr = expr.replace(/\$/g, "$$$$");
  return str.replace(new RegExp(dataVar, "g"), expr + "$1");
}
function schemaHasRules(schema2, rules3) {
  if (typeof schema2 == "boolean")
    return !schema2;
  for (var key in schema2)
    if (rules3[key])
      return true;
}
function schemaHasRulesExcept(schema2, rules3, exceptKeyword) {
  if (typeof schema2 == "boolean")
    return !schema2 && exceptKeyword != "not";
  for (var key in schema2)
    if (key != exceptKeyword && rules3[key])
      return true;
}
function schemaUnknownRules(schema2, rules3) {
  if (typeof schema2 == "boolean")
    return;
  for (var key in schema2)
    if (!rules3[key])
      return key;
}
function toQuotedString(str) {
  return "'" + escapeQuotes(str) + "'";
}
function getPathExpr(currentPath, expr, jsonPointers, isNumber2) {
  var path = jsonPointers ? "'/' + " + expr + (isNumber2 ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : isNumber2 ? "'[' + " + expr + " + ']'" : "'[\\'' + " + expr + " + '\\']'";
  return joinPaths(currentPath, path);
}
function getPath(currentPath, prop2, jsonPointers) {
  var path = jsonPointers ? toQuotedString("/" + escapeJsonPointer(prop2)) : toQuotedString(getProperty(prop2));
  return joinPaths(currentPath, path);
}
var JSON_POINTER$1 = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER$1 = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData2($data, lvl, paths) {
  var up, jsonPointer, data2, matches;
  if ($data === "")
    return "rootData";
  if ($data[0] == "/") {
    if (!JSON_POINTER$1.test($data))
      throw new Error("Invalid JSON-pointer: " + $data);
    jsonPointer = $data;
    data2 = "rootData";
  } else {
    matches = $data.match(RELATIVE_JSON_POINTER$1);
    if (!matches)
      throw new Error("Invalid JSON-pointer: " + $data);
    up = +matches[1];
    jsonPointer = matches[2];
    if (jsonPointer == "#") {
      if (up >= lvl)
        throw new Error("Cannot access property/index " + up + " levels up, current level is " + lvl);
      return paths[lvl - up];
    }
    if (up > lvl)
      throw new Error("Cannot access data " + up + " levels up, current level is " + lvl);
    data2 = "data" + (lvl - up || "");
    if (!jsonPointer)
      return data2;
  }
  var expr = data2;
  var segments = jsonPointer.split("/");
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment) {
      data2 += getProperty(unescapeJsonPointer(segment));
      expr += " && " + data2;
    }
  }
  return expr;
}
function joinPaths(a, b) {
  if (a == '""')
    return b;
  return (a + " + " + b).replace(/([^\\])' \+ '/g, "$1");
}
function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}
function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}
function escapeJsonPointer(str) {
  return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapeJsonPointer(str) {
  return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
var util$4 = util$5;
var schema_obj = SchemaObject$2;
function SchemaObject$2(obj) {
  util$4.copy(obj, this);
}
var jsonSchemaTraverse = { exports: {} };
var traverse$1 = jsonSchemaTraverse.exports = function(schema2, opts, cb) {
  if (typeof opts == "function") {
    cb = opts;
    opts = {};
  }
  cb = opts.cb || cb;
  var pre = typeof cb == "function" ? cb : cb.pre || function() {
  };
  var post = cb.post || function() {
  };
  _traverse(opts, pre, post, schema2, "", schema2);
};
traverse$1.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true
};
traverse$1.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};
traverse$1.propsKeywords = {
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};
traverse$1.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};
function _traverse(opts, pre, post, schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema2 && typeof schema2 == "object" && !Array.isArray(schema2)) {
    pre(schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema2) {
      var sch = schema2[key];
      if (Array.isArray(sch)) {
        if (key in traverse$1.arrayKeywords) {
          for (var i = 0; i < sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema2, i);
        }
      } else if (key in traverse$1.propsKeywords) {
        if (sch && typeof sch == "object") {
          for (var prop2 in sch)
            _traverse(opts, pre, post, sch[prop2], jsonPtr + "/" + key + "/" + escapeJsonPtr(prop2), rootSchema, jsonPtr, key, schema2, prop2);
        }
      } else if (key in traverse$1.keywords || opts.allKeys && !(key in traverse$1.skipKeywords)) {
        _traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema2);
      }
    }
    post(schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}
function escapeJsonPtr(str) {
  return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
var jsonSchemaTraverseExports = jsonSchemaTraverse.exports;
var URI$1 = uri_allExports, equal$1 = fastDeepEqual, util$3 = util$5, SchemaObject$1 = schema_obj, traverse = jsonSchemaTraverseExports;
var resolve_1 = resolve$3;
resolve$3.normalizeId = normalizeId;
resolve$3.fullPath = getFullPath;
resolve$3.url = resolveUrl;
resolve$3.ids = resolveIds;
resolve$3.inlineRef = inlineRef;
resolve$3.schema = resolveSchema;
function resolve$3(compile2, root2, ref2) {
  var refVal = this._refs[ref2];
  if (typeof refVal == "string") {
    if (this._refs[refVal])
      refVal = this._refs[refVal];
    else
      return resolve$3.call(this, compile2, root2, refVal);
  }
  refVal = refVal || this._schemas[ref2];
  if (refVal instanceof SchemaObject$1) {
    return inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
  }
  var res = resolveSchema.call(this, root2, ref2);
  var schema2, v, baseId;
  if (res) {
    schema2 = res.schema;
    root2 = res.root;
    baseId = res.baseId;
  }
  if (schema2 instanceof SchemaObject$1) {
    v = schema2.validate || compile2.call(this, schema2.schema, root2, void 0, baseId);
  } else if (schema2 !== void 0) {
    v = inlineRef(schema2, this._opts.inlineRefs) ? schema2 : compile2.call(this, schema2, root2, void 0, baseId);
  }
  return v;
}
function resolveSchema(root2, ref2) {
  var p = URI$1.parse(ref2), refPath = _getFullPath(p), baseId = getFullPath(this._getId(root2.schema));
  if (Object.keys(root2.schema).length === 0 || refPath !== baseId) {
    var id2 = normalizeId(refPath);
    var refVal = this._refs[id2];
    if (typeof refVal == "string") {
      return resolveRecursive.call(this, root2, refVal, p);
    } else if (refVal instanceof SchemaObject$1) {
      if (!refVal.validate)
        this._compile(refVal);
      root2 = refVal;
    } else {
      refVal = this._schemas[id2];
      if (refVal instanceof SchemaObject$1) {
        if (!refVal.validate)
          this._compile(refVal);
        if (id2 == normalizeId(ref2))
          return {
            schema: refVal,
            root: root2,
            baseId
          };
        root2 = refVal;
      } else {
        return;
      }
    }
    if (!root2.schema)
      return;
    baseId = getFullPath(this._getId(root2.schema));
  }
  return getJsonPointer.call(this, p, baseId, root2.schema, root2);
}
function resolveRecursive(root2, ref2, parsedRef) {
  var res = resolveSchema.call(this, root2, ref2);
  if (res) {
    var schema2 = res.schema;
    var baseId = res.baseId;
    root2 = res.root;
    var id2 = this._getId(schema2);
    if (id2)
      baseId = resolveUrl(baseId, id2);
    return getJsonPointer.call(this, parsedRef, baseId, schema2, root2);
  }
}
var PREVENT_SCOPE_CHANGE = util$3.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
function getJsonPointer(parsedRef, baseId, schema2, root2) {
  parsedRef.fragment = parsedRef.fragment || "";
  if (parsedRef.fragment.slice(0, 1) != "/")
    return;
  var parts = parsedRef.fragment.split("/");
  for (var i = 1; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      part = util$3.unescapeFragment(part);
      schema2 = schema2[part];
      if (schema2 === void 0)
        break;
      var id2;
      if (!PREVENT_SCOPE_CHANGE[part]) {
        id2 = this._getId(schema2);
        if (id2)
          baseId = resolveUrl(baseId, id2);
        if (schema2.$ref) {
          var $ref = resolveUrl(baseId, schema2.$ref);
          var res = resolveSchema.call(this, root2, $ref);
          if (res) {
            schema2 = res.schema;
            root2 = res.root;
            baseId = res.baseId;
          }
        }
      }
    }
  }
  if (schema2 !== void 0 && schema2 !== root2.schema)
    return {
      schema: schema2,
      root: root2,
      baseId
    };
}
var SIMPLE_INLINED = util$3.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
function inlineRef(schema2, limit2) {
  if (limit2 === false)
    return false;
  if (limit2 === void 0 || limit2 === true)
    return checkNoRef(schema2);
  else if (limit2)
    return countKeys(schema2) <= limit2;
}
function checkNoRef(schema2) {
  var item;
  if (Array.isArray(schema2)) {
    for (var i = 0; i < schema2.length; i++) {
      item = schema2[i];
      if (typeof item == "object" && !checkNoRef(item))
        return false;
    }
  } else {
    for (var key in schema2) {
      if (key == "$ref")
        return false;
      item = schema2[key];
      if (typeof item == "object" && !checkNoRef(item))
        return false;
    }
  }
  return true;
}
function countKeys(schema2) {
  var count2 = 0, item;
  if (Array.isArray(schema2)) {
    for (var i = 0; i < schema2.length; i++) {
      item = schema2[i];
      if (typeof item == "object")
        count2 += countKeys(item);
      if (count2 == Infinity)
        return Infinity;
    }
  } else {
    for (var key in schema2) {
      if (key == "$ref")
        return Infinity;
      if (SIMPLE_INLINED[key]) {
        count2++;
      } else {
        item = schema2[key];
        if (typeof item == "object")
          count2 += countKeys(item) + 1;
        if (count2 == Infinity)
          return Infinity;
      }
    }
  }
  return count2;
}
function getFullPath(id2, normalize2) {
  if (normalize2 !== false)
    id2 = normalizeId(id2);
  var p = URI$1.parse(id2);
  return _getFullPath(p);
}
function _getFullPath(p) {
  return URI$1.serialize(p).split("#")[0] + "#";
}
var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id2) {
  return id2 ? id2.replace(TRAILING_SLASH_HASH, "") : "";
}
function resolveUrl(baseId, id2) {
  id2 = normalizeId(id2);
  return URI$1.resolve(baseId, id2);
}
function resolveIds(schema2) {
  var schemaId = normalizeId(this._getId(schema2));
  var baseIds = {
    "": schemaId
  };
  var fullPaths = {
    "": getFullPath(schemaId, false)
  };
  var localRefs = {};
  var self2 = this;
  traverse(schema2, {
    allKeys: true
  }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (jsonPtr === "")
      return;
    var id2 = self2._getId(sch);
    var baseId = baseIds[parentJsonPtr];
    var fullPath = fullPaths[parentJsonPtr] + "/" + parentKeyword;
    if (keyIndex !== void 0)
      fullPath += "/" + (typeof keyIndex == "number" ? keyIndex : util$3.escapeFragment(keyIndex));
    if (typeof id2 == "string") {
      id2 = baseId = normalizeId(baseId ? URI$1.resolve(baseId, id2) : id2);
      var refVal = self2._refs[id2];
      if (typeof refVal == "string")
        refVal = self2._refs[refVal];
      if (refVal && refVal.schema) {
        if (!equal$1(sch, refVal.schema))
          throw new Error('id "' + id2 + '" resolves to more than one schema');
      } else if (id2 != normalizeId(fullPath)) {
        if (id2[0] == "#") {
          if (localRefs[id2] && !equal$1(sch, localRefs[id2]))
            throw new Error('id "' + id2 + '" resolves to more than one schema');
          localRefs[id2] = sch;
        } else {
          self2._refs[id2] = fullPath;
        }
      }
    }
    baseIds[jsonPtr] = baseId;
    fullPaths[jsonPtr] = fullPath;
  });
  return localRefs;
}
var resolve$2 = resolve_1;
var error_classes = {
  Validation: errorSubclass(ValidationError$1),
  MissingRef: errorSubclass(MissingRefError$1)
};
function ValidationError$1(errors) {
  this.message = "validation failed";
  this.errors = errors;
  this.ajv = this.validation = true;
}
MissingRefError$1.message = function(baseId, ref2) {
  return "can't resolve reference " + ref2 + " from id " + baseId;
};
function MissingRefError$1(baseId, ref2, message) {
  this.message = message || MissingRefError$1.message(baseId, ref2);
  this.missingRef = resolve$2.url(baseId, ref2);
  this.missingSchema = resolve$2.normalizeId(resolve$2.fullPath(this.missingRef));
}
function errorSubclass(Subclass) {
  Subclass.prototype = Object.create(Error.prototype);
  Subclass.prototype.constructor = Subclass;
  return Subclass;
}
var fastJsonStableStringify = function(data2, opts) {
  if (!opts)
    opts = {};
  if (typeof opts === "function")
    opts = {
      cmp: opts
    };
  var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
  var cmp = opts.cmp && /* @__PURE__ */ function(f2) {
    return function(node2) {
      return function(a, b) {
        var aobj = {
          key: a,
          value: node2[a]
        };
        var bobj = {
          key: b,
          value: node2[b]
        };
        return f2(aobj, bobj);
      };
    };
  }(opts.cmp);
  var seen = [];
  return function stringify2(node2) {
    if (node2 && node2.toJSON && typeof node2.toJSON === "function") {
      node2 = node2.toJSON();
    }
    if (node2 === void 0)
      return;
    if (typeof node2 == "number")
      return isFinite(node2) ? "" + node2 : "null";
    if (typeof node2 !== "object")
      return JSON.stringify(node2);
    var i, out;
    if (Array.isArray(node2)) {
      out = "[";
      for (i = 0; i < node2.length; i++) {
        if (i)
          out += ",";
        out += stringify2(node2[i]) || "null";
      }
      return out + "]";
    }
    if (node2 === null)
      return "null";
    if (seen.indexOf(node2) !== -1) {
      if (cycles)
        return JSON.stringify("__cycle__");
      throw new TypeError("Converting circular structure to JSON");
    }
    var seenIndex = seen.push(node2) - 1;
    var keys3 = Object.keys(node2).sort(cmp && cmp(node2));
    out = "";
    for (i = 0; i < keys3.length; i++) {
      var key = keys3[i];
      var value2 = stringify2(node2[key]);
      if (!value2)
        continue;
      if (out)
        out += ",";
      out += JSON.stringify(key) + ":" + value2;
    }
    seen.splice(seenIndex, 1);
    return "{" + out + "}";
  }(data2);
};
var validate$1 = function generate_validate(it, $keyword, $ruleType) {
  var out = "";
  var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, "$ref"), $id2 = it.self._getId(it.schema);
  if (it.opts.strictKeywords) {
    var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
    if ($unknownKwd) {
      var $keywordsMsg = "unknown keyword: " + $unknownKwd;
      if (it.opts.strictKeywords === "log")
        it.logger.warn($keywordsMsg);
      else
        throw new Error($keywordsMsg);
    }
  }
  if (it.isTop) {
    out += " var validate = ";
    if ($async) {
      it.async = true;
      out += "async ";
    }
    out += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ";
    if ($id2 && (it.opts.sourceCode || it.opts.processCode)) {
      out += " " + ("/*# sourceURL=" + $id2 + " */") + " ";
    }
  }
  if (typeof it.schema == "boolean" || !($refKeywords || it.schema.$ref)) {
    var $keyword = "false schema";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema2 = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    if (it.schema === false) {
      if (it.isTop) {
        $breakOnError = true;
      } else {
        out += " var " + $valid + " = false; ";
      }
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "false schema") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it.opts.messages !== false) {
          out += " , message: 'boolean schema is false' ";
        }
        if (it.opts.verbose) {
          out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        if (it.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
    } else {
      if (it.isTop) {
        if ($async) {
          out += " return data; ";
        } else {
          out += " validate.errors = null; return true; ";
        }
      } else {
        out += " var " + $valid + " = true; ";
      }
    }
    if (it.isTop) {
      out += " }; return validate; ";
    }
    return out;
  }
  if (it.isTop) {
    var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = "data";
    it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
    it.baseId = it.baseId || it.rootId;
    delete it.isTop;
    it.dataPathArr = [""];
    if (it.schema.default !== void 0 && it.opts.useDefaults && it.opts.strictDefaults) {
      var $defaultMsg = "default is ignored in the schema root";
      if (it.opts.strictDefaults === "log")
        it.logger.warn($defaultMsg);
      else
        throw new Error($defaultMsg);
    }
    out += " var vErrors = null; ";
    out += " var errors = 0;     ";
    out += " if (rootData === undefined) rootData = data; ";
  } else {
    var $lvl = it.level, $dataLvl = it.dataLevel, $data = "data" + ($dataLvl || "");
    if ($id2)
      it.baseId = it.resolve.url(it.baseId, $id2);
    if ($async && !it.async)
      throw new Error("async schema in sync schema");
    out += " var errs_" + $lvl + " = errors;";
  }
  var $valid = "valid" + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = "", $closingBraces2 = "";
  var $errorKeyword;
  var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
  if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
    if ($typeIsArray) {
      if ($typeSchema.indexOf("null") == -1)
        $typeSchema = $typeSchema.concat("null");
    } else if ($typeSchema != "null") {
      $typeSchema = [$typeSchema, "null"];
      $typeIsArray = true;
    }
  }
  if ($typeIsArray && $typeSchema.length == 1) {
    $typeSchema = $typeSchema[0];
    $typeIsArray = false;
  }
  if (it.schema.$ref && $refKeywords) {
    if (it.opts.extendRefs == "fail") {
      throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
    } else if (it.opts.extendRefs !== true) {
      $refKeywords = false;
      it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
    }
  }
  if (it.schema.$comment && it.opts.$comment) {
    out += " " + it.RULES.all.$comment.code(it, "$comment");
  }
  if ($typeSchema) {
    if (it.opts.coerceTypes) {
      var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
    }
    var $rulesGroup = it.RULES.types[$typeSchema];
    if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
      var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
      var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type", $method = $typeIsArray ? "checkDataTypes" : "checkDataType";
      out += " if (" + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ") { ";
      if ($coerceToTypes) {
        var $dataType = "dataType" + $lvl, $coerced = "coerced" + $lvl;
        out += " var " + $dataType + " = typeof " + $data + "; var " + $coerced + " = undefined; ";
        if (it.opts.coerceTypes == "array") {
          out += " if (" + $dataType + " == 'object' && Array.isArray(" + $data + ") && " + $data + ".length == 1) { " + $data + " = " + $data + "[0]; " + $dataType + " = typeof " + $data + "; if (" + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ") " + $coerced + " = " + $data + "; } ";
        }
        out += " if (" + $coerced + " !== undefined) ; ";
        var arr1 = $coerceToTypes;
        if (arr1) {
          var $type, $i = -1, l1 = arr1.length - 1;
          while ($i < l1) {
            $type = arr1[$i += 1];
            if ($type == "string") {
              out += " else if (" + $dataType + " == 'number' || " + $dataType + " == 'boolean') " + $coerced + " = '' + " + $data + "; else if (" + $data + " === null) " + $coerced + " = ''; ";
            } else if ($type == "number" || $type == "integer") {
              out += " else if (" + $dataType + " == 'boolean' || " + $data + " === null || (" + $dataType + " == 'string' && " + $data + " && " + $data + " == +" + $data + " ";
              if ($type == "integer") {
                out += " && !(" + $data + " % 1)";
              }
              out += ")) " + $coerced + " = +" + $data + "; ";
            } else if ($type == "boolean") {
              out += " else if (" + $data + " === 'false' || " + $data + " === 0 || " + $data + " === null) " + $coerced + " = false; else if (" + $data + " === 'true' || " + $data + " === 1) " + $coerced + " = true; ";
            } else if ($type == "null") {
              out += " else if (" + $data + " === '' || " + $data + " === 0 || " + $data + " === false) " + $coerced + " = null; ";
            } else if (it.opts.coerceTypes == "array" && $type == "array") {
              out += " else if (" + $dataType + " == 'string' || " + $dataType + " == 'number' || " + $dataType + " == 'boolean' || " + $data + " == null) " + $coerced + " = [" + $data + "]; ";
            }
          }
        }
        out += " else {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
          if ($typeIsArray) {
            out += "" + $typeSchema.join(",");
          } else {
            out += "" + $typeSchema;
          }
          out += "' } ";
          if (it.opts.messages !== false) {
            out += " , message: 'should be ";
            if ($typeIsArray) {
              out += "" + $typeSchema.join(",");
            } else {
              out += "" + $typeSchema;
            }
            out += "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        out += " } if (" + $coerced + " !== undefined) {  ";
        var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
        out += " " + $data + " = " + $coerced + "; ";
        if (!$dataLvl) {
          out += "if (" + $parentData + " !== undefined)";
        }
        out += " " + $parentData + "[" + $parentDataProperty + "] = " + $coerced + "; } ";
      } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
          if ($typeIsArray) {
            out += "" + $typeSchema.join(",");
          } else {
            out += "" + $typeSchema;
          }
          out += "' } ";
          if (it.opts.messages !== false) {
            out += " , message: 'should be ";
            if ($typeIsArray) {
              out += "" + $typeSchema.join(",");
            } else {
              out += "" + $typeSchema;
            }
            out += "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
      }
      out += " } ";
    }
  }
  if (it.schema.$ref && !$refKeywords) {
    out += " " + it.RULES.all.$ref.code(it, "$ref") + " ";
    if ($breakOnError) {
      out += " } if (errors === ";
      if ($top) {
        out += "0";
      } else {
        out += "errs_" + $lvl;
      }
      out += ") { ";
      $closingBraces2 += "}";
    }
  } else {
    var arr2 = it.RULES;
    if (arr2) {
      var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
      while (i2 < l2) {
        $rulesGroup = arr2[i2 += 1];
        if ($shouldUseGroup($rulesGroup)) {
          if ($rulesGroup.type) {
            out += " if (" + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ") { ";
          }
          if (it.opts.useDefaults) {
            if ($rulesGroup.type == "object" && it.schema.properties) {
              var $schema2 = it.schema.properties, $schemaKeys = Object.keys($schema2);
              var arr3 = $schemaKeys;
              if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while (i3 < l3) {
                  $propertyKey = arr3[i3 += 1];
                  var $sch = $schema2[$propertyKey];
                  if ($sch.default !== void 0) {
                    var $passData = $data + it.util.getProperty($propertyKey);
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = "default is ignored for: " + $passData;
                        if (it.opts.strictDefaults === "log")
                          it.logger.warn($defaultMsg);
                        else
                          throw new Error($defaultMsg);
                      }
                    } else {
                      out += " if (" + $passData + " === undefined ";
                      if (it.opts.useDefaults == "empty") {
                        out += " || " + $passData + " === null || " + $passData + " === '' ";
                      }
                      out += " ) " + $passData + " = ";
                      if (it.opts.useDefaults == "shared") {
                        out += " " + it.useDefault($sch.default) + " ";
                      } else {
                        out += " " + JSON.stringify($sch.default) + " ";
                      }
                      out += "; ";
                    }
                  }
                }
              }
            } else if ($rulesGroup.type == "array" && Array.isArray(it.schema.items)) {
              var arr4 = it.schema.items;
              if (arr4) {
                var $sch, $i = -1, l4 = arr4.length - 1;
                while ($i < l4) {
                  $sch = arr4[$i += 1];
                  if ($sch.default !== void 0) {
                    var $passData = $data + "[" + $i + "]";
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = "default is ignored for: " + $passData;
                        if (it.opts.strictDefaults === "log")
                          it.logger.warn($defaultMsg);
                        else
                          throw new Error($defaultMsg);
                      }
                    } else {
                      out += " if (" + $passData + " === undefined ";
                      if (it.opts.useDefaults == "empty") {
                        out += " || " + $passData + " === null || " + $passData + " === '' ";
                      }
                      out += " ) " + $passData + " = ";
                      if (it.opts.useDefaults == "shared") {
                        out += " " + it.useDefault($sch.default) + " ";
                      } else {
                        out += " " + JSON.stringify($sch.default) + " ";
                      }
                      out += "; ";
                    }
                  }
                }
              }
            }
          }
          var arr5 = $rulesGroup.rules;
          if (arr5) {
            var $rule, i5 = -1, l5 = arr5.length - 1;
            while (i5 < l5) {
              $rule = arr5[i5 += 1];
              if ($shouldUseRule($rule)) {
                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                if ($code) {
                  out += " " + $code + " ";
                  if ($breakOnError) {
                    $closingBraces1 += "}";
                  }
                }
              }
            }
          }
          if ($breakOnError) {
            out += " " + $closingBraces1 + " ";
            $closingBraces1 = "";
          }
          if ($rulesGroup.type) {
            out += " } ";
            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
              out += " else { ";
              var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = "";
              if (it.createErrors !== false) {
                out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                if ($typeIsArray) {
                  out += "" + $typeSchema.join(",");
                } else {
                  out += "" + $typeSchema;
                }
                out += "' } ";
                if (it.opts.messages !== false) {
                  out += " , message: 'should be ";
                  if ($typeIsArray) {
                    out += "" + $typeSchema.join(",");
                  } else {
                    out += "" + $typeSchema;
                  }
                  out += "' ";
                }
                if (it.opts.verbose) {
                  out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                }
                out += " } ";
              } else {
                out += " {} ";
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                if (it.async) {
                  out += " throw new ValidationError([" + __err + "]); ";
                } else {
                  out += " validate.errors = [" + __err + "]; return false; ";
                }
              } else {
                out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
              }
              out += " } ";
            }
          }
          if ($breakOnError) {
            out += " if (errors === ";
            if ($top) {
              out += "0";
            } else {
              out += "errs_" + $lvl;
            }
            out += ") { ";
            $closingBraces2 += "}";
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += " " + $closingBraces2 + " ";
  }
  if ($top) {
    if ($async) {
      out += " if (errors === 0) return data;           ";
      out += " else throw new ValidationError(vErrors); ";
    } else {
      out += " validate.errors = vErrors; ";
      out += " return errors === 0;       ";
    }
    out += " }; return validate;";
  } else {
    out += " var " + $valid + " = errors === errs_" + $lvl + ";";
  }
  function $shouldUseGroup($rulesGroup2) {
    var rules3 = $rulesGroup2.rules;
    for (var i = 0; i < rules3.length; i++)
      if ($shouldUseRule(rules3[i]))
        return true;
  }
  function $shouldUseRule($rule2) {
    return it.schema[$rule2.keyword] !== void 0 || $rule2.implements && $ruleImplementsSomeKeyword($rule2);
  }
  function $ruleImplementsSomeKeyword($rule2) {
    var impl = $rule2.implements;
    for (var i = 0; i < impl.length; i++)
      if (it.schema[impl[i]] !== void 0)
        return true;
  }
  return out;
};
var resolve$1 = resolve_1, util$2 = util$5, errorClasses$1 = error_classes, stableStringify$1 = fastJsonStableStringify;
var validateGenerator = validate$1;
var ucs2length2 = util$2.ucs2length;
var equal2 = fastDeepEqual;
var ValidationError = errorClasses$1.Validation;
var compile_1 = compile$1;
function compile$1(schema2, root2, localRefs, baseId) {
  var self2 = this, opts = this._opts, refVal = [void 0], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
  root2 = root2 || {
    schema: schema2,
    refVal,
    refs
  };
  var c2 = checkCompiling.call(this, schema2, root2, baseId);
  var compilation = this._compilations[c2.index];
  if (c2.compiling)
    return compilation.callValidate = callValidate;
  var formats2 = this._formats;
  var RULES = this.RULES;
  try {
    var v = localCompile(schema2, root2, localRefs, baseId);
    compilation.validate = v;
    var cv = compilation.callValidate;
    if (cv) {
      cv.schema = v.schema;
      cv.errors = null;
      cv.refs = v.refs;
      cv.refVal = v.refVal;
      cv.root = v.root;
      cv.$async = v.$async;
      if (opts.sourceCode)
        cv.source = v.source;
    }
    return v;
  } finally {
    endCompiling.call(this, schema2, root2, baseId);
  }
  function callValidate() {
    var validate2 = compilation.validate;
    var result = validate2.apply(this, arguments);
    callValidate.errors = validate2.errors;
    return result;
  }
  function localCompile(_schema, _root, localRefs2, baseId2) {
    var isRoot = !_root || _root && _root.schema == _schema;
    if (_root.schema != root2.schema)
      return compile$1.call(self2, _schema, _root, localRefs2, baseId2);
    var $async = _schema.$async === true;
    var sourceCode = validateGenerator({
      isTop: true,
      schema: _schema,
      isRoot,
      baseId: baseId2,
      root: _root,
      schemaPath: "",
      errSchemaPath: "#",
      errorPath: '""',
      MissingRefError: errorClasses$1.MissingRef,
      RULES,
      validate: validateGenerator,
      util: util$2,
      resolve: resolve$1,
      resolveRef,
      usePattern,
      useDefault,
      useCustomRule,
      opts,
      formats: formats2,
      logger: self2.logger,
      self: self2
    });
    sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode) + vars(defaults, defaultCode) + vars(customRules, customRuleCode$1) + sourceCode;
    if (opts.processCode)
      sourceCode = opts.processCode(sourceCode, _schema);
    var validate2;
    try {
      var makeValidate = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", sourceCode);
      validate2 = makeValidate(self2, RULES, formats2, root2, refVal, defaults, customRules, equal2, ucs2length2, ValidationError);
      refVal[0] = validate2;
    } catch (e) {
      self2.logger.error("Error compiling schema, function code:", sourceCode);
      throw e;
    }
    validate2.schema = _schema;
    validate2.errors = null;
    validate2.refs = refs;
    validate2.refVal = refVal;
    validate2.root = isRoot ? validate2 : _root;
    if ($async)
      validate2.$async = true;
    if (opts.sourceCode === true) {
      validate2.source = {
        code: sourceCode,
        patterns,
        defaults
      };
    }
    return validate2;
  }
  function resolveRef(baseId2, ref2, isRoot) {
    ref2 = resolve$1.url(baseId2, ref2);
    var refIndex = refs[ref2];
    var _refVal, refCode;
    if (refIndex !== void 0) {
      _refVal = refVal[refIndex];
      refCode = "refVal[" + refIndex + "]";
      return resolvedRef(_refVal, refCode);
    }
    if (!isRoot && root2.refs) {
      var rootRefId = root2.refs[ref2];
      if (rootRefId !== void 0) {
        _refVal = root2.refVal[rootRefId];
        refCode = addLocalRef(ref2, _refVal);
        return resolvedRef(_refVal, refCode);
      }
    }
    refCode = addLocalRef(ref2);
    var v2 = resolve$1.call(self2, localCompile, root2, ref2);
    if (v2 === void 0) {
      var localSchema = localRefs && localRefs[ref2];
      if (localSchema) {
        v2 = resolve$1.inlineRef(localSchema, opts.inlineRefs) ? localSchema : compile$1.call(self2, localSchema, root2, localRefs, baseId2);
      }
    }
    if (v2 === void 0) {
      removeLocalRef(ref2);
    } else {
      replaceLocalRef(ref2, v2);
      return resolvedRef(v2, refCode);
    }
  }
  function addLocalRef(ref2, v2) {
    var refId = refVal.length;
    refVal[refId] = v2;
    refs[ref2] = refId;
    return "refVal" + refId;
  }
  function removeLocalRef(ref2) {
    delete refs[ref2];
  }
  function replaceLocalRef(ref2, v2) {
    var refId = refs[ref2];
    refVal[refId] = v2;
  }
  function resolvedRef(refVal2, code2) {
    return typeof refVal2 == "object" || typeof refVal2 == "boolean" ? {
      code: code2,
      schema: refVal2,
      inline: true
    } : {
      code: code2,
      $async: refVal2 && !!refVal2.$async
    };
  }
  function usePattern(regexStr) {
    var index2 = patternsHash[regexStr];
    if (index2 === void 0) {
      index2 = patternsHash[regexStr] = patterns.length;
      patterns[index2] = regexStr;
    }
    return "pattern" + index2;
  }
  function useDefault(value2) {
    switch (typeof value2) {
      case "boolean":
      case "number":
        return "" + value2;
      case "string":
        return util$2.toQuotedString(value2);
      case "object":
        if (value2 === null)
          return "null";
        var valueStr = stableStringify$1(value2);
        var index2 = defaultsHash[valueStr];
        if (index2 === void 0) {
          index2 = defaultsHash[valueStr] = defaults.length;
          defaults[index2] = value2;
        }
        return "default" + index2;
    }
  }
  function useCustomRule(rule, schema3, parentSchema, it) {
    if (self2._opts.validateSchema !== false) {
      var deps = rule.definition.dependencies;
      if (deps && !deps.every(function(keyword2) {
        return Object.prototype.hasOwnProperty.call(parentSchema, keyword2);
      }))
        throw new Error("parent schema must have all required keywords: " + deps.join(","));
      var validateSchema2 = rule.definition.validateSchema;
      if (validateSchema2) {
        var valid = validateSchema2(schema3);
        if (!valid) {
          var message = "keyword schema is invalid: " + self2.errorsText(validateSchema2.errors);
          if (self2._opts.validateSchema == "log")
            self2.logger.error(message);
          else
            throw new Error(message);
        }
      }
    }
    var compile2 = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
    var validate2;
    if (compile2) {
      validate2 = compile2.call(self2, schema3, parentSchema, it);
    } else if (macro) {
      validate2 = macro.call(self2, schema3, parentSchema, it);
      if (opts.validateSchema !== false)
        self2.validateSchema(validate2, true);
    } else if (inline) {
      validate2 = inline.call(self2, it, rule.keyword, schema3, parentSchema);
    } else {
      validate2 = rule.definition.validate;
      if (!validate2)
        return;
    }
    if (validate2 === void 0)
      throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
    var index2 = customRules.length;
    customRules[index2] = validate2;
    return {
      code: "customRule" + index2,
      validate: validate2
    };
  }
}
function checkCompiling(schema2, root2, baseId) {
  var index2 = compIndex.call(this, schema2, root2, baseId);
  if (index2 >= 0)
    return {
      index: index2,
      compiling: true
    };
  index2 = this._compilations.length;
  this._compilations[index2] = {
    schema: schema2,
    root: root2,
    baseId
  };
  return {
    index: index2,
    compiling: false
  };
}
function endCompiling(schema2, root2, baseId) {
  var i = compIndex.call(this, schema2, root2, baseId);
  if (i >= 0)
    this._compilations.splice(i, 1);
}
function compIndex(schema2, root2, baseId) {
  for (var i = 0; i < this._compilations.length; i++) {
    var c2 = this._compilations[i];
    if (c2.schema == schema2 && c2.root == root2 && c2.baseId == baseId)
      return i;
  }
  return -1;
}
function patternCode(i, patterns) {
  return "var pattern" + i + " = new RegExp(" + util$2.toQuotedString(patterns[i]) + ");";
}
function defaultCode(i) {
  return "var default" + i + " = defaults[" + i + "];";
}
function refValCode(i, refVal) {
  return refVal[i] === void 0 ? "" : "var refVal" + i + " = refVal[" + i + "];";
}
function customRuleCode$1(i) {
  return "var customRule" + i + " = customRules[" + i + "];";
}
function vars(arr, statement) {
  if (!arr.length)
    return "";
  var code2 = "";
  for (var i = 0; i < arr.length; i++)
    code2 += statement(i, arr);
  return code2;
}
var cache = { exports: {} };
var Cache$1 = cache.exports = function Cache() {
  this._cache = {};
};
Cache$1.prototype.put = function Cache_put(key, value2) {
  this._cache[key] = value2;
};
Cache$1.prototype.get = function Cache_get(key) {
  return this._cache[key];
};
Cache$1.prototype.del = function Cache_del(key) {
  delete this._cache[key];
};
Cache$1.prototype.clear = function Cache_clear() {
  this._cache = {};
};
var cacheExports = cache.exports;
var util$1 = util$5;
var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
var URL$1 = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
var formats_1 = formats$1;
function formats$1(mode) {
  mode = mode == "full" ? "full" : "fast";
  return util$1.copy(formats$1[mode]);
}
formats$1.fast = {
  // date: http://tools.ietf.org/html/rfc3339#section-5.6
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
  time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
  "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
  // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
  uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
  "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
  "uri-template": URITEMPLATE,
  url: URL$1,
  // email (sources from jsen validator):
  // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
  // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex,
  // uuid: http://tools.ietf.org/html/rfc4122
  uuid: UUID,
  // JSON-pointer: https://tools.ietf.org/html/rfc6901
  // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
  "json-pointer": JSON_POINTER,
  "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
  // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
  "relative-json-pointer": RELATIVE_JSON_POINTER
};
formats$1.full = {
  date,
  time,
  "date-time": date_time,
  uri,
  "uri-reference": URIREF,
  "uri-template": URITEMPLATE,
  url: URL$1,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex,
  uuid: UUID,
  "json-pointer": JSON_POINTER,
  "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
  "relative-json-pointer": RELATIVE_JSON_POINTER
};
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function date(str) {
  var matches = str.match(DATE);
  if (!matches)
    return false;
  var year = +matches[1];
  var month = +matches[2];
  var day = +matches[3];
  return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function time(str, full) {
  var matches = str.match(TIME);
  if (!matches)
    return false;
  var hour = matches[1];
  var minute = matches[2];
  var second2 = matches[3];
  var timeZone = matches[5];
  return (hour <= 23 && minute <= 59 && second2 <= 59 || hour == 23 && minute == 59 && second2 == 60) && (!full || timeZone);
}
var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
  var dateTime = str.split(DATE_TIME_SEPARATOR);
  return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}
var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
  return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}
var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
  if (Z_ANCHOR.test(str))
    return false;
  try {
    new RegExp(str);
    return true;
  } catch (e) {
    return false;
  }
}
var ref = function generate_ref(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $async, $refCode;
  if ($schema2 == "#" || $schema2 == "#/") {
    if (it.isRoot) {
      $async = it.async;
      $refCode = "validate";
    } else {
      $async = it.root.schema.$async === true;
      $refCode = "root.refVal[0]";
    }
  } else {
    var $refVal = it.resolveRef(it.baseId, $schema2, it.isRoot);
    if ($refVal === void 0) {
      var $message = it.MissingRefError.message(it.baseId, $schema2);
      if (it.opts.missingRefs == "fail") {
        it.logger.error($message);
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { ref: '" + it.util.escapeQuotes($schema2) + "' } ";
          if (it.opts.messages !== false) {
            out += " , message: 'can\\'t resolve reference " + it.util.escapeQuotes($schema2) + "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: " + it.util.toQuotedString($schema2) + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        if ($breakOnError) {
          out += " if (false) { ";
        }
      } else if (it.opts.missingRefs == "ignore") {
        it.logger.warn($message);
        if ($breakOnError) {
          out += " if (true) { ";
        }
      } else {
        throw new it.MissingRefError(it.baseId, $schema2, $message);
      }
    } else if ($refVal.inline) {
      var $it = it.util.copy(it);
      $it.level++;
      var $nextValid = "valid" + $it.level;
      $it.schema = $refVal.schema;
      $it.schemaPath = "";
      $it.errSchemaPath = $schema2;
      var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
      out += " " + $code + " ";
      if ($breakOnError) {
        out += " if (" + $nextValid + ") { ";
      }
    } else {
      $async = $refVal.$async === true || it.async && $refVal.$async !== false;
      $refCode = $refVal.code;
    }
  }
  if ($refCode) {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it.opts.passContext) {
      out += " " + $refCode + ".call(this, ";
    } else {
      out += " " + $refCode + "( ";
    }
    out += " " + $data + ", (dataPath || '')";
    if (it.errorPath != '""') {
      out += " + " + it.errorPath;
    }
    var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
    out += " , " + $parentData + " , " + $parentDataProperty + ", rootData)  ";
    var __callValidate = out;
    out = $$outStack.pop();
    if ($async) {
      if (!it.async)
        throw new Error("async schema referenced by sync schema");
      if ($breakOnError) {
        out += " var " + $valid + "; ";
      }
      out += " try { await " + __callValidate + "; ";
      if ($breakOnError) {
        out += " " + $valid + " = true; ";
      }
      out += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ";
      if ($breakOnError) {
        out += " " + $valid + " = false; ";
      }
      out += " } ";
      if ($breakOnError) {
        out += " if (" + $valid + ") { ";
      }
    } else {
      out += " if (!" + __callValidate + ") { if (vErrors === null) vErrors = " + $refCode + ".errors; else vErrors = vErrors.concat(" + $refCode + ".errors); errors = vErrors.length; } ";
      if ($breakOnError) {
        out += " else { ";
      }
    }
  }
  return out;
};
var allOf = function generate_allOf(it, $keyword, $ruleType) {
  var out = " ";
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
  var arr1 = $schema2;
  if (arr1) {
    var $sch, $i = -1, l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
        $allSchemasEmpty = false;
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + "[" + $i + "]";
        $it.errSchemaPath = $errSchemaPath + "/" + $i;
        out += "  " + it.validate($it) + " ";
        $it.baseId = $currentBaseId;
        if ($breakOnError) {
          out += " if (" + $nextValid + ") { ";
          $closingBraces += "}";
        }
      }
    }
  }
  if ($breakOnError) {
    if ($allSchemasEmpty) {
      out += " if (true) { ";
    } else {
      out += " " + $closingBraces.slice(0, -1) + " ";
    }
  }
  return out;
};
var anyOf = function generate_anyOf(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $noEmptySchema = $schema2.every(function($sch2) {
    return it.opts.strictKeywords ? typeof $sch2 == "object" && Object.keys($sch2).length > 0 || $sch2 === false : it.util.schemaHasRules($sch2, it.RULES.all);
  });
  if ($noEmptySchema) {
    var $currentBaseId = $it.baseId;
    out += " var " + $errs + " = errors; var " + $valid + " = false;  ";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema2;
    if (arr1) {
      var $sch, $i = -1, l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + "[" + $i + "]";
        $it.errSchemaPath = $errSchemaPath + "/" + $i;
        out += "  " + it.validate($it) + " ";
        $it.baseId = $currentBaseId;
        out += " " + $valid + " = " + $valid + " || " + $nextValid + "; if (!" + $valid + ") { ";
        $closingBraces += "}";
      }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += " " + $closingBraces + " if (!" + $valid + ") {   var err =   ";
    if (it.createErrors !== false) {
      out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
      if (it.opts.messages !== false) {
        out += " , message: 'should match some schema in anyOf' ";
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError(vErrors); ";
      } else {
        out += " validate.errors = vErrors; return false; ";
      }
    }
    out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
    if (it.opts.allErrors) {
      out += " } ";
    }
  } else {
    if ($breakOnError) {
      out += " if (true) { ";
    }
  }
  return out;
};
var comment = function generate_comment(it, $keyword, $ruleType) {
  var out = " ";
  var $schema2 = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  !it.opts.allErrors;
  var $comment = it.util.toQuotedString($schema2);
  if (it.opts.$comment === true) {
    out += " console.log(" + $comment + ");";
  } else if (typeof it.opts.$comment == "function") {
    out += " self._opts.$comment(" + $comment + ", " + it.util.toQuotedString($errSchemaPath) + ", validate.root.schema);";
  }
  return out;
};
var _const = function generate_const(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $isData = it.opts.$data && $schema2 && $schema2.$data;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
  }
  if (!$isData) {
    out += " var schema" + $lvl + " = validate.schema" + $schemaPath + ";";
  }
  out += "var " + $valid + " = equal(" + $data + ", schema" + $lvl + "); if (!" + $valid + ") {   ";
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValue: schema" + $lvl + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should be equal to constant' ";
    }
    if (it.opts.verbose) {
      out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += " }";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var contains = function generate_contains(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it.util.schemaHasRules($schema2, it.RULES.all);
  out += "var " + $errs + " = errors;var " + $valid + ";";
  if ($nonEmptySchema) {
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.schema = $schema2;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += " var " + $nextValid + " = false; for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + "[" + $idx + "]";
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
    } else {
      out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
    }
    out += " if (" + $nextValid + ") break; }  ";
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += " " + $closingBraces + " if (!" + $nextValid + ") {";
  } else {
    out += " if (" + $data + ".length == 0) {";
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
    if (it.opts.messages !== false) {
      out += " , message: 'should contain a valid item' ";
    }
    if (it.opts.verbose) {
      out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += " } else { ";
  if ($nonEmptySchema) {
    out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
  }
  if (it.opts.allErrors) {
    out += " } ";
  }
  return out;
};
var dependencies = function generate_dependencies(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
  for ($property in $schema2) {
    if ($property == "__proto__")
      continue;
    var $sch = $schema2[$property];
    var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
    $deps[$property] = $sch;
  }
  out += "var " + $errs + " = errors;";
  var $currentErrorPath = it.errorPath;
  out += "var missing" + $lvl + ";";
  for (var $property in $propertyDeps) {
    $deps = $propertyDeps[$property];
    if ($deps.length) {
      out += " if ( " + $data + it.util.getProperty($property) + " !== undefined ";
      if ($ownProperties) {
        out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
      }
      if ($breakOnError) {
        out += " && ( ";
        var arr1 = $deps;
        if (arr1) {
          var $propertyKey, $i = -1, l1 = arr1.length - 1;
          while ($i < l1) {
            $propertyKey = arr1[$i += 1];
            if ($i) {
              out += " || ";
            }
            var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
            out += " ( ( " + $useData + " === undefined ";
            if ($ownProperties) {
              out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
            }
            out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
          }
        }
        out += ")) {  ";
        var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
          if (it.opts.messages !== false) {
            out += " , message: 'should have ";
            if ($deps.length == 1) {
              out += "property " + it.util.escapeQuotes($deps[0]);
            } else {
              out += "properties " + it.util.escapeQuotes($deps.join(", "));
            }
            out += " when property " + it.util.escapeQuotes($property) + " is present' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
      } else {
        out += " ) { ";
        var arr2 = $deps;
        if (arr2) {
          var $propertyKey, i2 = -1, l2 = arr2.length - 1;
          while (i2 < l2) {
            $propertyKey = arr2[i2 += 1];
            var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += " if ( " + $useData + " === undefined ";
            if ($ownProperties) {
              out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
            }
            out += ") {  var err =   ";
            if (it.createErrors !== false) {
              out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
              if (it.opts.messages !== false) {
                out += " , message: 'should have ";
                if ($deps.length == 1) {
                  out += "property " + it.util.escapeQuotes($deps[0]);
                } else {
                  out += "properties " + it.util.escapeQuotes($deps.join(", "));
                }
                out += " when property " + it.util.escapeQuotes($property) + " is present' ";
              }
              if (it.opts.verbose) {
                out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
              }
              out += " } ";
            } else {
              out += " {} ";
            }
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
        }
      }
      out += " }   ";
      if ($breakOnError) {
        $closingBraces += "}";
        out += " else { ";
      }
    }
  }
  it.errorPath = $currentErrorPath;
  var $currentBaseId = $it.baseId;
  for (var $property in $schemaDeps) {
    var $sch = $schemaDeps[$property];
    if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
      out += " " + $nextValid + " = true; if ( " + $data + it.util.getProperty($property) + " !== undefined ";
      if ($ownProperties) {
        out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
      }
      out += ") { ";
      $it.schema = $sch;
      $it.schemaPath = $schemaPath + it.util.getProperty($property);
      $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($property);
      out += "  " + it.validate($it) + " ";
      $it.baseId = $currentBaseId;
      out += " }  ";
      if ($breakOnError) {
        out += " if (" + $nextValid + ") { ";
        $closingBraces += "}";
      }
    }
  }
  if ($breakOnError) {
    out += "   " + $closingBraces + " if (" + $errs + " == errors) {";
  }
  return out;
};
var _enum = function generate_enum(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $isData = it.opts.$data && $schema2 && $schema2.$data;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
  }
  var $i = "i" + $lvl, $vSchema = "schema" + $lvl;
  if (!$isData) {
    out += " var " + $vSchema + " = validate.schema" + $schemaPath + ";";
  }
  out += "var " + $valid + ";";
  if ($isData) {
    out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
  }
  out += "" + $valid + " = false;for (var " + $i + "=0; " + $i + "<" + $vSchema + ".length; " + $i + "++) if (equal(" + $data + ", " + $vSchema + "[" + $i + "])) { " + $valid + " = true; break; }";
  if ($isData) {
    out += "  }  ";
  }
  out += " if (!" + $valid + ") {   ";
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValues: schema" + $lvl + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should be equal to one of the allowed values' ";
    }
    if (it.opts.verbose) {
      out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += " }";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var format = function generate_format(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  if (it.opts.format === false) {
    if ($breakOnError) {
      out += " if (true) { ";
    }
    return out;
  }
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
  if ($isData) {
    var $format = "format" + $lvl, $isObject = "isObject" + $lvl, $formatType = "formatType" + $lvl;
    out += " var " + $format + " = formats[" + $schemaValue + "]; var " + $isObject + " = typeof " + $format + " == 'object' && !(" + $format + " instanceof RegExp) && " + $format + ".validate; var " + $formatType + " = " + $isObject + " && " + $format + ".type || 'string'; if (" + $isObject + ") { ";
    if (it.async) {
      out += " var async" + $lvl + " = " + $format + ".async; ";
    }
    out += " " + $format + " = " + $format + ".validate; } if (  ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
    }
    out += " (";
    if ($unknownFormats != "ignore") {
      out += " (" + $schemaValue + " && !" + $format + " ";
      if ($allowUnknown) {
        out += " && self._opts.unknownFormats.indexOf(" + $schemaValue + ") == -1 ";
      }
      out += ") || ";
    }
    out += " (" + $format + " && " + $formatType + " == '" + $ruleType + "' && !(typeof " + $format + " == 'function' ? ";
    if (it.async) {
      out += " (async" + $lvl + " ? await " + $format + "(" + $data + ") : " + $format + "(" + $data + ")) ";
    } else {
      out += " " + $format + "(" + $data + ") ";
    }
    out += " : " + $format + ".test(" + $data + "))))) {";
  } else {
    var $format = it.formats[$schema2];
    if (!$format) {
      if ($unknownFormats == "ignore") {
        it.logger.warn('unknown format "' + $schema2 + '" ignored in schema at path "' + it.errSchemaPath + '"');
        if ($breakOnError) {
          out += " if (true) { ";
        }
        return out;
      } else if ($allowUnknown && $unknownFormats.indexOf($schema2) >= 0) {
        if ($breakOnError) {
          out += " if (true) { ";
        }
        return out;
      } else {
        throw new Error('unknown format "' + $schema2 + '" is used in schema at path "' + it.errSchemaPath + '"');
      }
    }
    var $isObject = typeof $format == "object" && !($format instanceof RegExp) && $format.validate;
    var $formatType = $isObject && $format.type || "string";
    if ($isObject) {
      var $async = $format.async === true;
      $format = $format.validate;
    }
    if ($formatType != $ruleType) {
      if ($breakOnError) {
        out += " if (true) { ";
      }
      return out;
    }
    if ($async) {
      if (!it.async)
        throw new Error("async format in sync schema");
      var $formatRef = "formats" + it.util.getProperty($schema2) + ".validate";
      out += " if (!(await " + $formatRef + "(" + $data + "))) { ";
    } else {
      out += " if (! ";
      var $formatRef = "formats" + it.util.getProperty($schema2);
      if ($isObject)
        $formatRef += ".validate";
      if (typeof $format == "function") {
        out += " " + $formatRef + "(" + $data + ") ";
      } else {
        out += " " + $formatRef + ".test(" + $data + ") ";
      }
      out += ") { ";
    }
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { format:  ";
    if ($isData) {
      out += "" + $schemaValue;
    } else {
      out += "" + it.util.toQuotedString($schema2);
    }
    out += "  } ";
    if (it.opts.messages !== false) {
      out += ` , message: 'should match format "`;
      if ($isData) {
        out += "' + " + $schemaValue + " + '";
      } else {
        out += "" + it.util.escapeQuotes($schema2);
      }
      out += `"' `;
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + it.util.toQuotedString($schema2);
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += " } ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var _if = function generate_if(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $thenSch = it.schema["then"], $elseSch = it.schema["else"], $thenPresent = $thenSch !== void 0 && (it.opts.strictKeywords ? typeof $thenSch == "object" && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== void 0 && (it.opts.strictKeywords ? typeof $elseSch == "object" && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
  if ($thenPresent || $elsePresent) {
    var $ifClause;
    $it.createErrors = false;
    $it.schema = $schema2;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += " var " + $errs + " = errors; var " + $valid + " = true;  ";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    out += "  " + it.validate($it) + " ";
    $it.baseId = $currentBaseId;
    $it.createErrors = true;
    out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }  ";
    it.compositeRule = $it.compositeRule = $wasComposite;
    if ($thenPresent) {
      out += " if (" + $nextValid + ") {  ";
      $it.schema = it.schema["then"];
      $it.schemaPath = it.schemaPath + ".then";
      $it.errSchemaPath = it.errSchemaPath + "/then";
      out += "  " + it.validate($it) + " ";
      $it.baseId = $currentBaseId;
      out += " " + $valid + " = " + $nextValid + "; ";
      if ($thenPresent && $elsePresent) {
        $ifClause = "ifClause" + $lvl;
        out += " var " + $ifClause + " = 'then'; ";
      } else {
        $ifClause = "'then'";
      }
      out += " } ";
      if ($elsePresent) {
        out += " else { ";
      }
    } else {
      out += " if (!" + $nextValid + ") { ";
    }
    if ($elsePresent) {
      $it.schema = it.schema["else"];
      $it.schemaPath = it.schemaPath + ".else";
      $it.errSchemaPath = it.errSchemaPath + "/else";
      out += "  " + it.validate($it) + " ";
      $it.baseId = $currentBaseId;
      out += " " + $valid + " = " + $nextValid + "; ";
      if ($thenPresent && $elsePresent) {
        $ifClause = "ifClause" + $lvl;
        out += " var " + $ifClause + " = 'else'; ";
      } else {
        $ifClause = "'else'";
      }
      out += " } ";
    }
    out += " if (!" + $valid + ") {   var err =   ";
    if (it.createErrors !== false) {
      out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { failingKeyword: " + $ifClause + " } ";
      if (it.opts.messages !== false) {
        out += ` , message: 'should match "' + ` + $ifClause + ` + '" schema' `;
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError(vErrors); ";
      } else {
        out += " validate.errors = vErrors; return false; ";
      }
    }
    out += " }   ";
    if ($breakOnError) {
      out += " else { ";
    }
  } else {
    if ($breakOnError) {
      out += " if (true) { ";
    }
  }
  return out;
};
var items = function generate_items(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId;
  out += "var " + $errs + " = errors;var " + $valid + ";";
  if (Array.isArray($schema2)) {
    var $additionalItems = it.schema.additionalItems;
    if ($additionalItems === false) {
      out += " " + $valid + " = " + $data + ".length <= " + $schema2.length + "; ";
      var $currErrSchemaPath = $errSchemaPath;
      $errSchemaPath = it.errSchemaPath + "/additionalItems";
      out += "  if (!" + $valid + ") {   ";
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it.createErrors !== false) {
        out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schema2.length + " } ";
        if (it.opts.messages !== false) {
          out += " , message: 'should NOT have more than " + $schema2.length + " items' ";
        }
        if (it.opts.verbose) {
          out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        if (it.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      out += " } ";
      $errSchemaPath = $currErrSchemaPath;
      if ($breakOnError) {
        $closingBraces += "}";
        out += " else { ";
      }
    }
    var arr1 = $schema2;
    if (arr1) {
      var $sch, $i = -1, l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
          out += " " + $nextValid + " = true; if (" + $data + ".length > " + $i + ") { ";
          var $passData = $data + "[" + $i + "]";
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + "[" + $i + "]";
          $it.errSchemaPath = $errSchemaPath + "/" + $i;
          $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
          $it.dataPathArr[$dataNxt] = $i;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
          } else {
            out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
          }
          out += " }  ";
          if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
          }
        }
      }
    }
    if (typeof $additionalItems == "object" && (it.opts.strictKeywords ? typeof $additionalItems == "object" && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
      $it.schema = $additionalItems;
      $it.schemaPath = it.schemaPath + ".additionalItems";
      $it.errSchemaPath = it.errSchemaPath + "/additionalItems";
      out += " " + $nextValid + " = true; if (" + $data + ".length > " + $schema2.length + ") {  for (var " + $idx + " = " + $schema2.length + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
      $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
      var $passData = $data + "[" + $idx + "]";
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it.validate($it);
      $it.baseId = $currentBaseId;
      if (it.util.varOccurences($code, $nextData) < 2) {
        out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
      } else {
        out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
      }
      if ($breakOnError) {
        out += " if (!" + $nextValid + ") break; ";
      }
      out += " } }  ";
      if ($breakOnError) {
        out += " if (" + $nextValid + ") { ";
        $closingBraces += "}";
      }
    }
  } else if (it.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it.util.schemaHasRules($schema2, it.RULES.all)) {
    $it.schema = $schema2;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += "  for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + "[" + $idx + "]";
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
    } else {
      out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
    }
    if ($breakOnError) {
      out += " if (!" + $nextValid + ") break; ";
    }
    out += " }";
  }
  if ($breakOnError) {
    out += " " + $closingBraces + " if (" + $errs + " == errors) {";
  }
  return out;
};
var _limit = function generate__limit(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  var $isMax = $keyword == "maximum", $exclusiveKeyword = $isMax ? "exclusiveMaximum" : "exclusiveMinimum", $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? "<" : ">", $notOp = $isMax ? ">" : "<", $errorKeyword = void 0;
  if (!($isData || typeof $schema2 == "number" || $schema2 === void 0)) {
    throw new Error($keyword + " must be number");
  }
  if (!($isDataExcl || $schemaExcl === void 0 || typeof $schemaExcl == "number" || typeof $schemaExcl == "boolean")) {
    throw new Error($exclusiveKeyword + " must be number or boolean");
  }
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = "exclusive" + $lvl, $exclType = "exclType" + $lvl, $exclIsNumber = "exclIsNumber" + $lvl, $opExpr = "op" + $lvl, $opStr = "' + " + $opExpr + " + '";
    out += " var schemaExcl" + $lvl + " = " + $schemaValueExcl + "; ";
    $schemaValueExcl = "schemaExcl" + $lvl;
    out += " var " + $exclusive + "; var " + $exclType + " = typeof " + $schemaValueExcl + "; if (" + $exclType + " != 'boolean' && " + $exclType + " != 'undefined' && " + $exclType + " != 'number') { ";
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
      if (it.opts.messages !== false) {
        out += " , message: '" + $exclusiveKeyword + " should be boolean' ";
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } else if ( ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    }
    out += " " + $exclType + " == 'number' ? ( (" + $exclusive + " = " + $schemaValue + " === undefined || " + $schemaValueExcl + " " + $op + "= " + $schemaValue + ") ? " + $data + " " + $notOp + "= " + $schemaValueExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) : ( (" + $exclusive + " = " + $schemaValueExcl + " === true) ? " + $data + " " + $notOp + "= " + $schemaValue + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { var op" + $lvl + " = " + $exclusive + " ? '" + $op + "' : '" + $op + "='; ";
    if ($schema2 === void 0) {
      $errorKeyword = $exclusiveKeyword;
      $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
      $schemaValue = $schemaValueExcl;
      $isData = $isDataExcl;
    }
  } else {
    var $exclIsNumber = typeof $schemaExcl == "number", $opStr = $op;
    if ($exclIsNumber && $isData) {
      var $opExpr = "'" + $opStr + "'";
      out += " if ( ";
      if ($isData) {
        out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
      }
      out += " ( " + $schemaValue + " === undefined || " + $schemaExcl + " " + $op + "= " + $schemaValue + " ? " + $data + " " + $notOp + "= " + $schemaExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { ";
    } else {
      if ($exclIsNumber && $schema2 === void 0) {
        $exclusive = true;
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
        $schemaValue = $schemaExcl;
        $notOp += "=";
      } else {
        if ($exclIsNumber)
          $schemaValue = Math[$isMax ? "min" : "max"]($schemaExcl, $schema2);
        if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
          $notOp += "=";
        } else {
          $exclusive = false;
          $opStr += "=";
        }
      }
      var $opExpr = "'" + $opStr + "'";
      out += " if ( ";
      if ($isData) {
        out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
      }
      out += " " + $data + " " + $notOp + " " + $schemaValue + " || " + $data + " !== " + $data + ") { ";
    }
  }
  $errorKeyword = $errorKeyword || $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: '" + ($errorKeyword || "_limit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { comparison: " + $opExpr + ", limit: " + $schemaValue + ", exclusive: " + $exclusive + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should be " + $opStr + " ";
      if ($isData) {
        out += "' + " + $schemaValue;
      } else {
        out += "" + $schemaValue + "'";
      }
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + $schema2;
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += " } ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var _limitItems = function generate__limitItems(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  if (!($isData || typeof $schema2 == "number")) {
    throw new Error($keyword + " must be number");
  }
  var $op = $keyword == "maxItems" ? ">" : "<";
  out += "if ( ";
  if ($isData) {
    out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
  }
  out += " " + $data + ".length " + $op + " " + $schemaValue + ") { ";
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: '" + ($errorKeyword || "_limitItems") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should NOT have ";
      if ($keyword == "maxItems") {
        out += "more";
      } else {
        out += "fewer";
      }
      out += " than ";
      if ($isData) {
        out += "' + " + $schemaValue + " + '";
      } else {
        out += "" + $schema2;
      }
      out += " items' ";
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + $schema2;
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += "} ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var _limitLength = function generate__limitLength(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  if (!($isData || typeof $schema2 == "number")) {
    throw new Error($keyword + " must be number");
  }
  var $op = $keyword == "maxLength" ? ">" : "<";
  out += "if ( ";
  if ($isData) {
    out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
  }
  if (it.opts.unicode === false) {
    out += " " + $data + ".length ";
  } else {
    out += " ucs2length(" + $data + ") ";
  }
  out += " " + $op + " " + $schemaValue + ") { ";
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: '" + ($errorKeyword || "_limitLength") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should NOT be ";
      if ($keyword == "maxLength") {
        out += "longer";
      } else {
        out += "shorter";
      }
      out += " than ";
      if ($isData) {
        out += "' + " + $schemaValue + " + '";
      } else {
        out += "" + $schema2;
      }
      out += " characters' ";
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + $schema2;
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += "} ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var _limitProperties = function generate__limitProperties(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  if (!($isData || typeof $schema2 == "number")) {
    throw new Error($keyword + " must be number");
  }
  var $op = $keyword == "maxProperties" ? ">" : "<";
  out += "if ( ";
  if ($isData) {
    out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
  }
  out += " Object.keys(" + $data + ").length " + $op + " " + $schemaValue + ") { ";
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: '" + ($errorKeyword || "_limitProperties") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should NOT have ";
      if ($keyword == "maxProperties") {
        out += "more";
      } else {
        out += "fewer";
      }
      out += " than ";
      if ($isData) {
        out += "' + " + $schemaValue + " + '";
      } else {
        out += "" + $schema2;
      }
      out += " properties' ";
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + $schema2;
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += "} ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var multipleOf = function generate_multipleOf(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  if (!($isData || typeof $schema2 == "number")) {
    throw new Error($keyword + " must be number");
  }
  out += "var division" + $lvl + ";if (";
  if ($isData) {
    out += " " + $schemaValue + " !== undefined && ( typeof " + $schemaValue + " != 'number' || ";
  }
  out += " (division" + $lvl + " = " + $data + " / " + $schemaValue + ", ";
  if (it.opts.multipleOfPrecision) {
    out += " Math.abs(Math.round(division" + $lvl + ") - division" + $lvl + ") > 1e-" + it.opts.multipleOfPrecision + " ";
  } else {
    out += " division" + $lvl + " !== parseInt(division" + $lvl + ") ";
  }
  out += " ) ";
  if ($isData) {
    out += "  )  ";
  }
  out += " ) {   ";
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { multipleOf: " + $schemaValue + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should be multiple of ";
      if ($isData) {
        out += "' + " + $schemaValue;
      } else {
        out += "" + $schemaValue + "'";
      }
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + $schema2;
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += "} ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var not = function generate_not(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = "valid" + $it.level;
  if (it.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it.util.schemaHasRules($schema2, it.RULES.all)) {
    $it.schema = $schema2;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += " var " + $errs + " = errors;  ";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.createErrors = false;
    var $allErrorsOption;
    if ($it.opts.allErrors) {
      $allErrorsOption = $it.opts.allErrors;
      $it.opts.allErrors = false;
    }
    out += " " + it.validate($it) + " ";
    $it.createErrors = true;
    if ($allErrorsOption)
      $it.opts.allErrors = $allErrorsOption;
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += " if (" + $nextValid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it.createErrors !== false) {
      out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
      if (it.opts.messages !== false) {
        out += " , message: 'should NOT be valid' ";
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
    if (it.opts.allErrors) {
      out += " } ";
    }
  } else {
    out += "  var err =   ";
    if (it.createErrors !== false) {
      out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
      if (it.opts.messages !== false) {
        out += " , message: 'should NOT be valid' ";
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if ($breakOnError) {
      out += " if (false) { ";
    }
  }
  return out;
};
var oneOf = function generate_oneOf(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $currentBaseId = $it.baseId, $prevValid = "prevValid" + $lvl, $passingSchemas = "passingSchemas" + $lvl;
  out += "var " + $errs + " = errors , " + $prevValid + " = false , " + $valid + " = false , " + $passingSchemas + " = null; ";
  var $wasComposite = it.compositeRule;
  it.compositeRule = $it.compositeRule = true;
  var arr1 = $schema2;
  if (arr1) {
    var $sch, $i = -1, l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + "[" + $i + "]";
        $it.errSchemaPath = $errSchemaPath + "/" + $i;
        out += "  " + it.validate($it) + " ";
        $it.baseId = $currentBaseId;
      } else {
        out += " var " + $nextValid + " = true; ";
      }
      if ($i) {
        out += " if (" + $nextValid + " && " + $prevValid + ") { " + $valid + " = false; " + $passingSchemas + " = [" + $passingSchemas + ", " + $i + "]; } else { ";
        $closingBraces += "}";
      }
      out += " if (" + $nextValid + ") { " + $valid + " = " + $prevValid + " = true; " + $passingSchemas + " = " + $i + "; }";
    }
  }
  it.compositeRule = $it.compositeRule = $wasComposite;
  out += "" + $closingBraces + "if (!" + $valid + ") {   var err =   ";
  if (it.createErrors !== false) {
    out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { passingSchemas: " + $passingSchemas + " } ";
    if (it.opts.messages !== false) {
      out += " , message: 'should match exactly one schema in oneOf' ";
    }
    if (it.opts.verbose) {
      out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError(vErrors); ";
    } else {
      out += " validate.errors = vErrors; return false; ";
    }
  }
  out += "} else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }";
  if (it.opts.allErrors) {
    out += " } ";
  }
  return out;
};
var pattern = function generate_pattern(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  var $regexp = $isData ? "(new RegExp(" + $schemaValue + "))" : it.usePattern($schema2);
  out += "if ( ";
  if ($isData) {
    out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
  }
  out += " !" + $regexp + ".test(" + $data + ") ) {   ";
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = "";
  if (it.createErrors !== false) {
    out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { pattern:  ";
    if ($isData) {
      out += "" + $schemaValue;
    } else {
      out += "" + it.util.toQuotedString($schema2);
    }
    out += "  } ";
    if (it.opts.messages !== false) {
      out += ` , message: 'should match pattern "`;
      if ($isData) {
        out += "' + " + $schemaValue + " + '";
      } else {
        out += "" + it.util.escapeQuotes($schema2);
      }
      out += `"' `;
    }
    if (it.opts.verbose) {
      out += " , schema:  ";
      if ($isData) {
        out += "validate.schema" + $schemaPath;
      } else {
        out += "" + it.util.toQuotedString($schema2);
      }
      out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
    }
    out += " } ";
  } else {
    out += " {} ";
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    if (it.async) {
      out += " throw new ValidationError([" + __err + "]); ";
    } else {
      out += " validate.errors = [" + __err + "]; return false; ";
    }
  } else {
    out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
  }
  out += "} ";
  if ($breakOnError) {
    out += " else { ";
  }
  return out;
};
var properties$3 = function generate_properties(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  var $key = "key" + $lvl, $idx = "idx" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl;
  var $schemaKeys = Object.keys($schema2 || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == "object" && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
  var $required = it.schema.required;
  if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) {
    var $requiredHash = it.util.toHash($required);
  }
  function notProto(p) {
    return p !== "__proto__";
  }
  out += "var " + $errs + " = errors;var " + $nextValid + " = true;";
  if ($ownProperties) {
    out += " var " + $dataProperties + " = undefined;";
  }
  if ($checkAdditional) {
    if ($ownProperties) {
      out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
    } else {
      out += " for (var " + $key + " in " + $data + ") { ";
    }
    if ($someProperties) {
      out += " var isAdditional" + $lvl + " = !(false ";
      if ($schemaKeys.length) {
        if ($schemaKeys.length > 8) {
          out += " || validate.schema" + $schemaPath + ".hasOwnProperty(" + $key + ") ";
        } else {
          var arr1 = $schemaKeys;
          if (arr1) {
            var $propertyKey, i1 = -1, l1 = arr1.length - 1;
            while (i1 < l1) {
              $propertyKey = arr1[i1 += 1];
              out += " || " + $key + " == " + it.util.toQuotedString($propertyKey) + " ";
            }
          }
        }
      }
      if ($pPropertyKeys.length) {
        var arr2 = $pPropertyKeys;
        if (arr2) {
          var $pProperty, $i = -1, l2 = arr2.length - 1;
          while ($i < l2) {
            $pProperty = arr2[$i += 1];
            out += " || " + it.usePattern($pProperty) + ".test(" + $key + ") ";
          }
        }
      }
      out += " ); if (isAdditional" + $lvl + ") { ";
    }
    if ($removeAdditional == "all") {
      out += " delete " + $data + "[" + $key + "]; ";
    } else {
      var $currentErrorPath = it.errorPath;
      var $additionalProperty = "' + " + $key + " + '";
      if (it.opts._errorDataPathProperty) {
        it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
      }
      if ($noAdditional) {
        if ($removeAdditional) {
          out += " delete " + $data + "[" + $key + "]; ";
        } else {
          out += " " + $nextValid + " = false; ";
          var $currErrSchemaPath = $errSchemaPath;
          $errSchemaPath = it.errSchemaPath + "/additionalProperties";
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it.createErrors !== false) {
            out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { additionalProperty: '" + $additionalProperty + "' } ";
            if (it.opts.messages !== false) {
              out += " , message: '";
              if (it.opts._errorDataPathProperty) {
                out += "is an invalid additional property";
              } else {
                out += "should NOT have additional properties";
              }
              out += "' ";
            }
            if (it.opts.verbose) {
              out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it.compositeRule && $breakOnError) {
            if (it.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
          $errSchemaPath = $currErrSchemaPath;
          if ($breakOnError) {
            out += " break; ";
          }
        }
      } else if ($additionalIsSchema) {
        if ($removeAdditional == "failing") {
          out += " var " + $errs + " = errors;  ";
          var $wasComposite = it.compositeRule;
          it.compositeRule = $it.compositeRule = true;
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + ".additionalProperties";
          $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + "[" + $key + "]";
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
          } else {
            out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
          }
          out += " if (!" + $nextValid + ") { errors = " + $errs + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + $data + "[" + $key + "]; }  ";
          it.compositeRule = $it.compositeRule = $wasComposite;
        } else {
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + ".additionalProperties";
          $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + "[" + $key + "]";
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
          } else {
            out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
          }
          if ($breakOnError) {
            out += " if (!" + $nextValid + ") break; ";
          }
        }
      }
      it.errorPath = $currentErrorPath;
    }
    if ($someProperties) {
      out += " } ";
    }
    out += " }  ";
    if ($breakOnError) {
      out += " if (" + $nextValid + ") { ";
      $closingBraces += "}";
    }
  }
  var $useDefaults = it.opts.useDefaults && !it.compositeRule;
  if ($schemaKeys.length) {
    var arr3 = $schemaKeys;
    if (arr3) {
      var $propertyKey, i3 = -1, l3 = arr3.length - 1;
      while (i3 < l3) {
        $propertyKey = arr3[i3 += 1];
        var $sch = $schema2[$propertyKey];
        if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
          var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== void 0;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + $prop;
          $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($propertyKey);
          $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
          $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            $code = it.util.varReplace($code, $nextData, $passData);
            var $useData = $passData;
          } else {
            var $useData = $nextData;
            out += " var " + $nextData + " = " + $passData + "; ";
          }
          if ($hasDefault) {
            out += " " + $code + " ";
          } else {
            if ($requiredHash && $requiredHash[$propertyKey]) {
              out += " if ( " + $useData + " === undefined ";
              if ($ownProperties) {
                out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
              }
              out += ") { " + $nextValid + " = false; ";
              var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
              if (it.opts._errorDataPathProperty) {
                it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
              }
              $errSchemaPath = it.errSchemaPath + "/required";
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = "";
              if (it.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                if (it.opts.messages !== false) {
                  out += " , message: '";
                  if (it.opts._errorDataPathProperty) {
                    out += "is a required property";
                  } else {
                    out += "should have required property \\'" + $missingProperty + "\\'";
                  }
                  out += "' ";
                }
                if (it.opts.verbose) {
                  out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                }
                out += " } ";
              } else {
                out += " {} ";
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                if (it.async) {
                  out += " throw new ValidationError([" + __err + "]); ";
                } else {
                  out += " validate.errors = [" + __err + "]; return false; ";
                }
              } else {
                out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
              }
              $errSchemaPath = $currErrSchemaPath;
              it.errorPath = $currentErrorPath;
              out += " } else { ";
            } else {
              if ($breakOnError) {
                out += " if ( " + $useData + " === undefined ";
                if ($ownProperties) {
                  out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                }
                out += ") { " + $nextValid + " = true; } else { ";
              } else {
                out += " if (" + $useData + " !== undefined ";
                if ($ownProperties) {
                  out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                }
                out += " ) { ";
              }
            }
            out += " " + $code + " } ";
          }
        }
        if ($breakOnError) {
          out += " if (" + $nextValid + ") { ";
          $closingBraces += "}";
        }
      }
    }
  }
  if ($pPropertyKeys.length) {
    var arr4 = $pPropertyKeys;
    if (arr4) {
      var $pProperty, i4 = -1, l4 = arr4.length - 1;
      while (i4 < l4) {
        $pProperty = arr4[i4 += 1];
        var $sch = $pProperties[$pProperty];
        if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + ".patternProperties" + it.util.getProperty($pProperty);
          $it.errSchemaPath = it.errSchemaPath + "/patternProperties/" + it.util.escapeFragment($pProperty);
          if ($ownProperties) {
            out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
          } else {
            out += " for (var " + $key + " in " + $data + ") { ";
          }
          out += " if (" + it.usePattern($pProperty) + ".test(" + $key + ")) { ";
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + "[" + $key + "]";
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
          } else {
            out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
          }
          if ($breakOnError) {
            out += " if (!" + $nextValid + ") break; ";
          }
          out += " } ";
          if ($breakOnError) {
            out += " else " + $nextValid + " = true; ";
          }
          out += " }  ";
          if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += " " + $closingBraces + " if (" + $errs + " == errors) {";
  }
  return out;
};
var propertyNames = function generate_propertyNames(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $errs = "errs__" + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = "";
  $it.level++;
  var $nextValid = "valid" + $it.level;
  out += "var " + $errs + " = errors;";
  if (it.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it.util.schemaHasRules($schema2, it.RULES.all)) {
    $it.schema = $schema2;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    var $key = "key" + $lvl, $idx = "idx" + $lvl, $i = "i" + $lvl, $invalidName = "' + " + $key + " + '", $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
    if ($ownProperties) {
      out += " var " + $dataProperties + " = undefined; ";
    }
    if ($ownProperties) {
      out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
    } else {
      out += " for (var " + $key + " in " + $data + ") { ";
    }
    out += " var startErrs" + $lvl + " = errors; ";
    var $passData = $key;
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
    } else {
      out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += " if (!" + $nextValid + ") { for (var " + $i + "=startErrs" + $lvl + "; " + $i + "<errors; " + $i + "++) { vErrors[" + $i + "].propertyName = " + $key + "; }   var err =   ";
    if (it.createErrors !== false) {
      out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { propertyName: '" + $invalidName + "' } ";
      if (it.opts.messages !== false) {
        out += " , message: 'property name \\'" + $invalidName + "\\' is invalid' ";
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError(vErrors); ";
      } else {
        out += " validate.errors = vErrors; return false; ";
      }
    }
    if ($breakOnError) {
      out += " break; ";
    }
    out += " } }";
  }
  if ($breakOnError) {
    out += " " + $closingBraces + " if (" + $errs + " == errors) {";
  }
  return out;
};
var required$2 = function generate_required(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $isData = it.opts.$data && $schema2 && $schema2.$data;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
  }
  var $vSchema = "schema" + $lvl;
  if (!$isData) {
    if ($schema2.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
      var $required = [];
      var arr1 = $schema2;
      if (arr1) {
        var $property, i1 = -1, l1 = arr1.length - 1;
        while (i1 < l1) {
          $property = arr1[i1 += 1];
          var $propertySch = it.schema.properties[$property];
          if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == "object" && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) {
            $required[$required.length] = $property;
          }
        }
      }
    } else {
      var $required = $schema2;
    }
  }
  if ($isData || $required.length) {
    var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
    if ($breakOnError) {
      out += " var missing" + $lvl + "; ";
      if ($loopRequired) {
        if (!$isData) {
          out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
        }
        var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        out += " var " + $valid + " = true; ";
        if ($isData) {
          out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
        }
        out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { " + $valid + " = " + $data + "[" + $vSchema + "[" + $i + "]] !== undefined ";
        if ($ownProperties) {
          out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
        }
        out += "; if (!" + $valid + ") break; } ";
        if ($isData) {
          out += "  }  ";
        }
        out += "  if (!" + $valid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
          if (it.opts.messages !== false) {
            out += " , message: '";
            if (it.opts._errorDataPathProperty) {
              out += "is a required property";
            } else {
              out += "should have required property \\'" + $missingProperty + "\\'";
            }
            out += "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        out += " } else { ";
      } else {
        out += " if ( ";
        var arr2 = $required;
        if (arr2) {
          var $propertyKey, $i = -1, l2 = arr2.length - 1;
          while ($i < l2) {
            $propertyKey = arr2[$i += 1];
            if ($i) {
              out += " || ";
            }
            var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
            out += " ( ( " + $useData + " === undefined ";
            if ($ownProperties) {
              out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
            }
            out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
          }
        }
        out += ") {  ";
        var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.createErrors !== false) {
          out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
          if (it.opts.messages !== false) {
            out += " , message: '";
            if (it.opts._errorDataPathProperty) {
              out += "is a required property";
            } else {
              out += "should have required property \\'" + $missingProperty + "\\'";
            }
            out += "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          if (it.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        out += " } else { ";
      }
    } else {
      if ($loopRequired) {
        if (!$isData) {
          out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
        }
        var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        if ($isData) {
          out += " if (" + $vSchema + " && !Array.isArray(" + $vSchema + ")) {  var err =   ";
          if (it.createErrors !== false) {
            out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
            if (it.opts.messages !== false) {
              out += " , message: '";
              if (it.opts._errorDataPathProperty) {
                out += "is a required property";
              } else {
                out += "should have required property \\'" + $missingProperty + "\\'";
              }
              out += "' ";
            }
            if (it.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + $vSchema + " !== undefined) { ";
        }
        out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { if (" + $data + "[" + $vSchema + "[" + $i + "]] === undefined ";
        if ($ownProperties) {
          out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
        }
        out += ") {  var err =   ";
        if (it.createErrors !== false) {
          out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
          if (it.opts.messages !== false) {
            out += " , message: '";
            if (it.opts._errorDataPathProperty) {
              out += "is a required property";
            } else {
              out += "should have required property \\'" + $missingProperty + "\\'";
            }
            out += "' ";
          }
          if (it.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ";
        if ($isData) {
          out += "  }  ";
        }
      } else {
        var arr3 = $required;
        if (arr3) {
          var $propertyKey, i3 = -1, l3 = arr3.length - 1;
          while (i3 < l3) {
            $propertyKey = arr3[i3 += 1];
            var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += " if ( " + $useData + " === undefined ";
            if ($ownProperties) {
              out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
            }
            out += ") {  var err =   ";
            if (it.createErrors !== false) {
              out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
              if (it.opts.messages !== false) {
                out += " , message: '";
                if (it.opts._errorDataPathProperty) {
                  out += "is a required property";
                } else {
                  out += "should have required property \\'" + $missingProperty + "\\'";
                }
                out += "' ";
              }
              if (it.opts.verbose) {
                out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
              }
              out += " } ";
            } else {
              out += " {} ";
            }
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
        }
      }
    }
    it.errorPath = $currentErrorPath;
  } else if ($breakOnError) {
    out += " if (true) {";
  }
  return out;
};
var uniqueItems = function generate_uniqueItems(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  if (($schema2 || $isData) && it.opts.uniqueItems !== false) {
    if ($isData) {
      out += " var " + $valid + "; if (" + $schemaValue + " === false || " + $schemaValue + " === undefined) " + $valid + " = true; else if (typeof " + $schemaValue + " != 'boolean') " + $valid + " = false; else { ";
    }
    out += " var i = " + $data + ".length , " + $valid + " = true , j; if (i > 1) { ";
    var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
    if (!$itemType || $itemType == "object" || $itemType == "array" || $typeIsArray && ($itemType.indexOf("object") >= 0 || $itemType.indexOf("array") >= 0)) {
      out += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + $data + "[i], " + $data + "[j])) { " + $valid + " = false; break outer; } } } ";
    } else {
      out += " var itemIndices = {}, item; for (;i--;) { var item = " + $data + "[i]; ";
      var $method = "checkDataType" + ($typeIsArray ? "s" : "");
      out += " if (" + it.util[$method]($itemType, "item", it.opts.strictNumbers, true) + ") continue; ";
      if ($typeIsArray) {
        out += ` if (typeof item == 'string') item = '"' + item; `;
      }
      out += " if (typeof itemIndices[item] == 'number') { " + $valid + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
    }
    out += " } ";
    if ($isData) {
      out += "  }  ";
    }
    out += " if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it.createErrors !== false) {
      out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { i: i, j: j } ";
      if (it.opts.messages !== false) {
        out += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' ";
      }
      if (it.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } ";
    if ($breakOnError) {
      out += " else { ";
    }
  } else {
    if ($breakOnError) {
      out += " if (true) { ";
    }
  }
  return out;
};
var dotjs = {
  "$ref": ref,
  allOf,
  anyOf,
  "$comment": comment,
  const: _const,
  contains,
  dependencies,
  "enum": _enum,
  format,
  "if": _if,
  items,
  maximum: _limit,
  minimum: _limit,
  maxItems: _limitItems,
  minItems: _limitItems,
  maxLength: _limitLength,
  minLength: _limitLength,
  maxProperties: _limitProperties,
  minProperties: _limitProperties,
  multipleOf,
  not,
  oneOf,
  pattern,
  properties: properties$3,
  propertyNames,
  required: required$2,
  uniqueItems,
  validate: validate$1
};
var ruleModules = dotjs, toHash = util$5.toHash;
var rules$1 = function rules() {
  var RULES = [{
    type: "number",
    rules: [{
      "maximum": ["exclusiveMaximum"]
    }, {
      "minimum": ["exclusiveMinimum"]
    }, "multipleOf", "format"]
  }, {
    type: "string",
    rules: ["maxLength", "minLength", "pattern", "format"]
  }, {
    type: "array",
    rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
  }, {
    type: "object",
    rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", {
      "properties": ["additionalProperties", "patternProperties"]
    }]
  }, {
    rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"]
  }];
  var ALL = ["type", "$comment"];
  var KEYWORDS2 = ["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"];
  var TYPES = ["number", "integer", "string", "array", "object", "boolean", "null"];
  RULES.all = toHash(ALL);
  RULES.types = toHash(TYPES);
  RULES.forEach(function(group2) {
    group2.rules = group2.rules.map(function(keyword2) {
      var implKeywords;
      if (typeof keyword2 == "object") {
        var key = Object.keys(keyword2)[0];
        implKeywords = keyword2[key];
        keyword2 = key;
        implKeywords.forEach(function(k) {
          ALL.push(k);
          RULES.all[k] = true;
        });
      }
      ALL.push(keyword2);
      var rule = RULES.all[keyword2] = {
        keyword: keyword2,
        code: ruleModules[keyword2],
        implements: implKeywords
      };
      return rule;
    });
    RULES.all.$comment = {
      keyword: "$comment",
      code: ruleModules.$comment
    };
    if (group2.type)
      RULES.types[group2.type] = group2;
  });
  RULES.keywords = toHash(ALL.concat(KEYWORDS2));
  RULES.custom = {};
  return RULES;
};
var KEYWORDS = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"];
var data = function(metaSchema2, keywordsJsonPointers) {
  for (var i = 0; i < keywordsJsonPointers.length; i++) {
    metaSchema2 = JSON.parse(JSON.stringify(metaSchema2));
    var segments = keywordsJsonPointers[i].split("/");
    var keywords = metaSchema2;
    var j;
    for (j = 1; j < segments.length; j++)
      keywords = keywords[segments[j]];
    for (j = 0; j < KEYWORDS.length; j++) {
      var key = KEYWORDS[j];
      var schema2 = keywords[key];
      if (schema2) {
        keywords[key] = {
          anyOf: [schema2, {
            $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
          }]
        };
      }
    }
  }
  return metaSchema2;
};
var MissingRefError = error_classes.MissingRef;
var async = compileAsync;
function compileAsync(schema2, meta, callback) {
  var self2 = this;
  if (typeof this._opts.loadSchema != "function")
    throw new Error("options.loadSchema should be a function");
  if (typeof meta == "function") {
    callback = meta;
    meta = void 0;
  }
  var p = loadMetaSchemaOf(schema2).then(function() {
    var schemaObj = self2._addSchema(schema2, void 0, meta);
    return schemaObj.validate || _compileAsync(schemaObj);
  });
  if (callback) {
    p.then(function(v) {
      callback(null, v);
    }, callback);
  }
  return p;
  function loadMetaSchemaOf(sch) {
    var $schema2 = sch.$schema;
    return $schema2 && !self2.getSchema($schema2) ? compileAsync.call(self2, {
      $ref: $schema2
    }, true) : Promise.resolve();
  }
  function _compileAsync(schemaObj) {
    try {
      return self2._compile(schemaObj);
    } catch (e) {
      if (e instanceof MissingRefError)
        return loadMissingSchema(e);
      throw e;
    }
    function loadMissingSchema(e) {
      var ref2 = e.missingSchema;
      if (added(ref2))
        throw new Error("Schema " + ref2 + " is loaded but " + e.missingRef + " cannot be resolved");
      var schemaPromise = self2._loadingSchemas[ref2];
      if (!schemaPromise) {
        schemaPromise = self2._loadingSchemas[ref2] = self2._opts.loadSchema(ref2);
        schemaPromise.then(removePromise, removePromise);
      }
      return schemaPromise.then(function(sch) {
        if (!added(ref2)) {
          return loadMetaSchemaOf(sch).then(function() {
            if (!added(ref2))
              self2.addSchema(sch, ref2, void 0, meta);
          });
        }
      }).then(function() {
        return _compileAsync(schemaObj);
      });
      function removePromise() {
        delete self2._loadingSchemas[ref2];
      }
      function added(ref22) {
        return self2._refs[ref22] || self2._schemas[ref22];
      }
    }
  }
}
var custom = function generate_custom(it, $keyword, $ruleType) {
  var out = " ";
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema2 = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = "data" + ($dataLvl || "");
  var $valid = "valid" + $lvl;
  var $errs = "errs__" + $lvl;
  var $isData = it.opts.$data && $schema2 && $schema2.$data, $schemaValue;
  if ($isData) {
    out += " var schema" + $lvl + " = " + it.util.getData($schema2.$data, $dataLvl, it.dataPathArr) + "; ";
    $schemaValue = "schema" + $lvl;
  } else {
    $schemaValue = $schema2;
  }
  var $rule = this, $definition = "definition" + $lvl, $rDef = $rule.definition, $closingBraces = "";
  var $compile, $inline, $macro, $ruleValidate, $validateCode;
  if ($isData && $rDef.$data) {
    $validateCode = "keywordValidate" + $lvl;
    var $validateSchema = $rDef.validateSchema;
    out += " var " + $definition + " = RULES.custom['" + $keyword + "'].definition; var " + $validateCode + " = " + $definition + ".validate;";
  } else {
    $ruleValidate = it.useCustomRule($rule, $schema2, it.schema, it);
    if (!$ruleValidate)
      return;
    $schemaValue = "validate.schema" + $schemaPath;
    $validateCode = $ruleValidate.code;
    $compile = $rDef.compile;
    $inline = $rDef.inline;
    $macro = $rDef.macro;
  }
  var $ruleErrs = $validateCode + ".errors", $i = "i" + $lvl, $ruleErr = "ruleErr" + $lvl, $asyncKeyword = $rDef.async;
  if ($asyncKeyword && !it.async)
    throw new Error("async keyword in sync schema");
  if (!($inline || $macro)) {
    out += "" + $ruleErrs + " = null;";
  }
  out += "var " + $errs + " = errors;var " + $valid + ";";
  if ($isData && $rDef.$data) {
    $closingBraces += "}";
    out += " if (" + $schemaValue + " === undefined) { " + $valid + " = true; } else { ";
    if ($validateSchema) {
      $closingBraces += "}";
      out += " " + $valid + " = " + $definition + ".validateSchema(" + $schemaValue + "); if (" + $valid + ") { ";
    }
  }
  if ($inline) {
    if ($rDef.statements) {
      out += " " + $ruleValidate.validate + " ";
    } else {
      out += " " + $valid + " = " + $ruleValidate.validate + "; ";
    }
  } else if ($macro) {
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    $it.schema = $ruleValidate.validate;
    $it.schemaPath = "";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += " " + $code;
  } else {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    out += "  " + $validateCode + ".call( ";
    if (it.opts.passContext) {
      out += "this";
    } else {
      out += "self";
    }
    if ($compile || $rDef.schema === false) {
      out += " , " + $data + " ";
    } else {
      out += " , " + $schemaValue + " , " + $data + " , validate.schema" + it.schemaPath + " ";
    }
    out += " , (dataPath || '')";
    if (it.errorPath != '""') {
      out += " + " + it.errorPath;
    }
    var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
    out += " , " + $parentData + " , " + $parentDataProperty + " , rootData )  ";
    var def_callRuleValidate = out;
    out = $$outStack.pop();
    if ($rDef.errors === false) {
      out += " " + $valid + " = ";
      if ($asyncKeyword) {
        out += "await ";
      }
      out += "" + def_callRuleValidate + "; ";
    } else {
      if ($asyncKeyword) {
        $ruleErrs = "customErrors" + $lvl;
        out += " var " + $ruleErrs + " = null; try { " + $valid + " = await " + def_callRuleValidate + "; } catch (e) { " + $valid + " = false; if (e instanceof ValidationError) " + $ruleErrs + " = e.errors; else throw e; } ";
      } else {
        out += " " + $ruleErrs + " = null; " + $valid + " = " + def_callRuleValidate + "; ";
      }
    }
  }
  if ($rDef.modifying) {
    out += " if (" + $parentData + ") " + $data + " = " + $parentData + "[" + $parentDataProperty + "];";
  }
  out += "" + $closingBraces;
  if ($rDef.valid) {
    if ($breakOnError) {
      out += " if (true) { ";
    }
  } else {
    out += " if ( ";
    if ($rDef.valid === void 0) {
      out += " !";
      if ($macro) {
        out += "" + $nextValid;
      } else {
        out += "" + $valid;
      }
    } else {
      out += " " + !$rDef.valid + " ";
    }
    out += ") { ";
    $errorKeyword = $rule.keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
      if (it.opts.messages !== false) {
        out += ` , message: 'should pass "` + $rule.keyword + `" keyword validation' `;
      }
      if (it.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      if (it.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    var def_customError = out;
    out = $$outStack.pop();
    if ($inline) {
      if ($rDef.errors) {
        if ($rDef.errors != "full") {
          out += "  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
          if (it.opts.verbose) {
            out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
          }
          out += " } ";
        }
      } else {
        if ($rDef.errors === false) {
          out += " " + def_customError + " ";
        } else {
          out += " if (" + $errs + " == errors) { " + def_customError + " } else {  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
          if (it.opts.verbose) {
            out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
          }
          out += " } } ";
        }
      }
    } else if ($macro) {
      out += "   var err =   ";
      if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
        if (it.opts.messages !== false) {
          out += ` , message: 'should pass "` + $rule.keyword + `" keyword validation' `;
        }
        if (it.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      if (!it.compositeRule && $breakOnError) {
        if (it.async) {
          out += " throw new ValidationError(vErrors); ";
        } else {
          out += " validate.errors = vErrors; return false; ";
        }
      }
    } else {
      if ($rDef.errors === false) {
        out += " " + def_customError + " ";
      } else {
        out += " if (Array.isArray(" + $ruleErrs + ")) { if (vErrors === null) vErrors = " + $ruleErrs + "; else vErrors = vErrors.concat(" + $ruleErrs + "); errors = vErrors.length;  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + ";  " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
        if (it.opts.verbose) {
          out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
        }
        out += " } } else { " + def_customError + " } ";
      }
    }
    out += " } ";
    if ($breakOnError) {
      out += " else { ";
    }
  }
  return out;
};
const $schema$2 = "http://json-schema.org/draft-07/schema#";
const $id$2 = "http://json-schema.org/draft-07/schema#";
const title$2 = "Core schema meta-schema";
const definitions$1 = {
  schemaArray: {
    type: "array",
    minItems: 1,
    items: {
      $ref: "#"
    }
  },
  nonNegativeInteger: {
    type: "integer",
    minimum: 0
  },
  nonNegativeIntegerDefault0: {
    allOf: [
      {
        $ref: "#/definitions/nonNegativeInteger"
      },
      {
        "default": 0
      }
    ]
  },
  simpleTypes: {
    "enum": [
      "array",
      "boolean",
      "integer",
      "null",
      "number",
      "object",
      "string"
    ]
  },
  stringArray: {
    type: "array",
    items: {
      type: "string"
    },
    uniqueItems: true,
    "default": []
  }
};
const type$2 = [
  "object",
  "boolean"
];
const properties$2 = {
  $id: {
    type: "string",
    format: "uri-reference"
  },
  $schema: {
    type: "string",
    format: "uri"
  },
  $ref: {
    type: "string",
    format: "uri-reference"
  },
  $comment: {
    type: "string"
  },
  title: {
    type: "string"
  },
  description: {
    type: "string"
  },
  "default": true,
  readOnly: {
    type: "boolean",
    "default": false
  },
  examples: {
    type: "array",
    items: true
  },
  multipleOf: {
    type: "number",
    exclusiveMinimum: 0
  },
  maximum: {
    type: "number"
  },
  exclusiveMaximum: {
    type: "number"
  },
  minimum: {
    type: "number"
  },
  exclusiveMinimum: {
    type: "number"
  },
  maxLength: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minLength: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  pattern: {
    type: "string",
    format: "regex"
  },
  additionalItems: {
    $ref: "#"
  },
  items: {
    anyOf: [
      {
        $ref: "#"
      },
      {
        $ref: "#/definitions/schemaArray"
      }
    ],
    "default": true
  },
  maxItems: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minItems: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  uniqueItems: {
    type: "boolean",
    "default": false
  },
  contains: {
    $ref: "#"
  },
  maxProperties: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minProperties: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  required: {
    $ref: "#/definitions/stringArray"
  },
  additionalProperties: {
    $ref: "#"
  },
  definitions: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    "default": {}
  },
  properties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    "default": {}
  },
  patternProperties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    propertyNames: {
      format: "regex"
    },
    "default": {}
  },
  dependencies: {
    type: "object",
    additionalProperties: {
      anyOf: [
        {
          $ref: "#"
        },
        {
          $ref: "#/definitions/stringArray"
        }
      ]
    }
  },
  propertyNames: {
    $ref: "#"
  },
  "const": true,
  "enum": {
    type: "array",
    items: true,
    minItems: 1,
    uniqueItems: true
  },
  type: {
    anyOf: [
      {
        $ref: "#/definitions/simpleTypes"
      },
      {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: true
      }
    ]
  },
  format: {
    type: "string"
  },
  contentMediaType: {
    type: "string"
  },
  contentEncoding: {
    type: "string"
  },
  "if": {
    $ref: "#"
  },
  then: {
    $ref: "#"
  },
  "else": {
    $ref: "#"
  },
  allOf: {
    $ref: "#/definitions/schemaArray"
  },
  anyOf: {
    $ref: "#/definitions/schemaArray"
  },
  oneOf: {
    $ref: "#/definitions/schemaArray"
  },
  not: {
    $ref: "#"
  }
};
const require$$13 = {
  $schema: $schema$2,
  $id: $id$2,
  title: title$2,
  definitions: definitions$1,
  type: type$2,
  properties: properties$2,
  "default": true
};
var metaSchema = require$$13;
var definition_schema = {
  $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
  definitions: {
    simpleTypes: metaSchema.definitions.simpleTypes
  },
  type: "object",
  dependencies: {
    schema: ["validate"],
    $data: ["validate"],
    statements: ["inline"],
    valid: {
      not: {
        required: ["macro"]
      }
    }
  },
  properties: {
    type: metaSchema.properties.type,
    schema: {
      type: "boolean"
    },
    statements: {
      type: "boolean"
    },
    dependencies: {
      type: "array",
      items: {
        type: "string"
      }
    },
    metaSchema: {
      type: "object"
    },
    modifying: {
      type: "boolean"
    },
    valid: {
      type: "boolean"
    },
    $data: {
      type: "boolean"
    },
    async: {
      type: "boolean"
    },
    errors: {
      anyOf: [{
        type: "boolean"
      }, {
        const: "full"
      }]
    }
  }
};
var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = custom;
var definitionSchema = definition_schema;
var keyword = {
  add: addKeyword,
  get: getKeyword,
  remove: removeKeyword,
  validate: validateKeyword
};
function addKeyword(keyword2, definition) {
  var RULES = this.RULES;
  if (RULES.keywords[keyword2])
    throw new Error("Keyword " + keyword2 + " is already defined");
  if (!IDENTIFIER.test(keyword2))
    throw new Error("Keyword " + keyword2 + " is not a valid identifier");
  if (definition) {
    this.validateKeyword(definition, true);
    var dataType = definition.type;
    if (Array.isArray(dataType)) {
      for (var i = 0; i < dataType.length; i++)
        _addRule(keyword2, dataType[i], definition);
    } else {
      _addRule(keyword2, dataType, definition);
    }
    var metaSchema2 = definition.metaSchema;
    if (metaSchema2) {
      if (definition.$data && this._opts.$data) {
        metaSchema2 = {
          anyOf: [metaSchema2, {
            "$ref": "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
          }]
        };
      }
      definition.validateSchema = this.compile(metaSchema2, true);
    }
  }
  RULES.keywords[keyword2] = RULES.all[keyword2] = true;
  function _addRule(keyword3, dataType2, definition2) {
    var ruleGroup;
    for (var i2 = 0; i2 < RULES.length; i2++) {
      var rg = RULES[i2];
      if (rg.type == dataType2) {
        ruleGroup = rg;
        break;
      }
    }
    if (!ruleGroup) {
      ruleGroup = {
        type: dataType2,
        rules: []
      };
      RULES.push(ruleGroup);
    }
    var rule = {
      keyword: keyword3,
      definition: definition2,
      custom: true,
      code: customRuleCode,
      implements: definition2.implements
    };
    ruleGroup.rules.push(rule);
    RULES.custom[keyword3] = rule;
  }
  return this;
}
function getKeyword(keyword2) {
  var rule = this.RULES.custom[keyword2];
  return rule ? rule.definition : this.RULES.keywords[keyword2] || false;
}
function removeKeyword(keyword2) {
  var RULES = this.RULES;
  delete RULES.keywords[keyword2];
  delete RULES.all[keyword2];
  delete RULES.custom[keyword2];
  for (var i = 0; i < RULES.length; i++) {
    var rules3 = RULES[i].rules;
    for (var j = 0; j < rules3.length; j++) {
      if (rules3[j].keyword == keyword2) {
        rules3.splice(j, 1);
        break;
      }
    }
  }
  return this;
}
function validateKeyword(definition, throwError) {
  validateKeyword.errors = null;
  var v = this._validateKeyword = this._validateKeyword || this.compile(definitionSchema, true);
  if (v(definition))
    return true;
  validateKeyword.errors = v.errors;
  if (throwError)
    throw new Error("custom keyword definition is invalid: " + this.errorsText(v.errors));
  else
    return false;
}
const $schema$1 = "http://json-schema.org/draft-07/schema#";
const $id$1 = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#";
const description = "Meta-schema for $data reference (JSON Schema extension proposal)";
const type$1 = "object";
const required$1 = [
  "$data"
];
const properties$1 = {
  $data: {
    type: "string",
    anyOf: [
      {
        format: "relative-json-pointer"
      },
      {
        format: "json-pointer"
      }
    ]
  }
};
const additionalProperties$1 = false;
const require$$12 = {
  $schema: $schema$1,
  $id: $id$1,
  description,
  type: type$1,
  required: required$1,
  properties: properties$1,
  additionalProperties: additionalProperties$1
};
var compileSchema = compile_1, resolve = resolve_1, Cache2 = cacheExports, SchemaObject = schema_obj, stableStringify = fastJsonStableStringify, formats = formats_1, rules2 = rules$1, $dataMetaSchema = data, util = util$5;
var ajv = Ajv;
Ajv.prototype.validate = validate;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;
Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;
Ajv.prototype.compileAsync = async;
var customKeyword = keyword;
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;
Ajv.prototype.validateKeyword = customKeyword.validate;
var errorClasses = error_classes;
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
var META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"];
var META_SUPPORT_DATA = ["/properties"];
function Ajv(opts) {
  if (!(this instanceof Ajv))
    return new Ajv(opts);
  opts = this._opts = util.copy(opts) || {};
  setLogger(this);
  this._schemas = {};
  this._refs = {};
  this._fragments = {};
  this._formats = formats(opts.format);
  this._cache = opts.cache || new Cache2();
  this._loadingSchemas = {};
  this._compilations = [];
  this.RULES = rules2();
  this._getId = chooseGetId(opts);
  opts.loopRequired = opts.loopRequired || Infinity;
  if (opts.errorDataPath == "property")
    opts._errorDataPathProperty = true;
  if (opts.serialize === void 0)
    opts.serialize = stableStringify;
  this._metaOpts = getMetaSchemaOptions(this);
  if (opts.formats)
    addInitialFormats(this);
  if (opts.keywords)
    addInitialKeywords(this);
  addDefaultMetaSchema(this);
  if (typeof opts.meta == "object")
    this.addMetaSchema(opts.meta);
  if (opts.nullable)
    this.addKeyword("nullable", {
      metaSchema: {
        type: "boolean"
      }
    });
  addInitialSchemas(this);
}
function validate(schemaKeyRef, data2) {
  var v;
  if (typeof schemaKeyRef == "string") {
    v = this.getSchema(schemaKeyRef);
    if (!v)
      throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
  } else {
    var schemaObj = this._addSchema(schemaKeyRef);
    v = schemaObj.validate || this._compile(schemaObj);
  }
  var valid = v(data2);
  if (v.$async !== true)
    this.errors = v.errors;
  return valid;
}
function compile(schema2, _meta) {
  var schemaObj = this._addSchema(schema2, void 0, _meta);
  return schemaObj.validate || this._compile(schemaObj);
}
function addSchema(schema2, key, _skipValidation, _meta) {
  if (Array.isArray(schema2)) {
    for (var i = 0; i < schema2.length; i++)
      this.addSchema(schema2[i], void 0, _skipValidation, _meta);
    return this;
  }
  var id2 = this._getId(schema2);
  if (id2 !== void 0 && typeof id2 != "string")
    throw new Error("schema id must be string");
  key = resolve.normalizeId(key || id2);
  checkUnique(this, key);
  this._schemas[key] = this._addSchema(schema2, _skipValidation, _meta, true);
  return this;
}
function addMetaSchema(schema2, key, skipValidation) {
  this.addSchema(schema2, key, skipValidation, true);
  return this;
}
function validateSchema(schema2, throwOrLogError) {
  var $schema2 = schema2.$schema;
  if ($schema2 !== void 0 && typeof $schema2 != "string")
    throw new Error("$schema must be a string");
  $schema2 = $schema2 || this._opts.defaultMeta || defaultMeta(this);
  if (!$schema2) {
    this.logger.warn("meta-schema not available");
    this.errors = null;
    return true;
  }
  var valid = this.validate($schema2, schema2);
  if (!valid && throwOrLogError) {
    var message = "schema is invalid: " + this.errorsText();
    if (this._opts.validateSchema == "log")
      this.logger.error(message);
    else
      throw new Error(message);
  }
  return valid;
}
function defaultMeta(self2) {
  var meta = self2._opts.meta;
  self2._opts.defaultMeta = typeof meta == "object" ? self2._getId(meta) || meta : self2.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : void 0;
  return self2._opts.defaultMeta;
}
function getSchema(keyRef) {
  var schemaObj = _getSchemaObj(this, keyRef);
  switch (typeof schemaObj) {
    case "object":
      return schemaObj.validate || this._compile(schemaObj);
    case "string":
      return this.getSchema(schemaObj);
    case "undefined":
      return _getSchemaFragment(this, keyRef);
  }
}
function _getSchemaFragment(self2, ref2) {
  var res = resolve.schema.call(self2, {
    schema: {}
  }, ref2);
  if (res) {
    var schema2 = res.schema, root2 = res.root, baseId = res.baseId;
    var v = compileSchema.call(self2, schema2, root2, void 0, baseId);
    self2._fragments[ref2] = new SchemaObject({
      ref: ref2,
      fragment: true,
      schema: schema2,
      root: root2,
      baseId,
      validate: v
    });
    return v;
  }
}
function _getSchemaObj(self2, keyRef) {
  keyRef = resolve.normalizeId(keyRef);
  return self2._schemas[keyRef] || self2._refs[keyRef] || self2._fragments[keyRef];
}
function removeSchema(schemaKeyRef) {
  if (schemaKeyRef instanceof RegExp) {
    _removeAllSchemas(this, this._schemas, schemaKeyRef);
    _removeAllSchemas(this, this._refs, schemaKeyRef);
    return this;
  }
  switch (typeof schemaKeyRef) {
    case "undefined":
      _removeAllSchemas(this, this._schemas);
      _removeAllSchemas(this, this._refs);
      this._cache.clear();
      return this;
    case "string":
      var schemaObj = _getSchemaObj(this, schemaKeyRef);
      if (schemaObj)
        this._cache.del(schemaObj.cacheKey);
      delete this._schemas[schemaKeyRef];
      delete this._refs[schemaKeyRef];
      return this;
    case "object":
      var serialize2 = this._opts.serialize;
      var cacheKey = serialize2 ? serialize2(schemaKeyRef) : schemaKeyRef;
      this._cache.del(cacheKey);
      var id2 = this._getId(schemaKeyRef);
      if (id2) {
        id2 = resolve.normalizeId(id2);
        delete this._schemas[id2];
        delete this._refs[id2];
      }
  }
  return this;
}
function _removeAllSchemas(self2, schemas, regex2) {
  for (var keyRef in schemas) {
    var schemaObj = schemas[keyRef];
    if (!schemaObj.meta && (!regex2 || regex2.test(keyRef))) {
      self2._cache.del(schemaObj.cacheKey);
      delete schemas[keyRef];
    }
  }
}
function _addSchema(schema2, skipValidation, meta, shouldAddSchema) {
  if (typeof schema2 != "object" && typeof schema2 != "boolean")
    throw new Error("schema should be object or boolean");
  var serialize2 = this._opts.serialize;
  var cacheKey = serialize2 ? serialize2(schema2) : schema2;
  var cached = this._cache.get(cacheKey);
  if (cached)
    return cached;
  shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
  var id2 = resolve.normalizeId(this._getId(schema2));
  if (id2 && shouldAddSchema)
    checkUnique(this, id2);
  var willValidate = this._opts.validateSchema !== false && !skipValidation;
  var recursiveMeta;
  if (willValidate && !(recursiveMeta = id2 && id2 == resolve.normalizeId(schema2.$schema)))
    this.validateSchema(schema2, true);
  var localRefs = resolve.ids.call(this, schema2);
  var schemaObj = new SchemaObject({
    id: id2,
    schema: schema2,
    localRefs,
    cacheKey,
    meta
  });
  if (id2[0] != "#" && shouldAddSchema)
    this._refs[id2] = schemaObj;
  this._cache.put(cacheKey, schemaObj);
  if (willValidate && recursiveMeta)
    this.validateSchema(schema2, true);
  return schemaObj;
}
function _compile(schemaObj, root2) {
  if (schemaObj.compiling) {
    schemaObj.validate = callValidate;
    callValidate.schema = schemaObj.schema;
    callValidate.errors = null;
    callValidate.root = root2 ? root2 : callValidate;
    if (schemaObj.schema.$async === true)
      callValidate.$async = true;
    return callValidate;
  }
  schemaObj.compiling = true;
  var currentOpts;
  if (schemaObj.meta) {
    currentOpts = this._opts;
    this._opts = this._metaOpts;
  }
  var v;
  try {
    v = compileSchema.call(this, schemaObj.schema, root2, schemaObj.localRefs);
  } catch (e) {
    delete schemaObj.validate;
    throw e;
  } finally {
    schemaObj.compiling = false;
    if (schemaObj.meta)
      this._opts = currentOpts;
  }
  schemaObj.validate = v;
  schemaObj.refs = v.refs;
  schemaObj.refVal = v.refVal;
  schemaObj.root = v.root;
  return v;
  function callValidate() {
    var _validate = schemaObj.validate;
    var result = _validate.apply(this, arguments);
    callValidate.errors = _validate.errors;
    return result;
  }
}
function chooseGetId(opts) {
  switch (opts.schemaId) {
    case "auto":
      return _get$IdOrId;
    case "id":
      return _getId;
    default:
      return _get$Id;
  }
}
function _getId(schema2) {
  if (schema2.$id)
    this.logger.warn("schema $id ignored", schema2.$id);
  return schema2.id;
}
function _get$Id(schema2) {
  if (schema2.id)
    this.logger.warn("schema id ignored", schema2.id);
  return schema2.$id;
}
function _get$IdOrId(schema2) {
  if (schema2.$id && schema2.id && schema2.$id != schema2.id)
    throw new Error("schema $id is different from id");
  return schema2.$id || schema2.id;
}
function errorsText(errors, options2) {
  errors = errors || this.errors;
  if (!errors)
    return "No errors";
  options2 = options2 || {};
  var separator = options2.separator === void 0 ? ", " : options2.separator;
  var dataVar = options2.dataVar === void 0 ? "data" : options2.dataVar;
  var text2 = "";
  for (var i = 0; i < errors.length; i++) {
    var e = errors[i];
    if (e)
      text2 += dataVar + e.dataPath + " " + e.message + separator;
  }
  return text2.slice(0, -separator.length);
}
function addFormat(name, format2) {
  if (typeof format2 == "string")
    format2 = new RegExp(format2);
  this._formats[name] = format2;
  return this;
}
function addDefaultMetaSchema(self2) {
  var $dataSchema;
  if (self2._opts.$data) {
    $dataSchema = require$$12;
    self2.addMetaSchema($dataSchema, $dataSchema.$id, true);
  }
  if (self2._opts.meta === false)
    return;
  var metaSchema2 = require$$13;
  if (self2._opts.$data)
    metaSchema2 = $dataMetaSchema(metaSchema2, META_SUPPORT_DATA);
  self2.addMetaSchema(metaSchema2, META_SCHEMA_ID, true);
  self2._refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
}
function addInitialSchemas(self2) {
  var optsSchemas = self2._opts.schemas;
  if (!optsSchemas)
    return;
  if (Array.isArray(optsSchemas))
    self2.addSchema(optsSchemas);
  else
    for (var key in optsSchemas)
      self2.addSchema(optsSchemas[key], key);
}
function addInitialFormats(self2) {
  for (var name in self2._opts.formats) {
    var format2 = self2._opts.formats[name];
    self2.addFormat(name, format2);
  }
}
function addInitialKeywords(self2) {
  for (var name in self2._opts.keywords) {
    var keyword2 = self2._opts.keywords[name];
    self2.addKeyword(name, keyword2);
  }
}
function checkUnique(self2, id2) {
  if (self2._schemas[id2] || self2._refs[id2])
    throw new Error('schema with key or id "' + id2 + '" already exists');
}
function getMetaSchemaOptions(self2) {
  var metaOpts = util.copy(self2._opts);
  for (var i = 0; i < META_IGNORE_OPTIONS.length; i++)
    delete metaOpts[META_IGNORE_OPTIONS[i]];
  return metaOpts;
}
function setLogger(self2) {
  var logger = self2._opts.logger;
  if (logger === false) {
    self2.logger = {
      log: noop,
      warn: noop,
      error: noop
    };
  } else {
    if (logger === void 0)
      logger = console;
    if (!(typeof logger == "object" && logger.log && logger.warn && logger.error))
      throw new Error("logger must implement log, warn and error methods");
    self2.logger = logger;
  }
}
function noop() {
}
const Ajv$1 = /* @__PURE__ */ getDefaultExportFromCjs(ajv);
const $schema = "http://json-schema.org/draft-07/schema#";
const $id = "https://higlass.io/#viewconf";
const title$1 = "HiGlass viewconf";
const type2 = "object";
const additionalProperties = false;
const required2 = [];
const properties = {
  editable: {
    type: "boolean",
    "default": true
  },
  viewEditable: {
    type: "boolean",
    "default": true
  },
  tracksEditable: {
    type: "boolean",
    "default": true
  },
  zoomFixed: {
    type: "boolean"
  },
  compactLayout: {
    type: "boolean"
  },
  exportViewUrl: {
    type: "string"
  },
  trackSourceServers: {
    type: "array",
    items: {
      type: "string"
    },
    minLength: 1
  },
  zoomLocks: {
    $ref: "#/definitions/locks/zoomLocks"
  },
  locationLocks: {
    $ref: "#/definitions/locks/locationLocks"
  },
  valueScaleLocks: {
    $ref: "#/definitions/locks/valueScaleLocks"
  },
  views: {
    type: "array",
    items: {
      $ref: "#/definitions/view"
    },
    minLength: 1
  },
  chromInfoPath: {
    type: "string"
  }
};
const definitions = {
  data: {
    type: "object",
    properties: {
      url: {
        type: "string"
      },
      server: {
        type: "string"
      },
      filetype: {
        type: "string"
      },
      type: {
        type: "string"
      },
      tilesetInfo: {
        type: "object"
      },
      children: {
        type: "array"
      },
      tiles: {
        type: "object"
      }
    }
  },
  locks: {
    slug: {
      type: "string"
    },
    locksByViewUid: {
      type: "object",
      additionalProperties: false,
      patternProperties: {
        ".": {
          $ref: "#/definitions/locks/slug"
        }
      }
    },
    axisSpecificLocks: {
      additionalProperties: false,
      properties: {
        axis: {
          "enum": [
            "x",
            "y"
          ],
          type: "string"
        },
        lock: {
          type: "string"
        }
      },
      required: [
        "lock",
        "axis"
      ],
      type: "object"
    },
    locationLocksByViewUid: {
      type: "object",
      additionalProperties: false,
      patternProperties: {
        ".": {
          anyOf: [
            {
              type: "string"
            },
            {
              additionalProperties: false,
              properties: {
                x: {
                  $ref: "#/definitions/locks/axisSpecificLocks"
                },
                y: {
                  $ref: "#/definitions/locks/axisSpecificLocks"
                }
              },
              type: "object"
            }
          ]
        }
      }
    },
    zoomLocks: {
      type: "object",
      additionalProperties: false,
      required: [],
      properties: {
        locksByViewUid: {
          $ref: "#/definitions/locks/locksByViewUid"
        },
        locksDict: {
          type: "object",
          additionalProperties: false,
          patternProperties: {
            ".": {
              type: "object",
              additionalProperties: false,
              properties: {
                uid: {
                  $ref: "#/definitions/locks/slug"
                }
              },
              patternProperties: {
                "^(?!uid).": {
                  type: "array",
                  minLength: 3,
                  maxLength: 3,
                  items: {
                    type: "number"
                  }
                }
              }
            }
          }
        }
      }
    },
    locationLocks: {
      type: "object",
      additionalProperties: false,
      required: [],
      properties: {
        locksByViewUid: {
          $ref: "#/definitions/locks/locationLocksByViewUid"
        },
        locksDict: {
          type: "object",
          additionalProperties: false,
          patternProperties: {
            ".": {
              type: "object",
              additionalProperties: false,
              properties: {
                uid: {
                  $ref: "#/definitions/locks/slug"
                }
              },
              patternProperties: {
                "^(?!uid).": {
                  type: "array",
                  minLength: 3,
                  maxLength: 3,
                  items: {
                    type: "number"
                  }
                }
              }
            }
          }
        }
      }
    },
    valueScaleLocks: {
      type: "object",
      additionalProperties: false,
      required: [
        "locksByViewUid",
        "locksDict"
      ],
      properties: {
        locksByViewUid: {
          $ref: "#/definitions/locks/locksByViewUid"
        },
        locksDict: {
          type: "object",
          additionalProperties: false,
          patternProperties: {
            ".": {
              type: "object",
              additionalProperties: false,
              properties: {
                uid: {
                  $ref: "#/definitions/locks/slug"
                },
                ignoreOffScreenValues: {
                  type: "boolean"
                }
              },
              patternProperties: {
                "^(?!(uid|ignoreOffScreenValues)).": {
                  type: "object",
                  additionalProperties: false,
                  required: [
                    "view",
                    "track"
                  ],
                  properties: {
                    view: {
                      type: "string"
                    },
                    track: {
                      $ref: "#/definitions/locks/slug"
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  view: {
    type: "object",
    additionalProperties: false,
    required: [
      "tracks",
      "layout"
    ],
    properties: {
      autocompleteSource: {
        type: "string"
      },
      chromInfoPath: {
        type: "string"
      },
      genomePositionSearchBox: {
        $ref: "#/definitions/viewProperties/genomePositionSearchBox"
      },
      genomePositionSearchBoxVisible: {
        type: "boolean"
      },
      initialXDomain: {
        $ref: "#/definitions/viewProperties/domain"
      },
      initialYDomain: {
        $ref: "#/definitions/viewProperties/domain"
      },
      layout: {
        $ref: "#/definitions/viewProperties/layout"
      },
      overlays: {
        type: "array",
        items: {
          $ref: "#/definitions/viewProperties/overlay"
        }
      },
      selectionView: {
        type: "boolean"
      },
      tracks: {
        $ref: "#/definitions/viewProperties/tracks_object"
      },
      uid: {
        type: "string"
      },
      zoomFixed: {
        type: "boolean"
      },
      zoomLimits: {
        type: "array",
        minLength: 2,
        maxLength: 2,
        "default": [
          1,
          null
        ]
      }
    }
  },
  viewProperties: {
    genomePositionSearchBox: {
      type: "object",
      title: "The Genome Position Search Box Schema",
      required: [
        "chromInfoServer",
        "chromInfoId"
      ],
      properties: {
        autocompleteServer: {
          type: "string",
          title: "The Autocomplete Server URL",
          "default": "",
          examples: [
            "//higlass.io/api/v1"
          ],
          pattern: "^(.*)$"
        },
        autocompleteId: {
          type: "string",
          title: "The Autocomplete ID",
          "default": "",
          examples: [
            "OHJakQICQD6gTD7skx4EWA"
          ],
          pattern: "^(.*)$"
        },
        chromInfoServer: {
          type: "string",
          title: "The Chrominfo Server URL",
          "default": "",
          examples: [
            "//higlass.io/api/v1"
          ],
          pattern: "^(.*)$"
        },
        chromInfoId: {
          type: "string",
          title: "The Chromosome Info ID",
          "default": "",
          examples: [
            "hg19"
          ],
          pattern: "^(.*)$"
        },
        visible: {
          type: "boolean",
          title: "The Visible Schema",
          "default": false
        }
      }
    },
    overlay: {
      type: "object",
      additionalProperties: false,
      properties: {
        chromInfoPath: {
          type: "string"
        },
        includes: {
          type: "array"
        },
        options: {
          type: "object",
          properties: {
            extent: {
              type: "array"
            },
            minWidth: {
              type: "number"
            },
            fill: {
              type: "string"
            },
            fillOpacity: {
              type: "number"
            },
            stroke: {
              type: "string"
            },
            strokeOpacity: {
              type: "number"
            },
            strokeWidth: {
              type: "number"
            },
            strokePos: {
              type: [
                "string",
                "array"
              ]
            },
            outline: {
              type: "string"
            },
            outlineOpacity: {
              type: "number"
            },
            outlineWidth: {
              type: "number"
            },
            outlinePos: {
              type: [
                "string",
                "array"
              ]
            }
          }
        },
        type: {
          type: "string"
        },
        uid: {
          type: "string"
        }
      }
    },
    layout: {
      type: "object",
      additionalProperties: false,
      required: [
        "w",
        "h",
        "x",
        "y"
      ],
      properties: {
        x: {
          type: "integer",
          title: "The X Position",
          "default": 0
        },
        y: {
          type: "integer",
          title: "The Y Position",
          "default": 0
        },
        w: {
          type: "integer",
          title: "Width",
          "default": 12
        },
        h: {
          type: "integer",
          title: "Height",
          "default": 12
        },
        moved: {
          type: "boolean"
        },
        "static": {
          type: "boolean"
        }
      }
    },
    tracks_object: {
      type: "object",
      additionalProperties: false,
      properties: {
        left: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        right: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        top: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        bottom: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        center: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        whole: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        gallery: {
          $ref: "#/definitions/viewProperties/tracks_array"
        }
      }
    },
    tracks_array: {
      type: "array",
      items: {
        oneOf: [
          {
            $ref: "#/definitions/tracks/enum_track"
          },
          {
            $ref: "#/definitions/tracks/combined_track"
          },
          {
            $ref: "#/definitions/tracks/heatmap_track"
          },
          {
            $ref: "#/definitions/tracks/independent_viewport_projection_track"
          }
        ]
      }
    },
    domain: {
      type: "array",
      items: {
        type: "number"
      },
      maxItems: 2,
      minItems: 2
    }
  },
  tracks: {
    heatmap_track: {
      type: "object",
      additionalProperties: false,
      required: [],
      properties: {
        uid: {
          type: "string"
        },
        type: {
          "const": "heatmap"
        },
        data: {
          $ref: "#/definitions/data"
        },
        height: {
          type: "number"
        },
        options: {
          type: "object"
        },
        position: {
          type: "string"
        },
        server: {
          type: "string"
        },
        tilesetUid: {
          type: "string"
        },
        width: {
          type: "number"
        },
        transforms: {
          type: "array"
        }
      }
    },
    combined_track: {
      type: "object",
      additionalProperties: false,
      required: [
        "contents"
      ],
      properties: {
        contents: {
          $ref: "#/definitions/viewProperties/tracks_array"
        },
        height: {
          type: "number"
        },
        options: {},
        position: {
          type: "string"
        },
        type: {
          "const": "combined"
        },
        uid: {
          type: "string"
        },
        width: {
          type: "number"
        }
      }
    },
    enum_track: {
      type: "object",
      additionalProperties: false,
      required: [
        "type"
      ],
      properties: {
        server: {
          type: "string"
        },
        tilesetUid: {
          type: "string"
        },
        data: {
          $ref: "#/definitions/data"
        },
        uid: {
          type: "string"
        },
        type: {
          "enum": [
            "multivec",
            "1d-heatmap",
            "line",
            "point",
            "bar",
            "divergent-bar",
            "stacked-interval",
            "gene-annotations",
            "linear-2d-rectangle-domains",
            "chromosome-labels",
            "linear-heatmap",
            "1d-value-interval",
            "2d-annotations",
            "2d-chromosome-annotations",
            "2d-chromosome-grid",
            "2d-chromosome-labels",
            "2d-rectangle-domains",
            "2d-tiles",
            "arrowhead-domains",
            "bedlike",
            "cross-rule",
            "dummy",
            "horizontal-1d-annotations",
            "horizontal-1d-heatmap",
            "horizontal-1d-tiles",
            "horizontal-1d-value-interval",
            "horizontal-2d-rectangle-domains",
            "horizontal-bar",
            "horizontal-chromosome-grid",
            "horizontal-chromosome-labels",
            "horizontal-divergent-bar",
            "horizontal-gene-annotations",
            "horizontal-heatmap",
            "horizontal-line",
            "horizontal-multivec",
            "horizontal-point",
            "horizontal-rule",
            "horizontal-vector-heatmap",
            "image-tiles",
            "left-axis",
            "left-stacked-interval",
            "mapbox-tiles",
            "osm-2d-tile-ids",
            "osm-tiles",
            "raster-tiles",
            "simple-svg",
            "square-markers",
            "top-axis",
            "top-stacked-interval",
            "vertical-1d-annotations",
            "vertical-1d-heatmap",
            "vertical-1d-tiles",
            "vertical-1d-value-interval",
            "vertical-2d-rectangle-domains",
            "vertical-bar",
            "vertical-bedlike",
            "vertical-chromosome-grid",
            "vertical-chromosome-labels",
            "vertical-gene-annotations",
            "vertical-heatmap",
            "vertical-line",
            "vertical-multivec",
            "vertical-point",
            "vertical-rule",
            "vertical-vector-heatmap",
            "viewport-projection-center",
            "viewport-projection-horizontal",
            "viewport-projection-vertical"
          ]
        },
        chromInfoPath: {
          type: "string"
        },
        fromViewUid: {
          type: "string"
        },
        height: {
          type: "number"
        },
        options: {
          type: "object"
        },
        width: {
          type: "number"
        },
        x: {
          type: "number"
        },
        y: {
          type: "number"
        }
      }
    },
    independent_viewport_projection_track: {
      type: "object",
      additionalProperties: false,
      properties: {
        uid: {
          type: "string"
        },
        type: {
          "enum": [
            "viewport-projection-horizontal",
            "viewport-projection-vertical",
            "viewport-projection-center"
          ]
        },
        fromViewUid: {
          type: "null"
        },
        projectionXDomain: {
          $ref: "#/definitions/viewProperties/domain"
        },
        projectionYDomain: {
          $ref: "#/definitions/viewProperties/domain"
        },
        options: {
          type: "object"
        },
        transforms: {
          type: "array"
        },
        width: {
          type: "number"
        },
        x: {
          type: "number"
        },
        y: {
          type: "number"
        }
      }
    }
  }
};
const schema = {
  $schema,
  $id,
  title: title$1,
  type: type2,
  additionalProperties,
  required: required2,
  properties,
  definitions
};
const title = "_title_1hlm6_70";
const Warning = "_Warning_1hlm6_76";
const Success = "_Success_1hlm6_79";
const classes = {
  "view-config-editor-header": "_view-config-editor-header_1hlm6_1",
  "view-config-editor": "_view-config-editor_1hlm6_1",
  "view-config-log": "_view-config-log_1hlm6_34",
  "view-config-log-header": "_view-config-log-header_1hlm6_46",
  "view-config-log-msg": "_view-config-log-msg_1hlm6_60",
  title,
  Warning,
  Success,
  "Error": "_Error_1hlm6_82"
};
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$2(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$2(o, p);
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}
function _possibleConstructorReturn$2(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self2);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$2(o);
}
let ViewConfigEditor = /* @__PURE__ */ function(_React$Component) {
  _inherits$2(ViewConfigEditor2, _React$Component);
  var _super = _createSuper$2(ViewConfigEditor2);
  function ViewConfigEditor2(props) {
    var _this;
    _classCallCheck$2(this, ViewConfigEditor2);
    _this = _super.call(this, props);
    _this.state = {
      code: props.viewConfig,
      hide: false,
      showLog: false,
      logMsgs: _this.getLogMsgs(props.viewConfig)
    };
    _this.handleChangeBound = _this.handleChange.bind(_assertThisInitialized$2(_this));
    _this.handleKeyDownBound = _this.handleKeyDown.bind(_assertThisInitialized$2(_this));
    _this.handleKeyUpBound = _this.handleKeyUp.bind(_assertThisInitialized$2(_this));
    _this.handleSubmitBound = _this.handleSubmit.bind(_assertThisInitialized$2(_this));
    _this.hideBound = _this.hide.bind(_assertThisInitialized$2(_this));
    _this.showBound = _this.show.bind(_assertThisInitialized$2(_this));
    _this.toggleLogBound = _this.toggleLog.bind(_assertThisInitialized$2(_this));
    _this.pubSubs = [];
    _this.pubSubs.push(_this.props.pubSub.subscribe("keydown", _this.handleKeyDownBound));
    _this.pubSubs.push(_this.props.pubSub.subscribe("keyup", _this.handleKeyUpBound));
    return _this;
  }
  _createClass$2(ViewConfigEditor2, [{
    key: "componentDidMount",
    value: async function componentDidMount() {
      if (this.editor) {
        this.editor._input.focus();
        this.editor._input.setSelectionRange(0, 0);
        await timeout$2(0);
        if (this.editorWrap) {
          this.editorWrap.scrollTop = 0;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
    }
  }, {
    key: "handleChange",
    value: function handleChange(code2) {
      const logMsgs = this.getLogMsgs(code2);
      this.setState({
        code: code2,
        logMsgs
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === "s" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        this.props.onChange(this.state.code);
      }
      if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        this.props.onChange(this.state.code);
        this.props.modal.close();
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      this.setState({
        hide: false
      });
      if (event.key === "Escape") {
        event.preventDefault();
        this.props.modal.close();
        this.props.onCancel();
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      if (event)
        event.preventDefault();
      this.props.onSave(this.state.code);
    }
  }, {
    key: "getLogMsgs",
    value: function getLogMsgs(code2) {
      const logMsgs = [];
      let viewConfig;
      try {
        viewConfig = JSON.parse(code2);
      } catch (e) {
        console.warn(e);
        logMsgs.push({
          type: "Error",
          msg: e.toString()
        });
        return logMsgs;
      }
      const validate2 = new Ajv$1().compile(schema);
      const valid = validate2(viewConfig);
      if (!valid) {
        console.warn("Invalid viewconf");
        logMsgs.push({
          type: "Warning",
          msg: "Invalid viewconf"
        });
      }
      if (validate2.errors) {
        console.warn(JSON.stringify(validate2.errors, null, 2));
        validate2.errors.forEach((e) => {
          logMsgs.push({
            type: "Warning",
            msg: JSON.stringify(e, null, 2)
          });
        });
      }
      if (logMsgs.length === 0) {
        logMsgs.push({
          type: "Success",
          msg: "No error or warnings"
        });
      }
      return logMsgs;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        hide: true
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        hide: false
      });
    }
  }, {
    key: "hideLog",
    value: function hideLog() {
      this.setState({
        showLog: false
      });
    }
  }, {
    key: "showLog",
    value: function showLog() {
      this.setState({
        showLog: true
      });
    }
  }, {
    key: "toggleLog",
    value: function toggleLog() {
      if (this.state.showLog) {
        this.hideLog();
      } else {
        this.showLog();
      }
    }
  }, {
    key: "render",
    value: function render3() {
      const logMessages = this.state.logMsgs.map((d, i) => {
        const key = `${i}-${d.msg}`;
        return /* @__PURE__ */ React$3.createElement("tr", {
          key
        }, /* @__PURE__ */ React$3.createElement("td", {
          className: clsx(classes.title, classes[d.type])
        }, `[${i}] ${d.type}`), /* @__PURE__ */ React$3.createElement("td", null, /* @__PURE__ */ React$3.createElement("pre", null, d.msg)));
      });
      return /* @__PURE__ */ React$3.createElement(Dialog$1, {
        cancelShortcut: "ESC",
        cancelTitle: "Discard Changes",
        hide: this.state.hide,
        maxHeight: true,
        okayShortcut: "⌘+Enter",
        okayTitle: "Save and Close",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmitBound,
        title: "Edit View Config"
      }, /* @__PURE__ */ React$3.createElement(React$3.Fragment, null, /* @__PURE__ */ React$3.createElement("header", {
        className: classes["view-config-editor-header"]
      }, /* @__PURE__ */ React$3.createElement(Button, {
        onBlur: this.showBound,
        onMouseDown: this.hideBound,
        onMouseOut: this.showBound,
        onMouseUp: this.showBound
      }, "Hide While Mousedown"), /* @__PURE__ */ React$3.createElement(Button, {
        onClick: () => {
          this.props.onChange(this.state.code);
        },
        shortcut: "⌘+S"
      }, "Save")), /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.editorWrap = c2;
        },
        className: classes["view-config-editor"]
      }, /* @__PURE__ */ React$3.createElement(_default, {
        ref: (c2) => {
          this.editor = c2;
        },
        highlight: (code2) => prismCoreExports.highlight(code2, prismCoreExports.languages.json),
        onValueChange: this.handleChangeBound,
        padding: 10,
        style: {
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: "inherit"
        },
        value: this.state.code
      })), /* @__PURE__ */ React$3.createElement("div", {
        className: classes["view-config-log"],
        style: {
          height: this.state.showLog ? "50%" : "30px"
        }
      }, /* @__PURE__ */ React$3.createElement("div", {
        className: classes["view-config-log-header"],
        onClick: () => this.toggleLogBound()
      }, `Log Messages (${this.state.logMsgs.filter((d) => d.type !== "Success").length})`), /* @__PURE__ */ React$3.createElement("div", {
        className: classes["view-config-log-msg"],
        style: {
          padding: this.state.showLog ? "10px" : 0
        }
      }, /* @__PURE__ */ React$3.createElement("table", null, /* @__PURE__ */ React$3.createElement("tbody", null, logMessages))))));
    }
  }]);
  return ViewConfigEditor2;
}(React$3.Component);
ViewConfigEditor.propTypes = {
  modal: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  pubSub: PropTypes.object.isRequired,
  viewConfig: PropTypes.string.isRequired
};
const ViewConfigEditor$1 = withPubSub(withModal(ViewConfigEditor));
function createSymbolIcon(el, id2, paths, viewBox) {
  const symbol = el.append("symbol").attr("id", id2).attr("viewBox", viewBox);
  paths.forEach((d) => symbol.append("path").attr("d", d).attr("fill", "currentColor"));
}
const forceUpdate = (self2) => {
  self2.setState(self2.state);
};
const createApi = function api2(context, pubSub) {
  const self2 = context;
  let pubSubs = [];
  const apiPubSub = createPubSub();
  const destroy = () => {
    pubSubs.forEach((subscription) => pubSub.unsubscribe(subscription));
    pubSubs = [];
  };
  return {
    destroy,
    publish: apiPubSub.publish,
    // Stack: mapping of callback names to arrays of callbacks, useful
    // to determine how many callbacks exist for a particular event.
    stack: apiPubSub.stack,
    // Public API
    public: {
      /**
       * HiGlass version
       * @return {string} Version number
       */
      get version() {
        return version;
      },
      /**
       * Enable or disable broadcasting the mouse position globally
       * @param {boolean} isBroadcastMousePositionGlobally - If `true` the mouse
       *   position will be broadcasted globally.
       */
      setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally = false) {
        self2.setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally);
      },
      /**
       * Enable or disable showing the global mouse position
       * @param {boolean} isShowGlobalMousePosition - If `true` the global mouse
       *   position will be shown for any track that has
       *   `options.showMousePosition = true`.
       */
      setShowGlobalMousePosition(isShowGlobalMousePosition = false) {
        self2.setShowGlobalMousePosition(isShowGlobalMousePosition);
      },
      /**
       * Convenience function to enable / disable the global mouse position
       * @description This function is equivalent to calling
       *   `setBroadcastMousePositionGlobally()` and
       *   `setShowGlobalMousePosition()`.
       * @param {boolean} isGlobalMousePosition - If `true` the global mouse
       *   position will be shown and broadcasted.
       */
      setGlobalMousePosition(isGlobalMousePosition = false) {
        self2.setBroadcastMousePositionGlobally(isGlobalMousePosition);
        self2.setShowGlobalMousePosition(isGlobalMousePosition);
      },
      /**
       * Set an auth header to be included with all tile requests.
       *
       * @param {string} newHeader The contensts of the header to be included.
       * Example: ``hgapi.setAuthHeader('JWT xyz')``
       */
      setAuthHeader(newHeader) {
        setTileProxyAuthHeader(newHeader);
        self2.reload();
      },
      /**
       * Get the currently set auth header
       */
      getAuthHeader() {
        return setTileProxyAuthHeader();
      },
      /**
       * Get a reference to the React HiGlassComponent
       *
       * @returns {HiGlassComponent}
       */
      getComponent() {
        return self2;
      },
      /**
       * Reload all or specific tiles for viewId/trackId
       *
       * @param {array} target Should be an array of type
       *                       ({ viewId: string, trackId: string } | string).
       *                       If the array is just strings, it's interpreted
       *                       as a list of views whose tracks to reload.
       */
      reload(target) {
        let tracks2;
        if (!target) {
          tracks2 = self2.iterateOverTracks();
        } else {
          tracks2 = target.flatMap((d) => typeof d === "string" ? self2.iterateOverTracksInView(d) : d);
        }
        for (const {
          viewId,
          trackId
        } of tracks2) {
          const selectedTrack = self2.getTrackObject(viewId, trackId);
          for (const track of selectedTrack.childTracks || [selectedTrack]) {
            if (track.fetchedTiles) {
              track.removeTiles(Object.keys(track.fetchedTiles));
              track.fetching.clear();
              track.refreshTiles();
            }
            track.rerender(track.options, true);
          }
        }
      },
      /**
       * Destroy HiGlass instance
       */
      destroy() {
        destroy();
        ReactDOM.unmountComponentAtNode(self2.topDiv.parentNode);
      },
      /**
       * Force integer range selections.
       *
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelectionToFloat(); // Allow float range selections
       */
      setRangeSelectionToInt() {
        self2.setState({
          rangeSelectionToInt: true
        });
      },
      /**
       * Force float range selections.
       *
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelectionToFloat(); // Allow float range selections
       */
      setRangeSelectionToFloat() {
        self2.setState({
          rangeSelectionToInt: false
        });
      },
      /**
       *
       *  The following enpoint restricts the size of range selection equally for 1D or
       *  2D tracks to a certain length (specified in absolute coordinates).
       *
       * @param {Number} [minSize = 0]  Minimum range selection.
       *   ``undefined`` unsets the value.
       * @param {Number} [maxSize = Infinity] Maximum range selection.
       *   ``undefined`` unsets the value.
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelection1dSize(5000, 10000); // Force selections to be between 5 and 10 Kb
       */
      setRangeSelection1dSize(minSize = 0, maxSize = Infinity) {
        self2.setState({
          rangeSelection1dSize: [minSize, maxSize]
        });
      },
      /**
       * Set a new view config to define the layout and data
       * of this component
       *
       * @param {obj} newViewConfig A JSON object that defines
       *    the state of the HiGlassComponent
       * @param {boolean} resolveImmediately If true, the returned promise resolves immediately
       *    even if not all data has loaded. This should be set to true, if the new viewconf does not request new data. Default: false.
       * @example
       *
       * const p = hgv.setViewConfig(newViewConfig);
       * p.then(() => {
       *   // the initial set of tiles has been loaded
       * });
       *
       * @return {Promise} dataLoaded A promise that resolves when
       *   all of the data for this viewconfig is loaded. If `resolveImmediately` is set to true,
       * the promise resolves without waiting for the data to be loaded.
       */
      setViewConfig(newViewConfig, resolveImmediately = false) {
        const viewsByUid = self2.processViewConfig(newViewConfig);
        const p = new Promise((resolve2) => {
          this.requestsInFlight = 0;
          pubSubs.push(pubSub.subscribe("requestSent", () => {
            this.requestsInFlight += 1;
          }));
          pubSubs.push(pubSub.subscribe("requestReceived", () => {
            this.requestsInFlight -= 1;
            if (this.requestsInFlight === 0) {
              resolve2();
            }
          }));
          self2.setState({
            viewConfig: newViewConfig,
            views: viewsByUid
          }, () => {
            if (resolveImmediately) {
              resolve2();
            }
          });
        });
        return p;
      },
      /**
       * Retrieve the visible viewconf.
       *
       * @returns (Object) A JSON object describing the visible views
       */
      getViewConfig() {
        return self2.getViewsAsJson();
      },
      /**
       * Validate a viewconf.
       *
       * @returns (Boolean) A JSON object describing the visible views
       */
      validateViewConfig(viewConfig, {
        verbose = false
      } = {}) {
        const validate2 = new Ajv$1().compile(schema);
        const valid = validate2(viewConfig);
        if (verbose && validate2.errors) {
          console.warn(JSON.stringify(validate2.errors, null, 2));
        }
        return valid;
      },
      /**
       * Get the minimum and maximum visible values for a given track.
       *
       * @param {string} viewId The id of the view containing the track.
       * @param {string} trackId The id of the track to query.
       * @param {bool} [ignoreOffScreenValues=false] If ``true`` only truly visible values
       *  are considered. Otherwise the values of visible tiles are used. Not that
       *  considering only the truly visible
       *  values results in a roughly 10x slowdown (from 0.1 to 1 millisecond).
       * @param {bool} [ignoreFixedScale=false]  If ``true`` potentially fixed scaled values are
       *  ignored. I.e., if the
       *  absolute range is ``[1, 18]`` but you have fixed the output range to
       *  ``[4, 5]`` you would normally retrieve ``[4, 5]``. Having this option set to
       *  ``true`` retrieves the absolute ``[1, 18]`` range.
       * @example
       * const [minVal, maxVal] = hgv.getMinMaxValue('myView', 'myTrack');
       * @returns {Array} The minimum and maximum value
       */
      getMinMaxValue(viewId, trackId, ignoreOffScreenValues = false, ignoreFixedScale = false) {
        return self2.getMinMaxValue(viewId, trackId, ignoreOffScreenValues, ignoreFixedScale);
      },
      /**
       * Generate a sharable link to the current view config. The `url` parameter should contain
       * the API endpoint used to export the view link (e.g. 'http://localhost:8989/api/v1/viewconfs').
       * If it is not provided, the value is taken from the `exportViewUrl` value of the viewconf.
       *
       * @param {string}  url  Custom URL that should point to a higlass server's
       *   view config endpoint, i.e.,
       *   `http://my-higlass-server.com/api/v1/viewconfs/`.
       * @returns {Object}  Promise resolving to the link ID and URL.
       * @example
       * hgv.shareViewConfigAsLink('http://localhost:8989/api/v1/viewconfs')
       * .then((sharedViewConfig) => {
       *   const { id, url } = sharedViewConfig;
       *   console.log(`Shared view config (ID: ${id}) is available at ${url}`)
       * })
       * .catch((err) => { console.error('Something did not work. Sorry', err); })
       */
      shareViewConfigAsLink(url) {
        return self2.handleExportViewsAsLink(url, true);
      },
      /**
       * Show overlays where this track can be positioned. This
       * function will take a track definition and display red,
       * blue or green overlays highlighting where the track can
       * be placed on the view. Blue indicates that a track can
       * be placed in that region, red that it can't and green that
       * the mouse is currently over the given region.
       *
       * @param {obj} track { server, tilesetUid, datatype }
       *
       * @example
       *
       *  let lineTrack = {
       *   "server": "http://higlass.io/api/v1",
       *   "tilesetUid": "WtBJUYawQzS9M2WVIIHnlA",
       *   "datatype": "multivec",
       *   "defaultTracks": ['horizontal-stacked-bar']
       * }
       *
       * window.hgApi.showAvailableTrackPositions(lineTrack);
       */
      showAvailableTrackPositions(track) {
        self2.setState({
          draggingHappening: track
        });
      },
      /**
       * Hide the overlay showing where a track can be positioned
       */
      hideAvailableTrackPositions() {
        self2.setState({
          draggingHappening: null
        });
      },
      /**
       * Show the track chooser which highlights tracks
       * when the mouse is over them.
       *
       * @param  {Function} callback (toViewUid, toTrackUid) =>: A function
       *                             to be called when a track is chosen.
       * @return {[type]}            [description]
       */
      showTrackChooser(callback) {
        self2.setState({
          chooseTrackHandler: (...args) => {
            self2.setState({
              chooseTrackHandler: null
            });
            callback(...args);
          }
        });
      },
      /**
       * Hide the track chooser.
       */
      hideTrackChooser() {
        this.setState({
          chooseTrackHandler: null
        });
      },
      /**
       *
       * When comparing different 1D tracks it can be desirable to fix their y or value
       * scale
       *
       * @param {string} [viewId=''] The view identifier. If you only have one view this
       * parameter can be omitted.
       *
       * @param {string} [trackId=null] The track identifier.
       * @param [Number] [minValue=null] Minimum value used for scaling the track.
       * @param [Number] [maxValue=null] Maximum value used for scaling the track.
       *
       * @example
       *
       * hgv.setTrackValueScale(myView, myTrack, 0, 100); // Sets the scaling to [0, 100]
       * hgv.setTrackValueScale(myView, myTrack); // Unsets the fixed scaling, i.e., enables
       * dynamic scaling again.
       */
      setTrackValueScaleLimits(viewId, trackId, minValue, maxValue) {
        self2.setTrackValueScaleLimits(viewId, trackId, minValue, maxValue);
      },
      /**
       * Choose a theme.
       * @deprecated since version 1.6.6. Use `setTheme()` instead.
       */
      setDarkTheme(darkTheme) {
        console.warn('`setDarkTheme(true)` is deprecated. Please use `setTheme("dark")`.');
        const theme = darkTheme ? "dark" : "light";
        self2.setTheme(theme);
      },
      /**
       * Choose a theme.
       */
      setTheme(theme) {
        console.warn("Please note that theming is still in beta!");
        self2.setTheme(theme);
      },
      /**
       * Change the current view port to a certain data location.
       * When ``animateTime`` is greater than 0, animate the transition.
        * If working with genomic data, a chromosome info file will need to be used in
       * order to calculate "data" coordinates from chromosome coordinates. "Data"
       * coordinates are simply the coordinates as if the chromosomes were placed next
       * to each other.
       *
       * @param {string} viewUid The identifier of the view to zoom
       * @param {Number} start1Abs The x start position
       * @param {Number} end1Abs The x end position
       * @param {Number} start2Abs (optional) The y start position. If not specified
       *    start1Abs will be used.
       * @param {Number} end2Abs (optional) The y end position. If not specified
       *    end1Abs will be used
       * @param {Number} animateTime The time to spend zooming to the specified location
       * @example
       *    // Absolute coordinates
       * hgApi.zoomTo('view1', 1000000, 1100000, 2000000, 2100000, 500);
       * // Chromosomal coordinates
       * hglib
       *   // Pass in the URL of your chrom sizes
       *   .ChromosomeInfo('//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv')
       *   // Now we can use the chromInfo object to convert
       *   .then((chromInfo) => {
       *     // Go to PTEN
       *     hgApi.zoomTo(
       *       viewConfig.views[0].uid,
       *       chromInfo.chrToAbs(['chr10', 89596071]),
       *       chromInfo.chrToAbs(['chr10', 89758810]),
       *       chromInfo.chrToAbs(['chr10', 89596071]),
       *       chromInfo.chrToAbs(['chr10', 89758810]),
       *       2500  // Animation time
       *     );
       *   });
       *   // Just in case, let us catch errors
       *   .catch(error => console.error('Oh boy...', error))
       * // Using getLocation() for coordinates
       * let firstViewLoc = hgApi.getLocation(oldViewUid);
       * hgApi.zoomTo(
       *  viewUid,
       *  firstViewLoc["xDomain"][0],
       *  firstViewLoc["xDomain"][1],
       *  firstViewLoc["yDomain"][0],
       *  firstViewLoc["yDomain"][1]
       * );
       */
      zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime = 0) {
        self2.zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime);
      },
      /**
       * Change the current view port to a location near the gene of interest.
       * When ``animateTime`` is greater than 0, animate the transition.
       *
       * @param {string} viewUid The identifier of the view to zoom
       * @param {string} geneName The name of gene symbol to search
       * @param {string} padding The padding (base pairs) around a given gene for the navigation
       * @param {Number} animateTime The time to spend zooming to the specified location
       * @example
       * // Zoom to the location near 'MYC'
       * hgApi.zoomToGene('view1', 'MYC', 100, 2000);
       */
      zoomToGene(viewUid, geneName, padding = 0, animateTime = 0) {
        self2.zoomToGene(viewUid, geneName, padding, animateTime);
      },
      /**
       * Get the list of genes of top match for a given keyword.
       *
       * @param {string} viewUid The id of the view containing the track.
       * @param {string} keyword The substring of gene name to search.
       * @param {function} callback A function to be called upon gene list search.
       * @example
       * hgv.suggestGene('view1', 'MY', (suggestions) => {
       *    if(suggestions && suggestions.length > 0) {
       *      console.log('Gene suggested', suggestions[0].geneName);
       *      console.log('Chromosome', suggestions[0].chr);
       *      console.log('Start position', suggestions[0].txStart);
       *      console.log('End position', suggestions[0].txEnd);
       *    }
       * });
       */
      suggestGene(viewUid, keyword2, callback) {
        return self2.suggestGene(viewUid, keyword2, callback);
      },
      /**
       * Zoom so that the entirety of all the datasets in a view
       * are visible.
       * The passed in ``viewUid`` should refer to a view which is present. If it
       * doesn't, an exception will be thrown. Note that if this function is invoked
       * directly after a HiGlass component is created, the information about the
       * visible tilesets will not have been retrieved from the server and
       * ``zoomToDataExtent`` will not work as expected. To ensure that the
       * visible data has been loaded from the server, use the ``setViewConfig``
       * function and place ``zoomToDataExtent`` in the promise resolution.
       *
       * @param {string} viewUid The view uid of the view to zoom
       * @example
       *
       * const p = hgv.setViewConfig(newViewConfig);
       * p.then(() => {
       *     hgv.zoomToDataExtent('viewUid');
       * });
       */
      zoomToDataExtent(viewUid) {
        self2.handleZoomToData(viewUid);
      },
      /**
       * The endpoint allows you to reset the viewport to the initially defined X and Y
       * domains of your view config.
       *
       * @param {string} viewId The view identifier. If you have only one view you can
       * omit this parameter.
       *
       * @example
       *
       * hgv.resetViewport(); // Resets the first view
       */
      resetViewport(viewId) {
        self2.resetViewport(viewId);
      },
      /**
       * Some tools needs conflicting mouse events such as mousedown or mousemove. To
       * avoid complicated triggers for certain actions HiGlass supports different mouse
       * tools for different interactions. The default mouse tool enables pan&zoom. The
       * only other mouse tool available right now is ``select``, which lets you brush
       * on to a track to select a range for annotating regions.
       *
       * @param {string} [mouseTool='']  Select a mouse tool to use. Currently there
       * only 'default' and 'select' are available.
       *
       * @example
       *
       * hgv.activateTool('select'); // Select tool is active
       * hgv.activateTool(); // Default pan&zoom tool is active
       */
      activateTool(tool) {
        switch (tool) {
          case "select":
            self2.setMouseTool(MOUSE_TOOL_SELECT);
            break;
          default:
            self2.setMouseTool(MOUSE_TOOL_MOVE);
            break;
        }
      },
      /**
       * Get a Promise which returns a Blob containing a PNG for the current view.
       * It's possible to get string of the PNG bytes from that:
       *
       * @example
       * hgApi.exportAsPngBlobPromise().then(function(blob) {
       *   var reader = new FileReader();
       *   reader.addEventListener("loadend", function() {
       *     var array = new Uint8Array(reader.result.slice(0,8));
       *     console.log(array);
       *     console.log(new TextDecoder("iso-8859-2").decode(array));
       *   });
       *   reader.readAsArrayBuffer(blob);
       * });
       *
       * @returns {promise}
       */
      exportAsPngBlobPromise() {
        return self2.createPNGBlobPromise();
      },
      /**
       * Get the current view as an SVG. Relies on all the tracks implementing
       * their respective exportAsSVG methods.
       *
       * @returns {string} An SVG string of the current view.
       */
      exportAsSvg() {
        return self2.createSVGString();
      },
      /**
       * Export the current view as a Viewconf.
       *
       * @returns {string} A stringified version of the current viewconf
       */
      exportAsViewConfString() {
        return self2.getViewsAsString();
      },
      /**
       * Get the current range selection
       *
       * @return {Array} The current range selection
       */
      getRangeSelection() {
        return self2.rangeSelection;
      },
      /**
       * Get the current location for a view.
       *
       * @param {string} [viewId=null] The id of the view to get the location for
       * @returns {obj} A an object containing four arrays representing the domains and ranges of
       *  the x and y scales of the view.
       * @example
       *
       * const {xDomain, yDomain, xRange, yRange} = hgv.getLocation('viewId');
       */
      getLocation(viewId) {
        const wurstId = viewId ? self2.xScales[viewId] && self2.yScales[viewId] && viewId : Object.values(self2.tiledPlots)[0] && Object.values(self2.tiledPlots)[0].props.uid;
        if (!wurstId) {
          return "Please provide a valid view UUID sweetheart 😙";
        }
        return {
          xDomain: self2.xScales[wurstId].domain(),
          yDomain: self2.yScales[wurstId].domain(),
          xRange: self2.xScales[wurstId].range(),
          yRange: self2.yScales[wurstId].range()
        };
      },
      /**
       * Return the track's javascript object. This is useful for subscribing to
       * data events (dataChanged)
       *
       * @param {string} viewId The id of the view containing the track
       * @param {string} trackId The id of the track within the view
       * @return {obj} The HiGlass track object for this track
       */
      getTrackObject(viewId, trackId) {
        let newViewId = viewId;
        let newTrackId = trackId;
        if (!trackId) {
          newViewId = Object.values(self2.state.views)[0].uid;
          newTrackId = viewId;
        }
        return getTrackObjectFromHGC(self2, newViewId, newTrackId);
      },
      /**
       * Set or get an option.
       * @param   {string}  key  The name of the option you want get or set
       * @param   {*}  value  If not `undefined`, `key` will be set to `value`
       * @return  {obj}  When `value` is `undefined` the current value of
       *   `key` will be returned.
       */
      option(key, value2) {
        if (typeof value2 === "undefined")
          return self2.props.options[key];
        switch (key) {
          case "sizeMode":
            self2.props.options[key] = value2;
            forceUpdate(self2);
            break;
          default:
            console.warn(`This option "${key}" is either unknown or not settable.`);
        }
        return void 0;
      },
      /**
       * Cancel a subscription.
       *
       * @param {string} event One of the available events
       * @param {function} listener The function to unsubscribe
       * @param {string} viewId The viewId to unsubscribe it from (not strictly necessary)
       * The variables used in the following examples are coming from the examples of ``on()``.
       *
       * @example
       *
       * hgv.off('location', listener, 'viewId1');
       * hgv.off('rangeSelection', rangeListener);
       * hgv.off('viewConfig', viewConfigListener);
       * hgv.off('mouseMoveZoom', mmz);
       * hgv.off('wheel', wheelListener);
       * hgv.off('createSVG');
       * hgv.off('click');
       * hgv.off('geneSearch', geneSearchListener);
       */
      off(event, listenerId, viewId) {
        const callback = typeof listenerId === "object" ? listenerId.callback : listenerId;
        switch (event) {
          case "click":
            apiPubSub.unsubscribe("click", callback);
            break;
          case "cursorLocation":
            apiPubSub.unsubscribe("cursorLocation", callback);
            break;
          case "location":
            self2.offLocationChange(viewId, listenerId);
            break;
          case "mouseMoveZoom":
            apiPubSub.unsubscribe("mouseMoveZoom", callback);
            break;
          case "wheel":
            apiPubSub.unsubscribe("wheel", callback);
            break;
          case "rangeSelection":
            apiPubSub.unsubscribe("rangeSelection", callback);
            break;
          case "viewConfig":
            self2.offViewChange(listenerId);
            break;
          case "createSVG":
            self2.offPostCreateSVG();
            break;
          case "geneSearch":
            apiPubSub.unsubscribe("geneSearch", callback);
            break;
        }
      },
      /**
       * Subscribe to events
       *
       *
       * HiGlass exposes the following event, which one can subscribe to via this method:
       *
       * - location
       * - rangeSelection
       * - viewConfig
       * - mouseMoveZoom
       *
       * **Event types**
       *
       * ``click``: Returns a list of objects for each track that is below the click event.
       *
       * .. code-block:: javascript
       *
       *     [
       *      {
       *       event: {
       *          type: 'annotation',
       *          event: { ... },
       *          payload: [230000000, 561000000]
       *        },
       *       trackType: '1d-annotation',
       *       trackUid: 'xyz',
       *       viewUid: 'abc'
       *      }
       *     ]
       *
       * ``cursorLocation:`` Returns an object describing the location under the cursor
       *
       * .. code-block:: javascript
       *
       *    {
       *        absX: 100,
       *        absY: 200,
       *        relX: 50,
       *        relY: 150,
       *        relTrackX: 50,
       *        relTrackY: 100,
       *        dataX: 10000,
       *        dataY: 123456,
       *        isFrom2dTrack: false,
       *        isFromVerticalTrack: false,
       *    }
       *
       * ``location:`` Returns an object describing the visible region
       *
       * .. code-block:: javascript
       *
       *    {
       *        xDomain: [1347750580.3773856, 1948723324.787681],
       *        xRange: [0, 346],
       *        yDomain: [1856870481.5391564, 2407472678.0075483],
       *        yRange: [0, 317]
       *    }
       *
       * ``rangeSelection:`` Returns a BED- (1D) or BEDPE (1d) array of the selected data and
       * genomic range (if chrom-sizes are available)
       *
       * .. code-block:: javascript
       *
       *  // Global output
       *  {
       *    dataRange: [...]
       *    genomicRange: [...]
       *  }
       *
       *  // 1D data range
       *  [[1218210862, 1528541001], null]
       *
       *  // 2D data range
       *  [[1218210862, 1528541001], [1218210862, 1528541001]]
       *
       *  // 1D or BED-like array
       *  [["chr1", 249200621, "chrM", 50000], null]
       *
       *  // 2D or BEDPE-like array
       *  [["chr1", 249200621, "chr2", 50000], ["chr3", 197972430, "chr4", 50000]]
       *
       * ``viewConfig:`` Returns the current view config (as a string).
       *  This event is published upon interactions including:
       *  - Saving in the view config editor modal.
       *  - Panning and zooming in views, which update view object ``initialXDomain`` and ``initialYDomain`` values.
       *  - Brushing in ``viewport-projection-`` tracks containing null ``fromViewUid`` fields, which update track object ``projectionXDomain`` and ``projectionYDomain`` values.
       *
       * ``mouseMoveZoom:`` Returns the location and data at the mouse cursor's
       * screen location.
       *
       * .. code-block:: javascript
       *
       *  {
       *    // Float value of the hovering track
       *    data,
       *    // Absolute x screen position of the cursor in px
       *    absX,
       *    // Absolute y screen position of the cursor in px
       *    absY,
       *    // X screen position of the cursor in px relative to the track extent.
       *    relX,
       *    // Y screen position of the cursor in px relative to the track extent.
       *    relY,
       *    // Data x position of the cursor relative to the track's data.
       *    dataX,
       *    // Data y position of the cursor relative to the track's data.
       *    dataY,
       *    // Track orientation, i.e., '1d-horizontal', '1d-vertical', or '2d'
       *    orientation: '1d-horizontal',
       *
       *    // The following properties are only returned when hovering 2D tracks:
       *    // Raw Float32Array
       *    dataLens,
       *    // Dimension of the lens, e.g., 3 (the lens is squared so `3` corresponds
       *    // to a 3x3 matrix represented by an array of length 9)
       *    dim,
       *    // Function for converting the raw data values to rgb values
       *    toRgb,
       *    // Center position of the data or genomic position (as a BED array)
       *    center,
       *    // Range of the x data or genomic position (as a BEDPE array)
       *    xRange,
       *    // Range of the y data or genomic position (as a BEDPE array)
       *    yRange,
       *    // If `true` `center`, `xRange`, and `yRange` are given in genomic positions
       *    isGenomicCoords
       *  }
       *
       * ``createSVG:`` Set a callback to obtain the current exported SVG DOM node,
       *                and potentially return a manipulated SVG DOM node.
       *
       * @param {string} event One of the events described below
       *
       * @param {function} callback A callback to be called when the event occurs
       *
       * @param {string} viewId The view ID to listen to events
       *
       * @example
       *
       * let locationListenerId;
       * hgv.on(
       *   'location',
       *   location => console.log('Here we are:', location),
       *   'viewId1',
       *   listenerId => locationListenerId = listenerId
       * );
       *
       * const rangeListenerId = hgv.on(
       *   'rangeSelection',
       *   range => console.log('Selected', range)
       * );
       *
       * const viewConfigListenerId = hgv.on(
       *   'viewConfig',
       *   range => console.log('Selected', range)
       * );
       *
       * const mmz = event => console.log('Moved', event);
       * hgv.on('mouseMoveZoom', mmz);
       *
       * const wheelListener = event => console.log('Wheel', event);
       * hgv.on('wheel', wheelListener);
       *
       * hgv.on('createSVG', (svg) => {
       *    const circle = document.createElement('circle');
       *    circle.setAttribute('cx', 100);
       *    circle.setAttribute('cy', 100);
       *    circle.setAttribute('r', 50);
       *    circle.setAttribute('fill', 'green');
       *    svg.appendChild(circle);
       *    return svg;
       * });
       *
       * const geneSearchListener = event => {
       *    console.log('Gene searched', event.geneSymbol);
       *    console.log('Range of the gene', event.range);
       *    console.log('Center of the gene', event.centerX);
       * }
       * hgv.on('geneSearch', geneSearchListener);
       */
      on(event, callback, viewId, callbackId) {
        switch (event) {
          case "click":
            return apiPubSub.subscribe("click", callback);
          case "cursorLocation":
            return apiPubSub.subscribe("cursorLocation", callback);
          case "location":
            return self2.onLocationChange(viewId, callback, callbackId);
          case "mouseMoveZoom":
            return apiPubSub.subscribe("mouseMoveZoom", callback);
          case "wheel":
            return apiPubSub.subscribe("wheel", callback);
          case "rangeSelection":
            return apiPubSub.subscribe("rangeSelection", callback);
          case "viewConfig":
            return self2.onViewChange(callback);
          case "createSVG":
            return self2.onPostCreateSVG(callback);
          case "geneSearch":
            return apiPubSub.subscribe("geneSearch", callback);
          default:
            return void 0;
        }
      }
    }
  };
};
const higlass = "_higlass_1uoq8_1";
const styles = {
  higlass,
  "higlass-dark-theme": "_higlass-dark-theme_1uoq8_5",
  "higlass-container-overflow": "_higlass-container-overflow_1uoq8_9",
  "higlass-scroll-container-overflow": "_higlass-scroll-container-overflow_1uoq8_10",
  "higlass-scroll-container-scroll": "_higlass-scroll-container-scroll_1uoq8_11",
  "higlass-canvas": "_higlass-canvas_1uoq8_28",
  "higlass-drawing-surface": "_higlass-drawing-surface_1uoq8_34",
  "higlass-svg": "_higlass-svg_1uoq8_38",
  "tiled-area": "_tiled-area_1uoq8_47",
  "track-mouseover-menu": "_track-mouseover-menu_1uoq8_52"
};
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
const NUM_GRID_COLUMNS = 12;
const DEFAULT_NEW_VIEW_HEIGHT = 12;
const VIEW_HEADER_HEIGHT = 20;
const SIZE_MODE_DEFAULT = "default";
const SIZE_MODE_BOUNDED = "bounded";
const SIZE_MODE_OVERFLOW = "overflow";
const SIZE_MODE_SCROLL = "scroll";
let HiGlassComponent = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(HiGlassComponent2, _React$Component);
  var _super = _createSuper$1(HiGlassComponent2);
  function HiGlassComponent2(props) {
    var _this;
    _classCallCheck$1(this, HiGlassComponent2);
    _this = _super.call(this, props);
    if (numericifyVersion(React$3.version) < 15.6) {
      console.warn("HiGlass requires React v15.6 or higher. Current version: ", React$3.version);
    }
    _this.pubSub = createPubSub();
    _this.domEvent = domEvent(_this.pubSub);
    _this.pubSubs = [];
    _this.minHorizontalHeight = 20;
    _this.minVerticalWidth = 20;
    _this.resizeSensor = null;
    _this.uid = slugid$1.nice();
    _this.tiledPlots = {};
    _this.genomePositionSearchBoxes = {};
    _this.xScales = {};
    _this.yScales = {};
    _this.projectionXDomains = {};
    _this.projectionYDomains = {};
    _this.topDiv = null;
    _this.zoomToDataExtentOnInit = /* @__PURE__ */ new Set();
    _this.viewTrackUidsToCombinedUid = {};
    _this.combinedUidToViewTrack = {};
    _this.scalesChangedListeners = {};
    _this.draggingChangedListeners = {};
    _this.valueScalesChangedListeners = {};
    _this.zoomLocks = {};
    _this.locationLocks = {};
    _this.locationLocksAxisWise = {
      x: {},
      y: {}
    };
    _this.valueScaleLocks = {};
    _this.prevAuthToken = props.options.authToken;
    _this.setCenters = {};
    _this.plusImg = {};
    _this.configImg = {};
    GLOBALS.PIXI = props.options && props.options.PIXI || PIXI;
    _this.viewMarginTop = +props.options.viewMarginTop >= 0 ? +props.options.viewMarginTop : DEFAULT_VIEW_MARGIN;
    _this.viewMarginBottom = +props.options.viewMarginBottom >= 0 ? +props.options.viewMarginBottom : DEFAULT_VIEW_MARGIN;
    _this.viewMarginLeft = +props.options.viewMarginLeft >= 0 ? +props.options.viewMarginLeft : DEFAULT_VIEW_MARGIN;
    _this.viewMarginRight = +props.options.viewMarginRight >= 0 ? +props.options.viewMarginRight : DEFAULT_VIEW_MARGIN;
    _this.viewPaddingTop = +props.options.viewPaddingTop >= 0 ? +props.options.viewPaddingTop : DEFAULT_VIEW_PADDING;
    _this.viewPaddingBottom = +props.options.viewPaddingBottom >= 0 ? +props.options.viewPaddingBottom : DEFAULT_VIEW_PADDING;
    _this.viewPaddingLeft = +props.options.viewPaddingLeft >= 0 ? +props.options.viewPaddingLeft : DEFAULT_VIEW_PADDING;
    _this.viewPaddingRight = +props.options.viewPaddingRight >= 0 ? +props.options.viewPaddingRight : DEFAULT_VIEW_PADDING;
    _this.genomePositionSearchBox = null;
    _this.viewHeaders = {};
    _this.boundRefreshView = () => {
      _this.refreshView(LONG_DRAG_TIMEOUT);
    };
    _this.unsetOnLocationChange = [];
    _this.setTheme(props.options.theme, props.options.isDarkTheme);
    _this.viewconfLoaded = false;
    const {
      viewConfig
    } = _this.props;
    const views = _this.loadIfRemoteViewConfig(_this.props.viewConfig);
    if (props.options.authToken) {
      setTileProxyAuthHeader(props.options.authToken);
    }
    _this.pixiRoot = new GLOBALS.PIXI.Container();
    _this.pixiRoot.interactive = true;
    _this.pixiStage = new GLOBALS.PIXI.Container();
    _this.pixiStage.interactive = true;
    _this.pixiRoot.addChild(_this.pixiStage);
    _this.pixiMask = new GLOBALS.PIXI.Graphics();
    _this.pixiRoot.addChild(_this.pixiMask);
    _this.pixiStage.mask = _this.pixiMask;
    _this.element = null;
    _this.scrollTop = 0;
    let mouseTool = MOUSE_TOOL_MOVE;
    if (_this.props.options) {
      switch (_this.props.options.mouseTool) {
        case MOUSE_TOOL_SELECT:
          mouseTool = MOUSE_TOOL_SELECT;
          break;
      }
    }
    if (_this.props.options.pluginTracks) {
      window.higlassTracksByType = Object.assign(window.higlassTracksByType || {}, _this.props.options.pluginTracks);
    }
    const pluginTracks = {};
    try {
      if (window.higlassTracksByType) {
        Object.entries(window.higlassTracksByType).forEach(([trackType, trackDef]) => {
          pluginTracks[trackType] = trackDef;
        });
      }
    } catch (e) {
      console.warn("Broken config of a plugin track");
    }
    if (_this.props.options.pluginDataFetchers) {
      window.higlassDataFetchersByType = Object.assign(window.higlassDataFetchersByType || {}, _this.props.options.pluginDataFetchers);
    }
    const pluginDataFetchers = window.higlassDataFetchersByType;
    const rowHeight = _this.props.options.pixelPreciseMarginPadding ? 1 : 30;
    _this.mounted = false;
    _this.pluginTracks = pluginTracks;
    _this.pluginDataFetchers = pluginDataFetchers;
    _this.state = {
      currentBreakpoint: "lg",
      width: 0,
      height: 0,
      rowHeight,
      svgElement: null,
      canvasElement: null,
      customDialog: null,
      views,
      viewConfig,
      addTrackPositionMenuPosition: null,
      typedEditable: void 0,
      mouseOverOverlayUid: null,
      mouseTool,
      isDarkTheme: false,
      rangeSelection1dSize: [0, Infinity],
      rangeSelectionToInt: false,
      modal: null,
      isShiftDown: false
    };
    _this.attachedToDOM = false;
    const {
      public: api3,
      destroy: apiDestroy,
      publish: apiPublish,
      stack: apiStack
    } = createApi(_assertThisInitialized$1(_this), _this.pubSub);
    _this.api = api3;
    _this.apiDestroy = apiDestroy;
    _this.apiPublish = apiPublish;
    _this.apiStack = apiStack;
    _this.viewChangeListener = [];
    _this.triggerViewChangeDb = debounce$1(_this.triggerViewChange.bind(_assertThisInitialized$1(_this)), 250);
    _this.pubSubs = [];
    _this.rangeSelection = [null, null];
    _this.prevMouseHoverTrack = null;
    _this.zooming = false;
    _this.appClickHandlerBound = _this.appClickHandler.bind(_assertThisInitialized$1(_this));
    _this.canvasClickHandlerBound = _this.canvasClickHandler.bind(_assertThisInitialized$1(_this));
    _this.keyDownHandlerBound = _this.keyDownHandler.bind(_assertThisInitialized$1(_this));
    _this.keyUpHandlerBound = _this.keyUpHandler.bind(_assertThisInitialized$1(_this));
    _this.resizeHandlerBound = _this.resizeHandler.bind(_assertThisInitialized$1(_this));
    _this.resizeHandlerBound = _this.resizeHandler.bind(_assertThisInitialized$1(_this));
    _this.dispatchEventBound = _this.dispatchEvent.bind(_assertThisInitialized$1(_this));
    _this.animateOnMouseMoveHandlerBound = _this.animateOnMouseMoveHandler.bind(_assertThisInitialized$1(_this));
    _this.zoomStartHandlerBound = _this.zoomStartHandler.bind(_assertThisInitialized$1(_this));
    _this.zoomEndHandlerBound = _this.zoomEndHandler.bind(_assertThisInitialized$1(_this));
    _this.zoomHandlerBound = _this.zoomHandler.bind(_assertThisInitialized$1(_this));
    _this.trackDroppedHandlerBound = _this.trackDroppedHandler.bind(_assertThisInitialized$1(_this));
    _this.trackDimensionsModifiedHandlerBound = _this.trackDimensionsModifiedHandler.bind(_assertThisInitialized$1(_this));
    _this.animateBound = _this.animate.bind(_assertThisInitialized$1(_this));
    _this.animateOnGlobalEventBound = _this.animateOnGlobalEvent.bind(_assertThisInitialized$1(_this));
    _this.requestReceivedHandlerBound = _this.requestReceivedHandler.bind(_assertThisInitialized$1(_this));
    _this.wheelHandlerBound = _this.wheelHandler.bind(_assertThisInitialized$1(_this));
    _this.mouseMoveHandlerBound = _this.mouseMoveHandler.bind(_assertThisInitialized$1(_this));
    _this.onMouseLeaveHandlerBound = _this.onMouseLeaveHandler.bind(_assertThisInitialized$1(_this));
    _this.onBlurHandlerBound = _this.onBlurHandler.bind(_assertThisInitialized$1(_this));
    _this.openModalBound = _this.openModal.bind(_assertThisInitialized$1(_this));
    _this.closeModalBound = _this.closeModal.bind(_assertThisInitialized$1(_this));
    _this.handleEditViewConfigBound = _this.handleEditViewConfig.bind(_assertThisInitialized$1(_this));
    _this.onScrollHandlerBound = _this.onScrollHandler.bind(_assertThisInitialized$1(_this));
    _this.typedText = "";
    _this.typedTextTimeout = null;
    _this.modal = {
      open: _this.openModalBound,
      close: _this.closeModalBound
    };
    _this.setBroadcastMousePositionGlobally(_this.props.options.broadcastMousePositionGlobally || _this.props.options.globalMousePosition);
    _this.setShowGlobalMousePosition(_this.props.options.showGlobalMousePosition || _this.props.options.globalMousePosition);
    return _this;
  }
  _createClass$1(HiGlassComponent2, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.domEvent.register("keydown", document);
      this.domEvent.register("keyup", document);
      this.domEvent.register("scroll", document);
      this.domEvent.register("resize", window);
      this.domEvent.register("orientationchange", window);
      this.domEvent.register("wheel", window);
      this.domEvent.register("mousedown", window, true);
      this.domEvent.register("mouseup", window, true);
      this.domEvent.register("click", window, true);
      this.domEvent.register("mousemove", window);
      this.domEvent.register("touchmove", window);
      this.domEvent.register("touchstart", window);
      this.domEvent.register("touchend", window);
      this.domEvent.register("touchcancel", window);
      this.domEvent.register("blur", window);
      this.pubSubs.push(this.pubSub.subscribe("app.click", this.appClickHandlerBound), this.pubSub.subscribe("blur", this.onBlurHandlerBound), this.pubSub.subscribe("keydown", this.keyDownHandlerBound), this.pubSub.subscribe("keyup", this.keyUpHandlerBound), this.pubSub.subscribe("resize", this.resizeHandlerBound), this.pubSub.subscribe("wheel", this.wheelHandlerBound), this.pubSub.subscribe("orientationchange", this.resizeHandlerBound), this.pubSub.subscribe("app.event", this.dispatchEventBound), this.pubSub.subscribe("app.animateOnMouseMove", this.animateOnMouseMoveHandlerBound), this.pubSub.subscribe("trackDropped", this.trackDroppedHandlerBound), this.pubSub.subscribe("trackDimensionsModified", this.trackDimensionsModifiedHandlerBound), this.pubSub.subscribe("app.zoomStart", this.zoomStartHandlerBound), this.pubSub.subscribe("app.zoomEnd", this.zoomEndHandlerBound), this.pubSub.subscribe("app.zoom", this.zoomHandlerBound), this.pubSub.subscribe("requestReceived", this.requestReceivedHandlerBound));
      if (this.props.getApi) {
        this.props.getApi(this.api);
      }
    }
  }, {
    key: "sizeMode",
    get: function() {
      return typeof this.props.options.sizeMode === "undefined" ? this.props.options.bounded ? "bounded" : SIZE_MODE_DEFAULT : this.props.options.sizeMode;
    }
  }, {
    key: "setBroadcastMousePositionGlobally",
    value: function setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally = false) {
      this.isBroadcastMousePositionGlobally = isBroadcastMousePositionGlobally;
    }
  }, {
    key: "setShowGlobalMousePosition",
    value: function setShowGlobalMousePosition(isShowGlobalMousePosition = false) {
      this.isShowGlobalMousePosition = isShowGlobalMousePosition;
      if (this.isShowGlobalMousePosition && !this.globalMousePositionListener) {
        this.globalMousePositionListener = globalPubSub.subscribe("higlass.mouseMove", this.animateOnGlobalEventBound);
        this.pubSubs.push(this.globalMousePositionListener);
      }
      if (this.isShowGlobalMousePosition && !this.globalMousePositionListener) {
        const index2 = this.pubSubs.findIndex((listener) => listener === this.globalMousePositionListener);
        globalPubSub.unsubscribe(this.globalMousePositionListener);
        if (index2 >= 0)
          this.pubSubs.splice(index2, 1);
        this.globalMousePositionListener = void 0;
      }
    }
  }, {
    key: "zoomStartHandler",
    value: function zoomStartHandler() {
      this.hideHoverMenu();
      this.zooming = true;
    }
  }, {
    key: "zoomEndHandler",
    value: function zoomEndHandler() {
      this.zooming = false;
    }
  }, {
    key: "zoomHandler",
    value: function zoomHandler(evt) {
      if (!evt.sourceEvent)
        return;
      this.mouseMoveHandler(evt.sourceEvent);
    }
  }, {
    key: "waitForDOMAttachment",
    value: function waitForDOMAttachment(callback) {
      if (!this.mounted)
        return;
      const thisElement = ReactDOM.findDOMNode(this);
      if (document.body.contains(thisElement)) {
        callback();
      } else {
        requestAnimationFrame(() => this.waitForDOMAttachment(callback));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.element = ReactDOM.findDOMNode(this);
      window.addEventListener("focus", this.boundRefreshView);
      Object.values(this.state.views).forEach((view) => {
        this.adjustLayoutToTrackSizes(view);
        if (!view.layout) {
          view.layout = this.generateViewLayout(view);
        } else {
          view.layout.i = view.uid;
        }
      });
      const rendererOptions = {
        width: this.state.width,
        height: this.state.height,
        view: this.canvasElement,
        antialias: true,
        backgroundAlpha: 0,
        resolution: 2,
        autoResize: true
      };
      const versionNumber = parseInt(PIXI.VERSION[0], 10);
      if (versionNumber === 4) {
        console.warn("Deprecation warning: please update Pixi.js to version 5 or above!");
        if (this.props.options.renderer === "canvas") {
          this.pixiRenderer = new GLOBALS.PIXI.CanvasRenderer(rendererOptions);
        } else {
          this.pixiRenderer = new GLOBALS.PIXI.WebGLRenderer(rendererOptions);
        }
      } else {
        if (versionNumber < 4) {
          console.warn("Deprecation warning: please update Pixi.js to version 5 or above! This version of Pixi.js is unsupported. Good luck 🤞");
        }
        if (this.props.options.renderer === "canvas") {
          this.pixiRenderer = new GLOBALS.PIXI.CanvasRenderer(rendererOptions);
        } else {
          this.pixiRenderer = new GLOBALS.PIXI.Renderer(rendererOptions);
        }
      }
      this.fitPixiToParentContainer();
      this.setState({
        svgElement: this.svgElement,
        canvasElement: this.canvasElement
      });
      this.waitForDOMAttachment(() => {
        cssElementQueries.ElementQueries.listen();
        this.resizeSensor = new cssElementQueries.ResizeSensor(this.element.parentNode, this.updateAfterResize.bind(this));
        this.updateAfterResize();
      });
      this.handleDragStart();
      this.handleDragStop();
      this.animate();
      const baseSvg = select$1(this.element).append("svg").style("display", "none");
      all$2.forEach((icon) => createSymbolIcon(baseSvg, icon.id, icon.paths, icon.viewBox));
    }
  }, {
    key: "getTrackObject",
    value: function getTrackObject(viewUid, trackUid) {
      return this.tiledPlots[viewUid].trackRenderer.getTrackObject(trackUid);
    }
  }, {
    key: "getTrackRenderer",
    value: function getTrackRenderer2(viewUid) {
      return this.tiledPlots[viewUid].trackRenderer;
    }
    /**
     * Check if the passed in viewConfig is remote (i.e. is a string).
     * If it is, fetch it before proceeding
     */
  }, {
    key: "loadIfRemoteViewConfig",
    value: function loadIfRemoteViewConfig(viewConfig) {
      let views = {};
      if (typeof viewConfig === "string") {
        api.json(viewConfig, (error, remoteViewConfig) => {
          viewConfig = remoteViewConfig;
          this.setState({
            views: this.processViewConfig(JSON.parse(JSON.stringify(remoteViewConfig))),
            viewConfig: remoteViewConfig
          });
          this.unsetOnLocationChange.forEach(({
            viewId,
            callback,
            callbackId
          }) => {
            this.onLocationChange(viewId, callback, callbackId);
          });
        }, this.pubSub);
      } else {
        views = this.processViewConfig(JSON.parse(JSON.stringify(viewConfig)));
        if (this.mounted) {
          this.setState({
            viewConfig
          });
        }
      }
      return views;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      const viewsByUid = this.loadIfRemoteViewConfig(newProps.viewConfig);
      if (newProps.options.authToken !== this.prevAuthToken) {
        setTileProxyAuthHeader(newProps.options.authToken);
        for (const viewId of this.iterateOverViews()) {
          const trackRenderer = this.getTrackRenderer(viewId);
          const trackDefinitions = JSON.parse(trackRenderer.prevTrackDefinitions);
          trackRenderer.syncTrackObjects([]);
          trackRenderer.syncTrackObjects(trackDefinitions);
        }
        this.prevAuthToken = newProps.options.authToken;
      }
      for (const view of dictValues(viewsByUid)) {
        this.adjustLayoutToTrackSizes(view);
      }
      this.setState({
        views: viewsByUid
      });
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
      this.pixiRenderer.render(this.pixiRoot);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setTheme(this.props.options.theme, this.props.options.isDarkTheme);
      this.animate();
      this.triggerViewChangeDb();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.pixiStage.destroy(false);
      this.pixiStage = null;
      this.pixiRenderer.destroy(true);
      this.pixiRenderer = null;
      window.removeEventListener("focus", this.boundRefreshView);
      if (this.resizeSensor)
        this.resizeSensor.detach();
      this.domEvent.unregister("keydown", document);
      this.domEvent.unregister("keyup", document);
      this.domEvent.unregister("scroll", document);
      this.domEvent.unregister("wheel", window);
      this.domEvent.unregister("mousedown", window);
      this.domEvent.unregister("mouseup", window);
      this.domEvent.unregister("click", window);
      this.domEvent.unregister("mousemove", window);
      this.domEvent.unregister("touchmove", window);
      this.domEvent.unregister("touchstart", window);
      this.domEvent.unregister("touchend", window);
      this.domEvent.unregister("touchcancel", window);
      this.pubSubs.forEach((subscription) => this.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
      this.apiDestroy();
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "setTheme",
    value: function setTheme(newTheme = this.props.options.theme, isDarkTheme = this.props.options.isDarkTheme) {
      if (typeof isDarkTheme !== "undefined") {
        console.warn("The option `isDarkTheme` is deprecated. Please use `theme` instead.");
        this.theme = isDarkTheme ? "dark" : "light";
      } else {
        switch (newTheme) {
          case "dark":
            this.theme = THEME_DARK;
            break;
          case "light":
          case void 0:
            this.theme = THEME_LIGHT;
            break;
          default:
            console.warn(`Unknown theme "${newTheme}". Using light theme.`);
            this.theme = THEME_LIGHT;
            break;
        }
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent2(e) {
      if (!this.canvasElement)
        return;
      forwardEvent(e, this.canvasElement);
    }
  }, {
    key: "trackDroppedHandler",
    value: function trackDroppedHandler() {
      this.setState({
        draggingHappening: null
      });
    }
  }, {
    key: "requestReceivedHandler",
    value: function requestReceivedHandler() {
      if (!this.viewconfLoaded && requestsInFlight === 0) {
        this.viewconfLoaded = true;
        if (this.props.options.onViewConfLoaded) {
          this.props.options.onViewConfLoaded();
        }
      }
    }
  }, {
    key: "animateOnMouseMoveHandler",
    value: function animateOnMouseMoveHandler(active3) {
      if (active3 && !this.animateOnMouseMove) {
        this.pubSubs.push(this.pubSub.subscribe("app.mouseMove", this.animateBound));
      }
      this.animateOnMouseMove = active3;
    }
  }, {
    key: "fitPixiToParentContainer",
    value: function fitPixiToParentContainer() {
      if (!this.element || !this.element.parentNode) {
        console.warn("No parentNode:", this.element);
        return;
      }
      const width = this.element.parentNode.clientWidth;
      const height2 = this.element.parentNode.clientHeight;
      this.pixiMask.beginFill(16777215).drawRect(0, 0, width, height2).endFill();
      this.pixiRenderer.resize(width, height2);
      this.pixiRenderer.view.style.width = `${width}px`;
      this.pixiRenderer.view.style.height = `${height2}px`;
      this.pixiRenderer.render(this.pixiRoot);
    }
    /**
     * Add default track options. These can come from two places:
     *
     * 1. The track definitions (configs/tracks-info.js)
     * 2. The default options passed into the component
     *
     * Of these, #2 takes precendence over #1.
     *
     * @param {array} track The track to add default options to
     */
  }, {
    key: "addDefaultTrackOptions",
    value: function addDefaultTrackOptions(track) {
      const trackInfo2 = this.getTrackInfo(track.type);
      if (!trackInfo2)
        return;
      if (typeof track.options === "undefined") {
        track.options = {};
      }
      const trackOptions = track.options ? track.options : {};
      if (this.props.options.defaultTrackOptions) {
        if (this.props.options.defaultTrackOptions.trackSpecific && this.props.options.defaultTrackOptions.trackSpecific[track.type]) {
          const options2 = this.props.options.defaultTrackOptions.trackSpecific[track.type];
          for (const optionName in options2) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(options2[optionName]));
          }
        }
        if (this.props.options.defaultTrackOptions.all) {
          const options2 = this.props.options.defaultTrackOptions.all;
          for (const optionName in options2) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(options2[optionName]));
          }
        }
      }
      if (trackInfo2.defaultOptions) {
        const defaultThemeOptions = trackInfo2.defaultOptionsByTheme && trackInfo2.defaultOptionsByTheme[this.theme] ? trackInfo2.defaultOptionsByTheme[this.theme] : {};
        const defaultOptions = {
          ...trackInfo2.defaultOptions,
          ...defaultThemeOptions
        };
        if (!track.options) {
          track.options = JSON.parse(JSON.stringify(defaultOptions));
        } else {
          for (const optionName in defaultOptions) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(defaultOptions[optionName]));
          }
        }
      } else {
        track.options = trackOptions;
      }
    }
  }, {
    key: "toggleTypedEditable",
    value: function toggleTypedEditable() {
      this.setState({
        typedEditable: !this.isEditable()
      });
    }
    /** Handle typed commands (e.g. e-d-i-t) */
  }, {
    key: "typedTextHandler",
    value: function typedTextHandler(event) {
      if (!this.props.options.cheatCodesEnabled) {
        return;
      }
      this.typedText = this.typedText.concat(event.key);
      if (this.typedText.endsWith("hgedit")) {
        this.toggleTypedEditable();
        this.typedText = "";
      }
      const TYPED_TEXT_TIMEOUT = 750;
      if (this.typedTextTimeout) {
        clearTimeout(this.typedTextTimeout);
      }
      this.typedTextTimeout = setTimeout(() => {
        this.typedText = "";
      }, TYPED_TEXT_TIMEOUT);
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(event) {
      this.typedTextHandler(event);
      if (this.props.options.rangeSelectionOnAlt && event.key === "Alt") {
        this.setState({
          mouseTool: MOUSE_TOOL_SELECT
        });
      }
      if (event.key === "Shift") {
        this.setState({
          isShiftDown: true
        });
      }
    }
  }, {
    key: "keyUpHandler",
    value: function keyUpHandler(event) {
      if (event.key === "Shift") {
        this.setState({
          isShiftDown: false
        });
      }
      if (this.props.options.rangeSelectionOnAlt && event.key === "Alt") {
        this.setState({
          mouseTool: MOUSE_TOOL_MOVE
        });
      }
    }
  }, {
    key: "openModal",
    value: function openModal(modal2) {
      this.setState({
        // The following is only needed for testing purposes
        modal: /* @__PURE__ */ React$3.cloneElement(modal2, {
          ref: (c2) => {
            this.modalRef = c2;
          }
        })
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modalRef = null;
      this.setState({
        modal: null
      });
    }
  }, {
    key: "handleEditViewConfig",
    value: function handleEditViewConfig() {
      const {
        viewConfig: viewConfigTmp
      } = this.state;
      this.setState({
        viewConfigTmp
      });
      this.openModal(/* @__PURE__ */ React$3.createElement(ViewConfigEditor$1, {
        onCancel: () => {
          const {
            viewConfigTmp: viewConfig
          } = this.state;
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig,
            viewConfigTmp: null
          });
        },
        onChange: (viewConfigJson) => {
          const viewConfig = JSON.parse(viewConfigJson);
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig
          });
        },
        onSave: (viewConfigJson) => {
          const viewConfig = JSON.parse(viewConfigJson);
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig,
            viewConfigTmp: null
          });
        },
        viewConfig: this.getViewsAsString()
      }));
    }
  }, {
    key: "animate",
    value: function animate() {
      if (this.isRequestingAnimationFrame)
        return;
      this.isRequestingAnimationFrame = true;
      requestAnimationFrame(() => {
        if (!this.pixiRenderer)
          return;
        this.pixiRenderer.render(this.pixiRoot);
        this.isRequestingAnimationFrame = false;
      });
    }
  }, {
    key: "animateOnGlobalEvent",
    value: function animateOnGlobalEvent({
      sourceUid
    } = {}) {
      if (sourceUid !== this.uid && this.animateOnMouseMove)
        this.animate();
    }
  }, {
    key: "measureSize",
    value: function measureSize() {
      const [width, height2] = getElementDim(this.element);
      if (width > 0 && height2 > 0) {
        this.setState({
          sizeMeasured: true,
          width,
          height: height2
        });
      }
    }
  }, {
    key: "updateAfterResize",
    value: function updateAfterResize() {
      this.measureSize();
      this.updateRowHeight();
      this.fitPixiToParentContainer();
      this.refreshView(LONG_DRAG_TIMEOUT);
      this.resizeHandler();
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange(breakpoint) {
      this.setState({
        currentBreakpoint: breakpoint
      });
    }
  }, {
    key: "handleOverlayMouseEnter",
    value: function handleOverlayMouseEnter(uid) {
      this.setState({
        mouseOverOverlayUid: uid
      });
    }
  }, {
    key: "handleOverlayMouseLeave",
    value: function handleOverlayMouseLeave() {
      this.setState({
        mouseOverOverlayUid: null
      });
    }
    /**
     * We want to lock the zoom of this view to the zoom of another view.
     *
     * First we pick which other view we want to lock to.
     *
     * The we calculate the current zoom offset and center offset. The differences
     * between the center of the two views will always remain the same, as will the
     * different between the zoom levels.
     */
  }, {
    key: "handleLockLocation",
    value: function handleLockLocation(uid) {
      this.setState({
        chooseViewHandler: (uid2) => this.handleLocationLockChosen(uid, uid2),
        mouseOverOverlayUid: uid
      });
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isEditable",
    value: function isEditable() {
      if (this.state.typedEditable !== void 0) {
        return this.state.typedEditable;
      }
      if (!this.props.options || !("editable" in this.props.options)) {
        return this.state.viewConfig.editable;
      }
      return this.props.options.editable && this.state.viewConfig.editable;
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isTrackMenuDisabled",
    value: function isTrackMenuDisabled() {
      if (this.props.options && (this.props.options.editable === false || this.props.options.tracksEditable === false)) {
        return true;
      }
      return this.state.viewConfig && (this.state.viewConfig.tracksEditable === false || this.state.viewConfig.editable === false);
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isViewHeaderDisabled",
    value: function isViewHeaderDisabled() {
      if (this.props.options && (this.props.options.editable === false || this.props.options.viewEditable === false)) {
        return true;
      }
      return this.state.viewConfig && (this.state.viewConfig.viewEditable === false || this.state.viewConfig.editable === false);
    }
    /**
     * Iteratate over all of the views in this component
     */
  }, {
    key: "iterateOverViews",
    value: function iterateOverViews() {
      const viewIds = [];
      for (const viewId in Object.keys(this.state.views)) {
        viewIds.push(viewId);
      }
      return viewIds;
    }
  }, {
    key: "iterateOverTracksInView",
    value: function iterateOverTracksInView(viewId) {
      const allTracks = [];
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      for (const trackType in tracks2) {
        for (const track of tracks2[trackType]) {
          if (track.type === "combined" && track.contents) {
            for (const subTrack of track.contents) {
              allTracks.push({
                viewId,
                trackId: subTrack.uid,
                track: subTrack
              });
            }
          } else {
            allTracks.push({
              viewId,
              trackId: track.uid,
              track
            });
          }
        }
      }
      return allTracks;
    }
    /**
     * Iterate over all the tracks in this component.
     */
  }, {
    key: "iterateOverTracks",
    value: function iterateOverTracks() {
      const allTracks = [];
      for (const viewId in this.state.views) {
        const {
          tracks: tracks2
        } = this.state.views[viewId];
        for (const trackType in tracks2) {
          for (const track of tracks2[trackType]) {
            if (track.type === "combined" && track.contents) {
              for (const subTrack of track.contents) {
                allTracks.push({
                  viewId,
                  trackId: subTrack.uid,
                  track: subTrack
                });
              }
            } else {
              allTracks.push({
                viewId,
                trackId: track.uid,
                track
              });
            }
          }
        }
      }
      return allTracks;
    }
  }, {
    key: "setMouseTool",
    value: function setMouseTool(mouseTool) {
      this.setState({
        mouseTool
      });
    }
    /**
     * Checks if a track's value scale is locked with another track
     */
  }, {
    key: "isValueScaleLocked",
    value: function isValueScaleLocked(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid]) {
        return false;
      }
      if (this.valueScaleLocks[uid]) {
        return true;
      }
      return false;
    }
    /**
     * Computed the minimal and maximal values of all tracks that are in the same
     * lockGroup as a given track
     * @param   {string}  viewUid  The id of the view containing the track
     * @param   {string}  trackUid   The id of the track
     * @return  {array}  Tuple [min,max] containing the overall extrema - or null.
     */
  }, {
    key: "getLockGroupExtrema",
    value: function getLockGroupExtrema(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid]) {
        return null;
      }
      if (!this.valueScaleLocks[uid]) {
        return null;
      }
      const lockGroup = this.valueScaleLocks[uid];
      const lockedTracks = Object.values(lockGroup).filter((track) => this.tiledPlots[track.view]).map((track) => this.tiledPlots[track.view].trackRenderer.getTrackObject(track.track)).filter((track) => track).map((track) => track.originalTrack === void 0 ? track : track.originalTrack);
      const minValues = lockedTracks.filter((track) => track.minRawValue && track.maxRawValue).map((track) => lockGroup.ignoreOffScreenValues ? track.minVisibleValue(true) : track.minVisibleValueInTiles(true));
      const maxValues = lockedTracks.filter((track) => track.minRawValue && track.maxRawValue).map((track) => lockGroup.ignoreOffScreenValues ? track.maxVisibleValue(true) : track.maxVisibleValueInTiles(true));
      if (minValues.length === 0 || minValues.filter((x) => x === null || x === Infinity).length > 0) {
        return null;
      }
      if (maxValues.length === 0 || maxValues.filter((x) => x === null || x === -Infinity).length > 0) {
        return null;
      }
      const allMin = Math.min(...minValues);
      const allMax = Math.max(...maxValues);
      return [allMin, allMax];
    }
    /**
     * Syncing the values of locked scales
     *
     * Arguments
     * ---------
     *  viewUid: string
     *    The id of the view containing the track whose value scale initially changed
     *  trackUid: string
     *    The id of the track that whose value scale changed
     *
     * Returns
     * -------
     *    Nothing
     */
  }, {
    key: "syncValueScales",
    value: function syncValueScales(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid])
        return;
      const sourceTrack = getTrackByUid(this.state.views[viewUid].tracks, trackUid);
      if (this.valueScaleLocks[uid]) {
        const lockGroup = this.valueScaleLocks[uid];
        const lockedTracks = Object.values(lockGroup).filter((track) => this.tiledPlots[track.view]).map((track) => this.tiledPlots[track.view].trackRenderer.getTrackObject(track.track)).filter((track) => track).map((track) => track.originalTrack === void 0 ? track : track.originalTrack);
        const lockGroupExtrema = this.getLockGroupExtrema(viewUid, trackUid);
        if (lockGroupExtrema === null) {
          return;
        }
        const allMin = lockGroupExtrema[0];
        const allMax = lockGroupExtrema[1];
        const epsilon3 = 1e-6;
        for (const lockedTrack of lockedTracks) {
          if (lockedTrack.minValue) {
            lockedTrack.minValue(allMin);
          }
          if (lockedTrack.maxValue) {
            lockedTrack.maxValue(allMax);
          }
          if (!lockedTrack.valueScale) {
            continue;
          }
          const hasScaleChanged = Math.abs(lockedTrack.minValue() - lockedTrack.valueScale.domain()[0]) > epsilon3 || Math.abs(lockedTrack.maxValue() - lockedTrack.valueScale.domain()[1]) > epsilon3;
          let hasBrushMoved = false;
          try {
            hasBrushMoved = sourceTrack.options && lockedTrack.options && typeof sourceTrack.options.scaleStartPercent !== "undefined" && typeof sourceTrack.options.scaleEndPercent !== "undefined" && (Math.abs(lockedTrack.options.scaleStartPercent - sourceTrack.options.scaleStartPercent) > epsilon3 || Math.abs(lockedTrack.options.scaleEndPercent - sourceTrack.options.scaleEndPercent) > epsilon3);
          } catch (e) {
          }
          if (lockedTrack.continuousScaling && !hasScaleChanged && !hasBrushMoved) {
            continue;
          }
          lockedTrack.valueScale.domain([allMin, allMax]);
          lockedTrack.prevValueScale = lockedTrack.valueScale.copy();
          if (hasBrushMoved) {
            lockedTrack.options.scaleStartPercent = sourceTrack.options.scaleStartPercent;
            lockedTrack.options.scaleEndPercent = sourceTrack.options.scaleEndPercent;
          }
          lockedTrack.rerender(lockedTrack.options, true);
        }
      }
    }
  }, {
    key: "handleNewTilesLoaded",
    value: function handleNewTilesLoaded(viewUid, trackUid) {
      this.animate();
    }
  }, {
    key: "notifyDragChangedListeners",
    value: function notifyDragChangedListeners(dragging) {
      dictValues(this.draggingChangedListeners).forEach((l) => {
        dictValues(l).forEach((listener) => listener(dragging));
      });
    }
    /**
     * Add a listener that will be called every time the view is updated.
     *
     * @param viewUid: The uid of the view being observed
     * @param listenerUid: The uid of the listener
     * @param eventHandler: The handler to be called when the scales change
     *    Event handler is called with parameters (xScale, yScale)
     */
  }, {
    key: "addDraggingChangedListener",
    value: function addDraggingChangedListener(viewUid, listenerUid, eventHandler) {
      if (!this.draggingChangedListeners.hasOwnProperty(viewUid)) {
        this.draggingChangedListeners[viewUid] = {};
      }
      this.draggingChangedListeners[viewUid][listenerUid] = eventHandler;
      eventHandler(true);
      eventHandler(false);
    }
    /**
     * Remove a scale change event listener
     *
     * @param viewUid: The view that it's listening on.
     * @param listenerUid: The uid of the listener itself.
     */
  }, {
    key: "removeDraggingChangedListener",
    value: function removeDraggingChangedListener(viewUid, listenerUid) {
      if (this.draggingChangedListeners.hasOwnProperty(viewUid)) {
        const listeners = this.draggingChangedListeners[viewUid];
        if (listeners.hasOwnProperty(listenerUid)) {
          listeners[listenerUid](false);
          delete listeners[listenerUid];
        }
      }
    }
    /**
     * Add an event listener that will be called every time the scale
     * of the view with uid viewUid is changed.
     *
     * @param viewUid: The uid of the view being observed
     * @param listenerUid: The uid of the listener
     * @param eventHandler: The handler to be called when the scales change
     *    Event handler is called with parameters (xScale, yScale)
     */
  }, {
    key: "addScalesChangedListener",
    value: function addScalesChangedListener(viewUid, listenerUid, eventHandler) {
      if (!this.scalesChangedListeners[viewUid]) {
        this.scalesChangedListeners[viewUid] = {};
      }
      this.scalesChangedListeners[viewUid][listenerUid] = eventHandler;
      if (!this.xScales[viewUid] || !this.yScales[viewUid]) {
        return;
      }
      eventHandler(this.xScales[viewUid], this.yScales[viewUid]);
    }
    /**
     * Remove a scale change event listener
     *
     * @param viewUid: The view that it's listening on.
     * @param listenerUid: The uid of the listener itself.
     */
  }, {
    key: "removeScalesChangedListener",
    value: function removeScalesChangedListener(viewUid, listenerUid) {
      if (this.scalesChangedListeners[viewUid]) {
        const listeners = this.scalesChangedListeners[viewUid];
        if (listeners[listenerUid]) {
          delete listeners[listenerUid];
        }
      }
    }
  }, {
    key: "createSVG",
    value: function createSVG() {
      const svg = document.createElement("svg");
      svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("version", "1.1");
      for (const tiledPlot of dictValues(this.tiledPlots)) {
        if (!tiledPlot)
          continue;
        for (const trackDefObject of dictValues(tiledPlot.trackRenderer.trackDefObjects)) {
          if (trackDefObject.trackObject.exportSVG) {
            const trackSVG = trackDefObject.trackObject.exportSVG();
            if (trackSVG)
              svg.appendChild(trackSVG[0]);
          }
        }
      }
      svg.setAttribute("width", this.canvasElement.style.width);
      svg.setAttribute("height", this.canvasElement.style.height);
      if (this.postCreateSVGCallback) {
        const modifiedSvg = this.postCreateSVGCallback(svg);
        return modifiedSvg;
      }
      return svg;
    }
  }, {
    key: "createSVGString",
    value: function createSVGString() {
      const svg = this.createSVG();
      let svgString = vkbeautify$1.xml(new window.XMLSerializer().serializeToString(svg));
      svgString = svgString.replace(/<a0:/g, "<");
      svgString = svgString.replace(/<\/a0:/g, "</");
      svgString = svgString.replace(/(<svg[\n\r])(\s+xmlns="http:\/\/www\.w3\.org\/1999\/xhtml"[\n\r])/gm, "$1");
      svgString = svgString.replace(/(\s+<clipPath[\n\r]\s+)(xmlns="http:\/\/www\.w3\.org\/2000\/svg")/gm, "$1");
      svgString = svgString.replace('xmlns="http://www.w3.org/1999/xhtml"', "");
      const xmlDeclaration = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>';
      const doctype2 = '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';
      return `${xmlDeclaration}
${doctype2}
${svgString}`;
    }
  }, {
    key: "handleExportSVG",
    value: function handleExportSVG() {
      download("export.svg", new Blob([this.createSVGString()], {
        type: "image/svg+xml"
      }));
    }
  }, {
    key: "offPostCreateSVG",
    value: function offPostCreateSVG() {
      this.postCreateSVGCallback = null;
    }
  }, {
    key: "onPostCreateSVG",
    value: function onPostCreateSVG(callback) {
      this.postCreateSVGCallback = callback;
    }
  }, {
    key: "createPNGBlobPromise",
    value: function createPNGBlobPromise() {
      return new Promise((resolve2) => {
        const svgString = this.createSVGString();
        const img = new Image(this.canvasElement.width, this.canvasElement.height);
        img.src = `data:image/svg+xml;base64,${btoa(svgString)}`;
        img.onload = () => {
          const targetCanvas = document.createElement("canvas");
          targetCanvas.width = this.canvasElement.width / 2;
          targetCanvas.height = this.canvasElement.height / 2;
          const ctx = targetCanvas.getContext("2d");
          ctx.globalCompositeOperation = "source-over";
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, targetCanvas.width, targetCanvas.height);
          targetCanvas.getContext("2d").drawImage(img, 0, 0);
          targetCanvas.toBlob((blob) => {
            resolve2(blob);
          });
        };
      });
    }
  }, {
    key: "handleExportPNG",
    value: function handleExportPNG() {
      this.createPNGBlobPromise().then((blob) => {
        download("export.png", blob);
      });
    }
    /*
     * The scales of some view have changed (presumably in response to zooming).
     *
     * Mark the new scales and update any locked views.
     *
     * @param uid: The view of whom the scales have changed.
     */
  }, {
    key: "handleScalesChanged",
    value: function handleScalesChanged(uid, xScale, yScale, notify = true) {
      this.xScales[uid] = xScale;
      this.yScales[uid] = yScale;
      if (notify) {
        if (uid in this.scalesChangedListeners) {
          dictValues(this.scalesChangedListeners[uid]).forEach((x) => {
            x(xScale, yScale);
          });
        }
      }
      if (this.zoomLocks[uid]) {
        const lockGroup = this.zoomLocks[uid];
        const lockGroupItems = dictItems(lockGroup);
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value2 = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          if (key === uid) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          const rk = value2[2] / lockGroup[uid][2];
          const newK = k * rk;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](keyCenterX, keyCenterY, newK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (this.scalesChangedListeners.hasOwnProperty(key)) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocks[uid]) {
        const lockGroup = this.locationLocks[uid];
        const lockGroupItems = dictItems(lockGroup);
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value2 = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dx = value2[0] - lockGroup[uid][0];
          const dy = value2[1] - lockGroup[uid][1];
          const newCenterX = centerX + dx;
          const newCenterY = centerY + dy;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](newCenterX, newCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (this.scalesChangedListeners.hasOwnProperty(key)) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocksAxisWise.x[uid]) {
        const lockGroup = this.locationLocksAxisWise.x[uid].lock;
        const lockGroupItems = dictItems(lockGroup);
        const lockCrossAxis = this.locationLocksAxisWise.x[uid].axis !== "x";
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value2 = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dx = value2[0] - lockGroup[uid][0];
          const newCenterX = centerX + dx;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](lockCrossAxis ? keyCenterX : newCenterX, lockCrossAxis ? newCenterX : keyCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (this.scalesChangedListeners.hasOwnProperty(key)) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocksAxisWise.y[uid]) {
        const lockGroup = this.locationLocksAxisWise.y[uid].lock;
        const lockGroupItems = dictItems(lockGroup);
        const lockCrossAxis = this.locationLocksAxisWise.y[uid].axis !== "y";
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value2 = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dy = value2[1] - lockGroup[uid][1];
          const newCenterY = centerY + dy;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](lockCrossAxis ? newCenterY : keyCenterX, lockCrossAxis ? keyCenterY : newCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (this.scalesChangedListeners.hasOwnProperty(key)) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      this.animate();
      this.triggerViewChangeDb();
    }
  }, {
    key: "handleProjectViewport",
    value: function handleProjectViewport(uid) {
      this.setState({
        chooseTrackHandler: (viewUid, trackUid) => this.handleViewportProjected(uid, viewUid, trackUid)
      });
    }
    /**
     * Adjust the zoom level so that all of the data is visible
     *
     * @param viewUid: The view uid for which to adjust the zoom level
     */
  }, {
    key: "handleZoomToData",
    value: function handleZoomToData(viewUid) {
      if (viewUid && !this.tiledPlots[viewUid]) {
        throw new Error(`View uid ${viewUid} does not exist in the current viewConfig`);
      }
      if (viewUid) {
        this.tiledPlots[viewUid].handleZoomToData();
      } else {
        Object.values(this.tiledPlots).forEach((tiledPlot) => tiledPlot.handleZoomToData());
      }
    }
    /**
     * Reset the viewport to the initial x and y domain
     * @param  {number} viewId - ID of the view for which the viewport should be
     *  reset.
     */
  }, {
    key: "resetViewport",
    value: function resetViewport(viewId) {
      if (viewId && !this.tiledPlots[viewId]) {
        throw new Error(`View uid ${viewId} does not exist in the current viewConfig`);
      }
      if (viewId) {
        this.tiledPlots[viewId].resetViewport();
      } else {
        Object.values(this.tiledPlots).forEach((tiledPlot) => tiledPlot.resetViewport());
      }
    }
    /**
     * We want to yank some attributes from another view.
     *
     * This will create a view selection overlay and then call the selected
     * provided function.
     */
  }, {
    key: "handleYankFunction",
    value: function handleYankFunction(uid, yankFunction) {
      this.setState({
        chooseViewHandler: (uid2) => yankFunction(uid, uid2),
        mouseOverOverlayUid: uid
      });
    }
    /**
     * We want to unlock uid from the zoom group that it's in.
     *
     * @param uid: The uid of a view.
     */
  }, {
    key: "handleUnlock",
    value: function handleUnlock(uid, lockGroups) {
      const lockGroup = lockGroups[uid];
      const lockGroupKeys = dictKeys(lockGroup);
      if (lockGroupKeys.length === 2) {
        delete lockGroups[lockGroupKeys[0]];
        delete lockGroups[lockGroupKeys[1]];
        return;
      }
      if (lockGroups[uid]) {
        if (lockGroups[uid][uid]) {
          delete lockGroups[uid][uid];
        }
      }
      if (lockGroups[uid]) {
        delete lockGroups[uid];
      }
    }
  }, {
    key: "viewScalesLockData",
    value: function viewScalesLockData(uid) {
      if (!this.xScales[uid] || !this.yScales[uid]) {
        console.warn("View scale lock doesn't correspond to existing uid: ", uid);
        return null;
      }
      return scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
    }
    /*
     * :param uid1 (string): The uid of the first element to be locked (e.g. viewUid)
     * :param uid2 (string): The uid of the second element to be locked (e.g. viewUid)
     * :param lockGroups (dict): The set of locks where to store this lock (e.g. this.locationLocks)
     * :parma lockData (function): A function that takes two uids and calculates some extra data
     * to store with this lock data (e.g. scalesCenterAndK(this.xScales[uid1], this.yScales[uid1]))
     */
  }, {
    key: "addLock",
    value: function addLock(uid1, uid2, lockGroups, lockData) {
      let group1Members = [];
      let group2Members = [];
      if (!lockGroups[uid1]) {
        group1Members = [[uid1, lockData.bind(this)(uid1)]];
      } else {
        group1Members = dictItems(lockGroups[uid1]).filter((x) => lockData(x[0])).map((x) => [x[0], lockData(x[0])]);
      }
      if (!lockGroups[uid2]) {
        group2Members = [[uid2, lockData.bind(this)(uid2)]];
      } else {
        group2Members = dictItems(lockGroups[uid2]).filter((x) => lockData.bind(this)(x[0])).map((x) => (
          // x is [uid, [centerX, centerY, k]]
          [x[0], lockData.bind(this)(x[0])]
        ));
      }
      const allMembers = group1Members.concat(group2Members);
      const groupDict = dictFromTuples(allMembers);
      allMembers.forEach((m) => {
        lockGroups[m[0]] = groupDict;
      });
    }
    /* Views uid1 and uid2 need to be locked so that they always maintain the current
     * zoom and translation difference.
     * @param uid1: The view that the lock was called from
     * @param uid2: The view that the lock was called on (the view that was selected)
     */
  }, {
    key: "handleLocationLockChosen",
    value: function handleLocationLockChosen(uid1, uid2) {
      if (uid1 === uid2) {
        this.setState({
          chooseViewHandler: null
        });
        return;
      }
      this.addLock(uid1, uid2, this.locationLocks, this.viewScalesLockData.bind(this));
      this.setState({
        chooseViewHandler: null
      });
    }
    /* Views uid1 and uid2 need to be locked so that they always maintain the current
     * zoom and translation difference.
     * @param uid1: The view that the lock was called from
     * @param uid2: The view that the lock was called on (the view that was selected)
     */
  }, {
    key: "handleZoomLockChosen",
    value: function handleZoomLockChosen(uid1, uid2) {
      if (uid1 === uid2) {
        this.setState({
          chooseViewHandler: null
        });
        return;
      }
      this.addLock(uid1, uid2, this.zoomLocks, this.viewScalesLockData.bind(this));
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * We want to project the viewport of fromView onto toTrack of toView.
     *
     * @param fromView: The uid of the view that we want to project
     * @param toView: The uid of the view that we want to project to
     * @param toTrack: The track we want to project to
     *
     * Returns
     * -------
     *
     *  newTrackUid: string
     *      The uid of the newly created viewport projection track
     */
  }, {
    key: "handleViewportProjected",
    value: function handleViewportProjected(fromView, toView, toTrack) {
      let newTrackUid = null;
      if (fromView === toView) {
        console.warn("A view can not show its own viewport.");
      } else {
        const hostTrack = getTrackByUid(this.state.views[toView].tracks, toTrack);
        const position = getTrackPositionByUid(this.state.views[toView].tracks, toTrack);
        newTrackUid = slugid$1.nice();
        const projectionTypes = {
          top: "horizontal",
          bottom: "horizontal",
          center: "center",
          left: "vertical",
          right: "vertical"
        };
        const newTrack = {
          uid: newTrackUid,
          type: `viewport-projection-${projectionTypes[position]}`,
          fromViewUid: fromView
        };
        this.addCallbacks(toView, newTrack);
        this.handleTrackAdded(toView, newTrack, position, hostTrack);
      }
      this.setState({
        chooseTrackHandler: null
      });
      return newTrackUid;
    }
    /**
     * Uid1 is copying the center of uid2
     */
  }, {
    key: "handleLocationYanked",
    value: function handleLocationYanked(uid1, uid2) {
      const sourceXScale = this.xScales[uid2];
      const sourceYScale = this.yScales[uid2];
      const targetXScale = this.xScales[uid1];
      const targetYScale = this.yScales[uid1];
      const [targetCenterX, targetCenterY, targetK] = scalesCenterAndK(targetXScale, targetYScale);
      const [sourceCenterX, sourceCenterY, sourceK] = scalesCenterAndK(sourceXScale, sourceYScale);
      this.setCenters[uid1](sourceCenterX, sourceCenterY, targetK, true);
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * Uid1 yanked the zoom of uid2, now  make sure that they're synchronized.
     */
  }, {
    key: "handleZoomYanked",
    value: function handleZoomYanked(uid1, uid2) {
      const sourceXScale = this.xScales[uid2];
      const sourceYScale = this.yScales[uid2];
      const targetXScale = this.xScales[uid1];
      const targetYScale = this.yScales[uid1];
      const [targetCenterX, targetCenterY, targetK] = scalesCenterAndK(targetXScale, targetYScale);
      const [sourceCenterX, sourceCenterY, sourceK] = scalesCenterAndK(sourceXScale, sourceYScale);
      this.setCenters[uid1](targetCenterX, targetCenterY, sourceK, true);
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * The user has chosen a position for the new track. The actual
     * track selection will be handled by TiledPlot
     *
     * We just need to close the menu here.
     */
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(viewUid, position) {
      this.setState({
        addTrackPosition: position,
        addTrackPositionView: viewUid
      });
    }
    /**
     * Update the height of each row in the layout so that it takes up all
     * of the available space in the div.
     */
  }, {
    key: "updateRowHeight",
    value: function updateRowHeight() {
      if (!this.props.options || this.sizeMode !== SIZE_MODE_BOUNDED || this.props.options.pixelPreciseMarginPadding) {
        return;
      }
      const height2 = this.element.parentNode.clientHeight;
      let maxHeight = 0;
      for (const view of dictValues(this.state.views)) {
        maxHeight = Math.max(maxHeight, view.layout.y + view.layout.h);
      }
      this.handleDragStart();
      this.handleDragStop();
      const MARGIN_HEIGHT = this.isEditable() ? 10 : 0;
      const marginHeight = MARGIN_HEIGHT * maxHeight - 1;
      const availableHeight = height2 - marginHeight;
      const prospectiveRowHeight = availableHeight / maxHeight;
      const chosenRowHeight = Math.floor(prospectiveRowHeight);
      this.setState({
        rowHeight: chosenRowHeight
      });
    }
    /**
     * Notify the children that the layout has changed so that they
     * know to redraw themselves
     */
  }, {
    key: "handleLayoutChange",
    value: function handleLayoutChange(layout2) {
      if (!this.element)
        return;
      layout2.forEach((l) => {
        const view = this.state.views[l.i];
        if (view) {
          view.layout.x = l.x;
          view.layout.y = l.y;
          view.layout.w = l.w;
          view.layout.h = l.h;
          view.layout.i = l.i;
        }
      });
      this.updateRowHeight();
      this.refreshView(LONG_DRAG_TIMEOUT);
    }
    /**
     * Maybe somebody started dragging again before the previous drag
     * timeout fired. In that case, we need to clear this timeout so
     * that it doesn't override a previously set one.
     */
  }, {
    key: "clearDragTimeout",
    value: function clearDragTimeout() {
      if (this.dragTimeout) {
        clearTimeout(this.dragTimeout);
        this.dragTimeout = null;
      }
    }
  }, {
    key: "getTrackInfo",
    value: function getTrackInfo(trackType) {
      if (TRACKS_INFO_BY_TYPE[trackType]) {
        return TRACKS_INFO_BY_TYPE[trackType];
      }
      if (this.pluginTracks && this.pluginTracks[trackType]) {
        return this.pluginTracks[trackType].config;
      }
      if (window.higlassTracksByType && window.higlassTracksByType[trackType]) {
        return window.higlassTracksByType[trackType].config;
      }
      console.warn("Track type not found:", trackType, "(check app/scripts/config/ for a list of defined track types)");
      return void 0;
    }
  }, {
    key: "forceRefreshView",
    value: function forceRefreshView() {
      this.setState(this.state);
    }
  }, {
    key: "refreshView",
    value: function refreshView(timeout2 = SHORT_DRAG_TIMEOUT) {
      this.clearDragTimeout();
      this.notifyDragChangedListeners(true);
      this.clearDragTimeout();
      this.dragTimeout = setTimeout(() => {
        this.notifyDragChangedListeners(false);
      }, timeout2);
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart() {
      this.clearDragTimeout();
      this.notifyDragChangedListeners(true);
    }
  }, {
    key: "handleDragStop",
    value: function handleDragStop() {
      this.clearDragTimeout();
      this.dragTimeout = setTimeout(() => {
        this.notifyDragChangedListeners(false);
      }, LONG_DRAG_TIMEOUT);
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      objVals(this.viewHeaders).filter((x) => x).forEach((viewHeader) => viewHeader.checkWidth());
    }
    /**
     * Get the dimensions for this view, counting just the tracks
     * that are present in it
     *
     * @param view: A view containing a list of tracks as a member.
     * @return: A width and a height pair (e.g. [width, height])
     */
  }, {
    key: "calculateViewDimensions",
    value: function calculateViewDimensions(view) {
      const defaultHorizontalHeight = 20;
      const defaultVerticalWidth = 0;
      const defaultCenterHeight = 100;
      const defaultCenterWidth = 100;
      let currHeight = this.viewMarginTop + this.viewMarginBottom + this.viewPaddingTop + this.viewPaddingBottom;
      let currWidth = this.viewMarginLeft + this.viewMarginRight + this.viewPaddingLeft + this.viewPaddingRight;
      let minNecessaryHeight = 0;
      minNecessaryHeight += 10;
      const MIN_VERTICAL_HEIGHT = 20;
      if (view.tracks.top) {
        for (let i = 0; i < view.tracks.top.length; i++) {
          const track = view.tracks.top[i];
          currHeight += track.height ? track.height : defaultHorizontalHeight;
          minNecessaryHeight += track.height ? track.height : defaultHorizontalHeight;
        }
      }
      if (view.tracks.bottom) {
        for (let i = 0; i < view.tracks.bottom.length; i++) {
          const track = view.tracks.bottom[i];
          currHeight += track.height ? track.height : defaultHorizontalHeight;
          minNecessaryHeight += track.height ? track.height : defaultHorizontalHeight;
        }
      }
      if (view.tracks.left && view.tracks.left.length > 0 || view.tracks.right && view.tracks.right.length > 0 || view.tracks.center && view.tracks.center.length > 0) {
        minNecessaryHeight += MIN_VERTICAL_HEIGHT;
      }
      let leftHeight = 0;
      if (view.tracks.left) {
        for (let i = 0; i < view.tracks.left.length; i++) {
          const track = view.tracks.left[i];
          const thisHeight = track.height ? track.height : defaultCenterHeight;
          currWidth += track.width ? track.width : defaultVerticalWidth;
          leftHeight = Math.max(leftHeight, thisHeight);
        }
      }
      let rightHeight = 0;
      if (view.tracks.right) {
        for (let i = 0; i < view.tracks.right.length; i++) {
          const track = view.tracks.right[i];
          const thisHeight = track.height ? track.height : defaultCenterHeight;
          currWidth += track.width ? track.width : defaultVerticalWidth;
          rightHeight = Math.max(rightHeight, thisHeight);
        }
      }
      const sideHeight = Math.max(leftHeight, rightHeight);
      let centerHeight = 0;
      let centerWidth = 0;
      if (view.tracks.center && dictValues(view.tracks.center).length > 0) {
        if (!view.tracks.center[0].contents || view.tracks.center[0].contents.length > 0) {
          let height2 = null;
          let width = null;
          if (view.tracks.center[0].contents) {
            for (const track of view.tracks.center[0].contents) {
              height2 = Math.max(height2, track.height ? track.height : defaultCenterHeight);
              width = Math.max(width, track.width ? track.width : defaultCenterWidth);
            }
          } else {
            height2 = view.tracks.center[0].height ? view.tracks.center[0].height : defaultCenterHeight;
            width = view.tracks.center[0].width ? view.tracks.center[0].width : defaultCenterWidth;
          }
          currHeight += height2;
          currWidth += width;
        }
      } else if ((view.tracks.top && dictValues(view.tracks.top).length > 1 || view.tracks.bottom && dictValues(view.tracks.bottom).length > 1) && (view.tracks.left && dictValues(view.tracks.left).length || view.tracks.right && dictValues(view.tracks.right).length)) {
        centerWidth = defaultCenterWidth;
        centerHeight = defaultCenterHeight;
      }
      if (sideHeight > centerHeight) {
        currHeight += sideHeight;
      } else {
        currHeight += centerHeight;
      }
      let topHeight = 0;
      let bottomHeight = 0;
      let leftWidth = 0;
      let rightWidth = 0;
      if ("top" in view.tracks) {
        topHeight = view.tracks.top.map((x) => x.height ? x.height : defaultHorizontalHeight).reduce((a, b) => a + b, 0);
      }
      if ("bottom" in view.tracks) {
        bottomHeight = view.tracks.bottom.map((x) => x.height ? x.height : defaultHorizontalHeight).reduce((a, b) => a + b, 0);
      }
      if ("left" in view.tracks) {
        leftWidth = view.tracks.left.map((x) => x.width ? x.width : defaultVerticalWidth).reduce((a, b) => a + b, 0);
      }
      if ("right" in view.tracks) {
        rightWidth = view.tracks.right.map((x) => x.width ? x.width : defaultVerticalWidth).reduce((a, b) => a + b, 0);
      }
      return {
        totalWidth: currWidth,
        totalHeight: currHeight,
        topHeight,
        bottomHeight,
        leftWidth,
        rightWidth,
        centerWidth,
        centerHeight,
        minNecessaryHeight
      };
    }
  }, {
    key: "calculateZoomLimits",
    value: function calculateZoomLimits(view, initialXDomain) {
      const limits = [0, Infinity];
      const viewConfLimit = view.zoomLimits || [1, null];
      const diffX = initialXDomain[1] - initialXDomain[0];
      if (viewConfLimit.length !== 2) {
        return limits;
      }
      if (viewConfLimit[0] !== null && viewConfLimit[0] > 0) {
        const upperLimit = diffX / viewConfLimit[0];
        limits[1] = Math.max(upperLimit, 1);
        if (upperLimit < 1) {
          console.warn(`Invalid zoom limits. Lower limit set to ${diffX}`);
        }
      }
      if (viewConfLimit[1] !== null && viewConfLimit[1] > viewConfLimit[0]) {
        const lowerLimit = diffX / viewConfLimit[1];
        limits[0] = Math.min(lowerLimit, 1);
        if (lowerLimit > 1) {
          console.warn(`Invalid zoom limits. Upper limit set to ${diffX}`);
        }
      }
      return limits;
    }
  }, {
    key: "generateViewLayout",
    value: function generateViewLayout(view) {
      let layout2 = null;
      if ("layout" in view) {
        ({
          layout: layout2
        } = view.layout);
      } else {
        layout2 = {
          x: 0,
          y: 0,
          w: NUM_GRID_COLUMNS,
          h: DEFAULT_NEW_VIEW_HEIGHT
        };
      }
      return layout2;
    }
    /**
     * Remove all the tracks from a view
     *
     * @param {viewUid} Thie view's identifier
     */
  }, {
    key: "handleClearView",
    value: function handleClearView(viewUid) {
      const {
        views
      } = this.state;
      views[viewUid].tracks.top = [];
      views[viewUid].tracks.bottom = [];
      views[viewUid].tracks.center = [];
      views[viewUid].tracks.left = [];
      views[viewUid].tracks.right = [];
      views[viewUid].tracks.whole = [];
      this.setState({
        views
      });
    }
    /**
     * A view needs to be closed. Remove it from from the viewConfig and then clean
     * up all of its connections (zoom links, workers, etc...)
     *
     * @param {uid} This view's identifier
     */
  }, {
    key: "handleCloseView",
    value: function handleCloseView(uid) {
      if (dictValues(this.state.views).length === 1) {
        return;
      }
      this.handleUnlock(uid, this.zoomLocks);
      this.setState((prevState) => {
        delete prevState.views[uid];
        const viewsByUid = this.removeInvalidTracks(prevState.views);
        return {
          views: viewsByUid
        };
      });
    }
    /**
     * We're adding a new dataset to an existing track
     *
     * @param newTrack: The new track to be added.
     * @param position: Where the new series should be placed.
     *  (This could also be inferred from the hostTrack, but since
     *  we already have it, we might as well use it)
     * @param hostTrack: The track that will host the new series.
     */
  }, {
    key: "handleSeriesAdded",
    value: function handleSeriesAdded(viewId, newTrack, position, hostTrack) {
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      if (hostTrack.type === "combined") {
        hostTrack.contents.push(newTrack);
        if (newTrack.type === "heatmap") {
          this.compatibilityfyStackedHeatmaps(newTrack, hostTrack);
        }
      } else {
        const newHost = {
          type: "combined",
          uid: slugid$1.nice(),
          height: hostTrack.height,
          width: hostTrack.width,
          contents: [hostTrack, newTrack]
        };
        const positionTracks = tracks2[position];
        for (let i = 0; i < positionTracks.length; i++) {
          if (positionTracks[i].uid === hostTrack.uid) {
            positionTracks[i] = newHost;
          }
        }
      }
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
  }, {
    key: "handleNoTrackAdded",
    value: function handleNoTrackAdded() {
      if (this.state.addTrackPosition) {
        this.setState({
          addTrackPosition: null
        });
      }
    }
    /**
     * Add multiple new tracks (likely from the AddTrackModal dialog)
     *
     * @param trackInfo: A JSON object that can be used as a track
     *                   definition
     * @param position: The position the track is being added to
     * @param host: If this track is being added to another track
     */
  }, {
    key: "handleTracksAdded",
    value: function handleTracksAdded(viewId, newTracks, position, host) {
      this.storeTrackSizes(viewId);
      for (const newTrack of newTracks) {
        this.handleTrackAdded(viewId, newTrack, position, host);
      }
    }
    /**
     * Change the type of a track. For example, convert a line to a bar track.
     *
     * Parameters
     * ----------
     *  viewUid: string
     *    The view containing the track to be changed
     *  trackUid: string
     *    The uid identifying the existin track
     *  newType: string
     *    The type to switch this track to.
     */
  }, {
    key: "handleChangeTrackType",
    value: function handleChangeTrackType(viewUid, trackUid, newType) {
      const view = this.state.views[viewUid];
      const trackConfig = getTrackByUid(view.tracks, trackUid);
      const oldUid = trackConfig.uid;
      trackConfig.uid = slugid$1.nice();
      trackConfig.type = newType;
      const newUid = trackConfig.uid;
      this.updateTrackLocks(viewUid, oldUid, newUid);
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
    /**
     * Change the data source for a track. E.g. when adding or
     * removing a divisor.
     *
     * Parameters
     * ----------
     *  viewUid: string
     *    The view containing the track to be changed
     *  trackUid: string
     *    The uid identifying the existin track
     *  newData: object
     *    The new data source section
     */
  }, {
    key: "handleChangeTrackData",
    value: function handleChangeTrackData(viewUid, trackUid, newData) {
      const view = this.state.views[viewUid];
      const trackConfig = getTrackByUid(view.tracks, trackUid);
      trackConfig.uid = slugid$1.nice();
      trackConfig.data = newData;
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
    /**
     * A track was added from the AddTrackModal dialog.
     *
     * @param trackInfo: A JSON object that can be used as a track
     *                   definition
     * @param position: The position the track is being added to
     * @param host: If this track is being added to another track
     *
     * @returns {Object}: A trackConfig (\{ uid: "", width: x \})
     *  describing this track
     */
  }, {
    key: "handleTrackAdded",
    value: function handleTrackAdded(viewId, newTrack, position, host = null) {
      this.addDefaultTrackOptions(newTrack);
      if (!newTrack.uid)
        newTrack.uid = slugid$1.nice();
      if (newTrack.contents) {
        for (const ct of newTrack.contents) {
          this.addDefaultTrackOptions(ct);
        }
      }
      if (this.state.addTrackPosition) {
        this.setState({
          addTrackPosition: null
        });
      }
      if (host) {
        this.handleSeriesAdded(viewId, newTrack, position, host);
        return null;
      }
      newTrack.position = position;
      const trackInfo2 = this.getTrackInfo(newTrack.type);
      newTrack.width = trackInfo2.defaultWidth || trackInfo2.defaultOptions && trackInfo2.defaultOptions.minWidth || this.minVerticalWidth;
      newTrack.height = trackInfo2.defaultHeight || trackInfo2.defaultOptions && trackInfo2.defaultOptions.minHeight || this.minHorizontalHeight;
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      let numTracks = 0;
      visitPositionedTracks(tracks2, () => numTracks++);
      if (position === "left" || position === "top") {
        tracks2[position].unshift(newTrack);
      } else if (position === "center") {
        if (tracks2.center.length === 0) {
          const newCombined = {
            uid: slugid$1.nice(),
            type: "combined",
            contents: [newTrack]
          };
          tracks2.center = [newCombined];
        } else if (tracks2.center[0].type === "combined") {
          tracks2.center[0].contents.push(newTrack);
          if (newTrack.type === "heatmap") {
            this.compatibilityfyStackedHeatmaps(newTrack, tracks2.center[0]);
          }
        } else {
          const newCombined = {
            uid: slugid$1.nice(),
            type: "combined",
            contents: [tracks2.center[0], newTrack]
          };
          tracks2.center = [newCombined];
          if (newTrack.type === "heatmap") {
            this.compatibilityfyStackedHeatmaps(newTrack, newCombined);
          }
        }
      } else {
        if (!tracks2[position]) {
          tracks2[position] = [];
        }
        tracks2[position].push(newTrack);
      }
      this.adjustLayoutToTrackSizes(this.state.views[viewId]);
      if (Object.keys(this.state.views).length === 1 && numTracks === 0) {
        this.handleZoomToData(viewId);
        this.zoomToDataExtentOnInit.add(viewId);
      }
      return newTrack;
    }
    /**
     * We're adding a new heatmap to a combined track. We need to make sure that
     * their options are compatible.
     *
     * @param   {object}  newTrack  New heatmap track
     * @param   {object}  combinedTrack  Combined track the new heatmap is added to
     */
  }, {
    key: "compatibilityfyStackedHeatmaps",
    value: function compatibilityfyStackedHeatmaps(newTrack, combinedTrack) {
      let otherHeatmap;
      const hasHeatmaps = combinedTrack.contents.some((track) => {
        otherHeatmap = track;
        return track.type === "heatmap";
      });
      if (hasHeatmaps) {
        newTrack.options.backgroundColor = "transparent";
        newTrack.options.showTooltip = otherHeatmap.options.showTooltip;
        newTrack.options.showMousePosition = otherHeatmap.options.showMousePosition;
        newTrack.options.mousePositionColor = otherHeatmap.options.mousePositionColor;
      }
    }
    /**
     * Go through each track and store its size in the viewconf.
     *
     * This is so that sizes don't get lost when the view is unbounded
     * and new tracks are added.
     *
     * Parameters
     * ----------
     *
     *  viewId : string
     *      The id of the view whose tracks we're measuring
     *
     * Returns
     * -------
     *
     *  Nothing
     */
  }, {
    key: "storeTrackSizes",
    value: function storeTrackSizes(viewId) {
      visitPositionedTracks(this.state.views[viewId].tracks, (track) => {
        const trackObj = this.tiledPlots[viewId].trackRenderer.getTrackObject(track.uid);
        if (trackObj)
          [track.width, track.height] = trackObj.dimensions;
      });
    }
    /*
     * Adjust the layout to match the size of the contained tracks. If tracks
     * are added, the layout size needs to expand. If they're removed, it needs
     * to contract.
     *
     * This function should be called from handleTrackAdded and handleCloseTrack.
     *
     * Parameters
     * ----------
     *
     *  view : {...}
     *      The definition from the viewconf
     */
  }, {
    key: "adjustLayoutToTrackSizes",
    value: function adjustLayoutToTrackSizes(view) {
      if (!view.layout)
        return;
      const isEditable = this.isEditable();
      let totalTrackHeight = 0;
      if (isEditable)
        totalTrackHeight += VIEW_HEADER_HEIGHT;
      const {
        totalHeight
      } = this.calculateViewDimensions(view);
      totalTrackHeight += totalHeight;
      const MARGIN_HEIGHT = this.isEditable() ? 10 : 0;
      totalTrackHeight += MARGIN_HEIGHT;
      const rowHeight = this.state.rowHeight + MARGIN_HEIGHT;
      if (this.sizeMode !== SIZE_MODE_BOUNDED) {
        view.layout.h = Math.ceil(totalTrackHeight / rowHeight);
      }
    }
  }, {
    key: "handleCloseTrack",
    value: function handleCloseTrack(viewId, uid) {
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      this.handleUnlockValueScale(viewId, uid);
      for (const trackType in tracks2) {
        const theseTracks = tracks2[trackType];
        const newTracks = theseTracks.filter((d) => d.uid !== uid);
        if (newTracks.length === theseTracks.length) {
          const combinedTracks = newTracks.filter((x) => x.type === "combined");
          combinedTracks.forEach((ct) => {
            ct.contents = ct.contents.filter((x) => x.uid !== uid);
          });
        } else {
          tracks2[trackType] = newTracks;
        }
      }
      this.storeTrackSizes(viewId);
      this.adjustLayoutToTrackSizes(this.state.views[viewId]);
      this.setState((prevState) => ({
        views: prevState.views
      }));
      return this.state.views;
    }
  }, {
    key: "handleLockValueScale",
    value: function handleLockValueScale(fromViewUid, fromTrackUid) {
      this.setState({
        chooseTrackHandler: (toViewUid, toTrackUid) => this.handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, toTrackUid)
      });
    }
  }, {
    key: "combineViewAndTrackUid",
    value: function combineViewAndTrackUid(viewUid, trackUid) {
      const uid = `${viewUid}.${trackUid}`;
      this.combinedUidToViewTrack[uid] = {
        view: viewUid,
        track: trackUid
      };
      if (this.viewTrackUidsToCombinedUid[viewUid]) {
        if (this.viewTrackUidsToCombinedUid[trackUid]) {
          return this.viewTrackUidsToCombinedUid[viewUid][trackUid];
        }
        this.viewTrackUidsToCombinedUid[viewUid][trackUid] = uid;
      } else {
        this.viewTrackUidsToCombinedUid[viewUid] = {};
        this.viewTrackUidsToCombinedUid[viewUid][trackUid] = uid;
      }
      return uid;
    }
    /**
     * Update all locks involving this track to use a new track uid.
     *
     * @param  {string} viewUid The view's uid
     * @param  {string} oldTrackUid The track's old uid
     * @param  {string} newTrackUid The track's new uid
     */
  }, {
    key: "updateTrackLocks",
    value: function updateTrackLocks(viewUid, oldTrackUid, newTrackUid) {
      const oldLockGroupUid = this.combineViewAndTrackUid(viewUid, oldTrackUid);
      const newLockGroupUid = this.combineViewAndTrackUid(viewUid, newTrackUid);
      if (this.valueScaleLocks[oldLockGroupUid]) {
        const lockGroup = this.valueScaleLocks[oldLockGroupUid];
        this.valueScaleLocks[newLockGroupUid] = lockGroup;
        delete this.valueScaleLocks[oldLockGroupUid];
      }
      for (const lockGroupUid in this.valueScaleLocks) {
        if (this.valueScaleLocks[lockGroupUid][oldLockGroupUid]) {
          const oldEntry = this.valueScaleLocks[lockGroupUid][oldLockGroupUid];
          this.valueScaleLocks[lockGroupUid][newLockGroupUid] = oldEntry;
          oldEntry.track = newTrackUid;
          delete this.valueScaleLocks[lockGroupUid][oldLockGroupUid];
        }
      }
    }
  }, {
    key: "handleUnlockValueScale",
    value: function handleUnlockValueScale(viewUid, trackUid) {
      if (this.tiledPlots[viewUid].trackRenderer.getTrackObject(trackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[viewUid].trackRenderer.getTrackObject(trackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleUnlock(this.combineViewAndTrackUid(viewUid, childTrackUid), this.valueScaleLocks);
        }
      } else {
        this.handleUnlock(this.combineViewAndTrackUid(viewUid, trackUid), this.valueScaleLocks);
      }
    }
  }, {
    key: "handleValueScaleLocked",
    value: function handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, toTrackUid) {
      if (this.tiledPlots[fromViewUid].trackRenderer.getTrackObject(fromTrackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[fromViewUid].trackRenderer.getTrackObject(fromTrackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleValueScaleLocked(fromViewUid, childTrackUid, toViewUid, toTrackUid);
        }
        return;
      }
      if (this.tiledPlots[toViewUid].trackRenderer.getTrackObject(toTrackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[toViewUid].trackRenderer.getTrackObject(toTrackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, childTrackUid);
        }
        return;
      }
      const fromUid = this.combineViewAndTrackUid(fromViewUid, fromTrackUid);
      const toUid = this.combineViewAndTrackUid(toViewUid, toTrackUid);
      this.addLock(fromUid, toUid, this.valueScaleLocks, (uid) => this.combinedUidToViewTrack[uid]);
      this.syncValueScales(fromViewUid, fromTrackUid);
      this.setState({
        chooseTrackHandler: null
      });
    }
    /**
     * Add callbacks for functions that need them
     *
     * Done in place.
     *
     * @param track: A view with tracks.
     */
  }, {
    key: "addCallbacks",
    value: function addCallbacks(viewUid, track) {
      const trackInfo2 = this.getTrackInfo(track.type);
      if (track.type === "viewport-projection-center" || track.type === "viewport-projection-horizontal" || track.type === "viewport-projection-vertical" || trackInfo2 && trackInfo2.projection) {
        const fromView = track.fromViewUid;
        track.registerViewportChanged = (trackId, listener) => this.addScalesChangedListener(fromView, trackId, listener);
        track.removeViewportChanged = (trackId) => this.removeScalesChangedListener(fromView, trackId);
        track.setDomainsCallback = (xDomain, yDomain) => {
          if (!fromView) {
            if (!this.projectionXDomains[viewUid]) {
              this.projectionXDomains[viewUid] = {};
            }
            if (!this.projectionYDomains[viewUid]) {
              this.projectionYDomains[viewUid] = {};
            }
            if (track.type === "viewport-projection-horizontal" || track.type === "viewport-projection-center") {
              this.projectionXDomains[viewUid][track.uid] = xDomain;
            }
            if (track.type === "viewport-projection-vertical" || track.type === "viewport-projection-center") {
              this.projectionYDomains[viewUid][track.uid] = yDomain;
            }
            this.triggerViewChangeDb();
            return;
          }
          const tXScale = linear().domain(xDomain).range(this.xScales[fromView].range());
          const tYScale = linear().domain(yDomain).range(this.yScales[fromView].range());
          const [tx, ty, k] = scalesCenterAndK(tXScale, tYScale);
          this.setCenters[fromView](tx, ty, k, false);
          let zoomLocked = false;
          let locationLocked = false;
          if (viewUid in this.zoomLocks) {
            zoomLocked = fromView in this.zoomLocks[viewUid];
          }
          if (zoomLocked) {
            this.handleUnlock(viewUid, this.zoomLocks);
          }
          if (viewUid in this.locationLocks) {
            locationLocked = fromView in this.locationLocks[viewUid];
          }
          if (locationLocked) {
            this.handleUnlock(viewUid, this.locationLocks);
          }
          this.handleScalesChanged(fromView, tXScale, tYScale, true);
          if (zoomLocked) {
            this.addLock(viewUid, fromView, this.zoomLocks, this.viewScalesLockData);
          }
          if (locationLocked) {
            this.addLock(viewUid, fromView, this.locationLocks, this.viewScalesLockData);
          }
        };
      }
    }
  }, {
    key: "validateLocks",
    value: function validateLocks(locks) {
      const toRemove = [];
      for (const viewUid of dictKeys(locks)) {
        if (!locks[viewUid] || !locks[viewUid][viewUid]) {
          toRemove.push(viewUid);
        }
      }
      for (const viewUid of toRemove) {
        if (locks[viewUid]) {
          console.warn(`View ${viewUid} not present in lock group. Removing...`);
          this.handleUnlock(viewUid, locks);
          delete locks[viewUid];
        }
      }
    }
  }, {
    key: "deserializeLocationLocks",
    value: function deserializeLocationLocks(viewConfig) {
      this.locationLocks = {};
      if (viewConfig.locationLocks) {
        for (const viewUid of dictKeys(viewConfig.locationLocks.locksByViewUid)) {
          if (typeof viewConfig.locationLocks.locksByViewUid[viewUid] !== "object") {
            this.locationLocks[viewUid] = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid]];
          } else {
            if ("x" in viewConfig.locationLocks.locksByViewUid[viewUid]) {
              const lockInfo = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid].x.lock];
              this.locationLocksAxisWise.x[viewUid] = {
                lock: lockInfo,
                axis: viewConfig.locationLocks.locksByViewUid[viewUid].x.axis
                // The axis of another view, either 'x' or 'y'
              };
            }
            if ("y" in viewConfig.locationLocks.locksByViewUid[viewUid]) {
              const lockInfo = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid].y.lock];
              this.locationLocksAxisWise.y[viewUid] = {
                lock: lockInfo,
                axis: viewConfig.locationLocks.locksByViewUid[viewUid].y.axis
                // The axis of another view, either 'x' or 'y'
              };
            }
          }
        }
      }
      this.validateLocks(this.locationLocks);
    }
  }, {
    key: "deserializeZoomLocks",
    value: function deserializeZoomLocks(viewConfig) {
      this.zoomLocks = {};
      if (viewConfig.zoomLocks) {
        for (const viewUid of dictKeys(viewConfig.zoomLocks.locksByViewUid)) {
          this.zoomLocks[viewUid] = viewConfig.zoomLocks.locksDict[viewConfig.zoomLocks.locksByViewUid[viewUid]];
        }
      }
      this.validateLocks(this.zoomLocks);
    }
  }, {
    key: "deserializeValueScaleLocks",
    value: function deserializeValueScaleLocks(viewConfig) {
      this.valueScaleLocks = {};
      if (viewConfig.valueScaleLocks) {
        for (const viewUid of dictKeys(viewConfig.valueScaleLocks.locksByViewUid)) {
          this.valueScaleLocks[viewUid] = viewConfig.valueScaleLocks.locksDict[viewConfig.valueScaleLocks.locksByViewUid[viewUid]];
        }
      }
    }
  }, {
    key: "serializeLocks",
    value: function serializeLocks(locks) {
      const locksDict = {};
      const locksByViewUid = {};
      for (const viewUid of dictKeys(locks)) {
        let lockUid = locks[viewUid] && locks[viewUid].uid;
        if (!lockUid) {
          lockUid = slugid$1.nice();
        }
        locks[viewUid].uid = lockUid;
        locksDict[lockUid] = locks[viewUid];
        locksByViewUid[viewUid] = locks[viewUid].uid;
      }
      return {
        locksByViewUid,
        locksDict
      };
    }
  }, {
    key: "getViewsAsJson",
    value: function getViewsAsJson() {
      const newJson = JSON.parse(JSON.stringify(this.state.viewConfig));
      newJson.views = Object.values(this.state.views).map((k) => {
        const newView = JSON.parse(JSON.stringify(k));
        visitPositionedTracks(newView.tracks, (track) => {
          if (track.server) {
            const url = parse$5(track.server, {});
            if (!url.hostname.length) {
              const hostString = window.location.host;
              const {
                protocol
              } = window.location;
              const newUrl = `${protocol}//${hostString}${url.pathname}`;
              track.server = newUrl;
            }
          }
          if ((track.type === "viewport-projection-center" || track.type === "viewport-projection-horizontal") && this.projectionXDomains[k.uid] && this.projectionXDomains[k.uid][track.uid]) {
            track.projectionXDomain = this.projectionXDomains[k.uid][track.uid];
          }
          if ((track.type === "viewport-projection-center" || track.type === "viewport-projection-vertical") && this.projectionYDomains[k.uid] && this.projectionYDomains[k.uid][track.uid]) {
            track.projectionYDomain = this.projectionYDomains[k.uid][track.uid];
          }
          delete track.name;
          delete track.position;
          delete track.header;
          delete track.description;
          delete track.created;
          delete track.project;
          delete track.project_name;
          delete track.serverUidKey;
          delete track.uuid;
          delete track.private;
          delete track.maxZoom;
          delete track.coordSystem;
          delete track.coordSystem2;
          delete track.datatype;
          delete track.maxWidth;
          delete track.datafile;
          delete track.binsPerDimension;
          delete track.resolutions;
          delete track.aggregationModes;
        });
        newView.uid = k.uid;
        newView.initialXDomain = this.xScales[k.uid].domain();
        newView.initialYDomain = this.yScales[k.uid].domain();
        delete newView.layout.i;
        return newView;
      });
      newJson.zoomLocks = this.serializeLocks(this.zoomLocks);
      newJson.locationLocks = this.serializeLocks(this.locationLocks);
      newJson.valueScaleLocks = this.serializeLocks(this.valueScaleLocks);
      return newJson;
    }
  }, {
    key: "getViewsAsString",
    value: function getViewsAsString() {
      return JSON.stringify(this.getViewsAsJson(), null, 2);
    }
  }, {
    key: "handleExportViewAsJSON",
    value: function handleExportViewAsJSON() {
      const data2 = this.getViewsAsString();
      download("viewconf.json", data2);
    }
  }, {
    key: "handleExportViewsAsLink",
    value: function handleExportViewsAsLink(url = this.state.viewConfig.exportViewUrl, fromApi = false) {
      const parsedUrl = new URL(url, window.location.origin);
      const req = fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: `{"viewconf":${this.getViewsAsString()}}`,
        credentials: "same-origin"
      }).then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      }).catch((err2) => {
        console.warn("err:", err2);
      }).then((_json) => ({
        id: _json.uid,
        url: `${parsedUrl.origin}/l/?d=${_json.uid}`
      }));
      if (!fromApi) {
        req.then((sharedView) => {
          this.openModal(/* @__PURE__ */ React$3.createElement(ExportLinkDialog, {
            onDone: () => {
              this.closeModalBound();
            },
            url: sharedView.url
          }));
        }).catch((e) => console.error("Exporting view config as link failed:", e));
      }
      return req;
    }
    /*
     * The initial[XY]Domain of a view has changed. Update its definition
     * and rerender.
     */
  }, {
    key: "handleDataDomainChanged",
    value: function handleDataDomainChanged(viewUid, newXDomain, newYDomain) {
      const {
        views
      } = this.state;
      views[viewUid].initialXDomain = newXDomain;
      views[viewUid].initialYDomain = newYDomain;
      this.xScales[viewUid] = linear().domain(newXDomain);
      this.yScales[viewUid] = linear().domain(newYDomain);
      if (this.zoomLocks[viewUid]) {
        const lockGroup = this.zoomLocks[viewUid];
        const lockGroupItems = dictItems(lockGroup);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          if (!(key in this.locationLocks)) {
            continue;
          }
          views[key].initialXDomain = newXDomain;
          views[key].initialYDomain = newYDomain;
          this.xScales[key] = linear().domain(newXDomain);
          this.yScales[key] = linear().domain(newYDomain);
        }
      }
      this.setState({
        views
      });
    }
    /**
     * Check if we can place a view at this position
     */
  }, {
    key: "viewPositionAvailable",
    value: function viewPositionAvailable(pX, pY, w, h) {
      const pEndX = pX + w;
      const pEndY = pY + h;
      if (pX + w > NUM_GRID_COLUMNS) {
        return false;
      }
      const sortedViews = dictValues(this.state.views);
      for (let j = 0; j < sortedViews.length; j++) {
        const svX = sortedViews[j].layout.x;
        const svY = sortedViews[j].layout.y;
        const svEndX = svX + sortedViews[j].layout.w;
        const svEndY = svY + sortedViews[j].layout.h;
        if (pX < svEndX && pEndX > svX) {
          if (pY < svEndY && pEndY > svY) {
            return false;
          }
        }
      }
      return true;
    }
    /**
     * User clicked on the "Add View" button. We'll duplicate the last
     * view.
     */
  }, {
    key: "handleAddView",
    value: function handleAddView(view) {
      const views = dictValues(this.state.views);
      const lastView = view;
      const potentialPositions = [];
      if (view.layout.w === 12) {
        view.layout.w = 6;
      }
      for (let i = 0; i < views.length; i++) {
        let pX = views[i].layout.x + views[i].layout.w;
        let pY = views[i].layout.y;
        if (this.viewPositionAvailable(pX, pY, view.layout.w, view.layout.h)) {
          potentialPositions.push([pX, pY]);
        }
        pX = views[i].layout.x;
        pY = views[i].layout.y + views[i].layout.h;
        if (this.viewPositionAvailable(pX, pY, view.layout.w, view.layout.h)) {
          potentialPositions.push([pX, pY]);
        }
      }
      potentialPositions.sort((a, b) => {
        const n = a[1] - b[1];
        if (n === 0) {
          return a[0] - b[0];
        }
        return n;
      });
      const jsonString = JSON.stringify(lastView);
      const newView = JSON.parse(jsonString);
      newView.initialXDomain = this.xScales[newView.uid].domain();
      newView.initialYDomain = this.yScales[newView.uid].domain();
      [[newView.layout.x, newView.layout.y]] = potentialPositions;
      newView.uid = slugid$1.nice();
      newView.layout.i = newView.uid;
      visitPositionedTracks(newView.tracks, (track) => {
        this.addCallbacks(newView.uid, track);
      });
      this.setState((prevState) => {
        const views2 = JSON.parse(JSON.stringify(prevState.views));
        views2[newView.uid] = newView;
        return {
          views: views2
        };
      });
    }
  }, {
    key: "handleSelectedAssemblyChanged",
    value: function handleSelectedAssemblyChanged(viewUid, newAssembly, newAutocompleteId, newServer) {
      const {
        views
      } = this.state;
      views[viewUid].genomePositionSearchBox.chromInfoId = newAssembly;
      views[viewUid].genomePositionSearchBox.autocompleteId = newAutocompleteId;
      views[viewUid].genomePositionSearchBox.autocompleteServer = newServer;
    }
  }, {
    key: "createGenomePostionSearchBoxEntry",
    value: function createGenomePostionSearchBoxEntry(existingGenomePositionSearchBox, suggestedAssembly) {
      let newGpsb = existingGenomePositionSearchBox;
      const defaultGpsb = {
        autocompleteServer: DEFAULT_SERVER,
        // "autocompleteId": "OHJakQICQD6gTD7skx4EWA",
        chromInfoServer: DEFAULT_SERVER,
        visible: false
      };
      if (!newGpsb) {
        newGpsb = JSON.parse(JSON.stringify(defaultGpsb));
      }
      if (!newGpsb.autocompleteServer) {
        newGpsb.autocompleteServer = defaultGpsb.autocompleteServer;
      }
      if (!newGpsb.chromInfoId) {
        newGpsb.chromInfoId = suggestedAssembly;
      }
      if (!newGpsb.chromInfoServer) {
        newGpsb.chromInfoServer = defaultGpsb.chromInfoServer;
      }
      if (!newGpsb.visible) {
        newGpsb.visible = false;
      }
      return newGpsb;
    }
  }, {
    key: "handleTogglePositionSearchBox",
    value: function handleTogglePositionSearchBox(viewUid) {
      const view = this.state.views[viewUid];
      view.genomePositionSearchBoxVisible = !view.genomePositionSearchBoxVisible;
      const assemblyCounts = {};
      visitPositionedTracks(view.tracks, (track) => {
        if (track.coordSystem) {
          if (!assemblyCounts[track.coordSystem]) {
            assemblyCounts[track.coordSystem] = 0;
          }
          assemblyCounts[track.coordSystem] += 1;
        }
      });
      const sortedAssemblyCounts = dictItems(assemblyCounts).sort((a, b) => b[1] - a[1]);
      let selectedAssembly = "hg19";
      if (sortedAssemblyCounts.length) {
        selectedAssembly = sortedAssemblyCounts[0][0];
      }
      view.genomePositionSearchBox = this.createGenomePostionSearchBoxEntry(view.genomePositionSearchBox, selectedAssembly);
      view.genomePositionSearchBox.visible = !view.genomePositionSearchBox.visible;
      this.refreshView();
      this.setState({
        configMenuUid: null
      });
    }
  }, {
    key: "handleTrackOptionsChanged",
    value: function handleTrackOptionsChanged(viewUid, trackUid, newOptions) {
      const view = this.state.views[viewUid];
      const track = getTrackByUid(view.tracks, trackUid);
      if (!track)
        return;
      track.options = Object.assign(track.options, newOptions);
      if (this.mounted) {
        this.setState((prevState) => ({
          views: prevState.views
        }));
        this.adjustSplitHeatmapTrackOptions(track, newOptions, view.tracks, viewUid);
      }
    }
    /**
     * For convenience we adjust some options of split heatmap tracks when they are newly added.
     * This function has no effect when we get split heatmap tracks that are already correctly configured
     * (i.e. correctly set "lower-extend"/"upper-extend" options)
     * @param   {object}  track  Track whose options have changed
     * @param   {object}  options  New track options
     * @param   {list}  allTracks  All tracks
     * @param   {string}  viewUid  Related view UID
     */
  }, {
    key: "adjustSplitHeatmapTrackOptions",
    value: function adjustSplitHeatmapTrackOptions(track, options2, allTracks, viewUid) {
      if (track.type === "heatmap") {
        if (options2.extent === "upper-right" && allTracks.center[0].type === "combined" && allTracks.center[0].contents.length > 1) {
          allTracks.center[0].contents.some((otherTrack) => {
            if (otherTrack.type === "heatmap" && otherTrack.uid !== track.uid && otherTrack.options.extent !== "lower-left") {
              const otherNewOptions = {
                ...otherTrack.options,
                extent: "lower-left",
                labelPosition: "bottomLeft",
                colorbarPosition: "bottomLeft"
              };
              const originalNewOptions = {
                ...options2,
                labelPosition: "topRight",
                colorbarPosition: "topRight"
              };
              this.handleTrackOptionsChanged(viewUid, otherTrack.uid, otherNewOptions);
              this.handleTrackOptionsChanged(viewUid, track.uid, originalNewOptions);
              return true;
            }
            return false;
          });
        }
        if (options2.extent === "lower-left") {
          if (options2.extent === "lower-left" && allTracks.center[0].type === "combined" && allTracks.center[0].contents.length > 1) {
            allTracks.center[0].contents.some((otherTrack) => {
              if (otherTrack.type === "heatmap" && otherTrack.uid !== track.uid && otherTrack.options.extent !== "upper-right") {
                const otherNewOptions = {
                  ...otherTrack.options,
                  extent: "upper-right",
                  labelPosition: "topRight",
                  colorbarPosition: "topRight"
                };
                const originalNewOptions = {
                  ...options2,
                  labelPosition: "bottomLeft",
                  colorbarPosition: "bottomLeft"
                };
                this.handleTrackOptionsChanged(viewUid, otherTrack.uid, otherNewOptions);
                this.handleTrackOptionsChanged(viewUid, track.uid, originalNewOptions);
                return true;
              }
              return false;
            });
          }
        }
      }
    }
  }, {
    key: "handleViewOptionsChanged",
    value: function handleViewOptionsChanged(viewUid, newOptions) {
      const view = this.state.views[viewUid];
      if (!view) {
        return;
      }
      view.options = Object.assign(view.options || {}, newOptions);
      if (this.mounted) {
        this.setState((prevState) => ({
          views: prevState.views
        }));
      }
    }
    /**
     * Determine whether a track is valid and can be displayed.
     *
     * Tracks can be invalid due to inconsistent input such as
     * referral to views that don't exist
     *
     * @param track (object): A track definition
     * @param viewUidsPresent (Set): The view uids which are available
     */
  }, {
    key: "isTrackValid",
    value: function isTrackValid(track, viewUidsPresent) {
      if (track.type === "viewport-projection-center") {
        if (!viewUidsPresent.has(track.fromViewUid)) {
          return false;
        }
      }
      return true;
    }
    /**
     * Remove tracks which can no longer be shown (possibly because the views they
     * refer to no longer exist
     */
  }, {
    key: "removeInvalidTracks",
    value: function removeInvalidTracks(viewsByUid) {
      const viewUidsSet = new Set(dictKeys(viewsByUid));
      for (const v of dictValues(viewsByUid)) {
        for (const trackOrientation of ["left", "top", "center", "right", "bottom"]) {
          if (v.tracks && v.tracks.hasOwnProperty(trackOrientation)) {
            v.tracks[trackOrientation] = v.tracks[trackOrientation].filter((t) => this.isTrackValid(t, viewUidsSet));
            v.tracks[trackOrientation].forEach((t) => {
              if (t.type === "combined") {
                t.contents = t.contents.filter((c2) => this.isTrackValid(c2, viewUidsSet));
              }
            });
          }
        }
      }
      return viewsByUid;
    }
  }, {
    key: "processViewConfig",
    value: function processViewConfig(viewConfig) {
      let {
        views
      } = viewConfig;
      let viewsByUid = {};
      if (!viewConfig.views || viewConfig.views.length === 0) {
        console.warn("No views provided in viewConfig");
        views = [{
          editable: true,
          tracks: {}
        }];
      }
      views.forEach((v) => {
        if (v.tracks) {
          fillInMinWidths(v.tracks);
        }
        if (!v.uid) {
          v.uid = slugid$1.nice();
        }
        viewsByUid[v.uid] = v;
        if (this.zoomToDataExtentOnInit.has(v.uid)) {
          this.zoomToDataExtentOnInit.delete(v.uid);
        }
        if (!v.initialXDomain) {
          v.initialXDomain = [0, 100];
          this.zoomToDataExtentOnInit.add(v.uid);
        } else {
          v.initialXDomain[0] = +v.initialXDomain[0];
          v.initialXDomain[1] = +v.initialXDomain[1];
        }
        if (!v.initialYDomain) {
          v.initialYDomain = [v.initialXDomain[0], v.initialXDomain[1]];
        } else {
          v.initialXDomain[0] = +v.initialXDomain[0];
          v.initialXDomain[1] = +v.initialXDomain[1];
        }
        if (!this.xScales[v.uid]) {
          this.xScales[v.uid] = linear().domain(v.initialXDomain);
        }
        if (!this.yScales[v.uid]) {
          this.yScales[v.uid] = linear().domain(v.initialYDomain);
        }
        visitPositionedTracks(v.tracks, (track) => {
          if (!track.uid)
            track.uid = slugid$1.nice();
          this.addCallbacks(v.uid, track);
          this.addDefaultTrackOptions(track);
          if (track.contents) {
            for (const ct of track.contents)
              this.addDefaultTrackOptions(ct);
          }
        });
        if (v.layout) {
          v.layout.i = v.uid;
        } else {
          v.layout = this.generateViewLayout(v);
        }
      });
      this.deserializeZoomLocks(viewConfig);
      this.deserializeLocationLocks(viewConfig);
      this.deserializeValueScaleLocks(viewConfig);
      viewsByUid = this.removeInvalidTracks(viewsByUid);
      return viewsByUid;
    }
  }, {
    key: "handleWindowFocused",
    value: function handleWindowFocused() {
    }
    /**
     * Handle range selection events.
     *
     * @description
     * Store active range selectio and forward the range selection event to the
     * API.
     *
     * @param  {Array}  range  Double array of the selected range.
     */
  }, {
    key: "rangeSelectionHandler",
    value: function rangeSelectionHandler(range2) {
      this.rangeSelection = range2;
      this.apiPublish("rangeSelection", range2);
    }
  }, {
    key: "offViewChange",
    value: function offViewChange(listenerId) {
      this.viewChangeListener.splice(listenerId, 1);
    }
  }, {
    key: "onViewChange",
    value: function onViewChange(callback) {
      return this.viewChangeListener.push(callback) - 1;
    }
  }, {
    key: "triggerViewChange",
    value: function triggerViewChange() {
      this.viewChangeListener.forEach((callback) => callback(this.getViewsAsString()));
    }
  }, {
    key: "getGenomeLocation",
    value: function getGenomeLocation(viewId) {
      return api$1.get(this.state.views[viewId].chromInfoPath).then((chrInfo) => scalesToGenomeLoci(this.xScales[viewId], this.yScales[viewId], chrInfo));
    }
  }, {
    key: "offLocationChange",
    value: function offLocationChange(viewId, listenerId) {
      this.removeScalesChangedListener(viewId, listenerId);
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (Number.isNaN(+start1Abs) || Number.isNaN(+end1Abs)) {
        const coords = [start1Abs, end1Abs].join(", ");
        console.warn([`Invalid coordinates (${coords}). All coordinates need to be numbers
        and should represent absolute coordinates (not chromosome
        coordinates).`].join(" "));
        return;
      }
      if (Number.isNaN(+start2Abs) || Number.isNaN(+end2Abs) || start2Abs === null || end2Abs === null) {
        start2Abs = start1Abs;
        end2Abs = end1Abs;
      }
      const [centerX, centerY, k] = scalesCenterAndK(this.xScales[viewUid].copy().domain([start1Abs, end1Abs]), this.yScales[viewUid].copy().domain([start2Abs, end2Abs]));
      this.setCenters[viewUid](centerX, centerY, k, false, animateTime);
    }
  }, {
    key: "zoomToGene",
    value: function zoomToGene(viewUid, geneName, padding, animateTime) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (!this.state.views[viewUid].genomePositionSearchBox || !this.state.views[viewUid].genomePositionSearchBox.autocompleteServer || !this.state.views[viewUid].genomePositionSearchBox.autocompleteId || !this.state.views[viewUid].chromInfoPath) {
        console.warn("Please set chromInfoPath, autocompleteServer, and autocompleteId to use the zoomToGene API");
        return;
      }
      this.suggestGene(viewUid, geneName, (suggestions) => {
        if (suggestions) {
          const exactMatch = suggestions.find((d) => d.geneName.toLowerCase() === geneName.toLowerCase());
          if (exactMatch) {
            const {
              chr,
              txStart,
              txEnd
            } = exactMatch;
            ChromosomeInfo(this.state.views[viewUid].chromInfoPath, (loadedChromInfo) => {
              const startAbs = loadedChromInfo.chrToAbs([chr, txStart]) - padding;
              const endAbs = loadedChromInfo.chrToAbs([chr, txEnd]) + padding;
              const [centerX, centerY, k] = scalesCenterAndK(this.xScales[viewUid].copy().domain([startAbs, endAbs]), this.yScales[viewUid].copy().domain([startAbs, endAbs]));
              this.setCenters[viewUid](centerX, centerY, k, false, animateTime);
            }, this.pubSub);
          } else {
            console.warn(`Couldn't find the gene symbol: ${geneName}`);
          }
        }
      });
    }
  }, {
    key: "suggestGene",
    value: function suggestGene(viewUid, keyword2, callback) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (!this.state.views[viewUid].genomePositionSearchBox || !this.state.views[viewUid].genomePositionSearchBox.autocompleteServer || !this.state.views[viewUid].genomePositionSearchBox.autocompleteId) {
        console.warn("Please set autocompleteServer and autocompleteId to use the suggestGene API");
        return;
      }
      const autocompleteServer = this.state.views[viewUid].genomePositionSearchBox.autocompleteServer;
      const autocompleteId = this.state.views[viewUid].genomePositionSearchBox.autocompleteId;
      const url = `${autocompleteServer}/suggest/?d=${autocompleteId}&ac=${keyword2.toLowerCase()}`;
      api.json(url, toVoid, this.pubSub).then((suggestions) => {
        callback(suggestions);
      }).catch((error) => console.error(error));
    }
  }, {
    key: "onLocationChange",
    value: function onLocationChange(viewId, callback, callbackId) {
      const viewsIds = Object.keys(this.state.views);
      if (!viewsIds.length) {
        this.unsetOnLocationChange.push({
          viewId,
          callback,
          callbackId
        });
        return null;
      }
      viewId = typeof viewId === "undefined" && viewsIds.length === 1 ? viewsIds[0] : viewId;
      if (typeof viewId === "undefined" || viewsIds.indexOf(viewId) === -1) {
        console.error("onLocationChange either missing a viewId or passed an invalid viewId: ", viewId);
        return null;
      }
      const view = this.state.views[viewId];
      const middleLayerListener = (xScale, yScale) => {
        callback({
          xDomain: xScale.domain(),
          yDomain: yScale.domain(),
          xRange: xScale.range(),
          yRange: yScale.range()
        });
      };
      let newListenerId = 1;
      if (this.scalesChangedListeners[view.uid]) {
        newListenerId = Object.keys(this.scalesChangedListeners[view.uid]).filter((listenerId) => listenerId.indexOf(LOCATION_LISTENER_PREFIX) === 0).map((listenerId) => parseInt(listenerId.slice(LOCATION_LISTENER_PREFIX.length + 1), 10)).reduce((max2, value2) => Math.max(max2, value2), 0) + 1;
      }
      this.addScalesChangedListener(view.uid, `${LOCATION_LISTENER_PREFIX}.${newListenerId}`, middleLayerListener);
      if (callbackId) {
        callbackId(`${LOCATION_LISTENER_PREFIX}.${newListenerId}`);
      }
      return newListenerId;
    }
    /**
     * List all the views that are at the given position view position
     */
  }, {
    key: "getTiledPlotAtPosition",
    value: function getTiledPlotAtPosition(x, y) {
      let foundTiledPlot;
      const views = dictValues(this.state.views);
      for (let i = 0; i < views.length; i++) {
        const tiledPlot = this.tiledPlots[views[i].uid];
        const area2 = this.tiledAreasDivs[views[i].uid].getBoundingClientRect();
        const {
          top: top2,
          left: left2
        } = area2;
        const bottom2 = top2 + area2.height;
        const right2 = left2 + area2.width;
        const withinX = x >= left2 && x <= right2;
        const withinY = y >= top2 && y <= bottom2;
        if (withinX && withinY) {
          foundTiledPlot = tiledPlot;
          break;
        }
      }
      return foundTiledPlot;
    }
    /**
     * Handle mousemove events by republishing the event using pubSub.
     *
     * @param {object}  e  Event object.
     */
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(e) {
      if (!this.topDiv || this.state.modal)
        return;
      const absX = e.clientX;
      const absY = e.clientY;
      const relPos = pointer(e, this.topDiv);
      relPos[1] += this.scrollTop;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
      const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
      const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
      let dataX = -1;
      let dataY = -1;
      if (hoveredTrack) {
        dataX = !hoveredTrack.flipText ? hoveredTrack._xScale.invert(relTrackPos[0]) : hoveredTrack._xScale.invert(relTrackPos[1]);
        dataY = hoveredTrack.is2d ? hoveredTrack._yScale.invert(relTrackPos[1]) : dataX;
      }
      const evt = {
        x: relPos[0],
        y: relPos[1],
        relTrackX: hoveredTrack && hoveredTrack.flipText ? relTrackPos[1] : relTrackPos[0],
        relTrackY: hoveredTrack && hoveredTrack.flipText ? relTrackPos[0] : relTrackPos[1],
        dataX,
        dataY,
        // See below why we need these derived boolean values
        isFrom2dTrack: !!(hoveredTrack && hoveredTrack.is2d),
        isFromVerticalTrack: !!(hoveredTrack && hoveredTrack.flipText),
        track: hoveredTrack,
        origEvt: e,
        sourceUid: this.uid,
        hoveredTracks,
        // See below why we need these derived boolean values
        noHoveredTracks: hoveredTracks.length === 0
      };
      this.pubSub.publish("app.mouseMove", evt);
      if (this.isBroadcastMousePositionGlobally) {
        const eventDataOnly = {
          ...evt
        };
        eventDataOnly.origEvt = void 0;
        eventDataOnly.track = void 0;
        eventDataOnly.hoveredTracks = void 0;
        delete eventDataOnly.origEvt;
        delete eventDataOnly.track;
        delete eventDataOnly.hoveredTracks;
        globalPubSub.publish("higlass.mouseMove", eventDataOnly);
      }
      this.apiPublish("cursorLocation", {
        absX,
        absY,
        relX: evt.x,
        relY: evt.y,
        relTrackX: evt.relTrackX,
        relTrackY: evt.relTrackY,
        dataX: evt.dataX,
        dataY: evt.dataY,
        isFrom2dTrack: evt.isFrom2dTrack,
        isFromVerticalTrack: evt.isFromVerticalTrack
      });
      this.showHoverMenu(evt, this.state.isShiftDown);
    }
  }, {
    key: "getMinMaxValue",
    value: function getMinMaxValue(viewId, trackId, ignoreOffScreenValues, ignoreFixedScale) {
      const track = getTrackObjById(this.tiledPlots, viewId, trackId);
      if (!track) {
        console.warn(`Track with ID: ${trackId} not found!`);
        return void 0;
      }
      if (!track.minVisibleValueInTiles || !track.maxVisibleValueInTiles) {
        console.warn(`Track ${trackId} doesn't support the retrieval of min or max values.`);
        return void 0;
      }
      if (ignoreOffScreenValues && track.getAggregatedVisibleValue) {
        return [track.getAggregatedVisibleValue("min"), track.getAggregatedVisibleValue("max")];
      }
      return [track.minVisibleValueInTiles(ignoreFixedScale), track.maxVisibleValueInTiles(ignoreFixedScale)];
    }
    /**
     * Show a menu displaying some information about the track under it
     */
  }, {
    key: "showHoverMenu",
    value: function showHoverMenu(evt, isShiftDown) {
      const mouseOverHtml = evt.track && evt.track.getMouseOverHtml ? evt.track.getMouseOverHtml(evt.relTrackX, evt.relTrackY, isShiftDown) : "";
      if (evt.track !== this.prevMouseHoverTrack) {
        if (this.prevMouseHoverTrack && this.prevMouseHoverTrack.stopHover) {
          this.prevMouseHoverTrack.stopHover();
        }
      }
      this.prevMouseHoverTrack = evt.track;
      if (this.zooming)
        return;
      const data2 = mouseOverHtml && mouseOverHtml.length ? [1] : [];
      let mouseOverDiv = select$1("body").selectAll(".track-mouseover-menu").data(data2);
      mouseOverDiv.exit().remove();
      mouseOverDiv.enter().append("div").classed("track-mouseover-menu", true).classed(styles["track-mouseover-menu"], true);
      mouseOverDiv = select$1("body").selectAll(".track-mouseover-menu");
      const mousePos = pointer(evt.origEvt, select$1("body").node());
      const normalizedMousePos = [mousePos[0] - window.scrollX, mousePos[1] - window.scrollY];
      mouseOverDiv.style("left", `${normalizedMousePos[0]}px`).style("top", `${normalizedMousePos[1]}px`);
      if (!mouseOverDiv.node())
        return;
      const bbox = mouseOverDiv.node().getBoundingClientRect();
      if (bbox.x + bbox.width > window.innerWidth) {
        mouseOverDiv.style("left", `${normalizedMousePos[0] - bbox.width}px`);
      }
      if (bbox.y + bbox.height > window.innerHeight) {
        mouseOverDiv.style("top", `${normalizedMousePos[1] - bbox.height}px`);
      }
      mouseOverDiv.html(mouseOverHtml);
    }
    /**
     * Hide the hover menu when e.g. the user starts zooming
     */
  }, {
    key: "hideHoverMenu",
    value: function hideHoverMenu() {
      select$1("body").selectAll(".track-mouseover-menu").remove();
    }
    /**
     * Close the custom dialog  (e.g. when the close button is clicked)
     */
  }, {
    key: "closeCustomDialog",
    value: function closeCustomDialog() {
      this.setState((prevState) => ({
        customDialog: null
      }));
    }
    /**
     * Handle internally broadcasted click events
     */
  }, {
    key: "appClickHandler",
    value: function appClickHandler(data2) {
      this.apiPublish("click", data2);
    }
    /** Handle click events on the canvas. The canvas is preferrable
     * to the top level div because the canvas's events aren't forwarded
     * so we only receive one click event
     */
  }, {
    key: "canvasClickHandler",
    value: function canvasClickHandler(evt) {
      const nativeEvent = evt.nativeEvent || evt;
      const absX = nativeEvent.clientX;
      const absY = nativeEvent.clientY;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      const relPos = pointer(nativeEvent, this.topDiv);
      relPos[1] += this.scrollTop;
      const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
      const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
      const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
      const relTrackX = hoveredTrack && hoveredTrack.flipText ? relTrackPos[1] : relTrackPos[0];
      const relTrackY = hoveredTrack && hoveredTrack.flipText ? relTrackPos[0] : relTrackPos[1];
      for (const track of this.iterateOverTracks()) {
        const trackObj = getTrackObjById(this.tiledPlots, track.viewId, track.trackId);
        if (!trackObj.respondsToPosition(relPos[0], relPos[1])) {
          trackObj.clickOutside();
        }
      }
      const clickReturns = [];
      for (const track of hoveredTracks) {
        if (track.childTracks) {
          for (const subtrack of track.childTracks) {
            clickReturns.push({
              trackUid: subtrack.context.trackUid,
              viewUid: subtrack.context.viewUid,
              trackType: subtrack.context.trackType,
              data: subtrack.click(relTrackX, relTrackY, evt)
            });
          }
          clickReturns.push({
            trackUid: track.context.trackUid,
            viewUid: track.context.viewUid,
            trackType: track.context.trackType,
            data: {
              type: "generic",
              event: evt
            }
          });
        } else {
          clickReturns.push({
            trackUid: track.context.trackUid,
            viewUid: track.context.viewUid,
            trackType: track.context.trackType,
            data: track.click(relTrackX, relTrackY, evt)
          });
        }
      }
      const customDialog = [];
      clickReturns.forEach((clickReturn, i) => {
        const trackObj = getTrackObjById(this.tiledPlots, clickReturn.viewUid, clickReturn.trackUid);
        if (typeof trackObj.clickDialog === "function") {
          const dialogData = trackObj.clickDialog();
          if (dialogData) {
            customDialog.push(dialogData);
          }
        }
      });
      if (customDialog.length > 0) {
        this.setState((prevState) => ({
          customDialog
        }));
      }
      this.pubSub.publish("app.click", clickReturns);
    }
    /**
     * Handle mousemove and zoom events.
     */
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(data2) {
      this.apiPublish("mouseMoveZoom", data2);
    }
    /**
     * Handle gene search events.
     */
  }, {
    key: "geneSearchHandler",
    value: function geneSearchHandler(data2) {
      this.apiPublish("geneSearch", data2);
    }
    /**
     * Handle mousedown events/
     */
  }, {
    key: "mouseDownHandler",
    value: function mouseDownHandler(evt) {
    }
  }, {
    key: "onScrollHandler",
    value: function onScrollHandler() {
      if (this.props.options.sizeMode !== SIZE_MODE_SCROLL)
        return;
      this.scrollTop = this.scrollContainer.scrollTop;
      this.pixiStage.y = -this.scrollTop;
      this.pubSub.publish("app.scroll", this.scrollTop);
      this.animate();
    }
  }, {
    key: "setTrackValueScaleLimits",
    value: function setTrackValueScaleLimits(viewId, trackId, minValue, maxValue) {
      const track = getTrackObjById(this.tiledPlots, viewId, trackId);
      if (!track) {
        console.warn(`Could't find track: ${trackId}`);
        return;
      }
      if (track.setFixedValueScaleMin && track.setFixedValueScaleMax) {
        track.setFixedValueScaleMin(minValue);
        track.setFixedValueScaleMax(maxValue);
        track.rerender(track.options, true);
        track.animate();
      } else {
        console.warn("Track doesn't support fixed value scales.");
      }
    }
  }, {
    key: "setChromInfo",
    value: function setChromInfo(chromInfoPath, callback) {
      ChromosomeInfo(chromInfoPath, (newChromInfo) => {
        this.chromInfo = newChromInfo;
        callback();
      }, this.pubSub);
    }
  }, {
    key: "onMouseLeaveHandler",
    value: function onMouseLeaveHandler() {
      this.pubSub.publish("app.mouseLeave");
      this.hideHoverMenu();
      this.animate();
    }
  }, {
    key: "onBlurHandler",
    value: function onBlurHandler() {
      this.animate();
    }
  }, {
    key: "isZoomFixed",
    value: function isZoomFixed(view) {
      return this.props.zoomFixed || this.props.options.zoomFixed || this.state.viewConfig.zoomFixed || this.props.options.sizeMode === SIZE_MODE_SCROLL || view && view.zoomFixed;
    }
    /**
     * Handle trackDimensionsModified events
     * settings.viewId = id of the view
     * settings.trackId = id of the track
     * settings.height = new height of the track or undefined if current height should remain
     * settings.width = new width of the track or undefined if current width should remain
     */
  }, {
    key: "trackDimensionsModifiedHandler",
    value: function trackDimensionsModifiedHandler(settings) {
      const view = this.state.views[settings.viewId];
      if (!view)
        return;
      const track = getTrackByUid(view.tracks, settings.trackId);
      if (!track)
        return;
      if (settings.height !== void 0) {
        track.height = settings.height;
      }
      if (settings.width !== void 0) {
        track.width = settings.width;
      }
      this.adjustLayoutToTrackSizes(view);
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
  }, {
    key: "wheelHandler",
    value: function wheelHandler(evt) {
      if (this.state.modal || this.props.options.sizeMode === SIZE_MODE_SCROLL)
        return;
      const nativeEvent = evt.nativeEvent || evt;
      const isTargetCanvas = evt.target === this.canvasElement;
      if (!hasParent(nativeEvent.target, this.topDiv)) {
        return;
      }
      if (this.isZoomFixed()) {
        return;
      }
      const absX = nativeEvent.clientX;
      const absY = nativeEvent.clientY;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      if (this.apiStack.wheel && this.apiStack.wheel.length > 0) {
        const relPos = pointer(nativeEvent, this.topDiv);
        relPos[1] += this.scrollTop;
        const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
        const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
        const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
        const evtToPublish = {
          x: relPos[0],
          y: relPos[1],
          relTrackX: hoveredTrack && hoveredTrack.flipText ? relTrackPos[1] : relTrackPos[0],
          relTrackY: hoveredTrack && hoveredTrack.flipText ? relTrackPos[0] : relTrackPos[1],
          track: hoveredTrack,
          origEvt: nativeEvent,
          sourceUid: this.uid,
          hoveredTracks,
          noHoveredTracks: hoveredTracks.length === 0
        };
        this.apiPublish("wheel", evtToPublish);
      }
      if (nativeEvent.forwarded || isTargetCanvas) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }
      evt.preventDefault();
      if (hoveredTiledPlot) {
        const {
          trackRenderer
        } = hoveredTiledPlot;
        nativeEvent.forwarded = true;
        if (nativeEvent) {
          forwardEvent(nativeEvent, trackRenderer.eventTracker);
          nativeEvent.preventDefault();
        }
      }
    }
  }, {
    key: "render",
    value: function render3() {
      this.tiledAreasDivs = {};
      this.tiledAreas = /* @__PURE__ */ React$3.createElement("div", {
        className: styles["tiled-area"]
      });
      if (this.mounted) {
        this.tiledAreas = dictValues(this.state.views).map((view) => {
          const addTrackPositionMenuPosition = view.uid === this.state.addTrackPositionMenuUid ? this.state.addTrackPositionMenuPosition : null;
          let overlay = null;
          if (this.state.chooseViewHandler) {
            let background = "transparent";
            if (this.state.mouseOverOverlayUid === view.uid)
              background = "green";
            overlay = /* @__PURE__ */ React$3.createElement("div", {
              className: "tiled-plot-overlay",
              onClick: () => this.state.chooseViewHandler(view.uid),
              onMouseEnter: () => this.handleOverlayMouseEnter(view.uid),
              onMouseLeave: () => this.handleOverlayMouseLeave(view.uid),
              onMouseMove: () => this.handleOverlayMouseEnter(view.uid),
              style: {
                position: "absolute",
                width: "100%",
                height: "100%",
                background,
                opacity: 0.3,
                zIndex: 1
              }
            });
          }
          const tiledPlot = /* @__PURE__ */ React$3.createElement(
            TiledPlot$1,
            {
              key: `tp${view.uid}`,
              ref: (c2) => {
                this.tiledPlots[view.uid] = c2;
              },
              addTrackPosition: this.state.addTrackPositionView === view.uid ? this.state.addTrackPosition : null,
              addTrackPositionMenuPosition,
              canvasElement: this.state.canvasElement,
              chooseTrackHandler: this.state.chooseTrackHandler ? (trackId) => this.state.chooseTrackHandler(view.uid, trackId) : null,
              customDialog: this.state.customDialog,
              closeCustomDialog: () => this.closeCustomDialog(),
              chromInfoPath: view.chromInfoPath,
              disableTrackMenu: this.isTrackMenuDisabled(),
              draggingHappening: this.state.draggingHappening !== null,
              editable: this.isEditable(),
              getLockGroupExtrema: (uid) => this.getLockGroupExtrema(view.uid, uid),
              initialXDomain: view.initialXDomain,
              initialYDomain: view.initialYDomain,
              isShowGlobalMousePosition: this.isShowGlobalMousePosition,
              isValueScaleLocked: (uid) => this.isValueScaleLocked(view.uid, uid),
              marginBottom: this.viewMarginBottom,
              marginLeft: this.viewMarginLeft,
              marginRight: this.viewMarginRight,
              marginTop: this.viewMarginTop,
              metaTracks: view.metaTracks,
              mouseTool: this.state.mouseTool,
              onChangeTrackData: (trackId, newData) => this.handleChangeTrackData(view.uid, trackId, newData),
              onChangeTrackType: (trackId, newType) => this.handleChangeTrackType(view.uid, trackId, newType),
              onCloseTrack: (uid) => this.handleCloseTrack(view.uid, uid),
              onDataDomainChanged: (xDomain, yDomain) => this.handleDataDomainChanged(view.uid, xDomain, yDomain),
              onLockValueScale: (uid) => this.handleLockValueScale(view.uid, uid),
              onMouseMoveZoom: this.mouseMoveZoomHandler.bind(this),
              onNewTilesLoaded: (trackUid) => this.handleNewTilesLoaded(view.uid, trackUid),
              onNoTrackAdded: this.handleNoTrackAdded.bind(this),
              onRangeSelection: this.rangeSelectionHandler.bind(this),
              onResizeTrack: this.triggerViewChangeDb,
              onScalesChanged: (x, y) => this.handleScalesChanged(view.uid, x, y),
              onTrackOptionsChanged: (trackId, options2) => this.handleTrackOptionsChanged(view.uid, trackId, options2),
              onTrackPositionChosen: this.handleTrackPositionChosen.bind(this),
              onTracksAdded: (newTracks, position, host) => this.handleTracksAdded(view.uid, newTracks, position, host),
              onUnlockValueScale: (uid) => this.handleUnlockValueScale(view.uid, uid),
              onValueScaleChanged: (uid) => this.syncValueScales(view.uid, uid),
              overlays: view.overlays,
              paddingBottom: this.viewPaddingBottom,
              paddingLeft: this.viewPaddingLeft,
              paddingRight: this.viewPaddingRight,
              paddingTop: this.viewPaddingTop,
              pixiRenderer: this.pixiRenderer,
              pixiStage: this.pixiStage,
              pluginDataFetchers: this.pluginDataFetchers,
              pluginTracks: this.pluginTracks,
              rangeSelection1dSize: this.state.rangeSelection1dSize,
              rangeSelectionToInt: this.state.rangeSelectionToInt,
              registerDraggingChangedListener: (listener) => this.addDraggingChangedListener(view.uid, view.uid, listener),
              removeDraggingChangedListener: (listener) => this.removeDraggingChangedListener(view.uid, view.uid, listener),
              setCentersFunction: (c2) => {
                this.setCenters[view.uid] = c2;
              },
              svgElement: this.state.svgElement,
              tracks: view.tracks,
              trackSourceServers: this.state.viewConfig.trackSourceServers,
              uid: view.uid,
              verticalMargin: this.verticalMargin,
              viewOptions: view.options,
              xDomainLimits: view.xDomainLimits,
              yDomainLimits: view.yDomainLimits,
              zoomable: !this.isZoomFixed(view),
              zoomLimits: this.calculateZoomLimits(view, view.initialXDomain),
              zoomToDataExtentOnInit: () => this.zoomToDataExtentOnInit.has(view.uid)
            }
          );
          const getGenomePositionSearchBox = (isFocused, onFocus) => {
            if (!view.genomePositionSearchBox)
              return null;
            return /* @__PURE__ */ React$3.createElement(
              GenomePositionSearchBox$1,
              {
                key: `gpsb${view.uid}`,
                ref: (c2) => {
                  this.genomePositionSearchBoxes[view.uid] = c2;
                },
                autocompleteId: view.genomePositionSearchBox.autocompleteId,
                autocompleteServer: view.genomePositionSearchBox.autocompleteServer,
                chromInfoId: view.genomePositionSearchBox.chromInfoId,
                chromInfoPath: view.genomePositionSearchBox.chromInfoPath,
                chromInfoServer: view.genomePositionSearchBox.chromInfoServer,
                hideAvailableAssemblies: view.genomePositionSearchBox.hideAvailableAssemblies,
                isFocused,
                onFocus,
                onGeneSearch: this.geneSearchHandler.bind(this),
                onSelectedAssemblyChanged: (x, y, server) => this.handleSelectedAssemblyChanged(view.uid, x, y, server),
                registerViewportChangedListener: (listener) => this.addScalesChangedListener(view.uid, view.uid, listener),
                removeViewportChangedListener: () => this.removeScalesChangedListener(view.uid, view.uid),
                setCenters: (centerX, centerY, k, animateTime) => this.setCenters[view.uid](centerX, centerY, k, false, animateTime),
                trackSourceServers: this.state.viewConfig.trackSourceServers,
                twoD: !!(view.tracks.left.length || view.tracks.right.length || view.tracks.center.length)
              }
            );
          };
          const multiTrackHeader = this.isEditable() && !this.isViewHeaderDisabled() && !this.state.viewConfig.hideHeader ? /* @__PURE__ */ React$3.createElement(ViewHeader$1, {
            ref: (c2) => {
              this.viewHeaders[view.uid] = c2;
            },
            getGenomePositionSearchBox,
            isGenomePositionSearchBoxVisible: view.genomePositionSearchBox && view.genomePositionSearchBox.visible,
            mouseTool: this.state.mouseTool,
            onAddView: () => this.handleAddView(view),
            onClearView: () => this.handleClearView(view.uid),
            onCloseView: () => this.handleCloseView(view.uid),
            onEditViewConfig: this.handleEditViewConfigBound,
            onExportPNG: this.handleExportPNG.bind(this),
            onExportSVG: this.handleExportSVG.bind(this),
            onExportViewsAsJSON: this.handleExportViewAsJSON.bind(this),
            onExportViewsAsLink: this.handleExportViewsAsLink.bind(this),
            onLockLocation: (uid) => this.handleYankFunction(uid, this.handleLocationLockChosen.bind(this)),
            onLockZoom: (uid) => this.handleYankFunction(uid, this.handleZoomLockChosen.bind(this)),
            onLockZoomAndLocation: (uid) => this.handleYankFunction(uid, (a, b) => {
              this.handleZoomLockChosen(a, b);
              this.handleLocationLockChosen(a, b);
            }),
            onProjectViewport: this.handleProjectViewport.bind(this),
            onTakeAndLockZoomAndLocation: (uid) => {
              this.handleYankFunction(uid, (a, b) => {
                this.handleZoomYanked(a, b);
                this.handleLocationYanked(a, b);
                this.handleZoomLockChosen(a, b);
                this.handleLocationLockChosen(a, b);
              });
            },
            onTogglePositionSearchBox: this.handleTogglePositionSearchBox.bind(this),
            onTrackPositionChosen: (position) => this.handleTrackPositionChosen(view.uid, position),
            onUnlockLocation: (uid) => this.handleUnlock(uid, this.locationLocks),
            onUnlockZoom: (uid) => this.handleUnlock(uid, this.zoomLocks),
            onUnlockZoomAndLocation: (uid) => {
              this.handleUnlock(uid, this.zoomLocks);
              this.handleUnlock(uid, this.locationLocks);
            },
            onViewOptionsChanged: (newOptions) => this.handleViewOptionsChanged(view.uid, newOptions),
            onYankLocation: (uid) => this.handleYankFunction(uid, this.handleLocationYanked.bind(this)),
            onYankZoom: (uid) => this.handleYankFunction(uid, this.handleZoomYanked.bind(this)),
            onYankZoomAndLocation: (uid) => this.handleYankFunction(uid, (a, b) => {
              this.handleZoomYanked(a, b);
              this.handleLocationYanked(a, b);
            }),
            onZoomToData: (uid) => this.handleZoomToData(uid),
            viewUid: view.uid
          }) : null;
          return /* @__PURE__ */ React$3.createElement("div", {
            key: view.uid,
            ref: (c2) => {
              this.tiledAreasDivs[view.uid] = c2;
            },
            className: styles["tiled-area"]
          }, multiTrackHeader, tiledPlot, overlay);
        });
      }
      let layouts2 = this.mounted ? Object.values(this.state.views).filter((view) => view.layout).map((view) => view.layout) : [];
      layouts2 = JSON.parse(JSON.stringify(layouts2));
      const defaultContainerPaddingX = this.isEditable() ? DEFAULT_CONTAINER_PADDING_X : 0;
      const defaultContainerPaddingY = this.isEditable() ? DEFAULT_CONTAINER_PADDING_Y : 0;
      const containerPaddingX = +this.props.options.containerPaddingX >= 0 ? +this.props.options.containerPaddingX : defaultContainerPaddingX;
      const containerPaddingY = +this.props.options.containerPaddingY >= 0 ? +this.props.options.containerPaddingY : defaultContainerPaddingY;
      const gridLayout = /* @__PURE__ */ React$3.createElement(
        ReactGridLayout,
        {
          ref: (c2) => {
            this.gridLayout = c2;
          },
          cols: 12,
          containerPadding: [containerPaddingX, containerPaddingY],
          draggableHandle: `.${stylesMTHeader["multitrack-header-grabber"]}`,
          isDraggable: this.isEditable(),
          isResizable: this.isEditable(),
          layout: layouts2,
          margin: this.isEditable() ? [10, 10] : [0, 0],
          measureBeforeMount: false,
          onBreakpointChange: this.onBreakpointChange.bind(this),
          onDragStart: this.handleDragStart.bind(this),
          onDragStop: this.handleDragStop.bind(this),
          onLayoutChange: this.handleLayoutChange.bind(this),
          onResize: this.resizeHandler.bind(this),
          rowHeight: this.state.rowHeight,
          useCSSTransforms: this.mounted,
          verticalCompact: this.state.viewConfig.compactLayout,
          width: this.state.width
        },
        this.tiledAreas
      );
      return /* @__PURE__ */ React$3.createElement("div", {
        key: this.uid,
        ref: (c2) => {
          this.topDiv = c2;
        },
        className: clsx("higlass", {
          "higlass-dark-theme": this.theme === THEME_DARK,
          "higlass-container-overflow": this.props.options.sizeMode === SIZE_MODE_OVERFLOW || this.props.options.sizeMode === SIZE_MODE_SCROLL
        }),
        onMouseLeave: this.onMouseLeaveHandlerBound,
        onMouseMove: this.mouseMoveHandlerBound
      }, /* @__PURE__ */ React$3.createElement(Provider$1, {
        value: this.pubSub
      }, /* @__PURE__ */ React$3.createElement(Provider, {
        value: this.modal
      }, /* @__PURE__ */ React$3.createElement(Provider$2, {
        value: this.theme
      }, this.state.modal, /* @__PURE__ */ React$3.createElement("canvas", {
        key: this.uid,
        ref: (c2) => {
          this.canvasElement = c2;
        },
        onClick: this.canvasClickHandlerBound,
        className: styles["higlass-canvas"]
      }), /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.scrollContainer = c2;
        },
        className: clsx("higlass-scroll-container", {
          "higlass-scroll-container-overflow": this.props.options.sizeMode === SIZE_MODE_OVERFLOW,
          "higlass-scroll-container-scroll": this.props.options.sizeMode === SIZE_MODE_SCROLL
        }),
        onScroll: this.onScrollHandlerBound
      }, /* @__PURE__ */ React$3.createElement("div", {
        ref: (c2) => {
          this.divDrawingSurface = c2;
        },
        className: clsx("higlass-drawing-surface", styles["higlass-drawing-surface"])
      }, gridLayout), /* @__PURE__ */ React$3.createElement("svg", {
        ref: (c2) => {
          this.svgElement = c2;
        },
        className: styles["higlass-svg"],
        style: {
          // inline the styles so they aren't overriden by other css
          // on the web page
          position: "absolute",
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          pointerEvents: "none"
        }
      }))))));
    }
  }]);
  return HiGlassComponent2;
}(React$3.Component);
HiGlassComponent.defaultProps = {
  options: {},
  zoomFixed: false,
  compactLayout: true
};
HiGlassComponent.propTypes = {
  getApi: PropTypes.func,
  options: PropTypes.object,
  viewConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  zoomFixed: PropTypes.bool,
  compactLayout: PropTypes.bool
};
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
const trackViewer = (element, [xMin, xMax, yMin, yMax], trackConfig) => {
  if (!trackConfig.options.colorbarPosition) {
    trackConfig.options.colorbarPosition = "hidden";
  }
  if (!trackConfig.options.labelPosition) {
    trackConfig.options.labelPosition = "hidden";
  }
  const id2 = "arbitary-id";
  const viewConfig = {
    editable: false,
    zoomFixed: false,
    views: [{
      uid: id2,
      initialXDomain: [xMin, xMax],
      initialYDomain: [yMin, yMax],
      tracks: {
        center: [trackConfig]
      },
      layout: {
        w: 12,
        h: 12,
        x: 0,
        y: 0,
        moved: false,
        static: false
      }
    }]
  };
  const hgApi = viewer(element, viewConfig, {
    sizeMode: "bounded"
  });
  return {
    id: id2,
    hgApi
  };
};
let HiGlassTrackComponent = /* @__PURE__ */ function(_React$Component) {
  _inherits(HiGlassTrackComponent2, _React$Component);
  var _super = _createSuper(HiGlassTrackComponent2);
  function HiGlassTrackComponent2(props) {
    var _this;
    _classCallCheck(this, HiGlassTrackComponent2);
    _this = _super.call(this, props);
    _this.id = `id-${Math.random()}`;
    return _this;
  }
  _createClass(HiGlassTrackComponent2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initTrackViewer();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      const {
        x,
        y,
        width,
        height: height2
      } = nextProps;
      this.zoomTo(x, y, width, height2);
      return false;
    }
  }, {
    key: "initTrackViewer",
    value: function initTrackViewer() {
      const {
        trackConfig,
        x,
        y,
        width,
        height: height2
      } = this.props;
      const element = document.getElementById(this.id);
      const {
        id: id2,
        hgApi
      } = trackViewer(element, [x, x + width, y, y + height2], trackConfig);
      this.viewUid = id2;
      this.viewer = hgApi;
    }
    /**
     * Zoom to a particular position.
     *
     * @param  {Number}  x       Left side of viewport
     * @param  {Number}  y       Top side of viewport
     * @param  {Number}  width   Width of viewport
     * @param  {Number}  height  Height of viewport
     */
  }, {
    key: "zoomTo",
    value: function zoomTo(x, y, width, height2) {
      this.viewer.zoomTo(this.viewUid, x, x + width, y, y + height2);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React$3.createElement("div", {
        id: this.id,
        style: {
          height: "100%",
          width: "100%"
        }
      });
    }
  }]);
  return HiGlassTrackComponent2;
}(React$3.Component);
HiGlassTrackComponent.propTypes = {
  trackConfig: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number
};
const goslingExports = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DataFetcher,
  DenseDataExtrema1D,
  HeatmapTiledPixiTrack,
  PixiTrack,
  SVGTrack,
  TiledPixiTrack,
  Track,
  ViewportTrackerHorizontal,
  absToChr,
  chrToAbs,
  chromInfoBisector,
  colorToHex,
  fakePubSub,
  pixiTextToSvg,
  showMousePosition: setupShowMousePosition,
  svgLine,
  tileProxy: api
}, Symbol.toStringTag, { value: "Module" }));
const tracks = {
  SVGTrack,
  TiledPixiTrack,
  HorizontalGeneAnnotationsTrack
};
const launch = (element, config, options2) => {
  const ref2 = /* @__PURE__ */ React$3.createRef();
  ReactDOM.render(/* @__PURE__ */ React$3.createElement(HiGlassComponent, {
    ref: ref2,
    options: options2 || {},
    viewConfig: config
  }), element);
  return ref2.current;
};
const viewer = (element, viewConfig, options2) => {
  const hg = launch(element, viewConfig, options2);
  return hg.api;
};
export {
  ChromosomeInfo,
  HiGlassComponent,
  HiGlassTrackComponent,
  getTrackObjectFromHGC,
  goslingExports as hggos,
  mountHGComponent,
  schema,
  trackViewer,
  tracks,
  version,
  viewer,
  waitForJsonComplete,
  waitForTilesLoaded,
  waitForTransitionsFinished
};
